import { openBlock as f, createElementBlock as p, createElementVNode as u, createStaticVNode as Ke, pushScopeId as hn, popScopeId as mn, normalizeClass as B, toDisplayString as T, createBlock as $, resolveDynamicComponent as oi, resolveComponent as j, createCommentVNode as N, renderSlot as pe, Fragment as se, createVNode as Z, createTextVNode as p1, resolveDirective as G2, withDirectives as S1, mergeProps as Q1, defineComponent as g0, h as zl, getCurrentInstance as a2, effectScope as Zm, inject as v3, onMounted as Il, onUnmounted as Wm, shallowRef as Bl, ref as L1, computed as T1, onBeforeMount as Qm, watch as Si, isRef as qm, Text as Gm, normalizeStyle as Ze, renderList as me, withModifiers as Qe, Transition as R3, withCtx as Ee, useCssVars as Y3, vShow as ri, getCurrentScope as Xm, onScopeDispose as Jm, unref as Km, toRef as $m, readonly as ep, customRef as np, createSlots as Ol, normalizeProps as ip, createApp as Hl, vModelText as jl, withKeys as d2, TransitionGroup as tp, onUpdated as ap, toHandlers as sp } from "vue";
const Z3 = 16, k = (e, i) => {
  const n = e.__vccOpts || e;
  for (const [a, r] of i)
    n[a] = r;
  return n;
}, op = {}, rp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lp = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C19.4825 35.0005 19.0625 34.5805 19.0625 34.063V20.938H5.9375C5.42 20.938 5 20.518 5 20.0005C5 19.483 5.42 19.063 5.9375 19.063H19.0625V5.93799C19.0625 5.42049 19.4825 5.00049 20 5.00049C20.5175 5.00049 20.9375 5.42049 20.9375 5.93799V19.063H34.0625C34.58 19.063 35 19.483 35 20.0005C35 20.518 34.58 20.938 34.0625 20.938H20.9375V34.063C20.9375 34.5805 20.5175 35.0005 20 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), dp = [
  lp
];
function cp(e, i) {
  return f(), p("svg", rp, dp);
}
const fp = /* @__PURE__ */ k(op, [["render", cp]]), up = {}, hp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mp = /* @__PURE__ */ u("path", {
  d: "M20 26.563C19.4825 26.563 19.0625 26.143 19.0625 25.6255V20.938H14.375C13.8575 20.938 13.4375 20.518 13.4375 20.0005C13.4375 19.483 13.8575 19.063 14.375 19.063H19.0625V14.3755C19.0625 13.858 19.4825 13.438 20 13.438C20.5175 13.438 20.9375 13.858 20.9375 14.3755V19.063H25.625C26.1425 19.063 26.5625 19.483 26.5625 20.0005C26.5625 20.518 26.1425 20.938 25.625 20.938H20.9375V25.6255C20.9375 26.143 20.5175 26.563 20 26.563Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), pp = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yp = [
  mp,
  pp
];
function vp(e, i) {
  return f(), p("svg", hp, yp);
}
const gp = /* @__PURE__ */ k(up, [["render", vp]]), _p = {}, wp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cp = /* @__PURE__ */ u("path", {
  d: "M31.25 26.8755C30.7527 26.8755 30.2758 26.6779 29.9242 26.3263C29.5725 25.9747 29.375 25.4978 29.375 25.0005V18.923C29.4472 16.5493 28.6677 14.2282 27.1775 12.3792C25.6873 10.5303 23.5848 9.27548 21.25 8.84174V6.25049C21.25 5.91897 21.1183 5.60103 20.8839 5.3666C20.6495 5.13218 20.3315 5.00049 20 5.00049C19.6685 5.00049 19.3505 5.13218 19.1161 5.3666C18.8817 5.60103 18.75 5.91897 18.75 6.25049V8.84174C16.4152 9.27548 14.3127 10.5303 12.8225 12.3792C11.3323 14.2282 10.5528 16.5493 10.625 18.923V25.0005C10.625 25.4978 10.4275 25.9747 10.0758 26.3263C9.72419 26.6779 9.24728 26.8755 8.75 26.8755C8.41848 26.8755 8.10054 27.0072 7.86612 27.2416C7.6317 27.476 7.5 27.794 7.5 28.1255C7.5 28.457 7.6317 28.7749 7.86612 29.0094C8.10054 29.2438 8.41848 29.3755 8.75 29.3755H31.25C31.5815 29.3755 31.8995 29.2438 32.1339 29.0094C32.3683 28.7749 32.5 28.457 32.5 28.1255C32.5 27.794 32.3683 27.476 32.1339 27.2416C31.8995 27.0072 31.5815 26.8755 31.25 26.8755Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kp = /* @__PURE__ */ u("path", {
  d: "M22.795 31.2505H17.205C17.1283 31.2506 17.0543 31.279 16.9971 31.3302C16.9399 31.3813 16.9036 31.4517 16.895 31.528C16.8814 31.6433 16.8747 31.7594 16.875 31.8755C16.875 32.7043 17.2042 33.4992 17.7903 34.0852C18.3764 34.6713 19.1712 35.0005 20 35.0005C20.8288 35.0005 21.6237 34.6713 22.2097 34.0852C22.7958 33.4992 23.125 32.7043 23.125 31.8755C23.1253 31.7594 23.1186 31.6433 23.105 31.528C23.097 31.4515 23.0608 31.3808 23.0035 31.3295C22.9462 31.2782 22.8719 31.2501 22.795 31.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xp = [
  Cp,
  kp
];
function bp(e, i) {
  return f(), p("svg", wp, xp);
}
const Mp = /* @__PURE__ */ k(_p, [["render", bp]]), Dp = {}, Ap = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lp = /* @__PURE__ */ u("path", {
  d: "M20.0028 35.0005C19.4153 35.0005 18.8291 34.8505 18.3078 34.5655C17.4766 34.1117 16.8716 33.3605 16.6053 32.4517C16.4591 31.9555 16.7441 31.4342 17.2403 31.288C17.3266 31.263 17.4153 31.2505 17.5041 31.2505C17.9166 31.2505 18.2866 31.5267 18.4041 31.923C18.5303 32.3517 18.8153 32.7055 19.2066 32.9205C19.4528 33.0542 19.7278 33.1255 20.0041 33.1255C20.1628 33.1255 20.3228 33.1017 20.4778 33.0567C21.0253 32.8955 21.4491 32.4717 21.6103 31.9242C21.7266 31.528 22.0966 31.2505 22.5103 31.2505C22.5991 31.2505 22.6866 31.263 22.7728 31.288C23.2691 31.4342 23.5553 31.9555 23.4091 32.4517C23.0678 33.6155 22.1691 34.5142 21.0053 34.8555C20.6778 34.9517 20.3403 35.0005 20.0028 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Tp = /* @__PURE__ */ u("path", {
  d: "M8.75403 29.3755C8.39778 29.3755 8.06778 29.1692 7.91153 28.8492C7.75278 28.5242 7.79403 28.1455 8.01528 27.8605C8.02278 27.8492 9.69153 25.4367 9.69153 18.1255C9.69153 12.7592 13.774 8.33174 19.0665 7.85549V5.93799C19.0665 5.42049 19.4865 5.00049 20.004 5.00049C20.5215 5.00049 20.9415 5.42049 20.9415 5.93799V7.85549C26.234 8.33174 30.3165 12.7592 30.3165 18.1255C30.3165 26.0042 31.874 27.733 31.889 27.7492C32.1615 27.998 32.2603 28.4142 32.1228 28.7717C31.9803 29.138 31.639 29.3755 31.254 29.3755H8.75403ZM29.6415 27.5005C29.039 25.9605 28.4403 23.163 28.4403 18.1255C28.4403 13.473 24.6553 9.68799 20.0028 9.68799C15.3503 9.68799 11.5653 13.473 11.5653 18.1255C11.5653 23.0717 10.8403 25.9717 10.2578 27.5005H29.6415Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Sp = [
  Lp,
  Tp
];
function Np(e, i) {
  return f(), p("svg", Ap, Sp);
}
const Ep = /* @__PURE__ */ k(Dp, [["render", Np]]), zp = {}, Ip = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bp = /* @__PURE__ */ Ke('<path d="M9.79181 13.9841C9.62249 13.9841 9.45583 13.9401 9.3065 13.8588C9.07318 13.7281 8.90385 13.5161 8.83052 13.2588C8.75719 13.0015 8.78786 12.7322 8.91718 12.4989C9.77715 10.9496 11.0504 9.67499 12.5997 8.81502C12.7477 8.73236 12.9157 8.6897 13.085 8.6897C13.4476 8.6897 13.7836 8.88702 13.9596 9.20434C14.2276 9.68699 14.053 10.2963 13.5703 10.5643C12.349 11.2416 11.3437 12.2469 10.6664 13.4682C10.4904 13.7868 10.1545 13.9841 9.79181 13.9841Z" fill="#3B414D" class="primary"></path><path d="M6.00001 12.9695C5.90802 12.9695 5.81602 12.9561 5.72669 12.9308C5.19605 12.7801 4.88806 12.2255 5.03872 11.6962C5.96002 8.451 8.44791 5.96178 11.6931 5.03915C11.7824 5.01382 11.8744 5.00049 11.9664 5.00049C12.4104 5.00049 12.8064 5.29914 12.9277 5.72712C13.001 5.98444 12.9704 6.2551 12.8397 6.48842C12.7104 6.72175 12.4971 6.88974 12.2397 6.96307C9.66652 7.69504 7.69327 9.66828 6.96131 12.2428C6.83998 12.6695 6.44533 12.9695 6.00001 12.9695Z" fill="#3B414D" class="primary"></path><path d="M9.99977 29.0007C9.93044 29.0007 9.85978 28.9927 9.79178 28.9781C9.77712 28.9754 9.75712 28.9687 9.73845 28.9634C9.68912 28.9501 9.64245 28.9341 9.59712 28.9141C9.57979 28.9061 9.54513 28.8887 9.52913 28.8794C9.49846 28.8634 9.45713 28.8394 9.41713 28.8114C9.40647 28.8034 9.37713 28.7794 9.36647 28.7714C9.33314 28.7434 9.3038 28.7167 9.27714 28.6887C9.26514 28.6781 9.25447 28.6661 9.24514 28.6554C9.22781 28.6367 9.20381 28.6047 9.19047 28.5821C9.18648 28.5794 9.16648 28.5501 9.14781 28.5194C9.13048 28.4914 9.11581 28.4648 9.10248 28.4368C9.08781 28.4061 9.07448 28.3754 9.06248 28.3434C9.05048 28.3101 9.04115 28.2794 9.03315 28.2474C9.02648 28.2234 9.01982 28.1914 9.01448 28.1581C9.00915 28.1208 9.00515 28.0874 9.00382 28.0528C8.99982 28.0314 8.99982 28.0234 8.99982 28.0008C8.99982 27.9794 9.00115 27.9594 9.00382 27.9394C9.00515 27.9141 9.00915 27.8861 9.01182 27.8594C9.01715 27.8234 9.02248 27.7928 9.03048 27.7621C9.03582 27.7381 9.04515 27.7075 9.05581 27.6768C9.06915 27.6395 9.07981 27.6101 9.09315 27.5808C9.10515 27.5555 9.11981 27.5288 9.13581 27.5021C9.15448 27.4715 9.17048 27.4435 9.19047 27.4168C9.21181 27.3888 9.23047 27.3661 9.24914 27.3435C9.26914 27.3208 9.2878 27.3008 9.30914 27.2808C9.32247 27.2675 9.33714 27.2528 9.3478 27.2435C9.3478 27.2421 10.9997 25.5636 10.9997 20.0025C10.9997 14.6734 14.4769 10.2242 18.9994 9.64426V8.00166C18.9994 7.44969 19.4474 7.00171 19.9993 7.00171C20.5513 7.00171 20.9993 7.44969 20.9993 8.00166V9.64292C25.5217 10.2229 28.9989 14.672 28.9989 20.0011C28.9989 25.5396 30.6562 27.2461 30.6722 27.2621C30.6882 27.2755 30.6935 27.2821 30.7042 27.2955C30.7228 27.3141 30.7362 27.3288 30.7495 27.3448C30.7748 27.3741 30.7935 27.3968 30.8108 27.4208C30.8255 27.4421 30.8428 27.4701 30.8602 27.4981C30.8815 27.5355 30.8948 27.5608 30.9068 27.5861C30.9188 27.6115 30.9282 27.6395 30.9375 27.6661C30.9548 27.7168 30.9628 27.7435 30.9695 27.7701C30.9762 27.7994 30.9815 27.8274 30.9842 27.8568C30.9882 27.8914 30.9922 27.9194 30.9935 27.9461C30.9948 27.9648 30.9962 27.9848 30.9962 27.9994C30.9962 28.0288 30.9935 28.0568 30.9895 28.0834C30.9895 28.0901 30.9868 28.1234 30.9815 28.1554C30.9762 28.1914 30.9682 28.2234 30.9602 28.2554C30.9535 28.2834 30.9428 28.3141 30.9322 28.3461C30.9175 28.3834 30.9055 28.4114 30.8922 28.4394C30.8775 28.4688 30.8628 28.4954 30.8482 28.5208C30.8295 28.5501 30.8122 28.5767 30.7922 28.6007C30.7788 28.6194 30.7628 28.6421 30.7508 28.6554C30.7335 28.6741 30.7202 28.6874 30.7095 28.6981C30.6949 28.7127 30.6789 28.7274 30.6629 28.7421C30.6255 28.7741 30.6029 28.7927 30.5802 28.8101C30.5575 28.8274 30.5309 28.8421 30.5042 28.8581C30.4695 28.8794 30.4389 28.8954 30.4082 28.9087C30.3855 28.9194 30.3575 28.9287 30.3309 28.9381C30.2895 28.9527 30.2562 28.9634 30.2229 28.9701C30.2002 28.9754 30.1669 28.9807 30.1349 28.9847C30.1109 28.9874 30.0829 28.9914 30.0535 28.9927C30.0349 28.9941 30.0149 28.9954 29.9989 28.9954H9.99977V29.0007ZM28.195 27.0008C27.5843 25.6435 26.999 23.4436 26.999 20.0011C26.999 15.356 23.8592 11.5775 19.9993 11.5775C16.1395 11.5775 12.9996 15.356 12.9996 20.0011C12.9996 23.4503 12.417 25.6475 11.809 27.0008H28.195Z" fill="#3B414D" class="primary"></path><path d="M19.9993 35.0006C18.3447 35.0006 16.9995 33.6553 16.9995 32.0007C16.9995 31.4487 17.4474 31.0007 17.9994 31.0007C18.5514 31.0007 18.9994 31.4487 18.9994 32.0007C18.9994 32.5527 19.4474 33.0006 19.9993 33.0006C20.5513 33.0006 20.9993 32.5527 20.9993 32.0007C20.9993 31.4487 21.4473 31.0007 21.9992 31.0007C22.5512 31.0007 22.9992 31.4487 22.9992 32.0007C22.9992 33.6539 21.6539 35.0006 19.9993 35.0006Z" fill="#3B414D" class="primary"></path><path d="M30.2069 13.9841C29.8442 13.9841 29.5082 13.7868 29.3322 13.4695C28.9949 12.8615 28.5749 12.3042 28.083 11.8109C27.5923 11.3216 27.0337 10.9016 26.4257 10.5616C26.1924 10.431 26.0244 10.2176 25.9511 9.96164C25.8777 9.70432 25.9097 9.435 26.0404 9.20167C26.2177 8.88569 26.5524 8.6897 26.915 8.6897C27.0857 8.6897 27.2537 8.7337 27.4017 8.81636C28.1696 9.24567 28.8736 9.77632 29.4962 10.3963C30.1202 11.0216 30.6535 11.7296 31.0802 12.4975C31.2095 12.7309 31.2415 13.0015 31.1668 13.2575C31.0935 13.5148 30.9242 13.7268 30.6908 13.8575C30.5442 13.9401 30.3762 13.9841 30.2069 13.9841Z" fill="#3B414D" class="primary"></path><path d="M33.9988 12.9695C33.5548 12.9695 33.1588 12.6708 33.0375 12.2428C32.3055 9.66828 30.3323 7.69504 27.7591 6.96307C27.2284 6.81241 26.9205 6.25777 27.0711 5.72712C27.1924 5.29914 27.5871 5.00049 28.0324 5.00049C28.1257 5.00049 28.2177 5.01382 28.3071 5.03915C31.5509 5.96178 34.0388 8.44967 34.9614 11.6949C35.1121 12.2255 34.8028 12.7788 34.2721 12.9295C34.1828 12.9561 34.0908 12.9695 33.9988 12.9695Z" fill="#3B414D" class="primary"></path>', 6), Op = [
  Bp
];
function Hp(e, i) {
  return f(), p("svg", Ip, Op);
}
const jp = /* @__PURE__ */ k(zp, [["render", Hp]]), Vp = {}, Fp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pp = /* @__PURE__ */ u("path", {
  d: "M20 27.5005C20.7767 27.5005 21.4062 26.8709 21.4062 26.0942C21.4062 25.3176 20.7767 24.688 20 24.688C19.2233 24.688 18.5938 25.3176 18.5938 26.0942C18.5938 26.8709 19.2233 27.5005 20 27.5005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Up = /* @__PURE__ */ u("path", {
  d: "M20 22.813C19.7514 22.813 19.5129 22.7142 19.3371 22.5384C19.1613 22.3626 19.0625 22.1241 19.0625 21.8755V11.563C19.0625 11.3143 19.1613 11.0759 19.3371 10.9001C19.5129 10.7243 19.7514 10.6255 20 10.6255C20.2486 10.6255 20.4871 10.7243 20.6629 10.9001C20.8387 11.0759 20.9375 11.3143 20.9375 11.563V21.8755C20.9375 22.1241 20.8387 22.3626 20.6629 22.5384C20.4871 22.7142 20.2486 22.813 20 22.813Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Rp = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Yp = [
  Pp,
  Up,
  Rp
];
function Zp(e, i) {
  return f(), p("svg", Fp, Yp);
}
const Wp = /* @__PURE__ */ k(Vp, [["render", Zp]]), Qp = {}, qp = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gp = /* @__PURE__ */ u("path", {
  d: "M19.9794 5.00384C15.9719 5.06944 12.1511 6.70954 9.34314 9.56957C7.93814 10.9684 6.8296 12.6361 6.08377 14.4731C5.33795 16.3101 4.97016 18.2785 5.00238 20.2609C5.00007 22.1979 5.38004 24.1163 6.1205 25.9062C6.86097 27.6961 7.94737 29.3223 9.31746 30.6916C10.6875 32.0608 12.3144 33.1463 14.1047 33.8857C15.895 34.6251 17.8137 35.0039 19.7507 35.0005H20.0182C24.0269 34.9592 27.8556 33.3294 30.6642 30.4686C33.4727 27.6078 35.0317 23.7498 34.999 19.7409C35.0036 17.7804 34.6162 15.8388 33.8594 14.0302C33.1027 12.2216 31.992 10.5826 30.5926 9.20949C29.1932 7.83642 27.5334 6.75702 25.7108 6.03477C23.8882 5.31252 21.9395 4.96201 19.9794 5.00384ZM18.1259 25.679C18.1169 25.4339 18.1568 25.1895 18.2434 24.9601C18.3299 24.7306 18.4614 24.5208 18.63 24.3427C18.7986 24.1647 19.0011 24.022 19.2255 23.9231C19.4499 23.8242 19.6918 23.771 19.9369 23.7667H19.9707C20.4639 23.7677 20.9376 23.9595 21.2925 24.302C21.6473 24.6446 21.8558 25.1112 21.8742 25.604C21.8834 25.8491 21.8436 26.0936 21.7571 26.3231C21.6706 26.5527 21.5392 26.7626 21.3705 26.9407C21.2018 27.1188 20.9993 27.2614 20.7749 27.3603C20.5504 27.4591 20.3084 27.5122 20.0632 27.5163H20.0294C19.5364 27.5147 19.0631 27.3227 18.7083 26.9803C18.3536 26.6379 18.1449 26.1717 18.1259 25.679ZM18.7508 20.6271V13.1279C18.7508 12.7964 18.8825 12.4785 19.1169 12.2441C19.3513 12.0097 19.6692 11.8781 20.0007 11.8781C20.3322 11.8781 20.6501 12.0097 20.8845 12.2441C21.1189 12.4785 21.2505 12.7964 21.2505 13.1279V20.6271C21.2505 20.9586 21.1189 21.2765 20.8845 21.5109C20.6501 21.7453 20.3322 21.8769 20.0007 21.8769C19.6692 21.8769 19.3513 21.7453 19.1169 21.5109C18.8825 21.2765 18.7508 20.9586 18.7508 20.6271Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Xp = [
  Gp
];
function Jp(e, i) {
  return f(), p("svg", qp, Xp);
}
const Kp = /* @__PURE__ */ k(Qp, [["render", Jp]]), $p = {}, ey = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ny = /* @__PURE__ */ u("path", {
  d: "M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z",
  fill: "#D4DEF7"
}, null, -1), iy = /* @__PURE__ */ u("path", {
  d: "M27.1392 16.1697L26.5587 17.4493H27.7228L27.1392 16.1697ZM20.441 16.9627C20.5504 16.9107 20.6148 16.7978 20.6148 16.6575C20.6148 16.52 20.5471 16.4205 20.4378 16.3737C20.3381 16.3219 20.1848 16.3159 20.0378 16.3159H18.9993V17.0288H20.0239C20.1879 17.0289 20.3251 17.0267 20.441 16.9627ZM7.13416 16.1697L6.56026 17.4493H7.71152L7.13416 16.1697ZM33.854 24.3673H32.2253V23.6789H33.8474C34.0082 23.6789 34.1208 23.6597 34.1886 23.5993C34.2528 23.5455 34.289 23.4695 34.2883 23.39C34.2883 23.2964 34.2475 23.2221 34.1852 23.1777C34.1242 23.1287 34.035 23.1064 33.8881 23.1064C33.0962 23.0819 32.1083 23.1286 32.1083 22.1126C32.1083 21.647 32.4334 21.1568 33.3184 21.1568H34.9983V20.518H33.4375C32.9665 20.518 32.6243 20.6207 32.382 20.7803V20.518H30.0734C29.7043 20.518 29.271 20.6013 29.066 20.7803V20.518H24.9432V20.7803C24.6152 20.5649 24.0615 20.518 23.8061 20.518H21.0867V20.7803C20.8272 20.5516 20.2499 20.518 19.8982 20.518H16.8548L16.1584 21.2037L15.5062 20.518H10.9599V24.9983H15.4204L16.1379 24.3016L16.8139 24.9983L19.5633 25.0005V23.9466H19.8337C20.1985 23.9519 20.6287 23.9384 21.0084 23.7891V24.9982H23.2762V23.8304H23.3856C23.5252 23.8304 23.539 23.8357 23.539 23.9626V24.9979H30.4284C30.8658 24.9979 31.323 24.8962 31.5762 24.7111V24.9979H33.7615C34.2162 24.9979 34.6603 24.9399 34.9982 24.7914V23.9569C34.7934 24.2294 34.3941 24.3675 33.8539 24.3675L33.854 24.3673ZM19.8698 23.3095H18.8175V24.3864H17.1783L16.1398 23.3236L15.0606 24.3864H11.72V21.1758H15.112L16.1496 22.2282L17.2223 21.1758H19.9171C20.5864 21.1758 21.3384 21.3444 21.3384 22.2335C21.3384 23.1254 20.607 23.3095 19.8698 23.3095V23.3095ZM24.9299 23.1639C25.0491 23.3206 25.0662 23.4669 25.0697 23.7499V24.3864H24.2229V23.9848C24.2229 23.7916 24.2434 23.5056 24.0866 23.3563C23.9635 23.2413 23.7756 23.2139 23.4678 23.2139H22.5666V24.3864H21.7192V21.1758H23.6662C24.0933 21.1758 24.4042 21.1931 24.681 21.3273C24.9471 21.4736 25.1146 21.674 25.1146 22.0403C25.1146 22.5527 24.7389 22.8141 24.5169 22.8944C24.7045 22.9574 24.8579 23.0704 24.9299 23.1639V23.1639ZM28.4137 21.8398H26.4388V22.4234H28.3654V23.0785H26.4388V23.7173L28.4137 23.7202V24.3864H25.5989V21.1758H28.4137V21.8398V21.8398ZM30.5808 24.3863H28.9383V23.6979H30.5742C30.7343 23.6979 30.8477 23.6786 30.9188 23.6183C30.9767 23.5687 31.0184 23.4965 31.0184 23.4091C31.0184 23.3154 30.9733 23.2411 30.9155 23.1966C30.8509 23.1476 30.7619 23.1255 30.6151 23.1255C29.8264 23.1009 28.8387 23.1476 28.8387 22.1317C28.8387 21.666 29.1604 21.1758 30.0445 21.1758H31.7353V21.859H30.1882C30.0348 21.859 29.9351 21.8644 29.8503 21.9172C29.7578 21.9692 29.7236 22.0463 29.7236 22.1481C29.7236 22.2692 29.8021 22.3516 29.9081 22.3872C29.9971 22.4154 30.0926 22.4236 30.2363 22.4236L30.6904 22.4349C31.148 22.4449 31.4624 22.5171 31.6535 22.693C31.8175 22.8476 31.9057 23.0428 31.9057 23.3732C31.9057 24.0639 31.4313 24.3863 30.5808 24.3863V24.3863ZM24.0399 21.8915C23.938 21.8365 23.7876 21.8336 23.6375 21.8336H22.599V22.5546H23.6236C23.7877 22.5546 23.9272 22.5493 24.0399 22.4884C24.1492 22.4283 24.2146 22.3176 24.2146 22.1803C24.2146 22.043 24.1492 21.9435 24.0399 21.8915ZM33.4628 21.8335C33.3094 21.8335 33.2073 21.8388 33.1215 21.8915C33.0325 21.9436 32.9983 22.0206 32.9983 22.1225C32.9983 22.2435 33.0735 22.326 33.1827 22.3617C33.2718 22.3898 33.3672 22.398 33.5077 22.398L33.9649 22.4091C34.426 22.4195 34.734 22.4917 34.9218 22.6677C34.956 22.6921 34.9765 22.7195 35 22.7471V21.8336H33.4628L33.4628 21.8335V21.8335ZM19.899 21.8335H18.7994V22.6512H19.8892C20.2133 22.6512 20.4148 22.5049 20.4149 22.2272C20.4148 21.9464 20.2035 21.8335 19.899 21.8335V21.8335ZM12.56 21.8335V22.4172H14.4114V23.0723H12.56V23.711H14.6335L15.5968 22.7692L14.6744 21.8335H12.56ZM17.9744 24.0787V21.5047L16.6796 22.771L17.9744 24.0787V24.0787ZM12.6308 18.9239V19.4771H19.6767L19.6734 18.3068H19.8098C19.9053 18.3098 19.9331 18.3178 19.9331 18.4612V19.4771H23.5773V19.2047C23.8712 19.348 24.3283 19.4771 24.9299 19.4771H26.463L26.7912 18.7642H27.5186L27.8395 19.4771H30.7938V18.7999L31.2411 19.4771H33.6086V15.0005H31.2657V15.5292L30.9376 15.0005H28.5334V15.5292L28.2322 15.0005H24.9846C24.441 15.0005 23.9633 15.0695 23.5773 15.2619V15.0005H21.3361V15.2619C21.0905 15.0636 20.7558 15.0005 20.3837 15.0005H12.1962L11.6469 16.1568L11.0827 15.0005H8.50396V15.5292L8.22061 15.0005H6.02133L5.00004 17.129V18.8316L6.51023 15.6217H7.76329L9.19755 18.6608V15.6217H10.5741L11.6778 17.7992L12.6917 15.6217H14.0959V18.8316H13.2314L13.2283 16.3177L12.0053 18.8316H11.2648L10.0388 16.3155V18.8316H8.32334L7.9993 18.1156H6.24333L5.91594 18.8316H5V19.4774H6.44103L6.76592 18.7644H7.4934L7.81745 19.4774H10.6526V18.9322L10.9057 19.4796H12.3775L12.6306 18.924L12.6308 18.9239ZM23.7337 15.9959C24.0062 15.7397 24.4333 15.6215 25.0144 15.6215H25.8309V16.3093H25.0316C24.7239 16.3093 24.55 16.351 24.3827 16.4995C24.2388 16.6346 24.1402 16.8901 24.1402 17.2266C24.1402 17.5705 24.2154 17.8184 24.372 17.9804C24.5019 18.1074 24.7379 18.1459 24.9599 18.1459H25.3388L26.5273 15.6217H27.7909L29.2188 18.6577V15.6217H30.5029L31.9854 17.8572V15.6217H32.8492V18.8315H31.6541L30.0555 16.4223V18.8315H28.338L28.0098 18.1155H26.2578L25.9395 18.8315H24.9525C24.5426 18.8315 24.0236 18.749 23.7297 18.4764C23.4332 18.2039 23.2792 17.8347 23.2792 17.2511C23.279 16.775 23.3711 16.3398 23.7337 15.9959V15.9959ZM21.999 15.6216H22.8595V18.8315H21.999V15.6216ZM18.1193 15.6216H20.0591C20.49 15.6216 20.8077 15.632 21.0804 15.7753C21.3471 15.9187 21.5071 16.128 21.5071 16.486C21.5071 16.9978 21.1316 17.2622 20.9129 17.3416C21.0974 17.4055 21.2551 17.5184 21.3302 17.6119C21.4493 17.7716 21.4698 17.9142 21.4698 18.2008V18.8314H20.6192L20.616 18.4266C20.616 18.2335 20.6363 17.9557 20.4829 17.8013C20.3597 17.6885 20.1718 17.6639 19.8681 17.6639H18.9628V18.8315H18.1194L18.1193 15.6216V15.6216ZM14.7195 15.6216H17.5369V16.29H15.563V16.8686H17.4895V17.5266H15.563V18.1676H17.5369V18.8314H14.7195V15.6216V15.6216Z",
  fill: "#2557D6"
}, null, -1), ty = [
  ny,
  iy
];
function ay(e, i) {
  return f(), p("svg", ey, ty);
}
const sy = /* @__PURE__ */ k($p, [["render", ay]]), oy = {}, ry = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ly = /* @__PURE__ */ u("path", {
  d: "M7.81227 31.2515C6.26115 31.2515 5 29.9903 5 28.4392V7.81593C5 6.26481 6.26115 5.00366 7.81227 5.00366H30.3104C31.8615 5.00366 33.1227 6.26481 33.1227 7.81593V15.3153C33.1227 15.8328 32.7027 16.2527 32.1852 16.2527C31.6678 16.2527 31.2478 15.8328 31.2478 15.3153V12.503H6.87484V28.4392C6.87484 28.9567 7.29481 29.3766 7.81227 29.3766H15.3116C15.8291 29.3766 16.2491 29.7966 16.2491 30.314C16.2491 30.8315 15.8291 31.2515 15.3116 31.2515H7.81227ZM31.2478 10.6282V7.81593C31.2478 7.29847 30.8279 6.87851 30.3104 6.87851H7.81227C7.29481 6.87851 6.87484 7.29847 6.87484 7.81593V10.6282H31.2478Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), dy = /* @__PURE__ */ u("path", {
  d: "M19.0601 34.9976C18.8101 34.9976 18.5739 34.9001 18.3977 34.7226C18.1752 34.5014 18.079 34.1839 18.1415 33.8765L19.0789 29.1894C19.1151 29.0069 19.2039 28.8406 19.3351 28.7094L28.8731 19.1727C29.5492 18.4965 30.4479 18.124 31.4053 18.124C32.3628 18.124 33.2614 18.4965 33.9376 19.1727C34.6213 19.8551 34.9988 20.7576 35 21.7137C35 22.6711 34.6288 23.5698 33.9539 24.2473L24.4122 33.784C24.2809 33.9152 24.1147 34.004 23.9322 34.0402L19.2451 34.9776C19.1826 34.9914 19.1214 34.9976 19.0601 34.9976ZM20.255 32.8653L23.2848 32.2591L32.6252 22.9236C32.9465 22.6012 33.1239 22.1737 33.1227 21.7175C33.1227 21.2613 32.944 20.8338 32.6215 20.5113C32.2928 20.1826 31.8591 20.0026 31.3991 20.0026C30.9441 20.0026 30.5179 20.1789 30.1967 20.5001L20.86 29.8356L20.255 32.8653Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cy = [
  ly,
  dy
];
function fy(e, i) {
  return f(), p("svg", ry, cy);
}
const uy = /* @__PURE__ */ k(oy, [["render", fy]]), hy = {}, my = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, py = /* @__PURE__ */ Ke('<path d="M20.9239 30.0593C20.8471 29.9825 20.7516 29.9269 20.6469 29.8982C20.5421 29.8695 20.4316 29.8686 20.3264 29.8956C20.2208 29.9228 20.1242 29.9771 20.0462 30.0532C19.9681 30.1293 19.9113 30.2245 19.8814 30.3293L18.7751 34.2043C18.7487 34.2972 18.7441 34.395 18.7618 34.49C18.7795 34.5849 18.8189 34.6745 18.8771 34.7517C18.9352 34.8288 19.0104 34.8915 19.0969 34.9346C19.1833 34.9778 19.2785 35.0004 19.3751 35.0006C19.4336 35.0008 19.4917 34.9924 19.5476 34.9756L23.4226 33.8693C23.5272 33.8393 23.6221 33.7826 23.698 33.7047C23.7739 33.6268 23.8282 33.5305 23.8555 33.4252C23.8827 33.3199 23.8821 33.2093 23.8535 33.1044C23.8249 32.9994 23.7695 32.9038 23.6926 32.8268L20.9239 30.0593Z" fill="#3B414D" class="primary"></path><path d="M28.464 21.5365C28.3468 21.4193 28.1879 21.3535 28.0222 21.3535C27.8564 21.3535 27.6975 21.4193 27.5803 21.5365L21.3178 27.8002C21.2006 27.9174 21.1348 28.0764 21.1348 28.2421C21.1348 28.4078 21.2006 28.5668 21.3178 28.684L25.0678 32.434C25.185 32.5511 25.344 32.617 25.5097 32.617C25.6754 32.617 25.8343 32.5511 25.9516 32.434L32.214 26.1702C32.3312 26.053 32.397 25.8941 32.397 25.7284C32.397 25.5626 32.3312 25.4037 32.214 25.2865L28.464 21.5365Z" fill="#3B414D" class="primary"></path><path d="M34.0401 19.7105C33.7293 19.4042 33.3609 19.1626 32.9562 18.9996C32.5515 18.8366 32.1185 18.7555 31.6822 18.761C31.2459 18.7665 30.815 18.8584 30.4145 19.0315C30.014 19.2045 29.6518 19.4553 29.3488 19.7693C29.2317 19.8865 29.1658 20.0454 29.1658 20.2111C29.1658 20.3769 29.2317 20.5358 29.3488 20.653L33.0988 24.403C33.1532 24.4548 33.2174 24.4953 33.2875 24.5221C33.3577 24.5489 33.4325 24.5616 33.5076 24.5593C33.7063 24.5596 33.8973 24.4825 34.0401 24.3443C34.6543 23.7297 34.9993 22.8963 34.9993 22.0274C34.9993 21.1585 34.6543 20.3251 34.0401 19.7105V19.7105Z" fill="#3B414D" class="primary"></path><path d="M31.25 5.00049H8.75005C7.75549 5.00049 6.80167 5.39558 6.09841 6.09883C5.39515 6.80209 5.00006 7.75592 5.00006 8.75048L5.00006 26.8754C5.00006 27.87 5.39515 28.8238 6.09841 29.5271C6.80167 30.2303 7.75549 30.6254 8.75005 30.6254H16.25C16.5815 30.6254 16.8995 30.4937 17.1339 30.2593C17.3683 30.0249 17.5 29.7069 17.5 29.3754C17.5 29.0439 17.3683 28.726 17.1339 28.4915C16.8995 28.2571 16.5815 28.1254 16.25 28.1254H8.75005C8.41853 28.1254 8.10059 27.9937 7.86617 27.7593C7.63175 27.5249 7.50005 27.2069 7.50005 26.8754V11.5642C7.49989 11.5231 7.50785 11.4823 7.52348 11.4442C7.53911 11.4062 7.5621 11.3716 7.59114 11.3424C7.62017 11.3133 7.65468 11.2902 7.69268 11.2744C7.73067 11.2586 7.77141 11.2505 7.81255 11.2505H32.1875C32.2704 11.2505 32.3498 11.2834 32.4085 11.342C32.4671 11.4006 32.5 11.4801 32.5 11.563V15.6255C32.5 15.957 32.6317 16.2749 32.8661 16.5093C33.1005 16.7438 33.4185 16.8755 33.75 16.8755C34.0815 16.8755 34.3994 16.7438 34.6339 16.5093C34.8683 16.2749 35 15.957 35 15.6255V8.75048C35 7.75592 34.6049 6.80209 33.9016 6.09883C33.1984 5.39558 32.2445 5.00049 31.25 5.00049ZM10.4325 8.75048C10.3283 8.93967 10.1751 9.09742 9.98914 9.20728C9.80314 9.31714 9.59107 9.37509 9.37505 9.37509C9.15902 9.37509 8.94696 9.31714 8.76095 9.20728C8.57495 9.09742 8.42183 8.93967 8.31755 8.75048C8.19747 8.56365 8.13089 8.34749 8.12505 8.12548C8.12633 7.94879 8.16555 7.77445 8.24005 7.61423C8.33828 7.39507 8.69884 7.07784 8.69884 7.07784C8.90012 6.94683 9.13489 6.87657 9.37505 6.87548C9.59066 6.87772 9.80188 6.93665 9.9875 7.04635C10.1731 7.15606 10.3266 7.31268 10.4325 7.50048C10.5528 7.68722 10.6194 7.90344 10.625 8.12548C10.6192 8.34749 10.5526 8.56365 10.4325 8.75048ZM14.8075 8.75048C14.7033 8.93967 14.5501 9.09742 14.3641 9.20728C14.1781 9.31714 13.9661 9.37509 13.75 9.37509C13.534 9.37509 13.3219 9.31714 13.1359 9.20728C12.9499 9.09742 12.7968 8.93967 12.6925 8.75048C12.5725 8.56365 12.5059 8.34749 12.5 8.12548C12.5057 7.90344 12.5723 7.68722 12.6925 7.50048C12.7968 7.31129 12.9499 7.15354 13.1359 7.04368C13.3219 6.93382 13.534 6.87586 13.75 6.87586C13.9661 6.87586 14.1781 6.93382 14.3641 7.04368C14.5501 7.15354 14.7033 7.31129 14.8075 7.50048C14.9278 7.68722 14.9944 7.90344 15 8.12548C14.9942 8.34749 14.9276 8.56365 14.8075 8.75048ZM19.1825 8.75048C19.0782 8.93967 18.9251 9.09742 18.7391 9.20728C18.5531 9.31714 18.341 9.37509 18.125 9.37509C17.909 9.37509 17.6969 9.31714 17.5109 9.20728C17.3249 9.09742 17.1718 8.93967 17.0675 8.75048C16.9474 8.56365 16.8809 8.34749 16.875 8.12548C16.8807 7.90344 16.9473 7.68722 17.0675 7.50048C17.1718 7.31129 17.3249 7.15354 17.5109 7.04368C17.6969 6.93382 17.909 6.87586 18.125 6.87586C18.341 6.87586 18.5531 6.93382 18.7391 7.04368C18.9251 7.15354 19.0782 7.31129 19.1825 7.50048C19.3028 7.68722 19.3694 7.90344 19.375 8.12548C19.3692 8.34749 19.3026 8.56365 19.1825 8.75048Z" fill="#3B414D" class="primary"></path><path d="M10.4325 8.75048C10.3283 8.93967 10.1751 9.09742 9.98914 9.20728C9.80314 9.31714 9.59107 9.37509 9.37505 9.37509C9.15902 9.37509 8.94696 9.31714 8.76095 9.20728C8.57495 9.09742 8.42183 8.93967 8.31755 8.75048C8.19747 8.56365 8.13089 8.34749 8.12505 8.12548C8.12633 7.94879 8.16555 7.77445 8.24005 7.61423C8.33828 7.39507 8.69884 7.07784 8.69884 7.07784C8.90012 6.94683 9.13489 6.87657 9.37505 6.87548C9.59066 6.87772 9.80188 6.93665 9.9875 7.04635C10.1731 7.15606 10.3266 7.31268 10.4325 7.50048C10.5528 7.68722 10.6194 7.90344 10.625 8.12548C10.6192 8.34749 10.5526 8.56365 10.4325 8.75048Z" fill="#3B414D" class="primary"></path><path d="M14.8075 8.75048C14.7033 8.93967 14.5501 9.09742 14.3641 9.20728C14.1781 9.31714 13.9661 9.37509 13.75 9.37509C13.534 9.37509 13.3219 9.31714 13.1359 9.20728C12.9499 9.09742 12.7968 8.93967 12.6925 8.75048C12.5725 8.56365 12.5059 8.34749 12.5 8.12548C12.5057 7.90344 12.5723 7.68722 12.6925 7.50048C12.7968 7.31129 12.9499 7.15354 13.1359 7.04368C13.3219 6.93382 13.534 6.87586 13.75 6.87586C13.9661 6.87586 14.1781 6.93382 14.3641 7.04368C14.5501 7.15354 14.7033 7.31129 14.8075 7.50048C14.9278 7.68722 14.9944 7.90344 15 8.12548C14.9942 8.34749 14.9276 8.56365 14.8075 8.75048Z" fill="#3B414D" class="primary"></path><path d="M19.1825 8.75048C19.0782 8.93967 18.9251 9.09742 18.7391 9.20728C18.5531 9.31714 18.341 9.37509 18.125 9.37509C17.909 9.37509 17.6969 9.31714 17.5109 9.20728C17.3249 9.09742 17.1718 8.93967 17.0675 8.75048C16.9474 8.56365 16.8809 8.34749 16.875 8.12548C16.8807 7.90344 16.9473 7.68722 17.0675 7.50048C17.1718 7.31129 17.3249 7.15354 17.5109 7.04368C17.6969 6.93382 17.909 6.87586 18.125 6.87586C18.341 6.87586 18.5531 6.93382 18.7391 7.04368C18.9251 7.15354 19.0782 7.31129 19.1825 7.50048C19.3028 7.68722 19.3694 7.90344 19.375 8.12548C19.3692 8.34749 19.3026 8.56365 19.1825 8.75048Z" fill="#3B414D" class="primary"></path>', 7), yy = [
  py
];
function vy(e, i) {
  return f(), p("svg", my, yy);
}
const gy = /* @__PURE__ */ k(hy, [["render", vy]]), _y = {}, wy = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cy = /* @__PURE__ */ u("path", {
  d: "M5.31471 14.0096L19.0432 29.5967C19.1676 29.7264 19.3169 29.8296 19.4822 29.9001C19.6474 29.9707 19.8253 30.007 20.005 30.007C20.1847 30.007 20.3625 29.9707 20.5278 29.9001C20.6931 29.8296 20.8424 29.7264 20.9668 29.5967L34.689 14.0096C34.7987 13.886 34.8825 13.7415 34.9353 13.5849C34.9882 13.4282 35.009 13.2625 34.9965 13.0977C34.984 12.9328 34.9385 12.7721 34.8627 12.6252C34.7869 12.4783 34.6824 12.3481 34.5553 12.2423L32.243 10.2963C31.9852 10.0789 31.6522 9.97163 31.316 9.99759C30.9797 10.0235 30.6671 10.1807 30.4457 10.435L20.2406 22.25C20.2112 22.2841 20.1749 22.3114 20.134 22.3302C20.0931 22.3489 20.0487 22.3587 20.0037 22.3587C19.9588 22.3587 19.9143 22.3489 19.8734 22.3302C19.8326 22.3114 19.7962 22.2841 19.7669 22.25L9.558 10.4338C9.33639 10.1806 9.02374 10.0252 8.68809 10.0013C8.52167 9.9865 8.35397 10.0052 8.19489 10.0563C8.03582 10.1074 7.8886 10.1898 7.76195 10.2988L5.44845 12.2423C5.32061 12.3479 5.21534 12.4781 5.13889 12.6252C5.06245 12.7723 5.0164 12.9332 5.0035 13.0985C4.99099 13.2635 5.01212 13.4294 5.06562 13.586C5.11911 13.7426 5.20386 13.8868 5.31471 14.0096Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ky = [
  Cy
];
function xy(e, i) {
  return f(), p("svg", wy, ky);
}
const by = /* @__PURE__ */ k(_y, [["render", xy]]), My = {}, Dy = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ay = /* @__PURE__ */ u("path", {
  d: "M14.0093 34.6856L29.5962 20.9572C29.726 20.8328 29.8292 20.6835 29.8997 20.5182C29.9702 20.3529 30.0066 20.1751 30.0066 19.9954C30.0066 19.8157 29.9702 19.6379 29.8997 19.4726C29.8292 19.3073 29.726 19.158 29.5962 19.0336L14.0093 5.31149C13.8857 5.20174 13.7412 5.11796 13.5845 5.06514C13.4279 5.01232 13.2622 4.99153 13.0973 5.00401C12.9325 5.01648 12.7718 5.06197 12.6249 5.13776C12.4779 5.21356 12.3477 5.31812 12.242 5.44522L10.296 7.75745C10.0786 8.0153 9.97133 8.34827 9.99728 8.68451C10.0232 9.02076 10.1804 9.33332 10.4347 9.55474L22.2496 19.7598C22.2837 19.7891 22.311 19.8255 22.3298 19.8664C22.3486 19.9072 22.3583 19.9517 22.3583 19.9967C22.3583 20.0416 22.3486 20.0861 22.3298 20.1269C22.311 20.1678 22.2837 20.2042 22.2496 20.2335L10.4385 30.4423C10.3118 30.5523 10.2081 30.6862 10.1333 30.8363C10.0584 30.9865 10.0139 31.1499 10.0023 31.3172C9.98744 31.4836 10.0061 31.6513 10.0572 31.8104C10.1083 31.9695 10.1908 32.1167 10.2997 32.2434L12.247 34.5568C12.3529 34.6836 12.4832 34.7879 12.6301 34.8635C12.7771 34.9391 12.9377 34.9845 13.1024 34.997C13.2672 35.0094 13.4328 34.9887 13.5894 34.9361C13.746 34.8835 13.8905 34.8 14.0143 34.6906L14.0093 34.6856Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ly = [
  Ay
];
function Ty(e, i) {
  return f(), p("svg", Dy, Ly);
}
const Sy = /* @__PURE__ */ k(My, [["render", Ty]]), Ny = {}, Ey = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zy = /* @__PURE__ */ u("path", {
  d: "M34.6851 25.9913L20.9567 10.4043C20.8323 10.2746 20.683 10.1714 20.5177 10.1009C20.3524 10.0304 20.1746 9.99402 19.9949 9.99402C19.8152 9.99402 19.6374 10.0304 19.4721 10.1009C19.3068 10.1714 19.1575 10.2746 19.0332 10.4043L5.311 25.9913C5.20125 26.1149 5.11748 26.2594 5.06465 26.416C5.01183 26.5727 4.99104 26.7384 5.00352 26.9032C5.01599 27.0681 5.06148 27.2288 5.13727 27.3757C5.21307 27.5226 5.31763 27.6528 5.44474 27.7586L7.75697 29.7046C8.01481 29.922 8.34778 30.0292 8.68402 30.0033C9.02027 29.9773 9.33283 29.8202 9.55426 29.5658L19.7593 17.751C19.7886 17.7169 19.825 17.6895 19.8659 17.6708C19.9067 17.652 19.9512 17.6423 19.9962 17.6423C20.0411 17.6423 20.0856 17.652 20.1265 17.6708C20.1673 17.6895 20.2037 17.7169 20.233 17.751L30.4418 29.5621C30.5518 29.6887 30.6857 29.7924 30.8358 29.8673C30.986 29.9421 31.1494 29.9867 31.3167 29.9983C31.4831 30.0131 31.6508 29.9944 31.8099 29.9434C31.969 29.8923 32.1162 29.8098 32.2429 29.7008L34.5563 27.7536C34.6832 27.6476 34.7874 27.5174 34.863 27.3704C34.9386 27.2235 34.984 27.0629 34.9965 26.8982C35.0089 26.7334 34.9883 26.5678 34.9356 26.4112C34.883 26.2546 34.7995 26.1101 34.6901 25.9863L34.6851 25.9913Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Iy = [
  zy
];
function By(e, i) {
  return f(), p("svg", Ey, Iy);
}
const Oy = /* @__PURE__ */ k(Ny, [["render", By]]), Hy = {}, jy = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vy = /* @__PURE__ */ u("path", {
  d: "M26.8368 35.0005C26.5868 35.0005 26.3506 34.903 26.1743 34.7255L12.7743 21.3255C12.4206 20.9717 12.2256 20.5017 12.2256 20.0017C12.2256 19.5017 12.4193 19.0305 12.7731 18.6767L26.1743 5.27549C26.3506 5.09799 26.5868 5.00049 26.8368 5.00049C27.0868 5.00049 27.3231 5.09799 27.4993 5.27549C27.6768 5.45174 27.7743 5.68799 27.7743 5.93799C27.7743 6.18799 27.6768 6.42424 27.4993 6.60049L14.0993 20.0005L27.4993 33.4005C27.6768 33.578 27.7743 33.813 27.7743 34.063C27.7743 34.313 27.6768 34.5492 27.4993 34.7255C27.3218 34.9017 27.0868 35.0005 26.8368 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Fy = [
  Vy
];
function Py(e, i) {
  return f(), p("svg", jy, Fy);
}
const Uy = /* @__PURE__ */ k(Hy, [["render", Py]]), Ry = {}, Yy = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zy = /* @__PURE__ */ u("path", {
  d: "M14.7188 3.4375C14.8438 3.4375 14.9619 3.48625 15.05 3.575L17.8625 6.3875C17.9063 6.43125 17.9406 6.48313 17.9644 6.54063C17.9663 6.545 17.9681 6.55063 17.97 6.55563C17.9894 6.60625 18 6.66188 18 6.71875C18 6.77438 17.99 6.82875 17.97 6.88188C17.9675 6.88875 17.965 6.89563 17.9625 6.90125C17.9406 6.95438 17.9063 7.00625 17.8625 7.05L15.05 9.8625C14.9613 9.95125 14.8438 10 14.7188 10C14.5938 10 14.4756 9.95125 14.3875 9.8625C14.2988 9.77438 14.25 9.65625 14.25 9.53125C14.25 9.40625 14.2988 9.28813 14.3875 9.2L16.4 7.1875L8.15625 7.1875C5.83 7.1875 3.9375 9.08 3.9375 11.4062C3.9375 13.7325 5.83 15.625 8.15625 15.625L11.9063 15.625C12.165 15.625 12.375 15.835 12.375 16.0937C12.375 16.3525 12.165 16.5625 11.9063 16.5625L8.15625 16.5625C5.31313 16.5625 3 14.2494 3 11.4062C3 8.56313 5.31313 6.25 8.15625 6.25L16.3994 6.25L14.3869 4.2375C14.2988 4.14938 14.25 4.03125 14.25 3.90625C14.25 3.78125 14.2988 3.66313 14.3875 3.575C14.4756 3.48625 14.5938 3.4375 14.7188 3.4375Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), Wy = [
  Zy
];
function Qy(e, i) {
  return f(), p("svg", Yy, Wy);
}
const qy = /* @__PURE__ */ k(Ry, [["render", Qy]]), Gy = {}, Xy = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jy = /* @__PURE__ */ u("path", {
  d: "M13.1635 35.0005C12.9135 35.0005 12.6772 34.903 12.501 34.7255C12.136 34.3605 12.136 33.7655 12.501 33.3992L25.901 20.0005L12.501 6.60049C12.3235 6.42424 12.226 6.18799 12.226 5.93799C12.226 5.68799 12.3235 5.45174 12.501 5.27549C12.6772 5.09799 12.9135 5.00049 13.1635 5.00049C13.4135 5.00049 13.6497 5.09799 13.826 5.27549L27.226 18.6755C27.956 19.4055 27.9572 20.5942 27.2272 21.3242L13.826 34.7255C13.6497 34.903 13.4135 35.0005 13.1635 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ky = [
  Jy
];
function $y(e, i) {
  return f(), p("svg", Xy, Ky);
}
const ev = /* @__PURE__ */ k(Gy, [["render", $y]]), nv = {}, iv = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tv = /* @__PURE__ */ u("path", {
  d: "M6.28125 3.4375C6.15625 3.4375 6.03812 3.48625 5.95 3.575L3.1375 6.3875C3.09375 6.43125 3.05937 6.48313 3.03562 6.54063C3.03375 6.545 3.03187 6.55063 3.03 6.55563C3.01062 6.60625 3 6.66188 3 6.71875C3 6.77438 3.01 6.82875 3.03 6.88188C3.0325 6.88875 3.035 6.89563 3.0375 6.90125C3.05937 6.95438 3.09375 7.00625 3.1375 7.05L5.95 9.8625C6.03875 9.95125 6.15625 10 6.28125 10C6.40625 10 6.52437 9.95125 6.6125 9.8625C6.70125 9.77438 6.75 9.65625 6.75 9.53125C6.75 9.40625 6.70125 9.28813 6.6125 9.2L4.6 7.1875L12.8437 7.1875C15.17 7.1875 17.0625 9.08 17.0625 11.4062C17.0625 13.7325 15.17 15.625 12.8437 15.625L9.09375 15.625C8.835 15.625 8.625 15.835 8.625 16.0937C8.625 16.3525 8.835 16.5625 9.09375 16.5625L12.8437 16.5625C15.6869 16.5625 18 14.2494 18 11.4062C18 8.56313 15.6869 6.25 12.8437 6.25L4.60062 6.25L6.61312 4.2375C6.70125 4.14938 6.75 4.03125 6.75 3.90625C6.75 3.78125 6.70125 3.66313 6.6125 3.575C6.52437 3.48625 6.40625 3.4375 6.28125 3.4375Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), av = [
  tv
];
function sv(e, i) {
  return f(), p("svg", iv, av);
}
const ov = /* @__PURE__ */ k(nv, [["render", sv]]), rv = {}, lv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dv = /* @__PURE__ */ u("path", {
  d: "M14.375 34.6329C11.8713 34.6329 9.51625 33.6579 7.74625 31.8867C5.97625 30.1154 5 27.7629 5 25.2579C5 22.7529 5.975 20.3992 7.74625 18.6292L19.0163 7.36042C20.225 6.10917 21.8587 5.40042 23.6112 5.36917C23.66 5.36792 23.7113 5.36792 23.7612 5.36792C25.4475 5.36792 27.0538 6.02292 28.2838 7.21042C29.5425 8.42667 30.2525 10.0617 30.2837 11.8167C30.3137 13.5717 29.6613 15.2304 28.445 16.4892C28.3913 16.5442 28.3375 16.5992 28.2825 16.6517L17.0275 27.9142C16.315 28.6029 15.3863 28.9792 14.4062 28.9792H14.3475C13.345 28.9617 12.41 28.5554 11.7137 27.8354C10.3025 26.3754 10.3025 24.0867 11.7125 22.6254L22.9938 11.3404C23.1713 11.1629 23.4062 11.0654 23.6562 11.0654C23.9062 11.0654 24.1413 11.1629 24.3188 11.3392C24.685 11.7054 24.685 12.3004 24.3188 12.6654L13.05 23.9379C12.3538 24.6592 12.3562 25.8004 13.0612 26.5317C13.4087 26.8917 13.8763 27.0942 14.3775 27.1029H14.4175C14.9012 27.1029 15.36 26.9154 15.7125 26.5754L26.97 15.3117C27.0212 15.2629 27.0588 15.2254 27.095 15.1867C28.8913 13.3267 28.84 10.3529 26.9812 8.55792C26.1025 7.70917 24.9462 7.24167 23.7262 7.24167L23.6437 7.24292C22.3925 7.26417 21.2237 7.77292 20.3538 8.67292L9.0725 19.9529C7.655 21.3717 6.875 23.2542 6.875 25.2579C6.875 27.2617 7.655 29.1442 9.07125 30.5617C10.485 31.9754 12.3688 32.7542 14.375 32.7542C16.3813 32.7542 18.2638 31.9754 19.6788 30.5617L33.4 16.8392C33.5775 16.6617 33.8125 16.5642 34.0625 16.5642C34.3125 16.5642 34.5487 16.6617 34.725 16.8392C34.9025 17.0154 35 17.2517 35 17.5017C35 17.7517 34.9025 17.9879 34.725 18.1642L21.0037 31.8867C19.2338 33.6579 16.8787 34.6329 14.375 34.6329Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cv = [
  dv
];
function fv(e, i) {
  return f(), p("svg", lv, cv);
}
const uv = /* @__PURE__ */ k(rv, [["render", fv]]), hv = {}, mv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pv = /* @__PURE__ */ u("path", {
  d: "M12.8413 35.0005C11.2933 35.0005 9.98 33.7925 9.852 32.2485L8.08 11.0005H6C5.448 11.0005 5 10.5525 5 10.0005C5 9.44849 5.448 9.00049 6 9.00049H14V8.00049C14 6.34582 15.3453 5.00049 17 5.00049H23C24.6547 5.00049 26 6.34582 26 8.00049V9.00049H34C34.552 9.00049 35 9.44849 35 10.0005C35 10.5525 34.552 11.0005 34 11.0005H31.92L30.1493 32.2498C30.0213 33.7925 28.708 35.0005 27.16 35.0005H12.8413V35.0005ZM11.844 32.0832C11.8867 32.5978 12.324 33.0005 12.8413 33.0005H27.16C27.676 33.0005 28.1147 32.5978 28.156 32.0832L29.9133 11.0005H10.0867L11.844 32.0832ZM24 9.00049V8.00049C24 7.44849 23.552 7.00049 23 7.00049H17C16.448 7.00049 16 7.44849 16 8.00049V9.00049H24Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yv = /* @__PURE__ */ u("path", {
  d: "M17 28.0005C16.448 28.0005 16 27.5525 16 27.0005V17.0005C16 16.4485 16.448 16.0005 17 16.0005C17.552 16.0005 18 16.4485 18 17.0005V27.0005C18 27.5525 17.552 28.0005 17 28.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), vv = /* @__PURE__ */ u("path", {
  d: "M22.9999 28.0005C22.4479 28.0005 21.9999 27.5525 21.9999 27.0005V17.0005C21.9999 16.4485 22.4479 16.0005 22.9999 16.0005C23.5519 16.0005 23.9999 16.4485 23.9999 17.0005V27.0005C23.9999 27.5525 23.5519 28.0005 22.9999 28.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), gv = [
  pv,
  yv,
  vv
];
function _v(e, i) {
  return f(), p("svg", mv, gv);
}
const wv = /* @__PURE__ */ k(hv, [["render", _v]]), Cv = {}, kv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xv = /* @__PURE__ */ u("path", {
  d: "M11.5625 35.0005C9.495 35.0005 7.8125 33.318 7.8125 31.2505V9.68799C7.8125 7.10299 9.915 5.00049 12.5 5.00049H30.3125C31.3463 5.00049 32.1875 5.84174 32.1875 6.87549V27.5005C32.1875 28.5342 31.3463 29.3755 30.3125 29.3755V33.1255H31.25C31.7675 33.1255 32.1875 33.5455 32.1875 34.063C32.1875 34.5805 31.7675 35.0005 31.25 35.0005H11.5625ZM11.5625 29.3755C10.5288 29.3755 9.6875 30.2167 9.6875 31.2505C9.6875 32.2842 10.5288 33.1255 11.5625 33.1255H28.4375V29.3755H11.5625ZM12.5 6.87549C10.9488 6.87549 9.6875 8.13674 9.6875 9.68799V28.0017C10.2513 27.6742 10.8925 27.5005 11.5625 27.5005H30.3125V6.87549H12.5Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), bv = /* @__PURE__ */ u("path", {
  d: "M14.375 25.6255C13.8575 25.6255 13.4375 25.2055 13.4375 24.688C13.4375 22.2392 14.825 20.0005 16.965 18.878C15.93 17.9955 15.3125 16.693 15.3125 15.313C15.3125 12.728 17.415 10.6255 20 10.6255C22.585 10.6255 24.6875 12.728 24.6875 15.313C24.6875 16.693 24.07 17.9955 23.035 18.878C25.175 20.0005 26.5625 22.2392 26.5625 24.688C26.5625 25.2055 26.1425 25.6255 25.625 25.6255H14.375ZM24.5925 23.7505C24.1525 21.6105 22.2275 20.0005 20 20.0005C17.7725 20.0005 15.8475 21.6105 15.4075 23.7505H24.5925ZM20 12.5005C18.4488 12.5005 17.1875 13.7617 17.1875 15.313C17.1875 16.8642 18.4488 18.1255 20 18.1255C21.5513 18.1255 22.8125 16.8642 22.8125 15.313C22.8125 13.7617 21.5513 12.5005 20 12.5005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Mv = [
  xv,
  bv
];
function Dv(e, i) {
  return f(), p("svg", kv, Mv);
}
const Av = /* @__PURE__ */ k(Cv, [["render", Dv]]), Lv = {}, Tv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sv = /* @__PURE__ */ u("path", {
  d: "M30.1875 10.0505C30.0465 10.0217 29.9198 9.94519 29.8287 9.83384C29.7376 9.72248 29.6878 9.58311 29.6875 9.43924V7.50049C29.6875 6.83745 29.4241 6.20156 28.9553 5.73272C28.4864 5.26388 27.8505 5.00049 27.1875 5.00049H11.5625C10.5679 5.00049 9.61411 5.39558 8.91085 6.09884C8.20759 6.8021 7.8125 7.75593 7.8125 8.75049V31.2505C7.8125 32.2451 8.20759 33.1989 8.91085 33.9021C9.61411 34.6054 10.5679 35.0005 11.5625 35.0005H29.6875C30.3505 35.0005 30.9864 34.7371 31.4553 34.2683C31.9241 33.7994 32.1875 33.1635 32.1875 32.5005V12.5005C32.1876 11.9242 31.9886 11.3655 31.6242 10.919C31.2597 10.4726 30.7522 10.1658 30.1875 10.0505ZM10.3125 8.75049C10.3125 8.41897 10.4442 8.10103 10.6786 7.8666C10.913 7.63218 11.231 7.50049 11.5625 7.50049H26.875C26.9579 7.50049 27.0374 7.53341 27.096 7.59202C27.1546 7.65062 27.1875 7.73011 27.1875 7.81299V9.68799C27.1875 9.77087 27.1546 9.85035 27.096 9.90896C27.0374 9.96756 26.9579 10.0005 26.875 10.0005H11.5625C11.231 10.0005 10.913 9.86879 10.6786 9.63437C10.4442 9.39995 10.3125 9.08201 10.3125 8.75049ZM27.28 29.9805C27.2214 30.0509 27.148 30.1075 27.065 30.1464C26.9821 30.1853 26.8916 30.2055 26.8 30.2055H13.2C13.1085 30.2056 13.0181 30.1857 12.9352 30.1471C12.8523 30.1085 12.7788 30.0521 12.7201 29.982C12.6613 29.9119 12.6186 29.8298 12.5951 29.7414C12.5715 29.653 12.5677 29.5605 12.5838 29.4705C12.696 28.8198 12.9005 28.1884 13.1913 27.5955C13.75 26.4755 15.1563 25.788 17.7263 24.8355C17.8343 24.5321 17.8307 24.2002 17.7163 23.8992C16.7103 22.6358 16.2132 21.0418 16.3225 19.4305C16.2965 18.9314 16.3723 18.4323 16.5453 17.9634C16.7184 17.4946 16.9851 17.0659 17.3291 16.7035C17.6732 16.341 18.0874 16.0524 18.5466 15.8551C19.0057 15.6579 19.5003 15.5562 20 15.5562C20.4998 15.5562 20.9943 15.6579 21.4534 15.8551C21.9126 16.0524 22.3268 16.341 22.6709 16.7035C23.0149 17.0659 23.2816 17.4946 23.4547 17.9634C23.6277 18.4323 23.7035 18.9314 23.6775 19.4305C23.786 21.0548 23.281 22.6606 22.2625 23.9305C22.1607 24.2313 22.1722 24.5589 22.295 24.8517C24.8438 25.7905 26.25 26.4767 26.8088 27.6017C27.0995 28.1946 27.304 28.826 27.4163 29.4767C27.4312 29.5656 27.4267 29.6566 27.4032 29.7435C27.3797 29.8305 27.3377 29.9113 27.28 29.9805Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Nv = [
  Sv
];
function Ev(e, i) {
  return f(), p("svg", Tv, Nv);
}
const zv = /* @__PURE__ */ k(Lv, [["render", Ev]]), Iv = {}, Bv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ov = /* @__PURE__ */ Ke('<path d="M17.2225 32.5005C16.8775 32.5005 16.5975 32.2205 16.5975 31.8755V30.0005C16.5975 29.6555 16.8775 29.3755 17.2225 29.3755C17.5675 29.3755 17.8475 29.6555 17.8475 30.0005V31.8755C17.8475 32.2205 17.5662 32.5005 17.2225 32.5005Z" fill="#3B414D" class="primary"></path><path d="M9.72247 25.0005C9.37747 25.0005 9.09747 24.7205 9.09747 24.3755V8.12549C9.09747 7.78049 9.37747 7.50049 9.72247 7.50049C10.0675 7.50049 10.3475 7.78049 10.3475 8.12549V24.3755C10.3475 24.7205 10.0662 25.0005 9.72247 25.0005Z" fill="#3B414D" class="primary"></path><path d="M17.2225 28.1255C16.8775 28.1255 16.5975 27.8455 16.5975 27.5005V18.1255C16.5975 17.7805 16.8775 17.5005 17.2225 17.5005C17.5675 17.5005 17.8475 17.7805 17.8475 18.1255V27.5005C17.8475 27.8455 17.5662 28.1255 17.2225 28.1255Z" fill="#3B414D" class="primary"></path><path d="M9.71741 31.8755C9.37241 31.8755 9.09241 31.5955 9.09241 31.2505V27.5005C9.09241 27.1555 9.37241 26.8755 9.71741 26.8755C10.0624 26.8755 10.3424 27.1555 10.3424 27.5005V31.2505C10.3424 31.5955 10.0612 31.8755 9.71741 31.8755Z" fill="#3B414D" class="primary"></path><path d="M14.7225 35.0005C14.2537 35.0005 13.8137 34.828 13.4725 34.5167C13.13 34.828 12.6912 35.0005 12.2225 35.0005H7.22247C6.18872 35.0005 5.34747 34.1592 5.34747 33.1255V6.87549C5.34747 5.84174 6.18872 5.00049 7.22247 5.00049H12.2225C13.2562 5.00049 14.0975 5.84174 14.0975 6.87549V15.1105C14.2962 15.038 14.5075 15.0005 14.7225 15.0005H19.7225C19.9112 15.0005 20.095 15.028 20.27 15.0817L19.2612 11.9905C19.1062 11.5142 19.145 11.0067 19.3712 10.5592C19.5975 10.1117 19.985 9.78049 20.4612 9.62549L25.2112 8.07424C25.4012 8.01174 25.5975 7.98049 25.795 7.98049C26.0862 7.98049 26.38 8.05049 26.6425 8.18424C27.085 8.40924 27.4162 8.79299 27.5725 9.26549L34.5587 30.6655C34.715 31.1417 34.675 31.6492 34.4487 32.0967C34.2225 32.5442 33.835 32.8755 33.3587 33.0305L28.6087 34.5817C28.42 34.643 28.225 34.6742 28.0275 34.6742C27.2125 34.6742 26.4962 34.1542 26.2437 33.3805L21.5962 19.1467V33.1255C21.5962 34.1592 20.755 35.0005 19.7212 35.0005H14.7225ZM14.7225 16.2505C14.3775 16.2505 14.0975 16.5305 14.0975 16.8755V33.1255C14.0975 33.4705 14.3775 33.7505 14.7225 33.7505H19.7225C20.0675 33.7505 20.3475 33.4705 20.3475 33.1255V16.8755C20.3475 16.5305 20.0675 16.2505 19.7225 16.2505H14.7225ZM7.22247 6.25049C6.87747 6.25049 6.59747 6.53049 6.59747 6.87549V33.1255C6.59747 33.4705 6.87747 33.7505 7.22247 33.7505H12.2225C12.5675 33.7505 12.8475 33.4705 12.8475 33.1255V6.87549C12.8475 6.53049 12.5675 6.25049 12.2225 6.25049H7.22247ZM25.7937 9.23174C25.7275 9.23174 25.6625 9.24174 25.5987 9.26299L20.8487 10.8142C20.69 10.8655 20.5612 10.9767 20.485 11.1255C20.41 11.2742 20.3962 11.4442 20.4487 11.6017L27.4325 32.9917C27.485 33.1505 27.595 33.2805 27.7437 33.3555C27.8325 33.4005 27.9275 33.423 28.0262 33.423C28.0912 33.423 28.1575 33.413 28.2212 33.3917L32.9712 31.8405C33.13 31.788 33.2587 31.678 33.335 31.5292C33.4112 31.3805 33.4237 31.2105 33.3712 31.0517L26.3887 9.67049C26.335 9.50549 26.2237 9.37549 26.075 9.30049C25.9862 9.25549 25.8912 9.23174 25.7937 9.23174Z" fill="#3B414D" class="primary"></path><path d="M27.6849 24.3305C27.4136 24.3305 27.1749 24.1568 27.0911 23.8993L23.2136 12.0155C23.1611 11.8568 23.1736 11.688 23.2499 11.5393C23.3261 11.3905 23.4549 11.2805 23.6136 11.228C23.6774 11.208 23.7424 11.1968 23.8086 11.1968C24.0799 11.1968 24.3174 11.3705 24.4024 11.628L28.2799 23.5118C28.3324 23.6705 28.3187 23.8393 28.2437 23.9893C28.1687 24.1393 28.0386 24.2493 27.8799 24.3005C27.8161 24.3205 27.7511 24.3305 27.6849 24.3305Z" fill="#3B414D" class="primary"></path><path d="M29.8125 30.8679C29.5413 30.8679 29.3025 30.6942 29.2175 30.4367L28.055 26.8717C27.9488 26.5442 28.1288 26.1917 28.4563 26.0842C28.52 26.0642 28.585 26.0542 28.65 26.0542C28.9225 26.0542 29.1613 26.2279 29.245 26.4854L30.4075 30.0504C30.5138 30.3779 30.3338 30.7304 30.0063 30.8379C29.9425 30.8579 29.8775 30.8679 29.8125 30.8679Z" fill="#3B414D" class="primary"></path>', 7), Hv = [
  Ov
];
function jv(e, i) {
  return f(), p("svg", Bv, Hv);
}
const Vv = /* @__PURE__ */ k(Iv, [["render", jv]]), Fv = {}, Pv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uv = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.5 23.613C6.773 23.862 7.125 24 7.5 24H11.499C12.326 24 12.999 23.327 12.999 22.5V11.317L16.717 22.704C16.919 23.323 17.492 23.739 18.144 23.739C18.302 23.739 18.458 23.714 18.609 23.665L22.409 22.424C22.79 22.3 23.1 22.035 23.281 21.677C23.462 21.319 23.494 20.913 23.369 20.532L17.78 3.412C17.655 3.034 17.39 2.727 17.036 2.547C16.826 2.44 16.591 2.384 16.358 2.384C16.2 2.384 16.043 2.409 15.891 2.459L12.091 3.7C11.71 3.824 11.4 4.089 11.219 4.447C11.038 4.805 11.007 5.211 11.131 5.592L11.938 8.065C11.798 8.022 11.651 8 11.5 8H7.5C7.328 8 7.159 8.03 7 8.088V1.5C7 0.673 6.327 0 5.5 0H1.5C0.673 0 0 0.673 0 1.5V22.5C0 23.327 0.673 24 1.5 24H5.5C5.875 24 6.226 23.862 6.5 23.613ZM9.49997 22C9.22397 22 8.99997 21.776 8.99997 21.5V20C8.99997 19.724 9.22397 19.5 9.49997 19.5C9.77597 19.5 9.99997 19.724 9.99997 20V21.5C9.99997 21.776 9.77497 22 9.49997 22ZM2.99997 15.5C2.99997 15.776 3.22397 16 3.49997 16C3.77497 16 3.99997 15.776 3.99997 15.5V2.5C3.99997 2.224 3.77597 2 3.49997 2C3.22397 2 2.99997 2.224 2.99997 2.5V15.5ZM9.49997 18.5C9.22397 18.5 8.99997 18.276 8.99997 18V10.5C8.99997 10.224 9.22397 10 9.49997 10C9.77597 10 9.99997 10.224 9.99997 10.5V18C9.99997 18.276 9.77497 18.5 9.49997 18.5ZM2.99597 21C2.99597 21.276 3.21997 21.5 3.49597 21.5C3.77097 21.5 3.99597 21.276 3.99597 21V18C3.99597 17.724 3.77197 17.5 3.49597 17.5C3.21997 17.5 2.99597 17.724 2.99597 18V21ZM17.87 15.464C17.653 15.464 17.462 15.325 17.395 15.119L14.293 5.612C14.251 5.485 14.261 5.35 14.322 5.231C14.383 5.112 14.486 5.024 14.613 4.982C14.664 4.966 14.716 4.957 14.769 4.957C14.986 4.957 15.176 5.096 15.244 5.302L18.346 14.809C18.388 14.936 18.377 15.071 18.317 15.191C18.257 15.311 18.153 15.399 18.026 15.44C17.975 15.456 17.923 15.464 17.87 15.464ZM19.096 20.349C19.164 20.555 19.355 20.694 19.572 20.694C19.624 20.694 19.676 20.686 19.727 20.67C19.989 20.584 20.133 20.302 20.048 20.04L19.118 17.188C19.051 16.982 18.86 16.843 18.642 16.843C18.59 16.843 18.538 16.851 18.487 16.867C18.225 16.953 18.081 17.235 18.166 17.497L19.096 20.349Z",
  fill: "#67738B",
  class: "primary"
}, null, -1), Rv = [
  Uv
];
function Yv(e, i) {
  return f(), p("svg", Pv, Rv);
}
const Zv = /* @__PURE__ */ k(Fv, [["render", Yv]]), Wv = {}, Qv = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qv = /* @__PURE__ */ u("g", { "clip-path": "url(#clip0)" }, [
  /* @__PURE__ */ u("rect", {
    x: "5.00018",
    y: "8.75061",
    width: "29.9997",
    height: "22.4998",
    fill: "#2B9F5A"
  }),
  /* @__PURE__ */ u("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 11.5631L7.81262 20.0005L20 28.438L32.1874 20.0005L20 11.5631Z",
    fill: "#FFD018"
  }),
  /* @__PURE__ */ u("path", {
    d: "M25.625 20.0006C25.625 23.1071 23.1066 25.6255 20 25.6255C16.8934 25.6255 14.3751 23.1071 14.3751 20.0006C14.3751 16.894 16.8934 14.3756 20 14.3756C23.1066 14.3756 25.625 16.894 25.625 20.0006Z",
    fill: "#41479B"
  }),
  /* @__PURE__ */ u("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "14",
    y: "14",
    width: "12",
    height: "12"
  }, [
    /* @__PURE__ */ u("path", {
      d: "M25.625 20.0006C25.625 23.1071 23.1066 25.6255 20 25.6255C16.8934 25.6255 14.3751 23.1071 14.3751 20.0006C14.3751 16.894 16.8934 14.3756 20 14.3756C23.1066 14.3756 25.625 16.894 25.625 20.0006Z",
      fill: "#41479B"
    })
  ]),
  /* @__PURE__ */ u("g", { mask: "url(#mask0)" }, [
    /* @__PURE__ */ u("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5145 18.8245L13.4375 18.1256C13.3604 17.4267 13.3605 17.4267 13.3607 17.4267L13.3653 17.4262L13.3762 17.425L13.416 17.421C13.4502 17.4176 13.4998 17.4128 13.5635 17.4072C13.6908 17.396 13.8746 17.3813 14.1046 17.3671C14.5643 17.3387 15.2108 17.3119 15.9628 17.318C17.4554 17.3301 19.4102 17.472 21.1474 18.0153C22.8725 18.555 24.3406 19.3892 25.3724 20.0822C25.89 20.4298 26.3021 20.7448 26.5866 20.9745C26.729 21.0895 26.8397 21.1833 26.916 21.2495C26.9542 21.2826 26.9837 21.3088 27.0044 21.3273L27.0286 21.3491L27.0357 21.3555L27.0379 21.3576C27.038 21.3577 27.0392 21.3588 26.5624 21.8756C26.0856 22.3923 26.0857 22.3924 26.0858 22.3925L26.0826 22.3895L26.0662 22.3748C26.0509 22.3611 26.0269 22.3398 25.9946 22.3118C25.9299 22.2557 25.8319 22.1725 25.7032 22.0687C25.4458 21.8608 25.0669 21.5709 24.5884 21.2496C23.6281 20.6046 22.2837 19.8442 20.7276 19.3575C19.1835 18.8745 17.3883 18.7359 15.9513 18.7242C15.2384 18.7184 14.6252 18.7439 14.1913 18.7707C13.9746 18.7841 13.8031 18.7978 13.6869 18.808C13.6288 18.8131 13.5846 18.8174 13.5554 18.8203L13.5232 18.8236L13.5145 18.8245Z",
      fill: "#F5F8FB"
    })
  ]),
  /* @__PURE__ */ u("path", {
    d: "M18.1251 22.3442C18.1251 22.6031 17.9152 22.813 17.6563 22.813C17.3974 22.813 17.1876 22.6031 17.1876 22.3442C17.1876 22.0854 17.3974 21.8755 17.6563 21.8755C17.9152 21.8755 18.1251 22.0854 18.1251 22.3442Z",
    fill: "#F5F8FB"
  }),
  /* @__PURE__ */ u("path", {
    d: "M20.9375 23.2817C20.9375 23.5406 20.7276 23.7505 20.4687 23.7505C20.2099 23.7505 20 23.5406 20 23.2817C20 23.0229 20.2099 22.813 20.4687 22.813C20.7276 22.813 20.9375 23.0229 20.9375 23.2817Z",
    fill: "#F5F8FB"
  }),
  /* @__PURE__ */ u("path", {
    d: "M22.8125 22.3442C22.8125 22.6031 22.6026 22.813 22.3437 22.813C22.0849 22.813 21.875 22.6031 21.875 22.3442C21.875 22.0854 22.0849 21.8755 22.3437 21.8755C22.6026 21.8755 22.8125 22.0854 22.8125 22.3442Z",
    fill: "#F5F8FB"
  })
], -1), Gv = /* @__PURE__ */ u("defs", null, [
  /* @__PURE__ */ u("clipPath", { id: "clip0" }, [
    /* @__PURE__ */ u("rect", {
      width: "40",
      height: "39.9996",
      fill: "white",
      transform: "translate(0 0.000488281)"
    })
  ])
], -1), Xv = [
  qv,
  Gv
];
function Jv(e, i) {
  return f(), p("svg", Qv, Xv);
}
const Kv = /* @__PURE__ */ k(Wv, [["render", Jv]]), $v = {}, eg = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ng = /* @__PURE__ */ Ke('<path d="M11.5625 20.0005C11.045 20.0005 10.625 19.5805 10.625 19.063V17.188C10.625 16.6705 11.045 16.2505 11.5625 16.2505C12.08 16.2505 12.5 16.6705 12.5 17.188V19.063C12.5 19.5805 12.08 20.0005 11.5625 20.0005Z" fill="#3B414D" class="primary"></path><path d="M17.1875 20.0005C16.67 20.0005 16.25 19.5805 16.25 19.063V17.188C16.25 16.6705 16.67 16.2505 17.1875 16.2505C17.705 16.2505 18.125 16.6705 18.125 17.188V19.063C18.125 19.5805 17.705 20.0005 17.1875 20.0005Z" fill="#3B414D" class="primary"></path><path d="M22.8125 20.0005C22.295 20.0005 21.875 19.5805 21.875 19.063V17.188C21.875 16.6705 22.295 16.2505 22.8125 16.2505C23.33 16.2505 23.75 16.6705 23.75 17.188V19.063C23.75 19.5805 23.33 20.0005 22.8125 20.0005Z" fill="#3B414D" class="primary"></path><path d="M28.4375 20.0005C27.92 20.0005 27.5 19.5805 27.5 19.063V17.188C27.5 16.6705 27.92 16.2505 28.4375 16.2505C28.955 16.2505 29.375 16.6705 29.375 17.188V19.063C29.375 19.5805 28.955 20.0005 28.4375 20.0005Z" fill="#3B414D" class="primary"></path><path d="M11.5625 25.6255C11.045 25.6255 10.625 25.2055 10.625 24.688V22.813C10.625 22.2955 11.045 21.8755 11.5625 21.8755C12.08 21.8755 12.5 22.2955 12.5 22.813V24.688C12.5 25.2055 12.08 25.6255 11.5625 25.6255Z" fill="#3B414D" class="primary"></path><path d="M17.1875 25.6255C16.67 25.6255 16.25 25.2055 16.25 24.688V22.813C16.25 22.2955 16.67 21.8755 17.1875 21.8755C17.705 21.8755 18.125 22.2955 18.125 22.813V24.688C18.125 25.2055 17.705 25.6255 17.1875 25.6255Z" fill="#3B414D" class="primary"></path><path d="M22.8125 25.6255C22.295 25.6255 21.875 25.2055 21.875 24.688V22.813C21.875 22.2955 22.295 21.8755 22.8125 21.8755C23.33 21.8755 23.75 22.2955 23.75 22.813V24.688C23.75 25.2055 23.33 25.6255 22.8125 25.6255Z" fill="#3B414D" class="primary"></path><path d="M28.4375 25.6255C27.92 25.6255 27.5 25.2055 27.5 24.688V22.813C27.5 22.2955 27.92 21.8755 28.4375 21.8755C28.955 21.8755 29.375 22.2955 29.375 22.813V24.688C29.375 25.2055 28.955 25.6255 28.4375 25.6255Z" fill="#3B414D" class="primary"></path><path d="M7.8125 35.0005C7.295 35.0005 6.875 34.5805 6.875 34.063V14.3755H5.9375C5.42 14.3755 5 13.9555 5 13.438C5 12.9205 5.42 12.5005 5.9375 12.5005H7.08L8.4225 7.13049C8.73625 5.87674 9.85875 5.00049 11.1512 5.00049H28.8488C30.1413 5.00049 31.2638 5.87674 31.5763 7.13049L32.9187 12.5005H34.0625C34.58 12.5005 35 12.9205 35 13.438C35 13.9555 34.58 14.3755 34.0625 14.3755H33.125V34.063C33.125 34.5805 32.705 35.0005 32.1875 35.0005H7.8125ZM31.25 33.1255V14.3755H8.75V33.1255H16.25V30.313C16.25 28.7617 17.5112 27.5005 19.0625 27.5005H20.9375C22.4888 27.5005 23.75 28.7617 23.75 30.313V33.1255H31.25ZM21.875 33.1255V30.313C21.875 29.7955 21.455 29.3755 20.9375 29.3755H19.0625C18.545 29.3755 18.125 29.7955 18.125 30.313V33.1255H21.875ZM30.9875 12.5005L29.7587 7.58549C29.6537 7.16799 29.28 6.87549 28.8488 6.87549H11.1512C10.72 6.87549 10.3462 7.16799 10.2413 7.58549L9.01375 12.5005H30.9875Z" fill="#3B414D" class="primary"></path><path d="M11.5625 31.2505C11.045 31.2505 10.625 30.8305 10.625 30.313V28.438C10.625 27.9205 11.045 27.5005 11.5625 27.5005C12.08 27.5005 12.5 27.9205 12.5 28.438V30.313C12.5 30.8305 12.08 31.2505 11.5625 31.2505Z" fill="#3B414D" class="primary"></path><path d="M28.4375 31.2505C27.92 31.2505 27.5 30.8305 27.5 30.313V28.438C27.5 27.9205 27.92 27.5005 28.4375 27.5005C28.955 27.5005 29.375 27.9205 29.375 28.438V30.313C29.375 30.8305 28.955 31.2505 28.4375 31.2505Z" fill="#3B414D" class="primary"></path>', 11), ig = [
  ng
];
function tg(e, i) {
  return f(), p("svg", eg, ig);
}
const ag = /* @__PURE__ */ k($v, [["render", tg]]), sg = {}, og = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rg = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), lg = /* @__PURE__ */ u("path", {
  d: "M18.2938 27.5005C17.4988 27.5005 16.75 27.1905 16.1875 26.6292C15.6237 26.0667 15.3125 25.318 15.3125 24.5205V15.483C15.3125 14.7605 15.5738 14.063 16.05 13.518C16.6163 12.8717 17.4337 12.5017 18.295 12.5017C19.0175 12.5017 19.7138 12.763 20.2575 13.2392L27.18 19.298C27.3837 19.4755 27.5 19.733 27.5 20.003C27.5 20.2742 27.3825 20.5305 27.1788 20.7092L20.2575 26.7642C19.7138 27.2392 19.0175 27.5005 18.2975 27.5005H18.2938ZM18.295 14.3767C17.975 14.3767 17.6712 14.5142 17.4612 14.7542C17.285 14.9555 17.1875 15.2142 17.1875 15.483V24.5192C17.1875 24.8142 17.3038 25.093 17.5125 25.3017C17.7213 25.5105 17.9988 25.6255 18.2938 25.6255C18.5625 25.6255 18.8213 25.528 19.0225 25.3517L25.1388 20.003L19.0225 14.6505C18.8213 14.473 18.5625 14.3767 18.295 14.3767Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), dg = [
  rg,
  lg
];
function cg(e, i) {
  return f(), p("svg", og, dg);
}
const fg = /* @__PURE__ */ k(sg, [["render", cg]]), ug = {}, hg = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mg = /* @__PURE__ */ u("path", {
  d: "M21.009 34.025C19.1582 34.025 17.3515 33.6629 15.6384 32.9506C15.3912 32.8478 15.1987 32.6553 15.0972 32.4081C14.9956 32.1609 14.9956 31.8883 15.0985 31.6411C15.2549 31.2656 15.6183 31.0237 16.0246 31.0237C16.1569 31.0237 16.2865 31.0491 16.4081 31.0999C17.8767 31.7105 19.4242 32.0206 21.0117 32.0206C24.116 32.0206 27.0599 30.8393 29.3022 28.6945C31.6113 26.4842 32.9223 23.5029 32.9931 20.2984C33.0639 17.094 31.8853 14.0565 29.6764 11.7474C27.3966 9.36472 24.3204 8.05246 21.013 8.05246C17.9088 8.05246 14.9662 9.23109 12.7292 11.3732C10.5738 13.4351 9.27086 16.2026 9.05972 19.1679C8.87263 21.8405 9.56084 24.4437 11.0134 26.6366V23.0018C11.0134 22.4486 11.4624 21.9996 12.0156 21.9996C12.5689 21.9996 13.0179 22.4486 13.0179 23.0018V29.0152C13.0179 29.5684 12.5689 30.0174 12.0156 30.0174H11.6976C11.6762 30.0201 11.6562 30.0214 11.6375 30.0214C11.6147 30.0214 11.592 30.0201 11.5693 30.0174H6.00223C5.449 30.0174 5 29.5684 5 29.0152C5 28.462 5.449 28.013 6.00223 28.013H9.52476C7.84367 25.5969 6.96171 22.6904 7.02719 19.7238C7.03387 19.4151 7.05391 19.0917 7.08999 18.7069L7.09935 18.6053C7.10737 18.5171 7.11538 18.4303 7.12474 18.3421L7.13276 18.2819C7.53632 15.0681 9.03299 12.0881 11.3528 9.86851C13.9774 7.35891 17.425 5.97583 21.0598 5.97583C22.9106 5.97583 24.7186 6.3353 26.4305 7.04488C26.5641 7.09967 26.6817 7.18252 26.7779 7.28542C28.4162 8.02306 29.8781 9.05737 31.1249 10.3603C36.4581 15.934 36.2617 24.8085 30.6879 30.1417C28.0714 32.6446 24.6344 34.0237 21.0117 34.0237H21.009V34.025Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), pg = [
  mg
];
function yg(e, i) {
  return f(), p("svg", hg, pg);
}
const vg = /* @__PURE__ */ k(ug, [["render", yg]]), gg = {}, _g = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wg = /* @__PURE__ */ u("path", {
  d: "M11.1462 29.3704H5.9375C5.42 29.3704 5 28.9504 5 28.4329C5 27.9154 5.42 27.4954 5.9375 27.4954H9.23375C7.65625 25.2292 6.82875 22.5029 6.89 19.7204C6.96625 16.2142 8.40375 12.9467 10.9363 10.5229C13.3912 8.17293 16.6163 6.87793 20.0175 6.87793C21.7525 6.87793 23.4463 7.21668 25.0513 7.88293C25.2825 7.97918 25.4625 8.15918 25.5588 8.39043C25.6538 8.62168 25.6537 8.87668 25.5575 9.10793C25.4112 9.45918 25.0713 9.68543 24.6912 9.68543C24.5675 9.68543 24.4463 9.66168 24.3312 9.61293C22.9562 9.04168 21.505 8.75168 20.0175 8.75168C17.1025 8.75168 14.3375 9.86168 12.2325 11.8767C10.0612 13.9554 8.82875 16.7554 8.76375 19.7604C8.71375 22.0654 9.3675 24.3104 10.625 26.2079V22.8067C10.625 22.2892 11.045 21.8692 11.5625 21.8692C12.08 21.8692 12.5 22.2904 12.5 22.8079V28.4329C12.5 28.9504 12.08 29.3704 11.5625 29.3704H11.265C11.245 29.3729 11.2263 29.3742 11.2087 29.3742C11.1937 29.3742 11.1675 29.3717 11.1462 29.3704Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Cg = /* @__PURE__ */ u("path", {
  d: "M19.9936 33.1227C18.2536 33.1227 16.5561 32.7827 14.9461 32.1127C14.7148 32.0165 14.5348 31.8365 14.4398 31.604C14.3448 31.3727 14.3448 31.1177 14.4411 30.8865C14.5873 30.5352 14.9273 30.309 15.3073 30.309C15.4311 30.309 15.5511 30.3327 15.6661 30.3802C17.0473 30.9552 18.5023 31.2477 19.9936 31.2477C22.9136 31.2477 25.6811 30.134 27.7861 28.1127C29.9548 26.0315 31.1836 23.2302 31.2448 20.2252C31.2923 17.919 30.6348 15.6752 29.3736 13.7777V17.1827C29.3736 17.7002 28.9536 18.1202 28.4361 18.1202C27.9186 18.1202 27.4998 17.699 27.4998 17.1827V11.5577C27.4998 11.0402 27.9198 10.6202 28.4373 10.6202H34.0623C34.5798 10.6202 34.9998 11.0402 34.9998 11.5577C34.9998 12.0752 34.5798 12.4952 34.0623 12.4952H30.7686C32.3473 14.759 33.1773 17.4827 33.1211 20.264C33.0486 23.769 31.6161 27.0377 29.0861 29.4665C26.6286 31.824 23.3998 33.1227 19.9936 33.1227Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kg = [
  wg,
  Cg
];
function xg(e, i) {
  return f(), p("svg", _g, kg);
}
const bg = /* @__PURE__ */ k(gg, [["render", xg]]), Mg = {}, Dg = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ag = /* @__PURE__ */ u("path", {
  d: "M31.25 35.0005C30.7325 35.0005 30.3125 34.5805 30.3125 34.063V28.438C30.3125 26.8867 29.0513 25.6255 27.5 25.6255C25.9487 25.6255 24.6875 26.8867 24.6875 28.438C24.6875 31.023 22.585 33.1255 20 33.1255C17.415 33.1255 15.3125 31.023 15.3125 28.438V25.573C11.0725 25.1042 7.8125 21.503 7.8125 17.188V13.438C7.8125 11.8867 9.07375 10.6255 10.625 10.6255H11.5625V5.93799C11.5625 5.42049 11.9825 5.00049 12.5 5.00049C13.0175 5.00049 13.4375 5.42049 13.4375 5.93799V10.6255H19.0625V5.93799C19.0625 5.42049 19.4825 5.00049 20 5.00049C20.5175 5.00049 20.9375 5.42049 20.9375 5.93799V10.6255H21.875C23.4263 10.6255 24.6875 11.8867 24.6875 13.438V17.188C24.6875 21.5017 21.4275 25.103 17.1875 25.573V28.438C17.1875 29.9892 18.4487 31.2505 20 31.2505C21.5513 31.2505 22.8125 29.9892 22.8125 28.438C22.8125 25.853 24.915 23.7505 27.5 23.7505C30.085 23.7505 32.1875 25.853 32.1875 28.438V34.063C32.1875 34.5805 31.7675 35.0005 31.25 35.0005ZM10.625 12.5005C10.1075 12.5005 9.6875 12.9205 9.6875 13.438V17.188C9.6875 20.8067 12.6312 23.7505 16.25 23.7505C19.8687 23.7505 22.8125 20.8067 22.8125 17.188V13.438C22.8125 12.9205 22.3925 12.5005 21.875 12.5005H10.625Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Lg = /* @__PURE__ */ u("path", {
  d: "M14.375 16.2505C13.8575 16.2505 13.4375 15.8305 13.4375 15.313C13.4375 14.7955 13.8575 14.3755 14.375 14.3755H18.125C18.6425 14.3755 19.0625 14.7955 19.0625 15.313C19.0625 15.8305 18.6425 16.2505 18.125 16.2505H14.375Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Tg = [
  Ag,
  Lg
];
function Sg(e, i) {
  return f(), p("svg", Dg, Tg);
}
const Ng = /* @__PURE__ */ k(Mg, [["render", Sg]]), Eg = {}, zg = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ig = /* @__PURE__ */ u("path", {
  d: "M14.375 16.2505C13.8575 16.2505 13.4375 15.8305 13.4375 15.313V14.3755H11.5625V15.313C11.5625 15.8305 11.1425 16.2505 10.625 16.2505C10.1075 16.2505 9.6875 15.8305 9.6875 15.313V11.563C9.6875 10.0117 10.9487 8.75049 12.5 8.75049C14.0512 8.75049 15.3125 10.0117 15.3125 11.563V15.313C15.3125 15.8305 14.8925 16.2505 14.375 16.2505ZM13.4375 12.5005V11.563C13.4375 11.0455 13.0175 10.6255 12.5 10.6255C11.9825 10.6255 11.5625 11.0455 11.5625 11.563V12.5005H13.4375Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Bg = /* @__PURE__ */ u("path", {
  d: "M29.3038 26.5605C27.9225 26.4667 26.5975 25.8655 25.6037 24.893C24.4712 26.0017 23.2188 26.563 21.875 26.563C21.3575 26.563 20.9375 26.143 20.9375 25.6255C20.9375 25.108 21.3575 24.688 21.875 24.688C23.925 24.688 25.365 22.418 26.0862 20.938H21.875C21.3575 20.938 20.9375 20.518 20.9375 20.0005C20.9375 19.483 21.3575 19.063 21.875 19.063H24.6875V18.1255C24.6875 17.608 25.1075 17.188 25.625 17.188C26.1425 17.188 26.5625 17.608 26.5625 18.1255V19.063H29.375C29.8925 19.063 30.3125 19.483 30.3125 20.0005C30.3125 20.518 29.8925 20.938 29.375 20.938H28.1463C27.89 21.5605 27.45 22.498 26.81 23.4355C27.4987 24.1692 28.4388 24.6217 29.4388 24.6905C29.6888 24.7067 29.9175 24.8205 30.0813 25.0092C30.2463 25.198 30.3275 25.4392 30.31 25.6892C30.2775 26.1792 29.8675 26.563 29.375 26.563C29.3525 26.563 29.3288 26.5617 29.3038 26.5605Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Og = /* @__PURE__ */ u("path", {
  d: "M30.3125 35.0005C30.0625 35.0005 29.8262 34.903 29.65 34.7255L24.3 29.3755H19.0625C17.5112 29.3755 16.25 28.1142 16.25 26.563V17.188C16.25 15.6367 17.5112 14.3755 19.0625 14.3755H32.1875C33.7388 14.3755 35 15.6367 35 17.188V26.563C35 28.1142 33.7388 29.3755 32.1875 29.3755H31.25V34.063C31.25 34.443 31.0225 34.783 30.6713 34.9292C30.5575 34.9767 30.4362 35.0005 30.3125 35.0005ZM19.0625 16.2505C18.545 16.2505 18.125 16.6705 18.125 17.188V26.563C18.125 27.0805 18.545 27.5005 19.0625 27.5005H24.6875C24.935 27.5005 25.1763 27.6005 25.35 27.7755L29.375 31.8005V28.438C29.375 27.9205 29.795 27.5005 30.3125 27.5005H32.1875C32.705 27.5005 33.125 27.0805 33.125 26.563V17.188C33.125 16.6705 32.705 16.2505 32.1875 16.2505H19.0625Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Hg = /* @__PURE__ */ u("path", {
  d: "M9.6875 25.6255C9.56375 25.6255 9.4425 25.6017 9.32875 25.5542C8.9775 25.408 8.75 25.068 8.75 24.688V20.0005H7.8125C6.26125 20.0005 5 18.7392 5 17.188V7.81299C5 6.26174 6.26125 5.00049 7.8125 5.00049H20.9375C22.4888 5.00049 23.75 6.26174 23.75 7.81299V11.563C23.75 12.0805 23.33 12.5005 22.8125 12.5005C22.295 12.5005 21.875 12.0805 21.875 11.563V7.81299C21.875 7.29549 21.455 6.87549 20.9375 6.87549H7.8125C7.295 6.87549 6.875 7.29549 6.875 7.81299V17.188C6.875 17.7055 7.295 18.1255 7.8125 18.1255H9.6875C10.205 18.1255 10.625 18.5455 10.625 19.063V22.4242L12.775 20.2742C12.9512 20.098 13.1875 20.0005 13.4375 20.0005C13.6875 20.0005 13.9237 20.098 14.1 20.2755C14.465 20.6405 14.465 21.2355 14.1 21.6017L10.35 25.3517C10.1738 25.528 9.9375 25.6255 9.6875 25.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jg = [
  Ig,
  Bg,
  Og,
  Hg
];
function Vg(e, i) {
  return f(), p("svg", zg, jg);
}
const Fg = /* @__PURE__ */ k(Eg, [["render", Vg]]), Pg = {}, Ug = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rg = /* @__PURE__ */ u("path", {
  d: "M34.8101 11.2317L31.1009 7.5118C31.0391 7.44994 30.9658 7.40086 30.8851 7.36738C30.8044 7.33389 30.7179 7.31665 30.6306 7.31665C30.5432 7.31665 30.4567 7.33389 30.376 7.36738C30.2953 7.40086 30.222 7.44994 30.1603 7.5118L14.4942 23.1885C14.4325 23.2503 14.3592 23.2994 14.2785 23.3329C14.1978 23.3664 14.1113 23.3836 14.0239 23.3836C13.9365 23.3836 13.85 23.3664 13.7693 23.3329C13.6886 23.2994 13.6153 23.2503 13.5536 23.1885L9.84435 19.4686C9.78264 19.4067 9.70934 19.3576 9.62864 19.3242C9.54794 19.2907 9.46142 19.2734 9.37405 19.2734C9.28667 19.2734 9.20016 19.2907 9.11946 19.3242C9.03876 19.3576 8.96545 19.4067 8.90375 19.4686L5.19449 23.1885C5.06996 23.313 5 23.482 5 23.6581C5 23.8343 5.06996 24.0032 5.19449 24.1278L13.5536 32.4882C13.6153 32.5501 13.6886 32.5991 13.7693 32.6326C13.85 32.6661 13.9365 32.6834 14.0239 32.6834C14.1113 32.6834 14.1978 32.6661 14.2785 32.6326C14.3592 32.5991 14.4325 32.5501 14.4942 32.4882L34.8101 12.1617C34.9318 12.0375 35 11.8706 35 11.6967C35 11.5228 34.9318 11.3559 34.8101 11.2317Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Yg = [
  Rg
];
function Zg(e, i) {
  return f(), p("svg", Ug, Yg);
}
const Wg = /* @__PURE__ */ k(Pg, [["render", Zg]]), Qg = {}, qg = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gg = /* @__PURE__ */ u("rect", {
  x: "5.5",
  y: "5.50049",
  width: "29",
  height: "29",
  rx: "3.5",
  stroke: "#3B414D",
  class: "primary-stroke"
}, null, -1), Xg = [
  Gg
];
function Jg(e, i) {
  return f(), p("svg", qg, Xg);
}
const Kg = /* @__PURE__ */ k(Qg, [["render", Jg]]), $g = {}, e_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n_ = /* @__PURE__ */ u("rect", {
  x: "5",
  y: "5.00049",
  width: "30",
  height: "30",
  rx: "4",
  fill: "#3B414D",
  class: "primary"
}, null, -1), i_ = [
  n_
];
function t_(e, i) {
  return f(), p("svg", e_, i_);
}
const a_ = /* @__PURE__ */ k($g, [["render", t_]]), s_ = {}, o_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r_ = /* @__PURE__ */ u("rect", {
  x: "5",
  y: "5.00049",
  width: "30",
  height: "30",
  rx: "4",
  fill: "#3B414D",
  class: "primary"
}, null, -1), l_ = /* @__PURE__ */ u("path", {
  d: "M12.0001 20.0006H28.0001",
  stroke: "white"
}, null, -1), d_ = [
  r_,
  l_
];
function c_(e, i) {
  return f(), p("svg", o_, d_);
}
const f_ = /* @__PURE__ */ k(s_, [["render", c_]]), u_ = {}, h_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m_ = /* @__PURE__ */ u("rect", {
  x: "5",
  y: "5.00049",
  width: "30",
  height: "30",
  rx: "4",
  fill: "#3B414D",
  class: "primary"
}, null, -1), p_ = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.0626 19.6981L17.0001 23.9295L26.9376 13.2504L28.2501 14.6608L17.0001 26.7504L11.7501 21.1086L13.0626 19.6981Z",
  fill: "white"
}, null, -1), y_ = [
  m_,
  p_
];
function v_(e, i) {
  return f(), p("svg", h_, y_);
}
const g_ = /* @__PURE__ */ k(u_, [["render", v_]]), __ = {}, w_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C_ = /* @__PURE__ */ u("path", {
  d: "M16.6562 27.3967C16.2858 27.3982 15.9209 27.3078 15.594 27.1335C15.2672 26.9592 14.9888 26.7064 14.7837 26.398L11.7337 22.0705C11.6628 21.9698 11.6124 21.8561 11.5855 21.7359C11.5585 21.6157 11.5554 21.4914 11.5765 21.37C11.5976 21.2487 11.6423 21.1327 11.7082 21.0286C11.7741 20.9246 11.8599 20.8345 11.9606 20.7636C12.0613 20.6927 12.175 20.6423 12.2952 20.6153C12.4154 20.5883 12.5397 20.5853 12.661 20.6064C12.7824 20.6274 12.8984 20.6722 13.0025 20.7381C13.1065 20.804 13.1966 20.8898 13.2675 20.9905L16.33 25.3367C16.3639 25.393 16.4117 25.4395 16.4689 25.4719C16.526 25.5044 16.5905 25.5215 16.6562 25.5217C16.7136 25.5217 16.7702 25.5082 16.8214 25.4824C16.8726 25.4565 16.9171 25.4191 16.9512 25.373L26.7662 12.9542C26.8403 12.8515 26.9344 12.7649 27.0429 12.6996C27.1514 12.6342 27.272 12.5916 27.3974 12.5741C27.5229 12.5567 27.6505 12.5648 27.7727 12.5981C27.8949 12.6313 28.0091 12.689 28.1084 12.7676C28.2077 12.8462 28.29 12.9441 28.3504 13.0554C28.4109 13.1666 28.4481 13.289 28.46 13.4151C28.4718 13.5412 28.458 13.6683 28.4193 13.7889C28.3806 13.9095 28.3179 14.021 28.235 14.1167L18.4312 26.5205C18.2832 26.7132 18.1046 26.8804 17.9025 27.0155C17.5344 27.2641 17.1004 27.3969 16.6562 27.3967Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), k_ = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), x_ = [
  C_,
  k_
];
function b_(e, i) {
  return f(), p("svg", w_, x_);
}
const M_ = /* @__PURE__ */ k(__, [["render", b_]]), D_ = {}, A_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L_ = /* @__PURE__ */ u("path", {
  d: "M20 5.00049C17.0333 5.00049 14.1332 5.88022 11.6665 7.52844C9.19971 9.17666 7.27713 11.5193 6.14181 14.2602C5.0065 17.0011 4.70945 20.0171 5.28823 22.9268C5.86701 25.8366 7.29562 28.5093 9.3934 30.6071C11.4912 32.7049 14.1639 34.1335 17.0737 34.7123C19.9834 35.291 22.9994 34.994 25.7403 33.8587C28.4811 32.7234 30.8238 30.8008 32.472 28.334C34.1203 25.8673 35 22.9672 35 20.0005C34.9954 16.0237 33.4135 12.211 30.6015 9.399C27.7894 6.58696 23.9768 5.00512 20 5.00049V5.00049ZM28.6588 15.2505L20.1025 26.8617C20.0015 26.9958 19.8748 27.1083 19.7298 27.1929C19.5848 27.2774 19.4244 27.3322 19.258 27.3541C19.0916 27.3759 18.9225 27.3644 18.7606 27.3203C18.5987 27.2761 18.4472 27.2001 18.315 27.0967L12.205 22.2117C12.0768 22.1091 11.9701 21.9823 11.8909 21.8385C11.8117 21.6946 11.7616 21.5366 11.7435 21.3734C11.7069 21.0438 11.8028 20.7132 12.01 20.4542C12.2172 20.1953 12.5188 20.0293 12.8484 19.9927C13.178 19.9562 13.5086 20.052 13.7675 20.2592L18.8625 24.3355L26.6463 13.7717C26.74 13.6311 26.8612 13.511 27.0027 13.4185C27.1441 13.3261 27.3028 13.2633 27.4692 13.2339C27.6357 13.2046 27.8063 13.2093 27.9708 13.2477C28.1354 13.2861 28.2904 13.3576 28.4266 13.4576C28.5628 13.5577 28.6772 13.6843 28.7631 13.8298C28.8489 13.9754 28.9044 14.1368 28.9261 14.3044C28.9478 14.472 28.9353 14.6422 28.8893 14.8048C28.8434 14.9674 28.7649 15.119 28.6588 15.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), T_ = [
  L_
];
function S_(e, i) {
  return f(), p("svg", A_, T_);
}
const N_ = /* @__PURE__ */ k(D_, [["render", S_]]), E_ = {}, z_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I_ = /* @__PURE__ */ u("path", {
  d: "M17.8831 32.9577C16.8707 32.9577 15.9085 32.637 15.0978 32.0293C14.9237 31.899 14.757 31.7537 14.6016 31.5983L6.29216 23.2876C5.42388 22.3717 4.96906 21.1876 5.00164 19.9472C5.03547 18.7056 5.55042 17.5516 6.45129 16.6984C7.31832 15.8777 8.45348 15.4254 9.64753 15.4254C10.8416 15.4254 11.9755 15.8764 12.8425 16.6959L17.3807 21.2327L26.6286 8.90257C27.5019 7.73859 28.8939 7.04321 30.3548 7.04321C31.366 7.04321 32.3282 7.36397 33.1376 7.97039C34.1312 8.71463 34.7765 9.80218 34.9519 11.0313C35.1285 12.2604 34.8153 13.4858 34.0698 14.4794L21.6068 31.0996C20.7348 32.2636 19.3428 32.9577 17.8831 32.9577ZM9.65254 17.3035C8.93962 17.3035 8.26178 17.5729 7.74557 18.0628C7.20806 18.5715 6.90234 19.2594 6.8823 19.9986C6.86225 20.7378 7.13163 21.4407 7.64032 21.9782L15.9298 30.2689C16.0212 30.3604 16.1215 30.4468 16.2267 30.527C16.7078 30.8879 17.2817 31.0796 17.8843 31.0796C18.7677 31.0796 19.5771 30.6761 20.1046 29.9732L32.5663 13.3518C33.0098 12.7604 33.1965 12.0312 33.0913 11.2982C32.986 10.5665 32.6026 9.91871 32.01 9.47391C31.5276 9.11307 30.955 8.92137 30.3523 8.92137C29.469 8.92137 28.6596 9.32481 28.1321 10.029L18.2339 23.2274C18.0698 23.4454 17.8204 23.582 17.5486 23.6008C17.5285 23.602 17.5035 23.6033 17.4796 23.6033C17.2303 23.6033 16.996 23.5056 16.8181 23.3277L11.5332 18.044C11.032 17.5691 10.3605 17.3035 9.65254 17.3035Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), B_ = [
  I_
];
function O_(e, i) {
  return f(), p("svg", z_, B_);
}
const H_ = /* @__PURE__ */ k(E_, [["render", O_]]), j_ = {}, V_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F_ = /* @__PURE__ */ u("path", {
  d: "M19.1123 23.7522C18.9548 23.7522 18.7948 23.7397 18.6398 23.7135C17.8899 23.5885 17.2336 23.1797 16.7924 22.561L12.6751 16.7962C12.3751 16.3763 12.4726 15.7888 12.8926 15.4888C13.0526 15.3751 13.24 15.3138 13.4375 15.3138C13.74 15.3138 14.025 15.4601 14.2013 15.7063L18.3186 21.4698C18.4686 21.681 18.6923 21.8198 18.9486 21.8623C19.0023 21.871 19.0573 21.876 19.1111 21.876C19.3123 21.876 19.506 21.8135 19.671 21.6948C19.7385 21.646 19.7998 21.5898 19.8523 21.526L33.3417 5.33797C33.5205 5.12298 33.7829 5.00049 34.0617 5.00049C34.2804 5.00049 34.4942 5.07799 34.6617 5.21798C34.8541 5.37797 34.9729 5.60296 34.9954 5.85295C35.0179 6.10294 34.9429 6.34543 34.7816 6.53792L21.2922 22.7272C21.136 22.9135 20.9572 23.0797 20.7597 23.221C20.2748 23.5685 19.7048 23.7522 19.1123 23.7522Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), P_ = /* @__PURE__ */ u("path", {
  d: "M9.6877 35.0005C7.10281 35.0005 5.0004 32.8981 5.0004 30.3132V11.564C5.0004 8.97912 7.10281 6.87671 9.6877 6.87671H25.6245C26.142 6.87671 26.562 7.29669 26.562 7.81417C26.562 8.33165 26.142 8.75163 25.6245 8.75163H9.6877C8.13652 8.75163 6.87532 10.0141 6.87532 11.564V30.3132C6.87532 31.8644 8.13652 33.1256 9.6877 33.1256H28.4369C29.9881 33.1256 31.2493 31.8644 31.2493 30.3132V18.1262C31.2493 17.6088 31.6693 17.1888 32.1868 17.1888C32.7042 17.1888 33.1242 17.6088 33.1242 18.1262V30.3132C33.1242 32.8981 31.0218 35.0005 28.4369 35.0005H9.6877Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), U_ = [
  F_,
  P_
];
function R_(e, i) {
  return f(), p("svg", V_, U_);
}
const Y_ = /* @__PURE__ */ k(j_, [["render", R_]]), Z_ = {}, W_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q_ = /* @__PURE__ */ u("path", {
  d: "M21.0203 27.5505C20.6902 27.9603 20.2775 28.296 19.8091 28.5359C19.3407 28.7757 18.827 28.9143 18.3016 28.9426C17.7761 28.9709 17.2505 28.8883 16.7591 28.7001C16.2676 28.512 15.8212 28.2225 15.449 27.8505L11.0515 23.4542C10.34 22.7711 9.91448 21.8434 9.86088 20.8586C9.80727 19.8738 10.1296 18.9054 10.7628 18.1492C11.1029 17.7699 11.5168 17.4639 11.9792 17.2498C12.4416 17.0358 12.9427 16.9182 13.452 16.9043C13.9613 16.8904 14.4681 16.9804 14.9415 17.1689C15.4149 17.3573 15.8449 17.6403 16.2053 18.0004L17.5528 19.3467C17.5837 19.3778 17.6208 19.402 17.6618 19.4177C17.7027 19.4335 17.7465 19.4404 17.7903 19.438C17.834 19.4357 17.8768 19.4241 17.9158 19.404C17.9548 19.384 17.9891 19.3559 18.0165 19.3217L25.1178 10.5066C25.1541 10.4607 25.1767 10.4056 25.1832 10.3475C25.1897 10.2894 25.1797 10.2306 25.1545 10.1779C25.1292 10.1251 25.0897 10.0805 25.0403 10.0491C24.991 10.0178 24.9338 10.0009 24.8753 10.0004H6.91773C6.42045 10.0004 5.94353 10.1979 5.5919 10.5495C5.24027 10.9012 5.04272 11.3781 5.04272 11.8754V33.1255C5.04272 33.6228 5.24027 34.0997 5.5919 34.4513C5.94353 34.803 6.42045 35.0005 6.91773 35.0005H28.1678C28.6651 35.0005 29.142 34.803 29.4937 34.4513C29.8453 34.0997 30.0428 33.6228 30.0428 33.1255V17.2367C30.043 17.1719 30.023 17.1087 29.9856 17.0557C29.9483 17.0028 29.8954 16.9628 29.8343 16.9413C29.7732 16.9197 29.707 16.9177 29.6447 16.9354C29.5824 16.9532 29.5271 16.9899 29.4866 17.0404L21.0203 27.5505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), q_ = /* @__PURE__ */ u("path", {
  d: "M34.259 5.4141C33.8719 5.10296 33.3772 4.95809 32.8835 5.01128C32.3897 5.06448 31.9372 5.3114 31.6253 5.69786L17.9489 22.3967L14.8752 19.3279C14.5215 18.9864 14.0479 18.7974 13.5563 18.8017C13.0647 18.8059 12.5944 19.0031 12.2467 19.3508C11.8991 19.6984 11.7019 20.1687 11.6976 20.6603C11.6934 21.1519 11.8824 21.6256 12.2239 21.9792L16.7689 26.5242C16.9564 26.7075 17.18 26.8498 17.4253 26.9421C17.6707 27.0345 17.9326 27.0749 18.1944 27.0608C18.4562 27.0467 18.7122 26.9784 18.9462 26.8602C19.1803 26.742 19.3872 26.5765 19.5539 26.3742L34.5428 8.05037C34.8547 7.66314 35 7.16786 34.9468 6.67347C34.8936 6.17909 34.6462 5.72609 34.259 5.4141Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), G_ = [
  Q_,
  q_
];
function X_(e, i) {
  return f(), p("svg", W_, G_);
}
const J_ = /* @__PURE__ */ k(Z_, [["render", X_]]), K_ = {}, $_ = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ew = /* @__PURE__ */ u("path", {
  d: "M34.0592 34.9982C33.9361 34.9985 33.8142 34.9744 33.7004 34.9272C33.5867 34.88 33.4835 34.8107 33.3969 34.7232L19.9995 21.3271L6.60213 34.7232C6.51561 34.811 6.4125 34.8808 6.29879 34.9284C6.18507 34.976 6.06303 35.0005 5.93976 35.0005C5.81648 35.0005 5.69444 34.976 5.58073 34.9284C5.46701 34.8808 5.3639 34.811 5.27739 34.7232C5.10209 34.5471 5.00367 34.3087 5.00367 34.0602C5.00367 33.8117 5.10209 33.5734 5.27739 33.3972L18.6748 19.9999L5.27739 6.60374C5.09992 6.42753 5.00244 6.19132 5.00244 5.94137C5.00244 5.69142 5.09992 5.45522 5.27739 5.279C5.4536 5.10154 5.68981 5.00406 5.93976 5.00406C6.18971 5.00406 6.42591 5.10154 6.60213 5.279L19.9995 18.6751L33.3969 5.27775C33.4834 5.18994 33.5865 5.1202 33.7002 5.0726C33.8139 5.025 33.936 5.00049 34.0592 5.00049C34.1825 5.00049 34.3046 5.025 34.4183 5.0726C34.532 5.1202 34.6351 5.18994 34.7216 5.27775C34.8092 5.36454 34.8787 5.46782 34.9261 5.58161C34.9735 5.69541 34.9979 5.81747 34.9979 5.94075C34.9979 6.06403 34.9735 6.18609 34.9261 6.29988C34.8787 6.41367 34.8092 6.51695 34.7216 6.60374L21.3242 20.0011L34.7216 33.3985C34.8969 33.5746 34.9953 33.813 34.9953 34.0615C34.9953 34.31 34.8969 34.5484 34.7216 34.7245C34.6347 34.8115 34.5315 34.8805 34.4178 34.9275C34.3041 34.9745 34.1822 34.9985 34.0592 34.9982Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), nw = [
  ew
];
function iw(e, i) {
  return f(), p("svg", $_, nw);
}
const tw = /* @__PURE__ */ k(K_, [["render", iw]]), aw = {}, sw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ow = /* @__PURE__ */ u("path", {
  d: "M15.1926 34.9965C14.3472 34.9965 13.5382 34.6839 12.9142 34.1161C12.1664 33.4359 11.7637 32.4655 11.81 31.4551L11.9 29.6994C11.9425 28.8678 11.301 28.1563 10.4694 28.1125C10.4432 28.1112 10.4169 28.11 10.3919 28.11C10.3656 28.11 10.3406 28.11 10.3144 28.1125L8.56242 28.2013C8.50364 28.2038 8.44237 28.2063 8.38234 28.2063C7.54701 28.2063 6.74294 27.8974 6.12019 27.3359C5.44867 26.7307 5.05227 25.9004 5.00475 24.9962C4.95098 23.9746 5.35614 22.9954 6.11394 22.3089L7.41696 21.1335C7.71583 20.8633 7.89215 20.4919 7.91341 20.088C7.93342 19.6841 7.79586 19.2965 7.52575 18.9964C7.49199 18.9588 7.45572 18.9226 7.41696 18.8876L6.11394 17.7046C5.44367 17.0968 5.05102 16.2653 5.00725 15.3611C4.96223 14.4583 5.2736 13.5917 5.88135 12.9214C6.5216 12.2149 7.43447 11.8097 8.38485 11.8097C8.43987 11.8097 8.49614 11.811 8.55116 11.8135L10.3044 11.9023C10.3306 11.9048 10.3831 11.9048 10.3831 11.9048C11.1885 11.9048 11.8512 11.2758 11.8937 10.4742C11.8962 10.4217 11.8962 10.3679 11.8937 10.3154L11.81 8.55718C11.7224 6.69019 13.1693 5.10081 15.035 5.01327C15.0888 5.01077 15.1425 5.00952 15.1963 5.00952C16.1467 5.00952 17.0583 5.41343 17.6986 6.11746L18.8753 7.41673C19.1466 7.7181 19.5168 7.89442 19.9194 7.91568C19.947 7.91693 19.9745 7.91818 20.002 7.91818C20.3784 7.91818 20.726 7.78438 21.0086 7.53052C21.0474 7.49551 21.0837 7.45925 21.1174 7.42048L22.3054 6.11746C22.9094 5.44844 23.741 5.05454 24.6451 5.00827C24.7026 5.00577 24.7589 5.00452 24.8151 5.00452C25.6567 5.00452 26.4646 5.31464 27.0886 5.87862C27.8476 6.56389 28.2528 7.54303 28.2003 8.56469L28.1115 10.3154C28.0702 11.147 28.713 11.8573 29.5445 11.8998C29.5708 11.901 29.5958 11.9023 29.6208 11.9023C29.6446 11.9023 29.6683 11.9023 29.6921 11.901L31.4428 11.8122C31.5016 11.8097 31.5578 11.8085 31.6154 11.8085C32.4557 11.8085 33.261 12.1199 33.885 12.6863C34.5553 13.2941 34.9492 14.1269 34.9942 15.0298C35.0442 16.0489 34.6391 17.0256 33.8825 17.7096L32.5795 18.8851C32.2806 19.1552 32.1043 19.5266 32.0843 19.9305C32.063 20.3344 32.2018 20.722 32.472 21.0209C32.507 21.0597 32.542 21.0959 32.5795 21.1285L33.8825 22.3052C34.554 22.9117 34.9492 23.7432 34.9955 24.6474C35.0417 25.5515 34.7329 26.4193 34.1264 27.0896C33.4849 27.7986 32.567 28.205 31.6066 28.205C31.5528 28.205 31.4978 28.2038 31.4428 28.2013L29.6896 28.1125C29.6621 28.1112 29.6346 28.11 29.6071 28.11C29.2294 28.11 28.8818 28.245 28.5992 28.4989C28.299 28.769 28.1227 29.1391 28.1027 29.5431C28.1002 29.5943 28.1002 29.6469 28.1027 29.6994L28.1915 31.4501C28.2315 32.3567 27.9176 33.2233 27.3061 33.8923C26.6947 34.5613 25.8606 34.9515 24.9577 34.9915C24.9039 34.994 24.8477 34.9952 24.7914 34.9952C23.8535 34.9952 22.9482 34.5938 22.3079 33.8948L21.1274 32.5893C20.8411 32.2729 20.4322 32.0916 20.0032 32.0916C19.6281 32.0916 19.2692 32.2291 18.9916 32.4805C18.9541 32.5142 18.9165 32.5505 18.8828 32.5893L17.6998 33.8923C17.0596 34.5938 16.1454 34.9965 15.1926 34.9965ZM10.3919 26.2355C10.4494 26.2355 10.5069 26.2367 10.5645 26.2405C12.4302 26.3368 13.8695 27.9324 13.7732 29.7969L13.6832 31.5476C13.6632 31.994 13.842 32.4267 14.1759 32.7306C14.4585 32.9882 14.8099 33.1232 15.1913 33.1232C15.2163 33.1232 15.2401 33.1232 15.2651 33.122C15.6678 33.1032 16.0404 32.9282 16.3118 32.6293L17.4922 31.3288C17.5673 31.245 17.6485 31.1637 17.7336 31.0862C18.3576 30.5235 19.1629 30.2133 20.0032 30.2133C20.9611 30.2133 21.8777 30.6197 22.5192 31.3288L23.696 32.6305C23.9786 32.9394 24.3862 33.117 24.8164 33.117L24.8777 33.1157C25.708 33.0782 26.3558 32.3704 26.3183 31.5376L26.2295 29.7932C26.2232 29.6781 26.2232 29.5618 26.2295 29.4455C26.2757 28.5427 26.6709 27.7111 27.3424 27.1058C27.9664 26.5431 28.7692 26.233 29.6046 26.233C29.6646 26.233 29.7246 26.2342 29.7859 26.238L31.5353 26.3268C31.5653 26.328 31.5941 26.3293 31.6216 26.3293C32.0418 26.3293 32.4469 26.148 32.7333 25.8303C33.0047 25.5302 33.1422 25.1426 33.1222 24.7399C33.1022 24.336 32.9259 23.9658 32.6258 23.6945L31.3227 22.519C31.2377 22.4427 31.1564 22.3614 31.0789 22.2752C29.8272 20.8896 29.9359 18.7425 31.3227 17.4895L32.6258 16.314C32.9634 16.0089 33.1435 15.5737 33.121 15.1186C33.101 14.7146 32.9259 14.3432 32.6258 14.0719C32.3469 13.8193 31.988 13.6805 31.6141 13.6805C31.5879 13.6805 31.5628 13.6817 31.5366 13.683L29.7871 13.7718C29.7321 13.7743 29.6758 13.7755 29.6208 13.7755C29.5633 13.7755 29.5058 13.7743 29.4495 13.7705C27.585 13.6767 26.1444 12.0836 26.2382 10.2191L26.327 8.46715C26.3508 8.01072 26.1694 7.57429 25.8306 7.26917C25.5479 7.01282 25.2016 6.87901 24.8277 6.87901C24.8001 6.87901 24.7714 6.88027 24.7426 6.88152C24.3375 6.90152 23.9661 7.07784 23.696 7.37796L22.5105 8.67848C22.4367 8.76102 22.3529 8.8448 22.2654 8.92358C21.6426 9.48505 20.8373 9.79393 19.997 9.79393C19.9395 9.79393 19.8819 9.79268 19.8244 9.79018C18.9203 9.74266 18.09 9.3475 17.4847 8.67598L16.3105 7.37796C16.0254 7.06534 15.6177 6.88527 15.1926 6.88527C15.1688 6.88527 15.145 6.88527 15.1213 6.88652C14.2897 6.92528 13.6444 7.63557 13.6832 8.4684L13.767 10.2191C13.7732 10.3329 13.7732 10.4529 13.767 10.573C13.672 12.3712 12.1864 13.7805 10.3844 13.7805C10.3256 13.7805 10.2668 13.7793 10.2081 13.7755L8.45862 13.688C8.43612 13.6867 8.41111 13.6855 8.38735 13.6855C7.96343 13.6855 7.55576 13.8668 7.27065 14.1807C6.99929 14.4795 6.86049 14.866 6.8805 15.2686C6.9005 15.6713 7.07557 16.0427 7.37444 16.314L8.67621 17.4958C8.75999 17.572 8.84128 17.6521 8.91756 17.7383C10.1693 19.1252 10.0605 21.2723 8.67371 22.524L7.37194 23.6995C7.03431 24.0046 6.85423 24.4423 6.87799 24.8975C6.89925 25.3001 7.07557 25.6715 7.37569 25.9416C7.6533 26.1917 8.0122 26.3293 8.38485 26.3293C8.41111 26.3293 8.43862 26.3293 8.46488 26.3268L10.2168 26.238C10.2756 26.2367 10.3331 26.2355 10.3919 26.2355Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), rw = /* @__PURE__ */ u("path", {
  d: "M19.9994 26.5705C16.3792 26.5705 13.4342 23.6256 13.4342 20.0054C13.4342 16.3852 16.3792 13.4403 19.9994 13.4403C23.6195 13.4403 26.5645 16.3852 26.5645 20.0054C26.5645 23.6256 23.6195 26.5705 19.9994 26.5705ZM19.9994 15.3161C17.4133 15.3161 15.31 17.4194 15.31 20.0054C15.31 22.5915 17.4133 24.6948 19.9994 24.6948C22.5854 24.6948 24.6887 22.5915 24.6887 20.0054C24.6887 17.4194 22.5854 15.3161 19.9994 15.3161Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), lw = [
  ow,
  rw
];
function dw(e, i) {
  return f(), p("svg", sw, lw);
}
const cw = /* @__PURE__ */ k(aw, [["render", dw]]), fw = {}, uw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hw = /* @__PURE__ */ u("path", {
  d: "M33.125 16.8755H30.7975C30.5661 16.0757 30.2462 15.3043 29.8437 14.5755L31.49 12.9305C31.6642 12.7564 31.8025 12.5496 31.8968 12.322C31.9911 12.0945 32.0396 11.8506 32.0396 11.6042C32.0396 11.3579 31.9911 11.114 31.8968 10.8864C31.8025 10.6589 31.6642 10.4521 31.49 10.278L29.7212 8.51174C29.3696 8.16023 28.8928 7.96276 28.3956 7.96276C27.8984 7.96276 27.4216 8.16023 27.07 8.51174L25.4225 10.158C24.6947 9.75524 23.9241 9.43532 23.125 9.20424V6.87549C23.125 6.37821 22.9275 5.90129 22.5758 5.54966C22.2242 5.19803 21.7473 5.00049 21.25 5.00049H18.75C18.2527 5.00049 17.7758 5.19803 17.4242 5.54966C17.0725 5.90129 16.875 6.37821 16.875 6.87549V9.20424C16.0757 9.43586 15.3047 9.75574 14.5762 10.158L12.9287 8.51174C12.5771 8.16023 12.1003 7.96276 11.6031 7.96276C11.1059 7.96276 10.6291 8.16023 10.2775 8.51174L8.50875 10.2792C8.33451 10.4534 8.19629 10.6601 8.10199 10.8877C8.00769 11.1152 7.95915 11.3592 7.95915 11.6055C7.95915 11.8518 8.00769 12.0957 8.10199 12.3233C8.19629 12.5509 8.33451 12.7576 8.50875 12.9317L10.1562 14.578C9.75323 15.3057 9.43331 16.0763 9.2025 16.8755H6.875C6.37772 16.8755 5.90081 17.073 5.54917 17.4247C5.19754 17.7763 5 18.2532 5 18.7505V21.2505C5 21.7478 5.19754 22.2247 5.54917 22.5763C5.90081 22.9279 6.37772 23.1255 6.875 23.1255H9.2025C9.43322 23.9251 9.75315 24.6962 10.1562 25.4242L8.5075 27.073C8.15599 27.4246 7.95853 27.9014 7.95853 28.3986C7.95853 28.8958 8.15599 29.3726 8.5075 29.7242L10.275 31.4917C10.6335 31.8304 11.108 32.0191 11.6012 32.0191C12.0945 32.0191 12.569 31.8304 12.9275 31.4917L14.575 29.8455C15.3039 30.2482 16.0753 30.5685 16.875 30.8005V33.1255C16.875 33.6228 17.0725 34.0997 17.4242 34.4513C17.7758 34.8029 18.2527 35.0005 18.75 35.0005H21.25C21.7473 35.0005 22.2242 34.8029 22.5758 34.4513C22.9275 34.0997 23.125 33.6228 23.125 33.1255V30.8005C23.9243 30.5689 24.6953 30.249 25.4237 29.8467L27.0712 31.493C27.4229 31.8445 27.8997 32.042 28.3969 32.042C28.8941 32.042 29.3709 31.8445 29.7225 31.493L31.49 29.7255C31.8415 29.3739 32.039 28.897 32.039 28.3999C32.039 27.9027 31.8415 27.4259 31.49 27.0742L29.8437 25.428C30.2466 24.6994 30.5666 23.9279 30.7975 23.128H33.125C33.3714 23.128 33.6155 23.0794 33.8431 22.985C34.0708 22.8906 34.2776 22.7523 34.4517 22.5779C34.6258 22.4036 34.7639 22.1966 34.858 21.9688C34.9521 21.741 35.0003 21.4969 35 21.2505V18.7505C35 18.2532 34.8025 17.7763 34.4508 17.4247C34.0992 17.073 33.6223 16.8755 33.125 16.8755ZM20 26.2505C18.7639 26.2505 17.5555 25.8839 16.5277 25.1972C15.4999 24.5104 14.6988 23.5343 14.2258 22.3923C13.7527 21.2502 13.6289 19.9936 13.8701 18.7812C14.1112 17.5688 14.7065 16.4551 15.5806 15.5811C16.4547 14.707 17.5683 14.1117 18.7807 13.8706C19.9931 13.6294 21.2497 13.7532 22.3918 14.2262C23.5338 14.6993 24.5099 15.5004 25.1967 16.5282C25.8834 17.556 26.25 18.7644 26.25 20.0005C26.248 21.6575 25.5889 23.246 24.4172 24.4177C23.2456 25.5894 21.657 26.2485 20 26.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), mw = [
  hw
];
function pw(e, i) {
  return f(), p("svg", uw, mw);
}
const yw = /* @__PURE__ */ k(fw, [["render", pw]]), vw = {}, gw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _w = /* @__PURE__ */ u("path", {
  d: "M8.77881 35.0005C7.22756 35.0005 5.96631 33.7392 5.96631 32.188V7.81299C5.96631 6.26174 7.22756 5.00049 8.77881 5.00049H27.5288C28.2663 5.00049 28.9626 5.28424 29.4926 5.79924L33.1863 9.40299C33.7251 9.93049 34.0338 10.6642 34.0338 11.4167V32.188C34.0338 33.7392 32.7726 35.0005 31.2213 35.0005H8.77881ZM8.77881 6.87549C8.26131 6.87549 7.84131 7.29549 7.84131 7.81299V32.188C7.84131 32.7055 8.26131 33.1255 8.77881 33.1255H31.2213C31.7388 33.1255 32.1588 32.7055 32.1588 32.188V11.4167C32.1588 11.1655 32.0563 10.9205 31.8763 10.7455L28.1826 7.14174C28.0076 6.97049 27.7751 6.87549 27.5288 6.87549H8.77881Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ww = [
  _w
];
function Cw(e, i) {
  return f(), p("svg", gw, ww);
}
const kw = /* @__PURE__ */ k(vw, [["render", Cw]]), xw = {}, bw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mw = /* @__PURE__ */ u("path", {
  d: "M35 15.518C34.9999 15.1865 34.8682 14.8686 34.6338 14.6342L27.8662 7.86674C27.6319 7.6323 27.314 7.50056 26.9825 7.50049H7.5C6.83696 7.50049 6.20107 7.76388 5.73223 8.23272C5.26339 8.70156 5 9.33745 5 10.0005L5 30.0005C5 30.6635 5.26339 31.2994 5.73223 31.7683C6.20107 32.2371 6.83696 32.5005 7.5 32.5005H32.5C33.163 32.5005 33.7989 32.2371 34.2678 31.7683C34.7366 31.2994 35 30.6635 35 30.0005V15.518ZM32.5 29.3755C32.5 29.5412 32.4342 29.7002 32.3169 29.8174C32.1997 29.9346 32.0408 30.0005 31.875 30.0005H8.125C7.95924 30.0005 7.80027 29.9346 7.68306 29.8174C7.56585 29.7002 7.5 29.5412 7.5 29.3755V10.6255C7.5 10.4597 7.56585 10.3008 7.68306 10.1835C7.80027 10.0663 7.95924 10.0005 8.125 10.0005H26.2063C26.3717 10.0005 26.5304 10.0662 26.6475 10.183L32.3175 15.853C32.4343 15.9701 32.5 16.1288 32.5 16.2942V29.3755Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Dw = /* @__PURE__ */ u("path", {
  d: "M15.3737 17.5005C16.7544 17.5005 17.8737 16.3812 17.8737 15.0005C17.8737 13.6198 16.7544 12.5005 15.3737 12.5005C13.9929 12.5005 12.8737 13.6198 12.8737 15.0005C12.8737 16.3812 13.9929 17.5005 15.3737 17.5005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Aw = /* @__PURE__ */ u("path", {
  d: "M22.1537 18.348C22.0975 18.2581 22.0194 18.1839 21.9266 18.1325C21.8339 18.0812 21.7297 18.0542 21.6237 18.0542C21.5177 18.0542 21.4134 18.0812 21.3207 18.1325C21.228 18.1839 21.1498 18.2581 21.0937 18.348L18.0612 23.2005C18.0328 23.2451 17.9937 23.2819 17.9474 23.3074C17.9011 23.3329 17.849 23.3462 17.7962 23.3462C17.7433 23.3462 17.6913 23.3329 17.6449 23.3074C17.5986 23.2819 17.5595 23.2451 17.5312 23.2005L16.4512 21.473C16.395 21.3831 16.3169 21.3089 16.2241 21.2575C16.1314 21.2062 16.0272 21.1792 15.9212 21.1792C15.8152 21.1792 15.7109 21.2062 15.6182 21.2575C15.5255 21.3089 15.4473 21.3831 15.3912 21.473L11.9224 27.0217C11.8927 27.069 11.8762 27.1234 11.8746 27.1793C11.8731 27.2352 11.8865 27.2904 11.9136 27.3393C11.9407 27.3882 11.9803 27.4289 12.0285 27.4573C12.0766 27.4856 12.1315 27.5005 12.1874 27.5005H27.3124C27.3683 27.5005 27.4232 27.4856 27.4713 27.4573C27.5195 27.4289 27.5591 27.3882 27.5862 27.3393C27.6133 27.2904 27.6267 27.2352 27.6252 27.1793C27.6236 27.1234 27.6071 27.069 27.5774 27.0217L22.1537 18.348Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Lw = [
  Mw,
  Dw,
  Aw
];
function Tw(e, i) {
  return f(), p("svg", bw, Lw);
}
const Sw = /* @__PURE__ */ k(xw, [["render", Tw]]), Nw = {}, Ew = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zw = /* @__PURE__ */ u("path", {
  d: "M15.2273 5.00049H9.77275C8.64308 5.00049 7.72729 5.91627 7.72729 7.04594V32.955C7.72729 34.0847 8.64308 35.0005 9.77275 35.0005H15.2273C16.357 35.0005 17.2728 34.0847 17.2728 32.955V7.04594C17.2728 5.91627 16.357 5.00049 15.2273 5.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Iw = /* @__PURE__ */ u("path", {
  d: "M30.2273 5.00049H24.7727C23.6431 5.00049 22.7273 5.91627 22.7273 7.04594V32.955C22.7273 34.0847 23.6431 35.0005 24.7727 35.0005H30.2273C31.357 35.0005 32.2728 34.0847 32.2728 32.955V7.04594C32.2728 5.91627 31.357 5.00049 30.2273 5.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Bw = [
  zw,
  Iw
];
function Ow(e, i) {
  return f(), p("svg", Ew, Bw);
}
const Hw = /* @__PURE__ */ k(Nw, [["render", Ow]]), jw = {}, Vw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fw = /* @__PURE__ */ u("path", {
  d: "M33.9245 18.2602L7.8162 5.20544C7.51938 5.05789 7.18983 4.98848 6.85871 5.00379C6.52759 5.0191 6.20584 5.11862 5.92391 5.29294C5.64197 5.46725 5.40916 5.71061 5.24749 5.99998C5.08582 6.28936 5.00064 6.61519 5 6.94666V33.0549C5.00051 33.3864 5.08563 33.7123 5.2473 34.0017C5.40897 34.2911 5.64184 34.5345 5.92385 34.7087C6.20586 34.8829 6.52768 34.9823 6.85884 34.9974C7.18999 35.0125 7.51951 34.9428 7.8162 34.7949L33.9245 21.7414C34.2477 21.5797 34.5195 21.3313 34.7094 21.0238C34.8994 20.7164 35 20.3622 35 20.0008C35 19.6394 34.8994 19.2852 34.7094 18.9778C34.5195 18.6703 34.2477 18.4219 33.9245 18.2602V18.2602Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Pw = [
  Fw
];
function Uw(e, i) {
  return f(), p("svg", Vw, Pw);
}
const Rw = /* @__PURE__ */ k(jw, [["render", Uw]]), Yw = {}, Zw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ww = /* @__PURE__ */ Ke('<path d="M7.81312 35.0005C6.26193 35.0005 5.00073 33.7393 5.00073 32.1881V11.564C5.00073 10.0128 6.26193 8.75158 7.81312 8.75158H11.5117L11.0855 7.46914C10.9267 6.99541 10.9617 6.48793 11.1855 6.04044C11.408 5.59171 11.7917 5.25798 12.2667 5.09923C12.4604 5.03424 12.6492 5.00049 12.8254 5.00049L12.8867 5.00174H23.3862C23.8874 5.00174 24.3562 5.19548 24.7099 5.54672C25.0649 5.90045 25.2611 6.37043 25.2624 6.87041C25.2636 7.0754 25.2299 7.27789 25.1649 7.47289L24.7374 8.75158H28.4373C29.9884 8.75158 31.2496 10.0128 31.2496 11.564V15.3138C31.2496 15.8313 30.8297 16.2513 30.3122 16.2513C29.7947 16.2513 29.3747 15.8313 29.3747 15.3138V11.564C29.3747 11.0465 28.9547 10.6265 28.4373 10.6265H24.1124L23.9149 11.219C23.6587 11.9852 22.945 12.5014 22.1363 12.5014H14.1141C13.3066 12.5014 12.5917 11.9864 12.3354 11.2202L12.1367 10.6265H7.81312C7.29564 10.6265 6.87565 11.0465 6.87565 11.564V32.1881C6.87565 32.7056 7.29564 33.1256 7.81312 33.1256H15.3128C15.8303 33.1256 16.2503 33.5455 16.2503 34.063C16.2503 34.5805 15.8303 35.0005 15.3128 35.0005H7.81312ZM12.8617 6.87666L14.1129 10.6265H22.1363L23.3862 6.87666H12.8617Z" fill="#3B414D" class="primary"></path><path d="M20.9377 35.0004C19.3865 35.0004 18.1253 33.7392 18.1253 32.188V20.9385C18.1253 19.3873 19.3865 18.1261 20.9377 18.1261H32.1872C33.7384 18.1261 34.9996 19.3873 34.9996 20.9385V32.188C34.9996 33.7392 33.7384 35.0004 32.1872 35.0004H20.9377ZM20.9377 20.001C20.4202 20.001 20.0002 20.421 20.0002 20.9385V32.188C20.0002 32.7055 20.4202 33.1255 20.9377 33.1255H32.1872C32.7047 33.1255 33.1247 32.7055 33.1247 32.188V20.9385C33.1247 20.421 32.7047 20.001 32.1872 20.001H20.9377Z" fill="#3B414D" class="primary"></path><path d="M22.8124 23.751C22.2949 23.751 21.8749 23.331 21.8749 22.8136C21.8749 22.2961 22.2949 21.8761 22.8124 21.8761H30.3121C30.8296 21.8761 31.2495 22.2961 31.2495 22.8136C31.2495 23.331 30.8296 23.751 30.3121 23.751H22.8124Z" fill="#3B414D" class="primary"></path><path d="M22.8124 27.5008C22.2949 27.5008 21.8749 27.0808 21.8749 26.5633C21.8749 26.0458 22.2949 25.6259 22.8124 25.6259H30.3121C30.8296 25.6259 31.2495 26.0458 31.2495 26.5633C31.2495 27.0808 30.8296 27.5008 30.3121 27.5008H22.8124Z" fill="#3B414D" class="primary"></path><path d="M22.8124 31.2507C22.2949 31.2507 21.8749 30.8307 21.8749 30.3132C21.8749 29.7957 22.2949 29.3757 22.8124 29.3757H25.6248C26.1423 29.3757 26.5622 29.7957 26.5622 30.3132C26.5622 30.8307 26.1423 31.2507 25.6248 31.2507H22.8124Z" fill="#3B414D" class="primary"></path>', 5), Qw = [
  Ww
];
function qw(e, i) {
  return f(), p("svg", Zw, Qw);
}
const Gw = /* @__PURE__ */ k(Yw, [["render", qw]]), Xw = {}, Jw = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kw = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7293 35.0005 5 28.2712 5 20.0005C5 11.7298 11.7293 5.00049 20 5.00049C28.2707 5.00049 35 11.7298 35 20.0005C35 28.2712 28.2707 35.0005 20 35.0005ZM20 7.00049C12.832 7.00049 7 12.8325 7 20.0005C7 27.1685 12.832 33.0005 20 33.0005C27.168 33.0005 33 27.1685 33 20.0005C33 12.8325 27.168 7.00049 20 7.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), $w = /* @__PURE__ */ u("path", {
  d: "M20.0001 30.0005C19.4481 30.0005 19.0001 29.5525 19.0001 29.0005V27.0005H16.0001C15.4481 27.0005 15.0001 26.5525 15.0001 26.0005C15.0001 25.4485 15.4481 25.0005 16.0001 25.0005H21.6894C22.0388 24.9938 22.3734 24.8472 22.6241 24.5898C22.8734 24.3312 23.0068 23.9925 23.0001 23.6338C23.0001 22.8858 20.8948 21.6712 19.5001 20.8672C17.1961 19.5378 15.0214 18.2832 15.0001 16.4125C14.9894 16.2805 14.9908 16.1152 15.0028 15.9525C15.0708 15.0965 15.4681 14.3192 16.1228 13.7618C16.7041 13.2658 17.4428 12.9938 18.2028 12.9938C18.2748 12.9938 18.3481 12.9965 18.4214 13.0005H19.0001V11.0005C19.0001 10.4485 19.4481 10.0005 20.0001 10.0005C20.5521 10.0005 21.0001 10.4485 21.0001 11.0005V13.0005H24.0001C24.5521 13.0005 25.0001 13.4485 25.0001 14.0005C25.0001 14.5525 24.5521 15.0005 24.0001 15.0005H18.3854C18.3574 15.0005 18.3294 14.9992 18.3028 14.9965C18.2734 14.9938 18.2401 14.9925 18.2068 14.9925C17.9148 14.9925 17.6441 15.0925 17.4201 15.2832C17.1734 15.4952 17.0228 15.7885 16.9974 16.1125C16.9921 16.1765 16.9921 16.2418 16.9974 16.3058C17.0001 16.3312 17.0001 16.3592 17.0001 16.3858C17.0001 17.1152 19.1068 18.3298 20.5001 19.1338C22.8148 20.4698 25.0001 21.7298 25.0001 23.6152C25.0161 24.4925 24.6841 25.3352 24.0641 25.9778C23.4441 26.6205 22.6108 26.9832 21.7188 27.0005H21.0001V29.0005C21.0001 29.5525 20.5521 30.0005 20.0001 30.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), eC = [
  Kw,
  $w
];
function nC(e, i) {
  return f(), p("svg", Jw, eC);
}
const iC = /* @__PURE__ */ k(Xw, [["render", nC]]), tC = {}, aC = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sC = /* @__PURE__ */ u("circle", {
  cx: "36",
  cy: "36",
  r: "35.5",
  fill: "white",
  stroke: "#E2E6ED",
  class: "primary-stroke"
}, null, -1), oC = /* @__PURE__ */ u("path", {
  d: "M36.0008 35.6667C40.0509 35.6667 43.3341 32.3834 43.3341 28.3333C43.3341 24.2832 40.0509 21 36.0008 21C31.9507 21 28.6675 24.2832 28.6675 28.3333C28.6675 32.3834 31.9507 35.6667 36.0008 35.6667Z",
  fill: "#D0D3D9",
  class: "primary"
}, null, -1), rC = /* @__PURE__ */ u("path", {
  d: "M36.0007 37.667C32.6424 37.6709 29.4229 39.0066 27.0483 41.3813C24.6736 43.7559 23.3379 46.9754 23.334 50.3337C23.334 50.5105 23.4042 50.68 23.5292 50.8051C23.6543 50.9301 23.8238 51.0003 24.0007 51.0003H48.0007C48.1775 51.0003 48.347 50.9301 48.4721 50.8051C48.5971 50.68 48.6673 50.5105 48.6673 50.3337C48.6634 46.9754 47.3277 43.7559 44.9531 41.3813C42.5784 39.0066 39.3589 37.6709 36.0007 37.667Z",
  fill: "#D0D3D9",
  class: "primary"
}, null, -1), lC = [
  sC,
  oC,
  rC
];
function dC(e, i) {
  return f(), p("svg", aC, lC);
}
const cC = /* @__PURE__ */ k(tC, [["render", dC]]), fC = {}, uC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hC = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C16.0325 35.0005 12.2925 33.4617 9.4625 30.6655C9.44 30.6505 9.415 30.6305 9.39 30.6042C9.375 30.588 9.35625 30.5655 9.33875 30.5417C6.54125 27.7117 5 23.9705 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C23.9675 5.00049 27.7087 6.53924 30.5375 9.33549C30.5588 9.35049 30.5812 9.36799 30.6038 9.39049C30.6225 9.40799 30.6425 9.43299 30.6612 9.45924C33.46 12.2892 35 16.0305 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM11.4125 29.9142C13.8025 31.9892 16.8325 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 16.833 31.9888 13.803 29.9137 11.413L11.4125 29.9142ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 23.168 8.0125 26.198 10.0862 28.588L28.5875 10.0867C26.1975 8.01299 23.1675 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), mC = [
  hC
];
function pC(e, i) {
  return f(), p("svg", uC, mC);
}
const yC = /* @__PURE__ */ k(fC, [["render", pC]]), vC = {}, gC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _C = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), wC = /* @__PURE__ */ u("path", {
  d: "M25.625 26.563C25.375 26.563 25.1388 26.4655 24.9625 26.288L20 21.3255L15.0388 26.288C14.8625 26.4655 14.6263 26.563 14.3763 26.563C14.1263 26.563 13.89 26.4655 13.7138 26.288C13.5363 26.1105 13.4388 25.8755 13.4388 25.6255C13.4388 25.3755 13.5363 25.1392 13.7138 24.963L18.6738 20.0005L13.7113 15.038C13.5338 14.8617 13.4363 14.6255 13.4363 14.3755C13.4363 14.1255 13.5338 13.8892 13.7113 13.713C13.8875 13.5355 14.1238 13.438 14.3738 13.438C14.6238 13.438 14.86 13.5355 15.0363 13.713L19.9988 18.6755L24.96 13.713C25.1375 13.5355 25.3725 13.438 25.6225 13.438C25.8725 13.438 26.1088 13.5355 26.285 13.713C26.4625 13.8892 26.56 14.1255 26.56 14.3755C26.56 14.6255 26.4625 14.8617 26.285 15.038L21.325 20.0005L26.2875 24.963C26.465 25.1405 26.5625 25.3755 26.5625 25.6255C26.5625 25.8755 26.465 26.1117 26.2875 26.288C26.11 26.4642 25.875 26.563 25.625 26.563Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), CC = [
  _C,
  wC
];
function kC(e, i) {
  return f(), p("svg", gC, CC);
}
const xC = /* @__PURE__ */ k(vC, [["render", kC]]), bC = {}, MC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DC = /* @__PURE__ */ u("path", {
  d: "M30.6068 9.38894C28.5085 7.29255 25.8357 5.86533 22.9264 5.28769C20.017 4.71005 17.0018 5.00792 14.2617 6.14364C11.5216 7.27937 9.17977 9.20196 7.53217 11.6684C5.88457 14.1348 5.00519 17.0344 5.00519 20.0005C5.00519 22.9666 5.88457 25.8661 7.53217 28.3326C9.17977 30.799 11.5216 32.7216 14.2617 33.8573C17.0018 34.9931 20.017 35.2909 22.9264 34.7133C25.8357 34.1356 28.5085 32.7084 30.6068 30.612C33.4168 27.7953 34.9948 23.9791 34.9948 20.0005C34.9948 16.0218 33.4168 12.2056 30.6068 9.38894V9.38894ZM25.8807 24.1013C26.0942 24.3391 26.2086 24.6496 26.2003 24.9691C26.1921 25.2886 26.0618 25.5928 25.8363 25.8192C25.6108 26.0457 25.3072 26.1772 24.9877 26.1868C24.6683 26.1965 24.3573 26.0834 24.1186 25.8709L20.2291 21.9815C20.1702 21.9233 20.0906 21.8906 20.0078 21.8906C19.9249 21.8906 19.8454 21.9233 19.7864 21.9815L15.8982 25.8709C15.6607 26.1001 15.3435 26.2282 15.0134 26.2282C14.6833 26.2282 14.3661 26.1001 14.1286 25.8709C14.0123 25.7548 13.9201 25.6168 13.8571 25.465C13.7942 25.3132 13.7618 25.1505 13.7618 24.9861C13.7618 24.8218 13.7942 24.659 13.8571 24.5072C13.9201 24.3554 14.0123 24.2174 14.1286 24.1013L18.018 20.2131C18.0471 20.1842 18.0702 20.1498 18.0859 20.1119C18.1017 20.074 18.1098 20.0334 18.1098 19.9924C18.1098 19.9513 18.1017 19.9107 18.0859 19.8728C18.0702 19.835 18.0471 19.8006 18.018 19.7716L14.1286 15.8822C13.9126 15.6447 13.7962 15.3332 13.8035 15.0122C13.8109 14.6913 13.9414 14.3854 14.168 14.158C14.3946 13.9306 14.6999 13.7991 15.0209 13.7906C15.3418 13.7821 15.6537 13.8974 15.892 14.1125L19.7802 18.002C19.8092 18.0311 19.8437 18.0542 19.8817 18.07C19.9197 18.0857 19.9604 18.0938 20.0015 18.0938C20.0426 18.0938 20.0834 18.0857 20.1214 18.07C20.1593 18.0542 20.1938 18.0311 20.2229 18.002L24.1123 14.1125C24.347 13.878 24.6652 13.7464 24.997 13.7465C25.3287 13.7466 25.6468 13.8785 25.8813 14.1132C26.1158 14.3478 26.2475 14.6661 26.2474 14.9978C26.2473 15.3296 26.1154 15.6477 25.8807 15.8822L21.9913 19.7716C21.9328 19.8302 21.9 19.9096 21.9 19.9924C21.9 20.0751 21.9328 20.1545 21.9913 20.2131L25.8807 24.1013Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), AC = [
  DC
];
function LC(e, i) {
  return f(), p("svg", MC, AC);
}
const TC = /* @__PURE__ */ k(bC, [["render", LC]]), SC = {}, NC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EC = /* @__PURE__ */ u("path", {
  d: "M20.0255 5.33667C16.4495 5.33561 12.9904 6.61035 10.2703 8.93167C7.55013 11.253 5.74737 14.4686 5.18617 18.0003C4.62496 21.532 5.34212 25.148 7.2087 28.1982C9.07527 31.2484 11.9688 33.5326 15.369 34.6401H15.732C15.9091 34.6511 16.0865 34.6243 16.2525 34.5615C16.4184 34.4987 16.5691 34.4013 16.6946 34.2759C16.8201 34.1504 16.9174 33.9997 16.9802 33.8337C17.043 33.6678 17.0698 33.4903 17.0588 33.3132V33.0504V31.686C17.0465 31.604 17.0181 31.5252 16.9751 31.4543C16.9321 31.3834 16.8755 31.3217 16.8085 31.2729C16.7358 31.2141 16.6508 31.1723 16.5598 31.1506C16.4688 31.129 16.3742 31.128 16.2827 31.1477C12.9281 31.8737 12.2146 29.7708 12.1645 29.6331C11.7444 28.5204 10.9929 27.5636 10.0115 26.8918C9.95269 26.8409 9.8899 26.7949 9.82373 26.7541C9.96919 26.6758 10.1356 26.6451 10.2994 26.6665C10.614 26.7102 10.9119 26.8347 11.1642 27.0277C11.4164 27.2207 11.6144 27.4758 11.7389 27.768C12.2231 28.6112 13.0155 29.2336 13.9494 29.5044C14.8832 29.7752 15.8857 29.6733 16.7459 29.22C16.8382 29.1797 16.9194 29.1176 16.9826 29.0392C17.0458 28.9607 17.0891 28.8682 17.1089 28.7694C17.1568 28.1904 17.4046 27.6461 17.8099 27.2297C17.8998 27.1499 17.9649 27.0457 17.9972 26.9298C18.0295 26.8139 18.0277 26.6912 17.992 26.5763C17.9564 26.4613 17.8884 26.3592 17.7961 26.2819C17.7039 26.2047 17.5913 26.1556 17.4719 26.1407C14.5053 25.8028 11.476 24.7638 11.476 19.6442C11.451 18.3585 11.9216 17.1124 12.7904 16.1643C12.8704 16.0759 12.9235 15.9665 12.9434 15.849C12.9634 15.7315 12.9494 15.6107 12.903 15.5009C12.5551 14.5289 12.5596 13.4657 12.9155 12.4967C14.0719 12.7017 15.1573 13.197 16.07 13.9362C16.1453 13.9894 16.2318 14.0249 16.3228 14.0401C16.4138 14.0553 16.5071 14.0497 16.5957 14.0238C17.7139 13.7205 18.8669 13.5648 20.0255 13.5607C21.1884 13.5616 22.346 13.7174 23.4678 14.0238C23.5545 14.0477 23.6455 14.0523 23.7341 14.0371C23.8228 14.022 23.9071 13.9875 23.981 13.9362C24.895 13.1993 25.9798 12.7043 27.1354 12.4967C27.4762 13.4605 27.4762 14.512 27.1354 15.4758C27.0891 15.5857 27.075 15.7064 27.095 15.824C27.1149 15.9415 27.1681 16.0509 27.2481 16.1393C28.1078 17.0779 28.5778 18.3088 28.5624 19.5816C28.5624 24.7012 25.5207 25.7276 22.5415 26.0656C22.4193 26.0783 22.3036 26.1267 22.2087 26.2048C22.1138 26.2829 22.044 26.3871 22.008 26.5045C21.9719 26.622 21.9713 26.7474 22.006 26.8653C22.0408 26.9831 22.1095 27.0881 22.2035 27.1672C22.4808 27.4533 22.6927 27.7963 22.8245 28.1723C22.9563 28.5484 23.005 28.9485 22.9671 29.3452V33.3258C22.9609 33.5215 22.9981 33.7161 23.076 33.8957C23.1539 34.0754 23.2706 34.2355 23.4177 34.3647C23.6051 34.505 23.8226 34.5995 24.053 34.6408C24.2833 34.6821 24.5202 34.669 24.7446 34.6025C28.1219 33.4727 30.988 31.1796 32.8313 28.1324C34.6746 25.0852 35.3754 21.4823 34.8084 17.9663C34.2415 14.4504 32.4438 11.2503 29.7361 8.93701C27.0283 6.6237 23.5868 5.34769 20.0255 5.33667Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), zC = [
  EC
];
function IC(e, i) {
  return f(), p("svg", NC, zC);
}
const BC = /* @__PURE__ */ k(SC, [["render", IC]]), OC = {}, HC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jC = /* @__PURE__ */ u("path", {
  d: "M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z",
  fill: "#CCECFF"
}, null, -1), VC = /* @__PURE__ */ u("path", {
  d: "M29.4482 20.0657C29.4482 15.5916 25.7138 12.4991 21.6219 12.5005H18.1007C13.9602 12.499 10.5522 15.5925 10.5522 20.0657C10.5522 24.158 13.9603 27.5202 18.1007 27.5004H21.6219C25.7134 27.5201 29.4482 24.1569 29.4482 20.0657Z",
  fill: "#0079BE"
}, null, -1), FC = /* @__PURE__ */ u("path", {
  d: "M18.1234 13.1343C14.3399 13.1354 11.2742 16.2084 11.2728 20.001C11.2738 23.793 14.3396 26.8655 18.1234 26.8669C21.9077 26.8657 24.9744 23.793 24.9748 20.001C24.9743 16.2083 21.9078 13.1356 18.1234 13.1343V13.1343Z",
  fill: "white"
}, null, -1), PC = /* @__PURE__ */ u("path", {
  d: "M13.7932 19.9825C13.7968 18.1293 14.9519 16.5489 16.5807 15.9209V24.0433C14.9519 23.4156 13.7967 21.8361 13.7932 19.9826V19.9825ZM19.6887 24.0453V15.9211C21.3182 16.5476 22.4751 18.1289 22.4781 19.983C22.4751 21.8377 21.3182 23.4178 19.6887 24.0455V24.0453Z",
  fill: "#0079BE"
}, null, -1), UC = [
  jC,
  VC,
  FC,
  PC
];
function RC(e, i) {
  return f(), p("svg", HC, UC);
}
const YC = /* @__PURE__ */ k(OC, [["render", RC]]), ZC = {}, WC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QC = /* @__PURE__ */ Ke('<path d="M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z" fill="#FCE0CF"></path><path d="M22.8627 19.9893C22.865 19.452 22.6635 18.9139 22.2581 18.5084C21.8517 18.102 21.3123 17.9007 20.7738 17.904C20.7713 17.904 20.7688 17.9038 20.7661 17.9038C19.5969 17.9038 18.6694 18.831 18.6694 20.0006C18.6694 21.1586 19.6083 22.0972 20.7661 22.0972C21.9356 22.0972 22.863 21.1698 22.863 20.0006C22.863 19.9967 22.8627 19.9931 22.8627 19.9893Z" fill="#F26E21"></path><path d="M18.2796 20.8876C17.9662 21.2013 17.677 21.3239 17.3654 21.3305C16.6065 21.3237 16.0484 20.7616 16.0484 19.9603C16.0484 19.5569 16.2012 19.2263 16.4431 18.9439C16.67 18.7284 16.9623 18.5893 17.2985 18.5893C17.6613 18.5893 17.9437 18.7102 18.266 19.0328V18.1054C17.9437 17.9442 17.6612 17.8635 17.2985 17.8635C16.7859 17.9002 16.3026 18.1073 15.9319 18.4325C15.8251 18.5286 15.7227 18.6347 15.6359 18.7562C15.3651 19.1071 15.2014 19.5369 15.2014 20.0008C15.2014 21.1699 16.1291 22.057 17.2984 22.057C17.3041 22.057 17.3097 22.0565 17.3152 22.0564C17.3231 22.0566 17.3309 22.057 17.3387 22.057C17.6612 22.057 17.9437 21.9765 18.3065 21.8152L18.2796 20.8876C18.266 20.9012 18.2931 20.9139 18.2796 20.9268V20.8876Z" fill="#2B2B2B"></path><path d="M25.5101 18.441L24.5969 20.6861L23.5485 18.0247H22.7018L24.355 22.0972H24.7985L26.5324 18.0247H25.6857L25.5101 18.441Z" fill="#2B2B2B"></path><path d="M26.8549 19.7989V21.9765H29.0324H29.0725V21.3311H28.3871H27.6613V20.6054V20.2426H29.0324V19.5569H27.6613V18.7103H29.0725V18.0247H26.8549V19.7989Z" fill="#2B2B2B"></path><path d="M8.62924 18.0247H7.5V21.9765H8.62918C9.23392 21.9765 9.67739 21.815 10.0403 21.5328C10.4838 21.1699 10.7661 20.6055 10.7661 20.0008C10.7662 18.8311 9.91929 18.0247 8.62924 18.0247ZM9.55656 21.0087C9.31461 21.2102 8.99202 21.3311 8.50812 21.3311H8.26617V18.7102H8.46775C8.95165 18.7102 9.27424 18.7908 9.51624 19.0327C9.79845 19.2745 9.95983 19.6376 9.95983 20.0006C10.0001 20.3635 9.83888 20.7665 9.55656 21.0087Z" fill="#2B2B2B"></path><path d="M11.8957 18.0242H11.1296V21.9759H11.8957V18.0242Z" fill="#2B2B2B"></path><path d="M13.8306 19.557C13.3468 19.3957 13.2257 19.2747 13.2257 19.0731C13.2257 18.8312 13.4677 18.6296 13.7902 18.6296C14.0322 18.6296 14.2338 18.7103 14.4354 18.9523L14.8387 18.4281C14.516 18.1457 14.113 17.9846 13.6694 17.9846C12.9838 17.9846 12.4192 18.4685 12.4192 19.1135C12.4192 19.6781 12.6614 19.92 13.3871 20.2023C13.7097 20.3231 13.8307 20.3635 13.9115 20.4442C14.0725 20.5247 14.1533 20.6861 14.1533 20.8472C14.1533 21.1699 13.9115 21.4119 13.5484 21.4119C13.1851 21.4119 12.8628 21.2103 12.7015 20.8876L12.2176 21.3715C12.5807 21.8957 13.0242 22.1376 13.5887 22.1376C14.3951 22.1376 14.9594 21.6134 14.9594 20.8472C14.9595 20.1619 14.7177 19.8796 13.8306 19.557Z" fill="#2B2B2B"></path><path d="M31.2501 20.323C31.8547 20.2022 32.1774 19.7988 32.1774 19.1942C32.1774 18.4685 31.6531 18.0247 30.7662 18.0247H29.5967V21.9765H30.3629V20.4037H30.484L31.5724 21.9765H32.4999L31.2501 20.323ZM30.6047 19.8391H30.3629V18.6296H30.6047C31.0886 18.6296 31.371 18.8311 31.371 19.2346C31.371 19.6376 31.0887 19.8391 30.6047 19.8391Z" fill="#2B2B2B"></path>', 9), qC = [
  QC
];
function GC(e, i) {
  return f(), p("svg", WC, qC);
}
const XC = /* @__PURE__ */ k(ZC, [["render", GC]]), JC = {}, KC = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $C = /* @__PURE__ */ u("path", {
  d: "M20 25.6255C19.89 25.6255 19.7813 25.6055 19.675 25.5667C19.665 25.563 19.6562 25.5605 19.6475 25.5567C19.5275 25.508 19.4238 25.4392 19.3363 25.3505L13.7125 19.7255C13.535 19.5492 13.4375 19.313 13.4375 19.063C13.4375 18.813 13.535 18.5767 13.7125 18.4005C13.8888 18.223 14.125 18.1255 14.375 18.1255C14.625 18.1255 14.8613 18.223 15.0375 18.4005L19.0625 22.4255V9.68799C19.0625 9.17049 19.4825 8.75049 20 8.75049C20.5175 8.75049 20.9375 9.17049 20.9375 9.68799V22.4242L24.9625 18.3992C25.14 18.2217 25.375 18.1242 25.625 18.1242C25.875 18.1242 26.1113 18.2217 26.2875 18.3992C26.465 18.5755 26.5625 18.8117 26.5625 19.0617C26.5625 19.3117 26.465 19.548 26.2875 19.7242L20.6625 25.3492C20.575 25.4367 20.4713 25.5055 20.355 25.5542C20.345 25.558 20.3337 25.563 20.3225 25.5667C20.2162 25.6067 20.1088 25.6255 20 25.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ek = /* @__PURE__ */ u("path", {
  d: "M9.6875 31.2505C7.1025 31.2505 5 29.148 5 26.563V24.688C5 24.1705 5.42 23.7505 5.9375 23.7505C6.455 23.7505 6.875 24.1705 6.875 24.688V26.563C6.875 28.1142 8.13625 29.3755 9.6875 29.3755H30.3125C31.8638 29.3755 33.125 28.1142 33.125 26.563V24.688C33.125 24.1705 33.545 23.7505 34.0625 23.7505C34.58 23.7505 35 24.1705 35 24.688V26.563C35 29.148 32.8975 31.2505 30.3125 31.2505H9.6875Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), nk = [
  $C,
  ek
];
function ik(e, i) {
  return f(), p("svg", KC, nk);
}
const tk = /* @__PURE__ */ k(JC, [["render", ik]]), ak = {}, sk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ok = /* @__PURE__ */ u("path", {
  d: "M15.77 7.17724C15.7703 6.69531 15.9619 6.23322 16.3027 5.89244C16.6435 5.55166 17.1056 5.36007 17.5875 5.35974H21.8275C22.3092 5.3604 22.771 5.55214 23.1115 5.89288C23.452 6.23362 23.6434 6.69553 23.6438 7.17724V17.4622C23.6438 17.5451 23.6767 17.6246 23.7353 17.6832C23.7939 17.7418 23.8734 17.7747 23.9563 17.7747H27.5813C27.8806 17.7515 28.1797 17.8236 28.4356 17.9807C28.6915 18.1379 28.8911 18.3719 29.0058 18.6494C29.1206 18.9269 29.1446 19.2336 29.0744 19.5255C29.0042 19.8175 28.8434 20.0797 28.615 20.2747L20.99 27.8997C20.6438 28.2302 20.1836 28.4145 19.705 28.4145C19.2264 28.4145 18.7662 28.2302 18.42 27.8997L10.795 20.2747C10.5658 20.0801 10.4043 19.8178 10.3336 19.5256C10.2629 19.2333 10.2867 18.9262 10.4016 18.6483C10.5165 18.3705 10.7166 18.1362 10.973 17.9793C11.2294 17.8223 11.5291 17.7507 11.8288 17.7747H15.4538C15.4949 17.7749 15.5356 17.7669 15.5736 17.7513C15.6115 17.7356 15.6461 17.7126 15.6751 17.6836C15.7042 17.6545 15.7272 17.62 15.7428 17.582C15.7585 17.544 15.7664 17.5033 15.7663 17.4622L15.77 7.17724Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), rk = /* @__PURE__ */ u("path", {
  d: "M5 29.5972C5.00132 30.9345 5.53314 32.2166 6.47874 33.1622C7.42434 34.1078 8.70647 34.6396 10.0437 34.6409H29.9562C31.2935 34.6396 32.5757 34.1078 33.5213 33.1622C34.4669 32.2166 34.9987 30.9345 35 29.5972V27.2509C34.9886 26.8526 34.8224 26.4743 34.5366 26.1966C34.2507 25.9188 33.8679 25.7634 33.4694 25.7634C33.0708 25.7634 32.688 25.9188 32.4022 26.1966C32.1164 26.4743 31.9501 26.8526 31.9388 27.2509V29.5934C31.9381 30.119 31.729 30.6229 31.3574 30.9945C30.9857 31.3662 30.4818 31.5753 29.9562 31.5759H10.0437C9.51816 31.5753 9.01429 31.3662 8.64264 30.9945C8.27099 30.6229 8.06191 30.119 8.06125 29.5934V27.2509C8.04986 26.8526 7.88361 26.4743 7.5978 26.1966C7.312 25.9188 6.92916 25.7634 6.53062 25.7634C6.13209 25.7634 5.74925 25.9188 5.46345 26.1966C5.17764 26.4743 5.01139 26.8526 5 27.2509L5 29.5972Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), lk = [
  ok,
  rk
];
function dk(e, i) {
  return f(), p("svg", sk, lk);
}
const ck = /* @__PURE__ */ k(ak, [["render", dk]]), fk = {}, uk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hk = /* @__PURE__ */ u("g", { "clip-path": "url(#clip0)" }, [
  /* @__PURE__ */ u("path", {
    d: "M8.00003 31.0002C7.20459 30.9995 6.44194 30.6832 5.87949 30.1208C5.31703 29.5583 5.00074 28.7957 5.00003 28.0002V12.0002C4.99699 11.3152 5.23166 10.6503 5.66403 10.1189L5.6947 10.0829C5.97527 9.74354 6.32748 9.47046 6.72605 9.28327C7.12462 9.09609 7.55969 8.99944 8.00003 9.00025H32C32.4501 8.99985 32.8944 9.10094 33.3 9.296C33.7056 9.49107 34.062 9.77508 34.3427 10.1269L34.3667 10.1616C34.7813 10.6936 35 11.3282 35 12.0002V28.0002C34.9993 28.7957 34.683 29.5583 34.1205 30.1208C33.5581 30.6832 32.7954 30.9995 32 31.0002H8.00003ZM7.00003 28.0002C7.00003 28.5522 7.44803 29.0002 8.00003 29.0002H32C32.2652 29.0002 32.5196 28.8949 32.7071 28.7073C32.8946 28.5198 33 28.2654 33 28.0002V12.4162L23.2987 19.8776C22.3519 20.6031 21.1928 20.9972 20 20.9989C18.812 20.9989 17.64 20.6002 16.7014 19.8776L7.00003 12.4162V28.0002ZM17.92 18.2922C18.512 18.7482 19.2507 18.9989 20 18.9989C20.7493 18.9989 21.4867 18.7482 22.0787 18.2922L31.56 10.9989H8.43869L17.92 18.2922Z",
    fill: "#3B414D",
    class: "primary"
  })
], -1), mk = /* @__PURE__ */ u("defs", null, [
  /* @__PURE__ */ u("clipPath", { id: "clip0" }, [
    /* @__PURE__ */ u("rect", {
      width: "40",
      height: "40",
      fill: "white",
      transform: "translate(0 0.000488281)"
    })
  ])
], -1), pk = [
  hk,
  mk
];
function yk(e, i) {
  return f(), p("svg", uk, pk);
}
const vk = /* @__PURE__ */ k(fk, [["render", yk]]), gk = {}, _k = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wk = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ck = /* @__PURE__ */ u("path", {
  d: "M20 31.2505C14.8312 31.2505 10.625 27.0442 10.625 21.8755C10.625 21.358 11.045 20.938 11.5625 20.938C12.08 20.938 12.5 21.358 12.5 21.8755C12.5 26.0105 15.865 29.3755 20 29.3755C24.135 29.3755 27.5 26.0105 27.5 21.8755C27.5 21.358 27.92 20.938 28.4375 20.938C28.955 20.938 29.375 21.358 29.375 21.8755C29.375 27.0442 25.1688 31.2505 20 31.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kk = /* @__PURE__ */ u("path", {
  d: "M28.1163 18.1255C27.7188 18.1255 27.3638 17.8743 27.2325 17.4993C27.0663 17.028 26.725 16.648 26.2738 16.433C26.0175 16.3105 25.7463 16.248 25.4663 16.248C25.2538 16.248 25.0438 16.2843 24.84 16.3568C24.3025 16.5468 23.8863 16.963 23.6963 17.5005C23.5638 17.8743 23.2088 18.1255 22.8125 18.1255C22.7063 18.1255 22.6013 18.108 22.5 18.0718C22.2638 17.988 22.0738 17.818 21.9663 17.5918C21.8588 17.3655 21.845 17.1118 21.9288 16.8755C22.3075 15.8018 23.1413 14.968 24.215 14.5893C24.6213 14.4468 25.0425 14.3743 25.4663 14.3743C26.0263 14.3743 26.57 14.498 27.0813 14.7418C27.985 15.173 28.6663 15.9318 29 16.8755C29.0838 17.1118 29.07 17.3655 28.9625 17.5918C28.855 17.818 28.665 17.988 28.4288 18.0718C28.3263 18.108 28.2213 18.1255 28.1163 18.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xk = /* @__PURE__ */ u("path", {
  d: "M17.1876 18.1255C16.7913 18.1255 16.4363 17.8743 16.3038 17.5005C16.0401 16.753 15.3288 16.2505 14.5338 16.2505C14.3226 16.2505 14.1126 16.2855 13.9113 16.3568C13.3738 16.5468 12.9576 16.963 12.7676 17.5005C12.6351 17.8743 12.2801 18.1255 11.8838 18.1255C11.7776 18.1255 11.6726 18.108 11.5713 18.0718C11.3351 17.988 11.1451 17.818 11.0376 17.5918C10.9301 17.3655 10.9163 17.1118 11.0001 16.8755C11.3788 15.8018 12.2126 14.968 13.2863 14.5893C13.6888 14.4468 14.1088 14.3743 14.5326 14.3743C16.1201 14.3743 17.5426 15.3793 18.0713 16.8755C18.2438 17.363 17.9863 17.8993 17.5001 18.0718C17.3988 18.108 17.2938 18.1255 17.1876 18.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), bk = [
  wk,
  Ck,
  kk,
  xk
];
function Mk(e, i) {
  return f(), p("svg", _k, bk);
}
const Dk = /* @__PURE__ */ k(gk, [["render", Mk]]), Ak = {}, Lk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tk = /* @__PURE__ */ u("path", {
  d: "M5.9375 16.2505C5.42 16.2505 5 15.8305 5 15.313V7.81299C5 6.26174 6.26125 5.00049 7.8125 5.00049H15.3125C15.83 5.00049 16.25 5.42049 16.25 5.93799C16.25 6.45549 15.83 6.87549 15.3125 6.87549H7.8125C7.295 6.87549 6.875 7.29549 6.875 7.81299V15.313C6.875 15.8305 6.455 16.2505 5.9375 16.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Sk = /* @__PURE__ */ u("path", {
  d: "M34.0625 16.2505C33.545 16.2505 33.125 15.8305 33.125 15.313V7.81299C33.125 7.29549 32.705 6.87549 32.1875 6.87549H24.6875C24.17 6.87549 23.75 6.45549 23.75 5.93799C23.75 5.42049 24.17 5.00049 24.6875 5.00049H32.1875C33.7387 5.00049 35 6.26174 35 7.81299V15.313C35 15.8305 34.58 16.2505 34.0625 16.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Nk = /* @__PURE__ */ u("path", {
  d: "M24.6875 35.0005C24.17 35.0005 23.75 34.5805 23.75 34.063C23.75 33.5455 24.17 33.1255 24.6875 33.1255H32.1875C32.705 33.1255 33.125 32.7055 33.125 32.188V24.688C33.125 24.1705 33.545 23.7505 34.0625 23.7505C34.58 23.7505 35 24.1705 35 24.688V32.188C35 33.7392 33.7387 35.0005 32.1875 35.0005H24.6875Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ek = /* @__PURE__ */ u("path", {
  d: "M7.8125 35.0005C6.26125 35.0005 5 33.7392 5 32.188V20.938C5 19.3867 6.26125 18.1255 7.8125 18.1255H19.0625C20.6138 18.1255 21.875 19.3867 21.875 20.938V32.188C21.875 33.7392 20.6138 35.0005 19.0625 35.0005H7.8125ZM7.8125 20.0005C7.295 20.0005 6.875 20.4205 6.875 20.938V32.188C6.875 32.7055 7.295 33.1255 7.8125 33.1255H19.0625C19.58 33.1255 20 32.7055 20 32.188V20.938C20 20.4205 19.58 20.0005 19.0625 20.0005H7.8125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), zk = [
  Tk,
  Sk,
  Nk,
  Ek
];
function Ik(e, i) {
  return f(), p("svg", Lk, zk);
}
const Bk = /* @__PURE__ */ k(Ak, [["render", Ik]]), Ok = {}, Hk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jk = /* @__PURE__ */ Ke('<path d="M5.9375 16.2505C5.42 16.2505 5 15.8305 5 15.313V7.81299C5 6.26174 6.26125 5.00049 7.8125 5.00049H15.3125C15.83 5.00049 16.25 5.42049 16.25 5.93799C16.25 6.45549 15.83 6.87549 15.3125 6.87549H7.8125C7.295 6.87549 6.875 7.29549 6.875 7.81299V15.313C6.875 15.8305 6.455 16.2505 5.9375 16.2505Z" fill="#3B414D" class="primary"></path><path d="M34.0625 16.2505C33.545 16.2505 33.125 15.8305 33.125 15.313V7.81299C33.125 7.29549 32.705 6.87549 32.1875 6.87549H24.6875C24.17 6.87549 23.75 6.45549 23.75 5.93799C23.75 5.42049 24.17 5.00049 24.6875 5.00049H32.1875C33.7388 5.00049 35 6.26174 35 7.81299V15.313C35 15.8305 34.58 16.2505 34.0625 16.2505Z" fill="#3B414D" class="primary"></path><path d="M7.8125 35.0005C6.26125 35.0005 5 33.7392 5 32.188V24.688C5 24.1705 5.42 23.7505 5.9375 23.7505C6.455 23.7505 6.875 24.1705 6.875 24.688V32.188C6.875 32.7055 7.295 33.1255 7.8125 33.1255H15.3125C15.83 33.1255 16.25 33.5455 16.25 34.063C16.25 34.5805 15.83 35.0005 15.3125 35.0005H7.8125Z" fill="#3B414D" class="primary"></path><path d="M24.6875 35.0005C24.17 35.0005 23.75 34.5805 23.75 34.063C23.75 33.5455 24.17 33.1255 24.6875 33.1255H32.1875C32.705 33.1255 33.125 32.7055 33.125 32.188V24.688C33.125 24.1705 33.545 23.7505 34.0625 23.7505C34.58 23.7505 35 24.1705 35 24.688V32.188C35 33.7392 33.7388 35.0005 32.1875 35.0005H24.6875Z" fill="#3B414D" class="primary"></path><path d="M13.4375 29.3755C11.8862 29.3755 10.625 28.1142 10.625 26.563V13.438C10.625 11.8867 11.8862 10.6255 13.4375 10.6255H26.5625C28.1138 10.6255 29.375 11.8867 29.375 13.438V26.563C29.375 28.1142 28.1138 29.3755 26.5625 29.3755H13.4375ZM13.4375 12.5005C12.92 12.5005 12.5 12.9205 12.5 13.438V26.563C12.5 27.0805 12.92 27.5005 13.4375 27.5005H26.5625C27.08 27.5005 27.5 27.0805 27.5 26.563V13.438C27.5 12.9205 27.08 12.5005 26.5625 12.5005H13.4375Z" fill="#3B414D" class="primary"></path>', 5), Vk = [
  jk
];
function Fk(e, i) {
  return f(), p("svg", Hk, Vk);
}
const Pk = /* @__PURE__ */ k(Ok, [["render", Fk]]), Uk = {}, Rk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yk = /* @__PURE__ */ u("path", {
  d: "M33.8693 5.00049H25.691C25.0665 5.00049 24.5604 5.50662 24.5604 6.13117C24.5604 6.75566 25.0665 7.2618 25.691 7.2618H32.7387V14.3095C32.7387 14.934 33.2448 15.4401 33.8693 15.4401C34.4938 15.4401 35 14.934 35 14.3095V6.13117C35 5.50662 34.4939 5.00049 33.8693 5.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Zk = /* @__PURE__ */ u("path", {
  d: "M34.6687 5.33179C34.2271 4.89005 33.5117 4.89005 33.07 5.33179L16.9393 21.4624C16.4976 21.9037 16.4976 22.6198 16.9393 23.0611C17.1598 23.282 17.4493 23.3924 17.7387 23.3924C18.0278 23.3924 18.3172 23.282 18.5381 23.0611L34.6687 6.93052C35.1105 6.48919 35.1105 5.77312 34.6687 5.33179Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Wk = /* @__PURE__ */ u("path", {
  d: "M30.0251 19.0583C29.4007 19.0583 28.8945 19.5644 28.8945 20.1889V32.7392H7.26131V11.106H19.8116C20.436 11.106 20.9422 10.5999 20.9422 9.97541C20.9422 9.35092 20.436 8.84473 19.8116 8.84473H6.13068C5.50613 8.84473 5 9.35086 5 9.97541V33.8699C5 34.4944 5.50613 35.0005 6.13068 35.0005H30.0251C30.65 35.0005 31.1558 34.4944 31.1558 33.8698V20.1889C31.1558 19.5644 30.6496 19.0583 30.0251 19.0583Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Qk = [
  Yk,
  Zk,
  Wk
];
function qk(e, i) {
  return f(), p("svg", Rk, Qk);
}
const Gk = /* @__PURE__ */ k(Uk, [["render", qk]]), Xk = {}, Jk = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kk = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M32.7357 8.04565C33.6311 8.04565 34.4187 8.54899 34.7906 9.35793C35.1614 10.1601 35.0333 11.0769 34.458 11.7499L24.4918 23.3321H19.9977H15.5036L5.54224 11.7499C4.967 11.0781 4.83891 10.1613 5.20855 9.35906C5.58156 8.55012 6.36916 8.04678 7.26461 8.04678L32.7357 8.04565ZM15.5036 26.6654V30.9352C15.5036 31.3498 15.4815 31.7307 15.8467 31.9262C16.0515 31.9262 16.3201 31.9262 16.5021 31.9262C16.7201 31.9262 17.0074 31.9262 17.2532 31.9262L23.9918 31.9542C24.3041 31.7453 24.4918 31.3947 24.4918 31.0195V26.6654H19.9979H15.5036Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), $k = [
  Kk
];
function ex(e, i) {
  return f(), p("svg", Jk, $k);
}
const nx = /* @__PURE__ */ k(Xk, [["render", ex]]), ix = {}, tx = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ax = /* @__PURE__ */ u("path", {
  d: "M19.8222 31.9333C14.8875 31.9333 9.52286 30.5671 6.47305 28.5335C4.31694 27.0948 4.52567 22.9763 7.11301 15.943C7.93671 13.6919 9.12788 11.6133 10.654 9.7634C11.549 8.68472 12.8639 8.06726 14.2626 8.06726H18.1261C20.7109 8.06726 22.8133 10.1696 22.8133 12.7545C22.8133 15.3393 20.7109 17.4417 18.1261 17.4417H15.7437C15.135 18.1941 14.7075 19.0828 14.495 20.024C15.5312 19.3528 16.5937 19.0141 17.6623 19.0141C18.8548 19.0141 20.0372 19.4378 21.1859 20.274C22.0096 17.2742 24.7956 15.0943 27.9617 15.0918C29.8453 15.0918 31.609 15.8205 32.9351 17.1454C34.265 18.4716 34.9987 20.2365 35 22.1151C35.0012 23.82 34.3863 25.4624 33.2676 26.7461C33.2526 26.7661 33.2376 26.7861 33.2214 26.8048C30.409 30.1109 25.6493 31.9333 19.8222 31.9333ZM14.2651 9.94214C13.4251 9.94214 12.6352 10.3134 12.1002 10.9596C10.709 12.642 9.6241 14.5369 8.87415 16.588C6.4143 23.2738 6.5593 26.3361 7.51424 26.9723C10.3153 28.8397 15.0688 30.0584 19.6235 30.0759H19.731C24.9994 30.0759 29.2604 28.5072 31.7315 25.6599C31.754 25.6274 31.779 25.5962 31.8065 25.5662C32.6589 24.6175 33.1289 23.3913 33.1264 22.1151C33.1251 20.7377 32.5877 19.444 31.6127 18.4704C30.639 17.4992 29.3454 16.9642 27.9704 16.9642C25.1219 16.9679 22.812 19.2828 22.8145 22.1264C22.8145 22.5113 22.5845 22.8526 22.2283 22.9976C22.1158 23.0426 21.9983 23.0663 21.8771 23.0663C21.6233 23.0663 21.3771 22.9613 21.2009 22.7776C19.9972 21.5239 18.8073 20.8889 17.6636 20.8889C16.5149 20.8889 15.3212 21.5252 14.1151 22.7788C13.9388 22.9613 13.6926 23.0663 13.4401 23.0663C13.3351 23.0663 13.2314 23.0488 13.1326 23.0138C12.7902 22.8951 12.5439 22.5838 12.5077 22.2226C12.3014 20.184 12.8864 18.1104 14.1176 16.478C13.2826 15.0856 13.4851 13.2582 14.6525 12.0908C14.83 11.9133 15.065 11.8158 15.3162 11.8158C15.5662 11.8158 15.8012 11.9133 15.9787 12.0895C16.1562 12.267 16.2537 12.502 16.2537 12.7532C16.2537 13.0032 16.1562 13.2394 15.98 13.4157C15.405 13.9906 15.3237 14.8981 15.7587 15.5655H18.1286C19.6797 15.5655 20.9409 14.3044 20.9409 12.7532C20.9409 11.2021 19.6797 9.94089 18.1286 9.94089H14.2651V9.94214Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), sx = [
  ax
];
function ox(e, i) {
  return f(), p("svg", tx, sx);
}
const rx = /* @__PURE__ */ k(ix, [["render", ox]]), lx = {}, dx = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cx = /* @__PURE__ */ u("path", {
  d: "M11.5063 35.0005C11.3188 35.0005 11.1375 34.9455 10.9812 34.8392C10.6099 34.5879 10.4674 34.1054 10.6449 33.6928L15.7106 21.8738H12.0064C11.5038 21.8738 11.0362 21.6801 10.6824 21.33C10.3274 20.9775 10.1311 20.5074 10.1286 20.0061C10.1274 19.7461 10.1799 19.4923 10.2836 19.2535L16.0231 6.12563C16.3206 5.44179 16.9957 5.00049 17.7408 5.00049H27.367C27.8683 5.00049 28.3396 5.19551 28.6934 5.55056C29.0472 5.9056 29.2423 6.37691 29.2423 6.87697C29.2423 7.30078 29.096 7.71708 28.8297 8.04962L23.7666 14.3767H27.9959C29.0297 14.3767 29.8711 15.218 29.8711 16.2506C29.8711 16.7532 29.6761 17.2245 29.3198 17.5796L12.1689 34.7255C11.9926 34.903 11.7563 35.0005 11.5063 35.0005ZM15.7106 19.9986C15.9669 19.9999 16.2131 20.0499 16.4469 20.1499C16.907 20.3462 17.2633 20.7112 17.4508 21.1763C17.6371 21.6413 17.6321 22.1514 17.4345 22.6127L14.2854 29.9599L27.9959 16.2519H23.7678C23.344 16.2519 22.9277 16.1056 22.5977 15.8418C21.7901 15.1968 21.6576 14.0154 22.3026 13.2065L27.367 6.87572H17.7421L12.0026 20.0024L15.7106 19.9986Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), fx = [
  cx
];
function ux(e, i) {
  return f(), p("svg", dx, fx);
}
const hx = /* @__PURE__ */ k(lx, [["render", ux]]), mx = {}, px = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yx = /* @__PURE__ */ u("path", {
  d: "M26.8765 15.0019H21.7508L27.4066 5.95438C27.4651 5.8598 27.4973 5.75134 27.4999 5.64017C27.5025 5.529 27.4754 5.41915 27.4214 5.32195C27.3673 5.22474 27.2884 5.14371 27.1926 5.08721C27.0968 5.0307 26.9877 5.00076 26.8765 5.00049H16.8751C16.7356 5.00053 16.6002 5.04718 16.4903 5.13304C16.3805 5.21889 16.3025 5.33902 16.2687 5.47431L12.5182 20.4765C12.4952 20.5686 12.4935 20.6648 12.5132 20.7576C12.533 20.8505 12.5736 20.9377 12.632 21.0125C12.6905 21.0873 12.7652 21.1479 12.8505 21.1895C12.9359 21.2312 13.0296 21.2528 13.1245 21.2528H17.3064L13.7721 34.2135C13.7329 34.3567 13.746 34.5092 13.809 34.6437C13.872 34.7781 13.9808 34.8858 14.1159 34.9473C14.2514 35.0065 14.4032 35.0166 14.5453 34.976C14.6874 34.9354 14.811 34.8466 14.8948 34.7248L27.3966 15.9721C27.4589 15.878 27.4946 15.7687 27.4998 15.656C27.505 15.5432 27.4796 15.4312 27.4263 15.3317C27.3729 15.2322 27.2937 15.149 27.1969 15.091C27.1001 15.0329 26.9894 15.0021 26.8765 15.0019V15.0019Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), vx = [
  yx
];
function gx(e, i) {
  return f(), p("svg", px, vx);
}
const _x = /* @__PURE__ */ k(mx, [["render", gx]]), wx = {}, Cx = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kx = /* @__PURE__ */ u("path", {
  d: "M7.8125 35.0005C6.26125 35.0005 5 33.7392 5 32.188V14.0542C5 12.8017 5.4875 11.6255 6.37375 10.7405L10.7375 6.37424C11.6238 5.48799 12.8013 5.00049 14.0538 5.00049H32.1875C33.7388 5.00049 35 6.26174 35 7.81299V32.188C35 33.7392 33.7388 35.0005 32.1875 35.0005H7.8125ZM32.1875 33.1255C32.705 33.1255 33.125 32.7055 33.125 32.188V7.81299C33.125 7.29549 32.705 6.87549 32.1875 6.87549H29.375V13.438C29.375 14.9892 28.1138 16.2505 26.5625 16.2505H17.1875C15.6362 16.2505 14.375 14.9892 14.375 13.438V6.87549H14.0538C13.3025 6.87549 12.595 7.16799 12.0638 7.69924L7.7 12.0655C7.1675 12.5967 6.875 13.303 6.875 14.0542V32.188C6.875 32.7055 7.295 33.1255 7.8125 33.1255H10.625V22.813C10.625 21.2617 11.8862 20.0005 13.4375 20.0005H26.5625C28.1138 20.0005 29.375 21.2617 29.375 22.813V33.1255H32.1875ZM27.5 33.1255V22.813C27.5 22.2955 27.08 21.8755 26.5625 21.8755H13.4375C12.92 21.8755 12.5 22.2955 12.5 22.813V33.1255H27.5ZM16.25 13.438C16.25 13.9555 16.67 14.3755 17.1875 14.3755H26.5625C27.08 14.3755 27.5 13.9555 27.5 13.438V6.87549H16.25V13.438Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xx = /* @__PURE__ */ u("path", {
  d: "M24.6875 12.5005C24.17 12.5005 23.75 12.0805 23.75 11.563V9.68799C23.75 9.17049 24.17 8.75049 24.6875 8.75049C25.205 8.75049 25.625 9.17049 25.625 9.68799V11.563C25.625 12.0805 25.205 12.5005 24.6875 12.5005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), bx = /* @__PURE__ */ u("path", {
  d: "M15.3125 25.6255C14.795 25.6255 14.375 25.2055 14.375 24.688C14.375 24.1705 14.795 23.7505 15.3125 23.7505H20.9375C21.455 23.7505 21.875 24.1705 21.875 24.688C21.875 25.2055 21.455 25.6255 20.9375 25.6255H15.3125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Mx = /* @__PURE__ */ u("path", {
  d: "M15.3125 29.3755C14.795 29.3755 14.375 28.9555 14.375 28.438C14.375 27.9205 14.795 27.5005 15.3125 27.5005H24.6875C25.205 27.5005 25.625 27.9205 25.625 28.438C25.625 28.9555 25.205 29.3755 24.6875 29.3755H15.3125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Dx = [
  kx,
  xx,
  bx,
  Mx
];
function Ax(e, i) {
  return f(), p("svg", Cx, Dx);
}
const Lx = /* @__PURE__ */ k(wx, [["render", Ax]]), Tx = {}, Sx = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nx = /* @__PURE__ */ u("path", {
  d: "M8.21429 32.8577C6.44143 32.8577 5 31.4163 5 29.6434V10.3577C5 8.58486 6.44143 7.14343 8.21429 7.14343H13.5714C14.5771 7.14343 15.5386 7.62343 16.1429 8.42915L18.3929 11.4291H31.7857C33.5586 11.4291 35 12.8706 35 14.6434V29.6434C35 31.4163 33.5586 32.8577 31.7857 32.8577H8.21429ZM8.21429 9.28629C7.62286 9.28629 7.14286 9.76629 7.14286 10.3577V29.6434C7.14286 30.2349 7.62286 30.7149 8.21429 30.7149H31.7857C32.3771 30.7149 32.8571 30.2349 32.8571 29.6434V14.6434C32.8571 14.052 32.3771 13.572 31.7857 13.572H17.8571C17.5214 13.572 17.2014 13.412 17 13.1434L14.4286 9.71486C14.2271 9.44629 13.9071 9.28629 13.5714 9.28629H8.21429Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ex = [
  Nx
];
function zx(e, i) {
  return f(), p("svg", Sx, Ex);
}
const Ix = /* @__PURE__ */ k(Tx, [["render", zx]]), Bx = {}, Ox = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hx = /* @__PURE__ */ u("path", {
  d: "M32.6316 11.3163H17.6316C17.5257 11.3161 17.421 11.2946 17.3236 11.2531C17.2262 11.2116 17.1382 11.151 17.0647 11.0748L14.9474 8.88318C14.7257 8.65403 14.4603 8.47178 14.1668 8.34727C13.8733 8.22277 13.5578 8.15856 13.2389 8.15845H7.82C7.07262 8.15928 6.35607 8.45644 5.82744 8.98477C5.29881 9.5131 5.00125 10.2295 5 10.9769V29.0242C5.00125 29.7716 5.29881 30.488 5.82744 31.0163C6.35607 31.5447 7.07262 31.8418 7.82 31.8427H32.18C32.9274 31.8418 33.6439 31.5447 34.1726 31.0163C34.7012 30.488 34.9987 29.7716 35 29.0242V13.6848C35 13.0566 34.7505 12.4542 34.3063 12.01C33.8621 11.5659 33.2597 11.3163 32.6316 11.3163Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jx = [
  Hx
];
function Vx(e, i) {
  return f(), p("svg", Ox, jx);
}
const Fx = /* @__PURE__ */ k(Bx, [["render", Vx]]), Px = {}, Ux = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rx = /* @__PURE__ */ u("path", {
  d: "M20 9.37549C16.0231 9.37979 12.2103 10.9615 9.39815 13.7736C6.58604 16.5858 5.0043 20.3986 5 24.3755L5 27.5005C5 28.3293 5.32924 29.1241 5.91529 29.7102C6.50134 30.2962 7.2962 30.6255 8.125 30.6255H31.875C32.2854 30.6255 32.6917 30.5447 33.0709 30.3876C33.45 30.2306 33.7945 30.0004 34.0847 29.7102C34.3749 29.42 34.6051 29.0755 34.7621 28.6964C34.9192 28.3172 35 27.9109 35 27.5005V24.3755C34.9957 20.3986 33.414 16.5858 30.6019 13.7736C27.7897 10.9615 23.9769 9.37979 20 9.37549ZM31.875 25.938H29.375C29.1264 25.938 28.8879 25.8392 28.7121 25.6634C28.5363 25.4876 28.4375 25.2491 28.4375 25.0005C28.4375 24.7518 28.5363 24.5134 28.7121 24.3376C28.8879 24.1618 29.1264 24.063 29.375 24.063H31.875C32.1236 24.063 32.3621 24.1618 32.5379 24.3376C32.7137 24.5134 32.8125 24.7518 32.8125 25.0005C32.8125 25.2491 32.7137 25.4876 32.5379 25.6634C32.3621 25.8392 32.1236 25.938 31.875 25.938ZM28.4325 21.168C28.2263 21.1675 28.0261 21.0991 27.8627 20.9735C27.6992 20.8478 27.5817 20.6718 27.5282 20.4727C27.4748 20.2736 27.4883 20.0625 27.5668 19.8718C27.6453 19.6812 27.7843 19.5217 27.9625 19.418L30.1275 18.168C30.2342 18.1064 30.352 18.0665 30.4741 18.0505C30.5962 18.0344 30.7203 18.0426 30.8393 18.0745C30.9583 18.1064 31.0698 18.1615 31.1675 18.2365C31.2652 18.3115 31.3472 18.405 31.4088 18.5117C31.4703 18.6184 31.5102 18.7362 31.5263 18.8583C31.5423 18.9805 31.5342 19.1046 31.5022 19.2236C31.4703 19.3425 31.4153 19.4541 31.3402 19.5518C31.2652 19.6495 31.1717 19.7314 31.065 19.793L28.9 21.043C28.758 21.1255 28.5967 21.1686 28.4325 21.168ZM23.4375 24.3755C23.4365 25.0979 23.2075 25.8016 22.7833 26.3864C22.359 26.9712 21.7611 27.4071 21.0746 27.6322C20.3881 27.8574 19.6481 27.8601 18.9599 27.6402C18.2718 27.4202 17.6706 26.9887 17.2419 26.4072C16.8133 25.8256 16.5791 25.1237 16.5726 24.4013C16.5662 23.6788 16.7879 22.9728 17.2061 22.3837C17.6243 21.7946 18.2177 21.3525 18.9018 21.1203C19.5859 20.8881 20.3259 20.8776 21.0163 21.0905L25.6925 13.893C25.7596 13.7897 25.8465 13.7007 25.948 13.631C26.0495 13.5613 26.1638 13.5123 26.2843 13.4868C26.4048 13.4612 26.5291 13.4597 26.6502 13.4822C26.7713 13.5047 26.8867 13.5508 26.99 13.618C27.0933 13.6851 27.1823 13.7719 27.252 13.8735C27.3217 13.975 27.3707 14.0893 27.3962 14.2098C27.4218 14.3303 27.4233 14.4546 27.4008 14.5757C27.3783 14.6968 27.3321 14.8122 27.265 14.9155L22.5863 22.1155C23.1356 22.7401 23.4382 23.5437 23.4375 24.3755ZM15.24 17.3755C15.0248 17.4981 14.77 17.5315 14.5304 17.4684C14.2909 17.4053 14.0856 17.2508 13.9587 17.038L12.7087 14.873C12.5844 14.6575 12.5508 14.4015 12.6153 14.1612C12.6797 13.9209 12.837 13.7161 13.0525 13.5917C13.268 13.4674 13.524 13.4338 13.7643 13.4983C14.0046 13.5627 14.2094 13.72 14.3337 13.9355L15.5837 16.1005C15.7066 16.3153 15.7394 16.57 15.6749 16.8089C15.6105 17.0478 15.4542 17.2515 15.24 17.3755ZM11.1 21.0405L8.935 19.7905C8.71951 19.6662 8.56224 19.4613 8.49777 19.2211C8.4333 18.9808 8.46693 18.7247 8.59125 18.5092C8.71557 18.2937 8.9204 18.1365 9.16068 18.072C9.40096 18.0075 9.65701 18.0412 9.8725 18.1655L12.0375 19.4155C12.144 19.4774 12.2373 19.5597 12.3119 19.6577C12.3865 19.7558 12.4411 19.8675 12.4725 19.9867C12.5038 20.1058 12.5113 20.23 12.4946 20.352C12.4779 20.4741 12.4372 20.5917 12.375 20.698C12.2483 20.9092 12.0446 21.063 11.8067 21.1269C11.5688 21.1908 11.3155 21.1598 11.1 21.0405ZM11.5625 25.0005C11.5625 25.2491 11.4637 25.4876 11.2879 25.6634C11.1121 25.8392 10.8736 25.938 10.625 25.938H8.125C7.87636 25.938 7.6379 25.8392 7.46209 25.6634C7.28627 25.4876 7.1875 25.2491 7.1875 25.0005C7.1875 24.7518 7.28627 24.5134 7.46209 24.3376C7.6379 24.1618 7.87636 24.063 8.125 24.063H10.625C10.8736 24.063 11.1121 24.1618 11.2879 24.3376C11.4637 24.5134 11.5625 24.7518 11.5625 25.0005ZM20 11.563C20.2486 11.563 20.4871 11.6618 20.6629 11.8376C20.8387 12.0134 20.9375 12.2518 20.9375 12.5005V15.0005C20.9375 15.2491 20.8387 15.4876 20.6629 15.6634C20.4871 15.8392 20.2486 15.938 20 15.938C19.7514 15.938 19.5129 15.8392 19.3371 15.6634C19.1613 15.4876 19.0625 15.2491 19.0625 15.0005V12.5005C19.0625 12.2518 19.1613 12.0134 19.3371 11.8376C19.5129 11.6618 19.7514 11.563 20 11.563Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Yx = /* @__PURE__ */ u("path", {
  d: "M20 25.938C20.8629 25.938 21.5625 25.2384 21.5625 24.3755C21.5625 23.5125 20.8629 22.813 20 22.813C19.1371 22.813 18.4375 23.5125 18.4375 24.3755C18.4375 25.2384 19.1371 25.938 20 25.938Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Zx = [
  Rx,
  Yx
];
function Wx(e, i) {
  return f(), p("svg", Ux, Zx);
}
const Qx = /* @__PURE__ */ k(Px, [["render", Wx]]), qx = {}, Gx = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xx = /* @__PURE__ */ Ke('<path d="M7.81285 30.3126C6.26164 30.3126 5.00043 29.0514 5.00043 27.5002V24.904C4.97043 20.8792 6.51414 17.0755 9.34905 14.1981C12.184 11.3207 15.9639 9.71823 19.9925 9.68823C28.336 9.75073 35.0621 16.578 34.9996 24.9065V27.5002C34.9996 29.0514 33.7384 30.3126 32.1871 30.3126H7.81285ZM32.1871 28.4377C32.7046 28.4377 33.1246 28.0177 33.1246 27.5002V24.9003C33.1784 17.6018 27.2898 11.6207 19.9962 11.5632C12.709 11.6207 6.82038 17.6005 6.87538 24.8953V27.5002C6.87538 28.0177 7.29536 28.4377 7.81285 28.4377H15.3126C15.3126 26.1203 17.0438 24.1441 19.3075 23.8053L21.9237 15.9581C22.0512 15.5743 22.4074 15.3168 22.8124 15.3168C22.9137 15.3168 23.0149 15.3331 23.1112 15.3656C23.3474 15.4443 23.5399 15.6106 23.6511 15.8356C23.7624 16.0593 23.7811 16.313 23.7024 16.5505L21.245 23.9241C23.2424 24.4778 24.6886 26.329 24.6886 28.4377H32.1871ZM22.8124 28.4377C22.8124 26.9052 21.5737 25.6515 20.0462 25.6265C20.03 25.6278 20.015 25.629 20 25.629C19.9862 25.629 19.97 25.6278 19.9538 25.6265C18.425 25.6515 17.1876 26.9052 17.1876 28.4377H22.8124Z" fill="#3B414D" class="primary"></path><path d="M11.094 25.6253C11.8706 25.6253 12.5002 24.9957 12.5002 24.2191C12.5002 23.4424 11.8706 22.8129 11.094 22.8129C10.3174 22.8129 9.68781 23.4424 9.68781 24.2191C9.68781 24.9957 10.3174 25.6253 11.094 25.6253Z" fill="#3B414D" class="primary"></path><path d="M12.969 20.9416C12.194 20.9416 11.5628 20.3103 11.5628 19.5354C11.5628 18.7604 12.194 18.1292 12.969 18.1292C13.744 18.1292 14.3752 18.7604 14.3752 19.5354C14.3752 20.3103 13.744 20.9416 12.969 20.9416Z" fill="#3B414D" class="primary"></path><path d="M28.9061 25.6253C29.6827 25.6253 30.3123 24.9957 30.3123 24.2191C30.3123 23.4424 29.6827 22.8129 28.9061 22.8129C28.1295 22.8129 27.4999 23.4424 27.4999 24.2191C27.4999 24.9957 28.1295 25.6253 28.9061 25.6253Z" fill="#3B414D" class="primary"></path><path d="M27.031 20.9416C26.256 20.9416 25.6248 20.3103 25.6248 19.5354C25.6248 18.8191 26.1598 18.2241 26.8723 18.1429C26.886 18.1404 26.9198 18.1379 26.921 18.1379C26.9598 18.1329 26.9948 18.1292 27.031 18.1292C27.046 18.1292 27.0648 18.1304 27.081 18.1317C27.0998 18.1329 27.1173 18.1341 27.1335 18.1366C27.8535 18.1766 28.436 18.7916 28.436 19.5354C28.4372 20.3103 27.806 20.9416 27.031 20.9416Z" fill="#3B414D" class="primary"></path><path d="M16.7188 17.1918C17.4955 17.1918 18.125 16.5622 18.125 15.7856C18.125 15.009 17.4955 14.3794 16.7188 14.3794C15.9422 14.3794 15.3126 15.009 15.3126 15.7856C15.3126 16.5622 15.9422 17.1918 16.7188 17.1918Z" fill="#3B414D" class="primary"></path>', 6), Jx = [
  Xx
];
function Kx(e, i) {
  return f(), p("svg", Gx, Jx);
}
const $x = /* @__PURE__ */ k(qx, [["render", Kx]]), eb = {}, nb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ib = /* @__PURE__ */ u("path", {
  d: "M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z",
  fill: "#E2E6ED"
}, null, -1), tb = /* @__PURE__ */ u("path", {
  d: "M5 13.3337H35V16.6671H5V13.3337Z",
  fill: "#9CACCC"
}, null, -1), ab = [
  ib,
  tb
];
function sb(e, i) {
  return f(), p("svg", nb, ab);
}
const ob = /* @__PURE__ */ k(eb, [["render", sb]]), rb = {}, lb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, db = /* @__PURE__ */ u("path", {
  d: "M23.8516 30.7762C23.049 30.7762 22.3352 30.2661 22.0752 29.5061L16.1522 11.0833L12.9069 18.7439C12.4706 19.7902 11.4518 20.4678 10.3129 20.4678H5.93758C5.42004 20.4678 5 20.0478 5 19.5302C5 19.0127 5.42004 18.5926 5.93758 18.5926H10.3129C10.693 18.5926 11.033 18.3664 11.1793 18.0151L14.432 10.3645C14.7258 9.6719 15.4046 9.22437 16.1597 9.22437C16.4122 9.22437 16.6585 9.27437 16.891 9.37438C17.381 9.58315 17.7598 9.99068 17.9323 10.4945L23.8553 28.9185L27.0793 20.354C27.5269 19.2777 28.5482 18.5926 29.6871 18.5926H34.0624C34.58 18.5926 35 19.0127 35 19.5302C35 20.0478 34.58 20.4678 34.0624 20.4678H29.6871C29.307 20.4678 28.967 20.6941 28.8207 21.0454L25.588 29.5998C25.3692 30.1186 24.9579 30.5036 24.4541 30.6762C24.2591 30.7424 24.0566 30.7762 23.8516 30.7762Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cb = [
  db
];
function fb(e, i) {
  return f(), p("svg", lb, cb);
}
const ub = /* @__PURE__ */ k(rb, [["render", fb]]), hb = {}, mb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pb = /* @__PURE__ */ u("path", {
  d: "M5.9375 28.438C5.6875 28.438 5.45125 28.3405 5.275 28.163C5.0975 27.9867 5 27.7505 5 27.5005C5 27.2505 5.0975 27.0142 5.275 26.838L14.2612 17.8517C14.7925 17.3205 15.4988 17.0292 16.2513 17.0292C17.0038 17.0292 17.71 17.3217 18.24 17.8517L22.15 21.7617C22.3275 21.9392 22.5638 22.0367 22.8138 22.0367C23.0638 22.0367 23.3 21.9392 23.4775 21.7617L31.8013 13.438H25.625C25.1075 13.438 24.6875 13.018 24.6875 12.5005C24.6875 11.983 25.1075 11.563 25.625 11.563H34.0625C34.1737 11.563 34.2825 11.583 34.3888 11.623C34.4025 11.628 34.4162 11.633 34.4287 11.638C34.6487 11.728 34.835 11.9142 34.93 12.1442C34.9338 12.1542 34.9388 12.1655 34.9425 12.1767C34.98 12.278 35 12.3892 35 12.5005V20.938C35 21.4555 34.58 21.8755 34.0625 21.8755C33.545 21.8755 33.125 21.4555 33.125 20.938V14.7642L24.8013 23.088C24.27 23.6192 23.5637 23.9105 22.8112 23.9105C22.06 23.9105 21.3538 23.6192 20.8238 23.088L16.9125 19.1767C16.7362 19.0005 16.5013 18.903 16.25 18.903C16 18.903 15.7638 19.0005 15.5875 19.1767L6.6 28.163C6.42375 28.3405 6.1875 28.438 5.9375 28.438Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yb = [
  pb
];
function vb(e, i) {
  return f(), p("svg", mb, yb);
}
const gb = /* @__PURE__ */ k(hb, [["render", vb]]), _b = {}, wb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cb = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2713 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2713 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kb = /* @__PURE__ */ u("path", {
  d: "M23.0125 27.1306C22.2187 27.1306 21.5075 26.6281 21.2437 25.8806L17.1288 14.2243L14.3088 21.2868C14.165 21.6443 13.8237 21.8756 13.4375 21.8756H9.6875C9.17 21.8756 8.75 21.4556 8.75 20.9381C8.75 20.4206 9.17 20.0006 9.6875 20.0006H12.8025L15.3925 13.5268C15.6813 12.8131 16.3638 12.3518 17.1325 12.3518C17.3738 12.3518 17.6087 12.3981 17.8325 12.4881C18.3287 12.6881 18.7163 13.0918 18.895 13.5956L23.01 25.2556L25.7475 20.4718C25.915 20.1818 26.2263 20.0006 26.5625 20.0006H30.3125C30.83 20.0006 31.25 20.4206 31.25 20.9381C31.25 21.4556 30.83 21.8756 30.3125 21.8756H27.1062L24.6388 26.1868C24.415 26.5768 24.0588 26.8743 23.6363 27.0231C23.435 27.0943 23.225 27.1306 23.0125 27.1306Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xb = [
  Cb,
  kb
];
function bb(e, i) {
  return f(), p("svg", wb, xb);
}
const Mb = /* @__PURE__ */ k(_b, [["render", bb]]), Db = {}, Ab = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lb = /* @__PURE__ */ u("path", {
  d: "M29.1924 22.5019C28.4741 22.5413 27.7592 22.3787 27.1287 22.0325C26.4981 21.6863 25.9772 21.1704 25.6249 20.5432C25.5927 20.4942 25.5472 20.4552 25.4938 20.431C25.4403 20.4068 25.381 20.3982 25.3229 20.4063C25.2648 20.4145 25.2101 20.4389 25.1653 20.4769C25.1206 20.5148 25.0875 20.5647 25.0699 20.6207L23.1 26.8881C22.9605 27.2605 22.7089 27.5805 22.38 27.804C22.051 28.0275 21.6608 28.1435 21.2632 28.1359C20.8656 28.1284 20.4801 27.9977 20.1598 27.7619C19.8396 27.5261 19.6003 27.1968 19.4751 26.8194L16.5701 16.0021C16.5521 15.9348 16.5121 15.8754 16.4565 15.8334C16.4008 15.7915 16.3328 15.7693 16.2631 15.7704C16.1934 15.7716 16.1261 15.796 16.0719 15.8398C16.0177 15.8836 15.9797 15.9442 15.9639 16.0121C15.6782 17.6368 15.1736 19.2153 14.4639 20.7045C14.1355 21.2976 13.6424 21.7829 13.0442 22.1019C12.446 22.4208 11.7682 22.5598 11.0927 22.5019H5.21036C5.80139 25.9968 7.61098 29.1695 10.3182 31.4574C13.0255 33.7453 16.4555 35.0005 20 35.0005C23.5446 35.0005 26.9746 33.7453 29.6818 31.4574C32.3891 29.1695 34.1987 25.9968 34.7897 22.5019H29.1924Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Tb = /* @__PURE__ */ u("path", {
  d: "M11.0928 20.002C12.2615 20.002 12.3577 20.002 13.484 15.5459C13.7415 14.5297 14.044 13.3322 14.4277 11.9272C14.5475 11.5411 14.7906 11.2048 15.1198 10.97C15.449 10.7352 15.846 10.6148 16.2502 10.6272V10.6272C16.6547 10.6159 17.0518 10.7378 17.3802 10.9743C17.7086 11.2108 17.9502 11.5487 18.0676 11.936L21.0676 23.0957C21.0847 23.1613 21.1227 23.2194 21.1759 23.2614C21.2291 23.3034 21.2945 23.3268 21.3622 23.3283C21.4299 23.3297 21.4963 23.3089 21.5511 23.2692C21.606 23.2295 21.6465 23.173 21.6663 23.1082L23.3488 17.7521C23.4721 17.4001 23.6991 17.0937 23.9998 16.8731C24.3005 16.6524 24.6609 16.5279 25.0337 16.5159C25.3952 16.4882 25.7571 16.5644 26.0767 16.7356C26.3962 16.9068 26.6602 17.1658 26.8374 17.4821C26.9624 17.7246 27.0874 17.9608 27.1937 18.1883C27.9199 19.6521 28.1312 19.9983 29.1936 19.9983H34.9998C34.9993 16.0201 33.4185 12.2051 30.6051 9.39247C27.7918 6.57983 23.9764 4.99999 19.9982 5.00049C16.02 5.00099 12.205 6.58178 9.39238 9.39512C6.57974 12.2085 4.9999 16.0239 5.0004 20.002H11.0928Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Sb = [
  Lb,
  Tb
];
function Nb(e, i) {
  return f(), p("svg", Ab, Sb);
}
const Eb = /* @__PURE__ */ k(Db, [["render", Nb]]), zb = {}, Ib = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:bx": "https://boxy-svg.com"
}, Bb = /* @__PURE__ */ u("path", {
  d: "M 5.937 11.563 C 6.187 11.563 6.424 11.66 6.6 11.838 L 15.587 20.824 C 15.764 21 16 21.098 16.25 21.098 C 16.501 21.098 16.736 21 16.913 20.824 L 20.824 16.913 C 21.354 16.382 22.06 16.09 22.811 16.09 C 23.564 16.09 24.27 16.382 24.801 16.913 L 33.125 25.237 L 33.125 19.063 C 33.125 18.545 33.545 18.125 34.063 18.125 C 34.58 18.125 35 18.545 35 19.063 L 35 27.5 C 35 27.612 34.98 27.723 34.943 27.824 C 34.939 27.835 34.934 27.847 34.93 27.857 C 34.835 28.087 34.649 28.273 34.429 28.363 C 34.416 28.368 34.403 28.373 34.389 28.378 C 34.283 28.418 34.174 28.438 34.063 28.438 L 25.625 28.438 C 25.108 28.438 24.688 28.018 24.688 27.5 C 24.688 26.983 25.108 26.563 25.625 26.563 L 31.801 26.563 L 23.478 18.239 C 23.3 18.062 23.064 17.964 22.814 17.964 C 22.564 17.964 22.328 18.062 22.15 18.239 L 18.24 22.149 C 17.71 22.679 17.004 22.972 16.251 22.972 C 15.499 22.972 14.792 22.68 14.261 22.149 L 5.275 13.163 C 5.097 12.987 5 12.75 5 12.5 C 5 12.25 5.097 12.014 5.275 11.838 C 5.451 11.66 5.687 11.563 5.937 11.563 Z",
  fill: "#3B414D",
  class: "primary",
  "bx:origin": "0.5 0.49997"
}, null, -1), Ob = [
  Bb
];
function Hb(e, i) {
  return f(), p("svg", Ib, Ob);
}
const jb = /* @__PURE__ */ k(zb, [["render", Hb]]), Vb = {}, Fb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pb = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C18.4487 35.0005 17.1875 33.7392 17.1875 32.188C17.1875 30.6367 18.4487 29.3755 20 29.3755H21.875C23.075 29.3755 24.135 30.1442 24.5263 31.2505H26.5625C28.1138 31.2505 29.375 29.9892 29.375 28.438C28.3412 28.438 27.5 27.5967 27.5 26.563V17.188C27.5 16.1705 28.3162 15.3392 29.3275 15.313C28.8563 10.5442 24.85 6.87549 20 6.87549C15.15 6.87549 11.1438 10.5442 10.6725 15.313C11.6838 15.3392 12.5 16.1705 12.5 17.188V26.563C12.5 27.5967 11.6588 28.438 10.625 28.438H9.6875C7.1025 28.438 5 26.3355 5 23.7505V20.0005C5 17.738 6.60125 15.8267 8.78375 15.4017C9.22 9.53799 14.0737 5.00049 20 5.00049C25.9263 5.00049 30.7812 9.53799 31.2162 15.4017C33.3988 15.8267 35 17.738 35 20.0005V23.7505C35 25.9992 33.415 27.9042 31.25 28.3417V28.438C31.25 31.023 29.1475 33.1255 26.5625 33.1255H24.5263C24.135 34.2317 23.075 35.0005 21.875 35.0005H20ZM20 31.2505C19.4825 31.2505 19.0625 31.6705 19.0625 32.188C19.0625 32.7055 19.4825 33.1255 20 33.1255H21.875C22.3925 33.1255 22.8125 32.7055 22.8125 32.188C22.8125 31.6705 22.3925 31.2505 21.875 31.2505H20ZM29.375 26.563H30.3125C31.8638 26.563 33.125 25.3017 33.125 23.7505V20.0005C33.125 18.4492 31.8638 17.188 30.3125 17.188H29.375V26.563ZM9.6875 17.188C8.13625 17.188 6.875 18.4492 6.875 20.0005V23.7505C6.875 25.3017 8.13625 26.563 9.6875 26.563H10.625V17.188H9.6875Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), Ub = [
  Pb
];
function Rb(e, i) {
  return f(), p("svg", Fb, Ub);
}
const Yb = /* @__PURE__ */ k(Vb, [["render", Rb]]), Zb = {}, Wb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qb = /* @__PURE__ */ u("path", {
  d: "M35 22.8145C35.0003 21.6519 34.6398 20.5179 33.9683 19.5689C33.2967 18.62 32.3471 17.9029 31.2506 17.5166V16.5655C31.2506 13.5822 30.0655 10.7212 27.9561 8.61178C25.8466 6.50234 22.9856 5.31726 20.0024 5.31726C17.0192 5.31726 14.1582 6.50234 12.0487 8.61178C9.93928 10.7212 8.75421 13.5822 8.75421 16.5655V17.5166C7.65652 17.9035 6.70593 18.6215 6.03351 19.5715C5.3611 20.5216 5 21.6568 5 22.8207C5 23.9846 5.3611 25.1198 6.03351 26.0699C6.70593 27.0199 7.65652 27.7379 8.75421 28.1249C9.03755 28.225 9.34082 28.2556 9.63846 28.2141C9.9361 28.1725 10.2194 28.06 10.4644 27.886C10.7095 27.712 10.9091 27.4816 11.0465 27.2144C11.1839 26.9471 11.255 26.6507 11.2538 26.3501V16.5655C11.2538 15.4166 11.4801 14.2789 11.9198 13.2175C12.3594 12.1561 13.0038 11.1916 13.8162 10.3793C14.6286 9.56688 15.593 8.92247 16.6545 8.48281C17.7159 8.04315 18.8535 7.81686 20.0024 7.81686C21.1513 7.81686 22.2889 8.04315 23.3503 8.48281C24.4118 8.92247 25.3762 9.56688 26.1886 10.3793C27.001 11.1916 27.6454 12.1561 28.0851 13.2175C28.5247 14.2789 28.751 15.4166 28.751 16.5655V26.3501C28.7537 26.6102 28.8107 26.8668 28.9183 27.1035C29.0259 27.3403 29.1818 27.5519 29.3759 27.7249V28.4348C29.3759 30.277 27.7624 30.9344 26.2514 30.9344H24.0293C23.7541 30.4579 23.3295 30.0854 22.8211 29.8749C22.3127 29.6643 21.7491 29.6274 21.2176 29.7698C20.6861 29.9122 20.2164 30.226 19.8815 30.6625C19.5465 31.0991 19.3649 31.634 19.3649 32.1842C19.3649 32.7344 19.5465 33.2693 19.8815 33.7059C20.2164 34.1424 20.6861 34.4562 21.2176 34.5986C21.7491 34.741 22.3127 34.7041 22.8211 34.4935C23.3295 34.283 23.7541 33.9105 24.0293 33.434H26.2514C29.5621 33.434 31.8755 31.3781 31.8755 28.4348V27.8374C32.8115 27.373 33.5996 26.6571 34.1515 25.7699C34.7034 24.8827 34.9972 23.8593 35 22.8145Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), qb = [
  Qb
];
function Gb(e, i) {
  return f(), p("svg", Wb, qb);
}
const Xb = /* @__PURE__ */ k(Zb, [["render", Gb]]), Jb = {}, Kb = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $b = /* @__PURE__ */ u("path", {
  d: "M26.9147 34.9992C26.3972 34.9992 25.9772 34.5792 25.9772 34.0617V28.8117C25.9772 28.478 26.1572 28.1655 26.4472 27.9992C28.8397 26.623 30.6047 24.3005 31.2897 21.6267C31.9722 18.9617 31.5759 16.1905 30.1747 13.8242C28.9922 11.828 27.1847 10.3005 25.0384 9.47049V14.8742C26.2334 15.943 26.9134 17.458 26.9134 19.063C26.9134 22.1642 24.3897 24.688 21.2884 24.688C21.0559 24.688 20.8222 24.673 20.5834 24.6405C18.6909 27.5692 15.3984 29.3755 11.9134 29.3755H10.0384C9.52094 29.3755 9.10094 28.9555 9.10094 28.438C9.10094 27.9205 9.52219 27.5005 10.0384 27.5005H11.9134C14.6147 27.5005 17.1159 26.223 18.7084 24.0567C16.8409 23.0955 15.6634 21.193 15.6634 19.063C15.6634 17.4567 16.3434 15.943 17.5384 14.8742V9.28424C13.5884 10.5017 10.9772 13.6217 10.9772 17.2017V18.1392C10.9772 18.3242 10.9234 18.5042 10.8197 18.6592L8.54469 22.0705C8.48469 22.1605 8.44094 22.258 8.41594 22.363C8.35469 22.6055 8.39219 22.858 8.52094 23.073C8.64969 23.288 8.85469 23.4392 9.09719 23.5005L10.2672 23.793C10.5097 23.853 10.7147 24.0055 10.8434 24.2192C10.9722 24.4342 11.0097 24.6867 10.9484 24.9292C10.8447 25.3467 10.4709 25.6392 10.0397 25.6392C9.96344 25.6392 9.88719 25.6292 9.81344 25.6117L8.64219 25.3192C7.91344 25.1367 7.29844 24.6817 6.91219 24.0367C6.52594 23.3917 6.41344 22.6367 6.59594 21.908C6.67469 21.5942 6.80469 21.2992 6.98344 21.0305L9.10094 17.8555V17.2017C9.10094 12.658 12.5509 8.64674 17.5372 7.33424V6.87549C17.5372 5.84174 18.3784 5.00049 19.4122 5.00049H23.1622C24.1959 5.00049 25.0372 5.84174 25.0372 6.87549V7.48549C27.8759 8.39424 30.2622 10.2955 31.7859 12.8692C33.4422 15.6667 33.9109 18.943 33.1034 22.093C32.3422 25.063 30.4347 27.6905 27.8497 29.3405V34.063C27.8522 34.5792 27.4322 34.9992 26.9147 34.9992ZM21.2884 18.1255C21.8059 18.1255 22.2259 18.5455 22.2259 19.063C22.2259 20.358 21.9897 21.6142 21.5222 22.8055C23.4822 22.6842 25.0384 21.0517 25.0384 19.063C25.0384 16.9955 23.3559 15.313 21.2884 15.313C19.2209 15.313 17.5384 16.9955 17.5384 19.063C17.5384 20.5017 18.3709 21.8067 19.6484 22.4292C20.1147 21.3655 20.3509 20.2355 20.3509 19.063C20.3509 18.5455 20.7722 18.1255 21.2884 18.1255ZM21.2884 13.438C21.9334 13.438 22.5622 13.5467 23.1634 13.763V6.87549H19.4134V13.763C20.0147 13.5467 20.6434 13.438 21.2884 13.438Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), eM = /* @__PURE__ */ u("path", {
  d: "M15.6646 35.0006C15.1471 35.0006 14.7271 34.5806 14.7271 34.0631V32.3706L14.5596 32.3981C14.3034 32.4418 14.0409 32.4643 13.7821 32.4643C13.3921 32.4643 12.9996 32.4143 12.6171 32.3156C12.1171 32.1856 11.8146 31.6731 11.9446 31.1731C12.0521 30.7593 12.4259 30.4706 12.8521 30.4706C12.9309 30.4706 13.0096 30.4806 13.0859 30.5006C13.3146 30.5593 13.5484 30.5906 13.7821 30.5906C13.9371 30.5906 14.0946 30.5768 14.2496 30.5506L15.5121 30.3418C15.5621 30.3331 15.6146 30.3293 15.6671 30.3293C15.8884 30.3293 16.1034 30.4081 16.2721 30.5518C16.4821 30.7306 16.6034 30.9918 16.6034 31.2668V34.0656C16.6022 34.5806 16.1821 35.0006 15.6646 35.0006Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), nM = [
  $b,
  eM
];
function iM(e, i) {
  return f(), p("svg", Kb, nM);
}
const tM = /* @__PURE__ */ k(Jb, [["render", iM]]), aM = {}, sM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oM = /* @__PURE__ */ u("path", {
  d: "M6.875 35.0005C5.84125 35.0005 5 34.1592 5 33.1255V29.3755C5 28.3417 5.84125 27.5005 6.875 27.5005H21.875C22.9088 27.5005 23.75 28.3417 23.75 29.3755V31.2505H26.5625C27.08 31.2505 27.5 30.8305 27.5 30.313V25.6255H18.125C17.0913 25.6255 16.25 24.7842 16.25 23.7505V20.0005C16.25 18.9667 17.0913 18.1255 18.125 18.1255H21.875V17.188C21.875 16.6705 21.455 16.2505 20.9375 16.2505H15.3125C13.7612 16.2505 12.5 14.9892 12.5 13.438V12.5005H6.875C5.84125 12.5005 5 11.6592 5 10.6255V6.87549C5 5.84174 5.84125 5.00049 6.875 5.00049H21.875C22.9088 5.00049 23.75 5.84174 23.75 6.87549V10.6255C23.75 11.6592 22.9088 12.5005 21.875 12.5005H14.375V13.438C14.375 13.9555 14.795 14.3755 15.3125 14.3755H20.9375C22.4888 14.3755 23.75 15.6367 23.75 17.188V18.1255H33.125C34.1588 18.1255 35 18.9667 35 20.0005V23.7505C35 24.7842 34.1588 25.6255 33.125 25.6255H29.375V30.313C29.375 31.8642 28.1138 33.1255 26.5625 33.1255H23.75C23.75 34.1592 22.9088 35.0005 21.875 35.0005H6.875ZM6.875 33.1255H21.875V29.3755H6.875V33.1255ZM18.125 23.7505H33.125V20.0005H18.125V23.7505ZM6.875 10.6255H21.875V6.87549H6.875V10.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), rM = [
  oM
];
function lM(e, i) {
  return f(), p("svg", sM, rM);
}
const dM = /* @__PURE__ */ k(aM, [["render", lM]]), cM = {}, fM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uM = /* @__PURE__ */ u("path", {
  d: "M35 20.6255C35 20.1282 34.8025 19.6513 34.4508 19.2997C34.0992 18.948 33.6223 18.7505 33.125 18.7505H24.0625C23.9796 18.7505 23.9001 18.7176 23.8415 18.659C23.7829 18.6004 23.75 18.5209 23.75 18.438V16.2505C23.75 15.4217 23.4208 14.6268 22.8347 14.0408C22.2487 13.4547 21.4538 13.1255 20.625 13.1255H15.625C15.4592 13.1255 15.3003 13.0596 15.1831 12.9424C15.0658 12.8252 15 12.6662 15 12.5005V10.3117C15.0003 10.2291 15.0334 10.1499 15.092 10.0916C15.1505 10.0332 15.2298 10.0005 15.3125 10.0005H20C20.4973 10.0005 20.9742 9.80294 21.3258 9.45131C21.6775 9.09968 21.875 8.62277 21.875 8.12549V6.87549C21.875 6.37821 21.6775 5.90129 21.3258 5.54966C20.9742 5.19803 20.4973 5.00049 20 5.00049H6.875C6.37772 5.00049 5.90081 5.19803 5.54917 5.54966C5.19754 5.90129 5 6.37821 5 6.87549V8.12549C5 8.62277 5.19754 9.09968 5.54917 9.45131C5.90081 9.80294 6.37772 10.0005 6.875 10.0005H12.1875C12.2704 10.0005 12.3499 10.0334 12.4085 10.092C12.4671 10.1506 12.5 10.2301 12.5 10.313V12.5005C12.5 13.3293 12.8292 14.1241 13.4153 14.7102C14.0013 15.2962 14.7962 15.6255 15.625 15.6255H20.625C20.7908 15.6255 20.9497 15.6913 21.0669 15.8085C21.1842 15.9258 21.25 16.0847 21.25 16.2505V18.438C21.25 18.5209 21.2171 18.6004 21.1585 18.659C21.0999 18.7176 21.0204 18.7505 20.9375 18.7505H20C19.5027 18.7505 19.0258 18.948 18.6742 19.2997C18.3225 19.6513 18.125 20.1282 18.125 20.6255V21.8755C18.125 22.3728 18.3225 22.8497 18.6742 23.2013C19.0258 23.5529 19.5027 23.7505 20 23.7505H26.5625C26.6454 23.7505 26.7249 23.7834 26.7835 23.842C26.8421 23.9006 26.875 23.9801 26.875 24.063V30.6255C26.875 30.7912 26.8092 30.9502 26.6919 31.0674C26.5747 31.1846 26.4158 31.2505 26.25 31.2505H21.9438C21.8913 31.2506 21.8399 31.2358 21.7956 31.2076C21.7513 31.1795 21.7159 31.1393 21.6937 31.0917C21.5446 30.7675 21.3059 30.4926 21.0059 30.2993C20.7059 30.106 20.3569 30.0023 20 30.0005H6.875C6.37772 30.0005 5.90081 30.198 5.54917 30.5497C5.19754 30.9013 5 31.3782 5 31.8755V33.1255C5 33.6228 5.19754 34.0997 5.54917 34.4513C5.90081 34.8029 6.37772 35.0005 6.875 35.0005H20C20.3571 34.9989 20.7064 34.8954 21.0066 34.702C21.3069 34.5087 21.5457 34.2337 21.695 33.9092C21.7169 33.8615 21.7522 33.8211 21.7966 33.7929C21.8409 33.7648 21.8925 33.75 21.945 33.7505H26.25C27.0788 33.7505 27.8737 33.4212 28.4597 32.8352C29.0458 32.2491 29.375 31.4543 29.375 30.6255V24.063C29.375 23.9801 29.4079 23.9006 29.4665 23.842C29.5251 23.7834 29.6046 23.7505 29.6875 23.7505H33.125C33.6223 23.7505 34.0992 23.5529 34.4508 23.2013C34.8025 22.8497 35 22.3728 35 21.8755V20.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), hM = [
  uM
];
function mM(e, i) {
  return f(), p("svg", fM, hM);
}
const pM = /* @__PURE__ */ k(cM, [["render", mM]]), yM = {}, vM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gM = /* @__PURE__ */ u("path", {
  d: "M22.812 33.6741C22.2945 33.6741 21.8744 33.2541 21.8744 32.7366V25.2362C21.8744 24.7187 21.4544 24.2987 20.9369 24.2987H19.0618C18.5443 24.2987 18.1243 24.7187 18.1243 25.2362V32.7366C18.1243 33.2541 17.7043 33.6741 17.1868 33.6741H9.68644C9.16892 33.6741 8.7489 33.2541 8.7489 32.7366V22.4236C8.7489 21.9061 9.16892 21.4861 9.68644 21.4861C10.204 21.4861 10.624 21.9061 10.624 22.4236V31.799H16.2492V25.2362C16.2492 23.6849 17.5105 22.4236 19.0618 22.4236H20.9369C22.4882 22.4236 23.7495 23.6849 23.7495 25.2362V31.799H29.3748V22.4236C29.3748 21.9061 29.7948 21.4861 30.3123 21.4861C30.8298 21.4861 31.2498 21.9061 31.2498 22.4236V32.7366C31.2498 33.2541 30.8298 33.6741 30.3123 33.6741H22.812Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), _M = /* @__PURE__ */ u("path", {
  d: "M5.93629 21.4862C5.68628 21.4862 5.45002 21.3887 5.27376 21.2112C4.90875 20.8461 4.90875 20.2511 5.27376 19.8848L18.0105 7.14932C18.5406 6.61804 19.2468 6.32678 19.9994 6.32678C20.7507 6.32678 21.4569 6.61929 21.9882 7.14932L34.7262 19.8873C35.0913 20.2524 35.0913 20.8474 34.7262 21.2137C34.5487 21.3912 34.3137 21.4887 34.0637 21.4887C33.8137 21.4887 33.5774 21.3912 33.4012 21.2137L20.6632 8.47437C20.4856 8.29811 20.2506 8.20061 19.9994 8.20061C19.7481 8.20061 19.5131 8.29811 19.3368 8.47437L6.59882 21.2112C6.42256 21.3887 6.1863 21.4862 5.93629 21.4862Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), wM = [
  gM,
  _M
];
function CM(e, i) {
  return f(), p("svg", vM, wM);
}
const kM = /* @__PURE__ */ k(yM, [["render", CM]]), xM = {}, bM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MM = /* @__PURE__ */ u("path", {
  d: "M34.634 19.1166L20.8839 5.36647C20.6495 5.13213 20.3316 5.00049 20.0001 5.00049C19.6687 5.00049 19.3508 5.13213 19.1164 5.36647L5.36623 19.1166C5.19147 19.2914 5.07246 19.5141 5.02425 19.7566C4.97604 19.999 5.00079 20.2503 5.09538 20.4787C5.18997 20.7071 5.35015 20.9023 5.55566 21.0396C5.76117 21.177 6.0028 21.2503 6.24999 21.2504H7.8125C7.89538 21.2504 7.97487 21.2833 8.03348 21.3419C8.09208 21.4005 8.12501 21.48 8.12501 21.5629V33.7505C8.12501 34.082 8.2567 34.3999 8.49113 34.6344C8.72555 34.8688 9.04349 35.0005 9.37502 35.0005H16.5626C16.6455 35.0005 16.7249 34.9676 16.7836 34.909C16.8422 34.8504 16.8751 34.7709 16.8751 34.688V28.7504C16.8751 27.9216 17.2043 27.1268 17.7904 26.5407C18.3764 25.9546 19.1713 25.6254 20.0001 25.6254C20.8289 25.6254 21.6238 25.9546 22.2098 26.5407C22.7959 27.1268 23.1251 27.9216 23.1251 28.7504V34.688C23.1251 34.7709 23.1581 34.8504 23.2167 34.909C23.2753 34.9676 23.3548 35.0005 23.4376 35.0005H30.6252C30.9567 35.0005 31.2747 34.8688 31.5091 34.6344C31.7435 34.3999 31.8752 34.082 31.8752 33.7505V21.5629C31.8752 21.48 31.9081 21.4005 31.9667 21.3419C32.0254 21.2833 32.1048 21.2504 32.1877 21.2504H33.7502C33.9974 21.2503 34.239 21.177 34.4446 21.0396C34.6501 20.9023 34.8103 20.7071 34.9048 20.4787C34.9994 20.2503 35.0242 19.999 34.976 19.7566C34.9278 19.5141 34.8088 19.2914 34.634 19.1166Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), DM = [
  MM
];
function AM(e, i) {
  return f(), p("svg", bM, DM);
}
const LM = /* @__PURE__ */ k(xM, [["render", AM]]), TM = {}, SM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NM = /* @__PURE__ */ u("circle", {
  cx: "20",
  cy: "20.0005",
  r: "6.66667",
  fill: "#3B414D",
  class: "primary"
}, null, -1), EM = [
  NM
];
function zM(e, i) {
  return f(), p("svg", SM, EM);
}
const IM = /* @__PURE__ */ k(TM, [["render", zM]]), BM = {}, OM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HM = /* @__PURE__ */ u("path", {
  d: "M20 5.00049C17.0333 5.00049 14.1332 5.88022 11.6665 7.52844C9.19971 9.17666 7.27713 11.5193 6.14181 14.2602C5.0065 17.0011 4.70945 20.0171 5.28823 22.9268C5.86701 25.8366 7.29562 28.5093 9.3934 30.6071C11.4912 32.7049 14.1639 34.1335 17.0737 34.7123C19.9834 35.291 22.9994 34.994 25.7403 33.8587C28.4811 32.7234 30.8238 30.8008 32.472 28.334C34.1203 25.8673 35 22.9672 35 20.0005C34.9957 16.0236 33.414 12.2107 30.6019 9.39864C27.7897 6.58652 23.9769 5.00479 20 5.00049V5.00049ZM20.3125 11.2505C20.6833 11.2505 21.0459 11.3605 21.3542 11.5665C21.6625 11.7725 21.9029 12.0653 22.0448 12.408C22.1867 12.7506 22.2238 13.1276 22.1515 13.4913C22.0791 13.855 21.9006 14.1891 21.6383 14.4513C21.3761 14.7135 21.042 14.8921 20.6783 14.9645C20.3146 15.0368 19.9376 14.9997 19.595 14.8578C19.2524 14.7158 18.9595 14.4755 18.7535 14.1672C18.5475 13.8588 18.4375 13.4963 18.4375 13.1255C18.4375 12.6282 18.635 12.1513 18.9867 11.7997C19.3383 11.448 19.8152 11.2505 20.3125 11.2505ZM23.125 28.1255H18.125C17.7935 28.1255 17.4755 27.9938 17.2411 27.7594C17.0067 27.5249 16.875 27.207 16.875 26.8755C16.875 26.544 17.0067 26.226 17.2411 25.9916C17.4755 25.7572 17.7935 25.6255 18.125 25.6255H19.0625C19.1454 25.6255 19.2249 25.5926 19.2835 25.534C19.3421 25.4753 19.375 25.3959 19.375 25.313V19.688C19.375 19.6051 19.3421 19.5256 19.2835 19.467C19.2249 19.4084 19.1454 19.3755 19.0625 19.3755H18.125C17.7935 19.3755 17.4755 19.2438 17.2411 19.0094C17.0067 18.7749 16.875 18.457 16.875 18.1255C16.875 17.794 17.0067 17.476 17.2411 17.2416C17.4755 17.0072 17.7935 16.8755 18.125 16.8755H19.375C20.038 16.8755 20.6739 17.1389 21.1428 17.6077C21.6116 18.0766 21.875 18.7124 21.875 19.3755V25.313C21.875 25.3959 21.9079 25.4753 21.9665 25.534C22.0251 25.5926 22.1046 25.6255 22.1875 25.6255H23.125C23.4565 25.6255 23.7745 25.7572 24.0089 25.9916C24.2433 26.226 24.375 26.544 24.375 26.8755C24.375 27.207 24.2433 27.5249 24.0089 27.7594C23.7745 27.9938 23.4565 28.1255 23.125 28.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jM = [
  HM
];
function VM(e, i) {
  return f(), p("svg", OM, jM);
}
const FM = /* @__PURE__ */ k(BM, [["render", VM]]), PM = {}, UM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RM = /* @__PURE__ */ Ke('<path d="M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z" fill="#CCEAFF"></path><path d="M30 24.5936C30 26.3115 28.6076 27.7045 26.8892 27.7045H10V15.4078C10 13.6894 11.3924 12.2964 13.1111 12.2964H29.9999L29.9998 24.5935L30 24.5936Z" fill="white"></path><path d="M24.4941 20.2703C24.9765 20.2808 25.4616 20.249 25.9421 20.2868C26.4287 20.3776 26.546 21.1142 26.1137 21.3555C25.8187 21.5144 25.4683 21.4146 25.1486 21.4427H24.4941V20.2703V20.2703ZM26.221 18.9433C26.3282 19.3216 25.9635 19.6613 25.5992 19.6092H24.4941C24.5019 19.2524 24.4789 18.8652 24.5053 18.5273C24.948 18.5397 25.3948 18.5018 25.8349 18.5471C26.024 18.5946 26.1823 18.7501 26.221 18.9433V18.9433ZM28.8805 13.3333C28.9011 14.0557 28.8835 14.8164 28.8894 15.5535C28.888 18.5503 28.8923 21.547 28.8871 24.544C28.8677 25.6671 27.8723 26.6431 26.7569 26.6655C25.6405 26.67 24.5239 26.6662 23.4073 26.6674V22.1369C24.6239 22.1306 25.8411 22.1496 27.0572 22.1274C27.6213 22.0919 28.2392 21.7197 28.2655 21.0989C28.3319 20.4754 27.7441 20.0441 27.186 19.976C26.9714 19.9704 26.9777 19.9135 27.186 19.8886C27.7183 19.7736 28.1363 19.2226 27.9797 18.6709C27.8462 18.0906 27.2048 17.8659 26.6713 17.8671C25.5835 17.8597 24.4954 17.866 23.4076 17.8639C23.4146 17.0181 23.3929 16.1714 23.4192 15.3262C23.5054 14.2233 24.5258 13.3138 25.6255 13.3336C26.7107 13.3334 27.7956 13.3334 28.8805 13.3334V13.3333Z" fill="url(#paint0_linear)"></path><path d="M11.1141 15.4404C11.1419 14.319 12.1415 13.3511 13.2555 13.3347C14.3678 13.3313 15.4802 13.3342 16.5926 13.3332C16.5895 17.085 16.5986 20.8373 16.588 24.5889C16.5451 25.6966 15.5564 26.646 14.4546 26.6657C13.3402 26.6697 12.2257 26.6662 11.1112 26.6673V21.984C12.1937 22.2398 13.3289 22.3486 14.4332 22.179C15.0934 22.0728 15.8156 21.7486 16.0391 21.0638C16.2036 20.478 16.111 19.8614 16.1355 19.2602V17.8638H14.2243C14.2157 18.7873 14.2419 19.7124 14.2104 20.6348C14.1589 21.2018 13.5975 21.562 13.0628 21.5427C12.3996 21.5498 11.0855 21.0622 11.0855 21.0622C11.0822 19.3319 11.1048 17.165 11.1141 15.4405V15.4404Z" fill="url(#paint1_linear)"></path><path d="M17.3051 18.427C17.2045 18.4484 17.2848 18.0843 17.2591 17.9463C17.266 17.0732 17.2448 16.1991 17.2708 15.3267C17.3568 14.2191 18.385 13.3074 19.4891 13.3333H22.7407C22.7377 17.0851 22.7467 20.8373 22.7361 24.5889C22.6932 25.6966 21.7045 26.6461 20.6026 26.6657C19.4882 26.6699 18.3736 26.6664 17.2591 26.6674V21.5362C18.0203 22.1608 19.0548 22.258 20.0031 22.2597C20.718 22.2594 21.4287 22.1492 22.123 21.9843V21.0443C21.3406 21.4342 20.4208 21.6819 19.5535 21.4579C18.9485 21.3073 18.5093 20.7226 18.5191 20.0982C18.449 19.4489 18.8296 18.7634 19.4677 18.5704C20.2599 18.3224 21.1233 18.5121 21.8659 18.8345C22.025 18.9178 22.1865 19.0211 22.1229 18.7552V18.0163C20.8809 17.7208 19.5592 17.6121 18.3115 17.9335C17.9503 18.0354 17.5984 18.1899 17.3051 18.4271V18.427Z" fill="url(#paint2_linear)"></path><defs><linearGradient id="paint0_linear" x1="23.3699" y1="19.7153" x2="28.8548" y2="19.7153" gradientUnits="userSpaceOnUse"><stop stop-color="#007B40"></stop><stop offset="1" stop-color="#55B330"></stop></linearGradient><linearGradient id="paint1_linear" x1="10.9946" y1="20.128" x2="16.5027" y2="20.128" gradientUnits="userSpaceOnUse"><stop stop-color="#1D2970"></stop><stop offset="1" stop-color="#006DBA"></stop></linearGradient><linearGradient id="paint2_linear" x1="17.251" y1="19.8444" x2="22.7397" y2="19.8444" gradientUnits="userSpaceOnUse"><stop stop-color="#6E2B2F"></stop><stop offset="1" stop-color="#E30138"></stop></linearGradient></defs>', 6), YM = [
  RM
];
function ZM(e, i) {
  return f(), p("svg", UM, YM);
}
const WM = /* @__PURE__ */ k(PM, [["render", ZM]]), QM = {}, qM = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GM = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C19.89 35.0005 19.7812 34.9805 19.675 34.9417C19.665 34.938 19.6563 34.9355 19.6475 34.9317C19.5275 34.883 19.4237 34.8142 19.3362 34.7255L14.65 30.038C14.4725 29.8605 14.375 29.6255 14.375 29.3755C14.375 29.1255 14.4725 28.8892 14.65 28.713C14.8275 28.5355 15.0625 28.438 15.3125 28.438C15.5625 28.438 15.7987 28.5355 15.975 28.713L19.0625 31.8005V5.93799C19.0625 5.42049 19.4825 5.00049 20 5.00049C20.5175 5.00049 20.9375 5.42049 20.9375 5.93799V31.7992L24.025 28.7117C24.2025 28.5342 24.4375 28.4367 24.6875 28.4367C24.9375 28.4367 25.1738 28.5342 25.35 28.7117C25.5263 28.8892 25.625 29.1242 25.625 29.3742C25.625 29.6242 25.5275 29.8605 25.35 30.0367L20.6625 34.7242C20.575 34.8117 20.4713 34.8805 20.355 34.9292C20.345 34.933 20.3325 34.938 20.3212 34.9417C20.215 34.9817 20.1075 35.0005 20 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), XM = [
  GM
];
function JM(e, i) {
  return f(), p("svg", qM, XM);
}
const KM = /* @__PURE__ */ k(QM, [["render", JM]]), $M = {}, eD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nD = /* @__PURE__ */ u("path", {
  d: "M10.625 25.6255C10.375 25.6255 10.1388 25.528 9.9625 25.3505L5.275 20.663C5.1875 20.5755 5.11875 20.4717 5.07125 20.3567C5.0675 20.348 5.06375 20.3367 5.06 20.3267C5.02125 20.2255 5 20.1142 5 20.0005C5 19.8892 5.02 19.7805 5.06 19.6742C5.0625 19.6655 5.06625 19.6567 5.07 19.648C5.12 19.5267 5.18875 19.4242 5.2775 19.3367L9.9625 14.6505C10.14 14.473 10.375 14.3755 10.625 14.3755C10.875 14.3755 11.1113 14.473 11.2875 14.6505C11.465 14.8267 11.5625 15.063 11.5625 15.313C11.5625 15.563 11.465 15.7992 11.2875 15.9755L8.2 19.063H34.0625C34.58 19.063 35 19.483 35 20.0005C35 20.518 34.58 20.938 34.0625 20.938H8.20125L11.2888 24.0255C11.4662 24.203 11.5637 24.438 11.5637 24.688C11.5637 24.938 11.4662 25.1742 11.2888 25.3505C11.1113 25.528 10.875 25.6255 10.625 25.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), iD = [
  nD
];
function tD(e, i) {
  return f(), p("svg", eD, iD);
}
const aD = /* @__PURE__ */ k($M, [["render", tD]]), sD = {}, oD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rD = /* @__PURE__ */ u("path", {
  d: "M29.375 25.6255C29.625 25.6255 29.8612 25.528 30.0375 25.3505L34.725 20.663C34.8125 20.5755 34.8813 20.4717 34.9287 20.3567C34.9325 20.348 34.9362 20.3367 34.94 20.3267C34.9787 20.2255 35 20.1142 35 20.0005C35 19.8892 34.98 19.7805 34.94 19.6742C34.9375 19.6655 34.9337 19.6567 34.93 19.648C34.88 19.5267 34.8112 19.4242 34.7225 19.3367L30.0375 14.6505C29.86 14.473 29.625 14.3755 29.375 14.3755C29.125 14.3755 28.8887 14.473 28.7125 14.6505C28.535 14.8267 28.4375 15.063 28.4375 15.313C28.4375 15.563 28.535 15.7992 28.7125 15.9755L31.8 19.063H5.9375C5.42 19.063 5 19.483 5 20.0005C5 20.518 5.42 20.938 5.9375 20.938H31.7987L28.7112 24.0255C28.5337 24.203 28.4363 24.438 28.4363 24.688C28.4363 24.938 28.5337 25.1742 28.7112 25.3505C28.8887 25.528 29.125 25.6255 29.375 25.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), lD = [
  rD
];
function dD(e, i) {
  return f(), p("svg", oD, lD);
}
const cD = /* @__PURE__ */ k(sD, [["render", dD]]), fD = {}, uD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hD = /* @__PURE__ */ u("path", {
  d: "M16.9999 28.0005C16.7333 28.0005 16.4813 27.8965 16.2933 27.7072L11.3159 22.7298C11.1226 22.5605 10.9999 22.2885 10.9999 22.0045C10.9999 21.9898 10.9999 21.9752 11.0013 21.9605C11.0066 21.8512 11.0279 21.7498 11.0653 21.6525C11.0693 21.6432 11.0826 21.6085 11.0866 21.5992C11.1253 21.5138 11.1759 21.4325 11.2373 21.3605C11.2546 21.3365 11.2746 21.3138 11.2933 21.2938L16.2933 16.2938C16.4826 16.1045 16.7333 16.0005 16.9999 16.0005C17.2666 16.0005 17.5186 16.1045 17.7066 16.2938C17.8959 16.4818 17.9999 16.7338 17.9999 17.0005C17.9999 17.2672 17.8959 17.5192 17.7066 17.7072L14.4106 21.0045H21.9999C24.7573 21.0045 26.9999 18.7618 26.9999 16.0045V13.0005C26.9999 12.4485 27.4479 12.0005 27.9999 12.0005C28.5519 12.0005 28.9999 12.4485 28.9999 13.0005V16.0045C28.9999 19.8645 25.8599 23.0045 21.9999 23.0045H14.4173L17.7066 26.2938C18.0959 26.6832 18.0959 27.3178 17.7066 27.7085C17.5186 27.8965 17.2666 28.0005 16.9999 28.0005Z",
  fill: "#3B414D"
}, null, -1), mD = /* @__PURE__ */ u("path", {
  d: "M10 35.0005C7.24267 35.0005 5 32.7578 5 30.0005V10.0005C5 7.24316 7.24267 5.00049 10 5.00049H30C32.7573 5.00049 35 7.24316 35 10.0005V30.0005C35 32.7578 32.7573 35.0005 30 35.0005H10ZM10 7.00049C8.34533 7.00049 7 8.34582 7 10.0005V30.0005C7 31.6552 8.34533 33.0005 10 33.0005H30C31.6547 33.0005 33 31.6552 33 30.0005V10.0005C33 8.34582 31.6547 7.00049 30 7.00049H10Z",
  fill: "#3B414D"
}, null, -1), pD = [
  hD,
  mD
];
function yD(e, i) {
  return f(), p("svg", uD, pD);
}
const vD = /* @__PURE__ */ k(fD, [["render", yD]]), gD = {}, _D = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wD = /* @__PURE__ */ u("path", {
  d: "M29.7826 5.00049H10.2174C8.83492 5.00462 7.51026 5.55563 6.5327 6.53319C5.55514 7.51075 5.00413 8.83541 5 10.2179V29.7831C5.00379 31.1657 5.55469 32.4905 6.53232 33.4682C7.50995 34.4458 8.83482 34.9967 10.2174 35.0005H29.7826C31.1652 34.9967 32.49 34.4458 33.4677 33.4682C34.4453 32.4905 34.9962 31.1657 35 29.7831V10.2179C34.9959 8.83541 34.4449 7.51075 33.4673 6.53319C32.4897 5.55563 31.1651 5.00462 29.7826 5.00049ZM28.4783 19.3483C28.4783 20.0402 28.2034 20.7037 27.7142 21.1929C27.225 21.6822 26.5614 21.957 25.8696 21.957H18.3696C18.2831 21.957 18.2001 21.9914 18.139 22.0525C18.0778 22.1137 18.0435 22.1966 18.0435 22.2831V24.5657C18.0435 24.8237 17.9671 25.0758 17.8239 25.2904C17.6806 25.5049 17.477 25.6721 17.2387 25.7709C17.0003 25.8697 16.738 25.8955 16.4849 25.8451C16.2318 25.7947 15.9994 25.6704 15.817 25.4879L11.9039 21.5748C11.6594 21.3302 11.522 20.9985 11.522 20.6527C11.522 20.3068 11.6594 19.9751 11.9039 19.7305L15.817 15.8174C15.9994 15.6351 16.2318 15.5109 16.4847 15.4606C16.7377 15.4103 16.9999 15.4361 17.2382 15.5348C17.4765 15.6335 17.6802 15.8007 17.8236 16.0151C17.9669 16.2296 18.0434 16.4817 18.0435 16.7396V19.0222C18.0433 19.0651 18.0516 19.1076 18.0679 19.1472C18.0843 19.1869 18.1083 19.2229 18.1386 19.2532C18.1689 19.2835 18.2049 19.3075 18.2446 19.3238C18.2842 19.3402 18.3267 19.3485 18.3696 19.3483H25.5435C25.5863 19.3485 25.6288 19.3402 25.6685 19.3238C25.7081 19.3075 25.7441 19.2835 25.7744 19.2532C25.8048 19.2229 25.8288 19.1869 25.8451 19.1472C25.8614 19.1076 25.8697 19.0651 25.8696 19.0222V15.4353C25.8696 15.0893 26.007 14.7576 26.2516 14.513C26.4962 14.2683 26.828 14.1309 27.1739 14.1309C27.5198 14.1309 27.8516 14.2683 28.0962 14.513C28.3408 14.7576 28.4783 15.0893 28.4783 15.4353V19.3483Z",
  fill: "#3B414D"
}, null, -1), CD = [
  wD
];
function kD(e, i) {
  return f(), p("svg", _D, CD);
}
const xD = /* @__PURE__ */ k(gD, [["render", kD]]), bD = {}, MD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DD = /* @__PURE__ */ u("path", {
  d: "M7.15925 22.8122C6.58177 22.811 6.03929 22.586 5.63181 22.1773C5.22558 21.7685 5.00184 21.2261 5.00309 20.6486V7.1629C5.00184 6.58792 5.22558 6.04419 5.63306 5.63671C6.04054 5.22798 6.58177 5.00174 7.15925 5.00049L16.9126 5.01674C18.1013 5.02174 19.0675 5.99295 19.065 7.1804V20.6486C19.0675 21.8373 18.1013 22.8085 16.9113 22.8122H16.9101H7.15925ZM7.1605 6.87541C7.08425 6.87541 7.0155 6.90416 6.96176 6.95916C6.90676 7.01415 6.87801 7.08415 6.87801 7.1604V20.6498C6.87801 20.7286 6.90676 20.7998 6.96051 20.8536C7.0155 20.9086 7.08425 20.9373 7.1605 20.9373H16.9088C17.0638 20.9373 17.1901 20.8086 17.1901 20.6511V7.17915C17.1901 7.0204 17.0626 6.89291 16.9063 6.89166L7.1605 6.87541Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), AD = /* @__PURE__ */ u("path", {
  d: "M23.0911 15.3126C22.5136 15.3126 21.9798 15.0926 21.5749 14.6951C21.1661 14.2926 20.9386 13.7551 20.9349 13.1814V7.15665C20.9424 5.97545 21.9049 5.01674 23.0811 5.01674L32.8356 5.00049C34.0231 5.00049 34.9868 5.9567 34.9968 7.1329V13.1726C34.9881 14.3551 34.0243 15.3126 32.8481 15.3126H23.0911ZM23.0848 6.89166C22.9336 6.89166 22.8111 7.0129 22.8098 7.16165V13.1726C22.8098 13.2401 22.8386 13.3076 22.8911 13.3589C22.9561 13.4226 23.0348 13.4364 23.0898 13.4376H32.8406C32.9969 13.4376 33.1206 13.3164 33.1219 13.1664V7.1404C33.1206 6.99666 32.9969 6.87541 32.8469 6.87541C32.8469 6.87541 23.0861 6.89166 23.0848 6.89166Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), LD = /* @__PURE__ */ u("path", {
  d: "M7.15549 34.983C5.97179 34.983 5.00933 34.0242 5.00308 32.8455V26.8295C5.00933 25.6471 5.97304 24.6871 7.15174 24.6871H16.9088C18.0938 24.6871 19.0575 25.6458 19.065 26.8245V32.8555C19.0612 33.4355 18.835 33.9742 18.4263 34.3792C18.0213 34.7792 17.4838 34.9992 16.9151 34.9992L7.15549 34.983ZM7.13549 26.5621C6.99675 26.5621 6.87925 26.6871 6.878 26.8345V32.8405C6.87925 32.9868 7.00175 33.108 7.15174 33.108L16.9101 33.1243C16.9888 33.1243 17.0413 33.1105 17.1076 33.0443C17.1613 32.9918 17.1901 32.9243 17.1901 32.8505V26.8295C17.1888 26.6833 17.0663 26.5621 16.9151 26.5621H7.13549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), TD = /* @__PURE__ */ u("path", {
  d: "M23.0911 34.9993C22.5136 34.998 21.9711 34.7718 21.5636 34.363C21.1574 33.9543 20.9336 33.4118 20.9349 32.8343V19.3512C20.9336 18.7774 21.1561 18.235 21.5636 17.825C21.9711 17.415 22.5123 17.1887 23.0886 17.1875H32.8406C33.4194 17.1887 33.9618 17.415 34.3693 17.825C34.7768 18.2337 34.9993 18.7774 34.9968 19.3549V32.8206C34.9993 34.0068 34.0343 34.978 32.8469 34.9843L23.0948 35.0005C23.0936 34.9993 23.0911 34.9993 23.0911 34.9993ZM23.0923 19.0624C22.9361 19.0637 22.8098 19.1912 22.8098 19.3487V32.8356C22.8098 32.9156 22.8386 32.9856 22.8923 33.0406C22.9473 33.0956 23.0161 33.1243 23.0936 33.1243L32.8394 33.1081C32.9944 33.1068 33.1219 32.9781 33.1219 32.8206V19.3512C33.1219 19.2712 33.0931 19.2012 33.0394 19.1462C32.9856 19.0912 32.9156 19.0624 32.8381 19.0624H23.0923Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), SD = [
  DD,
  AD,
  LD,
  TD
];
function ND(e, i) {
  return f(), p("svg", MD, SD);
}
const ED = /* @__PURE__ */ k(bD, [["render", ND]]), zD = {}, ID = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BD = /* @__PURE__ */ u("path", {
  d: "M5.39169 5.38241C5.14722 5.62681 5.00984 5.9583 5.00977 6.30399V20.662C5.00977 21.0077 5.1471 21.3393 5.39155 21.5837C5.636 21.8282 5.96755 21.9655 6.31326 21.9655H16.7412C17.0869 21.9655 17.4185 21.8282 17.6629 21.5837C17.9074 21.3393 18.0447 21.0077 18.0447 20.662V6.32354C18.0447 5.97783 17.9074 5.64628 17.6629 5.40183C17.4185 5.15737 17.0869 5.02004 16.7412 5.02004L6.31326 5.00049C5.96758 5.00056 5.63609 5.13794 5.39169 5.38241Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), OD = /* @__PURE__ */ u("path", {
  d: "M33.6866 5.00049L23.2587 5.01874C22.913 5.01874 22.5814 5.15607 22.337 5.40052C22.0925 5.64498 21.9552 5.97653 21.9552 6.32223V12.8397C21.9552 13.1854 22.0925 13.517 22.337 13.7614C22.5814 14.0059 22.913 14.1432 23.2587 14.1432H33.6866C34.0323 14.1432 34.3639 14.0059 34.6084 13.7614C34.8528 13.517 34.9901 13.1854 34.9901 12.8397V6.30399C34.9901 5.95828 34.8528 5.62673 34.6084 5.38227C34.3639 5.13782 34.0323 5.00049 33.6866 5.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), HD = /* @__PURE__ */ u("path", {
  d: "M17.6628 34.6171C17.9073 34.3727 18.0447 34.0412 18.0447 33.6955V27.178C18.0447 26.8323 17.9074 26.5007 17.6629 26.2563C17.4185 26.0118 17.0869 25.8745 16.7412 25.8745H6.31326C5.96755 25.8745 5.636 26.0118 5.39155 26.2563C5.1471 26.5007 5.00977 26.8323 5.00977 27.178V33.6759C5.00977 34.0217 5.1471 34.3532 5.39155 34.5977C5.636 34.8421 5.96755 34.9794 6.31326 34.9794L16.7412 34.9977C17.0867 34.998 17.4182 34.8611 17.6628 34.6171Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jD = /* @__PURE__ */ u("path", {
  d: "M33.6866 18.0551H23.2587C22.913 18.0551 22.5814 18.1924 22.337 18.4368C22.0925 18.6813 21.9552 19.0128 21.9552 19.3586V33.697C21.9552 34.0427 22.0925 34.3743 22.337 34.6187C22.5814 34.8632 22.913 35.0005 23.2587 35.0005L33.6866 34.9823C34.0323 34.9823 34.3639 34.8449 34.6084 34.6005C34.8528 34.356 34.9901 34.0245 34.9901 33.6788V19.3586C34.9901 19.0128 34.8528 18.6813 34.6084 18.4368C34.3639 18.1924 34.0323 18.0551 33.6866 18.0551Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), VD = [
  BD,
  OD,
  HD,
  jD
];
function FD(e, i) {
  return f(), p("svg", ID, VD);
}
const PD = /* @__PURE__ */ k(zD, [["render", FD]]), UD = {}, RD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YD = /* @__PURE__ */ Ke('<g clip-path="url(#clip0)"><path d="M14.4923 14.2916C14.3444 14.2912 14.1986 14.2561 14.0668 14.189C13.935 14.1219 13.8209 14.0247 13.7336 13.9053L11.5286 10.8716C11.4279 10.7315 11.3676 10.5665 11.3545 10.3945C11.3413 10.2225 11.3757 10.0502 11.454 9.89652C11.5322 9.74279 11.6512 9.61355 11.7979 9.52294C11.9447 9.43234 12.1136 9.38386 12.2861 9.38281C12.434 9.38274 12.5799 9.4177 12.7118 9.48484C12.8437 9.55197 12.9578 9.64937 13.0448 9.76906L15.2498 12.8028C15.351 12.9427 15.4116 13.1079 15.425 13.28C15.4384 13.4521 15.404 13.6246 15.3257 13.7785C15.2474 13.9324 15.1282 14.0617 14.9812 14.1522C14.8341 14.2428 14.665 14.291 14.4923 14.2916Z" fill="#3B414D" class="primary"></path><path d="M11.086 18.9791C10.9879 18.9793 10.8904 18.9637 10.7973 18.9329L7.23104 17.7741C6.99487 17.6968 6.79891 17.5292 6.68601 17.3078C6.5731 17.0865 6.55244 16.8294 6.62854 16.5929C6.66623 16.4757 6.72671 16.3671 6.80651 16.2734C6.88631 16.1797 6.98384 16.1027 7.0935 16.0468C7.20317 15.991 7.32279 15.9573 7.44551 15.9478C7.56822 15.9384 7.69159 15.9532 7.80854 15.9916L11.3748 17.1504C11.5096 17.1512 11.6426 17.1812 11.7648 17.2382C11.8869 17.2952 11.9953 17.3779 12.0825 17.4806C12.1698 17.5834 12.2338 17.7038 12.2702 17.8336C12.3067 17.9633 12.3147 18.0995 12.2936 18.2326C12.2726 18.3658 12.2231 18.4928 12.1484 18.605C12.0738 18.7173 11.9758 18.8121 11.8611 18.883C11.7465 18.9538 11.6179 18.9991 11.4841 19.0157C11.3503 19.0323 11.2145 19.0198 11.086 18.9791Z" fill="#3B414D" class="primary"></path><path d="M7.51851 25.9315C7.35778 25.9322 7.19958 25.8915 7.05918 25.8132C6.91879 25.7349 6.80094 25.6218 6.717 25.4847C6.63307 25.3477 6.5859 25.1913 6.58003 25.0306C6.57416 24.87 6.6098 24.7106 6.68351 24.5677C6.73911 24.4577 6.81603 24.3598 6.90981 24.2798C7.00359 24.1997 7.11235 24.1391 7.22976 24.1015L10.796 22.9427C11.0325 22.866 11.2899 22.8864 11.5114 22.9993C11.7329 23.1123 11.9005 23.3087 11.9773 23.5452C12.054 23.7818 12.0336 24.0391 11.9207 24.2607C11.8077 24.4822 11.6113 24.6497 11.3748 24.7265L7.80851 25.8852C7.71497 25.9162 7.61704 25.9318 7.51851 25.9315Z" fill="#3B414D" class="primary"></path><path d="M12.286 32.4939C12.0878 32.4943 11.8946 32.4312 11.7348 32.3139C11.6352 32.2418 11.5508 32.1507 11.4867 32.0458C11.4225 31.9408 11.3798 31.8242 11.361 31.7027C11.3415 31.5811 11.3462 31.4569 11.3749 31.3372C11.4037 31.2174 11.4559 31.1046 11.5285 31.0052L13.7335 27.9714C13.8059 27.8718 13.8972 27.7874 14.0022 27.723C14.1073 27.6587 14.2239 27.6157 14.3456 27.5964C14.4672 27.5771 14.5914 27.582 14.7112 27.6107C14.831 27.6395 14.9439 27.6916 15.0435 27.7639C15.1432 27.8363 15.2276 27.9276 15.2919 28.0327C15.3563 28.1377 15.3993 28.2543 15.4186 28.376C15.4379 28.4976 15.433 28.6219 15.4042 28.7416C15.3755 28.8614 15.3234 28.9743 15.251 29.0739L13.0448 32.1077C12.9576 32.2272 12.8435 32.3245 12.7116 32.3916C12.5798 32.4588 12.434 32.4938 12.286 32.4939Z" fill="#3B414D" class="primary"></path><path d="M20.001 35.0002C19.7524 35.0002 19.5139 34.9015 19.3381 34.7257C19.1623 34.5498 19.0635 34.3114 19.0635 34.0627V30.3127C19.0635 30.0641 19.1623 29.8256 19.3381 29.6498C19.5139 29.474 19.7524 29.3752 20.001 29.3752C20.2497 29.3752 20.4881 29.474 20.664 29.6498C20.8398 29.8256 20.9385 30.0641 20.9385 30.3127V34.0627C20.9385 34.3114 20.8398 34.5498 20.664 34.7257C20.4881 34.9015 20.2497 35.0002 20.001 35.0002Z" fill="#3B414D" class="primary"></path><path d="M27.7172 32.4941C27.5692 32.4941 27.4233 32.4592 27.2915 32.3921C27.1596 32.3249 27.0455 32.2275 26.9585 32.1078L24.7535 29.0741C24.6527 28.934 24.5925 28.7688 24.5794 28.5967C24.5663 28.4246 24.6008 28.2522 24.6792 28.0985C24.7575 27.9447 24.8767 27.8155 25.0237 27.725C25.1706 27.6345 25.3396 27.5861 25.5122 27.5853C25.8122 27.5853 26.0947 27.7303 26.271 27.9716L28.476 31.0053C28.5767 31.1454 28.637 31.3106 28.6501 31.4827C28.6632 31.6548 28.6286 31.8272 28.5503 31.9809C28.4719 32.1347 28.3527 32.2639 28.2058 32.3544C28.0588 32.4449 27.8898 32.4933 27.7172 32.4941Z" fill="#3B414D" class="primary"></path><path d="M32.4835 25.9315C32.3855 25.9315 32.2881 25.9163 32.1947 25.8865L28.6272 24.7277C28.3907 24.651 28.1943 24.4834 28.0813 24.2619C27.9683 24.0403 27.948 23.783 28.0247 23.5465C28.1015 23.3099 28.269 23.1136 28.4906 23.0006C28.7121 22.8876 28.9694 22.8672 29.206 22.944L32.7735 24.1027C32.9855 24.1719 33.1659 24.3144 33.2823 24.5047C33.3987 24.695 33.4435 24.9205 33.4086 25.1408C33.3736 25.3611 33.2613 25.5617 33.0917 25.7066C32.9222 25.8516 32.7065 25.9313 32.4835 25.9315Z" fill="#3B414D" class="primary"></path><path d="M28.9173 18.9789C28.6942 18.9787 28.4785 18.899 28.309 18.7541C28.1394 18.6092 28.0271 18.4085 27.9922 18.1882C27.9572 17.9679 28.002 17.7424 28.1184 17.5521C28.2348 17.3619 28.4152 17.2193 28.6273 17.1502L32.1935 15.9914C32.3105 15.953 32.434 15.9381 32.5568 15.9476C32.6796 15.9571 32.7993 15.9907 32.9091 16.0466C33.0189 16.1024 33.1165 16.1794 33.1964 16.2731C33.2763 16.3669 33.3369 16.4754 33.3748 16.5927C33.4516 16.829 33.4314 17.0862 33.3187 17.3078C33.2059 17.5293 33.0098 17.6969 32.7735 17.7739L29.2073 18.9327C29.1137 18.9634 29.0158 18.979 28.9173 18.9789Z" fill="#3B414D" class="primary"></path><path d="M25.511 14.2916C25.3383 14.291 25.1692 14.2428 25.0221 14.1522C24.8751 14.0617 24.7559 13.9324 24.6776 13.7785C24.5993 13.6246 24.5649 13.4521 24.5783 13.28C24.5917 13.1079 24.6523 12.9427 24.7535 12.8028L26.9585 9.76907C27.1051 9.56831 27.3252 9.43377 27.5707 9.39488C27.8162 9.35599 28.0671 9.41593 28.2685 9.56157C28.4695 9.70792 28.6043 9.92805 28.6432 10.1736C28.6821 10.4193 28.622 10.6703 28.476 10.8716L26.2697 13.9053C26.1827 14.025 26.0686 14.1224 25.9367 14.1895C25.8049 14.2567 25.659 14.2916 25.511 14.2916Z" fill="#3B414D" class="primary"></path><path d="M20.001 14.3752C19.7524 14.3752 19.5139 14.2765 19.3381 14.1007C19.1623 13.9248 19.0635 13.6864 19.0635 13.4377V5.93774C19.0635 5.6891 19.1623 5.45065 19.3381 5.27483C19.5139 5.09902 19.7524 5.00024 20.001 5.00024C20.2497 5.00024 20.4881 5.09902 20.664 5.27483C20.8398 5.45065 20.9385 5.6891 20.9385 5.93774V13.4377C20.9385 13.6864 20.8398 13.9248 20.664 14.1007C20.4881 14.2765 20.2497 14.3752 20.001 14.3752Z" fill="#3B414D" class="primary"></path></g><defs><clipPath id="clip0"><rect width="40" height="40" fill="white" transform="translate(0 0.000488281)"></rect></clipPath></defs>', 2), ZD = [
  YD
];
function WD(e, i) {
  return f(), p("svg", RD, ZD);
}
const QD = /* @__PURE__ */ k(UD, [["render", WD]]), qD = {}, GD = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XD = /* @__PURE__ */ u("path", {
  d: "M11.5625 35.0005C10.8168 34.9998 10.1018 34.7033 9.57449 34.176C9.04719 33.6487 8.75066 32.9337 8.75 32.188V19.063C8.75066 18.3173 9.04719 17.6023 9.57449 17.075C10.1018 16.5477 10.8168 16.2512 11.5625 16.2505H12.5V12.5005C12.5 8.36549 15.865 5.00049 20 5.00049C24.135 5.00049 27.5 8.36549 27.5 12.5005V16.2505H28.4375C29.1832 16.2512 29.8982 16.5477 30.4255 17.075C30.9528 17.6023 31.2493 18.3173 31.25 19.063V32.188C31.2493 32.9337 30.9528 33.6487 30.4255 34.176C29.8982 34.7033 29.1832 34.9998 28.4375 35.0005H11.5625ZM11.5625 18.1255C11.3139 18.1255 11.0754 18.2243 10.8996 18.4001C10.7238 18.5759 10.625 18.8143 10.625 19.063V32.188C10.625 32.7055 11.045 33.1255 11.5625 33.1255H28.4375C28.6861 33.1255 28.9246 33.0267 29.1004 32.8509C29.2762 32.6751 29.375 32.4366 29.375 32.188V19.063C29.375 18.8143 29.2762 18.5759 29.1004 18.4001C28.9246 18.2243 28.6861 18.1255 28.4375 18.1255H11.5625ZM25.625 16.2505V12.5005C25.625 9.39924 23.1012 6.87549 20 6.87549C18.5087 6.87714 17.0789 7.47031 16.0244 8.52484C14.9698 9.57937 14.3767 11.0092 14.375 12.5005V16.2505H25.625Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), JD = /* @__PURE__ */ u("path", {
  d: "M20 26.5629C19.225 26.5629 18.5938 25.9317 18.5938 25.1567C18.5947 24.8786 18.6779 24.607 18.8329 24.3761C18.9879 24.1453 19.2078 23.9654 19.4649 23.8593C19.7219 23.7532 20.0046 23.7255 20.2773 23.7798C20.5501 23.834 20.8006 23.9678 20.9975 24.1642C21.1931 24.3614 21.326 24.612 21.3795 24.8846C21.4329 25.1571 21.4045 25.4394 21.2979 25.6959C21.1912 25.9523 21.0111 26.1715 20.7801 26.3258C20.5492 26.4801 20.2777 26.5626 20 26.5629Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), KD = [
  XD,
  JD
];
function $D(e, i) {
  return f(), p("svg", GD, KD);
}
const eA = /* @__PURE__ */ k(qD, [["render", $D]]), nA = {}, iA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tA = /* @__PURE__ */ u("path", {
  d: "M29.375 16.8755H28.4375V13.438C28.4375 11.2002 27.5486 9.05411 25.9662 7.47177C24.3839 5.88944 22.2378 5.00049 20 5.00049C17.7622 5.00049 15.6161 5.88944 14.0338 7.47177C12.4514 9.05411 11.5625 11.2002 11.5625 13.438V16.8755H10.625C9.96196 16.8755 9.32607 17.1389 8.85723 17.6077C8.38839 18.0766 8.125 18.7124 8.125 19.3755V32.5005C8.125 33.1635 8.38839 33.7994 8.85723 34.2683C9.32607 34.7371 9.96196 35.0005 10.625 35.0005H29.375C30.038 35.0005 30.6739 34.7371 31.1428 34.2683C31.6116 33.7994 31.875 33.1635 31.875 32.5005V19.3755C31.875 18.7124 31.6116 18.0766 31.1428 17.6077C30.6739 17.1389 30.038 16.8755 29.375 16.8755ZM20 28.1255C19.5055 28.1255 19.0222 27.9789 18.6111 27.7042C18.2 27.4295 17.8795 27.039 17.6903 26.5822C17.5011 26.1254 17.4516 25.6227 17.548 25.1378C17.6445 24.6528 17.8826 24.2074 18.2322 23.8577C18.5819 23.5081 19.0273 23.27 19.5123 23.1735C19.9972 23.0771 20.4999 23.1266 20.9567 23.3158C21.4135 23.505 21.804 23.8254 22.0787 24.2366C22.3534 24.6477 22.5 25.131 22.5 25.6255C22.5 26.2885 22.2366 26.9244 21.7678 27.3933C21.2989 27.8621 20.663 28.1255 20 28.1255ZM25.3125 16.2505C25.3125 16.4162 25.2467 16.5752 25.1294 16.6924C25.0122 16.8096 24.8533 16.8755 24.6875 16.8755H15.3125C15.1467 16.8755 14.9878 16.8096 14.8706 16.6924C14.7533 16.5752 14.6875 16.4162 14.6875 16.2505V13.438C14.6875 12.029 15.2472 10.6778 16.2435 9.68148C17.2398 8.6852 18.591 8.12549 20 8.12549C21.409 8.12549 22.7602 8.6852 23.7565 9.68148C24.7528 10.6778 25.3125 12.029 25.3125 13.438V16.2505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), aA = [
  tA
];
function sA(e, i) {
  return f(), p("svg", iA, aA);
}
const oA = /* @__PURE__ */ k(nA, [["render", sA]]), rA = {}, lA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dA = /* @__PURE__ */ u("path", {
  d: "M15.3125 35.0005C13.7612 35.0005 12.5 33.7392 12.5 32.188V19.063C12.5 17.5117 13.7612 16.2505 15.3125 16.2505H18.125V12.5005C18.125 9.39924 15.6012 6.87549 12.5 6.87549C9.39875 6.87549 6.875 9.39924 6.875 12.5005V17.188C6.875 17.7055 6.455 18.1255 5.9375 18.1255C5.42 18.1255 5 17.7055 5 17.188V12.5005C5 8.36549 8.365 5.00049 12.5 5.00049C16.635 5.00049 20 8.36549 20 12.5005V16.2505H32.1875C33.7388 16.2505 35 17.5117 35 19.063V32.188C35 33.7392 33.7388 35.0005 32.1875 35.0005H15.3125ZM15.3125 18.1255C14.795 18.1255 14.375 18.5455 14.375 19.063V32.188C14.375 32.7055 14.795 33.1255 15.3125 33.1255H32.1875C32.705 33.1255 33.125 32.7055 33.125 32.188V19.063C33.125 18.5455 32.705 18.1255 32.1875 18.1255H15.3125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cA = /* @__PURE__ */ u("path", {
  d: "M23.75 26.563C22.975 26.563 22.3438 25.9317 22.3438 25.1567C22.3438 24.3817 22.975 23.7505 23.75 23.7505C24.13 23.7517 24.4825 23.898 24.7475 24.1642C25.0125 24.4305 25.1575 24.783 25.1562 25.1592C25.1562 25.933 24.525 26.563 23.75 26.563Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), fA = [
  dA,
  cA
];
function uA(e, i) {
  return f(), p("svg", lA, fA);
}
const hA = /* @__PURE__ */ k(rA, [["render", uA]]), mA = {}, pA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yA = /* @__PURE__ */ u("path", {
  d: "M29.3764 25.6303C29.1264 25.6303 28.8902 25.5328 28.7139 25.3553C28.3489 24.9903 28.3489 24.3953 28.7139 24.0291L31.8013 20.9418H14.3772C13.8597 20.9418 13.4398 20.5218 13.4398 20.0043C13.4398 19.4869 13.8597 19.0669 14.3772 19.0669H31.8L28.7127 15.9796C28.5352 15.8033 28.4377 15.5671 28.4377 15.3171C28.4377 15.0671 28.5352 14.8309 28.7127 14.6546C28.8902 14.4784 29.1251 14.3796 29.3751 14.3796C29.6251 14.3796 29.8614 14.4771 30.0376 14.6546L34.7248 19.3419C34.7686 19.3856 34.8073 19.4331 34.8423 19.4844C34.8511 19.4969 34.8611 19.5156 34.8698 19.5319C34.8911 19.5669 34.9098 19.6031 34.9261 19.6406C34.9348 19.6606 34.9461 19.6968 34.9523 19.7168C34.9623 19.7418 34.9736 19.7806 34.9811 19.8218C34.9923 19.8756 34.9998 19.9393 34.9998 20.0043C34.9998 20.0668 34.9936 20.1293 34.9811 20.1893C34.9736 20.2268 34.9623 20.2631 34.9498 20.2993C34.9448 20.3193 34.9348 20.3468 34.9236 20.3718C34.9123 20.4006 34.8923 20.4381 34.8698 20.4756C34.8686 20.4793 34.8573 20.5018 34.8436 20.5218C34.8161 20.5618 34.7911 20.593 34.7636 20.623C34.7623 20.6268 34.7448 20.648 34.7248 20.6668L30.0376 25.354C29.8614 25.5328 29.6264 25.6303 29.3764 25.6303Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), vA = /* @__PURE__ */ u("path", {
  d: "M7.62025 34.0623C6.11034 33.9861 4.9354 32.7061 5.00415 31.2075L5.0029 8.75119C4.93415 7.28627 6.09784 6.01509 7.59775 5.94009L22.9844 5.93884C24.5193 6.01384 25.693 7.29502 25.6255 8.79369L25.6268 14.3759C25.6268 14.8934 25.2068 15.3133 24.6893 15.3133C24.1718 15.3133 23.7519 14.8934 23.7519 14.3759V8.75119C23.7744 8.24747 23.4081 7.83624 22.9369 7.81249L7.644 7.81374C7.21777 7.83624 6.85529 8.24622 6.87654 8.70869L6.87779 31.25C6.85529 31.7537 7.22152 32.1649 7.6915 32.1887L22.9844 32.1874C23.4106 32.1649 23.7744 31.7549 23.7531 31.2924L23.7519 25.6253C23.7519 25.1078 24.1718 24.6878 24.6893 24.6878C25.2068 24.6878 25.6268 25.1078 25.6268 25.6253V31.25C25.6943 32.7161 24.5293 33.9861 23.0307 34.061L7.644 34.0623C7.6365 34.0623 7.62775 34.0623 7.62025 34.0623Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), gA = [
  yA,
  vA
];
function _A(e, i) {
  return f(), p("svg", pA, gA);
}
const wA = /* @__PURE__ */ k(mA, [["render", _A]]), CA = {}, kA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xA = /* @__PURE__ */ u("path", {
  d: "M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z",
  fill: "#FDEACE"
}, null, -1), bA = /* @__PURE__ */ u("path", {
  d: "M23.1297 14.0801L16.6741 14.1023L16.8697 25.9209L23.3253 25.8987L23.1297 14.0801Z",
  fill: "#FF5F00"
}, null, -1), MA = /* @__PURE__ */ u("path", {
  d: "M17.099 20.0356C17.059 17.6318 18.1359 15.4959 19.8225 14.1105C18.5494 13.1114 16.9533 12.5107 15.2232 12.5166C11.1243 12.5306 7.864 15.9073 7.93313 20.067C8.00225 24.2266 11.3744 27.5806 15.4733 27.5666C17.2034 27.5607 18.7794 26.949 20.0191 25.9414C18.287 24.5886 17.1389 22.4394 17.099 20.0356Z",
  fill: "#EB001B"
}, null, -1), DA = /* @__PURE__ */ u("path", {
  d: "M32.0664 19.9344C32.1355 24.094 28.8753 27.4707 24.7764 27.4848C23.0462 27.4907 21.4501 26.8899 20.177 25.8909C21.8843 24.5054 22.9405 22.3696 22.9005 19.9658C22.8606 17.562 21.7129 15.4337 19.9804 14.06C21.2202 13.0523 22.7961 12.4407 24.5263 12.4348C28.6252 12.4207 31.9976 15.7956 32.0664 19.9344Z",
  fill: "#F79E1B"
}, null, -1), AA = [
  xA,
  bA,
  MA,
  DA
];
function LA(e, i) {
  return f(), p("svg", kA, AA);
}
const TA = /* @__PURE__ */ k(CA, [["render", LA]]), SA = {}, NA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EA = /* @__PURE__ */ u("path", {
  d: "M5.93732 34.9884C5.68627 34.9884 5.45146 34.891 5.27411 34.7136C4.99434 34.4338 4.92065 34.0067 5.09051 33.6495L8.72631 26.0144C7.5098 23.8886 6.87031 21.4781 6.87281 19.0251C6.8853 11.2988 13.1802 5.0127 20.9064 5.0127H20.9489C23.573 5.0127 26.1384 5.74585 28.3679 7.13098C31.5503 9.10937 33.7735 12.2144 34.6266 15.8739C35.4796 19.5334 34.8601 23.3004 32.8817 26.4828C30.9008 29.6702 27.7958 31.8946 24.1413 32.7477C23.0822 32.995 21.9993 33.1199 20.9239 33.1199C18.4959 33.1199 16.0991 32.4779 13.9758 31.2627L6.34199 34.8985C6.2146 34.9572 6.07596 34.9884 5.93732 34.9884ZM20.9064 6.88618C14.2119 6.88618 8.75753 12.333 8.74754 19.0276C8.74379 21.307 9.37953 23.5352 10.5836 25.4699C10.7534 25.7434 10.7722 26.0781 10.6335 26.3679L7.91821 32.072L13.6211 29.3555C13.746 29.2955 13.8846 29.2643 14.0233 29.2643C14.1981 29.2643 14.3692 29.313 14.5179 29.4067C16.455 30.6107 18.6695 31.2464 20.9239 31.2464C21.8569 31.2464 22.7949 31.1378 23.7129 30.9229C26.8803 30.1835 29.5707 28.2563 31.2893 25.4936C34.8351 19.7907 33.0803 12.2668 27.3774 8.72219C25.4453 7.52066 23.2221 6.88618 20.9476 6.88618C20.9414 6.88618 20.9064 6.88618 20.9064 6.88618Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), zA = [
  EA
];
function IA(e, i) {
  return f(), p("svg", NA, zA);
}
const BA = /* @__PURE__ */ k(SA, [["render", IA]]), OA = {}, HA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jA = /* @__PURE__ */ u("path", {
  d: "M20 6.09277C11.7291 6.09277 5 11.6363 5 18.4502C5.0255 20.0882 5.40948 21.7008 6.12494 23.1745C6.84041 24.6482 7.86999 25.9474 9.1413 26.9806L6.1413 32.9636C6.08053 33.0848 6.05901 33.2218 6.07972 33.3558C6.10044 33.4897 6.16237 33.6139 6.2569 33.711C6.35144 33.8081 6.47388 33.8734 6.60721 33.8977C6.74054 33.922 6.87814 33.9042 7.00087 33.8467L15.0213 30.1136C16.6399 30.5785 18.316 30.8126 20 30.8089C28.2709 30.8089 35 25.2654 35 18.4502C35 11.6349 28.2709 6.09277 20 6.09277Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), VA = [
  jA
];
function FA(e, i) {
  return f(), p("svg", HA, VA);
}
const PA = /* @__PURE__ */ k(OA, [["render", FA]]), UA = {}, RA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YA = /* @__PURE__ */ u("path", {
  d: "M5.93732 34.9884C5.68627 34.9884 5.45146 34.891 5.27411 34.7136C4.99434 34.4338 4.92065 34.0067 5.09051 33.6495L8.72631 26.0144C7.5098 23.8886 6.87031 21.4781 6.87281 19.0251C6.8853 11.2988 13.1802 5.0127 20.9064 5.0127H20.9489C23.573 5.0127 26.1384 5.74585 28.3679 7.13098C31.5503 9.10937 33.7735 12.2144 34.6266 15.8739C35.4796 19.5334 34.8601 23.3004 32.8817 26.4828C30.9008 29.6702 27.7958 31.8946 24.1413 32.7477C23.0822 32.995 21.9993 33.1199 20.9239 33.1199C18.4959 33.1199 16.0991 32.4779 13.9758 31.2627L6.34199 34.8985C6.2146 34.9572 6.07596 34.9884 5.93732 34.9884ZM20.9064 6.88618C14.2119 6.88618 8.75753 12.333 8.74754 19.0276C8.74379 21.307 9.37953 23.5352 10.5836 25.4699C10.7534 25.7434 10.7722 26.0781 10.6335 26.3679L7.91821 32.072L13.6211 29.3555C13.746 29.2955 13.8846 29.2643 14.0233 29.2643C14.1981 29.2643 14.3692 29.313 14.5179 29.4067C16.455 30.6107 18.6695 31.2464 20.9239 31.2464C21.8569 31.2464 22.7949 31.1378 23.7129 30.9229C26.8803 30.1835 29.5707 28.2563 31.2893 25.4936C34.8351 19.7907 33.0803 12.2668 27.3774 8.72219C25.4453 7.52066 23.2221 6.88618 20.9476 6.88618C20.9414 6.88618 20.9064 6.88618 20.9064 6.88618Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ZA = [
  YA
];
function WA(e, i) {
  return f(), p("svg", RA, ZA);
}
const QA = /* @__PURE__ */ k(UA, [["render", WA]]), qA = {}, GA = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XA = /* @__PURE__ */ u("path", {
  d: "M16.0258 21.0054C16.2907 19.6519 16.9951 18.4236 18.0295 17.5114C18.9299 16.7133 19.985 16.109 21.129 15.7363C22.2731 15.3636 23.4816 15.2303 24.6794 15.3449C24.7758 15.3534 24.8728 15.3384 24.9622 15.3014C25.0516 15.2643 25.1307 15.2062 25.1928 15.132C25.2557 15.0589 25.3008 14.9723 25.3247 14.8789C25.3486 14.7855 25.3506 14.6878 25.3306 14.5935C25.045 13.3516 24.4972 12.185 23.724 11.1721C22.9508 10.1591 21.9699 9.32312 20.8473 8.72015C19.3967 7.91361 17.7911 7.42502 16.1372 7.28683C14.4832 7.14864 12.8188 7.36402 11.2545 7.91866C9.15585 8.64211 7.36383 10.0545 6.17008 11.9261C5.62631 12.7892 5.26181 13.7528 5.09829 14.7597C4.93478 15.7666 4.9756 16.7962 5.21832 17.7869C5.74011 19.7902 6.96176 21.5405 8.6622 22.7211C8.38669 23.51 8.1237 24.299 7.87324 25.088C7.83685 25.2061 7.83625 25.3324 7.87153 25.4509C7.90681 25.5694 7.97638 25.6748 8.07147 25.7538C8.16656 25.8329 8.28292 25.882 8.40587 25.8949C8.52883 25.9079 8.65288 25.8842 8.76238 25.8268L10.8162 24.7373L11.7429 24.2364C13.0299 24.6212 14.3699 24.7987 15.7128 24.7624C15.8086 24.756 15.9016 24.7276 15.9847 24.6795C16.0678 24.6314 16.1387 24.5648 16.192 24.4849C16.2453 24.405 16.2794 24.314 16.2919 24.2187C16.3043 24.1235 16.2947 24.0267 16.2638 23.9358C15.953 22.9918 15.8714 21.9873 16.0258 21.0054ZM17.2782 12.9405C17.3143 12.7198 17.4088 12.5128 17.552 12.3411C17.6951 12.1693 17.8816 12.039 18.0922 11.9637C18.2858 11.8951 18.4933 11.8753 18.6964 11.9059C18.8995 11.9364 19.092 12.0165 19.2568 12.139C19.4305 12.2698 19.5671 12.4436 19.6532 12.6432C19.7393 12.8428 19.7719 13.0614 19.7479 13.2775C19.7239 13.4936 19.6441 13.6997 19.5162 13.8755C19.3884 14.0514 19.217 14.1909 19.0189 14.2804C18.8538 14.3557 18.6743 14.3941 18.4929 14.3932C18.2016 14.3952 17.9201 14.2879 17.7039 14.0926C17.5338 13.9584 17.404 13.7798 17.3289 13.5765C17.2537 13.3732 17.2362 13.1531 17.2782 12.9405ZM13.1205 13.4664C13.065 13.6643 12.9618 13.8454 12.8198 13.9939C12.6779 14.1424 12.5016 14.2537 12.3064 14.318C12.1739 14.3662 12.0342 14.3916 11.8932 14.3932C11.608 14.3944 11.3321 14.292 11.1167 14.1051C10.9485 13.966 10.8196 13.7854 10.7427 13.5811C10.6658 13.3768 10.6437 13.156 10.6784 12.9405C10.7024 12.77 10.7612 12.6063 10.8512 12.4596C10.9412 12.3129 11.0605 12.1863 11.2016 12.0878C11.3427 11.9892 11.5026 11.9208 11.6714 11.8869C11.8401 11.8529 12.014 11.8541 12.1823 11.8903C12.3505 11.9265 12.5095 11.9971 12.6493 12.0975C12.7891 12.1979 12.9067 12.3261 12.9947 12.474C13.0827 12.6219 13.1393 12.7864 13.161 12.9571C13.1826 13.1279 13.1688 13.3013 13.1205 13.4664Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), JA = /* @__PURE__ */ u("path", {
  d: "M34.4851 21.8319C33.7254 20.1941 32.4254 18.8676 30.8032 18.075C29.4179 17.3789 27.8891 17.0164 26.3387 17.0164C24.7884 17.0164 23.2595 17.3789 21.8742 18.075C20.8733 18.5595 19.9923 19.2602 19.295 20.1264C18.5977 20.9927 18.1013 22.0029 17.8417 23.0843C17.4759 24.7321 17.7679 26.4576 18.6557 27.8932C19.3105 28.9073 20.1701 29.7733 21.1795 30.4354C22.1888 31.0976 23.3256 31.5412 24.5166 31.7378C26.1263 32.0295 27.782 31.9394 29.3506 31.4748C29.7797 31.6777 30.1978 31.9035 30.6029 32.1511C30.966 32.3514 31.3292 32.5643 31.7049 32.7396C31.7957 32.7597 31.8897 32.7597 31.9804 32.7396C32.0776 32.7396 32.1735 32.717 32.2605 32.6735C32.3474 32.6301 32.423 32.5669 32.4814 32.4892C32.5397 32.4114 32.5791 32.3211 32.5965 32.2255C32.6139 32.1299 32.6088 32.0315 32.5815 31.9382C32.3895 31.3037 32.1891 30.6733 31.9804 30.0472C32.9277 29.3457 33.7029 28.4378 34.2471 27.3922C34.6977 26.5414 34.9529 25.6008 34.994 24.639C35.0352 23.6771 34.8613 22.7181 34.4851 21.8319ZM25.1428 22.5959C25.0873 22.7937 24.9841 22.9748 24.8421 23.1233C24.7002 23.2718 24.5239 23.3831 24.3288 23.4474C24.1962 23.4956 24.0565 23.521 23.9155 23.5226C23.6303 23.5238 23.3544 23.4214 23.139 23.2345C22.9708 23.0954 22.8419 22.9148 22.765 22.7105C22.6881 22.5062 22.666 22.2854 22.7007 22.0699C22.7247 21.8994 22.7835 21.7357 22.8735 21.589C22.9635 21.4423 23.0828 21.3157 23.2239 21.2172C23.365 21.1187 23.5249 21.0503 23.6937 21.0163C23.8624 20.9823 24.0363 20.9835 24.2046 21.0197C24.3728 21.0559 24.5318 21.1265 24.6716 21.2269C24.8114 21.3273 24.929 21.4555 25.017 21.6034C25.105 21.7513 25.1616 21.9158 25.1833 22.0865C25.2049 22.2573 25.1911 22.4307 25.1428 22.5959ZM30.415 22.5959C30.3596 22.7937 30.2564 22.9748 30.1144 23.1233C29.9724 23.2718 29.7961 23.3831 29.601 23.4474C29.4685 23.4956 29.3288 23.521 29.1878 23.5226C28.9026 23.5238 28.6267 23.4214 28.4113 23.2345C28.2431 23.0954 28.1141 22.9148 28.0373 22.7105C27.9604 22.5062 27.9382 22.2854 27.973 22.0699C27.9969 21.8994 28.0557 21.7357 28.1457 21.589C28.2358 21.4423 28.355 21.3157 28.4962 21.2172C28.6373 21.1187 28.7972 21.0503 28.9659 21.0163C29.1347 20.9823 29.3086 20.9835 29.4768 21.0197C29.6451 21.0559 29.8041 21.1265 29.9439 21.2269C30.0837 21.3273 30.2012 21.4555 30.2893 21.6034C30.3773 21.7513 30.4339 21.9158 30.4556 22.0865C30.4772 22.2573 30.4634 22.4307 30.415 22.5959Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), KA = [
  XA,
  JA
];
function $A(e, i) {
  return f(), p("svg", GA, KA);
}
const eL = /* @__PURE__ */ k(qA, [["render", $A]]), nL = {}, iL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tL = /* @__PURE__ */ Ke('<path d="M17.0504 14.2013C17.2758 14.4001 17.5651 14.5114 17.8656 14.5148C18.0431 14.514 18.2184 14.4756 18.3798 14.402C18.5887 14.3086 18.768 14.16 18.8984 13.9721C19.0289 13.7842 19.1054 13.5642 19.1198 13.3359C19.1564 13.0033 19.0594 12.6697 18.85 12.4086C18.6407 12.1475 18.3362 11.9803 18.0036 11.9437C17.6709 11.9071 17.3374 12.0042 17.0763 12.2135C16.8152 12.4229 16.648 12.7273 16.6114 13.06C16.5732 13.2722 16.594 13.4908 16.6714 13.692C16.7488 13.8932 16.8798 14.0694 17.0504 14.2013Z" fill="#3B414D" class="primary"></path><path d="M11.8706 14.2138C12.0963 14.4008 12.3803 14.5029 12.6733 14.5023C12.8096 14.5034 12.9452 14.4822 13.0747 14.4396C13.2678 14.3735 13.4418 14.2612 13.5817 14.1126C13.7216 13.964 13.8231 13.7835 13.8774 13.5867C13.9378 13.3644 13.9358 13.1298 13.8716 12.9086C13.8075 12.6873 13.6836 12.488 13.5137 12.3325C13.3474 12.1807 13.1433 12.0764 12.9228 12.0307C12.7023 11.9849 12.4736 11.9994 12.2606 12.0725C12.0477 12.1456 11.8583 12.2747 11.7125 12.4463C11.5666 12.6178 11.4696 12.8255 11.4317 13.0474C11.3968 13.2632 11.419 13.4844 11.496 13.689C11.573 13.8936 11.7022 14.0745 11.8706 14.2138Z" fill="#3B414D" class="primary"></path><path d="M8.45913 22.7674C8.22083 23.4698 7.98253 24.1596 7.76931 24.8619C7.71399 25.0391 7.71229 25.2286 7.76443 25.4067C7.81657 25.5848 7.92022 25.7435 8.06233 25.8628C8.20444 25.9821 8.37867 26.0567 8.56309 26.0773C8.74752 26.0978 8.93389 26.0633 9.09877 25.9782L11.118 24.8996L11.9082 24.4731C12.9023 24.7776 13.9301 24.9587 14.9685 25.0124C15.1042 25.0171 15.2393 24.9922 15.3645 24.9397C15.4897 24.8871 15.602 24.8081 15.6938 24.708C15.7856 24.6079 15.8546 24.4891 15.8961 24.3598C15.9376 24.2305 15.9506 24.0937 15.9342 23.9589C15.9288 22.9365 16.1267 21.9232 16.5164 20.978C16.9061 20.0328 17.4799 19.1744 18.2043 18.4529C18.9982 17.5588 19.9799 16.8512 21.0792 16.3807C22.1785 15.9102 23.3682 15.6885 24.5631 15.7313C24.7055 15.7413 24.8482 15.7168 24.9792 15.6601C25.1101 15.6033 25.2255 15.5159 25.3157 15.4052C25.4081 15.2956 25.4742 15.1663 25.509 15.0271C25.5438 14.888 25.5463 14.7428 25.5163 14.6025C25.2263 13.3407 24.67 12.1553 23.8849 11.1257C23.0997 10.0961 22.1037 9.24611 20.9636 8.63252C19.4993 7.81846 17.8784 7.32581 16.2089 7.1874C14.5393 7.04899 12.8594 7.268 11.2811 7.82983C9.17614 8.57515 7.38276 10.0063 6.18901 11.8935C5.6358 12.7752 5.26527 13.7591 5.09938 14.7868C4.93349 15.8144 4.97562 16.8649 5.22327 17.876C5.70931 19.8292 6.8517 21.5561 8.45913 22.7674ZM7.73169 12.8843C8.71653 11.347 10.1931 10.1887 11.9207 9.59826C13.0027 9.20791 14.1443 9.00845 15.2945 9.00878C16.9562 9.01366 18.5887 9.44554 20.0354 10.263C21.506 11.0551 22.6677 12.3184 23.334 13.85C20.8245 14.0872 18.4961 15.2603 16.8121 17.136C15.293 18.7503 14.3266 20.806 14.0529 23.0057C13.3928 22.919 12.7421 22.7721 12.1089 22.5667C11.9896 22.5282 11.8637 22.5139 11.7388 22.5246C11.6139 22.5354 11.4924 22.571 11.3814 22.6295L10.3028 23.2064L10.4784 22.7047C10.547 22.5082 10.5486 22.2945 10.4827 22.0971C10.4169 21.8996 10.2875 21.7296 10.1147 21.6135C8.59073 20.681 7.47529 19.2072 6.99171 17.4872C6.8007 16.7095 6.76777 15.9014 6.89488 15.1107C7.02199 14.32 7.30655 13.5629 7.73169 12.8843Z" fill="#3B414D" class="primary"></path><path d="M30.7088 17.8133C29.3067 17.1055 27.758 16.7368 26.1874 16.7368C24.6167 16.7368 23.0681 17.1055 21.666 17.8133C20.6493 18.3092 19.7539 19.0222 19.0431 19.9021C18.3323 20.782 17.8233 21.8072 17.5522 22.9054C17.1588 24.623 17.4609 26.4265 18.3925 27.9222C19.0567 28.9547 19.9301 29.8365 20.9562 30.5105C21.9824 31.1846 23.1385 31.6359 24.35 31.8353C25.9398 32.1257 27.5754 32.0441 29.1285 31.597C29.5047 31.7601 29.881 31.9733 30.2698 32.199C30.6586 32.4248 30.9972 32.6129 31.3735 32.7885C31.5354 32.8523 31.7118 32.87 31.8831 32.8396C32.0544 32.8091 32.2139 32.7317 32.3439 32.6161C32.4738 32.5004 32.5692 32.3509 32.6193 32.1843C32.6694 32.0177 32.6723 31.8405 32.6277 31.6723C32.4605 31.1204 32.2891 30.5728 32.1135 30.0293C32.9956 29.3554 33.7227 28.5 34.2456 27.5209C34.7097 26.6307 34.9666 25.6471 34.997 24.6437C35.0274 23.6403 34.8306 22.643 34.4212 21.7264C33.6722 20.0329 32.3606 18.6504 30.7088 17.8133ZM32.6152 26.5927C32.1144 27.5244 31.3905 28.3173 30.5081 28.9005C30.3424 29.0193 30.2197 29.1887 30.1587 29.3832C30.0976 29.5778 30.1014 29.7869 30.1695 29.9791L29.5298 29.7032C29.3349 29.6353 29.1227 29.6353 28.9278 29.7032C27.5636 30.1429 26.1124 30.2419 24.7011 29.9916C23.7424 29.8375 22.827 29.4831 22.0144 28.9515C21.2019 28.4199 20.5105 27.723 19.9853 26.9063C19.3212 25.8409 19.1006 24.5578 19.3708 23.3318C19.5822 22.5072 19.9713 21.7387 20.5107 21.0801C21.0501 20.4215 21.7269 19.8888 22.4937 19.519C23.6303 18.9486 24.8844 18.6516 26.156 18.6516C27.4277 18.6516 28.6817 18.9486 29.8183 19.519C31.0871 20.1327 32.1057 21.1647 32.703 22.4413C32.9944 23.095 33.1376 23.805 33.1224 24.5206C33.1073 25.2361 32.934 25.9395 32.6152 26.5802V26.5927Z" fill="#3B414D" class="primary"></path><path d="M28.564 20.9614C28.2907 20.984 28.0323 21.0956 27.8284 21.2791C27.6245 21.4626 27.4864 21.7078 27.4353 21.9773C27.4175 22.1564 27.4433 22.3371 27.5105 22.5041C27.567 22.728 27.6841 22.932 27.8491 23.0935C28.0816 23.3177 28.3916 23.4434 28.7145 23.4447H28.9403C29.1225 23.4171 29.2958 23.3471 29.4461 23.2403C29.5964 23.1336 29.7195 22.9931 29.8057 22.8302C29.9226 22.6271 29.9803 22.3954 29.9722 22.1613C29.9642 21.9272 29.8907 21.7 29.7602 21.5055C29.6296 21.311 29.4472 21.1569 29.2336 21.0607C29.02 20.9646 28.7837 20.9302 28.5515 20.9614H28.564Z" fill="#3B414D" class="primary"></path><path d="M23.7478 21.0365C23.5512 21.109 23.3758 21.2297 23.2378 21.3874C23.0997 21.5452 23.0034 21.735 22.9577 21.9396C22.9103 22.1399 22.913 22.3488 22.9655 22.5479C23.018 22.7469 23.1187 22.93 23.2587 23.0809C23.3753 23.2032 23.5154 23.3007 23.6705 23.3675C23.8257 23.4343 23.9928 23.4691 24.1617 23.4697H24.4377C24.6311 23.4264 24.8115 23.338 24.9641 23.2115C25.1167 23.0851 25.2371 22.9242 25.3156 22.7423C25.4199 22.5173 25.4551 22.2666 25.417 22.0216C25.3788 21.7767 25.2689 21.5486 25.1011 21.3661C24.9334 21.1835 24.7153 21.0548 24.4744 20.9962C24.2336 20.9375 23.9807 20.9516 23.7478 21.0365Z" fill="#3B414D" class="primary"></path>', 6), aL = [
  tL
];
function sL(e, i) {
  return f(), p("svg", iL, aL);
}
const oL = /* @__PURE__ */ k(nL, [["render", sL]]), rL = {}, lL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dL = /* @__PURE__ */ u("path", {
  d: "M22.825 28.3274H23.3625C24.3409 28.3676 25.3113 28.1352 26.1654 27.6563C27.0196 27.1773 27.7239 26.4706 28.2 25.6149C28.4538 25.2349 28.6045 24.7955 28.6374 24.3397C28.6703 23.8839 28.5841 23.4274 28.3875 23.0149V23.0149C28.1605 22.6981 27.8421 22.4582 27.475 22.3274L27.3 22.2399C27.3 22.2399 25.1375 21.1774 24.6875 20.9899C24.3566 20.8273 23.9775 20.7922 23.6224 20.8913C23.2674 20.9905 22.9612 21.2169 22.7625 21.5274C22.55 21.8399 22.325 22.1649 22.1625 22.3774C20.3461 21.5813 18.797 20.2796 17.7 18.6274L17.9875 18.3649C18.207 18.1813 18.3822 17.9506 18.5 17.6899C18.6225 17.4611 18.6867 17.2056 18.6867 16.9461C18.6867 16.6866 18.6225 16.4311 18.5 16.2024C18.425 16.0524 18.125 15.3024 17.825 14.6024L17.3875 13.5524C17.2502 13.2221 17.0293 12.9332 16.7466 12.714C16.4639 12.4949 16.1291 12.353 15.775 12.3024C15.3309 12.2051 14.8695 12.2205 14.4328 12.3471C13.9962 12.4737 13.5981 12.7076 13.275 13.0274C12.383 13.949 11.7873 15.1166 11.5645 16.3797C11.3417 17.6428 11.5021 18.9437 12.025 20.1149C12.9805 22.2877 14.4732 24.1816 16.3626 25.6183C18.252 27.055 20.4759 27.9873 22.825 28.3274V28.3274ZM14.675 14.3899C14.8356 14.2664 15.0351 14.2043 15.2375 14.2149V14.2149C15.3762 14.2089 15.514 14.239 15.6375 14.3024L16.075 15.3524C16.3375 15.9899 16.6125 16.6024 16.75 16.9524L16.25 17.4399C15.973 17.6597 15.7876 17.9746 15.7299 18.3234C15.6721 18.6722 15.7461 19.0301 15.9375 19.3274C17.2465 21.4795 19.1896 23.1737 21.5 24.1774C21.8028 24.365 22.1632 24.4367 22.5148 24.3793C22.8663 24.3218 23.1852 24.1391 23.4125 23.8649C23.6375 23.6024 23.975 23.1399 24.175 22.8399C24.5875 23.0149 25.75 23.5774 26.475 23.9399L26.675 24.0399H26.7875C26.7644 24.2615 26.6917 24.4751 26.575 24.6649C26.2273 25.2953 25.6943 25.8037 25.0482 26.1211C24.402 26.4386 23.674 26.5499 22.9625 26.4399C20.9839 26.1309 19.1131 25.3352 17.5182 24.1243C15.9233 22.9134 14.6542 21.3252 13.825 19.5024C13.4278 18.6654 13.2963 17.7268 13.4483 16.8128C13.6002 15.8989 14.0283 15.0534 14.675 14.3899V14.3899Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cL = /* @__PURE__ */ u("path", {
  d: "M5.96253 33.1399C5.89158 33.3072 5.87082 33.4916 5.90279 33.6706C5.93476 33.8496 6.01808 34.0154 6.14259 34.1478C6.26711 34.2803 6.42746 34.3737 6.6041 34.4167C6.78075 34.4597 6.96608 34.4503 7.13753 34.3899L12.125 32.6899C14.3864 34.085 16.9779 34.8544 19.6342 34.9193C22.2905 34.9843 24.9165 34.3424 27.2433 33.0595C29.5702 31.7765 31.5146 29.8985 32.8774 27.6175C34.2403 25.3365 34.9728 22.7344 35 20.0774C35 16.0991 33.4196 12.2838 30.6066 9.47079C27.7936 6.65774 23.9783 5.07739 20 5.07739C16.0218 5.07739 12.2065 6.65774 9.39342 9.47079C6.58038 12.2838 5.00003 16.0991 5.00003 20.0774C4.99391 23.0532 5.89188 25.9607 7.57503 28.4149L5.96253 33.1399ZM6.86253 20.0774C6.84024 17.4774 7.59071 14.9293 9.01874 12.7564C10.4468 10.5836 12.488 8.88381 14.8835 7.87278C17.279 6.86174 19.9208 6.58499 22.4738 7.07763C25.0268 7.57028 27.376 8.81011 29.2233 10.6399C31.0707 12.4696 32.3329 14.8068 32.8499 17.355C33.3669 19.9032 33.1155 22.5475 32.1274 24.9526C31.1393 27.3576 29.4591 29.415 27.3 30.8638C25.1409 32.3125 22.6001 33.0873 20 33.0899C17.4333 33.0951 14.9213 32.3476 12.775 30.9399C12.6585 30.8627 12.5262 30.8125 12.3878 30.793C12.2493 30.7736 12.1083 30.7853 11.975 30.8274L8.33753 31.9774L9.50003 28.5649C9.551 28.419 9.56512 28.2628 9.54113 28.1101C9.51714 27.9574 9.45578 27.8131 9.36253 27.6899C7.73837 25.4841 6.86235 22.8166 6.86253 20.0774V20.0774Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), fL = [
  dL,
  cL
];
function uL(e, i) {
  return f(), p("svg", lL, fL);
}
const hL = /* @__PURE__ */ k(rL, [["render", uL]]), mL = {}, pL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yL = /* @__PURE__ */ u("path", {
  d: "M18.125 26.563C15.54 26.563 13.4375 24.4605 13.4375 21.8755V9.68799C13.4375 7.10299 15.54 5.00049 18.125 5.00049H21.875C24.46 5.00049 26.5625 7.10299 26.5625 9.68799V21.8755C26.5625 24.4605 24.46 26.563 21.875 26.563H18.125ZM18.125 6.87549C16.5738 6.87549 15.3125 8.13674 15.3125 9.68799V21.8755C15.3125 23.4267 16.5738 24.688 18.125 24.688H21.875C23.4263 24.688 24.6875 23.4267 24.6875 21.8755V9.68799C24.6875 8.13674 23.4263 6.87549 21.875 6.87549H18.125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), vL = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C19.4825 35.0005 19.0625 34.5805 19.0625 34.063V30.2705C13.77 29.7942 9.6875 25.3667 9.6875 20.0005V17.188C9.6875 16.6705 10.1075 16.2505 10.625 16.2505C11.1425 16.2505 11.5625 16.6705 11.5625 17.188V20.0005C11.5625 24.653 15.3475 28.438 20 28.438C24.6525 28.438 28.4375 24.653 28.4375 20.0005V17.188C28.4375 16.6705 28.8575 16.2505 29.375 16.2505C29.8925 16.2505 30.3125 16.6705 30.3125 17.188V20.0005C30.3125 25.3667 26.23 29.7942 20.9375 30.2705V34.063C20.9375 34.5805 20.5175 35.0005 20 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), gL = [
  yL,
  vL
];
function _L(e, i) {
  return f(), p("svg", pL, gL);
}
const wL = /* @__PURE__ */ k(mL, [["render", _L]]), CL = {}, kL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xL = /* @__PURE__ */ u("path", {
  d: "M20 13.1255C22.2437 13.1255 24.0625 11.3066 24.0625 9.06299C24.0625 6.81933 22.2437 5.00049 20 5.00049C17.7563 5.00049 15.9375 6.81933 15.9375 9.06299C15.9375 11.3066 17.7563 13.1255 20 13.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), bL = /* @__PURE__ */ u("path", {
  d: "M20 24.063C22.2437 24.063 24.0625 22.2441 24.0625 20.0005C24.0625 17.7568 22.2437 15.938 20 15.938C17.7563 15.938 15.9375 17.7568 15.9375 20.0005C15.9375 22.2441 17.7563 24.063 20 24.063Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ML = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C22.2437 35.0005 24.0625 33.1816 24.0625 30.938C24.0625 28.6943 22.2437 26.8755 20 26.8755C17.7563 26.8755 15.9375 28.6943 15.9375 30.938C15.9375 33.1816 17.7563 35.0005 20 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), DL = [
  xL,
  bL,
  ML
];
function AL(e, i) {
  return f(), p("svg", kL, DL);
}
const LL = /* @__PURE__ */ k(CL, [["render", AL]]), TL = {}, SL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NL = /* @__PURE__ */ Ke('<path d="M8.75 35.0005C7.71625 35.0005 6.875 34.1592 6.875 33.1255V9.37549C6.875 8.34174 7.71625 7.50049 8.75 7.50049H11.875V5.62549C11.875 5.28049 12.155 5.00049 12.5 5.00049C12.845 5.00049 13.125 5.28049 13.125 5.62549V7.50049H16.875V5.62549C16.875 5.28049 17.155 5.00049 17.5 5.00049C17.845 5.00049 18.125 5.28049 18.125 5.62549V7.50049H21.875V5.62549C21.875 5.28049 22.155 5.00049 22.5 5.00049C22.845 5.00049 23.125 5.28049 23.125 5.62549V7.50049H26.875V5.62549C26.875 5.28049 27.155 5.00049 27.5 5.00049C27.845 5.00049 28.125 5.28049 28.125 5.62549V7.50049H31.25C32.2838 7.50049 33.125 8.34174 33.125 9.37549V33.1255C33.125 34.1592 32.2838 35.0005 31.25 35.0005H8.75ZM8.75 8.75049C8.405 8.75049 8.125 9.03049 8.125 9.37549V33.1255C8.125 33.4705 8.405 33.7505 8.75 33.7505H31.25C31.595 33.7505 31.875 33.4705 31.875 33.1255V9.37549C31.875 9.03049 31.595 8.75049 31.25 8.75049H28.125V10.6255C28.125 10.9705 27.845 11.2505 27.5 11.2505C27.155 11.2505 26.875 10.9705 26.875 10.6255V8.75049H23.125V10.6255C23.125 10.9705 22.845 11.2505 22.5 11.2505C22.155 11.2505 21.875 10.9705 21.875 10.6255V8.75049H18.125V10.6255C18.125 10.9705 17.845 11.2505 17.5 11.2505C17.155 11.2505 16.875 10.9705 16.875 10.6255V8.75049H13.125V10.6255C13.125 10.9705 12.845 11.2505 12.5 11.2505C12.155 11.2505 11.875 10.9705 11.875 10.6255V8.75049H8.75Z" fill="#3B414D" class="primary"></path><path d="M12.5 17.5005C12.155 17.5005 11.875 17.2205 11.875 16.8755C11.875 16.5305 12.155 16.2505 12.5 16.2505H27.5C27.845 16.2505 28.125 16.5305 28.125 16.8755C28.125 17.2205 27.845 17.5005 27.5 17.5005H12.5Z" fill="#3B414D" class="primary"></path><path d="M12.5 21.2505C12.155 21.2505 11.875 20.9705 11.875 20.6255C11.875 20.2805 12.155 20.0005 12.5 20.0005H27.5C27.845 20.0005 28.125 20.2805 28.125 20.6255C28.125 20.9705 27.845 21.2505 27.5 21.2505H12.5Z" fill="#3B414D" class="primary"></path><path d="M12.5 25.0005C12.155 25.0005 11.875 24.7205 11.875 24.3755C11.875 24.0305 12.155 23.7505 12.5 23.7505H27.5C27.845 23.7505 28.125 24.0305 28.125 24.3755C28.125 24.7205 27.845 25.0005 27.5 25.0005H12.5Z" fill="#3B414D" class="primary"></path><path d="M12.5 28.7505C12.155 28.7505 11.875 28.4705 11.875 28.1255C11.875 27.7805 12.155 27.5005 12.5 27.5005H21.25C21.595 27.5005 21.875 27.7805 21.875 28.1255C21.875 28.4705 21.595 28.7505 21.25 28.7505H12.5Z" fill="#3B414D" class="primary"></path>', 5), EL = [
  NL
];
function zL(e, i) {
  return f(), p("svg", SL, EL);
}
const IL = /* @__PURE__ */ k(TL, [["render", zL]]), BL = {}, OL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HL = /* @__PURE__ */ u("path", {
  d: "M7.81315 34.9992C6.26196 34.9992 5.00076 33.738 5.00076 32.1869V7.81287C5.00076 6.26169 6.26196 5.00049 7.81315 5.00049H21.0988C21.8513 5.00049 22.5575 5.29298 23.0888 5.82545L30.4272 13.1639C30.9584 13.6951 31.2509 14.4013 31.2509 15.1538V20.9386C31.2509 21.4561 30.8309 21.876 30.3135 21.876C29.796 21.876 29.376 21.4561 29.376 20.9386V16.2513H22.8138C21.2626 16.2513 20.0014 14.9901 20.0014 13.4389V6.87666H7.8144C7.29692 6.87666 6.87693 7.29664 6.87693 7.81412V32.1881C6.87693 32.7056 7.29692 33.1256 7.8144 33.1256H11.5642C12.0817 33.1256 12.5017 33.5456 12.5017 34.063C12.5017 34.5805 12.0817 35.0005 11.5642 35.0005H7.81315V34.9992ZM21.8751 13.4376C21.8751 13.9551 22.295 14.3751 22.8125 14.3751H28.986L21.8751 7.26414V13.4376V13.4376Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jL = /* @__PURE__ */ u("path", {
  d: "M15.3128 34.9993C14.7953 34.9993 14.3754 34.5793 14.3754 34.0618V24.6872C14.3754 24.1697 14.7953 23.7498 15.3128 23.7498H16.2553C18.3227 23.7498 20.0051 25.4322 20.0051 27.4996C20.0051 29.567 18.3227 31.2494 16.2553 31.2494H16.2503V34.0618C16.2503 34.5793 15.8303 34.9993 15.3128 34.9993ZM16.2553 29.3745C17.289 29.3745 18.1302 28.5333 18.1302 27.4996C18.1302 26.4659 17.289 25.6247 16.2553 25.6247H16.2503V29.3745H16.2553Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), VL = /* @__PURE__ */ u("path", {
  d: "M22.8124 34.9993C22.295 34.9993 21.875 34.5793 21.875 34.0618V24.6872C21.875 24.1697 22.295 23.7498 22.8124 23.7498C25.3973 23.7498 27.4997 25.8522 27.4997 28.4371V30.312C27.4997 32.8969 25.3973 34.9993 22.8124 34.9993ZM23.7499 32.9631C24.8486 32.5719 25.6248 31.5144 25.6248 30.312V28.4371C25.6248 27.2346 24.8486 26.1772 23.7499 25.7859V32.9631V32.9631Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), FL = /* @__PURE__ */ u("path", {
  d: "M30.3121 34.9993C29.7946 34.9993 29.3746 34.5793 29.3746 34.0618V26.5621C29.3746 25.011 30.6358 23.7498 32.187 23.7498H34.0619C34.5794 23.7498 34.9994 24.1697 34.9994 24.6872C34.9994 25.2047 34.5794 25.6247 34.0619 25.6247H32.187C31.6695 25.6247 31.2495 26.0447 31.2495 26.5621V29.3745H33.1244C33.6419 29.3745 34.0619 29.7945 34.0619 30.312C34.0619 30.8295 33.6419 31.2494 33.1244 31.2494H31.2495V34.0618C31.2495 34.5793 30.8295 34.9993 30.3121 34.9993Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), PL = [
  HL,
  jL,
  VL,
  FL
];
function UL(e, i) {
  return f(), p("svg", OL, PL);
}
const RL = /* @__PURE__ */ k(BL, [["render", UL]]), YL = {}, ZL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WL = /* @__PURE__ */ Ke('<path d="M11.5625 31.2505C10.0112 31.2505 8.75 29.9892 8.75 28.438V7.81299C8.75 6.26174 10.0112 5.00049 11.5625 5.00049H32.1875C33.7388 5.00049 35 6.26174 35 7.81299V28.438C35 29.9892 33.7388 31.2505 32.1875 31.2505H11.5625ZM11.5625 6.87549C11.045 6.87549 10.625 7.29549 10.625 7.81299V28.438C10.625 28.9555 11.045 29.3755 11.5625 29.3755H32.1875C32.705 29.3755 33.125 28.9555 33.125 28.438V7.81299C33.125 7.29549 32.705 6.87549 32.1875 6.87549H11.5625V6.87549Z" fill="#3B414D" class="primary"></path><path d="M7.8125 35.0005C6.26125 35.0005 5 33.7392 5 32.188V9.68799C5 9.17049 5.42 8.75049 5.9375 8.75049C6.455 8.75049 6.875 9.17174 6.875 9.68799V32.188C6.875 32.7055 7.295 33.1255 7.8125 33.1255H30.3125C30.83 33.1255 31.25 33.5455 31.25 34.063C31.25 34.5805 30.83 35.0005 30.3125 35.0005H7.8125Z" fill="#3B414D" class="primary"></path><path d="M15.3125 14.3755C14.795 14.3755 14.375 13.9555 14.375 13.438C14.375 12.9205 14.795 12.5005 15.3125 12.5005H28.4375C28.955 12.5005 29.375 12.9205 29.375 13.438C29.375 13.9555 28.955 14.3755 28.4375 14.3755H15.3125Z" fill="#3B414D" class="primary"></path><path d="M15.3125 18.1255C14.795 18.1255 14.375 17.7055 14.375 17.188C14.375 16.6705 14.795 16.2505 15.3125 16.2505H28.4375C28.955 16.2505 29.375 16.6705 29.375 17.188C29.375 17.7055 28.955 18.1255 28.4375 18.1255H15.3125Z" fill="#3B414D" class="primary"></path><path d="M15.3125 21.8755C14.795 21.8755 14.375 21.4555 14.375 20.938C14.375 20.4205 14.795 20.0005 15.3125 20.0005H24.6875C25.205 20.0005 25.625 20.4205 25.625 20.938C25.625 21.4555 25.205 21.8755 24.6875 21.8755H15.3125Z" fill="#3B414D" class="primary"></path>', 5), QL = [
  WL
];
function qL(e, i) {
  return f(), p("svg", ZL, QL);
}
const GL = /* @__PURE__ */ k(YL, [["render", qL]]), XL = {}, JL = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KL = /* @__PURE__ */ u("path", {
  d: "M16.6671 24.2717C16.4171 24.2717 16.1809 24.1742 16.0046 23.9967C15.7971 23.7892 15.6984 23.4917 15.7396 23.2017L16.4021 18.5605C16.4309 18.3605 16.5246 18.173 16.6671 18.0305L28.5996 6.09799C29.3071 5.39049 30.2484 5.00049 31.2509 5.00049C32.2534 5.00049 33.1959 5.39049 33.9021 6.09799C35.3646 7.56049 35.3646 9.93924 33.9021 11.4017L21.9696 23.3342C21.8271 23.4767 21.6396 23.5705 21.4409 23.5992L16.7996 24.263C16.7534 24.268 16.7096 24.2717 16.6671 24.2717ZM17.7721 22.2292L20.8659 21.7867L30.5884 12.0642L27.9359 9.41299L18.2134 19.1355L17.7721 22.2292ZM31.9134 10.738L32.5771 10.0742C33.3084 9.34299 33.3084 8.15424 32.5771 7.42299C32.2234 7.06924 31.7534 6.87549 31.2509 6.87549C30.7496 6.87549 30.2784 7.07049 29.9246 7.42424L29.2609 8.08799L31.9134 10.738Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), $L = /* @__PURE__ */ u("path", {
  d: "M7.81335 35.0005C6.2621 35.0005 5.00085 33.7392 5.00085 32.188V13.438C5.00085 11.8867 6.2621 10.6255 7.81335 10.6255H17.1884C17.7059 10.6255 18.1259 11.0455 18.1259 11.563C18.1259 12.0805 17.7059 12.5005 17.1884 12.5005H7.81335C7.29585 12.5005 6.87585 12.9205 6.87585 13.438V32.188C6.87585 32.7055 7.29585 33.1255 7.81335 33.1255H26.5634C27.0809 33.1255 27.5009 32.7055 27.5009 32.188V22.813C27.5009 22.2955 27.9209 21.8755 28.4384 21.8755C28.9559 21.8755 29.3759 22.2955 29.3759 22.813V32.188C29.3759 33.7392 28.1146 35.0005 26.5634 35.0005H7.81335Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), eT = [
  KL,
  $L
];
function nT(e, i) {
  return f(), p("svg", JL, eT);
}
const iT = /* @__PURE__ */ k(XL, [["render", nT]]), tT = {}, aT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sT = /* @__PURE__ */ u("path", {
  d: "M27.5382 35.0005C26.0476 35.0005 24.5871 34.5719 23.3126 33.7611C23.3089 33.7586 23.2802 33.7398 23.2764 33.7386C16.5383 29.1832 10.8134 23.457 6.26046 16.7176C4.25388 13.5641 4.68743 9.53716 7.30998 6.91461L8.27704 5.94755C8.88926 5.33658 9.70264 5.00049 10.5697 5.00049C11.4368 5.00049 12.2502 5.33658 12.8612 5.94755L16.9368 10.0282C18.1987 11.2926 18.1975 13.3479 16.9343 14.6098C16.4021 15.1433 16.4021 16.0117 16.9356 16.5452C16.9356 16.5452 23.4676 23.0785 23.4726 23.0835C23.7137 23.3233 24.0573 23.4658 24.4221 23.4658C24.787 23.4658 25.1306 23.3233 25.3879 23.066C26.0002 22.455 26.8135 22.1176 27.6806 22.1176C28.5477 22.1176 29.3611 22.4537 29.9733 23.0647L34.0477 27.1378C35.3109 28.4023 35.3109 30.4588 34.0477 31.722L33.0807 32.689C31.5901 34.1796 29.621 35.0005 27.5382 35.0005ZM24.3134 32.1768C25.3105 32.8015 26.4162 33.1226 27.5407 33.1226C29.1237 33.1226 30.6193 32.4979 31.7538 31.3634L32.7208 30.3963C33.2531 29.8628 33.2531 28.9945 32.7208 28.461L28.6477 24.3891C28.3903 24.1317 28.0467 23.9905 27.6806 23.9905C27.3146 23.9905 26.971 24.133 26.7136 24.3904C26.1026 25.0013 25.288 25.3387 24.4221 25.3387C23.5613 25.3387 22.7517 25.0063 22.1432 24.4016L15.6112 17.8683C14.348 16.6039 14.348 14.5474 15.6112 13.2842C16.1409 12.7532 16.1434 11.8873 15.6124 11.3538C15.6062 11.3476 15.5849 11.3251 15.5787 11.3188L11.5355 7.27195C11.2782 7.01581 10.9346 6.87463 10.5697 6.87463C10.2037 6.87463 9.86006 7.01706 9.60143 7.27445L8.63438 8.24025C6.63904 10.2356 6.30294 13.2942 7.8185 15.6756C12.229 22.2039 17.7802 27.7588 24.3134 32.1768Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), oT = [
  sT
];
function rT(e, i) {
  return f(), p("svg", aT, oT);
}
const lT = /* @__PURE__ */ k(tT, [["render", rT]]), dT = {}, cT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fT = /* @__PURE__ */ u("path", {
  d: "M33.9174 26.5339L30.719 23.3342C30.3784 22.993 29.9739 22.7223 29.5286 22.5376C29.0833 22.3529 28.6059 22.2579 28.1238 22.2579C27.6418 22.2579 27.1644 22.3529 26.7191 22.5376C26.2738 22.7223 25.8693 22.993 25.5287 23.3342L24.8765 23.9864C21.6621 21.2931 18.6929 18.32 16.0039 15.1021L16.6561 14.4498C17.3429 13.7611 17.7286 12.8281 17.7286 11.8554C17.7286 10.8827 17.3429 9.9497 16.6561 9.26091L13.4512 6.0651C12.7515 5.39668 11.8211 5.02368 10.8535 5.02368C9.88581 5.02368 8.9554 5.39668 8.25572 6.0651L6.50781 7.82084C5.66788 8.66682 5.1446 9.77603 5.02584 10.9622C4.90708 12.1484 5.20007 13.3394 5.85561 14.3351C11.0668 22.1874 17.7961 28.918 25.6474 34.1308C26.6465 34.7803 27.8373 35.0697 29.0231 34.9511C30.2089 34.8325 31.3187 34.3131 32.1695 33.4786L33.9239 31.7228C34.265 31.3825 34.5356 30.9782 34.7203 30.5331C34.905 30.088 35 29.6109 35 29.129C35 28.6472 34.905 28.17 34.7203 27.7249C34.5356 27.2798 34.265 26.8756 33.9239 26.5352L33.9174 26.5339Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), uT = [
  fT
];
function hT(e, i) {
  return f(), p("svg", cT, uT);
}
const mT = /* @__PURE__ */ k(dT, [["render", hT]]), pT = {}, yT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vT = /* @__PURE__ */ u("path", {
  d: "M33.4378 21.2505C33.4378 20.919 33.3061 20.601 33.0717 20.3666C32.8373 20.1322 32.5194 20.0005 32.1878 20.0005H31.2503C29.179 20.0028 27.1932 20.8266 25.7286 22.2913C24.264 23.7559 23.4401 25.7417 23.4378 27.813V28.7505C23.4378 29.7451 23.0427 30.6989 22.3395 31.4021C21.6362 32.1054 20.6824 32.5005 19.6878 32.5005C18.6933 32.5005 17.7394 32.1054 17.0362 31.4021C16.3329 30.6989 15.9378 29.7451 15.9378 28.7505V26.5417C15.9379 26.4666 15.965 26.394 16.014 26.3371C16.0631 26.2802 16.131 26.2428 16.2053 26.2317C16.6517 26.1674 17.06 25.9443 17.3552 25.6034C17.6505 25.2624 17.8129 24.8265 17.8128 24.3755V22.2005C17.8127 22.1371 17.8319 22.0751 17.8679 22.0229C17.9038 21.9706 17.9548 21.9306 18.0141 21.908C19.4349 21.4016 20.6616 20.4633 21.5222 19.2245C22.3828 17.9857 22.8341 16.5087 22.8128 15.0005V11.2505C22.8128 10.7532 22.6153 10.2763 22.2637 9.92466C21.912 9.57303 21.4351 9.37549 20.9378 9.37549H20.0003C19.9175 9.37549 19.838 9.34256 19.7794 9.28396C19.7208 9.22535 19.6878 9.14587 19.6878 9.06299V6.25049C19.6878 5.91897 19.5561 5.60103 19.3217 5.3666C19.0873 5.13218 18.7694 5.00049 18.4378 5.00049C18.1063 5.00049 17.7884 5.13218 17.5539 5.3666C17.3195 5.60103 17.1878 5.91897 17.1878 6.25049V9.06299C17.1878 9.14587 17.1549 9.22535 17.0963 9.28396C17.0377 9.34256 16.9582 9.37549 16.8753 9.37549H12.5003C12.4175 9.37549 12.338 9.34256 12.2794 9.28396C12.2208 9.22535 12.1878 9.14587 12.1878 9.06299V6.25049C12.1878 5.91897 12.0561 5.60103 11.8217 5.3666C11.5873 5.13218 11.2694 5.00049 10.9378 5.00049C10.6063 5.00049 10.2884 5.13218 10.054 5.3666C9.81953 5.60103 9.68783 5.91897 9.68783 6.25049V9.06299C9.68783 9.14587 9.65491 9.22535 9.5963 9.28396C9.5377 9.34256 9.45821 9.37549 9.37533 9.37549H8.43783C7.94055 9.37549 7.46364 9.57303 7.11201 9.92466C6.76038 10.2763 6.56283 10.7532 6.56283 11.2505V15.0005C6.54184 16.5085 6.99327 17.9852 7.85384 19.2238C8.71441 20.4623 9.94097 21.4004 11.3616 21.9067C11.4208 21.9293 11.4718 21.9694 11.5078 22.0216C11.5437 22.0739 11.5629 22.1358 11.5628 22.1992V24.3755C11.563 24.8263 11.7256 25.2619 12.0209 25.6026C12.3161 25.9433 12.7242 26.1662 13.1703 26.2305C13.2448 26.2413 13.3128 26.2786 13.3619 26.3356C13.4111 26.3925 13.438 26.4653 13.4378 26.5405V28.7505C13.4378 30.4081 14.0963 31.9978 15.2684 33.1699C16.4405 34.342 18.0302 35.0005 19.6878 35.0005C21.3454 35.0005 22.9351 34.342 24.1072 33.1699C25.2794 31.9978 25.9378 30.4081 25.9378 28.7505V27.813C25.9395 26.4045 26.4997 25.0542 27.4957 24.0583C28.4916 23.0624 29.8419 22.5021 31.2503 22.5005H32.1878C32.5194 22.5005 32.8373 22.3688 33.0717 22.1344C33.3061 21.9 33.4378 21.582 33.4378 21.2505ZM18.1253 13.7505C18.1253 13.9991 18.0266 14.2376 17.8507 14.4134C17.6749 14.5892 17.4365 14.688 17.1878 14.688H12.1878C11.9392 14.688 11.7007 14.5892 11.5249 14.4134C11.3491 14.2376 11.2503 13.9991 11.2503 13.7505C11.2503 13.5018 11.3491 13.2634 11.5249 13.0876C11.7007 12.9118 11.9392 12.813 12.1878 12.813H17.1878C17.4365 12.813 17.6749 12.9118 17.8507 13.0876C18.0266 13.2634 18.1253 13.5018 18.1253 13.7505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), gT = [
  vT
];
function _T(e, i) {
  return f(), p("svg", yT, gT);
}
const wT = /* @__PURE__ */ k(pT, [["render", _T]]), CT = {}, kT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xT = /* @__PURE__ */ u("path", {
  d: "M24.375 29.378H15.625C13.1937 29.378 10.23 27.5468 6.78875 23.9256C6.7457 23.8804 6.69012 23.8491 6.62915 23.8358C6.56819 23.8225 6.50463 23.8277 6.44667 23.8509C6.38871 23.874 6.33901 23.914 6.30396 23.9656C6.2689 24.0172 6.25011 24.0781 6.25 24.1406V30.003C6.25 31.1634 6.71094 32.2762 7.53141 33.0966C8.35188 33.9171 9.46468 34.378 10.625 34.378H29.375C30.5353 34.378 31.6481 33.9171 32.4686 33.0966C33.2891 32.2762 33.75 31.1634 33.75 30.003V24.1406C33.7499 24.0781 33.7311 24.0172 33.696 23.9656C33.661 23.914 33.6113 23.874 33.5533 23.8509C33.4954 23.8277 33.4318 23.8225 33.3708 23.8358C33.3099 23.8491 33.2543 23.8804 33.2113 23.9256C29.77 27.5468 26.8062 29.378 24.375 29.378Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), bT = /* @__PURE__ */ u("path", {
  d: "M35 15.0029C35 14.5056 34.8025 14.0287 34.4508 13.6771C34.0992 13.3255 33.6223 13.1279 33.125 13.1279H6.875C6.37772 13.1279 5.90081 13.3255 5.54917 13.6771C5.19754 14.0287 5 14.5056 5 15.0029V17.8779C5.00041 18.6 5.25085 19.2996 5.70875 19.8579C8.05 22.7129 12.4538 27.5029 15.625 27.5029H24.375C27.5462 27.5029 31.95 22.7129 34.2913 19.8579C34.7492 19.2996 34.9996 18.6 35 17.8779V15.0029ZM29.6875 18.4404C29.6875 18.6891 29.5887 18.9275 29.4129 19.1033C29.2371 19.2792 28.9986 19.3779 28.75 19.3779H11.5625C11.3139 19.3779 11.0754 19.2792 10.8996 19.1033C10.7238 18.9275 10.625 18.6891 10.625 18.4404C10.625 18.1918 10.7238 17.9533 10.8996 17.7775C11.0754 17.6017 11.3139 17.5029 11.5625 17.5029H28.75C28.9986 17.5029 29.2371 17.6017 29.4129 17.7775C29.5887 17.9533 29.6875 18.1918 29.6875 18.4404Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), MT = /* @__PURE__ */ u("path", {
  d: "M15.4063 11.878C15.4782 11.8779 15.5479 11.853 15.6035 11.8075C15.6591 11.7619 15.6972 11.6985 15.7113 11.628C15.7376 11.503 15.7701 11.378 15.8063 11.253C16.0756 10.3502 16.629 9.55844 17.3844 8.99548C18.1398 8.43251 19.0567 8.12841 19.9988 8.12841C20.9409 8.12841 21.8578 8.43251 22.6132 8.99548C23.3686 9.55844 23.922 10.3502 24.1913 11.253C24.2276 11.378 24.2601 11.503 24.2863 11.628C24.3005 11.6985 24.3386 11.7619 24.3942 11.8075C24.4498 11.853 24.5194 11.8779 24.5913 11.878L26.4951 11.8855C26.54 11.8856 26.5844 11.876 26.6252 11.8574C26.6661 11.8388 26.7025 11.8116 26.7319 11.7777C26.7613 11.7438 26.7831 11.7039 26.7957 11.6608C26.8083 11.6177 26.8115 11.5724 26.8051 11.528C26.7913 11.4355 26.7763 11.343 26.7601 11.2517C26.4687 9.67104 25.6328 8.24237 24.3975 7.21402C23.1622 6.18568 21.6056 5.62265 19.9983 5.6228C18.391 5.62295 16.8345 6.18626 15.5994 7.21484C14.3643 8.24341 13.5286 9.67223 13.2376 11.253C13.2213 11.3417 13.2063 11.4305 13.1938 11.5205C13.1878 11.5644 13.1912 11.6092 13.2037 11.6517C13.2161 11.6943 13.2375 11.7338 13.2663 11.7675C13.2951 11.8013 13.3307 11.8286 13.3707 11.8476C13.4108 11.8666 13.4545 11.877 13.4988 11.878H15.4063Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), DT = [
  xT,
  bT,
  MT
];
function AT(e, i) {
  return f(), p("svg", kT, DT);
}
const LT = /* @__PURE__ */ k(CT, [["render", AT]]), TT = {}, ST = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NT = /* @__PURE__ */ Ke('<path d="M6.12499 12.125C6.02499 12.125 5.93049 12.086 5.85999 12.015C5.71399 11.869 5.71399 11.631 5.85999 11.4845L7.84499 9.49951C7.98649 9.35801 8.17449 9.28001 8.37499 9.27951C8.57549 9.27951 8.76399 9.35751 8.90549 9.49901L9.87549 10.469L11.86 8.48451C11.931 8.41351 12.025 8.37451 12.125 8.37451C12.225 8.37451 12.3195 8.41351 12.39 8.48451C12.536 8.63051 12.536 8.86851 12.39 9.01501L10.4055 10.9995C10.2635 11.141 10.0755 11.219 9.87499 11.219C9.67449 11.219 9.48599 11.141 9.34449 10.9995L8.37499 10.03L6.38999 12.015C6.31949 12.086 6.22499 12.125 6.12499 12.125Z" fill="#3B414D" class="primary"></path><path d="M3.125 14C2.5045 14 2 13.4955 2 12.875V3.125C2 2.5045 2.5045 2 3.125 2H12.875C13.4955 2 14 2.5045 14 3.125V12.875C14 13.4955 13.4955 14 12.875 14H3.125ZM3.125 2.75C2.918 2.75 2.75 2.918 2.75 3.125V12.875C2.75 13.082 2.918 13.25 3.125 13.25H12.875C13.082 13.25 13.25 13.082 13.25 12.875V3.125C13.25 2.918 13.082 2.75 12.875 2.75H3.125Z" fill="#3B414D" class="primary"></path><path d="M6.125 8.75C4.6775 8.75 3.5 7.5725 3.5 6.125C3.5 4.6775 4.6775 3.5 6.125 3.5C7.5725 3.5 8.75 4.6775 8.75 6.125C8.75 6.8165 8.4825 7.469 7.9965 7.9635C7.9915 7.97 7.9865 7.976 7.981 7.981C7.976 7.9865 7.9695 7.9915 7.963 7.9965C7.472 8.481 6.8185 8.75 6.125 8.75ZM5.75 4.289C4.894 4.465 4.25 5.235 4.25 6.125C4.25 7.159 5.091 8 6.125 8C6.4925 8 6.8525 7.8905 7.158 7.6885L5.86 6.39C5.789 6.319 5.75 6.225 5.75 6.125V4.289ZM7.6885 7.158C7.8905 6.8525 8 6.4925 8 6.125C8 5.2345 7.356 4.465 6.5 4.289V5.97L7.6885 7.158Z" fill="#3B414D" class="primary"></path><path d="M10.25 5C10.043 5 9.875 4.832 9.875 4.625C9.875 4.418 10.043 4.25 10.25 4.25H11.75C11.957 4.25 12.125 4.418 12.125 4.625C12.125 4.832 11.957 5 11.75 5H10.25Z" fill="#3B414D" class="primary"></path><path d="M10.25 6.5C10.043 6.5 9.875 6.332 9.875 6.125C9.875 5.918 10.043 5.75 10.25 5.75H11.75C11.957 5.75 12.125 5.918 12.125 6.125C12.125 6.332 11.957 6.5 11.75 6.5H10.25Z" fill="#3B414D" class="primary"></path>', 5), ET = [
  NT
];
function zT(e, i) {
  return f(), p("svg", ST, ET);
}
const IT = /* @__PURE__ */ k(TT, [["render", zT]]), BT = {}, OT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HT = /* @__PURE__ */ Ke('<path fill-rule="evenodd" clip-rule="evenodd" d="M11.3462 10.2288C10.6691 10.2288 10.1202 10.7776 10.1202 11.4547C10.1202 12.1318 10.6691 12.6807 11.3462 12.6807C12.0233 12.6807 12.5722 12.1318 12.5722 11.4547C12.5722 10.7776 12.0233 10.2288 11.3462 10.2288ZM8.24524 11.4547C8.24524 9.74211 9.63359 8.35376 11.3462 8.35376C13.0588 8.35376 14.4472 9.74211 14.4472 11.4547C14.4472 13.1673 13.0588 14.5557 11.3462 14.5557C9.63359 14.5557 8.24524 13.1673 8.24524 11.4547Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6538 11.4546C13.6538 10.9368 14.0735 10.5171 14.5913 10.5171L34.0625 10.5171C34.5802 10.5171 35 10.9368 35 11.4546C35 11.9724 34.5802 12.3921 34.0625 12.3921L14.5913 12.3921C14.0735 12.3921 13.6538 11.9724 13.6538 11.4546Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3462 27.3201C10.6691 27.3201 10.1202 27.8689 10.1202 28.546C10.1202 29.2231 10.6691 29.772 11.3462 29.772C12.0233 29.772 12.5722 29.2231 12.5722 28.546C12.5722 27.8689 12.0233 27.3201 11.3462 27.3201ZM8.24524 28.546C8.24524 26.8334 9.63359 25.4451 11.3462 25.4451C13.0588 25.4451 14.4472 26.8334 14.4472 28.546C14.4472 30.2586 13.0588 31.647 11.3462 31.647C9.63359 31.647 8.24524 30.2586 8.24524 28.546Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6538 28.5459C13.6538 28.0281 14.0735 27.6084 14.5913 27.6084L34.0625 27.6084C34.5802 27.6084 35 28.0281 35 28.5459C35 29.0637 34.5802 29.4834 34.0625 29.4834L14.5913 29.4834C14.0735 29.4834 13.6538 29.0637 13.6538 28.5459Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M28.6538 18.7744C27.9767 18.7744 27.4279 19.3233 27.4279 20.0004C27.4279 20.6775 27.9767 21.2263 28.6538 21.2263C29.3309 21.2263 29.8798 20.6775 29.8798 20.0004C29.8798 19.3233 29.3309 18.7744 28.6538 18.7744ZM25.5529 20.0004C25.5529 18.2878 26.9412 16.8994 28.6538 16.8994C30.3664 16.8994 31.7548 18.2878 31.7548 20.0004C31.7548 21.713 30.3664 23.1013 28.6538 23.1013C26.9412 23.1013 25.5529 21.713 25.5529 20.0004Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M5 20.0002C5 19.4825 5.41973 19.0627 5.9375 19.0627L25.4087 19.0627C25.9264 19.0627 26.3462 19.4825 26.3462 20.0002C26.3462 20.518 25.9264 20.9377 25.4087 20.9377L5.9375 20.9377C5.41973 20.9377 5 20.518 5 20.0002Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M5 11.4546C5 10.9368 5.41973 10.5171 5.9375 10.5171H9.18269C9.70046 10.5171 10.1202 10.9368 10.1202 11.4546C10.1202 11.9724 9.70046 12.3921 9.18269 12.3921H5.9375C5.41973 12.3921 5 11.9724 5 11.4546Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M29.8798 20.0002C29.8798 19.4825 30.2995 19.0627 30.8173 19.0627H34.0625C34.5802 19.0627 35 19.4825 35 20.0002C35 20.518 34.5802 20.9377 34.0625 20.9377H30.8173C30.2995 20.9377 29.8798 20.518 29.8798 20.0002Z" fill="#3B414D" class="primary"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M5 28.5459C5 28.0281 5.41973 27.6084 5.9375 27.6084H9.18269C9.70046 27.6084 10.1202 28.0281 10.1202 28.5459C10.1202 29.0637 9.70046 29.4834 9.18269 29.4834H5.9375C5.41973 29.4834 5 29.0637 5 28.5459Z" fill="#3B414D" class="primary"></path>', 9), jT = [
  HT
];
function VT(e, i) {
  return f(), p("svg", OT, jT);
}
const FT = /* @__PURE__ */ k(BT, [["render", VT]]), PT = {}, UT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RT = /* @__PURE__ */ u("path", {
  d: "M20 23.7505C19.4825 23.7505 19.0625 23.3305 19.0625 22.813V21.5555C19.0612 20.3655 19.815 19.2992 20.9375 18.903C22.0588 18.5067 22.8125 17.4405 22.8125 16.2517C22.8125 15.5005 22.52 14.7942 21.9887 14.263C21.4587 13.7317 20.7525 13.4392 20 13.4392C19.2487 13.4392 18.5425 13.7317 18.0113 14.263C17.48 14.793 17.1875 15.4992 17.1875 16.2505C17.1875 16.7667 16.7675 17.188 16.25 17.188C15.7325 17.188 15.3125 16.7667 15.3125 16.2505C15.3125 14.998 15.8012 13.8217 16.6862 12.9367C17.5712 12.0517 18.7487 11.5642 20 11.5642C22.585 11.5642 24.6875 13.668 24.6875 16.2517C24.6875 18.2342 23.4312 20.0092 21.5625 20.6705C21.1887 20.803 20.9375 21.158 20.9375 21.5542V22.813C20.9375 23.3305 20.5175 23.7505 20 23.7505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), YT = /* @__PURE__ */ u("path", {
  d: "M20 28.438C20.7767 28.438 21.4062 27.8084 21.4062 27.0317C21.4062 26.2551 20.7767 25.6255 20 25.6255C19.2233 25.6255 18.5938 26.2551 18.5938 27.0317C18.5938 27.8084 19.2233 28.438 20 28.438Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), ZT = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), WT = [
  RT,
  YT,
  ZT
];
function QT(e, i) {
  return f(), p("svg", UT, WT);
}
const qT = /* @__PURE__ */ k(PT, [["render", QT]]), GT = {}, XT = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JT = /* @__PURE__ */ u("path", {
  d: "M20 5.00049C17.0333 5.00049 14.1332 5.88022 11.6665 7.52844C9.19971 9.17666 7.27713 11.5193 6.14181 14.2602C5.0065 17.0011 4.70945 20.0171 5.28823 22.9268C5.86701 25.8366 7.29562 28.5093 9.3934 30.6071C11.4912 32.7049 14.1639 34.1335 17.0737 34.7123C19.9834 35.291 22.9994 34.994 25.7403 33.8587C28.4811 32.7234 30.8238 30.8008 32.472 28.334C34.1203 25.8673 35 22.9672 35 20.0005C34.9957 16.0236 33.414 12.2107 30.6019 9.39864C27.7897 6.58652 23.9769 5.00479 20 5.00049V5.00049ZM20 28.7505C19.6292 28.7505 19.2667 28.6405 18.9583 28.4345C18.65 28.2285 18.4096 27.9356 18.2677 27.593C18.1258 27.2504 18.0887 26.8734 18.161 26.5097C18.2334 26.146 18.412 25.8119 18.6742 25.5497C18.9364 25.2874 19.2705 25.1089 19.6342 25.0365C19.9979 24.9642 20.3749 25.0013 20.7175 25.1432C21.0601 25.2851 21.353 25.5254 21.559 25.8338C21.765 26.1421 21.875 26.5046 21.875 26.8755C21.875 27.3728 21.6775 27.8497 21.3258 28.2013C20.9742 28.5529 20.4973 28.7505 20 28.7505ZM22 21.1505C21.777 21.2478 21.5872 21.4081 21.454 21.6117C21.3208 21.8153 21.2499 22.0534 21.25 22.2967C21.25 22.6283 21.1183 22.9462 20.8839 23.1806C20.6495 23.415 20.3315 23.5467 20 23.5467C19.6685 23.5467 19.3505 23.415 19.1161 23.1806C18.8817 22.9462 18.75 22.6283 18.75 22.2967C18.7499 21.567 18.9627 20.853 19.3624 20.2424C19.762 19.6319 20.3312 19.1511 21 18.8592C21.4132 18.6789 21.7699 18.3903 22.0324 18.0238C22.2949 17.6573 22.4534 17.2267 22.4912 16.7775C22.529 16.3283 22.4446 15.8773 22.247 15.4721C22.0494 15.067 21.746 14.7228 21.3688 14.4759C20.9916 14.2291 20.5546 14.0889 20.1042 14.0701C19.6539 14.0513 19.2068 14.1547 18.8103 14.3692C18.4138 14.5837 18.0828 14.9014 17.8521 15.2887C17.6214 15.676 17.4998 16.1185 17.5 16.5692C17.5 16.9008 17.3683 17.2187 17.1339 17.4531C16.8995 17.6875 16.5815 17.8192 16.25 17.8192C15.9185 17.8192 15.6005 17.6875 15.3661 17.4531C15.1317 17.2187 15 16.9008 15 16.5692C15 15.6678 15.2437 14.7831 15.7053 14.0088C16.1669 13.2345 16.8293 12.5994 17.6223 12.1707C18.4152 11.742 19.3094 11.5357 20.21 11.5736C21.1107 11.6114 21.9844 11.8921 22.7386 12.3858C23.4928 12.8796 24.0995 13.568 24.4945 14.3783C24.8895 15.1887 25.058 16.0907 24.9823 16.989C24.9067 17.8872 24.5895 18.7483 24.0645 19.4811C23.5395 20.2139 22.8262 20.7912 22 21.1517V21.1505Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), KT = [
  JT
];
function $T(e, i) {
  return f(), p("svg", XT, KT);
}
const eS = /* @__PURE__ */ k(GT, [["render", $T]]), nS = {}, iS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tS = /* @__PURE__ */ u("circle", {
  cx: "20",
  cy: "20.0005",
  r: "14.5",
  stroke: "#3B414D",
  class: "primary-stroke"
}, null, -1), aS = [
  tS
];
function sS(e, i) {
  return f(), p("svg", iS, aS);
}
const oS = /* @__PURE__ */ k(nS, [["render", sS]]), rS = {}, lS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dS = /* @__PURE__ */ u("circle", {
  cx: "20",
  cy: "20.0005",
  r: "15",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cS = [
  dS
];
function fS(e, i) {
  return f(), p("svg", lS, cS);
}
const uS = /* @__PURE__ */ k(rS, [["render", fS]]), hS = {}, mS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pS = /* @__PURE__ */ u("circle", {
  cx: "20",
  cy: "20.0005",
  r: "15",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yS = /* @__PURE__ */ u("circle", {
  cx: "20",
  cy: "20.0005",
  r: "6.66667",
  fill: "white"
}, null, -1), vS = [
  pS,
  yS
];
function gS(e, i) {
  return f(), p("svg", mS, vS);
}
const _S = /* @__PURE__ */ k(hS, [["render", gS]]), wS = {}, CS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, kS = /* @__PURE__ */ u("path", {
  d: "M34.752 15.8274C34.6157 15.461 34.3708 15.145 34.0501 14.9215C33.7294 14.698 33.3482 14.5776 32.9573 14.5764H25.1872C25.0549 14.5765 24.926 14.5355 24.818 14.4592C24.7101 14.3828 24.6285 14.2748 24.5847 14.1501L21.7955 6.24466C21.6589 5.87927 21.4139 5.56433 21.0934 5.34198C20.7729 5.11964 20.3921 5.00049 20.002 5.00049C19.6119 5.00049 19.2311 5.11964 18.9106 5.34198C18.5901 5.56433 18.3451 5.87927 18.2085 6.24466L18.2021 6.26508L15.4193 14.1501C15.3755 14.2746 15.2942 14.3824 15.1865 14.4588C15.0788 14.5352 14.9501 14.5763 14.8181 14.5764H7.04544C6.65205 14.5761 6.2681 14.697 5.94584 14.9226C5.62357 15.1483 5.37862 15.4677 5.24431 15.8374C5.10999 16.2072 5.09282 16.6093 5.19514 16.9892C5.29746 17.3691 5.5143 17.7082 5.81617 17.9604L12.4336 23.4494C12.5326 23.5316 12.6044 23.6417 12.6397 23.7654C12.675 23.8891 12.6721 24.0205 12.6314 24.1426L9.85121 32.4794C9.72272 32.8649 9.72018 33.2812 9.84396 33.6682C9.96774 34.0552 10.2114 34.3928 10.5397 34.6322C10.8681 34.8715 11.264 35.0003 11.6704 34.9997C12.0767 34.9991 12.4723 34.8693 12.7999 34.6291L19.6241 29.6252C19.7336 29.545 19.8657 29.5018 20.0014 29.5018C20.137 29.5018 20.2691 29.545 20.3786 29.6252L27.2002 34.6278C27.5277 34.8689 27.9235 34.9994 28.3302 35.0005C28.7369 35.0016 29.1334 34.8731 29.4621 34.6338C29.7909 34.3944 30.035 34.0566 30.1589 33.6693C30.2829 33.2819 30.2803 32.8652 30.1515 32.4794L27.3713 24.1375C27.3306 24.0154 27.3277 23.884 27.363 23.7603C27.3983 23.6366 27.4701 23.5265 27.5691 23.4443L34.1993 17.9477C34.4973 17.6933 34.7101 17.3536 34.8089 16.9744C34.9078 16.5953 34.8879 16.1949 34.752 15.8274V15.8274Z",
  class: "primary"
}, null, -1), xS = [
  kS
];
function bS(e, i) {
  return f(), p("svg", CS, xS);
}
const MS = /* @__PURE__ */ k(wS, [["render", bS]]), DS = {}, AS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LS = /* @__PURE__ */ u("path", {
  d: "M11.8197 35.0005C10.8777 35.0005 10.0298 34.4785 9.6098 33.6366C9.33782 33.0906 9.27582 32.4667 9.43781 31.8807L11.5437 24.1532L5.85205 18.4596C5.38608 17.9936 5.1301 17.3737 5.1301 16.7157C5.1301 16.0558 5.38608 15.4358 5.85405 14.9698C6.25602 14.5678 6.78999 14.3139 7.35795 14.2599L14.1855 13.5759L17.7933 6.3624C18.2152 5.52245 19.0612 5.00049 20.0031 5.00049C20.3851 5.00049 20.7671 5.09048 21.109 5.26247C21.583 5.50046 21.975 5.89443 22.211 6.3684L25.8167 13.5799L32.6463 14.2639C33.9982 14.3959 34.9901 15.6058 34.8581 16.9597C34.8021 17.5297 34.5481 18.0636 34.1462 18.4656L28.4585 24.1532L30.5664 31.8787C30.7384 32.5187 30.6524 33.1846 30.3244 33.7566C29.9944 34.3305 29.4625 34.7385 28.8265 34.9105C28.6185 34.9685 28.4005 34.9965 28.1806 34.9965C27.8006 34.9965 27.4206 34.9065 27.0826 34.7385L20.0011 31.1967L12.9216 34.7405C12.5736 34.9125 12.2036 35.0005 11.8197 35.0005ZM14.2795 22.6473C14.6595 23.0273 14.8075 23.5852 14.6655 24.1032L12.6416 31.5247L19.3252 28.1789C19.5311 28.075 19.7631 28.019 19.9971 28.019C20.2291 28.019 20.4611 28.073 20.6671 28.1769L27.3546 31.5207L25.3288 24.1012C25.1868 23.5832 25.3348 23.0253 25.7147 22.6453L31.2264 17.1357L24.6888 16.4817C24.1748 16.4297 23.7289 16.1237 23.4969 15.6598L19.9971 8.65624L16.4953 15.6578C16.2634 16.1217 15.8174 16.4277 15.3034 16.4797L8.76585 17.1337L14.2795 22.6473Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), TS = [
  LS
];
function SS(e, i) {
  return f(), p("svg", AS, TS);
}
const NS = /* @__PURE__ */ k(DS, [["render", SS]]), ES = {}, zS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IS = /* @__PURE__ */ u("g", { "clip-path": "url(#clip0)" }, [
  /* @__PURE__ */ u("path", {
    d: "M19.9994 34.9995C18.029 35.0049 16.0771 34.6194 14.2567 33.8654C12.4363 33.1114 10.7835 32.0039 9.39397 30.6068C7.99672 29.2174 6.88892 27.5647 6.1347 25.7442C5.38049 23.9238 4.99483 21.9719 5.00005 20.0014C5.00005 15.995 6.56011 12.2286 9.39272 9.39477C12.2266 6.56216 15.993 5.00085 19.9994 5.00085C24.0058 5.00085 27.7722 6.56091 30.606 9.39352C32.0034 10.7831 33.1113 12.436 33.8655 14.2567C34.6198 16.0773 35.0053 18.0295 34.9999 20.0002V22.8128C34.9986 24.0556 34.5043 25.2472 33.6255 26.126C32.7467 27.0048 31.5551 27.4991 30.3123 27.5005C29.3754 27.4959 28.4612 27.2122 27.6864 26.6856C26.9115 26.159 26.3112 25.4135 25.9621 24.5441C25.2622 25.4619 24.3601 26.206 23.326 26.7187C22.2919 27.2314 21.1536 27.4989 19.9994 27.5005C15.8642 27.5005 12.4991 24.1353 12.4991 20.0002C12.4991 15.865 15.8642 12.4999 19.9994 12.4999C24.1345 12.4999 27.4997 15.865 27.4997 20.0002V22.8128C27.4997 24.3641 28.761 25.6254 30.3123 25.6254C31.8636 25.6254 33.1249 24.3641 33.1249 22.8128V20.0002C33.1249 16.495 31.7598 13.1987 29.281 10.7198C28.0648 9.49731 26.6183 8.52811 25.0251 7.86831C23.432 7.20851 21.7238 6.87121 19.9994 6.87593C18.2752 6.87124 16.5672 7.20856 14.9742 7.86836C13.3812 8.52816 11.9349 9.49735 10.719 10.7198C9.49655 11.9357 8.52736 13.382 7.86756 14.975C7.20776 16.568 6.87044 18.276 6.87512 20.0002C6.87037 21.7244 7.20766 23.4324 7.86746 25.0254C8.52727 26.6184 9.49649 28.0647 10.719 29.2805C11.9348 30.5028 13.3809 31.4718 14.9736 32.1314C16.5664 32.791 18.2742 33.1281 19.9981 33.1232C22.8195 33.1232 25.6158 32.1906 27.8722 30.4981C27.9706 30.4242 28.0826 30.3704 28.2018 30.3399C28.321 30.3093 28.445 30.3025 28.5668 30.3198C28.6887 30.3372 28.8059 30.3783 28.9118 30.441C29.0177 30.5036 29.1102 30.5865 29.1841 30.685C29.258 30.7834 29.3117 30.8954 29.3423 31.0146C29.3729 31.1337 29.3797 31.2578 29.3624 31.3796C29.345 31.5014 29.3038 31.6187 29.2412 31.7246C29.1785 31.8305 29.0956 31.923 28.9972 31.9969C26.3996 33.9407 23.2438 34.9938 19.9994 34.9995ZM19.9994 14.375C16.898 14.375 14.3742 16.8988 14.3742 20.0002C14.3742 23.1015 16.898 25.6254 19.9994 25.6254C23.1007 25.6254 25.6246 23.1015 25.6246 20.0002C25.6246 16.8988 23.1007 14.375 19.9994 14.375Z",
    fill: "#3B414D",
    class: "primary"
  })
], -1), BS = /* @__PURE__ */ u("defs", null, [
  /* @__PURE__ */ u("clipPath", { id: "clip0" }, [
    /* @__PURE__ */ u("rect", {
      width: "40",
      height: "40",
      fill: "white",
      transform: "translate(0 0.000488281)"
    })
  ])
], -1), OS = [
  IS,
  BS
];
function HS(e, i) {
  return f(), p("svg", zS, OS);
}
const jS = /* @__PURE__ */ k(ES, [["render", HS]]), VS = {}, FS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PS = /* @__PURE__ */ Ke('<path d="M24.6875 12.188C24.7704 12.188 24.8499 12.1551 24.9085 12.0965C24.9671 12.0379 25 11.9584 25 11.8755V10.0005C25 8.67441 24.4732 7.40264 23.5355 6.46495C22.5979 5.52727 21.3261 5.00049 20 5.00049C18.6739 5.00049 17.4022 5.52727 16.4645 6.46495C15.5268 7.40264 15 8.67441 15 10.0005V11.8755C14.9998 11.9166 15.0078 11.9573 15.0235 11.9953C15.0391 12.0333 15.0621 12.0678 15.0912 12.0968C15.1202 12.1259 15.1547 12.1489 15.1927 12.1645C15.2307 12.1802 15.2714 12.1882 15.3125 12.188H24.6875Z" fill="#3B414D" class="primary"></path><path d="M14.0625 26.563C14.0214 26.5628 13.9807 26.5708 13.9427 26.5864C13.9047 26.6021 13.8702 26.6251 13.8412 26.6542C13.8121 26.6832 13.7891 26.7177 13.7735 26.7557C13.7578 26.7937 13.7498 26.8344 13.75 26.8755V32.5005H12.5C12.1685 32.5005 11.8505 32.6322 11.6161 32.8666C11.3817 33.101 11.25 33.419 11.25 33.7505C11.25 34.082 11.3817 34.4 11.6161 34.6344C11.8505 34.8688 12.1685 35.0005 12.5 35.0005H18.125C18.4002 35.0005 18.6676 34.9097 18.8859 34.7422C19.1042 34.5747 19.2611 34.3398 19.3324 34.074C19.4036 33.8082 19.3851 33.5264 19.2798 33.2722C19.1745 33.018 18.9883 32.8056 18.75 32.668V26.8755C18.75 26.7926 18.7171 26.7131 18.6585 26.6545C18.5999 26.5959 18.5204 26.563 18.4375 26.563H14.0625Z" fill="#3B414D" class="primary"></path><path d="M21.5624 26.563C21.5214 26.5628 21.4807 26.5708 21.4427 26.5864C21.4047 26.6021 21.3702 26.6251 21.3411 26.6542C21.3121 26.6832 21.289 26.7177 21.2734 26.7557C21.2578 26.7937 21.2498 26.8344 21.2499 26.8755V32.668C21.0117 32.8056 20.8254 33.018 20.7201 33.2722C20.6148 33.5264 20.5964 33.8082 20.6676 34.074C20.7388 34.3398 20.8957 34.5747 21.114 34.7422C21.3323 34.9097 21.5998 35.0005 21.8749 35.0005H27.4999C27.8315 35.0005 28.1494 34.8688 28.3838 34.6344C28.6182 34.4 28.7499 34.082 28.7499 33.7505C28.7499 33.419 28.6182 33.101 28.3838 32.8666C28.1494 32.6322 27.8315 32.5005 27.4999 32.5005H26.2499V26.8755C26.2499 26.7926 26.217 26.7131 26.1584 26.6545C26.0998 26.5959 26.0203 26.563 25.9374 26.563H21.5624Z" fill="#3B414D" class="primary"></path><path d="M33.1249 22.2118V19.5005C33.1365 18.2056 32.6995 16.9466 31.8881 15.9374C31.0766 14.9282 29.9409 14.231 28.6737 13.9643C28.6202 13.9509 28.5641 13.9519 28.5112 13.9673C28.4583 13.9827 28.4104 14.0118 28.3724 14.0518C28.3343 14.0919 28.3075 14.1413 28.2945 14.195C28.2816 14.2488 28.283 14.305 28.2987 14.358C28.5129 15.061 28.6836 15.7766 28.8099 16.5005C28.8178 16.5477 28.8364 16.5924 28.8644 16.6312C28.8924 16.6701 28.9289 16.7019 28.9712 16.7243C29.4815 16.9829 29.9078 17.3811 30.2006 17.8726C30.4934 18.3641 30.6405 18.9287 30.6249 19.5005V22.2118C30.1483 22.487 29.7758 22.9117 29.5652 23.4201C29.3546 23.9286 29.3177 24.4923 29.4601 25.0239C29.6025 25.5555 29.9164 26.0252 30.353 26.3602C30.7896 26.6953 31.3246 26.8768 31.8749 26.8769C32.4252 26.8768 32.9602 26.6953 33.3968 26.3602C33.8334 26.0252 34.1473 25.5555 34.2897 25.0239C34.4322 24.4923 34.3952 23.9286 34.1846 23.4201C33.974 22.9117 33.6015 22.487 33.1249 22.2118Z" fill="#3B414D" class="primary"></path><path d="M6.875 19.5006V22.2118C6.3984 22.487 6.02591 22.9117 5.8153 23.4202C5.6047 23.9286 5.56775 24.4923 5.71019 25.0239C5.85262 25.5555 6.16649 26.0252 6.6031 26.3603C7.03971 26.6953 7.57467 26.8769 8.125 26.8769C8.67534 26.8769 9.21029 26.6953 9.6469 26.3603C10.0835 26.0252 10.3974 25.5555 10.5398 25.0239C10.6823 24.4923 10.6453 23.9286 10.4347 23.4202C10.2241 22.9117 9.8516 22.487 9.375 22.2118V19.5006C9.36006 18.9293 9.50737 18.3655 9.79985 17.8746C10.0923 17.3836 10.518 16.9856 11.0275 16.7268C11.0698 16.7043 11.1064 16.6724 11.1345 16.6336C11.1627 16.5949 11.1816 16.5502 11.19 16.5031C11.3159 15.7783 11.4862 15.062 11.7 14.3581C11.716 14.3052 11.7177 14.249 11.705 14.1952C11.6922 14.1414 11.6653 14.092 11.6272 14.0519C11.5891 14.0119 11.541 13.9827 11.4879 13.9673C11.4348 13.9519 11.3786 13.9509 11.325 13.9643C10.058 14.2313 8.92255 14.9286 8.11137 15.9378C7.3002 16.947 6.86334 18.2058 6.875 19.5006Z" fill="#3B414D" class="primary"></path><path d="M26.3025 14.2742C26.2812 14.2126 26.2412 14.1591 26.1881 14.1213C26.1351 14.0834 26.0715 14.063 26.0063 14.063H13.9925C13.9273 14.063 13.8637 14.0834 13.8106 14.1213C13.7575 14.1591 13.7176 14.2126 13.6963 14.2742C12.5269 17.575 12.5269 21.1773 13.6963 24.478C13.7177 24.5392 13.7576 24.5922 13.8104 24.6298C13.8632 24.6674 13.9264 24.6878 13.9913 24.688H26.0075C26.0724 24.6878 26.1355 24.6674 26.1884 24.6298C26.2412 24.5922 26.2811 24.5392 26.3025 24.478C27.4719 21.1773 27.4719 17.575 26.3025 14.2742ZM23.125 19.3755C22.8778 19.3755 22.6361 19.3022 22.4306 19.1648C22.225 19.0275 22.0648 18.8322 21.9702 18.6038C21.8756 18.3754 21.8508 18.1241 21.899 17.8816C21.9473 17.6391 22.0663 17.4164 22.2411 17.2416C22.416 17.0668 22.6387 16.9477 22.8812 16.8995C23.1236 16.8513 23.375 16.876 23.6034 16.9706C23.8318 17.0652 24.027 17.2255 24.1644 17.431C24.3017 17.6366 24.375 17.8783 24.375 18.1255C24.375 18.457 24.2433 18.775 24.0089 19.0094C23.7745 19.2438 23.4565 19.3755 23.125 19.3755Z" fill="#3B414D" class="primary"></path>', 6), US = [
  PS
];
function RS(e, i) {
  return f(), p("svg", FS, US);
}
const YS = /* @__PURE__ */ k(VS, [["render", RS]]), ZS = {}, WS = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QS = /* @__PURE__ */ u("path", {
  d: "M22.8125 35.0005C21.7787 35.0005 20.9375 34.1592 20.9375 33.1255V25.6255H19.0625V33.1255C19.0625 34.1592 18.2212 35.0005 17.1875 35.0005H11.5625C11.045 35.0005 10.625 34.5805 10.625 34.063C10.625 33.5455 11.045 33.1255 11.5625 33.1255H13.4375V25.2755C12.7525 24.9017 12.245 24.2542 12.055 23.493C11.7112 22.033 11.5462 20.5405 11.5625 19.0517C11.4887 17.4855 11.6788 15.9092 12.1275 14.3755H11.5625C10.0113 14.3755 8.75 15.6367 8.75 17.188V22.9742C9.85625 23.3655 10.625 24.4255 10.625 25.6255C10.625 26.143 10.205 26.563 9.6875 26.563C9.17 26.563 8.75 26.143 8.75 25.6255C8.75 25.108 8.33 24.688 7.8125 24.688C7.295 24.688 6.875 25.108 6.875 25.6255C6.875 26.143 6.455 26.563 5.9375 26.563C5.42 26.563 5 26.143 5 25.6255C5 24.4255 5.76875 23.3655 6.875 22.9742V17.188C6.875 14.603 8.9775 12.5005 11.5625 12.5005H15.3125V9.68799C15.3125 7.10299 17.415 5.00049 20 5.00049C22.585 5.00049 24.6875 7.10299 24.6875 9.68799V12.5005H28.4375C31.0225 12.5005 33.125 14.603 33.125 17.188V22.9742C34.2313 23.3655 35 24.4255 35 25.6255C35 26.143 34.58 26.563 34.0625 26.563C33.545 26.563 33.125 26.143 33.125 25.6255C33.125 25.108 32.705 24.688 32.1875 24.688C31.67 24.688 31.25 25.108 31.25 25.6255C31.25 26.143 30.83 26.563 30.3125 26.563C29.795 26.563 29.375 26.143 29.375 25.6255C29.375 24.4255 30.1437 23.3655 31.25 22.9742V17.188C31.25 15.6367 29.9888 14.3755 28.4375 14.3755H27.8725C28.3213 15.9105 28.51 17.4992 28.4363 19.1055C28.4538 20.5505 28.2887 22.0317 27.9475 23.4805C27.7563 24.2492 27.2488 24.8992 26.5625 25.2742V33.1242H28.4375C28.955 33.1242 29.375 33.5442 29.375 34.0617C29.375 34.5792 28.955 35.0005 28.4375 35.0005H22.8125ZM22.8125 33.1255H24.6875V25.6255H22.8125V33.1255ZM17.1875 33.1255V25.6255H15.3125V33.1255H17.1875ZM14.0912 14.3755C13.5837 15.8717 13.3625 17.433 13.4362 19.0205C13.4225 20.403 13.5712 21.7517 13.8775 23.053C13.98 23.4605 14.3525 23.7505 14.785 23.7505H25.2163C25.6475 23.7505 26.0225 23.458 26.1262 23.0405C26.43 21.7492 26.5775 20.4117 26.5637 19.073C26.6375 17.443 26.4175 15.8717 25.91 14.3755H14.0912ZM22.8125 12.5005V9.68799C22.8125 8.13674 21.5513 6.87549 20 6.87549C18.4487 6.87549 17.1875 8.13674 17.1875 9.68799V12.5005H22.8125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), qS = /* @__PURE__ */ u("path", {
  d: "M23.2812 19.063C23.2262 19.063 23.1712 19.058 23.1175 19.0492C22.4762 18.9742 21.965 18.4617 21.89 17.8205C21.88 17.768 21.8762 17.713 21.8762 17.658C21.8762 17.603 21.8812 17.548 21.89 17.4955C21.965 16.8542 22.4775 16.3417 23.1175 16.2667C23.1712 16.2555 23.2262 16.2505 23.2812 16.2505C23.3362 16.2505 23.3912 16.2555 23.445 16.2642C24.0862 16.3392 24.5975 16.8517 24.6737 17.493C24.6825 17.5455 24.6875 17.6005 24.6875 17.6555C24.6875 17.7105 24.6825 17.7655 24.6737 17.818C24.5975 18.4592 24.0862 18.9717 23.445 19.0467C23.3912 19.058 23.3362 19.063 23.2812 19.063Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), GS = /* @__PURE__ */ u("path", {
  d: "M16.25 19.063C15.7325 19.063 15.3125 18.643 15.3125 18.1255C15.3125 17.608 15.7325 17.188 16.25 17.188H19.0625C19.58 17.188 20 17.608 20 18.1255C20 18.643 19.58 19.063 19.0625 19.063H16.25Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), XS = [
  QS,
  qS,
  GS
];
function JS(e, i) {
  return f(), p("svg", WS, XS);
}
const KS = /* @__PURE__ */ k(ZS, [["render", JS]]), $S = {}, eN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nN = /* @__PURE__ */ u("path", {
  d: "M34.0615 35.0005C33.8116 35.0005 33.5754 34.903 33.3992 34.7256L25.2575 26.5826C24.3065 27.3961 23.2355 28.0597 22.067 28.5559C20.5312 29.2082 18.9178 29.5394 17.272 29.5394C15.7011 29.5394 14.1578 29.2382 12.6819 28.6421C9.64389 27.4161 7.26574 25.0817 5.98481 22.0662C4.70388 19.052 4.67263 15.7178 5.89858 12.6811C7.12452 9.64433 9.45894 7.26492 12.4732 5.98399C14.009 5.33041 15.6211 5.00049 17.2682 5.00049C18.8391 5.00049 20.3825 5.30291 21.8583 5.89776C24.8963 7.12371 27.2745 9.45812 28.5554 12.4736C29.8363 15.4891 29.8676 18.822 28.6416 21.8588C28.1393 23.1035 27.4469 24.2444 26.5809 25.2554L34.7251 33.4009C35.09 33.7658 35.09 34.3606 34.7251 34.7268C34.5477 34.903 34.3115 35.0005 34.0615 35.0005ZM17.2682 6.87502C15.8748 6.87502 14.5077 7.15495 13.2068 7.70856C10.6524 8.79454 8.67413 10.809 7.63564 13.3821C6.59715 15.9552 6.6234 18.7783 7.70813 21.3327C8.7941 23.887 10.8086 25.8653 13.3817 26.9038C14.6326 27.4086 15.9411 27.6636 17.2707 27.6636C18.6641 27.6636 20.0313 27.3836 21.3322 26.83C22.5494 26.3127 23.6404 25.5828 24.5739 24.6606C24.5864 24.6431 24.6002 24.6281 24.6139 24.6143C24.6339 24.5943 24.6526 24.5781 24.6701 24.5656C25.6236 23.6021 26.381 22.4499 26.9021 21.1565C27.9406 18.5833 27.9143 15.7603 26.8283 13.2059C25.7436 10.6516 23.7279 8.67332 21.1548 7.63483C19.9063 7.13121 18.5979 6.87502 17.2682 6.87502Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), iN = [
  nN
];
function tN(e, i) {
  return f(), p("svg", eN, iN);
}
const aN = /* @__PURE__ */ k($S, [["render", tN]]), sN = {}, oN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, rN = /* @__PURE__ */ u("path", {
  d: "M34.819 5.24875C34.7307 5.15892 34.6174 5.09784 34.4938 5.07352C34.3703 5.04921 34.2422 5.0628 34.1265 5.1125L5.37622 17.4864C5.26835 17.5332 5.17587 17.6095 5.10941 17.7065C5.04295 17.8035 5.0052 17.9173 5.0005 18.0348C4.9958 18.1522 5.02434 18.2687 5.08284 18.3707C5.14134 18.4727 5.22743 18.5561 5.33122 18.6114L13.6688 23.0252C13.7225 23.0554 13.7839 23.0691 13.8453 23.0644C13.9067 23.0597 13.9653 23.0369 14.0138 22.9989L26.8764 12.6238C26.9364 12.5742 27.0127 12.5487 27.0904 12.5524C27.1681 12.556 27.2417 12.5885 27.2967 12.6435C27.3517 12.6986 27.3843 12.7721 27.3879 12.8499C27.3915 12.9276 27.3661 13.0039 27.3164 13.0638L16.9413 25.9265C16.9028 25.974 16.8792 26.0319 16.8735 26.0928C16.8677 26.1537 16.88 26.215 16.9088 26.269L21.3226 34.6065C21.3758 34.707 21.4553 34.791 21.5527 34.8496C21.65 34.9081 21.7615 34.9391 21.8751 34.939H21.8989C22.0164 34.9345 22.1302 34.8969 22.2272 34.8305C22.3243 34.7642 22.4007 34.6718 22.4476 34.564L34.9478 5.93876C34.9978 5.82408 35.0123 5.697 34.9894 5.57398C34.9664 5.45096 34.9071 5.33766 34.819 5.24875V5.24875Z",
  class: "primary"
}, null, -1), lN = [
  rN
];
function dN(e, i) {
  return f(), p("svg", oN, lN);
}
const cN = /* @__PURE__ */ k(sN, [["render", dN]]), fN = {}, uN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hN = /* @__PURE__ */ u("path", {
  d: "M20.0001 19.6672C24.0502 19.6672 27.3334 16.3839 27.3334 12.3338C27.3334 8.28373 24.0502 5.00049 20.0001 5.00049C15.95 5.00049 12.6668 8.28373 12.6668 12.3338C12.6668 16.3839 15.95 19.6672 20.0001 19.6672Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), mN = /* @__PURE__ */ u("path", {
  d: "M20 21.6671C16.6418 21.671 13.4222 23.0068 11.0476 25.3814C8.67299 27.756 7.33723 30.9756 7.33334 34.3338C7.33334 34.5106 7.40358 34.6802 7.52861 34.8052C7.65363 34.9302 7.8232 35.0004 8.00001 35.0004H32C32.1768 35.0004 32.3464 34.9302 32.4714 34.8052C32.5964 34.6802 32.6667 34.5106 32.6667 34.3338C32.6628 30.9756 31.327 27.756 28.9524 25.3814C26.5778 23.0068 23.3582 21.671 20 21.6671Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), pN = [
  hN,
  mN
];
function yN(e, i) {
  return f(), p("svg", uN, pN);
}
const vN = /* @__PURE__ */ k(fN, [["render", yN]]), gN = {}, _N = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wN = /* @__PURE__ */ u("path", {
  d: "M20 20.0005C15.865 20.0005 12.5 16.6355 12.5 12.5005C12.5 8.36549 15.865 5.00049 20 5.00049C24.135 5.00049 27.5 8.36549 27.5 12.5005C27.5 16.6355 24.135 20.0005 20 20.0005ZM20 6.87549C16.8988 6.87549 14.375 9.39924 14.375 12.5005C14.375 15.6017 16.8988 18.1255 20 18.1255C23.1012 18.1255 25.625 15.6017 25.625 12.5005C25.625 9.39924 23.1012 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), CN = /* @__PURE__ */ u("path", {
  d: "M32.1875 35.0005C31.9389 35.0005 31.7004 34.9017 31.5246 34.7259C31.3488 34.5501 31.25 34.3116 31.25 34.063C31.25 27.8592 26.2038 22.813 20 22.813C13.7963 22.813 8.75 27.8592 8.75 34.063C8.75 34.3116 8.65123 34.5501 8.47541 34.7259C8.2996 34.9017 8.06114 35.0005 7.8125 35.0005C7.56386 35.0005 7.3254 34.9017 7.14959 34.7259C6.97377 34.5501 6.875 34.3116 6.875 34.063C6.875 26.8255 12.7625 20.938 20 20.938C27.2375 20.938 33.125 26.8255 33.125 34.063C33.125 34.3116 33.0262 34.5501 32.8504 34.7259C32.6746 34.9017 32.4361 35.0005 32.1875 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kN = [
  wN,
  CN
];
function xN(e, i) {
  return f(), p("svg", _N, kN);
}
const bN = /* @__PURE__ */ k(gN, [["render", xN]]), MN = {}, DN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AN = /* @__PURE__ */ u("path", {
  d: "M12.6315 14.2499C12.7561 14.3473 12.913 14.3937 13.0706 14.3798C13.2281 14.3659 13.3745 14.2927 13.4801 14.175C14.2871 13.2719 15.2731 12.5465 16.3755 12.0449C17.4779 11.5432 18.6726 11.2763 19.8836 11.261C21.0947 11.2458 22.2957 11.4825 23.4104 11.9562C24.5251 12.43 25.529 13.1303 26.3586 14.0128C26.4166 14.0713 26.4856 14.1177 26.5616 14.1494C26.6377 14.1811 26.7192 14.1974 26.8016 14.1974C26.8839 14.1974 26.9655 14.1811 27.0415 14.1494C27.1176 14.1177 27.1866 14.0713 27.2446 14.0128L30.8885 10.5935C30.947 10.5355 30.9934 10.4665 31.0251 10.3905C31.0567 10.3144 31.0731 10.2329 31.0731 10.1505C31.0731 10.0681 31.0567 9.98658 31.0251 9.91055C30.9934 9.83452 30.947 9.7655 30.8885 9.7075C29.4497 8.18004 27.7059 6.97203 25.7702 6.1618C23.8345 5.35156 21.7501 4.95719 19.6522 5.00426C17.5543 5.05132 15.4898 5.53877 13.5923 6.435C11.6949 7.33122 10.0071 8.61622 8.63819 10.2067C8.5809 10.2735 8.5384 10.3516 8.51346 10.436C8.48853 10.5204 8.48173 10.6092 8.49352 10.6964C8.50531 10.7836 8.53541 10.8673 8.58185 10.9421C8.62829 11.0168 8.69001 11.0809 8.76298 11.1301L12.6315 14.2499Z",
  fill: "#EB4335"
}, null, -1), LN = /* @__PURE__ */ u("path", {
  d: "M11.5583 23.4719C11.6487 23.3907 11.7133 23.2848 11.7444 23.1673C11.7754 23.0498 11.7714 22.9258 11.733 22.8105C11.1159 21.0066 11.1159 19.0488 11.733 17.2449C11.774 17.1238 11.7769 16.993 11.7412 16.8703C11.7055 16.7475 11.6329 16.6387 11.5333 16.5585L7.45265 13.3014C7.37973 13.2434 7.29473 13.2024 7.20388 13.1814C7.11304 13.1605 7.01866 13.1602 6.92768 13.1806C6.8367 13.2009 6.75145 13.2414 6.67817 13.299C6.60489 13.3567 6.54546 13.43 6.50424 13.5136C5.50373 15.592 4.99984 17.8744 5.03232 20.1808C5.06481 22.4872 5.63278 24.7545 6.69142 26.8039C6.73541 26.8887 6.79829 26.9623 6.87522 27.019C6.95214 27.0757 7.04106 27.1139 7.13511 27.1308C7.22916 27.1477 7.32583 27.1427 7.41767 27.1163C7.50951 27.0899 7.59406 27.0428 7.6648 26.9786L11.5583 23.4719Z",
  fill: "#FBBC05"
}, null, -1), TN = /* @__PURE__ */ u("path", {
  d: "M34.9692 18.1183C34.9692 17.9529 34.9034 17.7942 34.7864 17.6771C34.6694 17.5601 34.5107 17.4944 34.3452 17.4944H21.8661C21.7006 17.4944 21.5419 17.5601 21.4249 17.6771C21.3078 17.7942 21.2421 17.9529 21.2421 18.1183V23.11C21.2421 23.2755 21.3078 23.4342 21.4249 23.5512C21.5419 23.6682 21.7006 23.734 21.8661 23.734H27.906C27.5384 24.4957 27.0589 25.1982 26.4834 25.818C26.3799 25.9326 26.3226 26.0816 26.3226 26.236C26.3226 26.3905 26.3799 26.5394 26.4834 26.6541L29.8153 30.3978C29.8736 30.4602 29.9442 30.5099 30.0225 30.5438C30.1009 30.5778 30.1854 30.5953 30.2708 30.5953C30.3562 30.5953 30.4407 30.5778 30.519 30.5438C30.5974 30.5099 30.6679 30.4602 30.7263 30.3978C33.2654 27.7995 34.7733 24.3667 34.9692 20.739V18.1183Z",
  fill: "#4285F4"
}, null, -1), SN = /* @__PURE__ */ u("path", {
  d: "M24.3868 28.0518C24.2979 27.953 24.1797 27.8851 24.0495 27.8582C23.9193 27.8313 23.7839 27.8466 23.663 27.902C21.9831 28.6931 20.0931 28.9225 18.2727 28.5561C16.4523 28.1898 14.7981 27.2473 13.5549 25.8679C13.4383 25.7536 13.2815 25.6896 13.1182 25.6896C12.9549 25.6896 12.798 25.7536 12.6814 25.8679L8.93766 29.2123C8.87918 29.2704 8.83276 29.3394 8.80108 29.4154C8.76941 29.4914 8.7531 29.573 8.7531 29.6554C8.7531 29.7377 8.76941 29.8193 8.80108 29.8953C8.83276 29.9714 8.87918 30.0404 8.93766 30.0984C11.2574 32.6502 14.3867 34.3232 17.7972 34.8347C21.2076 35.3463 24.6901 34.6651 27.6564 32.9062C27.7352 32.8593 27.8027 32.7957 27.8541 32.7198C27.9055 32.6439 27.9396 32.5577 27.9539 32.4671C27.9682 32.3766 27.9624 32.284 27.9368 32.196C27.9113 32.1079 27.8667 32.0266 27.8061 31.9578L24.3868 28.0518Z",
  fill: "#34A853"
}, null, -1), NN = [
  AN,
  LN,
  TN,
  SN
];
function EN(e, i) {
  return f(), p("svg", DN, NN);
}
const zN = /* @__PURE__ */ k(MN, [["render", EN]]), IN = {}, BN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ON = /* @__PURE__ */ u("path", {
  d: "M28.1301 13.963C28.0723 13.8971 28.0012 13.8441 27.9215 13.8075C27.8418 13.7709 27.7553 13.7515 27.6676 13.7505H22.9551V11.988C22.9551 11.638 23.0301 11.238 23.5926 11.238H27.3426C27.4249 11.2415 27.507 11.2265 27.5827 11.194C27.6584 11.1616 27.7259 11.1125 27.7801 11.0505C27.8903 10.9362 27.9529 10.7842 27.9551 10.6255V5.62549C27.9551 5.45973 27.8893 5.30076 27.7721 5.18355C27.6549 5.06634 27.4959 5.00049 27.3301 5.00049H21.9176C15.9176 5.00049 15.4551 10.1255 15.4551 11.688V13.7505H12.3301C12.1644 13.7505 12.0054 13.8163 11.8882 13.9335C11.771 14.0508 11.7051 14.2097 11.7051 14.3755V19.3755C11.7051 19.5412 11.771 19.7002 11.8882 19.8174C12.0054 19.9346 12.1644 20.0005 12.3301 20.0005H15.4551V34.3755C15.4551 34.5412 15.521 34.7002 15.6382 34.8174C15.7554 34.9346 15.9144 35.0005 16.0801 35.0005H22.3301C22.4959 35.0005 22.6549 34.9346 22.7721 34.8174C22.8893 34.7002 22.9551 34.5412 22.9551 34.3755V20.0005H27.1426C27.2981 20.0013 27.4483 19.9441 27.5639 19.8401C27.6794 19.736 27.7521 19.5927 27.7676 19.438L28.2926 14.438C28.2999 14.3519 28.2891 14.2652 28.2612 14.1835C28.2332 14.1017 28.1886 14.0266 28.1301 13.963Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), HN = [
  ON
];
function jN(e, i) {
  return f(), p("svg", BN, HN);
}
const VN = /* @__PURE__ */ k(IN, [["render", jN]]), FN = {}, PN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UN = /* @__PURE__ */ u("path", {
  d: "M26.875 5.00049H13.125C10.9711 5.00379 8.90643 5.86088 7.38341 7.3839C5.86039 8.90691 5.00331 10.9716 5 13.1255V26.8755C5.00331 29.0294 5.86039 31.0941 7.38341 32.6171C8.90643 34.1401 10.9711 34.9972 13.125 35.0005H26.875C29.0289 34.9972 31.0936 34.1401 32.6166 32.6171C34.1396 31.0941 34.9967 29.0294 35 26.8755V13.1255C34.9967 10.9716 34.1396 8.90691 32.6166 7.3839C31.0936 5.86088 29.0289 5.00379 26.875 5.00049V5.00049ZM20 26.8755C18.6403 26.8755 17.311 26.4723 16.1805 25.7168C15.0499 24.9614 14.1687 23.8877 13.6483 22.6314C13.128 21.3752 12.9918 19.9929 13.2571 18.6592C13.5224 17.3256 14.1772 16.1006 15.1386 15.1391C16.1001 14.1776 17.3251 13.5229 18.6588 13.2576C19.9924 12.9923 21.3747 13.1285 22.6309 13.6488C23.8872 14.1692 24.9609 15.0504 25.7164 16.1809C26.4718 17.3115 26.875 18.6407 26.875 20.0005C26.875 21.8239 26.1507 23.5725 24.8614 24.8618C23.572 26.1512 21.8234 26.8755 20 26.8755ZM28.125 13.1255C27.7542 13.1255 27.3916 13.0155 27.0833 12.8095C26.775 12.6035 26.5346 12.3106 26.3927 11.968C26.2508 11.6254 26.2137 11.2484 26.286 10.8847C26.3584 10.521 26.537 10.1869 26.7992 9.92466C27.0614 9.66244 27.3955 9.48386 27.7592 9.41152C28.1229 9.33917 28.4999 9.3763 28.8425 9.51821C29.1851 9.66013 29.478 9.90045 29.684 10.2088C29.89 10.5171 30 10.8796 30 11.2505C30 11.7478 29.8025 12.2247 29.4508 12.5763C29.0992 12.9279 28.6223 13.1255 28.125 13.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), RN = [
  UN
];
function YN(e, i) {
  return f(), p("svg", PN, RN);
}
const ZN = /* @__PURE__ */ k(FN, [["render", YN]]), WN = {}, QN = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qN = /* @__PURE__ */ u("path", {
  d: "M27.0263 16.6724C26.9197 16.8617 26.7646 17.0191 26.5771 17.1287C26.3895 17.2383 26.1762 17.2961 25.959 17.2961H14.0409C13.8238 17.296 13.6107 17.2383 13.4232 17.1287C13.2358 17.0192 13.0808 16.8618 12.9742 16.6727C12.8675 16.4836 12.8131 16.2695 12.8163 16.0525C12.8195 15.8354 12.8804 15.6231 12.9926 15.4372L18.9517 5.59131C19.0608 5.41097 19.2147 5.26183 19.3983 5.15832C19.5819 5.05481 19.7892 5.00043 20 5.00043C20.2108 5.00043 20.418 5.05481 20.6017 5.15832C20.7853 5.26183 20.9391 5.41097 21.0483 5.59131L27.0073 15.4372C27.1196 15.623 27.1805 15.8352 27.1839 16.0523C27.1872 16.2693 27.1328 16.4833 27.0263 16.6724V16.6724Z",
  fill: "#D0D3D9"
}, null, -1), GN = /* @__PURE__ */ u("path", {
  d: "M27.0073 24.5637L21.0483 34.4096C20.9391 34.59 20.7853 34.7391 20.6017 34.8426C20.418 34.9461 20.2108 35.0005 20 35.0005C19.7892 35.0005 19.5819 34.9461 19.3983 34.8426C19.2147 34.7391 19.0608 34.59 18.9517 34.4096L12.9926 24.5637C12.8802 24.3778 12.8193 24.1654 12.8159 23.9483C12.8126 23.7311 12.8671 23.517 12.9737 23.3278C13.0804 23.1386 13.2354 22.9811 13.423 22.8715C13.6105 22.762 13.8238 22.7042 14.041 22.7042H25.959C26.1762 22.7042 26.3895 22.762 26.577 22.8715C26.7645 22.9811 26.9196 23.1386 27.0262 23.3278C27.1329 23.517 27.1873 23.7311 27.184 23.9483C27.1807 24.1654 27.1197 24.3778 27.0073 24.5637V24.5637Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), XN = [
  qN,
  GN
];
function JN(e, i) {
  return f(), p("svg", QN, XN);
}
const KN = /* @__PURE__ */ k(WN, [["render", JN]]), $N = {}, eE = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nE = /* @__PURE__ */ u("path", {
  d: "M27.0263 23.3286C26.9197 23.1393 26.7646 22.9818 26.5771 22.8722C26.3895 22.7626 26.1762 22.7049 25.959 22.7048H14.0409C13.8238 22.7049 13.6107 22.7627 13.4232 22.8723C13.2358 22.9818 13.0808 23.1392 12.9742 23.3283C12.8675 23.5174 12.8131 23.7314 12.8163 23.9485C12.8195 24.1656 12.8804 24.3779 12.9926 24.5637L18.9517 34.4097C19.0608 34.59 19.2147 34.7391 19.3983 34.8427C19.5819 34.9462 19.7892 35.0005 20 35.0005C20.2108 35.0005 20.418 34.9462 20.6017 34.8427C20.7853 34.7391 20.9391 34.59 21.0483 34.4097L27.0073 24.5637C27.1196 24.378 27.1805 24.1657 27.1839 23.9487C27.1872 23.7317 27.1328 23.5177 27.0263 23.3286V23.3286Z",
  fill: "#D0D3D9",
  class: "primary"
}, null, -1), iE = /* @__PURE__ */ u("path", {
  d: "M27.0073 15.4373L21.0483 5.59136C20.9391 5.41102 20.7853 5.26189 20.6017 5.15838C20.418 5.05487 20.2108 5.00049 20 5.00049C19.7892 5.00049 19.5819 5.05487 19.3983 5.15838C19.2147 5.26189 19.0608 5.41102 18.9517 5.59136L12.9926 15.4373C12.8802 15.6231 12.8193 15.8355 12.8159 16.0527C12.8126 16.2699 12.8671 16.484 12.9737 16.6732C13.0804 16.8624 13.2354 17.0199 13.423 17.1294C13.6105 17.239 13.8238 17.2968 14.041 17.2968H25.959C26.1762 17.2968 26.3895 17.239 26.577 17.1294C26.7645 17.0199 26.9196 16.8624 27.0262 16.6732C27.1329 16.484 27.1873 16.2699 27.184 16.0527C27.1807 15.8355 27.1197 15.6231 27.0073 15.4373V15.4373Z",
  fill: "#D0D3D9",
  class: "primary"
}, null, -1), tE = [
  nE,
  iE
];
function aE(e, i) {
  return f(), p("svg", eE, tE);
}
const sE = /* @__PURE__ */ k($N, [["render", aE]]), oE = {}, rE = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lE = /* @__PURE__ */ u("path", {
  d: "M27.0263 23.3286C26.9197 23.1393 26.7646 22.9818 26.5771 22.8722C26.3895 22.7626 26.1762 22.7049 25.959 22.7048H14.0409C13.8238 22.7049 13.6107 22.7627 13.4232 22.8723C13.2358 22.9818 13.0808 23.1392 12.9742 23.3283C12.8675 23.5174 12.8131 23.7314 12.8163 23.9485C12.8195 24.1656 12.8804 24.3779 12.9926 24.5637L18.9517 34.4097C19.0608 34.59 19.2147 34.7391 19.3983 34.8427C19.5819 34.9462 19.7892 35.0005 20 35.0005C20.2108 35.0005 20.418 34.9462 20.6017 34.8427C20.7853 34.7391 20.9391 34.59 21.0483 34.4097L27.0073 24.5637C27.1196 24.378 27.1805 24.1657 27.1839 23.9487C27.1872 23.7317 27.1328 23.5177 27.0263 23.3286V23.3286Z",
  fill: "#D0D3D9"
}, null, -1), dE = /* @__PURE__ */ u("path", {
  d: "M27.0073 15.4373L21.0483 5.59136C20.9391 5.41102 20.7853 5.26189 20.6017 5.15838C20.418 5.05487 20.2108 5.00049 20 5.00049C19.7892 5.00049 19.5819 5.05487 19.3983 5.15838C19.2147 5.26189 19.0608 5.41102 18.9517 5.59136L12.9926 15.4373C12.8802 15.6231 12.8193 15.8355 12.8159 16.0527C12.8126 16.2699 12.8671 16.484 12.9737 16.6732C13.0804 16.8624 13.2354 17.0199 13.423 17.1294C13.6105 17.239 13.8238 17.2968 14.041 17.2968H25.959C26.1762 17.2968 26.3895 17.239 26.577 17.1294C26.7645 17.0199 26.9196 16.8624 27.0262 16.6732C27.1329 16.484 27.1873 16.2699 27.184 16.0527C27.1807 15.8355 27.1197 15.6231 27.0073 15.4373V15.4373Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cE = [
  lE,
  dE
];
function fE(e, i) {
  return f(), p("svg", rE, cE);
}
const uE = /* @__PURE__ */ k(oE, [["render", fE]]), hE = {}, mE = {
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, pE = /* @__PURE__ */ Ke('<g transform="matrix(0.116989, 0, 0, 0.117019, 12.405169, -1.759683)"><g transform="matrix(1, 0, 0, 1, -185.080811, -64.049973)"><rect width="256.434" height="170.956" fill="#c60b1e" x="121.783" style="" y="164.522"></rect><rect width="256.434" height="85.478" y="207.261" fill="#ffc400" x="121.783" style=""></rect><g id="coa" stroke="#000" stroke-width="0.39" transform="matrix(0.341913, 0, 0, 0.341913, 121.782883, 164.522049)" style=""><g id="supporters"><g id="crown_left" stroke-width="0.26"><path fill="#ad1519" stroke-linejoin="round" d="m167.99 222.24s-0.51 0-0.79-0.16-1.13-0.96-1.13-0.96l-0.68-0.49-0.62-0.85s-0.73-1.18-0.4-2.09c0.34-0.91 0.91-1.23 1.42-1.5 0.51-0.26 1.58-0.59 1.58-0.59s0.85-0.37 1.13-0.42c0.28-0.06 1.3-0.32 1.3-0.32s0.28-0.16 0.56-0.27c0.29-0.11 0.68-0.11 0.91-0.16 0.22-0.06 0.79-0.24 1.13-0.26 0.52-0.02 1.36 0.1 1.64 0.1s1.24 0.05 1.64 0.05c0.39 0 1.8-0.11 2.2-0.11 0.39 0 0.68-0.05 1.13 0 0.45 0.06 1.24 0.32 1.47 0.43s1.58 0.59 2.09 0.75 1.75 0.37 2.32 0.64c0.56 0.27 0.91 0.72 1.19 1.1 0.28 0.37 0.34 0.78 0.45 1.05 0.11 0.26 0.11 0.84 0 1.11-0.11 0.26-0.51 0.81-0.51 0.81l-0.62 1.02-0.79 0.64s-0.57 0.54-1.02 0.48c-0.45-0.04-5.03-0.86-7.97-0.86s-7.64 0.86-7.64 0.86h0.01z"></path><g fill="#c8b100"><ellipse cx="175.66" cy="215.68" rx="1.38" ry="2.5"></ellipse><ellipse cx="175.68" cy="215.68" rx="0.64" ry="2.3"></ellipse><ellipse stroke="none" cx="175.68" cy="213.04" rx="0.93" ry="0.87"></ellipse><path stroke-width="0.3" d="m176.96 212.74v0.58h-2.53v-0.58h0.94v-1.32h-0.62v-0.57h0.62v-0.57h0.6v0.57h0.62v0.57h-0.62v1.32h0.99"></path><path fill="none" d="m175.94,212.2a0.93,0.87 0 1,1 -0.5,0"></path><path d="m175.68 222.08h-4.81l-0.11-1.18-0.23-1.23-0.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65 0.1-0.32 0.22-0.56 0.47-0.71 1.18-0.7 3.61 0.98 5.44 3.74 0.16 0.25 0.32 0.5 0.46 0.75h3.97c0.14-0.25 0.3-0.5 0.46-0.75 1.82-2.76 4.26-4.44 5.43-3.74 0.26 0.15 0.37 0.39 0.47 0.71-0.41-0.24-1.62 0.9-2.96 2.65l-0.23 1.53-0.23 1.23-0.1 1.18h-4.84z"></path><path fill="none" d="m167.55 215.44c0.91-0.53 3.02 1.14 4.73 3.74m11.55-3.74c-0.91-0.53-3.01 1.14-4.73 3.74"></path></g><g id="crown_pt1" fill="#c8b100"><path d="m168.58 224.25c-0.2-0.57-0.58-1.08-0.58-1.08 1.95-0.57 4.66-0.93 7.67-0.94 3.01 0.01 5.75 0.37 7.69 0.94 0 0-0.22 0.38-0.52 0.91-0.17 0.3-0.39 0.81-0.38 0.81-1.75-0.54-4.02-0.81-6.8-0.82-2.79 0.01-5.46 0.35-6.86 0.86 0.02 0-0.1-0.32-0.23-0.68h0.01"></path><path d="m175.67 226.73c2.43-0.01 5.11-0.38 6.1-0.63 0.66-0.2 1.05-0.49 0.98-0.84-0.04-0.16-0.18-0.3-0.37-0.38-1.46-0.47-4.07-0.8-6.71-0.8-2.63 0-5.27 0.33-6.72 0.8-0.19 0.08-0.33 0.22-0.37 0.38-0.07 0.35 0.32 0.64 0.98 0.84 0.99 0.25 3.68 0.62 6.11 0.63z"></path><path d="m183.48 222.08l-0.59-0.53s-0.57 0.34-1.28 0.24c-0.7-0.11-0.93-0.97-0.93-0.97s-0.79 0.67-1.44 0.62c-0.65-0.06-1.07-0.62-1.07-0.62s-0.71 0.51-1.33 0.46c-0.62-0.06-1.21-0.83-1.21-0.83s-0.63 0.8-1.25 0.86c-0.62 0.05-1.13-0.54-1.13-0.54s-0.28 0.59-1.07 0.72-1.47-0.62-1.47-0.62-0.45 0.73-0.99 0.92c-0.54 0.18-1.24-0.27-1.24-0.27s-0.12 0.27-0.2 0.43-0.31 0.19-0.31 0.19l0.18 0.47c1.93-0.56 4.56-0.91 7.53-0.91s5.67 0.35 7.61 0.92l0.2-0.54h-0.01z"></path><path d="m175.69 219.49l0.28 0.05c-0.05 0.12-0.06 0.24-0.06 0.38 0 0.58 0.5 1.05 1.12 1.05 0.49 0 0.91-0.31 1.06-0.73 0.01 0.01 0.11-0.38 0.15-0.38 0.03 0 0.03 0.41 0.05 0.41 0.07 0.53 0.55 0.89 1.1 0.89 0.62 0 1.11-0.47 1.11-1.06 0-0.04 0-0.08-0.01-0.12l0.35-0.35 0.19 0.44c-0.07 0.14-0.1 0.29-0.1 0.46 0 0.56 0.47 1.01 1.06 1.01 0.37 0 0.69-0.18 0.88-0.45l0.23-0.29v0.36c0 0.34 0.14 0.66 0.49 0.71 0 0 0.38 0.03 0.91-0.38 0.52-0.41 0.8-0.75 0.8-0.75l0.03 0.42s-0.51 0.84-0.97 1.1c-0.25 0.15-0.64 0.31-0.95 0.25-0.32-0.05-0.55-0.31-0.67-0.61-0.23 0.14-0.51 0.22-0.8 0.22-0.63 0-1.2-0.35-1.42-0.86-0.29 0.31-0.69 0.5-1.16 0.5-0.51 0-0.97-0.23-1.26-0.58-0.28 0.27-0.67 0.43-1.09 0.43-0.55 0-1.05-0.28-1.33-0.69-0.29 0.41-0.78 0.69-1.34 0.69-0.42 0-0.81-0.16-1.09-0.43-0.29 0.35-0.75 0.58-1.25 0.58-0.48 0-0.88-0.19-1.17-0.5-0.22 0.51-0.79 0.86-1.42 0.86-0.29 0-0.56-0.08-0.79-0.22-0.12 0.3-0.35 0.56-0.68 0.61-0.3 0.06-0.69-0.1-0.94-0.25-0.47-0.26-1.02-1.1-1.02-1.1l0.07-0.42s0.29 0.34 0.81 0.75 0.91 0.38 0.91 0.38c0.34-0.05 0.49-0.37 0.49-0.71v-0.36l0.22 0.29c0.19 0.27 0.51 0.45 0.88 0.45 0.59 0 1.06-0.45 1.06-1.01 0-0.17-0.02-0.32-0.1-0.46l0.19-0.44 0.35 0.35c-0.01 0.04-0.01 0.08-0.01 0.12 0 0.59 0.49 1.06 1.11 1.06 0.55 0 1.03-0.36 1.11-0.89 0.01 0 0.01-0.41 0.04-0.41 0.05 0 0.14 0.39 0.16 0.38 0.14 0.42 0.56 0.73 1.06 0.73 0.61 0 1.11-0.47 1.11-1.05 0-0.14 0-0.26-0.05-0.38l0.29-0.05h0.01z"></path><path stroke-linejoin="round" d="m175.67 222.23c-3.01 0.01-5.72 0.37-7.67 0.94-0.13 0.04-0.29-0.06-0.33-0.17-0.04-0.13 0.05-0.28 0.18-0.32 1.95-0.6 4.73-0.98 7.82-0.98s5.88 0.38 7.83 0.98c0.13 0.04 0.22 0.19 0.18 0.32-0.04 0.11-0.2 0.21-0.33 0.17-1.95-0.57-4.67-0.93-7.68-0.94z"></path><path d="m165.43 221c-0.01 0.01-0.38-0.48-0.65-0.73-0.2-0.18-0.68-0.33-0.68-0.33 0-0.08 0.28-0.28 0.58-0.28 0.18 0 0.35 0.07 0.45 0.2l0.04-0.2s0.24 0.05 0.35 0.32c0.12 0.29 0.05 0.72 0.05 0.72s-0.05 0.2-0.14 0.3z"></path><path d="m167.32 220.22l-0.11 0.66-1.4 0.15-0.21-0.12 0.04-0.23 1.06-0.87 0.62 0.41"></path><path d="m165.45 220.75c0.12-0.12 0.36-0.09 0.53 0.06 0.18 0.15 0.24 0.38 0.12 0.5-0.12 0.13-0.36 0.1-0.53-0.06-0.18-0.15-0.24-0.38-0.12-0.5z"></path><path d="m168.02 220.88c-0.06-0.18 0-0.37 0.13-0.42 0.14-0.03 0.3 0.09 0.37 0.27 0.06 0.19 0 0.38-0.14 0.42-0.13 0.04-0.29-0.08-0.36-0.27z"></path><path d="m168.67 220.04l0.51 0.48 1.22-0.66 0.09-0.21-0.17-0.17-1.4-0.12-0.25 0.68"></path><path d="m170.08 217.76l-0.67 0.64 0.86 1.14 0.23 0.09 0.17-0.18 0.3-1.37-0.89-0.32"></path><path d="m172.36 219.3l-0.26 0.63-1.4-0.13-0.18-0.16 0.1-0.22 1.22-0.64 0.52 0.52"></path><ellipse cx="170.51" cy="219.65" rx="0.49" ry="0.47"></ellipse><path d="m172.87 219.95c-0.03-0.2 0.07-0.37 0.21-0.39s0.28 0.13 0.3 0.33c0.03 0.19-0.07 0.37-0.21 0.38-0.14 0.02-0.28-0.13-0.3-0.32z"></path><path d="m173.78 219.24l0.4 0.57 1.34-0.42 0.14-0.18-0.15-0.2-1.33-0.39-0.4 0.62"></path><path d="m175.66 217.15l-0.86 0.52 0.64 1.38 0.22 0.14 0.22-0.14 0.64-1.38-0.86-0.52"></path><path d="m177.55 219.24l-0.39 0.57-1.34-0.42-0.14-0.18 0.14-0.2 1.34-0.39 0.39 0.62"></path><ellipse cx="175.67" cy="219.21" rx="0.49" ry="0.47"></ellipse><path d="m178.5 219.95c0.02-0.2-0.08-0.37-0.22-0.39s-0.28 0.13-0.3 0.33c-0.02 0.19 0.07 0.37 0.21 0.38 0.14 0.02 0.28-0.13 0.31-0.32z"></path><path d="m178.99 219.3l0.26 0.63 1.4-0.13 0.18-0.16-0.1-0.22-1.22-0.64-0.52 0.52"></path><path d="m181.27 217.76l0.67 0.64-0.86 1.14-0.23 0.09-0.17-0.18-0.3-1.37 0.89-0.32"></path><path d="m182.68 220.04l-0.51 0.48-1.22-0.66-0.1-0.21 0.19-0.17 1.4-0.12 0.24 0.68"></path><ellipse cx="180.85" cy="219.65" rx="0.49" ry="0.47"></ellipse><path d="m183.34 220.88c0.06-0.18 0-0.37-0.13-0.42-0.14-0.03-0.3 0.09-0.37 0.27-0.06 0.19 0 0.38 0.14 0.42 0.13 0.04 0.29-0.08 0.36-0.27z"></path><path d="m185.73 221c0.01 0.01 0.38-0.48 0.66-0.73 0.19-0.18 0.67-0.33 0.67-0.33 0-0.08-0.28-0.28-0.58-0.28-0.18 0-0.35 0.07-0.45 0.2l-0.04-0.2s-0.24 0.05-0.36 0.32c-0.11 0.29-0.03 0.72-0.03 0.72s0.04 0.2 0.13 0.3z"></path><path d="m183.84 220.22l0.11 0.66 1.4 0.15 0.21-0.12-0.05-0.23-1.05-0.87-0.62 0.41"></path><path d="m185.74 220.75c-0.11-0.12-0.35-0.09-0.53 0.06s-0.24 0.38-0.12 0.5c0.12 0.13 0.36 0.1 0.54-0.06 0.18-0.15 0.23-0.38 0.11-0.5z"></path></g><g id="crown_pt2" fill="none"><path fill="#ad1519" d="m168.05 224.3l0.31-0.5 0.65 0.13-0.38 0.56-0.58-0.19"></path><path fill="#058e6e" d="m170.85 223.81l-0.69 0.11c-0.18 0.02-0.35-0.09-0.38-0.26-0.02-0.17 0.1-0.32 0.27-0.35l0.7-0.1 0.71-0.11c0.18-0.02 0.34 0.09 0.37 0.25 0.02 0.17-0.1 0.33-0.27 0.35l-0.71 0.11"></path><ellipse fill="#fff" cx="173.19" cy="223.3" rx="0.44" ry="0.41"></ellipse><path fill="#ad1519" d="m175.7 223.48h-0.96c-0.18 0-0.33-0.14-0.33-0.31s0.14-0.31 0.32-0.31h1.96c0.19 0 0.33 0.14 0.33 0.31s-0.15 0.31-0.33 0.31h-0.99"></path><ellipse fill="#fff" cx="178.16" cy="223.3" rx="0.44" ry="0.41"></ellipse><path fill="#058e6e" d="m180.5 223.81l0.69 0.11c0.18 0.02 0.35-0.09 0.38-0.26 0.02-0.17-0.09-0.32-0.27-0.35l-0.7-0.1-0.71-0.11c-0.18-0.02-0.35 0.09-0.37 0.25-0.03 0.17 0.09 0.33 0.27 0.35l0.71 0.11"></path><path fill="#ad1519" d="m183.24 224.33l-0.25-0.53-0.67 0.06 0.32 0.59 0.6-0.12"></path><path fill="#ad1519" stroke-linejoin="round" d="m175.66 226.16c-2.43 0-4.63-0.22-6.3-0.65 1.67-0.43 3.87-0.69 6.3-0.7 2.44 0 4.65 0.27 6.33 0.7-1.68 0.43-3.89 0.65-6.33 0.65z"></path><path stroke-width="0.01" d="m176.8 226.08v-1.16m-0.58 1.2l0.01-1.23m-0.43 1.25v-1.26"></path><path stroke-width="0.02" d="m175.44 226.15v-1.27"></path><path stroke-width="0.03" d="m175.09 226.15v-1.27"></path><path stroke-width="0.04" d="m174.77 226.15v-1.27"></path><path stroke-width="0.04" d="m174.44 226.15v-1.27"></path><path stroke-width="0.05" d="m174.16 226.15v-1.27"></path><path stroke-width="0.06" d="m173.61 226.08l-0.01-1.15m0.27 1.17v-1.21"></path><path stroke-width="0.07" d="m173.1 226.03v-1.06m0.26 1.09l-0.01-1.13"></path><path stroke-width="0.08" d="m172.42 225.97v-0.93m0.23 0.94v-0.98m0.23 1.02v-1.02"></path><path stroke-width="0.09" d="m172.19 225.96v-0.9"></path><path stroke-width="0.1" d="m171.97 225.92v-0.85"></path><path stroke-width="0.11" d="m171.73 225.89v-0.78"></path><path stroke-width="0.12" d="m171.24 225.82l-0.01-0.62m0.26 0.66v-0.7"></path><path stroke-width="0.12" d="m170.99 225.77v-0.55"></path><path stroke-width="0.13" d="m170.76 225.73v-0.46"></path><path stroke-width="0.14" d="m170.51 225.67v-0.36"></path><path stroke-width="0.15" d="m170.26 225.64v-0.27"></path><path stroke-width="0.18" d="m169.99 225.58v-0.13"></path></g></g><g id="pillar_left"><g fill="#005bbf"><path d="m191.28 330.68c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.32-3.91 0.83-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.54-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.33 3.92-0.86 1.01-0.52 2.4-0.84 3.91-0.84 1.5 0 2.86 0.32 3.86 0.83 1.02 0.54 2.37 0.87 3.91 0.87l0.02-2.41z"></path><path fill="#ccc" d="m191.28 333.09c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.83-3.86-0.83-1.51 0-2.9 0.32-3.91 0.84-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.37-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.54 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.84 3.91-0.84c1.5 0 2.86 0.32 3.86 0.84 1.02 0.53 2.37 0.86 3.91 0.86l0.02-2.41"></path><path d="m191.28 335.5c-1.54 0-2.91-0.33-3.93-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.4c1.53 0 2.93-0.34 3.95-0.88 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.37 0.86 3.91 0.86l0.02-2.4"></path><path fill="#ccc" d="m191.26 340.32c-1.54 0-2.89-0.33-3.91-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.31-3.91 0.83s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.53-2.42 0.88-3.95 0.88v-2.4c1.53 0 2.93-0.36 3.95-0.9 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.39 0.86 3.93 0.86l-0.02 2.42"></path><path d="m191.26 342.73c-1.54 0-2.89-0.33-3.91-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v-2.39c1.53 0 2.93-0.37 3.95-0.9 1-0.52 2.34-0.81 3.86-0.81 1.45 0 2.79 0.3 3.79 0.79 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.83 3.91-0.83c1.5 0 2.86 0.31 3.86 0.82 1.02 0.54 2.38 0.87 3.93 0.87l-0.02 2.41z"></path></g><g fill="#c8b100"><path stroke-linejoin="round" d="m166.92 320.78c0.05 0.21 0.13 0.4 0.13 0.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-0.21 0.04-0.41 0.09-0.62-0.13 0.05-0.29 0.06-0.44 0.06h-16.69c-0.13 0-0.29-0.02-0.41-0.06z"></path><path d="m167.33 319.27h16.69c0.57 0 1.02 0.35 1.02 0.78s-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.36-1.02-0.79s0.46-0.78 1.02-0.78z"></path><path d="m164.27 329.86h22.87v-5.83h-22.87v5.83z"></path></g><path fill="#ccc" d="m167.55 318.32h16.25v-79.63h-16.25v79.63z"></path><path fill="none" d="m179.13 238.8v79.46m1.83-79.46v79.46"></path><g fill="#c8b100"><path d="m164.58 232.37h22.29v-5.84h-22.29v5.84z"></path><path stroke-linejoin="round" d="m166.92 236.26c0.14-0.06 0.24-0.07 0.41-0.07h16.69c0.17 0 0.32 0.03 0.46 0.08-0.58-0.19-0.99-0.71-0.99-1.32s0.45-1.14 1.03-1.33c-0.14 0.04-0.33 0.08-0.49 0.08h-16.7c-0.17 0-0.33-0.01-0.47-0.06l0.09 0.02c0.6 0.18 0.94 0.71 0.94 1.29 0 0.56-0.38 1.13-0.97 1.31z"></path><path d="m167.33 236.19h16.69c0.57 0 1.02 0.35 1.02 0.78 0 0.44-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.35-1.02-0.79 0-0.43 0.46-0.78 1.02-0.78z"></path><path d="m167.33 232.37h16.7c0.57 0 1.03 0.3 1.03 0.66 0 0.37-0.46 0.67-1.03 0.67h-16.7c-0.56 0-1.02-0.3-1.02-0.67 0-0.36 0.46-0.66 1.02-0.66z"></path></g></g><g id="ribbon_left" fill="#ad1519"><path d="m162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31 0.12 0.61 0.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-0.9-3.56-2.34-4.64z"></path><path stroke-linejoin="round" d="m200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39 0.02-5.04 0.25-7.79 0.7-9.72 1.63-17.13 5.51-16.54 8.67 0.01 0.06 0.04 0.2 0.05 0.26 0 0-3.64-8.21-3.7-8.52-0.65-3.51 7.56-7.82 18.35-9.62 3.39-0.57 6.69-0.79 9.56-0.76 6.9 0 12.9 0.89 16.52 2.23l0.04 9.82"></path><path d="m167.52 278.47c-4.51-0.32-7.58-1.53-7.94-3.41-0.28-1.5 1.25-3.17 3.97-4.68 1.21 0.14 2.58 0.3 4 0.3l-0.03 7.79"></path><path d="m183.83 272.38c2.82 0.43 4.93 1.13 5.98 1.99l0.1 0.17c0.5 1.03-1.97 3.22-6.11 5.67l0.03-7.83"></path><path stroke-linejoin="round" d="m157.42 293.83c-0.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-0.09-0.17c0.46 0.38 1.18 8.24 1.18 8.24 0.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-0.01z"></path></g><g id="crown_right" stroke-width="0.26"><path fill="#ad1519" stroke-width="0.27" d="m324.85 220.42s-0.74 0.78-1.28 0.89c-0.53 0.1-1.21-0.49-1.21-0.49s-0.48 0.51-1.08 0.64c-0.59 0.14-1.41-0.66-1.41-0.66s-0.57 0.8-1.07 0.99c-0.51 0.18-1.13-0.24-1.13-0.24s-0.23 0.39-0.65 0.61c-0.18 0.09-0.48-0.05-0.48-0.05l-0.6-0.38-0.68-0.72-0.62-0.24s-0.28-0.91-0.31-1.07c-0.02-0.16-0.08-0.57-0.08-0.57-0.13-0.65 0.87-1.4 2.3-1.72 0.82-0.19 1.54-0.18 2.06-0.02 0.57-0.48 1.78-0.82 3.2-0.82 1.29 0 2.42 0.27 3.04 0.7 0.61-0.43 1.74-0.7 3.03-0.7 1.42 0 2.62 0.34 3.19 0.82 0.53-0.16 1.24-0.17 2.07 0.02 1.42 0.32 2.43 1.07 2.3 1.72 0 0-0.06 0.41-0.08 0.57-0.03 0.16-0.32 1.07-0.32 1.07l-0.62 0.24-0.68 0.72-0.58 0.38s-0.3 0.14-0.48 0.05c-0.43-0.21-0.66-0.61-0.66-0.61s-0.62 0.42-1.13 0.24c-0.51-0.19-1.07-0.99-1.07-0.99s-0.82 0.8-1.42 0.66c-0.59-0.13-1.07-0.64-1.07-0.64s-0.68 0.59-1.21 0.49c-0.54-0.11-1.27-0.89-1.27-0.89z"></path><g fill="#c8b100"><ellipse cx="324.82" cy="216.2" rx="1.38" ry="1.96"></ellipse><ellipse cx="324.85" cy="216.2" rx="0.63" ry="1.81"></ellipse><ellipse stroke="none" cx="324.84" cy="213.95" rx="0.93" ry="0.88"></ellipse><path stroke-width="0.3" d="m326.13 213.64v0.58h-2.53v-0.58h0.94v-1.3h-0.62v-0.58h0.62v-0.58h0.61v0.58h0.61v0.58h-0.61v1.3h0.98"></path><path fill="none" d="m325.11,213.12a0.93,0.88 0 1,1 -0.51,-0.01"></path></g><g fill="none" stroke-width="0.21"><path stroke-width="0.26" stroke-linecap="round" d="m314.41 219.99c-0.13-0.33-0.22-0.7-0.22-1.08 0-1.59 1.26-2.88 2.83-2.88 0.5 0 0.96 0.13 1.37 0.37"></path><path stroke-width="0.26" d="m319.48 217.93c-0.15-0.26-0.29-0.54-0.29-0.84 0-1.15 1.19-2.08 2.64-2.08 0.62 0 1.2 0.17 1.65 0.45"></path><path stroke-width="0.26" d="m330.17 217.96c0.15-0.26 0.25-0.57 0.25-0.87 0-1.15-1.18-2.08-2.64-2.08-0.62 0-1.19 0.17-1.64 0.45"></path><path stroke-width="0.26" stroke-linecap="round" d="m335.21 219.99c0.13-0.33 0.21-0.7 0.21-1.08 0-1.59-1.26-2.88-2.82-2.88-0.5 0-0.97 0.13-1.38 0.37"></path><ellipse cx="313.57" cy="218.68" rx="0.45" ry="0.43"></ellipse><ellipse cx="313.74" cy="217.1" rx="0.45" ry="0.43"></ellipse><ellipse cx="314.76" cy="215.9" rx="0.45" ry="0.43"></ellipse><ellipse cx="316.11" cy="215.25" rx="0.45" ry="0.43"></ellipse><ellipse cx="317.55" cy="215.31" rx="0.45" ry="0.43"></ellipse><ellipse fill="#fff" cx="318.43" cy="217.08" rx="0.45" ry="0.43"></ellipse><ellipse cx="318.68" cy="215.58" rx="0.45" ry="0.43"></ellipse><ellipse cx="319.81" cy="214.64" rx="0.45" ry="0.43"></ellipse><ellipse cx="321.23" cy="214.19" rx="0.45" ry="0.43"></ellipse><ellipse cx="322.67" cy="214.24" rx="0.45" ry="0.43"></ellipse><ellipse cx="326.94" cy="214.24" rx="0.45" ry="0.43"></ellipse><ellipse cx="328.39" cy="214.19" rx="0.45" ry="0.43"></ellipse><ellipse cx="329.8" cy="214.64" rx="0.45" ry="0.43"></ellipse><ellipse cx="330.93" cy="215.58" rx="0.45" ry="0.43"></ellipse><ellipse fill="#fff" cx="331.18" cy="217.08" rx="0.45" ry="0.43"></ellipse><ellipse cx="332.06" cy="215.31" rx="0.45" ry="0.43"></ellipse><ellipse cx="333.51" cy="215.25" rx="0.45" ry="0.43"></ellipse><ellipse cx="334.86" cy="215.9" rx="0.45" ry="0.43"></ellipse><ellipse cx="335.88" cy="217.1" rx="0.45" ry="0.43"></ellipse><ellipse cx="336.05" cy="218.68" rx="0.45" ry="0.43"></ellipse></g><g fill="#c8b100" transform="matrix(1, 0, 0, 1, 149.1699981689453, 0)"><path d="m168.58 224.25c-0.2-0.57-0.58-1.08-0.58-1.08 1.95-0.57 4.66-0.93 7.67-0.94 3.01 0.01 5.75 0.37 7.69 0.94 0 0-0.22 0.38-0.52 0.91-0.17 0.3-0.39 0.81-0.38 0.81-1.75-0.54-4.02-0.81-6.8-0.82-2.79 0.01-5.46 0.35-6.86 0.86 0.02 0-0.1-0.32-0.23-0.68h0.01"></path><path d="m175.67 226.73c2.43-0.01 5.11-0.38 6.1-0.63 0.66-0.2 1.05-0.49 0.98-0.84-0.04-0.16-0.18-0.3-0.37-0.38-1.46-0.47-4.07-0.8-6.71-0.8-2.63 0-5.27 0.33-6.72 0.8-0.19 0.08-0.33 0.22-0.37 0.38-0.07 0.35 0.32 0.64 0.98 0.84 0.99 0.25 3.68 0.62 6.11 0.63z"></path><path d="m183.48 222.08l-0.59-0.53s-0.57 0.34-1.28 0.24c-0.7-0.11-0.93-0.97-0.93-0.97s-0.79 0.67-1.44 0.62c-0.65-0.06-1.07-0.62-1.07-0.62s-0.71 0.51-1.33 0.46c-0.62-0.06-1.21-0.83-1.21-0.83s-0.63 0.8-1.25 0.86c-0.62 0.05-1.13-0.54-1.13-0.54s-0.28 0.59-1.07 0.72-1.47-0.62-1.47-0.62-0.45 0.73-0.99 0.92c-0.54 0.18-1.24-0.27-1.24-0.27s-0.12 0.27-0.2 0.43-0.31 0.19-0.31 0.19l0.18 0.47c1.93-0.56 4.56-0.91 7.53-0.91s5.67 0.35 7.61 0.92l0.2-0.54h-0.01z"></path><path d="m175.69 219.49l0.28 0.05c-0.05 0.12-0.06 0.24-0.06 0.38 0 0.58 0.5 1.05 1.12 1.05 0.49 0 0.91-0.31 1.06-0.73 0.01 0.01 0.11-0.38 0.15-0.38 0.03 0 0.03 0.41 0.05 0.41 0.07 0.53 0.55 0.89 1.1 0.89 0.62 0 1.11-0.47 1.11-1.06 0-0.04 0-0.08-0.01-0.12l0.35-0.35 0.19 0.44c-0.07 0.14-0.1 0.29-0.1 0.46 0 0.56 0.47 1.01 1.06 1.01 0.37 0 0.69-0.18 0.88-0.45l0.23-0.29v0.36c0 0.34 0.14 0.66 0.49 0.71 0 0 0.38 0.03 0.91-0.38 0.52-0.41 0.8-0.75 0.8-0.75l0.03 0.42s-0.51 0.84-0.97 1.1c-0.25 0.15-0.64 0.31-0.95 0.25-0.32-0.05-0.55-0.31-0.67-0.61-0.23 0.14-0.51 0.22-0.8 0.22-0.63 0-1.2-0.35-1.42-0.86-0.29 0.31-0.69 0.5-1.16 0.5-0.51 0-0.97-0.23-1.26-0.58-0.28 0.27-0.67 0.43-1.09 0.43-0.55 0-1.05-0.28-1.33-0.69-0.29 0.41-0.78 0.69-1.34 0.69-0.42 0-0.81-0.16-1.09-0.43-0.29 0.35-0.75 0.58-1.25 0.58-0.48 0-0.88-0.19-1.17-0.5-0.22 0.51-0.79 0.86-1.42 0.86-0.29 0-0.56-0.08-0.79-0.22-0.12 0.3-0.35 0.56-0.68 0.61-0.3 0.06-0.69-0.1-0.94-0.25-0.47-0.26-1.02-1.1-1.02-1.1l0.07-0.42s0.29 0.34 0.81 0.75 0.91 0.38 0.91 0.38c0.34-0.05 0.49-0.37 0.49-0.71v-0.36l0.22 0.29c0.19 0.27 0.51 0.45 0.88 0.45 0.59 0 1.06-0.45 1.06-1.01 0-0.17-0.02-0.32-0.1-0.46l0.19-0.44 0.35 0.35c-0.01 0.04-0.01 0.08-0.01 0.12 0 0.59 0.49 1.06 1.11 1.06 0.55 0 1.03-0.36 1.11-0.89 0.01 0 0.01-0.41 0.04-0.41 0.05 0 0.14 0.39 0.16 0.38 0.14 0.42 0.56 0.73 1.06 0.73 0.61 0 1.11-0.47 1.11-1.05 0-0.14 0-0.26-0.05-0.38l0.29-0.05h0.01z"></path><path stroke-linejoin="round" d="m175.67 222.23c-3.01 0.01-5.72 0.37-7.67 0.94-0.13 0.04-0.29-0.06-0.33-0.17-0.04-0.13 0.05-0.28 0.18-0.32 1.95-0.6 4.73-0.98 7.82-0.98s5.88 0.38 7.83 0.98c0.13 0.04 0.22 0.19 0.18 0.32-0.04 0.11-0.2 0.21-0.33 0.17-1.95-0.57-4.67-0.93-7.68-0.94z"></path><path d="m165.43 221c-0.01 0.01-0.38-0.48-0.65-0.73-0.2-0.18-0.68-0.33-0.68-0.33 0-0.08 0.28-0.28 0.58-0.28 0.18 0 0.35 0.07 0.45 0.2l0.04-0.2s0.24 0.05 0.35 0.32c0.12 0.29 0.05 0.72 0.05 0.72s-0.05 0.2-0.14 0.3z"></path><path d="m167.32 220.22l-0.11 0.66-1.4 0.15-0.21-0.12 0.04-0.23 1.06-0.87 0.62 0.41"></path><path d="m165.45 220.75c0.12-0.12 0.36-0.09 0.53 0.06 0.18 0.15 0.24 0.38 0.12 0.5-0.12 0.13-0.36 0.1-0.53-0.06-0.18-0.15-0.24-0.38-0.12-0.5z"></path><path d="m168.02 220.88c-0.06-0.18 0-0.37 0.13-0.42 0.14-0.03 0.3 0.09 0.37 0.27 0.06 0.19 0 0.38-0.14 0.42-0.13 0.04-0.29-0.08-0.36-0.27z"></path><path d="m168.67 220.04l0.51 0.48 1.22-0.66 0.09-0.21-0.17-0.17-1.4-0.12-0.25 0.68"></path><path d="m170.08 217.76l-0.67 0.64 0.86 1.14 0.23 0.09 0.17-0.18 0.3-1.37-0.89-0.32"></path><path d="m172.36 219.3l-0.26 0.63-1.4-0.13-0.18-0.16 0.1-0.22 1.22-0.64 0.52 0.52"></path><ellipse cx="170.51" cy="219.65" rx="0.49" ry="0.47"></ellipse><path d="m172.87 219.95c-0.03-0.2 0.07-0.37 0.21-0.39s0.28 0.13 0.3 0.33c0.03 0.19-0.07 0.37-0.21 0.38-0.14 0.02-0.28-0.13-0.3-0.32z"></path><path d="m173.78 219.24l0.4 0.57 1.34-0.42 0.14-0.18-0.15-0.2-1.33-0.39-0.4 0.62"></path><path d="m175.66 217.15l-0.86 0.52 0.64 1.38 0.22 0.14 0.22-0.14 0.64-1.38-0.86-0.52"></path><path d="m177.55 219.24l-0.39 0.57-1.34-0.42-0.14-0.18 0.14-0.2 1.34-0.39 0.39 0.62"></path><ellipse cx="175.67" cy="219.21" rx="0.49" ry="0.47"></ellipse><path d="m178.5 219.95c0.02-0.2-0.08-0.37-0.22-0.39s-0.28 0.13-0.3 0.33c-0.02 0.19 0.07 0.37 0.21 0.38 0.14 0.02 0.28-0.13 0.31-0.32z"></path><path d="m178.99 219.3l0.26 0.63 1.4-0.13 0.18-0.16-0.1-0.22-1.22-0.64-0.52 0.52"></path><path d="m181.27 217.76l0.67 0.64-0.86 1.14-0.23 0.09-0.17-0.18-0.3-1.37 0.89-0.32"></path><path d="m182.68 220.04l-0.51 0.48-1.22-0.66-0.1-0.21 0.19-0.17 1.4-0.12 0.24 0.68"></path><ellipse cx="180.85" cy="219.65" rx="0.49" ry="0.47"></ellipse><path d="m183.34 220.88c0.06-0.18 0-0.37-0.13-0.42-0.14-0.03-0.3 0.09-0.37 0.27-0.06 0.19 0 0.38 0.14 0.42 0.13 0.04 0.29-0.08 0.36-0.27z"></path><path d="m185.73 221c0.01 0.01 0.38-0.48 0.66-0.73 0.19-0.18 0.67-0.33 0.67-0.33 0-0.08-0.28-0.28-0.58-0.28-0.18 0-0.35 0.07-0.45 0.2l-0.04-0.2s-0.24 0.05-0.36 0.32c-0.11 0.29-0.03 0.72-0.03 0.72s0.04 0.2 0.13 0.3z"></path><path d="m183.84 220.22l0.11 0.66 1.4 0.15 0.21-0.12-0.05-0.23-1.05-0.87-0.62 0.41"></path><path d="m185.74 220.75c-0.11-0.12-0.35-0.09-0.53 0.06s-0.24 0.38-0.12 0.5c0.12 0.13 0.36 0.1 0.54-0.06 0.18-0.15 0.23-0.38 0.11-0.5z"></path></g><g fill="none" transform="matrix(1, 0, 0, 1, 149.1699981689453, 0)"><path fill="#ad1519" d="m168.05 224.3l0.31-0.5 0.65 0.13-0.38 0.56-0.58-0.19"></path><path fill="#058e6e" d="m170.85 223.81l-0.69 0.11c-0.18 0.02-0.35-0.09-0.38-0.26-0.02-0.17 0.1-0.32 0.27-0.35l0.7-0.1 0.71-0.11c0.18-0.02 0.34 0.09 0.37 0.25 0.02 0.17-0.1 0.33-0.27 0.35l-0.71 0.11"></path><ellipse fill="#fff" cx="173.19" cy="223.3" rx="0.44" ry="0.41"></ellipse><path fill="#ad1519" d="m175.7 223.48h-0.96c-0.18 0-0.33-0.14-0.33-0.31s0.14-0.31 0.32-0.31h1.96c0.19 0 0.33 0.14 0.33 0.31s-0.15 0.31-0.33 0.31h-0.99"></path><ellipse fill="#fff" cx="178.16" cy="223.3" rx="0.44" ry="0.41"></ellipse><path fill="#058e6e" d="m180.5 223.81l0.69 0.11c0.18 0.02 0.35-0.09 0.38-0.26 0.02-0.17-0.09-0.32-0.27-0.35l-0.7-0.1-0.71-0.11c-0.18-0.02-0.35 0.09-0.37 0.25-0.03 0.17 0.09 0.33 0.27 0.35l0.71 0.11"></path><path fill="#ad1519" d="m183.24 224.33l-0.25-0.53-0.67 0.06 0.32 0.59 0.6-0.12"></path><path fill="#ad1519" stroke-linejoin="round" d="m175.66 226.16c-2.43 0-4.63-0.22-6.3-0.65 1.67-0.43 3.87-0.69 6.3-0.7 2.44 0 4.65 0.27 6.33 0.7-1.68 0.43-3.89 0.65-6.33 0.65z"></path><path stroke-width="0.01" d="m176.8 226.08v-1.16m-0.58 1.2l0.01-1.23m-0.43 1.25v-1.26"></path><path stroke-width="0.02" d="m175.44 226.15v-1.27"></path><path stroke-width="0.03" d="m175.09 226.15v-1.27"></path><path stroke-width="0.04" d="m174.77 226.15v-1.27"></path><path stroke-width="0.04" d="m174.44 226.15v-1.27"></path><path stroke-width="0.05" d="m174.16 226.15v-1.27"></path><path stroke-width="0.06" d="m173.61 226.08l-0.01-1.15m0.27 1.17v-1.21"></path><path stroke-width="0.07" d="m173.1 226.03v-1.06m0.26 1.09l-0.01-1.13"></path><path stroke-width="0.08" d="m172.42 225.97v-0.93m0.23 0.94v-0.98m0.23 1.02v-1.02"></path><path stroke-width="0.09" d="m172.19 225.96v-0.9"></path><path stroke-width="0.1" d="m171.97 225.92v-0.85"></path><path stroke-width="0.11" d="m171.73 225.89v-0.78"></path><path stroke-width="0.12" d="m171.24 225.82l-0.01-0.62m0.26 0.66v-0.7"></path><path stroke-width="0.12" d="m170.99 225.77v-0.55"></path><path stroke-width="0.13" d="m170.76 225.73v-0.46"></path><path stroke-width="0.14" d="m170.51 225.67v-0.36"></path><path stroke-width="0.15" d="m170.26 225.64v-0.27"></path><path stroke-width="0.18" d="m169.99 225.58v-0.13"></path></g></g><g id="pillar_right" transform="matrix(1, 0, 0, 1, 149.1699981689453, 0)"><g fill="#005bbf"><path d="m191.28 330.68c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.32-3.91 0.83-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.54-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.33 3.92-0.86 1.01-0.52 2.4-0.84 3.91-0.84 1.5 0 2.86 0.32 3.86 0.83 1.02 0.54 2.37 0.87 3.91 0.87l0.02-2.41z"></path><path fill="#ccc" d="m191.28 333.09c-1.54 0-2.91-0.33-3.93-0.87-1-0.51-2.36-0.83-3.86-0.83-1.51 0-2.9 0.32-3.91 0.84-1.01 0.53-2.4 0.86-3.92 0.86-1.54 0-2.92-0.37-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.41c1.53 0 2.93-0.35 3.95-0.88 1-0.52 2.34-0.82 3.86-0.82 1.45 0 2.79 0.31 3.79 0.8 1.01 0.54 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.84 3.91-0.84c1.5 0 2.86 0.32 3.86 0.84 1.02 0.53 2.37 0.86 3.91 0.86l0.02-2.41"></path><path d="m191.28 335.5c-1.54 0-2.91-0.33-3.93-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.36-3.93-0.9-1-0.49-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v2.4c1.53 0 2.93-0.34 3.95-0.88 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.37 0.86 3.91 0.86l0.02-2.4"></path><path fill="#ccc" d="m191.26 340.32c-1.54 0-2.89-0.33-3.91-0.87-1-0.51-2.36-0.82-3.86-0.82-1.51 0-2.9 0.31-3.91 0.83s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.79-3.79-0.79-1.52 0-2.86 0.29-3.86 0.81-1.02 0.53-2.42 0.88-3.95 0.88v-2.4c1.53 0 2.93-0.36 3.95-0.9 1-0.51 2.34-0.8 3.86-0.8 1.45 0 2.79 0.3 3.79 0.79 1.01 0.54 2.39 0.89 3.93 0.89 1.52 0 2.91-0.32 3.92-0.85 1.01-0.52 2.4-0.83 3.91-0.83 1.5 0 2.86 0.31 3.86 0.82 1.02 0.55 2.39 0.86 3.93 0.86l-0.02 2.42"></path><path d="m191.26 342.73c-1.54 0-2.89-0.33-3.91-0.86-1-0.52-2.36-0.84-3.86-0.84-1.51 0-2.9 0.32-3.91 0.84s-2.4 0.86-3.92 0.86c-1.54 0-2.92-0.37-3.93-0.9-1-0.5-2.33-0.8-3.79-0.8-1.52 0-2.86 0.3-3.86 0.82-1.02 0.53-2.42 0.88-3.95 0.88v-2.39c1.53 0 2.93-0.37 3.95-0.9 1-0.52 2.34-0.81 3.86-0.81 1.45 0 2.79 0.3 3.79 0.79 1.01 0.53 2.39 0.9 3.93 0.9 1.52 0 2.91-0.34 3.92-0.86s2.4-0.83 3.91-0.83c1.5 0 2.86 0.31 3.86 0.82 1.02 0.54 2.38 0.87 3.93 0.87l-0.02 2.41z"></path></g><g fill="#c8b100"><path stroke-linejoin="round" d="m166.92 320.78c0.05 0.21 0.13 0.4 0.13 0.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-0.21 0.04-0.41 0.09-0.62-0.13 0.05-0.29 0.06-0.44 0.06h-16.69c-0.13 0-0.29-0.02-0.41-0.06z"></path><path d="m167.33 319.27h16.69c0.57 0 1.02 0.35 1.02 0.78s-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.36-1.02-0.79s0.46-0.78 1.02-0.78z"></path><path d="m164.27 329.86h22.87v-5.83h-22.87v5.83z"></path></g><path fill="#ccc" d="m167.55 318.32h16.25v-79.63h-16.25v79.63z"></path><path fill="none" d="m179.13 238.8v79.46m1.83-79.46v79.46"></path><g fill="#c8b100"><path d="m164.58 232.37h22.29v-5.84h-22.29v5.84z"></path><path stroke-linejoin="round" d="m166.92 236.26c0.14-0.06 0.24-0.07 0.41-0.07h16.69c0.17 0 0.32 0.03 0.46 0.08-0.58-0.19-0.99-0.71-0.99-1.32s0.45-1.14 1.03-1.33c-0.14 0.04-0.33 0.08-0.49 0.08h-16.7c-0.17 0-0.33-0.01-0.47-0.06l0.09 0.02c0.6 0.18 0.94 0.71 0.94 1.29 0 0.56-0.38 1.13-0.97 1.31z"></path><path d="m167.33 236.19h16.69c0.57 0 1.02 0.35 1.02 0.78 0 0.44-0.45 0.79-1.02 0.79h-16.69c-0.56 0-1.02-0.35-1.02-0.79 0-0.43 0.46-0.78 1.02-0.78z"></path><path d="m167.33 232.37h16.7c0.57 0 1.03 0.3 1.03 0.66 0 0.37-0.46 0.67-1.03 0.67h-16.7c-0.56 0-1.02-0.3-1.02-0.67 0-0.36 0.46-0.66 1.02-0.66z"></path></g></g><g id="ribbon_right" fill="#ad1519" transform="matrix(-1, 0, 0, 1, 500.57000732421875, 0)"><path d="m162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31 0.12 0.61 0.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-0.9-3.56-2.34-4.64z"></path><path stroke-linejoin="round" d="m200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39 0.02-5.04 0.25-7.79 0.7-9.72 1.63-17.13 5.51-16.54 8.67 0.01 0.06 0.04 0.2 0.05 0.26 0 0-3.64-8.21-3.7-8.52-0.65-3.51 7.56-7.82 18.35-9.62 3.39-0.57 6.69-0.79 9.56-0.76 6.9 0 12.9 0.89 16.52 2.23l0.04 9.82"></path><path d="m167.52 278.47c-4.51-0.32-7.58-1.53-7.94-3.41-0.28-1.5 1.25-3.17 3.97-4.68 1.21 0.14 2.58 0.3 4 0.3l-0.03 7.79"></path><path d="m183.83 272.38c2.82 0.43 4.93 1.13 5.98 1.99l0.1 0.17c0.5 1.03-1.97 3.22-6.11 5.67l0.03-7.83"></path><path stroke-linejoin="round" d="m157.42 293.83c-0.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-0.09-0.17c0.46 0.38 1.18 8.24 1.18 8.24 0.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-0.01z"></path></g><g id="plus_ultra" fill="#c8b100" stroke="none"><path d="m166.42 264.65c1.99-0.72 3.29-1.58 2.66-3.14-0.41-1-1.43-1.19-2.97-0.63l-2.71 0.99 2.44 6.03c0.27-0.12 0.54-0.24 0.81-0.34 0.28-0.1 0.57-0.18 0.85-0.26l-1.08-2.64v-0.01zm-1.18-2.91l0.69-0.25c0.57-0.21 1.21 0.1 1.5 0.8 0.21 0.53 0.16 1.13-0.5 1.55-0.21 0.13-0.46 0.23-0.7 0.33l-0.99-2.43"></path><path d="m172.78 259.22c-0.29 0.08-0.57 0.16-0.86 0.22-0.29 0.05-0.59 0.09-0.88 0.12l1.41 6.28 4.38-0.88c-0.05-0.12-0.12-0.26-0.14-0.38-0.03-0.14-0.03-0.28-0.04-0.41-0.77 0.22-1.61 0.46-2.61 0.66l-1.26-5.61"></path><path d="m181.56 264.63c0.82-2.28 1.82-4.46 2.81-6.67-0.18 0.03-0.36 0.06-0.54 0.07s-0.37 0.01-0.54 0c-0.53 1.61-1.18 3.21-1.87 4.8-0.82-1.51-1.73-2.99-2.43-4.51-0.34 0.04-0.69 0.09-1.03 0.12-0.34 0.02-0.7 0.01-1.04 0.02 1.26 2.06 2.48 4.11 3.64 6.23 0.16-0.03 0.32-0.06 0.5-0.08 0.16-0.01 0.33 0.01 0.5 0.02"></path><path d="m190.72 259.8c0.15-0.31 0.31-0.6 0.48-0.89-0.24-0.22-0.96-0.55-1.81-0.63-1.79-0.18-2.81 0.61-2.93 1.69-0.26 2.26 3.31 2.07 3.14 3.57-0.07 0.64-0.75 0.9-1.48 0.83-0.81-0.08-1.41-0.53-1.51-1.19l-0.22-0.02c-0.12 0.39-0.29 0.77-0.48 1.15 0.53 0.34 1.21 0.53 1.85 0.59 1.83 0.19 3.22-0.54 3.35-1.74 0.23-2.15-3.37-2.27-3.23-3.54 0.06-0.53 0.47-0.88 1.4-0.79 0.67 0.07 1.08 0.43 1.26 0.95l0.18 0.02"></path><path d="m310.3 264.98c0.62-2.33 1.41-4.58 2.19-6.87-0.17 0.05-0.35 0.09-0.53 0.11-0.17 0.03-0.36 0.04-0.54 0.05-0.37 1.64-0.88 3.29-1.42 4.94-0.96-1.44-2-2.84-2.83-4.3-0.34 0.07-0.68 0.15-1.02 0.2s-0.69 0.07-1.04 0.11c1.45 1.94 2.85 3.89 4.2 5.91 0.16-0.04 0.32-0.1 0.5-0.12 0.16-0.02 0.33-0.02 0.49-0.03"></path><path d="m316.48 258.16c-0.29 0.01-0.59 0.04-0.88 0.03-0.3 0-0.6-0.04-0.89-0.06l-0.12 6.41 4.49 0.08c-0.03-0.13-0.06-0.28-0.06-0.41s0.04-0.27 0.07-0.4c-0.81 0.05-1.68 0.1-2.71 0.08l0.1-5.73"></path><path d="m323.52 259.21c0.72 0.06 1.41 0.19 2.1 0.31-0.01-0.13-0.03-0.27-0.02-0.41 0.01-0.13 0.06-0.26 0.1-0.39l-6.07-0.5c0.01 0.14 0.03 0.27 0.02 0.4-0.01 0.14-0.06 0.27-0.1 0.4 0.62-0.02 1.37-0.02 2.21 0.05l-0.53 5.77c0.29 0 0.59 0 0.88 0.03 0.3 0.02 0.59 0.07 0.88 0.11l0.53-5.77"></path><path d="m326.01 265.53c0.29 0.05 0.59 0.09 0.88 0.15 0.28 0.06 0.57 0.15 0.85 0.23l0.72-2.94 0.08 0.01c0.16 0.41 0.38 0.9 0.49 1.19l0.9 2.22c0.36 0.06 0.71 0.11 1.05 0.18 0.36 0.08 0.7 0.18 1.04 0.28l-0.31-0.67c-0.48-1-0.99-2.01-1.41-3.02 1.12 0.04 1.98-0.36 2.2-1.26 0.15-0.62-0.1-1.11-0.68-1.53-0.44-0.31-1.28-0.47-1.83-0.6l-2.44-0.53-1.54 6.29m3.14-5.42c0.71 0.16 1.59 0.27 1.59 1.07-0.01 0.21-0.03 0.35-0.06 0.48-0.23 0.94-0.94 1.26-2.13 0.91l0.6-2.46"></path><path d="m337.57 267.46c-0.05 0.69-0.18 1.37-0.31 2.1 0.3 0.14 0.61 0.27 0.9 0.44 0.3 0.16 0.57 0.34 0.86 0.52l0.6-7.23c-0.14-0.06-0.27-0.12-0.41-0.19-0.13-0.07-0.25-0.15-0.37-0.24l-6.38 4.05c0.17 0.08 0.35 0.16 0.51 0.25 0.17 0.09 0.31 0.19 0.47 0.28 0.54-0.45 1.1-0.82 1.74-1.3l2.39 1.31v0.01zm-1.81-1.66l2.13-1.37-0.25 2.4-1.88-1.03"></path></g></g><g id="crown_crest"><path fill="#ad1519" stroke-width="0.26" d="m249.65 182.72c6.64 0 12.56 0.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47 0.33 4.81 0.39 6.85 0.24 2.73-0.06 6.67 0.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-0.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6 0.21-0.79 2.25-32.91-3.86-33.02 3.86-0.79-2.25-2.61-0.21-5.08-4.07-2.15-1.83-4.3-4.92-0.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04 0.15 4.38 0.09 6.85-0.24 3.24-0.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z"></path><g fill="#c8b100"><path d="m225.34 191.42l1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-0.31 0.02-0.61 0.06-0.91 0.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63 0.95 8.84 2.48 0.06-0.67 0.12-1.25 0.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81"></path><path d="m225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-0.03 0.31-0.05 0.61-0.05 0.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85"></path><path d="m202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41 0.33-2.75 0.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23 0.23 6.14 0.67-0.42 0.46-0.75 0.97-1.08 1.48-1.59-0.31-3.29-0.48-5.06-0.48-7.27 0-13.36 2.83-15.12 6.65-0.47 0.97-0.73 2.06-0.73 3.2 0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z"></path><path d="m204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-0.58 1.2-0.91 2.54-0.91 3.95 0 2.33 0.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3z"></path><path d="m250.04 171.27c1.76 0 3.28 1.16 3.64 2.73 0.23 1.38 0.38 2.95 0.41 4.62 0.01 0.18-0.01 0.35-0.01 0.52 0 0.2 0.04 0.41 0.05 0.61 0.06 3.52 0.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c0.72-1.9 1.22-5 1.29-8.52 0-0.2 0.04-0.41 0.04-0.61 0-0.17-0.01-0.34-0.01-0.52 0.03-1.67 0.18-3.24 0.41-4.62 0.36-1.57 1.94-2.73 3.7-2.73z"></path><path d="m250.04 172.94c0.91 0 1.68 0.58 1.87 1.39 0.23 1.31 0.37 2.8 0.4 4.38 0 0.16-0.01 0.32-0.01 0.48 0 0.2 0.03 0.39 0.04 0.59 0.05 3.32 0.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c0.67-1.8 1.15-4.73 1.21-8.05 0-0.2 0.04-0.39 0.04-0.59 0-0.16-0.01-0.32-0.01-0.48 0.03-1.58 0.17-3.07 0.4-4.38 0.18-0.81 1.02-1.39 1.93-1.39z"></path><path d="m274.7 191.42l-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-0.31-0.02-0.61-0.06-0.91-0.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63 0.95-8.84 2.48-0.06-0.67-0.12-1.25-0.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81"></path><path d="m274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23 0.03 0.31 0.05 0.61 0.05 0.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85"></path><path d="m297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-0.33-2.75-0.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23 0.23-6.15 0.67 0.43 0.46 0.76 0.97 1.09 1.48 1.58-0.31 3.29-0.48 5.06-0.48 7.27 0 13.35 2.83 15.11 6.65 0.47 0.97 0.73 2.06 0.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z"></path><path d="m295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34 0.58 1.2 0.91 2.54 0.91 3.95 0 2.33-0.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z"></path><ellipse fill="#005bbf" stroke-width="0.26" cx="250.05" cy="167.3" rx="4.43" ry="4.2"></ellipse><path stroke-width="0.26" d="m248.89 155.54v2.26h-2.42v2.3h2.42v3.15 3.46h-3.05c-0.03 0.21-0.22 0.37-0.22 0.59 0 0.58 0.12 1.14 0.35 1.64 0 0.02 0.02 0.02 0.03 0.03h8.12c0-0.01 0.02-0.01 0.03-0.03 0.22-0.5 0.35-1.06 0.35-1.64 0-0.22-0.19-0.38-0.22-0.59h-2.96v-3.43-3.18h2.42v-2.3h-2.42v-2.26h-2.43z"></path></g><g fill="#fff"><ellipse cx="250.04" cy="188.94" rx="1.91" ry="1.8"></ellipse><ellipse cx="250.04" cy="185.4" rx="1.91" ry="1.8"></ellipse><ellipse cx="250.04" cy="181.6" rx="1.52" ry="1.44"></ellipse><ellipse cx="250.04" cy="178.18" rx="1.1" ry="1.04"></ellipse><ellipse cx="250.04" cy="175.18" rx="0.88" ry="0.83"></ellipse><ellipse cx="198.94" cy="198.67" rx="1.1" ry="1.04"></ellipse><ellipse cx="197.44" cy="196.02" rx="1.1" ry="1.04"></ellipse><ellipse cx="196.44" cy="192.94" rx="1.1" ry="1.04"></ellipse><ellipse cx="196.31" cy="189.64" rx="1.1" ry="1.04"></ellipse><ellipse cx="197.12" cy="186.4" rx="1.1" ry="1.04"></ellipse><ellipse cx="198.81" cy="183.45" rx="1.1" ry="1.04"></ellipse><ellipse cx="201.06" cy="181.02" rx="1.1" ry="1.04"></ellipse><ellipse cx="203.68" cy="179.01" rx="1.1" ry="1.04"></ellipse><ellipse cx="206.8" cy="177.36" rx="1.1" ry="1.04"></ellipse><ellipse cx="210.04" cy="176.19" rx="1.1" ry="1.04"></ellipse><ellipse cx="213.66" cy="175.54" rx="1.1" ry="1.04"></ellipse><ellipse cx="217.1" cy="175.36" rx="1.1" ry="1.04"></ellipse><ellipse cx="220.47" cy="175.48" rx="1.1" ry="1.04"></ellipse><ellipse cx="224.21" cy="190.32" rx="1.1" ry="1.04"></ellipse><ellipse cx="222.34" cy="187.65" rx="1.1" ry="1.04"></ellipse><ellipse cx="221.35" cy="184.75" rx="1.1" ry="1.04"></ellipse><ellipse cx="221.47" cy="181.57" rx="1.1" ry="1.04"></ellipse><ellipse cx="222.16" cy="178.37" rx="1.1" ry="1.04"></ellipse><ellipse cx="223.84" cy="175.48" rx="1.1" ry="1.04"></ellipse><ellipse cx="226.4" cy="173.47" rx="1.1" ry="1.04"></ellipse><ellipse cx="229.39" cy="171.81" rx="1.1" ry="1.04"></ellipse><ellipse cx="232.7" cy="170.82" rx="1.1" ry="1.04"></ellipse><ellipse cx="236.13" cy="170.23" rx="1.1" ry="1.04"></ellipse><ellipse cx="239.5" cy="170.28" rx="1.1" ry="1.04"></ellipse><ellipse cx="242.99" cy="170.87" rx="1.1" ry="1.04"></ellipse><ellipse cx="246.23" cy="171.99" rx="1.1" ry="1.04"></ellipse><ellipse cx="253.8" cy="171.99" rx="1.1" ry="1.04"></ellipse><ellipse cx="257.04" cy="170.87" rx="1.1" ry="1.04"></ellipse><ellipse cx="260.54" cy="170.28" rx="1.1" ry="1.04"></ellipse><ellipse cx="263.9" cy="170.23" rx="1.1" ry="1.04"></ellipse><ellipse cx="267.34" cy="170.82" rx="1.1" ry="1.04"></ellipse><ellipse cx="270.64" cy="171.81" rx="1.1" ry="1.04"></ellipse><ellipse cx="273.64" cy="173.47" rx="1.1" ry="1.04"></ellipse><ellipse cx="276.19" cy="175.48" rx="1.1" ry="1.04"></ellipse><ellipse cx="277.88" cy="178.37" rx="1.1" ry="1.04"></ellipse><ellipse cx="278.57" cy="181.57" rx="1.1" ry="1.04"></ellipse><ellipse cx="278.69" cy="184.75" rx="1.1" ry="1.04"></ellipse><ellipse cx="277.69" cy="187.65" rx="1.1" ry="1.04"></ellipse><ellipse cx="275.83" cy="190.32" rx="1.1" ry="1.04"></ellipse><ellipse cx="279.57" cy="175.48" rx="1.1" ry="1.04"></ellipse><ellipse cx="282.94" cy="175.36" rx="1.1" ry="1.04"></ellipse><ellipse cx="286.38" cy="175.54" rx="1.1" ry="1.04"></ellipse><ellipse cx="290" cy="176.19" rx="1.1" ry="1.04"></ellipse><ellipse cx="293.24" cy="177.36" rx="1.1" ry="1.04"></ellipse><ellipse cx="296.36" cy="179.01" rx="1.1" ry="1.04"></ellipse><ellipse cx="298.97" cy="181.02" rx="1.1" ry="1.04"></ellipse><ellipse cx="301.22" cy="183.45" rx="1.1" ry="1.04"></ellipse><ellipse cx="302.91" cy="186.4" rx="1.1" ry="1.04"></ellipse><ellipse cx="303.72" cy="189.64" rx="1.1" ry="1.04"></ellipse><ellipse cx="303.6" cy="192.94" rx="1.1" ry="1.04"></ellipse><ellipse cx="302.6" cy="196.02" rx="1.1" ry="1.04"></ellipse><ellipse cx="301.1" cy="198.67" rx="1.1" ry="1.04"></ellipse></g><g fill="#c8b100"><path d="m250.15 226.18c-12.26-0.02-23.25-1.47-31.09-3.83-0.57-0.18-0.87-0.7-0.84-1.25-0.01-0.52 0.29-1 0.84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27 0.02 23.25 1.47 31.09 3.83 0.55 0.17 0.84 0.65 0.83 1.17 0.03 0.55-0.27 1.07-0.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83"></path><path d="m250.07 216.09c-12.41 0.03-23.55 1.58-31.39 4 0.65-0.31 0.59-1.12-0.22-3.2-0.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44 0.02 25.6 1.62 34.27 4.18 0 0-1.53-0.11-2.51 2.42-0.81 2.08-0.87 2.89-0.21 3.2-7.84-2.42-19.19-3.97-31.6-4"></path><path d="m250.12 210.3c-13.43 0.02-25.5 1.62-34.16 4.18-0.58 0.17-1.19-0.05-1.38-0.6s0.12-1.18 0.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77 0.03 26.19 1.71 34.9 4.38 0.58 0.17 0.89 0.8 0.7 1.35s-0.8 0.77-1.38 0.6c-8.67-2.56-20.78-4.16-34.22-4.18"></path><path d="m250.2 199.78l1.23 0.22c-0.19 0.5-0.24 1.05-0.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21 0.08 0.05 0.47-1.68 0.68-1.66 0.17 0.02 0.15 1.8 0.22 1.77 0.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-0.19-0.01-0.38-0.04-0.57l1.54-1.52 0.83 1.94c-0.33 0.61-0.46 1.3-0.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-0.78 3.9-1.97l0.99-1.25-0.01 1.53c0 1.55 0.66 2.93 2.16 3.18 0 0 1.73 0.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l0.2 1.8s-1.9 2.95-3.97 4.15c-1.14 0.66-2.86 1.35-4.23 1.13-1.44-0.24-2.48-1.4-3.01-2.74-1.03 0.61-2.25 0.97-3.55 0.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56-1.27 1.16-2.98 1.87-4.88 1.87-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-0.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-0.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-0.36-3.55-0.97-0.54 1.34-1.57 2.5-3.02 2.74-1.36 0.22-3.08-0.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l0.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-0.25 2.16-1.63 2.16-3.18l-0.01-1.53 0.99 1.25c0.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-0.73-0.13-1.42-0.46-2.03l0.83-1.94 1.54 1.52c-0.02 0.19-0.04 0.38-0.04 0.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93 0.06 0.03 0.05-1.75 0.22-1.77 0.2-0.02 0.6 1.71 0.67 1.66 0.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-0.58-0.03-1.13-0.24-1.63l1.29-0.22"></path><path d="m208.37 206.32c-0.11-0.37-0.35-0.75-0.72-1.06-0.79-0.68-1.84-0.79-2.36-0.25-0.07 0.07-0.13 0.17-0.17 0.25 0 0-1.11-2.08-2.41-2.78-1.29-0.7-3.49-0.52-3.49-0.52 0-1.6 1.3-2.89 2.99-2.89 0.99 0 1.92 0.41 2.48 1.11l0.23-1.07s1.36 0.27 1.98 1.82-0.06 3.8-0.06 3.8 0.34-0.96 0.85-1.61c0.51-0.64 1.81-1.34 2.49-1.66 0.67-0.31 1.37-0.79 1.37-0.79s0.03 0.18 0.05 0.61c0.03 0.51-0.01 0.83-0.01 0.83 1.24-0.17 2.69 0.04 3.83 0.48-0.49 0.95-1.41 1.84-2.62 2.3 0 0 0.44 0.36 0.83 0.75 0.34 0.34 0.44 0.49 0.44 0.49s-0.85 0.13-1.27 0.19c-0.43 0.05-1.84 0.28-2.69 0.22-0.62-0.04-1.32-0.14-1.74-0.22"></path><path fill="#ad1519" d="m205.29 205.01c0.52-0.54 1.57-0.43 2.36 0.25 0.8 0.67 1.02 1.66 0.51 2.19-0.51 0.54-1.57 0.42-2.36-0.25-0.79-0.68-1.02-1.66-0.51-2.19"></path><path fill="#fff" d="m216.39 205.91c-0.28-0.83-0.03-1.65 0.57-1.83 0.6-0.19 1.32 0.33 1.6 1.16s0.03 1.65-0.57 1.84c-0.6 0.18-1.31-0.34-1.6-1.17"></path><path d="m226.12 201.86c-0.33-0.27-0.59-0.64-0.67-1.08s0.01-0.87 0.23-1.23c0 0-0.88-0.44-1.83-0.69-0.72-0.19-1.99-0.2-2.37-0.2-0.38-0.02-1.15-0.03-1.15-0.03s0.07 0.17 0.28 0.55c0.27 0.46 0.5 0.75 0.5 0.75-1.27 0.29-2.35 1.12-3.03 2.09 0.99 0.68 2.3 1.1 3.6 0.97 0 0-0.12 0.34-0.2 0.86-0.06 0.43-0.06 0.61-0.06 0.61s0.71-0.26 1.07-0.39c0.35-0.13 1.54-0.55 2.15-0.96 0.8-0.54 1.48-1.25 1.48-1.25"></path><path d="m225.68 191.65c1.06 0.67 1.98 1.79 2.3 3.03 0 0 0.13-0.25 0.71-0.59 0.59-0.33 1.09-0.32 1.09-0.32s-0.17 0.97-0.25 1.32c-0.09 0.34-0.09 1.38-0.32 2.32-0.23 0.93-0.63 1.68-0.63 1.68-0.42-0.34-0.99-0.51-1.58-0.41-0.58 0.1-1.06 0.44-1.32 0.9 0 0-0.66-0.58-1.21-1.38-0.55-0.81-0.93-1.78-1.13-2.08-0.21-0.3-0.72-1.15-0.72-1.15s0.47-0.18 1.14-0.05c0.67 0.12 0.88 0.32 0.88 0.32-0.14-1.28 0.28-2.62 1.04-3.59"></path><path d="m228.97 201.38c0.22-0.35 0.32-0.79 0.24-1.23s-0.32-0.81-0.66-1.07c0 0 0.67-0.71 1.47-1.26 0.6-0.41 1.8-0.82 2.15-0.95 0.36-0.13 1.07-0.4 1.07-0.4s0 0.18-0.06 0.61c-0.08 0.52-0.2 0.87-0.2 0.87 1.3-0.14 2.62 0.29 3.61 0.98-0.69 0.97-1.77 1.79-3.04 2.08 0 0 0.23 0.28 0.5 0.74 0.21 0.39 0.28 0.56 0.28 0.56s-0.77-0.02-1.15-0.03c-0.38 0-1.65-0.01-2.37-0.2-0.95-0.25-1.84-0.69-1.84-0.69"></path><ellipse fill="#ad1519" cx="227.37" cy="200.45" rx="2.17" ry="2.06"></ellipse><path fill="#fff" d="m237.76 201.77c-0.11-0.87 0.31-1.63 0.93-1.7 0.63-0.07 1.23 0.57 1.34 1.44 0.11 0.86-0.3 1.63-0.93 1.7-0.62 0.07-1.22-0.57-1.34-1.44"></path><path d="m248.5 199.83c-0.32-0.36-0.53-0.82-0.53-1.33 0-0.5 0.19-0.97 0.51-1.32 0 0-0.89-0.67-1.89-1.12-0.77-0.35-2.18-0.59-2.6-0.67-0.43-0.08-1.28-0.24-1.28-0.24s0.04 0.2 0.2 0.67c0.2 0.56 0.4 0.93 0.4 0.93-1.47 0.08-2.85 0.81-3.81 1.76 0.96 0.94 2.34 1.66 3.81 1.75 0 0-0.2 0.36-0.4 0.93-0.16 0.46-0.2 0.67-0.2 0.67s0.85-0.16 1.28-0.24c0.42-0.08 1.83-0.32 2.6-0.67 1-0.46 1.91-1.11 1.91-1.11"></path><path d="m250.11 188.36c1.05 0.95 1.85 2.36 1.95 3.82 0 0 0.19-0.27 0.91-0.53 0.73-0.26 1.28-0.16 1.28-0.16s-0.39 1.05-0.55 1.42c-0.17 0.37-0.39 1.53-0.84 2.53-0.44 1-1.05 1.76-1.05 1.76-0.4-0.45-1-0.75-1.67-0.75-0.68 0-1.27 0.3-1.67 0.75 0 0-0.61-0.76-1.05-1.76-0.45-1-0.67-2.16-0.84-2.53s-0.56-1.42-0.56-1.42 0.56-0.1 1.28 0.16 0.92 0.53 0.92 0.53c0.1-1.46 0.86-2.87 1.89-3.82"></path><path d="m251.76 199.83c0.33-0.36 0.53-0.82 0.53-1.33 0-0.5-0.19-0.97-0.51-1.32 0 0 0.89-0.67 1.9-1.12 0.76-0.35 2.17-0.59 2.6-0.67 0.42-0.08 1.26-0.24 1.26-0.24s-0.02 0.2-0.19 0.67c-0.2 0.56-0.4 0.93-0.4 0.93 1.47 0.08 2.86 0.81 3.81 1.76-0.95 0.94-2.33 1.66-3.81 1.75 0 0 0.2 0.36 0.4 0.93 0.16 0.46 0.19 0.67 0.19 0.67l-1.26-0.24c-0.43-0.08-1.84-0.32-2.6-0.67-1.01-0.46-1.92-1.11-1.92-1.11"></path><ellipse fill="#ad1519" cx="250.14" cy="198.5" rx="2.17" ry="2.06"></ellipse><path fill="#fff" d="m262.58 201.77c0.11-0.87-0.3-1.63-0.93-1.7s-1.23 0.57-1.34 1.44c-0.11 0.86 0.31 1.63 0.93 1.7 0.63 0.07 1.23-0.57 1.34-1.44"></path><path d="m271.38 201.38c-0.22-0.35-0.32-0.79-0.25-1.23 0.09-0.44 0.33-0.81 0.67-1.07 0 0-0.67-0.71-1.47-1.26-0.61-0.41-1.8-0.82-2.16-0.95-0.35-0.13-1.06-0.4-1.06-0.4s-0.01 0.18 0.06 0.61c0.08 0.52 0.19 0.87 0.19 0.87-1.29-0.14-2.61 0.29-3.6 0.98 0.68 0.97 1.77 1.79 3.03 2.08 0 0-0.23 0.28-0.49 0.74-0.22 0.39-0.28 0.56-0.28 0.56l1.14-0.03c0.38 0 1.66-0.01 2.37-0.2 0.95-0.25 1.84-0.69 1.84-0.69"></path><path d="m274.67 191.65c-1.06 0.67-1.98 1.79-2.31 3.03 0 0-0.12-0.25-0.71-0.59-0.58-0.33-1.09-0.32-1.09-0.32s0.17 0.97 0.26 1.32c0.09 0.34 0.09 1.38 0.31 2.32 0.23 0.93 0.64 1.68 0.64 1.68 0.42-0.34 0.99-0.51 1.57-0.41 0.59 0.1 1.06 0.44 1.33 0.9 0 0 0.66-0.58 1.21-1.38 0.54-0.81 0.92-1.78 1.12-2.08 0.21-0.3 0.72-1.15 0.72-1.15s-0.47-0.18-1.14-0.05c-0.67 0.12-0.88 0.32-0.88 0.32 0.15-1.28-0.28-2.62-1.03-3.59"></path><path d="m274.22 201.86c0.34-0.27 0.6-0.64 0.67-1.08 0.09-0.44 0-0.87-0.22-1.23 0 0 0.88-0.44 1.83-0.69 0.72-0.19 1.99-0.2 2.36-0.2 0.39-0.02 1.15-0.03 1.15-0.03s-0.06 0.17-0.28 0.55c-0.26 0.46-0.49 0.75-0.49 0.75 1.26 0.29 2.34 1.12 3.03 2.09-0.99 0.68-2.31 1.1-3.6 0.97 0 0 0.11 0.34 0.19 0.86 0.06 0.43 0.06 0.61 0.06 0.61s-0.71-0.26-1.06-0.39c-0.36-0.13-1.55-0.55-2.16-0.96-0.79-0.54-1.48-1.25-1.48-1.25"></path><ellipse fill="#ad1519" cx="272.98" cy="200.45" rx="2.17" ry="2.06"></ellipse><path fill="#fff" d="m283.96 205.91c0.28-0.83 0.03-1.65-0.57-1.83-0.6-0.19-1.32 0.33-1.61 1.16-0.28 0.83-0.03 1.65 0.57 1.84 0.6 0.18 1.32-0.34 1.61-1.17"></path><path d="m291.97 206.32c0.11-0.37 0.36-0.75 0.72-1.06 0.79-0.68 1.85-0.79 2.36-0.25 0.07 0.07 0.14 0.17 0.18 0.25 0 0 1.1-2.08 2.4-2.78s3.5-0.52 3.5-0.52c0-1.6-1.31-2.89-3-2.89-0.99 0-1.92 0.41-2.47 1.11l-0.23-1.07s-1.36 0.27-1.98 1.82 0.05 3.8 0.05 3.8-0.33-0.96-0.84-1.61c-0.51-0.64-1.81-1.34-2.49-1.66-0.68-0.31-1.37-0.79-1.37-0.79s-0.03 0.18-0.06 0.61c-0.02 0.51 0.02 0.83 0.02 0.83-1.25-0.17-2.7 0.04-3.83 0.48 0.48 0.95 1.4 1.84 2.61 2.3 0 0-0.43 0.36-0.83 0.75-0.33 0.34-0.43 0.49-0.43 0.49s0.85 0.13 1.27 0.19c0.43 0.05 1.84 0.28 2.68 0.22 0.63-0.04 1.32-0.14 1.74-0.22"></path><path fill="#ad1519" d="m295.05 205.01c-0.51-0.54-1.57-0.43-2.36 0.25-0.79 0.67-1.02 1.66-0.51 2.19 0.51 0.54 1.57 0.42 2.36-0.25 0.79-0.68 1.02-1.66 0.51-2.19"></path></g><g fill="none"><path fill="#ad1519" stroke-linejoin="round" d="m250.12 224.57c-11.06-0.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07 0.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z"></path><path stroke-width="0.05" d="m258.04 224.28v-6.01m-3.02 6.21l0.04-6.37m-2.24 6.45v-6.49"></path><path stroke-width="0.09" d="m250.95 224.64v-6.57"></path><path stroke-width="0.14" d="m249.16 224.64v-6.57"></path><path stroke-width="0.18" d="m247.48 224.64v-6.57"></path><path stroke-width="0.23" d="m245.81 224.64v-6.57"></path><path stroke-width="0.28" d="m244.32 224.64v-6.57"></path><path stroke-width="0.33" d="m241.48 224.28l-0.04-5.97m1.39 6.05v-6.25"></path><path stroke-width="0.37" d="m238.86 224.01v-5.5m1.33 5.66l-0.04-5.86"></path><path stroke-width="0.42" d="m235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28"></path><path stroke-width="0.46" d="m234.12 223.66v-4.68"></path><path stroke-width="0.51" d="m232.97 223.42v-4.36"></path><path stroke-width="0.56" d="m231.74 223.31v-4.06"></path><path stroke-width="0.6" d="m229.22 222.95l-0.04-3.22m1.33 3.38v-3.62"></path><path stroke-width="0.63" d="m227.93 222.68v-2.84"></path><path stroke-width="0.68" d="m226.74 222.45v-2.36"></path><path stroke-width="0.73" d="m225.45 222.13v-1.85"></path><path stroke-width="0.77" d="m224.12 221.98v-1.38"></path><path stroke-width="0.91" d="m222.72 221.66v-0.67"></path><path d="m220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72 0.02 22.31 1.36 30.06 3.54"></path><path fill="#ad1519" d="m216.72 217.16l1.22-1.59 3.37 0.43-2.69 1.96-1.9-0.8"></path><path fill="#fff" d="m224.03 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"></path><path fill="#058e6e" d="m233.64 215.07l-2.36 0.27c-0.61 0.07-1.17-0.33-1.24-0.9-0.08-0.57 0.35-1.09 0.96-1.15l2.37-0.28 2.42-0.28c0.6-0.07 1.15 0.33 1.22 0.9s-0.36 1.09-0.96 1.16l-2.41 0.28"></path><path fill="#fff" d="m240.54 213.35c0-0.58 0.49-1.04 1.1-1.04 0.6 0 1.1 0.46 1.1 1.04 0 0.57-0.5 1.04-1.1 1.04-0.61 0-1.1-0.47-1.1-1.04"></path><path fill="#ad1519" d="m250.15 214.16h-3.29c-0.6 0-1.11-0.46-1.11-1.03 0-0.58 0.49-1.04 1.1-1.04h6.64c0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.51 1.03-1.11 1.03h-3.33"></path><path fill="#fff" d="m257.56 213.35c0-0.58 0.5-1.04 1.1-1.04 0.61 0 1.1 0.46 1.1 1.04 0 0.57-0.49 1.04-1.1 1.04-0.6 0-1.1-0.47-1.1-1.04"></path><path fill="#058e6e" d="m266.66 215.07l2.36 0.27c0.6 0.07 1.17-0.33 1.24-0.9s-0.36-1.09-0.96-1.15l-2.37-0.28-2.42-0.28c-0.61-0.07-1.15 0.33-1.22 0.9-0.08 0.57 0.36 1.09 0.96 1.16l2.41 0.28"></path><path fill="#fff" d="m274.07 215.28c0-0.58 0.49-1.04 1.1-1.04s1.1 0.46 1.1 1.04c0 0.57-0.49 1.04-1.1 1.04s-1.1-0.47-1.1-1.04"></path><path fill="#ad1519" d="m283.57 217.16l-1.21-1.59-3.37 0.43 2.69 1.96 1.89-0.8"></path></g></g><g id="shield" stroke-width="0.52"><g id="Granada"><path fill="#ccc" d="m250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3h100.42v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z"></path><path fill="#ffd691" d="m252.91 329.55c2.09 0.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-0.06-0.19-0.24-0.5-0.22-0.23-0.64-0.66-0.64-0.66s0.79-0.15 1.25 0.02c0.46 0.18 0.77 0.47 0.77 0.47s0.21-0.43 0.52-0.76c0.3-0.33 0.7-0.53 0.7-0.53s0.46 0.38 0.61 0.64c0.15 0.27 0.25 0.59 0.25 0.59s0.42-0.35 0.79-0.49c0.37-0.15 0.84-0.26 0.84-0.26s-0.13 0.46-0.22 0.69-0.14 0.72-0.14 0.72"></path><path fill="#058e6e" d="m250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-0.47-4.69-0.09-5.76-0.15 0.03 0.03 1.29 0.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22 0.81 6.19-0.2 6.19-0.2"></path><path fill="#058e6e" d="m251.46 340.56s2.54-2.66 5.21-3.02c3.15-0.44 5.22 0.26 6.44 0.58 0.03 0-1.01 0.49-1.56 0.87-0.55 0.37-1.97 1.57-4.14 1.59-2.18 0.03-4.58-0.23-4.97-0.17-0.4 0.06-0.98 0.15-0.98 0.15"></path><path fill="#ad1519" d="m250.69 337.28c-1-0.93-1.62-2.25-1.62-3.72 0-1.46 0.62-2.78 1.63-3.71 0.99 0.93 1.61 2.25 1.61 3.71 0 1.47-0.62 2.79-1.62 3.72"></path><path fill="#058e6e" d="m249.68 342.71s0.61-1.52 0.67-2.83c0.06-1.09-0.15-2.17-0.15-2.17h0.52 0.28s0.39 1.16 0.39 2.17c0 1.02-0.18 2.37-0.18 2.37s-0.55 0.08-0.73 0.17c-0.19 0.09-0.8 0.29-0.8 0.29"></path></g><g id="Aragon" fill="#c8b100"><path fill="#ad1519" d="m250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35"></path><path d="m200.03 314.12c0.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-0.07 33.8z"></path><path d="m211.08 334.23c1.57 0.83 3.72 2.22 6.03 2.77l-0.15-56.96h-5.88v54.19z"></path><path d="m222.28 338.25c2.3 0.23 4.01 0.19 5.87 0v-58.21h-5.87v58.21z"></path><path d="m233.32 337c2.3-0.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-0.15 56.96z"></path><path d="m244.81 329.24c2.45-2.18 4.75-7.12 5.59-12.76l0.14-36.44h-5.87l0.14 49.2z"></path></g><g id="Navarre"><path fill="#ad1519" d="m300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33"></path><path id="chains_half" fill="#c8b100" stroke="#c8b100" stroke-width="0.26" d="m272.71,306.14c0.05-0.14,0.12-0.27,0.19-0.4l-4.26-4.74-1.67,0.72-3.06-3.39,1-1.46-5.34-5.99c-0.07,0.02-0.2,0.02-0.27,0.04l0.03,4.02,1.75,0.5v4.46l-1.75,0.48-0.03,4.08c0.84,0.26,1.48,0.88,1.74,1.67l3.21,0.01,0.51-1.67h4.72l0.5,1.67zm-6.98-18.5,0,1.61,2.76,0,0-1.61zm-7.3,20.37c0.64,0,1.16-0.49,1.16-1.1s-0.52-1.11-1.16-1.11c-0.65,0-1.17,0.5-1.17,1.11s0.52,1.1,1.17,1.1zm15.99-9.73-1.76-0.48,0-4.46,1.76-0.5-0.01-1.92c-0.85-0.25-1.51-0.87-1.79-1.67h-2.68l-0.51,1.67h-4.71l-0.51-1.67h-3.09c-0.08,0.22-0.17,0.42-0.29,0.61l5.38,5.96,1.67-0.71,3.06,3.4-1,1.45,4.18,4.64c0.09-0.04,0.18-0.08,0.28-0.12zm-7.25-1.39-1.29,1.04,1.77,1.98,1.29-1.05zm8.00432,36.1859c-1.23998-0.065-2.25509-0.9022-2.51432-2.01593-1.67-0.23-3.25-0.66-4.73-1.3l0.84-1.43c1.29,0.55,2.66,0.91,4.08,1.11,0.31-0.66,0.86-1.16,1.58-1.4l0.01-5.62-1.76-0.49v-4.46l1.76-0.48v-7.64c-0.07-0.02-0.13-0.05-0.2-0.09l-3.98,4.42,1,1.44-3.06,3.4-1.67-0.71-3.3,3.67c0.57,0.87,0.55,2-0.11,2.85,0.94,1.05,2.03,1.98,3.24,2.75l-0.84,1.44c-1.42-0.89-2.7-1.99-3.79-3.22-0.87,0.26-1.86,0.11-2.6-0.5-1.15-0.93-1.29-2.56-0.3-3.64l0.14-0.16c-0.69-1.56-1.16-3.24-1.32-5l1.71,0.01c0.14,1.5,0.51,2.93,1.09,4.27,0.49-0.06,1-0.01,1.46,0.16l3.32-3.68-1-1.45,3.06-3.4,1.67,0.72,3.99-4.43c-0.09-0.14-0.15-0.29-0.21-0.46l-2.76,0.01-0.5,1.67h-4.72l-0.51-1.67-3.24-0.01c-0.27,0.76-0.9,1.36-1.69,1.62l-0.01,4.04-1.71-0.01v-4.01c-1.1-0.33-1.91-1.31-1.91-2.47,0-1.15,0.82-2.15,1.92-2.48l0.01-4.05-1.76-0.48v-4.46l1.76-0.5v-4.05c-1.08-0.35-1.84-1.32-1.84-2.45,0-1.43,1.22-2.58,2.73-2.58,1.22,0,2.25,0.74,2.61,1.78h3.09l0.51-1.67h4.71l0.51,1.67h2.68c0.35692-1.0311,1.36258-1.76731,2.55896-1.77984l0.0711,8.36984h-0.85v2.61h0.845l-0.0214,21.59h-0.7836v2.61h0.77946zm-5.914-18.306l-1.29-1.04-1.78,1.98,1.29,1.04zm-9.96-18.44-1.69,0-0.01,2.61,1.7,0zm9.16,11.41,0-1.6-2.85,0,0,1.6zm-10.6,9.69-1.76-0.39-0.25-4.45,1.75-0.58,0,2.56c0,0.99,0.09,1.92,0.26,2.86zm1.46-5.52,1.75,0.41s0.09,2.87,0.05,2.22c-0.04-0.74,0.19,2.24,0.19,2.24l-1.76,0.58c-0.18-0.9-0.24-1.84-0.24-2.79zm10.81,16.93,0.39-1.7c-1.52-0.48-2.93-1.18-4.17-2.09l-1.26,1.11c1.48,1.15,3.19,2.08,5.04,2.68zm-0.85,1.44-1.3,1.22c-1.47-0.54-2.86-1.26-4.12-2.11l0.38-1.77c1.5,1.13,3.21,2.03,5.04,2.66z"></path><path fill="#c8b100" stroke="#c8b100" stroke-width="0.26" d="m272.71,306.14c0.05-0.14,0.12-0.27,0.19-0.4l-4.26-4.74-1.67,0.72-3.06-3.39,1-1.46-5.34-5.99c-0.07,0.02-0.2,0.02-0.27,0.04l0.03,4.02,1.75,0.5v4.46l-1.75,0.48-0.03,4.08c0.84,0.26,1.48,0.88,1.74,1.67l3.21,0.01,0.51-1.67h4.72l0.5,1.67zm-6.98-18.5,0,1.61,2.76,0,0-1.61zm-7.3,20.37c0.64,0,1.16-0.49,1.16-1.1s-0.52-1.11-1.16-1.11c-0.65,0-1.17,0.5-1.17,1.11s0.52,1.1,1.17,1.1zm15.99-9.73-1.76-0.48,0-4.46,1.76-0.5-0.01-1.92c-0.85-0.25-1.51-0.87-1.79-1.67h-2.68l-0.51,1.67h-4.71l-0.51-1.67h-3.09c-0.08,0.22-0.17,0.42-0.29,0.61l5.38,5.96,1.67-0.71,3.06,3.4-1,1.45,4.18,4.64c0.09-0.04,0.18-0.08,0.28-0.12zm-7.25-1.39-1.29,1.04,1.77,1.98,1.29-1.05zm8.00432,36.1859c-1.23998-0.065-2.25509-0.9022-2.51432-2.01593-1.67-0.23-3.25-0.66-4.73-1.3l0.84-1.43c1.29,0.55,2.66,0.91,4.08,1.11,0.31-0.66,0.86-1.16,1.58-1.4l0.01-5.62-1.76-0.49v-4.46l1.76-0.48v-7.64c-0.07-0.02-0.13-0.05-0.2-0.09l-3.98,4.42,1,1.44-3.06,3.4-1.67-0.71-3.3,3.67c0.57,0.87,0.55,2-0.11,2.85,0.94,1.05,2.03,1.98,3.24,2.75l-0.84,1.44c-1.42-0.89-2.7-1.99-3.79-3.22-0.87,0.26-1.86,0.11-2.6-0.5-1.15-0.93-1.29-2.56-0.3-3.64l0.14-0.16c-0.69-1.56-1.16-3.24-1.32-5l1.71,0.01c0.14,1.5,0.51,2.93,1.09,4.27,0.49-0.06,1-0.01,1.46,0.16l3.32-3.68-1-1.45,3.06-3.4,1.67,0.72,3.99-4.43c-0.09-0.14-0.15-0.29-0.21-0.46l-2.76,0.01-0.5,1.67h-4.72l-0.51-1.67-3.24-0.01c-0.27,0.76-0.9,1.36-1.69,1.62l-0.01,4.04-1.71-0.01v-4.01c-1.1-0.33-1.91-1.31-1.91-2.47,0-1.15,0.82-2.15,1.92-2.48l0.01-4.05-1.76-0.48v-4.46l1.76-0.5v-4.05c-1.08-0.35-1.84-1.32-1.84-2.45,0-1.43,1.22-2.58,2.73-2.58,1.22,0,2.25,0.74,2.61,1.78h3.09l0.51-1.67h4.71l0.51,1.67h2.68c0.35692-1.0311,1.36258-1.76731,2.55896-1.77984l0.0711,8.36984h-0.85v2.61h0.845l-0.0214,21.59h-0.7836v2.61h0.77946zm-5.914-18.306l-1.29-1.04-1.78,1.98,1.29,1.04zm-9.96-18.44-1.69,0-0.01,2.61,1.7,0zm9.16,11.41,0-1.6-2.85,0,0,1.6zm-10.6,9.69-1.76-0.39-0.25-4.45,1.75-0.58,0,2.56c0,0.99,0.09,1.92,0.26,2.86zm1.46-5.52,1.75,0.41s0.09,2.87,0.05,2.22c-0.04-0.74,0.19,2.24,0.19,2.24l-1.76,0.58c-0.18-0.9-0.24-1.84-0.24-2.79zm10.81,16.93,0.39-1.7c-1.52-0.48-2.93-1.18-4.17-2.09l-1.26,1.11c1.48,1.15,3.19,2.08,5.04,2.68zm-0.85,1.44-1.3,1.22c-1.47-0.54-2.86-1.26-4.12-2.11l0.38-1.77c1.5,1.13,3.21,2.03,5.04,2.66z" transform="matrix(-1, 0, 0, 1, 550.4299926757812, 0)"></path><path fill="#058e6e" stroke="none" d="m272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58"></path></g><g id="Castile" fill="#c8b100" stroke-width="0.46"><path fill="#ad1519" stroke-width="0.52" d="m200.12 281.25h50.18v-55.72h-50.18v55.72z"></path><path d="m217.34 238.41h-0.92v-0.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.93v-0.92h-1.61v0.92h-1.16v-0.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v0.93h-0.93v-0.93h-1.62v0.93h-0.92v-0.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v0.92h-0.92v-0.92h-1.85v0.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7"></path><path d="m230.05 273.54v-4.86c0-0.92-0.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z"></path><path d="m222.19 268.91l-2.31-0.23c0-0.92 0.23-2.31 0.93-2.77l2.08 1.62c-0.23 0.23-0.7 0.92-0.7 1.38z"></path><path d="m226.12 266.6l1.16-2.08c-0.46-0.23-1.39-0.46-2.08-0.46-0.46 0-1.39 0.23-1.85 0.46l1.15 2.08h1.62z"></path><path d="m228.43 268.91l2.31-0.23c0-0.92-0.23-2.31-0.92-2.77l-2.08 1.62c0.23 0.23 0.69 0.92 0.69 1.38z"></path><path d="m221.73 260.83v-5.09c0-1.38-0.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08z"></path><path d="m228.89 260.83v-5.09c0-1.38 0.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09z"></path><path d="m220.11 248.35l0.23-4.62h-4.39l0.47 4.62h3.69z"></path><path d="m227.05 248.35l0.46-4.62h-4.39l0.23 4.62h3.7z"></path><path d="m230.51 248.35l-0.46-4.62h4.62l-0.46 4.62h-3.7z"></path><g fill="#0039f0" stroke="none"><path d="m228.43 273.54v-4.16c0-0.7-0.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24z"></path><path d="m221.27 260.36v-4.39c0-1.15-0.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16z"></path><path d="m229.36 260.36v-4.39c0-1.15 0.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z"></path></g></g><g id="Leon"><path fill="#ccc" d="m250.28 281.25h50.32v-55.72h-50.32v55.72z"></path><path fill="#db4446" stroke-width="0.39" d="m275.93 239.26l0.05-0.62 0.09-0.34s-1.61 0.13-2.46-0.11-1.61-0.59-2.4-1.25c-0.79-0.68-1.1-1.1-1.67-1.18-1.36-0.22-2.4 0.4-2.4 0.4s1.02 0.37 1.78 1.31 1.59 1.41 1.95 1.53c0.59 0.18 2.66 0.05 3.22 0.07 0.57 0.03 1.84 0.19 1.84 0.19z"></path><g fill="none" stroke-width="0.39"><path fill="#ed72aa" d="m283.46 237s0.01 0.72 0.08 1.4c0.06 0.67-0.22 1.24-0.11 1.61s0.16 0.66 0.3 0.93c0.14 0.26 0.21 0.94 0.21 0.94s-0.38-0.28-0.74-0.54c-0.35-0.27-0.6-0.44-0.6-0.44s0.07 0.72 0.1 1.03c0.04 0.31 0.22 0.89 0.51 1.24 0.29 0.33 0.87 0.89 1.05 1.33 0.18 0.45 0.14 1.44 0.14 1.44s-0.46-0.75-0.87-0.89c-0.39-0.14-1.26-0.62-1.26-0.62s0.79 0.79 0.79 1.55c0 0.75-0.32 1.6-0.32 1.6s-0.36-0.68-0.83-1.12c-0.47-0.45-1.13-0.9-1.13-0.9s0.52 1.17 0.52 1.95c0 0.79-0.15 2.47-0.15 2.47s-0.39-0.64-0.79-0.96c-0.4-0.31-0.87-0.58-1.02-0.78-0.14-0.21 0.48 0.64 0.54 1.16 0.07 0.51 0.32 2.35 1.92 4.69 0.94 1.37 2.39 3.77 5.5 2.98 3.11-0.78 1.96-4.97 1.3-6.92-0.65-1.95-0.98-4.11-0.94-4.87 0.04-0.75 0.58-2.97 0.51-3.39-0.07-0.41-0.24-2 0.14-3.28 0.4-1.33 0.73-1.85 0.95-2.4 0.21-0.55 0.39-0.86 0.46-1.34s0.07-1.37 0.07-1.37 0.58 1.06 0.73 1.44c0.14 0.38 0.14 1.5 0.14 1.5s0.11-1.12 0.98-1.67 1.88-1.13 2.13-1.44 0.33-0.51 0.33-0.51-0.08 1.92-0.62 2.67c-0.36 0.49-1.77 2.09-1.77 2.09s0.73-0.28 1.23-0.3c0.51-0.04 0.87 0 0.87 0s-0.62 0.48-1.41 1.64c-0.8 1.16-0.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08 0.87-0.5 4.34-0.36 4.86 0.15 0.51 2.03 4.76 2.07 5.79 0.03 1.03 0.21 3.33-1.6 4.8-1.16 0.95-3.07 0.96-3.51 1.23-0.43 0.28-1.29 1.13-1.29 2.91 0 1.79 0.64 2.06 1.15 2.51 0.51 0.44 1.16 0.2 1.3 0.55 0.15 0.34 0.22 0.54 0.44 0.75 0.21 0.2 0.36 0.44 0.29 0.82-0.08 0.38-0.91 1.23-1.2 1.85-0.29 0.61-0.87 2.23-0.87 2.47s-0.07 0.99 0.18 1.37c0 0 0.91 1.06 0.29 1.26-0.4 0.14-0.78-0.25-0.97-0.2-0.54 0.14-0.83 0.47-0.98 0.45-0.36-0.07-0.36-0.25-0.4-0.76-0.03-0.51-0.01-0.72-0.17-0.72-0.22 0-0.33 0.18-0.37 0.45s-0.04 0.89-0.29 0.89-0.61-0.45-0.83-0.55-0.83-0.2-0.87-0.48c-0.03-0.27 0.36-0.85 0.76-0.96 0.4-0.1 0.76-0.3 0.51-0.51-0.26-0.2-0.51-0.2-0.76 0-0.25 0.21-0.79 0.04-0.76-0.27 0.04-0.31 0.11-0.69 0.07-0.86-0.03-0.17-0.47-0.51 0.1-0.82 0.59-0.31 0.84 0.27 1.42 0.17s0.86-0.31 1.08-0.65 0.18-1.06-0.22-1.5c-0.39-0.45-0.79-0.52-0.94-0.8-0.14-0.27-0.36-0.92-0.36-0.92s0.11 1.2 0.04 1.37-0.04 0.89-0.04 0.89-0.39-0.45-0.72-0.79c-0.32-0.34-0.65-1.37-0.65-1.37s-0.03 0.96-0.03 1.34c0 0.37 0.43 0.72 0.29 0.86-0.15 0.13-0.83-0.72-1.02-0.86-0.18-0.14-0.76-0.58-1.01-1.06s-0.44-1.16-0.51-1.41c-0.07-0.24-0.19-1.31-0.07-1.58 0.18-0.4 0.47-1.13 0.47-1.13h-1.41c-0.76 0-1.3-0.23-1.59 0.28s-0.15 1.54 0.21 2.88c0.37 1.33 0.58 1.98 0.48 2.22-0.11 0.24-0.58 0.79-0.76 0.89-0.19 0.11-0.69 0.07-0.91-0.03-0.21-0.1-0.57-0.27-1.26-0.27s-1.12 0.03-1.37-0.03c-0.26-0.07-0.88-0.38-1.17-0.31s-0.79 0.32-0.65 0.72c0.22 0.61-0.21 0.75-0.51 0.72-0.29-0.04-0.53-0.14-0.9-0.24-0.36-0.11-0.9 0-0.83-0.42 0.07-0.41 0.22-0.44 0.4-0.74 0.18-0.32 0.25-0.52 0.04-0.54-0.25-0.02-0.51-0.05-0.7 0.11-0.2 0.16-0.51 0.51-0.76 0.38-0.26-0.14-0.46-0.43-0.46-1.08 0-0.64-0.68-1.2-0.05-1.17 0.62 0.03 1.41 0.48 1.55 0.13s0.06-0.51-0.28-0.78-0.76-0.43-0.31-0.77c0.45-0.35 0.56-0.35 0.74-0.54 0.17-0.18 0.41-0.79 0.73-0.64 0.62 0.3 0.02 0.73 0.65 1.42 0.62 0.69 1.01 0.94 2.06 0.83 1.04-0.11 1.33-0.24 1.33-0.54 0-0.29-0.09-0.82-0.12-1.04-0.02-0.21 0.15-0.99 0.15-0.99s-0.48 0.3-0.63 0.59c-0.13 0.29-0.42 0.8-0.42 0.8s-0.11-0.6-0.08-1.09c0.02-0.29 0.12-0.79 0.11-0.89-0.03-0.27-0.23-0.94-0.23-0.94s-0.16 0.73-0.28 0.94c-0.11 0.21-0.16 1.07-0.16 1.07s-0.67-0.58-0.48-1.55c0.13-0.75-0.12-1.74 0.11-2.06 0.22-0.33 0.75-1.64 2.06-1.69 1.3-0.05 2.31 0.05 2.77 0.03 0.45-0.03 2.06-0.33 2.06-0.33s-2.97-1.52-3.64-1.98c-0.68-0.45-1.73-1.63-2.07-2.16-0.34-0.54-0.65-1.58-0.65-1.58s-0.53 0.02-1.02 0.29c-0.48 0.27-0.96 0.67-1.24 0.99s-0.73 1.05-0.73 1.05 0.08-0.94 0.08-1.23-0.06-0.86-0.06-0.86-0.33 1.28-1.01 1.76c-0.68 0.49-1.47 1.15-1.47 1.15s0.08-0.71 0.08-0.88c0-0.16 0.17-0.99 0.17-0.99s-0.48 0.72-1.21 0.86c-0.74 0.13-1.81 0.11-1.9 0.56-0.08 0.45 0.2 1.07 0.03 1.39s-0.54 0.54-0.54 0.54-0.42-0.35-0.79-0.38c-0.36-0.03-0.71 0.16-0.71 0.16s-0.31-0.4-0.19-0.67c0.11-0.26 0.67-0.66 0.54-0.83-0.15-0.16-0.6 0.06-0.88 0.19-0.28 0.14-0.88 0.27-0.82-0.19 0.05-0.45 0.2-0.72 0.05-1.04-0.14-0.32-0.05-0.53 0.18-0.61 0.22-0.08 1.12 0.02 1.21-0.19 0.08-0.21-0.22-0.48-0.82-0.61-0.59-0.14-0.88-0.49-0.57-0.78 0.32-0.3 0.4-0.38 0.54-0.64 0.14-0.27 0.2-0.76 0.74-0.51 0.53 0.24 0.42 0.83 0.99 1.01 0.56 0.19 1.89-0.08 2.17-0.24s1.19-0.83 1.5-0.99c0.31-0.15 1.61-1.12 1.61-1.12s-0.76-0.53-1.05-0.8c-0.28-0.27-0.78-0.91-1.04-1.05-0.25-0.13-1.5-0.61-1.92-0.64-0.42-0.02-1.72-0.48-1.72-0.48s0.59-0.19 0.79-0.35c0.19-0.16 0.64-0.56 0.87-0.53 0.22 0.02 0.28 0.02 0.28 0.02s-1.21-0.05-1.47-0.13c-0.25-0.08-0.99-0.54-1.27-0.54s-0.84 0.11-0.84 0.11 0.76-0.48 1.38-0.59c0.62-0.1 1.1-0.08 1.1-0.08s-0.96-0.27-1.19-0.58c-0.22-0.33-0.45-0.8-0.62-1.02-0.17-0.21-0.28-0.56-0.59-0.59s-0.85 0.38-1.16 0.35-0.54-0.22-0.57-0.67c-0.02-0.46 0-0.3-0.1-0.54-0.12-0.24-0.57-0.8-0.15-0.93 0.43-0.14 1.33 0.08 1.42-0.08 0.08-0.16-0.48-0.65-0.85-0.83-0.37-0.19-0.96-0.51-0.65-0.78 0.31-0.26 0.62-0.37 0.79-0.61s0.37-0.91 0.74-0.7c0.36 0.21 0.87 1.26 1.16 1.18 0.28-0.08 0.3-0.83 0.25-1.15-0.06-0.32 0-0.88 0.28-0.83s0.51 0.43 0.96 0.46c0.45 0.02 1.13-0.11 1.07 0.21-0.05 0.32-0.31 0.71-0.62 1.06-0.3 0.36-0.45 1.05-0.25 1.5 0.2 0.46 0.71 1.19 1.16 1.48s1.3 0.51 1.84 0.85c0.53 0.35 1.78 1.34 2.2 1.45s0.85 0.32 0.85 0.32 0.48-0.21 1.13-0.21 2.14 0.1 2.71-0.14 1.3-0.64 1.08-1.15c-0.23-0.51-1.47-0.96-1.36-1.36s0.57-0.43 1.33-0.46c0.76-0.02 1.8 0.14 2-0.94 0.2-1.06 0.26-1.68-0.81-1.92-1.08-0.24-1.87-0.27-2.07-1.04-0.2-0.78-0.39-0.97-0.17-1.18 0.23-0.21 0.62-0.32 1.41-0.37 0.8-0.06 1.7-0.06 1.96-0.25 0.25-0.18 0.3-0.69 0.61-0.91 0.31-0.21 1.53-0.4 1.53-0.4s1.46 0.71 2.8 1.71c1.21 0.9 2.3 2.23 2.3 2.23"></path><path d="m269 243.39s-0.8 0.23-1.1 0.67c-0.37 0.53-0.34 1.07-0.34 1.07s0.68-0.56 1.56-0.33c0.87 0.24 0.96 0.33 1.33 0.3s1.27-0.35 1.27-0.35-0.74 0.86-0.65 1.45c0.08 0.58 0.19 0.85 0.17 1.15-0.06 0.72-0.6 1.61-0.6 1.61s0.31-0.19 1.05-0.35c0.73-0.16 1.36-0.51 1.75-0.81 0.39-0.29 0.9-1.02 0.9-1.02s-0.16 1 0 1.42c0.17 0.44 0.23 1.67 0.23 1.67s0.47-0.42 0.85-0.62c0.19-0.11 0.7-0.38 0.9-0.7 0.14-0.22 0.32-1.06 0.32-1.06s0.11 0.9 0.39 1.34c0.28 0.42 0.7 1.74 0.7 1.74s0.29-0.86 0.6-1.21 0.68-0.8 0.7-1.07c0.03-0.27-0.08-0.85-0.08-0.85l0.39 0.85m-11.41 0.61s0.48-0.83 0.93-1.1c0.46-0.26 1.08-0.74 1.25-0.8 0.16-0.05 0.9-0.46 0.9-0.46m0.99 5.17s1.09-0.55 1.41-0.75c0.68-0.4 1.16-1.12 1.16-1.12"></path><path fill="none" stroke-width="0.26" d="m282.57 240.9s-0.34-0.48-0.42-0.65c-0.09-0.15-0.23-0.48-0.23-0.48"></path><path fill="none" d="m278.33 257.41s2.04 1.26 1.98 2.31c-0.06 1.04-1.13 2.41-1.13 2.41"></path></g><path fill="#000" stroke-width="0.26" d="m273.05 236.24s-0.17-0.48-0.2-0.62c-0.03-0.13-0.12-0.29-0.12-0.29s0.88 0 0.85 0.27c-0.02 0.27-0.28 0.27-0.34 0.37-0.05 0.11-0.19 0.27-0.19 0.27z"></path><path fill="#000" stroke-width="0.05" d="m277.06 234.85l-0.06-0.43s0.77 0 1.13 0.26c0.57 0.4 0.93 1.02 0.91 1.05-0.1 0.09-0.54-0.27-0.85-0.37 0 0-0.23 0.05-0.45 0.05-0.23 0-0.34-0.11-0.37-0.21-0.03-0.12 0.03-0.3 0.03-0.3l-0.34-0.05z"></path><g fill="#000" stroke-width="0.26"><path d="m273.08 240.14l0.33-0.53 0.34 0.49-0.67 0.04"></path><path d="m273.89 240.12l0.4-0.53 0.43 0.48-0.83 0.05"></path><path d="m273.53 236.83l0.82 0.29-0.74 0.38-0.08-0.67"></path><path d="m274.52 237.1l0.73 0.18-0.59 0.46-0.14-0.64"></path></g><g fill="#db4446" stroke-width="0.39"><path d="m261.88 236.08s0.48 0.34 0.85 0.4c0.37 0.05 0.76 0.05 0.82 0.05 0.05 0 0.17-0.54 0.11-0.91-0.2-1.2-1.3-1.47-1.3-1.47s0.33 0.73 0.17 1.07c-0.23 0.48-0.65 0.86-0.65 0.86z"></path><path d="m259.59 237.12s-0.43-0.77-1.33-0.67c-0.9 0.11-1.5 0.81-1.5 0.81s1-0.03 1.25 0.13c0.37 0.24 0.48 0.86 0.48 0.86s0.54-0.32 0.71-0.54c0.16-0.21 0.39-0.59 0.39-0.59z"></path><path d="m258.49 240.25s-0.77 0.11-1.19 0.59c-0.43 0.49-0.36 1.4-0.36 1.4s0.5-0.54 0.95-0.54c0.46 0 1.16 0.16 1.16 0.16s-0.22-0.56-0.22-0.8-0.34-0.81-0.34-0.81z"></path><path d="m261.06 250.37s-0.42-0.45-1.16-0.32c-0.74 0.14-1.22 0.97-1.22 0.97s0.63-0.17 1-0.08c0.36 0.08 0.62 0.45 0.62 0.45s0.34-0.29 0.45-0.45 0.31-0.57 0.31-0.57z"></path><path d="m260.21 253.34s-0.62-0.1-1.16 0.33c-0.53 0.43-0.56 1.25-0.56 1.25s0.51-0.43 0.91-0.37c0.39 0.05 0.87 0.27 0.87 0.27s0.08-0.51 0.11-0.64c0.09-0.38-0.17-0.84-0.17-0.84z"></path><path d="m261.66 256.08s-0.05 0.79 0.33 1.28c0.4 0.51 1.13 0.59 1.13 0.59s-0.24-0.53-0.28-0.8c-0.06-0.4 0.34-0.75 0.34-0.75s-0.37-0.38-0.73-0.38c-0.37 0-0.79 0.06-0.79 0.06z"></path><path d="m269 263.12s-0.51-0.64-1.21-0.62c-0.71 0.03-1.45 0.69-1.45 0.69s0.88-0.07 1.11 0.22c0.23 0.3 0.45 0.67 0.45 0.67s0.4-0.21 0.57-0.35c0.17-0.13 0.53-0.61 0.53-0.61z"></path><path d="m266.83 265.93s-0.93-0.14-1.39 0.35c-0.45 0.48-0.42 1.36-0.42 1.36s0.56-0.61 1.07-0.56 1.08 0.32 1.08 0.32-0.09-0.53-0.15-0.78c-0.05-0.24-0.19-0.69-0.19-0.69z"></path><path d="m268.84 268.9s-0.46 0.64-0.12 1.15 1.05 0.75 1.05 0.75-0.26-0.37-0.14-0.8c0.09-0.34 0.67-0.8 0.67-0.8l-1.46-0.3z"></path><path d="m281.24 270.11s-0.81-0.19-1.27 0.08c-0.45 0.26-0.82 1.39-0.82 1.39s0.74-0.62 1.28-0.54c0.53 0.08 0.93 0.3 0.93 0.3s0.08-0.46 0.02-0.78c-0.03-0.19-0.14-0.45-0.14-0.45z"></path><path d="m281.64 273.1s-0.62 0.64-0.4 1.18c0.23 0.54 0.62 1.1 0.62 1.1s-0.02-0.8 0.23-1.02c0.37-0.32 1.05-0.37 1.05-0.37s-0.54-0.48-0.71-0.54c-0.17-0.05-0.79-0.35-0.79-0.35z"></path><path d="m284.75 274.04s-0.31 0.78 0.28 1.28c0.59 0.52 1.11 0.57 1.11 0.57s-0.46-0.81-0.32-1.23c0.15-0.45 0.54-0.72 0.54-0.72s-0.74-0.25-0.85-0.22c-0.11 0.02-0.76 0.32-0.76 0.32z"></path></g><g fill="#c8b100" stroke-width="0.26"><path d="m282.88 232.71l-0.29 0.02c-0.01 0.03-0.14 0.24-0.26 0.35-0.26 0.25-0.65 0.28-0.86 0.07-0.11-0.11-0.16-0.26-0.14-0.41-0.17 0.09-0.35 0.09-0.51-0.01-0.26-0.15-0.32-0.5-0.14-0.79 0.03-0.06 0.06-0.14 0.11-0.18l-0.02-0.32-0.35 0.08-0.1 0.19c-0.22 0.25-0.54 0.31-0.7 0.17-0.08-0.07-0.14-0.26-0.13-0.27 0 0.01-0.09 0.09-0.17 0.11-0.54 0.13-0.75-1.05-0.77-1.35l-0.17 0.25s0.16 0.7 0.08 1.3c-0.08 0.59-0.29 1.19-0.29 1.19 0.74 0.19 1.86 0.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 0.58-0.32 1.18-0.51s1.36-0.2 1.36-0.2l0.22-0.21c-0.32 0.05-1.58 0.1-1.56-0.43 0-0.08 0.07-0.18 0.08-0.18-0.01 0.01-0.21-0.01-0.3-0.06-0.18-0.13-0.18-0.43 0.02-0.69l0.18-0.13 0.01-0.34-0.34 0.05c-0.03 0.04-0.11 0.09-0.15 0.13-0.27 0.23-0.65 0.25-0.86 0.03-0.13-0.12-0.17-0.29-0.11-0.46-0.16 0.04-0.32 0.03-0.45-0.05-0.26-0.15-0.31-0.52-0.11-0.8 0.09-0.14 0.28-0.31 0.31-0.32l-0.07-0.3h-0.01z"></path><g fill="#000" stroke-width="0.05"><path d="m280.63 233.4c0.05-0.07 0.15-0.06 0.23 0s0.1 0.16 0.06 0.21c-0.05 0.06-0.15 0.06-0.24-0.01-0.07-0.05-0.1-0.15-0.05-0.2z"></path><path d="m281.58 234.19l-0.33-0.25c-0.06-0.04-0.07-0.12-0.04-0.16 0.04-0.04 0.12-0.04 0.18 0l0.33 0.26 0.33 0.25c0.05 0.04 0.08 0.12 0.04 0.16s-0.12 0.04-0.18 0l-0.33-0.26"></path><path d="m279.84 233l-0.26-0.15c-0.07-0.04-0.1-0.12-0.07-0.17s0.11-0.06 0.17-0.02l0.26 0.16 0.26 0.15c0.06 0.03 0.09 0.11 0.07 0.16-0.03 0.05-0.11 0.06-0.17 0.02l-0.26-0.15"></path><path d="m278.8 232.29c0.05-0.06 0.16-0.06 0.24 0 0.08 0.07 0.1 0.16 0.05 0.22-0.05 0.05-0.15 0.05-0.23-0.01s-0.1-0.15-0.06-0.21z"></path><path d="m282.63 234.92c0.05-0.05 0.03-0.14-0.05-0.21-0.08-0.06-0.19-0.06-0.24 0-0.04 0.05-0.02 0.15 0.06 0.21s0.18 0.06 0.23 0z"></path><path d="m283.2 235.58l0.22 0.21c0.05 0.05 0.13 0.07 0.18 0.03 0.04-0.04 0.04-0.11-0.01-0.16l-0.21-0.21-0.22-0.21c-0.05-0.05-0.14-0.07-0.18-0.03-0.05 0.03-0.04 0.11 0.01 0.16l0.21 0.21"></path><path d="m284.15 236.39c0.05-0.06 0.03-0.15-0.05-0.21-0.08-0.07-0.18-0.07-0.23-0.01s-0.03 0.15 0.05 0.22c0.08 0.05 0.18 0.06 0.23 0z"></path></g><path d="m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"></path><path d="m281.4 230.36l-0.59 0.01-0.11 0.87 0.06 0.14 0.15-0.01 0.76-0.51-0.27-0.5"></path><path d="m279.8 230.84l-0.02 0.54 0.92 0.12 0.15-0.07-0.02-0.15-0.53-0.71-0.5 0.27"></path><path d="m281.7 231.92l-0.49 0.27-0.54-0.71-0.01-0.15 0.14-0.06 0.93 0.11-0.03 0.54"></path><path d="m280.51 231.25c0.08-0.13 0.26-0.17 0.39-0.09 0.14 0.07 0.18 0.24 0.1 0.37s-0.26 0.17-0.39 0.09c-0.14-0.08-0.18-0.24-0.1-0.37z"></path><path d="m278.36 230.35c-0.02 0.01-0.13-0.46-0.26-0.71-0.08-0.19-0.39-0.43-0.39-0.43 0.03-0.05 0.42-0.19 0.87 0.09 0.38 0.31-0.03 0.87-0.03 0.87s-0.09 0.14-0.19 0.18z"></path><path d="m279.39 230.66l-0.42 0.37-0.68-0.6 0.06-0.08 0.03-0.15 0.92-0.07 0.09 0.53"></path><path d="m278.24 230.29c0.05-0.15 0.18-0.23 0.28-0.2 0.11 0.04 0.15 0.18 0.1 0.33s-0.18 0.23-0.29 0.2c-0.11-0.04-0.15-0.18-0.09-0.33z"></path><path d="m283.67 231.77l-0.59-0.06-0.25 0.85 0.05 0.14 0.15 0.01 0.83-0.41-0.19-0.53"></path><path d="m282.01 232.03l-0.1 0.54 0.9 0.23 0.15-0.04 0.01-0.14-0.43-0.79-0.53 0.2"></path><path d="m283.73 233.36l-0.53 0.2-0.42-0.78 0.01-0.15 0.15-0.03 0.89 0.23-0.1 0.53"></path><path d="m282.65 232.54c0.1-0.12 0.28-0.13 0.4-0.04 0.13 0.09 0.15 0.26 0.05 0.38s-0.28 0.13-0.41 0.04c-0.12-0.09-0.14-0.26-0.04-0.38z"></path><path d="m285.64 233.61l0.11 0.55-0.87 0.3-0.16-0.04-0.01-0.14 0.36-0.81 0.57 0.14"></path><path d="m285.49 235.2l-0.56 0.13-0.31-0.83 0.04-0.15 0.15-0.02 0.85 0.35-0.17 0.52"></path><path d="m283.97 233.66l-0.18 0.52 0.85 0.34 0.16-0.02 0.03-0.14-0.3-0.83-0.56 0.13"></path><path d="m284.91 234.63c0.12-0.11 0.12-0.28 0.02-0.39-0.11-0.11-0.29-0.11-0.41-0.02-0.11 0.11-0.12 0.28-0.01 0.39 0.1 0.11 0.29 0.12 0.4 0.02z"></path><path d="m286.29 236.43c0 0.01 0.5 0.03 0.79 0.09 0.2 0.04 0.52 0.27 0.52 0.27 0.06-0.04 0.12-0.42-0.28-0.79-0.39-0.28-0.88 0.22-0.88 0.22s-0.12 0.12-0.15 0.21z"></path><path d="m285.75 235.54l-0.29 0.46 0.76 0.51 0.09-0.08 0.13-0.04-0.12-0.88-0.57 0.03"></path><path d="m286.37 236.53c0.14-0.07 0.21-0.22 0.15-0.31s-0.22-0.1-0.36-0.02-0.2 0.22-0.14 0.31c0.05 0.09 0.21 0.1 0.35 0.02z"></path></g></g><g id="inescutcheon" stroke-width="0.61"><ellipse fill="#ad1519" cx="250.43" cy="281.01" rx="16.26" ry="18.3"></ellipse><ellipse fill="#005bbf" cx="250.44" cy="280.97" rx="11.44" ry="13.42"></ellipse><g id="fdl" fill="#c8b100" stroke-width="0.34"><path stroke-linejoin="round" d="m245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39 0.57 2.54 0.57 2.54-0.21-0.55-0.76-0.94-1.41-0.94-0.83 0-1.5 0.63-1.5 1.42 0 0.22 0.14 0.58 0.24 0.77l0.49 0.99c0.16-0.37 0.54-0.57 0.98-0.57 0.59 0 1.08 0.45 1.08 1.01 0 0.09-0.01 0.17-0.04 0.25l-1.22 0.01v1.03h1.09l-0.81 1.61 1.07-0.42 0.81 0.91 0.84-0.91 1.07 0.42-0.8-1.61h1.08v-1.03l-1.22-0.01c-0.02-0.08-0.02-0.16-0.02-0.25 0-0.56 0.47-1.01 1.06-1.01 0.44 0 0.82 0.2 0.98 0.57l0.49-0.99c0.1-0.19 0.24-0.55 0.24-0.77 0-0.79-0.67-1.42-1.49-1.42-0.66 0-1.21 0.39-1.41 0.94 0 0 0.57-1.15 0.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"></path><path d="m242.87 281.11h4.36v-1.03h-4.36v1.03z"></path></g><g fill="#c8b100" stroke-width="0.34" transform="matrix(1, 0, 0, 1, 10.630000114440918, 0)"><path stroke-linejoin="round" d="m245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39 0.57 2.54 0.57 2.54-0.21-0.55-0.76-0.94-1.41-0.94-0.83 0-1.5 0.63-1.5 1.42 0 0.22 0.14 0.58 0.24 0.77l0.49 0.99c0.16-0.37 0.54-0.57 0.98-0.57 0.59 0 1.08 0.45 1.08 1.01 0 0.09-0.01 0.17-0.04 0.25l-1.22 0.01v1.03h1.09l-0.81 1.61 1.07-0.42 0.81 0.91 0.84-0.91 1.07 0.42-0.8-1.61h1.08v-1.03l-1.22-0.01c-0.02-0.08-0.02-0.16-0.02-0.25 0-0.56 0.47-1.01 1.06-1.01 0.44 0 0.82 0.2 0.98 0.57l0.49-0.99c0.1-0.19 0.24-0.55 0.24-0.77 0-0.79-0.67-1.42-1.49-1.42-0.66 0-1.21 0.39-1.41 0.94 0 0 0.57-1.15 0.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"></path><path d="m242.87 281.11h4.36v-1.03h-4.36v1.03z"></path></g><g fill="#c8b100" stroke-width="0.34" transform="matrix(1, 0, 0, 1, 5.309999942779541, 9.140000343322754)"><path stroke-linejoin="round" d="m245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39 0.57 2.54 0.57 2.54-0.21-0.55-0.76-0.94-1.41-0.94-0.83 0-1.5 0.63-1.5 1.42 0 0.22 0.14 0.58 0.24 0.77l0.49 0.99c0.16-0.37 0.54-0.57 0.98-0.57 0.59 0 1.08 0.45 1.08 1.01 0 0.09-0.01 0.17-0.04 0.25l-1.22 0.01v1.03h1.09l-0.81 1.61 1.07-0.42 0.81 0.91 0.84-0.91 1.07 0.42-0.8-1.61h1.08v-1.03l-1.22-0.01c-0.02-0.08-0.02-0.16-0.02-0.25 0-0.56 0.47-1.01 1.06-1.01 0.44 0 0.82 0.2 0.98 0.57l0.49-0.99c0.1-0.19 0.24-0.55 0.24-0.77 0-0.79-0.67-1.42-1.49-1.42-0.66 0-1.21 0.39-1.41 0.94 0 0 0.57-1.15 0.57-2.54 0-1.38-1.39-2.86-1.39-2.86z"></path><path d="m242.87 281.11h4.36v-1.03h-4.36v1.03z"></path></g></g></g></g></g></g>', 1), yE = [
  pE
];
function vE(e, i) {
  return f(), p("svg", mE, yE);
}
const gE = /* @__PURE__ */ k(hE, [["render", vE]]), _E = {}, wE = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CE = /* @__PURE__ */ Ke('<path d="M20 8.75049C19.4825 8.75049 19.0625 8.33049 19.0625 7.81299V5.93799C19.0625 5.42049 19.4825 5.00049 20 5.00049C20.5175 5.00049 20.9375 5.42049 20.9375 5.93799V7.81299C20.9375 8.33049 20.5175 8.75049 20 8.75049Z" fill="#3B414D" class="primary"></path><path d="M27.9545 12.0484C27.7045 12.0484 27.4683 11.9509 27.292 11.7734C27.1145 11.5959 27.017 11.3609 27.017 11.1109C27.017 10.8609 27.1145 10.6247 27.292 10.4484L28.6183 9.12217C28.7958 8.94467 29.0308 8.84717 29.2808 8.84717C29.5308 8.84717 29.767 8.94467 29.9433 9.12217C30.1208 9.29967 30.2183 9.53467 30.2183 9.78467C30.2183 10.0347 30.1208 10.2709 29.9433 10.4472L28.617 11.7734C28.4408 11.9509 28.2045 12.0484 27.9545 12.0484Z" fill="#3B414D" class="primary"></path><path d="M31.25 20.0005C30.7325 20.0005 30.3125 19.5805 30.3125 19.063C30.3125 18.5455 30.7325 18.1255 31.25 18.1255H33.125C33.6425 18.1255 34.0625 18.5455 34.0625 19.063C34.0625 19.5805 33.6425 20.0005 33.125 20.0005H31.25Z" fill="#3B414D" class="primary"></path><path d="M29.2815 29.2821C29.0315 29.2821 28.7953 29.1846 28.619 29.0071L27.2928 27.6808C26.9278 27.3158 26.9278 26.7208 27.2928 26.3546C27.4703 26.1771 27.7053 26.0796 27.9553 26.0796C28.2053 26.0796 28.4415 26.1771 28.6178 26.3546L29.944 27.6808C30.309 28.0458 30.309 28.6408 29.944 29.0071C29.7678 29.1846 29.5315 29.2821 29.2815 29.2821Z" fill="#3B414D" class="primary"></path><path d="M12.0445 12.0484C11.7945 12.0484 11.5582 11.9509 11.382 11.7734L10.0557 10.4472C9.8782 10.2709 9.7807 10.0347 9.7807 9.78467C9.7807 9.53467 9.8782 9.29842 10.0557 9.12217C10.232 8.94467 10.4682 8.84717 10.7182 8.84717C10.9682 8.84717 11.2045 8.94467 11.3807 9.12217L12.707 10.4484C12.8845 10.6247 12.982 10.8609 12.982 11.1109C12.982 11.3609 12.8845 11.5972 12.707 11.7734C12.5307 11.9509 12.2957 12.0484 12.0445 12.0484Z" fill="#3B414D" class="primary"></path><path d="M6.875 20.0005C6.3575 20.0005 5.9375 19.5805 5.9375 19.063C5.9375 18.5455 6.3575 18.1255 6.875 18.1255H8.75C9.2675 18.1255 9.6875 18.5455 9.6875 19.063C9.6875 19.5805 9.2675 20.0005 8.75 20.0005H6.875Z" fill="#3B414D" class="primary"></path><path d="M10.719 29.2821C10.469 29.2821 10.2327 29.1846 10.0565 29.0071C9.69146 28.6421 9.69146 28.0471 10.0565 27.6808L11.3827 26.3546C11.5602 26.1771 11.7952 26.0796 12.0452 26.0796C12.2952 26.0796 12.5315 26.1771 12.7077 26.3546C13.0727 26.7196 13.0727 27.3146 12.7077 27.6808L11.3815 29.0071C11.2052 29.1846 10.969 29.2821 10.719 29.2821Z" fill="#3B414D" class="primary"></path><path d="M20 35.0005C19.4825 35.0005 19.0625 34.5805 19.0625 34.063V33.0267C16.8975 32.5892 15.3125 30.6842 15.3125 28.4355V26.073C12.9587 24.498 11.5625 21.8967 11.5625 19.063C11.5625 14.4105 15.3475 10.6255 20 10.6255C24.6525 10.6255 28.4375 14.4105 28.4375 19.063C28.4375 21.8967 27.0413 24.498 24.6875 26.073V28.4355C24.6875 30.6842 23.1025 32.5892 20.9375 33.0267V34.063C20.9375 34.5805 20.5175 35.0005 20 35.0005ZM17.1875 28.4355C17.1875 29.9867 18.4487 31.248 20 31.248C21.5513 31.248 22.8125 29.9867 22.8125 28.4355V27.0167C21.91 27.338 20.9675 27.5005 20 27.5005C19.0325 27.5005 18.09 27.338 17.1875 27.0167V28.4355ZM20 12.5005C16.3813 12.5005 13.4375 15.4442 13.4375 19.063C13.4375 22.6817 16.3813 25.6255 20 25.6255C23.6187 25.6255 26.5625 22.6817 26.5625 19.063C26.5625 15.4442 23.6187 12.5005 20 12.5005Z" fill="#3B414D" class="primary"></path>', 8), kE = [
  CE
];
function xE(e, i) {
  return f(), p("svg", wE, kE);
}
const bE = /* @__PURE__ */ k(_E, [["render", xE]]), ME = {}, DE = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AE = /* @__PURE__ */ u("path", {
  d: "M5.9375 21.2505C5.42 21.2505 5 20.6905 5 20.0005C5 19.3105 5.42 18.7505 5.9375 18.7505H34.0625C34.58 18.7505 35 19.3105 35 20.0005C35 20.6905 34.58 21.2505 34.0625 21.2505H5.9375Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), LE = [
  AE
];
function TE(e, i) {
  return f(), p("svg", DE, LE);
}
const SE = /* @__PURE__ */ k(ME, [["render", TE]]), NE = {}, EE = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zE = /* @__PURE__ */ u("path", {
  d: "M14.375 20.938C13.8575 20.938 13.4375 20.518 13.4375 20.0005C13.4375 19.483 13.8575 19.063 14.375 19.063H25.625C26.1425 19.063 26.5625 19.483 26.5625 20.0005C26.5625 20.518 26.1425 20.938 25.625 20.938H14.375Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), IE = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7287 35.0005 5 28.2717 5 20.0005C5 11.7292 11.7287 5.00049 20 5.00049C28.2712 5.00049 35 11.7292 35 20.0005C35 28.2717 28.2712 35.0005 20 35.0005ZM20 6.87549C12.7625 6.87549 6.875 12.763 6.875 20.0005C6.875 27.238 12.7625 33.1255 20 33.1255C27.2375 33.1255 33.125 27.238 33.125 20.0005C33.125 12.763 27.2375 6.87549 20 6.87549Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), BE = [
  zE,
  IE
];
function OE(e, i) {
  return f(), p("svg", EE, BE);
}
const HE = /* @__PURE__ */ k(NE, [["render", OE]]);
const jE = {}, Vl = (e) => (hn("data-v-fbb3af00"), e = e(), mn(), e), VE = {
  id: "default",
  width: "80",
  height: "40",
  viewBox: "0 0 80 40",
  xmlns: "http://www.w3.org/2000/svg"
}, FE = /* @__PURE__ */ Vl(() => /* @__PURE__ */ u("rect", {
  x: "4.20013",
  y: "2.10046",
  width: "71.6",
  height: "35.8",
  rx: "17.9",
  class: "primary"
}, null, -1)), PE = /* @__PURE__ */ Vl(() => /* @__PURE__ */ u("circle", {
  id: "default-circle",
  cx: "22.5",
  cy: "20.0005",
  r: "12.5",
  fill: "white"
}, null, -1)), UE = [
  FE,
  PE
];
function RE(e, i) {
  return f(), p("svg", VE, UE);
}
const YE = /* @__PURE__ */ k(jE, [["render", RE], ["__scopeId", "data-v-fbb3af00"]]), ZE = {}, WE = {
  width: "48",
  height: "24",
  viewBox: "0 0 48 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QE = /* @__PURE__ */ u("rect", {
  x: "2.51953",
  y: "1.2605",
  width: "42.96",
  height: "21.48",
  rx: "10.74",
  fill: "#E2E6ED",
  class: "primary"
}, null, -1), qE = /* @__PURE__ */ u("circle", {
  cx: "13.5",
  cy: "12.0005",
  r: "7.5",
  fill: "#D0D3D9"
}, null, -1), GE = [
  QE,
  qE
];
function XE(e, i) {
  return f(), p("svg", WE, GE);
}
const JE = /* @__PURE__ */ k(ZE, [["render", XE]]);
const KE = {}, Fl = (e) => (hn("data-v-56beb670"), e = e(), mn(), e), $E = {
  id: "selected",
  width: "80",
  height: "40",
  viewBox: "0 0 80 40",
  xmlns: "http://www.w3.org/2000/svg"
}, ez = /* @__PURE__ */ Fl(() => /* @__PURE__ */ u("rect", {
  x: "4.20013",
  y: "2.10046",
  width: "71.6",
  height: "35.8",
  rx: "17.9",
  class: "primary"
}, null, -1)), nz = /* @__PURE__ */ Fl(() => /* @__PURE__ */ u("circle", {
  id: "selected-circle",
  cx: "57.5",
  cy: "20.0005",
  r: "12.5",
  fill: "white"
}, null, -1)), iz = [
  ez,
  nz
];
function tz(e, i) {
  return f(), p("svg", $E, iz);
}
const az = /* @__PURE__ */ k(KE, [["render", tz], ["__scopeId", "data-v-56beb670"]]), sz = {}, oz = {
  width: "48",
  height: "24",
  viewBox: "0 0 48 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rz = /* @__PURE__ */ u("rect", {
  width: "42.96",
  height: "21.48",
  rx: "10.74",
  transform: "matrix(-1 0 0 1 45.4805 1.2605)",
  fill: "#E2E6ED",
  class: "primary"
}, null, -1), lz = /* @__PURE__ */ u("circle", {
  r: "7.5",
  transform: "matrix(-1 0 0 1 34.5 12.0005)",
  fill: "#D0D3D9"
}, null, -1), dz = [
  rz,
  lz
];
function cz(e, i) {
  return f(), p("svg", oz, dz);
}
const fz = /* @__PURE__ */ k(sz, [["render", cz]]), uz = {}, hz = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mz = /* @__PURE__ */ u("path", {
  d: "M21.875 33.1255C21.3575 33.1255 20.9375 32.7055 20.9375 32.188C20.9375 31.6705 21.3575 31.2505 21.875 31.2505C28.0788 31.2505 33.125 26.2042 33.125 20.0005C33.125 13.7967 28.0788 8.75049 21.875 8.75049C16.1938 8.75049 11.4262 13.0567 10.7188 18.5767L12.775 16.5217C12.9525 16.3442 13.1875 16.2467 13.4375 16.2467C13.6875 16.2467 13.9237 16.3442 14.1 16.5217C14.2775 16.698 14.375 16.9342 14.375 17.1842C14.375 17.4342 14.2775 17.6705 14.1 17.8467L10.3675 21.5792C10.2088 21.7605 9.95375 21.8755 9.6875 21.8755C9.42125 21.8755 9.16625 21.7605 8.9875 21.5592L5.275 17.8467C5.0975 17.6705 5 17.4342 5 17.1842C5 16.9342 5.0975 16.698 5.275 16.5217C5.45125 16.3442 5.6875 16.2467 5.9375 16.2467C6.1875 16.2467 6.42375 16.3442 6.6 16.5217L8.81375 18.7355C9.4575 12.1042 15.1062 6.87549 21.875 6.87549C29.1125 6.87549 35 12.763 35 20.0005C35 27.238 29.1125 33.1255 21.875 33.1255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), pz = /* @__PURE__ */ u("path", {
  d: "M20.9375 21.8718C20.42 21.8718 20 21.4518 20 20.9343V12.4968C20 11.9793 20.42 11.5593 20.9375 11.5593C21.455 11.5593 21.875 11.9793 21.875 12.4968V19.9968H27.5C28.0175 19.9968 28.4375 20.4168 28.4375 20.9343C28.4375 21.4518 28.0175 21.8718 27.5 21.8718H20.9375Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yz = [
  mz,
  pz
];
function vz(e, i) {
  return f(), p("svg", hz, yz);
}
const gz = /* @__PURE__ */ k(uz, [["render", vz]]), _z = {}, wz = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cz = /* @__PURE__ */ u("path", {
  d: "M21.19 12.3408C20.8513 12.3408 20.5266 12.4754 20.2871 12.7148C20.0476 12.9543 19.9131 13.2791 19.9131 13.6177V20.6407C19.9131 20.9794 20.0476 21.3042 20.2871 21.5437C20.5266 21.7831 20.8513 21.9177 21.19 21.9177H27.5746C27.9132 21.9177 28.238 21.7831 28.4775 21.5437C28.7169 21.3042 28.8515 20.9794 28.8515 20.6407C28.8515 20.3021 28.7169 19.9773 28.4775 19.7378C28.238 19.4984 27.9132 19.3638 27.5746 19.3638H22.7861C22.7015 19.3638 22.6203 19.3302 22.5604 19.2703C22.5005 19.2105 22.4669 19.1293 22.4669 19.0446V13.6177C22.4669 13.2791 22.3324 12.9543 22.0929 12.7148C21.8534 12.4754 21.5287 12.3408 21.19 12.3408Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), kz = /* @__PURE__ */ u("path", {
  d: "M20.6817 6.28565C17.935 6.39518 15.2833 7.32143 13.0658 8.94596C10.8483 10.5705 9.16567 12.8195 8.23309 15.4054C8.20824 15.4746 8.16022 15.5332 8.09716 15.5711C8.03411 15.609 7.95988 15.624 7.88705 15.6135L5.73035 15.2892C5.61215 15.274 5.49206 15.2913 5.38296 15.3392C5.27386 15.3871 5.17986 15.4639 5.11104 15.5611C5.04355 15.6601 5.00524 15.776 5.0005 15.8957C4.99576 16.0153 5.02477 16.1339 5.08423 16.2379L8.50507 22.2394C8.55367 22.3244 8.62117 22.3971 8.70234 22.4518C8.78352 22.5066 8.8762 22.5419 8.97322 22.5551C9.07024 22.5683 9.16899 22.559 9.26185 22.528C9.35471 22.4969 9.43918 22.4449 9.50873 22.376L14.3227 17.5927C14.407 17.5092 14.4664 17.404 14.4942 17.2887C14.522 17.1733 14.5171 17.0526 14.4801 16.9399C14.4431 16.8272 14.3755 16.727 14.2847 16.6506C14.194 16.5742 14.0838 16.5246 13.9664 16.5073L11.7765 16.1804C11.7276 16.1733 11.681 16.155 11.6404 16.1268C11.5998 16.0986 11.5663 16.0614 11.5426 16.0181C11.5188 15.9747 11.5054 15.9265 11.5035 15.8771C11.5015 15.8277 11.5111 15.7786 11.5314 15.7335C12.2919 14.0115 13.4996 12.5244 15.029 11.4268C16.5583 10.3291 18.3536 9.66078 20.2285 9.49124C22.1034 9.3217 23.9894 9.65711 25.6909 10.4626C27.3924 11.2682 28.8472 12.5144 29.9044 14.0721C30.9615 15.6297 31.5825 17.442 31.7027 19.3206C31.823 21.1993 31.4382 23.0759 30.5883 24.7557C29.7384 26.4354 28.4544 27.857 26.8695 28.8729C25.2846 29.8888 23.4567 30.462 21.5755 30.5329C21.1522 30.5405 20.7493 30.716 20.4553 31.0207C20.1614 31.3255 20.0005 31.7345 20.0081 32.1578C20.0157 32.5811 20.1912 32.9841 20.4959 33.278C20.8007 33.572 21.2097 33.7328 21.633 33.7252H21.693C23.5021 33.6697 25.2823 33.257 26.9313 32.5108C28.5802 31.7647 30.0654 30.6999 31.3013 29.3776C32.5371 28.0553 33.4994 26.5017 34.1325 24.8062C34.7657 23.1106 35.0574 21.3066 34.9907 19.4979C34.924 17.6892 34.5004 15.9116 33.7441 14.2672C32.9878 12.6229 31.9138 11.1444 30.5839 9.91665C29.2541 8.68895 27.6946 7.73633 25.9951 7.11362C24.2957 6.49091 22.4899 6.21039 20.6817 6.28821V6.28565Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xz = [
  Cz,
  kz
];
function bz(e, i) {
  return f(), p("svg", wz, xz);
}
const Mz = /* @__PURE__ */ k(_z, [["render", bz]]), Dz = {}, Az = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lz = /* @__PURE__ */ u("path", {
  d: "M3.87495 14C3.25448 14 2.75 13.4955 2.75 12.875V4.62539C2.75 4.00492 3.25448 3.50044 3.87495 3.50044H5.35439L5.1839 2.98746C5.1204 2.79797 5.1344 2.59498 5.2239 2.41598C5.31289 2.23649 5.46639 2.103 5.65638 2.0395C5.70988 2.0215 5.79187 2 5.88037 2L5.90437 2.0005H10.1042C10.3047 2.0005 10.4922 2.078 10.6337 2.21849C10.7757 2.35998 10.8542 2.54798 10.8547 2.74797C10.8552 2.82997 10.8417 2.91096 10.8157 2.98896L10.6447 3.50044H12.1246C12.7451 3.50044 13.2496 4.00492 13.2496 4.62539V12.875C13.2496 13.4955 12.7451 14 12.1246 14H3.87495ZM3.87495 4.25041C3.66796 4.25041 3.49997 4.4184 3.49997 4.62539V12.875C3.49997 13.082 3.66796 13.25 3.87495 13.25H12.1246C12.3316 13.25 12.4996 13.082 12.4996 12.875V4.62539C12.4996 4.4184 12.3316 4.25041 12.1246 4.25041H10.3947L10.3157 4.4874C10.2132 4.79388 9.9277 5.00038 9.60421 5.00038H6.39535C6.07236 5.00038 5.78637 4.79438 5.68388 4.4879L5.60438 4.25041H3.87495ZM5.89437 2.75047L6.39485 4.25041H9.60421L10.1042 2.75047H5.89437Z",
  fill: "#4E5666",
  class: "primary"
}, null, -1), Tz = /* @__PURE__ */ u("path", {
  d: "M4.99997 12.5001C4.58649 12.5001 4.25 12.1636 4.25 11.7501V5.37535C4.25 5.16836 4.41799 5.00037 4.62498 5.00037C4.83198 5.00037 4.99997 5.16836 4.99997 5.37535V11.7501H8.74981V10.6251C8.74981 10.0047 9.25429 9.50018 9.87477 9.50018H10.9997V5.37535C10.9997 5.16836 11.1677 5.00037 11.3747 5.00037C11.5817 5.00037 11.7497 5.16836 11.7497 5.37535V10.3141C11.7497 10.6146 11.6332 10.8971 11.4207 11.1096L10.3592 12.1701C10.1473 12.3826 9.86477 12.4996 9.56428 12.5001H4.99997ZM9.56428 11.7501C9.66278 11.7501 9.75927 11.7101 9.82877 11.6401L10.8902 10.5796C10.9607 10.5086 10.9997 10.4146 10.9997 10.3146V10.2506H9.87477C9.66777 10.2506 9.49978 10.4186 9.49978 10.6256V11.7506H9.56428V11.7501Z",
  fill: "#4E5666",
  class: "primary"
}, null, -1), Sz = [
  Lz,
  Tz
];
function Nz(e, i) {
  return f(), p("svg", Az, Sz);
}
const Ez = /* @__PURE__ */ k(Dz, [["render", Nz]]), zz = {}, Iz = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bz = /* @__PURE__ */ Ke('<path d="M26.5625 35.0005C21.91 35.0005 18.125 31.2155 18.125 26.563C18.125 21.9105 21.91 18.1255 26.5625 18.1255C31.215 18.1255 35 21.9105 35 26.563C35 31.2155 31.215 35.0005 26.5625 35.0005ZM26.5625 20.0005C22.9437 20.0005 20 22.9442 20 26.563C20 30.1817 22.9437 33.1255 26.5625 33.1255C30.1812 33.1255 33.125 30.1817 33.125 26.563C33.125 22.9442 30.1812 20.0005 26.5625 20.0005Z" fill="#3B414D" class="primary"></path><path d="M26.5625 27.5004C26.045 27.5004 25.625 27.0804 25.625 26.5629V23.2479C25.625 22.7304 26.045 22.3104 26.5625 22.3104C27.08 22.3104 27.5 22.7304 27.5 23.2479V25.6254H29.8775C30.395 25.6254 30.815 26.0454 30.815 26.5629C30.815 27.0804 30.395 27.5004 29.8775 27.5004H26.5625Z" fill="#3B414D" class="primary"></path><path d="M11.5625 19.063C11.045 19.063 10.625 18.643 10.625 18.1255C10.625 17.608 11.045 17.188 11.5625 17.188H18.125C18.6425 17.188 19.0625 17.608 19.0625 18.1255C19.0625 18.643 18.6425 19.063 18.125 19.063H11.5625Z" fill="#3B414D" class="primary"></path><path d="M11.5625 23.7505C11.045 23.7505 10.625 23.3305 10.625 22.813C10.625 22.2955 11.045 21.8755 11.5625 21.8755H15.3125C15.83 21.8755 16.25 22.2955 16.25 22.813C16.25 23.3305 15.83 23.7505 15.3125 23.7505H11.5625Z" fill="#3B414D" class="primary"></path><path d="M11.5625 28.438C11.045 28.438 10.625 28.018 10.625 27.5005C10.625 26.983 11.045 26.563 11.5625 26.563H15.3125C15.83 26.563 16.25 26.983 16.25 27.5005C16.25 28.018 15.83 28.438 15.3125 28.438H11.5625Z" fill="#3B414D" class="primary"></path><path d="M7.8125 35.0005C6.26125 35.0005 5 33.7392 5 32.188V12.5005C5 10.9492 6.26125 9.68799 7.8125 9.68799H11.6413C12.0938 7.02674 14.4513 5.00049 17.1875 5.00049C19.925 5.00049 22.2825 7.02674 22.7337 9.68799H26.5625C28.1138 9.68799 29.375 10.9492 29.375 12.5005V15.313C29.375 15.8305 28.955 16.2505 28.4375 16.2505C27.92 16.2505 27.5 15.8305 27.5 15.313V12.5005C27.5 11.983 27.08 11.563 26.5625 11.563H21.875C21.3575 11.563 20.9375 11.143 20.9375 10.6255C20.9375 8.55799 19.255 6.87549 17.1875 6.87549C15.12 6.87549 13.4375 8.55799 13.4375 10.6255C13.4375 11.143 13.0175 11.563 12.5 11.563H7.8125C7.295 11.563 6.875 11.983 6.875 12.5005V32.188C6.875 32.7055 7.295 33.1255 7.8125 33.1255H17.1875C17.705 33.1255 18.125 33.5455 18.125 34.063C18.125 34.5805 17.705 35.0005 17.1875 35.0005H7.8125Z" fill="#3B414D" class="primary"></path><path d="M17.1875 11.563C17.9642 11.563 18.5938 10.9334 18.5938 10.1567C18.5938 9.38009 17.9642 8.75049 17.1875 8.75049C16.4108 8.75049 15.7812 9.38009 15.7812 10.1567C15.7812 10.9334 16.4108 11.563 17.1875 11.563Z" fill="#3B414D" class="primary"></path>', 7), Oz = [
  Bz
];
function Hz(e, i) {
  return f(), p("svg", Iz, Oz);
}
const jz = /* @__PURE__ */ k(zz, [["render", Hz]]), Vz = {}, Fz = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pz = /* @__PURE__ */ u("path", {
  d: "M5.34375 17.5C5.085 17.5 4.875 17.29 4.875 17.0312C4.875 16.7725 5.085 16.5625 5.34375 16.5625H6.75V3.4375H5.34375C5.085 3.4375 4.875 3.2275 4.875 2.96875C4.875 2.71 5.085 2.5 5.34375 2.5H11.9062C13.7156 2.5 15.1875 3.97187 15.1875 5.78125C15.1875 6.95937 14.5438 8.045 13.5419 8.62437C15.1063 9.41437 16.125 11.0369 16.125 12.8125C16.125 15.3969 14.0219 17.5 11.4375 17.5H5.34375ZM11.4375 16.5625C13.505 16.5625 15.1875 14.88 15.1875 12.8125C15.1875 10.745 13.505 9.0625 11.4375 9.0625H7.6875V16.5625H11.4375ZM11.9062 8.125C13.1988 8.125 14.25 7.07375 14.25 5.78125C14.25 4.48875 13.1988 3.4375 11.9062 3.4375H7.6875V8.125H11.9062Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), Uz = [
  Pz
];
function Rz(e, i) {
  return f(), p("svg", Fz, Uz);
}
const Yz = /* @__PURE__ */ k(Vz, [["render", Rz]]), Zz = {}, Wz = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qz = /* @__PURE__ */ Ke('<path d="M4.40625 4.84375C4.1475 4.84375 3.9375 4.63375 3.9375 4.375C3.9375 4.11625 4.1475 3.90625 4.40625 3.90625H16.5938C16.8525 3.90625 17.0625 4.11625 17.0625 4.375C17.0625 4.63375 16.8525 4.84375 16.5938 4.84375H4.40625Z" fill="#9CACCC" class="primary"></path><path d="M6.28125 7.65625C6.0225 7.65625 5.8125 7.44625 5.8125 7.1875C5.8125 6.92875 6.0225 6.71875 6.28125 6.71875H14.7188C14.9775 6.71875 15.1875 6.92875 15.1875 7.1875C15.1875 7.44625 14.9775 7.65625 14.7188 7.65625H6.28125Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 10.4688C3.21 10.4688 3 10.2588 3 10C3 9.74125 3.21 9.53125 3.46875 9.53125H17.5312C17.79 9.53125 18 9.74125 18 10C18 10.2588 17.79 10.4688 17.5312 10.4688H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M6.28125 13.2812C6.0225 13.2812 5.8125 13.0712 5.8125 12.8125C5.8125 12.5537 6.0225 12.3438 6.28125 12.3438H14.7188C14.9775 12.3438 15.1875 12.5537 15.1875 12.8125C15.1875 13.0712 14.9775 13.2812 14.7188 13.2812H6.28125Z" fill="#9CACCC" class="primary"></path><path d="M4.40625 16.0938C4.1475 16.0938 3.9375 15.8838 3.9375 15.625C3.9375 15.3662 4.1475 15.1562 4.40625 15.1562H16.5938C16.8525 15.1562 17.0625 15.3662 17.0625 15.625C17.0625 15.8838 16.8525 16.0938 16.5938 16.0938H4.40625Z" fill="#9CACCC" class="primary"></path>', 5), qz = [
  Qz
];
function Gz(e, i) {
  return f(), p("svg", Wz, qz);
}
const Xz = /* @__PURE__ */ k(Zz, [["render", Gz]]), Jz = {}, Kz = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $z = /* @__PURE__ */ u("path", {
  d: "M3.46875 17.5C3.21 17.5 3 17.29 3 17.0312C3 16.7725 3.21 16.5625 3.46875 16.5625H6.46875L13.4688 3.4375H10.9688C10.71 3.4375 10.5 3.2275 10.5 2.96875C10.5 2.71 10.71 2.5 10.9688 2.5H17.5312C17.79 2.5 18 2.71 18 2.96875C18 3.2275 17.79 3.4375 17.5312 3.4375H14.5312L7.53125 16.5625H10.0312C10.29 16.5625 10.5 16.7725 10.5 17.0312C10.5 17.29 10.29 17.5 10.0312 17.5H3.46875Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), eI = [
  $z
];
function nI(e, i) {
  return f(), p("svg", Kz, eI);
}
const iI = /* @__PURE__ */ k(Jz, [["render", nI]]), tI = {}, aI = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sI = /* @__PURE__ */ Ke('<path d="M3.46875 4.84375C3.21 4.84375 3 4.63375 3 4.375C3 4.11625 3.21 3.90625 3.46875 3.90625H17.5312C17.79 3.90625 18 4.11625 18 4.375C18 4.63375 17.79 4.84375 17.5312 4.84375H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 7.65625C3.21 7.65625 3 7.44625 3 7.1875C3 6.92875 3.21 6.71875 3.46875 6.71875H17.5312C17.79 6.71875 18 6.92875 18 7.1875C18 7.44625 17.79 7.65625 17.5312 7.65625H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 10.4688C3.21 10.4688 3 10.2588 3 10C3 9.74125 3.21 9.53125 3.46875 9.53125H17.5312C17.79 9.53125 18 9.74125 18 10C18 10.2588 17.79 10.4688 17.5312 10.4688H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 13.2812C3.21 13.2812 3 13.0713 3 12.8125C3 12.5538 3.21 12.3438 3.46875 12.3438H17.5312C17.79 12.3438 18 12.5538 18 12.8125C18 13.0713 17.79 13.2812 17.5312 13.2812H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 16.0938C3.21 16.0938 3 15.8838 3 15.625C3 15.3662 3.21 15.1562 3.46875 15.1562H14.7188C14.9775 15.1562 15.1875 15.3662 15.1875 15.625C15.1875 15.8838 14.9775 16.0938 14.7188 16.0938H3.46875Z" fill="#9CACCC" class="primary"></path>', 5), oI = [
  sI
];
function rI(e, i) {
  return f(), p("svg", aI, oI);
}
const lI = /* @__PURE__ */ k(tI, [["render", rI]]), dI = {}, cI = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fI = /* @__PURE__ */ Ke('<path d="M3.46875 4.84375C3.21 4.84375 3 4.63375 3 4.375C3 4.11625 3.21 3.90625 3.46875 3.90625H16.5938C16.8525 3.90625 17.0625 4.11625 17.0625 4.375C17.0625 4.63375 16.8525 4.84375 16.5938 4.84375H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 7.65625C3.21 7.65625 3 7.44625 3 7.1875C3 6.92875 3.21 6.71875 3.46875 6.71875H14.7188C14.9775 6.71875 15.1875 6.92875 15.1875 7.1875C15.1875 7.44625 14.9775 7.65625 14.7188 7.65625H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 10.4688C3.21 10.4688 3 10.2588 3 10C3 9.74125 3.21 9.53125 3.46875 9.53125H17.5312C17.79 9.53125 18 9.74125 18 10C18 10.2588 17.79 10.4688 17.5312 10.4688H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 13.2812C3.21 13.2812 3 13.0712 3 12.8125C3 12.5537 3.21 12.3438 3.46875 12.3438H14.7188C14.9775 12.3438 15.1875 12.5537 15.1875 12.8125C15.1875 13.0712 14.9775 13.2812 14.7188 13.2812H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 16.0938C3.21 16.0938 3 15.8838 3 15.625C3 15.3662 3.21 15.1562 3.46875 15.1562H16.5938C16.8525 15.1562 17.0625 15.3662 17.0625 15.625C17.0625 15.8838 16.8525 16.0938 16.5938 16.0938H3.46875Z" fill="#9CACCC" class="primary"></path>', 5), uI = [
  fI
];
function hI(e, i) {
  return f(), p("svg", cI, uI);
}
const mI = /* @__PURE__ */ k(dI, [["render", hI]]), pI = {}, yI = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vI = /* @__PURE__ */ Ke('<path d="M4.40625 4.84375C4.1475 4.84375 3.9375 4.63375 3.9375 4.375C3.9375 4.11625 4.1475 3.90625 4.40625 3.90625H17.5312C17.79 3.90625 18 4.11625 18 4.375C18 4.63375 17.79 4.84375 17.5312 4.84375H4.40625Z" fill="#9CACCC" class="primary"></path><path d="M6.28125 7.65625C6.0225 7.65625 5.8125 7.44625 5.8125 7.1875C5.8125 6.92875 6.0225 6.71875 6.28125 6.71875H17.5312C17.79 6.71875 18 6.92875 18 7.1875C18 7.44625 17.79 7.65625 17.5312 7.65625H6.28125Z" fill="#9CACCC" class="primary"></path><path d="M3.46875 10.4688C3.21 10.4688 3 10.2588 3 10C3 9.74125 3.21 9.53125 3.46875 9.53125H17.5312C17.79 9.53125 18 9.74125 18 10C18 10.2588 17.79 10.4688 17.5312 10.4688H3.46875Z" fill="#9CACCC" class="primary"></path><path d="M6.28125 13.2812C6.0225 13.2812 5.8125 13.0712 5.8125 12.8125C5.8125 12.5537 6.0225 12.3438 6.28125 12.3438H17.5312C17.79 12.3438 18 12.5537 18 12.8125C18 13.0712 17.79 13.2812 17.5312 13.2812H6.28125Z" fill="#9CACCC" class="primary"></path><path d="M4.40625 16.0938C4.1475 16.0938 3.9375 15.8838 3.9375 15.625C3.9375 15.3662 4.1475 15.1562 4.40625 15.1562H17.5312C17.79 15.1562 18 15.3662 18 15.625C18 15.8838 17.79 16.0938 17.5312 16.0938H4.40625Z" fill="#9CACCC" class="primary"></path>', 5), gI = [
  vI
];
function _I(e, i) {
  return f(), p("svg", yI, gI);
}
const wI = /* @__PURE__ */ k(pI, [["render", _I]]), CI = {}, kI = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xI = /* @__PURE__ */ u("path", {
  d: "M3.46875 17.5C3.21 17.5 3 17.29 3 17.0312C3 16.7725 3.21 16.5625 3.46875 16.5625H17.5312C17.79 16.5625 18 16.7725 18 17.0312C18 17.29 17.79 17.5 17.5312 17.5H3.46875Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), bI = /* @__PURE__ */ u("path", {
  d: "M10.5 14.6888C7.91562 14.6888 5.8125 12.5856 5.8125 10.0012V3.4375H5.34375C5.085 3.4375 4.875 3.2275 4.875 2.96875C4.875 2.71 5.085 2.5 5.34375 2.5H7.21875C7.4775 2.5 7.6875 2.71 7.6875 2.96875C7.6875 3.2275 7.4775 3.4375 7.21875 3.4375H6.75V10.0012C6.75 12.0688 8.4325 13.7513 10.5 13.7513C12.5675 13.7513 14.25 12.0688 14.25 10.0012V3.4375H13.7812C13.5225 3.4375 13.3125 3.2275 13.3125 2.96875C13.3125 2.71 13.5225 2.5 13.7812 2.5H15.6562C15.915 2.5 16.125 2.71 16.125 2.96875C16.125 3.2275 15.915 3.4375 15.6562 3.4375H15.1875V10.0012C15.1875 12.5856 13.0844 14.6888 10.5 14.6888Z",
  fill: "#9CACCC",
  class: "primary"
}, null, -1), MI = [
  xI,
  bI
];
function DI(e, i) {
  return f(), p("svg", kI, MI);
}
const AI = /* @__PURE__ */ k(CI, [["render", DI]]), LI = {}, TI = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SI = /* @__PURE__ */ u("path", {
  d: "M20 35.0005C11.7293 35.0005 5 28.2712 5 20.0005C5 11.7298 11.7293 5.00049 20 5.00049C28.2707 5.00049 35 11.7298 35 20.0005C35 28.2712 28.2707 35.0005 20 35.0005ZM20 7.00049C12.832 7.00049 7 12.8325 7 20.0005C7 27.1685 12.832 33.0005 20 33.0005C27.168 33.0005 33 27.1685 33 20.0005C33 12.8325 27.168 7.00049 20 7.00049Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), NI = /* @__PURE__ */ u("path", {
  d: "M26.2493 27.2512C25.9827 27.2512 25.7307 27.1472 25.5427 26.9578L19.2933 20.7072C19.2 20.6138 19.1267 20.5045 19.076 20.3805C19.072 20.3698 19.068 20.3578 19.064 20.3472C19.0213 20.2325 19.0013 20.1178 19.0013 20.0005V15.0005C19.0013 14.4485 19.4493 14.0005 20.0013 14.0005C20.5533 14.0005 21.0013 14.4485 21.0013 15.0005V19.5858L26.9573 25.5432C27.1467 25.7325 27.2507 25.9832 27.2507 26.2498C27.2507 26.5165 27.1467 26.7685 26.9573 26.9565C26.768 27.1445 26.516 27.2512 26.2493 27.2512Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), EI = [
  SI,
  NI
];
function zI(e, i) {
  return f(), p("svg", TI, EI);
}
const II = /* @__PURE__ */ k(LI, [["render", zI]]), BI = {}, OI = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HI = /* @__PURE__ */ u("path", {
  d: "M7.8125 29.3755C6.26125 29.3755 5 28.1142 5 26.563V13.438C5 11.8867 6.26125 10.6255 7.8125 10.6255H32.1875C33.7388 10.6255 35 11.8867 35 13.438V26.563C35 28.1142 33.7388 29.3755 32.1875 29.3755H7.8125ZM7.8125 12.5005C7.295 12.5005 6.875 12.9205 6.875 13.438V26.563C6.875 27.0805 7.295 27.5005 7.8125 27.5005H32.1875C32.705 27.5005 33.125 27.0805 33.125 26.563V13.438C33.125 12.9205 32.705 12.5005 32.1875 12.5005H7.8125Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jI = /* @__PURE__ */ u("path", {
  d: "M11.5625 25.6255C11.045 25.6255 10.625 25.2055 10.625 24.688C10.625 24.1705 11.045 23.7505 11.5625 23.7505H12.5V16.2505H11.5625C11.045 16.2505 10.625 15.8305 10.625 15.313C10.625 14.7955 11.045 14.3755 11.5625 14.3755H15.3125C15.83 14.3755 16.25 14.7955 16.25 15.313C16.25 15.8305 15.83 16.2505 15.3125 16.2505H14.375V23.7505H15.3125C15.83 23.7505 16.25 24.1705 16.25 24.688C16.25 25.2055 15.83 25.6255 15.3125 25.6255H11.5625Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), VI = [
  HI,
  jI
];
function FI(e, i) {
  return f(), p("svg", OI, VI);
}
const PI = /* @__PURE__ */ k(BI, [["render", FI]]), UI = {}, RI = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YI = /* @__PURE__ */ Ke('<path d="M34.0613 16.1744C33.6688 16.1744 33.3151 15.9269 33.1801 15.5582C32.2263 12.9408 29.8614 11.0709 27.1378 10.6984L28.4927 12.9558C28.6215 13.1708 28.659 13.422 28.5977 13.6658C28.5365 13.9082 28.3853 14.1132 28.1703 14.242C28.0253 14.3295 27.8578 14.3757 27.689 14.3757C27.3615 14.3757 27.0528 14.2007 26.8853 13.9207L24.0729 9.23343C23.9442 9.01844 23.9067 8.7672 23.9679 8.52346C24.0292 8.28097 24.1804 8.07598 24.3954 7.94723L29.0827 5.13484C29.2277 5.04735 29.3952 5.0011 29.564 5.0011C29.8914 5.0011 30.2002 5.17609 30.3689 5.45733C30.4977 5.67107 30.5352 5.92356 30.4739 6.1673C30.4127 6.40979 30.2614 6.61478 30.0464 6.74353L26.6616 8.77345C30.3752 8.98469 33.6613 11.3983 34.9425 14.9157C35.0287 15.1507 35.0175 15.4057 34.9112 15.6319C34.805 15.8594 34.6175 16.0307 34.3825 16.1169C34.2788 16.1557 34.1713 16.1744 34.0613 16.1744Z" fill="#3B414D" class="primary"></path><path d="M10.4347 34.9998C10.1072 34.9998 9.7985 34.8249 9.63101 34.5449C9.50226 34.3299 9.46476 34.0786 9.52601 33.8349C9.58726 33.5912 9.7385 33.3874 9.95349 33.2587L13.3296 31.2325C9.62101 31.0175 6.33989 28.6013 5.05744 25.084C4.97119 24.849 4.98244 24.594 5.08869 24.3678C5.19493 24.1403 5.38243 23.9678 5.61742 23.8828C5.71991 23.8453 5.82866 23.8265 5.93865 23.8265C6.33114 23.8265 6.68487 24.074 6.81862 24.4428C7.77108 27.0564 10.1347 28.9251 12.8596 29.3001L11.5072 27.0452C11.3784 26.8302 11.3409 26.5789 11.4022 26.3352C11.4634 26.0914 11.6147 25.8877 11.8297 25.759C11.9747 25.6715 12.1409 25.6252 12.3109 25.6252C12.6384 25.6252 12.9459 25.799 13.1146 26.0802L15.927 30.7675C16.0558 30.9825 16.0932 31.2337 16.032 31.4775C15.9708 31.7212 15.8195 31.925 15.6045 32.0537L10.9172 34.8661C10.7722 34.9536 10.6047 34.9998 10.4347 34.9998Z" fill="#3B414D" class="primary"></path><path d="M7.81239 21.8754C6.2612 21.8754 5 20.6142 5 19.063V7.81349C5 6.2623 6.2612 5.0011 7.81239 5.0011H19.0619C20.6131 5.0011 21.8743 6.2623 21.8743 7.81349V19.063C21.8743 20.6142 20.6131 21.8754 19.0619 21.8754H7.81239ZM7.81239 6.87602C7.29491 6.87602 6.87493 7.29601 6.87493 7.81349V19.063C6.87493 19.5805 7.29491 20.0005 7.81239 20.0005H19.0619C19.5794 20.0005 19.9994 19.5805 19.9994 19.063V7.81349C19.9994 7.29601 19.5794 6.87602 19.0619 6.87602H7.81239Z" fill="#3B414D" class="primary"></path><path d="M20.937 34.9999C19.3858 34.9999 18.1246 33.7387 18.1246 32.1876V24.6879C18.1246 24.1704 18.5446 23.7504 19.062 23.7504C19.5795 23.7504 19.9995 24.1704 19.9995 24.6879V32.1876C19.9995 32.705 20.4195 33.125 20.937 33.125H32.1865C32.704 33.125 33.124 32.705 33.124 32.1876V20.938C33.124 20.4205 32.704 20.0005 32.1865 20.0005H24.6868C24.1693 20.0005 23.7493 19.5806 23.7493 19.0631C23.7493 18.5456 24.1693 18.1256 24.6868 18.1256H32.1865C33.7377 18.1256 34.9989 19.3868 34.9989 20.938V32.1876C34.9989 33.7387 33.7377 34.9999 32.1865 34.9999H20.937Z" fill="#3B414D" class="primary"></path><path d="M28.4365 31.2501C27.919 31.2501 27.4991 30.8301 27.4991 30.3127V29.3752H25.6241V30.3127C25.6241 30.8301 25.2041 31.2501 24.6867 31.2501C24.1692 31.2501 23.7492 30.8289 23.7492 30.3127V24.6879C23.7492 23.1367 25.0104 21.8755 26.5616 21.8755C28.1128 21.8755 29.374 23.1367 29.374 24.6879V30.3127C29.374 30.8289 28.954 31.2501 28.4365 31.2501ZM27.4991 27.5003V24.6879C27.4991 24.1704 27.0791 23.7504 26.5616 23.7504C26.0441 23.7504 25.6241 24.1704 25.6241 24.6879V27.5003H27.4991Z" fill="#3B414D" class="primary"></path><path d="M17.1209 18.123C15.7347 18.0292 14.4097 17.428 13.416 16.4555C12.2835 17.5643 11.0311 18.1255 9.6874 18.1255C9.16992 18.1255 8.74994 17.7055 8.74994 17.188C8.74994 16.6705 9.16992 16.2506 9.6874 16.2506C10.7286 16.2506 11.7286 15.6593 12.6623 14.4931C12.6823 14.4631 12.706 14.4344 12.7298 14.4069C13.231 13.7632 13.6247 13.0582 13.8972 12.5007H9.6874C9.16992 12.5007 8.74994 12.0795 8.74994 11.5632C8.74994 11.047 9.16992 10.6258 9.6874 10.6258H12.4998V9.68832C12.4998 9.17084 12.9198 8.75085 13.4373 8.75085C13.9547 8.75085 14.3747 9.17084 14.3747 9.68832V10.6258H17.1871C17.7046 10.6258 18.1246 11.0458 18.1246 11.5632C18.1246 12.0807 17.7046 12.5007 17.1871 12.5007H15.9584C15.7009 13.1232 15.2609 14.0619 14.6222 14.9981C15.3097 15.7318 16.2496 16.1843 17.2496 16.2531C17.7646 16.2881 18.1558 16.7368 18.1208 17.2518C18.0871 17.7417 17.6771 18.1255 17.1859 18.1255C17.1646 18.1255 17.1434 18.1242 17.1209 18.123Z" fill="#3B414D" class="primary"></path>', 6), ZI = [
  YI
];
function WI(e, i) {
  return f(), p("svg", RI, ZI);
}
const QI = /* @__PURE__ */ k(UI, [["render", WI]]), qI = {}, GI = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XI = /* @__PURE__ */ Ke('<path d="M33.6463 18.7505H24.375C24.2092 18.7505 24.0503 18.8163 23.9331 18.9335C23.8158 19.0508 23.75 19.2097 23.75 19.3755V19.8967C23.75 20.9188 23.344 21.899 22.6213 22.6218C21.8985 23.3445 20.9183 23.7505 19.8962 23.7505H19.375C19.2092 23.7505 19.0503 23.8163 18.9331 23.9335C18.8158 24.0508 18.75 24.2097 18.75 24.3755V33.6467C18.75 34.0058 18.8926 34.3501 19.1465 34.604C19.4004 34.8579 19.7447 35.0005 20.1038 35.0005H33.6463C33.8242 35.0005 34.0005 34.9654 34.1649 34.8972C34.3293 34.829 34.4786 34.7291 34.6044 34.6031C34.7301 34.4771 34.8298 34.3276 34.8977 34.1631C34.9656 33.9985 35.0003 33.8222 35 33.6442V20.1017C34.9993 19.7431 34.8564 19.3994 34.6026 19.1461C34.3488 18.8928 34.0049 18.7505 33.6463 18.7505ZM30.955 32.7505C30.8496 32.7904 30.7377 32.8107 30.625 32.8105C30.4347 32.8102 30.249 32.7518 30.0927 32.6433C29.9364 32.5348 29.8168 32.3812 29.75 32.203L29.1163 30.513C29.0937 30.4536 29.0537 30.4024 29.0015 30.3663C28.9492 30.3301 28.8873 30.3107 28.8238 30.3105H24.9288C24.8652 30.3107 24.8033 30.3301 24.751 30.3663C24.6988 30.4024 24.6588 30.4536 24.6363 30.513L24 32.203C23.9008 32.4184 23.7237 32.5883 23.5043 32.6784C23.2849 32.7684 23.0395 32.7719 22.8175 32.6882C22.5956 32.6045 22.4137 32.4398 22.3083 32.2273C22.203 32.0148 22.1822 31.7703 22.25 31.543L25.415 23.1042C25.5269 22.8068 25.7268 22.5505 25.9881 22.3696C26.2494 22.1887 26.5597 22.0917 26.8775 22.0917C27.1953 22.0917 27.5056 22.1887 27.7669 22.3696C28.0282 22.5505 28.2281 22.8068 28.34 23.1042L30.5375 28.963C30.5558 29.0037 30.5717 29.0454 30.585 29.088L31.505 31.5417C31.5485 31.6572 31.5687 31.7801 31.5646 31.9034C31.5604 32.0267 31.532 32.148 31.4809 32.2603C31.4298 32.3726 31.3571 32.4737 31.2668 32.5578C31.1766 32.6419 31.0706 32.7074 30.955 32.7505Z" fill="#3B414D" class="primary"></path><path d="M25.5738 28.0131C25.556 28.0604 25.5499 28.1112 25.5561 28.1614C25.5623 28.2115 25.5806 28.2594 25.6093 28.3009C25.6381 28.3425 25.6765 28.3764 25.7212 28.3999C25.766 28.4233 25.8158 28.4356 25.8663 28.4356H27.8838C27.9343 28.4356 27.9841 28.4233 28.0288 28.3999C28.0736 28.3764 28.112 28.3425 28.1407 28.3009C28.1695 28.2594 28.1877 28.2115 28.1939 28.1614C28.2001 28.1112 28.1941 28.0604 28.1763 28.0131L27.1675 25.3243C27.1451 25.2648 27.1052 25.2136 27.0529 25.1774C27.0006 25.1412 26.9386 25.1218 26.875 25.1218C26.8115 25.1218 26.7494 25.1412 26.6971 25.1774C26.6449 25.2136 26.6049 25.2648 26.5825 25.3243L25.5738 28.0131Z" fill="#3B414D" class="primary"></path><path d="M14.7238 12.0093C14.7465 11.9615 14.7568 11.9088 14.7538 11.8559C14.7507 11.8031 14.7342 11.7519 14.7061 11.7071C14.6779 11.6624 14.6388 11.6254 14.5925 11.5998C14.5462 11.5742 14.4942 11.5607 14.4413 11.5605H11.8088C11.7558 11.5607 11.7038 11.5742 11.6575 11.5998C11.6112 11.6254 11.5722 11.6624 11.544 11.7071C11.5158 11.7519 11.4994 11.8031 11.4963 11.8559C11.4932 11.9088 11.5035 11.9615 11.5263 12.0093C11.8906 12.758 12.3475 13.4581 12.8863 14.093C12.9155 14.128 12.952 14.1561 12.9932 14.1753C13.0345 14.1946 13.0795 14.2046 13.125 14.2046C13.1705 14.2046 13.2155 14.1946 13.2568 14.1753C13.298 14.1561 13.3345 14.128 13.3638 14.093C13.9025 13.4581 14.3594 12.758 14.7238 12.0093Z" fill="#3B414D" class="primary"></path><path d="M19.8962 21.2505C20.0742 21.2505 20.2505 21.2154 20.4149 21.1472C20.5793 21.079 20.7286 20.9791 20.8544 20.8531C20.9801 20.7271 21.0798 20.5776 21.1477 20.4131C21.2156 20.2485 21.2503 20.0722 21.25 19.8942V6.35174C21.2493 5.99313 21.1064 5.64945 20.8526 5.39611C20.5988 5.14277 20.2549 5.00049 19.8962 5.00049H6.35375C5.99515 5.00049 5.65119 5.14277 5.39739 5.39611C5.14358 5.64945 5.00066 5.99313 5 6.35174V19.8942C4.99967 20.0722 5.03445 20.2485 5.10233 20.4131C5.17022 20.5776 5.26988 20.7271 5.39562 20.8531C5.52136 20.9791 5.67071 21.079 5.83512 21.1472C5.99952 21.2154 6.17576 21.2505 6.35375 21.2505H19.8962ZM18.405 18.3755C18.351 18.5742 18.2331 18.7496 18.0696 18.8748C17.9061 18.9999 17.7059 19.0678 17.5 19.068C17.4156 19.068 17.3316 19.0571 17.25 19.0355C15.8251 18.6449 14.4887 17.9837 13.3138 17.088C13.2597 17.0472 13.1939 17.0252 13.1263 17.0252C13.0586 17.0252 12.9928 17.0472 12.9388 17.088C11.7624 17.9813 10.4252 18.6399 9 19.028C8.91842 19.0496 8.83439 19.0605 8.75 19.0605C8.52175 19.063 8.30043 18.9821 8.12768 18.8328C7.95493 18.6836 7.84263 18.4765 7.81192 18.2503C7.78121 18.0241 7.83419 17.7944 7.96091 17.6046C8.08762 17.4147 8.27934 17.2777 8.5 17.2192C9.55638 16.9322 10.5561 16.4672 11.4563 15.8442C11.4933 15.8195 11.5247 15.7872 11.5484 15.7495C11.5721 15.7118 11.5875 15.6696 11.5938 15.6255C11.6005 15.5811 11.5975 15.5357 11.585 15.4925C11.5725 15.4493 11.5507 15.4094 11.5213 15.3755C10.6105 14.3062 9.89659 13.084 9.4125 11.7655C9.39099 11.7062 9.35197 11.6549 9.30063 11.6183C9.2493 11.5817 9.18805 11.5615 9.125 11.5605H8.16375C7.91511 11.5605 7.67665 11.4617 7.50084 11.2859C7.32502 11.1101 7.22625 10.8716 7.22625 10.623C7.22625 10.3743 7.32502 10.1359 7.50084 9.96008C7.67665 9.78426 7.91511 9.68549 8.16375 9.68549H11.875C11.9579 9.68549 12.0374 9.65256 12.096 9.59396C12.1546 9.53535 12.1875 9.45587 12.1875 9.37299V8.12299C12.1875 7.87435 12.2863 7.63589 12.4621 7.46008C12.6379 7.28426 12.8764 7.18549 13.125 7.18549C13.3736 7.18549 13.6121 7.28426 13.7879 7.46008C13.9637 7.63589 14.0625 7.87435 14.0625 8.12299V9.37299C14.0625 9.45587 14.0954 9.53535 14.154 9.59396C14.2126 9.65256 14.2921 9.68549 14.375 9.68549H18.125C18.3736 9.68549 18.6121 9.78426 18.7879 9.96008C18.9637 10.1359 19.0625 10.3743 19.0625 10.623C19.0625 10.8716 18.9637 11.1101 18.7879 11.2859C18.6121 11.4617 18.3736 11.5605 18.125 11.5605H17.1313C17.0671 11.5602 17.0045 11.5798 16.9519 11.6165C16.8994 11.6532 16.8594 11.7052 16.8375 11.7655C16.3534 13.084 15.6395 14.3062 14.7288 15.3755C14.7004 15.4087 14.6793 15.4476 14.6668 15.4895C14.6544 15.5314 14.6509 15.5755 14.6565 15.6188C14.6622 15.6622 14.6769 15.7039 14.6997 15.7412C14.7224 15.7785 14.7528 15.8106 14.7888 15.8355C15.6889 16.4585 16.6886 16.9234 17.745 17.2105C17.8648 17.2425 17.977 17.2979 18.0751 17.3736C18.1733 17.4492 18.2555 17.5436 18.3169 17.6513C18.3783 17.759 18.4177 17.8778 18.4328 18.0008C18.4479 18.1238 18.4385 18.2486 18.405 18.368V18.3755Z" fill="#3B414D" class="primary"></path><path d="M27.0576 11.6905C27.1448 11.778 27.2561 11.8377 27.3772 11.8619C27.4984 11.8862 27.624 11.8741 27.7382 11.827C27.8525 11.7799 27.9502 11.7 28.019 11.5974C28.0879 11.4948 28.1248 11.3741 28.1251 11.2505V10.863C28.125 10.8091 28.139 10.7561 28.1655 10.7092C28.192 10.6623 28.2302 10.623 28.2764 10.5952C28.3225 10.5674 28.3751 10.552 28.429 10.5506C28.4828 10.5491 28.5362 10.5615 28.5838 10.5868C29.3873 11.0108 30.0601 11.6458 30.5298 12.4234C30.9996 13.2011 31.2486 14.092 31.2501 15.0005C31.2501 15.332 31.3818 15.65 31.6162 15.8844C31.8506 16.1188 32.1685 16.2505 32.5001 16.2505C32.8316 16.2505 33.1495 16.1188 33.3839 15.8844C33.6184 15.65 33.7501 15.332 33.7501 15.0005C33.7482 13.3792 33.221 11.8022 32.2474 10.5058C31.2739 9.20931 29.9065 8.26323 28.3501 7.80927C28.2852 7.79034 28.2281 7.75086 28.1876 7.69677C28.147 7.64268 28.1251 7.57688 28.1251 7.50927V6.25052C28.125 6.12684 28.0883 6.00596 28.0196 5.90316C27.9508 5.80035 27.8531 5.72026 27.7388 5.67302C27.6244 5.62677 27.4989 5.61503 27.3778 5.63924C27.2568 5.66345 27.1454 5.72255 27.0576 5.80927L24.5576 8.30927C24.4404 8.42647 24.3746 8.58542 24.3746 8.75114C24.3746 8.91687 24.4404 9.07581 24.5576 9.19302L27.0576 11.6905Z" fill="#3B414D" class="primary"></path><path d="M7.5 22.5005C7.1702 22.5005 6.85377 22.6308 6.61963 22.8631C6.3855 23.0953 6.25264 23.4107 6.25 23.7405V23.7505C6.25189 25.3718 6.7791 26.9488 7.75262 28.2452C8.72615 29.5417 10.0936 30.4878 11.65 30.9417C11.7149 30.9607 11.7719 31.0001 11.8125 31.0542C11.8531 31.1083 11.875 31.1741 11.875 31.2417V32.5005C11.8748 32.6243 11.9113 32.7453 11.98 32.8483C12.0486 32.9513 12.1463 33.0316 12.2607 33.079C12.375 33.1264 12.5009 33.1387 12.6222 33.1145C12.7436 33.0903 12.8551 33.0306 12.9425 32.943L15.4425 30.443C15.5597 30.3258 15.6255 30.1668 15.6255 30.0011C15.6255 29.8354 15.5597 29.6764 15.4425 29.5592L12.9425 27.0592C12.8552 26.9717 12.7438 26.912 12.6225 26.8878C12.5013 26.8635 12.3755 26.8758 12.2612 26.923C12.147 26.9703 12.0493 27.0503 11.9805 27.1531C11.9117 27.2559 11.875 27.3768 11.875 27.5005V27.888C11.8749 27.942 11.861 27.9951 11.8345 28.0421C11.808 28.0892 11.7699 28.1287 11.7237 28.1567C11.6776 28.1846 11.6249 28.2 11.571 28.2013C11.5171 28.2026 11.4637 28.1899 11.4162 28.1642C10.6128 27.7402 9.94001 27.1052 9.47025 26.3276C9.00049 25.5499 8.75149 24.659 8.75 23.7505C8.75 23.419 8.6183 23.101 8.38388 22.8666C8.14946 22.6322 7.83152 22.5005 7.5 22.5005Z" fill="#3B414D" class="primary"></path>', 6), JI = [
  XI
];
function KI(e, i) {
  return f(), p("svg", GI, JI);
}
const $I = /* @__PURE__ */ k(qI, [["render", KI]]), eB = {}, nB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iB = /* @__PURE__ */ Ke('<path d="M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z" fill="#FAD1D7"></path><path d="M12.7067 12.5022H18.6917C19.5271 12.5022 20.0467 13.1832 19.8518 14.0214L17.0654 25.9845C16.8688 26.8198 16.0323 27.5014 15.1963 27.5014H9.21192C8.37764 27.5014 7.85685 26.8198 8.05175 25.9845L10.8393 14.0214C11.0342 13.1832 11.8703 12.5022 12.7067 12.5022Z" fill="#E21836"></path><path d="M18.1932 12.5005H25.0757C25.911 12.5005 25.5344 13.1814 25.3379 14.0197L22.5519 25.9828C22.3564 26.8181 22.4174 27.4997 21.5803 27.4997H14.6978C13.8608 27.4997 13.3427 26.8181 13.5394 25.9828L16.3252 14.0197C16.523 13.1814 17.3573 12.5005 18.1932 12.5005Z" fill="#00447C"></path><path d="M24.803 12.5005H30.7879C31.6245 12.5005 32.1442 13.1814 31.9477 14.0197L29.1617 25.9828C28.965 26.8181 28.128 27.4997 27.2915 27.4997H21.3094C20.4723 27.4997 19.9531 26.8181 20.1492 25.9828L22.9356 14.0197C23.1305 13.1814 23.9659 12.5005 24.803 12.5005Z" fill="#007B84"></path><path d="M14.2695 16.3344C13.6541 16.3406 13.4723 16.3344 13.4143 16.3206C13.3919 16.4267 12.9766 18.3425 12.9755 18.3441C12.886 18.7317 12.821 19.008 12.6 19.1864C12.4745 19.2901 12.328 19.3402 12.1582 19.3402C11.8853 19.3402 11.7263 19.2047 11.6996 18.9476L11.6945 18.8594C11.6945 18.8594 11.7776 18.3402 11.7776 18.3373C11.7776 18.3373 12.2135 16.5914 12.2916 16.3606C12.2957 16.3475 12.2968 16.3406 12.2978 16.3344C11.4494 16.3418 11.299 16.3344 11.2887 16.3206C11.283 16.3395 11.262 16.4477 11.262 16.4477L10.8169 18.4155L10.7787 18.5823L10.7047 19.1282C10.7047 19.2901 10.7365 19.4223 10.7998 19.534C11.0026 19.8884 11.581 19.9415 11.9082 19.9415C12.3298 19.9415 12.7253 19.8519 12.9925 19.6884C13.4564 19.4143 13.5778 18.9858 13.686 18.6051L13.7362 18.4098C13.7362 18.4098 14.1852 16.5965 14.2615 16.3606C14.2644 16.3475 14.2656 16.3406 14.2695 16.3344ZM15.7973 17.7971C15.689 17.7971 15.4912 17.8234 15.3135 17.9105C15.2491 17.9436 15.1881 17.9818 15.1238 18.0199L15.1818 17.8103L15.15 17.775C14.7732 17.8513 14.6889 17.8615 14.3408 17.9105L14.3117 17.9299C14.2712 18.265 14.2354 18.5169 14.0855 19.1755C14.0285 19.4183 13.9693 19.6634 13.9099 19.9055L13.926 19.9363C14.2826 19.9175 14.3909 19.9175 14.7009 19.9226L14.7259 19.8953C14.7653 19.6936 14.7704 19.6463 14.8577 19.2377C14.8987 19.044 14.9842 18.6183 15.0263 18.4667C15.1038 18.4308 15.1802 18.3955 15.2531 18.3955C15.4269 18.3955 15.4057 18.5471 15.399 18.6075C15.3916 18.7089 15.3283 19.04 15.2634 19.3243L15.22 19.5078C15.1898 19.6434 15.1567 19.7751 15.1265 19.9095L15.1397 19.9363C15.4912 19.9175 15.5984 19.9175 15.8987 19.9226L15.934 19.8953C15.9882 19.5802 16.0041 19.4959 16.1004 19.0371L16.1488 18.8263C16.2429 18.4138 16.2902 18.2046 16.219 18.0342C16.1437 17.8432 15.9631 17.7971 15.7973 17.7971ZM17.5039 18.2291C17.3171 18.265 17.1979 18.2889 17.0794 18.3043C16.962 18.3232 16.8475 18.3402 16.6669 18.3653L16.6526 18.3783L16.6395 18.3887C16.6206 18.5232 16.6075 18.6394 16.5826 18.7761C16.5614 18.9175 16.5289 19.0781 16.4759 19.3089C16.4349 19.4855 16.4138 19.5471 16.3904 19.6092C16.3677 19.6714 16.3426 19.7318 16.2965 19.9055L16.3073 19.9215L16.3163 19.9363C16.4851 19.9283 16.5956 19.9226 16.709 19.9215C16.8224 19.9175 16.9398 19.9215 17.1216 19.9226L17.1375 19.9096L17.1546 19.8953C17.1808 19.7386 17.1848 19.6965 17.2008 19.62C17.2167 19.538 17.2441 19.4245 17.3114 19.1214C17.3432 18.979 17.3786 18.8371 17.4116 18.6918C17.4459 18.5471 17.4818 18.4046 17.5159 18.2622L17.5108 18.245L17.5039 18.2291ZM17.5079 17.6467C17.3381 17.5465 17.0401 17.5783 16.8395 17.7167C16.6395 17.8524 16.6167 18.0449 16.786 18.1465C16.9529 18.2439 17.252 18.2149 17.4509 18.0753C17.6504 17.9367 17.6754 17.7459 17.5079 17.6467ZM18.5348 19.9677C18.8784 19.9677 19.2305 19.873 19.4956 19.592C19.6995 19.3642 19.793 19.0252 19.8254 18.8856C19.9309 18.4228 19.8487 18.2068 19.7456 18.0752C19.5889 17.8746 19.3121 17.8103 19.0248 17.8103C18.8521 17.8103 18.4407 17.8274 18.1194 18.1236C17.8886 18.3374 17.7819 18.6274 17.7176 18.9054C17.6527 19.1887 17.578 19.6987 18.047 19.8885C18.1917 19.9506 18.4003 19.9677 18.5348 19.9677ZM18.508 18.9266C18.5872 18.5762 18.6807 18.2821 18.9194 18.2821C19.1064 18.2821 19.1199 18.5009 19.0368 18.8524C19.0219 18.9305 18.9536 19.2206 18.8613 19.3442C18.7968 19.4354 18.7205 19.4907 18.6362 19.4907C18.6111 19.4907 18.4619 19.4907 18.4596 19.2691C18.4584 19.1597 18.4807 19.0479 18.508 18.9266ZM20.6842 19.9226L20.711 19.8953C20.7491 19.6936 20.7554 19.6462 20.8397 19.2377C20.8819 19.044 20.9691 18.6183 21.0101 18.4668C21.0877 18.4307 21.1628 18.3954 21.2381 18.3954C21.4107 18.3954 21.3897 18.547 21.3828 18.6074C21.3765 18.7089 21.3132 19.0399 21.2471 19.3242L21.2061 19.5077C21.1748 19.6434 21.1406 19.775 21.1105 19.9095L21.1236 19.9363C21.4763 19.9175 21.5794 19.9175 21.8814 19.9226L21.9179 19.8953C21.9708 19.5801 21.9851 19.4958 22.0843 19.0371L22.1316 18.8262C22.2261 18.4137 22.274 18.2046 22.204 18.0342C22.1265 17.8433 21.9447 17.7972 21.7812 17.7972C21.6728 17.7972 21.474 17.8233 21.2973 17.9105C21.2342 17.9436 21.1708 17.9817 21.1087 18.0199L21.1628 17.8103L21.1338 17.7749C20.7571 17.8513 20.6711 17.8615 20.3234 17.9105L20.2967 17.9299C20.2546 18.265 20.2203 18.5168 20.0705 19.1756C20.0134 19.4183 19.9542 19.6634 19.895 19.9056L19.9109 19.9363C20.2681 19.9175 20.3748 19.9175 20.6842 19.9226ZM23.2758 19.9363C23.298 19.828 23.4297 19.1864 23.4309 19.1864C23.4309 19.1864 23.543 18.7157 23.5499 18.6986C23.5499 18.6986 23.5852 18.6496 23.6205 18.6302H23.6724C24.1624 18.6302 24.7158 18.6302 25.1495 18.3112C25.4446 18.0924 25.6463 17.7692 25.7363 17.3765C25.7597 17.2803 25.7769 17.1657 25.7769 17.0512C25.7769 16.9008 25.7467 16.752 25.6594 16.6358C25.4383 16.3264 24.9979 16.3207 24.4895 16.3183C24.4879 16.3183 24.2389 16.3207 24.2389 16.3207C23.5881 16.3287 23.3271 16.3264 23.2199 16.3132C23.2109 16.3606 23.1938 16.445 23.1938 16.445C23.1938 16.445 22.9607 17.5253 22.9607 17.5271C22.9607 17.5271 22.4029 19.8241 22.3766 19.9323C22.9448 19.9255 23.1778 19.9255 23.2758 19.9363ZM23.7077 18.0171C23.7077 18.0171 23.9556 16.9389 23.9544 16.943L23.9624 16.8877L23.9659 16.8455L24.065 16.8558C24.065 16.8558 24.5762 16.8997 24.5881 16.9008C24.7899 16.9789 24.873 17.18 24.815 17.4426C24.762 17.6826 24.6063 17.8843 24.4063 17.9818C24.2417 18.0644 24.0399 18.0712 23.832 18.0712H23.6975L23.7077 18.0171ZM25.2509 18.9465C25.1854 19.2257 25.1101 19.7357 25.5768 19.9175C25.7256 19.9808 25.8589 19.9996 25.9944 19.9928C26.1375 19.985 26.2701 19.9133 26.393 19.81C26.3819 19.8524 26.3708 19.8949 26.3597 19.9375L26.3809 19.9648C26.7165 19.9506 26.8207 19.9506 27.1844 19.9534L27.2173 19.9283C27.2704 19.6161 27.3205 19.313 27.4585 18.7157C27.5257 18.4297 27.5928 18.1464 27.6618 17.8615L27.651 17.8301C27.2755 17.8997 27.1752 17.9146 26.814 17.9658L26.7866 17.9881C26.7829 18.0171 26.7791 18.045 26.7756 18.0729C26.7195 17.9821 26.6381 17.9047 26.5125 17.8564C26.3518 17.7932 25.9746 17.8746 25.6503 18.1699C25.4224 18.3807 25.313 18.6695 25.2509 18.9465ZM26.0395 18.9636C26.1199 18.6195 26.2122 18.3283 26.4515 18.3283C26.6028 18.3283 26.6824 18.4679 26.6662 18.706C26.6534 18.7653 26.6395 18.8279 26.623 18.8987C26.5991 19.0009 26.5731 19.1023 26.5479 19.2039C26.5222 19.2733 26.4923 19.3388 26.4595 19.3824C26.3979 19.4696 26.2515 19.5238 26.1672 19.5238C26.1432 19.5238 25.9956 19.5238 25.9905 19.3061C25.9893 19.1977 26.0117 19.0861 26.0395 18.9636ZM30.1577 17.8273L30.1287 17.7942C29.7571 17.8695 29.6899 17.8815 29.3485 17.9275L29.3235 17.9526C29.3223 17.9567 29.3213 17.963 29.3195 17.9687L29.3183 17.963C29.0642 18.5493 29.0717 18.4228 28.8648 18.8844C28.8636 18.8634 28.8636 18.8502 28.8625 18.8279L28.8107 17.8273L28.7782 17.7942C28.389 17.8695 28.3798 17.8815 28.0203 17.9275L27.9923 17.9526C27.9884 17.9646 27.9884 17.9777 27.986 17.992L27.9884 17.9971C28.0333 18.2267 28.0225 18.1755 28.0676 18.5379C28.0886 18.7157 28.1166 18.8946 28.1376 19.0702C28.1731 19.3642 28.1929 19.5089 28.2362 19.9574C27.9935 20.358 27.936 20.5096 27.7023 20.8612L27.7039 20.8647L27.5394 21.1249C27.5205 21.1523 27.5035 21.1712 27.4796 21.1792C27.4533 21.1922 27.4192 21.1945 27.3717 21.1945H27.2806L27.1451 21.6453L27.61 21.6533C27.8829 21.6521 28.0545 21.5245 28.1468 21.3529L28.4391 20.852H28.4345L28.4652 20.8167C28.6619 20.3933 30.1577 17.8273 30.1577 17.8273ZM25.2509 23.7474H25.0537L25.7836 21.333H26.0258L26.1027 21.0843L26.1101 21.3609C26.1011 21.5318 26.2356 21.6834 26.5889 21.6583H26.9975L27.1381 21.1934H26.9844C26.896 21.1934 26.855 21.1711 26.8601 21.1232L26.8526 20.8418H26.096V20.8433C25.8513 20.8484 25.1208 20.8668 24.9728 20.9062C24.7938 20.9523 24.6052 21.0879 24.6052 21.0879L24.6793 20.8389H23.9715L23.824 21.333L23.0843 23.7843H22.9408L22.8 24.2459H24.2097L24.1625 24.3998H24.8572L24.9033 24.2459H25.0981L25.2509 23.7474ZM24.6725 21.8236C24.5591 21.855 24.3482 21.9501 24.3482 21.9501L24.5358 21.333H25.0981L24.9625 21.7826C24.9625 21.7826 24.7887 21.7928 24.6725 21.8236ZM24.6833 22.7051C24.6833 22.7051 24.5066 22.7273 24.3903 22.7536C24.2758 22.7883 24.0611 22.8977 24.0611 22.8977L24.2548 22.2555H24.8201L24.6833 22.7051ZM24.3682 23.7531H23.8041L23.9676 23.2112H24.53L24.3682 23.7531ZM25.7267 22.2555H26.5398L26.423 22.6339H25.599L25.4753 23.0477H26.1963L25.6504 23.8163C25.6122 23.8727 25.5779 23.8927 25.5398 23.9086C25.5016 23.928 25.4514 23.9508 25.3933 23.9508H25.1933L25.0559 24.4039H25.579C25.851 24.4039 26.0116 24.2802 26.1302 24.1178L26.5045 23.6055L26.5849 24.1257C26.6019 24.2231 26.672 24.2802 26.7194 24.3024C26.7718 24.3286 26.8259 24.3737 26.9023 24.3804C26.9843 24.3839 27.0435 24.3867 27.0829 24.3867H27.3399L27.4943 23.8796H27.3929C27.3347 23.8796 27.2345 23.8698 27.2174 23.8516C27.2003 23.8294 27.2003 23.7953 27.1911 23.7433L27.1096 23.222H26.7757L26.9222 23.0477H27.7445L27.8709 22.6339H27.1096L27.2282 22.2555H27.9872L28.128 21.7889H25.8651L25.7267 22.2555ZM18.859 23.8585L19.0488 23.2271H19.8288L19.9713 22.7575H19.1906L19.3098 22.3689H20.0727L20.2141 21.9142H18.3051L18.1667 22.3689H18.6004L18.4847 22.7575H18.0498L17.9057 23.2352H18.3392L18.0863 24.0705C18.0521 24.181 18.1023 24.2232 18.1341 24.2745C18.1667 24.3246 18.1996 24.3577 18.2737 24.3765C18.3502 24.3936 18.4025 24.4038 18.4737 24.4038H19.3531L19.5098 23.8836L19.12 23.9371C19.0447 23.9371 18.8362 23.9281 18.859 23.8585ZM18.9485 20.8361L18.7508 21.1933C18.7085 21.2714 18.6704 21.3198 18.6361 21.3421C18.6059 21.3609 18.5461 21.3688 18.4595 21.3688H18.3563L18.2185 21.8259H18.561C18.7257 21.8259 18.8522 21.7655 18.9126 21.7353C18.9775 21.7005 18.9946 21.7204 19.0447 21.672L19.1604 21.5717H20.23L20.3719 21.0959H19.589L19.7257 20.8361H18.9485ZM20.5275 23.8677C20.5093 23.8414 20.5224 23.7952 20.5503 23.6989L20.8426 22.7313H21.8826C22.0341 22.7291 22.1435 22.7273 22.2147 22.7222C22.2912 22.7142 22.3743 22.6869 22.4649 22.6379C22.5584 22.5866 22.6063 22.5324 22.6467 22.4703C22.6918 22.4083 22.7641 22.2726 22.8263 22.0634L23.1937 20.8389L22.1145 20.8452C22.1145 20.8452 21.7822 20.8942 21.6359 20.9484C21.4883 21.0087 21.2773 21.1774 21.2773 21.1774L21.3748 20.8417H20.7081L19.7748 23.9371C19.7417 24.0573 19.7195 24.1445 19.7144 24.1969C19.7126 24.2534 19.7856 24.3092 19.8328 24.3514C19.8887 24.3936 19.9713 24.3867 20.0505 24.3936C20.1338 24.3998 20.2522 24.4038 20.4158 24.4038H20.9281L21.0853 23.8728L20.6267 23.9161C20.5777 23.9161 20.5422 23.8898 20.5275 23.8677ZM21.0312 22.0777H22.1236L22.0541 22.2954C22.0443 22.3005 22.021 22.2846 21.9098 22.2977H20.964L21.0312 22.0777ZM21.25 21.3478H22.3516L22.2724 21.6099C22.2724 21.6099 21.7532 21.6048 21.67 21.6201C21.3042 21.6834 21.0905 21.8789 21.0905 21.8789L21.25 21.3478ZM22.0786 23.0242C22.0695 23.0568 22.0552 23.0766 22.0352 23.0915C22.0131 23.1058 21.9772 23.1109 21.9236 23.1109H21.768L21.7772 22.8458H21.1298L21.1035 24.1417C21.1025 24.2352 21.1115 24.2893 21.18 24.3326C21.2484 24.3867 21.4592 24.3936 21.7429 24.3936H22.1486L22.2951 23.9086L21.9419 23.928L21.8245 23.9348C21.8084 23.928 21.7931 23.9217 21.776 23.9046C21.7611 23.8899 21.736 23.8989 21.7401 23.8054L21.7429 23.4733L22.1133 23.4579C22.3133 23.4579 22.3988 23.3929 22.4717 23.3309C22.5413 23.2715 22.5641 23.2032 22.5903 23.1109L22.6525 22.8168H22.1435L22.0786 23.0242Z" fill="#FEFEFE"></path>', 5), tB = [
  iB
];
function aB(e, i) {
  return f(), p("svg", nB, tB);
}
const sB = /* @__PURE__ */ k(eB, [["render", aB]]), oB = {}, rB = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lB = /* @__PURE__ */ Ke('<path d="M4.875 6.25C3.84125 6.25 3 5.40875 3 4.375C3 3.34125 3.84125 2.5 4.875 2.5C5.90875 2.5 6.75 3.34125 6.75 4.375C6.75 5.40875 5.90875 6.25 4.875 6.25ZM4.875 3.4375C4.35812 3.4375 3.9375 3.85812 3.9375 4.375C3.9375 4.89188 4.35812 5.3125 4.875 5.3125C5.39188 5.3125 5.8125 4.89188 5.8125 4.375C5.8125 3.85812 5.39188 3.4375 4.875 3.4375Z" fill="#9CACCC" class="primary"></path><path d="M4.875 11.875C3.84125 11.875 3 11.0338 3 10C3 8.96625 3.84125 8.125 4.875 8.125C5.90875 8.125 6.75 8.96625 6.75 10C6.75 11.0338 5.90875 11.875 4.875 11.875ZM4.875 9.0625C4.35812 9.0625 3.9375 9.48312 3.9375 10C3.9375 10.5169 4.35812 10.9375 4.875 10.9375C5.39188 10.9375 5.8125 10.5169 5.8125 10C5.8125 9.48312 5.39188 9.0625 4.875 9.0625Z" fill="#9CACCC" class="primary"></path><path d="M4.875 17.5C3.84125 17.5 3 16.6588 3 15.625C3 14.5912 3.84125 13.75 4.875 13.75C5.90875 13.75 6.75 14.5912 6.75 15.625C6.75 16.6588 5.90875 17.5 4.875 17.5ZM4.875 14.6875C4.35812 14.6875 3.9375 15.1081 3.9375 15.625C3.9375 16.1419 4.35812 16.5625 4.875 16.5625C5.39188 16.5625 5.8125 16.1419 5.8125 15.625C5.8125 15.1081 5.39188 14.6875 4.875 14.6875Z" fill="#9CACCC" class="primary"></path><path d="M8.15625 5.3125C7.8975 5.3125 7.6875 5.1025 7.6875 4.84375C7.6875 4.585 7.8975 4.375 8.15625 4.375H17.5312C17.79 4.375 18 4.585 18 4.84375C18 5.1025 17.79 5.3125 17.5312 5.3125H8.15625Z" fill="#9CACCC" class="primary"></path><path d="M8.15625 10.9375C7.8975 10.9375 7.6875 10.7275 7.6875 10.4688C7.6875 10.21 7.8975 10 8.15625 10H17.5312C17.79 10 18 10.21 18 10.4688C18 10.7275 17.79 10.9375 17.5312 10.9375H8.15625Z" fill="#9CACCC" class="primary"></path><path d="M8.15625 16.5625C7.8975 16.5625 7.6875 16.3525 7.6875 16.0938C7.6875 15.835 7.8975 15.625 8.15625 15.625H17.5312C17.79 15.625 18 15.835 18 16.0938C18 16.3525 17.79 16.5625 17.5312 16.5625H8.15625Z" fill="#9CACCC" class="primary"></path>', 6), dB = [
  lB
];
function cB(e, i) {
  return f(), p("svg", rB, dB);
}
const fB = /* @__PURE__ */ k(oB, [["render", cB]]), uB = {}, hB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mB = /* @__PURE__ */ u("path", {
  d: "M20 25.6255C19.4825 25.6255 19.0625 25.2055 19.0625 24.688V11.9517L15.0375 15.9767C14.8613 16.153 14.625 16.2505 14.375 16.2505C14.125 16.2505 13.8888 16.153 13.7125 15.9755C13.535 15.7992 13.4375 15.563 13.4375 15.313C13.4375 15.063 13.535 14.8267 13.7125 14.6505L19.3363 9.02549C19.4238 8.93799 19.5263 8.86924 19.6425 8.82174C19.6525 8.81799 19.6625 8.81424 19.6737 8.81049C19.7812 8.77049 19.89 8.75049 20 8.75049C20.1113 8.75049 20.2213 8.77049 20.3263 8.81049C20.335 8.81299 20.3437 8.81674 20.3512 8.81924C20.4725 8.86924 20.575 8.93799 20.6637 9.02674L26.2875 14.6505C26.465 14.8267 26.5625 15.063 26.5625 15.313C26.5625 15.563 26.465 15.7992 26.2875 15.9755C26.11 16.1517 25.875 16.2505 25.625 16.2505C25.375 16.2505 25.1387 16.153 24.9625 15.9755L20.9375 11.9505V24.688C20.9375 25.2055 20.5175 25.6255 20 25.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), pB = /* @__PURE__ */ u("path", {
  d: "M9.6875 31.2505C7.1025 31.2505 5 29.148 5 26.563V24.688C5 24.1705 5.42 23.7505 5.9375 23.7505C6.455 23.7505 6.875 24.1705 6.875 24.688V26.563C6.875 28.1142 8.13625 29.3755 9.6875 29.3755H30.3125C31.8638 29.3755 33.125 28.1142 33.125 26.563V24.688C33.125 24.1705 33.545 23.7505 34.0625 23.7505C34.58 23.7505 35 24.1705 35 24.688V26.563C35 29.148 32.8975 31.2505 30.3125 31.2505H9.6875Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), yB = [
  mB,
  pB
];
function vB(e, i) {
  return f(), p("svg", hB, yB);
}
const gB = /* @__PURE__ */ k(uB, [["render", vB]]), _B = {}, wB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CB = /* @__PURE__ */ Ke('<rect x="5" y="8.75049" width="30" height="20.625" fill="#EEF3F8"></rect><rect x="5" y="8.75049" width="16.875" height="13.125" fill="#41479B"></rect><rect x="21.875" y="8.75049" width="13.125" height="1.875" fill="#DC251C"></rect><rect x="21.875" y="12.5005" width="13.125" height="1.875" fill="#DC251C"></rect><rect x="21.875" y="16.2505" width="13.125" height="1.875" fill="#DC251C"></rect><rect x="21.875" y="20.0005" width="13.125" height="1.875" fill="#DC251C"></rect><rect x="5" y="23.7505" width="30" height="1.875" fill="#DC251C"></rect><rect x="5" y="27.5005" width="30" height="1.875" fill="#DC251C"></rect><rect x="6.875" y="10.6255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="10.625" y="10.6255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="14.375" y="10.6255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="18.125" y="10.6255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="6.875" y="14.3755" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="10.625" y="14.3755" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="14.375" y="14.3755" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="8.75" y="16.2505" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="12.5" y="16.2505" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="16.25" y="16.2505" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="8.75" y="12.5005" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="12.5" y="12.5005" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="16.25" y="12.5005" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="18.125" y="14.3755" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="6.875" y="18.1255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="10.625" y="18.1255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="14.375" y="18.1255" width="1.875" height="1.875" fill="#C5D0EC"></rect><rect x="18.125" y="18.1255" width="1.875" height="1.875" fill="#C5D0EC"></rect>', 26), kB = [
  CB
];
function xB(e, i) {
  return f(), p("svg", wB, kB);
}
const bB = /* @__PURE__ */ k(_B, [["render", xB]]), MB = {}, DB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AB = /* @__PURE__ */ u("path", {
  d: "M7.82385 35.0005C6.2726 35.0005 5.01135 33.7392 5.01135 32.188V7.81299C5.01135 6.26174 6.2726 5.00049 7.82385 5.00049H21.1101C21.8614 5.00049 22.5676 5.29299 23.0989 5.82299L30.4376 13.163C30.9689 13.6942 31.2614 14.4005 31.2614 15.1505V20.9367C31.2614 21.4542 30.8414 21.8742 30.3239 21.8742C29.8064 21.8742 29.3864 21.4542 29.3864 20.9367V16.2505H22.8239C21.2726 16.2505 20.0114 14.9892 20.0114 13.438V6.87549H7.82385C7.30635 6.87549 6.88635 7.29549 6.88635 7.81299V32.188C6.88635 32.7055 7.30635 33.1255 7.82385 33.1255C8.34135 33.1255 8.76135 33.5455 8.76135 34.063C8.76135 34.5805 8.34135 35.0005 7.82385 35.0005ZM21.8864 13.438C21.8864 13.9555 22.3064 14.3755 22.8239 14.3755H28.9976L21.8864 7.26299V13.438Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), LB = /* @__PURE__ */ u("path", {
  d: "M17.1989 35.0005C16.6814 35.0005 16.2614 34.5805 16.2614 34.063V28.073L15.1901 29.858C15.0226 30.138 14.7139 30.313 14.3864 30.313C14.0589 30.313 13.7501 30.138 13.5826 29.858L12.5114 28.073V34.063C12.5114 34.5805 12.0914 35.0005 11.5739 35.0005C11.0564 35.0005 10.6364 34.5805 10.6364 34.063V24.688C10.6364 24.268 10.9189 23.8967 11.3239 23.7842C11.4039 23.7617 11.4889 23.7505 11.5751 23.7505C11.9026 23.7505 12.2101 23.9255 12.3789 24.2067L14.3876 27.5542L16.3964 24.2067C16.5639 23.9242 16.8714 23.7505 17.1989 23.7505C17.2839 23.7505 17.3689 23.763 17.4501 23.7855C17.8539 23.8967 18.1364 24.268 18.1364 24.688V34.063C18.1364 34.5805 17.7164 35.0005 17.1989 35.0005Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), TB = /* @__PURE__ */ u("path", {
  d: "M20.9489 35.0005C20.4314 35.0005 20.0114 34.5805 20.0114 34.063V24.688C20.0114 24.1705 20.4314 23.7505 20.9489 23.7505H21.8864C23.9539 23.7505 25.6364 25.433 25.6364 27.5005C25.6364 29.568 23.9539 31.2505 21.8864 31.2505V34.063C21.8864 34.5805 21.4664 35.0005 20.9489 35.0005ZM21.8864 29.3755C22.9201 29.3755 23.7614 28.5342 23.7614 27.5005C23.7614 26.4667 22.9201 25.6255 21.8864 25.6255V29.3755Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), SB = /* @__PURE__ */ u("path", {
  d: "M34.0515 35.0005C33.534 35.0005 33.114 34.5805 33.114 34.063V33.1255H28.449C28.1715 33.1255 27.9103 33.0043 27.7315 32.7918C27.5528 32.5793 27.4778 32.3005 27.5253 32.0268C28.1415 28.5005 30.4253 25.4505 33.6365 23.8655C33.7665 23.8018 33.909 23.7693 34.0515 23.7693C34.2265 23.7693 34.3978 23.818 34.5465 23.9105C34.8228 24.0818 34.989 24.3793 34.989 24.7068V34.063C34.989 34.5805 34.569 35.0005 34.0515 35.0005ZM33.114 31.2505V26.3643C31.4603 27.5655 30.229 29.293 29.634 31.2505H33.114Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), NB = [
  AB,
  LB,
  TB,
  SB
];
function EB(e, i) {
  return f(), p("svg", DB, NB);
}
const zB = /* @__PURE__ */ k(MB, [["render", EB]]), IB = {}, BB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OB = /* @__PURE__ */ u("path", {
  d: "M19.8016 29.3733C14.3859 29.3733 9.00766 25.5737 5.77922 22.019C5.27816 21.4657 5.00046 20.7461 5 19.9997C4.99954 19.2532 5.27634 18.5333 5.77672 17.9794C9.00641 14.4235 14.3909 10.6263 19.8179 10.6263L20.0066 10.6276L20.1978 10.6263C25.6073 10.6263 30.9893 14.4235 34.2202 17.9769C35.2589 19.1305 35.2601 20.8666 34.2227 22.0177C30.9905 25.5749 25.6023 29.3745 20.1678 29.3745L19.9816 29.3733H19.8016ZM19.8154 12.4999C15.0021 12.4999 10.125 15.9796 7.16658 19.2368C6.97809 19.4461 6.874 19.718 6.87446 19.9997C6.87492 20.2814 6.97991 20.5529 7.16908 20.7616C10.1263 24.0176 15.0021 27.4985 19.8179 27.4985L19.9816 27.4972L20.1516 27.4985C24.9849 27.4985 29.8707 24.0176 32.8316 20.7591C33.0201 20.5498 33.1242 20.2779 33.1237 19.9962C33.1233 19.7145 33.0183 19.443 32.8291 19.2343C29.8694 15.9796 24.9899 12.5012 20.1766 12.5012L19.9816 12.5024L19.8154 12.4999Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), HB = /* @__PURE__ */ u("path", {
  d: "M19.9965 25.6225C19.2575 25.6243 18.5255 25.4795 17.8428 25.1965C17.1602 24.9136 16.5404 24.498 16.0194 23.9739C15.4954 23.4529 15.0801 22.8331 14.7975 22.1504C14.5149 21.4677 14.3708 20.7356 14.3733 19.9967C14.3753 18.5058 14.9686 17.0764 16.023 16.0223C17.0774 14.9681 18.5068 14.3752 19.9978 14.3735C21.5001 14.3735 22.9125 14.9585 23.9749 16.0196C24.4988 16.5404 24.9142 17.16 25.197 17.8425C25.4797 18.525 25.6243 19.2568 25.6222 19.9955C25.6246 20.7351 25.48 21.4679 25.1971 22.1512C24.9141 22.8346 24.4982 23.4549 23.9737 23.9764C23.4526 24.4999 22.833 24.9149 22.1505 25.1974C21.4681 25.48 20.7364 25.6244 19.9978 25.6225H19.9965ZM19.999 16.2484C17.9317 16.2484 16.2494 17.9294 16.2494 19.9967C16.2494 20.9979 16.6394 21.9403 17.3468 22.6477C17.6941 22.9971 18.1072 23.274 18.5622 23.4626C19.0173 23.6512 19.5052 23.7476 19.9978 23.7464C21.0002 23.7464 21.9413 23.3564 22.6488 22.649C23.3562 21.9416 23.7474 20.9991 23.7474 19.998C23.7474 18.9931 23.3575 18.0519 22.6488 17.3445C22.3014 16.9959 21.8883 16.7195 21.4335 16.5314C20.9788 16.3433 20.4912 16.2471 19.999 16.2484Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), jB = [
  OB,
  HB
];
function VB(e, i) {
  return f(), p("svg", BB, jB);
}
const FB = /* @__PURE__ */ k(IB, [["render", VB]]), PB = {}, UB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RB = /* @__PURE__ */ Ke('<path d="M8.47771 32.1875C8.35152 32.1872 8.22667 32.1616 8.11054 32.1122C7.99441 32.0628 7.88934 31.9907 7.80154 31.9001C7.71592 31.8114 7.64874 31.7067 7.6039 31.5919C7.55906 31.4771 7.53745 31.3546 7.54032 31.2314C7.54254 31.1081 7.5692 30.9866 7.61876 30.8737C7.66832 30.7609 7.7398 30.659 7.82904 30.574L31.2637 8.07665C31.3522 7.99075 31.4567 7.92326 31.5714 7.8781C31.6861 7.83294 31.8087 7.811 31.9319 7.81355C32.0551 7.81611 32.1767 7.84312 32.2894 7.893C32.4021 7.94288 32.5038 8.01465 32.5886 8.10414C32.6743 8.19275 32.7416 8.29742 32.7867 8.41215C32.8318 8.52688 32.8538 8.6494 32.8513 8.77265C32.8489 8.8959 32.8221 9.01745 32.7725 9.13031C32.7229 9.24316 32.6515 9.34509 32.5623 9.43024L9.12763 31.9276C8.95247 32.0945 8.71972 32.1876 8.47771 32.1875Z" fill="#3B414D" class="primary"></path><path d="M19.9826 30.3127L19.8451 30.314C18.5352 30.314 17.2166 30.1103 15.9243 29.7103C15.7119 29.6421 15.5308 29.5005 15.4133 29.3109C15.2959 29.1213 15.2498 28.896 15.2834 28.6755C15.3169 28.455 15.4279 28.2536 15.5964 28.1075C15.7649 27.9613 15.98 27.88 16.203 27.878C16.2971 27.8778 16.3907 27.8921 16.4805 27.9205C17.5904 28.2655 18.7302 28.4405 19.8663 28.4405L20.1775 28.4417C24.9932 28.4417 29.8714 24.9596 32.8323 21.7013C33.0208 21.4919 33.1249 21.2201 33.1244 20.9384C33.1239 20.6567 33.019 20.3852 32.8298 20.1765C31.7114 18.9499 30.4724 17.839 29.1315 16.8606C29.0317 16.7884 28.9473 16.697 28.8832 16.5919C28.819 16.4868 28.7764 16.3699 28.7578 16.2482C28.7303 16.0653 28.7574 15.8784 28.8356 15.7109C28.9139 15.5434 29.0398 15.4026 29.1976 15.3063C29.3554 15.21 29.5382 15.1624 29.7229 15.1694C29.9077 15.1764 30.0863 15.2378 30.2363 15.3458C31.6804 16.4 33.0149 17.5967 34.2196 18.9179C35.2595 20.0715 35.2595 21.8075 34.2234 22.9586C30.9913 26.5157 25.6056 30.3152 20.1788 30.3152L19.9826 30.3127Z" fill="#3B414D" class="primary"></path><path d="M9.7213 26.2645C9.51305 26.2642 9.3108 26.1948 9.14637 26.067C7.93851 25.1284 6.81251 24.089 5.78052 22.9599C5.27886 22.4065 5.00069 21.6865 5 20.9396C4.99931 20.1927 5.27614 19.4721 5.77677 18.9178C9.00888 15.362 14.3957 11.5637 19.8201 11.5637L20.1163 11.565C21.1737 11.565 22.2248 11.6925 23.2409 11.9462C23.3604 11.976 23.4729 12.029 23.5719 12.1022C23.6709 12.1755 23.7545 12.2675 23.8179 12.3731C23.8813 12.4786 23.9233 12.5957 23.9415 12.7174C23.9597 12.8392 23.9538 12.9634 23.924 13.0829C23.8942 13.2024 23.8412 13.3149 23.7679 13.4138C23.6947 13.5128 23.6026 13.5964 23.4971 13.6599C23.3915 13.7233 23.2745 13.7653 23.1527 13.7835C23.0309 13.8017 22.9067 13.7957 22.7872 13.766C21.9168 13.5496 21.0232 13.4405 20.1263 13.441H19.8401C15.0119 13.441 10.1275 16.9218 7.1666 20.1789C6.97812 20.3883 6.87402 20.6601 6.87448 20.9418C6.87495 21.2235 6.97993 21.495 7.1691 21.7038C8.12853 22.7527 9.17506 23.7186 10.2975 24.5909C10.3952 24.666 10.477 24.7598 10.5382 24.8667C10.5994 24.9737 10.6389 25.0917 10.6542 25.2139C10.6695 25.3362 10.6605 25.4603 10.6276 25.579C10.5947 25.6978 10.5386 25.8088 10.4625 25.9058C10.3742 26.0179 10.2617 26.1084 10.1333 26.1706C10.0048 26.2327 9.86396 26.2648 9.7213 26.2645Z" fill="#3B414D" class="primary"></path><path d="M15.3106 21.8763C15.062 21.8763 14.8236 21.7775 14.6478 21.6017C14.472 21.426 14.3732 21.1875 14.3732 20.9389C14.3732 19.4391 14.9582 18.028 16.0205 16.9644C16.5407 16.4402 17.1598 16.0244 17.8418 15.7412C18.5238 15.458 19.2553 15.313 19.9938 15.3146C20.2525 15.3146 20.4613 15.5233 20.4625 15.782L20.465 16.7194C20.465 16.8444 20.4163 16.9631 20.3288 17.0519C20.2413 17.1406 20.1225 17.1894 19.9976 17.1894C19.5049 17.1883 19.0169 17.2849 18.5619 17.4737C18.1069 17.6625 17.6938 17.9397 17.3466 18.2892C16.9974 18.6363 16.7205 19.0492 16.5319 19.504C16.3433 19.9589 16.2468 20.4466 16.248 20.9389C16.2483 21.0621 16.2243 21.1842 16.1773 21.298C16.1303 21.4119 16.0613 21.5154 15.9742 21.6025C15.8871 21.6896 15.7836 21.7586 15.6697 21.8056C15.5559 21.8526 15.4338 21.8766 15.3106 21.8763Z" fill="#3B414D" class="primary"></path><path d="M19.9988 26.5632C19.9372 26.5634 19.8762 26.5514 19.8193 26.5279C19.7623 26.5044 19.7106 26.4699 19.667 26.4263C19.6235 26.3827 19.589 26.331 19.5655 26.2741C19.542 26.2171 19.53 26.1561 19.5301 26.0945L19.5289 25.1571C19.5289 25.0334 19.5776 24.9134 19.6664 24.8259C19.7097 24.7822 19.7613 24.7476 19.8182 24.724C19.875 24.7004 19.936 24.6883 19.9976 24.6884C20.4903 24.6899 20.9785 24.5935 21.4338 24.4049C21.889 24.2163 22.3023 23.9393 22.6497 23.5898C22.9987 23.2421 23.2753 22.8287 23.4637 22.3735C23.652 21.9183 23.7484 21.4303 23.7471 20.9376C23.7471 20.689 23.8459 20.4506 24.0217 20.2748C24.1975 20.099 24.4359 20.0002 24.6845 20.0002C24.9331 20.0002 25.1715 20.099 25.3473 20.2748C25.5231 20.4506 25.6219 20.689 25.6219 20.9376C25.6241 21.6764 25.4798 22.4084 25.1972 23.091C24.9147 23.7737 24.4995 24.3935 23.9758 24.9147C23.4549 25.4388 22.8351 25.8543 22.1525 26.1373C21.4698 26.4203 20.7378 26.565 19.9988 26.5632Z" fill="#3B414D" class="primary"></path>', 5), YB = [
  RB
];
function ZB(e, i) {
  return f(), p("svg", UB, YB);
}
const WB = /* @__PURE__ */ k(PB, [["render", ZB]]), QB = {}, qB = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GB = /* @__PURE__ */ u("path", {
  d: "M9.4887 26.5591C8.797 26.6906 8.17896 27.0747 7.75483 27.6367C7.3307 28.1987 7.13083 28.8984 7.19409 29.5996C7.25736 30.3008 7.57925 30.9534 8.09712 31.4304C8.61499 31.9075 9.2918 32.1747 9.99586 32.1803H29.9824C30.3764 32.1895 30.7677 32.1137 31.1297 31.9578C31.4916 31.8019 31.8157 31.5698 32.0797 31.2771C32.5374 30.7477 32.7861 30.0695 32.7792 29.3697C32.8124 28.702 32.5975 28.0457 32.176 27.5269C31.7545 27.008 31.1561 26.6634 30.4958 26.5591H9.4887Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), XB = /* @__PURE__ */ u("path", {
  d: "M30.2324 25.3099C30.3766 25.3102 30.5165 25.2606 30.6283 25.1696C30.74 25.0785 30.8169 24.9515 30.8457 24.8102L32.3447 17.1779C32.9974 17.1398 33.6166 16.8761 34.0963 16.4319C34.576 15.9876 34.8864 15.3904 34.9744 14.7426C35.0623 14.0947 34.9224 13.4364 34.5784 12.8803C34.2345 12.3243 33.708 11.905 33.0891 11.6943C32.4701 11.4837 31.7972 11.4947 31.1855 11.7255C30.5737 11.9562 30.0612 12.3925 29.7357 12.9595C29.4101 13.5265 29.2917 14.189 29.4008 14.8336C29.5099 15.4783 29.8396 16.065 30.3336 16.4934L27.3044 19.9498C27.2466 20.0157 27.1756 20.0687 27.0959 20.1054C27.0163 20.1421 26.9299 20.1616 26.8422 20.1627C26.7545 20.1637 26.6676 20.1463 26.5871 20.1116C26.5066 20.0768 26.4344 20.0255 26.375 19.961L21.3047 14.4285C22.0388 14.1242 22.6447 13.5748 23.0192 12.8739C23.3936 12.173 23.5135 11.3639 23.3584 10.5845C23.2033 9.80516 22.7827 9.10366 22.1684 8.59956C21.5541 8.09546 20.784 7.81995 19.9893 7.81995C19.1946 7.81995 18.4245 8.09546 17.8102 8.59956C17.1959 9.10366 16.7753 9.80516 16.6202 10.5845C16.4651 11.3639 16.585 12.173 16.9595 12.8739C17.3339 13.5748 17.9398 14.1242 18.6739 14.4285L13.6186 19.9435C13.5589 20.0086 13.486 20.0604 13.4049 20.0952C13.3237 20.1301 13.236 20.1474 13.1477 20.1459C13.0595 20.1444 12.9726 20.1243 12.8927 20.0869C12.8128 20.0494 12.7418 19.9954 12.6842 19.9285L9.69376 16.4509C10.1746 16.0125 10.4881 15.4204 10.5804 14.7763C10.6727 14.1321 10.5381 13.4759 10.1996 12.9201C9.8612 12.3643 9.34002 11.9435 8.72537 11.7297C8.11073 11.516 7.44089 11.5227 6.83064 11.7487C6.22039 11.9746 5.7077 12.4058 5.38044 12.9682C5.05318 13.5307 4.93171 14.1894 5.03685 14.8316C5.14198 15.4738 5.46718 16.0595 5.95672 16.4882C6.44625 16.9169 7.06965 17.1621 7.7201 17.1816L9.15788 24.8015C9.18493 24.9444 9.261 25.0734 9.37296 25.1662C9.48493 25.259 9.62578 25.3098 9.77121 25.3099H30.2324Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), JB = [
  GB,
  XB
];
function KB(e, i) {
  return f(), p("svg", qB, JB);
}
const $B = /* @__PURE__ */ k(QB, [["render", KB]]), eO = {}, nO = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iO = /* @__PURE__ */ Ke('<path d="M5 12.5005C5 11.1198 6.11929 10.0005 7.5 10.0005H32.5C33.8807 10.0005 35 11.1198 35 12.5005V27.5005C35 28.8812 33.8807 30.0005 32.5 30.0005H7.5C6.11929 30.0005 5 28.8812 5 27.5005V12.5005Z" fill="#D8E3F3"></path><path d="M30.8187 16.2725H29.2471C28.7719 16.2725 28.4064 16.4187 28.1871 16.8938L25.1901 23.7286H27.3099C27.3099 23.7286 27.6754 22.8149 27.7485 22.5956C27.9678 22.5956 30.0512 22.5956 30.3436 22.5956C30.4167 22.8514 30.5994 23.6921 30.5994 23.6921H32.5L30.8187 16.2725ZM28.3333 21.0605C28.5161 20.6219 29.1374 18.9771 29.1374 18.9771C29.1374 19.0137 29.3202 18.5385 29.3933 18.2827L29.5395 18.9406C29.5395 18.9406 29.9415 20.7315 30.0146 21.097H28.3333V21.0605Z" fill="#3362AB"></path><path d="M25.3362 21.2798C25.3362 22.8149 23.9473 23.8383 21.7909 23.8383C20.8771 23.8383 19.9999 23.6555 19.5248 23.4362L19.8172 21.7549L20.073 21.8646C20.7309 22.157 21.1695 22.2666 21.9736 22.2666C22.5584 22.2666 23.1798 22.0473 23.1798 21.5356C23.1798 21.2067 22.9239 20.9874 22.1198 20.6219C21.3523 20.2564 20.3289 19.6716 20.3289 18.6117C20.3289 17.1497 21.7543 16.1628 23.7645 16.1628C24.5321 16.1628 25.19 16.309 25.592 16.4918L25.2996 18.1L25.1534 17.9538C24.7879 17.8076 24.3128 17.6614 23.6183 17.6614C22.8508 17.6979 22.4853 18.0269 22.4853 18.3193C22.4853 18.6482 22.9239 18.9041 23.6183 19.233C24.7879 19.7813 25.3362 20.4026 25.3362 21.2798Z" fill="#3362AB"></path><path d="M7.5 16.3457L7.53655 16.1995H10.6798C11.1184 16.1995 11.4474 16.3457 11.557 16.8208L12.2515 20.1103C11.557 18.3559 9.94883 16.9305 7.5 16.3457Z" fill="#F9B50B"></path><path d="M16.6739 16.2724L13.494 23.692H11.3376L9.51013 17.4785C10.8259 18.3192 11.9224 19.635 12.3245 20.5487L12.5438 21.3162L14.5174 16.2358H16.6739V16.2724Z" fill="#3362AB"></path><path d="M17.5146 16.2358H19.5248L18.2456 23.692H16.2354L17.5146 16.2358Z" fill="#3362AB"></path>', 6), tO = [
  iO
];
function aO(e, i) {
  return f(), p("svg", nO, tO);
}
const sO = /* @__PURE__ */ k(eO, [["render", aO]]), oO = {}, rO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.125 12.0002C13.8468 12.0002 12 13.8471 12 16.1252C12 18.4034 13.8468 20.2502 16.125 20.2502C18.4032 20.2502 20.25 18.4034 20.25 16.1252C20.25 13.8471 18.4032 12.0002 16.125 12.0002ZM11.25 16.1252C11.25 13.4329 13.4326 11.2502 16.125 11.2502C18.8174 11.2502 21 13.4329 21 16.1252C21 18.8176 18.8174 21.0002 16.125 21.0002C13.4326 21.0002 11.25 18.8176 11.25 16.1252Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), dO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.125 13.5002C16.3321 13.5002 16.5 13.6681 16.5 13.8752V15.9002H17.625C17.8321 15.9002 18 16.0681 18 16.2752C18 16.4823 17.8321 16.6502 17.625 16.6502H16.125C15.9179 16.6502 15.75 16.4823 15.75 16.2752V13.8752C15.75 13.6681 15.9179 13.5002 16.125 13.5002Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), cO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.36575 3.00036C9.3719 3.00021 9.37806 3.00021 9.38422 3.00036C9.78102 3.01013 10.1715 3.10153 10.5315 3.26884C10.8914 3.43615 11.213 3.6758 11.4763 3.97285C11.7395 4.2699 11.9388 4.61799 12.0616 4.99542C12.1807 5.3612 12.2255 5.74693 12.1935 6.13002C12.2453 6.71087 12.1763 7.29629 11.9906 7.84936C11.8027 8.409 11.4995 8.92298 11.1008 9.35816C11.0984 9.36286 11.0934 9.37303 11.0868 9.39045C11.0728 9.42754 11.0576 9.48088 11.0443 9.54926C11.0177 9.68608 11.0036 9.85731 11.01 10.0282C11.0165 10.2017 11.0435 10.353 11.0849 10.4597C11.1192 10.5481 11.1485 10.5704 11.1528 10.5734C11.2947 10.6259 11.4358 10.6777 11.5749 10.7289C11.7651 10.7987 11.9515 10.8672 12.1309 10.9341C12.325 11.0064 12.4237 11.2223 12.3514 11.4164C12.2791 11.6105 12.0631 11.7092 11.869 11.6369C11.69 11.5701 11.5074 11.5031 11.3195 11.434C11.1795 11.3826 11.0365 11.33 10.8896 11.2757L10.8892 11.2755C10.6145 11.1736 10.4653 10.9359 10.3858 10.7312C10.3039 10.5203 10.2689 10.2791 10.2605 10.0564C10.252 9.83092 10.27 9.60208 10.3081 9.40611C10.3272 9.30809 10.3525 9.21186 10.3853 9.12509C10.416 9.04411 10.4628 8.94493 10.5374 8.86281L10.5394 8.86066C10.8715 8.50082 11.1237 8.07483 11.2796 7.61064C11.4354 7.14645 11.4914 6.65455 11.4438 6.16722C11.4414 6.14315 11.4414 6.11891 11.4437 6.09484C11.4718 5.80227 11.4394 5.50703 11.3484 5.22753C11.2575 4.94803 11.1099 4.69027 10.915 4.47029C10.72 4.25031 10.4819 4.07285 10.2153 3.94895C9.95158 3.82634 9.66565 3.75879 9.37498 3.75038C9.08432 3.75879 8.79839 3.82634 8.53464 3.94895C8.26811 4.07285 8.02994 4.25031 7.83499 4.47029C7.64005 4.69026 7.49249 4.94803 7.40153 5.22753C7.31056 5.50703 7.27814 5.80227 7.30627 6.09484C7.30857 6.11882 7.30856 6.14296 7.30624 6.16693C7.25896 6.65446 7.31534 7.14648 7.47166 7.61068C7.62799 8.07487 7.88074 8.50076 8.2133 8.86037L8.21555 8.8628L8.21554 8.86281C8.29015 8.94493 8.337 9.04411 8.36764 9.12509C8.40046 9.21186 8.4258 9.30809 8.44485 9.40611C8.48296 9.60208 8.50092 9.83092 8.49244 10.0564C8.48406 10.2791 8.4491 10.5203 8.36718 10.7312C8.28768 10.9359 8.13845 11.1736 7.86374 11.2755L7.86341 11.2757C7.69941 11.3364 7.53907 11.3953 7.38268 11.4528C6.60898 11.7372 5.93197 11.9861 5.38775 12.2364C5.06241 12.386 4.79983 12.5295 4.60164 12.672C4.40681 12.8121 4.29566 12.9361 4.23996 13.0425C3.97547 13.6655 3.81566 14.3269 3.76615 15.0002H9.74998C9.95709 15.0002 10.125 15.1681 10.125 15.3752C10.125 15.5823 9.95709 15.7502 9.74998 15.7502H3.375C3.27478 15.7502 3.17872 15.7101 3.10827 15.6388C3.03782 15.5675 2.99884 15.471 3.00003 15.3708C3.01072 14.4648 3.19933 13.5697 3.55512 12.7365C3.55805 12.7296 3.56119 12.7228 3.56452 12.7162C3.69415 12.4566 3.91221 12.244 4.16379 12.0631C4.41738 11.8807 4.72845 11.7141 5.07437 11.555C5.64809 11.2911 6.35973 11.0296 7.13309 10.7454C7.28655 10.689 7.44243 10.6317 7.60015 10.5734C7.60446 10.5704 7.63371 10.5481 7.66806 10.4597C7.70948 10.353 7.73644 10.2017 7.74297 10.0282C7.7494 9.85731 7.73525 9.68608 7.70864 9.54926C7.69535 9.48088 7.68018 9.42754 7.66615 9.39045C7.65958 9.37309 7.65463 9.36293 7.65219 9.35821C7.25298 8.92335 6.94933 8.40959 6.76089 7.85004C6.57461 7.29691 6.50505 6.7113 6.55644 6.13017C6.52449 5.74703 6.56929 5.36124 6.68835 4.99542C6.81119 4.61799 7.01044 4.2699 7.2737 3.97285C7.53695 3.6758 7.85857 3.43615 8.21849 3.26884C8.57842 3.10153 8.96895 3.01013 9.36575 3.00036Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), fO = [
  lO,
  dO,
  cO
];
function uO(e, i) {
  return f(), p("svg", rO, fO);
}
const hO = /* @__PURE__ */ k(oO, [["render", uO]]), mO = {}, pO = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yO = /* @__PURE__ */ Ke('<mask id="path-1-inside-1_14511_41733" fill="white"><path d="M12.8127 11.8754C10.2284 11.8754 8.12537 9.77233 8.12537 7.18805C8.12537 4.60378 10.2284 2.50073 12.8127 2.50073C15.397 2.50073 17.5 4.60378 17.5 7.18805C17.5 9.77233 15.3976 11.8754 12.8127 11.8754ZM12.8127 3.12571C10.5728 3.12571 8.75034 4.94814 8.75034 7.18805C8.75034 9.42797 10.5728 11.2504 12.8127 11.2504C15.0526 11.2504 16.875 9.42797 16.875 7.18805C16.875 4.94814 15.0532 3.12571 12.8127 3.12571Z"></path></mask><path d="M12.8127 11.8754C10.2284 11.8754 8.12537 9.77233 8.12537 7.18805C8.12537 4.60378 10.2284 2.50073 12.8127 2.50073C15.397 2.50073 17.5 4.60378 17.5 7.18805C17.5 9.77233 15.3976 11.8754 12.8127 11.8754ZM12.8127 3.12571C10.5728 3.12571 8.75034 4.94814 8.75034 7.18805C8.75034 9.42797 10.5728 11.2504 12.8127 11.2504C15.0526 11.2504 16.875 9.42797 16.875 7.18805C16.875 4.94814 15.0532 3.12571 12.8127 3.12571Z" fill="#3B414D" class="primary"></path><path d="M12.8127 10.5754C10.9464 10.5754 9.42537 9.05436 9.42537 7.18805H6.82537C6.82537 10.4903 9.51044 13.1754 12.8127 13.1754V10.5754ZM9.42537 7.18805C9.42537 5.32175 10.9464 3.80073 12.8127 3.80073V1.20073C9.51044 1.20073 6.82537 3.88581 6.82537 7.18805H9.42537ZM12.8127 3.80073C14.679 3.80073 16.2 5.32175 16.2 7.18805H18.8C18.8 3.88581 16.1149 1.20073 12.8127 1.20073V3.80073ZM16.2 7.18805C16.2 9.05447 14.6795 10.5754 12.8127 10.5754V13.1754C16.1157 13.1754 18.8 10.4902 18.8 7.18805H16.2ZM12.8127 1.82571C9.8548 1.82571 7.45034 4.23017 7.45034 7.18805H10.0503C10.0503 5.66611 11.2907 4.42571 12.8127 4.42571V1.82571ZM7.45034 7.18805C7.45034 10.1459 9.8548 12.5504 12.8127 12.5504V9.9504C11.2907 9.9504 10.0503 8.71 10.0503 7.18805H7.45034ZM12.8127 12.5504C15.7706 12.5504 18.175 10.1459 18.175 7.18805H15.575C15.575 8.71 14.3346 9.9504 12.8127 9.9504V12.5504ZM18.175 7.18805C18.175 4.2303 15.7713 1.82571 12.8127 1.82571V4.42571C14.3351 4.42571 15.575 5.66598 15.575 7.18805H18.175Z" fill="#3B414D" class="primary" mask="url(#path-1-inside-1_14511_41733)"></path><mask id="path-3-inside-2_14511_41733" fill="white"><path d="M12.8127 7.50057C12.729 7.50057 12.6509 7.46807 12.5915 7.40932C12.5321 7.35057 12.5002 7.27183 12.5002 7.18808V4.68755C12.5002 4.51506 12.6402 4.37506 12.8127 4.37506C12.9852 4.37506 13.1252 4.51506 13.1252 4.68755V6.87559L14.687 6.87497C14.8595 6.87497 14.9995 7.01496 14.9995 7.18745C14.9995 7.35932 14.8595 7.49994 14.687 7.49994L12.8127 7.50057ZM2.81249 17.4996C2.63999 17.4996 2.5 17.3589 2.5 17.1871V10.9373C2.5 10.7648 2.63999 10.6248 2.81249 10.6248C2.98498 10.6248 3.12498 10.7648 3.12498 10.9373V11.8748H7.18732C8.27478 11.8748 9.19912 12.6872 9.35224 13.7497H12.8121C14.0183 13.7497 14.9995 14.7309 14.9995 15.9371C14.9995 16.1096 14.8595 16.2496 14.687 16.2496H3.12498V17.1871C3.12498 17.3589 2.98498 17.4996 2.81249 17.4996ZM14.3433 15.6246C14.1964 14.9115 13.5552 14.3747 12.8127 14.3747H7.18795C7.01483 14.3747 6.87483 14.2341 6.87483 14.0622C6.87483 13.8903 7.01483 13.7497 7.18732 13.7497H8.71726C8.57039 13.0366 7.92917 12.4998 7.18732 12.4998H3.12498V15.6246H14.3433Z"></path></mask><path d="M12.8127 7.50057C12.729 7.50057 12.6509 7.46807 12.5915 7.40932C12.5321 7.35057 12.5002 7.27183 12.5002 7.18808V4.68755C12.5002 4.51506 12.6402 4.37506 12.8127 4.37506C12.9852 4.37506 13.1252 4.51506 13.1252 4.68755V6.87559L14.687 6.87497C14.8595 6.87497 14.9995 7.01496 14.9995 7.18745C14.9995 7.35932 14.8595 7.49994 14.687 7.49994L12.8127 7.50057ZM2.81249 17.4996C2.63999 17.4996 2.5 17.3589 2.5 17.1871V10.9373C2.5 10.7648 2.63999 10.6248 2.81249 10.6248C2.98498 10.6248 3.12498 10.7648 3.12498 10.9373V11.8748H7.18732C8.27478 11.8748 9.19912 12.6872 9.35224 13.7497H12.8121C14.0183 13.7497 14.9995 14.7309 14.9995 15.9371C14.9995 16.1096 14.8595 16.2496 14.687 16.2496H3.12498V17.1871C3.12498 17.3589 2.98498 17.4996 2.81249 17.4996ZM14.3433 15.6246C14.1964 14.9115 13.5552 14.3747 12.8127 14.3747H7.18795C7.01483 14.3747 6.87483 14.2341 6.87483 14.0622C6.87483 13.8903 7.01483 13.7497 7.18732 13.7497H8.71726C8.57039 13.0366 7.92917 12.4998 7.18732 12.4998H3.12498V15.6246H14.3433Z" fill="#3B414D" class="primary"></path><path d="M12.8127 7.50057L12.8127 8.80057L12.8132 8.80057L12.8127 7.50057ZM13.1252 6.87559H11.8252V8.17611L13.1257 8.17559L13.1252 6.87559ZM14.687 6.87497L14.687 5.57497L14.6865 5.57497L14.687 6.87497ZM14.687 7.49994L14.687 6.19994L14.6866 6.19994L14.687 7.49994ZM3.12498 11.8748H1.82498V13.1748H3.12498V11.8748ZM9.35224 13.7497L8.06553 13.9351L8.22616 15.0497H9.35224V13.7497ZM3.12498 16.2496V14.9496H1.82498V16.2496H3.12498ZM14.3433 15.6246V16.9246H15.9383L15.6166 15.3624L14.3433 15.6246ZM8.71726 13.7497V15.0497H10.3123L9.99054 13.4875L8.71726 13.7497ZM3.12498 12.4998V11.1998H1.82498V12.4998H3.12498ZM3.12498 15.6246H1.82498V16.9246H3.12498V15.6246ZM12.8127 6.20057C13.075 6.20057 13.3244 6.30569 13.5059 6.48523L11.6771 8.33341C11.9773 8.63045 12.383 8.80057 12.8127 8.80057V6.20057ZM13.5059 6.48523C13.7011 6.67839 13.8002 6.9358 13.8002 7.18808H11.2002C11.2002 7.60785 11.3632 8.02275 11.6771 8.33341L13.5059 6.48523ZM13.8002 7.18808V4.68755H11.2002V7.18808H13.8002ZM13.8002 4.68755C13.8002 5.23303 13.3582 5.67506 12.8127 5.67506V3.07506C11.9223 3.07506 11.2002 3.79709 11.2002 4.68755H13.8002ZM12.8127 5.67506C12.2673 5.67506 11.8252 5.23303 11.8252 4.68755H14.4252C14.4252 3.79709 13.7032 3.07506 12.8127 3.07506V5.67506ZM11.8252 4.68755V6.87559H14.4252V4.68755H11.8252ZM13.1257 8.17559L14.6876 8.17497L14.6865 5.57497L13.1247 5.57559L13.1257 8.17559ZM14.687 8.17497C14.1416 8.17497 13.6995 7.73293 13.6995 7.18745H16.2995C16.2995 6.29699 15.5775 5.57497 14.687 5.57497V8.17497ZM13.6995 7.18745C13.6995 6.64304 14.1399 6.19994 14.687 6.19994V8.79994C15.5792 8.79994 16.2995 8.0756 16.2995 7.18745H13.6995ZM14.6866 6.19994L12.8123 6.20057L12.8132 8.80057L14.6875 8.79994L14.6866 6.19994ZM2.81249 16.1996C3.35966 16.1996 3.8 16.6427 3.8 17.1871H1.2C1.2 18.0752 1.92033 18.7996 2.81249 18.7996V16.1996ZM3.8 17.1871V10.9373H1.2V17.1871H3.8ZM3.8 10.9373C3.8 11.4828 3.35796 11.9248 2.81249 11.9248V9.32482C1.92202 9.32482 1.2 10.0468 1.2 10.9373H3.8ZM2.81249 11.9248C2.26701 11.9248 1.82498 11.4828 1.82498 10.9373H4.42498C4.42498 10.0468 3.70295 9.32482 2.81249 9.32482V11.9248ZM1.82498 10.9373V11.8748H4.42498V10.9373H1.82498ZM3.12498 13.1748H7.18732V10.5748H3.12498V13.1748ZM7.18732 13.1748C7.62361 13.1748 8.00392 13.5076 8.06553 13.9351L10.6389 13.5643C10.3943 11.8669 8.92595 10.5748 7.18732 10.5748V13.1748ZM9.35224 15.0497H12.8121V12.4497H9.35224V15.0497ZM12.8121 15.0497C13.3003 15.0497 13.6995 15.4489 13.6995 15.9371H16.2995C16.2995 14.0129 14.7363 12.4497 12.8121 12.4497V15.0497ZM13.6995 15.9371C13.6995 15.3916 14.1416 14.9496 14.687 14.9496V17.5496C15.5775 17.5496 16.2995 16.8276 16.2995 15.9371H13.6995ZM14.687 14.9496H3.12498V17.5496H14.687V14.9496ZM1.82498 16.2496V17.1871H4.42498V16.2496H1.82498ZM1.82498 17.1871C1.82498 16.6427 2.26532 16.1996 2.81249 16.1996V18.7996C3.70464 18.7996 4.42498 18.0752 4.42498 17.1871H1.82498ZM15.6166 15.3624C15.3473 14.0552 14.1824 13.0747 12.8127 13.0747V15.6747C12.8666 15.6747 12.9239 15.6938 12.9754 15.7361C13.028 15.7794 13.0593 15.8346 13.07 15.8869L15.6166 15.3624ZM12.8127 13.0747H7.18795V15.6747H12.8127V13.0747ZM7.18795 13.0747C7.7328 13.0747 8.17483 13.5161 8.17483 14.0622H5.57483C5.57483 14.952 6.29686 15.6747 7.18795 15.6747V13.0747ZM8.17483 14.0622C8.17483 14.6066 7.73449 15.0497 7.18732 15.0497V12.4497C6.29517 12.4497 5.57483 13.174 5.57483 14.0622H8.17483ZM7.18732 15.0497H8.71726V12.4497H7.18732V15.0497ZM9.99054 13.4875C9.72138 12.1806 8.55666 11.1998 7.18732 11.1998V13.7998C7.24063 13.7998 7.29777 13.8187 7.34932 13.8611C7.40196 13.9044 7.43322 13.9597 7.44399 14.0119L9.99054 13.4875ZM7.18732 11.1998H3.12498V13.7998H7.18732V11.1998ZM1.82498 12.4998V15.6246H4.42498V12.4998H1.82498ZM3.12498 16.9246H14.3433V14.3246H3.12498V16.9246Z" fill="#3B414D" class="primary" mask="url(#path-3-inside-2_14511_41733)"></path>', 6), vO = [
  yO
];
function gO(e, i) {
  return f(), p("svg", pO, vO);
}
const _O = /* @__PURE__ */ k(mO, [["render", gO]]), wO = {}, CO = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.64752 6.64801C7.70242 5.59312 9.13316 5.00049 10.625 5.00049H23.125C24.6168 5.00049 26.0476 5.59312 27.1025 6.64801C28.1574 7.7029 28.75 9.13364 28.75 10.6255V16.8755C28.75 18.3673 28.1574 19.7981 27.1025 20.853C26.0476 21.9078 24.6168 22.5005 23.125 22.5005H17.7376L12.2902 27.3426C12.1063 27.5061 11.8435 27.5464 11.619 27.4456C11.3944 27.3448 11.25 27.1216 11.25 26.8755V22.5005H10.625C9.13316 22.5005 7.70242 21.9078 6.64752 20.853C5.59263 19.7981 5 18.3673 5 16.8755V10.6255C5 9.13364 5.59263 7.7029 6.64752 6.64801ZM10.625 6.25049C9.46468 6.25049 8.35188 6.71142 7.53141 7.53189C6.71094 8.35237 6.25 9.46516 6.25 10.6255V16.8755C6.25 18.0358 6.71094 19.1486 7.53141 19.9691C8.35188 20.7895 9.46468 21.2505 10.625 21.2505H11.875C12.2202 21.2505 12.5 21.5303 12.5 21.8755V25.4837L17.0848 21.4083C17.1992 21.3067 17.3469 21.2505 17.5 21.2505H23.125C24.2853 21.2505 25.3981 20.7895 26.2186 19.9691C27.0391 19.1486 27.5 18.0358 27.5 16.8755V10.6255C27.5 9.46516 27.0391 8.35237 26.2186 7.53189C25.3981 6.71142 24.2853 6.25049 23.125 6.25049H10.625ZM30 20.6255C30 20.2803 30.2798 20.0005 30.625 20.0005H31.25C32.2445 20.0005 33.1984 20.3956 33.9016 21.0988C34.6049 21.8021 35 22.7559 35 23.7505V27.5005C35 27.9929 34.903 28.4806 34.7145 28.9355C34.5261 29.3905 34.2499 29.8039 33.9016 30.1521C33.5534 30.5003 33.14 30.7766 32.685 30.965C32.2301 31.1535 31.7424 31.2505 31.25 31.2505H30V34.3755C30 34.6283 29.8477 34.8562 29.6142 34.9529C29.3806 35.0496 29.1118 34.9962 28.933 34.8174L25.3661 31.2505H22.5C22.0075 31.2505 21.5199 31.1535 21.0649 30.965C20.61 30.7766 20.1966 30.5003 19.8483 30.1521C19.5001 29.8039 19.2239 29.3905 19.0354 28.9355C18.847 28.4806 18.75 27.9929 18.75 27.5005V25.6255C18.75 25.2803 19.0298 25.0005 19.375 25.0005C19.7202 25.0005 20 25.2803 20 25.6255V27.5005C20 27.8288 20.0647 28.1539 20.1903 28.4572C20.3159 28.7605 20.5001 29.0361 20.7322 29.2682C20.9644 29.5004 21.24 29.6845 21.5433 29.8102C21.8466 29.9358 22.1717 30.0005 22.5 30.0005H25.625C25.7908 30.0005 25.9497 30.0663 26.0669 30.1835L28.75 32.8666V30.6255C28.75 30.2803 29.0298 30.0005 29.375 30.0005H31.25C31.5783 30.0005 31.9034 29.9358 32.2067 29.8102C32.51 29.6845 32.7856 29.5004 33.0178 29.2682C33.2499 29.0361 33.434 28.7605 33.5597 28.4572C33.6853 28.1539 33.75 27.8288 33.75 27.5005V23.7505C33.75 23.0874 33.4866 22.4516 33.0178 21.9827C32.5489 21.5139 31.913 21.2505 31.25 21.2505H30.625C30.2798 21.2505 30 20.9707 30 20.6255Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), xO = [
  kO
];
function bO(e, i) {
  return f(), p("svg", CO, xO);
}
const MO = /* @__PURE__ */ k(wO, [["render", bO]]), DO = {}, AO = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M27.9441 19.6156C28.156 19.3431 28.5487 19.294 28.8211 19.506L34.4461 23.881C34.5984 23.9994 34.6874 24.1814 34.6874 24.3743C34.6874 24.5672 34.5984 24.7492 34.4461 24.8676L28.8211 29.2426C28.5487 29.4546 28.156 29.4055 27.9441 29.133C27.7322 28.8605 27.7813 28.4679 28.0537 28.256L33.0444 24.3743L28.0537 20.4926C27.7813 20.2807 27.7322 19.8881 27.9441 19.6156Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), TO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.31257 16.2505C5.31257 9.92097 11.5972 5.00049 19.0626 5.00049C26.5279 5.00049 32.8126 9.91967 32.8126 16.2505V16.2584L32.8125 16.2584C32.8068 16.7154 32.7669 17.1714 32.6931 17.6225C32.6375 17.9632 32.3162 18.1942 31.9755 18.1386C31.6349 18.0829 31.4038 17.7616 31.4595 17.4209C31.523 17.0326 31.5574 16.6401 31.5626 16.2466C31.5599 10.8416 26.0955 6.25049 19.0626 6.25049C12.031 6.25049 6.56736 10.841 6.56257 16.2434C6.59434 17.5923 6.92716 18.9171 7.53673 20.1209C8.14738 21.3268 9.02026 22.3807 10.0913 23.2052C10.3199 23.3812 10.3984 23.6908 10.2812 23.9543L8.43275 28.1129L13.972 25.5579C14.114 25.4925 14.2753 25.4826 14.4241 25.5302C15.9229 26.0093 17.4871 26.2524 19.0606 26.2505C19.7268 26.2465 20.3921 26.1995 21.0523 26.1099C21.3943 26.0635 21.7092 26.3031 21.7556 26.6452C21.8021 26.9872 21.5624 27.3021 21.2204 27.3486C20.5064 27.4455 19.7868 27.4962 19.0663 27.5005L19.0634 27.5005C17.4414 27.5025 15.8286 27.2642 14.2774 26.7937L7.44934 29.943C7.21306 30.052 6.93398 30.0032 6.74871 29.8205C6.56344 29.6378 6.51076 29.3594 6.61645 29.1216L8.94423 23.8847C7.90009 22.9979 7.04192 21.9107 6.42156 20.6856C5.72661 19.3132 5.34774 17.8026 5.31273 16.2647L5.31241 16.2505H5.31257ZM23.9423 26.1302C25.4661 24.6065 27.5327 23.7505 29.6876 23.7505H34.0626C34.4077 23.7505 34.6876 24.0303 34.6876 24.3755C34.6876 24.7207 34.4077 25.0005 34.0626 25.0005H29.6876C27.8642 25.0005 26.1155 25.7248 24.8262 27.0141C23.5369 28.3034 22.8126 30.0521 22.8126 31.8755V34.3755C22.8126 34.7207 22.5327 35.0005 22.1876 35.0005C21.8424 35.0005 21.5626 34.7207 21.5626 34.3755V31.8755C21.5626 29.7206 22.4186 27.654 23.9423 26.1302Z",
  fill: "#3B414D",
  class: "primary"
}, null, -1), SO = [
  LO,
  TO
];
function NO(e, i) {
  return f(), p("svg", AO, SO);
}
const EO = /* @__PURE__ */ k(DO, [["render", NO]]), zO = {}, IO = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.5101 2.82107C4.09055 3.19418 4.35999 3.15172 4.30294 3.1689C4.06986 3.23912 3.88434 3.38437 3.75704 3.59634C3.70552 3.68211 3.66242 3.80249 3.64537 3.90821C3.64013 3.94061 3.49279 4.89709 3.31791 6.03373C3.01915 7.97559 2.99996 8.10507 3 8.17881C3.00007 8.32589 3.02895 8.45154 3.09253 8.5813C3.11355 8.6242 3.14772 8.6836 3.16846 8.7133C3.2 8.75848 3.88967 9.45107 7.38872 12.9514C9.68914 15.2527 11.5969 17.1572 11.6283 17.1837C12.1236 17.6023 12.8569 17.6047 13.3504 17.1895C13.3817 17.1632 14.3702 16.1781 15.547 15.0005C17.2152 13.3313 17.696 12.8469 17.7289 12.8024C17.9785 12.4653 18.0602 12.0491 17.9554 11.6484C17.9078 11.4661 17.8086 11.2763 17.6836 11.1284C17.6571 11.097 15.7526 9.18924 13.4513 6.88883C9.95096 3.38977 9.25838 2.7001 9.2132 2.66856C9.1835 2.64782 9.1241 2.61366 9.08119 2.59263C8.9478 2.52727 8.82426 2.49966 8.67018 2.50076C8.58672 2.50136 8.49863 2.51442 6.5101 2.82107ZM6.6571 3.88435C5.57796 4.05093 4.69325 4.18901 4.69108 4.19118C4.68891 4.19336 4.55081 5.07942 4.38419 6.16021L4.08125 8.12528L8.20128 12.2461C10.4673 14.5126 12.3341 16.3753 12.3498 16.3854C12.4269 16.4352 12.5328 16.4394 12.62 16.3961C12.6515 16.3804 16.8654 12.1707 16.8886 12.1317C16.9367 12.051 16.9383 11.9422 16.8925 11.8614C16.8819 11.8426 15.5187 10.4751 12.751 7.70677C10.4818 5.4371 8.62385 3.58042 8.62219 3.58079C8.62053 3.58117 7.73624 3.71777 6.6571 3.88435ZM7.31713 5.83609C7.24743 5.84211 7.19027 5.85168 7.13412 5.86672C6.7184 5.97814 6.41487 6.31362 6.34472 6.73923C6.33131 6.82061 6.33136 6.9885 6.34483 7.06901C6.42313 7.53717 6.77536 7.88708 7.24513 7.96336C7.36764 7.98325 7.54107 7.97444 7.66983 7.94177C8.04418 7.84679 8.34669 7.54428 8.44167 7.16993C8.48447 7.00123 8.48447 6.80724 8.44167 6.63854C8.33753 6.22809 7.98994 5.91138 7.5719 5.84605C7.49862 5.8346 7.3856 5.83018 7.31713 5.83609Z",
  fill: "#4E5666",
  class: "primary"
}, null, -1), OO = [
  BO
];
function HO(e, i) {
  return f(), p("svg", IO, OO);
}
const jO = /* @__PURE__ */ k(zO, [["render", HO]]), VO = {}, FO = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PO = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.91422 2.00989C7.86649 2.02164 7.82897 2.03857 7.79282 2.06468C7.74877 2.09651 3.54653 6.30199 3.52607 6.33472C3.50908 6.36192 3.48965 6.40724 3.47876 6.44512C3.47512 6.45777 3.47253 6.49256 3.47249 6.52912C3.47245 6.57971 3.4745 6.59875 3.48334 6.62971C3.51797 6.75101 3.61974 6.85233 3.74065 6.88586C3.76225 6.89185 3.78827 6.89385 3.84174 6.89362C3.90591 6.89335 3.91779 6.89197 3.95107 6.88089C4.03806 6.85193 3.87354 7.01214 6.02937 4.85694L8.00101 2.88589L9.97264 4.85694C12.1296 7.01331 11.9645 6.85256 12.0509 6.88056C12.1015 6.89694 12.1868 6.90098 12.2419 6.8896C12.3223 6.87299 12.4043 6.82035 12.4562 6.75198C12.5112 6.67955 12.5296 6.6236 12.5295 6.52912C12.5295 6.49256 12.5269 6.45777 12.5233 6.44512C12.5124 6.40724 12.4929 6.36192 12.4759 6.33472C12.4555 6.30199 8.25324 2.09651 8.20919 2.06468C8.12948 2.0071 8.01329 1.98552 7.91422 2.00989ZM3.79339 9.10481C3.74621 9.11027 3.69174 9.12854 3.6508 9.15264C3.60962 9.17687 3.5463 9.2393 3.52323 9.2784C3.4526 9.39811 3.45254 9.53867 3.52308 9.66011C3.53538 9.68128 4.02231 10.1712 5.64881 11.7988C6.8092 12.9599 7.77156 13.9193 7.7874 13.9306C7.90755 14.0169 8.06109 14.0231 8.19195 13.9471C8.21312 13.9348 8.70302 13.4479 10.3306 11.8214C11.4918 10.661 12.4511 9.69861 12.4625 9.68277C12.5114 9.61453 12.5295 9.5569 12.5295 9.46917C12.5295 9.42155 12.5273 9.40144 12.5188 9.37169C12.4529 9.14042 12.194 9.03352 11.9818 9.14993C11.9525 9.16598 11.7404 9.37651 9.97505 11.1413L8.00101 13.1148L6.02458 11.139L4.04814 9.16328L4.00254 9.14115C3.93469 9.1082 3.86652 9.09636 3.79339 9.10481Z",
  fill: "#D0D3D9",
  class: "primary"
}, null, -1), UO = [
  PO
];
function RO(e, i) {
  return f(), p("svg", FO, UO);
}
const YO = /* @__PURE__ */ k(VO, [["render", RO]]), l4 = {
  "add-1": fp,
  "add-circle-1": gp,
  "alarm-bell-2": Mp,
  "alarm-bell-3": Ep,
  "alarm-bell-ring": jp,
  "alert-circle-1-1": Kp,
  "alert-circle-1": Wp,
  "american-express": sy,
  "app-window-edit-1": uy,
  "app-window-edit-2": gy,
  "arrow-button-down-1": by,
  "arrow-button-right-1": Sy,
  "arrow-button-up-1": Oy,
  "arrow-left-1-1": Uy,
  "arrow-redo": qy,
  "arrow-right-1-1": ev,
  "arrow-undo": ov,
  attachment: uv,
  "bin-1-1": wv,
  "book-address-1-2": Av,
  "book-address-2": zv,
  "book-library-1": Vv,
  "book-library-2": Zv,
  Brazil: Kv,
  "building-2-1": ag,
  "button-play-1": fg,
  "button-refresh-arrow-1": vg,
  "button-refresh-arrows-1": bg,
  "charger-1": Ng,
  "chat-translate-1": Fg,
  "check-2": Wg,
  "check-circle-1-1-1": N_,
  "check-circle-1-1": M_,
  "check-double": H_,
  "check-square-1": Y_,
  "check-square-2": J_,
  "checkbox-default": Kg,
  "checkbox-disable": a_,
  "checkbox-less": f_,
  "checkbox-select": g_,
  "close-1": tw,
  "cog-1": cw,
  "cog-2": yw,
  "common-file-empty-1": kw,
  "common-file-horizontal-image-1": Sw,
  "controls-pause-1": Hw,
  "controls-play-1": Rw,
  "copy-paste-1": Gw,
  "currency-dollar-circle-1": iC,
  "default-avatar": cC,
  "delete-1-1": xC,
  "delete-1": yC,
  "delete-2-1": TC,
  "developer-community-github-1-1": BC,
  "diners-club": YC,
  discover: XC,
  "download-bottom-1": tk,
  "download-thick-bottom-1": ck,
  "email-action-unread-1": vk,
  emoji: Dk,
  "expand-8-1": Bk,
  "expand-full-1": Pk,
  "export-1": Gk,
  filter: nx,
  "fitness-biceps-1": rx,
  "flash-1-3": hx,
  "flash-1-4": _x,
  "floppy-disk-1": Lx,
  "folder-1": Ix,
  "folder-2": Fx,
  "gauge-dashboard-1": Qx,
  "gauge-dashboard-2": $x,
  "generic-card": ob,
  "graph-stats-1": ub,
  "graph-stats-ascend-2": gb,
  "graph-stats-descend-2": jb,
  "graph-status-circle-1": Mb,
  "graph-status-circle-1-1": Eb,
  "headphones-customer-support-1": Yb,
  "headphones-customer-support-2": Xb,
  "headphones-customer-support-human-1-1": tM,
  "hierarchy-3-2": dM,
  "hierarchy-3-3": pM,
  "house-1-1": kM,
  "house-2-2": LM,
  indicator: IM,
  "information-circle-4": FM,
  jcb: WM,
  "keyboard-arrow-down-1": KM,
  "keyboard-arrow-left-1": aD,
  "keyboard-arrow-right-1": cD,
  "keyboard-return-1": vD,
  "keyboard-return-1-1": xD,
  "layout-dashboard-1": ED,
  "layout-dashboard-2": PD,
  "loading-circle-1": QD,
  "lock-2-1": eA,
  "lock-2-2": oA,
  "lock-unlock-1-1": hA,
  "logout-1-1": wA,
  mastercard: TA,
  "messages-bubble-1": BA,
  "messages-bubble-3": PA,
  "messages-bubble-4": QA,
  "messaging-we-chat-2": eL,
  "messaging-we-chat-3": oL,
  "messaging-whatsapp-1": hL,
  microphone: wL,
  "navigation-menu-vertical-1": LL,
  "notes-1": IL,
  "office-file-pdf-1-1": RL,
  "paginate-filter-text-1": GL,
  "pencil-write-1": iT,
  "phone-3": lT,
  "phone-4": mT,
  "phone-charger-1": wT,
  "photography-equipment-bag-1": LT,
  "pie-line-graph-1": IT,
  preferences: FT,
  "question-circle-1": qT,
  "question-circle-2": eS,
  "radio-default": oS,
  "radio-disable": uS,
  "radio-selected": _S,
  "rating-star-1": MS,
  "rating-star-1-1": NS,
  "read-email-at-1": jS,
  "science-fiction-robot-1": YS,
  "science-fiction-robot-2": KS,
  "search-1": aN,
  "send-email-3-1": cN,
  "single-neutral-2": vN,
  "single-neutral-actions-1": bN,
  "social-media-google-1": zN,
  "social-media-facebook-1": VN,
  "social-instagram-1": ZN,
  "sort-asc": KN,
  "sort-default": sE,
  "sort-desc": uE,
  Spain: gE,
  "study-light-idea-1": bE,
  "subtract-1": SE,
  "subtract-circle-1": HE,
  "switch-default-disabled": JE,
  "switch-default": YE,
  "switch-selected-disabled": fz,
  "switch-selected": az,
  "synchronize-arrow-clock-4": gz,
  "synchronize-arrow-clock-5": Mz,
  "task-checklist-1": Ez,
  "task-list-clock-1": jz,
  "text-bold": Yz,
  "text-center": Xz,
  "text-italic": iI,
  "text-justified": lI,
  "text-left": mI,
  "text-right": wI,
  "text-underline": AI,
  "time-clock-circle-1": II,
  "typing-1": PI,
  "translate-1": QI,
  "translate-2": $I,
  unionpay: sB,
  "unordered-list": fB,
  "upload-bottom-1": gB,
  USA: bB,
  "video-file-mp4-1": zB,
  "view-1-1": FB,
  "view-off-1": WB,
  "vip-crown-queen-2": $B,
  visa: sO,
  "interaction-time": hO,
  "response-time": _O,
  messages: MO,
  "transfer-message": EO,
  "bookmark-tag-1": jO,
  "move-expand-vertical-1": YO
}, ZO = "mood", WO = "attach_file", QO = "mic", qO = "tune", GO = {
  "lock-2-1": "lock",
  "view-1-1": "visibility",
  "view-off-1": "visibility_off",
  "read-email-at-1": "alternate_email",
  "email-action-unread-1": "mail",
  "loading-circle-1": "progress_activity",
  "close-1": "close",
  "alert-circle-1": "error",
  "check-circle-1-1": "check_circle",
  "search-1": "search",
  "house-1-1": "some",
  "gauge-dashboard-2": "speed",
  "science-fiction-robot-2": "neurology",
  "hierarchy-3-2": "account_tree",
  "messaging-we-chat-3": "forum",
  "question-circle-1": "help",
  "alarm-bell-3": "notifications",
  "expand-full-1": "open_in_full",
  "expand-8-1": "close_fullscreen",
  "logout-1-1": "logout",
  "arrow-left-1-1": "chevron_left",
  "arrow-right-1-1": "chevron_right",
  "arrow-button-down-1": "expand_more",
  "task-list-clock-1": "pending_actions",
  "graph-stats-ascend-2": "trending_up",
  "graph-stats-descend-2": "trending_down",
  "messages-bubble-1": "chat_bubble",
  "chat-translate-1": "translate",
  "arrow-button-up-1": "expand_less",
  "delete-1": "error",
  "button-refresh-arrow-1": "refresh",
  "book-address-1-2": "contacts",
  "synchronize-arrow-clock-4": "update",
  "flash-1-3": "bolt",
  "phone-3": "call",
  "layout-dashboard-1": "dashboard",
  "check-square-1": "task_alt",
  "cog-1": "settings",
  "download-bottom-1": "download",
  "charger-1": "cloud",
  "upload-bottom-1": "upload",
  "copy-paste-1": "content_copy",
  "pencil-write-1": "edit_square",
  "add-1": "add",
  "time-clock-circle-1": "schedule",
  "button-refresh-arrows-1": "refresh",
  "keyboard-return-1": "keyboard_return",
  "delete-1-1": "dangerous",
  "keyboard-arrow-left-1": "keyboard_backspace",
  "graph-stats-circle-1": "vital_signs",
  "graph-stats-1": "vital_signs",
  "paginate-filter-text-1": "article",
  "keyboard-arrow-down-1": "south",
  "study-light-idea-1": "lightbulb",
  "folder-1": "folder",
  "export-1": "open_in_new",
  "add-circle-1": "add_circle",
  "subtract-circle-1": "do_not_disturb_on",
  "button-play-1": "play_circle",
  "lock-unlock-1-1": "lock_open_right",
  "video-file-mp4-1": "video_file",
  "office-file-pdf-1-1": "picture_as_pdf",
  "send-email-3-1": "send",
  "rating-star-1": "star",
  "floppy-disk-1": "save",
  "common-file-empty-1": "check_box_outline_blank",
  "currency-dollar-circle-1": "paid",
  "app-window-edit-1": "web_asset",
  "headphones-customer-support-human-1-1": "headset_mic",
  "bin-1-1": "delete",
  "book-library-1": "school",
  "notes-1": "event_note",
  "arrow-undo": "undo",
  "arrow-redo": "redo",
  emoji: ZO,
  "text-bold": "format_bold",
  "text-italic": "format_italic",
  "text-left": "format_align_left",
  "text-center": "format_align_center",
  "text-right": "format_align_right",
  "text-justified": "format_align_justify",
  attachment: WO,
  microphone: QO,
  "controls-play-1": "play_arrow",
  "controls-pause-1": "pause",
  "common-file-horizontal-image-1": "image",
  "information-circle-4": "info",
  "task-checklist-1": "content_paste",
  preferences: qO,
  "check-double": "done",
  "alarm-bell-ring": "notifications_ative",
  "bookmark-tag-1": "sell",
  "move-expand-vertical-1": "unfold_more",
  "text-underline": "format_underlined",
  "unordered-list": "list"
};
const XO = {
  name: "Icon",
  props: {
    filled: {
      type: Boolean
    },
    next: {
      type: Boolean
    },
    icon: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md",
      validator(e) {
        return [
          "nano",
          "xs",
          "sm",
          "ant",
          "md",
          "lg",
          "xl",
          "avatar-lg",
          "avatar-md",
          "avatar-sm",
          "avatar-xs",
          "avatar-nano"
        ].indexOf(e) !== -1;
      }
    },
    lineHeight: {
      type: String,
      default: null,
      validator(e) {
        return !e || ["sm", "md", "lg"].indexOf(e) !== -1;
      }
    },
    scheme: {
      type: String,
      default: "neutral-darkest"
    }
  },
  emits: ["click", "mousedown", "mouseup"],
  computed: {
    svg() {
      return l4[this.icon];
    },
    materialSymbolsName() {
      return Object.keys(l4).includes(this.icon) && !this.next ? null : GO[this.icon] || this.icon;
    }
  },
  mounted() {
  },
  methods: {
    onClick(e) {
      this.clickable && this.$emit("click", e);
    }
  }
};
function JO(e, i, n, a, r, o) {
  return o.materialSymbolsName ? (f(), p("span", {
    key: 0,
    class: B([
      "material-symbols-rounded",
      `unnnic-icon-scheme--${n.scheme}`,
      `unnnic-icon-size--${n.size}`,
      {
        "unnnic--clickable": n.clickable,
        "material-symbols-rounded--filled": n.filled
      }
    ]),
    "data-testid": "material-icon",
    translate: "no",
    onClick: i[0] || (i[0] = (...l) => o.onClick && o.onClick(...l)),
    onMousedown: i[1] || (i[1] = (l) => e.$emit("mousedown")),
    onMouseup: i[2] || (i[2] = (l) => e.$emit("mouseup"))
  }, T(o.materialSymbolsName), 35)) : (f(), $(oi(o.svg), {
    key: 1,
    class: B([
      "unnnic-icon",
      `unnnic-icon__size--${n.size}`,
      n.clickable ? "unnnic--clickable" : "",
      n.lineHeight ? `unnnic-icon__line-height--${n.lineHeight}` : "",
      n.scheme ? `unnnic-icon-scheme--${n.scheme}` : ""
    ]),
    "data-testid": "old-map-icons",
    onClick: o.onClick,
    onMousedown: i[3] || (i[3] = (l) => e.$emit("mousedown")),
    onMouseup: i[4] || (i[4] = (l) => e.$emit("mouseup"))
  }, null, 40, ["class", "onClick"]));
}
const ce = /* @__PURE__ */ k(XO, [["render", JO], ["__scopeId", "data-v-9846e6db"]]);
function Pl(e) {
  return typeof e != "string" ? "" : e.replace(/<\/?[a-zA-Z]+\b[^>]*>/g, "");
}
function KO(e, i = [], n = 1e3) {
  return typeof e != "string" ? "" : (e.length > n && (e = e.substring(0, n)), e = Pl(e), e = e.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, (a, r) => i.includes(r.toLowerCase()) ? a : ""), e);
}
function Mt(e, i = [], n = 1e3) {
  if (typeof e != "string")
    return "";
  let a = KO(e, i, n);
  return Pl(a);
}
const $O = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    size: {
      type: String,
      default: "md",
      validator: (e) => ["md", "sm"].includes(e)
    },
    label: String,
    fixedLabel: Boolean,
    error: {
      type: [Boolean, String],
      default: !1
    },
    message: String,
    disabled: Boolean
  },
  data() {
    return {};
  },
  computed: {
    shouldShowErrorSection() {
      return this.error && (this.error !== !0 || !!this.$slots.rightMessage);
    }
  },
  methods: {
    fullySanitize: Mt
  }
}, eH = {
  key: 1,
  class: "unnnic-form-element__error"
}, nH = {
  key: 1,
  class: "unnnic-form-element__right-message"
}, iH = {
  key: 2,
  class: "unnnic-form-element__message"
}, tH = {
  key: 0,
  class: "unnnic-form-element__right-message"
};
function aH(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("section", {
    class: B(["unnnic-form-element", { "unnnic-form-element--disabled": n.disabled }])
  }, [
    n.label ? (f(), p("p", {
      key: 0,
      class: B([
        "unnnic-form-element__label",
        {
          "unnnic-form-element__label--fixed": n.fixedLabel
        }
      ])
    }, T(o.fullySanitize(n.label)), 3)) : N("", !0),
    pe(e.$slots, "default", {}, void 0, !0),
    o.shouldShowErrorSection ? (f(), p("p", eH, [
      n.error !== !0 ? (f(), p(se, { key: 0 }, [
        Z(l, {
          size: "sm",
          icon: "warning",
          scheme: "aux-red-500"
        }),
        p1(" " + T(o.fullySanitize(n.error)), 1)
      ], 64)) : N("", !0),
      e.$slots.rightMessage ? (f(), p("span", nH, [
        pe(e.$slots, "rightMessage", {}, void 0, !0)
      ])) : N("", !0)
    ])) : N("", !0),
    n.message || e.$slots.rightMessage ? (f(), p("p", iH, [
      p1(T(o.fullySanitize(n.message)) + " ", 1),
      !o.shouldShowErrorSection && e.$slots.rightMessage ? (f(), p("span", tH, [
        pe(e.$slots, "rightMessage", {}, void 0, !0)
      ])) : N("", !0)
    ])) : N("", !0)
  ], 2);
}
const Ul = /* @__PURE__ */ k($O, [["render", aH], ["__scopeId", "data-v-bee89e89"]]);
var qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Rl = { exports: {} };
(function(e, i) {
  (function(n, a) {
    e.exports = a();
  })(qt, function() {
    return function(n) {
      function a(o) {
        if (r[o])
          return r[o].exports;
        var l = r[o] = { i: o, l: !1, exports: {} };
        return n[o].call(l.exports, l, l.exports, a), l.l = !0, l.exports;
      }
      var r = {};
      return a.m = n, a.c = r, a.i = function(o) {
        return o;
      }, a.d = function(o, l, c) {
        a.o(o, l) || Object.defineProperty(o, l, { configurable: !1, enumerable: !0, get: c });
      }, a.n = function(o) {
        var l = o && o.__esModule ? function() {
          return o.default;
        } : function() {
          return o;
        };
        return a.d(l, "a", l), l;
      }, a.o = function(o, l) {
        return Object.prototype.hasOwnProperty.call(o, l);
      }, a.p = ".", a(a.s = 10);
    }([function(n, a) {
      n.exports = { "#": { pattern: /\d/ }, X: { pattern: /[0-9a-zA-Z]/ }, S: { pattern: /[a-zA-Z]/ }, A: { pattern: /[a-zA-Z]/, transform: function(r) {
        return r.toLocaleUpperCase();
      } }, a: { pattern: /[a-zA-Z]/, transform: function(r) {
        return r.toLocaleLowerCase();
      } }, "!": { escape: !0 } };
    }, function(n, a, r) {
      function o(y) {
        var v = document.createEvent("Event");
        return v.initEvent(y, !0, !0), v;
      }
      var l = r(2), c = r(0), h = r.n(c);
      a.a = function(y, v) {
        var x = v.value;
        if ((Array.isArray(x) || typeof x == "string") && (x = { mask: x, tokens: h.a }), y.tagName.toLocaleUpperCase() !== "INPUT") {
          var C = y.getElementsByTagName("input");
          if (C.length !== 1)
            throw new Error("v-mask directive requires 1 input, found " + C.length);
          y = C[0];
        }
        y.oninput = function(z) {
          if (z.isTrusted) {
            var R = y.selectionEnd, U = y.value[R - 1];
            for (y.value = r.i(l.a)(y.value, x.mask, !0, x.tokens); R < y.value.length && y.value.charAt(R - 1) !== U; )
              R++;
            y === document.activeElement && (y.setSelectionRange(R, R), setTimeout(function() {
              y.setSelectionRange(R, R);
            }, 0)), y.dispatchEvent(o("input"));
          }
        };
        var M = r.i(l.a)(y.value, x.mask, !0, x.tokens);
        M !== y.value && (y.value = M, y.dispatchEvent(o("input")));
      };
    }, function(n, a, r) {
      var o = r(6), l = r(5);
      a.a = function(c, h) {
        var y = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], v = arguments[3];
        return Array.isArray(h) ? r.i(l.a)(o.a, h, v)(c, h, y, v) : r.i(o.a)(c, h, y, v);
      };
    }, function(n, a, r) {
      function o(C) {
        C.component(v.a.name, v.a), C.directive("mask", h.a);
      }
      Object.defineProperty(a, "__esModule", { value: !0 });
      var l = r(0), c = r.n(l), h = r(1), y = r(7), v = r.n(y);
      r.d(a, "TheMask", function() {
        return v.a;
      }), r.d(a, "mask", function() {
        return h.a;
      }), r.d(a, "tokens", function() {
        return c.a;
      }), r.d(a, "version", function() {
        return x;
      });
      var x = "0.11.1";
      a.default = o, typeof window < "u" && window.Vue && window.Vue.use(o);
    }, function(n, a, r) {
      Object.defineProperty(a, "__esModule", { value: !0 });
      var o = r(1), l = r(0), c = r.n(l), h = r(2);
      a.default = { name: "TheMask", props: { value: [String, Number], mask: { type: [String, Array], required: !0 }, masked: { type: Boolean, default: !1 }, tokens: { type: Object, default: function() {
        return c.a;
      } } }, directives: { mask: o.a }, data: function() {
        return { lastValue: null, display: this.value };
      }, watch: { value: function(y) {
        y !== this.lastValue && (this.display = y);
      }, masked: function() {
        this.refresh(this.display);
      } }, computed: { config: function() {
        return { mask: this.mask, tokens: this.tokens, masked: this.masked };
      } }, methods: { onInput: function(y) {
        y.isTrusted || this.refresh(y.target.value);
      }, refresh: function(v) {
        this.display = v;
        var v = r.i(h.a)(v, this.mask, this.masked, this.tokens);
        v !== this.lastValue && (this.lastValue = v, this.$emit("input", v));
      } } };
    }, function(n, a, r) {
      function o(l, c, h) {
        return c = c.sort(function(y, v) {
          return y.length - v.length;
        }), function(y, v) {
          for (var x = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], C = 0; C < c.length; ) {
            var M = c[C];
            C++;
            var z = c[C];
            if (!(z && l(y, z, !0, h).length > M.length))
              return l(y, M, x, h);
          }
          return "";
        };
      }
      a.a = o;
    }, function(n, a, r) {
      function o(l, c) {
        var h = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], y = arguments[3];
        l = l || "", c = c || "";
        for (var v = 0, x = 0, C = ""; v < c.length && x < l.length; ) {
          var M = c[v], z = y[M], R = l[x];
          z && !z.escape ? (z.pattern.test(R) && (C += z.transform ? z.transform(R) : R, v++), x++) : (z && z.escape && (v++, M = c[v]), h && (C += M), R === M && x++, v++);
        }
        for (var U = ""; v < c.length && h; ) {
          var M = c[v];
          if (y[M]) {
            U = "";
            break;
          }
          U += M, v++;
        }
        return C + U;
      }
      a.a = o;
    }, function(n, a, r) {
      var o = r(8)(r(4), r(9), null, null);
      n.exports = o.exports;
    }, function(n, a) {
      n.exports = function(r, o, l, c) {
        var h, y = r = r || {}, v = typeof r.default;
        v !== "object" && v !== "function" || (h = r, y = r.default);
        var x = typeof y == "function" ? y.options : y;
        if (o && (x.render = o.render, x.staticRenderFns = o.staticRenderFns), l && (x._scopeId = l), c) {
          var C = x.computed || (x.computed = {});
          Object.keys(c).forEach(function(M) {
            var z = c[M];
            C[M] = function() {
              return z;
            };
          });
        }
        return { esModule: h, exports: y, options: x };
      };
    }, function(n, a) {
      n.exports = { render: function() {
        var r = this, o = r.$createElement;
        return (r._self._c || o)("input", { directives: [{ name: "mask", rawName: "v-mask", value: r.config, expression: "config" }], attrs: { type: "text" }, domProps: { value: r.display }, on: { input: r.onInput } });
      }, staticRenderFns: [] };
    }, function(n, a, r) {
      n.exports = r(3);
    }]);
  });
})(Rl);
var sH = Rl.exports;
const oH = {
  directives: { mask: sH.mask },
  props: {
    type: {
      type: String,
      default: "normal",
      validator(e) {
        return ["normal", "error"].indexOf(e) !== -1;
      }
    },
    modelValue: {
      type: String,
      default: ""
    },
    nativeType: {
      type: String,
      default: "text"
    },
    size: {
      type: String,
      default: "md"
    },
    mask: {
      type: [String, Array],
      default: ""
    },
    hasIconLeft: Boolean,
    hasIconRight: Boolean
  },
  emits: ["update:modelValue"],
  data() {
    return {};
  },
  computed: {
    attributes() {
      return {
        ...this.$attrs,
        ...this.$attrs["v-bind"],
        onInput: (e) => {
          this.$emit("update:modelValue", e.srcElement.value);
        }
      };
    },
    classes() {
      return [
        "input",
        `size-${this.size}`,
        this.type,
        {
          "input--has-icon-left": this.hasIconLeft,
          "input--has-icon-right": this.hasIconRight
        }
      ];
    }
  },
  methods: {
    fullySanitize: Mt
  }
}, rH = ["value", "type"], lH = ["value", "type"];
function dH(e, i, n, a, r, o) {
  const l = G2("mask");
  return n.mask ? S1((f(), p("input", Q1({ key: 0 }, o.attributes, {
    value: o.fullySanitize(n.modelValue),
    class: o.classes,
    type: n.nativeType
  }), null, 16, rH)), [
    [l, n.mask]
  ]) : (f(), p("input", Q1({ key: 1 }, o.attributes, {
    value: o.fullySanitize(n.modelValue),
    class: o.classes,
    type: n.nativeType
  }), null, 16, lH));
}
const cH = /* @__PURE__ */ k(oH, [["render", dH], ["__scopeId", "data-v-0caa2ccb"]]);
const fH = {
  components: {
    BaseInput: cH,
    UnnnicIcon: ce
  },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "normal",
      validator(e) {
        return ["normal", "error"].indexOf(e) !== -1;
      }
    },
    modelValue: {
      type: String,
      default: ""
    },
    nativeType: {
      type: String,
      default: ""
    },
    iconLeft: {
      type: String,
      default: null
    },
    iconRight: {
      type: String,
      default: null
    },
    iconLeftClickable: {
      type: Boolean,
      default: null
    },
    iconRightClickable: {
      type: Boolean,
      default: null
    },
    iconRightSize: {
      type: String,
      default: "sm"
    },
    allowTogglePassword: {
      type: Boolean,
      default: null
    },
    hasCloudyColor: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["icon-left-click", "icon-right-click"],
  data() {
    return {
      isFocused: !1,
      showPassword: !1
    };
  },
  computed: {
    isDisabled() {
      return this.$attrs.disabled;
    },
    iconRightSvg() {
      return this.allowTogglePassword ? this.showPassword ? "view-off-1" : "view-1-1" : this.iconRight;
    },
    iconScheme() {
      return this.type === "error" ? "aux-red-500" : this.isDisabled ? "neutral-cleanest" : this.modelValue || this.isFocused ? "neutral-dark" : (this.hasCloudyColor, "neutral-cloudy");
    },
    attributes() {
      return { ...this.$attrs, ...this.$attrs["v-bind"], ...this.$props };
    }
  },
  methods: {
    focus() {
      this.$refs["base-input"].$el.focus();
    },
    onFocus() {
      this.isFocused = !0;
    },
    onBlur() {
      this.isFocused = !1;
    },
    onIconLeftClick() {
      this.iconLeftClickable && this.$emit("icon-left-click");
    },
    onIconRightClick() {
      this.attributes.disabled || (this.allowTogglePassword ? this.showPassword = !this.showPassword : this.iconRightClickable && this.$emit("icon-right-click"));
    }
  }
};
function uH(e, i, n, a, r, o) {
  const l = j("BaseInput"), c = j("UnnnicIcon");
  return f(), p("div", {
    class: B([
      "text-input",
      `size--${n.size}`,
      `text-input--icon-right-size-${n.iconRightSize}`
    ])
  }, [
    Z(l, Q1(o.attributes, {
      ref: "base-input",
      modelValue: n.modelValue,
      size: n.size,
      nativeType: n.nativeType === "password" && r.showPassword ? "text" : n.nativeType,
      type: n.type,
      class: "input-itself",
      hasIconLeft: !!n.iconLeft,
      hasIconRight: !!n.iconRight || n.allowTogglePassword,
      onFocus: o.onFocus,
      onBlur: o.onBlur
    }), null, 16, ["modelValue", "size", "nativeType", "type", "hasIconLeft", "hasIconRight", "onFocus", "onBlur"]),
    n.iconLeft ? (f(), $(c, {
      key: 0,
      scheme: o.iconScheme,
      icon: n.iconLeft,
      size: "sm",
      clickable: n.iconLeftClickable,
      class: B(["icon-left", { clickable: n.iconLeftClickable }]),
      onClick: o.onIconLeftClick
    }, null, 8, ["scheme", "icon", "clickable", "class", "onClick"])) : N("", !0),
    o.iconRightSvg ? (f(), $(c, {
      key: 1,
      scheme: o.iconScheme,
      icon: o.iconRightSvg,
      size: n.iconRightSize,
      clickable: n.iconRightClickable || n.allowTogglePassword,
      class: B([
        "icon-right",
        { clickable: n.iconRightClickable || n.allowTogglePassword }
      ]),
      onClick: o.onIconRightClick
    }, null, 8, ["scheme", "icon", "size", "clickable", "class", "onClick"])) : N("", !0)
  ], 2);
}
const Yl = /* @__PURE__ */ k(fH, [["render", uH], ["__scopeId", "data-v-c1401a33"]]);
const hH = {
  name: "UnnnicInput",
  components: { TextInput: Yl },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "normal",
      validator(e) {
        return ["normal", "error"].indexOf(e) !== -1;
      }
    },
    modelValue: {
      type: String,
      default: ""
    },
    nativeType: {
      type: String,
      default: "text"
    },
    message: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    iconLeft: {
      type: String,
      default: null
    },
    iconRight: {
      type: String,
      default: null
    },
    allowTogglePassword: {
      type: Boolean,
      default: !1
    },
    iconLeftClickable: {
      type: Boolean,
      default: null
    },
    iconRightClickable: {
      type: Boolean,
      default: null
    },
    hasCloudyColor: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    mask: {
      type: [String, Array],
      default: ""
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      val: this.modelValue
    };
  },
  computed: {
    hasLabelSlot() {
      return !!this.$slots.label;
    }
  },
  methods: {
    fullySanitize: Mt
  },
  watch: {
    val() {
      this.$emit("update:modelValue", Mt(this.val));
    },
    modelValue() {
      this.val = this.modelValue;
    }
  },
  mounted() {
    this.val = this.modelValue;
  }
}, mH = {
  key: 0,
  class: "unnnic-form__label"
}, pH = {
  key: 1,
  class: "unnnic-form__label"
}, yH = {
  key: 2,
  class: "unnnic-form__message"
};
function vH(e, i, n, a, r, o) {
  const l = j("TextInput");
  return f(), p("div", {
    class: B(["unnnic-form", n.size])
  }, [
    o.hasLabelSlot ? (f(), p("p", mH, [
      pe(e.$slots, "label", {}, void 0, !0)
    ])) : n.label ? (f(), p("p", pH, T(o.fullySanitize(n.label)), 1)) : N("", !0),
    Z(l, Q1(e.$attrs, {
      modelValue: r.val,
      "onUpdate:modelValue": i[0] || (i[0] = (c) => r.val = c),
      class: "unnnic-form-input",
      placeholder: n.placeholder,
      iconLeft: n.iconLeft,
      iconRight: n.iconRight,
      type: n.type,
      iconLeftClickable: n.iconLeftClickable,
      iconRightClickable: n.iconRightClickable,
      hasCloudyColor: n.hasCloudyColor,
      size: n.size,
      mask: n.mask,
      nativeType: n.nativeType
    }), null, 16, ["modelValue", "placeholder", "iconLeft", "iconRight", "type", "iconLeftClickable", "iconRightClickable", "hasCloudyColor", "size", "mask", "nativeType"]),
    n.message ? (f(), p("p", yH, T(o.fullySanitize(n.message)), 1)) : N("", !0)
  ], 2);
}
const _0 = /* @__PURE__ */ k(hH, [["render", vH], ["__scopeId", "data-v-24f2d284"]]);
const gH = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    modelValue: String,
    label: String,
    iconLeft: String,
    iconRight: String,
    allowTogglePassword: Boolean,
    disabled: Boolean,
    maxlength: {
      type: [String, Number]
    },
    size: {
      type: String,
      default: "md",
      validator: (e) => ["md", "sm"].includes(e)
    },
    type: {
      type: String,
      default: "normal",
      validator: (e) => ["normal", "error"].includes(e)
    },
    nativeType: {
      type: String,
      default: "text",
      validator: (e) => ["text", "password"].includes(e)
    },
    placeholder: String,
    message: String,
    error: {
      type: [Boolean, String]
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isFocused: !1,
      showPassword: !1
    };
  },
  computed: {
    hasError() {
      return this.error === !0 || this.error || this.type === "error";
    },
    iconScheme() {
      return this.hasError ? "feedback-red" : this.isFocused ? "neutral-dark" : "neutral-cloudy";
    }
  },
  methods: {
    focus() {
      this.isFocused = !0;
    },
    blur() {
      this.isFocused = !1;
    }
  }
}, _H = ["type", "placeholder", "disabled", "value", "maxlength", "readonly"], wH = {
  key: 1,
  class: "message unnnic-font secondary body-md color-feedback-red"
}, CH = {
  key: 2,
  class: "message unnnic-font secondary body-md color-neutral-cloudy"
};
function kH(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B(["unnnic-input", `size-${n.size}`, { "type-error": o.hasError }])
  }, [
    e.$slots.label || n.label ? (f(), p("span", {
      key: 0,
      class: B([
        "label unnnic-font secondary color-neutral-cloudy",
        { "body-md": n.size === "sm", "body-gt": n.size == "md" }
      ]),
      onClick: i[0] || (i[0] = (c) => e.$refs.input.focus())
    }, [
      e.$slots.label ? pe(e.$slots, "label", { key: 0 }, void 0, !0) : n.label ? (f(), p(se, { key: 1 }, [
        p1(T(n.label), 1)
      ], 64)) : N("", !0)
    ], 2)) : N("", !0),
    u("div", {
      class: "input-container",
      onClick: i[7] || (i[7] = (c) => e.$refs.input.focus())
    }, [
      n.iconLeft ? (f(), $(l, {
        key: 0,
        icon: n.iconLeft,
        size: "sm",
        scheme: o.iconScheme,
        clickable: !!e.$attrs["icon-left-click"],
        onClick: i[1] || (i[1] = (c) => e.$attrs["icon-left-click"] ? e.$emit("icon-left-click") : e.$refs.input.focus())
      }, null, 8, ["icon", "scheme", "clickable"])) : N("", !0),
      u("input", {
        ref: "input",
        class: "unnnic-font secondary",
        type: n.allowTogglePassword ? r.showPassword ? "text" : "password" : n.nativeType,
        placeholder: n.placeholder,
        disabled: n.disabled,
        value: n.modelValue,
        maxlength: n.maxlength,
        readonly: n.readonly,
        onFocus: i[2] || (i[2] = (...c) => o.focus && o.focus(...c)),
        onBlur: i[3] || (i[3] = (...c) => o.blur && o.blur(...c)),
        onInput: i[4] || (i[4] = (c) => e.$emit("update:model-value", c.srcElement.value))
      }, null, 40, _H),
      n.iconRight ? (f(), $(l, {
        key: 1,
        icon: n.iconRight,
        size: "sm",
        scheme: o.iconScheme,
        clickable: !!e.$attrs["icon-right-click"],
        onClick: i[5] || (i[5] = (c) => e.$attrs["icon-right-click"] ? e.$emit("icon-right-click") : e.$refs.input.focus())
      }, null, 8, ["icon", "scheme", "clickable"])) : N("", !0),
      n.allowTogglePassword ? (f(), $(l, {
        key: 2,
        icon: r.showPassword ? "view-off-1" : "view-1-1",
        size: "sm",
        scheme: o.iconScheme,
        clickable: "",
        onClick: i[6] || (i[6] = (c) => r.showPassword = !r.showPassword)
      }, null, 8, ["icon", "scheme"])) : N("", !0)
    ]),
    n.error && n.error !== !0 ? (f(), p("div", wH, T(n.error), 1)) : n.message ? (f(), p("div", CH, T(n.message), 1)) : N("", !0)
  ], 2);
}
const xH = /* @__PURE__ */ k(gH, [["render", kH], ["__scopeId", "data-v-1bfe622c"]]);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Zl;
function oe() {
  return Zl.apply(null, arguments);
}
function bH(e) {
  Zl = e;
}
function Un(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function bt(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function qe(e, i) {
  return Object.prototype.hasOwnProperty.call(e, i);
}
function W3(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var i;
  for (i in e)
    if (qe(e, i))
      return !1;
  return !0;
}
function tn(e) {
  return e === void 0;
}
function zi(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function X2(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Wl(e, i) {
  var n = [], a, r = e.length;
  for (a = 0; a < r; ++a)
    n.push(i(e[a], a));
  return n;
}
function Ki(e, i) {
  for (var n in i)
    qe(i, n) && (e[n] = i[n]);
  return qe(i, "toString") && (e.toString = i.toString), qe(i, "valueOf") && (e.valueOf = i.valueOf), e;
}
function di(e, i, n, a) {
  return pd(e, i, n, a, !0).utc();
}
function MH() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Ae(e) {
  return e._pf == null && (e._pf = MH()), e._pf;
}
var g3;
Array.prototype.some ? g3 = Array.prototype.some : g3 = function(e) {
  var i = Object(this), n = i.length >>> 0, a;
  for (a = 0; a < n; a++)
    if (a in i && e.call(this, i[a], a, i))
      return !0;
  return !1;
};
function Q3(e) {
  var i = null, n = !1, a = e._d && !isNaN(e._d.getTime());
  if (a && (i = Ae(e), n = g3.call(i.parsedDateParts, function(r) {
    return r != null;
  }), a = i.overflow < 0 && !i.empty && !i.invalidEra && !i.invalidMonth && !i.invalidWeekday && !i.weekdayMismatch && !i.nullInput && !i.invalidFormat && !i.userInvalidated && (!i.meridiem || i.meridiem && n), e._strict && (a = a && i.charsLeftOver === 0 && i.unusedTokens.length === 0 && i.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = a;
  else
    return a;
  return e._isValid;
}
function w0(e) {
  var i = di(NaN);
  return e != null ? Ki(Ae(i), e) : Ae(i).userInvalidated = !0, i;
}
var d4 = oe.momentProperties = [], n3 = !1;
function q3(e, i) {
  var n, a, r, o = d4.length;
  if (tn(i._isAMomentObject) || (e._isAMomentObject = i._isAMomentObject), tn(i._i) || (e._i = i._i), tn(i._f) || (e._f = i._f), tn(i._l) || (e._l = i._l), tn(i._strict) || (e._strict = i._strict), tn(i._tzm) || (e._tzm = i._tzm), tn(i._isUTC) || (e._isUTC = i._isUTC), tn(i._offset) || (e._offset = i._offset), tn(i._pf) || (e._pf = Ae(i)), tn(i._locale) || (e._locale = i._locale), o > 0)
    for (n = 0; n < o; n++)
      a = d4[n], r = i[a], tn(r) || (e[a] = r);
  return e;
}
function J2(e) {
  q3(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), n3 === !1 && (n3 = !0, oe.updateOffset(this), n3 = !1);
}
function Rn(e) {
  return e instanceof J2 || e != null && e._isAMomentObject != null;
}
function Ql(e) {
  oe.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Nn(e, i) {
  var n = !0;
  return Ki(function() {
    if (oe.deprecationHandler != null && oe.deprecationHandler(null, e), n) {
      var a = [], r, o, l, c = arguments.length;
      for (o = 0; o < c; o++) {
        if (r = "", typeof arguments[o] == "object") {
          r += `
[` + o + "] ";
          for (l in arguments[0])
            qe(arguments[0], l) && (r += l + ": " + arguments[0][l] + ", ");
          r = r.slice(0, -2);
        } else
          r = arguments[o];
        a.push(r);
      }
      Ql(
        e + `
Arguments: ` + Array.prototype.slice.call(a).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return i.apply(this, arguments);
  }, i);
}
var c4 = {};
function ql(e, i) {
  oe.deprecationHandler != null && oe.deprecationHandler(e, i), c4[e] || (Ql(i), c4[e] = !0);
}
oe.suppressDeprecationWarnings = !1;
oe.deprecationHandler = null;
function ci(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function DH(e) {
  var i, n;
  for (n in e)
    qe(e, n) && (i = e[n], ci(i) ? this[n] = i : this["_" + n] = i);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function _3(e, i) {
  var n = Ki({}, e), a;
  for (a in i)
    qe(i, a) && (bt(e[a]) && bt(i[a]) ? (n[a] = {}, Ki(n[a], e[a]), Ki(n[a], i[a])) : i[a] != null ? n[a] = i[a] : delete n[a]);
  for (a in e)
    qe(e, a) && !qe(i, a) && bt(e[a]) && (n[a] = Ki({}, n[a]));
  return n;
}
function G3(e) {
  e != null && this.set(e);
}
var w3;
Object.keys ? w3 = Object.keys : w3 = function(e) {
  var i, n = [];
  for (i in e)
    qe(e, i) && n.push(i);
  return n;
};
var AH = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function LH(e, i, n) {
  var a = this._calendar[e] || this._calendar.sameElse;
  return ci(a) ? a.call(i, n) : a;
}
function li(e, i, n) {
  var a = "" + Math.abs(e), r = i - a.length, o = e >= 0;
  return (o ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + a;
}
var X3 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Ra = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, i3 = {}, e2 = {};
function ye(e, i, n, a) {
  var r = a;
  typeof a == "string" && (r = function() {
    return this[a]();
  }), e && (e2[e] = r), i && (e2[i[0]] = function() {
    return li(r.apply(this, arguments), i[1], i[2]);
  }), n && (e2[n] = function() {
    return this.localeData().ordinal(
      r.apply(this, arguments),
      e
    );
  });
}
function TH(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function SH(e) {
  var i = e.match(X3), n, a;
  for (n = 0, a = i.length; n < a; n++)
    e2[i[n]] ? i[n] = e2[i[n]] : i[n] = TH(i[n]);
  return function(r) {
    var o = "", l;
    for (l = 0; l < a; l++)
      o += ci(i[l]) ? i[l].call(r, e) : i[l];
    return o;
  };
}
function Xa(e, i) {
  return e.isValid() ? (i = Gl(i, e.localeData()), i3[i] = i3[i] || SH(i), i3[i](e)) : e.localeData().invalidDate();
}
function Gl(e, i) {
  var n = 5;
  function a(r) {
    return i.longDateFormat(r) || r;
  }
  for (Ra.lastIndex = 0; n >= 0 && Ra.test(e); )
    e = e.replace(
      Ra,
      a
    ), Ra.lastIndex = 0, n -= 1;
  return e;
}
var NH = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function EH(e) {
  var i = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return i || !n ? i : (this._longDateFormat[e] = n.match(X3).map(function(a) {
    return a === "MMMM" || a === "MM" || a === "DD" || a === "dddd" ? a.slice(1) : a;
  }).join(""), this._longDateFormat[e]);
}
var zH = "Invalid date";
function IH() {
  return this._invalidDate;
}
var BH = "%d", OH = /\d{1,2}/;
function HH(e) {
  return this._ordinal.replace("%d", e);
}
var jH = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function VH(e, i, n, a) {
  var r = this._relativeTime[n];
  return ci(r) ? r(e, i, n, a) : r.replace(/%d/i, e);
}
function FH(e, i) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return ci(n) ? n(i) : n.replace(/%s/i, i);
}
var f4 = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function En(e) {
  return typeof e == "string" ? f4[e] || f4[e.toLowerCase()] : void 0;
}
function J3(e) {
  var i = {}, n, a;
  for (a in e)
    qe(e, a) && (n = En(a), n && (i[n] = e[a]));
  return i;
}
var PH = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function UH(e) {
  var i = [], n;
  for (n in e)
    qe(e, n) && i.push({ unit: n, priority: PH[n] });
  return i.sort(function(a, r) {
    return a.priority - r.priority;
  }), i;
}
var Xl = /\d/, pn = /\d\d/, Jl = /\d{3}/, K3 = /\d{4}/, C0 = /[+-]?\d{6}/, d1 = /\d\d?/, Kl = /\d\d\d\d?/, $l = /\d\d\d\d\d\d?/, k0 = /\d{1,3}/, $3 = /\d{1,4}/, x0 = /[+-]?\d{1,6}/, c2 = /\d+/, b0 = /[+-]?\d+/, RH = /Z|[+-]\d\d:?\d\d/gi, M0 = /Z|[+-]\d\d(?::?\d\d)?/gi, YH = /[+-]?\d+(\.\d{1,3})?/, K2 = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, f2 = /^[1-9]\d?/, eo = /^([1-9]\d|\d)/, t0;
t0 = {};
function ue(e, i, n) {
  t0[e] = ci(i) ? i : function(a, r) {
    return a && n ? n : i;
  };
}
function ZH(e, i) {
  return qe(t0, e) ? t0[e](i._strict, i._locale) : new RegExp(WH(e));
}
function WH(e) {
  return Ni(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(i, n, a, r, o) {
        return n || a || r || o;
      }
    )
  );
}
function Ni(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Tn(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function je(e) {
  var i = +e, n = 0;
  return i !== 0 && isFinite(i) && (n = Tn(i)), n;
}
var C3 = {};
function i1(e, i) {
  var n, a = i, r;
  for (typeof e == "string" && (e = [e]), zi(i) && (a = function(o, l) {
    l[i] = je(o);
  }), r = e.length, n = 0; n < r; n++)
    C3[e[n]] = a;
}
function $2(e, i) {
  i1(e, function(n, a, r, o) {
    r._w = r._w || {}, i(n, r._w, r, o);
  });
}
function QH(e, i, n) {
  i != null && qe(C3, e) && C3[e](i, n._a, n, e);
}
function D0(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var P1 = 0, Li = 1, ti = 2, b1 = 3, Pn = 4, Ti = 5, xt = 6, qH = 7, GH = 8;
ye("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? li(e, 4) : "+" + e;
});
ye(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
ye(0, ["YYYY", 4], 0, "year");
ye(0, ["YYYYY", 5], 0, "year");
ye(0, ["YYYYYY", 6, !0], 0, "year");
ue("Y", b0);
ue("YY", d1, pn);
ue("YYYY", $3, K3);
ue("YYYYY", x0, C0);
ue("YYYYYY", x0, C0);
i1(["YYYYY", "YYYYYY"], P1);
i1("YYYY", function(e, i) {
  i[P1] = e.length === 2 ? oe.parseTwoDigitYear(e) : je(e);
});
i1("YY", function(e, i) {
  i[P1] = oe.parseTwoDigitYear(e);
});
i1("Y", function(e, i) {
  i[P1] = parseInt(e, 10);
});
function H2(e) {
  return D0(e) ? 366 : 365;
}
oe.parseTwoDigitYear = function(e) {
  return je(e) + (je(e) > 68 ? 1900 : 2e3);
};
var ed = u2("FullYear", !0);
function XH() {
  return D0(this.year());
}
function u2(e, i) {
  return function(n) {
    return n != null ? (nd(this, e, n), oe.updateOffset(this, i), this) : P2(this, e);
  };
}
function P2(e, i) {
  if (!e.isValid())
    return NaN;
  var n = e._d, a = e._isUTC;
  switch (i) {
    case "Milliseconds":
      return a ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return a ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return a ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return a ? n.getUTCHours() : n.getHours();
    case "Date":
      return a ? n.getUTCDate() : n.getDate();
    case "Day":
      return a ? n.getUTCDay() : n.getDay();
    case "Month":
      return a ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return a ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function nd(e, i, n) {
  var a, r, o, l, c;
  if (!(!e.isValid() || isNaN(n))) {
    switch (a = e._d, r = e._isUTC, i) {
      case "Milliseconds":
        return void (r ? a.setUTCMilliseconds(n) : a.setMilliseconds(n));
      case "Seconds":
        return void (r ? a.setUTCSeconds(n) : a.setSeconds(n));
      case "Minutes":
        return void (r ? a.setUTCMinutes(n) : a.setMinutes(n));
      case "Hours":
        return void (r ? a.setUTCHours(n) : a.setHours(n));
      case "Date":
        return void (r ? a.setUTCDate(n) : a.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    o = n, l = e.month(), c = e.date(), c = c === 29 && l === 1 && !D0(o) ? 28 : c, r ? a.setUTCFullYear(o, l, c) : a.setFullYear(o, l, c);
  }
}
function JH(e) {
  return e = En(e), ci(this[e]) ? this[e]() : this;
}
function KH(e, i) {
  if (typeof e == "object") {
    e = J3(e);
    var n = UH(e), a, r = n.length;
    for (a = 0; a < r; a++)
      this[n[a].unit](e[n[a].unit]);
  } else if (e = En(e), ci(this[e]))
    return this[e](i);
  return this;
}
function $H(e, i) {
  return (e % i + i) % i;
}
var g1;
Array.prototype.indexOf ? g1 = Array.prototype.indexOf : g1 = function(e) {
  var i;
  for (i = 0; i < this.length; ++i)
    if (this[i] === e)
      return i;
  return -1;
};
function no(e, i) {
  if (isNaN(e) || isNaN(i))
    return NaN;
  var n = $H(i, 12);
  return e += (i - n) / 12, n === 1 ? D0(e) ? 29 : 28 : 31 - n % 7 % 2;
}
ye("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
ye("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
ye("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
ue("M", d1, f2);
ue("MM", d1, pn);
ue("MMM", function(e, i) {
  return i.monthsShortRegex(e);
});
ue("MMMM", function(e, i) {
  return i.monthsRegex(e);
});
i1(["M", "MM"], function(e, i) {
  i[Li] = je(e) - 1;
});
i1(["MMM", "MMMM"], function(e, i, n, a) {
  var r = n._locale.monthsParse(e, a, n._strict);
  r != null ? i[Li] = r : Ae(n).invalidMonth = e;
});
var ej = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), id = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), td = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, nj = K2, ij = K2;
function tj(e, i) {
  return e ? Un(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || td).test(i) ? "format" : "standalone"][e.month()] : Un(this._months) ? this._months : this._months.standalone;
}
function aj(e, i) {
  return e ? Un(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[td.test(i) ? "format" : "standalone"][e.month()] : Un(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function sj(e, i, n) {
  var a, r, o, l = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], a = 0; a < 12; ++a)
      o = di([2e3, a]), this._shortMonthsParse[a] = this.monthsShort(
        o,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[a] = this.months(o, "").toLocaleLowerCase();
  return n ? i === "MMM" ? (r = g1.call(this._shortMonthsParse, l), r !== -1 ? r : null) : (r = g1.call(this._longMonthsParse, l), r !== -1 ? r : null) : i === "MMM" ? (r = g1.call(this._shortMonthsParse, l), r !== -1 ? r : (r = g1.call(this._longMonthsParse, l), r !== -1 ? r : null)) : (r = g1.call(this._longMonthsParse, l), r !== -1 ? r : (r = g1.call(this._shortMonthsParse, l), r !== -1 ? r : null));
}
function oj(e, i, n) {
  var a, r, o;
  if (this._monthsParseExact)
    return sj.call(this, e, i, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), a = 0; a < 12; a++) {
    if (r = di([2e3, a]), n && !this._longMonthsParse[a] && (this._longMonthsParse[a] = new RegExp(
      "^" + this.months(r, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[a] = new RegExp(
      "^" + this.monthsShort(r, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[a] && (o = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[a] = new RegExp(o.replace(".", ""), "i")), n && i === "MMMM" && this._longMonthsParse[a].test(e))
      return a;
    if (n && i === "MMM" && this._shortMonthsParse[a].test(e))
      return a;
    if (!n && this._monthsParse[a].test(e))
      return a;
  }
}
function ad(e, i) {
  if (!e.isValid())
    return e;
  if (typeof i == "string") {
    if (/^\d+$/.test(i))
      i = je(i);
    else if (i = e.localeData().monthsParse(i), !zi(i))
      return e;
  }
  var n = i, a = e.date();
  return a = a < 29 ? a : Math.min(a, no(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, a) : e._d.setMonth(n, a), e;
}
function sd(e) {
  return e != null ? (ad(this, e), oe.updateOffset(this, !0), this) : P2(this, "Month");
}
function rj() {
  return no(this.year(), this.month());
}
function lj(e) {
  return this._monthsParseExact ? (qe(this, "_monthsRegex") || od.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (qe(this, "_monthsShortRegex") || (this._monthsShortRegex = nj), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function dj(e) {
  return this._monthsParseExact ? (qe(this, "_monthsRegex") || od.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (qe(this, "_monthsRegex") || (this._monthsRegex = ij), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function od() {
  function e(h, y) {
    return y.length - h.length;
  }
  var i = [], n = [], a = [], r, o, l, c;
  for (r = 0; r < 12; r++)
    o = di([2e3, r]), l = Ni(this.monthsShort(o, "")), c = Ni(this.months(o, "")), i.push(l), n.push(c), a.push(c), a.push(l);
  i.sort(e), n.sort(e), a.sort(e), this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  );
}
function cj(e, i, n, a, r, o, l) {
  var c;
  return e < 100 && e >= 0 ? (c = new Date(e + 400, i, n, a, r, o, l), isFinite(c.getFullYear()) && c.setFullYear(e)) : c = new Date(e, i, n, a, r, o, l), c;
}
function U2(e) {
  var i, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, i = new Date(Date.UTC.apply(null, n)), isFinite(i.getUTCFullYear()) && i.setUTCFullYear(e)) : i = new Date(Date.UTC.apply(null, arguments)), i;
}
function a0(e, i, n) {
  var a = 7 + i - n, r = (7 + U2(e, 0, a).getUTCDay() - i) % 7;
  return -r + a - 1;
}
function rd(e, i, n, a, r) {
  var o = (7 + n - a) % 7, l = a0(e, a, r), c = 1 + 7 * (i - 1) + o + l, h, y;
  return c <= 0 ? (h = e - 1, y = H2(h) + c) : c > H2(e) ? (h = e + 1, y = c - H2(e)) : (h = e, y = c), {
    year: h,
    dayOfYear: y
  };
}
function R2(e, i, n) {
  var a = a0(e.year(), i, n), r = Math.floor((e.dayOfYear() - a - 1) / 7) + 1, o, l;
  return r < 1 ? (l = e.year() - 1, o = r + Ei(l, i, n)) : r > Ei(e.year(), i, n) ? (o = r - Ei(e.year(), i, n), l = e.year() + 1) : (l = e.year(), o = r), {
    week: o,
    year: l
  };
}
function Ei(e, i, n) {
  var a = a0(e, i, n), r = a0(e + 1, i, n);
  return (H2(e) - a + r) / 7;
}
ye("w", ["ww", 2], "wo", "week");
ye("W", ["WW", 2], "Wo", "isoWeek");
ue("w", d1, f2);
ue("ww", d1, pn);
ue("W", d1, f2);
ue("WW", d1, pn);
$2(
  ["w", "ww", "W", "WW"],
  function(e, i, n, a) {
    i[a.substr(0, 1)] = je(e);
  }
);
function fj(e) {
  return R2(e, this._week.dow, this._week.doy).week;
}
var uj = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function hj() {
  return this._week.dow;
}
function mj() {
  return this._week.doy;
}
function pj(e) {
  var i = this.localeData().week(this);
  return e == null ? i : this.add((e - i) * 7, "d");
}
function yj(e) {
  var i = R2(this, 1, 4).week;
  return e == null ? i : this.add((e - i) * 7, "d");
}
ye("d", 0, "do", "day");
ye("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
ye("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
ye("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
ye("e", 0, 0, "weekday");
ye("E", 0, 0, "isoWeekday");
ue("d", d1);
ue("e", d1);
ue("E", d1);
ue("dd", function(e, i) {
  return i.weekdaysMinRegex(e);
});
ue("ddd", function(e, i) {
  return i.weekdaysShortRegex(e);
});
ue("dddd", function(e, i) {
  return i.weekdaysRegex(e);
});
$2(["dd", "ddd", "dddd"], function(e, i, n, a) {
  var r = n._locale.weekdaysParse(e, a, n._strict);
  r != null ? i.d = r : Ae(n).invalidWeekday = e;
});
$2(["d", "e", "E"], function(e, i, n, a) {
  i[a] = je(e);
});
function vj(e, i) {
  return typeof e != "string" ? e : isNaN(e) ? (e = i.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function gj(e, i) {
  return typeof e == "string" ? i.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function io(e, i) {
  return e.slice(i, 7).concat(e.slice(0, i));
}
var _j = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), ld = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), wj = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Cj = K2, kj = K2, xj = K2;
function bj(e, i) {
  var n = Un(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(i) ? "format" : "standalone"];
  return e === !0 ? io(n, this._week.dow) : e ? n[e.day()] : n;
}
function Mj(e) {
  return e === !0 ? io(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Dj(e) {
  return e === !0 ? io(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Aj(e, i, n) {
  var a, r, o, l = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], a = 0; a < 7; ++a)
      o = di([2e3, 1]).day(a), this._minWeekdaysParse[a] = this.weekdaysMin(
        o,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[a] = this.weekdaysShort(
        o,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[a] = this.weekdays(o, "").toLocaleLowerCase();
  return n ? i === "dddd" ? (r = g1.call(this._weekdaysParse, l), r !== -1 ? r : null) : i === "ddd" ? (r = g1.call(this._shortWeekdaysParse, l), r !== -1 ? r : null) : (r = g1.call(this._minWeekdaysParse, l), r !== -1 ? r : null) : i === "dddd" ? (r = g1.call(this._weekdaysParse, l), r !== -1 || (r = g1.call(this._shortWeekdaysParse, l), r !== -1) ? r : (r = g1.call(this._minWeekdaysParse, l), r !== -1 ? r : null)) : i === "ddd" ? (r = g1.call(this._shortWeekdaysParse, l), r !== -1 || (r = g1.call(this._weekdaysParse, l), r !== -1) ? r : (r = g1.call(this._minWeekdaysParse, l), r !== -1 ? r : null)) : (r = g1.call(this._minWeekdaysParse, l), r !== -1 || (r = g1.call(this._weekdaysParse, l), r !== -1) ? r : (r = g1.call(this._shortWeekdaysParse, l), r !== -1 ? r : null));
}
function Lj(e, i, n) {
  var a, r, o;
  if (this._weekdaysParseExact)
    return Aj.call(this, e, i, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), a = 0; a < 7; a++) {
    if (r = di([2e3, 1]).day(a), n && !this._fullWeekdaysParse[a] && (this._fullWeekdaysParse[a] = new RegExp(
      "^" + this.weekdays(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[a] = new RegExp(
      "^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[a] || (o = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[a] = new RegExp(o.replace(".", ""), "i")), n && i === "dddd" && this._fullWeekdaysParse[a].test(e))
      return a;
    if (n && i === "ddd" && this._shortWeekdaysParse[a].test(e))
      return a;
    if (n && i === "dd" && this._minWeekdaysParse[a].test(e))
      return a;
    if (!n && this._weekdaysParse[a].test(e))
      return a;
  }
}
function Tj(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var i = P2(this, "Day");
  return e != null ? (e = vj(e, this.localeData()), this.add(e - i, "d")) : i;
}
function Sj(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var i = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? i : this.add(e - i, "d");
}
function Nj(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var i = gj(e, this.localeData());
    return this.day(this.day() % 7 ? i : i - 7);
  } else
    return this.day() || 7;
}
function Ej(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || to.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (qe(this, "_weekdaysRegex") || (this._weekdaysRegex = Cj), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function zj(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || to.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (qe(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = kj), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Ij(e) {
  return this._weekdaysParseExact ? (qe(this, "_weekdaysRegex") || to.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (qe(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = xj), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function to() {
  function e(v, x) {
    return x.length - v.length;
  }
  var i = [], n = [], a = [], r = [], o, l, c, h, y;
  for (o = 0; o < 7; o++)
    l = di([2e3, 1]).day(o), c = Ni(this.weekdaysMin(l, "")), h = Ni(this.weekdaysShort(l, "")), y = Ni(this.weekdays(l, "")), i.push(c), n.push(h), a.push(y), r.push(c), r.push(h), r.push(y);
  i.sort(e), n.sort(e), a.sort(e), r.sort(e), this._weekdaysRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + a.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + i.join("|") + ")",
    "i"
  );
}
function ao() {
  return this.hours() % 12 || 12;
}
function Bj() {
  return this.hours() || 24;
}
ye("H", ["HH", 2], 0, "hour");
ye("h", ["hh", 2], 0, ao);
ye("k", ["kk", 2], 0, Bj);
ye("hmm", 0, 0, function() {
  return "" + ao.apply(this) + li(this.minutes(), 2);
});
ye("hmmss", 0, 0, function() {
  return "" + ao.apply(this) + li(this.minutes(), 2) + li(this.seconds(), 2);
});
ye("Hmm", 0, 0, function() {
  return "" + this.hours() + li(this.minutes(), 2);
});
ye("Hmmss", 0, 0, function() {
  return "" + this.hours() + li(this.minutes(), 2) + li(this.seconds(), 2);
});
function dd(e, i) {
  ye(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      i
    );
  });
}
dd("a", !0);
dd("A", !1);
function cd(e, i) {
  return i._meridiemParse;
}
ue("a", cd);
ue("A", cd);
ue("H", d1, eo);
ue("h", d1, f2);
ue("k", d1, f2);
ue("HH", d1, pn);
ue("hh", d1, pn);
ue("kk", d1, pn);
ue("hmm", Kl);
ue("hmmss", $l);
ue("Hmm", Kl);
ue("Hmmss", $l);
i1(["H", "HH"], b1);
i1(["k", "kk"], function(e, i, n) {
  var a = je(e);
  i[b1] = a === 24 ? 0 : a;
});
i1(["a", "A"], function(e, i, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
i1(["h", "hh"], function(e, i, n) {
  i[b1] = je(e), Ae(n).bigHour = !0;
});
i1("hmm", function(e, i, n) {
  var a = e.length - 2;
  i[b1] = je(e.substr(0, a)), i[Pn] = je(e.substr(a)), Ae(n).bigHour = !0;
});
i1("hmmss", function(e, i, n) {
  var a = e.length - 4, r = e.length - 2;
  i[b1] = je(e.substr(0, a)), i[Pn] = je(e.substr(a, 2)), i[Ti] = je(e.substr(r)), Ae(n).bigHour = !0;
});
i1("Hmm", function(e, i, n) {
  var a = e.length - 2;
  i[b1] = je(e.substr(0, a)), i[Pn] = je(e.substr(a));
});
i1("Hmmss", function(e, i, n) {
  var a = e.length - 4, r = e.length - 2;
  i[b1] = je(e.substr(0, a)), i[Pn] = je(e.substr(a, 2)), i[Ti] = je(e.substr(r));
});
function Oj(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Hj = /[ap]\.?m?\.?/i, jj = u2("Hours", !0);
function Vj(e, i, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var fd = {
  calendar: AH,
  longDateFormat: NH,
  invalidDate: zH,
  ordinal: BH,
  dayOfMonthOrdinalParse: OH,
  relativeTime: jH,
  months: ej,
  monthsShort: id,
  week: uj,
  weekdays: _j,
  weekdaysMin: wj,
  weekdaysShort: ld,
  meridiemParse: Hj
}, f1 = {}, E2 = {}, Y2;
function Fj(e, i) {
  var n, a = Math.min(e.length, i.length);
  for (n = 0; n < a; n += 1)
    if (e[n] !== i[n])
      return n;
  return a;
}
function u4(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Pj(e) {
  for (var i = 0, n, a, r, o; i < e.length; ) {
    for (o = u4(e[i]).split("-"), n = o.length, a = u4(e[i + 1]), a = a ? a.split("-") : null; n > 0; ) {
      if (r = A0(o.slice(0, n).join("-")), r)
        return r;
      if (a && a.length >= n && Fj(o, a) >= n - 1)
        break;
      n--;
    }
    i++;
  }
  return Y2;
}
function Uj(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function A0(e) {
  var i = null, n;
  if (f1[e] === void 0 && typeof module < "u" && module && module.exports && Uj(e))
    try {
      i = Y2._abbr, n = require, n("./locale/" + e), nt(i);
    } catch {
      f1[e] = null;
    }
  return f1[e];
}
function nt(e, i) {
  var n;
  return e && (tn(i) ? n = Ii(e) : n = so(e, i), n ? Y2 = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Y2._abbr;
}
function so(e, i) {
  if (i !== null) {
    var n, a = fd;
    if (i.abbr = e, f1[e] != null)
      ql(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), a = f1[e]._config;
    else if (i.parentLocale != null)
      if (f1[i.parentLocale] != null)
        a = f1[i.parentLocale]._config;
      else if (n = A0(i.parentLocale), n != null)
        a = n._config;
      else
        return E2[i.parentLocale] || (E2[i.parentLocale] = []), E2[i.parentLocale].push({
          name: e,
          config: i
        }), null;
    return f1[e] = new G3(_3(a, i)), E2[e] && E2[e].forEach(function(r) {
      so(r.name, r.config);
    }), nt(e), f1[e];
  } else
    return delete f1[e], null;
}
function Rj(e, i) {
  if (i != null) {
    var n, a, r = fd;
    f1[e] != null && f1[e].parentLocale != null ? f1[e].set(_3(f1[e]._config, i)) : (a = A0(e), a != null && (r = a._config), i = _3(r, i), a == null && (i.abbr = e), n = new G3(i), n.parentLocale = f1[e], f1[e] = n), nt(e);
  } else
    f1[e] != null && (f1[e].parentLocale != null ? (f1[e] = f1[e].parentLocale, e === nt() && nt(e)) : f1[e] != null && delete f1[e]);
  return f1[e];
}
function Ii(e) {
  var i;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Y2;
  if (!Un(e)) {
    if (i = A0(e), i)
      return i;
    e = [e];
  }
  return Pj(e);
}
function Yj() {
  return w3(f1);
}
function oo(e) {
  var i, n = e._a;
  return n && Ae(e).overflow === -2 && (i = n[Li] < 0 || n[Li] > 11 ? Li : n[ti] < 1 || n[ti] > no(n[P1], n[Li]) ? ti : n[b1] < 0 || n[b1] > 24 || n[b1] === 24 && (n[Pn] !== 0 || n[Ti] !== 0 || n[xt] !== 0) ? b1 : n[Pn] < 0 || n[Pn] > 59 ? Pn : n[Ti] < 0 || n[Ti] > 59 ? Ti : n[xt] < 0 || n[xt] > 999 ? xt : -1, Ae(e)._overflowDayOfYear && (i < P1 || i > ti) && (i = ti), Ae(e)._overflowWeeks && i === -1 && (i = qH), Ae(e)._overflowWeekday && i === -1 && (i = GH), Ae(e).overflow = i), e;
}
var Zj = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Wj = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Qj = /Z|[+-]\d\d(?::?\d\d)?/, Ya = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], t3 = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], qj = /^\/?Date\((-?\d+)/i, Gj = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, Xj = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ud(e) {
  var i, n, a = e._i, r = Zj.exec(a) || Wj.exec(a), o, l, c, h, y = Ya.length, v = t3.length;
  if (r) {
    for (Ae(e).iso = !0, i = 0, n = y; i < n; i++)
      if (Ya[i][1].exec(r[1])) {
        l = Ya[i][0], o = Ya[i][2] !== !1;
        break;
      }
    if (l == null) {
      e._isValid = !1;
      return;
    }
    if (r[3]) {
      for (i = 0, n = v; i < n; i++)
        if (t3[i][1].exec(r[3])) {
          c = (r[2] || " ") + t3[i][0];
          break;
        }
      if (c == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!o && c != null) {
      e._isValid = !1;
      return;
    }
    if (r[4])
      if (Qj.exec(r[4]))
        h = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = l + (c || "") + (h || ""), lo(e);
  } else
    e._isValid = !1;
}
function Jj(e, i, n, a, r, o) {
  var l = [
    Kj(e),
    id.indexOf(i),
    parseInt(n, 10),
    parseInt(a, 10),
    parseInt(r, 10)
  ];
  return o && l.push(parseInt(o, 10)), l;
}
function Kj(e) {
  var i = parseInt(e, 10);
  return i <= 49 ? 2e3 + i : i <= 999 ? 1900 + i : i;
}
function $j(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function eV(e, i, n) {
  if (e) {
    var a = ld.indexOf(e), r = new Date(
      i[0],
      i[1],
      i[2]
    ).getDay();
    if (a !== r)
      return Ae(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function nV(e, i, n) {
  if (e)
    return Xj[e];
  if (i)
    return 0;
  var a = parseInt(n, 10), r = a % 100, o = (a - r) / 100;
  return o * 60 + r;
}
function hd(e) {
  var i = Gj.exec($j(e._i)), n;
  if (i) {
    if (n = Jj(
      i[4],
      i[3],
      i[2],
      i[5],
      i[6],
      i[7]
    ), !eV(i[1], n, e))
      return;
    e._a = n, e._tzm = nV(i[8], i[9], i[10]), e._d = U2.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Ae(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function iV(e) {
  var i = qj.exec(e._i);
  if (i !== null) {
    e._d = /* @__PURE__ */ new Date(+i[1]);
    return;
  }
  if (ud(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (hd(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : oe.createFromInputFallback(e);
}
oe.createFromInputFallback = Nn(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Gt(e, i, n) {
  return e ?? i ?? n;
}
function tV(e) {
  var i = new Date(oe.now());
  return e._useUTC ? [
    i.getUTCFullYear(),
    i.getUTCMonth(),
    i.getUTCDate()
  ] : [i.getFullYear(), i.getMonth(), i.getDate()];
}
function ro(e) {
  var i, n, a = [], r, o, l;
  if (!e._d) {
    for (r = tV(e), e._w && e._a[ti] == null && e._a[Li] == null && aV(e), e._dayOfYear != null && (l = Gt(e._a[P1], r[P1]), (e._dayOfYear > H2(l) || e._dayOfYear === 0) && (Ae(e)._overflowDayOfYear = !0), n = U2(l, 0, e._dayOfYear), e._a[Li] = n.getUTCMonth(), e._a[ti] = n.getUTCDate()), i = 0; i < 3 && e._a[i] == null; ++i)
      e._a[i] = a[i] = r[i];
    for (; i < 7; i++)
      e._a[i] = a[i] = e._a[i] == null ? i === 2 ? 1 : 0 : e._a[i];
    e._a[b1] === 24 && e._a[Pn] === 0 && e._a[Ti] === 0 && e._a[xt] === 0 && (e._nextDay = !0, e._a[b1] = 0), e._d = (e._useUTC ? U2 : cj).apply(
      null,
      a
    ), o = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[b1] = 24), e._w && typeof e._w.d < "u" && e._w.d !== o && (Ae(e).weekdayMismatch = !0);
  }
}
function aV(e) {
  var i, n, a, r, o, l, c, h, y;
  i = e._w, i.GG != null || i.W != null || i.E != null ? (o = 1, l = 4, n = Gt(
    i.GG,
    e._a[P1],
    R2(l1(), 1, 4).year
  ), a = Gt(i.W, 1), r = Gt(i.E, 1), (r < 1 || r > 7) && (h = !0)) : (o = e._locale._week.dow, l = e._locale._week.doy, y = R2(l1(), o, l), n = Gt(i.gg, e._a[P1], y.year), a = Gt(i.w, y.week), i.d != null ? (r = i.d, (r < 0 || r > 6) && (h = !0)) : i.e != null ? (r = i.e + o, (i.e < 0 || i.e > 6) && (h = !0)) : r = o), a < 1 || a > Ei(n, o, l) ? Ae(e)._overflowWeeks = !0 : h != null ? Ae(e)._overflowWeekday = !0 : (c = rd(n, a, r, o, l), e._a[P1] = c.year, e._dayOfYear = c.dayOfYear);
}
oe.ISO_8601 = function() {
};
oe.RFC_2822 = function() {
};
function lo(e) {
  if (e._f === oe.ISO_8601) {
    ud(e);
    return;
  }
  if (e._f === oe.RFC_2822) {
    hd(e);
    return;
  }
  e._a = [], Ae(e).empty = !0;
  var i = "" + e._i, n, a, r, o, l, c = i.length, h = 0, y, v;
  for (r = Gl(e._f, e._locale).match(X3) || [], v = r.length, n = 0; n < v; n++)
    o = r[n], a = (i.match(ZH(o, e)) || [])[0], a && (l = i.substr(0, i.indexOf(a)), l.length > 0 && Ae(e).unusedInput.push(l), i = i.slice(
      i.indexOf(a) + a.length
    ), h += a.length), e2[o] ? (a ? Ae(e).empty = !1 : Ae(e).unusedTokens.push(o), QH(o, a, e)) : e._strict && !a && Ae(e).unusedTokens.push(o);
  Ae(e).charsLeftOver = c - h, i.length > 0 && Ae(e).unusedInput.push(i), e._a[b1] <= 12 && Ae(e).bigHour === !0 && e._a[b1] > 0 && (Ae(e).bigHour = void 0), Ae(e).parsedDateParts = e._a.slice(0), Ae(e).meridiem = e._meridiem, e._a[b1] = sV(
    e._locale,
    e._a[b1],
    e._meridiem
  ), y = Ae(e).era, y !== null && (e._a[P1] = e._locale.erasConvertYear(y, e._a[P1])), ro(e), oo(e);
}
function sV(e, i, n) {
  var a;
  return n == null ? i : e.meridiemHour != null ? e.meridiemHour(i, n) : (e.isPM != null && (a = e.isPM(n), a && i < 12 && (i += 12), !a && i === 12 && (i = 0)), i);
}
function oV(e) {
  var i, n, a, r, o, l, c = !1, h = e._f.length;
  if (h === 0) {
    Ae(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (r = 0; r < h; r++)
    o = 0, l = !1, i = q3({}, e), e._useUTC != null && (i._useUTC = e._useUTC), i._f = e._f[r], lo(i), Q3(i) && (l = !0), o += Ae(i).charsLeftOver, o += Ae(i).unusedTokens.length * 10, Ae(i).score = o, c ? o < a && (a = o, n = i) : (a == null || o < a || l) && (a = o, n = i, l && (c = !0));
  Ki(e, n || i);
}
function rV(e) {
  if (!e._d) {
    var i = J3(e._i), n = i.day === void 0 ? i.date : i.day;
    e._a = Wl(
      [i.year, i.month, n, i.hour, i.minute, i.second, i.millisecond],
      function(a) {
        return a && parseInt(a, 10);
      }
    ), ro(e);
  }
}
function lV(e) {
  var i = new J2(oo(md(e)));
  return i._nextDay && (i.add(1, "d"), i._nextDay = void 0), i;
}
function md(e) {
  var i = e._i, n = e._f;
  return e._locale = e._locale || Ii(e._l), i === null || n === void 0 && i === "" ? w0({ nullInput: !0 }) : (typeof i == "string" && (e._i = i = e._locale.preparse(i)), Rn(i) ? new J2(oo(i)) : (X2(i) ? e._d = i : Un(n) ? oV(e) : n ? lo(e) : dV(e), Q3(e) || (e._d = null), e));
}
function dV(e) {
  var i = e._i;
  tn(i) ? e._d = new Date(oe.now()) : X2(i) ? e._d = new Date(i.valueOf()) : typeof i == "string" ? iV(e) : Un(i) ? (e._a = Wl(i.slice(0), function(n) {
    return parseInt(n, 10);
  }), ro(e)) : bt(i) ? rV(e) : zi(i) ? e._d = new Date(i) : oe.createFromInputFallback(e);
}
function pd(e, i, n, a, r) {
  var o = {};
  return (i === !0 || i === !1) && (a = i, i = void 0), (n === !0 || n === !1) && (a = n, n = void 0), (bt(e) && W3(e) || Un(e) && e.length === 0) && (e = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = r, o._l = n, o._i = e, o._f = i, o._strict = a, lV(o);
}
function l1(e, i, n, a) {
  return pd(e, i, n, a, !1);
}
var cV = Nn(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = l1.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : w0();
  }
), fV = Nn(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = l1.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : w0();
  }
);
function yd(e, i) {
  var n, a;
  if (i.length === 1 && Un(i[0]) && (i = i[0]), !i.length)
    return l1();
  for (n = i[0], a = 1; a < i.length; ++a)
    (!i[a].isValid() || i[a][e](n)) && (n = i[a]);
  return n;
}
function uV() {
  var e = [].slice.call(arguments, 0);
  return yd("isBefore", e);
}
function hV() {
  var e = [].slice.call(arguments, 0);
  return yd("isAfter", e);
}
var mV = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, z2 = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function pV(e) {
  var i, n = !1, a, r = z2.length;
  for (i in e)
    if (qe(e, i) && !(g1.call(z2, i) !== -1 && (e[i] == null || !isNaN(e[i]))))
      return !1;
  for (a = 0; a < r; ++a)
    if (e[z2[a]]) {
      if (n)
        return !1;
      parseFloat(e[z2[a]]) !== je(e[z2[a]]) && (n = !0);
    }
  return !0;
}
function yV() {
  return this._isValid;
}
function vV() {
  return Zn(NaN);
}
function L0(e) {
  var i = J3(e), n = i.year || 0, a = i.quarter || 0, r = i.month || 0, o = i.week || i.isoWeek || 0, l = i.day || 0, c = i.hour || 0, h = i.minute || 0, y = i.second || 0, v = i.millisecond || 0;
  this._isValid = pV(i), this._milliseconds = +v + y * 1e3 + // 1000
  h * 6e4 + // 1000 * 60
  c * 1e3 * 60 * 60, this._days = +l + o * 7, this._months = +r + a * 3 + n * 12, this._data = {}, this._locale = Ii(), this._bubble();
}
function Ja(e) {
  return e instanceof L0;
}
function k3(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function gV(e, i, n) {
  var a = Math.min(e.length, i.length), r = Math.abs(e.length - i.length), o = 0, l;
  for (l = 0; l < a; l++)
    (n && e[l] !== i[l] || !n && je(e[l]) !== je(i[l])) && o++;
  return o + r;
}
function vd(e, i) {
  ye(e, 0, 0, function() {
    var n = this.utcOffset(), a = "+";
    return n < 0 && (n = -n, a = "-"), a + li(~~(n / 60), 2) + i + li(~~n % 60, 2);
  });
}
vd("Z", ":");
vd("ZZ", "");
ue("Z", M0);
ue("ZZ", M0);
i1(["Z", "ZZ"], function(e, i, n) {
  n._useUTC = !0, n._tzm = co(M0, e);
});
var _V = /([\+\-]|\d\d)/gi;
function co(e, i) {
  var n = (i || "").match(e), a, r, o;
  return n === null ? null : (a = n[n.length - 1] || [], r = (a + "").match(_V) || ["-", 0, 0], o = +(r[1] * 60) + je(r[2]), o === 0 ? 0 : r[0] === "+" ? o : -o);
}
function fo(e, i) {
  var n, a;
  return i._isUTC ? (n = i.clone(), a = (Rn(e) || X2(e) ? e.valueOf() : l1(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + a), oe.updateOffset(n, !1), n) : l1(e).local();
}
function x3(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
oe.updateOffset = function() {
};
function wV(e, i, n) {
  var a = this._offset || 0, r;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = co(M0, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && i && (r = x3(this)), this._offset = e, this._isUTC = !0, r != null && this.add(r, "m"), a !== e && (!i || this._changeInProgress ? wd(
      this,
      Zn(e - a, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, oe.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? a : x3(this);
}
function CV(e, i) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, i), this) : -this.utcOffset();
}
function kV(e) {
  return this.utcOffset(0, e);
}
function xV(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(x3(this), "m")), this;
}
function bV() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = co(RH, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function MV(e) {
  return this.isValid() ? (e = e ? l1(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function DV() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function AV() {
  if (!tn(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, i;
  return q3(e, this), e = md(e), e._a ? (i = e._isUTC ? di(e._a) : l1(e._a), this._isDSTShifted = this.isValid() && gV(e._a, i.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function LV() {
  return this.isValid() ? !this._isUTC : !1;
}
function TV() {
  return this.isValid() ? this._isUTC : !1;
}
function gd() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var SV = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, NV = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Zn(e, i) {
  var n = e, a = null, r, o, l;
  return Ja(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : zi(e) || !isNaN(+e) ? (n = {}, i ? n[i] = +e : n.milliseconds = +e) : (a = SV.exec(e)) ? (r = a[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: je(a[ti]) * r,
    h: je(a[b1]) * r,
    m: je(a[Pn]) * r,
    s: je(a[Ti]) * r,
    ms: je(k3(a[xt] * 1e3)) * r
    // the millisecond decimal point is included in the match
  }) : (a = NV.exec(e)) ? (r = a[1] === "-" ? -1 : 1, n = {
    y: _t(a[2], r),
    M: _t(a[3], r),
    w: _t(a[4], r),
    d: _t(a[5], r),
    h: _t(a[6], r),
    m: _t(a[7], r),
    s: _t(a[8], r)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (l = EV(
    l1(n.from),
    l1(n.to)
  ), n = {}, n.ms = l.milliseconds, n.M = l.months), o = new L0(n), Ja(e) && qe(e, "_locale") && (o._locale = e._locale), Ja(e) && qe(e, "_isValid") && (o._isValid = e._isValid), o;
}
Zn.fn = L0.prototype;
Zn.invalid = vV;
function _t(e, i) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * i;
}
function h4(e, i) {
  var n = {};
  return n.months = i.month() - e.month() + (i.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(i) && --n.months, n.milliseconds = +i - +e.clone().add(n.months, "M"), n;
}
function EV(e, i) {
  var n;
  return e.isValid() && i.isValid() ? (i = fo(i, e), e.isBefore(i) ? n = h4(e, i) : (n = h4(i, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function _d(e, i) {
  return function(n, a) {
    var r, o;
    return a !== null && !isNaN(+a) && (ql(
      i,
      "moment()." + i + "(period, number) is deprecated. Please use moment()." + i + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), o = n, n = a, a = o), r = Zn(n, a), wd(this, r, e), this;
  };
}
function wd(e, i, n, a) {
  var r = i._milliseconds, o = k3(i._days), l = k3(i._months);
  e.isValid() && (a = a ?? !0, l && ad(e, P2(e, "Month") + l * n), o && nd(e, "Date", P2(e, "Date") + o * n), r && e._d.setTime(e._d.valueOf() + r * n), a && oe.updateOffset(e, o || l));
}
var zV = _d(1, "add"), IV = _d(-1, "subtract");
function Cd(e) {
  return typeof e == "string" || e instanceof String;
}
function BV(e) {
  return Rn(e) || X2(e) || Cd(e) || zi(e) || HV(e) || OV(e) || e === null || e === void 0;
}
function OV(e) {
  var i = bt(e) && !W3(e), n = !1, a = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], r, o, l = a.length;
  for (r = 0; r < l; r += 1)
    o = a[r], n = n || qe(e, o);
  return i && n;
}
function HV(e) {
  var i = Un(e), n = !1;
  return i && (n = e.filter(function(a) {
    return !zi(a) && Cd(e);
  }).length === 0), i && n;
}
function jV(e) {
  var i = bt(e) && !W3(e), n = !1, a = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], r, o;
  for (r = 0; r < a.length; r += 1)
    o = a[r], n = n || qe(e, o);
  return i && n;
}
function VV(e, i) {
  var n = e.diff(i, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function FV(e, i) {
  arguments.length === 1 && (arguments[0] ? BV(arguments[0]) ? (e = arguments[0], i = void 0) : jV(arguments[0]) && (i = arguments[0], e = void 0) : (e = void 0, i = void 0));
  var n = e || l1(), a = fo(n, this).startOf("day"), r = oe.calendarFormat(this, a) || "sameElse", o = i && (ci(i[r]) ? i[r].call(this, n) : i[r]);
  return this.format(
    o || this.localeData().calendar(r, this, l1(n))
  );
}
function PV() {
  return new J2(this);
}
function UV(e, i) {
  var n = Rn(e) ? e : l1(e);
  return this.isValid() && n.isValid() ? (i = En(i) || "millisecond", i === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(i).valueOf()) : !1;
}
function RV(e, i) {
  var n = Rn(e) ? e : l1(e);
  return this.isValid() && n.isValid() ? (i = En(i) || "millisecond", i === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(i).valueOf() < n.valueOf()) : !1;
}
function YV(e, i, n, a) {
  var r = Rn(e) ? e : l1(e), o = Rn(i) ? i : l1(i);
  return this.isValid() && r.isValid() && o.isValid() ? (a = a || "()", (a[0] === "(" ? this.isAfter(r, n) : !this.isBefore(r, n)) && (a[1] === ")" ? this.isBefore(o, n) : !this.isAfter(o, n))) : !1;
}
function ZV(e, i) {
  var n = Rn(e) ? e : l1(e), a;
  return this.isValid() && n.isValid() ? (i = En(i) || "millisecond", i === "millisecond" ? this.valueOf() === n.valueOf() : (a = n.valueOf(), this.clone().startOf(i).valueOf() <= a && a <= this.clone().endOf(i).valueOf())) : !1;
}
function WV(e, i) {
  return this.isSame(e, i) || this.isAfter(e, i);
}
function QV(e, i) {
  return this.isSame(e, i) || this.isBefore(e, i);
}
function qV(e, i, n) {
  var a, r, o;
  if (!this.isValid())
    return NaN;
  if (a = fo(e, this), !a.isValid())
    return NaN;
  switch (r = (a.utcOffset() - this.utcOffset()) * 6e4, i = En(i), i) {
    case "year":
      o = Ka(this, a) / 12;
      break;
    case "month":
      o = Ka(this, a);
      break;
    case "quarter":
      o = Ka(this, a) / 3;
      break;
    case "second":
      o = (this - a) / 1e3;
      break;
    case "minute":
      o = (this - a) / 6e4;
      break;
    case "hour":
      o = (this - a) / 36e5;
      break;
    case "day":
      o = (this - a - r) / 864e5;
      break;
    case "week":
      o = (this - a - r) / 6048e5;
      break;
    default:
      o = this - a;
  }
  return n ? o : Tn(o);
}
function Ka(e, i) {
  if (e.date() < i.date())
    return -Ka(i, e);
  var n = (i.year() - e.year()) * 12 + (i.month() - e.month()), a = e.clone().add(n, "months"), r, o;
  return i - a < 0 ? (r = e.clone().add(n - 1, "months"), o = (i - a) / (a - r)) : (r = e.clone().add(n + 1, "months"), o = (i - a) / (r - a)), -(n + o) || 0;
}
oe.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
oe.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function GV() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function XV(e) {
  if (!this.isValid())
    return null;
  var i = e !== !0, n = i ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? Xa(
    n,
    i ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : ci(Date.prototype.toISOString) ? i ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Xa(n, "Z")) : Xa(
    n,
    i ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function JV() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", i = "", n, a, r, o;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", i = "Z"), n = "[" + e + '("]', a = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", r = "-MM-DD[T]HH:mm:ss.SSS", o = i + '[")]', this.format(n + a + r + o);
}
function KV(e) {
  e || (e = this.isUtc() ? oe.defaultFormatUtc : oe.defaultFormat);
  var i = Xa(this, e);
  return this.localeData().postformat(i);
}
function $V(e, i) {
  return this.isValid() && (Rn(e) && e.isValid() || l1(e).isValid()) ? Zn({ to: this, from: e }).locale(this.locale()).humanize(!i) : this.localeData().invalidDate();
}
function eF(e) {
  return this.from(l1(), e);
}
function nF(e, i) {
  return this.isValid() && (Rn(e) && e.isValid() || l1(e).isValid()) ? Zn({ from: this, to: e }).locale(this.locale()).humanize(!i) : this.localeData().invalidDate();
}
function iF(e) {
  return this.to(l1(), e);
}
function kd(e) {
  var i;
  return e === void 0 ? this._locale._abbr : (i = Ii(e), i != null && (this._locale = i), this);
}
var xd = Nn(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function bd() {
  return this._locale;
}
var s0 = 1e3, n2 = 60 * s0, o0 = 60 * n2, Md = (365 * 400 + 97) * 24 * o0;
function i2(e, i) {
  return (e % i + i) % i;
}
function Dd(e, i, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, i, n) - Md : new Date(e, i, n).valueOf();
}
function Ad(e, i, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, i, n) - Md : Date.UTC(e, i, n);
}
function tF(e) {
  var i, n;
  if (e = En(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Ad : Dd, e) {
    case "year":
      i = n(this.year(), 0, 1);
      break;
    case "quarter":
      i = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      i = n(this.year(), this.month(), 1);
      break;
    case "week":
      i = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      i = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      i = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      i = this._d.valueOf(), i -= i2(
        i + (this._isUTC ? 0 : this.utcOffset() * n2),
        o0
      );
      break;
    case "minute":
      i = this._d.valueOf(), i -= i2(i, n2);
      break;
    case "second":
      i = this._d.valueOf(), i -= i2(i, s0);
      break;
  }
  return this._d.setTime(i), oe.updateOffset(this, !0), this;
}
function aF(e) {
  var i, n;
  if (e = En(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Ad : Dd, e) {
    case "year":
      i = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      i = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      i = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      i = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      i = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      i = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      i = this._d.valueOf(), i += o0 - i2(
        i + (this._isUTC ? 0 : this.utcOffset() * n2),
        o0
      ) - 1;
      break;
    case "minute":
      i = this._d.valueOf(), i += n2 - i2(i, n2) - 1;
      break;
    case "second":
      i = this._d.valueOf(), i += s0 - i2(i, s0) - 1;
      break;
  }
  return this._d.setTime(i), oe.updateOffset(this, !0), this;
}
function sF() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function oF() {
  return Math.floor(this.valueOf() / 1e3);
}
function rF() {
  return new Date(this.valueOf());
}
function lF() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function dF() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function cF() {
  return this.isValid() ? this.toISOString() : null;
}
function fF() {
  return Q3(this);
}
function uF() {
  return Ki({}, Ae(this));
}
function hF() {
  return Ae(this).overflow;
}
function mF() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
ye("N", 0, 0, "eraAbbr");
ye("NN", 0, 0, "eraAbbr");
ye("NNN", 0, 0, "eraAbbr");
ye("NNNN", 0, 0, "eraName");
ye("NNNNN", 0, 0, "eraNarrow");
ye("y", ["y", 1], "yo", "eraYear");
ye("y", ["yy", 2], 0, "eraYear");
ye("y", ["yyy", 3], 0, "eraYear");
ye("y", ["yyyy", 4], 0, "eraYear");
ue("N", uo);
ue("NN", uo);
ue("NNN", uo);
ue("NNNN", MF);
ue("NNNNN", DF);
i1(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, i, n, a) {
    var r = n._locale.erasParse(e, a, n._strict);
    r ? Ae(n).era = r : Ae(n).invalidEra = e;
  }
);
ue("y", c2);
ue("yy", c2);
ue("yyy", c2);
ue("yyyy", c2);
ue("yo", AF);
i1(["y", "yy", "yyy", "yyyy"], P1);
i1(["yo"], function(e, i, n, a) {
  var r;
  n._locale._eraYearOrdinalRegex && (r = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? i[P1] = n._locale.eraYearOrdinalParse(e, r) : i[P1] = parseInt(e, 10);
});
function pF(e, i) {
  var n, a, r, o = this._eras || Ii("en")._eras;
  for (n = 0, a = o.length; n < a; ++n) {
    switch (typeof o[n].since) {
      case "string":
        r = oe(o[n].since).startOf("day"), o[n].since = r.valueOf();
        break;
    }
    switch (typeof o[n].until) {
      case "undefined":
        o[n].until = 1 / 0;
        break;
      case "string":
        r = oe(o[n].until).startOf("day").valueOf(), o[n].until = r.valueOf();
        break;
    }
  }
  return o;
}
function yF(e, i, n) {
  var a, r, o = this.eras(), l, c, h;
  for (e = e.toUpperCase(), a = 0, r = o.length; a < r; ++a)
    if (l = o[a].name.toUpperCase(), c = o[a].abbr.toUpperCase(), h = o[a].narrow.toUpperCase(), n)
      switch (i) {
        case "N":
        case "NN":
        case "NNN":
          if (c === e)
            return o[a];
          break;
        case "NNNN":
          if (l === e)
            return o[a];
          break;
        case "NNNNN":
          if (h === e)
            return o[a];
          break;
      }
    else if ([l, c, h].indexOf(e) >= 0)
      return o[a];
}
function vF(e, i) {
  var n = e.since <= e.until ? 1 : -1;
  return i === void 0 ? oe(e.since).year() : oe(e.since).year() + (i - e.offset) * n;
}
function gF() {
  var e, i, n, a = this.localeData().eras();
  for (e = 0, i = a.length; e < i; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].name;
  return "";
}
function _F() {
  var e, i, n, a = this.localeData().eras();
  for (e = 0, i = a.length; e < i; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].narrow;
  return "";
}
function wF() {
  var e, i, n, a = this.localeData().eras();
  for (e = 0, i = a.length; e < i; ++e)
    if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return a[e].abbr;
  return "";
}
function CF() {
  var e, i, n, a, r = this.localeData().eras();
  for (e = 0, i = r.length; e < i; ++e)
    if (n = r[e].since <= r[e].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), r[e].since <= a && a <= r[e].until || r[e].until <= a && a <= r[e].since)
      return (this.year() - oe(r[e].since).year()) * n + r[e].offset;
  return this.year();
}
function kF(e) {
  return qe(this, "_erasNameRegex") || ho.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function xF(e) {
  return qe(this, "_erasAbbrRegex") || ho.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function bF(e) {
  return qe(this, "_erasNarrowRegex") || ho.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function uo(e, i) {
  return i.erasAbbrRegex(e);
}
function MF(e, i) {
  return i.erasNameRegex(e);
}
function DF(e, i) {
  return i.erasNarrowRegex(e);
}
function AF(e, i) {
  return i._eraYearOrdinalRegex || c2;
}
function ho() {
  var e = [], i = [], n = [], a = [], r, o, l, c, h, y = this.eras();
  for (r = 0, o = y.length; r < o; ++r)
    l = Ni(y[r].name), c = Ni(y[r].abbr), h = Ni(y[r].narrow), i.push(l), e.push(c), n.push(h), a.push(l), a.push(c), a.push(h);
  this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
ye(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
ye(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function T0(e, i) {
  ye(0, [e, e.length], 0, i);
}
T0("gggg", "weekYear");
T0("ggggg", "weekYear");
T0("GGGG", "isoWeekYear");
T0("GGGGG", "isoWeekYear");
ue("G", b0);
ue("g", b0);
ue("GG", d1, pn);
ue("gg", d1, pn);
ue("GGGG", $3, K3);
ue("gggg", $3, K3);
ue("GGGGG", x0, C0);
ue("ggggg", x0, C0);
$2(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, i, n, a) {
    i[a.substr(0, 2)] = je(e);
  }
);
$2(["gg", "GG"], function(e, i, n, a) {
  i[a] = oe.parseTwoDigitYear(e);
});
function LF(e) {
  return Ld.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function TF(e) {
  return Ld.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function SF() {
  return Ei(this.year(), 1, 4);
}
function NF() {
  return Ei(this.isoWeekYear(), 1, 4);
}
function EF() {
  var e = this.localeData()._week;
  return Ei(this.year(), e.dow, e.doy);
}
function zF() {
  var e = this.localeData()._week;
  return Ei(this.weekYear(), e.dow, e.doy);
}
function Ld(e, i, n, a, r) {
  var o;
  return e == null ? R2(this, a, r).year : (o = Ei(e, a, r), i > o && (i = o), IF.call(this, e, i, n, a, r));
}
function IF(e, i, n, a, r) {
  var o = rd(e, i, n, a, r), l = U2(o.year, 0, o.dayOfYear);
  return this.year(l.getUTCFullYear()), this.month(l.getUTCMonth()), this.date(l.getUTCDate()), this;
}
ye("Q", 0, "Qo", "quarter");
ue("Q", Xl);
i1("Q", function(e, i) {
  i[Li] = (je(e) - 1) * 3;
});
function BF(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
ye("D", ["DD", 2], "Do", "date");
ue("D", d1, f2);
ue("DD", d1, pn);
ue("Do", function(e, i) {
  return e ? i._dayOfMonthOrdinalParse || i._ordinalParse : i._dayOfMonthOrdinalParseLenient;
});
i1(["D", "DD"], ti);
i1("Do", function(e, i) {
  i[ti] = je(e.match(d1)[0]);
});
var Td = u2("Date", !0);
ye("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
ue("DDD", k0);
ue("DDDD", Jl);
i1(["DDD", "DDDD"], function(e, i, n) {
  n._dayOfYear = je(e);
});
function OF(e) {
  var i = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? i : this.add(e - i, "d");
}
ye("m", ["mm", 2], 0, "minute");
ue("m", d1, eo);
ue("mm", d1, pn);
i1(["m", "mm"], Pn);
var HF = u2("Minutes", !1);
ye("s", ["ss", 2], 0, "second");
ue("s", d1, eo);
ue("ss", d1, pn);
i1(["s", "ss"], Ti);
var jF = u2("Seconds", !1);
ye("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
ye(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
ye(0, ["SSS", 3], 0, "millisecond");
ye(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
ye(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
ye(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
ye(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
ye(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
ye(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
ue("S", k0, Xl);
ue("SS", k0, pn);
ue("SSS", k0, Jl);
var $i, Sd;
for ($i = "SSSS"; $i.length <= 9; $i += "S")
  ue($i, c2);
function VF(e, i) {
  i[xt] = je(("0." + e) * 1e3);
}
for ($i = "S"; $i.length <= 9; $i += "S")
  i1($i, VF);
Sd = u2("Milliseconds", !1);
ye("z", 0, 0, "zoneAbbr");
ye("zz", 0, 0, "zoneName");
function FF() {
  return this._isUTC ? "UTC" : "";
}
function PF() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var te = J2.prototype;
te.add = zV;
te.calendar = FV;
te.clone = PV;
te.diff = qV;
te.endOf = aF;
te.format = KV;
te.from = $V;
te.fromNow = eF;
te.to = nF;
te.toNow = iF;
te.get = JH;
te.invalidAt = hF;
te.isAfter = UV;
te.isBefore = RV;
te.isBetween = YV;
te.isSame = ZV;
te.isSameOrAfter = WV;
te.isSameOrBefore = QV;
te.isValid = fF;
te.lang = xd;
te.locale = kd;
te.localeData = bd;
te.max = fV;
te.min = cV;
te.parsingFlags = uF;
te.set = KH;
te.startOf = tF;
te.subtract = IV;
te.toArray = lF;
te.toObject = dF;
te.toDate = rF;
te.toISOString = XV;
te.inspect = JV;
typeof Symbol < "u" && Symbol.for != null && (te[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
te.toJSON = cF;
te.toString = GV;
te.unix = oF;
te.valueOf = sF;
te.creationData = mF;
te.eraName = gF;
te.eraNarrow = _F;
te.eraAbbr = wF;
te.eraYear = CF;
te.year = ed;
te.isLeapYear = XH;
te.weekYear = LF;
te.isoWeekYear = TF;
te.quarter = te.quarters = BF;
te.month = sd;
te.daysInMonth = rj;
te.week = te.weeks = pj;
te.isoWeek = te.isoWeeks = yj;
te.weeksInYear = EF;
te.weeksInWeekYear = zF;
te.isoWeeksInYear = SF;
te.isoWeeksInISOWeekYear = NF;
te.date = Td;
te.day = te.days = Tj;
te.weekday = Sj;
te.isoWeekday = Nj;
te.dayOfYear = OF;
te.hour = te.hours = jj;
te.minute = te.minutes = HF;
te.second = te.seconds = jF;
te.millisecond = te.milliseconds = Sd;
te.utcOffset = wV;
te.utc = kV;
te.local = xV;
te.parseZone = bV;
te.hasAlignedHourOffset = MV;
te.isDST = DV;
te.isLocal = LV;
te.isUtcOffset = TV;
te.isUtc = gd;
te.isUTC = gd;
te.zoneAbbr = FF;
te.zoneName = PF;
te.dates = Nn(
  "dates accessor is deprecated. Use date instead.",
  Td
);
te.months = Nn(
  "months accessor is deprecated. Use month instead",
  sd
);
te.years = Nn(
  "years accessor is deprecated. Use year instead",
  ed
);
te.zone = Nn(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  CV
);
te.isDSTShifted = Nn(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  AV
);
function UF(e) {
  return l1(e * 1e3);
}
function RF() {
  return l1.apply(null, arguments).parseZone();
}
function Nd(e) {
  return e;
}
var Ge = G3.prototype;
Ge.calendar = LH;
Ge.longDateFormat = EH;
Ge.invalidDate = IH;
Ge.ordinal = HH;
Ge.preparse = Nd;
Ge.postformat = Nd;
Ge.relativeTime = VH;
Ge.pastFuture = FH;
Ge.set = DH;
Ge.eras = pF;
Ge.erasParse = yF;
Ge.erasConvertYear = vF;
Ge.erasAbbrRegex = xF;
Ge.erasNameRegex = kF;
Ge.erasNarrowRegex = bF;
Ge.months = tj;
Ge.monthsShort = aj;
Ge.monthsParse = oj;
Ge.monthsRegex = dj;
Ge.monthsShortRegex = lj;
Ge.week = fj;
Ge.firstDayOfYear = mj;
Ge.firstDayOfWeek = hj;
Ge.weekdays = bj;
Ge.weekdaysMin = Dj;
Ge.weekdaysShort = Mj;
Ge.weekdaysParse = Lj;
Ge.weekdaysRegex = Ej;
Ge.weekdaysShortRegex = zj;
Ge.weekdaysMinRegex = Ij;
Ge.isPM = Oj;
Ge.meridiem = Vj;
function r0(e, i, n, a) {
  var r = Ii(), o = di().set(a, i);
  return r[n](o, e);
}
function Ed(e, i, n) {
  if (zi(e) && (i = e, e = void 0), e = e || "", i != null)
    return r0(e, i, n, "month");
  var a, r = [];
  for (a = 0; a < 12; a++)
    r[a] = r0(e, a, n, "month");
  return r;
}
function mo(e, i, n, a) {
  typeof e == "boolean" ? (zi(i) && (n = i, i = void 0), i = i || "") : (i = e, n = i, e = !1, zi(i) && (n = i, i = void 0), i = i || "");
  var r = Ii(), o = e ? r._week.dow : 0, l, c = [];
  if (n != null)
    return r0(i, (n + o) % 7, a, "day");
  for (l = 0; l < 7; l++)
    c[l] = r0(i, (l + o) % 7, a, "day");
  return c;
}
function YF(e, i) {
  return Ed(e, i, "months");
}
function ZF(e, i) {
  return Ed(e, i, "monthsShort");
}
function WF(e, i, n) {
  return mo(e, i, n, "weekdays");
}
function QF(e, i, n) {
  return mo(e, i, n, "weekdaysShort");
}
function qF(e, i, n) {
  return mo(e, i, n, "weekdaysMin");
}
nt("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var i = e % 10, n = je(e % 100 / 10) === 1 ? "th" : i === 1 ? "st" : i === 2 ? "nd" : i === 3 ? "rd" : "th";
    return e + n;
  }
});
oe.lang = Nn(
  "moment.lang is deprecated. Use moment.locale instead.",
  nt
);
oe.langData = Nn(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Ii
);
var Ci = Math.abs;
function GF() {
  var e = this._data;
  return this._milliseconds = Ci(this._milliseconds), this._days = Ci(this._days), this._months = Ci(this._months), e.milliseconds = Ci(e.milliseconds), e.seconds = Ci(e.seconds), e.minutes = Ci(e.minutes), e.hours = Ci(e.hours), e.months = Ci(e.months), e.years = Ci(e.years), this;
}
function zd(e, i, n, a) {
  var r = Zn(i, n);
  return e._milliseconds += a * r._milliseconds, e._days += a * r._days, e._months += a * r._months, e._bubble();
}
function XF(e, i) {
  return zd(this, e, i, 1);
}
function JF(e, i) {
  return zd(this, e, i, -1);
}
function m4(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function KF() {
  var e = this._milliseconds, i = this._days, n = this._months, a = this._data, r, o, l, c, h;
  return e >= 0 && i >= 0 && n >= 0 || e <= 0 && i <= 0 && n <= 0 || (e += m4(b3(n) + i) * 864e5, i = 0, n = 0), a.milliseconds = e % 1e3, r = Tn(e / 1e3), a.seconds = r % 60, o = Tn(r / 60), a.minutes = o % 60, l = Tn(o / 60), a.hours = l % 24, i += Tn(l / 24), h = Tn(Id(i)), n += h, i -= m4(b3(h)), c = Tn(n / 12), n %= 12, a.days = i, a.months = n, a.years = c, this;
}
function Id(e) {
  return e * 4800 / 146097;
}
function b3(e) {
  return e * 146097 / 4800;
}
function $F(e) {
  if (!this.isValid())
    return NaN;
  var i, n, a = this._milliseconds;
  if (e = En(e), e === "month" || e === "quarter" || e === "year")
    switch (i = this._days + a / 864e5, n = this._months + Id(i), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (i = this._days + Math.round(b3(this._months)), e) {
      case "week":
        return i / 7 + a / 6048e5;
      case "day":
        return i + a / 864e5;
      case "hour":
        return i * 24 + a / 36e5;
      case "minute":
        return i * 1440 + a / 6e4;
      case "second":
        return i * 86400 + a / 1e3;
      case "millisecond":
        return Math.floor(i * 864e5) + a;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Bi(e) {
  return function() {
    return this.as(e);
  };
}
var Bd = Bi("ms"), eP = Bi("s"), nP = Bi("m"), iP = Bi("h"), tP = Bi("d"), aP = Bi("w"), sP = Bi("M"), oP = Bi("Q"), rP = Bi("y"), lP = Bd;
function dP() {
  return Zn(this);
}
function cP(e) {
  return e = En(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Tt(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var fP = Tt("milliseconds"), uP = Tt("seconds"), hP = Tt("minutes"), mP = Tt("hours"), pP = Tt("days"), yP = Tt("months"), vP = Tt("years");
function gP() {
  return Tn(this.days() / 7);
}
var Mi = Math.round, Kt = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function _P(e, i, n, a, r) {
  return r.relativeTime(i || 1, !!n, e, a);
}
function wP(e, i, n, a) {
  var r = Zn(e).abs(), o = Mi(r.as("s")), l = Mi(r.as("m")), c = Mi(r.as("h")), h = Mi(r.as("d")), y = Mi(r.as("M")), v = Mi(r.as("w")), x = Mi(r.as("y")), C = o <= n.ss && ["s", o] || o < n.s && ["ss", o] || l <= 1 && ["m"] || l < n.m && ["mm", l] || c <= 1 && ["h"] || c < n.h && ["hh", c] || h <= 1 && ["d"] || h < n.d && ["dd", h];
  return n.w != null && (C = C || v <= 1 && ["w"] || v < n.w && ["ww", v]), C = C || y <= 1 && ["M"] || y < n.M && ["MM", y] || x <= 1 && ["y"] || ["yy", x], C[2] = i, C[3] = +e > 0, C[4] = a, _P.apply(null, C);
}
function CP(e) {
  return e === void 0 ? Mi : typeof e == "function" ? (Mi = e, !0) : !1;
}
function kP(e, i) {
  return Kt[e] === void 0 ? !1 : i === void 0 ? Kt[e] : (Kt[e] = i, e === "s" && (Kt.ss = i - 1), !0);
}
function xP(e, i) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, a = Kt, r, o;
  return typeof e == "object" && (i = e, e = !1), typeof e == "boolean" && (n = e), typeof i == "object" && (a = Object.assign({}, Kt, i), i.s != null && i.ss == null && (a.ss = i.s - 1)), r = this.localeData(), o = wP(this, !n, a, r), n && (o = r.pastFuture(+this, o)), r.postformat(o);
}
var a3 = Math.abs;
function Zt(e) {
  return (e > 0) - (e < 0) || +e;
}
function S0() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = a3(this._milliseconds) / 1e3, i = a3(this._days), n = a3(this._months), a, r, o, l, c = this.asSeconds(), h, y, v, x;
  return c ? (a = Tn(e / 60), r = Tn(a / 60), e %= 60, a %= 60, o = Tn(n / 12), n %= 12, l = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", h = c < 0 ? "-" : "", y = Zt(this._months) !== Zt(c) ? "-" : "", v = Zt(this._days) !== Zt(c) ? "-" : "", x = Zt(this._milliseconds) !== Zt(c) ? "-" : "", h + "P" + (o ? y + o + "Y" : "") + (n ? y + n + "M" : "") + (i ? v + i + "D" : "") + (r || a || e ? "T" : "") + (r ? x + r + "H" : "") + (a ? x + a + "M" : "") + (e ? x + l + "S" : "")) : "P0D";
}
var Ye = L0.prototype;
Ye.isValid = yV;
Ye.abs = GF;
Ye.add = XF;
Ye.subtract = JF;
Ye.as = $F;
Ye.asMilliseconds = Bd;
Ye.asSeconds = eP;
Ye.asMinutes = nP;
Ye.asHours = iP;
Ye.asDays = tP;
Ye.asWeeks = aP;
Ye.asMonths = sP;
Ye.asQuarters = oP;
Ye.asYears = rP;
Ye.valueOf = lP;
Ye._bubble = KF;
Ye.clone = dP;
Ye.get = cP;
Ye.milliseconds = fP;
Ye.seconds = uP;
Ye.minutes = hP;
Ye.hours = mP;
Ye.days = pP;
Ye.weeks = gP;
Ye.months = yP;
Ye.years = vP;
Ye.humanize = xP;
Ye.toISOString = S0;
Ye.toString = S0;
Ye.toJSON = S0;
Ye.locale = kd;
Ye.localeData = bd;
Ye.toIsoString = Nn(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  S0
);
Ye.lang = xd;
ye("X", 0, 0, "unix");
ye("x", 0, 0, "valueOf");
ue("x", b0);
ue("X", YH);
i1("X", function(e, i, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
i1("x", function(e, i, n) {
  n._d = new Date(je(e));
});
//! moment.js
oe.version = "2.30.1";
bH(l1);
oe.fn = te;
oe.min = uV;
oe.max = hV;
oe.now = mV;
oe.utc = di;
oe.unix = UF;
oe.months = YF;
oe.isDate = X2;
oe.locale = nt;
oe.invalid = w0;
oe.duration = Zn;
oe.isMoment = Rn;
oe.weekdays = WF;
oe.parseZone = RF;
oe.localeData = Ii;
oe.isDuration = Ja;
oe.monthsShort = ZF;
oe.weekdaysMin = qF;
oe.defineLocale = so;
oe.updateLocale = Rj;
oe.locales = Yj;
oe.weekdaysShort = QF;
oe.normalizeUnits = En;
oe.relativeTimeRounding = CP;
oe.relativeTimeThreshold = kP;
oe.calendarFormat = VV;
oe.prototype = te;
oe.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const p4 = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], y4 = ["S", "M", "T", "W", "T", "F", "S"], v4 = [
  { name: "Last 7 days", id: "last-7-days" },
  { name: "Last 14 days", id: "last-14-days" },
  { name: "Last 30 days", id: "last-30-days" },
  { name: "Last 12 months", id: "last-12-months" },
  { name: "Current month", id: "current-month" },
  { name: "Previous month", id: "previous-month" },
  { name: "Custom", id: "custom" }
], bP = {
  "pt-br": [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ],
  en: p4,
  "en-us": p4,
  es: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ]
}, MP = {
  "pt-br": ["D", "S", "T", "Q", "Q", "S", "S"],
  en: y4,
  "en-us": y4,
  es: ["D", "L", "M", "M", "J", "V", "S"]
}, DP = {
  "pt-br": [
    {
      name: "Últimos 7 dias",
      id: "last-7-days"
    },
    {
      name: "Últimos 14 dias",
      id: "last-14-days"
    },
    {
      name: "Últimos 30 dias",
      id: "last-30-days"
    },
    {
      name: "Últimos 12 meses",
      id: "last-12-months"
    },
    {
      name: "Mês Atual",
      id: "current-month"
    },
    {
      name: "Mês Anterior",
      id: "previous-month"
    },
    {
      name: "Personalizar",
      id: "custom"
    }
  ],
  en: v4,
  "en-us": v4,
  es: [
    {
      name: "Últimos 7 días",
      id: "last-7-days"
    },
    {
      name: "Últimos 14 días",
      id: "last-14-days"
    },
    {
      name: "Últimos 30 días",
      id: "last-30-days"
    },
    {
      name: "Últimos 12 meses",
      id: "last-12-months"
    },
    {
      name: "Mes actual",
      id: "current-month"
    },
    {
      name: "Mes anterior",
      id: "previous-month"
    },
    {
      name: "Personalizar",
      id: "custom"
    }
  ]
};
var l0 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
l0.exports;
(function(e, i) {
  (function() {
    var n, a = "4.17.21", r = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", c = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", y = 500, v = "__lodash_placeholder__", x = 1, C = 2, M = 4, z = 1, R = 2, U = 1, G = 2, re = 4, I = 8, V = 16, K = 32, H = 64, Y = 128, ae = 256, ee = 512, Pe = 30, N1 = "...", ze = 800, _1 = 16, Qn = 1, ot = 2, vn = 3, sn = 1 / 0, G1 = 9007199254740991, rt = 17976931348623157e292, qn = 0 / 0, H1 = 4294967295, X1 = H1 - 1, Oi = H1 >>> 1, Hi = [
      ["ary", Y],
      ["bind", U],
      ["bindKey", G],
      ["curry", I],
      ["curryRight", V],
      ["flip", ee],
      ["partial", K],
      ["partialRight", H],
      ["rearg", ae]
    ], gn = "[object Arguments]", Gn = "[object Array]", lt = "[object AsyncFunction]", Xn = "[object Boolean]", zn = "[object Date]", ji = "[object DOMException]", Jn = "[object Error]", Kn = "[object Function]", Vi = "[object GeneratorFunction]", ie = "[object Map]", Ie = "[object Number]", dt = "[object Null]", E1 = "[object Object]", Fi = "[object Promise]", p2 = "[object Proxy]", D = "[object RegExp]", L = "[object Set]", X = "[object String]", ve = "[object Symbol]", Te = "[object Undefined]", Ue = "[object WeakMap]", Xe = "[object WeakSet]", F = "[object ArrayBuffer]", ne = "[object DataView]", Ve = "[object Float32Array]", o1 = "[object Float64Array]", _n = "[object Int8Array]", Pi = "[object Int16Array]", $n = "[object Int32Array]", In = "[object Uint8Array]", y2 = "[object Uint8ClampedArray]", St = "[object Uint16Array]", U0 = "[object Uint32Array]", uf = /\b__p \+= '';/g, hf = /\b(__p \+=) '' \+/g, mf = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zo = /&(?:amp|lt|gt|quot|#39);/g, Io = /[&<>"']/g, pf = RegExp(zo.source), yf = RegExp(Io.source), vf = /<%-([\s\S]+?)%>/g, gf = /<%([\s\S]+?)%>/g, Bo = /<%=([\s\S]+?)%>/g, _f = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, wf = /^\w*$/, Cf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, R0 = /[\\^$.*+?()[\]{}|]/g, kf = RegExp(R0.source), Y0 = /^\s+/, xf = /\s/, bf = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Mf = /\{\n\/\* \[wrapped with (.+)\] \*/, Df = /,? & /, Af = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Lf = /[()=,{}\[\]\/\s]/, Tf = /\\(\\)?/g, Sf = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Oo = /\w*$/, Nf = /^[-+]0x[0-9a-f]+$/i, Ef = /^0b[01]+$/i, zf = /^\[object .+?Constructor\]$/, If = /^0o[0-7]+$/i, Bf = /^(?:0|[1-9]\d*)$/, Of = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, na = /($^)/, Hf = /['\n\r\u2028\u2029\\]/g, ia = "\\ud800-\\udfff", jf = "\\u0300-\\u036f", Vf = "\\ufe20-\\ufe2f", Ff = "\\u20d0-\\u20ff", Ho = jf + Vf + Ff, jo = "\\u2700-\\u27bf", Vo = "a-z\\xdf-\\xf6\\xf8-\\xff", Pf = "\\xac\\xb1\\xd7\\xf7", Uf = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Rf = "\\u2000-\\u206f", Yf = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Fo = "A-Z\\xc0-\\xd6\\xd8-\\xde", Po = "\\ufe0e\\ufe0f", Uo = Pf + Uf + Rf + Yf, Z0 = "['’]", Zf = "[" + ia + "]", Ro = "[" + Uo + "]", ta = "[" + Ho + "]", Yo = "\\d+", Wf = "[" + jo + "]", Zo = "[" + Vo + "]", Wo = "[^" + ia + Uo + Yo + jo + Vo + Fo + "]", W0 = "\\ud83c[\\udffb-\\udfff]", Qf = "(?:" + ta + "|" + W0 + ")", Qo = "[^" + ia + "]", Q0 = "(?:\\ud83c[\\udde6-\\uddff]){2}", q0 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Nt = "[" + Fo + "]", qo = "\\u200d", Go = "(?:" + Zo + "|" + Wo + ")", qf = "(?:" + Nt + "|" + Wo + ")", Xo = "(?:" + Z0 + "(?:d|ll|m|re|s|t|ve))?", Jo = "(?:" + Z0 + "(?:D|LL|M|RE|S|T|VE))?", Ko = Qf + "?", $o = "[" + Po + "]?", Gf = "(?:" + qo + "(?:" + [Qo, Q0, q0].join("|") + ")" + $o + Ko + ")*", Xf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Jf = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", er = $o + Ko + Gf, Kf = "(?:" + [Wf, Q0, q0].join("|") + ")" + er, $f = "(?:" + [Qo + ta + "?", ta, Q0, q0, Zf].join("|") + ")", e7 = RegExp(Z0, "g"), n7 = RegExp(ta, "g"), G0 = RegExp(W0 + "(?=" + W0 + ")|" + $f + er, "g"), i7 = RegExp([
      Nt + "?" + Zo + "+" + Xo + "(?=" + [Ro, Nt, "$"].join("|") + ")",
      qf + "+" + Jo + "(?=" + [Ro, Nt + Go, "$"].join("|") + ")",
      Nt + "?" + Go + "+" + Xo,
      Nt + "+" + Jo,
      Jf,
      Xf,
      Yo,
      Kf
    ].join("|"), "g"), t7 = RegExp("[" + qo + ia + Ho + Po + "]"), a7 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, s7 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], o7 = -1, r1 = {};
    r1[Ve] = r1[o1] = r1[_n] = r1[Pi] = r1[$n] = r1[In] = r1[y2] = r1[St] = r1[U0] = !0, r1[gn] = r1[Gn] = r1[F] = r1[Xn] = r1[ne] = r1[zn] = r1[Jn] = r1[Kn] = r1[ie] = r1[Ie] = r1[E1] = r1[D] = r1[L] = r1[X] = r1[Ue] = !1;
    var a1 = {};
    a1[gn] = a1[Gn] = a1[F] = a1[ne] = a1[Xn] = a1[zn] = a1[Ve] = a1[o1] = a1[_n] = a1[Pi] = a1[$n] = a1[ie] = a1[Ie] = a1[E1] = a1[D] = a1[L] = a1[X] = a1[ve] = a1[In] = a1[y2] = a1[St] = a1[U0] = !0, a1[Jn] = a1[Kn] = a1[Ue] = !1;
    var r7 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, l7 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, d7 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, c7 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, f7 = parseFloat, u7 = parseInt, nr = typeof qt == "object" && qt && qt.Object === Object && qt, h7 = typeof self == "object" && self && self.Object === Object && self, z1 = nr || h7 || Function("return this")(), X0 = i && !i.nodeType && i, ct = X0 && !0 && e && !e.nodeType && e, ir = ct && ct.exports === X0, J0 = ir && nr.process, wn = function() {
      try {
        var S = ct && ct.require && ct.require("util").types;
        return S || J0 && J0.binding && J0.binding("util");
      } catch {
      }
    }(), tr = wn && wn.isArrayBuffer, ar = wn && wn.isDate, sr = wn && wn.isMap, or = wn && wn.isRegExp, rr = wn && wn.isSet, lr = wn && wn.isTypedArray;
    function on(S, P, O) {
      switch (O.length) {
        case 0:
          return S.call(P);
        case 1:
          return S.call(P, O[0]);
        case 2:
          return S.call(P, O[0], O[1]);
        case 3:
          return S.call(P, O[0], O[1], O[2]);
      }
      return S.apply(P, O);
    }
    function m7(S, P, O, fe) {
      for (var be = -1, Je = S == null ? 0 : S.length; ++be < Je; ) {
        var w1 = S[be];
        P(fe, w1, O(w1), S);
      }
      return fe;
    }
    function Cn(S, P) {
      for (var O = -1, fe = S == null ? 0 : S.length; ++O < fe && P(S[O], O, S) !== !1; )
        ;
      return S;
    }
    function p7(S, P) {
      for (var O = S == null ? 0 : S.length; O-- && P(S[O], O, S) !== !1; )
        ;
      return S;
    }
    function dr(S, P) {
      for (var O = -1, fe = S == null ? 0 : S.length; ++O < fe; )
        if (!P(S[O], O, S))
          return !1;
      return !0;
    }
    function Ui(S, P) {
      for (var O = -1, fe = S == null ? 0 : S.length, be = 0, Je = []; ++O < fe; ) {
        var w1 = S[O];
        P(w1, O, S) && (Je[be++] = w1);
      }
      return Je;
    }
    function aa(S, P) {
      var O = S == null ? 0 : S.length;
      return !!O && Et(S, P, 0) > -1;
    }
    function K0(S, P, O) {
      for (var fe = -1, be = S == null ? 0 : S.length; ++fe < be; )
        if (O(P, S[fe]))
          return !0;
      return !1;
    }
    function c1(S, P) {
      for (var O = -1, fe = S == null ? 0 : S.length, be = Array(fe); ++O < fe; )
        be[O] = P(S[O], O, S);
      return be;
    }
    function Ri(S, P) {
      for (var O = -1, fe = P.length, be = S.length; ++O < fe; )
        S[be + O] = P[O];
      return S;
    }
    function $0(S, P, O, fe) {
      var be = -1, Je = S == null ? 0 : S.length;
      for (fe && Je && (O = S[++be]); ++be < Je; )
        O = P(O, S[be], be, S);
      return O;
    }
    function y7(S, P, O, fe) {
      var be = S == null ? 0 : S.length;
      for (fe && be && (O = S[--be]); be--; )
        O = P(O, S[be], be, S);
      return O;
    }
    function es(S, P) {
      for (var O = -1, fe = S == null ? 0 : S.length; ++O < fe; )
        if (P(S[O], O, S))
          return !0;
      return !1;
    }
    var v7 = ns("length");
    function g7(S) {
      return S.split("");
    }
    function _7(S) {
      return S.match(Af) || [];
    }
    function cr(S, P, O) {
      var fe;
      return O(S, function(be, Je, w1) {
        if (P(be, Je, w1))
          return fe = Je, !1;
      }), fe;
    }
    function sa(S, P, O, fe) {
      for (var be = S.length, Je = O + (fe ? 1 : -1); fe ? Je-- : ++Je < be; )
        if (P(S[Je], Je, S))
          return Je;
      return -1;
    }
    function Et(S, P, O) {
      return P === P ? N7(S, P, O) : sa(S, fr, O);
    }
    function w7(S, P, O, fe) {
      for (var be = O - 1, Je = S.length; ++be < Je; )
        if (fe(S[be], P))
          return be;
      return -1;
    }
    function fr(S) {
      return S !== S;
    }
    function ur(S, P) {
      var O = S == null ? 0 : S.length;
      return O ? ts(S, P) / O : qn;
    }
    function ns(S) {
      return function(P) {
        return P == null ? n : P[S];
      };
    }
    function is(S) {
      return function(P) {
        return S == null ? n : S[P];
      };
    }
    function hr(S, P, O, fe, be) {
      return be(S, function(Je, w1, t1) {
        O = fe ? (fe = !1, Je) : P(O, Je, w1, t1);
      }), O;
    }
    function C7(S, P) {
      var O = S.length;
      for (S.sort(P); O--; )
        S[O] = S[O].value;
      return S;
    }
    function ts(S, P) {
      for (var O, fe = -1, be = S.length; ++fe < be; ) {
        var Je = P(S[fe]);
        Je !== n && (O = O === n ? Je : O + Je);
      }
      return O;
    }
    function as(S, P) {
      for (var O = -1, fe = Array(S); ++O < S; )
        fe[O] = P(O);
      return fe;
    }
    function k7(S, P) {
      return c1(P, function(O) {
        return [O, S[O]];
      });
    }
    function mr(S) {
      return S && S.slice(0, gr(S) + 1).replace(Y0, "");
    }
    function rn(S) {
      return function(P) {
        return S(P);
      };
    }
    function ss(S, P) {
      return c1(P, function(O) {
        return S[O];
      });
    }
    function v2(S, P) {
      return S.has(P);
    }
    function pr(S, P) {
      for (var O = -1, fe = S.length; ++O < fe && Et(P, S[O], 0) > -1; )
        ;
      return O;
    }
    function yr(S, P) {
      for (var O = S.length; O-- && Et(P, S[O], 0) > -1; )
        ;
      return O;
    }
    function x7(S, P) {
      for (var O = S.length, fe = 0; O--; )
        S[O] === P && ++fe;
      return fe;
    }
    var b7 = is(r7), M7 = is(l7);
    function D7(S) {
      return "\\" + c7[S];
    }
    function A7(S, P) {
      return S == null ? n : S[P];
    }
    function zt(S) {
      return t7.test(S);
    }
    function L7(S) {
      return a7.test(S);
    }
    function T7(S) {
      for (var P, O = []; !(P = S.next()).done; )
        O.push(P.value);
      return O;
    }
    function os(S) {
      var P = -1, O = Array(S.size);
      return S.forEach(function(fe, be) {
        O[++P] = [be, fe];
      }), O;
    }
    function vr(S, P) {
      return function(O) {
        return S(P(O));
      };
    }
    function Yi(S, P) {
      for (var O = -1, fe = S.length, be = 0, Je = []; ++O < fe; ) {
        var w1 = S[O];
        (w1 === P || w1 === v) && (S[O] = v, Je[be++] = O);
      }
      return Je;
    }
    function oa(S) {
      var P = -1, O = Array(S.size);
      return S.forEach(function(fe) {
        O[++P] = fe;
      }), O;
    }
    function S7(S) {
      var P = -1, O = Array(S.size);
      return S.forEach(function(fe) {
        O[++P] = [fe, fe];
      }), O;
    }
    function N7(S, P, O) {
      for (var fe = O - 1, be = S.length; ++fe < be; )
        if (S[fe] === P)
          return fe;
      return -1;
    }
    function E7(S, P, O) {
      for (var fe = O + 1; fe--; )
        if (S[fe] === P)
          return fe;
      return fe;
    }
    function It(S) {
      return zt(S) ? I7(S) : v7(S);
    }
    function Bn(S) {
      return zt(S) ? B7(S) : g7(S);
    }
    function gr(S) {
      for (var P = S.length; P-- && xf.test(S.charAt(P)); )
        ;
      return P;
    }
    var z7 = is(d7);
    function I7(S) {
      for (var P = G0.lastIndex = 0; G0.test(S); )
        ++P;
      return P;
    }
    function B7(S) {
      return S.match(G0) || [];
    }
    function O7(S) {
      return S.match(i7) || [];
    }
    var H7 = function S(P) {
      P = P == null ? z1 : Bt.defaults(z1.Object(), P, Bt.pick(z1, s7));
      var O = P.Array, fe = P.Date, be = P.Error, Je = P.Function, w1 = P.Math, t1 = P.Object, rs = P.RegExp, j7 = P.String, kn = P.TypeError, ra = O.prototype, V7 = Je.prototype, Ot = t1.prototype, la = P["__core-js_shared__"], da = V7.toString, e1 = Ot.hasOwnProperty, F7 = 0, _r = function() {
        var t = /[^.]+$/.exec(la && la.keys && la.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), ca = Ot.toString, P7 = da.call(t1), U7 = z1._, R7 = rs(
        "^" + da.call(e1).replace(R0, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), fa = ir ? P.Buffer : n, Zi = P.Symbol, ua = P.Uint8Array, wr = fa ? fa.allocUnsafe : n, ha = vr(t1.getPrototypeOf, t1), Cr = t1.create, kr = Ot.propertyIsEnumerable, ma = ra.splice, xr = Zi ? Zi.isConcatSpreadable : n, g2 = Zi ? Zi.iterator : n, ft = Zi ? Zi.toStringTag : n, pa = function() {
        try {
          var t = yt(t1, "defineProperty");
          return t({}, "", {}), t;
        } catch {
        }
      }(), Y7 = P.clearTimeout !== z1.clearTimeout && P.clearTimeout, Z7 = fe && fe.now !== z1.Date.now && fe.now, W7 = P.setTimeout !== z1.setTimeout && P.setTimeout, ya = w1.ceil, va = w1.floor, ls = t1.getOwnPropertySymbols, Q7 = fa ? fa.isBuffer : n, br = P.isFinite, q7 = ra.join, G7 = vr(t1.keys, t1), C1 = w1.max, j1 = w1.min, X7 = fe.now, J7 = P.parseInt, Mr = w1.random, K7 = ra.reverse, ds = yt(P, "DataView"), _2 = yt(P, "Map"), cs = yt(P, "Promise"), Ht = yt(P, "Set"), w2 = yt(P, "WeakMap"), C2 = yt(t1, "create"), ga = w2 && new w2(), jt = {}, $7 = vt(ds), e9 = vt(_2), n9 = vt(cs), i9 = vt(Ht), t9 = vt(w2), _a = Zi ? Zi.prototype : n, k2 = _a ? _a.valueOf : n, Dr = _a ? _a.toString : n;
      function _(t) {
        if (m1(t) && !Me(t) && !(t instanceof He)) {
          if (t instanceof xn)
            return t;
          if (e1.call(t, "__wrapped__"))
            return A5(t);
        }
        return new xn(t);
      }
      var Vt = function() {
        function t() {
        }
        return function(s) {
          if (!h1(s))
            return {};
          if (Cr)
            return Cr(s);
          t.prototype = s;
          var d = new t();
          return t.prototype = n, d;
        };
      }();
      function wa() {
      }
      function xn(t, s) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = n;
      }
      _.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: vf,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: gf,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Bo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _
        }
      }, _.prototype = wa.prototype, _.prototype.constructor = _, xn.prototype = Vt(wa.prototype), xn.prototype.constructor = xn;
      function He(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = H1, this.__views__ = [];
      }
      function a9() {
        var t = new He(this.__wrapped__);
        return t.__actions__ = J1(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = J1(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = J1(this.__views__), t;
      }
      function s9() {
        if (this.__filtered__) {
          var t = new He(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function o9() {
        var t = this.__wrapped__.value(), s = this.__dir__, d = Me(t), m = s < 0, g = d ? t.length : 0, w = g8(0, g, this.__views__), b = w.start, A = w.end, E = A - b, W = m ? A : b - 1, Q = this.__iteratees__, J = Q.length, de = 0, he = j1(E, this.__takeCount__);
        if (!d || !m && g == E && he == E)
          return Xr(t, this.__actions__);
        var we = [];
        e:
          for (; E-- && de < he; ) {
            W += s;
            for (var Le = -1, Ce = t[W]; ++Le < J; ) {
              var Be = Q[Le], Fe = Be.iteratee, cn = Be.type, Y1 = Fe(Ce);
              if (cn == ot)
                Ce = Y1;
              else if (!Y1) {
                if (cn == Qn)
                  continue e;
                break e;
              }
            }
            we[de++] = Ce;
          }
        return we;
      }
      He.prototype = Vt(wa.prototype), He.prototype.constructor = He;
      function ut(t) {
        var s = -1, d = t == null ? 0 : t.length;
        for (this.clear(); ++s < d; ) {
          var m = t[s];
          this.set(m[0], m[1]);
        }
      }
      function r9() {
        this.__data__ = C2 ? C2(null) : {}, this.size = 0;
      }
      function l9(t) {
        var s = this.has(t) && delete this.__data__[t];
        return this.size -= s ? 1 : 0, s;
      }
      function d9(t) {
        var s = this.__data__;
        if (C2) {
          var d = s[t];
          return d === h ? n : d;
        }
        return e1.call(s, t) ? s[t] : n;
      }
      function c9(t) {
        var s = this.__data__;
        return C2 ? s[t] !== n : e1.call(s, t);
      }
      function f9(t, s) {
        var d = this.__data__;
        return this.size += this.has(t) ? 0 : 1, d[t] = C2 && s === n ? h : s, this;
      }
      ut.prototype.clear = r9, ut.prototype.delete = l9, ut.prototype.get = d9, ut.prototype.has = c9, ut.prototype.set = f9;
      function ui(t) {
        var s = -1, d = t == null ? 0 : t.length;
        for (this.clear(); ++s < d; ) {
          var m = t[s];
          this.set(m[0], m[1]);
        }
      }
      function u9() {
        this.__data__ = [], this.size = 0;
      }
      function h9(t) {
        var s = this.__data__, d = Ca(s, t);
        if (d < 0)
          return !1;
        var m = s.length - 1;
        return d == m ? s.pop() : ma.call(s, d, 1), --this.size, !0;
      }
      function m9(t) {
        var s = this.__data__, d = Ca(s, t);
        return d < 0 ? n : s[d][1];
      }
      function p9(t) {
        return Ca(this.__data__, t) > -1;
      }
      function y9(t, s) {
        var d = this.__data__, m = Ca(d, t);
        return m < 0 ? (++this.size, d.push([t, s])) : d[m][1] = s, this;
      }
      ui.prototype.clear = u9, ui.prototype.delete = h9, ui.prototype.get = m9, ui.prototype.has = p9, ui.prototype.set = y9;
      function hi(t) {
        var s = -1, d = t == null ? 0 : t.length;
        for (this.clear(); ++s < d; ) {
          var m = t[s];
          this.set(m[0], m[1]);
        }
      }
      function v9() {
        this.size = 0, this.__data__ = {
          hash: new ut(),
          map: new (_2 || ui)(),
          string: new ut()
        };
      }
      function g9(t) {
        var s = za(this, t).delete(t);
        return this.size -= s ? 1 : 0, s;
      }
      function _9(t) {
        return za(this, t).get(t);
      }
      function w9(t) {
        return za(this, t).has(t);
      }
      function C9(t, s) {
        var d = za(this, t), m = d.size;
        return d.set(t, s), this.size += d.size == m ? 0 : 1, this;
      }
      hi.prototype.clear = v9, hi.prototype.delete = g9, hi.prototype.get = _9, hi.prototype.has = w9, hi.prototype.set = C9;
      function ht(t) {
        var s = -1, d = t == null ? 0 : t.length;
        for (this.__data__ = new hi(); ++s < d; )
          this.add(t[s]);
      }
      function k9(t) {
        return this.__data__.set(t, h), this;
      }
      function x9(t) {
        return this.__data__.has(t);
      }
      ht.prototype.add = ht.prototype.push = k9, ht.prototype.has = x9;
      function On(t) {
        var s = this.__data__ = new ui(t);
        this.size = s.size;
      }
      function b9() {
        this.__data__ = new ui(), this.size = 0;
      }
      function M9(t) {
        var s = this.__data__, d = s.delete(t);
        return this.size = s.size, d;
      }
      function D9(t) {
        return this.__data__.get(t);
      }
      function A9(t) {
        return this.__data__.has(t);
      }
      function L9(t, s) {
        var d = this.__data__;
        if (d instanceof ui) {
          var m = d.__data__;
          if (!_2 || m.length < r - 1)
            return m.push([t, s]), this.size = ++d.size, this;
          d = this.__data__ = new hi(m);
        }
        return d.set(t, s), this.size = d.size, this;
      }
      On.prototype.clear = b9, On.prototype.delete = M9, On.prototype.get = D9, On.prototype.has = A9, On.prototype.set = L9;
      function Ar(t, s) {
        var d = Me(t), m = !d && gt(t), g = !d && !m && Xi(t), w = !d && !m && !g && Rt(t), b = d || m || g || w, A = b ? as(t.length, j7) : [], E = A.length;
        for (var W in t)
          (s || e1.call(t, W)) && !(b && // Safari 9 has enumerable `arguments.length` in strict mode.
          (W == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (W == "offset" || W == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          w && (W == "buffer" || W == "byteLength" || W == "byteOffset") || // Skip index properties.
          vi(W, E))) && A.push(W);
        return A;
      }
      function Lr(t) {
        var s = t.length;
        return s ? t[Cs(0, s - 1)] : n;
      }
      function T9(t, s) {
        return Ia(J1(t), mt(s, 0, t.length));
      }
      function S9(t) {
        return Ia(J1(t));
      }
      function fs(t, s, d) {
        (d !== n && !Hn(t[s], d) || d === n && !(s in t)) && mi(t, s, d);
      }
      function x2(t, s, d) {
        var m = t[s];
        (!(e1.call(t, s) && Hn(m, d)) || d === n && !(s in t)) && mi(t, s, d);
      }
      function Ca(t, s) {
        for (var d = t.length; d--; )
          if (Hn(t[d][0], s))
            return d;
        return -1;
      }
      function N9(t, s, d, m) {
        return Wi(t, function(g, w, b) {
          s(m, g, d(g), b);
        }), m;
      }
      function Tr(t, s) {
        return t && ni(s, D1(s), t);
      }
      function E9(t, s) {
        return t && ni(s, $1(s), t);
      }
      function mi(t, s, d) {
        s == "__proto__" && pa ? pa(t, s, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        }) : t[s] = d;
      }
      function us(t, s) {
        for (var d = -1, m = s.length, g = O(m), w = t == null; ++d < m; )
          g[d] = w ? n : Ws(t, s[d]);
        return g;
      }
      function mt(t, s, d) {
        return t === t && (d !== n && (t = t <= d ? t : d), s !== n && (t = t >= s ? t : s)), t;
      }
      function bn(t, s, d, m, g, w) {
        var b, A = s & x, E = s & C, W = s & M;
        if (d && (b = g ? d(t, m, g, w) : d(t)), b !== n)
          return b;
        if (!h1(t))
          return t;
        var Q = Me(t);
        if (Q) {
          if (b = w8(t), !A)
            return J1(t, b);
        } else {
          var J = V1(t), de = J == Kn || J == Vi;
          if (Xi(t))
            return $r(t, A);
          if (J == E1 || J == gn || de && !g) {
            if (b = E || de ? {} : g5(t), !A)
              return E ? d8(t, E9(b, t)) : l8(t, Tr(b, t));
          } else {
            if (!a1[J])
              return g ? t : {};
            b = C8(t, J, A);
          }
        }
        w || (w = new On());
        var he = w.get(t);
        if (he)
          return he;
        w.set(t, b), Q5(t) ? t.forEach(function(Ce) {
          b.add(bn(Ce, s, d, Ce, t, w));
        }) : Z5(t) && t.forEach(function(Ce, Be) {
          b.set(Be, bn(Ce, s, d, Be, t, w));
        });
        var we = W ? E ? Es : Ns : E ? $1 : D1, Le = Q ? n : we(t);
        return Cn(Le || t, function(Ce, Be) {
          Le && (Be = Ce, Ce = t[Be]), x2(b, Be, bn(Ce, s, d, Be, t, w));
        }), b;
      }
      function z9(t) {
        var s = D1(t);
        return function(d) {
          return Sr(d, t, s);
        };
      }
      function Sr(t, s, d) {
        var m = d.length;
        if (t == null)
          return !m;
        for (t = t1(t); m--; ) {
          var g = d[m], w = s[g], b = t[g];
          if (b === n && !(g in t) || !w(b))
            return !1;
        }
        return !0;
      }
      function Nr(t, s, d) {
        if (typeof t != "function")
          throw new kn(l);
        return S2(function() {
          t.apply(n, d);
        }, s);
      }
      function b2(t, s, d, m) {
        var g = -1, w = aa, b = !0, A = t.length, E = [], W = s.length;
        if (!A)
          return E;
        d && (s = c1(s, rn(d))), m ? (w = K0, b = !1) : s.length >= r && (w = v2, b = !1, s = new ht(s));
        e:
          for (; ++g < A; ) {
            var Q = t[g], J = d == null ? Q : d(Q);
            if (Q = m || Q !== 0 ? Q : 0, b && J === J) {
              for (var de = W; de--; )
                if (s[de] === J)
                  continue e;
              E.push(Q);
            } else
              w(s, J, m) || E.push(Q);
          }
        return E;
      }
      var Wi = a5(ei), Er = a5(ms, !0);
      function I9(t, s) {
        var d = !0;
        return Wi(t, function(m, g, w) {
          return d = !!s(m, g, w), d;
        }), d;
      }
      function ka(t, s, d) {
        for (var m = -1, g = t.length; ++m < g; ) {
          var w = t[m], b = s(w);
          if (b != null && (A === n ? b === b && !dn(b) : d(b, A)))
            var A = b, E = w;
        }
        return E;
      }
      function B9(t, s, d, m) {
        var g = t.length;
        for (d = De(d), d < 0 && (d = -d > g ? 0 : g + d), m = m === n || m > g ? g : De(m), m < 0 && (m += g), m = d > m ? 0 : G5(m); d < m; )
          t[d++] = s;
        return t;
      }
      function zr(t, s) {
        var d = [];
        return Wi(t, function(m, g, w) {
          s(m, g, w) && d.push(m);
        }), d;
      }
      function I1(t, s, d, m, g) {
        var w = -1, b = t.length;
        for (d || (d = x8), g || (g = []); ++w < b; ) {
          var A = t[w];
          s > 0 && d(A) ? s > 1 ? I1(A, s - 1, d, m, g) : Ri(g, A) : m || (g[g.length] = A);
        }
        return g;
      }
      var hs = s5(), Ir = s5(!0);
      function ei(t, s) {
        return t && hs(t, s, D1);
      }
      function ms(t, s) {
        return t && Ir(t, s, D1);
      }
      function xa(t, s) {
        return Ui(s, function(d) {
          return gi(t[d]);
        });
      }
      function pt(t, s) {
        s = qi(s, t);
        for (var d = 0, m = s.length; t != null && d < m; )
          t = t[ii(s[d++])];
        return d && d == m ? t : n;
      }
      function Br(t, s, d) {
        var m = s(t);
        return Me(t) ? m : Ri(m, d(t));
      }
      function U1(t) {
        return t == null ? t === n ? Te : dt : ft && ft in t1(t) ? v8(t) : S8(t);
      }
      function ps(t, s) {
        return t > s;
      }
      function O9(t, s) {
        return t != null && e1.call(t, s);
      }
      function H9(t, s) {
        return t != null && s in t1(t);
      }
      function j9(t, s, d) {
        return t >= j1(s, d) && t < C1(s, d);
      }
      function ys(t, s, d) {
        for (var m = d ? K0 : aa, g = t[0].length, w = t.length, b = w, A = O(w), E = 1 / 0, W = []; b--; ) {
          var Q = t[b];
          b && s && (Q = c1(Q, rn(s))), E = j1(Q.length, E), A[b] = !d && (s || g >= 120 && Q.length >= 120) ? new ht(b && Q) : n;
        }
        Q = t[0];
        var J = -1, de = A[0];
        e:
          for (; ++J < g && W.length < E; ) {
            var he = Q[J], we = s ? s(he) : he;
            if (he = d || he !== 0 ? he : 0, !(de ? v2(de, we) : m(W, we, d))) {
              for (b = w; --b; ) {
                var Le = A[b];
                if (!(Le ? v2(Le, we) : m(t[b], we, d)))
                  continue e;
              }
              de && de.push(we), W.push(he);
            }
          }
        return W;
      }
      function V9(t, s, d, m) {
        return ei(t, function(g, w, b) {
          s(m, d(g), w, b);
        }), m;
      }
      function M2(t, s, d) {
        s = qi(s, t), t = k5(t, s);
        var m = t == null ? t : t[ii(Dn(s))];
        return m == null ? n : on(m, t, d);
      }
      function Or(t) {
        return m1(t) && U1(t) == gn;
      }
      function F9(t) {
        return m1(t) && U1(t) == F;
      }
      function P9(t) {
        return m1(t) && U1(t) == zn;
      }
      function D2(t, s, d, m, g) {
        return t === s ? !0 : t == null || s == null || !m1(t) && !m1(s) ? t !== t && s !== s : U9(t, s, d, m, D2, g);
      }
      function U9(t, s, d, m, g, w) {
        var b = Me(t), A = Me(s), E = b ? Gn : V1(t), W = A ? Gn : V1(s);
        E = E == gn ? E1 : E, W = W == gn ? E1 : W;
        var Q = E == E1, J = W == E1, de = E == W;
        if (de && Xi(t)) {
          if (!Xi(s))
            return !1;
          b = !0, Q = !1;
        }
        if (de && !Q)
          return w || (w = new On()), b || Rt(t) ? p5(t, s, d, m, g, w) : p8(t, s, E, d, m, g, w);
        if (!(d & z)) {
          var he = Q && e1.call(t, "__wrapped__"), we = J && e1.call(s, "__wrapped__");
          if (he || we) {
            var Le = he ? t.value() : t, Ce = we ? s.value() : s;
            return w || (w = new On()), g(Le, Ce, d, m, w);
          }
        }
        return de ? (w || (w = new On()), y8(t, s, d, m, g, w)) : !1;
      }
      function R9(t) {
        return m1(t) && V1(t) == ie;
      }
      function vs(t, s, d, m) {
        var g = d.length, w = g, b = !m;
        if (t == null)
          return !w;
        for (t = t1(t); g--; ) {
          var A = d[g];
          if (b && A[2] ? A[1] !== t[A[0]] : !(A[0] in t))
            return !1;
        }
        for (; ++g < w; ) {
          A = d[g];
          var E = A[0], W = t[E], Q = A[1];
          if (b && A[2]) {
            if (W === n && !(E in t))
              return !1;
          } else {
            var J = new On();
            if (m)
              var de = m(W, Q, E, t, s, J);
            if (!(de === n ? D2(Q, W, z | R, m, J) : de))
              return !1;
          }
        }
        return !0;
      }
      function Hr(t) {
        if (!h1(t) || M8(t))
          return !1;
        var s = gi(t) ? R7 : zf;
        return s.test(vt(t));
      }
      function Y9(t) {
        return m1(t) && U1(t) == D;
      }
      function Z9(t) {
        return m1(t) && V1(t) == L;
      }
      function W9(t) {
        return m1(t) && Fa(t.length) && !!r1[U1(t)];
      }
      function jr(t) {
        return typeof t == "function" ? t : t == null ? en : typeof t == "object" ? Me(t) ? Pr(t[0], t[1]) : Fr(t) : o4(t);
      }
      function gs(t) {
        if (!T2(t))
          return G7(t);
        var s = [];
        for (var d in t1(t))
          e1.call(t, d) && d != "constructor" && s.push(d);
        return s;
      }
      function Q9(t) {
        if (!h1(t))
          return T8(t);
        var s = T2(t), d = [];
        for (var m in t)
          m == "constructor" && (s || !e1.call(t, m)) || d.push(m);
        return d;
      }
      function _s(t, s) {
        return t < s;
      }
      function Vr(t, s) {
        var d = -1, m = K1(t) ? O(t.length) : [];
        return Wi(t, function(g, w, b) {
          m[++d] = s(g, w, b);
        }), m;
      }
      function Fr(t) {
        var s = Is(t);
        return s.length == 1 && s[0][2] ? w5(s[0][0], s[0][1]) : function(d) {
          return d === t || vs(d, t, s);
        };
      }
      function Pr(t, s) {
        return Os(t) && _5(s) ? w5(ii(t), s) : function(d) {
          var m = Ws(d, t);
          return m === n && m === s ? Qs(d, t) : D2(s, m, z | R);
        };
      }
      function ba(t, s, d, m, g) {
        t !== s && hs(s, function(w, b) {
          if (g || (g = new On()), h1(w))
            q9(t, s, b, d, ba, m, g);
          else {
            var A = m ? m(js(t, b), w, b + "", t, s, g) : n;
            A === n && (A = w), fs(t, b, A);
          }
        }, $1);
      }
      function q9(t, s, d, m, g, w, b) {
        var A = js(t, d), E = js(s, d), W = b.get(E);
        if (W) {
          fs(t, d, W);
          return;
        }
        var Q = w ? w(A, E, d + "", t, s, b) : n, J = Q === n;
        if (J) {
          var de = Me(E), he = !de && Xi(E), we = !de && !he && Rt(E);
          Q = E, de || he || we ? Me(A) ? Q = A : y1(A) ? Q = J1(A) : he ? (J = !1, Q = $r(E, !0)) : we ? (J = !1, Q = e5(E, !0)) : Q = [] : N2(E) || gt(E) ? (Q = A, gt(A) ? Q = X5(A) : (!h1(A) || gi(A)) && (Q = g5(E))) : J = !1;
        }
        J && (b.set(E, Q), g(Q, E, m, w, b), b.delete(E)), fs(t, d, Q);
      }
      function Ur(t, s) {
        var d = t.length;
        if (d)
          return s += s < 0 ? d : 0, vi(s, d) ? t[s] : n;
      }
      function Rr(t, s, d) {
        s.length ? s = c1(s, function(w) {
          return Me(w) ? function(b) {
            return pt(b, w.length === 1 ? w[0] : w);
          } : w;
        }) : s = [en];
        var m = -1;
        s = c1(s, rn(ge()));
        var g = Vr(t, function(w, b, A) {
          var E = c1(s, function(W) {
            return W(w);
          });
          return { criteria: E, index: ++m, value: w };
        });
        return C7(g, function(w, b) {
          return r8(w, b, d);
        });
      }
      function G9(t, s) {
        return Yr(t, s, function(d, m) {
          return Qs(t, m);
        });
      }
      function Yr(t, s, d) {
        for (var m = -1, g = s.length, w = {}; ++m < g; ) {
          var b = s[m], A = pt(t, b);
          d(A, b) && A2(w, qi(b, t), A);
        }
        return w;
      }
      function X9(t) {
        return function(s) {
          return pt(s, t);
        };
      }
      function ws(t, s, d, m) {
        var g = m ? w7 : Et, w = -1, b = s.length, A = t;
        for (t === s && (s = J1(s)), d && (A = c1(t, rn(d))); ++w < b; )
          for (var E = 0, W = s[w], Q = d ? d(W) : W; (E = g(A, Q, E, m)) > -1; )
            A !== t && ma.call(A, E, 1), ma.call(t, E, 1);
        return t;
      }
      function Zr(t, s) {
        for (var d = t ? s.length : 0, m = d - 1; d--; ) {
          var g = s[d];
          if (d == m || g !== w) {
            var w = g;
            vi(g) ? ma.call(t, g, 1) : bs(t, g);
          }
        }
        return t;
      }
      function Cs(t, s) {
        return t + va(Mr() * (s - t + 1));
      }
      function J9(t, s, d, m) {
        for (var g = -1, w = C1(ya((s - t) / (d || 1)), 0), b = O(w); w--; )
          b[m ? w : ++g] = t, t += d;
        return b;
      }
      function ks(t, s) {
        var d = "";
        if (!t || s < 1 || s > G1)
          return d;
        do
          s % 2 && (d += t), s = va(s / 2), s && (t += t);
        while (s);
        return d;
      }
      function Se(t, s) {
        return Vs(C5(t, s, en), t + "");
      }
      function K9(t) {
        return Lr(Yt(t));
      }
      function $9(t, s) {
        var d = Yt(t);
        return Ia(d, mt(s, 0, d.length));
      }
      function A2(t, s, d, m) {
        if (!h1(t))
          return t;
        s = qi(s, t);
        for (var g = -1, w = s.length, b = w - 1, A = t; A != null && ++g < w; ) {
          var E = ii(s[g]), W = d;
          if (E === "__proto__" || E === "constructor" || E === "prototype")
            return t;
          if (g != b) {
            var Q = A[E];
            W = m ? m(Q, E, A) : n, W === n && (W = h1(Q) ? Q : vi(s[g + 1]) ? [] : {});
          }
          x2(A, E, W), A = A[E];
        }
        return t;
      }
      var Wr = ga ? function(t, s) {
        return ga.set(t, s), t;
      } : en, e8 = pa ? function(t, s) {
        return pa(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Gs(s),
          writable: !0
        });
      } : en;
      function n8(t) {
        return Ia(Yt(t));
      }
      function Mn(t, s, d) {
        var m = -1, g = t.length;
        s < 0 && (s = -s > g ? 0 : g + s), d = d > g ? g : d, d < 0 && (d += g), g = s > d ? 0 : d - s >>> 0, s >>>= 0;
        for (var w = O(g); ++m < g; )
          w[m] = t[m + s];
        return w;
      }
      function i8(t, s) {
        var d;
        return Wi(t, function(m, g, w) {
          return d = s(m, g, w), !d;
        }), !!d;
      }
      function Ma(t, s, d) {
        var m = 0, g = t == null ? m : t.length;
        if (typeof s == "number" && s === s && g <= Oi) {
          for (; m < g; ) {
            var w = m + g >>> 1, b = t[w];
            b !== null && !dn(b) && (d ? b <= s : b < s) ? m = w + 1 : g = w;
          }
          return g;
        }
        return xs(t, s, en, d);
      }
      function xs(t, s, d, m) {
        var g = 0, w = t == null ? 0 : t.length;
        if (w === 0)
          return 0;
        s = d(s);
        for (var b = s !== s, A = s === null, E = dn(s), W = s === n; g < w; ) {
          var Q = va((g + w) / 2), J = d(t[Q]), de = J !== n, he = J === null, we = J === J, Le = dn(J);
          if (b)
            var Ce = m || we;
          else
            W ? Ce = we && (m || de) : A ? Ce = we && de && (m || !he) : E ? Ce = we && de && !he && (m || !Le) : he || Le ? Ce = !1 : Ce = m ? J <= s : J < s;
          Ce ? g = Q + 1 : w = Q;
        }
        return j1(w, X1);
      }
      function Qr(t, s) {
        for (var d = -1, m = t.length, g = 0, w = []; ++d < m; ) {
          var b = t[d], A = s ? s(b) : b;
          if (!d || !Hn(A, E)) {
            var E = A;
            w[g++] = b === 0 ? 0 : b;
          }
        }
        return w;
      }
      function qr(t) {
        return typeof t == "number" ? t : dn(t) ? qn : +t;
      }
      function ln(t) {
        if (typeof t == "string")
          return t;
        if (Me(t))
          return c1(t, ln) + "";
        if (dn(t))
          return Dr ? Dr.call(t) : "";
        var s = t + "";
        return s == "0" && 1 / t == -sn ? "-0" : s;
      }
      function Qi(t, s, d) {
        var m = -1, g = aa, w = t.length, b = !0, A = [], E = A;
        if (d)
          b = !1, g = K0;
        else if (w >= r) {
          var W = s ? null : h8(t);
          if (W)
            return oa(W);
          b = !1, g = v2, E = new ht();
        } else
          E = s ? [] : A;
        e:
          for (; ++m < w; ) {
            var Q = t[m], J = s ? s(Q) : Q;
            if (Q = d || Q !== 0 ? Q : 0, b && J === J) {
              for (var de = E.length; de--; )
                if (E[de] === J)
                  continue e;
              s && E.push(J), A.push(Q);
            } else
              g(E, J, d) || (E !== A && E.push(J), A.push(Q));
          }
        return A;
      }
      function bs(t, s) {
        return s = qi(s, t), t = k5(t, s), t == null || delete t[ii(Dn(s))];
      }
      function Gr(t, s, d, m) {
        return A2(t, s, d(pt(t, s)), m);
      }
      function Da(t, s, d, m) {
        for (var g = t.length, w = m ? g : -1; (m ? w-- : ++w < g) && s(t[w], w, t); )
          ;
        return d ? Mn(t, m ? 0 : w, m ? w + 1 : g) : Mn(t, m ? w + 1 : 0, m ? g : w);
      }
      function Xr(t, s) {
        var d = t;
        return d instanceof He && (d = d.value()), $0(s, function(m, g) {
          return g.func.apply(g.thisArg, Ri([m], g.args));
        }, d);
      }
      function Ms(t, s, d) {
        var m = t.length;
        if (m < 2)
          return m ? Qi(t[0]) : [];
        for (var g = -1, w = O(m); ++g < m; )
          for (var b = t[g], A = -1; ++A < m; )
            A != g && (w[g] = b2(w[g] || b, t[A], s, d));
        return Qi(I1(w, 1), s, d);
      }
      function Jr(t, s, d) {
        for (var m = -1, g = t.length, w = s.length, b = {}; ++m < g; ) {
          var A = m < w ? s[m] : n;
          d(b, t[m], A);
        }
        return b;
      }
      function Ds(t) {
        return y1(t) ? t : [];
      }
      function As(t) {
        return typeof t == "function" ? t : en;
      }
      function qi(t, s) {
        return Me(t) ? t : Os(t, s) ? [t] : D5($e(t));
      }
      var t8 = Se;
      function Gi(t, s, d) {
        var m = t.length;
        return d = d === n ? m : d, !s && d >= m ? t : Mn(t, s, d);
      }
      var Kr = Y7 || function(t) {
        return z1.clearTimeout(t);
      };
      function $r(t, s) {
        if (s)
          return t.slice();
        var d = t.length, m = wr ? wr(d) : new t.constructor(d);
        return t.copy(m), m;
      }
      function Ls(t) {
        var s = new t.constructor(t.byteLength);
        return new ua(s).set(new ua(t)), s;
      }
      function a8(t, s) {
        var d = s ? Ls(t.buffer) : t.buffer;
        return new t.constructor(d, t.byteOffset, t.byteLength);
      }
      function s8(t) {
        var s = new t.constructor(t.source, Oo.exec(t));
        return s.lastIndex = t.lastIndex, s;
      }
      function o8(t) {
        return k2 ? t1(k2.call(t)) : {};
      }
      function e5(t, s) {
        var d = s ? Ls(t.buffer) : t.buffer;
        return new t.constructor(d, t.byteOffset, t.length);
      }
      function n5(t, s) {
        if (t !== s) {
          var d = t !== n, m = t === null, g = t === t, w = dn(t), b = s !== n, A = s === null, E = s === s, W = dn(s);
          if (!A && !W && !w && t > s || w && b && E && !A && !W || m && b && E || !d && E || !g)
            return 1;
          if (!m && !w && !W && t < s || W && d && g && !m && !w || A && d && g || !b && g || !E)
            return -1;
        }
        return 0;
      }
      function r8(t, s, d) {
        for (var m = -1, g = t.criteria, w = s.criteria, b = g.length, A = d.length; ++m < b; ) {
          var E = n5(g[m], w[m]);
          if (E) {
            if (m >= A)
              return E;
            var W = d[m];
            return E * (W == "desc" ? -1 : 1);
          }
        }
        return t.index - s.index;
      }
      function i5(t, s, d, m) {
        for (var g = -1, w = t.length, b = d.length, A = -1, E = s.length, W = C1(w - b, 0), Q = O(E + W), J = !m; ++A < E; )
          Q[A] = s[A];
        for (; ++g < b; )
          (J || g < w) && (Q[d[g]] = t[g]);
        for (; W--; )
          Q[A++] = t[g++];
        return Q;
      }
      function t5(t, s, d, m) {
        for (var g = -1, w = t.length, b = -1, A = d.length, E = -1, W = s.length, Q = C1(w - A, 0), J = O(Q + W), de = !m; ++g < Q; )
          J[g] = t[g];
        for (var he = g; ++E < W; )
          J[he + E] = s[E];
        for (; ++b < A; )
          (de || g < w) && (J[he + d[b]] = t[g++]);
        return J;
      }
      function J1(t, s) {
        var d = -1, m = t.length;
        for (s || (s = O(m)); ++d < m; )
          s[d] = t[d];
        return s;
      }
      function ni(t, s, d, m) {
        var g = !d;
        d || (d = {});
        for (var w = -1, b = s.length; ++w < b; ) {
          var A = s[w], E = m ? m(d[A], t[A], A, d, t) : n;
          E === n && (E = t[A]), g ? mi(d, A, E) : x2(d, A, E);
        }
        return d;
      }
      function l8(t, s) {
        return ni(t, Bs(t), s);
      }
      function d8(t, s) {
        return ni(t, y5(t), s);
      }
      function Aa(t, s) {
        return function(d, m) {
          var g = Me(d) ? m7 : N9, w = s ? s() : {};
          return g(d, t, ge(m, 2), w);
        };
      }
      function Ft(t) {
        return Se(function(s, d) {
          var m = -1, g = d.length, w = g > 1 ? d[g - 1] : n, b = g > 2 ? d[2] : n;
          for (w = t.length > 3 && typeof w == "function" ? (g--, w) : n, b && R1(d[0], d[1], b) && (w = g < 3 ? n : w, g = 1), s = t1(s); ++m < g; ) {
            var A = d[m];
            A && t(s, A, m, w);
          }
          return s;
        });
      }
      function a5(t, s) {
        return function(d, m) {
          if (d == null)
            return d;
          if (!K1(d))
            return t(d, m);
          for (var g = d.length, w = s ? g : -1, b = t1(d); (s ? w-- : ++w < g) && m(b[w], w, b) !== !1; )
            ;
          return d;
        };
      }
      function s5(t) {
        return function(s, d, m) {
          for (var g = -1, w = t1(s), b = m(s), A = b.length; A--; ) {
            var E = b[t ? A : ++g];
            if (d(w[E], E, w) === !1)
              break;
          }
          return s;
        };
      }
      function c8(t, s, d) {
        var m = s & U, g = L2(t);
        function w() {
          var b = this && this !== z1 && this instanceof w ? g : t;
          return b.apply(m ? d : this, arguments);
        }
        return w;
      }
      function o5(t) {
        return function(s) {
          s = $e(s);
          var d = zt(s) ? Bn(s) : n, m = d ? d[0] : s.charAt(0), g = d ? Gi(d, 1).join("") : s.slice(1);
          return m[t]() + g;
        };
      }
      function Pt(t) {
        return function(s) {
          return $0(a4(t4(s).replace(e7, "")), t, "");
        };
      }
      function L2(t) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new t();
            case 1:
              return new t(s[0]);
            case 2:
              return new t(s[0], s[1]);
            case 3:
              return new t(s[0], s[1], s[2]);
            case 4:
              return new t(s[0], s[1], s[2], s[3]);
            case 5:
              return new t(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new t(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new t(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var d = Vt(t.prototype), m = t.apply(d, s);
          return h1(m) ? m : d;
        };
      }
      function f8(t, s, d) {
        var m = L2(t);
        function g() {
          for (var w = arguments.length, b = O(w), A = w, E = Ut(g); A--; )
            b[A] = arguments[A];
          var W = w < 3 && b[0] !== E && b[w - 1] !== E ? [] : Yi(b, E);
          if (w -= W.length, w < d)
            return f5(
              t,
              s,
              La,
              g.placeholder,
              n,
              b,
              W,
              n,
              n,
              d - w
            );
          var Q = this && this !== z1 && this instanceof g ? m : t;
          return on(Q, this, b);
        }
        return g;
      }
      function r5(t) {
        return function(s, d, m) {
          var g = t1(s);
          if (!K1(s)) {
            var w = ge(d, 3);
            s = D1(s), d = function(A) {
              return w(g[A], A, g);
            };
          }
          var b = t(s, d, m);
          return b > -1 ? g[w ? s[b] : b] : n;
        };
      }
      function l5(t) {
        return yi(function(s) {
          var d = s.length, m = d, g = xn.prototype.thru;
          for (t && s.reverse(); m--; ) {
            var w = s[m];
            if (typeof w != "function")
              throw new kn(l);
            if (g && !b && Ea(w) == "wrapper")
              var b = new xn([], !0);
          }
          for (m = b ? m : d; ++m < d; ) {
            w = s[m];
            var A = Ea(w), E = A == "wrapper" ? zs(w) : n;
            E && Hs(E[0]) && E[1] == (Y | I | K | ae) && !E[4].length && E[9] == 1 ? b = b[Ea(E[0])].apply(b, E[3]) : b = w.length == 1 && Hs(w) ? b[A]() : b.thru(w);
          }
          return function() {
            var W = arguments, Q = W[0];
            if (b && W.length == 1 && Me(Q))
              return b.plant(Q).value();
            for (var J = 0, de = d ? s[J].apply(this, W) : Q; ++J < d; )
              de = s[J].call(this, de);
            return de;
          };
        });
      }
      function La(t, s, d, m, g, w, b, A, E, W) {
        var Q = s & Y, J = s & U, de = s & G, he = s & (I | V), we = s & ee, Le = de ? n : L2(t);
        function Ce() {
          for (var Be = arguments.length, Fe = O(Be), cn = Be; cn--; )
            Fe[cn] = arguments[cn];
          if (he)
            var Y1 = Ut(Ce), fn = x7(Fe, Y1);
          if (m && (Fe = i5(Fe, m, g, he)), w && (Fe = t5(Fe, w, b, he)), Be -= fn, he && Be < W) {
            var v1 = Yi(Fe, Y1);
            return f5(
              t,
              s,
              La,
              Ce.placeholder,
              d,
              Fe,
              v1,
              A,
              E,
              W - Be
            );
          }
          var jn = J ? d : this, wi = de ? jn[t] : t;
          return Be = Fe.length, A ? Fe = N8(Fe, A) : we && Be > 1 && Fe.reverse(), Q && E < Be && (Fe.length = E), this && this !== z1 && this instanceof Ce && (wi = Le || L2(wi)), wi.apply(jn, Fe);
        }
        return Ce;
      }
      function d5(t, s) {
        return function(d, m) {
          return V9(d, t, s(m), {});
        };
      }
      function Ta(t, s) {
        return function(d, m) {
          var g;
          if (d === n && m === n)
            return s;
          if (d !== n && (g = d), m !== n) {
            if (g === n)
              return m;
            typeof d == "string" || typeof m == "string" ? (d = ln(d), m = ln(m)) : (d = qr(d), m = qr(m)), g = t(d, m);
          }
          return g;
        };
      }
      function Ts(t) {
        return yi(function(s) {
          return s = c1(s, rn(ge())), Se(function(d) {
            var m = this;
            return t(s, function(g) {
              return on(g, m, d);
            });
          });
        });
      }
      function Sa(t, s) {
        s = s === n ? " " : ln(s);
        var d = s.length;
        if (d < 2)
          return d ? ks(s, t) : s;
        var m = ks(s, ya(t / It(s)));
        return zt(s) ? Gi(Bn(m), 0, t).join("") : m.slice(0, t);
      }
      function u8(t, s, d, m) {
        var g = s & U, w = L2(t);
        function b() {
          for (var A = -1, E = arguments.length, W = -1, Q = m.length, J = O(Q + E), de = this && this !== z1 && this instanceof b ? w : t; ++W < Q; )
            J[W] = m[W];
          for (; E--; )
            J[W++] = arguments[++A];
          return on(de, g ? d : this, J);
        }
        return b;
      }
      function c5(t) {
        return function(s, d, m) {
          return m && typeof m != "number" && R1(s, d, m) && (d = m = n), s = _i(s), d === n ? (d = s, s = 0) : d = _i(d), m = m === n ? s < d ? 1 : -1 : _i(m), J9(s, d, m, t);
        };
      }
      function Na(t) {
        return function(s, d) {
          return typeof s == "string" && typeof d == "string" || (s = An(s), d = An(d)), t(s, d);
        };
      }
      function f5(t, s, d, m, g, w, b, A, E, W) {
        var Q = s & I, J = Q ? b : n, de = Q ? n : b, he = Q ? w : n, we = Q ? n : w;
        s |= Q ? K : H, s &= ~(Q ? H : K), s & re || (s &= ~(U | G));
        var Le = [
          t,
          s,
          g,
          he,
          J,
          we,
          de,
          A,
          E,
          W
        ], Ce = d.apply(n, Le);
        return Hs(t) && x5(Ce, Le), Ce.placeholder = m, b5(Ce, t, s);
      }
      function Ss(t) {
        var s = w1[t];
        return function(d, m) {
          if (d = An(d), m = m == null ? 0 : j1(De(m), 292), m && br(d)) {
            var g = ($e(d) + "e").split("e"), w = s(g[0] + "e" + (+g[1] + m));
            return g = ($e(w) + "e").split("e"), +(g[0] + "e" + (+g[1] - m));
          }
          return s(d);
        };
      }
      var h8 = Ht && 1 / oa(new Ht([, -0]))[1] == sn ? function(t) {
        return new Ht(t);
      } : Ks;
      function u5(t) {
        return function(s) {
          var d = V1(s);
          return d == ie ? os(s) : d == L ? S7(s) : k7(s, t(s));
        };
      }
      function pi(t, s, d, m, g, w, b, A) {
        var E = s & G;
        if (!E && typeof t != "function")
          throw new kn(l);
        var W = m ? m.length : 0;
        if (W || (s &= ~(K | H), m = g = n), b = b === n ? b : C1(De(b), 0), A = A === n ? A : De(A), W -= g ? g.length : 0, s & H) {
          var Q = m, J = g;
          m = g = n;
        }
        var de = E ? n : zs(t), he = [
          t,
          s,
          d,
          m,
          g,
          Q,
          J,
          w,
          b,
          A
        ];
        if (de && L8(he, de), t = he[0], s = he[1], d = he[2], m = he[3], g = he[4], A = he[9] = he[9] === n ? E ? 0 : t.length : C1(he[9] - W, 0), !A && s & (I | V) && (s &= ~(I | V)), !s || s == U)
          var we = c8(t, s, d);
        else
          s == I || s == V ? we = f8(t, s, A) : (s == K || s == (U | K)) && !g.length ? we = u8(t, s, d, m) : we = La.apply(n, he);
        var Le = de ? Wr : x5;
        return b5(Le(we, he), t, s);
      }
      function h5(t, s, d, m) {
        return t === n || Hn(t, Ot[d]) && !e1.call(m, d) ? s : t;
      }
      function m5(t, s, d, m, g, w) {
        return h1(t) && h1(s) && (w.set(s, t), ba(t, s, n, m5, w), w.delete(s)), t;
      }
      function m8(t) {
        return N2(t) ? n : t;
      }
      function p5(t, s, d, m, g, w) {
        var b = d & z, A = t.length, E = s.length;
        if (A != E && !(b && E > A))
          return !1;
        var W = w.get(t), Q = w.get(s);
        if (W && Q)
          return W == s && Q == t;
        var J = -1, de = !0, he = d & R ? new ht() : n;
        for (w.set(t, s), w.set(s, t); ++J < A; ) {
          var we = t[J], Le = s[J];
          if (m)
            var Ce = b ? m(Le, we, J, s, t, w) : m(we, Le, J, t, s, w);
          if (Ce !== n) {
            if (Ce)
              continue;
            de = !1;
            break;
          }
          if (he) {
            if (!es(s, function(Be, Fe) {
              if (!v2(he, Fe) && (we === Be || g(we, Be, d, m, w)))
                return he.push(Fe);
            })) {
              de = !1;
              break;
            }
          } else if (!(we === Le || g(we, Le, d, m, w))) {
            de = !1;
            break;
          }
        }
        return w.delete(t), w.delete(s), de;
      }
      function p8(t, s, d, m, g, w, b) {
        switch (d) {
          case ne:
            if (t.byteLength != s.byteLength || t.byteOffset != s.byteOffset)
              return !1;
            t = t.buffer, s = s.buffer;
          case F:
            return !(t.byteLength != s.byteLength || !w(new ua(t), new ua(s)));
          case Xn:
          case zn:
          case Ie:
            return Hn(+t, +s);
          case Jn:
            return t.name == s.name && t.message == s.message;
          case D:
          case X:
            return t == s + "";
          case ie:
            var A = os;
          case L:
            var E = m & z;
            if (A || (A = oa), t.size != s.size && !E)
              return !1;
            var W = b.get(t);
            if (W)
              return W == s;
            m |= R, b.set(t, s);
            var Q = p5(A(t), A(s), m, g, w, b);
            return b.delete(t), Q;
          case ve:
            if (k2)
              return k2.call(t) == k2.call(s);
        }
        return !1;
      }
      function y8(t, s, d, m, g, w) {
        var b = d & z, A = Ns(t), E = A.length, W = Ns(s), Q = W.length;
        if (E != Q && !b)
          return !1;
        for (var J = E; J--; ) {
          var de = A[J];
          if (!(b ? de in s : e1.call(s, de)))
            return !1;
        }
        var he = w.get(t), we = w.get(s);
        if (he && we)
          return he == s && we == t;
        var Le = !0;
        w.set(t, s), w.set(s, t);
        for (var Ce = b; ++J < E; ) {
          de = A[J];
          var Be = t[de], Fe = s[de];
          if (m)
            var cn = b ? m(Fe, Be, de, s, t, w) : m(Be, Fe, de, t, s, w);
          if (!(cn === n ? Be === Fe || g(Be, Fe, d, m, w) : cn)) {
            Le = !1;
            break;
          }
          Ce || (Ce = de == "constructor");
        }
        if (Le && !Ce) {
          var Y1 = t.constructor, fn = s.constructor;
          Y1 != fn && "constructor" in t && "constructor" in s && !(typeof Y1 == "function" && Y1 instanceof Y1 && typeof fn == "function" && fn instanceof fn) && (Le = !1);
        }
        return w.delete(t), w.delete(s), Le;
      }
      function yi(t) {
        return Vs(C5(t, n, S5), t + "");
      }
      function Ns(t) {
        return Br(t, D1, Bs);
      }
      function Es(t) {
        return Br(t, $1, y5);
      }
      var zs = ga ? function(t) {
        return ga.get(t);
      } : Ks;
      function Ea(t) {
        for (var s = t.name + "", d = jt[s], m = e1.call(jt, s) ? d.length : 0; m--; ) {
          var g = d[m], w = g.func;
          if (w == null || w == t)
            return g.name;
        }
        return s;
      }
      function Ut(t) {
        var s = e1.call(_, "placeholder") ? _ : t;
        return s.placeholder;
      }
      function ge() {
        var t = _.iteratee || Xs;
        return t = t === Xs ? jr : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function za(t, s) {
        var d = t.__data__;
        return b8(s) ? d[typeof s == "string" ? "string" : "hash"] : d.map;
      }
      function Is(t) {
        for (var s = D1(t), d = s.length; d--; ) {
          var m = s[d], g = t[m];
          s[d] = [m, g, _5(g)];
        }
        return s;
      }
      function yt(t, s) {
        var d = A7(t, s);
        return Hr(d) ? d : n;
      }
      function v8(t) {
        var s = e1.call(t, ft), d = t[ft];
        try {
          t[ft] = n;
          var m = !0;
        } catch {
        }
        var g = ca.call(t);
        return m && (s ? t[ft] = d : delete t[ft]), g;
      }
      var Bs = ls ? function(t) {
        return t == null ? [] : (t = t1(t), Ui(ls(t), function(s) {
          return kr.call(t, s);
        }));
      } : $s, y5 = ls ? function(t) {
        for (var s = []; t; )
          Ri(s, Bs(t)), t = ha(t);
        return s;
      } : $s, V1 = U1;
      (ds && V1(new ds(new ArrayBuffer(1))) != ne || _2 && V1(new _2()) != ie || cs && V1(cs.resolve()) != Fi || Ht && V1(new Ht()) != L || w2 && V1(new w2()) != Ue) && (V1 = function(t) {
        var s = U1(t), d = s == E1 ? t.constructor : n, m = d ? vt(d) : "";
        if (m)
          switch (m) {
            case $7:
              return ne;
            case e9:
              return ie;
            case n9:
              return Fi;
            case i9:
              return L;
            case t9:
              return Ue;
          }
        return s;
      });
      function g8(t, s, d) {
        for (var m = -1, g = d.length; ++m < g; ) {
          var w = d[m], b = w.size;
          switch (w.type) {
            case "drop":
              t += b;
              break;
            case "dropRight":
              s -= b;
              break;
            case "take":
              s = j1(s, t + b);
              break;
            case "takeRight":
              t = C1(t, s - b);
              break;
          }
        }
        return { start: t, end: s };
      }
      function _8(t) {
        var s = t.match(Mf);
        return s ? s[1].split(Df) : [];
      }
      function v5(t, s, d) {
        s = qi(s, t);
        for (var m = -1, g = s.length, w = !1; ++m < g; ) {
          var b = ii(s[m]);
          if (!(w = t != null && d(t, b)))
            break;
          t = t[b];
        }
        return w || ++m != g ? w : (g = t == null ? 0 : t.length, !!g && Fa(g) && vi(b, g) && (Me(t) || gt(t)));
      }
      function w8(t) {
        var s = t.length, d = new t.constructor(s);
        return s && typeof t[0] == "string" && e1.call(t, "index") && (d.index = t.index, d.input = t.input), d;
      }
      function g5(t) {
        return typeof t.constructor == "function" && !T2(t) ? Vt(ha(t)) : {};
      }
      function C8(t, s, d) {
        var m = t.constructor;
        switch (s) {
          case F:
            return Ls(t);
          case Xn:
          case zn:
            return new m(+t);
          case ne:
            return a8(t, d);
          case Ve:
          case o1:
          case _n:
          case Pi:
          case $n:
          case In:
          case y2:
          case St:
          case U0:
            return e5(t, d);
          case ie:
            return new m();
          case Ie:
          case X:
            return new m(t);
          case D:
            return s8(t);
          case L:
            return new m();
          case ve:
            return o8(t);
        }
      }
      function k8(t, s) {
        var d = s.length;
        if (!d)
          return t;
        var m = d - 1;
        return s[m] = (d > 1 ? "& " : "") + s[m], s = s.join(d > 2 ? ", " : " "), t.replace(bf, `{
/* [wrapped with ` + s + `] */
`);
      }
      function x8(t) {
        return Me(t) || gt(t) || !!(xr && t && t[xr]);
      }
      function vi(t, s) {
        var d = typeof t;
        return s = s ?? G1, !!s && (d == "number" || d != "symbol" && Bf.test(t)) && t > -1 && t % 1 == 0 && t < s;
      }
      function R1(t, s, d) {
        if (!h1(d))
          return !1;
        var m = typeof s;
        return (m == "number" ? K1(d) && vi(s, d.length) : m == "string" && s in d) ? Hn(d[s], t) : !1;
      }
      function Os(t, s) {
        if (Me(t))
          return !1;
        var d = typeof t;
        return d == "number" || d == "symbol" || d == "boolean" || t == null || dn(t) ? !0 : wf.test(t) || !_f.test(t) || s != null && t in t1(s);
      }
      function b8(t) {
        var s = typeof t;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? t !== "__proto__" : t === null;
      }
      function Hs(t) {
        var s = Ea(t), d = _[s];
        if (typeof d != "function" || !(s in He.prototype))
          return !1;
        if (t === d)
          return !0;
        var m = zs(d);
        return !!m && t === m[0];
      }
      function M8(t) {
        return !!_r && _r in t;
      }
      var D8 = la ? gi : e3;
      function T2(t) {
        var s = t && t.constructor, d = typeof s == "function" && s.prototype || Ot;
        return t === d;
      }
      function _5(t) {
        return t === t && !h1(t);
      }
      function w5(t, s) {
        return function(d) {
          return d == null ? !1 : d[t] === s && (s !== n || t in t1(d));
        };
      }
      function A8(t) {
        var s = ja(t, function(m) {
          return d.size === y && d.clear(), m;
        }), d = s.cache;
        return s;
      }
      function L8(t, s) {
        var d = t[1], m = s[1], g = d | m, w = g < (U | G | Y), b = m == Y && d == I || m == Y && d == ae && t[7].length <= s[8] || m == (Y | ae) && s[7].length <= s[8] && d == I;
        if (!(w || b))
          return t;
        m & U && (t[2] = s[2], g |= d & U ? 0 : re);
        var A = s[3];
        if (A) {
          var E = t[3];
          t[3] = E ? i5(E, A, s[4]) : A, t[4] = E ? Yi(t[3], v) : s[4];
        }
        return A = s[5], A && (E = t[5], t[5] = E ? t5(E, A, s[6]) : A, t[6] = E ? Yi(t[5], v) : s[6]), A = s[7], A && (t[7] = A), m & Y && (t[8] = t[8] == null ? s[8] : j1(t[8], s[8])), t[9] == null && (t[9] = s[9]), t[0] = s[0], t[1] = g, t;
      }
      function T8(t) {
        var s = [];
        if (t != null)
          for (var d in t1(t))
            s.push(d);
        return s;
      }
      function S8(t) {
        return ca.call(t);
      }
      function C5(t, s, d) {
        return s = C1(s === n ? t.length - 1 : s, 0), function() {
          for (var m = arguments, g = -1, w = C1(m.length - s, 0), b = O(w); ++g < w; )
            b[g] = m[s + g];
          g = -1;
          for (var A = O(s + 1); ++g < s; )
            A[g] = m[g];
          return A[s] = d(b), on(t, this, A);
        };
      }
      function k5(t, s) {
        return s.length < 2 ? t : pt(t, Mn(s, 0, -1));
      }
      function N8(t, s) {
        for (var d = t.length, m = j1(s.length, d), g = J1(t); m--; ) {
          var w = s[m];
          t[m] = vi(w, d) ? g[w] : n;
        }
        return t;
      }
      function js(t, s) {
        if (!(s === "constructor" && typeof t[s] == "function") && s != "__proto__")
          return t[s];
      }
      var x5 = M5(Wr), S2 = W7 || function(t, s) {
        return z1.setTimeout(t, s);
      }, Vs = M5(e8);
      function b5(t, s, d) {
        var m = s + "";
        return Vs(t, k8(m, E8(_8(m), d)));
      }
      function M5(t) {
        var s = 0, d = 0;
        return function() {
          var m = X7(), g = _1 - (m - d);
          if (d = m, g > 0) {
            if (++s >= ze)
              return arguments[0];
          } else
            s = 0;
          return t.apply(n, arguments);
        };
      }
      function Ia(t, s) {
        var d = -1, m = t.length, g = m - 1;
        for (s = s === n ? m : s; ++d < s; ) {
          var w = Cs(d, g), b = t[w];
          t[w] = t[d], t[d] = b;
        }
        return t.length = s, t;
      }
      var D5 = A8(function(t) {
        var s = [];
        return t.charCodeAt(0) === 46 && s.push(""), t.replace(Cf, function(d, m, g, w) {
          s.push(g ? w.replace(Tf, "$1") : m || d);
        }), s;
      });
      function ii(t) {
        if (typeof t == "string" || dn(t))
          return t;
        var s = t + "";
        return s == "0" && 1 / t == -sn ? "-0" : s;
      }
      function vt(t) {
        if (t != null) {
          try {
            return da.call(t);
          } catch {
          }
          try {
            return t + "";
          } catch {
          }
        }
        return "";
      }
      function E8(t, s) {
        return Cn(Hi, function(d) {
          var m = "_." + d[0];
          s & d[1] && !aa(t, m) && t.push(m);
        }), t.sort();
      }
      function A5(t) {
        if (t instanceof He)
          return t.clone();
        var s = new xn(t.__wrapped__, t.__chain__);
        return s.__actions__ = J1(t.__actions__), s.__index__ = t.__index__, s.__values__ = t.__values__, s;
      }
      function z8(t, s, d) {
        (d ? R1(t, s, d) : s === n) ? s = 1 : s = C1(De(s), 0);
        var m = t == null ? 0 : t.length;
        if (!m || s < 1)
          return [];
        for (var g = 0, w = 0, b = O(ya(m / s)); g < m; )
          b[w++] = Mn(t, g, g += s);
        return b;
      }
      function I8(t) {
        for (var s = -1, d = t == null ? 0 : t.length, m = 0, g = []; ++s < d; ) {
          var w = t[s];
          w && (g[m++] = w);
        }
        return g;
      }
      function B8() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var s = O(t - 1), d = arguments[0], m = t; m--; )
          s[m - 1] = arguments[m];
        return Ri(Me(d) ? J1(d) : [d], I1(s, 1));
      }
      var O8 = Se(function(t, s) {
        return y1(t) ? b2(t, I1(s, 1, y1, !0)) : [];
      }), H8 = Se(function(t, s) {
        var d = Dn(s);
        return y1(d) && (d = n), y1(t) ? b2(t, I1(s, 1, y1, !0), ge(d, 2)) : [];
      }), j8 = Se(function(t, s) {
        var d = Dn(s);
        return y1(d) && (d = n), y1(t) ? b2(t, I1(s, 1, y1, !0), n, d) : [];
      });
      function V8(t, s, d) {
        var m = t == null ? 0 : t.length;
        return m ? (s = d || s === n ? 1 : De(s), Mn(t, s < 0 ? 0 : s, m)) : [];
      }
      function F8(t, s, d) {
        var m = t == null ? 0 : t.length;
        return m ? (s = d || s === n ? 1 : De(s), s = m - s, Mn(t, 0, s < 0 ? 0 : s)) : [];
      }
      function P8(t, s) {
        return t && t.length ? Da(t, ge(s, 3), !0, !0) : [];
      }
      function U8(t, s) {
        return t && t.length ? Da(t, ge(s, 3), !0) : [];
      }
      function R8(t, s, d, m) {
        var g = t == null ? 0 : t.length;
        return g ? (d && typeof d != "number" && R1(t, s, d) && (d = 0, m = g), B9(t, s, d, m)) : [];
      }
      function L5(t, s, d) {
        var m = t == null ? 0 : t.length;
        if (!m)
          return -1;
        var g = d == null ? 0 : De(d);
        return g < 0 && (g = C1(m + g, 0)), sa(t, ge(s, 3), g);
      }
      function T5(t, s, d) {
        var m = t == null ? 0 : t.length;
        if (!m)
          return -1;
        var g = m - 1;
        return d !== n && (g = De(d), g = d < 0 ? C1(m + g, 0) : j1(g, m - 1)), sa(t, ge(s, 3), g, !0);
      }
      function S5(t) {
        var s = t == null ? 0 : t.length;
        return s ? I1(t, 1) : [];
      }
      function Y8(t) {
        var s = t == null ? 0 : t.length;
        return s ? I1(t, sn) : [];
      }
      function Z8(t, s) {
        var d = t == null ? 0 : t.length;
        return d ? (s = s === n ? 1 : De(s), I1(t, s)) : [];
      }
      function W8(t) {
        for (var s = -1, d = t == null ? 0 : t.length, m = {}; ++s < d; ) {
          var g = t[s];
          m[g[0]] = g[1];
        }
        return m;
      }
      function N5(t) {
        return t && t.length ? t[0] : n;
      }
      function Q8(t, s, d) {
        var m = t == null ? 0 : t.length;
        if (!m)
          return -1;
        var g = d == null ? 0 : De(d);
        return g < 0 && (g = C1(m + g, 0)), Et(t, s, g);
      }
      function q8(t) {
        var s = t == null ? 0 : t.length;
        return s ? Mn(t, 0, -1) : [];
      }
      var G8 = Se(function(t) {
        var s = c1(t, Ds);
        return s.length && s[0] === t[0] ? ys(s) : [];
      }), X8 = Se(function(t) {
        var s = Dn(t), d = c1(t, Ds);
        return s === Dn(d) ? s = n : d.pop(), d.length && d[0] === t[0] ? ys(d, ge(s, 2)) : [];
      }), J8 = Se(function(t) {
        var s = Dn(t), d = c1(t, Ds);
        return s = typeof s == "function" ? s : n, s && d.pop(), d.length && d[0] === t[0] ? ys(d, n, s) : [];
      });
      function K8(t, s) {
        return t == null ? "" : q7.call(t, s);
      }
      function Dn(t) {
        var s = t == null ? 0 : t.length;
        return s ? t[s - 1] : n;
      }
      function $8(t, s, d) {
        var m = t == null ? 0 : t.length;
        if (!m)
          return -1;
        var g = m;
        return d !== n && (g = De(d), g = g < 0 ? C1(m + g, 0) : j1(g, m - 1)), s === s ? E7(t, s, g) : sa(t, fr, g, !0);
      }
      function e6(t, s) {
        return t && t.length ? Ur(t, De(s)) : n;
      }
      var n6 = Se(E5);
      function E5(t, s) {
        return t && t.length && s && s.length ? ws(t, s) : t;
      }
      function i6(t, s, d) {
        return t && t.length && s && s.length ? ws(t, s, ge(d, 2)) : t;
      }
      function t6(t, s, d) {
        return t && t.length && s && s.length ? ws(t, s, n, d) : t;
      }
      var a6 = yi(function(t, s) {
        var d = t == null ? 0 : t.length, m = us(t, s);
        return Zr(t, c1(s, function(g) {
          return vi(g, d) ? +g : g;
        }).sort(n5)), m;
      });
      function s6(t, s) {
        var d = [];
        if (!(t && t.length))
          return d;
        var m = -1, g = [], w = t.length;
        for (s = ge(s, 3); ++m < w; ) {
          var b = t[m];
          s(b, m, t) && (d.push(b), g.push(m));
        }
        return Zr(t, g), d;
      }
      function Fs(t) {
        return t == null ? t : K7.call(t);
      }
      function o6(t, s, d) {
        var m = t == null ? 0 : t.length;
        return m ? (d && typeof d != "number" && R1(t, s, d) ? (s = 0, d = m) : (s = s == null ? 0 : De(s), d = d === n ? m : De(d)), Mn(t, s, d)) : [];
      }
      function r6(t, s) {
        return Ma(t, s);
      }
      function l6(t, s, d) {
        return xs(t, s, ge(d, 2));
      }
      function d6(t, s) {
        var d = t == null ? 0 : t.length;
        if (d) {
          var m = Ma(t, s);
          if (m < d && Hn(t[m], s))
            return m;
        }
        return -1;
      }
      function c6(t, s) {
        return Ma(t, s, !0);
      }
      function f6(t, s, d) {
        return xs(t, s, ge(d, 2), !0);
      }
      function u6(t, s) {
        var d = t == null ? 0 : t.length;
        if (d) {
          var m = Ma(t, s, !0) - 1;
          if (Hn(t[m], s))
            return m;
        }
        return -1;
      }
      function h6(t) {
        return t && t.length ? Qr(t) : [];
      }
      function m6(t, s) {
        return t && t.length ? Qr(t, ge(s, 2)) : [];
      }
      function p6(t) {
        var s = t == null ? 0 : t.length;
        return s ? Mn(t, 1, s) : [];
      }
      function y6(t, s, d) {
        return t && t.length ? (s = d || s === n ? 1 : De(s), Mn(t, 0, s < 0 ? 0 : s)) : [];
      }
      function v6(t, s, d) {
        var m = t == null ? 0 : t.length;
        return m ? (s = d || s === n ? 1 : De(s), s = m - s, Mn(t, s < 0 ? 0 : s, m)) : [];
      }
      function g6(t, s) {
        return t && t.length ? Da(t, ge(s, 3), !1, !0) : [];
      }
      function _6(t, s) {
        return t && t.length ? Da(t, ge(s, 3)) : [];
      }
      var w6 = Se(function(t) {
        return Qi(I1(t, 1, y1, !0));
      }), C6 = Se(function(t) {
        var s = Dn(t);
        return y1(s) && (s = n), Qi(I1(t, 1, y1, !0), ge(s, 2));
      }), k6 = Se(function(t) {
        var s = Dn(t);
        return s = typeof s == "function" ? s : n, Qi(I1(t, 1, y1, !0), n, s);
      });
      function x6(t) {
        return t && t.length ? Qi(t) : [];
      }
      function b6(t, s) {
        return t && t.length ? Qi(t, ge(s, 2)) : [];
      }
      function M6(t, s) {
        return s = typeof s == "function" ? s : n, t && t.length ? Qi(t, n, s) : [];
      }
      function Ps(t) {
        if (!(t && t.length))
          return [];
        var s = 0;
        return t = Ui(t, function(d) {
          if (y1(d))
            return s = C1(d.length, s), !0;
        }), as(s, function(d) {
          return c1(t, ns(d));
        });
      }
      function z5(t, s) {
        if (!(t && t.length))
          return [];
        var d = Ps(t);
        return s == null ? d : c1(d, function(m) {
          return on(s, n, m);
        });
      }
      var D6 = Se(function(t, s) {
        return y1(t) ? b2(t, s) : [];
      }), A6 = Se(function(t) {
        return Ms(Ui(t, y1));
      }), L6 = Se(function(t) {
        var s = Dn(t);
        return y1(s) && (s = n), Ms(Ui(t, y1), ge(s, 2));
      }), T6 = Se(function(t) {
        var s = Dn(t);
        return s = typeof s == "function" ? s : n, Ms(Ui(t, y1), n, s);
      }), S6 = Se(Ps);
      function N6(t, s) {
        return Jr(t || [], s || [], x2);
      }
      function E6(t, s) {
        return Jr(t || [], s || [], A2);
      }
      var z6 = Se(function(t) {
        var s = t.length, d = s > 1 ? t[s - 1] : n;
        return d = typeof d == "function" ? (t.pop(), d) : n, z5(t, d);
      });
      function I5(t) {
        var s = _(t);
        return s.__chain__ = !0, s;
      }
      function I6(t, s) {
        return s(t), t;
      }
      function Ba(t, s) {
        return s(t);
      }
      var B6 = yi(function(t) {
        var s = t.length, d = s ? t[0] : 0, m = this.__wrapped__, g = function(w) {
          return us(w, t);
        };
        return s > 1 || this.__actions__.length || !(m instanceof He) || !vi(d) ? this.thru(g) : (m = m.slice(d, +d + (s ? 1 : 0)), m.__actions__.push({
          func: Ba,
          args: [g],
          thisArg: n
        }), new xn(m, this.__chain__).thru(function(w) {
          return s && !w.length && w.push(n), w;
        }));
      });
      function O6() {
        return I5(this);
      }
      function H6() {
        return new xn(this.value(), this.__chain__);
      }
      function j6() {
        this.__values__ === n && (this.__values__ = q5(this.value()));
        var t = this.__index__ >= this.__values__.length, s = t ? n : this.__values__[this.__index__++];
        return { done: t, value: s };
      }
      function V6() {
        return this;
      }
      function F6(t) {
        for (var s, d = this; d instanceof wa; ) {
          var m = A5(d);
          m.__index__ = 0, m.__values__ = n, s ? g.__wrapped__ = m : s = m;
          var g = m;
          d = d.__wrapped__;
        }
        return g.__wrapped__ = t, s;
      }
      function P6() {
        var t = this.__wrapped__;
        if (t instanceof He) {
          var s = t;
          return this.__actions__.length && (s = new He(this)), s = s.reverse(), s.__actions__.push({
            func: Ba,
            args: [Fs],
            thisArg: n
          }), new xn(s, this.__chain__);
        }
        return this.thru(Fs);
      }
      function U6() {
        return Xr(this.__wrapped__, this.__actions__);
      }
      var R6 = Aa(function(t, s, d) {
        e1.call(t, d) ? ++t[d] : mi(t, d, 1);
      });
      function Y6(t, s, d) {
        var m = Me(t) ? dr : I9;
        return d && R1(t, s, d) && (s = n), m(t, ge(s, 3));
      }
      function Z6(t, s) {
        var d = Me(t) ? Ui : zr;
        return d(t, ge(s, 3));
      }
      var W6 = r5(L5), Q6 = r5(T5);
      function q6(t, s) {
        return I1(Oa(t, s), 1);
      }
      function G6(t, s) {
        return I1(Oa(t, s), sn);
      }
      function X6(t, s, d) {
        return d = d === n ? 1 : De(d), I1(Oa(t, s), d);
      }
      function B5(t, s) {
        var d = Me(t) ? Cn : Wi;
        return d(t, ge(s, 3));
      }
      function O5(t, s) {
        var d = Me(t) ? p7 : Er;
        return d(t, ge(s, 3));
      }
      var J6 = Aa(function(t, s, d) {
        e1.call(t, d) ? t[d].push(s) : mi(t, d, [s]);
      });
      function K6(t, s, d, m) {
        t = K1(t) ? t : Yt(t), d = d && !m ? De(d) : 0;
        var g = t.length;
        return d < 0 && (d = C1(g + d, 0)), Pa(t) ? d <= g && t.indexOf(s, d) > -1 : !!g && Et(t, s, d) > -1;
      }
      var $6 = Se(function(t, s, d) {
        var m = -1, g = typeof s == "function", w = K1(t) ? O(t.length) : [];
        return Wi(t, function(b) {
          w[++m] = g ? on(s, b, d) : M2(b, s, d);
        }), w;
      }), eu = Aa(function(t, s, d) {
        mi(t, d, s);
      });
      function Oa(t, s) {
        var d = Me(t) ? c1 : Vr;
        return d(t, ge(s, 3));
      }
      function nu(t, s, d, m) {
        return t == null ? [] : (Me(s) || (s = s == null ? [] : [s]), d = m ? n : d, Me(d) || (d = d == null ? [] : [d]), Rr(t, s, d));
      }
      var iu = Aa(function(t, s, d) {
        t[d ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function tu(t, s, d) {
        var m = Me(t) ? $0 : hr, g = arguments.length < 3;
        return m(t, ge(s, 4), d, g, Wi);
      }
      function au(t, s, d) {
        var m = Me(t) ? y7 : hr, g = arguments.length < 3;
        return m(t, ge(s, 4), d, g, Er);
      }
      function su(t, s) {
        var d = Me(t) ? Ui : zr;
        return d(t, Va(ge(s, 3)));
      }
      function ou(t) {
        var s = Me(t) ? Lr : K9;
        return s(t);
      }
      function ru(t, s, d) {
        (d ? R1(t, s, d) : s === n) ? s = 1 : s = De(s);
        var m = Me(t) ? T9 : $9;
        return m(t, s);
      }
      function lu(t) {
        var s = Me(t) ? S9 : n8;
        return s(t);
      }
      function du(t) {
        if (t == null)
          return 0;
        if (K1(t))
          return Pa(t) ? It(t) : t.length;
        var s = V1(t);
        return s == ie || s == L ? t.size : gs(t).length;
      }
      function cu(t, s, d) {
        var m = Me(t) ? es : i8;
        return d && R1(t, s, d) && (s = n), m(t, ge(s, 3));
      }
      var fu = Se(function(t, s) {
        if (t == null)
          return [];
        var d = s.length;
        return d > 1 && R1(t, s[0], s[1]) ? s = [] : d > 2 && R1(s[0], s[1], s[2]) && (s = [s[0]]), Rr(t, I1(s, 1), []);
      }), Ha = Z7 || function() {
        return z1.Date.now();
      };
      function uu(t, s) {
        if (typeof s != "function")
          throw new kn(l);
        return t = De(t), function() {
          if (--t < 1)
            return s.apply(this, arguments);
        };
      }
      function H5(t, s, d) {
        return s = d ? n : s, s = t && s == null ? t.length : s, pi(t, Y, n, n, n, n, s);
      }
      function j5(t, s) {
        var d;
        if (typeof s != "function")
          throw new kn(l);
        return t = De(t), function() {
          return --t > 0 && (d = s.apply(this, arguments)), t <= 1 && (s = n), d;
        };
      }
      var Us = Se(function(t, s, d) {
        var m = U;
        if (d.length) {
          var g = Yi(d, Ut(Us));
          m |= K;
        }
        return pi(t, m, s, d, g);
      }), V5 = Se(function(t, s, d) {
        var m = U | G;
        if (d.length) {
          var g = Yi(d, Ut(V5));
          m |= K;
        }
        return pi(s, m, t, d, g);
      });
      function F5(t, s, d) {
        s = d ? n : s;
        var m = pi(t, I, n, n, n, n, n, s);
        return m.placeholder = F5.placeholder, m;
      }
      function P5(t, s, d) {
        s = d ? n : s;
        var m = pi(t, V, n, n, n, n, n, s);
        return m.placeholder = P5.placeholder, m;
      }
      function U5(t, s, d) {
        var m, g, w, b, A, E, W = 0, Q = !1, J = !1, de = !0;
        if (typeof t != "function")
          throw new kn(l);
        s = An(s) || 0, h1(d) && (Q = !!d.leading, J = "maxWait" in d, w = J ? C1(An(d.maxWait) || 0, s) : w, de = "trailing" in d ? !!d.trailing : de);
        function he(v1) {
          var jn = m, wi = g;
          return m = g = n, W = v1, b = t.apply(wi, jn), b;
        }
        function we(v1) {
          return W = v1, A = S2(Be, s), Q ? he(v1) : b;
        }
        function Le(v1) {
          var jn = v1 - E, wi = v1 - W, r4 = s - jn;
          return J ? j1(r4, w - wi) : r4;
        }
        function Ce(v1) {
          var jn = v1 - E, wi = v1 - W;
          return E === n || jn >= s || jn < 0 || J && wi >= w;
        }
        function Be() {
          var v1 = Ha();
          if (Ce(v1))
            return Fe(v1);
          A = S2(Be, Le(v1));
        }
        function Fe(v1) {
          return A = n, de && m ? he(v1) : (m = g = n, b);
        }
        function cn() {
          A !== n && Kr(A), W = 0, m = E = g = A = n;
        }
        function Y1() {
          return A === n ? b : Fe(Ha());
        }
        function fn() {
          var v1 = Ha(), jn = Ce(v1);
          if (m = arguments, g = this, E = v1, jn) {
            if (A === n)
              return we(E);
            if (J)
              return Kr(A), A = S2(Be, s), he(E);
          }
          return A === n && (A = S2(Be, s)), b;
        }
        return fn.cancel = cn, fn.flush = Y1, fn;
      }
      var hu = Se(function(t, s) {
        return Nr(t, 1, s);
      }), mu = Se(function(t, s, d) {
        return Nr(t, An(s) || 0, d);
      });
      function pu(t) {
        return pi(t, ee);
      }
      function ja(t, s) {
        if (typeof t != "function" || s != null && typeof s != "function")
          throw new kn(l);
        var d = function() {
          var m = arguments, g = s ? s.apply(this, m) : m[0], w = d.cache;
          if (w.has(g))
            return w.get(g);
          var b = t.apply(this, m);
          return d.cache = w.set(g, b) || w, b;
        };
        return d.cache = new (ja.Cache || hi)(), d;
      }
      ja.Cache = hi;
      function Va(t) {
        if (typeof t != "function")
          throw new kn(l);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, s[0]);
            case 2:
              return !t.call(this, s[0], s[1]);
            case 3:
              return !t.call(this, s[0], s[1], s[2]);
          }
          return !t.apply(this, s);
        };
      }
      function yu(t) {
        return j5(2, t);
      }
      var vu = t8(function(t, s) {
        s = s.length == 1 && Me(s[0]) ? c1(s[0], rn(ge())) : c1(I1(s, 1), rn(ge()));
        var d = s.length;
        return Se(function(m) {
          for (var g = -1, w = j1(m.length, d); ++g < w; )
            m[g] = s[g].call(this, m[g]);
          return on(t, this, m);
        });
      }), Rs = Se(function(t, s) {
        var d = Yi(s, Ut(Rs));
        return pi(t, K, n, s, d);
      }), R5 = Se(function(t, s) {
        var d = Yi(s, Ut(R5));
        return pi(t, H, n, s, d);
      }), gu = yi(function(t, s) {
        return pi(t, ae, n, n, n, s);
      });
      function _u(t, s) {
        if (typeof t != "function")
          throw new kn(l);
        return s = s === n ? s : De(s), Se(t, s);
      }
      function wu(t, s) {
        if (typeof t != "function")
          throw new kn(l);
        return s = s == null ? 0 : C1(De(s), 0), Se(function(d) {
          var m = d[s], g = Gi(d, 0, s);
          return m && Ri(g, m), on(t, this, g);
        });
      }
      function Cu(t, s, d) {
        var m = !0, g = !0;
        if (typeof t != "function")
          throw new kn(l);
        return h1(d) && (m = "leading" in d ? !!d.leading : m, g = "trailing" in d ? !!d.trailing : g), U5(t, s, {
          leading: m,
          maxWait: s,
          trailing: g
        });
      }
      function ku(t) {
        return H5(t, 1);
      }
      function xu(t, s) {
        return Rs(As(s), t);
      }
      function bu() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return Me(t) ? t : [t];
      }
      function Mu(t) {
        return bn(t, M);
      }
      function Du(t, s) {
        return s = typeof s == "function" ? s : n, bn(t, M, s);
      }
      function Au(t) {
        return bn(t, x | M);
      }
      function Lu(t, s) {
        return s = typeof s == "function" ? s : n, bn(t, x | M, s);
      }
      function Tu(t, s) {
        return s == null || Sr(t, s, D1(s));
      }
      function Hn(t, s) {
        return t === s || t !== t && s !== s;
      }
      var Su = Na(ps), Nu = Na(function(t, s) {
        return t >= s;
      }), gt = Or(function() {
        return arguments;
      }()) ? Or : function(t) {
        return m1(t) && e1.call(t, "callee") && !kr.call(t, "callee");
      }, Me = O.isArray, Eu = tr ? rn(tr) : F9;
      function K1(t) {
        return t != null && Fa(t.length) && !gi(t);
      }
      function y1(t) {
        return m1(t) && K1(t);
      }
      function zu(t) {
        return t === !0 || t === !1 || m1(t) && U1(t) == Xn;
      }
      var Xi = Q7 || e3, Iu = ar ? rn(ar) : P9;
      function Bu(t) {
        return m1(t) && t.nodeType === 1 && !N2(t);
      }
      function Ou(t) {
        if (t == null)
          return !0;
        if (K1(t) && (Me(t) || typeof t == "string" || typeof t.splice == "function" || Xi(t) || Rt(t) || gt(t)))
          return !t.length;
        var s = V1(t);
        if (s == ie || s == L)
          return !t.size;
        if (T2(t))
          return !gs(t).length;
        for (var d in t)
          if (e1.call(t, d))
            return !1;
        return !0;
      }
      function Hu(t, s) {
        return D2(t, s);
      }
      function ju(t, s, d) {
        d = typeof d == "function" ? d : n;
        var m = d ? d(t, s) : n;
        return m === n ? D2(t, s, n, d) : !!m;
      }
      function Ys(t) {
        if (!m1(t))
          return !1;
        var s = U1(t);
        return s == Jn || s == ji || typeof t.message == "string" && typeof t.name == "string" && !N2(t);
      }
      function Vu(t) {
        return typeof t == "number" && br(t);
      }
      function gi(t) {
        if (!h1(t))
          return !1;
        var s = U1(t);
        return s == Kn || s == Vi || s == lt || s == p2;
      }
      function Y5(t) {
        return typeof t == "number" && t == De(t);
      }
      function Fa(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= G1;
      }
      function h1(t) {
        var s = typeof t;
        return t != null && (s == "object" || s == "function");
      }
      function m1(t) {
        return t != null && typeof t == "object";
      }
      var Z5 = sr ? rn(sr) : R9;
      function Fu(t, s) {
        return t === s || vs(t, s, Is(s));
      }
      function Pu(t, s, d) {
        return d = typeof d == "function" ? d : n, vs(t, s, Is(s), d);
      }
      function Uu(t) {
        return W5(t) && t != +t;
      }
      function Ru(t) {
        if (D8(t))
          throw new be(o);
        return Hr(t);
      }
      function Yu(t) {
        return t === null;
      }
      function Zu(t) {
        return t == null;
      }
      function W5(t) {
        return typeof t == "number" || m1(t) && U1(t) == Ie;
      }
      function N2(t) {
        if (!m1(t) || U1(t) != E1)
          return !1;
        var s = ha(t);
        if (s === null)
          return !0;
        var d = e1.call(s, "constructor") && s.constructor;
        return typeof d == "function" && d instanceof d && da.call(d) == P7;
      }
      var Zs = or ? rn(or) : Y9;
      function Wu(t) {
        return Y5(t) && t >= -G1 && t <= G1;
      }
      var Q5 = rr ? rn(rr) : Z9;
      function Pa(t) {
        return typeof t == "string" || !Me(t) && m1(t) && U1(t) == X;
      }
      function dn(t) {
        return typeof t == "symbol" || m1(t) && U1(t) == ve;
      }
      var Rt = lr ? rn(lr) : W9;
      function Qu(t) {
        return t === n;
      }
      function qu(t) {
        return m1(t) && V1(t) == Ue;
      }
      function Gu(t) {
        return m1(t) && U1(t) == Xe;
      }
      var Xu = Na(_s), Ju = Na(function(t, s) {
        return t <= s;
      });
      function q5(t) {
        if (!t)
          return [];
        if (K1(t))
          return Pa(t) ? Bn(t) : J1(t);
        if (g2 && t[g2])
          return T7(t[g2]());
        var s = V1(t), d = s == ie ? os : s == L ? oa : Yt;
        return d(t);
      }
      function _i(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = An(t), t === sn || t === -sn) {
          var s = t < 0 ? -1 : 1;
          return s * rt;
        }
        return t === t ? t : 0;
      }
      function De(t) {
        var s = _i(t), d = s % 1;
        return s === s ? d ? s - d : s : 0;
      }
      function G5(t) {
        return t ? mt(De(t), 0, H1) : 0;
      }
      function An(t) {
        if (typeof t == "number")
          return t;
        if (dn(t))
          return qn;
        if (h1(t)) {
          var s = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = h1(s) ? s + "" : s;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = mr(t);
        var d = Ef.test(t);
        return d || If.test(t) ? u7(t.slice(2), d ? 2 : 8) : Nf.test(t) ? qn : +t;
      }
      function X5(t) {
        return ni(t, $1(t));
      }
      function Ku(t) {
        return t ? mt(De(t), -G1, G1) : t === 0 ? t : 0;
      }
      function $e(t) {
        return t == null ? "" : ln(t);
      }
      var $u = Ft(function(t, s) {
        if (T2(s) || K1(s)) {
          ni(s, D1(s), t);
          return;
        }
        for (var d in s)
          e1.call(s, d) && x2(t, d, s[d]);
      }), J5 = Ft(function(t, s) {
        ni(s, $1(s), t);
      }), Ua = Ft(function(t, s, d, m) {
        ni(s, $1(s), t, m);
      }), eh = Ft(function(t, s, d, m) {
        ni(s, D1(s), t, m);
      }), nh = yi(us);
      function ih(t, s) {
        var d = Vt(t);
        return s == null ? d : Tr(d, s);
      }
      var th = Se(function(t, s) {
        t = t1(t);
        var d = -1, m = s.length, g = m > 2 ? s[2] : n;
        for (g && R1(s[0], s[1], g) && (m = 1); ++d < m; )
          for (var w = s[d], b = $1(w), A = -1, E = b.length; ++A < E; ) {
            var W = b[A], Q = t[W];
            (Q === n || Hn(Q, Ot[W]) && !e1.call(t, W)) && (t[W] = w[W]);
          }
        return t;
      }), ah = Se(function(t) {
        return t.push(n, m5), on(K5, n, t);
      });
      function sh(t, s) {
        return cr(t, ge(s, 3), ei);
      }
      function oh(t, s) {
        return cr(t, ge(s, 3), ms);
      }
      function rh(t, s) {
        return t == null ? t : hs(t, ge(s, 3), $1);
      }
      function lh(t, s) {
        return t == null ? t : Ir(t, ge(s, 3), $1);
      }
      function dh(t, s) {
        return t && ei(t, ge(s, 3));
      }
      function ch(t, s) {
        return t && ms(t, ge(s, 3));
      }
      function fh(t) {
        return t == null ? [] : xa(t, D1(t));
      }
      function uh(t) {
        return t == null ? [] : xa(t, $1(t));
      }
      function Ws(t, s, d) {
        var m = t == null ? n : pt(t, s);
        return m === n ? d : m;
      }
      function hh(t, s) {
        return t != null && v5(t, s, O9);
      }
      function Qs(t, s) {
        return t != null && v5(t, s, H9);
      }
      var mh = d5(function(t, s, d) {
        s != null && typeof s.toString != "function" && (s = ca.call(s)), t[s] = d;
      }, Gs(en)), ph = d5(function(t, s, d) {
        s != null && typeof s.toString != "function" && (s = ca.call(s)), e1.call(t, s) ? t[s].push(d) : t[s] = [d];
      }, ge), yh = Se(M2);
      function D1(t) {
        return K1(t) ? Ar(t) : gs(t);
      }
      function $1(t) {
        return K1(t) ? Ar(t, !0) : Q9(t);
      }
      function vh(t, s) {
        var d = {};
        return s = ge(s, 3), ei(t, function(m, g, w) {
          mi(d, s(m, g, w), m);
        }), d;
      }
      function gh(t, s) {
        var d = {};
        return s = ge(s, 3), ei(t, function(m, g, w) {
          mi(d, g, s(m, g, w));
        }), d;
      }
      var _h = Ft(function(t, s, d) {
        ba(t, s, d);
      }), K5 = Ft(function(t, s, d, m) {
        ba(t, s, d, m);
      }), wh = yi(function(t, s) {
        var d = {};
        if (t == null)
          return d;
        var m = !1;
        s = c1(s, function(w) {
          return w = qi(w, t), m || (m = w.length > 1), w;
        }), ni(t, Es(t), d), m && (d = bn(d, x | C | M, m8));
        for (var g = s.length; g--; )
          bs(d, s[g]);
        return d;
      });
      function Ch(t, s) {
        return $5(t, Va(ge(s)));
      }
      var kh = yi(function(t, s) {
        return t == null ? {} : G9(t, s);
      });
      function $5(t, s) {
        if (t == null)
          return {};
        var d = c1(Es(t), function(m) {
          return [m];
        });
        return s = ge(s), Yr(t, d, function(m, g) {
          return s(m, g[0]);
        });
      }
      function xh(t, s, d) {
        s = qi(s, t);
        var m = -1, g = s.length;
        for (g || (g = 1, t = n); ++m < g; ) {
          var w = t == null ? n : t[ii(s[m])];
          w === n && (m = g, w = d), t = gi(w) ? w.call(t) : w;
        }
        return t;
      }
      function bh(t, s, d) {
        return t == null ? t : A2(t, s, d);
      }
      function Mh(t, s, d, m) {
        return m = typeof m == "function" ? m : n, t == null ? t : A2(t, s, d, m);
      }
      var e4 = u5(D1), n4 = u5($1);
      function Dh(t, s, d) {
        var m = Me(t), g = m || Xi(t) || Rt(t);
        if (s = ge(s, 4), d == null) {
          var w = t && t.constructor;
          g ? d = m ? new w() : [] : h1(t) ? d = gi(w) ? Vt(ha(t)) : {} : d = {};
        }
        return (g ? Cn : ei)(t, function(b, A, E) {
          return s(d, b, A, E);
        }), d;
      }
      function Ah(t, s) {
        return t == null ? !0 : bs(t, s);
      }
      function Lh(t, s, d) {
        return t == null ? t : Gr(t, s, As(d));
      }
      function Th(t, s, d, m) {
        return m = typeof m == "function" ? m : n, t == null ? t : Gr(t, s, As(d), m);
      }
      function Yt(t) {
        return t == null ? [] : ss(t, D1(t));
      }
      function Sh(t) {
        return t == null ? [] : ss(t, $1(t));
      }
      function Nh(t, s, d) {
        return d === n && (d = s, s = n), d !== n && (d = An(d), d = d === d ? d : 0), s !== n && (s = An(s), s = s === s ? s : 0), mt(An(t), s, d);
      }
      function Eh(t, s, d) {
        return s = _i(s), d === n ? (d = s, s = 0) : d = _i(d), t = An(t), j9(t, s, d);
      }
      function zh(t, s, d) {
        if (d && typeof d != "boolean" && R1(t, s, d) && (s = d = n), d === n && (typeof s == "boolean" ? (d = s, s = n) : typeof t == "boolean" && (d = t, t = n)), t === n && s === n ? (t = 0, s = 1) : (t = _i(t), s === n ? (s = t, t = 0) : s = _i(s)), t > s) {
          var m = t;
          t = s, s = m;
        }
        if (d || t % 1 || s % 1) {
          var g = Mr();
          return j1(t + g * (s - t + f7("1e-" + ((g + "").length - 1))), s);
        }
        return Cs(t, s);
      }
      var Ih = Pt(function(t, s, d) {
        return s = s.toLowerCase(), t + (d ? i4(s) : s);
      });
      function i4(t) {
        return qs($e(t).toLowerCase());
      }
      function t4(t) {
        return t = $e(t), t && t.replace(Of, b7).replace(n7, "");
      }
      function Bh(t, s, d) {
        t = $e(t), s = ln(s);
        var m = t.length;
        d = d === n ? m : mt(De(d), 0, m);
        var g = d;
        return d -= s.length, d >= 0 && t.slice(d, g) == s;
      }
      function Oh(t) {
        return t = $e(t), t && yf.test(t) ? t.replace(Io, M7) : t;
      }
      function Hh(t) {
        return t = $e(t), t && kf.test(t) ? t.replace(R0, "\\$&") : t;
      }
      var jh = Pt(function(t, s, d) {
        return t + (d ? "-" : "") + s.toLowerCase();
      }), Vh = Pt(function(t, s, d) {
        return t + (d ? " " : "") + s.toLowerCase();
      }), Fh = o5("toLowerCase");
      function Ph(t, s, d) {
        t = $e(t), s = De(s);
        var m = s ? It(t) : 0;
        if (!s || m >= s)
          return t;
        var g = (s - m) / 2;
        return Sa(va(g), d) + t + Sa(ya(g), d);
      }
      function Uh(t, s, d) {
        t = $e(t), s = De(s);
        var m = s ? It(t) : 0;
        return s && m < s ? t + Sa(s - m, d) : t;
      }
      function Rh(t, s, d) {
        t = $e(t), s = De(s);
        var m = s ? It(t) : 0;
        return s && m < s ? Sa(s - m, d) + t : t;
      }
      function Yh(t, s, d) {
        return d || s == null ? s = 0 : s && (s = +s), J7($e(t).replace(Y0, ""), s || 0);
      }
      function Zh(t, s, d) {
        return (d ? R1(t, s, d) : s === n) ? s = 1 : s = De(s), ks($e(t), s);
      }
      function Wh() {
        var t = arguments, s = $e(t[0]);
        return t.length < 3 ? s : s.replace(t[1], t[2]);
      }
      var Qh = Pt(function(t, s, d) {
        return t + (d ? "_" : "") + s.toLowerCase();
      });
      function qh(t, s, d) {
        return d && typeof d != "number" && R1(t, s, d) && (s = d = n), d = d === n ? H1 : d >>> 0, d ? (t = $e(t), t && (typeof s == "string" || s != null && !Zs(s)) && (s = ln(s), !s && zt(t)) ? Gi(Bn(t), 0, d) : t.split(s, d)) : [];
      }
      var Gh = Pt(function(t, s, d) {
        return t + (d ? " " : "") + qs(s);
      });
      function Xh(t, s, d) {
        return t = $e(t), d = d == null ? 0 : mt(De(d), 0, t.length), s = ln(s), t.slice(d, d + s.length) == s;
      }
      function Jh(t, s, d) {
        var m = _.templateSettings;
        d && R1(t, s, d) && (s = n), t = $e(t), s = Ua({}, s, m, h5);
        var g = Ua({}, s.imports, m.imports, h5), w = D1(g), b = ss(g, w), A, E, W = 0, Q = s.interpolate || na, J = "__p += '", de = rs(
          (s.escape || na).source + "|" + Q.source + "|" + (Q === Bo ? Sf : na).source + "|" + (s.evaluate || na).source + "|$",
          "g"
        ), he = "//# sourceURL=" + (e1.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++o7 + "]") + `
`;
        t.replace(de, function(Ce, Be, Fe, cn, Y1, fn) {
          return Fe || (Fe = cn), J += t.slice(W, fn).replace(Hf, D7), Be && (A = !0, J += `' +
__e(` + Be + `) +
'`), Y1 && (E = !0, J += `';
` + Y1 + `;
__p += '`), Fe && (J += `' +
((__t = (` + Fe + `)) == null ? '' : __t) +
'`), W = fn + Ce.length, Ce;
        }), J += `';
`;
        var we = e1.call(s, "variable") && s.variable;
        if (!we)
          J = `with (obj) {
` + J + `
}
`;
        else if (Lf.test(we))
          throw new be(c);
        J = (E ? J.replace(uf, "") : J).replace(hf, "$1").replace(mf, "$1;"), J = "function(" + (we || "obj") + `) {
` + (we ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (A ? ", __e = _.escape" : "") + (E ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + J + `return __p
}`;
        var Le = s4(function() {
          return Je(w, he + "return " + J).apply(n, b);
        });
        if (Le.source = J, Ys(Le))
          throw Le;
        return Le;
      }
      function Kh(t) {
        return $e(t).toLowerCase();
      }
      function $h(t) {
        return $e(t).toUpperCase();
      }
      function em(t, s, d) {
        if (t = $e(t), t && (d || s === n))
          return mr(t);
        if (!t || !(s = ln(s)))
          return t;
        var m = Bn(t), g = Bn(s), w = pr(m, g), b = yr(m, g) + 1;
        return Gi(m, w, b).join("");
      }
      function nm(t, s, d) {
        if (t = $e(t), t && (d || s === n))
          return t.slice(0, gr(t) + 1);
        if (!t || !(s = ln(s)))
          return t;
        var m = Bn(t), g = yr(m, Bn(s)) + 1;
        return Gi(m, 0, g).join("");
      }
      function im(t, s, d) {
        if (t = $e(t), t && (d || s === n))
          return t.replace(Y0, "");
        if (!t || !(s = ln(s)))
          return t;
        var m = Bn(t), g = pr(m, Bn(s));
        return Gi(m, g).join("");
      }
      function tm(t, s) {
        var d = Pe, m = N1;
        if (h1(s)) {
          var g = "separator" in s ? s.separator : g;
          d = "length" in s ? De(s.length) : d, m = "omission" in s ? ln(s.omission) : m;
        }
        t = $e(t);
        var w = t.length;
        if (zt(t)) {
          var b = Bn(t);
          w = b.length;
        }
        if (d >= w)
          return t;
        var A = d - It(m);
        if (A < 1)
          return m;
        var E = b ? Gi(b, 0, A).join("") : t.slice(0, A);
        if (g === n)
          return E + m;
        if (b && (A += E.length - A), Zs(g)) {
          if (t.slice(A).search(g)) {
            var W, Q = E;
            for (g.global || (g = rs(g.source, $e(Oo.exec(g)) + "g")), g.lastIndex = 0; W = g.exec(Q); )
              var J = W.index;
            E = E.slice(0, J === n ? A : J);
          }
        } else if (t.indexOf(ln(g), A) != A) {
          var de = E.lastIndexOf(g);
          de > -1 && (E = E.slice(0, de));
        }
        return E + m;
      }
      function am(t) {
        return t = $e(t), t && pf.test(t) ? t.replace(zo, z7) : t;
      }
      var sm = Pt(function(t, s, d) {
        return t + (d ? " " : "") + s.toUpperCase();
      }), qs = o5("toUpperCase");
      function a4(t, s, d) {
        return t = $e(t), s = d ? n : s, s === n ? L7(t) ? O7(t) : _7(t) : t.match(s) || [];
      }
      var s4 = Se(function(t, s) {
        try {
          return on(t, n, s);
        } catch (d) {
          return Ys(d) ? d : new be(d);
        }
      }), om = yi(function(t, s) {
        return Cn(s, function(d) {
          d = ii(d), mi(t, d, Us(t[d], t));
        }), t;
      });
      function rm(t) {
        var s = t == null ? 0 : t.length, d = ge();
        return t = s ? c1(t, function(m) {
          if (typeof m[1] != "function")
            throw new kn(l);
          return [d(m[0]), m[1]];
        }) : [], Se(function(m) {
          for (var g = -1; ++g < s; ) {
            var w = t[g];
            if (on(w[0], this, m))
              return on(w[1], this, m);
          }
        });
      }
      function lm(t) {
        return z9(bn(t, x));
      }
      function Gs(t) {
        return function() {
          return t;
        };
      }
      function dm(t, s) {
        return t == null || t !== t ? s : t;
      }
      var cm = l5(), fm = l5(!0);
      function en(t) {
        return t;
      }
      function Xs(t) {
        return jr(typeof t == "function" ? t : bn(t, x));
      }
      function um(t) {
        return Fr(bn(t, x));
      }
      function hm(t, s) {
        return Pr(t, bn(s, x));
      }
      var mm = Se(function(t, s) {
        return function(d) {
          return M2(d, t, s);
        };
      }), pm = Se(function(t, s) {
        return function(d) {
          return M2(t, d, s);
        };
      });
      function Js(t, s, d) {
        var m = D1(s), g = xa(s, m);
        d == null && !(h1(s) && (g.length || !m.length)) && (d = s, s = t, t = this, g = xa(s, D1(s)));
        var w = !(h1(d) && "chain" in d) || !!d.chain, b = gi(t);
        return Cn(g, function(A) {
          var E = s[A];
          t[A] = E, b && (t.prototype[A] = function() {
            var W = this.__chain__;
            if (w || W) {
              var Q = t(this.__wrapped__), J = Q.__actions__ = J1(this.__actions__);
              return J.push({ func: E, args: arguments, thisArg: t }), Q.__chain__ = W, Q;
            }
            return E.apply(t, Ri([this.value()], arguments));
          });
        }), t;
      }
      function ym() {
        return z1._ === this && (z1._ = U7), this;
      }
      function Ks() {
      }
      function vm(t) {
        return t = De(t), Se(function(s) {
          return Ur(s, t);
        });
      }
      var gm = Ts(c1), _m = Ts(dr), wm = Ts(es);
      function o4(t) {
        return Os(t) ? ns(ii(t)) : X9(t);
      }
      function Cm(t) {
        return function(s) {
          return t == null ? n : pt(t, s);
        };
      }
      var km = c5(), xm = c5(!0);
      function $s() {
        return [];
      }
      function e3() {
        return !1;
      }
      function bm() {
        return {};
      }
      function Mm() {
        return "";
      }
      function Dm() {
        return !0;
      }
      function Am(t, s) {
        if (t = De(t), t < 1 || t > G1)
          return [];
        var d = H1, m = j1(t, H1);
        s = ge(s), t -= H1;
        for (var g = as(m, s); ++d < t; )
          s(d);
        return g;
      }
      function Lm(t) {
        return Me(t) ? c1(t, ii) : dn(t) ? [t] : J1(D5($e(t)));
      }
      function Tm(t) {
        var s = ++F7;
        return $e(t) + s;
      }
      var Sm = Ta(function(t, s) {
        return t + s;
      }, 0), Nm = Ss("ceil"), Em = Ta(function(t, s) {
        return t / s;
      }, 1), zm = Ss("floor");
      function Im(t) {
        return t && t.length ? ka(t, en, ps) : n;
      }
      function Bm(t, s) {
        return t && t.length ? ka(t, ge(s, 2), ps) : n;
      }
      function Om(t) {
        return ur(t, en);
      }
      function Hm(t, s) {
        return ur(t, ge(s, 2));
      }
      function jm(t) {
        return t && t.length ? ka(t, en, _s) : n;
      }
      function Vm(t, s) {
        return t && t.length ? ka(t, ge(s, 2), _s) : n;
      }
      var Fm = Ta(function(t, s) {
        return t * s;
      }, 1), Pm = Ss("round"), Um = Ta(function(t, s) {
        return t - s;
      }, 0);
      function Rm(t) {
        return t && t.length ? ts(t, en) : 0;
      }
      function Ym(t, s) {
        return t && t.length ? ts(t, ge(s, 2)) : 0;
      }
      return _.after = uu, _.ary = H5, _.assign = $u, _.assignIn = J5, _.assignInWith = Ua, _.assignWith = eh, _.at = nh, _.before = j5, _.bind = Us, _.bindAll = om, _.bindKey = V5, _.castArray = bu, _.chain = I5, _.chunk = z8, _.compact = I8, _.concat = B8, _.cond = rm, _.conforms = lm, _.constant = Gs, _.countBy = R6, _.create = ih, _.curry = F5, _.curryRight = P5, _.debounce = U5, _.defaults = th, _.defaultsDeep = ah, _.defer = hu, _.delay = mu, _.difference = O8, _.differenceBy = H8, _.differenceWith = j8, _.drop = V8, _.dropRight = F8, _.dropRightWhile = P8, _.dropWhile = U8, _.fill = R8, _.filter = Z6, _.flatMap = q6, _.flatMapDeep = G6, _.flatMapDepth = X6, _.flatten = S5, _.flattenDeep = Y8, _.flattenDepth = Z8, _.flip = pu, _.flow = cm, _.flowRight = fm, _.fromPairs = W8, _.functions = fh, _.functionsIn = uh, _.groupBy = J6, _.initial = q8, _.intersection = G8, _.intersectionBy = X8, _.intersectionWith = J8, _.invert = mh, _.invertBy = ph, _.invokeMap = $6, _.iteratee = Xs, _.keyBy = eu, _.keys = D1, _.keysIn = $1, _.map = Oa, _.mapKeys = vh, _.mapValues = gh, _.matches = um, _.matchesProperty = hm, _.memoize = ja, _.merge = _h, _.mergeWith = K5, _.method = mm, _.methodOf = pm, _.mixin = Js, _.negate = Va, _.nthArg = vm, _.omit = wh, _.omitBy = Ch, _.once = yu, _.orderBy = nu, _.over = gm, _.overArgs = vu, _.overEvery = _m, _.overSome = wm, _.partial = Rs, _.partialRight = R5, _.partition = iu, _.pick = kh, _.pickBy = $5, _.property = o4, _.propertyOf = Cm, _.pull = n6, _.pullAll = E5, _.pullAllBy = i6, _.pullAllWith = t6, _.pullAt = a6, _.range = km, _.rangeRight = xm, _.rearg = gu, _.reject = su, _.remove = s6, _.rest = _u, _.reverse = Fs, _.sampleSize = ru, _.set = bh, _.setWith = Mh, _.shuffle = lu, _.slice = o6, _.sortBy = fu, _.sortedUniq = h6, _.sortedUniqBy = m6, _.split = qh, _.spread = wu, _.tail = p6, _.take = y6, _.takeRight = v6, _.takeRightWhile = g6, _.takeWhile = _6, _.tap = I6, _.throttle = Cu, _.thru = Ba, _.toArray = q5, _.toPairs = e4, _.toPairsIn = n4, _.toPath = Lm, _.toPlainObject = X5, _.transform = Dh, _.unary = ku, _.union = w6, _.unionBy = C6, _.unionWith = k6, _.uniq = x6, _.uniqBy = b6, _.uniqWith = M6, _.unset = Ah, _.unzip = Ps, _.unzipWith = z5, _.update = Lh, _.updateWith = Th, _.values = Yt, _.valuesIn = Sh, _.without = D6, _.words = a4, _.wrap = xu, _.xor = A6, _.xorBy = L6, _.xorWith = T6, _.zip = S6, _.zipObject = N6, _.zipObjectDeep = E6, _.zipWith = z6, _.entries = e4, _.entriesIn = n4, _.extend = J5, _.extendWith = Ua, Js(_, _), _.add = Sm, _.attempt = s4, _.camelCase = Ih, _.capitalize = i4, _.ceil = Nm, _.clamp = Nh, _.clone = Mu, _.cloneDeep = Au, _.cloneDeepWith = Lu, _.cloneWith = Du, _.conformsTo = Tu, _.deburr = t4, _.defaultTo = dm, _.divide = Em, _.endsWith = Bh, _.eq = Hn, _.escape = Oh, _.escapeRegExp = Hh, _.every = Y6, _.find = W6, _.findIndex = L5, _.findKey = sh, _.findLast = Q6, _.findLastIndex = T5, _.findLastKey = oh, _.floor = zm, _.forEach = B5, _.forEachRight = O5, _.forIn = rh, _.forInRight = lh, _.forOwn = dh, _.forOwnRight = ch, _.get = Ws, _.gt = Su, _.gte = Nu, _.has = hh, _.hasIn = Qs, _.head = N5, _.identity = en, _.includes = K6, _.indexOf = Q8, _.inRange = Eh, _.invoke = yh, _.isArguments = gt, _.isArray = Me, _.isArrayBuffer = Eu, _.isArrayLike = K1, _.isArrayLikeObject = y1, _.isBoolean = zu, _.isBuffer = Xi, _.isDate = Iu, _.isElement = Bu, _.isEmpty = Ou, _.isEqual = Hu, _.isEqualWith = ju, _.isError = Ys, _.isFinite = Vu, _.isFunction = gi, _.isInteger = Y5, _.isLength = Fa, _.isMap = Z5, _.isMatch = Fu, _.isMatchWith = Pu, _.isNaN = Uu, _.isNative = Ru, _.isNil = Zu, _.isNull = Yu, _.isNumber = W5, _.isObject = h1, _.isObjectLike = m1, _.isPlainObject = N2, _.isRegExp = Zs, _.isSafeInteger = Wu, _.isSet = Q5, _.isString = Pa, _.isSymbol = dn, _.isTypedArray = Rt, _.isUndefined = Qu, _.isWeakMap = qu, _.isWeakSet = Gu, _.join = K8, _.kebabCase = jh, _.last = Dn, _.lastIndexOf = $8, _.lowerCase = Vh, _.lowerFirst = Fh, _.lt = Xu, _.lte = Ju, _.max = Im, _.maxBy = Bm, _.mean = Om, _.meanBy = Hm, _.min = jm, _.minBy = Vm, _.stubArray = $s, _.stubFalse = e3, _.stubObject = bm, _.stubString = Mm, _.stubTrue = Dm, _.multiply = Fm, _.nth = e6, _.noConflict = ym, _.noop = Ks, _.now = Ha, _.pad = Ph, _.padEnd = Uh, _.padStart = Rh, _.parseInt = Yh, _.random = zh, _.reduce = tu, _.reduceRight = au, _.repeat = Zh, _.replace = Wh, _.result = xh, _.round = Pm, _.runInContext = S, _.sample = ou, _.size = du, _.snakeCase = Qh, _.some = cu, _.sortedIndex = r6, _.sortedIndexBy = l6, _.sortedIndexOf = d6, _.sortedLastIndex = c6, _.sortedLastIndexBy = f6, _.sortedLastIndexOf = u6, _.startCase = Gh, _.startsWith = Xh, _.subtract = Um, _.sum = Rm, _.sumBy = Ym, _.template = Jh, _.times = Am, _.toFinite = _i, _.toInteger = De, _.toLength = G5, _.toLower = Kh, _.toNumber = An, _.toSafeInteger = Ku, _.toString = $e, _.toUpper = $h, _.trim = em, _.trimEnd = nm, _.trimStart = im, _.truncate = tm, _.unescape = am, _.uniqueId = Tm, _.upperCase = sm, _.upperFirst = qs, _.each = B5, _.eachRight = O5, _.first = N5, Js(_, function() {
        var t = {};
        return ei(_, function(s, d) {
          e1.call(_.prototype, d) || (t[d] = s);
        }), t;
      }(), { chain: !1 }), _.VERSION = a, Cn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        _[t].placeholder = _;
      }), Cn(["drop", "take"], function(t, s) {
        He.prototype[t] = function(d) {
          d = d === n ? 1 : C1(De(d), 0);
          var m = this.__filtered__ && !s ? new He(this) : this.clone();
          return m.__filtered__ ? m.__takeCount__ = j1(d, m.__takeCount__) : m.__views__.push({
            size: j1(d, H1),
            type: t + (m.__dir__ < 0 ? "Right" : "")
          }), m;
        }, He.prototype[t + "Right"] = function(d) {
          return this.reverse()[t](d).reverse();
        };
      }), Cn(["filter", "map", "takeWhile"], function(t, s) {
        var d = s + 1, m = d == Qn || d == vn;
        He.prototype[t] = function(g) {
          var w = this.clone();
          return w.__iteratees__.push({
            iteratee: ge(g, 3),
            type: d
          }), w.__filtered__ = w.__filtered__ || m, w;
        };
      }), Cn(["head", "last"], function(t, s) {
        var d = "take" + (s ? "Right" : "");
        He.prototype[t] = function() {
          return this[d](1).value()[0];
        };
      }), Cn(["initial", "tail"], function(t, s) {
        var d = "drop" + (s ? "" : "Right");
        He.prototype[t] = function() {
          return this.__filtered__ ? new He(this) : this[d](1);
        };
      }), He.prototype.compact = function() {
        return this.filter(en);
      }, He.prototype.find = function(t) {
        return this.filter(t).head();
      }, He.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, He.prototype.invokeMap = Se(function(t, s) {
        return typeof t == "function" ? new He(this) : this.map(function(d) {
          return M2(d, t, s);
        });
      }), He.prototype.reject = function(t) {
        return this.filter(Va(ge(t)));
      }, He.prototype.slice = function(t, s) {
        t = De(t);
        var d = this;
        return d.__filtered__ && (t > 0 || s < 0) ? new He(d) : (t < 0 ? d = d.takeRight(-t) : t && (d = d.drop(t)), s !== n && (s = De(s), d = s < 0 ? d.dropRight(-s) : d.take(s - t)), d);
      }, He.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, He.prototype.toArray = function() {
        return this.take(H1);
      }, ei(He.prototype, function(t, s) {
        var d = /^(?:filter|find|map|reject)|While$/.test(s), m = /^(?:head|last)$/.test(s), g = _[m ? "take" + (s == "last" ? "Right" : "") : s], w = m || /^find/.test(s);
        g && (_.prototype[s] = function() {
          var b = this.__wrapped__, A = m ? [1] : arguments, E = b instanceof He, W = A[0], Q = E || Me(b), J = function(Be) {
            var Fe = g.apply(_, Ri([Be], A));
            return m && de ? Fe[0] : Fe;
          };
          Q && d && typeof W == "function" && W.length != 1 && (E = Q = !1);
          var de = this.__chain__, he = !!this.__actions__.length, we = w && !de, Le = E && !he;
          if (!w && Q) {
            b = Le ? b : new He(this);
            var Ce = t.apply(b, A);
            return Ce.__actions__.push({ func: Ba, args: [J], thisArg: n }), new xn(Ce, de);
          }
          return we && Le ? t.apply(this, A) : (Ce = this.thru(J), we ? m ? Ce.value()[0] : Ce.value() : Ce);
        });
      }), Cn(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var s = ra[t], d = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", m = /^(?:pop|shift)$/.test(t);
        _.prototype[t] = function() {
          var g = arguments;
          if (m && !this.__chain__) {
            var w = this.value();
            return s.apply(Me(w) ? w : [], g);
          }
          return this[d](function(b) {
            return s.apply(Me(b) ? b : [], g);
          });
        };
      }), ei(He.prototype, function(t, s) {
        var d = _[s];
        if (d) {
          var m = d.name + "";
          e1.call(jt, m) || (jt[m] = []), jt[m].push({ name: s, func: d });
        }
      }), jt[La(n, G).name] = [{
        name: "wrapper",
        func: n
      }], He.prototype.clone = a9, He.prototype.reverse = s9, He.prototype.value = o9, _.prototype.at = B6, _.prototype.chain = O6, _.prototype.commit = H6, _.prototype.next = j6, _.prototype.plant = F6, _.prototype.reverse = P6, _.prototype.toJSON = _.prototype.valueOf = _.prototype.value = U6, _.prototype.first = _.prototype.head, g2 && (_.prototype[g2] = V6), _;
    }, Bt = H7();
    ct ? ((ct.exports = Bt)._ = Bt, X0._ = Bt) : z1._ = Bt;
  }).call(qt);
})(l0, l0.exports);
var Wt = l0.exports;
/*!
  * shared v9.12.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Yn = typeof window < "u";
let un, Dt;
if (process.env.NODE_ENV !== "production") {
  const e = Yn && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (un = (i) => {
    e.mark(i);
  }, Dt = (i, n, a) => {
    e.measure(i, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const AP = /\{([0-9a-zA-Z]+)\}/g;
function po(e, ...i) {
  return i.length === 1 && We(i[0]) && (i = i[0]), (!i || !i.hasOwnProperty) && (i = {}), e.replace(AP, (n, a) => i.hasOwnProperty(a) ? i[a] : "");
}
const fi = (e, i = !1) => i ? Symbol.for(e) : Symbol(e), LP = (e, i, n) => TP({ l: e, k: i, s: n }), TP = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), k1 = (e) => typeof e == "number" && isFinite(e), SP = (e) => Hd(e) === "[object Date]", tt = (e) => Hd(e) === "[object RegExp]", N0 = (e) => xe(e) && Object.keys(e).length === 0, O1 = Object.assign;
let g4;
const Di = () => g4 || (g4 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function _4(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const NP = Object.prototype.hasOwnProperty;
function d0(e, i) {
  return NP.call(e, i);
}
const s1 = Array.isArray, n1 = (e) => typeof e == "function", le = (e) => typeof e == "string", Ne = (e) => typeof e == "boolean", We = (e) => e !== null && typeof e == "object", EP = (e) => We(e) && n1(e.then) && n1(e.catch), Od = Object.prototype.toString, Hd = (e) => Od.call(e), xe = (e) => {
  if (!We(e))
    return !1;
  const i = Object.getPrototypeOf(e);
  return i === null || i.constructor === Object;
}, zP = (e) => e == null ? "" : s1(e) || xe(e) && e.toString === Od ? JSON.stringify(e, null, 2) : String(e);
function IP(e, i = "") {
  return e.reduce((n, a, r) => r === 0 ? n + a : n + i + a, "");
}
const w4 = 2;
function BP(e, i = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let r = 0;
  const o = [];
  for (let l = 0; l < a.length; l++)
    if (r += a[l].length + 1, r >= i) {
      for (let c = l - w4; c <= l + w4 || n > r; c++) {
        if (c < 0 || c >= a.length)
          continue;
        const h = c + 1;
        o.push(`${h}${" ".repeat(3 - String(h).length)}|  ${a[c]}`);
        const y = a[c].length;
        if (c === l) {
          const v = i - (r - y) + 1, x = Math.max(1, n > r ? y - v : n - i);
          o.push("   |  " + " ".repeat(v) + "^".repeat(x));
        } else if (c > l) {
          if (n > r) {
            const v = Math.max(Math.min(n - r, y), 1);
            o.push("   |  " + "^".repeat(v));
          }
          r += y + 1;
        }
      }
      break;
    }
  return o.join(`
`);
}
function E0(e) {
  let i = e;
  return () => ++i;
}
function x1(e, i) {
  typeof console < "u" && (console.warn("[intlify] " + e), i && console.warn(i.stack));
}
const C4 = {};
function jd(e) {
  C4[e] || (C4[e] = !0, x1(e));
}
function yo() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const r = e.get(n);
      r && r.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const r = e.get(n);
      r && r.splice(r.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((r) => r(a)), (e.get("*") || []).slice().map((r) => r(n, a));
    }
  };
}
const Za = (e) => !We(e) || s1(e);
function $a(e, i) {
  if (Za(e) || Za(i))
    throw new Error("Invalid value");
  const n = [{ src: e, des: i }];
  for (; n.length; ) {
    const { src: a, des: r } = n.pop();
    Object.keys(a).forEach((o) => {
      Za(a[o]) || Za(r[o]) ? r[o] = a[o] : n.push({ src: a[o], des: r[o] });
    });
  }
}
/*!
  * message-compiler v9.12.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function OP(e, i, n) {
  return { line: e, column: i, offset: n };
}
function c0(e, i, n) {
  const a = { start: e, end: i };
  return n != null && (a.source = n), a;
}
const HP = /\{([0-9a-zA-Z]+)\}/g;
function Vd(e, ...i) {
  return i.length === 1 && jP(i[0]) && (i = i[0]), (!i || !i.hasOwnProperty) && (i = {}), e.replace(HP, (n, a) => i.hasOwnProperty(a) ? i[a] : "");
}
const Fd = Object.assign, k4 = (e) => typeof e == "string", jP = (e) => e !== null && typeof e == "object";
function Pd(e, i = "") {
  return e.reduce((n, a, r) => r === 0 ? n + a : n + i + a, "");
}
const z0 = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, VP = {
  [z0.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function FP(e, i, ...n) {
  const a = Vd(VP[e] || "", ...n || []), r = { message: String(a), code: e };
  return i && (r.location = i), r;
}
const ke = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, PP = {
  // tokenizer error messages
  [ke.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ke.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ke.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ke.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ke.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ke.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ke.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ke.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ke.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ke.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ke.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ke.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ke.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ke.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ke.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ke.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function h2(e, i, n = {}) {
  const { domain: a, messages: r, args: o } = n, l = Vd((r || PP)[e] || "", ...o || []), c = new SyntaxError(String(l));
  return c.code = e, i && (c.location = i), c.domain = a, c;
}
function UP(e) {
  throw e;
}
const RP = /<\/?[\w\s="/.':;#-\/]+>/, YP = (e) => RP.test(e), ki = " ", ZP = "\r", Z1 = `
`, WP = String.fromCharCode(8232), QP = String.fromCharCode(8233);
function qP(e) {
  const i = e;
  let n = 0, a = 1, r = 1, o = 0;
  const l = (Y) => i[Y] === ZP && i[Y + 1] === Z1, c = (Y) => i[Y] === Z1, h = (Y) => i[Y] === QP, y = (Y) => i[Y] === WP, v = (Y) => l(Y) || c(Y) || h(Y) || y(Y), x = () => n, C = () => a, M = () => r, z = () => o, R = (Y) => l(Y) || h(Y) || y(Y) ? Z1 : i[Y], U = () => R(n), G = () => R(n + o);
  function re() {
    return o = 0, v(n) && (a++, r = 0), l(n) && n++, n++, r++, i[n];
  }
  function I() {
    return l(n + o) && o++, o++, i[n + o];
  }
  function V() {
    n = 0, a = 1, r = 1, o = 0;
  }
  function K(Y = 0) {
    o = Y;
  }
  function H() {
    const Y = n + o;
    for (; Y !== n; )
      re();
    o = 0;
  }
  return {
    index: x,
    line: C,
    column: M,
    peekOffset: z,
    charAt: R,
    currentChar: U,
    currentPeek: G,
    next: re,
    peek: I,
    reset: V,
    resetPeek: K,
    skipToPeek: H
  };
}
const Ji = void 0, GP = ".", x4 = "'", XP = "tokenizer";
function JP(e, i = {}) {
  const n = i.location !== !1, a = qP(e), r = () => a.index(), o = () => OP(a.line(), a.column(), a.index()), l = o(), c = r(), h = {
    currentType: 14,
    offset: c,
    startLoc: l,
    endLoc: l,
    lastType: 14,
    lastOffset: c,
    lastStartLoc: l,
    lastEndLoc: l,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, y = () => h, { onError: v } = i;
  function x(D, L, X, ...ve) {
    const Te = y();
    if (L.column += X, L.offset += X, v) {
      const Ue = n ? c0(Te.startLoc, L) : null, Xe = h2(D, Ue, {
        domain: XP,
        args: ve
      });
      v(Xe);
    }
  }
  function C(D, L, X) {
    D.endLoc = o(), D.currentType = L;
    const ve = { type: L };
    return n && (ve.loc = c0(D.startLoc, D.endLoc)), X != null && (ve.value = X), ve;
  }
  const M = (D) => C(
    D,
    14
    /* TokenTypes.EOF */
  );
  function z(D, L) {
    return D.currentChar() === L ? (D.next(), L) : (x(ke.EXPECTED_TOKEN, o(), 0, L), "");
  }
  function R(D) {
    let L = "";
    for (; D.currentPeek() === ki || D.currentPeek() === Z1; )
      L += D.currentPeek(), D.peek();
    return L;
  }
  function U(D) {
    const L = R(D);
    return D.skipToPeek(), L;
  }
  function G(D) {
    if (D === Ji)
      return !1;
    const L = D.charCodeAt(0);
    return L >= 97 && L <= 122 || // a-z
    L >= 65 && L <= 90 || // A-Z
    L === 95;
  }
  function re(D) {
    if (D === Ji)
      return !1;
    const L = D.charCodeAt(0);
    return L >= 48 && L <= 57;
  }
  function I(D, L) {
    const { currentType: X } = L;
    if (X !== 2)
      return !1;
    R(D);
    const ve = G(D.currentPeek());
    return D.resetPeek(), ve;
  }
  function V(D, L) {
    const { currentType: X } = L;
    if (X !== 2)
      return !1;
    R(D);
    const ve = D.currentPeek() === "-" ? D.peek() : D.currentPeek(), Te = re(ve);
    return D.resetPeek(), Te;
  }
  function K(D, L) {
    const { currentType: X } = L;
    if (X !== 2)
      return !1;
    R(D);
    const ve = D.currentPeek() === x4;
    return D.resetPeek(), ve;
  }
  function H(D, L) {
    const { currentType: X } = L;
    if (X !== 8)
      return !1;
    R(D);
    const ve = D.currentPeek() === ".";
    return D.resetPeek(), ve;
  }
  function Y(D, L) {
    const { currentType: X } = L;
    if (X !== 9)
      return !1;
    R(D);
    const ve = G(D.currentPeek());
    return D.resetPeek(), ve;
  }
  function ae(D, L) {
    const { currentType: X } = L;
    if (!(X === 8 || X === 12))
      return !1;
    R(D);
    const ve = D.currentPeek() === ":";
    return D.resetPeek(), ve;
  }
  function ee(D, L) {
    const { currentType: X } = L;
    if (X !== 10)
      return !1;
    const ve = () => {
      const Ue = D.currentPeek();
      return Ue === "{" ? G(D.peek()) : Ue === "@" || Ue === "%" || Ue === "|" || Ue === ":" || Ue === "." || Ue === ki || !Ue ? !1 : Ue === Z1 ? (D.peek(), ve()) : G(Ue);
    }, Te = ve();
    return D.resetPeek(), Te;
  }
  function Pe(D) {
    R(D);
    const L = D.currentPeek() === "|";
    return D.resetPeek(), L;
  }
  function N1(D) {
    const L = R(D), X = D.currentPeek() === "%" && D.peek() === "{";
    return D.resetPeek(), {
      isModulo: X,
      hasSpace: L.length > 0
    };
  }
  function ze(D, L = !0) {
    const X = (Te = !1, Ue = "", Xe = !1) => {
      const F = D.currentPeek();
      return F === "{" ? Ue === "%" ? !1 : Te : F === "@" || !F ? Ue === "%" ? !0 : Te : F === "%" ? (D.peek(), X(Te, "%", !0)) : F === "|" ? Ue === "%" || Xe ? !0 : !(Ue === ki || Ue === Z1) : F === ki ? (D.peek(), X(!0, ki, Xe)) : F === Z1 ? (D.peek(), X(!0, Z1, Xe)) : !0;
    }, ve = X();
    return L && D.resetPeek(), ve;
  }
  function _1(D, L) {
    const X = D.currentChar();
    return X === Ji ? Ji : L(X) ? (D.next(), X) : null;
  }
  function Qn(D) {
    const L = D.charCodeAt(0);
    return L >= 97 && L <= 122 || // a-z
    L >= 65 && L <= 90 || // A-Z
    L >= 48 && L <= 57 || // 0-9
    L === 95 || // _
    L === 36;
  }
  function ot(D) {
    return _1(D, Qn);
  }
  function vn(D) {
    const L = D.charCodeAt(0);
    return L >= 97 && L <= 122 || // a-z
    L >= 65 && L <= 90 || // A-Z
    L >= 48 && L <= 57 || // 0-9
    L === 95 || // _
    L === 36 || // $
    L === 45;
  }
  function sn(D) {
    return _1(D, vn);
  }
  function G1(D) {
    const L = D.charCodeAt(0);
    return L >= 48 && L <= 57;
  }
  function rt(D) {
    return _1(D, G1);
  }
  function qn(D) {
    const L = D.charCodeAt(0);
    return L >= 48 && L <= 57 || // 0-9
    L >= 65 && L <= 70 || // A-F
    L >= 97 && L <= 102;
  }
  function H1(D) {
    return _1(D, qn);
  }
  function X1(D) {
    let L = "", X = "";
    for (; L = rt(D); )
      X += L;
    return X;
  }
  function Oi(D) {
    U(D);
    const L = D.currentChar();
    return L !== "%" && x(ke.EXPECTED_TOKEN, o(), 0, L), D.next(), "%";
  }
  function Hi(D) {
    let L = "";
    for (; ; ) {
      const X = D.currentChar();
      if (X === "{" || X === "}" || X === "@" || X === "|" || !X)
        break;
      if (X === "%")
        if (ze(D))
          L += X, D.next();
        else
          break;
      else if (X === ki || X === Z1)
        if (ze(D))
          L += X, D.next();
        else {
          if (Pe(D))
            break;
          L += X, D.next();
        }
      else
        L += X, D.next();
    }
    return L;
  }
  function gn(D) {
    U(D);
    let L = "", X = "";
    for (; L = sn(D); )
      X += L;
    return D.currentChar() === Ji && x(ke.UNTERMINATED_CLOSING_BRACE, o(), 0), X;
  }
  function Gn(D) {
    U(D);
    let L = "";
    return D.currentChar() === "-" ? (D.next(), L += `-${X1(D)}`) : L += X1(D), D.currentChar() === Ji && x(ke.UNTERMINATED_CLOSING_BRACE, o(), 0), L;
  }
  function lt(D) {
    return D !== x4 && D !== Z1;
  }
  function Xn(D) {
    U(D), z(D, "'");
    let L = "", X = "";
    for (; L = _1(D, lt); )
      L === "\\" ? X += zn(D) : X += L;
    const ve = D.currentChar();
    return ve === Z1 || ve === Ji ? (x(ke.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), ve === Z1 && (D.next(), z(D, "'")), X) : (z(D, "'"), X);
  }
  function zn(D) {
    const L = D.currentChar();
    switch (L) {
      case "\\":
      case "'":
        return D.next(), `\\${L}`;
      case "u":
        return ji(D, L, 4);
      case "U":
        return ji(D, L, 6);
      default:
        return x(ke.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, L), "";
    }
  }
  function ji(D, L, X) {
    z(D, L);
    let ve = "";
    for (let Te = 0; Te < X; Te++) {
      const Ue = H1(D);
      if (!Ue) {
        x(ke.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${L}${ve}${D.currentChar()}`);
        break;
      }
      ve += Ue;
    }
    return `\\${L}${ve}`;
  }
  function Jn(D) {
    return D !== "{" && D !== "}" && D !== ki && D !== Z1;
  }
  function Kn(D) {
    U(D);
    let L = "", X = "";
    for (; L = _1(D, Jn); )
      X += L;
    return X;
  }
  function Vi(D) {
    let L = "", X = "";
    for (; L = ot(D); )
      X += L;
    return X;
  }
  function ie(D) {
    const L = (X = !1, ve) => {
      const Te = D.currentChar();
      return Te === "{" || Te === "%" || Te === "@" || Te === "|" || Te === "(" || Te === ")" || !Te || Te === ki ? ve : Te === Z1 || Te === GP ? (ve += Te, D.next(), L(X, ve)) : (ve += Te, D.next(), L(!0, ve));
    };
    return L(!1, "");
  }
  function Ie(D) {
    U(D);
    const L = z(
      D,
      "|"
      /* TokenChars.Pipe */
    );
    return U(D), L;
  }
  function dt(D, L) {
    let X = null;
    switch (D.currentChar()) {
      case "{":
        return L.braceNest >= 1 && x(ke.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), D.next(), X = C(
          L,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), U(D), L.braceNest++, X;
      case "}":
        return L.braceNest > 0 && L.currentType === 2 && x(ke.EMPTY_PLACEHOLDER, o(), 0), D.next(), X = C(
          L,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), L.braceNest--, L.braceNest > 0 && U(D), L.inLinked && L.braceNest === 0 && (L.inLinked = !1), X;
      case "@":
        return L.braceNest > 0 && x(ke.UNTERMINATED_CLOSING_BRACE, o(), 0), X = E1(D, L) || M(L), L.braceNest = 0, X;
      default: {
        let Te = !0, Ue = !0, Xe = !0;
        if (Pe(D))
          return L.braceNest > 0 && x(ke.UNTERMINATED_CLOSING_BRACE, o(), 0), X = C(L, 1, Ie(D)), L.braceNest = 0, L.inLinked = !1, X;
        if (L.braceNest > 0 && (L.currentType === 5 || L.currentType === 6 || L.currentType === 7))
          return x(ke.UNTERMINATED_CLOSING_BRACE, o(), 0), L.braceNest = 0, Fi(D, L);
        if (Te = I(D, L))
          return X = C(L, 5, gn(D)), U(D), X;
        if (Ue = V(D, L))
          return X = C(L, 6, Gn(D)), U(D), X;
        if (Xe = K(D, L))
          return X = C(L, 7, Xn(D)), U(D), X;
        if (!Te && !Ue && !Xe)
          return X = C(L, 13, Kn(D)), x(ke.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, X.value), U(D), X;
        break;
      }
    }
    return X;
  }
  function E1(D, L) {
    const { currentType: X } = L;
    let ve = null;
    const Te = D.currentChar();
    switch ((X === 8 || X === 9 || X === 12 || X === 10) && (Te === Z1 || Te === ki) && x(ke.INVALID_LINKED_FORMAT, o(), 0), Te) {
      case "@":
        return D.next(), ve = C(
          L,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), L.inLinked = !0, ve;
      case ".":
        return U(D), D.next(), C(
          L,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return U(D), D.next(), C(
          L,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return Pe(D) ? (ve = C(L, 1, Ie(D)), L.braceNest = 0, L.inLinked = !1, ve) : H(D, L) || ae(D, L) ? (U(D), E1(D, L)) : Y(D, L) ? (U(D), C(L, 12, Vi(D))) : ee(D, L) ? (U(D), Te === "{" ? dt(D, L) || ve : C(L, 11, ie(D))) : (X === 8 && x(ke.INVALID_LINKED_FORMAT, o(), 0), L.braceNest = 0, L.inLinked = !1, Fi(D, L));
    }
  }
  function Fi(D, L) {
    let X = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (L.braceNest > 0)
      return dt(D, L) || M(L);
    if (L.inLinked)
      return E1(D, L) || M(L);
    switch (D.currentChar()) {
      case "{":
        return dt(D, L) || M(L);
      case "}":
        return x(ke.UNBALANCED_CLOSING_BRACE, o(), 0), D.next(), C(
          L,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return E1(D, L) || M(L);
      default: {
        if (Pe(D))
          return X = C(L, 1, Ie(D)), L.braceNest = 0, L.inLinked = !1, X;
        const { isModulo: Te, hasSpace: Ue } = N1(D);
        if (Te)
          return Ue ? C(L, 0, Hi(D)) : C(L, 4, Oi(D));
        if (ze(D))
          return C(L, 0, Hi(D));
        break;
      }
    }
    return X;
  }
  function p2() {
    const { currentType: D, offset: L, startLoc: X, endLoc: ve } = h;
    return h.lastType = D, h.lastOffset = L, h.lastStartLoc = X, h.lastEndLoc = ve, h.offset = r(), h.startLoc = o(), a.currentChar() === Ji ? C(
      h,
      14
      /* TokenTypes.EOF */
    ) : Fi(a, h);
  }
  return {
    nextToken: p2,
    currentOffset: r,
    currentPosition: o,
    context: y
  };
}
const KP = "parser", $P = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function eU(e, i, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(i || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function nU(e = {}) {
  const i = e.location !== !1, { onError: n, onWarn: a } = e;
  function r(I, V, K, H, ...Y) {
    const ae = I.currentPosition();
    if (ae.offset += H, ae.column += H, n) {
      const ee = i ? c0(K, ae) : null, Pe = h2(V, ee, {
        domain: KP,
        args: Y
      });
      n(Pe);
    }
  }
  function o(I, V, K, H, ...Y) {
    const ae = I.currentPosition();
    if (ae.offset += H, ae.column += H, a) {
      const ee = i ? c0(K, ae) : null;
      a(FP(V, ee, Y));
    }
  }
  function l(I, V, K) {
    const H = { type: I };
    return i && (H.start = V, H.end = V, H.loc = { start: K, end: K }), H;
  }
  function c(I, V, K, H) {
    H && (I.type = H), i && (I.end = V, I.loc && (I.loc.end = K));
  }
  function h(I, V) {
    const K = I.context(), H = l(3, K.offset, K.startLoc);
    return H.value = V, c(H, I.currentOffset(), I.currentPosition()), H;
  }
  function y(I, V) {
    const K = I.context(), { lastOffset: H, lastStartLoc: Y } = K, ae = l(5, H, Y);
    return ae.index = parseInt(V, 10), I.nextToken(), c(ae, I.currentOffset(), I.currentPosition()), ae;
  }
  function v(I, V, K) {
    const H = I.context(), { lastOffset: Y, lastStartLoc: ae } = H, ee = l(4, Y, ae);
    return ee.key = V, K === !0 && (ee.modulo = !0), I.nextToken(), c(ee, I.currentOffset(), I.currentPosition()), ee;
  }
  function x(I, V) {
    const K = I.context(), { lastOffset: H, lastStartLoc: Y } = K, ae = l(9, H, Y);
    return ae.value = V.replace($P, eU), I.nextToken(), c(ae, I.currentOffset(), I.currentPosition()), ae;
  }
  function C(I) {
    const V = I.nextToken(), K = I.context(), { lastOffset: H, lastStartLoc: Y } = K, ae = l(8, H, Y);
    return V.type !== 12 ? (r(I, ke.UNEXPECTED_EMPTY_LINKED_MODIFIER, K.lastStartLoc, 0), ae.value = "", c(ae, H, Y), {
      nextConsumeToken: V,
      node: ae
    }) : (V.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, K.lastStartLoc, 0, Vn(V)), ae.value = V.value || "", c(ae, I.currentOffset(), I.currentPosition()), {
      node: ae
    });
  }
  function M(I, V) {
    const K = I.context(), H = l(7, K.offset, K.startLoc);
    return H.value = V, c(H, I.currentOffset(), I.currentPosition()), H;
  }
  function z(I) {
    const V = I.context(), K = l(6, V.offset, V.startLoc);
    let H = I.nextToken();
    if (H.type === 9) {
      const Y = C(I);
      K.modifier = Y.node, H = Y.nextConsumeToken || I.nextToken();
    }
    switch (H.type !== 10 && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(H)), H = I.nextToken(), H.type === 2 && (H = I.nextToken()), H.type) {
      case 11:
        H.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(H)), K.key = M(I, H.value || "");
        break;
      case 5:
        H.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(H)), K.key = v(I, H.value || "");
        break;
      case 6:
        H.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(H)), K.key = y(I, H.value || "");
        break;
      case 7:
        H.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(H)), K.key = x(I, H.value || "");
        break;
      default: {
        r(I, ke.UNEXPECTED_EMPTY_LINKED_KEY, V.lastStartLoc, 0);
        const Y = I.context(), ae = l(7, Y.offset, Y.startLoc);
        return ae.value = "", c(ae, Y.offset, Y.startLoc), K.key = ae, c(K, Y.offset, Y.startLoc), {
          nextConsumeToken: H,
          node: K
        };
      }
    }
    return c(K, I.currentOffset(), I.currentPosition()), {
      node: K
    };
  }
  function R(I) {
    const V = I.context(), K = V.currentType === 1 ? I.currentOffset() : V.offset, H = V.currentType === 1 ? V.endLoc : V.startLoc, Y = l(2, K, H);
    Y.items = [];
    let ae = null, ee = null;
    do {
      const ze = ae || I.nextToken();
      switch (ae = null, ze.type) {
        case 0:
          ze.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(ze)), Y.items.push(h(I, ze.value || ""));
          break;
        case 6:
          ze.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(ze)), Y.items.push(y(I, ze.value || ""));
          break;
        case 4:
          ee = !0;
          break;
        case 5:
          ze.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(ze)), Y.items.push(v(I, ze.value || "", !!ee)), ee && (o(I, z0.USE_MODULO_SYNTAX, V.lastStartLoc, 0, Vn(ze)), ee = null);
          break;
        case 7:
          ze.value == null && r(I, ke.UNEXPECTED_LEXICAL_ANALYSIS, V.lastStartLoc, 0, Vn(ze)), Y.items.push(x(I, ze.value || ""));
          break;
        case 8: {
          const _1 = z(I);
          Y.items.push(_1.node), ae = _1.nextConsumeToken || null;
          break;
        }
      }
    } while (V.currentType !== 14 && V.currentType !== 1);
    const Pe = V.currentType === 1 ? V.lastOffset : I.currentOffset(), N1 = V.currentType === 1 ? V.lastEndLoc : I.currentPosition();
    return c(Y, Pe, N1), Y;
  }
  function U(I, V, K, H) {
    const Y = I.context();
    let ae = H.items.length === 0;
    const ee = l(1, V, K);
    ee.cases = [], ee.cases.push(H);
    do {
      const Pe = R(I);
      ae || (ae = Pe.items.length === 0), ee.cases.push(Pe);
    } while (Y.currentType !== 14);
    return ae && r(I, ke.MUST_HAVE_MESSAGES_IN_PLURAL, K, 0), c(ee, I.currentOffset(), I.currentPosition()), ee;
  }
  function G(I) {
    const V = I.context(), { offset: K, startLoc: H } = V, Y = R(I);
    return V.currentType === 14 ? Y : U(I, K, H, Y);
  }
  function re(I) {
    const V = JP(I, Fd({}, e)), K = V.context(), H = l(0, K.offset, K.startLoc);
    return i && H.loc && (H.loc.source = I), H.body = G(V), e.onCacheKey && (H.cacheKey = e.onCacheKey(I)), K.currentType !== 14 && r(V, ke.UNEXPECTED_LEXICAL_ANALYSIS, K.lastStartLoc, 0, I[K.offset] || ""), c(H, V.currentOffset(), V.currentPosition()), H;
  }
  return { parse: re };
}
function Vn(e) {
  if (e.type === 14)
    return "EOF";
  const i = (e.value || "").replace(/\r?\n/gu, "\\n");
  return i.length > 10 ? i.slice(0, 9) + "…" : i;
}
function iU(e, i = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (o) => (n.helpers.add(o), o) };
}
function b4(e, i) {
  for (let n = 0; n < e.length; n++)
    vo(e[n], i);
}
function vo(e, i) {
  switch (e.type) {
    case 1:
      b4(e.cases, i), i.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      b4(e.items, i);
      break;
    case 6: {
      vo(e.key, i), i.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), i.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      i.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), i.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      i.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), i.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function tU(e, i = {}) {
  const n = iU(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && vo(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function aU(e) {
  const i = e.body;
  return i.type === 2 ? M4(i) : i.cases.forEach((n) => M4(n)), e;
}
function M4(e) {
  if (e.items.length === 1) {
    const i = e.items[0];
    (i.type === 3 || i.type === 9) && (e.static = i.value, delete i.value);
  } else {
    const i = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      i.push(a.value);
    }
    if (i.length === e.items.length) {
      e.static = Pd(i);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const sU = "minifier";
function Xt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const i = e;
      Xt(i.body), i.b = i.body, delete i.body;
      break;
    }
    case 1: {
      const i = e, n = i.cases;
      for (let a = 0; a < n.length; a++)
        Xt(n[a]);
      i.c = n, delete i.cases;
      break;
    }
    case 2: {
      const i = e, n = i.items;
      for (let a = 0; a < n.length; a++)
        Xt(n[a]);
      i.i = n, delete i.items, i.static && (i.s = i.static, delete i.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const i = e;
      i.value && (i.v = i.value, delete i.value);
      break;
    }
    case 6: {
      const i = e;
      Xt(i.key), i.k = i.key, delete i.key, i.modifier && (Xt(i.modifier), i.m = i.modifier, delete i.modifier);
      break;
    }
    case 5: {
      const i = e;
      i.i = i.index, delete i.index;
      break;
    }
    case 4: {
      const i = e;
      i.k = i.key, delete i.key;
      break;
    }
    default:
      throw h2(ke.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: sU,
        args: [e.type]
      });
  }
  delete e.type;
}
const oU = "parser";
function rU(e, i) {
  const { sourceMap: n, filename: a, breakLineCode: r, needIndent: o } = i, l = i.location !== !1, c = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: o,
    indentLevel: 0
  };
  l && e.loc && (c.source = e.loc.source);
  const h = () => c;
  function y(U, G) {
    c.code += U;
  }
  function v(U, G = !0) {
    const re = G ? r : "";
    y(o ? re + "  ".repeat(U) : re);
  }
  function x(U = !0) {
    const G = ++c.indentLevel;
    U && v(G);
  }
  function C(U = !0) {
    const G = --c.indentLevel;
    U && v(G);
  }
  function M() {
    v(c.indentLevel);
  }
  return {
    context: h,
    push: y,
    indent: x,
    deindent: C,
    newline: M,
    helper: (U) => `_${U}`,
    needIndent: () => c.needIndent
  };
}
function lU(e, i) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), s2(e, i.key), i.modifier ? (e.push(", "), s2(e, i.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function dU(e, i) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const r = i.items.length;
  for (let o = 0; o < r && (s2(e, i.items[o]), o !== r - 1); o++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function cU(e, i) {
  const { helper: n, needIndent: a } = e;
  if (i.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const r = i.cases.length;
    for (let o = 0; o < r && (s2(e, i.cases[o]), o !== r - 1); o++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function fU(e, i) {
  i.body ? s2(e, i.body) : e.push("null");
}
function s2(e, i) {
  const { helper: n } = e;
  switch (i.type) {
    case 0:
      fU(e, i);
      break;
    case 1:
      cU(e, i);
      break;
    case 2:
      dU(e, i);
      break;
    case 6:
      lU(e, i);
      break;
    case 8:
      e.push(JSON.stringify(i.value), i);
      break;
    case 7:
      e.push(JSON.stringify(i.value), i);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${i.index}))`, i);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(i.key)}))`, i);
      break;
    case 9:
      e.push(JSON.stringify(i.value), i);
      break;
    case 3:
      e.push(JSON.stringify(i.value), i);
      break;
    default:
      throw h2(ke.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: oU,
        args: [i.type]
      });
  }
}
const uU = (e, i = {}) => {
  const n = k4(i.mode) ? i.mode : "normal", a = k4(i.filename) ? i.filename : "message.intl", r = !!i.sourceMap, o = i.breakLineCode != null ? i.breakLineCode : n === "arrow" ? ";" : `
`, l = i.needIndent ? i.needIndent : n !== "arrow", c = e.helpers || [], h = rU(e, {
    mode: n,
    filename: a,
    sourceMap: r,
    breakLineCode: o,
    needIndent: l
  });
  h.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), h.indent(l), c.length > 0 && (h.push(`const { ${Pd(c.map((x) => `${x}: _${x}`), ", ")} } = ctx`), h.newline()), h.push("return "), s2(h, e), h.deindent(l), h.push("}"), delete e.helpers;
  const { code: y, map: v } = h.context();
  return {
    ast: e,
    code: y,
    map: v ? v.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function hU(e, i = {}) {
  const n = Fd({}, i), a = !!n.jit, r = !!n.minify, o = n.optimize == null ? !0 : n.optimize, c = nU(n).parse(e);
  return a ? (o && aU(c), r && Xt(c), { ast: c, code: "" }) : (tU(c, n), uU(c, n));
}
/*!
  * core-base v9.12.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function mU() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Di().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Di().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Di().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const st = [];
st[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  [
    "["
    /* PathCharTypes.LEFT_BRACKET */
  ]: [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
st[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  [
    "."
    /* PathCharTypes.DOT */
  ]: [
    2
    /* States.BEFORE_IDENT */
  ],
  [
    "["
    /* PathCharTypes.LEFT_BRACKET */
  ]: [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
st[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  [
    0
    /* PathCharTypes.ZERO */
  ]: [
    3,
    0
    /* Actions.APPEND */
  ]
};
st[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  [
    0
    /* PathCharTypes.ZERO */
  ]: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  [
    "."
    /* PathCharTypes.DOT */
  ]: [
    2,
    1
    /* Actions.PUSH */
  ],
  [
    "["
    /* PathCharTypes.LEFT_BRACKET */
  ]: [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
st[
  4
  /* States.IN_SUB_PATH */
] = {
  [
    "'"
    /* PathCharTypes.SINGLE_QUOTE */
  ]: [
    5,
    0
    /* Actions.APPEND */
  ],
  [
    '"'
    /* PathCharTypes.DOUBLE_QUOTE */
  ]: [
    6,
    0
    /* Actions.APPEND */
  ],
  [
    "["
    /* PathCharTypes.LEFT_BRACKET */
  ]: [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  [
    "]"
    /* PathCharTypes.RIGHT_BRACKET */
  ]: [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
st[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  [
    "'"
    /* PathCharTypes.SINGLE_QUOTE */
  ]: [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
st[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  [
    '"'
    /* PathCharTypes.DOUBLE_QUOTE */
  ]: [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const pU = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function yU(e) {
  return pU.test(e);
}
function vU(e) {
  const i = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return i === n && (i === 34 || i === 39) ? e.slice(1, -1) : e;
}
function gU(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function _U(e) {
  const i = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : yU(i) ? vU(i) : "*" + i;
}
function wU(e) {
  const i = [];
  let n = -1, a = 0, r = 0, o, l, c, h, y, v, x;
  const C = [];
  C[
    0
    /* Actions.APPEND */
  ] = () => {
    l === void 0 ? l = c : l += c;
  }, C[
    1
    /* Actions.PUSH */
  ] = () => {
    l !== void 0 && (i.push(l), l = void 0);
  }, C[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    C[
      0
      /* Actions.APPEND */
    ](), r++;
  }, C[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, a = 4, C[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, l === void 0 || (l = _U(l), l === !1))
        return !1;
      C[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function M() {
    const z = e[n + 1];
    if (a === 5 && z === "'" || a === 6 && z === '"')
      return n++, c = "\\" + z, C[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, o = e[n], !(o === "\\" && M())) {
      if (h = gU(o), x = st[a], y = x[h] || x.l || 8, y === 8 || (a = y[0], y[1] !== void 0 && (v = C[y[1]], v && (c = o, v() === !1))))
        return;
      if (a === 7)
        return i;
    }
}
const D4 = /* @__PURE__ */ new Map();
function CU(e, i) {
  return We(e) ? e[i] : null;
}
function kU(e, i) {
  if (!We(e))
    return null;
  let n = D4.get(i);
  if (n || (n = wU(i), n && D4.set(i, n)), !n)
    return null;
  const a = n.length;
  let r = e, o = 0;
  for (; o < a; ) {
    const l = r[n[o]];
    if (l === void 0 || n1(r))
      return null;
    r = l, o++;
  }
  return r;
}
const xU = (e) => e, bU = (e) => "", MU = "text", DU = (e) => e.length === 0 ? "" : IP(e), AU = zP;
function A4(e, i) {
  return e = Math.abs(e), i === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function LU(e) {
  const i = k1(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (k1(e.named.count) || k1(e.named.n)) ? k1(e.named.count) ? e.named.count : k1(e.named.n) ? e.named.n : i : i;
}
function TU(e, i) {
  i.count || (i.count = e), i.n || (i.n = e);
}
function SU(e = {}) {
  const i = e.locale, n = LU(e), a = We(e.pluralRules) && le(i) && n1(e.pluralRules[i]) ? e.pluralRules[i] : A4, r = We(e.pluralRules) && le(i) && n1(e.pluralRules[i]) ? A4 : void 0, o = (G) => G[a(n, G.length, r)], l = e.list || [], c = (G) => l[G], h = e.named || {};
  k1(e.pluralIndex) && TU(n, h);
  const y = (G) => h[G];
  function v(G) {
    const re = n1(e.messages) ? e.messages(G) : We(e.messages) ? e.messages[G] : !1;
    return re || (e.parent ? e.parent.message(G) : bU);
  }
  const x = (G) => e.modifiers ? e.modifiers[G] : xU, C = xe(e.processor) && n1(e.processor.normalize) ? e.processor.normalize : DU, M = xe(e.processor) && n1(e.processor.interpolate) ? e.processor.interpolate : AU, z = xe(e.processor) && le(e.processor.type) ? e.processor.type : MU, U = {
    list: c,
    named: y,
    plural: o,
    linked: (G, ...re) => {
      const [I, V] = re;
      let K = "text", H = "";
      re.length === 1 ? We(I) ? (H = I.modifier || H, K = I.type || K) : le(I) && (H = I || H) : re.length === 2 && (le(I) && (H = I || H), le(V) && (K = V || K));
      const Y = v(G)(U), ae = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        K === "vnode" && s1(Y) && H ? Y[0] : Y
      );
      return H ? x(H)(ae, K) : ae;
    },
    message: v,
    type: z,
    interpolate: M,
    normalize: C,
    values: O1({}, l, h)
  };
  return U;
}
let Z2 = null;
function NU(e) {
  Z2 = e;
}
function EU(e, i, n) {
  Z2 && Z2.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: i,
    meta: n
  });
}
const zU = /* @__PURE__ */ IU(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function IU(e) {
  return (i) => Z2 && Z2.emit(e, i);
}
const Ud = z0.__EXTEND_POINT__, wt = E0(Ud), W1 = {
  NOT_FOUND_KEY: Ud,
  // 2
  FALLBACK_TO_TRANSLATE: wt(),
  // 3
  CANNOT_FORMAT_NUMBER: wt(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: wt(),
  // 5
  CANNOT_FORMAT_DATE: wt(),
  // 6
  FALLBACK_TO_DATE_FORMAT: wt(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: wt(),
  // 8
  __EXTEND_POINT__: wt()
  // 9
}, BU = {
  [W1.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [W1.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [W1.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [W1.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [W1.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [W1.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [W1.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function At(e, ...i) {
  return po(BU[e], ...i);
}
const Rd = ke.__EXTEND_POINT__, Ct = E0(Rd), A1 = {
  INVALID_ARGUMENT: Rd,
  // 17
  INVALID_DATE_ARGUMENT: Ct(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Ct(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Ct(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Ct(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Ct(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Ct(),
  // 23
  __EXTEND_POINT__: Ct()
  // 24
};
function ai(e) {
  return h2(e, null, process.env.NODE_ENV !== "production" ? { messages: OU } : void 0);
}
const OU = {
  [A1.INVALID_ARGUMENT]: "Invalid arguments",
  [A1.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [A1.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [A1.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [A1.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [A1.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [A1.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function go(e, i) {
  return i.locale != null ? L4(i.locale) : L4(e.locale);
}
let s3;
function L4(e) {
  if (le(e))
    return e;
  if (n1(e)) {
    if (e.resolvedOnce && s3 != null)
      return s3;
    if (e.constructor.name === "Function") {
      const i = e();
      if (EP(i))
        throw ai(A1.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return s3 = i;
    } else
      throw ai(A1.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ai(A1.NOT_SUPPORT_LOCALE_TYPE);
}
function HU(e, i, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...s1(i) ? i : We(i) ? Object.keys(i) : le(i) ? [i] : [n]
  ])];
}
function Yd(e, i, n) {
  const a = le(n) ? n : o2, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let o = r.__localeChainCache.get(a);
  if (!o) {
    o = [];
    let l = [n];
    for (; s1(l); )
      l = T4(o, l, i);
    const c = s1(i) || !xe(i) ? i : i.default ? i.default : null;
    l = le(c) ? [c] : c, s1(l) && T4(o, l, !1), r.__localeChainCache.set(a, o);
  }
  return o;
}
function T4(e, i, n) {
  let a = !0;
  for (let r = 0; r < i.length && Ne(a); r++) {
    const o = i[r];
    le(o) && (a = jU(e, i[r], n));
  }
  return a;
}
function jU(e, i, n) {
  let a;
  const r = i.split("-");
  do {
    const o = r.join("-");
    a = VU(e, o, n), r.splice(-1, 1);
  } while (r.length && a === !0);
  return a;
}
function VU(e, i, n) {
  let a = !1;
  if (!e.includes(i) && (a = !0, i)) {
    a = i[i.length - 1] !== "!";
    const r = i.replace(/!/g, "");
    e.push(r), (s1(n) || xe(n)) && n[r] && (a = n[r]);
  }
  return a;
}
const FU = "9.12.1", I0 = -1, o2 = "en-US", f0 = "", S4 = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function PU() {
  return {
    upper: (e, i) => i === "text" && le(e) ? e.toUpperCase() : i === "vnode" && We(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, i) => i === "text" && le(e) ? e.toLowerCase() : i === "vnode" && We(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, i) => i === "text" && le(e) ? S4(e) : i === "vnode" && We(e) && "__v_isVNode" in e ? S4(e.children) : e
  };
}
let Zd;
function N4(e) {
  Zd = e;
}
let Wd;
function UU(e) {
  Wd = e;
}
let Qd;
function RU(e) {
  Qd = e;
}
let qd = null;
const YU = (e) => {
  qd = e;
}, ZU = () => qd;
let Gd = null;
const E4 = (e) => {
  Gd = e;
}, WU = () => Gd;
let z4 = 0;
function QU(e = {}) {
  const i = n1(e.onWarn) ? e.onWarn : x1, n = le(e.version) ? e.version : FU, a = le(e.locale) || n1(e.locale) ? e.locale : o2, r = n1(a) ? o2 : a, o = s1(e.fallbackLocale) || xe(e.fallbackLocale) || le(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, l = xe(e.messages) ? e.messages : { [r]: {} }, c = xe(e.datetimeFormats) ? e.datetimeFormats : { [r]: {} }, h = xe(e.numberFormats) ? e.numberFormats : { [r]: {} }, y = O1({}, e.modifiers || {}, PU()), v = e.pluralRules || {}, x = n1(e.missing) ? e.missing : null, C = Ne(e.missingWarn) || tt(e.missingWarn) ? e.missingWarn : !0, M = Ne(e.fallbackWarn) || tt(e.fallbackWarn) ? e.fallbackWarn : !0, z = !!e.fallbackFormat, R = !!e.unresolving, U = n1(e.postTranslation) ? e.postTranslation : null, G = xe(e.processor) ? e.processor : null, re = Ne(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, I = !!e.escapeParameter, V = n1(e.messageCompiler) ? e.messageCompiler : Zd;
  process.env.NODE_ENV !== "production" && n1(e.messageCompiler) && jd(At(W1.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const K = n1(e.messageResolver) ? e.messageResolver : Wd || CU, H = n1(e.localeFallbacker) ? e.localeFallbacker : Qd || HU, Y = We(e.fallbackContext) ? e.fallbackContext : void 0, ae = e, ee = We(ae.__datetimeFormatters) ? ae.__datetimeFormatters : /* @__PURE__ */ new Map(), Pe = We(ae.__numberFormatters) ? ae.__numberFormatters : /* @__PURE__ */ new Map(), N1 = We(ae.__meta) ? ae.__meta : {};
  z4++;
  const ze = {
    version: n,
    cid: z4,
    locale: a,
    fallbackLocale: o,
    messages: l,
    modifiers: y,
    pluralRules: v,
    missing: x,
    missingWarn: C,
    fallbackWarn: M,
    fallbackFormat: z,
    unresolving: R,
    postTranslation: U,
    processor: G,
    warnHtmlMessage: re,
    escapeParameter: I,
    messageCompiler: V,
    messageResolver: K,
    localeFallbacker: H,
    fallbackContext: Y,
    onWarn: i,
    __meta: N1
  };
  return ze.datetimeFormats = c, ze.numberFormats = h, ze.__datetimeFormatters = ee, ze.__numberFormatters = Pe, process.env.NODE_ENV !== "production" && (ze.__v_emitter = ae.__v_emitter != null ? ae.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && EU(ze, n, N1), ze;
}
function B0(e, i) {
  return e instanceof RegExp ? e.test(i) : e;
}
function Xd(e, i) {
  return e instanceof RegExp ? e.test(i) : e;
}
function _o(e, i, n, a, r) {
  const { missing: o, onWarn: l } = e;
  if (process.env.NODE_ENV !== "production") {
    const c = e.__v_emitter;
    c && c.emit("missing", {
      locale: n,
      key: i,
      type: r,
      groupId: `${r}:${i}`
    });
  }
  if (o !== null) {
    const c = o(e, n, i, r);
    return le(c) ? c : i;
  } else
    return process.env.NODE_ENV !== "production" && Xd(a, i) && l(At(W1.NOT_FOUND_KEY, { key: i, locale: n })), i;
}
function I2(e, i, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, i);
}
function o3(e) {
  return (n) => qU(n, e);
}
function qU(e, i) {
  const n = i.b || i.body;
  if ((n.t || n.type) === 1) {
    const a = n, r = a.c || a.cases;
    return e.plural(r.reduce((o, l) => [
      ...o,
      I4(e, l)
    ], []));
  } else
    return I4(e, n);
}
function I4(e, i) {
  const n = i.s || i.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = (i.i || i.items).reduce((r, o) => [...r, M3(e, o)], []);
    return e.normalize(a);
  }
}
function M3(e, i) {
  const n = i.t || i.type;
  switch (n) {
    case 3: {
      const a = i;
      return a.v || a.value;
    }
    case 9: {
      const a = i;
      return a.v || a.value;
    }
    case 4: {
      const a = i;
      return e.interpolate(e.named(a.k || a.key));
    }
    case 5: {
      const a = i;
      return e.interpolate(e.list(a.i != null ? a.i : a.index));
    }
    case 6: {
      const a = i, r = a.m || a.modifier;
      return e.linked(M3(e, a.k || a.key), r ? M3(e, r) : void 0, e.type);
    }
    case 7: {
      const a = i;
      return a.v || a.value;
    }
    case 8: {
      const a = i;
      return a.v || a.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const GU = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Jd(e, i) {
  i && YP(e) && x1(po(GU, { source: e }));
}
const Kd = (e) => e;
let $t = /* @__PURE__ */ Object.create(null);
function $d(e) {
  e.code === z0.USE_MODULO_SYNTAX && x1(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
const at = (e) => We(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function ec(e, i = {}) {
  let n = !1;
  const a = i.onError || UP;
  return i.onError = (r) => {
    n = !0, a(r);
  }, { ...hU(e, i), detectError: n };
}
const XU = (e, i) => {
  if (!le(e))
    throw ai(A1.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (i.onWarn = $d);
  {
    const n = Ne(i.warnHtmlMessage) ? i.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Jd(e, n);
    const r = (i.onCacheKey || Kd)(e), o = $t[r];
    if (o)
      return o;
    const { code: l, detectError: c } = ec(e, i), h = new Function(`return ${l}`)();
    return c ? h : $t[r] = h;
  }
};
function JU(e, i) {
  if (process.env.NODE_ENV !== "production" && (i.onWarn = $d), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && le(e)) {
    const n = Ne(i.warnHtmlMessage) ? i.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Jd(e, n);
    const r = (i.onCacheKey || Kd)(e), o = $t[r];
    if (o)
      return o;
    const { ast: l, detectError: c } = ec(e, {
      ...i,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), h = o3(l);
    return c ? h : $t[r] = h;
  } else {
    if (process.env.NODE_ENV !== "production" && !at(e))
      return x1(`the message that is resolve with key '${i.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const a = $t[n];
      return a || ($t[n] = o3(e));
    } else
      return o3(e);
  }
}
const B4 = () => "", Sn = (e) => n1(e);
function O4(e, ...i) {
  const { fallbackFormat: n, postTranslation: a, unresolving: r, messageCompiler: o, fallbackLocale: l, messages: c } = e, [h, y] = D3(...i), v = Ne(y.missingWarn) ? y.missingWarn : e.missingWarn, x = Ne(y.fallbackWarn) ? y.fallbackWarn : e.fallbackWarn, C = Ne(y.escapeParameter) ? y.escapeParameter : e.escapeParameter, M = !!y.resolvedMessage, z = le(y.default) || Ne(y.default) ? Ne(y.default) ? o ? h : () => h : y.default : n ? o ? h : () => h : "", R = n || z !== "", U = go(e, y);
  C && KU(y);
  let [G, re, I] = M ? [
    h,
    U,
    c[U] || {}
  ] : nc(e, h, U, l, x, v), V = G, K = h;
  if (!M && !(le(V) || at(V) || Sn(V)) && R && (V = z, K = V), !M && (!(le(V) || at(V) || Sn(V)) || !le(re)))
    return r ? I0 : h;
  if (process.env.NODE_ENV !== "production" && le(V) && e.messageCompiler == null)
    return x1(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${h}'.`), h;
  let H = !1;
  const Y = () => {
    H = !0;
  }, ae = Sn(V) ? V : ic(e, h, re, V, K, Y);
  if (H)
    return V;
  const ee = iR(e, re, I, y), Pe = SU(ee), N1 = $U(e, ae, Pe), ze = a ? a(N1, h) : N1;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const _1 = {
      timestamp: Date.now(),
      key: le(h) ? h : Sn(V) ? V.key : "",
      locale: re || (Sn(V) ? V.locale : ""),
      format: le(V) ? V : Sn(V) ? V.source : "",
      message: ze
    };
    _1.meta = O1({}, e.__meta, ZU() || {}), zU(_1);
  }
  return ze;
}
function KU(e) {
  s1(e.list) ? e.list = e.list.map((i) => le(i) ? _4(i) : i) : We(e.named) && Object.keys(e.named).forEach((i) => {
    le(e.named[i]) && (e.named[i] = _4(e.named[i]));
  });
}
function nc(e, i, n, a, r, o) {
  const { messages: l, onWarn: c, messageResolver: h, localeFallbacker: y } = e, v = y(e, a, n);
  let x = {}, C, M = null, z = n, R = null;
  const U = "translate";
  for (let G = 0; G < v.length; G++) {
    if (C = R = v[G], process.env.NODE_ENV !== "production" && n !== C && B0(r, i) && c(At(W1.FALLBACK_TO_TRANSLATE, {
      key: i,
      target: C
    })), process.env.NODE_ENV !== "production" && n !== C) {
      const H = e.__v_emitter;
      H && H.emit("fallback", {
        type: U,
        key: i,
        from: z,
        to: R,
        groupId: `${U}:${i}`
      });
    }
    x = l[C] || {};
    let re = null, I, V;
    if (process.env.NODE_ENV !== "production" && Yn && (re = window.performance.now(), I = "intlify-message-resolve-start", V = "intlify-message-resolve-end", un && un(I)), (M = h(x, i)) === null && (M = x[i]), process.env.NODE_ENV !== "production" && Yn) {
      const H = window.performance.now(), Y = e.__v_emitter;
      Y && re && M && Y.emit("message-resolve", {
        type: "message-resolve",
        key: i,
        message: M,
        time: H - re,
        groupId: `${U}:${i}`
      }), I && V && un && Dt && (un(V), Dt("intlify message resolve", I, V));
    }
    if (le(M) || at(M) || Sn(M))
      break;
    const K = _o(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      i,
      C,
      o,
      U
    );
    K !== i && (M = K), z = R;
  }
  return [M, C, x];
}
function ic(e, i, n, a, r, o) {
  const { messageCompiler: l, warnHtmlMessage: c } = e;
  if (Sn(a)) {
    const C = a;
    return C.locale = C.locale || n, C.key = C.key || i, C;
  }
  if (l == null) {
    const C = () => a;
    return C.locale = n, C.key = i, C;
  }
  let h = null, y, v;
  process.env.NODE_ENV !== "production" && Yn && (h = window.performance.now(), y = "intlify-message-compilation-start", v = "intlify-message-compilation-end", un && un(y));
  const x = l(a, eR(e, n, r, a, c, o));
  if (process.env.NODE_ENV !== "production" && Yn) {
    const C = window.performance.now(), M = e.__v_emitter;
    M && h && M.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: C - h,
      groupId: `translate:${i}`
    }), y && v && un && Dt && (un(v), Dt("intlify message compilation", y, v));
  }
  return x.locale = n, x.key = i, x.source = a, x;
}
function $U(e, i, n) {
  let a = null, r, o;
  process.env.NODE_ENV !== "production" && Yn && (a = window.performance.now(), r = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", un && un(r));
  const l = i(n);
  if (process.env.NODE_ENV !== "production" && Yn) {
    const c = window.performance.now(), h = e.__v_emitter;
    h && a && h.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: c - a,
      groupId: `translate:${i.key}`
    }), r && o && un && Dt && (un(o), Dt("intlify message evaluation", r, o));
  }
  return l;
}
function D3(...e) {
  const [i, n, a] = e, r = {};
  if (!le(i) && !k1(i) && !Sn(i) && !at(i))
    throw ai(A1.INVALID_ARGUMENT);
  const o = k1(i) ? String(i) : (Sn(i), i);
  return k1(n) ? r.plural = n : le(n) ? r.default = n : xe(n) && !N0(n) ? r.named = n : s1(n) && (r.list = n), k1(a) ? r.plural = a : le(a) ? r.default = a : xe(a) && O1(r, a), [o, r];
}
function eR(e, i, n, a, r, o) {
  return {
    locale: i,
    key: n,
    warnHtmlMessage: r,
    onError: (l) => {
      if (o && o(l), process.env.NODE_ENV !== "production") {
        const c = nR(a), h = `Message compilation error: ${l.message}`, y = l.location && c && BP(c, l.location.start.offset, l.location.end.offset), v = e.__v_emitter;
        v && c && v.emit("compile-error", {
          message: c,
          error: l.message,
          start: l.location && l.location.start.offset,
          end: l.location && l.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(y ? `${h}
${y}` : h);
      } else
        throw l;
    },
    onCacheKey: (l) => LP(i, n, l)
  };
}
function nR(e) {
  if (le(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function iR(e, i, n, a) {
  const { modifiers: r, pluralRules: o, messageResolver: l, fallbackLocale: c, fallbackWarn: h, missingWarn: y, fallbackContext: v } = e, C = {
    locale: i,
    modifiers: r,
    pluralRules: o,
    messages: (M) => {
      let z = l(n, M);
      if (z == null && v) {
        const [, , R] = nc(v, M, i, c, h, y);
        z = l(R, M);
      }
      if (le(z) || at(z)) {
        let R = !1;
        const G = ic(e, M, i, z, M, () => {
          R = !0;
        });
        return R ? B4 : G;
      } else
        return Sn(z) ? z : B4;
    }
  };
  return e.processor && (C.processor = e.processor), a.list && (C.list = a.list), a.named && (C.named = a.named), k1(a.plural) && (C.pluralIndex = a.plural), C;
}
const H4 = typeof Intl < "u", tc = {
  dateTimeFormat: H4 && typeof Intl.DateTimeFormat < "u",
  numberFormat: H4 && typeof Intl.NumberFormat < "u"
};
function j4(e, ...i) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: r, onWarn: o, localeFallbacker: l } = e, { __datetimeFormatters: c } = e;
  if (process.env.NODE_ENV !== "production" && !tc.dateTimeFormat)
    return o(At(W1.CANNOT_FORMAT_DATE)), f0;
  const [h, y, v, x] = A3(...i), C = Ne(v.missingWarn) ? v.missingWarn : e.missingWarn, M = Ne(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn, z = !!v.part, R = go(e, v), U = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    R
  );
  if (!le(h) || h === "")
    return new Intl.DateTimeFormat(R, x).format(y);
  let G = {}, re, I = null, V = R, K = null;
  const H = "datetime format";
  for (let ee = 0; ee < U.length; ee++) {
    if (re = K = U[ee], process.env.NODE_ENV !== "production" && R !== re && B0(M, h) && o(At(W1.FALLBACK_TO_DATE_FORMAT, {
      key: h,
      target: re
    })), process.env.NODE_ENV !== "production" && R !== re) {
      const Pe = e.__v_emitter;
      Pe && Pe.emit("fallback", {
        type: H,
        key: h,
        from: V,
        to: K,
        groupId: `${H}:${h}`
      });
    }
    if (G = n[re] || {}, I = G[h], xe(I))
      break;
    _o(e, h, re, C, H), V = K;
  }
  if (!xe(I) || !le(re))
    return a ? I0 : h;
  let Y = `${re}__${h}`;
  N0(x) || (Y = `${Y}__${JSON.stringify(x)}`);
  let ae = c.get(Y);
  return ae || (ae = new Intl.DateTimeFormat(re, O1({}, I, x)), c.set(Y, ae)), z ? ae.formatToParts(y) : ae.format(y);
}
const ac = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function A3(...e) {
  const [i, n, a, r] = e, o = {};
  let l = {}, c;
  if (le(i)) {
    const h = i.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!h)
      throw ai(A1.INVALID_ISO_DATE_ARGUMENT);
    const y = h[3] ? h[3].trim().startsWith("T") ? `${h[1].trim()}${h[3].trim()}` : `${h[1].trim()}T${h[3].trim()}` : h[1].trim();
    c = new Date(y);
    try {
      c.toISOString();
    } catch {
      throw ai(A1.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (SP(i)) {
    if (isNaN(i.getTime()))
      throw ai(A1.INVALID_DATE_ARGUMENT);
    c = i;
  } else if (k1(i))
    c = i;
  else
    throw ai(A1.INVALID_ARGUMENT);
  return le(n) ? o.key = n : xe(n) && Object.keys(n).forEach((h) => {
    ac.includes(h) ? l[h] = n[h] : o[h] = n[h];
  }), le(a) ? o.locale = a : xe(a) && (l = a), xe(r) && (l = r), [o.key || "", c, o, l];
}
function V4(e, i, n) {
  const a = e;
  for (const r in n) {
    const o = `${i}__${r}`;
    a.__datetimeFormatters.has(o) && a.__datetimeFormatters.delete(o);
  }
}
function F4(e, ...i) {
  const { numberFormats: n, unresolving: a, fallbackLocale: r, onWarn: o, localeFallbacker: l } = e, { __numberFormatters: c } = e;
  if (process.env.NODE_ENV !== "production" && !tc.numberFormat)
    return o(At(W1.CANNOT_FORMAT_NUMBER)), f0;
  const [h, y, v, x] = L3(...i), C = Ne(v.missingWarn) ? v.missingWarn : e.missingWarn, M = Ne(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn, z = !!v.part, R = go(e, v), U = l(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    R
  );
  if (!le(h) || h === "")
    return new Intl.NumberFormat(R, x).format(y);
  let G = {}, re, I = null, V = R, K = null;
  const H = "number format";
  for (let ee = 0; ee < U.length; ee++) {
    if (re = K = U[ee], process.env.NODE_ENV !== "production" && R !== re && B0(M, h) && o(At(W1.FALLBACK_TO_NUMBER_FORMAT, {
      key: h,
      target: re
    })), process.env.NODE_ENV !== "production" && R !== re) {
      const Pe = e.__v_emitter;
      Pe && Pe.emit("fallback", {
        type: H,
        key: h,
        from: V,
        to: K,
        groupId: `${H}:${h}`
      });
    }
    if (G = n[re] || {}, I = G[h], xe(I))
      break;
    _o(e, h, re, C, H), V = K;
  }
  if (!xe(I) || !le(re))
    return a ? I0 : h;
  let Y = `${re}__${h}`;
  N0(x) || (Y = `${Y}__${JSON.stringify(x)}`);
  let ae = c.get(Y);
  return ae || (ae = new Intl.NumberFormat(re, O1({}, I, x)), c.set(Y, ae)), z ? ae.formatToParts(y) : ae.format(y);
}
const sc = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function L3(...e) {
  const [i, n, a, r] = e, o = {};
  let l = {};
  if (!k1(i))
    throw ai(A1.INVALID_ARGUMENT);
  const c = i;
  return le(n) ? o.key = n : xe(n) && Object.keys(n).forEach((h) => {
    sc.includes(h) ? l[h] = n[h] : o[h] = n[h];
  }), le(a) ? o.locale = a : xe(a) && (l = a), xe(r) && (l = r), [o.key || "", c, o, l];
}
function P4(e, i, n) {
  const a = e;
  for (const r in n) {
    const o = `${i}__${r}`;
    a.__numberFormatters.has(o) && a.__numberFormatters.delete(o);
  }
}
mU();
function tR() {
  return oc().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function oc() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const aR = typeof Proxy == "function", sR = "devtools-plugin:setup", oR = "plugin:settings:set";
let Qt, T3;
function rR() {
  var e;
  return Qt !== void 0 || (typeof window < "u" && window.performance ? (Qt = !0, T3 = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Qt = !0, T3 = globalThis.perf_hooks.performance) : Qt = !1), Qt;
}
function lR() {
  return rR() ? T3.now() : Date.now();
}
class dR {
  constructor(i, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = i, this.hook = n;
    const a = {};
    if (i.settings)
      for (const l in i.settings) {
        const c = i.settings[l];
        a[l] = c.defaultValue;
      }
    const r = `__vue-devtools-plugin-settings__${i.id}`;
    let o = Object.assign({}, a);
    try {
      const l = localStorage.getItem(r), c = JSON.parse(l);
      Object.assign(o, c);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return o;
      },
      setSettings(l) {
        try {
          localStorage.setItem(r, JSON.stringify(l));
        } catch {
        }
        o = l;
      },
      now() {
        return lR();
      }
    }, n && n.on(oR, (l, c) => {
      l === this.plugin.id && this.fallbacks.setSettings(c);
    }), this.proxiedOn = new Proxy({}, {
      get: (l, c) => this.target ? this.target.on[c] : (...h) => {
        this.onQueue.push({
          method: c,
          args: h
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (l, c) => this.target ? this.target[c] : c === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(c) ? (...h) => (this.targetQueue.push({
        method: c,
        args: h,
        resolve: () => {
        }
      }), this.fallbacks[c](...h)) : (...h) => new Promise((y) => {
        this.targetQueue.push({
          method: c,
          args: h,
          resolve: y
        });
      })
    });
  }
  async setRealTarget(i) {
    this.target = i;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function cR(e, i) {
  const n = e, a = oc(), r = tR(), o = aR && n.enableEarlyProxy;
  if (r && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !o))
    r.emit(sR, e, i);
  else {
    const l = o ? new dR(n, r) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: i,
      proxy: l
    }), l && i(l.proxiedTarget);
  }
}
/*!
  * vue-i18n v9.12.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const fR = "9.12.1";
function uR() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Di().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Di().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Di().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Di().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Di().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const rc = W1.__EXTEND_POINT__, xi = E0(rc), u1 = {
  FALLBACK_TO_ROOT: rc,
  // 9
  NOT_SUPPORTED_PRESERVE: xi(),
  // 10
  NOT_SUPPORTED_FORMATTER: xi(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: xi(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: xi(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: xi(),
  // 14
  NOT_FOUND_PARENT_SCOPE: xi(),
  // 15
  IGNORE_OBJ_FLATTEN: xi(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: xi(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: xi()
  // 18
}, hR = {
  [u1.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [u1.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [u1.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [u1.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [u1.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [u1.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [u1.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [u1.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [u1.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [u1.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function an(e, ...i) {
  return po(hR[e], ...i);
}
const lc = A1.__EXTEND_POINT__, nn = E0(lc), Re = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: lc,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: nn(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: nn(),
  // 26
  NOT_INSTALLED: nn(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: nn(),
  // 28
  // directive module errors
  REQUIRED_VALUE: nn(),
  // 29
  INVALID_VALUE: nn(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: nn(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: nn(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: nn(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: nn(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: nn(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: nn(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: nn(),
  // 37
  // for enhancement
  __EXTEND_POINT__: nn()
  // 38
};
function M1(e, ...i) {
  return h2(e, null, process.env.NODE_ENV !== "production" ? { messages: mR, args: i } : void 0);
}
const mR = {
  [Re.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Re.INVALID_ARGUMENT]: "Invalid argument",
  [Re.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Re.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Re.UNEXPECTED_ERROR]: "Unexpected error",
  [Re.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [Re.REQUIRED_VALUE]: "Required in value: {0}",
  [Re.INVALID_VALUE]: "Invalid value",
  [Re.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Re.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Re.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Re.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [Re.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [Re.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, S3 = /* @__PURE__ */ fi("__translateVNode"), N3 = /* @__PURE__ */ fi("__datetimeParts"), E3 = /* @__PURE__ */ fi("__numberParts"), Lt = /* @__PURE__ */ fi("__enableEmitter"), W2 = /* @__PURE__ */ fi("__disableEmitter"), dc = fi("__setPluralRules"), cc = /* @__PURE__ */ fi("__injectWithOption"), z3 = /* @__PURE__ */ fi("__dispose");
function Q2(e) {
  if (!We(e))
    return e;
  for (const i in e)
    if (d0(e, i))
      if (!i.includes("."))
        We(e[i]) && Q2(e[i]);
      else {
        const n = i.split("."), a = n.length - 1;
        let r = e, o = !1;
        for (let l = 0; l < a; l++) {
          if (n[l] in r || (r[n[l]] = {}), !We(r[n[l]])) {
            process.env.NODE_ENV !== "production" && x1(an(u1.IGNORE_OBJ_FLATTEN, {
              key: n[l]
            })), o = !0;
            break;
          }
          r = r[n[l]];
        }
        o || (r[n[a]] = e[i], delete e[i]), We(r[n[a]]) && Q2(r[n[a]]);
      }
  return e;
}
function O0(e, i) {
  const { messages: n, __i18n: a, messageResolver: r, flatJson: o } = i, l = xe(n) ? n : s1(a) ? {} : { [e]: {} };
  if (s1(a) && a.forEach((c) => {
    if ("locale" in c && "resource" in c) {
      const { locale: h, resource: y } = c;
      h ? (l[h] = l[h] || {}, $a(y, l[h])) : $a(y, l);
    } else
      le(c) && $a(JSON.parse(c), l);
  }), r == null && o)
    for (const c in l)
      d0(l, c) && Q2(l[c]);
  return l;
}
function fc(e) {
  return e.type;
}
function uc(e, i, n) {
  let a = We(i.messages) ? i.messages : {};
  "__i18nGlobal" in n && (a = O0(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(a);
  r.length && r.forEach((o) => {
    e.mergeLocaleMessage(o, a[o]);
  });
  {
    if (We(i.datetimeFormats)) {
      const o = Object.keys(i.datetimeFormats);
      o.length && o.forEach((l) => {
        e.mergeDateTimeFormat(l, i.datetimeFormats[l]);
      });
    }
    if (We(i.numberFormats)) {
      const o = Object.keys(i.numberFormats);
      o.length && o.forEach((l) => {
        e.mergeNumberFormat(l, i.numberFormats[l]);
      });
    }
  }
}
function U4(e) {
  return Z(Gm, null, e, 0);
}
const R4 = "__INTLIFY_META__", Y4 = () => [], pR = () => !1;
let Z4 = 0;
function W4(e) {
  return (i, n, a, r) => e(n, a, a2() || void 0, r);
}
const yR = () => {
  const e = a2();
  let i = null;
  return e && (i = fc(e)[R4]) ? { [R4]: i } : null;
};
function wo(e = {}, i) {
  const { __root: n, __injectWithOption: a } = e, r = n === void 0, o = e.flatJson, l = Yn ? L1 : Bl, c = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && c && jd(an(u1.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let h = Ne(e.inheritLocale) ? e.inheritLocale : !0;
  const y = l(
    // prettier-ignore
    n && h ? n.locale.value : le(e.locale) ? e.locale : o2
  ), v = l(
    // prettier-ignore
    n && h ? n.fallbackLocale.value : le(e.fallbackLocale) || s1(e.fallbackLocale) || xe(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : y.value
  ), x = l(O0(y.value, e)), C = l(xe(e.datetimeFormats) ? e.datetimeFormats : { [y.value]: {} }), M = l(xe(e.numberFormats) ? e.numberFormats : { [y.value]: {} });
  let z = n ? n.missingWarn : Ne(e.missingWarn) || tt(e.missingWarn) ? e.missingWarn : !0, R = n ? n.fallbackWarn : Ne(e.fallbackWarn) || tt(e.fallbackWarn) ? e.fallbackWarn : !0, U = n ? n.fallbackRoot : Ne(e.fallbackRoot) ? e.fallbackRoot : !0, G = !!e.fallbackFormat, re = n1(e.missing) ? e.missing : null, I = n1(e.missing) ? W4(e.missing) : null, V = n1(e.postTranslation) ? e.postTranslation : null, K = n ? n.warnHtmlMessage : Ne(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, H = !!e.escapeParameter;
  const Y = n ? n.modifiers : xe(e.modifiers) ? e.modifiers : {};
  let ae = e.pluralRules || n && n.pluralRules, ee;
  ee = (() => {
    r && E4(null);
    const F = {
      version: fR,
      locale: y.value,
      fallbackLocale: v.value,
      messages: x.value,
      modifiers: Y,
      pluralRules: ae,
      missing: I === null ? void 0 : I,
      missingWarn: z,
      fallbackWarn: R,
      fallbackFormat: G,
      unresolving: !0,
      postTranslation: V === null ? void 0 : V,
      warnHtmlMessage: K,
      escapeParameter: H,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    F.datetimeFormats = C.value, F.numberFormats = M.value, F.__datetimeFormatters = xe(ee) ? ee.__datetimeFormatters : void 0, F.__numberFormatters = xe(ee) ? ee.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (F.__v_emitter = xe(ee) ? ee.__v_emitter : void 0);
    const ne = QU(F);
    return r && E4(ne), ne;
  })(), I2(ee, y.value, v.value);
  function N1() {
    return [
      y.value,
      v.value,
      x.value,
      C.value,
      M.value
    ];
  }
  const ze = T1({
    get: () => y.value,
    set: (F) => {
      y.value = F, ee.locale = y.value;
    }
  }), _1 = T1({
    get: () => v.value,
    set: (F) => {
      v.value = F, ee.fallbackLocale = v.value, I2(ee, y.value, F);
    }
  }), Qn = T1(() => x.value), ot = /* @__PURE__ */ T1(() => C.value), vn = /* @__PURE__ */ T1(() => M.value);
  function sn() {
    return n1(V) ? V : null;
  }
  function G1(F) {
    V = F, ee.postTranslation = F;
  }
  function rt() {
    return re;
  }
  function qn(F) {
    F !== null && (I = W4(F)), re = F, ee.missing = I;
  }
  function H1(F, ne) {
    return F !== "translate" || !ne.resolvedMessage;
  }
  const X1 = (F, ne, Ve, o1, _n, Pi) => {
    N1();
    let $n;
    try {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && YU(yR()), r || (ee.fallbackContext = n ? WU() : void 0), $n = F(ee);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (ee.fallbackContext = void 0);
    }
    if (Ve !== "translate exists" && // for not `te` (e.g `t`)
    k1($n) && $n === I0 || Ve === "translate exists" && !$n) {
      const [In, y2] = ne();
      if (process.env.NODE_ENV !== "production" && n && le(In) && H1(Ve, y2) && (U && (B0(R, In) || Xd(z, In)) && x1(an(u1.FALLBACK_TO_ROOT, {
        key: In,
        type: Ve
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: St } = ee;
        St && U && St.emit("fallback", {
          type: Ve,
          key: In,
          to: "global",
          groupId: `${Ve}:${In}`
        });
      }
      return n && U ? o1(n) : _n(In);
    } else {
      if (Pi($n))
        return $n;
      throw M1(Re.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Oi(...F) {
    return X1((ne) => Reflect.apply(O4, null, [ne, ...F]), () => D3(...F), "translate", (ne) => Reflect.apply(ne.t, ne, [...F]), (ne) => ne, (ne) => le(ne));
  }
  function Hi(...F) {
    const [ne, Ve, o1] = F;
    if (o1 && !We(o1))
      throw M1(Re.INVALID_ARGUMENT);
    return Oi(ne, Ve, O1({ resolvedMessage: !0 }, o1 || {}));
  }
  function gn(...F) {
    return X1((ne) => Reflect.apply(j4, null, [ne, ...F]), () => A3(...F), "datetime format", (ne) => Reflect.apply(ne.d, ne, [...F]), () => f0, (ne) => le(ne));
  }
  function Gn(...F) {
    return X1((ne) => Reflect.apply(F4, null, [ne, ...F]), () => L3(...F), "number format", (ne) => Reflect.apply(ne.n, ne, [...F]), () => f0, (ne) => le(ne));
  }
  function lt(F) {
    return F.map((ne) => le(ne) || k1(ne) || Ne(ne) ? U4(String(ne)) : ne);
  }
  const zn = {
    normalize: lt,
    interpolate: (F) => F,
    type: "vnode"
  };
  function ji(...F) {
    return X1(
      (ne) => {
        let Ve;
        const o1 = ne;
        try {
          o1.processor = zn, Ve = Reflect.apply(O4, null, [o1, ...F]);
        } finally {
          o1.processor = null;
        }
        return Ve;
      },
      () => D3(...F),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ne) => ne[S3](...F),
      (ne) => [U4(ne)],
      (ne) => s1(ne)
    );
  }
  function Jn(...F) {
    return X1(
      (ne) => Reflect.apply(F4, null, [ne, ...F]),
      () => L3(...F),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ne) => ne[E3](...F),
      Y4,
      (ne) => le(ne) || s1(ne)
    );
  }
  function Kn(...F) {
    return X1(
      (ne) => Reflect.apply(j4, null, [ne, ...F]),
      () => A3(...F),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (ne) => ne[N3](...F),
      Y4,
      (ne) => le(ne) || s1(ne)
    );
  }
  function Vi(F) {
    ae = F, ee.pluralRules = ae;
  }
  function ie(F, ne) {
    return X1(() => {
      if (!F)
        return !1;
      const Ve = le(ne) ? ne : y.value, o1 = E1(Ve), _n = ee.messageResolver(o1, F);
      return c ? _n != null : at(_n) || Sn(_n) || le(_n);
    }, () => [F], "translate exists", (Ve) => Reflect.apply(Ve.te, Ve, [F, ne]), pR, (Ve) => Ne(Ve));
  }
  function Ie(F) {
    let ne = null;
    const Ve = Yd(ee, v.value, y.value);
    for (let o1 = 0; o1 < Ve.length; o1++) {
      const _n = x.value[Ve[o1]] || {}, Pi = ee.messageResolver(_n, F);
      if (Pi != null) {
        ne = Pi;
        break;
      }
    }
    return ne;
  }
  function dt(F) {
    const ne = Ie(F);
    return ne ?? (n ? n.tm(F) || {} : {});
  }
  function E1(F) {
    return x.value[F] || {};
  }
  function Fi(F, ne) {
    if (o) {
      const Ve = { [F]: ne };
      for (const o1 in Ve)
        d0(Ve, o1) && Q2(Ve[o1]);
      ne = Ve[F];
    }
    x.value[F] = ne, ee.messages = x.value;
  }
  function p2(F, ne) {
    x.value[F] = x.value[F] || {};
    const Ve = { [F]: ne };
    if (o)
      for (const o1 in Ve)
        d0(Ve, o1) && Q2(Ve[o1]);
    ne = Ve[F], $a(ne, x.value[F]), ee.messages = x.value;
  }
  function D(F) {
    return C.value[F] || {};
  }
  function L(F, ne) {
    C.value[F] = ne, ee.datetimeFormats = C.value, V4(ee, F, ne);
  }
  function X(F, ne) {
    C.value[F] = O1(C.value[F] || {}, ne), ee.datetimeFormats = C.value, V4(ee, F, ne);
  }
  function ve(F) {
    return M.value[F] || {};
  }
  function Te(F, ne) {
    M.value[F] = ne, ee.numberFormats = M.value, P4(ee, F, ne);
  }
  function Ue(F, ne) {
    M.value[F] = O1(M.value[F] || {}, ne), ee.numberFormats = M.value, P4(ee, F, ne);
  }
  Z4++, n && Yn && (Si(n.locale, (F) => {
    h && (y.value = F, ee.locale = F, I2(ee, y.value, v.value));
  }), Si(n.fallbackLocale, (F) => {
    h && (v.value = F, ee.fallbackLocale = F, I2(ee, y.value, v.value));
  }));
  const Xe = {
    id: Z4,
    locale: ze,
    fallbackLocale: _1,
    get inheritLocale() {
      return h;
    },
    set inheritLocale(F) {
      h = F, F && n && (y.value = n.locale.value, v.value = n.fallbackLocale.value, I2(ee, y.value, v.value));
    },
    get availableLocales() {
      return Object.keys(x.value).sort();
    },
    messages: Qn,
    get modifiers() {
      return Y;
    },
    get pluralRules() {
      return ae || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return z;
    },
    set missingWarn(F) {
      z = F, ee.missingWarn = z;
    },
    get fallbackWarn() {
      return R;
    },
    set fallbackWarn(F) {
      R = F, ee.fallbackWarn = R;
    },
    get fallbackRoot() {
      return U;
    },
    set fallbackRoot(F) {
      U = F;
    },
    get fallbackFormat() {
      return G;
    },
    set fallbackFormat(F) {
      G = F, ee.fallbackFormat = G;
    },
    get warnHtmlMessage() {
      return K;
    },
    set warnHtmlMessage(F) {
      K = F, ee.warnHtmlMessage = F;
    },
    get escapeParameter() {
      return H;
    },
    set escapeParameter(F) {
      H = F, ee.escapeParameter = F;
    },
    t: Oi,
    getLocaleMessage: E1,
    setLocaleMessage: Fi,
    mergeLocaleMessage: p2,
    getPostTranslationHandler: sn,
    setPostTranslationHandler: G1,
    getMissingHandler: rt,
    setMissingHandler: qn,
    [dc]: Vi
  };
  return Xe.datetimeFormats = ot, Xe.numberFormats = vn, Xe.rt = Hi, Xe.te = ie, Xe.tm = dt, Xe.d = gn, Xe.n = Gn, Xe.getDateTimeFormat = D, Xe.setDateTimeFormat = L, Xe.mergeDateTimeFormat = X, Xe.getNumberFormat = ve, Xe.setNumberFormat = Te, Xe.mergeNumberFormat = Ue, Xe[cc] = a, Xe[S3] = ji, Xe[N3] = Kn, Xe[E3] = Jn, process.env.NODE_ENV !== "production" && (Xe[Lt] = (F) => {
    ee.__v_emitter = F;
  }, Xe[W2] = () => {
    ee.__v_emitter = void 0;
  }), Xe;
}
function vR(e) {
  const i = le(e.locale) ? e.locale : o2, n = le(e.fallbackLocale) || s1(e.fallbackLocale) || xe(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i, a = n1(e.missing) ? e.missing : void 0, r = Ne(e.silentTranslationWarn) || tt(e.silentTranslationWarn) ? !e.silentTranslationWarn : !0, o = Ne(e.silentFallbackWarn) || tt(e.silentFallbackWarn) ? !e.silentFallbackWarn : !0, l = Ne(e.fallbackRoot) ? e.fallbackRoot : !0, c = !!e.formatFallbackMessages, h = xe(e.modifiers) ? e.modifiers : {}, y = e.pluralizationRules, v = n1(e.postTranslation) ? e.postTranslation : void 0, x = le(e.warnHtmlInMessage) ? e.warnHtmlInMessage !== "off" : !0, C = !!e.escapeParameterHtml, M = Ne(e.sync) ? e.sync : !0;
  process.env.NODE_ENV !== "production" && e.formatter && x1(an(u1.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && e.preserveDirectiveContent && x1(an(u1.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let z = e.messages;
  if (xe(e.sharedMessages)) {
    const H = e.sharedMessages;
    z = Object.keys(H).reduce((ae, ee) => {
      const Pe = ae[ee] || (ae[ee] = {});
      return O1(Pe, H[ee]), ae;
    }, z || {});
  }
  const { __i18n: R, __root: U, __injectWithOption: G } = e, re = e.datetimeFormats, I = e.numberFormats, V = e.flatJson, K = e.translateExistCompatible;
  return {
    locale: i,
    fallbackLocale: n,
    messages: z,
    flatJson: V,
    datetimeFormats: re,
    numberFormats: I,
    missing: a,
    missingWarn: r,
    fallbackWarn: o,
    fallbackRoot: l,
    fallbackFormat: c,
    modifiers: h,
    pluralRules: y,
    postTranslation: v,
    warnHtmlMessage: x,
    escapeParameter: C,
    messageResolver: e.messageResolver,
    inheritLocale: M,
    translateExistCompatible: K,
    __i18n: R,
    __root: U,
    __injectWithOption: G
  };
}
function I3(e = {}, i) {
  {
    const n = wo(vR(e)), { __extender: a } = e, r = {
      // id
      id: n.id,
      // locale
      get locale() {
        return n.locale.value;
      },
      set locale(o) {
        n.locale.value = o;
      },
      // fallbackLocale
      get fallbackLocale() {
        return n.fallbackLocale.value;
      },
      set fallbackLocale(o) {
        n.fallbackLocale.value = o;
      },
      // messages
      get messages() {
        return n.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return n.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return n.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return n.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && x1(an(u1.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(o) {
        process.env.NODE_ENV !== "production" && x1(an(u1.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return n.getMissingHandler();
      },
      set missing(o) {
        n.setMissingHandler(o);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return Ne(n.missingWarn) ? !n.missingWarn : n.missingWarn;
      },
      set silentTranslationWarn(o) {
        n.missingWarn = Ne(o) ? !o : o;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return Ne(n.fallbackWarn) ? !n.fallbackWarn : n.fallbackWarn;
      },
      set silentFallbackWarn(o) {
        n.fallbackWarn = Ne(o) ? !o : o;
      },
      // modifiers
      get modifiers() {
        return n.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return n.fallbackFormat;
      },
      set formatFallbackMessages(o) {
        n.fallbackFormat = o;
      },
      // postTranslation
      get postTranslation() {
        return n.getPostTranslationHandler();
      },
      set postTranslation(o) {
        n.setPostTranslationHandler(o);
      },
      // sync
      get sync() {
        return n.inheritLocale;
      },
      set sync(o) {
        n.inheritLocale = o;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return n.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(o) {
        n.warnHtmlMessage = o !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return n.escapeParameter;
      },
      set escapeParameterHtml(o) {
        n.escapeParameter = o;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && x1(an(u1.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(o) {
        process.env.NODE_ENV !== "production" && x1(an(u1.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return n.pluralRules || {};
      },
      // for internal
      __composer: n,
      // t
      t(...o) {
        const [l, c, h] = o, y = {};
        let v = null, x = null;
        if (!le(l))
          throw M1(Re.INVALID_ARGUMENT);
        const C = l;
        return le(c) ? y.locale = c : s1(c) ? v = c : xe(c) && (x = c), s1(h) ? v = h : xe(h) && (x = h), Reflect.apply(n.t, n, [
          C,
          v || x || {},
          y
        ]);
      },
      rt(...o) {
        return Reflect.apply(n.rt, n, [...o]);
      },
      // tc
      tc(...o) {
        const [l, c, h] = o, y = { plural: 1 };
        let v = null, x = null;
        if (!le(l))
          throw M1(Re.INVALID_ARGUMENT);
        const C = l;
        return le(c) ? y.locale = c : k1(c) ? y.plural = c : s1(c) ? v = c : xe(c) && (x = c), le(h) ? y.locale = h : s1(h) ? v = h : xe(h) && (x = h), Reflect.apply(n.t, n, [
          C,
          v || x || {},
          y
        ]);
      },
      // te
      te(o, l) {
        return n.te(o, l);
      },
      // tm
      tm(o) {
        return n.tm(o);
      },
      // getLocaleMessage
      getLocaleMessage(o) {
        return n.getLocaleMessage(o);
      },
      // setLocaleMessage
      setLocaleMessage(o, l) {
        n.setLocaleMessage(o, l);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(o, l) {
        n.mergeLocaleMessage(o, l);
      },
      // d
      d(...o) {
        return Reflect.apply(n.d, n, [...o]);
      },
      // getDateTimeFormat
      getDateTimeFormat(o) {
        return n.getDateTimeFormat(o);
      },
      // setDateTimeFormat
      setDateTimeFormat(o, l) {
        n.setDateTimeFormat(o, l);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(o, l) {
        n.mergeDateTimeFormat(o, l);
      },
      // n
      n(...o) {
        return Reflect.apply(n.n, n, [...o]);
      },
      // getNumberFormat
      getNumberFormat(o) {
        return n.getNumberFormat(o);
      },
      // setNumberFormat
      setNumberFormat(o, l) {
        n.setNumberFormat(o, l);
      },
      // mergeNumberFormat
      mergeNumberFormat(o, l) {
        n.mergeNumberFormat(o, l);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(o, l) {
        return process.env.NODE_ENV !== "production" && x1(an(u1.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return r.__extender = a, process.env.NODE_ENV !== "production" && (r.__enableEmitter = (o) => {
      const l = n;
      l[Lt] && l[Lt](o);
    }, r.__disableEmitter = () => {
      const o = n;
      o[W2] && o[W2]();
    }), r;
  }
}
const Co = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function gR({ slots: e }, i) {
  return i.length === 1 && i[0] === "default" ? (e.default ? e.default() : []).reduce((a, r) => [
    ...a,
    // prettier-ignore
    ...r.type === se ? r.children : [r]
  ], []) : i.reduce((n, a) => {
    const r = e[a];
    return r && (n[a] = r()), n;
  }, {});
}
function hc(e) {
  return se;
}
const _R = /* @__PURE__ */ g0({
  /* eslint-disable */
  name: "i18n-t",
  props: O1({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => k1(e) || !isNaN(e)
    }
  }, Co),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, i) {
    const { slots: n, attrs: a } = i, r = e.i18n || xo({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const o = Object.keys(n).filter((x) => x !== "_"), l = {};
      e.locale && (l.locale = e.locale), e.plural !== void 0 && (l.plural = le(e.plural) ? +e.plural : e.plural);
      const c = gR(i, o), h = r[S3](e.keypath, c, l), y = O1({}, a), v = le(e.tag) || We(e.tag) ? e.tag : hc();
      return zl(v, y, h);
    };
  }
}), r3 = _R;
function wR(e) {
  return s1(e) && !le(e[0]);
}
function mc(e, i, n, a) {
  const { slots: r, attrs: o } = i;
  return () => {
    const l = { part: !0 };
    let c = {};
    e.locale && (l.locale = e.locale), le(e.format) ? l.key = e.format : We(e.format) && (le(e.format.key) && (l.key = e.format.key), c = Object.keys(e.format).reduce((C, M) => n.includes(M) ? O1({}, C, { [M]: e.format[M] }) : C, {}));
    const h = a(e.value, l, c);
    let y = [l.key];
    s1(h) ? y = h.map((C, M) => {
      const z = r[C.type], R = z ? z({ [C.type]: C.value, index: M, parts: h }) : [C.value];
      return wR(R) && (R[0].key = `${C.type}-${M}`), R;
    }) : le(h) && (y = [h]);
    const v = O1({}, o), x = le(e.tag) || We(e.tag) ? e.tag : hc();
    return zl(x, v, y);
  };
}
const CR = /* @__PURE__ */ g0({
  /* eslint-disable */
  name: "i18n-n",
  props: O1({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Co),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, i) {
    const n = e.i18n || xo({
      useScope: e.scope,
      __useComponent: !0
    });
    return mc(e, i, sc, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[E3](...a)
    ));
  }
}), Q4 = CR, kR = /* @__PURE__ */ g0({
  /* eslint-disable */
  name: "i18n-d",
  props: O1({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, Co),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, i) {
    const n = e.i18n || xo({
      useScope: e.scope,
      __useComponent: !0
    });
    return mc(e, i, ac, (...a) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[N3](...a)
    ));
  }
}), q4 = kR;
function xR(e, i) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(i) || e.global;
  {
    const a = n.__getInstance(i);
    return a != null ? a.__composer : e.global.__composer;
  }
}
function bR(e) {
  const i = (l) => {
    const { instance: c, modifiers: h, value: y } = l;
    if (!c || !c.$)
      throw M1(Re.UNEXPECTED_ERROR);
    const v = xR(e, c.$);
    process.env.NODE_ENV !== "production" && h.preserve && x1(an(u1.NOT_SUPPORTED_PRESERVE));
    const x = G4(y);
    return [
      Reflect.apply(v.t, v, [...X4(x)]),
      v
    ];
  };
  return {
    created: (l, c) => {
      const [h, y] = i(c);
      Yn && e.global === y && (l.__i18nWatcher = Si(y.locale, () => {
        c.instance && c.instance.$forceUpdate();
      })), l.__composer = y, l.textContent = h;
    },
    unmounted: (l) => {
      Yn && l.__i18nWatcher && (l.__i18nWatcher(), l.__i18nWatcher = void 0, delete l.__i18nWatcher), l.__composer && (l.__composer = void 0, delete l.__composer);
    },
    beforeUpdate: (l, { value: c }) => {
      if (l.__composer) {
        const h = l.__composer, y = G4(c);
        l.textContent = Reflect.apply(h.t, h, [
          ...X4(y)
        ]);
      }
    },
    getSSRProps: (l) => {
      const [c] = i(l);
      return { textContent: c };
    }
  };
}
function G4(e) {
  if (le(e))
    return { path: e };
  if (xe(e)) {
    if (!("path" in e))
      throw M1(Re.REQUIRED_VALUE, "path");
    return e;
  } else
    throw M1(Re.INVALID_VALUE);
}
function X4(e) {
  const { path: i, locale: n, args: a, choice: r, plural: o } = e, l = {}, c = a || {};
  return le(n) && (l.locale = n), k1(r) && (l.plural = r), k1(o) && (l.plural = o), [i, c, l];
}
function MR(e, i, ...n) {
  const a = xe(n[0]) ? n[0] : {}, r = !!a.useI18nComponentName, o = Ne(a.globalInstall) ? a.globalInstall : !0;
  process.env.NODE_ENV !== "production" && o && r && x1(an(u1.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: r3.name
  })), o && ([r ? "i18n" : r3.name, "I18nT"].forEach((l) => e.component(l, r3)), [Q4.name, "I18nN"].forEach((l) => e.component(l, Q4)), [q4.name, "I18nD"].forEach((l) => e.component(l, q4))), e.directive("t", bR(i));
}
const l3 = {
  [
    "vue-devtools-plugin-vue-i18n"
    /* VueDevToolsIDs.PLUGIN */
  ]: "Vue I18n devtools",
  [
    "vue-i18n-resource-inspector"
    /* VueDevToolsIDs.CUSTOM_INSPECTOR */
  ]: "I18n Resources",
  [
    "vue-i18n-timeline"
    /* VueDevToolsIDs.TIMELINE */
  ]: "Vue I18n"
}, DR = {
  [
    "vue-i18n-resource-inspector"
    /* VueDevToolsIDs.CUSTOM_INSPECTOR */
  ]: "Search for scopes ..."
}, AR = {
  [
    "vue-i18n-timeline"
    /* VueDevToolsIDs.TIMELINE */
  ]: 16764185
}, pc = "vue-i18n: composer properties";
let B3;
async function LR(e, i) {
  return new Promise((n, a) => {
    try {
      cR({
        id: "vue-devtools-plugin-vue-i18n",
        label: l3[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [pc],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (r) => {
        B3 = r, r.on.visitComponentTree(({ componentInstance: l, treeNode: c }) => {
          TR(l, c, i);
        }), r.on.inspectComponent(({ componentInstance: l, instanceData: c }) => {
          l.vnode.el && l.vnode.el.__VUE_I18N__ && c && (i.mode === "legacy" ? l.vnode.el.__VUE_I18N__ !== i.global.__composer && J4(c, l.vnode.el.__VUE_I18N__) : J4(c, l.vnode.el.__VUE_I18N__));
        }), r.addInspector({
          id: "vue-i18n-resource-inspector",
          label: l3[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: DR[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), r.on.getInspectorTree((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && IR(l, i);
        });
        const o = /* @__PURE__ */ new Map();
        r.on.getInspectorState(async (l) => {
          if (l.app === e && l.inspectorId === "vue-i18n-resource-inspector")
            if (r.unhighlightElement(), OR(l, i), l.nodeId === "global") {
              if (!o.has(l.app)) {
                const [c] = await r.getComponentInstances(l.app);
                o.set(l.app, c);
              }
              r.highlightElement(o.get(l.app));
            } else {
              const c = BR(l.nodeId, i);
              c && r.highlightElement(c);
            }
        }), r.on.editInspectorState((l) => {
          l.app === e && l.inspectorId === "vue-i18n-resource-inspector" && jR(l, i);
        }), r.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: l3[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: AR[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (r) {
      console.error(r), a(!1);
    }
  });
}
function yc(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function TR(e, i, n) {
  const a = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== a) {
    const r = {
      label: `i18n (${yc(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    i.tags.push(r);
  }
}
function J4(e, i) {
  const n = pc;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: i.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: i.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: i.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: i.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: ko(i.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: i.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: i.numberFormats.value
  });
}
function ko(e) {
  const i = {};
  return Object.keys(e).forEach((n) => {
    const a = e[n];
    n1(a) && "source" in a ? i[n] = zR(a) : at(a) && a.loc && a.loc.source ? i[n] = a.loc.source : We(a) ? i[n] = ko(a) : i[n] = a;
  }), i;
}
const SR = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function NR(e) {
  return e.replace(/[<>"&]/g, ER);
}
function ER(e) {
  return SR[e] || e;
}
function zR(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${NR(e.source)}")` : "(?)"}`
    }
  };
}
function IR(e, i) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = i.mode === "composition" ? i.global : i.global.__composer;
  for (const [a, r] of i.__instances) {
    const o = i.mode === "composition" ? r : r.__composer;
    n !== o && e.rootNodes.push({
      id: o.id.toString(),
      label: `${yc(a)} Scope`
    });
  }
}
function BR(e, i) {
  let n = null;
  if (e !== "global") {
    for (const [a, r] of i.__instances.entries())
      if (r.id.toString() === e) {
        n = a;
        break;
      }
  }
  return n;
}
function vc(e, i) {
  if (e === "global")
    return i.mode === "composition" ? i.global : i.global.__composer;
  {
    const n = Array.from(i.__instances.values()).find((a) => a.id.toString() === e);
    return n ? i.mode === "composition" ? n : n.__composer : null;
  }
}
function OR(e, i) {
  const n = vc(e.nodeId, i);
  return n && (e.state = HR(n)), null;
}
function HR(e) {
  const i = {}, n = "Locale related info", a = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  i[n] = a;
  const r = "Locale messages info", o = [
    {
      type: r,
      key: "messages",
      editable: !1,
      value: ko(e.messages.value)
    }
  ];
  i[r] = o;
  {
    const l = "Datetime formats info", c = [
      {
        type: l,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    i[l] = c;
    const h = "Datetime formats info", y = [
      {
        type: h,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    i[h] = y;
  }
  return i;
}
function q2(e, i) {
  if (B3) {
    let n;
    i && "groupId" in i && (n = i.groupId, delete i.groupId), B3.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: i || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function jR(e, i) {
  const n = vc(e.nodeId, i);
  if (n) {
    const [a] = e.path;
    a === "locale" && le(e.state.value) ? n.locale.value = e.state.value : a === "fallbackLocale" && (le(e.state.value) || s1(e.state.value) || We(e.state.value)) ? n.fallbackLocale.value = e.state.value : a === "inheritLocale" && Ne(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
function VR(e, i, n) {
  return {
    beforeCreate() {
      const a = a2();
      if (!a)
        throw M1(Re.UNEXPECTED_ERROR);
      const r = this.$options;
      if (r.i18n) {
        const o = r.i18n;
        if (r.__i18n && (o.__i18n = r.__i18n), o.__root = i, this === this.$root)
          this.$i18n = K4(e, o);
        else {
          o.__injectWithOption = !0, o.__extender = n.__vueI18nExtend, this.$i18n = I3(o);
          const l = this.$i18n;
          l.__extender && (l.__disposer = l.__extender(this.$i18n));
        }
      } else if (r.__i18n)
        if (this === this.$root)
          this.$i18n = K4(e, r);
        else {
          this.$i18n = I3({
            __i18n: r.__i18n,
            __injectWithOption: !0,
            __extender: n.__vueI18nExtend,
            __root: i
          });
          const o = this.$i18n;
          o.__extender && (o.__disposer = o.__extender(this.$i18n));
        }
      else
        this.$i18n = e;
      r.__i18nGlobal && uc(i, r, r), this.$t = (...o) => this.$i18n.t(...o), this.$rt = (...o) => this.$i18n.rt(...o), this.$tc = (...o) => this.$i18n.tc(...o), this.$te = (o, l) => this.$i18n.te(o, l), this.$d = (...o) => this.$i18n.d(...o), this.$n = (...o) => this.$i18n.n(...o), this.$tm = (o) => this.$i18n.tm(o), n.__setInstance(a, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const a = this.$i18n;
        this.$el.__VUE_I18N__ = a.__composer;
        const r = this.__v_emitter = yo();
        a.__enableEmitter && a.__enableEmitter(r), r.on("*", q2);
      }
    },
    unmounted() {
      const a = a2();
      if (!a)
        throw M1(Re.UNEXPECTED_ERROR);
      const r = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", q2), delete this.__v_emitter), this.$i18n && (r.__disableEmitter && r.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, r.__disposer && (r.__disposer(), delete r.__disposer, delete r.__extender), n.__deleteInstance(a), delete this.$i18n;
    }
  };
}
function K4(e, i) {
  e.locale = i.locale || e.locale, e.fallbackLocale = i.fallbackLocale || e.fallbackLocale, e.missing = i.missing || e.missing, e.silentTranslationWarn = i.silentTranslationWarn || e.silentFallbackWarn, e.silentFallbackWarn = i.silentFallbackWarn || e.silentFallbackWarn, e.formatFallbackMessages = i.formatFallbackMessages || e.formatFallbackMessages, e.postTranslation = i.postTranslation || e.postTranslation, e.warnHtmlInMessage = i.warnHtmlInMessage || e.warnHtmlInMessage, e.escapeParameterHtml = i.escapeParameterHtml || e.escapeParameterHtml, e.sync = i.sync || e.sync, e.__composer[dc](i.pluralizationRules || e.pluralizationRules);
  const n = O0(e.locale, {
    messages: i.messages,
    __i18n: i.__i18n
  });
  return Object.keys(n).forEach((a) => e.mergeLocaleMessage(a, n[a])), i.datetimeFormats && Object.keys(i.datetimeFormats).forEach((a) => e.mergeDateTimeFormat(a, i.datetimeFormats[a])), i.numberFormats && Object.keys(i.numberFormats).forEach((a) => e.mergeNumberFormat(a, i.numberFormats[a])), e;
}
const FR = /* @__PURE__ */ fi("global-vue-i18n");
function PR(e = {}, i) {
  const n = __VUE_I18N_LEGACY_API__ && Ne(e.legacy) ? e.legacy : __VUE_I18N_LEGACY_API__, a = Ne(e.globalInjection) ? e.globalInjection : !0, r = __VUE_I18N_LEGACY_API__ && n ? !!e.allowComposition : !0, o = /* @__PURE__ */ new Map(), [l, c] = UR(e, n), h = /* @__PURE__ */ fi(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && n && r && x1(an(u1.NOTICE_DROP_ALLOW_COMPOSITION));
  function y(C) {
    return o.get(C) || null;
  }
  function v(C, M) {
    o.set(C, M);
  }
  function x(C) {
    o.delete(C);
  }
  {
    const C = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && n ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return r;
      },
      // install plugin
      async install(M, ...z) {
        if (process.env.NODE_ENV !== "production" && (M.__VUE_I18N__ = C), M.__VUE_I18N_SYMBOL__ = h, M.provide(M.__VUE_I18N_SYMBOL__, C), xe(z[0])) {
          const G = z[0];
          C.__composerExtend = G.__composerExtend, C.__vueI18nExtend = G.__vueI18nExtend;
        }
        let R = null;
        !n && a && (R = JR(M, C.global)), __VUE_I18N_FULL_INSTALL__ && MR(M, C, ...z), __VUE_I18N_LEGACY_API__ && n && M.mixin(VR(c, c.__composer, C));
        const U = M.unmount;
        if (M.unmount = () => {
          R && R(), C.dispose(), U();
        }, process.env.NODE_ENV !== "production") {
          if (!await LR(M, C))
            throw M1(Re.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const re = yo();
          if (n) {
            const I = c;
            I.__enableEmitter && I.__enableEmitter(re);
          } else {
            const I = c;
            I[Lt] && I[Lt](re);
          }
          re.on("*", q2);
        }
      },
      // global accessor
      get global() {
        return c;
      },
      dispose() {
        l.stop();
      },
      // @internal
      __instances: o,
      // @internal
      __getInstance: y,
      // @internal
      __setInstance: v,
      // @internal
      __deleteInstance: x
    };
    return C;
  }
}
function xo(e = {}) {
  const i = a2();
  if (i == null)
    throw M1(Re.MUST_BE_CALL_SETUP_TOP);
  if (!i.isCE && i.appContext.app != null && !i.appContext.app.__VUE_I18N_SYMBOL__)
    throw M1(Re.NOT_INSTALLED);
  const n = RR(i), a = ZR(n), r = fc(i), o = YR(e, r);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw M1(Re.NOT_AVAILABLE_IN_LEGACY_MODE);
    return GR(i, o, a, e);
  }
  if (o === "global")
    return uc(a, e, r), a;
  if (o === "parent") {
    let h = WR(n, i, e.__useComponent);
    return h == null && (process.env.NODE_ENV !== "production" && x1(an(u1.NOT_FOUND_PARENT_SCOPE)), h = a), h;
  }
  const l = n;
  let c = l.__getInstance(i);
  if (c == null) {
    const h = O1({}, e);
    "__i18n" in r && (h.__i18n = r.__i18n), a && (h.__root = a), c = wo(h), l.__composerExtend && (c[z3] = l.__composerExtend(c)), qR(l, i, c), l.__setInstance(i, c);
  }
  return c;
}
function UR(e, i, n) {
  const a = Zm();
  {
    const r = __VUE_I18N_LEGACY_API__ && i ? a.run(() => I3(e)) : a.run(() => wo(e));
    if (r == null)
      throw M1(Re.UNEXPECTED_ERROR);
    return [a, r];
  }
}
function RR(e) {
  {
    const i = v3(e.isCE ? FR : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!i)
      throw M1(e.isCE ? Re.NOT_INSTALLED_WITH_PROVIDE : Re.UNEXPECTED_ERROR);
    return i;
  }
}
function YR(e, i) {
  return N0(e) ? "__i18n" in i ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function ZR(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function WR(e, i, n = !1) {
  let a = null;
  const r = i.root;
  let o = QR(i, n);
  for (; o != null; ) {
    const l = e;
    if (e.mode === "composition")
      a = l.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const c = l.__getInstance(o);
      c != null && (a = c.__composer, n && a && !a[cc] && (a = null));
    }
    if (a != null || r === o)
      break;
    o = o.parent;
  }
  return a;
}
function QR(e, i = !1) {
  return e == null ? null : i && e.vnode.ctx || e.parent;
}
function qR(e, i, n) {
  let a = null;
  Il(() => {
    if (process.env.NODE_ENV !== "production" && i.vnode.el) {
      i.vnode.el.__VUE_I18N__ = n, a = yo();
      const r = n;
      r[Lt] && r[Lt](a), a.on("*", q2);
    }
  }, i), Wm(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && i.vnode.el && i.vnode.el.__VUE_I18N__ && (a && a.off("*", q2), r[W2] && r[W2](), delete i.vnode.el.__VUE_I18N__), e.__deleteInstance(i);
    const o = r[z3];
    o && (o(), delete r[z3]);
  }, i);
}
function GR(e, i, n, a = {}) {
  const r = i === "local", o = Bl(null);
  if (r && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw M1(Re.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const l = Ne(a.inheritLocale) ? a.inheritLocale : !le(a.locale), c = L1(
    // prettier-ignore
    !r || l ? n.locale.value : le(a.locale) ? a.locale : o2
  ), h = L1(
    // prettier-ignore
    !r || l ? n.fallbackLocale.value : le(a.fallbackLocale) || s1(a.fallbackLocale) || xe(a.fallbackLocale) || a.fallbackLocale === !1 ? a.fallbackLocale : c.value
  ), y = L1(O0(c.value, a)), v = L1(xe(a.datetimeFormats) ? a.datetimeFormats : { [c.value]: {} }), x = L1(xe(a.numberFormats) ? a.numberFormats : { [c.value]: {} }), C = r ? n.missingWarn : Ne(a.missingWarn) || tt(a.missingWarn) ? a.missingWarn : !0, M = r ? n.fallbackWarn : Ne(a.fallbackWarn) || tt(a.fallbackWarn) ? a.fallbackWarn : !0, z = r ? n.fallbackRoot : Ne(a.fallbackRoot) ? a.fallbackRoot : !0, R = !!a.fallbackFormat, U = n1(a.missing) ? a.missing : null, G = n1(a.postTranslation) ? a.postTranslation : null, re = r ? n.warnHtmlMessage : Ne(a.warnHtmlMessage) ? a.warnHtmlMessage : !0, I = !!a.escapeParameter, V = r ? n.modifiers : xe(a.modifiers) ? a.modifiers : {}, K = a.pluralRules || r && n.pluralRules;
  function H() {
    return [
      c.value,
      h.value,
      y.value,
      v.value,
      x.value
    ];
  }
  const Y = T1({
    get: () => o.value ? o.value.locale.value : c.value,
    set: (ie) => {
      o.value && (o.value.locale.value = ie), c.value = ie;
    }
  }), ae = T1({
    get: () => o.value ? o.value.fallbackLocale.value : h.value,
    set: (ie) => {
      o.value && (o.value.fallbackLocale.value = ie), h.value = ie;
    }
  }), ee = T1(() => o.value ? o.value.messages.value : y.value), Pe = T1(() => v.value), N1 = T1(() => x.value);
  function ze() {
    return o.value ? o.value.getPostTranslationHandler() : G;
  }
  function _1(ie) {
    o.value && o.value.setPostTranslationHandler(ie);
  }
  function Qn() {
    return o.value ? o.value.getMissingHandler() : U;
  }
  function ot(ie) {
    o.value && o.value.setMissingHandler(ie);
  }
  function vn(ie) {
    return H(), ie();
  }
  function sn(...ie) {
    return o.value ? vn(() => Reflect.apply(o.value.t, null, [...ie])) : vn(() => "");
  }
  function G1(...ie) {
    return o.value ? Reflect.apply(o.value.rt, null, [...ie]) : "";
  }
  function rt(...ie) {
    return o.value ? vn(() => Reflect.apply(o.value.d, null, [...ie])) : vn(() => "");
  }
  function qn(...ie) {
    return o.value ? vn(() => Reflect.apply(o.value.n, null, [...ie])) : vn(() => "");
  }
  function H1(ie) {
    return o.value ? o.value.tm(ie) : {};
  }
  function X1(ie, Ie) {
    return o.value ? o.value.te(ie, Ie) : !1;
  }
  function Oi(ie) {
    return o.value ? o.value.getLocaleMessage(ie) : {};
  }
  function Hi(ie, Ie) {
    o.value && (o.value.setLocaleMessage(ie, Ie), y.value[ie] = Ie);
  }
  function gn(ie, Ie) {
    o.value && o.value.mergeLocaleMessage(ie, Ie);
  }
  function Gn(ie) {
    return o.value ? o.value.getDateTimeFormat(ie) : {};
  }
  function lt(ie, Ie) {
    o.value && (o.value.setDateTimeFormat(ie, Ie), v.value[ie] = Ie);
  }
  function Xn(ie, Ie) {
    o.value && o.value.mergeDateTimeFormat(ie, Ie);
  }
  function zn(ie) {
    return o.value ? o.value.getNumberFormat(ie) : {};
  }
  function ji(ie, Ie) {
    o.value && (o.value.setNumberFormat(ie, Ie), x.value[ie] = Ie);
  }
  function Jn(ie, Ie) {
    o.value && o.value.mergeNumberFormat(ie, Ie);
  }
  const Kn = {
    get id() {
      return o.value ? o.value.id : -1;
    },
    locale: Y,
    fallbackLocale: ae,
    messages: ee,
    datetimeFormats: Pe,
    numberFormats: N1,
    get inheritLocale() {
      return o.value ? o.value.inheritLocale : l;
    },
    set inheritLocale(ie) {
      o.value && (o.value.inheritLocale = ie);
    },
    get availableLocales() {
      return o.value ? o.value.availableLocales : Object.keys(y.value);
    },
    get modifiers() {
      return o.value ? o.value.modifiers : V;
    },
    get pluralRules() {
      return o.value ? o.value.pluralRules : K;
    },
    get isGlobal() {
      return o.value ? o.value.isGlobal : !1;
    },
    get missingWarn() {
      return o.value ? o.value.missingWarn : C;
    },
    set missingWarn(ie) {
      o.value && (o.value.missingWarn = ie);
    },
    get fallbackWarn() {
      return o.value ? o.value.fallbackWarn : M;
    },
    set fallbackWarn(ie) {
      o.value && (o.value.missingWarn = ie);
    },
    get fallbackRoot() {
      return o.value ? o.value.fallbackRoot : z;
    },
    set fallbackRoot(ie) {
      o.value && (o.value.fallbackRoot = ie);
    },
    get fallbackFormat() {
      return o.value ? o.value.fallbackFormat : R;
    },
    set fallbackFormat(ie) {
      o.value && (o.value.fallbackFormat = ie);
    },
    get warnHtmlMessage() {
      return o.value ? o.value.warnHtmlMessage : re;
    },
    set warnHtmlMessage(ie) {
      o.value && (o.value.warnHtmlMessage = ie);
    },
    get escapeParameter() {
      return o.value ? o.value.escapeParameter : I;
    },
    set escapeParameter(ie) {
      o.value && (o.value.escapeParameter = ie);
    },
    t: sn,
    getPostTranslationHandler: ze,
    setPostTranslationHandler: _1,
    getMissingHandler: Qn,
    setMissingHandler: ot,
    rt: G1,
    d: rt,
    n: qn,
    tm: H1,
    te: X1,
    getLocaleMessage: Oi,
    setLocaleMessage: Hi,
    mergeLocaleMessage: gn,
    getDateTimeFormat: Gn,
    setDateTimeFormat: lt,
    mergeDateTimeFormat: Xn,
    getNumberFormat: zn,
    setNumberFormat: ji,
    mergeNumberFormat: Jn
  };
  function Vi(ie) {
    ie.locale.value = c.value, ie.fallbackLocale.value = h.value, Object.keys(y.value).forEach((Ie) => {
      ie.mergeLocaleMessage(Ie, y.value[Ie]);
    }), Object.keys(v.value).forEach((Ie) => {
      ie.mergeDateTimeFormat(Ie, v.value[Ie]);
    }), Object.keys(x.value).forEach((Ie) => {
      ie.mergeNumberFormat(Ie, x.value[Ie]);
    }), ie.escapeParameter = I, ie.fallbackFormat = R, ie.fallbackRoot = z, ie.fallbackWarn = M, ie.missingWarn = C, ie.warnHtmlMessage = re;
  }
  return Qm(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw M1(Re.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const ie = o.value = e.proxy.$i18n.__composer;
    i === "global" ? (c.value = ie.locale.value, h.value = ie.fallbackLocale.value, y.value = ie.messages.value, v.value = ie.datetimeFormats.value, x.value = ie.numberFormats.value) : r && Vi(ie);
  }), Kn;
}
const XR = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], $4 = ["t", "rt", "d", "n", "tm", "te"];
function JR(e, i) {
  const n = /* @__PURE__ */ Object.create(null);
  return XR.forEach((r) => {
    const o = Object.getOwnPropertyDescriptor(i, r);
    if (!o)
      throw M1(Re.UNEXPECTED_ERROR);
    const l = qm(o.value) ? {
      get() {
        return o.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(c) {
        o.value.value = c;
      }
    } : {
      get() {
        return o.get && o.get();
      }
    };
    Object.defineProperty(n, r, l);
  }), e.config.globalProperties.$i18n = n, $4.forEach((r) => {
    const o = Object.getOwnPropertyDescriptor(i, r);
    if (!o || !o.value)
      throw M1(Re.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${r}`, o);
  }), () => {
    delete e.config.globalProperties.$i18n, $4.forEach((r) => {
      delete e.config.globalProperties[`$${r}`];
    });
  };
}
uR();
__INTLIFY_JIT_COMPILATION__ ? N4(JU) : N4(XU);
UU(kU);
RU(Yd);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Di();
  e.__INTLIFY__ = !0, NU(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const KR = {
  title: {
    text: "Drag your file here or",
    highlight: "search it"
  },
  invalid: {
    subtitle: "File not supported, select supported formats:"
  },
  subtitle: "Supported formats:"
}, $R = {
  importing: "Importing"
}, eY = {
  discard_button: "Discard"
}, nY = {
  reply_message: {
    you: "You",
    video: "Video",
    image: "Image",
    audio: "Audio message"
  }
}, iY = {
  upload_area: KR,
  import_card: $R,
  audio_recorder: eY,
  chat_message: nY
}, tY = {
  title: {
    text: "Arrastra tu archivo aquí o",
    highlight: "búscalo"
  },
  invalid: {
    subtitle: "Archivo no compatible, seleccione los formatos compatibles:"
  },
  subtitle: "Formatos compatibles:"
}, aY = {
  importing: "Importando"
}, sY = {
  discard_button: "Descartar"
}, oY = {
  reply_message: {
    you: "Tú",
    video: "Vídeo",
    image: "Imagen",
    audio: "Mensaje de audio"
  }
}, rY = {
  upload_area: tY,
  import_card: aY,
  audio_recorder: sY,
  chat_message: oY
}, lY = {
  title: {
    text: "Arraste seu arquivo aqui, ou",
    highlight: "procure-o"
  },
  invalid: {
    subtitle: "Arquivo não compatível, selecione formatos suportados:"
  },
  subtitle: "Formatos suportados:"
}, dY = {
  importing: "Importando"
}, cY = {
  discard_button: "Descartar"
}, fY = {
  reply_message: {
    you: "Você",
    video: "Vídeo",
    image: "Imagem",
    audio: "Mensagem de áudio"
  }
}, el = {
  upload_area: lY,
  import_card: dY,
  audio_recorder: cY,
  chat_message: fY
}, uY = {
  en: iY,
  es: rY,
  "pt-br": el,
  "pt-BR": el
}, hY = Object.assign(uY), d3 = PR({
  locale: "en",
  fallbackLocale: "en",
  messages: hY
}), yn = {
  props: {
    locale: {
      type: String
    },
    translations: {
      type: Object
    }
  },
  methods: {
    i18n(...e) {
      const [i, n] = e, a = Object.keys(d3.global.messages);
      let { locale: r } = this;
      const o = Wt.get(d3, "global.locale") === "en-us" ? "en" : Wt.get(d3, "global.locale");
      r = a.includes(r) ? r : o, r = r == null ? void 0 : r.toLowerCase();
      let l = Wt.get(
        this.translations,
        `${i}.${r}`,
        Wt.get(this.translations, i)
      );
      if (l || (l = Wt.get(Wt.get(this.defaultTranslations, i), r, n)), l != null && l.includes("|") && typeof e[1] == "number") {
        const h = e[1], y = l.split("|");
        y.length === 3 ? l = y[h] || y[2] : y.length === 2 && (l = h === 1 ? y[0] : y[1]);
      }
      let c = {};
      return Object.values(e).slice(1).forEach((h) => {
        !(h instanceof Array) && h instanceof Object && (c = h);
      }), Object.keys(c).forEach((h) => {
        l = l == null ? void 0 : l.replaceAll(
          new RegExp(`{ *${h} *}`, "g"),
          c[h]
        );
      }), l;
    }
  }
};
const mY = {
  name: "UnnnicButton",
  components: {
    UnnnicIcon: ce
  },
  props: {
    size: {
      type: String,
      default: "large"
    },
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "primary"
    },
    float: {
      type: Boolean,
      default: !1
    },
    iconLeft: {
      type: String,
      default: ""
    },
    iconRight: {
      type: String,
      default: ""
    },
    iconCenter: {
      type: String,
      default: ""
    },
    iconsFilled: {
      type: Boolean,
      default: !1
    },
    next: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    buttonDisabled() {
      return this.disabled || this.loading;
    },
    iconSize() {
      return this.size === "small" ? "sm" : "md";
    },
    hasText() {
      return this.$slots.default ? !0 : this.text && this.text.length > 0;
    },
    iconScheme() {
      return this.buttonDisabled ? "neutral-clean" : {
        primary: "neutral-white",
        secondary: "neutral-dark",
        tertiary: "neutral-dark",
        warning: "neutral-white",
        attention: "neutral-white"
      }[this.type] || "";
    },
    isSizePropValid() {
      return this.size === "large" || !this.float && this.size === "small" || this.float && this.size === "extra-large";
    },
    isTypePropValid() {
      return [
        "primary",
        "secondary",
        "tertiary",
        "alternative",
        "warning",
        "attention"
      ].includes(this.type);
    }
  },
  watch: {
    $props: {
      deep: !0,
      immediate: !0,
      handler() {
        this.validateProps();
      }
    }
  },
  methods: {
    validateProps() {
      if (!this.isSizePropValid || !this.isTypePropValid) {
        let e = "TypeError:";
        throw this.isSizePropValid || (e += " Invalid size prop.", e += " Please provide 'large', 'small' (only if float prop is false), or 'extra-large' (only if float prop is true)."), this.isTypePropValid || (e += " Invalid type prop."), new Error(e);
      }
    }
  }
}, pY = ["disabled"];
function yY(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("button", Q1(e.$attrs, {
    disabled: o.buttonDisabled,
    class: [
      "unnnic-button",
      `unnnic-button--size-${n.size}`,
      `unnnic-button--${n.type}`,
      n.iconCenter ? "unnnic-button--icon-on-center" : null,
      n.float ? "unnnic-button--float" : null
    ]
  }), [
    n.loading ? (f(), $(l, {
      key: 0,
      icon: "loading-circle-1",
      scheme: o.iconScheme,
      size: o.iconSize,
      filled: n.iconsFilled,
      style: { position: "absolute" },
      class: "rotation",
      next: n.next,
      "data-testid": "icon-loading"
    }, null, 8, ["scheme", "size", "filled", "next"])) : N("", !0),
    n.iconLeft ? (f(), $(l, {
      key: 1,
      icon: n.iconLeft,
      scheme: o.iconScheme,
      size: o.iconSize,
      filled: n.iconsFilled,
      class: B({ "unnnic-button__icon-left": o.hasText }),
      style: Ze({ visibility: n.loading ? "hidden" : null }),
      next: n.next,
      "data-testid": "icon-left"
    }, null, 8, ["icon", "scheme", "size", "filled", "class", "style", "next"])) : N("", !0),
    n.iconCenter ? (f(), $(l, {
      key: 2,
      icon: n.iconCenter,
      scheme: o.iconScheme,
      style: Ze({ visibility: n.loading ? "hidden" : null }),
      size: o.iconSize,
      filled: n.iconsFilled,
      next: n.next,
      "data-testid": "icon-center"
    }, null, 8, ["icon", "scheme", "style", "size", "filled", "next"])) : N("", !0),
    n.float ? N("", !0) : (f(), p("span", {
      key: 3,
      class: "unnnic-button__label",
      style: Ze({ visibility: n.loading ? "hidden" : null }),
      "data-testid": "button-label"
    }, [
      pe(e.$slots, "default", {}, void 0, !0),
      p1(" " + T(n.text), 1)
    ], 4)),
    n.iconRight ? (f(), $(l, {
      key: 4,
      icon: n.iconRight,
      scheme: o.iconScheme,
      size: o.iconSize,
      filled: n.iconsFilled,
      class: B({ "unnnic-button__icon-right": o.hasText }),
      style: Ze({ visibility: n.loading ? "hidden" : null }),
      next: n.next,
      "data-testid": "icon-right"
    }, null, 8, ["icon", "scheme", "size", "filled", "class", "style", "next"])) : N("", !0)
  ], 16, pY);
}
const Wn = /* @__PURE__ */ k(mY, [["render", yY], ["__scopeId", "data-v-d127031e"]]);
const vY = {
  components: {
    UnnnicButton: Wn
  },
  mixins: [yn],
  props: {
    initialStartDate: { type: String, default: "" },
    initialEndDate: { type: String, default: "" },
    minDate: { type: String, default: "" },
    maxDate: { type: String, default: "" },
    type: {
      type: String,
      default: "day",
      validator(e) {
        return ["day", "month", "year"].includes(e);
      }
    },
    size: {
      type: String,
      default: "large",
      validator(e) {
        return ["small", "large"].includes(e);
      }
    },
    clearLabel: {
      type: String,
      default: ""
    },
    actionLabel: {
      type: String,
      default: ""
    },
    months: {
      type: Array,
      default: () => [],
      validator(e) {
        return [0, 12].includes(e.length);
      }
    },
    days: {
      type: Array,
      default: () => [],
      validator(e) {
        return [0, 7].includes(e.length);
      }
    },
    options: {
      type: Array,
      default: () => []
    },
    disableClear: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["change", "submit"],
  data() {
    const e = /* @__PURE__ */ new Date();
    return {
      referenceDate: `${e.getMonth() + 1} 1 ${e.getFullYear()}`,
      startDate: (this.initialStartDate || "").replace(/-/g, " "),
      endDate: (this.initialEndDate || "").replace(/-/g, " "),
      optionSelected: "",
      defaultTranslations: {
        clean: {
          "pt-br": "Limpar",
          en: "Clean",
          es: "Limpiar"
        },
        filter: {
          "pt-br": "Filtrar",
          en: "Filter",
          es: "Filtrar"
        }
      }
    };
  },
  computed: {
    openMonths() {
      return [this.addMonth(this.referenceDate, -1), this.referenceDate];
    },
    value() {
      return {
        startDate: this.startDate.replaceAll(" ", "-"),
        endDate: this.endDate.replaceAll(" ", "-")
      };
    },
    i18nLocale() {
      return this.$i18n.locale.toLowerCase();
    },
    monthsLocale() {
      const { months: e } = this;
      return e.length ? e : bP[this.i18nLocale];
    },
    daysLocale() {
      const { days: e } = this;
      return e.length ? e : MP[this.i18nLocale];
    },
    periodsLocale() {
      const { options: e } = this;
      return e.length ? e : DP[this.i18nLocale];
    },
    clearText() {
      return this.clearLabel || this.i18n("clean");
    },
    filterText() {
      return this.actionLabel || this.i18n("filter");
    }
  },
  watch: {
    value({ startDate: e, endDate: i }) {
      this.optionSelected = e || i ? "custom" : "", this.$emit("change", this.value);
    }
  },
  methods: {
    dateToString(e) {
      return `${e.getMonth() + 1} ${e.getDate()} ${e.getFullYear()}`;
    },
    dateToStringMonth(e) {
      return `${e.getMonth() + 1} ${e.getFullYear()}`;
    },
    dateToStringYear(e) {
      return e.getFullYear();
    },
    stringToTime(e) {
      const [i, n, a] = e.split(" ");
      return new Date(a, Number(i) - 1, n).getTime();
    },
    getDate(e) {
      return e.toString().split(" ")[1];
    },
    getMonth(e) {
      return e.toString().split(" ")[0];
    },
    getFullYear(e) {
      const [i, n, a] = e.split(" ");
      return new Date(a, Number(i) - 1, n).getFullYear();
    },
    addMonth(e, i) {
      const [n, a, r] = e.split(" "), o = new Date(r, Number(n) - 1, a);
      return o.setMonth(o.getMonth() + i), this.dateToString(o);
    },
    isDateBetween(e) {
      if (this.startDate && this.endDate) {
        if (e >= this.stringToTime(this.startDate) && e <= this.stringToTime(this.endDate))
          return !0;
      } else {
        if (this.startDate && e >= this.stringToTime(this.startDate))
          return !0;
        if (this.endDate && e <= this.stringToTime(this.endDate))
          return !0;
      }
      return !1;
    },
    isDateBetweenMonth(e) {
      const [i, n, a] = e.split(" "), r = new Date(a, Number(i) - 1, n);
      r.setDate(1);
      const o = r.getTime();
      if (this.startDate && this.endDate) {
        if (e >= o && e <= this.stringToTime(this.endDate))
          return !0;
      } else {
        if (this.startDate && e >= o)
          return !0;
        if (this.endDate && e <= this.stringToTime(this.endDate))
          return !0;
      }
      return !1;
    },
    isDateBetweenYear(e) {
      const [i, n, a] = e.split(" "), r = new Date(a, Number(i) - 1, n);
      r.setDate(1), r.setMonth(0);
      const o = r.getTime();
      if (this.startDate && this.endDate) {
        if (e >= o && e <= this.stringToTime(this.endDate))
          return !0;
      } else {
        if (this.startDate && e >= o)
          return !0;
        if (this.endDate && e <= this.stringToTime(this.endDate))
          return !0;
      }
      return !1;
    },
    getDatesOfTheMonth(e) {
      const [i, n, a] = e.split(" "), r = new Date(a, Number(i) - 1, n), o = r.getMonth(), l = 86400;
      r.setDate(1 - r.getDay());
      const c = [];
      for (let h = 0; h < 6 * 7; h += 1) {
        const y = this.dateToString(r), v = [];
        if (this.minDate) {
          const [x, C, M] = this.minDate.split("-"), z = new Date(
            x,
            Number(C) - 1,
            M
          );
          r < z && v.push("out of range");
        }
        if (this.maxDate) {
          const [x, C, M] = this.maxDate.split("-"), z = new Date(
            x,
            Number(C) - 1,
            M
          );
          r > z && v.push("out of range");
        }
        if (o === r.getMonth()) {
          v.push("inside month");
          const x = this.stringToTime(this.dateToString(r)), C = x - l, M = x + l;
          this.isDateBetween(x) && (v.push("selected"), this.isDateBetween(C) || v.push("left-highlighted"), this.isDateBetween(M) || v.push("right-highlighted"), (v.includes("left-highlighted") || v.includes("right-highlighted")) && v.push("highlighted"));
        }
        this.dateToString(r) === this.dateToString(/* @__PURE__ */ new Date()) && v.push("today"), c.push({
          properties: v,
          toString: () => y
        }), r.setDate(r.getDate() + 1);
      }
      return c;
    },
    getMonthsOfTheYear(e) {
      const [i, n, a] = e.split(" "), r = new Date(a, Number(i) - 1, n);
      r.setMonth(0);
      const o = [];
      for (let l = 0; l < 3 * 4; l += 1) {
        const c = this.dateToString(r), h = [];
        h.push("inside month");
        const y = this.stringToTime(this.dateToString(r));
        let v = new Date(y), x = new Date(y);
        v.setMonth(v.getMonth() - 1), x.setMonth(x.getMonth() + 1), v = v.getTime(), x = x.getTime(), this.isDateBetweenMonth(y) && (h.push("selected"), this.isDateBetweenMonth(v) || h.push("left-highlighted"), this.isDateBetweenMonth(x) || h.push("right-highlighted"), (h.includes("left-highlighted") || h.includes("right-highlighted")) && h.push("highlighted")), this.dateToStringMonth(r) === this.dateToStringMonth(/* @__PURE__ */ new Date()) && h.push("today"), o.push({
          properties: h,
          date: c,
          toString: () => c
        }), r.setMonth(r.getMonth() + 1);
      }
      return o;
    },
    getYears(e) {
      const [i, n, a] = e.split(" "), r = new Date(a, Number(i) - 1, n);
      r.setMonth(0);
      const o = [];
      for (let l = 0; l < 3 * 4; l += 1) {
        const c = this.dateToString(r), h = [];
        h.push("inside month");
        const y = this.stringToTime(this.dateToString(r)), [v, x, C] = e.split(" ");
        let M = new Date(
          C,
          Number(v) - 1,
          x
        ), z = new Date(
          C,
          Number(v) - 1,
          x
        );
        M.setMonth(M.getMonth() - 12), z.setMonth(z.getMonth() + 12), M = M.getTime(), z = z.getTime(), this.isDateBetweenYear(y) && (h.push("selected"), this.isDateBetweenYear(M) || h.push("left-highlighted"), this.isDateBetweenYear(z) || h.push("right-highlighted"), (h.includes("left-highlighted") || h.includes("right-highlighted")) && h.push("highlighted")), this.dateToStringYear(r) === this.dateToStringYear(/* @__PURE__ */ new Date()) && h.push("today"), o.push({
          properties: h,
          date: r.getFullYear(),
          toString: () => c
        }), r.setFullYear(r.getFullYear() + 1);
      }
      return o;
    },
    selectDate(e) {
      if (!this.startDate || !this.endDate)
        this.startDate = e.toString(), this.endDate = this.startDate;
      else {
        const i = this.stringToTime(e.toString()), n = this.stringToTime(this.startDate), a = this.stringToTime(this.endDate);
        n !== a ? (this.startDate = e.toString(), this.endDate = this.startDate) : i > a ? this.endDate = e.toString() : i < n ? this.startDate = e.toString() : i === n || i === a ? (this.startDate = e.toString(), this.endDate = this.startDate) : i - n < a - i ? this.startDate = e.toString() : this.endDate = e.toString();
      }
    },
    clear() {
      this.startDate = "", this.endDate = "", this.optionSelected = "";
    },
    autoSelect(e) {
      const i = /* @__PURE__ */ new Date(), n = e.match(/^last-(\d+)-days$/), a = e.match(/^last-(\d+)-months$/);
      if (n) {
        const r = Number(n[1]);
        this.endDate = this.dateToString(i), i.setDate(i.getDate() - r + 1), this.startDate = this.dateToString(i);
      } else if (a) {
        const r = Number(a[1]);
        this.endDate = this.dateToString(i), i.setDate(i.getDate() + 1), i.setMonth(i.getMonth() - r), this.startDate = this.dateToString(i);
      } else
        e === "current-month" ? (i.setDate(1), this.startDate = this.dateToString(i), i.setMonth(i.getMonth() + 1), i.setDate(0), this.endDate = this.dateToString(i)) : e === "previous-month" && (i.setDate(1), i.setMonth(i.getMonth() - 1), this.startDate = this.dateToString(i), i.setMonth(i.getMonth() + 1), i.setDate(0), this.endDate = this.dateToString(i));
      if (this.endDate) {
        const r = this.addMonth(this.referenceDate, 1), o = `${Number(
          this.getMonth(this.endDate)
        )} 1 ${this.getFullYear(this.endDate)}`;
        [this.referenceDate, r].includes(o) || (this.referenceDate = o);
      }
      this.$nextTick(() => {
        this.optionSelected = e;
      });
    }
  }
}, bo = (e) => (hn("data-v-6b5bf0b6"), e = e(), mn(), e), gY = { class: "unnnic-date-picker" }, _Y = { class: "month-container" }, wY = ["onClick"], CY = /* @__PURE__ */ bo(() => /* @__PURE__ */ u("div", { class: "divider" }, null, -1)), kY = { class: "month-container" }, xY = ["onClick"], bY = /* @__PURE__ */ bo(() => /* @__PURE__ */ u("div", { class: "divider" }, null, -1)), MY = { class: "month-container" }, DY = ["onClick"], AY = /* @__PURE__ */ bo(() => /* @__PURE__ */ u("div", { class: "divider" }, null, -1)), LY = {
  key: 3,
  class: "options-container"
}, TY = { class: "options" }, SY = ["onClick"], NY = { class: "actions" };
function EY(e, i, n, a, r, o) {
  const l = j("UnnnicButton");
  return f(), p("div", gY, [
    n.type === "day" ? (f(!0), p(se, { key: 0 }, me(o.openMonths, (c, h) => (f(), p(se, { key: c }, [
      u("div", _Y, [
        u("div", {
          class: B(["header", `header--${n.size}`])
        }, [
          Z(l, {
            size: "small",
            iconCenter: `arrow-${h === 0 ? "left" : "right"}-1-1`,
            type: n.size === "large" ? "secondary" : "tertiary",
            class: "button-space",
            style: Ze({ gridArea: `${h === 0 ? "left" : "right"}-button` }),
            onClick: Qe((y) => r.referenceDate = o.addMonth(r.referenceDate, h === 0 ? -1 : 1), ["stop"])
          }, null, 8, ["iconCenter", "type", "style", "onClick"]),
          u("div", {
            class: B(["label", `label--${n.size}`])
          }, T(o.monthsLocale[Number(o.getMonth(c)) - 1]) + " " + T(o.getFullYear(c)), 3)
        ], 2),
        u("div", {
          class: B(["days", `days--${n.size}`])
        }, [
          (f(!0), p(se, null, me(o.daysLocale, (y, v) => (f(), p("div", {
            key: v,
            class: "name"
          }, T(y), 1))), 128)),
          (f(!0), p(se, null, me(o.getDatesOfTheMonth(c), (y, v) => (f(), p("div", {
            key: `${c}-${v}`,
            class: B({
              disabled: !y.properties.includes("inside month") || y.properties.includes("out of range"),
              selectable: y.properties.includes("inside month") && !y.properties.includes("out of range"),
              today: y.properties.includes("today"),
              selected: y.properties.includes("selected"),
              highlighted: y.properties.includes("highlighted"),
              left: y.properties.includes("left-highlighted"),
              right: y.properties.includes("right-highlighted")
            }),
            onClick: (x) => y.properties.includes("inside month") && !y.properties.includes("out of range") && o.selectDate(y)
          }, T(o.getDate(y)), 11, wY))), 128))
        ], 2)
      ]),
      CY
    ], 64))), 128)) : n.type === "month" ? (f(!0), p(se, { key: 1 }, me([r.referenceDate], (c) => (f(), p(se, { key: c }, [
      u("div", kY, [
        u("div", {
          class: B(["header", `header--${n.size}`])
        }, [
          Z(l, {
            size: "small",
            iconCenter: "arrow-left-1-1",
            type: n.size === "large" ? "secondary" : "tertiary",
            class: "button-space",
            style: { gridArea: "left-button" },
            onClick: i[0] || (i[0] = (h) => r.referenceDate = o.addMonth(r.referenceDate, -12))
          }, null, 8, ["type"]),
          u("div", {
            class: B(["label", `label--${n.size}`])
          }, T(o.getFullYear(c)), 3),
          Z(l, {
            size: "small",
            iconCenter: "arrow-right-1-1",
            type: n.size === "large" ? "secondary" : "tertiary",
            class: "button-space",
            style: { gridArea: "right-button" },
            onClick: i[1] || (i[1] = (h) => r.referenceDate = o.addMonth(r.referenceDate, 12))
          }, null, 8, ["type"])
        ], 2),
        u("div", {
          class: B(["days", `months--${n.size}`])
        }, [
          (f(!0), p(se, null, me(o.getMonthsOfTheYear(c), (h, y) => (f(), p("div", {
            key: `${c}-${y}`,
            class: B({
              disabled: !h.properties.includes("inside month"),
              selectable: h.properties.includes("inside month"),
              today: h.properties.includes("today"),
              selected: h.properties.includes("selected"),
              highlighted: h.properties.includes("highlighted"),
              left: h.properties.includes("left-highlighted"),
              right: h.properties.includes("right-highlighted")
            }),
            onClick: (v) => h.properties.includes("inside month") && o.selectDate(h)
          }, T(o.monthsLocale[o.getMonth(h)].substr(0, 3)), 11, xY))), 128))
        ], 2)
      ]),
      bY
    ], 64))), 128)) : n.type === "year" ? (f(!0), p(se, { key: 2 }, me([r.referenceDate], (c) => (f(), p(se, { key: c }, [
      u("div", MY, [
        u("div", {
          class: B(["header", `header--${n.size}`])
        }, [
          Z(l, {
            size: "small",
            iconCenter: "arrow-left-1-1",
            type: n.size === "large" ? "secondary" : "tertiary",
            class: "button-space",
            style: { gridArea: "left-button" },
            onClick: i[2] || (i[2] = (h) => r.referenceDate = o.addMonth(r.referenceDate, -12 * 12))
          }, null, 8, ["type"]),
          u("div", {
            class: B(["label", `label--${n.size}`])
          }, T(o.getFullYear(c)), 3),
          Z(l, {
            size: "small",
            iconCenter: "arrow-right-1-1",
            type: n.size === "large" ? "secondary" : "tertiary",
            class: "button-space",
            style: { gridArea: "right-button" },
            onClick: i[3] || (i[3] = (h) => r.referenceDate = o.addMonth(r.referenceDate, 12 * 12))
          }, null, 8, ["type"])
        ], 2),
        u("div", {
          class: B(["days", `months--${n.size}`])
        }, [
          (f(!0), p(se, null, me(o.getYears(c), (h, y) => (f(), p("div", {
            key: `${c}-${y}`,
            class: B({
              disabled: !h.properties.includes("inside month"),
              selectable: h.properties.includes("inside month"),
              today: h.properties.includes("today"),
              selected: h.properties.includes("selected"),
              highlighted: h.properties.includes("highlighted"),
              left: h.properties.includes("left-highlighted"),
              right: h.properties.includes("right-highlighted")
            }),
            onClick: (v) => h.properties.includes("inside month") && o.selectDate(h)
          }, T(h.date), 11, DY))), 128))
        ], 2)
      ]),
      AY
    ], 64))), 128)) : N("", !0),
    n.size !== "small" ? (f(), p("div", LY, [
      u("div", TY, [
        (f(!0), p(se, null, me(o.periodsLocale, (c, h) => (f(), p("div", {
          key: h,
          class: B(["option", { selected: r.optionSelected === c.id }]),
          onClick: (y) => o.autoSelect(c.id)
        }, T(c.name), 11, SY))), 128))
      ]),
      u("div", NY, [
        n.disableClear ? N("", !0) : (f(), $(l, {
          key: 0,
          size: "small",
          text: o.clearText,
          type: "tertiary",
          onClick: o.clear
        }, null, 8, ["text", "onClick"])),
        Z(l, {
          size: "small",
          text: o.filterText,
          type: "secondary",
          onClick: i[4] || (i[4] = (c) => e.$emit("submit", o.value))
        }, null, 8, ["text"])
      ])
    ])) : N("", !0)
  ]);
}
const gc = /* @__PURE__ */ k(vY, [["render", EY], ["__scopeId", "data-v-6b5bf0b6"]]);
const zY = {
  components: {
    UnnnicInput: _0,
    UnnnicDatePicker: gc
  },
  model: {
    event: "changed"
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    iconPosition: {
      type: String,
      default: "left",
      validator(e) {
        return ["left", "right"].includes(e);
      }
    },
    minDate: { type: String, default: "" },
    maxDate: { type: String, default: "" },
    fillW: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "day"
    },
    size: {
      type: String,
      default: "md"
    },
    clearText: {
      type: String,
      default: "Clear"
    },
    actionText: {
      type: String,
      default: "Filter"
    },
    months: {
      type: Array,
      default: () => []
    },
    days: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    next: {
      type: Boolean,
      default: !1
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    inputFormat: {
      type: String,
      default: "MM-DD-YYYY"
    },
    position: {
      type: String,
      default: "left"
    },
    disableClear: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:model-value", "selectDate"],
  data() {
    return {
      showCalendarFilter: !1
    };
  },
  computed: {
    filterText() {
      var i, n, a, r;
      const e = [];
      return (i = this.modelValue) != null && i.start && e.push(
        oe((n = this.modelValue) == null ? void 0 : n.start, this.format).format(this.inputFormat)
      ), (a = this.modelValue) != null && a.end && e.push(
        oe((r = this.modelValue) == null ? void 0 : r.end, this.format).format(this.inputFormat)
      ), e.length ? e.join(" ~ ") : String(this.inputFormat).replaceAll("-", "/").toLowerCase();
    },
    initialStartDate() {
      return this.modelValue.start ? oe(this.modelValue.start, this.format).format("MM DD YYYY") : null;
    },
    initialEndDate() {
      return this.modelValue.end ? oe(this.modelValue.end, this.format).format("MM DD YYYY") : null;
    }
  },
  mounted() {
    window.document.body.addEventListener("click", this.mouseout);
  },
  beforeUnmount() {
    window.document.body.removeEventListener("click", this.mouseout);
  },
  methods: {
    emitSelectDate(e) {
      const { startDate: i, endDate: n } = e, a = {
        start: oe(i, "MM-DD-YYYY").format(this.format),
        end: oe(n, "MM-DD-YYYY").format(this.format)
      };
      this.$emit("selectDate", a);
    },
    mouseout(e) {
      var i;
      (i = this.$refs.dropdown) != null && i.contains(e.target) || (this.showCalendarFilter = !1);
    },
    changeDate(e) {
      const i = e.startDate.replace(
        /(\d+)-(\d+)-(\d+)/,
        "$3-$1-$2"
      ), n = e.endDate.replace(/(\d+)-(\d+)-(\d+)/, "$3-$1-$2");
      this.showCalendarFilter = !1, this.$emit("update:model-value", {
        start: i ? oe(i, "YYYY-MM-DD").format(this.format) : null,
        end: n ? oe(n, "YYYY-MM-DD").format(this.format) : null
      });
    }
  }
};
function IY(e, i, n, a, r, o) {
  const l = j("UnnnicInput"), c = j("UnnnicDatePicker");
  return f(), p("div", {
    ref: "dropdown",
    class: B(["dropdown", { active: r.showCalendarFilter, "fill-w": n.fillW }])
  }, [
    Z(l, {
      class: B(["input", { "date-picker-input-next": n.next }]),
      size: n.size,
      iconLeft: n.iconPosition === "left" && "calendar_month",
      iconRight: n.iconPosition === "right" && "calendar_month",
      hasCloudyColor: "",
      readonly: "",
      modelValue: o.filterText,
      onFocus: i[0] || (i[0] = (h) => r.showCalendarFilter = !0)
    }, null, 8, ["class", "size", "iconLeft", "iconRight", "modelValue"]),
    u("div", {
      class: "dropdown-data",
      style: Ze({ [n.position]: "0" })
    }, [
      r.showCalendarFilter ? (f(), $(c, {
        key: 0,
        type: n.type,
        clearLabel: n.clearText,
        actionLabel: n.actionText,
        months: n.months,
        days: n.days,
        options: n.options,
        initialStartDate: o.initialStartDate,
        initialEndDate: o.initialEndDate,
        minDate: n.minDate,
        maxDate: n.maxDate,
        disableClear: n.disableClear,
        onChange: o.emitSelectDate,
        onSubmit: o.changeDate
      }, null, 8, ["type", "clearLabel", "actionLabel", "months", "days", "options", "initialStartDate", "initialEndDate", "minDate", "maxDate", "disableClear", "onChange", "onSubmit"])) : N("", !0)
    ], 4)
  ], 2);
}
const BY = /* @__PURE__ */ k(zY, [["render", IY], ["__scopeId", "data-v-cf22f1fe"]]);
const OY = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    type: {
      type: String,
      default: "secondary"
    },
    size: {
      type: String,
      required: !0,
      validator(e) {
        return ["small", "large"].includes(e);
      }
    },
    icon: {
      type: String,
      required: !0
    }
  },
  computed: {
    iconScheme() {
      return this.type === "primary" ? "neutral-snow" : "neutral-darkest";
    }
  }
};
function HY(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("button", Q1({
    class: ["button-icon", n.size, n.type]
  }, e.$attrs), [
    Z(l, {
      icon: n.icon,
      scheme: o.iconScheme,
      size: "ant"
    }, null, 8, ["icon", "scheme"])
  ], 16);
}
const jY = /* @__PURE__ */ k(OY, [["render", HY], ["__scopeId", "data-v-46ae4cf4"]]), Mo = (e) => {
  const { label: i, children: n } = e;
  if (!!!i.trim())
    throw new Error('Each item in "items" must have "label".');
  return n && Array.isArray(n) && n.forEach(Mo), !0;
}, VY = (e) => {
  if (!(e != null && e[0]))
    throw new Error("Items property cannot be an empty array.");
  return e.forEach(Mo), !0;
};
const FY = ["title"], PY = {
  key: 0,
  class: "unnnic-sidebar-item-children"
}, UY = ["onClick"], RY = ["title"], YY = {
  name: "UnnnicSidebarItem"
}, ZY = /* @__PURE__ */ Object.assign(YY, {
  props: {
    item: {
      type: Object,
      required: !0,
      validator: Mo
    },
    active: {
      type: Object,
      default: () => ({ item: !1, childIndex: null })
    },
    autoNavigateFirstChild: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["navigate"],
  setup(e, { emit: i }) {
    const n = e;
    Il(() => {
      const { childIndex: v, item: x } = n.active;
      typeof v == "number" && v >= 0 && x && o();
    });
    const a = T1(() => {
      var v;
      return !!((v = n.item.children) != null && v.length);
    }), r = L1(!1), o = () => {
      r.value = !r.value, r.value && n.autoNavigateFirstChild && y("navigate", { item: n.item, child: n.item.children[0] });
    }, l = (v) => {
      const { item: x, childIndex: C } = n.active;
      return typeof C != "number" ? x : x && C === v;
    }, c = () => {
      a.value ? o() : h();
    }, h = () => {
      n.active.item || y("navigate", { item: n.item, child: null });
    }, y = i;
    return (v, x) => {
      var C;
      return f(), p(se, null, [
        u("section", {
          "data-testid": "sidebar-item",
          class: B({ "unnnic-sidebar-item": !0, active: e.active.item }),
          onClick: Qe(c, ["stop"])
        }, [
          e.item.icon ? (f(), $(ce, {
            key: 0,
            class: "unnnic-sidebar-item__icon",
            icon: e.item.icon,
            size: "ant",
            scheme: e.active.item ? "weni-600" : "neutral-cloudy",
            "data-testid": "item-icon"
          }, null, 8, ["icon", "scheme"])) : N("", !0),
          u("p", {
            class: B({ "unnnic-sidebar-item__label": !0, active: e.active.item }),
            title: e.item.label
          }, T(e.item.label), 11, FY),
          (C = e.item.children) != null && C.length ? (f(), $(ce, {
            key: 1,
            class: "unnnic-sidebar-item__arrow",
            icon: r.value ? "keyboard_arrow_up" : "keyboard_arrow_down",
            size: "ant",
            scheme: "neutral-cloudy",
            "data-testid": "arrow-icon"
          }, null, 8, ["icon"])) : N("", !0)
        ], 2),
        Z(R3, { name: "slide-fade" }, {
          default: Ee(() => [
            r.value ? (f(), p("ul", PY, [
              (f(!0), p(se, null, me(e.item.children, (M, z) => (f(), p("li", {
                key: M,
                class: B({
                  "unnnic-sidebar-item-child": !0,
                  active: l(z)
                }),
                "data-testid": "sidebar-item-child",
                onClick: Qe((R) => !l(z) && y("navigate", { item: e.item, child: M }), ["stop"])
              }, [
                M.icon ? (f(), $(ce, {
                  key: 0,
                  class: "unnnic-sidebar-item-child__icon",
                  icon: M.icon,
                  size: "ant",
                  scheme: l(z) ? "weni-600" : "neutral-cloudy"
                }, null, 8, ["icon", "scheme"])) : N("", !0),
                u("p", {
                  class: B({
                    "unnnic-sidebar-item-child__label": !0,
                    active: l(z)
                  }),
                  title: M.label
                }, T(M.label), 11, RY)
              ], 10, UY))), 128))
            ])) : N("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), _c = /* @__PURE__ */ k(ZY, [["__scopeId", "data-v-418b1f69"]]);
const WY = { class: "unnnic-sidebar-items" }, QY = {
  name: "UnnnicSidebar"
}, qY = /* @__PURE__ */ Object.assign(QY, {
  props: {
    position: {
      type: String,
      default: "left",
      validator(e) {
        return ["left", "right"].includes(e);
      }
    },
    width: {
      type: String,
      default: "200px",
      validator(e) {
        const i = /^\d+(\.\d+)?px$/, n = /^\d+(\.\d+)?%$/;
        return i.test(e) || n.test(e);
      }
    },
    items: {
      type: Array,
      required: !0,
      validator: VY
    },
    active: {
      type: Object,
      default: () => ({ itemIndex: null, childIndex: null })
    },
    autoNavigateFirstChild: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["navigate"],
  setup(e, { emit: i }) {
    Y3((o) => ({
      "6c03e4b5": n.width
    }));
    const n = e, a = i, r = ({ item: o, child: l }) => {
      a("navigate", { item: o, child: l });
    };
    return (o, l) => (f(), p("nav", {
      class: B(["unnnic-sidebar", `unnnic-sidebar--${e.position}`])
    }, [
      pe(o.$slots, "top", { class: "unnnic-sidebar-top" }, void 0, !0),
      u("ul", WY, [
        (f(!0), p(se, null, me(e.items, (c, h) => (f(), p("li", { key: c }, [
          Z(_c, {
            item: c,
            active: {
              item: e.active.itemIndex === h,
              childIndex: e.active.childIndex
            },
            autoNavigateFirstChild: e.autoNavigateFirstChild,
            "data-testid": "sidebar-item",
            onNavigate: l[0] || (l[0] = (y) => r(y))
          }, null, 8, ["item", "active", "autoNavigateFirstChild"])
        ]))), 128))
      ]),
      pe(o.$slots, "bottom", { class: "unnnic-sidebar-bottom" }, void 0, !0)
    ], 2));
  }
}), GY = /* @__PURE__ */ k(qY, [["__scopeId", "data-v-7bdf478e"]]);
const XY = {
  name: "UnnnicTable",
  components: {},
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      value: !1
    };
  },
  computed: {}
}, JY = (e) => (hn("data-v-b2229274"), e = e(), mn(), e), KY = { class: "unnnic-table" }, $Y = { class: "header" }, eZ = /* @__PURE__ */ JY(() => /* @__PURE__ */ u("div", null, [
  /* @__PURE__ */ u("div", { class: "item-spacer" })
], -1)), nZ = { class: "scroll" };
function iZ(e, i, n, a, r, o) {
  return S1((f(), p("div", KY, [
    u("div", $Y, [
      pe(e.$slots, "header", {}, void 0, !0)
    ]),
    eZ,
    u("div", nZ, [
      (f(!0), p(se, null, me(n.items, (l, c) => (f(), p("div", {
        key: c,
        class: "item"
      }, [
        pe(e.$slots, "item", { item: l }, void 0, !0)
      ]))), 128))
    ])
  ], 512)), [
    [ri, !0]
  ]);
}
const tZ = /* @__PURE__ */ k(XY, [["render", iZ], ["__scopeId", "data-v-b2229274"]]);
const aZ = {
  name: "UnnnicTableRow",
  props: {
    headers: {
      type: Array
    }
  },
  data() {
    return {};
  }
}, sZ = { class: "table-row" }, oZ = { class: "break-text" };
function rZ(e, i, n, a, r, o) {
  return f(), p("div", sZ, [
    (f(!0), p(se, null, me(n.headers, (l, c) => (f(), p(se, {
      key: l.id
    }, [
      u("div", {
        class: "col",
        style: Ze({
          width: l.width,
          flex: l.flex,
          minWidth: 0
        })
      }, [
        pe(e.$slots, l.id, {}, () => [
          u("div", oZ, T(l.text), 1)
        ], !0)
      ], 4),
      S1(u("div", {
        class: B(["divider", { condensed: l.condensed }])
      }, null, 2), [
        [ri, c + 1 !== n.headers.length]
      ])
    ], 64))), 128))
  ]);
}
const lZ = /* @__PURE__ */ k(aZ, [["render", rZ], ["__scopeId", "data-v-cb0c6b93"]]);
function wc(e) {
  return Xm() ? (Jm(e), !0) : !1;
}
function j2(e) {
  return typeof e == "function" ? e() : Km(e);
}
const Cc = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const dZ = Object.prototype.toString, cZ = (e) => dZ.call(e) === "[object Object]", V2 = () => {
}, O3 = /* @__PURE__ */ fZ();
function fZ() {
  var e, i;
  return Cc && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((i = window == null ? void 0 : window.navigator) == null ? void 0 : i.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const nl = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function uZ(...e) {
  if (e.length !== 1)
    return $m(...e);
  const i = e[0];
  return typeof i == "function" ? ep(np(() => ({ get: i, set: V2 }))) : L1(i);
}
function B2(e) {
  var i;
  const n = j2(e);
  return (i = n == null ? void 0 : n.$el) != null ? i : n;
}
const kc = Cc ? window : void 0;
function e0(...e) {
  let i, n, a, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, a, r] = e, i = kc) : [i, n, a, r] = e, !i)
    return V2;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const o = [], l = () => {
    o.forEach((v) => v()), o.length = 0;
  }, c = (v, x, C, M) => (v.addEventListener(x, C, M), () => v.removeEventListener(x, C, M)), h = Si(
    () => [B2(i), j2(r)],
    ([v, x]) => {
      if (l(), !v)
        return;
      const C = cZ(x) ? { ...x } : x;
      o.push(
        ...n.flatMap((M) => a.map((z) => c(v, M, z, C)))
      );
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    h(), l();
  };
  return wc(y), y;
}
let il = !1;
function tl(e, i, n = {}) {
  const { window: a = kc, ignore: r = [], capture: o = !0, detectIframe: l = !1 } = n;
  if (!a)
    return V2;
  O3 && !il && (il = !0, Array.from(a.document.body.children).forEach((C) => C.addEventListener("click", V2)), a.document.documentElement.addEventListener("click", V2));
  let c = !0;
  const h = (C) => r.some((M) => {
    if (typeof M == "string")
      return Array.from(a.document.querySelectorAll(M)).some((z) => z === C.target || C.composedPath().includes(z));
    {
      const z = B2(M);
      return z && (C.target === z || C.composedPath().includes(z));
    }
  }), v = [
    e0(a, "click", (C) => {
      const M = B2(e);
      if (!(!M || M === C.target || C.composedPath().includes(M))) {
        if (C.detail === 0 && (c = !h(C)), !c) {
          c = !0;
          return;
        }
        i(C);
      }
    }, { passive: !0, capture: o }),
    e0(a, "pointerdown", (C) => {
      const M = B2(e);
      c = !h(C) && !!(M && !C.composedPath().includes(M));
    }, { passive: !0 }),
    l && e0(a, "blur", (C) => {
      setTimeout(() => {
        var M;
        const z = B2(e);
        ((M = a.document.activeElement) == null ? void 0 : M.tagName) === "IFRAME" && !(z != null && z.contains(a.document.activeElement)) && i(C);
      }, 0);
    })
  ].filter(Boolean);
  return () => v.forEach((C) => C());
}
const H0 = {
  [nl.mounted](e, i) {
    const n = !i.modifiers.bubble;
    if (typeof i.value == "function")
      e.__onClickOutside_stop = tl(e, i.value, { capture: n });
    else {
      const [a, r] = i.value;
      e.__onClickOutside_stop = tl(e, a, Object.assign({ capture: n }, r));
    }
  },
  [nl.unmounted](e) {
    e.__onClickOutside_stop();
  }
};
function c3(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function xc(e) {
  const i = window.getComputedStyle(e);
  if (i.overflowX === "scroll" || i.overflowY === "scroll" || i.overflowX === "auto" && e.clientWidth < e.scrollWidth || i.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : xc(n);
  }
}
function hZ(e) {
  const i = e || window.event, n = i.target;
  return xc(n) ? !1 : i.touches.length > 1 ? !0 : (i.preventDefault && i.preventDefault(), !1);
}
const Wa = /* @__PURE__ */ new WeakMap();
function mZ(e, i = !1) {
  const n = L1(i);
  let a = null;
  Si(uZ(e), (l) => {
    const c = c3(j2(l));
    if (c) {
      const h = c;
      Wa.get(h) || Wa.set(h, h.style.overflow), n.value && (h.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const l = c3(j2(e));
    !l || n.value || (O3 && (a = e0(
      l,
      "touchmove",
      (c) => {
        hZ(c);
      },
      { passive: !1 }
    )), l.style.overflow = "hidden", n.value = !0);
  }, o = () => {
    var l;
    const c = c3(j2(e));
    !c || !n.value || (O3 && (a == null || a()), c.style.overflow = (l = Wa.get(c)) != null ? l : "", Wa.delete(c), n.value = !1);
  };
  return wc(o), T1({
    get() {
      return n.value;
    },
    set(l) {
      l ? r() : o();
    }
  });
}
function pZ() {
  let e = !1;
  const i = L1(!1);
  return (n, a) => {
    if (i.value = a.value, e)
      return;
    e = !0;
    const r = mZ(n, a.value);
    Si(i, (o) => r.value = o);
  };
}
pZ();
const yZ = {
  name: "UnnnicDropdown",
  directives: {
    onClickOutside: H0
  },
  props: {
    useOpenProp: {
      type: Boolean,
      default: !1
    },
    open: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "bottom-left",
      validator(e) {
        return [
          "top-left",
          "top-right",
          "none",
          "bottom-left",
          "bottom-right"
        ].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:open"],
  data() {
    return {
      active: !1
    };
  },
  watch: {
    open: {
      handler() {
        this.active = this.open;
      },
      immediate: !0
    },
    active() {
      this.useOpenProp || this.$emit("update:open", this.active);
    }
  },
  methods: {
    onClickTrigger() {
      this.useOpenProp ? this.$emit("update:open", !this.open) : this.active = !this.active;
    },
    onClickOutside() {
      if (this.useOpenProp && this.open) {
        this.$emit("update:open", !1);
        return;
      }
      this.active && (this.active = !1);
    }
  }
}, vZ = { class: "unnnic-dropdown__trigger" };
function gZ(e, i, n, a, r, o) {
  const l = G2("on-click-outside");
  return f(), p("div", {
    class: "unnnic-dropdown",
    onClick: i[0] || (i[0] = Qe((...c) => o.onClickTrigger && o.onClickTrigger(...c), ["stop"]))
  }, [
    u("div", vZ, [
      pe(e.$slots, "trigger", {}, void 0, !0),
      (n.useOpenProp ? n.open : r.active) ? S1((f(), p("div", {
        key: 0,
        "data-testid": "dropdown-content",
        class: B([
          "unnnic-dropdown__content",
          n.useOpenProp ? n.open : r.active ? "" : "unnnic-dropdown__content--hidden",
          `unnnic-dropdown__content__position-${n.position}`
        ])
      }, [
        pe(e.$slots, "default", {}, void 0, !0)
      ], 2)), [
        [l, o.onClickOutside]
      ]) : N("", !0)
    ])
  ]);
}
const Do = /* @__PURE__ */ k(yZ, [["render", gZ], ["__scopeId", "data-v-66495a5a"]]);
const _Z = {
  name: "UnnnicDropdownItem"
}, wZ = {
  class: "unnnic-dropdown-item unnnic--clickable",
  "data-testid": "dropdown-item"
};
function CZ(e, i, n, a, r, o) {
  return f(), p("a", wZ, [
    pe(e.$slots, "default")
  ]);
}
const bc = /* @__PURE__ */ k(_Z, [["render", CZ]]);
const kZ = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    enabled: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: "graph-stats-1"
    },
    size: {
      type: String,
      default: "sm",
      validator(e) {
        return ["nano", "xs", "sm", "lg", "xl"].indexOf(e) !== -1;
      }
    },
    scheme: {
      type: String,
      default: "aux-blue"
    },
    filled: {
      type: Boolean,
      default: !1
    },
    opacity: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    iconSize() {
      return {
        nano: "xs",
        xs: "sm",
        sm: "md",
        lg: "lg",
        xl: "xl"
      }[this.size];
    }
  }
};
function xZ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B([
      "unnnic-avatar-icon",
      n.scheme,
      n.size,
      { disabled: !n.enabled },
      n.filled,
      { opacity: !n.opacity }
    ])
  }, [
    Z(l, {
      icon: n.icon,
      scheme: n.enabled ? n.scheme : "neutral-cloudy",
      size: o.iconSize,
      filled: n.filled
    }, null, 8, ["icon", "scheme", "size", "filled"])
  ], 2);
}
const m2 = /* @__PURE__ */ k(kZ, [["render", xZ], ["__scopeId", "data-v-d0742329"]]);
const bZ = {
  name: "IconLoading",
  components: {
    UnnnicIcon: ce
  },
  props: {
    scheme: {
      type: String,
      default: "neutral-dark"
    },
    size: {
      type: String,
      default: "lg"
    }
  }
};
function MZ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), $(l, {
    class: "unnnic-icon-loading",
    icon: "progress_activity",
    scheme: n.scheme,
    size: n.size
  }, null, 8, ["scheme", "size"]);
}
const j0 = /* @__PURE__ */ k(bZ, [["render", MZ], ["__scopeId", "data-v-97257015"]]);
const DZ = {
  name: "UnnnicTooltip",
  props: {
    text: {
      type: String,
      default: ""
    },
    enabled: {
      type: Boolean,
      default: !1
    },
    forceOpen: {
      type: Boolean,
      default: !1
    },
    side: {
      type: String,
      default: "right",
      validator(e) {
        return ["top", "right", "bottom", "left"].indexOf(e) !== -1;
      }
    },
    maxWidth: {
      type: String,
      default: ""
    },
    shortcutText: {
      type: String,
      default: null
    },
    enableHtml: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      topPos: null,
      leftPos: null
    };
  },
  watch: {
    side() {
      this.getRightPost(this.$refs.tooltip);
    }
  },
  mounted() {
    this.handleResize(), window.addEventListener("scroll", this.handleResize), window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleResize), window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.getRightPost(this.$refs.tooltip);
    },
    getRightPost(e) {
      const i = e.getBoundingClientRect();
      e && this.$refs.label && (this.side === "right" ? (this.leftPos = `${i.x + i.width + 8}px`, this.topPos = `${i.y + i.height / 2 - this.$refs.label.offsetHeight / 2}px`) : this.side === "left" ? (this.leftPos = `${i.x - this.$refs.label.offsetWidth - 8}px`, this.topPos = `${i.y + i.height / 2 - this.$refs.label.offsetHeight / 2}px`) : this.side === "top" ? (this.leftPos = `${i.x + i.width / 2 - this.$refs.label.clientWidth / 2}px`, this.topPos = `${i.y - this.$refs.label.offsetHeight - 8}px`) : this.side === "bottom" && (this.leftPos = `${i.x + i.width / 2 - this.$refs.label.clientWidth / 2}px`, this.topPos = `${i.y + i.height + 8}px`));
    }
  }
}, AZ = (e) => (hn("data-v-8c61d974"), e = e(), mn(), e), LZ = ["innerHTML"], TZ = /* @__PURE__ */ AZ(() => /* @__PURE__ */ u("br", null, null, -1)), SZ = {
  key: 2,
  class: "unnnic-tooltip-label-shortcut",
  "data-testid": "tooltip-label-shortcut"
};
function NZ(e, i, n, a, r, o) {
  return f(), p("div", {
    ref: "tooltip",
    class: B({
      "unnnic-tooltip": n.enabled || n.forceOpen,
      "force-open": n.forceOpen
    }),
    onMouseover: i[0] || (i[0] = (...l) => o.handleResize && o.handleResize(...l))
  }, [
    pe(e.$slots, "default", {}, void 0, !0),
    S1(u("span", {
      ref: "label",
      class: B(["unnnic-tooltip-label", `unnnic-tooltip-label-${n.side}`]),
      style: Ze({ maxWidth: n.maxWidth, left: r.leftPos, top: r.topPos }),
      "data-testid": "tooltip-label"
    }, [
      n.enableHtml ? (f(), p("section", {
        key: 0,
        innerHTML: n.text
      }, null, 8, LZ)) : (f(!0), p(se, { key: 1 }, me(n.text.split(`
`), (l, c) => (f(), p(se, { key: c }, [
        p1(T(l) + " ", 1),
        TZ
      ], 64))), 128)),
      n.shortcutText ? (f(), p("span", SZ, T(n.shortcutText), 1)) : N("", !0)
    ], 6), [
      [ri, n.enabled || n.forceOpen]
    ])
  ], 34);
}
const q1 = /* @__PURE__ */ k(DZ, [["render", NZ], ["__scopeId", "data-v-8c61d974"]]);
const EZ = {
  name: "UnnnicCard",
  components: {
    UnnnicIcon: ce,
    UnnnicAvatarIcon: m2
  },
  props: {
    title: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    percent: {
      type: Number,
      default: 0
    },
    invertedPercentage: {
      type: Boolean,
      default: !1
    },
    scheme: {
      type: String,
      default: null
    }
  },
  computed: {
    color() {
      return this.invertedPercentage ? this.percent < 0 ? "green" : "red" : this.percent < 0 ? "red" : "green";
    }
  }
}, zZ = { class: "unnnic-card-dash" }, IZ = { class: "header" }, BZ = { class: "label" }, OZ = { class: "content" }, HZ = { class: "value" }, jZ = { class: "label" };
function VZ(e, i, n, a, r, o) {
  const l = j("UnnnicAvatarIcon"), c = j("UnnnicIcon");
  return f(), p("div", zZ, [
    u("div", IZ, [
      Z(l, {
        size: "sm",
        scheme: n.scheme,
        icon: n.icon
      }, null, 8, ["scheme", "icon"]),
      u("div", BZ, T(n.title), 1)
    ]),
    u("div", OZ, [
      u("div", HZ, T(n.value), 1),
      n.percent ? (f(), p("div", {
        key: 0,
        class: B(["percent", `unnnic-card-scheme--feedback-${o.color}`])
      }, [
        Z(c, {
          icon: `graph-stats-${n.percent >= 0 ? "ascend" : "descend"}-2`,
          scheme: `feedback-${o.color}`,
          size: "sm",
          class: "icon"
        }, null, 8, ["icon", "scheme"]),
        u("div", jZ, T(n.percent >= 0 ? `+${n.percent}%` : `${n.percent}%`), 1)
      ], 2)) : N("", !0)
    ])
  ]);
}
const FZ = /* @__PURE__ */ k(EZ, [["render", VZ], ["__scopeId", "data-v-aab8cf56"]]);
const PZ = {
  name: "UnnnicCard",
  components: { ToolTip: q1, UnnnicIcon: ce },
  props: {
    title: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    infoPosition: {
      type: String,
      default: "right"
    },
    scheme: {
      type: String,
      default: null
    },
    hasInformationIcon: {
      type: Boolean,
      default: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  }
}, UZ = { class: "unnnic-card-title" }, RZ = { class: "title" };
function YZ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("ToolTip");
  return f(), p("div", UZ, [
    u("div", {
      class: B(["avatar-icon", `unnnic-card-scheme--${n.scheme}`])
    }, [
      Z(l, {
        icon: n.icon,
        scheme: n.scheme,
        size: "md"
      }, null, 8, ["icon", "scheme"])
    ], 2),
    u("div", RZ, T(n.title), 1),
    n.hasInformationIcon ? (f(), $(c, {
      key: 0,
      class: "information",
      side: n.infoPosition,
      text: n.info,
      enabled: n.enabled
    }, {
      default: Ee(() => [
        Z(l, {
          icon: "information-circle-4",
          class: "unnnic-card-title__content_info",
          size: "sm",
          scheme: "neutral-soft"
        })
      ]),
      _: 1
    }, 8, ["side", "text", "enabled"])) : N("", !0)
  ]);
}
const al = /* @__PURE__ */ k(PZ, [["render", YZ], ["__scopeId", "data-v-14d9d015"]]);
const ZZ = {
  name: "UnnnicCard",
  components: { UnnnicIcon: ce },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default: null
    }
  }
}, WZ = { class: "header" }, QZ = { class: "label" }, qZ = { class: "content" }, GZ = { class: "title-container" }, XZ = { class: "title" }, JZ = { class: "description" };
function KZ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B(["unnnic-card-status", `unnnic-card-scheme--${n.scheme}--border`])
  }, [
    u("div", WZ, [
      Z(l, {
        icon: n.icon,
        scheme: "neutral-dark",
        size: "md",
        class: "icon"
      }, null, 8, ["icon"]),
      u("div", QZ, T(n.title), 1)
    ]),
    u("div", qZ, [
      u("div", GZ, [
        Z(l, {
          icon: "indicator",
          scheme: n.scheme,
          size: "sm"
        }, null, 8, ["scheme"]),
        u("div", XZ, T(n.status), 1)
      ]),
      u("div", JZ, T(n.description), 1)
    ])
  ], 2);
}
const $Z = /* @__PURE__ */ k(ZZ, [["render", KZ], ["__scopeId", "data-v-1fc599bf"]]);
const eW = {
  name: "UnnnicCard",
  components: {
    UnnnicAvatarIcon: m2
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    scheme: {
      type: String,
      default: null
    }
  }
}, nW = { class: "icon" }, iW = { class: "content" }, tW = { class: "title" }, aW = { class: "description" };
function sW(e, i, n, a, r, o) {
  const l = j("UnnnicAvatarIcon");
  return f(), p("div", {
    class: B({
      "unnnic-card-account": !0,
      enabled: n.enabled
    })
  }, [
    u("div", nW, [
      Z(l, {
        size: "xs",
        scheme: n.scheme,
        icon: n.icon,
        enabled: n.enabled
      }, null, 8, ["scheme", "icon", "enabled"])
    ]),
    u("div", iW, [
      u("div", tW, T(n.title), 1),
      u("div", aW, T(n.description), 1)
    ])
  ], 2);
}
const oW = /* @__PURE__ */ k(eW, [["render", sW], ["__scopeId", "data-v-7f42cb11"]]);
const rW = {
  name: "UnnnicCard",
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  }
}, lW = { class: "unnnic-card-default__content" }, dW = { class: "unnnic-card-default__title" }, cW = ["title"];
function fW(e, i, n, a, r, o) {
  return f(), p("div", {
    class: B({
      "unnnic-card-default": !0,
      "unnnic-card-default__clickable": n.clickable
    })
  }, [
    u("div", lW, [
      u("div", dW, T(n.title), 1),
      u("p", {
        class: "unnnic-card-default__description",
        title: n.description
      }, T(n.description), 9, cW)
    ])
  ], 2);
}
const uW = /* @__PURE__ */ k(rW, [["render", fW]]);
const hW = {
  name: "UnnnicCard",
  components: {
    UnnnicIcon: ce
  },
  props: {
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  }
}, mW = { class: "unnnic-card-blank__content" }, pW = { class: "unnnic-card-blank__content__text" };
function yW(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B({
      "unnnic-card-blank": !0,
      "unnnic-card-blank__clickable": n.clickable
    })
  }, [
    u("div", mW, [
      Z(l, {
        icon: n.icon,
        scheme: "neutral-clean",
        class: "unnnic-card-blank__content__icon",
        size: "xl"
      }, null, 8, ["icon"]),
      u("div", pW, T(n.text), 1)
    ])
  ], 2);
}
const vW = /* @__PURE__ */ k(hW, [["render", yW]]);
const gW = {
  name: "UnnnicCard",
  components: {
    UnnnicIcon: ce
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    enabled: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  }
}, _W = { class: "unnnic-card-content__content" }, wW = { class: "unnnic-card-content__content__title" }, CW = { class: "unnnic-card-content__content__description" };
function kW(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B({
      "unnnic-card-content": !0,
      "unnnic-card-content--disabled": !n.enabled,
      "unnnic-card-content__clickable": n.clickable
    })
  }, [
    u("div", {
      class: B([
        "unnnic-card-content__icon",
        n.enabled && "unnnic-card-content__icon--disabled"
      ])
    }, [
      Z(l, {
        icon: n.icon,
        scheme: "neutral-cloudy",
        size: "sm"
      }, null, 8, ["icon"])
    ], 2),
    u("div", _W, [
      u("div", wW, T(n.title), 1),
      u("div", CW, T(n.description), 1)
    ])
  ], 2);
}
const xW = /* @__PURE__ */ k(gW, [["render", kW]]);
const bW = {
  name: "UnnnicCard",
  components: { UnnnicIcon: ce },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    comments: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    iconSrc: {
      type: String,
      default: null
    },
    rating: {
      type: Number,
      default: 0
    },
    typeAction: {
      type: String,
      default: null
    }
  },
  methods: {
    cardClick() {
      this.$emit("openModal");
    }
  }
}, MW = {
  class: /* @__PURE__ */ B(["unnnic-card-marketplace__icons"])
}, DW = ["src"], AW = { class: "unnnic-card-marketplace__content" }, LW = { class: "unnnic-card-marketplace__content__title" }, TW = ["title"], SW = {
  key: 0,
  class: "unnnic-card-marketplace__content__rating"
}, NW = { class: "unnnic-card-marketplace__content__rating__value" }, EW = { class: "unnnic-card-marketplace__content__rating__comments" };
function zW(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B({
      "unnnic-card-marketplace": !0,
      "unnnic-card-marketplace__clickable": n.clickable,
      "unnnic-card-marketplace__add": n.typeAction === "add",
      "unnnic-card-marketplace__config": n.typeAction === "config",
      "unnnic-card-marketplace__edit": n.typeAction === "edit"
    }),
    onClick: i[0] || (i[0] = (...c) => o.cardClick && o.cardClick(...c))
  }, [
    u("div", MW, [
      u("img", {
        class: "unnnic-card-marketplace__icons__app",
        src: n.iconSrc
      }, null, 8, DW),
      pe(e.$slots, "actions")
    ]),
    u("div", AW, [
      u("div", LW, T(n.title), 1),
      u("div", {
        class: "unnnic-card-marketplace__content__description",
        title: n.description
      }, T(n.description), 9, TW),
      n.typeAction === "add" ? (f(), p("div", SW, [
        Z(l, {
          class: "unnnic-card-marketplace__content__rating__star",
          scheme: "feedback-yellow",
          icon: "rating-star-1",
          size: "ant"
        }),
        u("div", NW, T(n.rating), 1),
        u("div", EW, " (" + T(n.comments) + ") ", 1)
      ])) : N("", !0)
    ])
  ], 2);
}
const IW = /* @__PURE__ */ k(bW, [["render", zW]]);
const BW = {
  name: "UnnnicCard",
  props: {
    type: {
      type: String,
      default: "title",
      validator(e) {
        return [
          "title",
          "status",
          "dash",
          "account",
          "default",
          "blank",
          "content",
          "marketplace"
        ].indexOf(e) !== -1;
      }
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    percent: {
      type: Number,
      default: 0
    },
    invertedPercentage: {
      type: Boolean,
      default: !1
    },
    rating: {
      type: Number,
      default: 0
    },
    comments: {
      type: String,
      default: null
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    iconSrc: {
      type: String,
      default: null
    },
    infoPosition: {
      type: String,
      default: "right"
    },
    hasInformationIcon: {
      type: Boolean,
      default: !0
    },
    scheme: {
      type: String,
      default: "aux-blue",
      validator(e) {
        return [
          "feedback-red",
          "feedback-green",
          "feedback-yellow",
          "feedback-blue",
          "feedback-grey",
          "aux-blue",
          "aux-purple",
          "aux-orange",
          "aux-lemon",
          "aux-pink",
          "brand-weni-soft"
        ].indexOf(e) !== -1;
      }
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    typeAction: {
      type: String,
      default: null,
      validator(e) {
        return ["add", "config", "edit"].indexOf(e) !== -1;
      }
    },
    buttonAction: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    currentTypeIcon() {
      return this.icon ? this.icon : this.type === "title" ? "graph-stats-1" : this.type === "dash" ? "messages-bubble-1" : this.type === "status" ? "science-fiction-robot-2" : this.type === "account" ? "single-neutral-2" : null;
    },
    currentComponent() {
      return this.type === "title" ? al : this.type === "dash" ? FZ : this.type === "status" ? $Z : this.type === "account" ? oW : this.type === "default" ? uW : this.type === "blank" ? vW : this.type === "content" ? xW : this.type === "marketplace" ? IW : al;
    }
  },
  methods: {
    openModal() {
      this.$emit("openModal");
    }
  }
};
function OW(e, i, n, a, r, o) {
  return f(), $(oi(o.currentComponent), Q1({ class: "unnnic-card-component" }, e.$attrs, {
    title: n.title,
    text: n.text,
    info: n.info,
    icon: o.currentTypeIcon,
    iconSrc: n.iconSrc,
    rating: n.rating,
    comments: n.comments,
    typeAction: n.typeAction,
    buttonAction: n.buttonAction,
    value: n.value,
    percent: n.percent,
    invertedPercentage: n.invertedPercentage || null,
    status: n.status,
    description: n.description,
    infoPosition: n.infoPosition,
    enabled: n.enabled,
    scheme: n.scheme,
    clickable: n.clickable || null,
    hasInformationIcon: n.hasInformationIcon || null,
    onOpenModal: o.openModal
  }), Ol({ _: 2 }, [
    me(e.$slots, (l, c) => ({
      name: c,
      fn: Ee(() => [
        pe(e.$slots, c)
      ])
    }))
  ]), 1040, ["title", "text", "info", "icon", "iconSrc", "rating", "comments", "typeAction", "buttonAction", "value", "percent", "invertedPercentage", "status", "description", "infoPosition", "enabled", "scheme", "clickable", "hasInformationIcon", "onOpenModal"]);
}
const HW = /* @__PURE__ */ k(BW, [["render", OW]]);
const Ao = {
  name: "UnnnicSimpleCard",
  components: {
    UnnnicToolTip: q1,
    UnnnicIcon: ce
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    titleSize: {
      type: String,
      default: "16px"
    },
    titleTooltip: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"]
}, sl = () => {
  Y3((e) => ({
    "14ad6579": e.titleSize
  }));
}, ol = Ao.setup;
Ao.setup = ol ? (e, i) => (sl(), ol(e, i)) : sl;
const jW = {
  key: 0,
  class: "unnnic-simple-card__header"
}, VW = { class: "unnnic-simple-card-header-container" }, FW = { class: "unnnic-simple-card-header-container__title" }, PW = {
  key: 0,
  class: "unnnic-simple-card__header-slot"
}, UW = ["title"], RW = {
  key: 2,
  class: "unnnic-simple-card__footer"
};
function YW(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip");
  return f(), p("section", {
    class: B({
      "unnnic-simple-card": !0,
      "unnnic-simple-card--clickable": n.clickable
    }),
    onClick: i[0] || (i[0] = Qe((h) => n.clickable && e.$emit("click"), ["stop"]))
  }, [
    n.title || e.$slots.headerSlot ? (f(), p("section", jW, [
      u("section", VW, [
        u("h1", FW, T(n.title), 1),
        n.titleTooltip ? (f(), $(c, {
          key: 0,
          text: n.titleTooltip,
          enabled: "",
          class: "unnnic-simple-card-header-container__title-tooltip"
        }, {
          default: Ee(() => [
            Z(l, {
              icon: "info",
              size: "nano",
              scheme: "neutral-cloudy"
            })
          ]),
          _: 1
        }, 8, ["text"])) : N("", !0)
      ]),
      e.$slots.headerSlot ? (f(), p("section", PW, [
        pe(e.$slots, "headerSlot", {}, void 0, !0)
      ])) : N("", !0)
    ])) : N("", !0),
    n.text ? (f(), p("p", {
      key: 1,
      class: "unnnic-simple-card__text",
      title: n.text
    }, T(n.text), 9, UW)) : N("", !0),
    e.$slots.footer ? (f(), p("section", RW, [
      pe(e.$slots, "footer", {}, void 0, !0)
    ])) : N("", !0)
  ], 2);
}
const ZW = /* @__PURE__ */ k(Ao, [["render", YW], ["__scopeId", "data-v-80dbbab7"]]);
const WW = {
  name: "UnnnicTag",
  components: {
    UnnnicIcon: ce
  },
  props: {
    text: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    hasCloseIcon: {
      type: Boolean,
      default: !1
    },
    scheme: {
      type: String,
      default: "aux-purple"
    },
    leftIcon: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    }
  },
  methods: {
    closeClicked() {
      this.closeClicked && this.$emit("close-click");
    },
    emitClose() {
      this.$emit("close");
    }
  }
}, QW = {
  key: 0,
  class: "unnnic-tag__icon"
};
function qW(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("section", {
    class: B(`unnnic-tag
        ${n.disabled ? "unnnic-tag--disabled" : `unnnic-tag-scheme--${n.scheme}`}
        ${n.clickable ? "unnnic-tag--clickable" : ""}`)
  }, [
    n.leftIcon ? (f(), p("section", QW, [
      Z(l, {
        icon: n.leftIcon,
        scheme: n.scheme,
        size: "sm"
      }, null, 8, ["icon", "scheme"])
    ])) : N("", !0),
    u("span", {
      class: B(`unnnic-tag__label
      ${n.disabled ? "unnnic-tag__label--disabled" : ""}`)
    }, T(n.text), 3),
    n.rightIcon || n.hasCloseIcon ? (f(), p("section", {
      key: 1,
      class: B({ "unnnic-tag__icon": !0, clickable: !n.rightIcon }),
      onClick: i[0] || (i[0] = Qe((c) => n.hasCloseIcon ? o.emitClose() : () => {
      }, ["stop"]))
    }, [
      Z(l, {
        icon: n.rightIcon || "close",
        scheme: n.rightIcon ? n.scheme : "neutral-darkest",
        size: "sm"
      }, null, 8, ["icon", "scheme"])
    ], 2)) : N("", !0)
  ], 2);
}
const GW = /* @__PURE__ */ k(WW, [["render", qW], ["__scopeId", "data-v-618eeccb"]]);
const XW = {
  name: "UnnnicTag",
  components: {
    UnnnicIcon: ce,
    ToolTip: q1
  },
  props: {
    text: {
      type: String,
      default: null
    },
    tooltipText: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      default: 0
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    hasBackButton: {
      type: Boolean,
      default: !1
    },
    enableTooltip: {
      type: Boolean,
      default: !1
    }
  }
}, JW = { class: "unnnic-tag__count" }, KW = { class: "unnnic-tag__label" };
function $W(e, i, n, a, r, o) {
  const l = j("ToolTip"), c = j("UnnnicIcon");
  return f(), p("div", {
    class: B(`unnnic-tag
        ${n.clickable ? "unnnic-tag--clickable" : ""}`)
  }, [
    Z(l, {
      enabled: n.enableTooltip,
      text: n.tooltipText,
      side: "bottom"
    }, {
      default: Ee(() => [
        u("span", JW, T(n.count), 1)
      ]),
      _: 1
    }, 8, ["enabled", "text"]),
    u("span", KW, T(n.text), 1),
    n.hasBackButton ? (f(), $(c, {
      key: 0,
      icon: "arrow-right-1-1",
      class: "unnnic-tag__icon",
      scheme: "neutral-darkest",
      size: "xs"
    })) : N("", !0)
  ], 2);
}
const eQ = /* @__PURE__ */ k(XW, [["render", $W], ["__scopeId", "data-v-e2dde609"]]);
const nQ = {
  name: "UnnnicBrandTag",
  components: {
    UnnnicIcon: ce
  },
  props: {
    text: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    closeClicked() {
      this.closeClicked && this.$emit("close-click");
    }
  }
}, iQ = { class: "unnnic-brand-tag__label" };
function tQ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B({
      "unnnic-brand-tag": !0,
      "unnnic-brand-tag--disabled": !n.disabled,
      "unnnic-brand-tag--clickable": n.clickable
    })
  }, [
    u("span", iQ, T(n.text), 1),
    Z(l, {
      icon: n.disabled ? "close-1" : "add-1",
      scheme: n.disabled ? "neutral-snow" : "brand-weni-dark",
      class: "unnnic-brand-tag__icon",
      size: "xs"
    }, null, 8, ["icon", "scheme"])
  ], 2);
}
const aQ = /* @__PURE__ */ k(nQ, [["render", tQ], ["__scopeId", "data-v-5f94d752"]]);
const sQ = {
  name: "TagNext",
  props: {
    text: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default: "weni"
    }
  }
}, oQ = { class: "unnnic-tag-next__text" };
function rQ(e, i, n, a, r, o) {
  return f(), p("section", {
    class: B(["unnnic-tag-next", `unnnic-tag-next--${n.scheme}`])
  }, [
    u("p", oQ, T(n.text), 1)
  ], 2);
}
const lQ = /* @__PURE__ */ k(sQ, [["render", rQ], ["__scopeId", "data-v-93d929a6"]]), dQ = {
  name: "UnnnicTag",
  props: {
    type: {
      type: String,
      default: "default",
      validator(e) {
        return ["default", "indicator", "brand", "next"].indexOf(e) !== -1;
      }
    },
    text: {
      type: String,
      default: null
    },
    tooltipText: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    count: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    hasCloseIcon: {
      type: Boolean,
      default: !1
    },
    scheme: {
      type: String,
      default: "aux-purple"
    },
    hasBackButton: {
      type: Boolean,
      default: !1
    },
    enableTooltip: {
      type: Boolean,
      default: !1
    },
    leftIcon: {
      type: String,
      default: ""
    },
    rightIcon: {
      type: String,
      default: ""
    }
  },
  computed: {
    currentComponent() {
      return this.type === "indicator" ? eQ : this.type === "brand" ? aQ : this.type === "next" ? lQ : GW;
    }
  }
};
function cQ(e, i, n, a, r, o) {
  return f(), $(oi(o.currentComponent), Q1({ class: "unnnic-tag-content" }, e.$attrs, {
    text: n.text,
    disabled: n.disabled,
    hasCloseIcon: n.hasCloseIcon,
    scheme: n.scheme,
    count: n.count,
    hasBackButton: n.hasBackButton,
    clickable: n.clickable,
    tooltipText: n.tooltipText,
    enableTooltip: n.enableTooltip,
    leftIcon: n.leftIcon,
    rightIcon: n.rightIcon
  }), null, 16, ["text", "disabled", "hasCloseIcon", "scheme", "count", "hasBackButton", "clickable", "tooltipText", "enableTooltip", "leftIcon", "rightIcon"]);
}
const ea = /* @__PURE__ */ k(dQ, [["render", cQ]]);
const fQ = {
  components: {
    UnnnicTag: ea
  },
  mixins: [yn],
  props: {
    oldVersion: Boolean,
    name: String,
    description: String,
    plan: String,
    actionText: String
  },
  data() {
    return {
      isOptionsOpen: !1
    };
  }
}, uQ = { class: "name" }, hQ = { class: "description" }, mQ = { key: 1 };
function pQ(e, i, n, a, r, o) {
  const l = j("UnnnicTag"), c = j("UnnnicIcon"), h = j("UnnnicDropdown");
  return f(), p("div", {
    class: B([
      "unnnic-connect-card-company",
      { "unnnic-connect-card-company--old-version": n.oldVersion }
    ]),
    onClick: i[3] || (i[3] = (y) => e.$emit("enter"))
  }, [
    u("div", null, [
      u("h2", uQ, T(n.name), 1),
      u("p", hQ, T(n.description), 1),
      n.plan ? (f(), p("div", {
        key: 0,
        class: B(["tag", n.plan])
      }, T(e.i18n(`plans.${n.plan}`)), 3)) : N("", !0)
    ]),
    n.actionText ? (f(), $(l, {
      key: 0,
      class: "action",
      clickable: "",
      text: n.actionText,
      scheme: "aux-blue",
      onClick: i[0] || (i[0] = (y) => e.$emit("action"))
    }, null, 8, ["text"])) : N("", !0),
    e.$slots.options ? (f(), p("div", mQ, [
      Z(h, {
        open: r.isOptionsOpen,
        "onUpdate:open": i[1] || (i[1] = (y) => r.isOptionsOpen = y),
        class: "unnnic-dropdown",
        onClick: i[2] || (i[2] = Qe(() => {
        }, ["prevent"]))
      }, {
        trigger: Ee(() => [
          Z(c, {
            class: "menu-icon",
            icon: "navigation-menu-vertical-1",
            size: "sm",
            scheme: r.isOptionsOpen ? "neutral-cloudy" : "neutral-clean"
          }, null, 8, ["scheme"])
        ]),
        default: Ee(() => [
          pe(e.$slots, "options", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["open"])
    ])) : N("", !0)
  ], 2);
}
const yQ = /* @__PURE__ */ k(fQ, [["render", pQ], ["__scopeId", "data-v-331afc72"]]);
const vQ = {
  components: { UnnnicIcon: ce },
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    score: {
      type: String
    },
    info: {
      type: String
    },
    checked: {
      type: Boolean,
      default: !1
    }
  }
}, gQ = { class: "card" }, _Q = { class: "header" }, wQ = { class: "title" }, CQ = {
  key: 0,
  class: "check"
}, kQ = { class: "description" }, xQ = {
  key: 0,
  class: "footer"
}, bQ = { class: "evaluation" }, MQ = { class: "info" };
function DQ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", gQ, [
    u("div", _Q, [
      u("div", wQ, T(n.title), 1),
      n.checked ? (f(), p("div", CQ, [
        Z(l, {
          size: "md",
          icon: "check-circle-1-1-1",
          scheme: "feedback-green"
        })
      ])) : N("", !0)
    ]),
    u("div", kQ, T(n.description), 1),
    n.score || n.info ? (f(), p("div", xQ, [
      u("div", bQ, [
        n.score ? (f(), $(l, {
          key: 0,
          size: "sm",
          icon: "rating-star-1",
          scheme: "feedback-yellow"
        })) : N("", !0),
        p1(" " + T(n.score) + " ", 1),
        u("span", MQ, T(n.info), 1)
      ])
    ])) : N("", !0)
  ]);
}
const AQ = /* @__PURE__ */ k(vQ, [["render", DQ], ["__scopeId", "data-v-b40ec35c"]]);
const LQ = {
  components: {
    UnnnicIcon: ce
  },
  model: {
    event: "change"
  },
  props: {
    modelValue: {
      type: [Boolean, String],
      default: !1,
      validator(e) {
        return [!0, !1, "less"].includes(e);
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md",
      validator(e) {
        return ["md", "sm"].includes(e);
      }
    },
    textRight: {
      type: String,
      default: ""
    }
  },
  emits: ["change", "update:model-value"],
  computed: {
    valueName() {
      return this.modelValue === !0 ? "checked" : this.modelValue === !1 ? "default" : "less";
    },
    icon() {
      return {
        checked: "checkbox-select",
        default: this.disabled ? "checkbox-disable" : "checkbox-default",
        less: "checkbox-less"
      }[this.valueName];
    },
    color() {
      return this.valueName === "default" ? "neutral-clean" : "brand-weni";
    }
  },
  methods: {
    click() {
      const e = ["checked", "less"].includes(this.valueName);
      this.$emit("change", !e), this.$emit("update:model-value", !e);
    }
  }
}, TQ = { class: "unnnic-checkbox-wrapper" };
function SQ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", TQ, [
    Z(l, {
      class: B(["unnnic-checkbox", { disabled: n.disabled }]),
      icon: o.icon,
      scheme: o.color,
      clickable: !n.disabled,
      size: n.size,
      onClick: o.click
    }, null, 8, ["class", "icon", "scheme", "clickable", "size", "onClick"]),
    n.textRight ? (f(), p("div", {
      key: 0,
      class: B([
        "unnnic-checkbox__label",
        "unnnic-checkbox__label__right",
        `unnnic-checkbox__label__${n.size}`
      ]),
      "data-testid": "checkbox-text-right"
    }, T(n.textRight), 3)) : N("", !0)
  ]);
}
const V0 = /* @__PURE__ */ k(LQ, [["render", SQ], ["__scopeId", "data-v-f5f8c62c"]]);
const NQ = {
  components: {
    UnnnicIcon: ce,
    UnnnicCheckbox: V0,
    UnnnicAvatarIcon: m2,
    UnnnicDropdown: Do
  },
  props: {
    modelValue: Boolean,
    title: String,
    description: String,
    image: String,
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  }
}, EQ = { class: "header" }, zQ = { class: "content" }, IQ = {
  key: 0,
  class: "u font secondary body-lg bold color-neutral-darkest"
}, BQ = {
  key: 1,
  class: "u font secondary body-md color-neutral-cloudy"
}, OQ = ["src"], HQ = {
  key: 0,
  class: "details"
}, jQ = { class: "u font secondary body-gt color-neutral-dark" }, VQ = { class: "value-container" }, FQ = { class: "u font secondary body-gt black color-neutral-darkest" };
function PQ(e, i, n, a, r, o) {
  const l = j("UnnnicCheckbox"), c = j("UnnnicIcon"), h = j("UnnnicDropdown"), y = j("UnnnicAvatarIcon");
  return f(), p("div", {
    class: B(["unnnic-card-image", { checked: n.modelValue }])
  }, [
    u("div", EQ, [
      u("div", zQ, [
        n.title ? (f(), p("div", IQ, T(n.title), 1)) : N("", !0),
        n.description ? (f(), p("div", BQ, T(n.description), 1)) : N("", !0)
      ]),
      Z(l, {
        modelValue: n.modelValue,
        onChange: i[0] || (i[0] = (v) => e.$emit("update:model-value", v))
      }, null, 8, ["modelValue"]),
      e.$slots.actions ? (f(), $(h, {
        key: 0,
        position: "bottom-left"
      }, {
        trigger: Ee(() => [
          Z(c, {
            icon: "navigation-menu-vertical-1",
            size: "sm",
            scheme: "neutral-cleanest",
            clickable: ""
          })
        ]),
        default: Ee(() => [
          pe(e.$slots, "actions", {}, void 0, !0)
        ]),
        _: 3
      })) : N("", !0)
    ]),
    u("img", {
      class: "image",
      src: n.image
    }, null, 8, OQ),
    n.data.length ? (f(), p("div", HQ, [
      (f(!0), p(se, null, me(n.data, (v, x) => (f(), p("div", {
        key: x,
        class: "data"
      }, [
        u("div", jQ, T(v.name), 1),
        u("div", VQ, [
          Z(y, {
            icon: v.icon,
            size: "xs",
            scheme: v.scheme
          }, null, 8, ["icon", "scheme"]),
          u("div", FQ, T(v.value), 1)
        ])
      ]))), 128))
    ])) : N("", !0)
  ], 2);
}
const UQ = /* @__PURE__ */ k(NQ, [["render", PQ], ["__scopeId", "data-v-87c573e3"]]);
const RQ = {
  components: {
    UnnnicIcon: ce,
    UnnnicDropdown: Do,
    UnnnicDropdownItem: bc
  },
  mixins: [yn],
  props: {
    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      required: !0
    },
    canUpdateStatus: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click", "changeProjectStatus"],
  data() {
    return {
      openDropdown: !1,
      defaultTranslations: {
        IN_TEST: {
          "pt-br": "Em teste",
          en: "In test",
          es: "En prueba"
        },
        ACTIVE: {
          "pt-br": "Ativo",
          en: "Active",
          es: "Activo"
        },
        INACTIVE: {
          "pt-br": "Inativo",
          en: "Inactive",
          es: "Inactivo"
        }
      }
    };
  },
  computed: {
    showActions() {
      var i, n;
      const e = (n = (i = this.$slots).actions) == null ? void 0 : n.call(i);
      return !!(e != null && e.length);
    },
    colorStatus() {
      return {
        ACTIVE: "aux-green-900",
        INACTIVE: "neutral-cloudy",
        IN_TEST: "aux-orange-500"
      }[this.status];
    },
    statusOptions() {
      return ["ACTIVE", "INACTIVE", "IN_TEST"].filter(
        (e) => e !== this.status
      );
    }
  },
  methods: {
    emitClick(e) {
      this.clickable && this.$emit("click", { button: e == null ? void 0 : e.button });
    },
    handlerDropdownOpen() {
      this.canUpdateStatus && (this.openDropdown = !this.openDropdown);
    },
    handlerClickDropdownItem(e) {
      this.$emit("changeProjectStatus", e);
    }
  }
}, YQ = { class: "unnnic-card-project__header" }, ZQ = ["title"], WQ = { class: "unnnic-card-project__description" }, QQ = ["title"], qQ = { class: "unnnic-card-project__bottom" }, GQ = { class: "unnnic-card-project__status-options-container" };
function XQ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicDropdown"), h = j("UnnnicDropdownItem");
  return f(), p("section", {
    class: B({
      "unnnic-card-project": !0,
      "unnnic-card-project--clickable": n.clickable,
      "unnnic-card-project--inactive": n.status === "INACTIVE"
    }),
    "data-testid": "unnnic-card-project",
    onClick: [
      i[2] || (i[2] = Qe((...y) => o.emitClick && o.emitClick(...y), ["left", "exact"])),
      i[4] || (i[4] = Qe((y) => o.emitClick({ button: 1 }), ["ctrl"]))
    ],
    onMouseup: i[3] || (i[3] = Qe((...y) => o.emitClick && o.emitClick(...y), ["middle", "exact", "prevent"]))
  }, [
    u("section", YQ, [
      u("h1", {
        title: n.name,
        class: B({
          "unnnic-card-project__title": !0,
          "unnnic-card-project__title--inactive": n.status === "INACTIVE"
        }),
        "data-testid": "card-project-title"
      }, T(n.name), 11, ZQ),
      o.showActions ? (f(), $(c, {
        key: 0,
        position: "bottom-left",
        "data-testid": "dropdown-actions"
      }, {
        trigger: Ee(() => [
          Z(l, {
            size: "sm",
            icon: "navigation-menu-vertical-1",
            clickable: "",
            scheme: "neutral-cleanest"
          })
        ]),
        default: Ee(() => [
          pe(e.$slots, "actions", {}, void 0, !0)
        ]),
        _: 3
      })) : N("", !0)
    ]),
    u("section", WQ, [
      u("p", {
        title: n.description,
        class: B({
          "unnnic-card-project__description": !0,
          "unnnic-card-project__description--inactive": n.status === "INACTIVE"
        })
      }, T(n.description), 11, QQ)
    ]),
    u("section", qQ, [
      u("section", {
        class: B([
          "unnnic-card-project__status-chip",
          `unnnic-card-project__status-chip--${n.status}`
        ]),
        "data-testid": "project-status-chip",
        onClick: i[1] || (i[1] = Qe((y) => o.handlerDropdownOpen(), ["stop"]))
      }, [
        u("p", null, T(e.i18n(n.status)), 1),
        n.canUpdateStatus ? (f(), $(l, {
          key: 0,
          icon: "keyboard_arrow_down",
          size: "sm",
          clickable: "",
          scheme: o.colorStatus
        }, null, 8, ["scheme"])) : N("", !0),
        Z(c, {
          open: r.openDropdown,
          useOpenProp: "",
          "data-testid": "status-dropdown",
          "onUpdate:open": i[0] || (i[0] = (y) => r.openDropdown = y)
        }, {
          default: Ee(() => [
            u("section", GQ, [
              (f(!0), p(se, null, me(o.statusOptions, (y) => (f(), $(h, {
                key: y,
                class: "status-option",
                onClick: (v) => o.handlerClickDropdownItem(y)
              }, {
                default: Ee(() => [
                  p1(T(e.i18n(y)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))), 128))
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ], 2)
    ])
  ], 34);
}
const JQ = /* @__PURE__ */ k(RQ, [["render", XQ], ["__scopeId", "data-v-d7f7ed7d"]]);
const KQ = {
  components: {
    UnnnicAvatarIcon: m2,
    UnnnicToolTip: q1,
    UnnnicIcon: ce
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    descriptionRow: {
      type: String,
      default: ""
    },
    descriptionRowInfo: {
      type: String,
      default: ""
    },
    statuses: {
      type: Array
    },
    minStatusWidth: {
      type: [String, Number],
      default: 5.625 * Z3
    }
  }
}, $Q = (e) => (hn("data-v-d88c3045"), e = e(), mn(), e), eq = { class: "unnnic-card-container" }, nq = { class: "header" }, iq = { class: "title" }, tq = ["title"], aq = {
  key: 0,
  class: "subtitle"
}, sq = {
  key: 0,
  class: "description"
}, oq = {
  key: 1,
  class: "description-row-container"
}, rq = {
  key: 0,
  class: "description-row"
}, lq = /* @__PURE__ */ $Q(() => /* @__PURE__ */ u("div", { class: "separator" }, null, -1)), dq = { class: "title" }, cq = { class: "content" }, fq = { class: "number" };
function uq(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip"), h = j("UnnnicAvatarIcon");
  return f(), p("div", eq, [
    u("div", nq, [
      u("div", iq, [
        u("span", {
          class: "name",
          title: n.name.length > 25 ? n.name : null
        }, T(n.name), 9, tq),
        n.subtitle ? (f(), p("div", aq, T(n.subtitle), 1)) : N("", !0)
      ]),
      pe(e.$slots, "header-buttons", {}, void 0, !0)
    ]),
    n.description ? (f(), p("div", sq, T(n.description), 1)) : N("", !0),
    n.descriptionRow || n.descriptionRowInfo ? (f(), p("div", oq, [
      n.descriptionRow ? (f(), p("div", rq, T(n.descriptionRow), 1)) : N("", !0),
      n.descriptionRowInfo ? (f(), $(c, {
        key: 1,
        side: "top",
        text: n.descriptionRowInfo,
        enabled: ""
      }, {
        default: Ee(() => [
          Z(l, {
            class: "info",
            icon: "information-circle-4",
            size: "sm",
            scheme: "neutral-soft"
          })
        ]),
        _: 1
      }, 8, ["text"])) : N("", !0)
    ])) : N("", !0),
    lq,
    pe(e.$slots, "content", {}, void 0, !0),
    u("div", {
      class: "statuses",
      style: Ze({
        gridTemplateColumns: `repeat(auto-fit, minmax(${n.minStatusWidth}, 1fr))`
      })
    }, [
      (f(!0), p(se, null, me(n.statuses, (y, v) => (f(), p("div", {
        key: v,
        class: "status"
      }, [
        u("div", dq, T(y.title), 1),
        u("div", cq, [
          Z(h, {
            icon: y.icon,
            scheme: y.scheme,
            size: "xs"
          }, null, 8, ["icon", "scheme"]),
          u("div", fq, T(y.count), 1)
        ])
      ]))), 128))
    ], 4)
  ]);
}
const hq = /* @__PURE__ */ k(KQ, [["render", uq], ["__scopeId", "data-v-d88c3045"]]);
const mq = {
  components: {
    CardStatusesContainer: hq
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    descriptionRow: {
      type: String,
      default: ""
    },
    descriptionRowInfo: {
      type: String,
      default: ""
    },
    statuses: {
      type: Array
    }
  },
  data() {
    return {
      unnnicFontSize: Z3
    };
  }
};
function pq(e, i, n, a, r, o) {
  const l = j("CardStatusesContainer");
  return f(), $(l, {
    class: "unnnic-card-information",
    name: n.name,
    subtitle: n.subtitle,
    description: n.description,
    descriptionRow: n.descriptionRow,
    descriptionRowInfo: n.descriptionRowInfo,
    statuses: n.statuses,
    minStatusWidth: 8.75 * r.unnnicFontSize + "px"
  }, null, 8, ["name", "subtitle", "description", "descriptionRow", "descriptionRowInfo", "statuses", "minStatusWidth"]);
}
const yq = /* @__PURE__ */ k(mq, [["render", pq], ["__scopeId", "data-v-ee17403c"]]);
const vq = { class: "unnnic-collapse__body" }, gq = {
  __name: "Collapse",
  props: {
    title: String,
    active: Boolean,
    borderBottom: Boolean,
    unspacedIcon: Boolean,
    size: {
      type: String,
      default: "lg",
      validator(e) {
        return ["md", "lg"].includes(e);
      }
    },
    modelValue: Boolean
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: i }) {
    const n = e, a = i, r = L1(!1);
    return Si(r, (o) => {
      a("change", o), a("update:modelValue", o);
    }), Si(
      () => n.active,
      (o) => {
        r.value = o;
      },
      { immediate: !0 }
    ), Si(
      () => n.modelValue,
      (o) => {
        r.value = o;
      },
      { immediate: !0 }
    ), (o, l) => (f(), p("div", {
      "data-testid": "collapse",
      class: B([
        "unnnic-collapse",
        `unnnic-collapse--size-${e.size}`,
        {
          "unnnic-collapse--border-bottom": e.borderBottom,
          "unnnic-collapse--unspaced-icon": e.unspacedIcon,
          "unnnic-collapse--active": r.value
        }
      ])
    }, [
      u("div", {
        "data-testid": "collapse-header",
        class: "unnnic-collapse__header",
        onClick: l[0] || (l[0] = (c) => r.value = !r.value)
      }, [
        p1(T(e.title), 1),
        pe(o.$slots, "header", {}, void 0, !0),
        Z(ce, {
          size: "xs",
          icon: r.value ? "arrow-button-up-1" : "arrow-button-down-1",
          scheme: r.value ? "neutral-dark" : "neutral-cloudy"
        }, null, 8, ["icon", "scheme"])
      ]),
      S1(u("div", vq, [
        pe(o.$slots, "default", {}, void 0, !0)
      ], 512), [
        [ri, r.value]
      ])
    ], 2));
  }
}, _q = /* @__PURE__ */ k(gq, [["__scopeId", "data-v-1f77973f"]]);
const wq = { class: "label" }, Cq = {
  __name: "Radio",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md",
      validator(e) {
        return ["md", "sm"].includes(e);
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: i }) {
    const n = e, a = i, r = T1(
      () => n.modelValue === n.value ? "selected" : "default"
    ), o = T1(
      () => ({
        selected: "radio-selected",
        default: n.disabled ? "radio-disable" : "radio-default"
      })[r.value]
    ), l = T1(() => n.disabled ? "brand-sec" : r.value === "selected" ? "brand-weni" : "neutral-cleanest");
    function c() {
      n.disabled || a("update:modelValue", n.value);
    }
    return (h, y) => (f(), p("div", {
      class: B([
        "unnnic-radio-container",
        `unnnic-radio-container--${e.size}`,
        e.disabled ? "disabled" : null
      ]),
      onClick: c
    }, [
      Z(ce, {
        class: "unnnic-radio",
        icon: o.value,
        scheme: l.value,
        size: e.size
      }, null, 8, ["icon", "scheme", "size"]),
      u("span", wq, [
        pe(h.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}, Mc = /* @__PURE__ */ k(Cq, [["__scopeId", "data-v-abd1b195"]]), kq = {
  name: "Flag",
  components: {
    UnnnicIcon: ce
  },
  props: {
    code: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: "md",
      validator(e) {
        return ["nano", "xs", "sm", "md", "lg"].indexOf(e) !== -1;
      }
    }
  },
  computed: {
    name() {
      return {
        "pt-br": "Brazil",
        en: "USA",
        es: "Spain"
      }[this.code];
    }
  }
};
function xq(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), $(l, {
    icon: o.name,
    size: n.size
  }, null, 8, ["icon", "size"]);
}
const bq = /* @__PURE__ */ k(kq, [["render", xq]]);
const Mq = {
  name: "LanguageSelect",
  components: {
    UnnnicFlag: bq,
    UnnnicIcon: ce
  },
  directives: {
    onClickOutside: H0
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top-right"
    },
    contracted: {
      type: Boolean,
      default: !1
    },
    supportedLanguages: {
      type: Array,
      default: () => ["pt-br", "en"]
    }
  },
  data() {
    return {
      open: !1,
      val: this.modelValue,
      unnnicFontSize: Z3
    };
  },
  computed: {
    languages() {
      const e = {
        "pt-br": "Português - Brasil",
        en: "English",
        es: "Español"
      };
      return this.supportedLanguages.reduce(
        (i, n) => ({
          ...i,
          [n]: e[n]
        }),
        {}
      );
    },
    otherLanguages() {
      return this.languageList.filter(({ id: e }) => e !== this.val);
    },
    languageList() {
      return Object.entries(this.languages).map(([e, i]) => ({ id: e, name: i }));
    },
    dropdownIcon() {
      let e = "";
      return this.position === "bottom" ? e = this.open ? "up" : "down" : e = this.open ? "down" : "up", `arrow-button-${e}-1`;
    }
  },
  watch: {
    val() {
      this.$emit("update:model-value", this.val);
    },
    modelValue() {
      this.val = this.modelValue;
    }
  },
  methods: {
    onClickTrigger() {
      this.open = !this.open;
    },
    onClickOutside() {
      this.open && (this.open = !1);
    }
  }
}, Dq = {
  key: 0,
  class: "unnnic-language-select contracted"
}, Aq = { class: "option" }, Lq = ["onClick"], Tq = {
  key: 1,
  class: "unnnic-language-select normal"
}, Sq = { class: "option" }, Nq = { class: "label" }, Eq = /* @__PURE__ */ u("div", { class: "divider" }, null, -1), zq = ["onClick"], Iq = { class: "label" }, Bq = /* @__PURE__ */ u("div", { class: "divider" }, null, -1), Oq = { class: "option" }, Hq = { class: "label" };
function jq(e, i, n, a, r, o) {
  const l = j("UnnnicFlag"), c = j("UnnnicIcon"), h = G2("on-click-outside");
  return n.contracted ? S1((f(), p("div", Dq, [
    u("div", {
      class: B(["container contracted", { open: r.open }]),
      onClick: i[0] || (i[0] = (...y) => o.onClickTrigger && o.onClickTrigger(...y))
    }, [
      u("div", Aq, [
        Z(l, {
          size: "sm",
          code: r.val
        }, null, 8, ["code"])
      ]),
      (f(!0), p(se, null, me(o.otherLanguages, (y) => (f(), p("div", {
        key: y.id,
        class: "option",
        onClick: (v) => r.val = y.id
      }, [
        Z(l, {
          size: "sm",
          code: y.id
        }, null, 8, ["code"])
      ], 8, Lq))), 128))
    ], 2)
  ])), [
    [h, o.onClickOutside]
  ]) : S1((f(), p("div", Tq, [
    u("div", {
      class: B(["container normal", { open: r.open }]),
      onClick: i[1] || (i[1] = (...y) => o.onClickTrigger && o.onClickTrigger(...y))
    }, [
      u("div", {
        style: Ze({
          position: "absolute",
          [n.position === "bottom" ? "top" : "bottom"]: -0.125 * r.unnnicFontSize + "px",
          width: "100%",
          padding: 0.0625 * r.unnnicFontSize + "px",
          left: -0.0625 * r.unnnicFontSize + "px"
        }),
        class: "all"
      }, [
        n.position === "bottom" ? (f(), p(se, { key: 0 }, [
          u("div", Sq, [
            Z(l, {
              size: "sm",
              code: r.val
            }, null, 8, ["code"]),
            u("div", Nq, T(o.languages[r.val]), 1),
            Z(c, {
              size: "xs",
              icon: o.dropdownIcon,
              scheme: "neutral-clean"
            }, null, 8, ["icon"])
          ]),
          Eq
        ], 64)) : N("", !0),
        (f(!0), p(se, null, me(o.otherLanguages, (y) => (f(), p("div", {
          key: y.id,
          class: "option",
          onClick: (v) => r.val = y.id
        }, [
          Z(l, {
            size: "sm",
            code: y.id
          }, null, 8, ["code"]),
          u("div", Iq, T(o.languages[y.id]), 1)
        ], 8, zq))), 128)),
        n.position !== "bottom" ? (f(), p(se, { key: 1 }, [
          Bq,
          u("div", Oq, [
            Z(l, {
              size: "sm",
              code: r.val
            }, null, 8, ["code"]),
            u("div", Hq, T(o.languages[r.val]), 1),
            Z(c, {
              size: "xs",
              icon: o.dropdownIcon,
              scheme: "neutral-clean"
            }, null, 8, ["icon"])
          ])
        ], 64)) : N("", !0)
      ], 4)
    ], 2)
  ])), [
    [h, o.onClickOutside]
  ]);
}
const Vq = /* @__PURE__ */ k(Mq, [["render", jq]]);
const Fq = {
  name: "UnnnicModal",
  components: {
    UnnnicIcon: ce
  },
  props: {
    text: {
      type: String,
      default: null
    },
    modalIcon: {
      type: String,
      default: null
    },
    closeIcon: {
      type: Boolean,
      default: !0
    },
    description: {
      type: String,
      default: null
    },
    alertMessage: {
      type: String,
      default: null
    },
    showModal: {
      type: Boolean,
      default: !0
    },
    scheme: {
      type: String,
      default: null
    },
    persistent: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasAlertMessage() {
      return !(this.alertMessage === null || this.alertMessage.length === 0);
    },
    hasButton() {
      var e, i;
      return !!((i = (e = this.$slots).options) != null && i.call(e).length);
    },
    hasIcon() {
      var e, i;
      return !!((i = (e = this.$slots).icon) != null && i.call(e).length);
    }
  },
  mounted() {
    window.innerWidth <= 600 && this.mobileAnimateOpen();
  },
  methods: {
    mobileAnimateReset() {
      this.$refs.modalContainer && (this.$refs.modalContainer.style.transition = null), this.$refs.modal && (this.$refs.modal.style.transition = null);
    },
    mobileAnimateOpen() {
      this.$nextTick(() => {
        this.$refs.modalContainer && (this.$refs.modalContainer.style.transition = "none", this.$refs.modalContainer.style.backgroundColor = "transparent"), this.$refs.modal && (this.$refs.modal.style.transition = "none", this.$refs.modal.style.marginBottom = `${-this.$refs.modal.offsetHeight}px`), setTimeout(() => {
          this.$refs.modalContainer && (this.$refs.modalContainer.style.transition = "background-color 0.2s", this.$refs.modalContainer.style.backgroundColor = null), this.$refs.modal && (this.$refs.modal.style.transition = "margin-bottom 0.2s", this.$refs.modal.style.marginBottom = null), setTimeout(() => {
            this.mobileAnimateReset();
          }, 200);
        });
      });
    },
    mobileAnimateClose() {
      return new Promise((e) => {
        this.$refs.modalContainer && (this.$refs.modalContainer.style.transition = "background-color 0.2s", this.$refs.modalContainer.style.backgroundColor = "transparent"), this.$refs.modal && (this.$refs.modal.style.transition = "margin-bottom 0.2s", this.$refs.modal.style.marginBottom = `${-this.$refs.modal.offsetHeight}px`), setTimeout(() => {
          this.mobileAnimateReset(), e();
        }, 200);
      });
    },
    onOutsideCloseClick() {
      this.persistent || this.onCloseClick();
    },
    async onCloseClick() {
      console.log("keycloak log", window), window.innerWidth <= 600 && await this.mobileAnimateClose(), this.$emit("close");
    }
  }
}, Pq = {
  ref: "modal",
  class: "unnnic-modal-container-background"
}, Uq = { class: "unnnic-modal-container-background-body" }, Rq = {
  key: 0,
  class: "unnnic-modal-container-background-body-close_icon"
}, Yq = {
  key: 1,
  class: "unnnic-modal-container-background-body__icon-slot"
}, Zq = { class: "unnnic-modal-container-background-body-title" }, Wq = { class: "unnnic-modal-container-background-body-description-container" }, Qq = { class: "unnnic-modal-container-background-body-description" }, qq = {
  key: 0,
  class: "unnnic-modal-container-background-report"
}, Gq = {
  key: 1,
  class: "unnnic-modal-container-background-button"
};
function Xq(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), $(R3, { name: "modal" }, {
    default: Ee(() => [
      n.showModal ? (f(), p("div", Q1({ key: 0 }, e.$attrs, {
        ref: "modalContainer",
        class: ["unnnic-modal"]
      }), [
        u("div", {
          class: "unnnic-modal-container",
          onClick: i[0] || (i[0] = Qe((...c) => o.onOutsideCloseClick && o.onOutsideCloseClick(...c), ["self"]))
        }, [
          u("div", Pq, [
            u("div", Uq, [
              n.closeIcon ? (f(), p("div", Rq, [
                Z(l, {
                  icon: "close-1",
                  scheme: "neutral-dark",
                  size: "sm",
                  clickable: "",
                  onClick: o.onCloseClick
                }, null, 8, ["onClick"])
              ])) : N("", !0),
              o.hasIcon ? (f(), p("div", Yq, [
                pe(e.$slots, "icon", {}, void 0, !0)
              ])) : N("", !0),
              n.modalIcon ? (f(), p("div", {
                key: 2,
                class: B([
                  "unnnic-modal-container-background-body-alert_icon",
                  `unnnic-card-scheme--${n.scheme}--icon`,
                  n.closeIcon ? "" : "unnnic-modal-container-background-body-spacing_header"
                ])
              }, [
                Z(l, {
                  scheme: n.scheme,
                  icon: n.modalIcon,
                  size: "xl"
                }, null, 8, ["scheme", "icon"])
              ], 2)) : N("", !0),
              u("div", Zq, T(n.text), 1)
            ]),
            u("div", Wq, [
              u("div", Qq, [
                p1(T(n.description) + " ", 1),
                pe(e.$slots, "message", {}, void 0, !0),
                pe(e.$slots, "default", {}, void 0, !0)
              ])
            ]),
            o.hasAlertMessage ? (f(), p("div", qq, T(n.alertMessage), 1)) : N("", !0),
            o.hasButton ? (f(), p("div", Gq, [
              pe(e.$slots, "options", {}, void 0, !0)
            ])) : N("", !0)
          ], 512)
        ])
      ], 16)) : N("", !0)
    ]),
    _: 3
  });
}
const Dc = /* @__PURE__ */ k(Fq, [["render", Xq], ["__scopeId", "data-v-64ca1a24"]]), Ac = { "application/prs.cww": ["cww"], "application/prs.xsf+xml": ["xsf"], "application/vnd.1000minds.decision-model+xml": ["1km"], "application/vnd.3gpp.pic-bw-large": ["plb"], "application/vnd.3gpp.pic-bw-small": ["psb"], "application/vnd.3gpp.pic-bw-var": ["pvb"], "application/vnd.3gpp2.tcap": ["tcap"], "application/vnd.3m.post-it-notes": ["pwn"], "application/vnd.accpac.simply.aso": ["aso"], "application/vnd.accpac.simply.imp": ["imp"], "application/vnd.acucobol": ["acu"], "application/vnd.acucorp": ["atc", "acutc"], "application/vnd.adobe.air-application-installer-package+zip": ["air"], "application/vnd.adobe.formscentral.fcdt": ["fcdt"], "application/vnd.adobe.fxp": ["fxp", "fxpl"], "application/vnd.adobe.xdp+xml": ["xdp"], "application/vnd.adobe.xfdf": ["*xfdf"], "application/vnd.age": ["age"], "application/vnd.ahead.space": ["ahead"], "application/vnd.airzip.filesecure.azf": ["azf"], "application/vnd.airzip.filesecure.azs": ["azs"], "application/vnd.amazon.ebook": ["azw"], "application/vnd.americandynamics.acc": ["acc"], "application/vnd.amiga.ami": ["ami"], "application/vnd.android.package-archive": ["apk"], "application/vnd.anser-web-certificate-issue-initiation": ["cii"], "application/vnd.anser-web-funds-transfer-initiation": ["fti"], "application/vnd.antix.game-component": ["atx"], "application/vnd.apple.installer+xml": ["mpkg"], "application/vnd.apple.keynote": ["key"], "application/vnd.apple.mpegurl": ["m3u8"], "application/vnd.apple.numbers": ["numbers"], "application/vnd.apple.pages": ["pages"], "application/vnd.apple.pkpass": ["pkpass"], "application/vnd.aristanetworks.swi": ["swi"], "application/vnd.astraea-software.iota": ["iota"], "application/vnd.audiograph": ["aep"], "application/vnd.balsamiq.bmml+xml": ["bmml"], "application/vnd.blueice.multipass": ["mpm"], "application/vnd.bmi": ["bmi"], "application/vnd.businessobjects": ["rep"], "application/vnd.chemdraw+xml": ["cdxml"], "application/vnd.chipnuts.karaoke-mmd": ["mmd"], "application/vnd.cinderella": ["cdy"], "application/vnd.citationstyles.style+xml": ["csl"], "application/vnd.claymore": ["cla"], "application/vnd.cloanto.rp9": ["rp9"], "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"], "application/vnd.cluetrust.cartomobile-config": ["c11amc"], "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"], "application/vnd.commonspace": ["csp"], "application/vnd.contact.cmsg": ["cdbcmsg"], "application/vnd.cosmocaller": ["cmc"], "application/vnd.crick.clicker": ["clkx"], "application/vnd.crick.clicker.keyboard": ["clkk"], "application/vnd.crick.clicker.palette": ["clkp"], "application/vnd.crick.clicker.template": ["clkt"], "application/vnd.crick.clicker.wordbank": ["clkw"], "application/vnd.criticaltools.wbs+xml": ["wbs"], "application/vnd.ctc-posml": ["pml"], "application/vnd.cups-ppd": ["ppd"], "application/vnd.curl.car": ["car"], "application/vnd.curl.pcurl": ["pcurl"], "application/vnd.dart": ["dart"], "application/vnd.data-vision.rdz": ["rdz"], "application/vnd.dbf": ["dbf"], "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"], "application/vnd.dece.ttml+xml": ["uvt", "uvvt"], "application/vnd.dece.unspecified": ["uvx", "uvvx"], "application/vnd.dece.zip": ["uvz", "uvvz"], "application/vnd.denovo.fcselayout-link": ["fe_launch"], "application/vnd.dna": ["dna"], "application/vnd.dolby.mlp": ["mlp"], "application/vnd.dpgraph": ["dpg"], "application/vnd.dreamfactory": ["dfac"], "application/vnd.ds-keypoint": ["kpxx"], "application/vnd.dvb.ait": ["ait"], "application/vnd.dvb.service": ["svc"], "application/vnd.dynageo": ["geo"], "application/vnd.ecowin.chart": ["mag"], "application/vnd.enliven": ["nml"], "application/vnd.epson.esf": ["esf"], "application/vnd.epson.msf": ["msf"], "application/vnd.epson.quickanime": ["qam"], "application/vnd.epson.salt": ["slt"], "application/vnd.epson.ssf": ["ssf"], "application/vnd.eszigno3+xml": ["es3", "et3"], "application/vnd.ezpix-album": ["ez2"], "application/vnd.ezpix-package": ["ez3"], "application/vnd.fdf": ["*fdf"], "application/vnd.fdsn.mseed": ["mseed"], "application/vnd.fdsn.seed": ["seed", "dataless"], "application/vnd.flographit": ["gph"], "application/vnd.fluxtime.clip": ["ftc"], "application/vnd.framemaker": ["fm", "frame", "maker", "book"], "application/vnd.frogans.fnc": ["fnc"], "application/vnd.frogans.ltf": ["ltf"], "application/vnd.fsc.weblaunch": ["fsc"], "application/vnd.fujitsu.oasys": ["oas"], "application/vnd.fujitsu.oasys2": ["oa2"], "application/vnd.fujitsu.oasys3": ["oa3"], "application/vnd.fujitsu.oasysgp": ["fg5"], "application/vnd.fujitsu.oasysprs": ["bh2"], "application/vnd.fujixerox.ddd": ["ddd"], "application/vnd.fujixerox.docuworks": ["xdw"], "application/vnd.fujixerox.docuworks.binder": ["xbd"], "application/vnd.fuzzysheet": ["fzs"], "application/vnd.genomatix.tuxedo": ["txd"], "application/vnd.geogebra.file": ["ggb"], "application/vnd.geogebra.tool": ["ggt"], "application/vnd.geometry-explorer": ["gex", "gre"], "application/vnd.geonext": ["gxt"], "application/vnd.geoplan": ["g2w"], "application/vnd.geospace": ["g3w"], "application/vnd.gmx": ["gmx"], "application/vnd.google-apps.document": ["gdoc"], "application/vnd.google-apps.presentation": ["gslides"], "application/vnd.google-apps.spreadsheet": ["gsheet"], "application/vnd.google-earth.kml+xml": ["kml"], "application/vnd.google-earth.kmz": ["kmz"], "application/vnd.grafeq": ["gqf", "gqs"], "application/vnd.groove-account": ["gac"], "application/vnd.groove-help": ["ghf"], "application/vnd.groove-identity-message": ["gim"], "application/vnd.groove-injector": ["grv"], "application/vnd.groove-tool-message": ["gtm"], "application/vnd.groove-tool-template": ["tpl"], "application/vnd.groove-vcard": ["vcg"], "application/vnd.hal+xml": ["hal"], "application/vnd.handheld-entertainment+xml": ["zmm"], "application/vnd.hbci": ["hbci"], "application/vnd.hhe.lesson-player": ["les"], "application/vnd.hp-hpgl": ["hpgl"], "application/vnd.hp-hpid": ["hpid"], "application/vnd.hp-hps": ["hps"], "application/vnd.hp-jlyt": ["jlt"], "application/vnd.hp-pcl": ["pcl"], "application/vnd.hp-pclxl": ["pclxl"], "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"], "application/vnd.ibm.minipay": ["mpy"], "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"], "application/vnd.ibm.rights-management": ["irm"], "application/vnd.ibm.secure-container": ["sc"], "application/vnd.iccprofile": ["icc", "icm"], "application/vnd.igloader": ["igl"], "application/vnd.immervision-ivp": ["ivp"], "application/vnd.immervision-ivu": ["ivu"], "application/vnd.insors.igm": ["igm"], "application/vnd.intercon.formnet": ["xpw", "xpx"], "application/vnd.intergeo": ["i2g"], "application/vnd.intu.qbo": ["qbo"], "application/vnd.intu.qfx": ["qfx"], "application/vnd.ipunplugged.rcprofile": ["rcprofile"], "application/vnd.irepository.package+xml": ["irp"], "application/vnd.is-xpr": ["xpr"], "application/vnd.isac.fcs": ["fcs"], "application/vnd.jam": ["jam"], "application/vnd.jcp.javame.midlet-rms": ["rms"], "application/vnd.jisp": ["jisp"], "application/vnd.joost.joda-archive": ["joda"], "application/vnd.kahootz": ["ktz", "ktr"], "application/vnd.kde.karbon": ["karbon"], "application/vnd.kde.kchart": ["chrt"], "application/vnd.kde.kformula": ["kfo"], "application/vnd.kde.kivio": ["flw"], "application/vnd.kde.kontour": ["kon"], "application/vnd.kde.kpresenter": ["kpr", "kpt"], "application/vnd.kde.kspread": ["ksp"], "application/vnd.kde.kword": ["kwd", "kwt"], "application/vnd.kenameaapp": ["htke"], "application/vnd.kidspiration": ["kia"], "application/vnd.kinar": ["kne", "knp"], "application/vnd.koan": ["skp", "skd", "skt", "skm"], "application/vnd.kodak-descriptor": ["sse"], "application/vnd.las.las+xml": ["lasxml"], "application/vnd.llamagraphics.life-balance.desktop": ["lbd"], "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"], "application/vnd.lotus-1-2-3": ["123"], "application/vnd.lotus-approach": ["apr"], "application/vnd.lotus-freelance": ["pre"], "application/vnd.lotus-notes": ["nsf"], "application/vnd.lotus-organizer": ["org"], "application/vnd.lotus-screencam": ["scm"], "application/vnd.lotus-wordpro": ["lwp"], "application/vnd.macports.portpkg": ["portpkg"], "application/vnd.mapbox-vector-tile": ["mvt"], "application/vnd.mcd": ["mcd"], "application/vnd.medcalcdata": ["mc1"], "application/vnd.mediastation.cdkey": ["cdkey"], "application/vnd.mfer": ["mwf"], "application/vnd.mfmp": ["mfm"], "application/vnd.micrografx.flo": ["flo"], "application/vnd.micrografx.igx": ["igx"], "application/vnd.mif": ["mif"], "application/vnd.mobius.daf": ["daf"], "application/vnd.mobius.dis": ["dis"], "application/vnd.mobius.mbk": ["mbk"], "application/vnd.mobius.mqy": ["mqy"], "application/vnd.mobius.msl": ["msl"], "application/vnd.mobius.plc": ["plc"], "application/vnd.mobius.txf": ["txf"], "application/vnd.mophun.application": ["mpn"], "application/vnd.mophun.certificate": ["mpc"], "application/vnd.mozilla.xul+xml": ["xul"], "application/vnd.ms-artgalry": ["cil"], "application/vnd.ms-cab-compressed": ["cab"], "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"], "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"], "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"], "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"], "application/vnd.ms-excel.template.macroenabled.12": ["xltm"], "application/vnd.ms-fontobject": ["eot"], "application/vnd.ms-htmlhelp": ["chm"], "application/vnd.ms-ims": ["ims"], "application/vnd.ms-lrm": ["lrm"], "application/vnd.ms-officetheme": ["thmx"], "application/vnd.ms-outlook": ["msg"], "application/vnd.ms-pki.seccat": ["cat"], "application/vnd.ms-pki.stl": ["*stl"], "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"], "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"], "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"], "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"], "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"], "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"], "application/vnd.ms-project": ["*mpp", "mpt"], "application/vnd.ms-word.document.macroenabled.12": ["docm"], "application/vnd.ms-word.template.macroenabled.12": ["dotm"], "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"], "application/vnd.ms-wpl": ["wpl"], "application/vnd.ms-xpsdocument": ["xps"], "application/vnd.mseq": ["mseq"], "application/vnd.musician": ["mus"], "application/vnd.muvee.style": ["msty"], "application/vnd.mynfc": ["taglet"], "application/vnd.neurolanguage.nlu": ["nlu"], "application/vnd.nitf": ["ntf", "nitf"], "application/vnd.noblenet-directory": ["nnd"], "application/vnd.noblenet-sealer": ["nns"], "application/vnd.noblenet-web": ["nnw"], "application/vnd.nokia.n-gage.ac+xml": ["*ac"], "application/vnd.nokia.n-gage.data": ["ngdat"], "application/vnd.nokia.n-gage.symbian.install": ["n-gage"], "application/vnd.nokia.radio-preset": ["rpst"], "application/vnd.nokia.radio-presets": ["rpss"], "application/vnd.novadigm.edm": ["edm"], "application/vnd.novadigm.edx": ["edx"], "application/vnd.novadigm.ext": ["ext"], "application/vnd.oasis.opendocument.chart": ["odc"], "application/vnd.oasis.opendocument.chart-template": ["otc"], "application/vnd.oasis.opendocument.database": ["odb"], "application/vnd.oasis.opendocument.formula": ["odf"], "application/vnd.oasis.opendocument.formula-template": ["odft"], "application/vnd.oasis.opendocument.graphics": ["odg"], "application/vnd.oasis.opendocument.graphics-template": ["otg"], "application/vnd.oasis.opendocument.image": ["odi"], "application/vnd.oasis.opendocument.image-template": ["oti"], "application/vnd.oasis.opendocument.presentation": ["odp"], "application/vnd.oasis.opendocument.presentation-template": ["otp"], "application/vnd.oasis.opendocument.spreadsheet": ["ods"], "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"], "application/vnd.oasis.opendocument.text": ["odt"], "application/vnd.oasis.opendocument.text-master": ["odm"], "application/vnd.oasis.opendocument.text-template": ["ott"], "application/vnd.oasis.opendocument.text-web": ["oth"], "application/vnd.olpc-sugar": ["xo"], "application/vnd.oma.dd2+xml": ["dd2"], "application/vnd.openblox.game+xml": ["obgx"], "application/vnd.openofficeorg.extension": ["oxt"], "application/vnd.openstreetmap.data+xml": ["osm"], "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"], "application/vnd.openxmlformats-officedocument.presentationml.slide": ["sldx"], "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ["ppsx"], "application/vnd.openxmlformats-officedocument.presentationml.template": ["potx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ["xltx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ["dotx"], "application/vnd.osgeo.mapguide.package": ["mgp"], "application/vnd.osgi.dp": ["dp"], "application/vnd.osgi.subsystem": ["esa"], "application/vnd.palm": ["pdb", "pqa", "oprc"], "application/vnd.pawaafile": ["paw"], "application/vnd.pg.format": ["str"], "application/vnd.pg.osasli": ["ei6"], "application/vnd.picsel": ["efif"], "application/vnd.pmi.widget": ["wg"], "application/vnd.pocketlearn": ["plf"], "application/vnd.powerbuilder6": ["pbd"], "application/vnd.previewsystems.box": ["box"], "application/vnd.proteus.magazine": ["mgz"], "application/vnd.publishare-delta-tree": ["qps"], "application/vnd.pvi.ptid1": ["ptid"], "application/vnd.pwg-xhtml-print+xml": ["xhtm"], "application/vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"], "application/vnd.rar": ["rar"], "application/vnd.realvnc.bed": ["bed"], "application/vnd.recordare.musicxml": ["mxl"], "application/vnd.recordare.musicxml+xml": ["musicxml"], "application/vnd.rig.cryptonote": ["cryptonote"], "application/vnd.rim.cod": ["cod"], "application/vnd.rn-realmedia": ["rm"], "application/vnd.rn-realmedia-vbr": ["rmvb"], "application/vnd.route66.link66+xml": ["link66"], "application/vnd.sailingtracker.track": ["st"], "application/vnd.seemail": ["see"], "application/vnd.sema": ["sema"], "application/vnd.semd": ["semd"], "application/vnd.semf": ["semf"], "application/vnd.shana.informed.formdata": ["ifm"], "application/vnd.shana.informed.formtemplate": ["itp"], "application/vnd.shana.informed.interchange": ["iif"], "application/vnd.shana.informed.package": ["ipk"], "application/vnd.simtech-mindmapper": ["twd", "twds"], "application/vnd.smaf": ["mmf"], "application/vnd.smart.teacher": ["teacher"], "application/vnd.software602.filler.form+xml": ["fo"], "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"], "application/vnd.spotfire.dxp": ["dxp"], "application/vnd.spotfire.sfs": ["sfs"], "application/vnd.stardivision.calc": ["sdc"], "application/vnd.stardivision.draw": ["sda"], "application/vnd.stardivision.impress": ["sdd"], "application/vnd.stardivision.math": ["smf"], "application/vnd.stardivision.writer": ["sdw", "vor"], "application/vnd.stardivision.writer-global": ["sgl"], "application/vnd.stepmania.package": ["smzip"], "application/vnd.stepmania.stepchart": ["sm"], "application/vnd.sun.wadl+xml": ["wadl"], "application/vnd.sun.xml.calc": ["sxc"], "application/vnd.sun.xml.calc.template": ["stc"], "application/vnd.sun.xml.draw": ["sxd"], "application/vnd.sun.xml.draw.template": ["std"], "application/vnd.sun.xml.impress": ["sxi"], "application/vnd.sun.xml.impress.template": ["sti"], "application/vnd.sun.xml.math": ["sxm"], "application/vnd.sun.xml.writer": ["sxw"], "application/vnd.sun.xml.writer.global": ["sxg"], "application/vnd.sun.xml.writer.template": ["stw"], "application/vnd.sus-calendar": ["sus", "susp"], "application/vnd.svd": ["svd"], "application/vnd.symbian.install": ["sis", "sisx"], "application/vnd.syncml+xml": ["xsm"], "application/vnd.syncml.dm+wbxml": ["bdm"], "application/vnd.syncml.dm+xml": ["xdm"], "application/vnd.syncml.dmddf+xml": ["ddf"], "application/vnd.tao.intent-module-archive": ["tao"], "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"], "application/vnd.tmobile-livetv": ["tmo"], "application/vnd.trid.tpt": ["tpt"], "application/vnd.triscape.mxs": ["mxs"], "application/vnd.trueapp": ["tra"], "application/vnd.ufdl": ["ufd", "ufdl"], "application/vnd.uiq.theme": ["utz"], "application/vnd.umajin": ["umj"], "application/vnd.unity": ["unityweb"], "application/vnd.uoml+xml": ["uoml", "uo"], "application/vnd.vcx": ["vcx"], "application/vnd.visio": ["vsd", "vst", "vss", "vsw"], "application/vnd.visionary": ["vis"], "application/vnd.vsf": ["vsf"], "application/vnd.wap.wbxml": ["wbxml"], "application/vnd.wap.wmlc": ["wmlc"], "application/vnd.wap.wmlscriptc": ["wmlsc"], "application/vnd.webturbo": ["wtb"], "application/vnd.wolfram.player": ["nbp"], "application/vnd.wordperfect": ["wpd"], "application/vnd.wqd": ["wqd"], "application/vnd.wt.stf": ["stf"], "application/vnd.xara": ["xar"], "application/vnd.xfdl": ["xfdl"], "application/vnd.yamaha.hv-dic": ["hvd"], "application/vnd.yamaha.hv-script": ["hvs"], "application/vnd.yamaha.hv-voice": ["hvp"], "application/vnd.yamaha.openscoreformat": ["osf"], "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"], "application/vnd.yamaha.smaf-audio": ["saf"], "application/vnd.yamaha.smaf-phrase": ["spf"], "application/vnd.yellowriver-custom-menu": ["cmp"], "application/vnd.zul": ["zir", "zirz"], "application/vnd.zzazz.deck+xml": ["zaz"], "application/x-7z-compressed": ["7z"], "application/x-abiword": ["abw"], "application/x-ace-compressed": ["ace"], "application/x-apple-diskimage": ["*dmg"], "application/x-arj": ["arj"], "application/x-authorware-bin": ["aab", "x32", "u32", "vox"], "application/x-authorware-map": ["aam"], "application/x-authorware-seg": ["aas"], "application/x-bcpio": ["bcpio"], "application/x-bdoc": ["*bdoc"], "application/x-bittorrent": ["torrent"], "application/x-blorb": ["blb", "blorb"], "application/x-bzip": ["bz"], "application/x-bzip2": ["bz2", "boz"], "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"], "application/x-cdlink": ["vcd"], "application/x-cfs-compressed": ["cfs"], "application/x-chat": ["chat"], "application/x-chess-pgn": ["pgn"], "application/x-chrome-extension": ["crx"], "application/x-cocoa": ["cco"], "application/x-conference": ["nsc"], "application/x-cpio": ["cpio"], "application/x-csh": ["csh"], "application/x-debian-package": ["*deb", "udeb"], "application/x-dgc-compressed": ["dgc"], "application/x-director": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"], "application/x-doom": ["wad"], "application/x-dtbncx+xml": ["ncx"], "application/x-dtbook+xml": ["dtb"], "application/x-dtbresource+xml": ["res"], "application/x-dvi": ["dvi"], "application/x-envoy": ["evy"], "application/x-eva": ["eva"], "application/x-font-bdf": ["bdf"], "application/x-font-ghostscript": ["gsf"], "application/x-font-linux-psf": ["psf"], "application/x-font-pcf": ["pcf"], "application/x-font-snf": ["snf"], "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"], "application/x-freearc": ["arc"], "application/x-futuresplash": ["spl"], "application/x-gca-compressed": ["gca"], "application/x-glulx": ["ulx"], "application/x-gnumeric": ["gnumeric"], "application/x-gramps-xml": ["gramps"], "application/x-gtar": ["gtar"], "application/x-hdf": ["hdf"], "application/x-httpd-php": ["php"], "application/x-install-instructions": ["install"], "application/x-iso9660-image": ["*iso"], "application/x-iwork-keynote-sffkey": ["*key"], "application/x-iwork-numbers-sffnumbers": ["*numbers"], "application/x-iwork-pages-sffpages": ["*pages"], "application/x-java-archive-diff": ["jardiff"], "application/x-java-jnlp-file": ["jnlp"], "application/x-keepass2": ["kdbx"], "application/x-latex": ["latex"], "application/x-lua-bytecode": ["luac"], "application/x-lzh-compressed": ["lzh", "lha"], "application/x-makeself": ["run"], "application/x-mie": ["mie"], "application/x-mobipocket-ebook": ["*prc", "mobi"], "application/x-ms-application": ["application"], "application/x-ms-shortcut": ["lnk"], "application/x-ms-wmd": ["wmd"], "application/x-ms-wmz": ["wmz"], "application/x-ms-xbap": ["xbap"], "application/x-msaccess": ["mdb"], "application/x-msbinder": ["obd"], "application/x-mscardfile": ["crd"], "application/x-msclip": ["clp"], "application/x-msdos-program": ["*exe"], "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"], "application/x-msmediaview": ["mvb", "m13", "m14"], "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"], "application/x-msmoney": ["mny"], "application/x-mspublisher": ["pub"], "application/x-msschedule": ["scd"], "application/x-msterminal": ["trm"], "application/x-mswrite": ["wri"], "application/x-netcdf": ["nc", "cdf"], "application/x-ns-proxy-autoconfig": ["pac"], "application/x-nzb": ["nzb"], "application/x-perl": ["pl", "pm"], "application/x-pilot": ["*prc", "*pdb"], "application/x-pkcs12": ["p12", "pfx"], "application/x-pkcs7-certificates": ["p7b", "spc"], "application/x-pkcs7-certreqresp": ["p7r"], "application/x-rar-compressed": ["*rar"], "application/x-redhat-package-manager": ["rpm"], "application/x-research-info-systems": ["ris"], "application/x-sea": ["sea"], "application/x-sh": ["sh"], "application/x-shar": ["shar"], "application/x-shockwave-flash": ["swf"], "application/x-silverlight-app": ["xap"], "application/x-sql": ["*sql"], "application/x-stuffit": ["sit"], "application/x-stuffitx": ["sitx"], "application/x-subrip": ["srt"], "application/x-sv4cpio": ["sv4cpio"], "application/x-sv4crc": ["sv4crc"], "application/x-t3vm-image": ["t3"], "application/x-tads": ["gam"], "application/x-tar": ["tar"], "application/x-tcl": ["tcl", "tk"], "application/x-tex": ["tex"], "application/x-tex-tfm": ["tfm"], "application/x-texinfo": ["texinfo", "texi"], "application/x-tgif": ["*obj"], "application/x-ustar": ["ustar"], "application/x-virtualbox-hdd": ["hdd"], "application/x-virtualbox-ova": ["ova"], "application/x-virtualbox-ovf": ["ovf"], "application/x-virtualbox-vbox": ["vbox"], "application/x-virtualbox-vbox-extpack": ["vbox-extpack"], "application/x-virtualbox-vdi": ["vdi"], "application/x-virtualbox-vhd": ["vhd"], "application/x-virtualbox-vmdk": ["vmdk"], "application/x-wais-source": ["src"], "application/x-web-app-manifest+json": ["webapp"], "application/x-x509-ca-cert": ["der", "crt", "pem"], "application/x-xfig": ["fig"], "application/x-xliff+xml": ["*xlf"], "application/x-xpinstall": ["xpi"], "application/x-xz": ["xz"], "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"], "audio/vnd.dece.audio": ["uva", "uvva"], "audio/vnd.digital-winds": ["eol"], "audio/vnd.dra": ["dra"], "audio/vnd.dts": ["dts"], "audio/vnd.dts.hd": ["dtshd"], "audio/vnd.lucent.voice": ["lvp"], "audio/vnd.ms-playready.media.pya": ["pya"], "audio/vnd.nuera.ecelp4800": ["ecelp4800"], "audio/vnd.nuera.ecelp7470": ["ecelp7470"], "audio/vnd.nuera.ecelp9600": ["ecelp9600"], "audio/vnd.rip": ["rip"], "audio/x-aac": ["*aac"], "audio/x-aiff": ["aif", "aiff", "aifc"], "audio/x-caf": ["caf"], "audio/x-flac": ["flac"], "audio/x-m4a": ["*m4a"], "audio/x-matroska": ["mka"], "audio/x-mpegurl": ["m3u"], "audio/x-ms-wax": ["wax"], "audio/x-ms-wma": ["wma"], "audio/x-pn-realaudio": ["ram", "ra"], "audio/x-pn-realaudio-plugin": ["rmp"], "audio/x-realaudio": ["*ra"], "audio/x-wav": ["*wav"], "chemical/x-cdx": ["cdx"], "chemical/x-cif": ["cif"], "chemical/x-cmdf": ["cmdf"], "chemical/x-cml": ["cml"], "chemical/x-csml": ["csml"], "chemical/x-xyz": ["xyz"], "image/prs.btif": ["btif", "btf"], "image/prs.pti": ["pti"], "image/vnd.adobe.photoshop": ["psd"], "image/vnd.airzip.accelerator.azv": ["azv"], "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"], "image/vnd.djvu": ["djvu", "djv"], "image/vnd.dvb.subtitle": ["*sub"], "image/vnd.dwg": ["dwg"], "image/vnd.dxf": ["dxf"], "image/vnd.fastbidsheet": ["fbs"], "image/vnd.fpx": ["fpx"], "image/vnd.fst": ["fst"], "image/vnd.fujixerox.edmics-mmr": ["mmr"], "image/vnd.fujixerox.edmics-rlc": ["rlc"], "image/vnd.microsoft.icon": ["ico"], "image/vnd.ms-dds": ["dds"], "image/vnd.ms-modi": ["mdi"], "image/vnd.ms-photo": ["wdp"], "image/vnd.net-fpx": ["npx"], "image/vnd.pco.b16": ["b16"], "image/vnd.tencent.tap": ["tap"], "image/vnd.valve.source.texture": ["vtf"], "image/vnd.wap.wbmp": ["wbmp"], "image/vnd.xiff": ["xif"], "image/vnd.zbrush.pcx": ["pcx"], "image/x-3ds": ["3ds"], "image/x-cmu-raster": ["ras"], "image/x-cmx": ["cmx"], "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"], "image/x-icon": ["*ico"], "image/x-jng": ["jng"], "image/x-mrsid-image": ["sid"], "image/x-ms-bmp": ["*bmp"], "image/x-pcx": ["*pcx"], "image/x-pict": ["pic", "pct"], "image/x-portable-anymap": ["pnm"], "image/x-portable-bitmap": ["pbm"], "image/x-portable-graymap": ["pgm"], "image/x-portable-pixmap": ["ppm"], "image/x-rgb": ["rgb"], "image/x-tga": ["tga"], "image/x-xbitmap": ["xbm"], "image/x-xpixmap": ["xpm"], "image/x-xwindowdump": ["xwd"], "message/vnd.wfa.wsc": ["wsc"], "model/vnd.cld": ["cld"], "model/vnd.collada+xml": ["dae"], "model/vnd.dwf": ["dwf"], "model/vnd.gdl": ["gdl"], "model/vnd.gtw": ["gtw"], "model/vnd.mts": ["mts"], "model/vnd.opengex": ["ogex"], "model/vnd.parasolid.transmit.binary": ["x_b"], "model/vnd.parasolid.transmit.text": ["x_t"], "model/vnd.pytha.pyox": ["pyo", "pyox"], "model/vnd.sap.vds": ["vds"], "model/vnd.usda": ["usda"], "model/vnd.usdz+zip": ["usdz"], "model/vnd.valve.source.compiled-map": ["bsp"], "model/vnd.vtu": ["vtu"], "text/prs.lines.tag": ["dsc"], "text/vnd.curl": ["curl"], "text/vnd.curl.dcurl": ["dcurl"], "text/vnd.curl.mcurl": ["mcurl"], "text/vnd.curl.scurl": ["scurl"], "text/vnd.dvb.subtitle": ["sub"], "text/vnd.familysearch.gedcom": ["ged"], "text/vnd.fly": ["fly"], "text/vnd.fmi.flexstor": ["flx"], "text/vnd.graphviz": ["gv"], "text/vnd.in3d.3dml": ["3dml"], "text/vnd.in3d.spot": ["spot"], "text/vnd.sun.j2me.app-descriptor": ["jad"], "text/vnd.wap.wml": ["wml"], "text/vnd.wap.wmlscript": ["wmls"], "text/x-asm": ["s", "asm"], "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"], "text/x-component": ["htc"], "text/x-fortran": ["f", "for", "f77", "f90"], "text/x-handlebars-template": ["hbs"], "text/x-java-source": ["java"], "text/x-lua": ["lua"], "text/x-markdown": ["mkd"], "text/x-nfo": ["nfo"], "text/x-opml": ["opml"], "text/x-org": ["*org"], "text/x-pascal": ["p", "pas"], "text/x-processing": ["pde"], "text/x-sass": ["sass"], "text/x-scss": ["scss"], "text/x-setext": ["etx"], "text/x-sfv": ["sfv"], "text/x-suse-ymp": ["ymp"], "text/x-uuencode": ["uu"], "text/x-vcalendar": ["vcs"], "text/x-vcard": ["vcf"], "video/vnd.dece.hd": ["uvh", "uvvh"], "video/vnd.dece.mobile": ["uvm", "uvvm"], "video/vnd.dece.pd": ["uvp", "uvvp"], "video/vnd.dece.sd": ["uvs", "uvvs"], "video/vnd.dece.video": ["uvv", "uvvv"], "video/vnd.dvb.file": ["dvb"], "video/vnd.fvt": ["fvt"], "video/vnd.mpegurl": ["mxu", "m4u"], "video/vnd.ms-playready.media.pyv": ["pyv"], "video/vnd.uvvu.mp4": ["uvu", "uvvu"], "video/vnd.vivo": ["viv"], "video/x-f4v": ["f4v"], "video/x-fli": ["fli"], "video/x-flv": ["flv"], "video/x-m4v": ["m4v"], "video/x-matroska": ["mkv", "mk3d", "mks"], "video/x-mng": ["mng"], "video/x-ms-asf": ["asf", "asx"], "video/x-ms-vob": ["vob"], "video/x-ms-wm": ["wm"], "video/x-ms-wmv": ["wmv"], "video/x-ms-wmx": ["wmx"], "video/x-ms-wvx": ["wvx"], "video/x-msvideo": ["avi"], "video/x-sgi-movie": ["movie"], "video/x-smv": ["smv"], "x-conference/x-cooltalk": ["ice"] };
Object.freeze(Ac);
const Lc = { "application/andrew-inset": ["ez"], "application/appinstaller": ["appinstaller"], "application/applixware": ["aw"], "application/appx": ["appx"], "application/appxbundle": ["appxbundle"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/automationml-aml+xml": ["aml"], "application/automationml-amlx+zip": ["amlx"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cpl+xml": ["cpl"], "application/cu-seeme": ["cu"], "application/cwl": ["cwl"], "application/dash+xml": ["mpd"], "application/dash-patch+xml": ["mpp"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdf": ["fdf"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["*js"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/media-policy-dataset+xml": ["mpf"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["*mp4", "*mpg4", "mp4s", "m4p"], "application/msix": ["msix"], "application/msixbundle": ["msixbundle"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-keys": ["asc"], "application/pgp-signature": ["sig", "*asc"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/sql": ["sql"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/watcherinfo+xml": ["wif"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xfdf": ["xfdf"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/aac": ["adts", "aac"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avci": ["avci"], "image/avcs": ["avcs"], "image/avif": ["avif"], "image/bmp": ["bmp", "dib"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/dpx": ["dpx"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm", "jpgm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/jt": ["jt"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/prc": ["prc"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/u3d": ["u3d"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/javascript": ["js", "mjs"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["md", "markdown"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/wgsl": ["wgsl"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "*jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] };
Object.freeze(Lc);
var Ln = globalThis && globalThis.__classPrivateFieldGet || function(e, i, n, a) {
  if (n === "a" && !a)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof i == "function" ? e !== i || !a : !i.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? a : n === "a" ? a.call(e) : a ? a.value : i.get(e);
}, Jt, O2, kt;
class Jq {
  constructor(...i) {
    Jt.set(this, /* @__PURE__ */ new Map()), O2.set(this, /* @__PURE__ */ new Map()), kt.set(this, /* @__PURE__ */ new Map());
    for (const n of i)
      this.define(n);
  }
  define(i, n = !1) {
    for (let [a, r] of Object.entries(i)) {
      a = a.toLowerCase(), r = r.map((c) => c.toLowerCase()), Ln(this, kt, "f").has(a) || Ln(this, kt, "f").set(a, /* @__PURE__ */ new Set());
      const o = Ln(this, kt, "f").get(a);
      let l = !0;
      for (let c of r) {
        const h = c.startsWith("*");
        if (c = h ? c.slice(1) : c, o == null || o.add(c), l && Ln(this, O2, "f").set(a, c), l = !1, h)
          continue;
        const y = Ln(this, Jt, "f").get(c);
        if (y && y != a && !n)
          throw new Error(`"${a} -> ${c}" conflicts with "${y} -> ${c}". Pass \`force=true\` to override this definition.`);
        Ln(this, Jt, "f").set(c, a);
      }
    }
    return this;
  }
  getType(i) {
    if (typeof i != "string")
      return null;
    const n = i.replace(/^.*[/\\]/, "").toLowerCase(), a = n.replace(/^.*\./, "").toLowerCase(), r = n.length < i.length;
    return !(a.length < n.length - 1) && r ? null : Ln(this, Jt, "f").get(a) ?? null;
  }
  getExtension(i) {
    var n;
    return typeof i != "string" ? null : (i = (n = i == null ? void 0 : i.split) == null ? void 0 : n.call(i, ";")[0], (i && Ln(this, O2, "f").get(i.trim().toLowerCase())) ?? null);
  }
  getAllExtensions(i) {
    return typeof i != "string" ? null : Ln(this, kt, "f").get(i.toLowerCase()) ?? null;
  }
  _freeze() {
    this.define = () => {
      throw new Error("define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances");
    }, Object.freeze(this);
    for (const i of Ln(this, kt, "f").values())
      Object.freeze(i);
    return this;
  }
  _getTestState() {
    return {
      types: Ln(this, Jt, "f"),
      extensions: Ln(this, O2, "f")
    };
  }
}
Jt = /* @__PURE__ */ new WeakMap(), O2 = /* @__PURE__ */ new WeakMap(), kt = /* @__PURE__ */ new WeakMap();
const Kq = new Jq(Lc, Ac)._freeze();
const $q = { class: "unnnic-upload-area__dropzone__content" }, eG = { class: "unnnic-upload-area__dropzone__content__title" }, nG = ["title"], iG = ["accept", "multiple"], tG = {
  __name: "DropArea",
  props: {
    acceptMultiple: {
      type: Boolean,
      default: !0
    },
    supportedFormats: {
      type: String,
      default: "*"
    },
    maxFileSize: {
      type: Number,
      default: void 0
    },
    shouldReplace: {
      type: Boolean,
      default: !1
    },
    currentFiles: {
      type: Array,
      default() {
        return [];
      }
    },
    maximumUploads: {
      type: Number,
      default: 1
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:currentFiles",
    "fileChange",
    "unsupportedFormat",
    "exceededTheMaximumFileSizeLimit"
  ],
  setup(e, { emit: i }) {
    const n = L1(!1), a = L1(!1), r = L1(0), o = L1(), l = e, c = i, h = a2();
    function y(H) {
      var Y, ae;
      return !!((ae = (Y = h == null ? void 0 : h.vnode) == null ? void 0 : Y.props) != null && ae[H]);
    }
    const v = T1(() => l.supportedFormats.split(",").map((Y) => Y.toUpperCase()).join(", "));
    function x() {
      r.value += 1, n.value = !0;
    }
    function C() {
      n.value = !0;
    }
    function M() {
      r.value -= 1, r.value === 0 && (n.value = !1);
    }
    function z() {
      n.value = !1;
    }
    function R(H) {
      n.value = !1;
      const { files: Y } = H.dataTransfer;
      re(Y) && K(Y);
    }
    function U(H) {
      const { files: Y } = H.target;
      re(Y) && K(Y), o.value.value = "";
    }
    function G() {
      a.value = !0, setTimeout(() => {
        a.value = !1;
      }, 5e3);
    }
    function re(H) {
      return !l.acceptMultiple && H.length > 1 ? (G(), !1) : I(H) ? V(H) ? !0 : (y("onExceededTheMaximumFileSizeLimit") ? c("exceededTheMaximumFileSizeLimit") : G(), !1) : (y("onUnsupportedFormat") ? c("unsupportedFormat") : G(), !1);
    }
    function I(H) {
      if (l.supportedFormats === "*")
        return !0;
      const Y = l.supportedFormats.split(",").map((ee) => ee.trim());
      return Array.from(H).find((ee) => {
        const Pe = ee.name.toLowerCase(), N1 = ee.type.toLowerCase(), ze = `.${Pe.split(".").pop()}`, _1 = Y.includes(ze), Qn = N1 === Kq.getType(Pe);
        return _1 && Qn;
      });
    }
    function V(H) {
      return l.maxFileSize ? Array.from(H).find((ae) => (ae.size / 1048576).toFixed(2) <= l.maxFileSize) : !0;
    }
    function K(H) {
      let Y = H.length;
      if (l.shouldReplace || (Y += l.currentFiles.length), Y > l.maximumUploads) {
        G();
        return;
      }
      const ae = Array.from(H).filter((Pe) => !!(I([Pe]) && V([Pe])));
      let ee;
      l.shouldReplace ? ee = ae : ee = l.currentFiles.concat(ae), c("update:currentFiles", ee), c("fileChange", ee);
    }
    return (H, Y) => (f(), p("section", {
      ref: "dropzone",
      class: B({
        "unnnic-upload-area__dropzone": !0,
        "unnnic-upload-area__dropzone__is-dragover": n.value,
        "unnnic-upload-area__dropzone__has-error": a.value
      }),
      onDragenter: Qe(x, ["stop", "prevent"]),
      onDragover: Qe(C, ["stop", "prevent"]),
      onDragleave: Qe(M, ["stop", "prevent"]),
      onDragend: Qe(z, ["stop", "prevent"]),
      onDrop: Qe(R, ["stop", "prevent"]),
      onClick: Y[0] || (Y[0] = () => H.$refs.file.click())
    }, [
      Z(ce, {
        class: "unnnic-upload-area__dropzone__icon",
        icon: "upload",
        scheme: a.value ? "feedback-red" : "weni-500",
        size: "lg"
      }, null, 8, ["scheme"]),
      u("div", $q, [
        u("span", eG, [
          pe(H.$slots, "title", {}, () => [
            p1(T(H.$t("upload_area.title.text")) + " ", 1),
            u("span", {
              class: B(`unnnic-upload-area__dropzone__content__title__${a.value ? "error" : "search"}`)
            }, T(H.$t("upload_area.title.highlight")), 3)
          ], !0)
        ]),
        u("span", {
          class: B([
            "unnnic-upload-area__dropzone__content__subtitle",
            {
              "unnnic-upload-area__dropzone__content__subtitle__error": a.value
            }
          ]),
          title: v.value
        }, [
          pe(H.$slots, "subtitle", {}, () => [
            p1(T(e.subtitle || `${H.$t(
              `upload_area${a.value ? ".invalid" : ""}.subtitle`
            )} ${v.value}`), 1)
          ], !0)
        ], 10, nG)
      ]),
      S1(u("input", {
        ref_key: "file",
        ref: o,
        type: "file",
        accept: e.supportedFormats,
        multiple: e.acceptMultiple,
        onInput: U
      }, null, 40, iG), [
        [ri, !1]
      ])
    ], 34));
  }
}, Tc = /* @__PURE__ */ k(tG, [["__scopeId", "data-v-09e769d3"]]);
const aG = {
  name: "ImportCard",
  components: {
    UnnnicButton: Wn,
    UnnnicIcon: ce
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    importProgress: {
      type: Number,
      default: 0
    },
    isImporting: {
      type: Boolean,
      default: !1
    },
    canImport: {
      type: Boolean,
      default: !0
    },
    canDelete: {
      type: Boolean,
      default: !0
    },
    acceptedFormats: {
      type: String,
      default: "*"
    },
    uploadIcon: {
      type: String,
      default: "upload-bottom-1"
    }
  },
  computed: {
    fileIcon() {
      const e = this.title.slice(this.title.lastIndexOf(".") + 1);
      return {
        pdf: "picture_as_pdf",
        txt: "text_snippet",
        xls: "table",
        xlsx: "table",
        doc: "draft",
        docx: "draft"
      }[e] || "draft";
    }
  },
  methods: {
    importFile() {
      this.$refs.file.click();
    },
    handleFileChange(e) {
      const { files: i } = e.target;
      let n;
      i.length > 0 && ([n] = e.target.files), n && this.$emit("modifiedFile", n);
    },
    emitDeletion() {
      this.$emit("delete");
    }
  }
}, sG = { class: "unnnic-import-card" }, oG = { class: "unnnic-import-card__data" }, rG = {
  key: 0,
  class: "unnnic-import-card__data__title"
}, lG = {
  key: 1,
  class: "unnnic-import-card__data__title"
}, dG = {
  key: 2,
  class: "unnnic-import-card__data__subtitle"
}, cG = {
  key: 0,
  class: "unnnic-import-card__data__subtitle__text"
}, fG = {
  key: 1,
  class: "unnnic-import-card__data__subtitle__progress"
}, uG = { class: "unnnic-import-card__buttons" }, hG = ["accept"];
function mG(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicButton");
  return f(), p("div", sG, [
    Z(l, {
      class: "unnnic-import-card__file-icon",
      size: "md",
      scheme: "weni-600",
      icon: o.fileIcon
    }, null, 8, ["icon"]),
    u("div", oG, [
      n.isImporting ? (f(), p("div", rG, T(e.$t("import_card.importing")) + "... ", 1)) : (f(), p("div", lG, T(n.title), 1)),
      n.subtitle && n.isImporting ? (f(), p("div", dG, [
        n.subtitle && n.isImporting ? (f(), p("div", cG, T(n.subtitle), 1)) : N("", !0),
        n.subtitle && n.isImporting ? (f(), p("div", fG, "  - " + T(n.importProgress) + "% ", 1)) : N("", !0)
      ])) : N("", !0)
    ]),
    u("div", uG, [
      n.canImport ? (f(), $(c, {
        key: 0,
        class: "unnnic-import-card__buttons__import",
        size: "small",
        iconCenter: n.uploadIcon,
        type: "primary",
        onClick: o.importFile
      }, {
        default: Ee(() => [
          u("input", {
            ref: "file",
            type: "file",
            accept: n.acceptedFormats,
            style: { display: "none" },
            onChange: i[0] || (i[0] = (...h) => o.handleFileChange && o.handleFileChange(...h))
          }, null, 40, hG)
        ]),
        _: 1
      }, 8, ["iconCenter", "onClick"])) : N("", !0),
      n.canDelete ? (f(), $(l, {
        key: 1,
        class: "unnnic-import-card__buttons__delete",
        size: "sm",
        scheme: "neutral-cloudy",
        icon: "delete",
        clickable: "",
        onClick: o.emitDeletion
      }, null, 8, ["onClick"])) : N("", !0)
    ])
  ]);
}
const Sc = /* @__PURE__ */ k(aG, [["render", mG], ["__scopeId", "data-v-0990f36a"]]);
const pG = {
  name: "UnnnicUploadArea",
  components: {
    UnnnicDropArea: Tc,
    UnnnicImportCard: Sc
  },
  model: {
    prop: "files",
    event: "fileChange"
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    acceptMultiple: {
      type: Boolean,
      default: !0
    },
    supportedFormats: {
      type: String,
      default: "*"
    },
    maximumUploads: {
      type: Number,
      default: 1
    },
    filesProgress: {
      type: Array,
      default: () => []
    },
    isUploading: {
      type: Boolean,
      default: !1
    },
    canImport: {
      type: Boolean,
      default: !1
    },
    canDelete: {
      type: Boolean,
      default: !0
    },
    maxFileSize: {
      type: Number,
      default: void 0
    },
    shouldReplace: {
      type: Boolean,
      default: !1
    },
    subtitle: {
      required: !1,
      type: String,
      default: ""
    }
  },
  emits: ["fileChange"],
  data() {
    return {
      currentFiles: this.files
    };
  },
  watch: {
    files(e) {
      this.currentFiles = e;
    }
  },
  methods: {
    emitFileChange() {
      this.$emit("fileChange", this.currentFiles);
    },
    modifyFile(e, i) {
      this.currentFiles.splice(e, 1, i), this.emitFileChange();
    },
    removeFile(e) {
      this.currentFiles.splice(e, 1), this.emitFileChange();
    }
  }
}, yG = {
  key: 0,
  class: "unnnic-upload-area__cards"
};
function vG(e, i, n, a, r, o) {
  const l = j("UnnnicDropArea"), c = j("UnnnicImportCard");
  return f(), p("div", null, [
    Z(l, {
      currentFiles: r.currentFiles,
      "onUpdate:currentFiles": i[0] || (i[0] = (h) => r.currentFiles = h),
      acceptMultiple: n.acceptMultiple,
      supportedFormats: n.supportedFormats,
      maxFileSize: n.maxFileSize,
      shouldReplace: n.shouldReplace,
      maximumUploads: n.maximumUploads,
      subtitle: n.subtitle,
      onFileChange: i[1] || (i[1] = (h) => e.$emit("fileChange", h))
    }, null, 8, ["currentFiles", "acceptMultiple", "supportedFormats", "maxFileSize", "shouldReplace", "maximumUploads", "subtitle"]),
    r.currentFiles.length > 0 ? (f(), p("div", yG, [
      (f(!0), p(se, null, me(r.currentFiles, (h, y) => (f(), $(c, {
        key: y,
        title: h.name,
        subtitle: h.name,
        isImporting: n.isUploading,
        importProgress: n.filesProgress[y] || 100,
        canImport: n.canImport,
        canDelete: n.canDelete,
        acceptedFormats: n.supportedFormats,
        uploadIcon: "button-refresh-arrows-1",
        onDelete: (v) => o.removeFile(y),
        onModifiedFile: (v) => o.modifyFile(y, v)
      }, null, 8, ["title", "subtitle", "isImporting", "importProgress", "canImport", "canDelete", "acceptedFormats", "onDelete", "onModifiedFile"]))), 128))
    ])) : N("", !0)
  ]);
}
const Nc = /* @__PURE__ */ k(pG, [["render", vG], ["__scopeId", "data-v-872a45ed"]]);
const gG = {
  components: {
    UnnnicUploadArea: Nc,
    UnnnicIcon: ce,
    UnnnicButton: Wn
  },
  model: {
    prop: "files",
    event: "file-change"
  },
  props: {
    textCancel: {
      type: String,
      default: "Cancelar"
    },
    textAction: {
      type: String,
      default: "Importar tudo"
    },
    textTitle: {
      type: String,
      default: "Importar sentenças"
    },
    acceptMultiple: {
      type: Boolean,
      default: !0
    },
    supportedFormats: {
      type: String,
      default: ".png"
    },
    maximumUploads: {
      type: Number,
      default: 1
    },
    filesProgress: {
      type: Array,
      default: () => []
    },
    isUploading: {
      type: Boolean,
      default: !1
    },
    canImport: {
      type: Boolean,
      default: !1
    },
    canDelete: {
      type: Boolean,
      default: !0
    },
    maxFileSize: {
      type: Number,
      default: void 0
    },
    files: {
      type: Array,
      default: () => []
    },
    subtitle: {
      required: !1,
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
}, _G = { class: "modal-upload" }, wG = { class: "close-button-container" }, CG = { class: "title" }, kG = { class: "footer" };
function xG(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicUploadArea"), h = j("UnnnicButton");
  return f(), p("div", _G, [
    u("div", wG, [
      Z(l, {
        class: "close-button",
        icon: "close-1",
        scheme: "neutral-dark",
        size: "sm",
        onClick: i[0] || (i[0] = (y) => e.$emit("close"))
      })
    ]),
    u("div", CG, T(n.textTitle), 1),
    Z(c, {
      acceptMultiple: n.acceptMultiple,
      supportedFormats: n.supportedFormats,
      maximumUploads: n.maximumUploads,
      filesProgress: n.filesProgress,
      isUploading: n.isUploading,
      canImport: n.canImport,
      canDelete: n.canDelete,
      maxFileSize: n.maxFileSize,
      files: n.files,
      subtitle: n.subtitle,
      onFileChange: i[1] || (i[1] = (y) => e.$emit("file-change", y))
    }, null, 8, ["acceptMultiple", "supportedFormats", "maximumUploads", "filesProgress", "isUploading", "canImport", "canDelete", "maxFileSize", "files", "subtitle"]),
    u("div", kG, [
      Z(h, {
        size: "large",
        type: "tertiary",
        text: n.textCancel,
        onClick: i[2] || (i[2] = (y) => e.$emit("cancel"))
      }, null, 8, ["text"]),
      Z(h, {
        size: "large",
        type: "primary",
        text: n.textAction,
        onClick: i[3] || (i[3] = (y) => e.$emit("action"))
      }, null, 8, ["text"])
    ])
  ]);
}
const bG = /* @__PURE__ */ k(gG, [["render", xG], ["__scopeId", "data-v-91328cf9"]]);
const MG = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    version: {
      type: String,
      default: "1.0"
    },
    text: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default: null
    },
    onClose: {
      type: Function,
      default: () => {
      }
    },
    linkHref: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: "_blank"
    },
    linkText: {
      type: String,
      default: "Learn more"
    },
    type: {
      type: String,
      default: "default"
    }
  },
  emits: ["close"],
  mounted() {
    this.$refs.progress.addEventListener("animationend", () => {
      this.$refs.alertContainer.classList.add("slide-down");
    }), this.$refs.alertContainer.addEventListener("animationend", (e) => {
      var i;
      (i = e.animationName) != null && i.startsWith("slideDown") && this.emitClose();
    });
  },
  methods: {
    emitClose() {
      this.onClose(), this.$emit("close");
    }
  }
}, DG = {
  ref: "alertContainer",
  class: "alert-container"
}, AG = {
  ref: "progress",
  class: "alert__progress"
}, LG = ["href", "target"];
function TG(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", DG, [
    u("div", {
      class: B([
        "alert",
        {
          "alert--scheme-aux-green": n.scheme === "feedback-green" || n.type === "success",
          "alert--scheme-aux-red": n.scheme === "feedback-red" || n.type === "error"
        }
      ])
    }, [
      u("div", AG, null, 512),
      S1(u("div", { class: "alert__text" }, T(n.text), 513), [
        [ri, n.text]
      ]),
      n.linkHref ? (f(), p("a", {
        key: 0,
        class: "alert__link",
        href: n.linkHref,
        target: n.linkTarget
      }, T(n.linkText), 9, LG)) : N("", !0),
      u("div", {
        class: "alert__close",
        onClick: i[0] || (i[0] = (...c) => o.emitClose && o.emitClose(...c))
      }, [
        Z(l, {
          icon: "close-1",
          size: "sm",
          scheme: "neutral-white"
        })
      ])
    ], 2)
  ], 512);
}
const SG = /* @__PURE__ */ k(MG, [["render", TG], ["__scopeId", "data-v-c2ade830"]]);
const NG = {
  name: "UnnnicAlert",
  components: {
    UnnnicIcon: ce,
    Version1dot1: SG
  },
  props: {
    version: {
      type: String,
      default: "1.1"
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    onClose: {
      type: Function,
      default: () => {
      }
    },
    closeText: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top-right"
    },
    linkHref: {
      type: String,
      default: ""
    },
    linkTarget: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  }
}, EG = { class: "unnnic-alert__content" }, zG = { class: "unnnic-alert__title" }, IG = { class: "unnnic-alert__text" };
function BG(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return n.version === "1.0" ? (f(), p("div", {
    key: 0,
    class: B(["unnnic-alert", `unnnic-alert-position--${n.position}`])
  }, [
    Z(l, {
      icon: n.icon,
      scheme: n.scheme,
      size: "sm",
      "data-test": "unnnic-icon"
    }, null, 8, ["icon", "scheme"]),
    u("div", EG, [
      u("div", zG, T(n.title.toUpperCase()), 1),
      u("div", IG, T(n.text), 1)
    ]),
    n.closeText ? (f(), p("div", {
      key: 0,
      class: "unnnic-alert__close-text unnnic--clickable",
      onClick: i[0] || (i[0] = (c) => n.onClose())
    }, T(n.closeText.toUpperCase()), 1)) : (f(), $(l, {
      key: 1,
      clickable: "",
      icon: "close-1",
      scheme: "brand-sec",
      size: "xs",
      "data-test": "unnnic-icon-close",
      onClick: n.onClose
    }, null, 8, ["onClick"]))
  ], 2)) : (f(), $(oi("version" + n.version.replace(/\./g, "dot")), ip(Q1({ key: 1 }, { ...e.$props })), null, 16));
}
const Ec = /* @__PURE__ */ k(NG, [["render", BG], ["__scopeId", "data-v-52bb2cbb"]]);
function OG(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(i, n) {
    var a = e.get(i);
    a ? a.push(n) : e.set(i, [n]);
  }, off: function(i, n) {
    var a = e.get(i);
    a && (n ? a.splice(a.indexOf(n) >>> 0, 1) : e.set(i, []));
  }, emit: function(i, n) {
    var a = e.get(i);
    a && a.slice().map(function(r) {
      r(n);
    }), (a = e.get("*")) && a.slice().map(function(r) {
      r(i, n);
    });
  } };
}
const zc = OG(), HG = ({ props: e, containerRef: i }) => {
  const n = Hl(Ec, {
    ...e,
    onClose: () => {
      r.$el.remove();
    },
    created() {
      zc.on(["close"], () => {
        r.$el.remove();
      });
    }
  }), a = document.createElement("div"), r = n.mount(a);
  i ? (r.$el.style.position = "absolute", i.appendChild(r.$el)) : document.body.appendChild(r.$el);
}, jG = ({ props: e }) => {
  const i = Hl(Dc, {
    ...e,
    onClose: () => {
      a.$el.remove();
    },
    created() {
      zc.on(["close"], () => {
        a.$el.remove();
      });
    }
  }), n = document.createElement("div"), a = i.mount(n);
  document.body.appendChild(n);
};
const VG = {
  name: "UnnnicSelectSmartOption",
  components: { UnnnicCheckbox: V0 },
  props: {
    label: {
      type: String,
      default: "Option",
      required: !0
    },
    description: {
      type: String,
      default: "",
      required: !1
    },
    size: {
      type: String,
      default: ""
    },
    selectable: {
      type: Boolean,
      default: !0
    },
    focused: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: null
    },
    allowCheckbox: {
      type: Boolean,
      default: !1
    },
    isMultiple: Boolean,
    activeColor: {
      type: String,
      default: "primary",
      validator(e) {
        return ["primary", "secondary"].indexOf(e) !== -1;
      }
    }
  },
  methods: {
    fullySanitize: Mt
  }
}, FG = ["title"];
function PG(e, i, n, a, r, o) {
  const l = j("UnnnicCheckbox");
  return f(), p("div", {
    class: B({
      "unnnic-select-smart-option": !0,
      "unnnic-select-smart-option--focused": n.focused,
      "unnnic-select-smart-option--active": n.active,
      "unnnic-select-smart-option--active-secondary": n.active && n.activeColor === "secondary",
      "unnnic--clickable": n.selectable,
      "unnnic-select-smart-option--selectable": n.selectable,
      "unnnic-select-smart-option--with-checkbox": n.allowCheckbox
    }),
    title: n.label,
    "data-testid": "select-smart-option"
  }, [
    n.allowCheckbox ? (f(), $(l, {
      key: 0,
      ref: "checkbox",
      "data-testid": "checkbox",
      modelValue: n.active,
      size: n.size
    }, null, 8, ["modelValue", "size"])) : N("", !0),
    u("div", null, [
      u("span", {
        class: B([
          "unnnic-select-smart-option__label",
          `unnnic-select-smart-option__label--${n.size}`
        ]),
        "data-testid": "label"
      }, T(o.fullySanitize(n.label)), 3),
      n.description ? (f(), p("p", {
        key: 0,
        "data-testid": "description",
        class: B([
          "unnnic-select-smart-option__description",
          `unnnic-select-smart-option__description--${n.size}`
        ])
      }, T(o.fullySanitize(n.description)), 3)) : N("", !0)
    ])
  ], 10, FG);
}
const UG = /* @__PURE__ */ k(VG, [["render", PG]]);
const RG = {
  name: "UnnnicSelectSmartMultipleHeader",
  components: {
    Tag: ea
  },
  mixins: [yn],
  props: {
    selectedOptions: {
      type: Array,
      required: !0
    },
    withoutSelectsMessage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      multipleSelectedsTags: 2,
      defaultTranslations: {
        without_multiple_selected: {
          "pt-br": "Nenhuma opção selecionada",
          en: "No option selected",
          es: "Ninguna opción seleccionada"
        }
      }
    };
  },
  computed: {
    firstMultipleSelecteds() {
      const { selectedOptions: e, multipleSelectedsTags: i } = this, n = [];
      for (let a = 0; a < i; a += 1)
        n.push(e == null ? void 0 : e[a]);
      return n.filter((a) => a !== void 0);
    }
  },
  methods: {
    unselectOption(e) {
      this.$emit("unselect-option", e);
    }
  }
}, YG = { class: "unnnic-select-smart__options__multiple" }, ZG = {
  key: 0,
  class: "unnnic-select-smart__options__multiple__selecteds__container"
}, WG = { class: "unnnic-select-smart__options__multiple__selecteds" }, QG = {
  key: 0,
  class: "unnnic-select-smart__options__multiple__selecteds__remaining",
  "data-testid": "remaining-count"
}, qG = {
  key: 1,
  class: "unnnic-select-smart__options__multiple--without-multiples",
  "data-testid": "without-selects-message"
};
function GG(e, i, n, a, r, o) {
  const l = j("Tag");
  return f(), p("div", YG, [
    n.selectedOptions[0] ? (f(), p("div", ZG, [
      u("div", WG, [
        (f(!0), p(se, null, me(o.firstMultipleSelecteds, (c) => (f(), $(l, {
          key: c.value,
          class: "unnnic-select-smart__options__multiple__selecteds__option",
          text: c.label,
          hasCloseIcon: "",
          onClose: (h) => o.unselectOption(c)
        }, null, 8, ["text", "onClose"]))), 128)),
        n.selectedOptions.length > r.multipleSelectedsTags ? (f(), p("p", QG, " +" + T(n.selectedOptions.length - r.multipleSelectedsTags), 1)) : N("", !0)
      ])
    ])) : N("", !0),
    n.selectedOptions[0] ? N("", !0) : (f(), p("p", qG, T(n.withoutSelectsMessage || e.i18n("without_multiple_selected")), 1))
  ]);
}
const XG = /* @__PURE__ */ k(RG, [["render", GG], ["__scopeId", "data-v-bcf6f5c9"]]);
const JG = {
  props: {
    type: {
      type: String,
      default: "automatic"
    },
    modelValue: Boolean,
    position: {
      type: String,
      default: "bottom-left"
    }
  },
  data() {
    return {
      clientHeight: 0,
      clientWidth: 0,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      data: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    active() {
      return this.type === "manual" ? this.modelValue : !1;
    },
    positions() {
      let e, i;
      return this.position.startsWith("bottom") ? (e = this.y + this.height, e + this.data.height > this.clientHeight && (e = this.clientHeight - this.data.height, this.y >= this.data.height && (e = this.y - this.data.height))) : this.position.startsWith("top") && (e = this.y - this.data.height, e < 0 && (e = 0, this.y + this.height + this.data.height <= this.clientHeight && (e = this.y + this.height))), this.position.endsWith("right") ? (i = this.x + this.width, i + this.data.width > this.clientWidth && (i = this.clientWidth - this.data.width, this.x >= this.data.width && (i = this.x - this.data.width))) : this.position.endsWith("left") && (i = this.x - this.data.width, i < 0 && (i = 0, this.x + this.width + this.data.width <= this.clientWidth && (i = this.x + this.width))), {
        left: `${i}px`,
        top: `${e}px`
      };
    }
  },
  mounted() {
    this.calculatePosition(), window.addEventListener("scroll", this.calculatePosition), window.addEventListener("resize", this.calculatePosition);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.calculatePosition), window.removeEventListener("resize", this.calculatePosition);
  },
  methods: {
    calculatePosition() {
      const e = this.$refs.dropdown.getBoundingClientRect(), i = this.$refs["dropdown-data"].getBoundingClientRect();
      this.clientHeight = document.documentElement.clientHeight, this.clientWidth = document.documentElement.clientWidth, this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this.data.x = i.x, this.data.y = i.y, this.data.width = i.width, this.data.height = i.height;
    }
  }
};
function KG(e, i, n, a, r, o) {
  return f(), p("span", {
    ref: "dropdown",
    "data-testid": "dropdown-skeleton",
    class: B(["dropdown", { active: o.active }])
  }, [
    pe(e.$slots, "default", {}, void 0, !0),
    u("div", {
      ref: "dropdown-data",
      "data-testid": "dropdown-data",
      class: "dropdown-data",
      style: Ze({ position: "fixed", ...o.positions })
    }, [
      pe(e.$slots, "inside", {
        width: `${r.width}px`,
        height: `${r.height}px`
      }, void 0, !0)
    ], 4)
  ], 2);
}
const $G = /* @__PURE__ */ k(JG, [["render", KG], ["__scopeId", "data-v-003b0171"]]);
const eX = {
  name: "UnnnicSelectSmart",
  components: {
    TextInput: Yl,
    SelectSmartOption: UG,
    SelectSmartMultipleHeader: XG,
    DropdownSkeleton: $G,
    UnnnicIconLoading: j0
  },
  directives: {
    onClickOutside: H0
  },
  mixins: [yn],
  props: {
    options: {
      type: Array,
      required: !0,
      default: () => [
        {
          value: "",
          label: "Initial value"
        },
        {
          value: "option1",
          label: "Option1"
        }
      ]
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "md"
    },
    type: {
      type: String,
      default: "normal",
      validator(e) {
        return ["normal", "error", "secondary"].indexOf(e) !== -1;
      }
    },
    disabled: {
      type: Boolean,
      default: null
    },
    orderedByIndex: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    multipleWithoutSelectsMessage: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: Boolean,
      default: !1
    },
    autocompleteIconLeft: {
      type: Boolean,
      default: !1
    },
    autocompleteClearOnFocus: {
      type: Boolean,
      default: !1
    },
    selectFirst: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    enableSearchByValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:searchValue", "onChange", "update:modelValue"],
  data() {
    return {
      active: !1,
      status: "not-mounted",
      focusedOption: null,
      searchValue: "",
      isAutocompleteAllowed: !1,
      multipleSelectedsTags: 2,
      defaultTranslations: {
        without_results: {
          "pt-br": "Nenhum resultado encontrado",
          en: "No results found",
          es: "Ningún resultado encontrado"
        }
      }
    };
  },
  computed: {
    selectedLabel() {
      var n;
      if (this.status !== "mounted")
        return "";
      const e = this.options.find((a) => {
        const r = a.value === this.modelValue;
        return this.isAutocompleteAllowed ? r && a.value !== "" : a.value === "" && this.modelValue.length === 0 || r;
      });
      return e ? e.label : this.multiple ? this.modelValue.map((r) => r.label).join(", ") : ((n = this.modelValue.at(-1)) == null ? void 0 : n.label) || "";
    },
    hasDescriptionOptions() {
      return this.options.some(
        (e) => typeof e.description < "u"
      );
    },
    autocompletePlaceholder() {
      if (this.isAutocompleteAllowed) {
        const e = this.options.find((i) => i.value === "");
        if (e)
          return e.label;
      }
      return "";
    },
    inputValue() {
      const { isAutocompleteAllowed: e, searchValue: i, multiple: n, modelValue: a } = this;
      return e || n ? i : !n && a.length !== 0 ? a == null ? void 0 : a[0].label : "";
    }
  },
  watch: {
    active(e) {
      this.$refs["dropdown-skeleton"].calculatePosition(), this.$nextTick(() => {
        if (e && !this.multiple) {
          const i = this.getOptionIndex("active");
          i !== -1 && this.scrollToOption(i, "center");
        }
      });
    },
    searchValue(e, i) {
      this.focusedOption = null, !this.active && i && (this.active = !0), this.$emit("update:searchValue", e);
    },
    modelValue: {
      deep: !0,
      handler(e) {
        this.$emit("onChange", e), this.$emit("update:modelValue", e), this.onSelectOption(e.at(-1));
      }
    },
    autocomplete(e) {
      this.multiple || (this.isAutocompleteAllowed = e);
    }
  },
  mounted() {
    var e, i, n, a, r;
    this.status = "mounted", (this.multiple || this.autocomplete) && (this.isAutocompleteAllowed = !0), (e = this.modelValue) != null && e[0] && ((i = this.modelValue) != null && i[0].value) ? this.isAutocompleteAllowed && this.$nextTick(() => {
      this.searchValue = this.selectedLabel;
    }) : this.selectFirst && ((n = this.options) != null && n[0]) && ((a = this.options) != null && a[0].value) && this.selectOption((r = this.options) == null ? void 0 : r[0]);
  },
  methods: {
    optionIsSelected(e) {
      return this.modelValue.some(
        (i) => i.value === e.value
      );
    },
    handleSelect(e) {
      if (e) {
        if (this.multiple && this.optionIsSelected(e)) {
          this.unselectOption(e);
          return;
        }
        this.selectOption(e);
      }
    },
    handleClickInput() {
      if (this.isAutocompleteAllowed) {
        if (this.active)
          return;
        (this.autocompleteClearOnFocus || this.multiple) && (this.searchValue = "");
      }
      this.active = !this.active;
    },
    filterOptions(e) {
      const n = this.searchValue.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" "), a = (c) => c.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), r = (c) => {
        var h;
        return parseInt((h = c.match(/\d+/)) == null ? void 0 : h[0], 10) || 0;
      }, o = e.filter(
        ({ value: c, label: h }, y, v) => {
          const x = a(h), C = v.findIndex((z) => z.value === c) === y, M = n.every((z) => {
            const R = x.includes(z), U = c.includes(z);
            return this.enableSearchByValue ? R || U : R;
          });
          return C && M && c;
        }
      );
      return this.orderedByIndex ? o : o.sort((c, h) => {
        const y = a(c.label), v = a(h.label), x = r(y), C = r(v);
        return x - C || y.localeCompare(v);
      });
    },
    onClickOutside() {
      this.active && (this.isAutocompleteAllowed && (this.searchValue = this.selectedLabel), this.$nextTick(() => {
        this.active = !1;
      }));
    },
    getOptionIndex(e) {
      var a, r, o, l;
      const i = this.filterOptions(this.options);
      let n = "";
      return e === "active" && (n = (r = (a = this.modelValue) == null ? void 0 : a[0]) == null ? void 0 : r.value), e === "focused" && (n = ((o = this.focusedOption) == null ? void 0 : o.value) || ((l = this.modelValue.at(-1)) == null ? void 0 : l.value)), i.findIndex((c) => c.value === n);
    },
    scrollToOption(e, i = "nearest") {
      const n = this.$refs.selectSmartOptionsScrollArea;
      if (n && e >= 0 && e < n.childNodes.length) {
        const a = n.childNodes[e];
        a instanceof HTMLElement && (a == null || a.scrollIntoView({ block: i }));
      }
    },
    selectOption(e) {
      const i = e.value === null || e.value.length === 0 ? null : e;
      this.$emit(
        "update:modelValue",
        this.multiple ? [...this.modelValue, i] : [i]
      );
    },
    unselectOption(e) {
      const i = this.modelValue.findIndex(
        (n) => n.value === e.value
      );
      if (i !== -1) {
        const n = this.modelValue;
        n.splice(i, 1), this.$emit("update:modelValue", n);
      }
      this.multiple && (this.searchValue = "");
    },
    onSelectOption(e) {
      if (this.$nextTick(() => {
        this.multiple || (this.active = !1);
      }), this.isAutocompleteAllowed && !this.multiple && e && e.label) {
        this.searchValue = e.label;
        return;
      }
      this.multiple && (this.searchValue = "");
    },
    async onKeyDownSelect(e) {
      const { key: i } = e;
      if (["Escape", "Enter", "ArrowUp", "ArrowDown"].includes(i)) {
        e.preventDefault();
        const a = this.filterOptions(this.options), r = this.getOptionIndex("focused");
        let o;
        switch (i) {
          case "Escape":
            this.active = !1, this.searchValue = "";
            break;
          case "Enter":
            this.focusedOption && this.active && this.handleSelect(this.focusedOption), this.active || (this.active = !0);
            break;
          case "ArrowUp":
          case "ArrowDown":
            this.multiple && !this.active && (this.active = !0, await this.$nextTick()), o = i === "ArrowUp" ? Math.max(r - 1, 0) : Math.min(r + 1, a.length - 1), this.active || this.handleSelect(a[o]);
            break;
        }
        o !== void 0 && this.active && this.scrollToOption(o);
        const l = a[o === void 0 ? r : o];
        this.focusedOption = l;
      }
    }
  }
}, nX = { style: { overflow: "auto" } }, iX = {
  key: 2,
  class: "unnnic-select-smart__options--no-results"
};
function tX(e, i, n, a, r, o) {
  const l = j("TextInput"), c = j("SelectSmartMultipleHeader"), h = j("UnnnicIconLoading"), y = j("SelectSmartOption"), v = j("DropdownSkeleton"), x = G2("on-click-outside");
  return S1((f(), p("div", {
    class: B([
      "unnnic-select-smart",
      { "unnnic-select-smart--secondary": n.type === "secondary" }
    ]),
    "data-testid": "select-smart",
    onKeydown: i[1] || (i[1] = (...C) => o.onKeyDownSelect && o.onKeyDownSelect(...C))
  }, [
    Z(v, {
      ref: "dropdown-skeleton",
      type: "manual",
      modelValue: r.active || null,
      position: "bottom"
    }, {
      inside: Ee((C) => [
        r.active ? (f(), p("div", {
          key: 0,
          style: Ze({ width: C.width }),
          class: B({
            "unnnic-select-smart__options": !0,
            active: r.active,
            inactive: !r.active
          }),
          "data-testid": "options-container"
        }, [
          u("div", nX, [
            n.multiple ? (f(), $(c, {
              key: 0,
              selectedOptions: n.modelValue,
              withoutSelectsMessage: n.multipleWithoutSelectsMessage,
              locale: e.locale,
              translations: e.translations,
              onUnselectOption: o.unselectOption
            }, null, 8, ["selectedOptions", "withoutSelectsMessage", "locale", "translations", "onUnselectOption"])) : N("", !0),
            u("div", {
              ref: "selectSmartOptionsScrollArea",
              "data-testid": "options-scroll-area",
              class: B([
                "unnnic-select-smart__options__scroll-area",
                `size-${n.size}`,
                {
                  "with-descriptions": o.hasDescriptionOptions,
                  "with-checkboxes": !!n.multiple
                }
              ])
            }, [
              n.isLoading ? (f(), $(h, {
                key: 0,
                class: "unnnic-select-smart__options-loading",
                scheme: "neutral-dark",
                size: "sm"
              })) : (f(!0), p(se, { key: 1 }, me(o.filterOptions(n.options), (M, z) => (f(), $(y, {
                key: M.value,
                "data-testid": "option",
                label: M.label,
                description: M.description,
                tabindex: z,
                size: n.size,
                active: M.value === n.modelValue || o.optionIsSelected(M),
                focused: r.focusedOption && r.focusedOption.value === M.value,
                allowCheckbox: !!n.multiple,
                activeColor: n.type === "secondary" ? "secondary" : "primary",
                onClick: (R) => o.handleSelect(M)
              }, null, 8, ["label", "description", "tabindex", "size", "active", "focused", "allowCheckbox", "activeColor", "onClick"]))), 128)),
              o.filterOptions(n.options).length === 0 && !n.isLoading ? (f(), p("p", iX, T(e.i18n("without_results")), 1)) : N("", !0)
            ], 2)
          ])
        ], 6)) : N("", !0)
      ]),
      default: Ee(() => [
        Z(l, {
          ref: "selectSmartInput",
          class: B([
            "unnnic-select-smart__input",
            { "unnnic-select-smart__input--secondary": n.type === "secondary" }
          ]),
          "data-testid": "select-smart-input",
          modelValue: o.inputValue,
          placeholder: n.placeholder || o.autocompletePlaceholder || o.selectedLabel,
          type: n.type,
          size: n.size,
          disabled: n.disabled,
          readonly: !r.isAutocompleteAllowed,
          iconLeft: r.isAutocompleteAllowed && n.autocompleteIconLeft ? "search-1" : "",
          iconRight: r.active ? "keyboard_arrow_up" : "keyboard_arrow_down",
          iconRightSize: "ant",
          onClick: Qe(o.handleClickInput, ["stop"]),
          "onUpdate:modelValue": i[0] || (i[0] = (C) => r.searchValue = C)
        }, null, 8, ["class", "modelValue", "placeholder", "type", "size", "disabled", "readonly", "iconLeft", "iconRight", "onClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 34)), [
    [x, o.onClickOutside]
  ]);
}
const aX = /* @__PURE__ */ k(eX, [["render", tX]]);
const sX = {
  name: "UnnicSelectItem",
  props: {
    size: {
      type: String,
      default: ""
    },
    selectable: {
      type: Boolean,
      default: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    textFocused: {
      type: Boolean,
      default: !1
    }
  }
};
function oX(e, i, n, a, r, o) {
  return f(), p("div", {
    class: B({
      "unnnic-select-item": !0,
      "unnnic-select-item__active": n.active,
      "unnnic--clickable": n.selectable,
      "unnnic-select-item--selectable": n.selectable,
      "text-focused": n.textFocused
    }),
    onClick: i[0] || (i[0] = (l) => e.$emit("click"))
  }, [
    u("span", {
      class: B([
        "unnnic-select-item__label",
        `unnnic-select-item__label--${n.size}`
      ])
    }, [
      pe(e.$slots, "default")
    ], 2)
  ], 2);
}
const rX = /* @__PURE__ */ k(sX, [["render", oX]]);
const lX = {
  name: "UnnnicMultiSelect",
  components: {
    UnnnicIcon: ce,
    UnnnicRadio: Mc
  },
  directives: {
    onClickOutside: H0
  },
  props: {
    isOpen: {
      default: !1
    },
    expand: {
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    inputTitle: {
      type: String,
      default: "Teste"
    },
    hideRadio: {
      type: Boolean,
      default: !1
    },
    hideGroupTitle: {
      type: Boolean,
      default: !1
    },
    unselectable: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      active: !1
    };
  },
  watch: {
    isOpen() {
      this.active = this.open;
    }
  },
  methods: {
    handleIsOpenKeyboard(e) {
      document.querySelector(".select-permission:focus-visible") && e.keyCode === 32 && (this.active = !this.active);
    },
    onClickOutside() {
      this.active && (this.active = !1);
    },
    change(e, i) {
      this.$emit(
        "update:model-value",
        this.modelValue.map((n, a) => {
          if (a === e) {
            let r = i;
            return this.unselectable && n.selected === i && (r = -1), { ...n, selected: r };
          }
          return n;
        })
      );
    }
  }
}, dX = {
  key: 0,
  class: "select-permission-label"
}, cX = { class: "title noselect" }, fX = {
  key: 1,
  class: "select-content",
  tabindex: "0"
}, uX = ["onClick"];
function hX(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicRadio"), h = G2("on-click-outside");
  return f(), p("div", {
    class: B(n.expand ? "expand-multiselect" : "normal-multiselect"),
    tabindex: "-1"
  }, [
    n.label ? (f(), p("span", dX, T(n.label), 1)) : N("", !0),
    u("div", {
      class: "select-permission",
      tabindex: "0",
      onKeypress: i[0] || (i[0] = (...y) => o.handleIsOpenKeyboard && o.handleIsOpenKeyboard(...y)),
      onClick: i[1] || (i[1] = (y) => r.active = !r.active)
    }, [
      u("h6", cX, T(n.inputTitle), 1),
      Z(l, {
        icon: r.active ? "arrow-button-up-1" : "arrow-button-down-1",
        size: "sm",
        scheme: "neutral-dark"
      }, null, 8, ["icon"])
    ], 32),
    r.active ? S1((f(), p("div", fX, [
      u("div", null, [
        (f(!0), p(se, null, me(n.modelValue, (y, v) => (f(), p(se, {
          key: `group-${v}`
        }, [
          n.hideGroupTitle ? N("", !0) : (f(), p("h6", {
            key: `title-${v}`,
            class: "title"
          }, T(y.title), 1)),
          u("section", null, [
            (f(!0), p(se, null, me(y.items, (x, C) => (f(), p(se, {
              key: `item-${C}`
            }, [
              n.hideRadio ? (f(), p("div", {
                key: C + "input",
                class: "unnnic-radio-container unnnic-radio-container--sm",
                style: { cursor: "pointer" },
                onClick: (M) => o.change(v, C)
              }, [
                u("strong", null, T(x.title), 1),
                u("span", null, T(x.description), 1)
              ], 8, uX)) : (f(), $(c, {
                id: "",
                key: "else" + C + "input",
                name: "",
                modelValue: y.selected,
                value: C,
                size: "sm",
                class: "",
                "onUpdate:modelValue": (M) => o.change(v, M)
              }, {
                default: Ee(() => [
                  u("strong", null, T(x.title), 1),
                  u("span", null, T(x.description), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "value", "onUpdate:modelValue"]))
            ], 64))), 128))
          ])
        ], 64))), 128))
      ])
    ])), [
      [h, o.onClickOutside]
    ]) : N("", !0)
  ], 2);
}
const mX = /* @__PURE__ */ k(lX, [["render", hX], ["__scopeId", "data-v-313464ed"]]);
const pX = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      height: 0,
      setHeightToNull: null
    };
  },
  watch: {
    open(e) {
      clearTimeout(this.setHeightToNull), e ? (this.height = `${this.$refs.content.scrollHeight}px`, this.setHeightToNull = setTimeout(() => {
        this.height = null;
      }, 200)) : (this.height = `${this.$refs.content.scrollHeight}px`, setTimeout(() => {
        this.height = 0;
      }, 0));
    }
  },
  mounted() {
    this.open && (this.height = null);
  }
}, yX = { class: "header" }, vX = { class: "actions" };
function gX(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: "unnnic-accordion",
    onClick: i[0] || (i[0] = (c) => e.$emit("update:open", !n.open))
  }, [
    u("div", yX, [
      Z(l, {
        icon: n.open ? "subtract-circle-1" : "add-circle-1",
        scheme: "neutral-clean",
        size: "md"
      }, null, 8, ["icon"]),
      u("div", {
        class: B(["title", { open: n.open }])
      }, T(n.title), 3),
      S1(u("div", vX, [
        pe(e.$slots, "actions", {}, void 0, !0)
      ], 512), [
        [ri, n.open]
      ])
    ]),
    u("div", {
      ref: "content",
      class: B(["content", { open: n.open }]),
      style: Ze({ height: r.height })
    }, [
      pe(e.$slots, "default", {}, void 0, !0)
    ], 6)
  ]);
}
const _X = /* @__PURE__ */ k(pX, [["render", gX], ["__scopeId", "data-v-ae70d9af"]]);
const wX = {
  name: "UnnnicIndicator",
  props: {
    numberOfSteps: {
      type: Number,
      required: !0
    },
    titles: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 0
    }
  },
  methods: {
    titleForStep(e) {
      try {
        return this.titles[e - 1];
      } catch {
        return null;
      }
    }
  }
}, CX = { class: "weni-step-indicator" }, kX = { class: "weni-step-indicator__label" };
function xX(e, i, n, a, r, o) {
  return f(), p("div", CX, [
    (f(!0), p(se, null, me(n.numberOfSteps, (l) => (f(), p("div", {
      key: l,
      class: B({
        "weni-step-indicator__step__wrapper": !0,
        "weni-step-indicator--has-separator": l > 1
      })
    }, [
      l !== 1 ? (f(), p("div", {
        key: 0,
        class: B({
          "weni-step-indicator__step__separator": !0,
          "weni-step-indicator__step__separator--active": l <= n.currentStep
        })
      }, null, 2)) : N("", !0),
      u("div", {
        class: B({
          "weni-step-indicator__step": !0,
          "weni-step-indicator__step--active": l <= n.currentStep
        })
      }, [
        u("span", kX, T(o.titleForStep(l)), 1)
      ], 2)
    ], 2))), 128))
  ]);
}
const bX = /* @__PURE__ */ k(wX, [["render", xX], ["__scopeId", "data-v-2caaee7c"]]), MX = `:export{unnnicColorBackgroundSolo:#E8F4F4}.color-background-solo{color:#e8f4f4}.bg-background-solo{background-color:#e8f4f4}.color-background-sky{color:#f4f6f8}.bg-background-sky{background-color:#f4f6f8}.color-background-grass{color:#f5f6f6}.bg-background-grass{background-color:#f5f6f6}.color-background-carpet{color:#f9f9f9}.bg-background-carpet{background-color:#f9f9f9}.color-background-snow{color:#fff}.bg-background-snow{background-color:#fff}.color-background-lightest{color:#f9f9f9}.bg-background-lightest{background-color:#f9f9f9}.color-background-white{color:#fff}.bg-background-white{background-color:#fff}.color-neutral-black{color:#272b33}.bg-neutral-black{background-color:#272b33}.color-neutral-darkest{color:#3b414d}.bg-neutral-darkest{background-color:#3b414d}.color-neutral-dark{color:#4e5666}.bg-neutral-dark{background-color:#4e5666}.color-neutral-cloudy{color:#67738b}.bg-neutral-cloudy{background-color:#67738b}.color-neutral-cleanest{color:#d0d3d9}.bg-neutral-cleanest{background-color:#d0d3d9}.color-neutral-clean{color:#9caccc}.bg-neutral-clean{background-color:#9caccc}.color-neutral-soft{color:#e2e6ed}.bg-neutral-soft{background-color:#e2e6ed}.color-neutral-lightest{color:#f9f9f9}.bg-neutral-lightest{background-color:#f9f9f9}.color-neutral-light{color:#f4f6f8}.bg-neutral-light{background-color:#f4f6f8}.color-neutral-white{color:#fff}.bg-neutral-white{background-color:#fff}.color-neutral-snow{color:#fff}.bg-neutral-snow{background-color:#fff}.color-feedback-red{color:#ff4545}.bg-feedback-red{background-color:#ff4545}.color-feedback-green{color:#47d66f}.bg-feedback-green{background-color:#47d66f}.color-feedback-yellow{color:#fdba38}.bg-feedback-yellow{background-color:#fdba38}.color-feedback-blue{color:#2856fc}.bg-feedback-blue{background-color:#2856fc}.color-feedback-grey{color:#ececec}.bg-feedback-grey{background-color:#ececec}.color-aux-blue{color:#00ded3}.bg-aux-blue{background-color:#00ded3}.color-aux-purple{color:#8416de}.bg-aux-purple{background-color:#8416de}.color-aux-orange{color:#f4691f}.bg-aux-orange{background-color:#f4691f}.color-aux-lemon{color:#ccde0b}.bg-aux-lemon{background-color:#ccde0b}.color-aux-pink{color:#de16ba}.bg-aux-pink{background-color:#de16ba}.color-aux-baby-blue{color:#8edef5}.bg-aux-baby-blue{background-color:#8edef5}.color-aux-baby-yellow{color:#fbf391}.bg-aux-baby-yellow{background-color:#fbf391}.color-aux-baby-red{color:#f48e8e}.bg-aux-baby-red{background-color:#f48e8e}.color-aux-baby-green{color:#b2fca6}.bg-aux-baby-green{background-color:#b2fca6}.color-aux-baby-pink{color:#ffcbf6}.bg-aux-baby-pink{background-color:#ffcbf6}.color-aux-green-100{color:#c6f6d5}.bg-aux-green-100{background-color:#c6f6d5}.color-aux-green-300{color:#68d391}.bg-aux-green-300{background-color:#68d391}.color-aux-green-500{color:#38a169}.bg-aux-green-500{background-color:#38a169}.color-aux-green-700{color:#276749}.bg-aux-green-700{background-color:#276749}.color-aux-green-900{color:#1c4532}.bg-aux-green-900{background-color:#1c4532}.color-aux-blue-100{color:#bee3f8}.bg-aux-blue-100{background-color:#bee3f8}.color-aux-blue-300{color:#63b3ed}.bg-aux-blue-300{background-color:#63b3ed}.color-aux-blue-500{color:#3182ce}.bg-aux-blue-500{background-color:#3182ce}.color-aux-blue-700{color:#2c5282}.bg-aux-blue-700{background-color:#2c5282}.color-aux-blue-900{color:#1a365d}.bg-aux-blue-900{background-color:#1a365d}.color-aux-purple-100{color:#e9d8fd}.bg-aux-purple-100{background-color:#e9d8fd}.color-aux-purple-300{color:#b794f4}.bg-aux-purple-300{background-color:#b794f4}.color-aux-purple-500{color:#805ad5}.bg-aux-purple-500{background-color:#805ad5}.color-aux-purple-700{color:#553c9a}.bg-aux-purple-700{background-color:#553c9a}.color-aux-purple-900{color:#322659}.bg-aux-purple-900{background-color:#322659}.color-aux-red-100{color:#fed7d7}.bg-aux-red-100{background-color:#fed7d7}.color-aux-red-300{color:#fc8181}.bg-aux-red-300{background-color:#fc8181}.color-aux-red-500{color:#e53e3e}.bg-aux-red-500{background-color:#e53e3e}.color-aux-red-700{color:#9b2c2c}.bg-aux-red-700{background-color:#9b2c2c}.color-aux-red-900{color:#63171b}.bg-aux-red-900{background-color:#63171b}.color-aux-orange-100{color:#feebc8}.bg-aux-orange-100{background-color:#feebc8}.color-aux-orange-300{color:#f6ad55}.bg-aux-orange-300{background-color:#f6ad55}.color-aux-orange-500{color:#dd6b20}.bg-aux-orange-500{background-color:#dd6b20}.color-aux-orange-700{color:#9c4221}.bg-aux-orange-700{background-color:#9c4221}.color-aux-orange-900{color:#652b19}.bg-aux-orange-900{background-color:#652b19}.color-aux-yellow-100{color:#fefcbf}.bg-aux-yellow-100{background-color:#fefcbf}.color-aux-yellow-300{color:#f6e05e}.bg-aux-yellow-300{background-color:#f6e05e}.color-aux-yellow-500{color:#d69e2e}.bg-aux-yellow-500{background-color:#d69e2e}.color-aux-yellow-700{color:#975a16}.bg-aux-yellow-700{background-color:#975a16}.color-aux-yellow-900{color:#5f370e}.bg-aux-yellow-900{background-color:#5f370e}.color-floweditor-blue{color:#0080a3}.bg-floweditor-blue{background-color:#0080a3}.color-floweditor-purple{color:#7a00a3}.bg-floweditor-purple{background-color:#7a00a3}.color-floweditor-wine{color:#a3006a}.bg-floweditor-wine{background-color:#a3006a}.color-floweditor-orange{color:#f99707}.bg-floweditor-orange{background-color:#f99707}.color-floweditor-pink{color:#de16ba}.bg-floweditor-pink{background-color:#de16ba}.color-floweditor-turquoise{color:#00ded2}.bg-floweditor-turquoise{background-color:#00ded2}.color-floweditor-green{color:#00a339}.bg-floweditor-green{background-color:#00a339}.color-weni-50{color:#eefffc}.bg-weni-50{background-color:#eefffc}.color-weni-100{color:#c6fff7}.bg-weni-100{background-color:#c6fff7}.color-weni-200{color:#8efff1}.bg-weni-200{background-color:#8efff1}.color-weni-300{color:#4dfbea}.bg-weni-300{background-color:#4dfbea}.color-weni-400{color:#19e8da}.bg-weni-400{background-color:#19e8da}.color-weni-500{color:#00ded2}.bg-weni-500{background-color:#00ded2}.color-weni-600{color:#00a49f}.bg-weni-600{background-color:#00a49f}.color-weni-700{color:#028380}.bg-weni-700{background-color:#028380}.color-weni-800{color:#086766}.bg-weni-800{background-color:#086766}.color-weni-900{color:#0c5554}.bg-weni-900{background-color:#0c5554}.color-weni-950{color:#003234}.bg-weni-950{background-color:#003234}.color-brand-weni{color:#00a49f}.bg-brand-weni{background-color:#00a49f}.color-brand-weni-dark{color:#086766}.bg-brand-weni-dark{background-color:#086766}.color-brand-weni-soft{color:#00a49f}.bg-brand-weni-soft{background-color:#00a49f}.color-brand-sec-dark{color:#272b33}.bg-brand-sec-dark{background-color:#272b33}.color-brand-sec-soft{color:#4e5666}.bg-brand-sec-soft{background-color:#4e5666}.color-brand-sec{color:#d0d3d9}.bg-brand-sec{background-color:#d0d3d9}.u.color-background-solo{color:#e8f4f4}.u.bg-background-solo{background-color:#e8f4f4}.u.color-background-sky{color:#f4f6f8}.u.bg-background-sky{background-color:#f4f6f8}.u.color-background-grass{color:#f5f6f6}.u.bg-background-grass{background-color:#f5f6f6}.u.color-background-carpet{color:#f9f9f9}.u.bg-background-carpet{background-color:#f9f9f9}.u.color-background-snow{color:#fff}.u.bg-background-snow{background-color:#fff}.u.color-background-lightest{color:#f9f9f9}.u.bg-background-lightest{background-color:#f9f9f9}.u.color-background-white{color:#fff}.u.bg-background-white{background-color:#fff}.u.color-neutral-black{color:#272b33}.u.bg-neutral-black{background-color:#272b33}.u.color-neutral-darkest{color:#3b414d}.u.bg-neutral-darkest{background-color:#3b414d}.u.color-neutral-dark{color:#4e5666}.u.bg-neutral-dark{background-color:#4e5666}.u.color-neutral-cloudy{color:#67738b}.u.bg-neutral-cloudy{background-color:#67738b}.u.color-neutral-cleanest{color:#d0d3d9}.u.bg-neutral-cleanest{background-color:#d0d3d9}.u.color-neutral-clean{color:#9caccc}.u.bg-neutral-clean{background-color:#9caccc}.u.color-neutral-soft{color:#e2e6ed}.u.bg-neutral-soft{background-color:#e2e6ed}.u.color-neutral-lightest{color:#f9f9f9}.u.bg-neutral-lightest{background-color:#f9f9f9}.u.color-neutral-light{color:#f4f6f8}.u.bg-neutral-light{background-color:#f4f6f8}.u.color-neutral-white{color:#fff}.u.bg-neutral-white{background-color:#fff}.u.color-neutral-snow{color:#fff}.u.bg-neutral-snow{background-color:#fff}.u.color-feedback-red{color:#ff4545}.u.bg-feedback-red{background-color:#ff4545}.u.color-feedback-green{color:#47d66f}.u.bg-feedback-green{background-color:#47d66f}.u.color-feedback-yellow{color:#fdba38}.u.bg-feedback-yellow{background-color:#fdba38}.u.color-feedback-blue{color:#2856fc}.u.bg-feedback-blue{background-color:#2856fc}.u.color-feedback-grey{color:#ececec}.u.bg-feedback-grey{background-color:#ececec}.u.color-aux-blue{color:#00ded3}.u.bg-aux-blue{background-color:#00ded3}.u.color-aux-purple{color:#8416de}.u.bg-aux-purple{background-color:#8416de}.u.color-aux-orange{color:#f4691f}.u.bg-aux-orange{background-color:#f4691f}.u.color-aux-lemon{color:#ccde0b}.u.bg-aux-lemon{background-color:#ccde0b}.u.color-aux-pink{color:#de16ba}.u.bg-aux-pink{background-color:#de16ba}.u.color-aux-baby-blue{color:#8edef5}.u.bg-aux-baby-blue{background-color:#8edef5}.u.color-aux-baby-yellow{color:#fbf391}.u.bg-aux-baby-yellow{background-color:#fbf391}.u.color-aux-baby-red{color:#f48e8e}.u.bg-aux-baby-red{background-color:#f48e8e}.u.color-aux-baby-green{color:#b2fca6}.u.bg-aux-baby-green{background-color:#b2fca6}.u.color-aux-baby-pink{color:#ffcbf6}.u.bg-aux-baby-pink{background-color:#ffcbf6}.u.color-aux-green-100{color:#c6f6d5}.u.bg-aux-green-100{background-color:#c6f6d5}.u.color-aux-green-300{color:#68d391}.u.bg-aux-green-300{background-color:#68d391}.u.color-aux-green-500{color:#38a169}.u.bg-aux-green-500{background-color:#38a169}.u.color-aux-green-700{color:#276749}.u.bg-aux-green-700{background-color:#276749}.u.color-aux-green-900{color:#1c4532}.u.bg-aux-green-900{background-color:#1c4532}.u.color-aux-blue-100{color:#bee3f8}.u.bg-aux-blue-100{background-color:#bee3f8}.u.color-aux-blue-300{color:#63b3ed}.u.bg-aux-blue-300{background-color:#63b3ed}.u.color-aux-blue-500{color:#3182ce}.u.bg-aux-blue-500{background-color:#3182ce}.u.color-aux-blue-700{color:#2c5282}.u.bg-aux-blue-700{background-color:#2c5282}.u.color-aux-blue-900{color:#1a365d}.u.bg-aux-blue-900{background-color:#1a365d}.u.color-aux-purple-100{color:#e9d8fd}.u.bg-aux-purple-100{background-color:#e9d8fd}.u.color-aux-purple-300{color:#b794f4}.u.bg-aux-purple-300{background-color:#b794f4}.u.color-aux-purple-500{color:#805ad5}.u.bg-aux-purple-500{background-color:#805ad5}.u.color-aux-purple-700{color:#553c9a}.u.bg-aux-purple-700{background-color:#553c9a}.u.color-aux-purple-900{color:#322659}.u.bg-aux-purple-900{background-color:#322659}.u.color-aux-red-100{color:#fed7d7}.u.bg-aux-red-100{background-color:#fed7d7}.u.color-aux-red-300{color:#fc8181}.u.bg-aux-red-300{background-color:#fc8181}.u.color-aux-red-500{color:#e53e3e}.u.bg-aux-red-500{background-color:#e53e3e}.u.color-aux-red-700{color:#9b2c2c}.u.bg-aux-red-700{background-color:#9b2c2c}.u.color-aux-red-900{color:#63171b}.u.bg-aux-red-900{background-color:#63171b}.u.color-aux-orange-100{color:#feebc8}.u.bg-aux-orange-100{background-color:#feebc8}.u.color-aux-orange-300{color:#f6ad55}.u.bg-aux-orange-300{background-color:#f6ad55}.u.color-aux-orange-500{color:#dd6b20}.u.bg-aux-orange-500{background-color:#dd6b20}.u.color-aux-orange-700{color:#9c4221}.u.bg-aux-orange-700{background-color:#9c4221}.u.color-aux-orange-900{color:#652b19}.u.bg-aux-orange-900{background-color:#652b19}.u.color-aux-yellow-100{color:#fefcbf}.u.bg-aux-yellow-100{background-color:#fefcbf}.u.color-aux-yellow-300{color:#f6e05e}.u.bg-aux-yellow-300{background-color:#f6e05e}.u.color-aux-yellow-500{color:#d69e2e}.u.bg-aux-yellow-500{background-color:#d69e2e}.u.color-aux-yellow-700{color:#975a16}.u.bg-aux-yellow-700{background-color:#975a16}.u.color-aux-yellow-900{color:#5f370e}.u.bg-aux-yellow-900{background-color:#5f370e}.u.color-floweditor-blue{color:#0080a3}.u.bg-floweditor-blue{background-color:#0080a3}.u.color-floweditor-purple{color:#7a00a3}.u.bg-floweditor-purple{background-color:#7a00a3}.u.color-floweditor-wine{color:#a3006a}.u.bg-floweditor-wine{background-color:#a3006a}.u.color-floweditor-orange{color:#f99707}.u.bg-floweditor-orange{background-color:#f99707}.u.color-floweditor-pink{color:#de16ba}.u.bg-floweditor-pink{background-color:#de16ba}.u.color-floweditor-turquoise{color:#00ded2}.u.bg-floweditor-turquoise{background-color:#00ded2}.u.color-floweditor-green{color:#00a339}.u.bg-floweditor-green{background-color:#00a339}.u.color-weni-50{color:#eefffc}.u.bg-weni-50{background-color:#eefffc}.u.color-weni-100{color:#c6fff7}.u.bg-weni-100{background-color:#c6fff7}.u.color-weni-200{color:#8efff1}.u.bg-weni-200{background-color:#8efff1}.u.color-weni-300{color:#4dfbea}.u.bg-weni-300{background-color:#4dfbea}.u.color-weni-400{color:#19e8da}.u.bg-weni-400{background-color:#19e8da}.u.color-weni-500{color:#00ded2}.u.bg-weni-500{background-color:#00ded2}.u.color-weni-600{color:#00a49f}.u.bg-weni-600{background-color:#00a49f}.u.color-weni-700{color:#028380}.u.bg-weni-700{background-color:#028380}.u.color-weni-800{color:#086766}.u.bg-weni-800{background-color:#086766}.u.color-weni-900{color:#0c5554}.u.bg-weni-900{background-color:#0c5554}.u.color-weni-950{color:#003234}.u.bg-weni-950{background-color:#003234}.u.color-brand-weni{color:#00a49f}.u.bg-brand-weni{background-color:#00a49f}.u.color-brand-weni-dark{color:#086766}.u.bg-brand-weni-dark{background-color:#086766}.u.color-brand-weni-soft{color:#00a49f}.u.bg-brand-weni-soft{background-color:#00a49f}.u.color-brand-sec-dark{color:#272b33}.u.bg-brand-sec-dark{background-color:#272b33}.u.color-brand-sec-soft{color:#4e5666}.u.bg-brand-sec-soft{background-color:#4e5666}.u.color-brand-sec{color:#d0d3d9}.u.bg-brand-sec{background-color:#d0d3d9}
`, DX = /unnnicColorBackgroundSolo:\s*(.*)\;/, rl = DX.exec(MX), f3 = rl ? rl[1] : "#E8F4F4", AX = "rgba(255,255,255,0.375)", LX = {
  backgroundColor: f3,
  backgroundImage: `linear-gradient(
    90deg,
    ${f3},
    ${AX},
    ${f3}
  )`
};
const TX = {
  name: "UnnnicSkeletonLoading",
  props: {
    prefix: {
      type: String,
      default: "unnnic"
    },
    count: {
      type: Number,
      default: 1
    },
    duration: {
      type: Number,
      default: 1.5
    },
    tag: {
      type: String,
      default: "span"
    },
    width: [String, Number],
    height: [String, Number],
    circle: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    direct: {
      type: Boolean
    }
  },
  setup() {
    const e = v3("_themeStyle", L1(LX)), i = v3("_skeletonTheme", L1({}));
    return {
      themeStyle: e,
      theme: i
    };
  },
  computed: {
    classes() {
      return [`${this.prefix}-skeleton`];
    },
    styles() {
      const e = { ...this.themeStyle };
      return this.duration ? e.animation = `SkeletonLoading ${this.duration}s ease-in-out infinite` : e.backgroundImage = "", this.width && (e.width = this.width), this.height && (e.height = this.height), this.circle && (e.borderRadius = "50%"), e;
    },
    elements() {
      const e = [];
      for (let i = 0; i < this.count; i += 1)
        e.push({});
      return e;
    },
    showLoading() {
      return typeof this.loading < "u" ? this.loading : this.isEmptyVNode(this.$slots.default);
    }
  },
  methods: {
    isEmptyVNode(e) {
      if (!e)
        return !0;
      const [i] = e();
      let n = i.children;
      return n && (n = n.replace(/(\n|\r\n|\s)/g, "")), !n;
    }
  }
};
function SX(e, i, n, a, r, o) {
  return n.direct ? (f(), $(oi(n.tag), {
    key: 0,
    class: B(o.classes),
    style: Ze(o.styles)
  }, null, 8, ["class", "style"])) : o.showLoading ? (f(), $(oi(n.tag), { key: 1 }, {
    default: Ee(() => [
      (f(!0), p(se, null, me(o.elements, (l, c) => (f(), p("span", {
        key: c,
        class: B(o.classes),
        style: Ze(o.styles)
      }, " ‌ ", 6))), 128))
    ]),
    _: 1
  })) : N("", !0);
}
const NX = /* @__PURE__ */ k(TX, [["render", SX]]);
const EX = {
  name: "UnnnicTagCarousel",
  components: {
    UnnnicTag: ea,
    UnnnicIcon: ce
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    tagItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hasNext: !0,
      hasPrev: !1,
      slides: []
    };
  },
  mounted() {
    this.slides = this.tagItems;
  },
  methods: {
    save(e) {
      let i = this.modelValue;
      this.checkIsInclude(e) ? i = i.filter((n) => n !== e.id) : i = [...i, e.id], this.$emit("selected", i);
    },
    checkIsInclude(e) {
      return this.modelValue.some((i) => i === e.id);
    },
    next() {
      const e = document.querySelector("#scroll"), i = e.scrollWidth - e.clientWidth;
      e.scrollLeft += 200, i !== e.scrollLeft ? (this.hasNext || (this.hasNext = !0), this.hasPrev = !0) : this.hasNext = !1;
    },
    previous() {
      const e = document.querySelector("#scroll");
      e.scrollLeft -= 200, e.scrollLeft !== 0 ? (this.hasPrev || (this.hasPrev = !0), this.hasNext = !0) : this.hasPrev = !1;
    }
  }
}, zX = { class: "unnnic-card-tag-carousel" }, IX = { class: "unnnic-card-tag-carousel__button unnnic-card-tag-carousel__button--left" }, BX = { class: "unnnic-card-tag-carousel__button__icon" }, OX = { class: "unnnic-card-tag-carousel__button__blur unnnic-card-tag-carousel__button__blur--left" }, HX = {
  id: "scroll",
  class: "unnnic-card-tag-carousel__container"
}, jX = { class: "unnnic-card-tag-carousel__button unnnic-card-tag-carousel__button--right" }, VX = { class: "unnnic-card-tag-carousel__button__blur unnnic-card-tag-carousel__button__blur--right" }, FX = { class: "unnnic-card-tag-carousel__button__icon" };
function PX(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicTag");
  return f(), p("div", zX, [
    u("div", IX, [
      u("div", BX, [
        Z(l, {
          icon: "arrow-left-1-1",
          size: "sm",
          scheme: r.hasPrev ? "neutral-black" : "neutral-cleanest",
          clickable: "",
          onClick: i[0] || (i[0] = (h) => o.previous())
        }, null, 8, ["scheme"])
      ]),
      S1(u("span", OX, null, 512), [
        [ri, r.hasPrev]
      ])
    ]),
    u("div", HX, [
      (f(!0), p(se, null, me(r.slides, (h) => (f(), p("div", {
        key: h.id,
        class: "unnnic-card-tag-carousel__container__slide"
      }, [
        Z(c, {
          text: h.name,
          clickable: "",
          type: "brand",
          disabled: o.checkIsInclude(h),
          class: "unnnic-card-tag-carousel__container__slide__item",
          onClick: (y) => o.save(h)
        }, null, 8, ["text", "disabled", "onClick"])
      ]))), 128))
    ]),
    u("div", jX, [
      S1(u("span", VX, null, 512), [
        [ri, r.hasNext]
      ]),
      u("div", FX, [
        Z(l, {
          icon: "arrow-right-1-1",
          size: "sm",
          scheme: r.hasNext ? "neutral-black" : "neutral-cleanest",
          clickable: "",
          onClick: i[1] || (i[1] = (h) => o.next())
        }, null, 8, ["scheme"])
      ])
    ])
  ]);
}
const UX = /* @__PURE__ */ k(EX, [["render", PX]]), RX = {
  name: "UnnnicCarousel",
  model: {
    event: "update:model-value"
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: "brand",
      validator(e) {
        return ["brand"].indexOf(e) !== -1;
      }
    },
    tagItems: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    currentComponent() {
      return UX;
    }
  }
};
function YX(e, i, n, a, r, o) {
  return f(), $(oi(o.currentComponent), Q1({ class: "unnnic-carousel-component" }, e.$attrs, {
    name: n.name,
    clickable: n.clickable,
    tagItems: n.tagItems,
    modelValue: n.modelValue,
    onSelected: i[0] || (i[0] = (l) => e.$emit("update:model-value", l))
  }), null, 16, ["name", "clickable", "tagItems", "modelValue"]);
}
const ZX = /* @__PURE__ */ k(RX, [["render", YX]]);
const WX = {
  name: "UnnnicLabel",
  props: {
    label: {
      type: String,
      default: null
    }
  },
  methods: {
    fullySanitize: Mt
  }
}, QX = { class: "unnnic-label__label" };
function qX(e, i, n, a, r, o) {
  return f(), p("p", QX, T(o.fullySanitize(n.label)), 1);
}
const GX = /* @__PURE__ */ k(WX, [["render", qX]]);
const XX = {
  components: {
    UnnnicIcon: ce,
    UnnnicToolTip: q1
  },
  model: {
    prop: "activeTab",
    event: "change"
  },
  props: {
    size: {
      type: String,
      default: "md",
      validator: (e) => ["md", "sm"].includes(e)
    },
    activeTab: {
      type: String,
      default: ""
    },
    initialTab: {
      type: String,
      default: null
    },
    tabs: {
      type: Array,
      default: null
    }
  },
  emits: ["change"],
  data() {
    return {
      localValue: ""
    };
  },
  computed: {
    tabPanelSlotName() {
      return `tab-panel-${this.localValue}`;
    }
  },
  watch: {
    activeTab() {
      this.localValue = this.activeTab;
    }
  },
  created() {
    const e = this.initialTab || this.activeTab || this.tabs && this.tabs[0];
    this.change(e);
  },
  methods: {
    tabHeadSlotName(e) {
      return `tab-head-${e}`;
    },
    tabHeadTooltipSlotName(e) {
      return e ? `tab-head-${e}-tooltip` : "";
    },
    getHeadTooltip(e) {
      var n, a;
      const i = this.$slots[this.tabHeadTooltipSlotName(e)];
      return i ? (a = (n = i()) == null ? void 0 : n[0]) == null ? void 0 : a.children : "";
    },
    change(e) {
      this.localValue = e, this.$emit("change", this.localValue);
    }
  }
}, JX = { class: "tab-header" }, KX = { class: "tab-content" }, $X = ["onClick"], eJ = { class: "tab-body" }, nJ = { class: "tab-panel" };
function iJ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip");
  return f(), p("div", {
    class: B(["tab", `size-${n.size}`])
  }, [
    u("header", JX, [
      u("ul", KX, [
        (f(!0), p(se, null, me(n.tabs, (h) => (f(), p("li", {
          key: h,
          class: B(["tab-head", {
            "tab-head--active": r.localValue === h
          }]),
          onClick: (y) => o.change(h)
        }, [
          pe(e.$slots, o.tabHeadSlotName(h), {}, () => [
            p1(T(h), 1)
          ], !0),
          o.getHeadTooltip(h) ? (f(), $(c, {
            key: 0,
            enabled: "",
            text: o.getHeadTooltip(h),
            side: "bottom"
          }, {
            default: Ee(() => [
              Z(l, {
                icon: "info",
                size: n.size === "sm" ? "xs" : "sm",
                filled: "",
                scheme: "neutral-cleanest"
              }, null, 8, ["size"])
            ]),
            _: 2
          }, 1032, ["text"])) : N("", !0)
        ], 10, $X))), 128))
      ])
    ]),
    u("main", eJ, [
      u("div", nJ, [
        pe(e.$slots, o.tabPanelSlotName, {}, void 0, !0)
      ])
    ])
  ], 2);
}
const tJ = /* @__PURE__ */ k(XX, [["render", iJ], ["__scopeId", "data-v-c96f0199"]]);
const aJ = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    modelValue: {
      type: [String, Number],
      required: !0
    },
    items: {
      type: Array,
      required: !0
    }
  },
  emits: ["back", "update:model-value", "close-tab", "add"]
}, sJ = { class: "unnnic-tabs-expanded" }, oJ = ["onClick"], rJ = {
  "data-testid": "tab-description",
  class: "u font secondary body-sm color-neutral-cloudy"
}, lJ = {
  key: 0,
  class: "close-container"
};
function dJ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", sJ, [
    u("div", {
      class: "back-container",
      "data-testid": "back",
      onClick: i[0] || (i[0] = (c) => e.$emit("back"))
    }, [
      Z(l, {
        icon: "keyboard-arrow-left-1",
        scheme: "neutral-cloudy"
      })
    ]),
    (f(!0), p(se, null, me(n.items, (c) => (f(), p("div", {
      key: c.value,
      class: "tab",
      "data-testid": "tab",
      onClick: (h) => e.$emit("update:model-value", c.value)
    }, [
      u("div", null, [
        u("div", {
          class: B([
            "u font secondary body-gt bold",
            c.value === n.modelValue ? "color-brand-weni-soft" : "color-neutral-cloudy"
          ]),
          "data-testid": "tab-title"
        }, T(c.title), 3),
        u("div", rJ, T(c.description), 1)
      ]),
      c.value === n.modelValue ? (f(), p("div", lJ, [
        Z(l, {
          icon: "close-1",
          size: "xs",
          clickable: "",
          scheme: "neutral-cloudy",
          "data-testid": "tab-close-icon",
          onClick: Qe((h) => e.$emit("close-tab", c), ["stop"])
        }, null, 8, ["onClick"])
      ])) : N("", !0)
    ], 8, oJ))), 128)),
    u("div", {
      class: "add-container",
      "data-testid": "tab-add",
      onClick: i[1] || (i[1] = (c) => e.$emit("add"))
    }, [
      Z(l, {
        icon: "add-1",
        scheme: "neutral-cloudy",
        size: "sm"
      })
    ])
  ]);
}
const cJ = /* @__PURE__ */ k(aJ, [["render", dJ], ["__scopeId", "data-v-ffc5e425"]]);
const fJ = {
  name: "UnnnicBanner",
  components: { UnnnicIcon: ce },
  props: {
    firstTitle: {
      type: String,
      default: null
    },
    secondTitle: {
      type: String,
      default: null
    },
    thirdTitle: {
      type: String,
      default: null
    },
    firstDescription: {
      type: String,
      default: null
    },
    secondDescription: {
      type: String,
      default: null
    },
    thirdDescription: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    rating: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tempRating: null,
      baseRating: this.rating
    };
  },
  methods: {
    emitRatingAction(e) {
      this.$emit("ratingAction", e);
    },
    starScheme(e) {
      return e <= this.baseRating ? "feedback-yellow" : "neutral-clean";
    },
    starOver(e) {
      this.tempRating = this.baseRating, this.baseRating = e;
    },
    starOut() {
      this.baseRating = this.tempRating;
    }
  }
}, uJ = { class: "unnnic-banner-info" }, hJ = { class: "unnnic-banner-info__section" }, mJ = { class: "unnnic-banner-info__title" }, pJ = { class: "unnnic-banner-info__description" }, yJ = /* @__PURE__ */ u("div", { class: "unnnic-banner-info__divider" }, null, -1), vJ = { class: "unnnic-banner-info__section" }, gJ = { class: "unnnic-banner-info__title" }, _J = { class: "unnnic-banner-info__description" }, wJ = { class: "unnnic-banner-info__subtitle" }, CJ = /* @__PURE__ */ u("div", { class: "unnnic-banner-info__divider" }, null, -1), kJ = { class: "unnnic-banner-info__section" }, xJ = { class: "unnnic-banner-info__title" }, bJ = { class: "unnnic-banner-info__description" }, MJ = { class: "unnnic-banner-info__rating" };
function DJ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", uJ, [
    u("section", hJ, [
      u("div", mJ, T(n.firstTitle), 1),
      u("div", pJ, T(n.firstDescription), 1)
    ]),
    yJ,
    u("section", vJ, [
      u("div", gJ, T(n.secondTitle), 1),
      u("div", _J, T(n.secondDescription), 1),
      u("div", wJ, T(n.subtitle), 1)
    ]),
    CJ,
    u("section", kJ, [
      u("div", xJ, T(n.thirdTitle), 1),
      u("div", bJ, T(n.thirdDescription), 1),
      u("div", MJ, [
        (f(), p(se, null, me(5, (c) => Z(l, {
          key: c,
          class: B({
            "unnnic-banner-info__rating__star": !0,
            "unnnic-banner-info__rating__star__active": c <= r.baseRating
          }),
          scheme: o.starScheme(c),
          icon: "rating-star-1",
          size: "ant",
          onClick: (h) => o.emitRatingAction(c),
          onMouseover: (h) => o.starOver(c),
          onMouseout: o.starOut
        }, null, 8, ["class", "scheme", "onClick", "onMouseover", "onMouseout"])), 64))
      ])
    ])
  ]);
}
const ll = /* @__PURE__ */ k(fJ, [["render", DJ]]);
const AJ = {
  name: "UnnnicBanner",
  props: {
    type: {
      type: String,
      default: "info",
      validator(e) {
        return ["info"].indexOf(e) !== -1;
      }
    },
    firstTitle: {
      type: String,
      default: null
    },
    secondTitle: {
      type: String,
      default: null
    },
    thirdTitle: {
      type: String,
      default: null
    },
    firstDescription: {
      type: String,
      default: null
    },
    secondDescription: {
      type: String,
      default: null
    },
    thirdDescription: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    rating: {
      type: Number,
      default: 0
    }
  },
  computed: {
    currentComponent() {
      return this.type === "info", ll;
    }
  },
  methods: {
    emitRatingAction(e) {
      this.$emit("ratingAction", e);
    }
  }
};
function LJ(e, i, n, a, r, o) {
  return f(), $(oi(o.currentComponent), Q1({ class: "unnnic-banner-component" }, e.$attrs, {
    firstTitle: n.firstTitle,
    secondTitle: n.secondTitle,
    thirdTitle: n.thirdTitle,
    firstDescription: n.firstDescription,
    secondDescription: n.secondDescription,
    thirdDescription: n.thirdDescription,
    subtitle: n.subtitle,
    rating: n.rating
  }), null, 16, ["firstTitle", "secondTitle", "thirdTitle", "firstDescription", "secondDescription", "thirdDescription", "subtitle", "rating"]);
}
const TJ = /* @__PURE__ */ k(AJ, [["render", LJ]]);
const SJ = {
  name: "UnnnicComment",
  components: {},
  props: {
    title: {
      type: String,
      default: null
    },
    time: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  }
}, NJ = { class: "unnnic-comment" }, EJ = { class: "unnnic-comment__avatar" }, zJ = { class: "unnnic-comment__content" }, IJ = { class: "unnnic-comment__content__header" }, BJ = { class: "unnnic-comment__content__header__title" }, OJ = { class: "unnnic-comment__content__header__time" }, HJ = { class: "unnnic-comment__content__header__actions" }, jJ = { class: "unnnic-comment__content__text" };
function VJ(e, i, n, a, r, o) {
  return f(), p("div", NJ, [
    u("div", EJ, [
      pe(e.$slots, "avatar", {}, void 0, !0)
    ]),
    u("div", zJ, [
      u("div", IJ, [
        u("div", BJ, T(n.title), 1),
        u("div", OJ, T(n.time), 1),
        u("div", HJ, [
          pe(e.$slots, "actions", {}, void 0, !0)
        ])
      ]),
      u("div", jJ, T(n.text), 1)
    ])
  ]);
}
const FJ = /* @__PURE__ */ k(SJ, [["render", VJ], ["__scopeId", "data-v-ec10b2dd"]]);
const PJ = {
  name: "UnnnicBreadcrumb",
  components: { UnnnicIcon: ce },
  props: {
    crumbs: {
      type: Array,
      default: null,
      validator: (e) => e.every((i) => i.name !== null)
    }
  },
  emits: ["crumb-click"]
}, UJ = { class: "unnnic-breadcrumb" }, RJ = ["data-test", "onClick"];
function YJ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", UJ, [
    (f(!0), p(se, null, me(n.crumbs, (c, h) => (f(), p(se, {
      key: c.name
    }, [
      u("div", {
        class: B({
          "unnnic-breadcrumb__container__link": !0,
          "unnnic-breadcrumb__container__link__active": h === n.crumbs.length - 1
        }),
        "data-test": c.name,
        onClick: (y) => e.$emit("crumb-click", c)
      }, T(c.name), 11, RJ),
      h !== n.crumbs.length - 1 ? (f(), $(l, {
        key: 0,
        "data-test": "right-icon",
        icon: "arrow-right-1-1",
        size: "xs",
        lineHeight: "md",
        class: "unnnic-breadcrumb__container__divider",
        scheme: "neutral-cloudy"
      })) : N("", !0)
    ], 64))), 128))
  ]);
}
const Ic = /* @__PURE__ */ k(PJ, [["render", YJ], ["__scopeId", "data-v-92e355b9"]]);
const ZJ = {
  name: "UnnnicSwitch",
  components: { UnnnicIcon: ce },
  props: {
    size: {
      type: String,
      default: "medium",
      validator(e) {
        return ["small", "medium"].indexOf(e) !== -1;
      }
    },
    textLeft: {
      type: String,
      default: ""
    },
    textRight: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    useVModel: {
      type: Boolean
    }
  },
  emits: ["update:model-value"],
  data() {
    return {
      isActive: !1
    };
  },
  computed: {
    currentIcon() {
      return this.disabled ? this.isActive ? "switch-selected-disabled" : "switch-default-disabled" : "switch-default";
    },
    iconSize() {
      return this.size === "small" ? "sm" : "md";
    },
    iconScheme() {
      return this.disabled || this.isActive === !1 ? "neutral-soft" : "brand-weni";
    },
    iconLineHeight() {
      return this.size === "small" ? "sm" : "";
    }
  },
  watch: {
    modelValue: {
      immediate: !0,
      handler() {
        this.isActive = this.modelValue;
      }
    }
  },
  methods: {
    toggleState() {
      this.disabled || (this.useVModel ? this.$emit("update:model-value", !this.isActive) : (this.isActive = !this.isActive, this.$emit("update:model-value", this.isActive)));
    }
  }
}, WJ = { class: "unnnic-switch" };
function QJ(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", WJ, [
    n.textLeft ? (f(), p("div", {
      key: 0,
      "data-test-id": "switch-text-left",
      class: B([
        "unnnic-switch__label",
        "unnnic-switch__label__left",
        `unnnic-switch__label__${n.size}`
      ])
    }, T(n.textLeft), 3)) : N("", !0),
    Z(l, {
      class: B({ "unnnic-switch__icon": !0, active: r.isActive }),
      icon: o.currentIcon,
      size: o.iconSize,
      scheme: o.iconScheme,
      lineHeight: o.iconLineHeight,
      disabled: n.disabled,
      clickable: !n.disabled,
      "data-test-id": "switch-icon",
      onClick: o.toggleState
    }, null, 8, ["class", "icon", "size", "scheme", "lineHeight", "disabled", "clickable", "onClick"]),
    n.textRight ? (f(), p("div", {
      key: 1,
      "data-test-id": "switch-text-right",
      class: B([
        "unnnic-switch__label",
        "unnnic-switch__label__right",
        `unnnic-switch__label__${n.size}`
      ])
    }, T(n.textRight), 3)) : N("", !0)
  ]);
}
const qJ = /* @__PURE__ */ k(ZJ, [["render", QJ], ["__scopeId", "data-v-4de61148"]]);
const GJ = {
  name: "UnnnicSlider",
  components: {
    UnnnicTooltip: q1,
    UnnnicIcon: ce
  },
  props: {
    initialValue: {
      type: Number,
      default: 0
    },
    showInputValue: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: ""
    },
    labelInfo: {
      type: String,
      default: ""
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 5
    },
    step: {
      type: Number,
      default: 1
    },
    minLabel: {
      type: String,
      default: ""
    },
    maxLabel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showTooltip: !1,
      sliderVal: this.initialValue,
      tooltipOffset: 0,
      sliderWidth: 0,
      labelWidth: 0
    };
  },
  computed: {
    cssVars() {
      return {
        "--val": this.sliderVal,
        "--tooltip-offset": this.tooltipOffset,
        "--min": this.minValue,
        "--max": this.maxValue
      };
    }
  },
  watch: {
    sliderVal: {
      handler() {
        this.$nextTick(() => {
          this.configureTooltip();
          const e = this.$refs["value-input"];
          e && e.textContent !== this.sliderVal && (this.$refs["value-input"].textContent = this.sliderVal);
        });
      },
      immediate: !0,
      deep: !0
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.checkInputWidth(), this.checkTooltipLabelWidth();
  },
  methods: {
    configureTooltip() {
      this.sliderWidth = this.$refs.input.clientWidth, this.labelWidth = this.$refs.tooltip.$refs.label.clientWidth, this.tooltipOffset = this.getNewTooltipPosition();
    },
    handleResize() {
      this.configureTooltip();
    },
    handleValueChange() {
      this.configureTooltip(), this.$emit("valueChange", this.sliderVal);
    },
    handleInput(e) {
      this.sliderVal = e.target.value, this.handleValueChange();
    },
    checkInputWidth() {
      const e = setInterval(() => {
        const i = this.$refs.input;
        if (i) {
          const { offsetWidth: n } = i;
          n > 0 && (this.sliderWidth = n, this.configureTooltip(), clearInterval(e));
        }
      }, 100);
    },
    checkTooltipLabelWidth() {
      const e = setInterval(() => {
        var a;
        const i = (a = this.$refs.tooltip) == null ? void 0 : a.$refs.label;
        if (!i)
          return;
        const { clientWidth: n } = i;
        n > 0 && (this.labelWidth = n, this.configureTooltip(), clearInterval(e));
      }, 100);
    },
    getNewTooltipPosition() {
      if (this.sliderWidth === 0 || this.labelWidth === 0)
        return 0;
      const e = 12 / 2, i = this.labelWidth / 2 || 16, n = this.sliderWidth / 2;
      let a = (this.sliderVal - this.minValue) / (this.maxValue - this.minValue);
      Number.isNaN(a) && (a = 0);
      const r = a * this.sliderWidth, c = (r - n) / n * e;
      return r - i - c;
    }
  }
}, XJ = { class: "unnnic-label" }, JJ = {
  key: 0,
  class: "unnnic-slider__label"
}, KJ = { class: "unnnic-slider__content" }, $J = { class: "unnnic-slider__content__labels" }, eK = { class: "unnnic-slider__content__labels__min" }, nK = ["min", "max", "step"], iK = { class: "unnnic-slider__content__labels__max" }, tK = ["value"];
function aK(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicTooltip");
  return f(), p("article", null, [
    u("section", XJ, [
      n.label ? (f(), p("p", JJ, T(n.label), 1)) : N("", !0),
      n.labelInfo ? (f(), $(c, {
        key: 1,
        class: "unnnic-label__tooltip",
        text: n.labelInfo,
        enabled: "",
        side: "top"
      }, {
        default: Ee(() => [
          Z(l, {
            class: "unnnic-label__tooltip__icon",
            icon: "info",
            size: "sm",
            scheme: "neutral-clean",
            filled: !0
          })
        ]),
        _: 1
      }, 8, ["text"])) : N("", !0)
    ]),
    u("section", {
      class: "unnnic-slider",
      style: Ze(o.cssVars)
    }, [
      u("section", KJ, [
        u("section", $J, [
          u("span", eK, T(n.minLabel), 1),
          Z(c, {
            ref: "tooltip",
            class: "unnnic-slider__content__tooltip",
            text: r.sliderVal.toString(),
            forceOpen: !0,
            enabled: r.showTooltip,
            side: "top"
          }, {
            default: Ee(() => [
              S1(u("input", {
                ref: "input",
                "onUpdate:modelValue": i[0] || (i[0] = (h) => r.sliderVal = h),
                class: "unnnic-slider__content__range-input",
                type: "range",
                min: n.minValue,
                max: n.maxValue,
                step: n.step,
                onChange: i[1] || (i[1] = (...h) => o.handleValueChange && o.handleValueChange(...h)),
                onMouseover: i[2] || (i[2] = (h) => r.showTooltip = !0),
                onMouseleave: i[3] || (i[3] = (h) => r.showTooltip = !1)
              }, null, 40, nK), [
                [jl, r.sliderVal]
              ])
            ]),
            _: 1
          }, 8, ["text", "enabled"]),
          u("span", iK, T(n.maxLabel), 1)
        ])
      ]),
      n.showInputValue ? (f(), p("input", {
        key: 0,
        ref: "value-input",
        class: "value-input",
        value: r.sliderVal,
        onInput: i[4] || (i[4] = (...h) => o.handleInput && o.handleInput(...h))
      }, null, 40, tK)) : N("", !0)
    ], 4)
  ]);
}
const sK = /* @__PURE__ */ k(GJ, [["render", aK], ["__scopeId", "data-v-32de7704"]]);
const oK = {
  name: "UnnnicDataArea",
  components: {
    ToolTip: q1
  },
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    enableHover: {
      type: Boolean,
      default: !1
    },
    hoverText: {
      type: String,
      default: ""
    }
  }
}, rK = { class: "data-area-container" }, lK = { class: "data-area-container__header" }, dK = { class: "data-area-container__header__title" }, cK = { class: "data-area-container__header__links-slot" }, fK = { class: "data-area-container__content" }, uK = { class: "data-area-container__content__text" }, hK = { class: "data-area-container__content__buttons-slot" };
function mK(e, i, n, a, r, o) {
  const l = j("ToolTip");
  return f(), p("div", rK, [
    u("div", lK, [
      u("div", dK, T(n.title), 1),
      u("div", cK, [
        pe(e.$slots, "links", {}, void 0, !0)
      ])
    ]),
    u("div", fK, [
      Z(l, {
        enabled: n.enableHover,
        text: n.hoverText
      }, {
        default: Ee(() => [
          u("div", uK, T(n.text), 1)
        ]),
        _: 1
      }, 8, ["enabled", "text"]),
      u("div", hK, [
        pe(e.$slots, "buttons", {}, void 0, !0)
      ])
    ])
  ]);
}
const pK = /* @__PURE__ */ k(oK, [["render", mK], ["__scopeId", "data-v-4e7e72b5"]]);
const yK = {
  components: {
    UnnnicButton: Wn
  },
  props: {
    modelValue: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 1
    },
    show: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:model-value"],
  data() {
    return {
      reference: 3
    };
  },
  computed: {
    pages() {
      const e = [];
      for (let a = 1; a <= this.max; a += 1)
        e.push(a);
      const i = this.show - 4, n = this.max - i - 3;
      if (this.reference > 3) {
        const a = this.reference - 2, r = a > n ? n : a;
        e.splice(1, r, "left-hidden");
      }
      if (this.reference < this.max - i - 1) {
        const a = this.max - i - this.reference, r = a > n ? n : a;
        e.splice(-(r + 1), r, "right-hidden");
      }
      return e;
    },
    canPrevious() {
      return this.modelValue > 1;
    },
    canNext() {
      return this.modelValue < this.max;
    }
  },
  created() {
    const e = this.modelValue;
    this.selectPage(e, !0), this.pages.includes(e) || this.setReference(e);
  },
  methods: {
    selectPage(e, i) {
      if (e === "left-hidden") {
        const n = this.pages[this.pages.indexOf("left-hidden") + 1] - 1;
        i || this.$emit("update:model-value", n), this.setReference(n);
      } else if (e === "right-hidden") {
        const n = this.pages[this.pages.indexOf("right-hidden") - 1] + 1;
        i || this.$emit("update:model-value", n), this.pages.includes("left-hidden") ? this.setReference(
          this.pages[this.pages.indexOf("left-hidden") + 1] + 1
        ) : this.setReference(4);
      } else
        i || this.$emit("update:model-value", e);
    },
    previousPage() {
      if (this.canPrevious) {
        const e = this.modelValue - 1;
        this.selectPage(e), this.pages.includes(e) || this.setReference(e);
      }
    },
    nextPage() {
      if (this.canNext) {
        const e = this.modelValue + 1;
        this.selectPage(e), this.pages.includes(e) || this.setReference(e);
      }
    },
    setReference(e) {
      this.reference = e;
    }
  }
}, vK = { class: "pagination" };
function gK(e, i, n, a, r, o) {
  const l = j("UnnnicButton");
  return f(), p("div", vK, [
    Z(l, {
      type: "tertiary",
      size: "small",
      iconCenter: "arrow-left-1-1",
      disabled: !o.canPrevious || n.disabled,
      "data-test": "previous-button",
      onClick: o.previousPage
    }, null, 8, ["disabled", "onClick"]),
    (f(!0), p(se, null, me(o.pages, (c, h) => (f(), $(l, {
      key: h,
      type: c === n.modelValue ? "secondary" : "tertiary",
      size: "small",
      text: ["left-hidden", "right-hidden"].includes(c) ? "..." : String(c),
      disabled: n.disabled,
      "data-test": "page-button",
      onClick: (y) => o.selectPage(c)
    }, null, 8, ["type", "text", "disabled", "onClick"]))), 128)),
    Z(l, {
      type: "tertiary",
      size: "small",
      iconCenter: "arrow-right-1-1",
      disabled: !o.canNext || n.disabled,
      "data-test": "next-button",
      onClick: o.nextPage
    }, null, 8, ["disabled", "onClick"])
  ]);
}
const Bc = /* @__PURE__ */ k(yK, [["render", gK], ["__scopeId", "data-v-b2612197"]]), _K = {
  name: "UnnnicDateFilter",
  components: { UnnnicInput: _0 },
  props: {
    size: {
      type: String,
      default: "sm"
    },
    dateFormat: {
      type: String,
      default: "DD/MM/YYYY"
    },
    dateSeparator: {
      type: String,
      default: "~"
    },
    startDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  computed: {
    dateRange() {
      let e = "";
      if (this.startDate) {
        const i = oe(this.startDate).format(
          this.dateFormat.replaceAll("/", "")
        );
        e += i.toString();
      }
      if (this.endDate) {
        const i = oe(this.endDate).format(
          this.dateFormat.replaceAll("/", "")
        );
        e += i.toString();
      }
      return e;
    },
    fullMask() {
      return `${this.maskedDateFormat} !${this.dateSeparator} ${this.maskedDateFormat}`;
    },
    maskedDateFormat() {
      return this.dateFormat.replace(/D|M|Y/gi, "#");
    }
  },
  methods: {
    emitFilter() {
      this.$emit("filter");
    }
  }
}, wK = { class: "unnnic-date-filter" };
function CK(e, i, n, a, r, o) {
  const l = j("UnnnicInput");
  return f(), p("div", wK, [
    Z(l, {
      class: "unnnic-date-filter__input",
      size: n.size,
      iconLeft: "notes-1",
      readonly: "",
      mask: o.fullMask,
      value: o.dateRange,
      placeholder: n.placeholder,
      onFocus: Qe(o.emitFilter, ["stop"])
    }, null, 8, ["size", "mask", "value", "placeholder", "onFocus"])
  ]);
}
const kK = /* @__PURE__ */ k(_K, [["render", CK]]);
const xK = {
  components: {
    UnnnicToolTip: q1,
    UnnnicIcon: ce
  },
  props: {
    size: {
      type: String,
      default: "normal"
    },
    title: {
      type: String
    },
    titleColor: {
      type: String,
      default: "brand-weni-soft"
    },
    info: {
      type: String
    }
  },
  data() {
    return {
      isScrollable: !1
    };
  },
  mounted() {
    const e = this.$refs.description.scrollHeight - this.$refs.description.offsetHeight;
    this.isScrollable = e;
  }
}, bK = { class: "header" }, MK = {
  ref: "description",
  class: "description"
}, DK = {
  key: 0,
  class: "scrollable-gradient"
};
function AK(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip");
  return f(), p("div", {
    class: B(["unnnic-chat-text", n.size])
  }, [
    u("div", bK, [
      u("div", {
        class: B(["title", n.titleColor])
      }, [
        p1(T(n.title) + " ", 1),
        n.info ? (f(), $(c, {
          key: 0,
          side: "top",
          class: "info",
          text: n.info,
          enabled: ""
        }, {
          default: Ee(() => [
            Z(l, {
              class: "info__icon",
              icon: "info",
              size: "sm",
              scheme: "neutral-clean"
            })
          ]),
          _: 1
        }, 8, ["text"])) : N("", !0)
      ], 2),
      pe(e.$slots, "actions", {}, void 0, !0)
    ]),
    u("div", MK, [
      pe(e.$slots, "description", {}, void 0, !0),
      r.isScrollable ? (f(), p("div", DK)) : N("", !0)
    ], 512)
  ], 2);
}
const LK = /* @__PURE__ */ k(xK, [["render", AK], ["__scopeId", "data-v-4007f3f4"]]);
const TK = {
  components: {
    UnnnicFormElement: Ul
  },
  props: {
    size: {
      type: String,
      default: "md"
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    modelValue: {
      type: String
    },
    maxLength: {
      type: Number
    },
    message: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    type: {
      type: String,
      default: "normal",
      validator(e) {
        return ["normal", "error"].indexOf(e) !== -1;
      }
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  methods: {
    fullySanitize: Mt,
    focus() {
      this.$refs.textarea.focus();
    }
  }
}, SK = ["placeholder", "maxlength", "disabled", "value"];
function NK(e, i, n, a, r, o) {
  const l = j("UnnnicFormElement");
  return f(), $(l, {
    label: n.label,
    size: n.size,
    disabled: n.disabled,
    message: n.message,
    error: n.errors.join(", ") || n.type === "error"
  }, Ol({
    default: Ee(() => [
      u("textarea", {
        ref: "textarea",
        class: B(["unnnic-text-area__textarea", [
          `unnnic-text-area__textarea--size-${n.size}`,
          `unnnic-text-area__textarea--type-${n.type}`
        ]]),
        placeholder: o.fullySanitize(n.placeholder),
        maxlength: n.maxLength,
        disabled: n.disabled,
        value: n.modelValue,
        onInput: i[0] || (i[0] = (c) => e.$emit("update:modelValue", o.fullySanitize(c.target.value)))
      }, null, 42, SK)
    ]),
    _: 2
  }, [
    n.maxLength ? {
      name: "rightMessage",
      fn: Ee(() => [
        p1(T(n.modelValue.length) + "/" + T(n.maxLength), 1)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["label", "size", "disabled", "message", "error"]);
}
const EK = /* @__PURE__ */ k(TK, [["render", NK], ["__scopeId", "data-v-adccf3ee"]]);
const zK = {
  props: {
    description: {
      type: String,
      default: ""
    },
    number: {
      type: String,
      default: ""
    },
    fullSize: {
      type: Boolean,
      default: !1
    }
  }
};
function IK(e, i, n, a, r, o) {
  return f(), p("div", {
    class: B(["unnnic-card-number", { "v-full": n.fullSize }])
  }, [
    u("h4", null, T(n.description), 1),
    u("span", null, T(n.number), 1)
  ], 2);
}
const BK = /* @__PURE__ */ k(zK, [["render", IK], ["__scopeId", "data-v-dcd65145"]]);
const OK = {
  components: {},
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    description: {
      type: String
    }
  },
  watch: {
    modelValue() {
      this.updateChartSvg();
    }
  },
  mounted() {
    this.updateChartSvg();
  },
  methods: {
    updateChartSvg() {
      function e(a, r, o, l) {
        const c = (l - 90) * Math.PI / 180;
        return {
          x: a + o * Math.cos(c),
          y: r + o * Math.sin(c)
        };
      }
      function i(a, r, o, l, c, h) {
        const y = o, v = l - o, x = e(a, r, y + v, h), C = e(a, r, y + v, c), M = h - c <= 180 ? "0" : "1";
        return [
          "M",
          x.x,
          x.y,
          "A",
          y + v,
          y + v,
          0,
          M,
          0,
          C.x,
          C.y
        ].join(" ");
      }
      const n = i(166, 166, 139.44, 152.72, -85, 85);
      this.$refs.background.setAttribute("d", n), this.$refs.front.setAttribute(
        "d",
        i(
          166,
          166,
          139.44,
          152.72,
          -85,
          -85 + this.modelValue / 100 * 170
        )
      );
    }
  }
}, Oc = (e) => (hn("data-v-c4367c70"), e = e(), mn(), e), HK = { class: "unnnic-chart-rainbow" }, jK = {
  width: "332",
  height: "166",
  class: "semicircle"
}, VK = /* @__PURE__ */ Oc(() => /* @__PURE__ */ u("defs", { xmlns: "http://www.w3.org/2000/svg" }, [
  /* @__PURE__ */ u("linearGradient", {
    id: "paint0_linear_10224_36584",
    x1: "178",
    y1: "45",
    x2: "28",
    y2: "198",
    gradientUnits: "userSpaceOnUse"
  }, [
    /* @__PURE__ */ u("stop", { "stop-color": "#00DED2" }),
    /* @__PURE__ */ u("stop", {
      offset: "1",
      "stop-color": "#00DED2",
      "stop-opacity": "0"
    })
  ])
], -1)), FK = {
  id: "path",
  ref: "background",
  fill: "none",
  "stroke-linecap": "round",
  class: "background",
  "stroke-width": "26.56px"
}, PK = {
  id: "path",
  ref: "front",
  fill: "none",
  "stroke-linecap": "round",
  class: "front",
  "stroke-width": "26.56px"
}, UK = { class: "content" }, RK = { class: "percentage" }, YK = { class: "number" }, ZK = /* @__PURE__ */ Oc(() => /* @__PURE__ */ u("span", { class: "symbol" }, "%", -1)), WK = {
  key: 0,
  class: "description"
};
function QK(e, i, n, a, r, o) {
  return f(), p("div", HK, [
    (f(), p("svg", jK, [
      VK,
      u("path", FK, null, 512),
      u("path", PK, null, 512)
    ])),
    u("div", UK, [
      u("div", RK, [
        u("span", YK, T(n.modelValue), 1),
        ZK
      ]),
      n.description ? (f(), p("div", WK, T(n.description), 1)) : N("", !0)
    ])
  ]);
}
const qK = /* @__PURE__ */ k(OK, [["render", QK], ["__scopeId", "data-v-c4367c70"]]);
const GK = {
  components: {
    UnnnicIcon: ce,
    UnnnicButton: Wn,
    UnnnicToolTip: q1
  },
  props: {
    condensed: Boolean,
    groups: Array,
    fixedMaxValue: Number,
    title: String,
    description: String,
    updateText: String,
    previousDisabled: Boolean,
    nextDisabled: Boolean,
    showFooterLegend: Boolean
  },
  data() {
    return {
      colors: [
        "aux-blue",
        "aux-purple",
        "aux-orange",
        "aux-lemon",
        "aux-pink",
        "aux-baby-blue",
        "aux-baby-yellow",
        "aux-baby-red",
        "aux-baby-green",
        "aux-baby-pink"
      ]
    };
  },
  computed: {
    legends() {
      return this.groups.map(({ values: e }) => Object.keys(e)).flat().filter((e, i, n) => n.indexOf(e) === i);
    },
    maxValue() {
      return this.fixedMaxValue || Math.max(
        ...this.groups.map(({ values: e }) => Object.values(e)).flat()
      );
    }
  },
  methods: {
    value(e) {
      return this.maxValue <= 1 ? e.toFixed(1) : String(Math.ceil(e));
    }
  }
}, XK = (e) => (hn("data-v-2888817c"), e = e(), mn(), e), JK = {
  key: 0,
  class: "header"
}, KK = {
  key: 0,
  class: "content"
}, $K = {
  key: 1,
  class: "description unnnic-font secondary body-gt color-neutral-cloudy"
}, e$ = {
  key: 1,
  class: "actions"
}, n$ = {
  key: 0,
  class: "unnnic-font secondary body-md color-neutral-dark"
}, i$ = {
  key: 1,
  class: "navigation-container"
}, t$ = { class: "main" }, a$ = { class: "reference" }, s$ = { class: "values" }, o$ = /* @__PURE__ */ XK(() => /* @__PURE__ */ u("div", { class: "unnnic-font secondary body-md color-neutral-cleanest" }, "   ", -1)), r$ = { class: "groups" }, l$ = { class: "bars" }, d$ = { class: "title unnnic-font secondary body-md color-neutral-cleanest" }, c$ = {
  key: 1,
  class: "footer"
}, f$ = { class: "unnnic-font secondary body-gt color-neutral-cloudy" };
function u$(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicButton"), h = j("UnnnicToolTip");
  return f(), p("div", {
    class: B(["unnnic-chart-bar", { condensed: n.condensed }])
  }, [
    n.title || n.description || e.$attrs.update || e.$attrs.previous || e.$attrs.next ? (f(), p("div", JK, [
      n.title || n.description ? (f(), p("div", KK, [
        n.title ? (f(), p("div", {
          key: 0,
          class: "title unnnic-font bold title-sm color-neutral-darkest",
          onClick: i[0] || (i[0] = (y) => e.$emit("update"))
        }, T(n.title), 1)) : N("", !0),
        n.description ? (f(), p("div", $K, T(n.description), 1)) : N("", !0)
      ])) : N("", !0),
      e.$attrs.update || e.$attrs.previous || e.$attrs.next ? (f(), p("div", e$, [
        e.$attrs.update ? (f(), p("div", {
          key: 0,
          class: "update-button",
          onClick: i[1] || (i[1] = (y) => e.$emit("update"))
        }, [
          Z(l, {
            icon: "button-refresh-arrow-1",
            size: "sm",
            scheme: "neutral-darkest"
          }),
          n.updateText ? (f(), p("span", n$, T(n.updateText), 1)) : N("", !0)
        ])) : N("", !0),
        e.$attrs.previous || e.$attrs.next ? (f(), p("div", i$, [
          e.$attrs.previous ? (f(), $(c, {
            key: 0,
            size: "small",
            type: "tertiary",
            iconCenter: "arrow-left-1-1",
            disabled: n.previousDisabled,
            onClick: i[2] || (i[2] = (y) => e.$emit("previous"))
          }, null, 8, ["disabled"])) : N("", !0),
          e.$attrs.next ? (f(), $(c, {
            key: 1,
            size: "small",
            type: "tertiary",
            iconCenter: "arrow-right-1-1",
            disabled: n.nextDisabled,
            onClick: i[3] || (i[3] = (y) => e.$emit("next"))
          }, null, 8, ["disabled"])) : N("", !0)
        ])) : N("", !0)
      ])) : N("", !0)
    ])) : N("", !0),
    u("div", t$, [
      u("div", a$, [
        u("div", s$, [
          (f(!0), p(se, null, me([
            o.value(o.maxValue),
            o.value(o.maxValue / 2),
            o.value(0)
          ], (y, v) => (f(), p("div", {
            key: v,
            class: "value unnnic-font secondary body-md color-neutral-cleanest"
          }, T(y), 1))), 128))
        ]),
        o$
      ]),
      u("div", r$, [
        (f(!0), p(se, null, me(n.groups, (y, v) => (f(), p("div", {
          key: v,
          class: "group"
        }, [
          u("div", l$, [
            (f(!0), p(se, null, me(o.legends.map((x, C) => ({ legend: x, index: C })).filter(({ legend: x }) => y.values[x]), ({ legend: x, index: C }) => (f(), $(h, {
              key: C,
              enabled: "",
              text: `${y.title}: ${y.values[x]}
${x}`,
              side: "top",
              style: Ze({ height: `${y.values[x] / o.maxValue * 100}%` })
            }, {
              default: Ee(() => [
                u("div", {
                  class: B(["bar", `color-${C}`])
                }, null, 2)
              ]),
              _: 2
            }, 1032, ["text", "style"]))), 128))
          ]),
          u("div", d$, T(y.title), 1)
        ]))), 128))
      ])
    ]),
    n.showFooterLegend ? (f(), p("div", c$, [
      (f(!0), p(se, null, me(o.legends, (y, v) => (f(), p("div", {
        key: v,
        class: "legend"
      }, [
        Z(l, {
          icon: "indicator",
          scheme: r.colors[v]
        }, null, 8, ["scheme"]),
        u("div", f$, T(y), 1)
      ]))), 128))
    ])) : N("", !0)
  ], 2);
}
const h$ = /* @__PURE__ */ k(GK, [["render", u$], ["__scopeId", "data-v-2888817c"]]);
const m$ = {
  components: {
    UnnnicToolTip: q1
  },
  props: {
    condensed: Boolean,
    fixedMaxValue: Number,
    data: Array,
    title: String
  },
  data() {
    return {
      chartContainerWidthInterval: null,
      chartContainerWidth: 0
    };
  },
  computed: {
    maxValue() {
      return this.fixedMaxValue || Math.max(...this.data.map(({ value: e }) => e).flat());
    },
    svgChart() {
      const e = this.data.map(
        ({ value: l }) => 49.39 - (l / this.maxValue * 48.78 + Math.random() * 0.01)
      ), i = 100 / e.length, n = i / 2;
      let a = "";
      a += `L ${i / 2} ${e[0]}`;
      let r = 0;
      for (let l = 1; l < e.length; l += 1)
        l === 1 ? r = i * 1.5 : r += i, a += `C ${r - n} ${e[l - 1]} ${r - n} ${e[l]} ${r} ${e[l]}`;
      e.length <= 1 && (r += i / 2), a += `L ${r + n} ${e[e.length - 1]}`;
      const o = `
        <svg xmlns='http://www.w3.org/2000/svg' viewBox="0 0 100 50" width="100%" height="100%">
          <defs>
            <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#DE16BA" stop-opacity="1" />
              <stop offset="50%" stop-color="#DE16BA" stop-opacity="0.4" />
              <stop offset="100%" stop-color="#2856FC" stop-opacity="1.0" />
            </linearGradient>

            <linearGradient id="linear1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#DE16BA" stop-opacity="0.16" />
              <stop offset="50%" stop-color="#2856FC" stop-opacity="0.16" />
            </linearGradient>
          </defs>

          <g style="transform: scaleX(${this.chartContainerWidth / (122 / 50 * 100)}); transform-origin: center;">
            <path fill="url(#linear1)" d="M0 50 L0 ${String(e[0]) + a} L100 50Z" />
            <path fill="none" stroke-width="2" stroke-linecap="round" vector-effect="non-scaling-stroke" stroke="url(#linear)" d="M0 ${String(e[0]) + a}" />
          </g>
        </svg>
      `;
      return `url("data:image/svg+xml,${encodeURIComponent(o)}")`;
    }
  },
  mounted() {
    this.chartContainerWidth = this.$refs.chart.offsetWidth, this.chartContainerWidthInterval = setInterval(() => {
      this.chartContainerWidth = this.$refs.chart.offsetWidth;
    }, 100);
  },
  beforeUnmount() {
    this.chartContainerWidthInterval && clearInterval(this.chartContainerWidthInterval);
  },
  methods: {
    value(e) {
      return this.maxValue <= 1 ? e.toFixed(1) : String(Math.ceil(e));
    }
  }
}, Hc = (e) => (hn("data-v-6d53cf31"), e = e(), mn(), e), p$ = {
  key: 0,
  class: "header"
}, y$ = { class: "title unnnic-font secondary body-lg color-neutral-dark" }, v$ = { class: "main" }, g$ = { class: "reference" }, _$ = { class: "values" }, w$ = /* @__PURE__ */ Hc(() => /* @__PURE__ */ u("div", { class: "unnnic-font secondary body-md color-neutral-cleanest" }, "   ", -1)), C$ = { class: "groups" }, k$ = /* @__PURE__ */ Hc(() => /* @__PURE__ */ u("div", { class: "bar" }, null, -1)), x$ = { class: "titles" };
function b$(e, i, n, a, r, o) {
  const l = j("UnnnicToolTip");
  return f(), p("div", {
    class: B(["unnnic-chart-line", { condensed: n.condensed }])
  }, [
    n.title ? (f(), p("div", p$, [
      u("div", y$, T(n.title), 1)
    ])) : N("", !0),
    u("div", v$, [
      u("div", g$, [
        u("div", _$, [
          (f(!0), p(se, null, me([
            o.value(o.maxValue),
            o.value(o.maxValue / 2),
            o.value(0)
          ], (c, h) => (f(), p("div", {
            key: h,
            class: "value unnnic-font secondary body-md color-neutral-cleanest"
          }, T(c), 1))), 128))
        ]),
        w$
      ]),
      u("div", C$, [
        u("div", {
          ref: "chart",
          class: "chart",
          style: Ze({ backgroundImage: o.svgChart })
        }, [
          (f(!0), p(se, null, me(n.data, ({ value: c }, h) => (f(), p("div", {
            key: h,
            class: "group"
          }, [
            Z(l, {
              enabled: "",
              text: String(c),
              side: "top",
              style: Ze({ height: `${c / o.maxValue * 100}%`, width: "100%" })
            }, {
              default: Ee(() => [
                k$
              ]),
              _: 2
            }, 1032, ["text", "style"])
          ]))), 128))
        ], 4),
        u("div", x$, [
          (f(!0), p(se, null, me(n.data, ({ title: c }, h) => (f(), p("div", {
            key: h,
            class: "title unnnic-font secondary body-md color-neutral-cleanest"
          }, T(c), 1))), 128))
        ])
      ])
    ])
  ], 2);
}
const M$ = /* @__PURE__ */ k(m$, [["render", b$], ["__scopeId", "data-v-6d53cf31"]]), D$ = "data:image/png;base64,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", A$ = "data:image/png;base64,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", L$ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAABRmElEQVR4AeybA5Aky9q/n8xSY6ZndnbWx7bPtW3btm3btm3b9r3H9llj3CxkfjlR2TEZfSsq+vv/v/X8Ip54q2q9+8z71psdy97Kcpaj4QSh2XtZznIky1nOsoDLWRZwOctZFnA5B1t8lvP/lD984AECtAE0QgOa5fyvI373gQewnKXU9EJF4420qa+t0zx0lIVJpBxLCSdC0ZvwRVr3yGpS6BC0BwgQmUbEmZadVPnNng5nQ5FMo7K5BT0y1aSxaVS0NgudNIE2/bAcv6FmOVjT0VE11sH6EdE+wXC8J7Pj637ryKqM14d+vDqQ6ZiQOvSkQsoMPA3SIACwVQAaNDlKgEFlHlkm0VqkqZLzcRru7GbR1qaqXa8zrmjp2pVN0bg0pLcJaHKQRvz9vXfhYElLV3xP6CNHmT+7LrpnjcjmOUa4Y6tBvMb300AGKfgix7PIRcirWMQVD0AvXWttcKrSkC2iDECqDQqd+iSJr+LU39FM6tcsqPp5Rs5/zdE4L9PySqB78Izgd92DAzxRSO+MuujcfMxfuP24N392LexuCIIYQgzCSidzcuks2gAIV0IAW7WmH/sAFKD7lQERsTJaKZNFNMSCNAnoxOHOubhxfltXf7+1N/6nHUn9X0DrgBbwG2+4DwdiVteSU8eZvf2EN3uPFf7czWpRd0xWsly4UIJnCAw+IPsSOh3Ps1X0BbS449eJldEKZ6VzO6ECMm1xrtM+VsieQvc82r2oPROP/Xs+G/n5nG78pkX9H0B2wAn4y3fciwMlSsgxI90dJ9n1oIlw7g6NSmuNjFKIvBzfCucLCPqjFoM02Huhc9E8VzosznXfNjcagwB3FKs+QMbSfQq4oznpC2mv4wx6Gbrr0exW5nYlE7/frld/23THXwJbDxgBf/2Ou7G/x9fpYSM077fG2/GwldHsTSuVnqQioOJBIC2iL5/FSucBfl84LNqQGRQIey+wcgJIEF5e3banM9v5HBkzgwYyCcqgPcj6Eior5qCA/QrECnopdBVJN2C6N37RzmTiW22q3wQu2/+XkLfdgv01McGx42Lukav9XQ9dGc6d4FUzqEkIfYOAwOI71Qc8aaWThizHCpdLOWIYtXXSsBLEmGHUUDdUDIHBtxJmoFNDbGgbWqDmDNOQ7TTMGVqQzkPWNYhcxswD5eX3qTJod1lZEjHGoHK6KarjMdcd2bg5Xfu9jdmazwLn7bcC/uQtd2V/S00kR0ww9Zi1wc7HTFbmjhY1lXe7cBGR03+/cyX0+gKmVjwFQQ28cQg3QHA0eIdBcAiIQ0GussJFQAUIgWBp4WAwAsiA2NIF3cll1NshvRGSTZDdAPG1kOyAdA6SJBcxNWSeO5atiFbAxMqYKOhm0IGZzui2G5P132iq+qeAi/Y7Af/0lluxv6Qj62MNPf+Yw70bn7aqOnOSrGkrnoDIShdiq7vd9qWL8/tgAqLDDKdCeDJ4xxo2gBjPhUNAf43Vqn/tIBiM820OEoR0vr8EUtALtjteD8kV0LvIcJlhCyRNSCWoEFNtZ8TKl8uYLysaYkMvg5Zmut3YuDlb9+ldcvVngI37jYC/efud2R9Sy+bvvU5ue9G6ytRtgnoC1cBKB4TCIt2OZ1BWOiCcgOqJUDkHorPAPzrvcDoCMitbamUTIFzJBMXVjS641hb3yMZ9hzQIYYVclO9y6PzT8B/oXg+9JmS+IYQUiG1HjLUVchGgl3fErCXY0V154aXdQ9+7PR37EpDu8wJ++dX79hKyppqcsIbtLzoi3PiYkVonoO5DJA3CdjsrXui+66Xg9SCsQ+04w82haghOALECtO1ErnBI8ggHrIzu82GirXC6UEgHR0g/hx5kW/Ku2PkzNP9h6qa862URpMIKaImxIupcxFZKtxVwQ2/d9zbKI94G/H3fPoZ5653YV1PPFh57hHfjy9fVpo6nLqDiG4QzchdhqfP5sSHNu93ouVC/Y97xvLWAZ5eEbKCLSVc2S7GINiUiFsnGQFUlMmpHxgDoQnw1tP8IC7+D1qXQ64KqQCJtRwRiZQVcBOhm0M6YajW2X5Me+e5trPnwvvoZtPj+m+7Jvhaddo84Ntz2qiP9655YHU2g5kMoc/kibMdzR20CgaGyGhq3gZG7QHQ6iAboBIhZiiwRrUzAUvFKRFSFYhbL6Nxrg/AMoUFAtg3af4bZn8HCeRB3IK1AJnPxEkdCU+kCnZi46XNdd8OPt+m1rwQu2Pc+invjLdmXMpf4dz/Nv/ItR4zsOoNRAVV/adxWnFEbyqVRW52EsdtC455QOQ0IQfUAt9vJvCBKkAXd0UmJjKXvgMX3xQJqir+PCEEGkO2C1l9g5odWxCQXMcHgjGK3GzZTtrdWXHeVOub1wOf3KQH/+MabsS9kQTa8NWrri44KNr5ivL7QoBbYjif6Y9fpfBr8LoQ1GLslrLg/VM8AIlBdK57nHJfI/x63QgzR/YoEHHb8MqR4yllSdMn3tVX4IKNcRDOWmfq+qZflIzkL7ftgX0BL19BOabdCdVl87Ps2eke+HpjfJwT87lvux96Op+O1h2fXv+mE6JonhqMZ1GzXc+nL58UQZDB6Cqx8iKm3AlkH1QGtADHkmLUIMcT31bj3w49dSjqhAl3wbNiuKQKQYX6uOP1jmPoRtLfZbiiXOmHsSNjJSBfgmt5hP97K2hcBl+91AX+7t0ew1iduYPNHjqpsvp3XEFD1bNeTEJKLF/W7XgeqK2Hinob7QbAuH7U6BVG8ybrjtFzEYgHLj2J0wTjWwwmoVbGUrmiFVTvviItEgAft82Hn12HmrxBnkEX23bAvoK3tDFoZW1oTF18qTnka8Gf2YvyUYC+6xy1O5uKPr69Pn8KID1UJkTt2MfSXjBTGzoLVj4T62YCGbHZJFA0Ir2Sk6nIpta3gdsYhx68ok61wxJbgClf43MprH7cACfVTITocaj+DHd/MuyEVkAJwBgMeSMF6OXWKbF749Us49XnAt/aagALN3kiivbufzgUfWzcycxhGPirS4IgXkVe/A2ENVt0fJh8E4SrI2oD6b8m0I5koEm3wenBk4wpZLqBwxNNFC0iZRLp0G87Tl6xMSE2eDLIYZAiT94fK0bD9yzD7b7tJ+wN/VdIQslbMbAib//nURdnJY8Cn984W/Pqb7Xn5RPDg07nww6tG51YxElnxLGEfDV4XRg6DNY+EsduAFKB7JaNSFIAjpCwfy+Uj2FIaV4wSYUrkyylZSsqe90sVkhnY+W3Dj6DXgTSCGHDHcTc/uJ5diDqXZCe+HHg/ezi+T8yeTFfWH3KGOu+jk43mBCPhkniRO3Iz8BIYPxvWPgaqx4HuglIDRynF14VLiBbOx2x9+ZStOFWUVEthtxMF47PsYHpg6dBDHNGUCehWFYNXzb9ww/Ww7avQ2g5hxfmC1HklYJxu9dT5S991sTrJA96zh0fwnkuT+oPOWpRvxMhXjyBiiZCls71Aw+SdYPXDIZgENQ9Su2O1vANasYrFZEBGA+WAHuZAukAGyseuLv628uWk6Ntwn+VyqRZoD8ZvD/4kbPkcLFwFgSOh1gYMIQ3d809ZuOTtF6mTFfC+PSagZs9kQYzd/Sz1749Mji7KF0IFR0BhO18MYQCr7wWT9wMvBD23JIkukE5QsP1SfLBc1B11cQd0t+qSbbhEPEq6W/HSUT5yKRZRl0mZ5t2wfiIc8kzY+nmYPQ+IQAuDdH6egAaxf8r8ZW87X522sKfeCcXvXndTdneaOrrFGeKir28YnT2Euj1grgKRNNjqxxBVYO0DYeJuIDXoBDzbpUTRYqELjlKKZMOtQ0CB5P1NW5Su9cMfSquSLlcsasFSUiyp+39RtLbNvgrxFGz9Ikz/DeIAEtl/FzRoA9BK2DVfnT9Pnv0k4Jvs5vixDNmtkcEJpyUXfGJDbeYQqqEzcoXdcu3hcliFtQ+GFXcAHTtne0VndBSLoge2XaEAhhXNEVYPHNG4Gy+lGf6juOE/okMPjllVuG0Xi2lRC+CPwtpHgwhg5x9BBwZvSVQAFTCZtRuntC784MXe6TuA3+9WARGC3ZVpNbryzPTCj66vTJ1MLXDEszWQduzWYO1DYOxWoLtAClpaF0SOKJJlUERlq73WBT9GlEmYFV1bKHkfdOURxYKVSVl+QF2yPQuKpbZl8JlKQFZg9UMgA6b/aJ/bcaw0RAYVsE7NrUlbF378Iu/M++3OT0z8RHnsjly0Qwa3W3HVO4+sbrydV/MgHHjfC+wBc1SB1feHxs1BdUAqEM4ZncYgCwRUwx2/4KJdKQvf94p/vHaf/T90QFG8xbpLSCkM2UEteuAAXCvnu7ZARvnfuU7ycawC+4VOTgbUfNZns8cvdK/54GXRmQ8GZneLgB2/we7IzSZueN7J/tWPD2oSItnvejkB4GcQ+DB5Dxi7Geg2iGzwvW1JRl18tmdTIqAEir9fHlkgZdHP7UYWyEb5Bvw/rJ0FkONIErW/rJLMjcO8s3hMC8d8PzMzM1PQz8zMFPAzMzPTwcIxLg9jc9uWqvLvWJdDGRVte2Z2KkLhsVRyy9bTy3wvUxoLtnnGMyy2X/K/owuAm4f2uAuuBcd+PIQh3HkRypa5k09BBR89j9VvfmFvPPj9r7We/DVA5OGrYOFhj2Xd+mHv9t//7YN+hE7ZCI2WS+BT8BHWPwerHwNSB4skthEsiGYDSO16NwOYbkGnSzxkLjMqIbqoGcHMY2H4nS9MyOcvALHOVuFi9hdNhLwHRReO/RiodmDz+1C2UxiWyWtwtPvKU9vf+xVbo/5LwF996ABcH13mYY6N4tjZx+qv/7Ejvd0lOiWUOfMBvoaV52D100DdCA4FxGUnPX8/S4gYwaFmP9F8/uIc0C7z6r6LQThH6bIg1yMTH3Fxx00Oyln5qKb3sYZyFY79aKj+PuxchaIFBQmEQPQshUqe3Pru7/uiPP0C8PxDBeBdHfCwRmgt+8fG3/69Z1s33yOdIgcfeMCNYfAUHPkCOA86NCc7O4FRwMU5/XuY13tVxvOAOA/o7gE7oVmUzxlgkO0b53RWM59FVZO4yP+GNasVYgXt03Dsh0P1j0B3oFWCTgEIhJKT463j7xp9/499u/2hH/cwewkLaS/xsMbR6vrPfFRe+bntrq3p2ueupLb59c+D76W8z4Q8kZQwZ/4bkq+bVzqbL1Y0veaWiywE4SIWXAwwu03nK93FoVoO2ye9WOETDS6zecQExB3oPwZHPgXX/z3ECIWDEKEFBCi6jnP1lc/cGa//BuB3PzQAnhi/xsMYt8rTFy+G7/3O5V7taBXQzsEXoOzA+qehcwJ0t7FZ8qqEWsCY7dYMlnifzJVvC9nnzvqsHJyLhw2f84G0CLgKLPocMe1ZBtwqRrwp6BzVLUCMsPwBGF6H21+BogUhgbBQaHv6dcWjOy//huf9c/8B+L8PJwS7I7zdsddbk4tb3/otJ4s7j7mOt8AzDwACVj8E/SdA90FiXsHI2SoHRjNXcyXqcsYEdJ7pPH9bnhfq/eaAdswH3UJfMPf7lHmANFWQ2DBhxLb+zxA4FUgJax+G/euwfSmBMFlmtSLtgqPj3ZWLox/83m+0PvjjgN23DcBd9/ZD8LLc+REX9NWf0+4KMs33Sgz7jaF/EZY/CFqBBnCWzRxA817FhGYAmQG0DIA6A1jiAJ0DMhaU73QG285RvmZ7M6IF1GIm1Jhti3PmksBnt0UL2NnMbEVJMYD1j8Do30Lch8JPAQhBKLqOM9WVz1+vjv8C4M+9bQAeq96eCq7rI/2T8upvWmmP2tIuoDTPYCkACVAuwcoz4NpJdLgGbAhoyBtBIQJOss53hxm5lTI7F9RZ+aKZJ/NAmQ8BdO76xc0JLGDGuIA9c9azqxTUhGe7XYBoxYqZg0IM0DsLK++F6ksQaR5dVyrS8vQ7FRd3X/6Nz/tn/w3wytsC4B1Z5+2MR3Yv/+Tj7auf9l2HFObpBN6BS+F3+V0p79tP50gN22EEhvXhADVWihUoTpvXuSLBATrHjLZ51AzRISxgRJ3VI2jD3Twmmw1UWMCUmgFMEnan4sM1YMzBGS1bZovq5JztXYatS+ALKARqoFBcy3NsuHHxZLj0a4Ff/7YAePAhPOjwK5snjrr9X7vE2EurSDYLzavU0D4FgydBa6Bu2oA0gUPNyZcIMYVfZ8KFGqUq5ocO0WArV7YCBPM6q5asc3LEPAWYA2Ai+Vic+zHDt4vZ+zyMkzEX5tWU35q8z6yflTeqmV+D78DKe2D/JoTKRjVcKbQ6cGH3jZ/31fKjf/PteIPFRnmGBx3hlfiL3nnq+odaHcHbvM85EAVfwNKj4DqgY5Ap4BQICWypCO6MRSI2RNNc1ZI+Vxw4yVjG5SAAyQWJXeLiXr85VZD5OeDi0txizzAP2XboIbvEZr3mf8MAELKHaEabCzZLHE3Io38Rxt9JLAgUmu4I9ayNdldPVK//GuDnPzAADz6ABxnfDOcufO7ErV/ccQHXKjLVm2yXzlnonAYdpy+W1XbFAEEzL1AsINN26gTOCBEQAwxRgFnsNaOB9X5MaTXv54kNyQFmx/x6reoC0Oa2izSAAsuIBlA5cLOcMVqxY73CGqSAweOwdwXCDrjpU2UFV0DZhlPVpZ/0YvHhv/ygtkxxzT8YAx4fXf+5K+Wdi67tcAX2WcvNgx8Hj4FrgVZNnqXSgCe3WNSZmqUFhrMnyRCSs6arAaEFUgY4lcwDZHEDQs52i8cCdTsr7NoRM0Brhsdo2uoNAO2FF817tSxnXzNQYlmwhnIZ+hdg9E3wTAGIFBNBslLsD06ES7/sgQF44gFywBvdx089WV/7OWWpSOERPz2wqXIN0DsF7SOgo8xakebqjc5gw0GM0/fZttjsG6sU4gENCYSkoTOaWGMGQLXAnG16W+A9kA84rybMbPAJdh8Lnlzt5ttyJjMpZczIVw/ZPw/bEfDQPQetS1BvNgBMLFi04cTOlR/3te7HP/ggjwourrcvcr+jP7z5k1e5+4RrCc6T/YcuEcr+5KAlyXqXdxcDMYXpmMDkorFfgJjeOwEyxoy1eWJ9MHaOgjNmtfFiJc1PStsm3ff5DBjDxvdsvbAoD2xEmIJGAwYRxALKqtfIYemAUcaJBZUs91MbtrO8UdK6tFIDFL2JNTPcakSmF5xTpHCsFXura/uXft4DAfBgx/tjv/4TS8fD5Z/VacWG/ZyANyWyzgkol5PwADShSg9TmHpISU4MOThwU3XsmnxPsaBrQBMioQ6E0RitRmhdoShSlLiyje/08K0SxAIpzqmI5LlfYPHI92FxOU6VWI0Jw4NlvI+OawCkKCbH3TpYCt/kvTHaFMaGzybHjmLBaFgvY0QsQGfcs9I+AcWbUG1Nz3diQUdZRo6Nrvyk/z5+358GXr0vAH5r/+j9+X7lzc+tc/sZaQniJgs+LU7BtycNB8QUIiWxnTbM5FwTHkSN+NAm/HqT21nGEgCbK07ZVNAYqYcjxjvbDO9ucfvSBpt391AcSystjpxeYnB8nWJplaLbxXk3QzW7mfneHHDOYDvJ7JNIPoiBajii2t5mdHeTu5c32LizT4jK8kqbo2dW6K6tUPSXKLodnBPQQxg42mdb0wzLcqqLu7Z1CnASYOtJrO0eh1ECoFPwgjhFS8fRcvvsOzp7Px74k/cFwHcs73Gv42p5Vlb3vvFT+r7yhv2aRRRa61AMkvI1IsKq4JiAI1gQmYbUaPa1uZnanNCAGKiVejRivLXN9Zev88X/eo2vv7DN7Y2KqLCyVPDUu3p85HMnufCeivbqGuWgh/M+w5NkLCfc39A5II15yEZDpN4fMt7c4NZrN/jSf7vK157f4ubNijooK8ued713wMc/d5yzT51Awyplz1w8CpAZ0dPQqaQlt2EMKG0QsHVkNAvnQOcIFFeg3k/gm7CgFI6Wr1mrrv2k7/af/iv3UyMubrTuXQW3qr2n1uLNL/gOiGfCgPa/tHIFdBKjam2EhkJMQHQA0QBLDfjS0ClrztiOWNaCGKhHY+qdHS595yb/8u+/wYtf3iQE8KUAsL054s03R7z68pAf9zMD7/6IIj5Q9jqIcxnrOas+zbZFbVlxARhj7u9Rj0fU25u89o1r/Mu/+yZff3GbulZ8IYjAzlbg9Tdu8/3v7fFTflbgXc9CLTo5bnsRRmPLWJtGjWImZmDMoq3mZTptXmME34XWGoz2QRz4gKSswJXC2vj2M/1686PAf7pnAB7scO8ArLd/2LLbOUFpQq+jYb9yAEUftDZWC/aHaNSt0JSKHFa5NvtKZiLbaOYasIa6Ig73ufnGBv/mn13mpee36LQdnY7g3PRPK+MxvPKDPf7J375Ed7nkqWc8oXQU7RYQ53h/88Iw9xWS7Qh1jQ53ufbKHf7J33zjgLG3GPQdK8sO5yTpAWVUwWsv7/P3/volfm6n5MkPeYIjHXde+wViMAAUK1xyGybLDQViyDpqDAvioL0GuzfB1eCmihgohJ4ftlfrmz/mvgB4sAP3Mi6Xj5Qnwis/sl1ExHvEgTgTghFoLYN4iDU4m0sZ/89p86OIpveHtdJnjakqRitM/62gShxX7N7Z5X/+26t84yt36feEfkdotcC5hNkoVC0oSs+br+7yn/7FFU6eG7DW7qCFR7xbACY7dH7oXVh6EzTUxPGQvbt7/Od/dYVvf22LtVVPryu0SphmBiEKnRrapefyG3v8q39yiV94useRc57oZZJCaGj6KaOa9xjRltkxuaUTMQIGo7SNIo5JEZd9GG+kipQiXhHvKIrI6vDGD/1O9+njwI17M6KLc9zLaMfhu1fi3WddQeJcswD4FhRLQFYIx4GadnhVAywDPmIClQdnxIltQo2kbU0ZLlQBGe/znZdu8MX/fYvCwfJA6Lag1RK8l3QilXGluEJQdXzrxU2++sVbfObEgFg6vCsNy0oGKLJwvPgZ0Xn1JL9fN9Y1Ug359gs3+Mr/ukW/71haErptaJVCYY67qpSiEATPd7+xxZf+5w1+2E/uIYUHKU24tKXLQ5X2IczHoXXiTA039WVxUC6B2wKZYoHJ4oUltp7oxZ2PAv/8ngB4MJl7mhiGn+q7vTUKh7jGllMEEaDopqpHDcghMn8KxtgwXYxTMJs5hiFN82maY/ZxEBWJFVsbQ778f+6wu12xvubpdaHbFtqlWCah9NNswXH7ds3z//s27//ocY50SzQIIg4kgT/3+4jGq4uZjWPHjAYGCxBVJFTsbY544X/dZrhbc/RoQb8D3Y457sTco6Lx3ocjeP7/3uaZTxzjxCOtyXG7Q8vJBkhme27J5OW4KM17BTSFZDHnpuiBL0GqlDmlYyiEjhv7Qbj72XsG4MHkxeq3+4S/sPO1z5YugvMggBNEDGOUvcRS02ZTZ8Jspn4b0zNTvDb3N42k09xRHNZhjhoRAlfe2OH1H+zR6wjdt5YJAFslFFMARvBOktujDAaOyy/v8Np3Nzl2fgkNihTmpBBAmht4miSe2XaK/QK5ijd2h8aI08i113d47XvbDPpCr8PBInQ6+XGD881xLy85rl8d8vJ3tjj1yDIxOgRTN09hMw0DNpPSmEaEtN2sNw6+BWIMDbp9C3wXlarJ1Z2COLyPLFV3Pvn9/tMrwObiELy4EkIrDs8txbtPSwnYvG8KQF+C6wKhuYoEw2Su+XJOmnqsmJMzBbLazmjLiiGB3yTIIUBd89r3t9nbGrGy5GiX0GnJwQJlKXjXEKdLwAjR0evDnds1r35niw99cozvOYhFo6zzsCYmkXd5iJ4Cd5Z4EVDzz7pGwpjXX95id3PM0sDRbgmt9ozjFk24clR1ZHcnHFxw23x4NKboAFIAOqO7PwHSpj6omRMPsWssANN6C0gkRbyJJ6giTfruYTDeemev3no/8D8Wh+B6i0XDa/VMV3fP4KWx9aRZxLfAFRBrwBlT2TUgxDVspx7A5IZqAOpATMLsGoA2jOpAwaHs743fYkCH0unI5ESWUBYp5LrG2wYhRKUdoNsSygKuvbnL3vaI5a6HkGrL2LQAC0ZrE85XvHZ7xiwSI+NRxZXXdlGNdNolrfLw41Zz3K0A7VJot+DqpX12typWuyVoyMAkgGRNBhh2NG5DqqhkQDP72iU2+/s2SIFKPQ3DyZx2dNjvdsPOc/cEwIOJ9wTAllSOKTgEwxSkVnsBosn1XBOOo9iUyqxXcMGoX0P/aq0YwKrhkPYXZX8vsHFzPDl5JZQFFF7wvskWALyAeigKoSiUooBWCVsbFXu7NctiHwwERAssZ3KgxS5MMt6NkLJFfxDRt/K+jVsjylIoW1AWSukdPoFPTAnc+8l3KrzSKqHdcty9PWJrY8TqibbJl5vfvzGb1fRY2uOI5t/mxiXNSnLZzfFpTvPsaSrUGb3ohLKItKvND78YHndAnF+KGx5j3jjWl9bF4bee9q5pOlDEsKBDXYlITIDy2VMKAEmg8y6rCytEQJy5R1UakOcd0rYeGwQKYTys2dupKUqhcOB9czeAgBXMuKRdfJpXlsJot2K0VzesS3MyG7CFXODOUL0CYBjJzjPvnXJw3G8xWKsQvCcBb5rZ5MedjrmYzGu1oB4FdrbHCRAW9AZcjRDJ3mMAOkO0YA3rQ9r3RVBfAsNDH6vTi5vvKSUcXWTHFKUE5g9/qht3nqAEy+7KlP2KCeg0mE6KqffkTGdKApkXIDTx2wEhgJdmf5d5fdDMt8JAYDyuCXWk9DIBXlpy8kzvp3PSSZeJ0TsOIFPQHHY/cMzxNr82bLfpIXefORiPA6P9msIzuXCc4GTWcZteUDc57mqsjIcBXFIqahnMNqlmnTNWAUfJQJYb1VYNW1ESURR8ibqpAGlEaRToy/6Fs93xOxcC8GxvzLzhYvWuNvuncRbl1jf2htIdaEivU8rHGMuYEpsFFiAk5JCGNtucmg7o/HF9cRphcgaZNWxjL2rVub0HRRyoRYKzYErzZ7Tpz+x0BitylJQmOJC5x223mxAtCl6hygAUAZU8f7UVDgM+wLZuRfNvpZlvQ3J6rzI5eNUI9px4oc24u72x+c5FD7gsDiYxb6z1iydLHZea0C3YXyqFYEBsAoy9clx67wyobFuVgkij1pwzYThaJjTGZ2JTFVodT1E64pDFozns5qO80Oo4kLxTJMz39hRA55nSc5Tw9LiFynwtYX7lzwLUF9Bqe9JJacCTXwRRM0WcN6FmgDOms7FwsrxRUQ3pgJzphWhSGEfNsU71FAtGcTBpkQB5wktEnQeMldTAHYgTHGUPgkwgtExlcqSM7aDZBxqAihx+T0QCcm9QMDhYbm8NQVg0MstLaXcc/eUCRC3zzimnmWPLgSi56TwjPCt0BwWDlRZ7d4aLS8x5b3VU2m3P6noLmIKvto+YM0CyBYAsryMHIna7AZ/dL5ownCKDjY5O0PTvJXbfcbv/WAnMBFkx7p9k1ggaW0d3X3k8V73ahKV0kQREp+o2QvTGjE5gc8aBByCacAxEY1Y7MSFRshNrXqPQ7XnWj5bcupSmzxv57hGWV1sMVorEAGH+TW75RrXr8n3ULAJ2/wCdgbB+vOT6yxYr9/YfsIegLC2VLL113AFibXZuPL/mvpGQ2S056Mz3OmRbci4S8BL7ESb/xqHQeIGGzoswPDt03WXg9kwAHkxg1oiqgzKOTuOnFGsW7E1uEfWCMM39mlpwmmD8QMClbU6bdi2xyaXmP8qUDY09oxAj5aDgyOku+uJdYlxwImm2hzhZjp/r0VkpoA4Qg/EwZT4PqV09949mbAMExfcLTp7v8a3/e5sQIS4AoY2OIcCRUx160+O2EzBAM4LjUEaPzBEdZqq1bKImEMamL1MEQTNygjLunyBWp+YCkDg7BIvK8VKHx6ZGox22cqFERAVVRTTzvpSmGuLMF5IESGcSY8nbsABb/XCmLJZOJH3H6Uf7FG1PXSsxClMg5sN6qXWlOC+cf+cS0vOwVdvc1eBPWDj0PtvzYwTvuPDOZdr9gmoc0I43IDSZh0ndgk7wpgrnnhzgl0vYGlnxNFnyKw3jMNjeQTXrNBchWfu+oWklTkgnBhQAMSlZk687Ha91R3cvAN+YCcCDCcwaQcqzLo7XZj8uRVAUwSpgAG/EBfmTSu0VaUI0QJ6HxcOfEWPZJNZceHLA2rE227f2qKNMGCWmjl0rK2JagjIcRtZOdHnsvcvTlc2FQfa3Fo88SztcmFijelxz/h1LnHykz9XvbjDou3T+Bad5JGoqj8P9yGC15Mn3L4PGZqNplDRiI/utsmcFxkwhHxr3wQJRUw5oPmiyKdtfBVwMhSccZ84oPGH2xnp4DNW2SR1MKBAUmIJPiQhJEVu574x3h/2ylumSL5gn90ICdQK0cw0Tkihh6DhyrsvjH1rji/9qj7pSQgEhSEOmAjotHQelrpVqpLzzI0c5frEHe6PEFKbchjnGex6SvVrQZSbvEHpHe7z3k8e49N1NxiOlVQrBg5hSe9RpyVsJtTLci7z3uVXOPLUEo7HpVsmaDJi+ilmXJ7gZWxpFnUA33x+0zxckS8+YKOEo7thcAEZxzBpOddVpjWIZT5r3mWRXjUiMjZHrSdtMZ0y0bGeZwlZIrBLOflDJOj9GAekrz3zhFN97/i67t3ZptwrqOtkBCYAxMgFerWxvBY6dH/DcjzgFAlTBsIUNwdbHPEzROntZzhEj6UXM51URqpoPff443/5/t7j09bu02oJzAIJ3zYVT1Updw+5OoLfS4iM/7BS+dLCVxAVi8r26ISfI8jprjM9QZ1GzfBJy4GliQo0RzW+OorEhJZHYXAAeTGDWGLvWmiNgsE5uN6gmC2aaQ7gEJDL/STJXXhTc9EebCpEanDPG9PSbRBCXasDTOiTND7494vQTAz75E8/zb//q99jZDshyMclJfRPpxxXsbAYoPJ/9WRc4/ngfbu9CiA1AEqODZQzsE7zM+piBzxi2kt+5RtOUQdq2M6Z/dMDnf/aj/IM/9A227o5w6wUA0Tfp4riG3d3AuBY+89Mv8MgHVmFjNyWEJseLpnWerMkgHnaz+vSY8nzQLmq4JqCExLqxCcGaT1c0nXAXRutzAejCaF58XgVSoE0fmt1OICigjeBVNQsGeJJeY6ZujUpGE1OaUCDWOXZpXQDnGnYcVbA75NkDRtveCfyfv/8yG7fHb3mEZemIKNVY2d+NaMvz2Z/zGO//wgnY3ofxuPk72oCr+TeZRxgta8wOa9F2UOdJdMrdKoWNfR57ZpUf+kuf4D/8pe+91WTQXy5otRwiUFeRvd1AjeOjP+kRPvGTzsFwH4ZjU/6ERkx6yNvvyVksK8FF28Bg7TID1OxBSaoRLAMyTcuicSrAa7Vyp//4TGOr2OxdYNZY3r/UB1CaA07/Tig3V5eL0zzQ0L4DkSwXst0ZBmDQgNA8IcEoxwQ6DwRjZqcrd2eEKws+d8AQK8e6fPlfvM6dN7dgp0KcUHQKjj25yjM/7hxPf/4o7OxNljo7BgAhZ3EzYgY4lwExLTOVsjZLDLC3D4Xw9A8/yeBol//z917j6rfvsLdTpWvOsXp+had/1Hme+WEnKeo92NrPQq9Je8gez4tmIMwe6qkAzrgV2NYuU9834GNqxUyRPsVsYkPjYkgM/SKOSmB8eAiOsxlQNHQBIBNPCJ6pKnKoJuChqCZVjDdfOIKN32Jp35xY53K7KgNoBFzGhNL8jc09nCrP/qhTPPb0UV77+gabN4aICOune1x4zzIrxz1sbE9OYggZQCybyeECV1y2gsPNaZHsgUEz8kFV2NoDhaeeW+Psk6u8/OImN17dJlaR9TP9g5C7xtEzJWzswOZe8iwxLoIAPgNfFhdtRmFZTgFsmmQVhdmG8f/yu+xQg3NplHHCkIujYiYA3XwAtsl/u+wV8tv8bNOKgJJAElPulqvgxGQ6Q0nmNgyaQODto8pSSKsnudGoZn21z/oPOwEUzePG9odwfRv2xxBryEWDzKhcQGYhzaI3zeflKth+r2bUcZIOjAL95S7v++xR+OzJJv7t78O1O5Pjrmp7sZjUIVWd1Hx+niJYS+D/U3YePLLjOBAmZc+8zeECwoVfcL/ifv/lnHPOm3eSWNeYYT9/KLQ9eAt4IVt602p3ucQiKbrvOQQM2vXY5HWFKD6BTRxxKYOrrnLej10z79R5FDZYJc8+Ok8gcR/gkrm4SYfhNERC/CWBki19nUWN3XA9rkE4UMm+Q4CqR3swbu4j1o9PR//9Wc0cWJ6GvPyZPwzOhjbWxyXB6GaH45VbEFoV3/a8Pz0d6xOKHupJpc+ee3G+zXwEmFyVDgAfQPNXouWwxIWE0Dp2ulc1PM1t2CeWVmQAPHa0ug2bQLxCpRB8SFJGwkbINBXoSar8kskxA2pyWEIk2crCfTSw6yHi4cGefstvquw2bJ0Uxo9XyP/LiyyIh8Yr+eMc3++hWt3eAjQT5gzFzQL1KttoxO+IB5wqOcYOq8MJ6fPjsht5OcnDczSOVPBRpzIn8jF3tpCq13r1qSL3SpzV2VRJX0b6WvLaljQ5PGA+GiTVoiTNLTJobF8gsrSV1l8DwWRYv5MONFmboiDNA3DRl2UEIfwbV9LVB8E3z/cJfWm2W3KFwYPqn9HnZnep1KdCl6KqHo8mH8ydmMmqAwiuR52KcauCOi8q+2ZDKl7VJuezBYm4BAsvoh6IegwuId02dakAWKmY69Jy3EiHq8Z34O39twMWJEWwE20HVL7iKxz4vQrdwyIZ/b0APjjvvfYlwMfUfdjdj0e3+fDIvweVL3/3bpOYmMua417jau4C8NR5EAteb4r2M8AgXJdboP4jien5ThhJRyo2z0QDy9sZkbxRLTDGShDiDUcLxldErlB8xmwH/7H/1V9mzXHOdHSNwJSIBR6EsymxYp172ACF+obYDIW4PDLKyyJOSqDF1lHGeKvB11tkBTeNQpZWqM0aGMtNjet9AJ46D3LX108LWPIdegLo1Dc4PUIgLnl4sjLRjyUgE+BI3GD8++SOnb7BcyJXfbHX3y8NxM75o3Jk3Cp7bod4zCOA7atkhbeNYarPB9ip2Tx5TaZYQXmliFzwIw2LCcOEcYbjysO58uhxqnrJhiVdqHmU3R+hXD6by4v9hNRT5y7+bm7XD14KjsgGnkJKZC51f81ILSFtBSmzgZmIhpi8h50me5oJzIHk1MGyv4yWdPvMlgQifGUpq08YFBsAdxFvppC1k4Wvo1Qtr3XY4CpsuMpuT9idEJFFG9ciRQ04Lt0tYCgqvGA7wYdrZ1A10Eqd9V6hKlgoCeYzFdzHXNYP3vr0D7ULwFPnLgD/fvP6/76eI0q1CS3YflTFoQp1VaykpB8Fu08NjjLDG4DUgF0nKBd7J0ih0mpVMyeUXuLHSwGIC2OzYD1nuLHjIzRmP3pVGMHHv4foepccgf01zdRw1TfAfHgI5eKItqRvAoPQKcrYBXWo6XBuMCKh8qwHcLnxoFCDtipi5ov/Hdccyn0GfO+1/OD+syWuq2yjfOeSGgizmAna7NcTSqZVu5BI7mkdECwuNIo/cjPhQlADuD0pT5Ss2adY1lJUsFTLpmbLxBHHuThKG1MA38DBF/ecWXd1mwdjcZ5YGQg+7gFpMgDlgy37nP1UuqE+Zo+pUH+++Kawegk64ENRinhYXvvXIQBPA3Y7c7n+d3027lRxTcGhXjKk5PLMDJnIzuPbwFQA2uhzMkZibMd7kzdFvjUSWdWD46h4d311/cTYjuqwlORylWtL3OFrGdAmMBf7W3AtgOnBeoz6GBg5LwJbnmjKbbIQa8bQxSnTrzgbfEg6kIycn67VS1ZUPMQaI+rfhwAcUbudn1+//efKqw+rbr9cpFqK3koQTm/PrBnKjHxUagNs6FscCaqkbeZ2n4XvgudWY4ZLcF7ASDbAxQNsSHswiT2vqH+QDTMcrOYfFMDgDBrG3EwobTDyo5jNgkQQa5szGp9VgiqGEddIkib8gNVqmEUVZOVkFKp86s9lVozjjekVY793Wf9xP177Z81PvizZej/VNYay5XYiKgKfkWYka0Unl+ECM9JOYsiOCvgMOle5BNhAX5/LNw7xoeN8fCO9gz3NRLDkBDkQyUK8TveJRTi05xNMiiCygIFPaAOwSvSF29TbeQuNiBkSzILa0q90BtoEWfdQ8TzXD+5ee/8PhwA8DdjvvP3o45kv/qaKb0hEt6IqY/SDMihQegbpO+mX89I8sNzSt8cnUGCfju+CLeF87nOBNQMgLUYlPA/RmKtMMIAljdEslssOAJqql581AUqXyomDbHupIr4MfGXgExkUh7P2QB+Yr+8zfJPAPUAIm4/tqoj78fo/Yr366yEAYz1wRK9Xt/fXb/22PmFFBj/oimmCUIOt2U2akY8MmPDDLczOaKC5XSIa22S4PsB2BG7au+cgZHANzGa18xLKfffVXeN5p7XKAb4XdsPDxKr2S48n2wV9fACfx3aHsWlZaHAaQOFgjk3eCo7fBl6z6fabV+kl/mmqzfW1vyx3n354CMDTgKP+mFdv/nwqo6pCWqIKuylrA+boiaknloGZRJ4Ht/boSln8kUtYctMYjUxIx/bcUrMkLrMmbEzMkOmSAiEA5Mla1gflN9La4YW+jTXl6ppgBRgv9YeLCGM+iBFf9QXwMZlVuUU3iih6PPr6bIEhemKcBUOl7msGvHrrl6999q+7QwCeBhwC8O76nV/PcTU175aasAGBeo+QKBsMWSGNyNS2YWlkM2IX8BMzXuRvUbetnZYlQ9dIWlTD3DoAExXTzl4PGVg9eQJt/6U96cGFBkHu4IzFQCfPb2J0yJiyAL4E8XpEqvBZAvM94Lwwv2qmEyr3CuyXT1ggIU3FVMYJgD97tjbMadDhgNObH352Wsv//tq8++oZ2VW57WEt9Tn8gqWoVIysyCzLLXsEToOwb8QYFBlwr4QLEPj8ABq6X3I5czcA6W/QHHQse+rU5RSu9HR8AxTHsY+pXg4+zkv+t0xg5bDlsjhXKmT377kw6XZfL4iNMxh783mCYSRsM9mIEuDTtq99KuZ47TauXnsegKdBz4Xg/3S/vPVL3X/4VbBfA40O6WQuAQPXO6p3skAlAKIGA21wRhcU8jqCj8BDGC7DDPkNXA1aA4pwFIHjADDwiWN4bgzqrhUuo77EYg7uuOf6F1gBekx6UX+CTg7SiijscFMgk6gipVArXwZHesltBcwld2tnRdzkG3/84ydXzwPwNOiZIfe3b7149/vz9i/fHFNRs0tf9IeNmVFLRE5FjsZBbnHjjNmAG/1UzZc5fsqKVFd2ymZCIi+TeuHxzUJ1/3RICl1gqQRrKrLbxTzDSBY8Qns/XaooRviZ+7mB4rXEYSlmBlJRHKnnajagtF3LBnMuI5ar9XQs/f47C7nR1xpB8GEPMD5ftTFfh+RoHhZtwS6rM0tRTaZ3V+/8uMb6z2cBWGONeA6C61vffog1lvkQVQNIzycQ1hlwfSy5rRTdkUIFhNzKqylm5CMg8Sb1sbDecagU97f3cf/pTXz8n8/jfx/cxc3dw1awPtXkN5oANzWckaZHRAg0mLhiJvImXqU8R9o4/mv+z3EuNtHf86ASjYEQrzr3IiMz4vq1/7d3FkBy5Ei//6eqGobJzLfg5XvMzMzMzMzMzMzMzMzMzG9vDw1r9vA0lZRv1kp99Y+M65hxO+76extWhEJV6qq2x/5NpjKVyqyxebaPlY0ldBZ7uUCP+kCFBBZn7G7xUlFTNkqKirVX6FqLCrZUKK1/eBIFcXn1P7yCB/FEAF8JD3BSG/TO/adJtXi/G/cufIWuj3n9p8oQlmWFZikIzTsi5QQbKkvlFpyPLNF1ZXq9lRipSYiDCT7zwT7+0b/cwe0HDcYxQcDVIigVB8rIyzkXr8CmgZwOLgZaW0SgU/LA8Ls+isxD54Upz5ftTqaZ/3Rozvj/3huL+JbfNODMxQqh14EIH0IvEBN8SQlIgw8Mp9LuhjM0bMyd1HJKiNIfjTtL/wGnaPXxgzippU7/s+Pu+n9ZHO59O0uSk+FLkvf2qwxdqKQ9451o+9Gy4YvbHrKzvmYhU8lXtoLNen7ydIy/+U938R//5yCXsqrbLPhiVE1r+jySTPGlbXL6h+SEyutFaMWkGE0Sbj/ax+pGD996awF1pza/qz+EnkGzt4miBgq7JotXGToDMUUt4Nn6r1i+Cm2AUb3ywbi39l9OB2BvDSe22Eyaha1/Go9uf7sQDbykiM/gy+tANQgliKWCUbNyrbD1MwgTZ5EHULutrdhat9qe9QhB8Lm7I3xwa4SVpVwNqVMLajKgT8WPysmaE19mAPX5IBWXsi3ZgblJrLB3EPE/3x/g63+dhIVlsJ8PAPvQCL5U/t2b1u8Hjn5SJAs+yLDba7Te08aSi8W8PTdc2PxXK7ufe3IqAI8fxGnabvfcP1sK/f26GaykWpCiuN8EMddfBk+S2M+vSLDPNAK2byzsxYfa7lUFJC5OY/6+Kp+0FFErx9UWdakqAnCGpoo5tpn/7lQsSjFpgMkEaCaCSQSSWN2HRoyiSGOCSpGErdWrigIkh1Wxi4WMzwQ1oyPGYgFnABt0UlzY+Mc4ZauPH8Zp2hf2Ov9tvd74z4vN4JvkP6xdNqSqBS8kaUV2EEj5AVCQ4zCsBkiaM26rQBEg4gvZ5MIY5y4sYXW5QjNu0OsI+j2xojR0mG3G/8h5Npn171iyvDaCypYtVVCc2epgZd0qimukXqzcooHoM7Z6U2L4CngchELqOM8VIwRRcRSWP3frqPuvTg3g8cM4TVuum+Gkc/ZvN9v3vkkVE2IKCLHV/xIlJ7gvrhjlOjOtOC+BqxoShJy07WGiKl+mkilLno2v3NzAK68s4//+r6coajlUyD3MBh+/NNems0tutU2gpklYWanwNb/WeSxuLmaVoY0vUkMwJgA+yjlRaJVJtohiWOau5f+8zJkREhO0AYZLZ//xDdy/e2oAjx/GadtR7+rfHVdLP2ehOdjUOovg0ACxUkhMSCFAqgRJASEJkqidjSZXR1I7GhzbsPryDxUypBJqQNCaW5MJ1s8u4Vt/19cxip/C/S/sABpzVckABG/1vghnMn/g9JSJ1qPmpAnjRtBf7OLrfJPrx4UXrwBpXDIpmKRrA4Vpj5fEXANNxeplJlsQE637cs82QGzyHJqEsXabyeK5v47naPXxCzhti92l/zXon/mn/cOD756tIUE0J3SqBJw5LcUWPgm0cxIA0eK4TlkNS0UuiDoDWZI2hAZocibUN9/bxOrFr4X/8m8/xM6jQ9TdgLoSiIEOFSRNreVtLcUE9ZAldcm/7Qnh+2LR02cQuzfrG+rSFXt/czbC4BOfF9eRxVEW570ISrn+bLy5vDShlMmFoIlA00RUdY1X3j6LT35yC93JENg5ovWdGnyR4aMxtjtboDWfQVi6abqy7nzW9dl9HnUCDHub/23YW/+XzwXg8Qs4ddMUhwvn/nxzdOe7dZsoWqkZI7wWbK1hSSWRlTmLVZ512+bN7hfOfpCKe7CGSDKSbc1yNARkH5fOreHS93wTkxiA2mrplv8UESshUJzJQj41CufKknaKuMwg0W1532786W8fZOpIp++QE4qpl5yC4YudNTELQKQNWtCYsvtLFRUaYO8A2N3PFkmKBVoCrrGkTO0cB5gmju2LcNts2kJIS6/McLaUh0sX/tLK4Z2d5wLw+AU8TztavvwPhntb/73TPPgq6JS/kCDGhBDzbkQMxSgxCMVngihBjdnQEGmAVFM4VsPnXPN1jMDhYU4o2V9Ap9vNz3NeacnS0GCxz0oniMSXTXIweO80R8Cw1FNxB9xl6i6H2wlxz/H5EAaSk2IKPdvmVqxUgGYCDIc5Z3ScUNo5E13kZjGVYPMGlkHIxkVRuX69FyNorlW/g2r1/n73zF/Gc7b6+CU8VxuPnh4uXvwzCzsPv0odEzRU+bfwGYQAguZsukFRVKOgwAEg27pIodTtMx+htLslQIGwAjgAtLED6GNT2xIcaCBQGBjx1yRg/N6zuvAs11jHeinGMPpC3HC5+DyADLAydM4xDw6v5wXbhLO3suSjUcHXSTmQVKAePnYyxyLxUna9NB+NWTKnBjhcvvg3Vg5uv//cAB6/hOdtg+XLf35Urf74erx7LVWa7Ykotq7L7pcQFEkKIwrYmrBIrKABKWmBILtnYnFWdyzbqpMgxSqOTRuMKpV1dyRTWIMlyk+YvFSz7iVcckEKPnLGN50STj8t9q/cu3dUfVo1B6xQRAwbFR4+JfjoOuX7VLilo7XeyCjwlR6TgdjQEnOSMJaFo8HypT+GGVp9/OIsZtznDpev/tn+zu7Prp5JwYDUqAmlbP3GIBBJOUDADJGUBEC7Tywhj5rEqnaZxz4AQG0S0FRHqACtAWHplEgNkh4NgaOMyzsUaxipnKw/lOSDS23+5K0LD6eHjhsBxpKuADYtDw2BBOWD7K5OcGM98tFK62xgMHyJJV+7y9Jk6LLUK8ZHgkbNvQEOly7+7dRb+bczAXj8ImZpg07/D48OvvCDF8f7F1Iw1dvgGWhRBIia/XMWmMCHv6VwkDKwSNm6SwBCMToqXn/xb7gd2i5AIZUvoqhpyhHjT6Qld+DIp0ITH7nsAQOrdP6ek306yg8ZHBxoimlHMpXgsxGl+88ioJMCae5axBZ4i81GsVD7VuppIgs3S79WeDbtEhJNxFh6w8Oly7+vHmzHmQA8fhEztvefLlz7k/2D//UzQ1RosMCEJq/nQhMQc3CBdXOXQNoi6FbAMBX7IFCaomhSqqrMNQNbFyY70FQZrRxNrfZZouhoOoXn03EU2LhsbOJTd9ScUeIzurpGEmvaZxWV1+c8foGXqV6N5u7VdSrzLsCUw1YKfD60Klmev9jeU0WpPOZ1n/VseSOmZ5wfLF76W5Pe2j/FjK0+fhmztrF2f89gcOf7LE52r6ISS7ssKEYIoqkG88cEyeoZiQo2QxCC3ZljWjn9TfmXCUUl0292qkyyCoFA5yKEkpqLEKwGZPJrPfEH0uneqVbOo8wCkmH136FgqUuAsRQUt64j6DJwNM/GRqQ5g9bgSwQflNWuAcfbqlG5m+o1h3Ojpnrz2m8kC4dHq9d/e2dy0MwM4PHLmLV1Knx2b/nG7+1u//df1WnyWlBtIYuQpWFZ/4WUF7Ea4RboBkkwi1jBp2HNQo5tia5QuZQZfLou+LUbwRJMlROIrG79sUcP4bQs/5AphoVdF3Ef3RlfYeBAYMEbFb5YIMHIFm7pWvQkHSGmTkcpynqPJWFMBltMGcimwIgWvpgQJ8DesR3Q2//wn+MFWn38BXiRtrf55u9fHNz7XmuTh18151RURNsbiyHvdogExKKKUQxWycZHSeSK4ppRSIkel2yoWMb+9h++GBlQArgugLBH27lB2FKWck/AeheLl1gEmPAZXPC7Dmw+YM9/F59agyBz1wQehVE1dO+iQ/ioJIp7hYok8TYbxfXF1upt69M5+Ir0O6rW7++u3vzNeMFWH38JXqg16fH26lu/tvNg508tNeNKQ64+rpItpGgh82xNSpkLktVy0rwmNBQhBcn8ijFokdUGUkgGYqAKS/m+NVD8QXiWipw5lRNjCqYfbp+SUm6aocyvpAJrJHCTv3bxepG/jKxauy7vcNFqShpUlpbJGRy5tzF/tr6zrzF3SwOkJmUJSOoXMWIwrrG/eeN3Lh/d+d8vDODxl+BF240bw7/8cHDhL4/3bn2vbsjqLgWlU4cpq2K7N6u4SC/LotFm2QqhFXImJcnPrBDKAJqNES4NRutAzjjACY84yz6rcTZOWCJ68BhcwGepml7ylEckktSsZj2UvOaj+Txn1m0Cg6fkzkkpFfjMl5c4mNXUrprLJRGIySRfVsfFMp4Mj/vCxr9795VHvxt48VYffxFepF1bvisAJtXVa7/i1v/e+oZbkycXbTPdKvYXt0sGU6QFqlShCwitayAAivxMEEBtDzmEDK4aTFKkHhqDJxSjg6Ajdex9dJrIN+jzCbpkSeLT8OLkVqBXf86XIbJ7v/4TnivjFOeyS5EL5QSiCWztanmWDhDlXtZ61idq0g9lzrw7EYdpeXD5evVLRwdx+/UL9+lgyowAXlu6ixdqKQ9vbN36HzuXb/ya/VsHv321GgGhMqtYDcDiI0zg85NCB9Y5bhCpdddArCRYEDJINUModM4kgMr7K/kDhZzWNJe4Hki0UV3kgG/+PLE7g8z3qUCcvGSkZYMygAQWS1CnlpWII4nHR5uTiblE6ZRTHs3fV9Z9ghgjYpnLEs8ATc9ARMw+v8NhDd06+/vuPMTfBYDXz8sLh5RXv/S74kWbFP3aXar/+/3d9Xeqo/23qgo2TZ4P4T1hgFWdCK+9aI7q8nJt2mJpikytz+tcF+LnnXrzUQCJXBvwW1428hzRoJHAadznye9oeDfLCW6Yslyx51yW2sjBBUpJI1URyfKNNh/zXm5+r1GzgPOYdzoyiOOBYryw9R9uvtH82DMbk6NPXrkroDY/AImWpXrQ9Fe6/+3eo9536EyONkLdOp/b1C7SrgOJXxRr2EBRXsFLfoYX1mKSS4FWLTuVlkcUmJhUipHyi/xE6y+CCNFZp/xcovcidSe5PLDlHQGr19yh/DzDaaq1ZIgUTolrsYqtn0/d1lsBtAQXWFBBhm+SyOAoDmcgjSJ2m/XdKzcXfuRkEv73jfV7HOc2fwB5WOkePd4N5z/cezz5zn0Z1ahCCx9YAtpYrgukBBwhSlkNCM7CEKlDyk3o1CJnfSqAciPfH89pGfnP8N/v7/22saufDBfNkhra52roeyIFEBTozKUCoSBS8+dR3d4CH+drST7CxQyNGIvkM/hY+o0b7A96WLqy9UuHo/Anjzsub+4Jwzd/AEszai6s7v7vx5OtpcPt8TfsVQ3gYUJRye5Vzek0aJaCVtwmA0k7AT+jUJtz6TFYxTp117iIGHdynYFyzmDX3TlctEEC3nmcJk7iMciJwKMIba5OVZ50J9gAnstjG91CuxtmgMSmgJjyXJNdNMXoODqqMFq//Kffvrn/8zfXx83rZx9MscLmCiDfZU9vb6X3b+/tbbytB/tv1lX2rQjHBrY4kuCxeYLHCVhKxNMaYOpKXYkIsaQMDQejEpj8jFt/5Xs6X6He+Utg+vMWLMGoJ4aN/YLsJaZEkCbVgPZa0Z5OgwonPyDpx64WZOCsF2lXDA11ki9N8rpv2D/zH996u/kRMYXtc/0ngST7V0IAaVG3WA3G/dXuv3+43f9GYXh0sapbV5ywU7pQyU0CSTchQglCEEOcSAoy3Xa1h1x8HQFZGh2WTyzdCjh+LN0DyTkPndXMryVlM5U8G8LuQ1+plD4TPsPrdzjIuqVrCyxQczar9XLdDBJ2sXn3xpvhhzYN/s+1tUdhyrpP5wbgdAizPl3pHm2nheX/eu9R/9t249FaqKSs1xAYPIj397YYCVff5Mc9kEpxqOJ20ZQAy+AIS7zEko2jlt3er89u5VOs+WfM4PI+uyIVfZIVRYFOWerZaxxMYJYvBEhk7SoKmC1symo3ufWfmqGhUJKKzTBip1nd33p140ePmu4/fPvi3QLfybDNH0BCJEA2Fo/u7NUX33/6RL9tLw4WJRifTugwZlwJy4On9pLypINR4OcIUk+xSTXx6jd59wmZ4N5X51PFsqUbi2FhkCe2jtUfIaHUuQYgGRpcNo1XDRZab24W5KCPlAw8lDWdAQeDr1W7iO12WxxF7I6Wxhuf2PzpmvRPHndcWiej4ys/gDSneYP34tr2B7ty8e7TR+lb93TYDRUAOB+hspECJ3XEpmzaV6J3UKoSwdrCzepMDFZ7P0+Wee+X42SOoHB4zrHnk+UlgpAMpiLFIMLT9qgQ12K+bG3hQ2GXe5F0sJw9qVWzCeWaQ60yeDQW/18cRuwN+li/sf5LRNNvOe74Gq98WGF603kDOB1CrgWvohfXdv7Hjlx4tP0ofqsuRp0iCUF2rzAwkLbYoQ84Zi3JBgtL0ww1wViMk+Arl9sJPXq37VPK7ft6tTRfBnEHoai8FbFNhob4P8LUqtI6z6BtI1la+CKt+WIJLLV0acW6jUUqIsNHTudmFLE/7GH9+vqveu/m9i8/vzXAlY3dyn5rZodtPgDSHFnGl9Z3//OOnN/efpy++UcQhlAesTPD8OeApqSxcifTkolQZw3nYVoRapFWglJsnxgY3Pzaj614MDi+6CGrfQLNLHm7ZknNOfgyYDDJxkBy6ozEuxsJZHSkLA3J4UxrPTM4DL6hwXd19de9e3P3FwFIHR1nyTcdPp0XgDNIQYJwY+8/PJOEj9M36+qoG4KPNFFIq1uJQwNM/B/hqmRyU0NGxVhQr4oZIn6NmngJC9Fp5RmU/woeTjatDEjxlm0xKMjwINOJLFwklzyI0mdoTC2IDUqmU1vnpRwmRwbH3rCPjWtrv+rdm3sfwRcZPt/mLwFnh1AgOfDqeFH7n3aqC3efPpZvXMXBYqj41JdT4E59tVKEBaKyhOG1FTeapz+rXeA7QHhkryUfFhLrbOgYaMrPkDTmTATF8jWJZtLaxRqUPds8Kvv4CnAU4+cPE5GlS/F9eDZOBmZw3Fj/hZDwyx9uL+ix2q0BnGTx6vwBnF0SVgj6kTr+b4e98/93e1u+nowG63WlUAS2gFmu0B6xi6qy7mtqJAqMUTDAQtqbHL3Q9trDx8s9rpXs5/wvABjwlnlKucvvUCeXCts3BpvGIunydXGxoBwep8ND6tRthi9hfJSwPVnb2Xpl/WdAwm+DBHyNT3xYsxj3sPH9/78AUtqB8yu77/fWFv7d/e2lr9kcDi50AuU+zqrY7mitxsAltPdg6QJ6T8i9wXMkAcG7a6TwWR2WB6Y3CsFyYJZ7c4Kzt8YDnFjSKUk8H8lCvj52NquNJV0aGxol4GB4oDisNj5/7vW1nxAq+ZPHHV/92m2GT2eHb/4AnmiUGAQBAqz2h7cXNpb+0f39zaujveFbdWggwavkAh2bv5QinCBTl49Fy1Nf9FrLe04zuy1fw9mF6bkuSAp6Tvh73LVBxal2C1RFYrv0aFrcK7Zzksjq1TZyOY/OsRxN5TbjiP2DCuPFs//2rXfxw5e6439089y9cGFlr+J4ty8XfAzg/CAEwkcRNOvnqr9zGJer7af42lUzqkJQqK/kSIAJg2P3xKsDqdwUUL3nRAts9Lk4tTkNPiFY3fPU+WxGSt6JDOtKxWDoPtHh8AJfvrf5kq0AHNViPSevHA8S9gddVGfO/7G334kfSb7/c3HlcQWVMM3S9fB9HACkeQ72Q7UQhoPLZw7/4X73wue2d6qvGofDjToo4AwOhsYVfHEGBavkQo4HErl5iBgcL8EYYPMhTq2EQND52noFNBQgfRq0rxgLZJyNFNZTUbvQhg8SZRDjJKvcwaFiJ64/OfOJtV/8Vd/c/UW9zuTpemenQ8sSnVfmYtE/SnfzkIIc/hxyJObd3TOf/D/vd3+Zbj/5riv9Ebr9gFDLs15VAgnI10FyqbkqQILNi5TrPEqeQ+AI7XJNtm2gKB2ah5RbjrA6IcW+wFnt6sMLnWGiUD9H4KbkanVEzWBb6Lw/RBTtfjJK2B92gOX1f3X9tfoXA/jHAPDa1v0OlWRyp5/nJgHnLQkhUKkgkNXe0f3N89XfHMj69tOd6r00Gq1UIUHgjAeSWDZRpJI/kObPT7A0NAC4KhHyWMAQJwXJOld4lcvSkEECWbaUl8+dz9UyRpBfT22O1bE9MyEDo0EexwlHh/osoGDtytpvffPN5qf1u/F/Xl19VG0uHNYF+1M2nY8EnAOEHEkDYAIAn92+8LVufR4/e/J053suVkP0FoGqqhAqS1Je5zHfi501hklBMYmIPI88sgTMk3YfplRPKpKR7zndKUWqlKZ8wYZPuU/K0pDUtlPV2fxtYSzQuuOTObLZ1nqjHqq19X9y9RPh1wL4+wBw8+z9jv1FfCh4mhd8DOB8IeTPOEAv5Iw7R2mp+8Gdte9/79bkJ1eDna+23J2g2xeEOlC2/DxKJc/mpHLq2K5ZBaPMw0AUcfBxvKINUxvH/XF4fCHOSeYvqm5tzkBk4BJLzibfxwYGX0IzTjgcVJh0Vz+7eXnx9756bfAHAWxvdp8GqNQAknexMGAf3zXgDOtCghAsDR8Mtq584Xb3h2/fO/oRncnBtcV+RKcbIJWtDSugKiAGQSiSL+R7k3rl2jAn6VeyM9hzBUCVki7EB8JS8wep4JcK7DAnP5/p7AQFnBWcol/zlS00tOH1o4TDUcAorGwvn1v6k69eH/1eAP8bAC4uP+0a9R46zATfHACcv3FSMBFFAfHe/sYnP3Or/8MOHh193+7k4EK/F9HtmUSsMnBFKhZjJLD0q4KlDzYQWSIqXAYHuz5VeSP11jpBqM66VnetXATaOke4lHJYGbzJOGEwDBjK8v7C1vJfvnpN/wCAfwUAr27dq6Ei7Fg+2dLlufkDOG8Ip7tsglo6BODW9tmv/rk7vR8yfHLw3WR8eHWxM0G3B1R1xQAakE4Vh1b65U6JkGAwwlqQ9poE3HRj2G6dwVTmeP2Xks2V68QGiYGXSuaChMlYMRhXGFfLT/qbS3/zyqX0x66c3f9nANKCHGa/nhHvwZvByfyxB3A6dCdZzCGfWzSJ+M6tu73v/fRh891kePBePwzR6wF1RxCqkAEs60KCL6toUs0k+Th3JeieCZzayPeoPkVMYslXdjYsTbG20CVyQDeThNEIGMYutLf82cWt/t84Bu/PXNrc//cAtC+HAUlqVrezS72PP4CzWMn+vhVV0oJ4/2jr6r2HvW95DOJ3H+4Pv1EnHq31qyZLxSr7EotKrgLYV9hKQSHpR0dHOZsDx81Mt3oZRqVoZhdyZXPJ1eV4FjAwBoaTGpPQH3RX+v927Uz/r109P/g7AD4FABdWnkwDj0ecfP8SQG5yejBLF7BqPmxWFu7vLn61J4/lWz99HL9VczT4ah0dLvRCg24XqOpWMha1zNe+xAiQ4Tzxb6R0qeLXfrwdV2ArqjcHkDb6DLpxrDBCfxIWFv/X+mb1j86djX/3wsbgPwDYBYDlzoFtoQHTwJvB0HgJ4IxqmUYyVqw9Ha1vPtrrfbXdbXzjnW39RpPD0buYjM72whidKqHTsTTUvJsCAELSsdyf7IvxOCC57T9OAl5KrTaNYJy6SHV3t17s/+/VNfnX65vyT7fWm/8M4ENYOz6X2+HI2i8leC8BJLCeH8QCo0lFawdxZfXB7tJrg4P4NR7tdL7W6GD8XjMcvyZNc6bCGJ3QIEguAVvVYPcN5VISTG1icLVVjtoTaw3QxJwgskkVJuhCq85O1e98rrfU/R9n1pr/tLAS/uPZ1cH/BfAU1tZ7ezUSLC3YyWp2dvBeAjg7iCfCSNYztZ3Rytbj/eXrk1Hz1v4BXt856N4Mo8H10ThdTE3aktQsi6ZQISLIcVeFBIX4cykumDUhIGlARG1p5aqDqg5Pu71wXzv92wuL8qnN1fGn6n73/a2VwWeX++NHvCPRw2F2o7CKnR94LwGkJjNCSqOZtsV4oTZIyx2kuPLkaGn9YNi7jGZ8SZvJ1vbh4sbhuLMpKa7iGEokXYBqV1Vr4zuKyBgiQxzDplW9t9CN25sLh9vSqZ5I3b231J/c2Vo82JYqHAAYgtpCOAxQ1FAxjDEdurmC9xJA32QGQIXn2rzQqghWA2JKG6ZlgaJWaA3VigyhBJEkQAORhqWZb/1wIEil3KVgGnAnQCdzdqm8BJCazC4tT4BYCBABOCHMiZa52kiR3Seoz1mhmzN4LwH0+xFy8mczS9PZ2wkSax6S7iWAc4BxBsjkSwAePt5S7iWAs0g/pesvZWPYZjiL8RLAjy+Q85eA8FLw4w8g8CaA/2v3L9sf/bJJwJcNwP8DSHw62l3Q3S8AAAAASUVORK5CYII=", T$ = "data:image/png;base64,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", S$ = "data:image/png;base64,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";
const N$ = {
  components: {
    UnnnicToolTip: q1
  },
  props: {
    modelValue: {
      type: Number
    },
    title: {
      type: String
    },
    titlesMoods: {
      type: Array,
      default() {
        return ["Decepcionado", "Insatisfeito", "Neutro", "Feliz", "Produtivo"];
      }
    }
  },
  data() {
    return {
      moods: [
        {
          image: D$
        },
        {
          image: A$
        },
        {
          image: L$
        },
        {
          image: T$
        },
        {
          image: S$
        }
      ]
    };
  }
}, E$ = { class: "unnnic-mood-rating" }, z$ = { class: "title" }, I$ = ["src", "onClick"];
function B$(e, i, n, a, r, o) {
  const l = j("UnnnicToolTip");
  return f(), p("div", E$, [
    u("div", z$, T(n.title), 1),
    u("div", {
      class: B(["moods", { selected: n.modelValue !== null }])
    }, [
      (f(!0), p(se, null, me(r.moods, (c, h) => (f(), p("div", {
        key: h,
        class: "mood"
      }, [
        Z(l, {
          side: "bottom",
          text: n.titlesMoods[h],
          enabled: ""
        }, {
          default: Ee(() => [
            u("img", {
              src: c.image,
              class: B({
                active: n.modelValue && h === n.modelValue - 1
              }),
              onClick: (y) => n.modelValue && h === n.modelValue - 1 ? e.$emit("update:model-value", null) : e.$emit("update:model-value", h + 1)
            }, null, 10, I$)
          ]),
          _: 2
        }, 1032, ["text"])
      ]))), 128))
    ], 2)
  ]);
}
const O$ = /* @__PURE__ */ k(N$, [["render", B$], ["__scopeId", "data-v-c3860fb6"]]);
const H$ = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    modelValue: {
      type: Number
    },
    showValue: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    starScheme(e) {
      return e <= this.modelValue ? "feedback-yellow" : "neutral-clean";
    }
  }
}, j$ = { class: "unnnic-star-rating" }, V$ = {
  key: 0,
  class: "rating-title"
}, F$ = { class: "highlight" };
function P$(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", j$, [
    (f(), p(se, null, me(5, (c) => Z(l, {
      key: c,
      scheme: o.starScheme(c),
      icon: "rating-star-1",
      size: "ant"
    }, null, 8, ["scheme"])), 64)),
    n.showValue ? (f(), p("div", V$, [
      u("span", F$, T(n.modelValue.toFixed(1)), 1),
      p1(" /5.0 ")
    ])) : N("", !0)
  ]);
}
const U$ = /* @__PURE__ */ k(H$, [["render", P$], ["__scopeId", "data-v-05a2aeeb"]]);
const R$ = {
  components: {
    UnnnicIcon: ce,
    UnnnicToolTip: q1
  },
  props: {
    isRecording: {
      type: Boolean,
      default: !1
    },
    time: {
      type: String,
      default: ""
    }
  },
  emits: ["save"],
  methods: {
    save() {
      this.$emit("save");
    }
  }
}, Y$ = { class: "audio-handler" }, Z$ = { class: "audio-handler__time" };
function W$(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip");
  return f(), p("div", Y$, [
    u("div", null, [
      u("span", Z$, T(n.time), 1),
      Z(l, {
        icon: "indicator",
        size: "sm",
        class: B([{ "is-recording": n.isRecording }]),
        scheme: n.isRecording ? null : "neutral-clean"
      }, null, 8, ["class", "scheme"])
    ]),
    Z(c, {
      enabled: "",
      text: "Salvar",
      side: "top"
    }, {
      default: Ee(() => [
        u("span", {
          class: "unnnic--clickable",
          onClick: i[0] || (i[0] = (...h) => o.save && o.save(...h)),
          onKeypress: i[1] || (i[1] = d2((...h) => o.save && o.save(...h), ["enter"]))
        }, [
          Z(l, {
            icon: "check-circle-1-1",
            scheme: "feedback-green"
          })
        ], 32)
      ]),
      _: 1
    })
  ]);
}
const Q$ = /* @__PURE__ */ k(R$, [["render", W$], ["__scopeId", "data-v-72a94191"]]);
const q$ = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    time: {
      type: String,
      default: ""
    },
    duration: {
      type: String,
      default: ""
    },
    reqStatus: {
      type: String,
      default: "default",
      validate(e) {
        return ["default", "sending", "failed"].includes(e);
      }
    },
    isPlaying: {
      type: Boolean,
      default: !1
    },
    progressBarPercentualValue: {
      type: Number,
      default: 0
    },
    bars: {
      type: Array
    }
  },
  emits: ["play", "pause", "progress-bar-update", "failed-click"],
  data() {
    return {
      progress: 0
    };
  },
  computed: {
    showProgressBar() {
      return !this.bars || this.bars.length === 0;
    },
    playbackIcon() {
      const e = {
        sending: "loading-circle-1",
        failed: "upload-bottom-1"
      };
      return this.reqStatus in e ? e[this.reqStatus] : this.isPlaying ? "controls-pause-1" : "controls-play-1";
    },
    progressBarStyle() {
      return {
        "--progressBarPercentualValue": `${this.progress}%`
      };
    }
  },
  watch: {
    progressBarPercentualValue(e) {
      this.progress = e;
    }
  },
  methods: {
    click() {
      this.reqStatus === "failed" ? this.$emit("failed-click") : this.reqStatus !== "sending" && this.togglePlayback();
    },
    togglePlayback() {
      this[this.isPlaying ? "pause" : "play"]();
    },
    play() {
      this.$emit("play");
    },
    pause() {
      this.$emit("pause");
    },
    emitProgressBarUpdate(e) {
      this.$emit("progress-bar-update", e);
    },
    isBarActive(e) {
      return this.progressBarPercentualValue / 100 * 22 > e;
    }
  }
}, G$ = { class: "audio-player" }, X$ = ["max"], J$ = {
  key: 1,
  class: "audio-player__progress-bar-bars"
}, K$ = { class: "audio-player__time" };
function $$(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", G$, [
    u("span", {
      class: B(["unnnic--clickable", { inactive: n.reqStatus === "sending" }]),
      onClick: i[0] || (i[0] = (...c) => o.click && o.click(...c)),
      onKeypress: i[1] || (i[1] = d2((...c) => o.click && o.click(...c), ["enter"]))
    }, [
      Z(l, {
        icon: o.playbackIcon,
        scheme: "neutral-darkest"
      }, null, 8, ["icon"])
    ], 34),
    o.showProgressBar ? S1((f(), p("input", {
      key: 0,
      "onUpdate:modelValue": i[2] || (i[2] = (c) => r.progress = c),
      class: B(["audio-player__progress-bar unnnic--clickable", { inactive: n.reqStatus !== "default" }]),
      type: "range",
      min: "0",
      max: n.duration,
      step: "0.001",
      style: Ze(o.progressBarStyle),
      onInput: i[3] || (i[3] = (...c) => o.emitProgressBarUpdate && o.emitProgressBarUpdate(...c))
    }, null, 46, X$)), [
      [jl, r.progress]
    ]) : (f(), p("div", J$, [
      (f(!0), p(se, null, me(n.bars, (c, h) => (f(), p("div", {
        key: h,
        style: Ze({ height: `${c * 100}%` }),
        class: B(["bar", { active: o.isBarActive(h) }])
      }, null, 6))), 128))
    ])),
    u("span", K$, T(n.time), 1)
  ]);
}
const eee = /* @__PURE__ */ k(q$, [["render", $$], ["__scopeId", "data-v-29fa1a08"]]);
const nee = (e) => {
  const i = e.getChannelData(0), n = 22, a = Math.floor(i.length / n), r = [];
  for (let o = 0; o < n; o += 1) {
    const l = a * o;
    let c = 0;
    for (let h = 0; h < a; h += 1)
      c += Math.abs(i[l + h]);
    r.push(c / a);
  }
  return r;
}, iee = (e) => {
  const i = Math.pow(Math.max(...e), -1);
  return e.map((n) => n * i);
}, tee = {
  name: "AudioRecorder",
  components: {
    AudioHandler: Q$,
    AudioPlayer: eee,
    UnnnicIcon: ce,
    UnnnicToolTip: q1
  },
  props: {
    modelValue: {
      type: HTMLAudioElement
    },
    src: {
      type: String
    },
    canDiscard: {
      type: Boolean,
      default: !0
    },
    reqStatus: {
      type: String,
      default: "default",
      validate(e) {
        return ["default", "sending", "failed"].includes(e);
      }
    },
    playbackAudioBars: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:model-value", "status", "failed-click"],
  data: () => ({
    /**
     * @type MediaRecorder
     */
    recorder: null,
    /**
     * @type HTMLAudioElement
     */
    audio: null,
    /**
     * @type MediaStream
     */
    stream: null,
    audioChunks: [],
    duration: 0,
    currentTime: 0,
    mockMilliseconds: 0,
    intervalMockMilliseconds: null,
    /**
     * @type {('idle'|'recording'|'recorded'|'playing'|'paused')}
     */
    status: "idle",
    bars: []
  }),
  computed: {
    isIdle() {
      return this.status === "idle";
    },
    isPlaying() {
      return this.status === "playing";
    },
    isRecording() {
      return this.status === "recording";
    },
    isRecorded() {
      return this.status === "recorded";
    },
    playedPercentual() {
      return this.currentTime * 100 / this.duration;
    }
  },
  watch: {
    src: {
      immediate: !0,
      async handler() {
        this.src && (this.audio = new Audio(), this.audio.src = this.src, this.duration = await this.getBlobDuration(this.src), this.addAudioEventListeners());
      }
    },
    status(e) {
      this.$emit("status", e);
    }
  },
  methods: {
    getBlobDuration(e) {
      const i = document.createElement("audio"), n = new Promise((a, r) => {
        i.addEventListener("loadedmetadata", () => {
          i.duration === 1 / 0 ? (i.currentTime = Number.MAX_SAFE_INTEGER, i.ontimeupdate = () => {
            i.ontimeupdate = null, a(i.duration), i.currentTime = 0;
          }) : a(i.duration);
        }), i.onerror = (o) => r(o.target.error);
      });
      return i.src = typeof e == "string" || e instanceof String ? e : window.URL.createObjectURL(e), n;
    },
    // entry point; accessed by external components
    async record() {
      this.hasInUseRecordDevice() || (this.discard(), await this.getAudioRecordDevice(), this.setupRecorderAndAudio(), this.addListeners(), this.startRecord());
    },
    hasInUseRecordDevice() {
      return !!this.recorder;
    },
    async getAudioRecordDevice() {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: !0 }), this.recorder = new MediaRecorder(this.stream);
    },
    async setupRecorderAndAudio() {
      this.audio = new Audio(), this.audioChunks = [], this.duration = 0, this.currentTime = 0;
    },
    addListeners() {
      this.recorder.addEventListener("dataavailable", (e) => {
        this.audioChunks.push(e.data);
        const i = new Blob(this.audioChunks), n = URL.createObjectURL(i);
        this.audio.src = n, this.audio.currentTime = 1e100;
      }), this.recorder.addEventListener("stop", () => {
        this.stream.getTracks().forEach((e) => {
          e.stop();
        }), this.recorder = null;
      }), this.addAudioEventListeners();
    },
    addAudioEventListeners() {
      const e = () => {
        this.audio.duration !== 1 / 0 && (this.audio.currentTime = 0, this.duration = this.audio.duration);
      };
      this.audio.addEventListener("loadeddata", e), this.audio.addEventListener("durationchange", e), this.audio.addEventListener("play", () => {
        this.status = "playing";
      }), this.audio.addEventListener("pause", () => {
        this.audio && (this.status = "paused");
      }), this.audio.addEventListener("timeupdate", () => {
        this.status === "playing" && (this.currentTime = this.audio.currentTime);
      }), this.audio.addEventListener("ended", () => {
        this.currentTime = 0, this.status = "recorded";
      });
    },
    startMockMilliseconds() {
      this.intervalMockMilliseconds = setInterval(() => {
        this.mockMilliseconds += 1, this.mockMilliseconds >= 100 && (this.mockMilliseconds = 0);
      }, 10);
    },
    stopMockMilliseconds() {
      clearInterval(this.intervalMockMilliseconds);
    },
    startRecord() {
      this.status = "recording";
      const e = 500;
      this.recorder.start(e), this.startMockMilliseconds();
    },
    discard() {
      this.audio && this.stop(), this.audio = null, this.$emit("update:model-value", null), this.status = "idle";
    },
    save() {
      this.stop(), this.status = "recorded", this.stopMockMilliseconds();
    },
    pause() {
      this.audio.pause();
    },
    stop() {
      this.status = "recorded", this.pause(), this.hasInUseRecordDevice() && this.recorder.stop(), this.$emit("update:model-value", this.audio), this.stopMockMilliseconds();
    },
    play() {
      this.audio.play();
    },
    progressBarUpdate(e) {
      if (this.audio) {
        const { audio: i } = this;
        i.currentTime = e.target.value * i.duration / 100;
      }
    },
    async srcToBars(e) {
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      const i = new AudioContext(), a = await (await fetch(e)).arrayBuffer(), r = await i.decodeAudioData(a);
      return iee(nee(r));
    },
    numberToTimeString(e) {
      const { isRecording: i } = this;
      function n(l, c = 2) {
        return l.toString().padStart(c, "0");
      }
      const a = n(Math.floor(e / 60), i ? 2 : 1), r = n(Math.round(e % 60)), o = n(this.mockMilliseconds);
      return `${a}:${r}${i ? `:${o}` : ""}`;
    }
  }
}, aee = {
  key: 0,
  class: "unnnic-audio-recorder"
};
function see(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicToolTip"), h = j("AudioHandler"), y = j("AudioPlayer");
  return n.modelValue || o.isRecording || n.src ? (f(), p("section", aee, [
    o.isRecording || n.canDiscard ? (f(), $(c, {
      key: 0,
      enabled: "",
      text: e.$t("audio_recorder.discard_button"),
      side: "top"
    }, {
      default: Ee(() => [
        u("span", {
          class: "delete-button unnnic--clickable",
          onClick: i[0] || (i[0] = (...v) => o.discard && o.discard(...v)),
          onKeypress: i[1] || (i[1] = d2((...v) => o.discard && o.discard(...v), ["enter"]))
        }, [
          Z(l, {
            icon: "delete-1-1",
            scheme: "feedback-red"
          })
        ], 32)
      ]),
      _: 1
    }, 8, ["text"])) : N("", !0),
    o.isRecording ? (f(), $(h, {
      key: 1,
      isRecording: o.isRecording,
      time: o.numberToTimeString(e.duration),
      onSave: o.save
    }, null, 8, ["isRecording", "time", "onSave"])) : (f(), $(y, {
      key: 2,
      time: o.numberToTimeString(o.isIdle || o.isRecorded ? e.duration : e.currentTime),
      reqStatus: n.reqStatus,
      progressBarPercentualValue: o.playedPercentual,
      isPlaying: o.isPlaying,
      bars: n.playbackAudioBars ? e.bars : null,
      onFailedClick: i[2] || (i[2] = (v) => e.$emit("failed-click")),
      onPause: o.pause,
      onPlay: o.play,
      onProgressBarUpdate: o.progressBarUpdate
    }, null, 8, ["time", "reqStatus", "progressBarPercentualValue", "isPlaying", "bars", "onPause", "onPlay", "onProgressBarUpdate"]))
  ])) : N("", !0);
}
const oee = /* @__PURE__ */ k(tee, [["render", see], ["__scopeId", "data-v-7d51729d"]]);
const ree = {
  components: {},
  props: {
    progress: {
      type: Number
    },
    totalProgress: {
      type: Number
    }
  },
  computed: {
    progressChange() {
      return `${this.progress}-${this.totalProgress}`;
    }
  },
  watch: {
    progressChange: {
      immediate: !0,
      handler() {
        function e(r, o, l, c) {
          const h = (c - 90) * Math.PI / 180;
          return {
            x: r + l * -Math.cos(h),
            y: o + l * -Math.sin(h)
          };
        }
        function i(r, o, l, c, h, y) {
          const v = l, x = c - l, C = e(r, o, v + x, y), M = e(r, o, v + x, h), z = y - h <= 180 ? "0" : "1";
          return [
            "M",
            C.x,
            C.y,
            "A",
            v + x,
            v + x,
            0,
            z,
            0,
            M.x,
            M.y
          ].join(" ");
        }
        const n = this.progress / this.totalProgress * 360, a = i(23, 23, 0, 21, 180 - n.toFixed(), 180);
        this.$nextTick(() => {
          this.$refs.background.setAttribute("d", a);
        });
      }
    }
  }
}, lee = { class: "unnnic-circle-progress-bar" }, dee = {
  width: "46",
  height: "46",
  class: "semicircle"
}, cee = {
  id: "path",
  ref: "background",
  fill: "none",
  "stroke-linecap": "round",
  class: "front",
  "stroke-width": "4px"
}, fee = { class: "content" };
function uee(e, i, n, a, r, o) {
  return f(), p("div", lee, [
    (f(), p("svg", dee, [
      u("circle", {
        cx: "23",
        cy: "23",
        r: "21",
        stroke: "black",
        "stroke-width": "4px",
        class: B(["background", n.progress === n.totalProgress ? "filled" : ""])
      }, null, 2),
      S1(u("path", cee, null, 512), [
        [ri, n.progress < n.totalProgress && n.progress > 0]
      ])
    ])),
    u("div", fee, T(n.progress) + "/" + T(n.totalProgress), 1)
  ]);
}
const hee = /* @__PURE__ */ k(ree, [["render", uee], ["__scopeId", "data-v-508ff0bd"]]);
const mee = {
  components: {
    UnnnicIcon: ce
  },
  props: {
    modelValue: {
      type: Number
    },
    type: {
      type: String,
      default: "primary"
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    inline: {
      type: Boolean
    },
    canClose: {
      type: Boolean
    }
  },
  computed: {
    percentage() {
      return Math.floor(this.modelValue);
    }
  }
}, pee = { class: "main" }, yee = {
  key: 0,
  class: "title"
}, vee = { class: "progress-bar-container" }, gee = { class: "progress-container" }, _ee = {
  key: 0,
  class: "percentage"
}, wee = {
  key: 0,
  class: "percentage"
}, Cee = {
  key: 1,
  class: "footer"
}, kee = { class: "subtitle" }, xee = { class: "percentage" }, bee = {
  key: 0,
  class: "close"
};
function Mee(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", {
    class: B([
      "unnnic-progress-bar",
      n.type,
      {
        inline: n.inline,
        "has-subtitle": n.subtitle,
        "can-close": n.canClose
      }
    ])
  }, [
    u("div", pee, [
      n.title && !n.subtitle ? (f(), p("div", yee, T(n.title), 1)) : N("", !0),
      u("div", vee, [
        u("div", gee, [
          u("div", {
            class: "bar",
            style: Ze({ width: `${n.modelValue}%` })
          }, [
            n.type === "secondary" && !n.subtitle ? (f(), p("div", _ee, T(o.percentage) + "% ", 1)) : N("", !0)
          ], 4)
        ]),
        n.type === "primary" && !n.subtitle ? (f(), p("div", wee, T(o.percentage) + "% ", 1)) : N("", !0)
      ]),
      n.type === "primary" && n.subtitle ? (f(), p("div", Cee, [
        u("div", kee, T(n.subtitle), 1),
        u("div", xee, T(o.percentage) + "%", 1)
      ])) : N("", !0)
    ]),
    n.type === "primary" && n.subtitle && n.canClose ? (f(), p("div", bee, [
      Z(l, {
        icon: "close-1",
        scheme: "neutral-clean",
        size: "sm",
        clickable: "",
        onClick: i[0] || (i[0] = (c) => e.$emit("close"))
      })
    ])) : N("", !0)
  ], 2);
}
const Dee = /* @__PURE__ */ k(mee, [["render", Mee], ["__scopeId", "data-v-ac4fc1a8"]]);
const Aee = {
  name: "UserAvatar",
  components: {
    UnnnicIcon: ce
  },
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "xl",
      validator: (e) => ["xs", "sm", "ant", "md", "lg", "xl", "2xl"].indexOf(e) !== -1
    },
    username: {
      type: String,
      required: !0
    },
    photoUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  computed: {
    getUsernameFirstCharacter() {
      const i = (this.username.replace(/[^a-zA-Z0-9]+/g, "") || this.username).codePointAt(0);
      return i ? String.fromCodePoint(i) : "";
    }
  }
}, Lee = ["src"], Tee = { key: 3 };
function See(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("section", {
    class: B(["user-avatar", {
      active: n.active,
      clickable: n.clickable,
      disabled: n.disabled,
      [`user-avatar--${n.size}`]: !0
    }]),
    onClick: i[0] || (i[0] = (c) => e.$emit("click")),
    onKeypress: i[1] || (i[1] = d2((c) => e.$emit("click"), ["enter"]))
  }, [
    n.username === "Agent" ? (f(), $(l, {
      key: 0,
      icon: "single-neutral-actions-1",
      size: "sm",
      scheme: n.disabled ? "neutral-snow" : ""
    }, null, 8, ["scheme"])) : n.username === "Bot" ? (f(), $(l, {
      key: 1,
      icon: "science-fiction-robot-2",
      size: "sm",
      scheme: n.disabled ? "neutral-snow" : ""
    }, null, 8, ["scheme"])) : n.photoUrl ? (f(), p("img", {
      key: 2,
      src: n.photoUrl,
      alt: ""
    }, null, 8, Lee)) : (f(), p("span", Tee, T(o.getUsernameFirstCharacter), 1))
  ], 34);
}
const Lo = /* @__PURE__ */ k(Aee, [["render", See], ["__scopeId", "data-v-1674bedc"]]);
const Nee = {
  props: {
    color: {
      type: String,
      default: "neutral-white"
    }
  },
  data() {
    return {
      ripples: [],
      rippleWidth: 0,
      halfRippleWidth: 0
    };
  },
  mounted() {
    const { transitionContainer: e } = this.$parent.$refs;
    e && (this.$parent.$refs.transitionContainer.style.position = "relative", this.$parent.$refs.transitionContainer.style.overflow = "hidden");
    const i = e.offsetWidth, n = e.offsetHeight;
    this.rippleWidth = i > n ? i : n, this.halfRippleWidth = this.rippleWidth / 2, window.addEventListener("mouseup", this.purgeRipples);
  },
  beforeUnmount() {
    window.removeEventListener("mouseup", this.purgeRipples);
  },
  methods: {
    addRipple(e) {
      const { left: i, top: n } = this.$parent.$refs.transitionContainer.getBoundingClientRect(), a = Date.now();
      this.ripples.push({
        width: `${this.rippleWidth}px`,
        height: `${this.rippleWidth}px`,
        left: `${e.clientX - i - this.halfRippleWidth}px`,
        top: `${e.clientY - n - this.halfRippleWidth}px`,
        id: a
      });
    },
    purgeRipples() {
      this.ripples = [];
    }
  }
};
function Eee(e, i, n, a, r, o) {
  return f(), $(tp, {
    class: "ripples",
    name: "grow",
    tag: "div"
  }, {
    default: Ee(() => [
      (f(!0), p(se, null, me(r.ripples, (l) => (f(), p("div", {
        key: l.id,
        class: B(["ripple", `ripples-color--${n.color}`]),
        style: Ze({
          top: l.top,
          left: l.left,
          width: l.width,
          height: l.height
        })
      }, null, 6))), 128))
    ]),
    _: 1
  });
}
const zee = /* @__PURE__ */ k(Nee, [["render", Eee], ["__scopeId", "data-v-9b793da0"]]);
import("./es-2722d018.mjs");
import("./pt-br-26267027.mjs");
const To = {
  name: "ChatsContact",
  components: {
    UserAvatar: Lo,
    UnnnicIcon: ce,
    TransitionRipple: zee,
    Checkbox: V0,
    UnnnicTag: ea
  },
  mixins: [yn],
  props: {
    locale: {
      type: String,
      default: "en"
    },
    title: {
      type: String,
      default: "",
      required: !0
    },
    lastMessage: {
      type: Object,
      default: () => ({})
    },
    lastInteractionTime: {
      type: String,
      default: ""
    },
    userPhoto: {
      type: String,
      default: ""
    },
    waitingTime: {
      type: Number,
      default: 0
    },
    unreadMessages: {
      type: Number,
      default: 0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    checkboxWhenSelect: {
      type: Boolean,
      default: !1
    },
    discussionGoal: {
      type: String,
      default: ""
    },
    projectName: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  data() {
    return {
      isHovered: !1,
      defaultTranslations: {
        waiting_for: {
          "pt-br": "Aguardando há 1 minuto | Aguardando há {waitingTime} minutos",
          en: "1 minute waiting | {waitingTime} minutes waiting",
          es: "Esperando por un minuto | Esperando por {waitingTime} minutos"
        },
        unread_messages: {
          "pt-br": "{unreadMessages} mensagens não lidas",
          en: "{unreadMessages} unread messages",
          es: "{unreadMessages} mensajes no leídos"
        },
        discussion_about: {
          "pt-br": "Discussão sobre {discussionGoal}",
          en: "Discussion about {discussionGoal}",
          es: "Discusión sobre {discussionGoal}"
        },
        audio_message: {
          "pt-br": "Mensagem de áudio",
          en: "Audio message",
          es: "Mensaje de audio"
        },
        image_message: {
          "pt-br": "Imagem",
          en: "Image",
          es: "Imagen"
        },
        video_message: {
          "pt-br": "Vídeo",
          en: "Video",
          es: "Video"
        }
      }
    };
  },
  computed: {
    messageInfoAlign() {
      return this.unreadMessages && this.selected ? "center" : "flex-start";
    },
    messageInfoMarginTop() {
      return this.unreadMessages && this.selected ? "0px" : "4px";
    },
    formattedLastInteraction() {
      if (!this.lastInteractionTime)
        return "";
      const e = {
        en: "Yesterday",
        "pt-br": "Ontem",
        ayer: "Ayer"
      };
      oe.locale(this.locale);
      const i = oe(), n = oe(this.lastInteractionTime);
      return i.subtract(1, "day").isSame(n, "day") ? e[this.locale || "en"] : i.diff(n, "hours") > 0 ? n.format("L") : n.format("HH:mm");
    },
    lastMessageMedia() {
      var c, h, y, v, x;
      const { lastMessage: e } = this, i = typeof e == "object" && ((c = e == null ? void 0 : e.media) == null ? void 0 : c[0]);
      if (!i)
        return { isMedia: i };
      const n = (x = (v = (y = (h = e == null ? void 0 : e.media) == null ? void 0 : h[0]) == null ? void 0 : y.content_type) == null ? void 0 : v.split("/")) == null ? void 0 : x[0], r = {
        audio: "mic",
        image: "image",
        video: "videocam",
        application: "article",
        geo: "location_on"
      }[n], l = {
        audio: this.i18n("audio_message"),
        image: this.i18n("image_message"),
        video: this.i18n("video_message"),
        application: e.media[0].url.split("/").at(-1),
        geo: e.text
      }[n];
      return { isMedia: i, contentType: n, lastMessage: e, mediaIcon: r, mediaText: l };
    },
    subtitle() {
      const { discussionGoal: e, lastMessage: i } = this;
      return e ? this.i18n("discussion_about", e, { discussionGoal: e }) : i == null ? void 0 : i.text;
    }
  }
}, dl = () => {
  Y3((e) => ({
    edd46818: e.messageInfoAlign,
    ed983b94: e.messageInfoMarginTop
  }));
}, cl = To.setup;
To.setup = cl ? (e, i) => (dl(), cl(e, i)) : dl;
const Iee = {
  key: 0,
  class: "chats-contact__discussion-icon"
}, Bee = { class: "chats-contact__infos" }, Oee = { class: "chats-contact__infos__title-container" }, Hee = ["title"], jee = {
  key: 0,
  class: "ellipsis"
}, Vee = {
  key: 1,
  class: "chats-contact__infos__media"
}, Fee = ["title"], Pee = ["title"], Uee = {
  key: 2,
  class: "chats-contact__infos__unread-messages-container"
}, Ree = ["title"];
function Yee(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UserAvatar"), h = j("UnnnicTag"), y = j("Checkbox"), v = j("TransitionRipple");
  return f(), p("div", {
    ref: "transitionContainer",
    class: B(["chats-contact", {
      selected: n.selected,
      disabled: n.disabled,
      "unread-messages": n.unreadMessages,
      waiting: n.waitingTime && !n.discussionGoal
    }]),
    tabindex: 0,
    onClick: i[0] || (i[0] = Qe((x) => e.$emit("click", x), ["stop"])),
    onKeypress: i[1] || (i[1] = d2((x) => e.$emit("click"), ["enter"])),
    onMouseenter: i[2] || (i[2] = (x) => r.isHovered = !0),
    onMouseleave: i[3] || (i[3] = (x) => r.isHovered = !1),
    onMousedown: i[4] || (i[4] = (x) => {
      e.$refs.transitionRipple.addRipple(x);
    })
  }, [
    n.discussionGoal ? (f(), p("div", Iee, [
      Z(l, {
        icon: "forum",
        scheme: "weni-50"
      })
    ])) : (f(), $(c, {
      key: 1,
      username: n.title,
      photoUrl: n.userPhoto,
      active: r.isHovered || n.selected
    }, null, 8, ["username", "photoUrl", "active"])),
    u("div", Bee, [
      u("section", Oee, [
        u("h1", {
          class: B(["chats-contact__infos__title ellipsis", { bold: n.unreadMessages }]),
          title: n.title
        }, T(n.title), 11, Hee),
        n.projectName ? (f(), $(h, {
          key: 0,
          class: "chats-contact__infos__project-tag",
          text: n.projectName,
          scheme: "neutral-white"
        }, null, 8, ["text"])) : N("", !0)
      ]),
      u("div", {
        class: B(["chats-contact__infos__additional-information", { bold: n.unreadMessages || n.checkboxWhenSelect && n.selected }])
      }, [
        n.waitingTime !== 0 && !n.discussionGoal ? (f(), p("p", jee, T(e.i18n("waiting_for", n.waitingTime, { waitingTime: n.waitingTime })), 1)) : o.lastMessageMedia.isMedia ? (f(), p("section", Vee, [
          Z(l, {
            icon: o.lastMessageMedia.mediaIcon,
            scheme: "neutral-cloudy",
            size: "sm"
          }, null, 8, ["icon"]),
          u("p", {
            title: o.lastMessageMedia.mediaText,
            class: "ellipsis"
          }, T(o.lastMessageMedia.mediaText), 9, Fee)
        ])) : o.subtitle ? (f(), p("p", {
          key: 2,
          class: "ellipsis",
          title: o.subtitle
        }, T(o.subtitle), 9, Pee)) : N("", !0)
      ], 2)
    ]),
    n.checkboxWhenSelect ? n.selected && n.checkboxWhenSelect ? (f(), $(y, {
      key: 3,
      class: "chats-contact__infos__checkbox",
      modelValue: !0
    })) : N("", !0) : (f(), p("section", Uee, [
      n.lastInteractionTime ? (f(), p("p", {
        key: 0,
        class: B({
          "chats-contact__infos__message-time": !0,
          "chats-contact__infos__message-time--active": n.unreadMessages
        }),
        "data-testid": "last-interaction-time"
      }, T(o.formattedLastInteraction), 3)) : N("", !0),
      n.unreadMessages && !n.selected ? (f(), p("p", {
        key: 1,
        class: "chats-contact__infos__unread-messages",
        title: e.i18n("unread_messages", n.unreadMessages, { unreadMessages: n.unreadMessages })
      }, T(n.unreadMessages), 9, Ree)) : N("", !0)
    ])),
    Z(v, {
      ref: "transitionRipple",
      color: "neutral-cleanest"
    }, null, 512)
  ], 34);
}
const Zee = /* @__PURE__ */ k(To, [["render", Yee], ["__scopeId", "data-v-f9e6a61f"]]);
const Wee = {
  name: "UnnnicChatsDashboardTagLive",
  components: {
    UnnnicIcon: ce
  },
  mixins: [yn],
  data() {
    return {
      defaultTranslations: {
        live: {
          "pt-br": "Ao vivo",
          en: "Live",
          es: "En vivo"
        }
      }
    };
  }
}, Qee = { class: "unnnic-chats-dashboard-tag-live" }, qee = { class: "unnnic-chats-dashboard-tag-live__text" };
function Gee(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("div", Qee, [
    Z(l, {
      class: "unnnic-chats-dashboard-tag-live__indicator",
      icon: "indicator",
      scheme: "aux-green-300"
    }),
    u("p", qee, T(e.i18n("live")), 1)
  ]);
}
const Xee = /* @__PURE__ */ k(Wee, [["render", Gee]]);
const Jee = {
  name: "UnnnicChatsHeader",
  components: {
    UnnnicButton: Wn,
    UnnnicAvatarIcon: m2,
    UnnnicChatsUserAvatar: Lo,
    UnnnicBreadcrumb: Ic
  },
  mixins: [yn],
  props: {
    title: {
      type: String,
      required: !0,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    sectionIconScheme: {
      type: String,
      default: "aux-purple"
    },
    avatarIcon: {
      type: String,
      default: ""
    },
    avatarName: {
      type: String,
      default: ""
    },
    back: {
      type: Function,
      required: !1
    },
    close: {
      type: Function,
      required: !1
    },
    avatarClick: {
      type: Function,
      required: !1
    },
    titleClick: {
      type: Function,
      required: !1
    },
    crumbs: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "auto",
      validator(e) {
        return ["auto", "small", "large"].includes(e);
      }
    }
  }
}, Kee = {
  key: 0,
  class: "unnnic-chats-header__topbar"
}, $ee = { class: "unnnic-chats-header__main" }, e1e = { class: "unnnic-chats-header__infos" }, n1e = { class: "unnnic-chats-header__infos__title" }, i1e = { key: 0 }, t1e = { class: "unnnic-chats-header__slot" };
function a1e(e, i, n, a, r, o) {
  const l = j("UnnnicBreadcrumb"), c = j("UnnnicButton"), h = j("UnnnicChatsUserAvatar"), y = j("UnnnicAvatarIcon");
  return f(), p("div", {
    class: B(["unnnic-chats-header__container", [n.size]])
  }, [
    u("header", {
      class: B(["unnnic-chats-header", { contact: !!n.avatarName }])
    }, [
      n.avatarName ? N("", !0) : (f(), p("div", Kee, [
        Z(l, {
          crumbs: n.crumbs,
          onCrumbClick: i[0] || (i[0] = (v) => e.$emit("crumbClick", v))
        }, null, 8, ["crumbs"]),
        n.close ? (f(), $(c, {
          key: 0,
          type: "tertiary",
          iconCenter: "close-1",
          size: "small",
          onClick: n.close
        }, null, 8, ["onClick"])) : N("", !0)
      ])),
      u("main", $ee, [
        n.back ? (f(), $(c, {
          key: 0,
          class: "unnnic-chats-header__main__back",
          type: "tertiary",
          size: "small",
          iconCenter: "keyboard-arrow-left-1",
          onClick: n.back
        }, null, 8, ["onClick"])) : N("", !0),
        u("section", e1e, [
          n.avatarName ? (f(), $(h, {
            key: 0,
            clickable: !!n.avatarClick,
            username: n.avatarName,
            onClick: i[1] || (i[1] = (v) => n.avatarClick ? n.avatarClick() : () => {
            })
          }, null, 8, ["clickable", "username"])) : (f(), p("div", {
            key: 1,
            class: B({ clickable: !!n.avatarClick }),
            onClick: i[2] || (i[2] = (v) => n.avatarClick ? n.avatarClick() : () => {
            })
          }, [
            Z(y, {
              scheme: n.sectionIconScheme,
              class: "unnnic-chats-header__avatar-icon",
              size: "sm",
              icon: n.avatarIcon
            }, null, 8, ["scheme", "icon"])
          ], 2)),
          u("hgroup", n1e, [
            u("h1", {
              class: B({ clickable: !!n.titleClick }),
              onClick: i[3] || (i[3] = (v) => n.titleClick ? n.titleClick() : () => {
              })
            }, T(n.title), 3),
            n.subtitle ? (f(), p("h2", i1e, T(n.subtitle), 1)) : N("", !0)
          ])
        ]),
        u("div", t1e, [
          pe(e.$slots, "default")
        ])
      ]),
      n.close ? (f(), $(c, {
        key: 1,
        class: "unnnic-chats-header__close--sm",
        type: "tertiary",
        iconCenter: "close-1",
        size: "small",
        onClick: n.close
      }, null, 8, ["onClick"])) : N("", !0)
    ], 2)
  ], 2);
}
const s1e = /* @__PURE__ */ k(Jee, [["render", a1e]]);
const o1e = {
  name: "UnnnicChatsMessageStatusBackdrop",
  components: {
    UnnnicIconLoading: j0,
    UnnnicIcon: ce
  },
  props: {
    status: {
      type: String,
      required: !0,
      default: "sending",
      validate(e) {
        return ["sending", "failed"].includes(e);
      }
    }
  }
}, r1e = { class: "unnnic-chats-message-status-backdrop__container" }, l1e = { class: "unnnic-chats-message-status-backdrop" };
function d1e(e, i, n, a, r, o) {
  const l = j("UnnnicIconLoading"), c = j("UnnnicIcon");
  return f(), p("div", r1e, [
    u("div", l1e, [
      n.status === "sending" ? (f(), $(l, {
        key: 0,
        scheme: "neutral-white",
        size: "avatar-sm"
      })) : (f(), $(c, {
        key: 1,
        icon: "upload",
        scheme: "neutral-white",
        size: "avatar-sm",
        class: B({ loading: n.status === "sending" })
      }, null, 8, ["class"]))
    ])
  ]);
}
const c1e = /* @__PURE__ */ k(o1e, [["render", d1e]]), f1e = {
  name: "ChatsMessageText",
  props: {
    text: {
      type: String,
      required: !0
    }
  },
  computed: {
    formattedText() {
      var a;
      function e(r) {
        const o = /(https?:\/\/[^\s]+)/g;
        return r.replace(o, '<a href="$1" target="_blank">$1</a>');
      }
      function i(r) {
        return r.replace(
          /<(\/)?([^> ]+)( [^>]+)?>/gi,
          (o, l = "", c, h = "") => {
            if (["b", "i", "u", "ul", "li", "br", "div"].includes(c)) {
              const y = [];
              for (const v of h.matchAll(
                /((?<name1>[^ =]+)="(?<value1>[^"]*)"|(?<name2>[^ =]+)='(?<value2>[^"]*)')/g
              )) {
                const x = v.groups.name1 || v.groups.name2, C = v.groups.value1 || v.groups.value2;
                if (x === "style") {
                  const M = [];
                  for (const z of C.matchAll(
                    /(?<propertyName>[^:]+):(?<propertyValue>[^;]+);?/g
                  ))
                    z.groups.propertyName.toLowerCase().trim() === "text-align" && M.push(
                      `${z.groups.propertyName.toLowerCase().trim()}: ${z.groups.propertyValue.trim()}`
                    );
                  y.push(`style="${M.join("; ")};"`);
                }
              }
              return `<${l}${c}${y.length ? ` ${y.join(" ")}` : ""}>`;
            }
            return "";
          }
        );
      }
      const n = e(
        (a = i(this.text).trim()) == null ? void 0 : a.replace(/\n/g, "<br/>")
      );
      return typeof this.text == "string" ? n : "";
    }
  }
}, u1e = ["innerHTML"];
function h1e(e, i, n, a, r, o) {
  return f(), p("p", {
    class: "unnnic-chats-message__text",
    innerHTML: o.formattedText
  }, null, 8, u1e);
}
const m1e = /* @__PURE__ */ k(f1e, [["render", h1e]]);
const p1e = { class: "reply-message__message-container" }, y1e = { class: "reply-message__content" }, v1e = {
  class: "reply-message__content-text",
  "data-testid": "content-text"
}, g1e = { "data-testid": "content-attachment" }, _1e = { "data-testid": "content-image" }, w1e = { "data-testid": "content-video" }, C1e = { "data-testid": "content-audio" }, k1e = ["id", "src"], x1e = ["src"], b1e = ["src"], M1e = {
  __name: "ReplyMessage",
  props: {
    replyMessage: {
      type: Object,
      required: !0
    },
    messageType: {
      type: String,
      required: !0
    },
    showClose: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(e) {
    const i = e, n = T1(() => {
      var l;
      if (!((l = i.replyMessage.media) != null && l.length))
        return "text";
      const o = i.replyMessage.media[0].content_type.split("/")[0];
      return ["audio", "video", "image", "geo"].includes(o) ? o : "attachment";
    }), a = T1(
      () => ["video", "image"].includes(n.value)
    ), r = L1("");
    return ap(() => {
      var l;
      const o = document.getElementById((l = i.replyMessage) == null ? void 0 : l.uuid);
      o && o.addEventListener(
        "loadedmetadata",
        () => {
          const c = Math.round(o.duration), h = Math.floor(c / 60), y = Math.floor(c % 60), v = `${String(h).padStart(2, "0")}:${String(y).padStart(2, "0")}`;
          r.value = v;
        },
        { once: !0 }
      );
    }), (o, l) => {
      var c, h, y, v;
      return e.replyMessage ? (f(), p("section", {
        key: 0,
        class: B(`reply-message reply-message--${i.replyMessage.user ? "you" : "contact"} ${e.messageType}`)
      }, [
        u("section", p1e, [
          u("p", {
            class: B(`reply-message__contact-name reply-message__contact-name--${i.replyMessage.user ? "you" : "contact"}`),
            "data-testid": "contact-name"
          }, T(i.replyMessage.user ? o.$t("chat_message.reply_message.you") : i.replyMessage.contact.name), 3),
          u("section", y1e, [
            n.value === "text" || n.value === "geo" ? (f(), p(se, { key: 0 }, [
              n.value === "geo" ? (f(), $(ce, {
                key: 0,
                icon: "location_on",
                size: "avatar-nano",
                "data-testid": "content-geo-icon"
              })) : N("", !0),
              u("p", v1e, T(i.replyMessage.text), 1)
            ], 64)) : N("", !0),
            n.value === "attachment" ? (f(), p(se, { key: 1 }, [
              Z(ce, {
                icon: "article",
                size: "avatar-nano",
                "data-testid": "content-attachment-icon"
              }),
              u("p", g1e, T(((h = (c = i.replyMessage.media[0]) == null ? void 0 : c.url) == null ? void 0 : h.split("/").at(-1)) || ((v = (y = i.replyMessage.media[0]) == null ? void 0 : y.file) == null ? void 0 : v.name)), 1)
            ], 64)) : N("", !0),
            n.value === "image" ? (f(), p(se, { key: 2 }, [
              Z(ce, {
                icon: "image",
                size: "avatar-nano",
                "data-testid": "content-image-icon"
              }),
              u("p", _1e, T(o.$t("chat_message.reply_message.image")), 1)
            ], 64)) : N("", !0),
            n.value === "video" ? (f(), p(se, { key: 3 }, [
              Z(ce, {
                icon: "videocam",
                size: "avatar-nano",
                "data-testid": "content-video-icon"
              }),
              u("p", w1e, T(o.$t("chat_message.reply_message.video")), 1)
            ], 64)) : N("", !0),
            n.value === "audio" ? (f(), p(se, { key: 4 }, [
              Z(ce, {
                icon: "mic",
                size: "avatar-nano",
                "data-testid": "content-audio-icon"
              }),
              u("p", C1e, T(o.$t("chat_message.reply_message.audio")) + " " + T(r.value), 1),
              u("audio", {
                id: i.replyMessage.uuid,
                src: i.replyMessage.media[0].url,
                preload: "metadata",
                "data-testid": "content-audio-media"
              }, null, 8, k1e)
            ], 64)) : N("", !0)
          ])
        ]),
        a.value ? (f(), p("section", {
          key: 0,
          class: B({
            "reply-message__media-preview-container": !0,
            right: a.value
          })
        }, [
          n.value === "image" ? (f(), p("img", {
            key: 0,
            src: i.replyMessage.media[0].url,
            class: "reply-message__media-preview",
            width: "100%",
            height: "100%",
            "data-testid": "preview-image"
          }, null, 8, x1e)) : N("", !0),
          n.value === "video" ? (f(), p("video", {
            key: 1,
            src: i.replyMessage.media[0].url,
            class: "reply-message__media-preview",
            preload: "metadata",
            width: "100%",
            height: "100%",
            "data-testid": "preview-video"
          }, null, 8, b1e)) : N("", !0)
        ], 2)) : N("", !0),
        e.showClose ? (f(), $(ce, {
          key: 1,
          class: B({ right: !a.value }),
          icon: "close",
          clickable: "",
          "data-testid": "close-icon",
          size: "avatar-nano",
          scheme: "neutral-clean",
          onClick: l[0] || (l[0] = (x) => o.$emit("close"))
        }, null, 8, ["class"])) : N("", !0)
      ], 2)) : N("", !0);
    };
  }
}, jc = /* @__PURE__ */ k(M1e, [["__scopeId", "data-v-f8932fc3"]]);
const D1e = {
  name: "UnnnicChatsMessage",
  components: {
    UnnnicChatsMessageText: m1e,
    UnnnicChatsMessageStatusBackdrop: c1e,
    UnnnicIconLoading: j0,
    UnnnicIcon: ce,
    UnnnicTooltip: q1,
    ReplyMessage: jc
  },
  mixins: [yn],
  props: {
    enableReply: {
      type: Boolean,
      default: !1
    },
    replyMessage: {
      type: [Object, null],
      default: null
    },
    type: {
      type: String,
      default: "received",
      validate(e) {
        return ["received", "sent"].includes(e);
      }
    },
    time: {
      type: Date,
      required: !0
    },
    signature: {
      type: String,
      default: ""
    },
    documentName: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: "sent",
      validate(e) {
        return ["sending", "sent", "failed"].includes(e);
      }
    },
    mediaType: {
      type: String,
      default: "",
      validate(e) {
        return ["audio", "image", "video", "geo"].includes(e);
      }
    }
  },
  emits: ["click", "click-image", "reply"],
  data() {
    return {
      isHovering: !1,
      defaultTranslations: {
        reply: {
          "pt-br": "Responder",
          en: "Reply",
          es: "Responder"
        }
      }
    };
  },
  computed: {
    formattedTime() {
      const e = new Date(this.time), i = e.getHours();
      let n = e.getMinutes();
      return n < 10 && (n = `0${n}`), `${i}:${n}`;
    },
    isMedia() {
      return !!this.mediaType;
    },
    isDocument() {
      return !!this.documentName;
    },
    isText() {
      return (!this.isMedia || this.isGeolocation) && !this.isDocument;
    },
    isImage() {
      return this.isMedia && this.mediaType === "image";
    },
    isVideo() {
      return this.isMedia && this.mediaType === "video";
    },
    isGeolocation() {
      return this.isMedia && this.mediaType === "geo";
    },
    slotText() {
      var e, i, n, a, r, o, l, c;
      return ((a = (n = (i = (e = this.$slots) == null ? void 0 : e.default) == null ? void 0 : i.call(e)) == null ? void 0 : n[0]) == null ? void 0 : a.children) || ((c = (l = (o = (r = this.$slots) == null ? void 0 : r.text) == null ? void 0 : o.call(r)) == null ? void 0 : l[0]) == null ? void 0 : c.children) || "";
    },
    sendingMedia() {
      return this.isMedia && this.status === "sending";
    },
    failedToSendMedia() {
      return (this.isImage || this.isVideo) && this.status === "failed";
    }
  },
  methods: {
    onClickMedia() {
      (this.isImage || this.isVideo) && this.$emit("click-image");
    }
  }
}, A1e = {
  key: 1,
  class: "unnnic-chats-message__signature"
}, L1e = {
  key: 2,
  class: "unnnic-chats-message__document"
}, T1e = {
  key: 5,
  class: "unnnic-chats-message__tooltip"
}, S1e = {
  key: 6,
  class: "unnnic-chats-message__time"
};
function N1e(e, i, n, a, r, o) {
  const l = j("ReplyMessage"), c = j("UnnnicIcon"), h = j("UnnnicChatsMessageText"), y = j("UnnnicIconLoading"), v = j("UnnnicChatsMessageStatusBackdrop"), x = j("UnnnicTooltip");
  return f(), p("section", {
    class: B(["unnnic-chats-message", {
      sent: n.type === "sent",
      sending: n.status === "sending",
      "is-document": o.isDocument,
      "is-media": o.isMedia,
      "is-image": o.isImage,
      "is-video": o.isVideo,
      "is-geo": o.isGeolocation
    }]),
    onMouseover: i[4] || (i[4] = (C) => r.isHovering = !0),
    onMouseleave: i[5] || (i[5] = (C) => r.isHovering = !1)
  }, [
    n.replyMessage ? (f(), $(l, {
      key: 0,
      class: "unnnic-chats-message__reply-message",
      replyMessage: n.replyMessage,
      messageType: n.type,
      "data-testid": "reply-message"
    }, null, 8, ["replyMessage", "messageType"])) : N("", !0),
    n.signature ? (f(), p("p", A1e, T(n.signature), 1)) : N("", !0),
    u("main", {
      class: B(["unnnic-chats-message__main", {
        "is-document": o.isDocument,
        "is-media": o.isMedia,
        "is-image": o.isImage,
        "is-video": o.isVideo,
        "is-geo": o.isGeolocation
      }])
    }, [
      o.isGeolocation ? (f(), $(c, {
        key: 0,
        class: "geolocation-icon",
        icon: "location_on",
        size: "avatar-nano"
      })) : N("", !0),
      o.isText ? (f(), $(h, {
        key: 1,
        text: o.slotText
      }, null, 8, ["text"])) : N("", !0),
      o.isDocument ? (f(), p("div", L1e, [
        n.status === "sending" ? (f(), $(y, {
          key: 0,
          scheme: "neutral-dark",
          size: "lg"
        })) : n.status === "failed" ? (f(), $(c, {
          key: 1,
          icon: "upload",
          scheme: "neutral-dark",
          size: "lg"
        })) : (f(), $(c, {
          key: 2,
          icon: "article",
          scheme: "neutral-dark",
          size: "lg"
        })),
        u("p", {
          class: "unnnic-chats-message__document__text",
          onClick: i[0] || (i[0] = (C) => e.$emit("click"))
        }, T(n.documentName), 1)
      ])) : o.isMedia && !o.isGeolocation ? (f(), p("div", {
        key: 3,
        class: B(["unnnic-chats-message__media__container", { failed: o.failedToSendMedia }]),
        onClick: i[2] || (i[2] = (...C) => o.onClickMedia && o.onClickMedia(...C))
      }, [
        pe(e.$slots, "default"),
        (o.sendingMedia || o.failedToSendMedia) && (o.isImage || o.isVideo) ? (f(), $(v, {
          key: 0,
          status: n.status,
          onClick: i[1] || (i[1] = Qe((C) => n.status === "failed" ? e.$emit("click") : () => {
          }, ["stop"]))
        }, null, 8, ["status"])) : N("", !0)
      ], 2)) : N("", !0),
      o.sendingMedia ? (f(), $(y, {
        key: 4,
        size: "avatar-nano",
        scheme: "neutral-dark"
      })) : N("", !0),
      n.enableReply && r.isHovering && !["sending", "failed"].includes(n.status) ? (f(), p("section", T1e, [
        Z(x, {
          enabled: "",
          size: "right",
          text: e.i18n("reply"),
          side: n.type === "sent" ? "bottom" : "right"
        }, {
          default: Ee(() => [
            Z(c, {
              icon: "reply",
              clickable: "",
              scheme: "neutral-dark",
              size: "avatar-nano",
              "data-testid": "reply-icon",
              onClick: i[3] || (i[3] = Qe((C) => e.$emit("reply"), ["stop"]))
            })
          ]),
          _: 1
        }, 8, ["text", "side"])
      ])) : (f(), p("p", S1e, T(o.formattedTime), 1))
    ], 2)
  ], 34);
}
const E1e = /* @__PURE__ */ k(D1e, [["render", N1e]]);
const z1e = {
  name: "UnnnicChatsNavbar",
  components: {
    UnnnicIcon: ce
  },
  props: {
    links: {
      type: Array,
      required: !0,
      default: () => [
        {
          name: "",
          icon: {
            default: "",
            selected: ""
          },
          action: () => {
          }
        }
      ],
      validator(e) {
        if (e.length === 0)
          return !1;
        function i(n) {
          const a = typeof n.name == "string", r = typeof n.icon == "string" || typeof n.icon.default == "string", o = typeof n.action == "function";
          return a && r && o;
        }
        return e.every(i);
      }
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  methods: {
    selectLink(e) {
      this.$emit("update:modelValue", e.name);
    },
    isSelected(e) {
      return this.modelValue === e.name;
    },
    getLinkIcon(e) {
      const { icon: i } = e;
      return typeof i == "string" ? i : this.isSelected(e) ? i.selected : i.default || "";
    }
  }
}, I1e = { class: "unnnic-chats-navbar" }, B1e = { class: "unnnic-chats-navbar__list" }, O1e = ["onClick"];
function H1e(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("nav", I1e, [
    u("ol", B1e, [
      (f(!0), p(se, null, me(n.links, (c, h) => (f(), p("li", {
        key: c.icon + h
      }, [
        u("a", {
          class: B([
            "unnnic-chats-navbar__link",
            "unnnic--clickable",
            { selected: o.isSelected(c) }
          ]),
          onClick: () => {
            o.selectLink(c), c.action();
          }
        }, [
          Z(l, {
            icon: o.getLinkIcon(c),
            size: "lg",
            scheme: "neutral-snow",
            filled: o.isSelected(c)
          }, null, 8, ["icon", "filled"])
        ], 10, O1e)
      ]))), 128))
    ])
  ]);
}
const j1e = /* @__PURE__ */ k(z1e, [["render", H1e]]);
const V1e = {
  props: {
    fixedMaxValue: Number,
    fixedMinValue: Number,
    data: Array,
    color: String
  },
  data() {
    return {
      chartContainerWidth: 0,
      chartContainerHeight: 122,
      minValue: 0
    };
  },
  computed: {
    maxValue() {
      return this.fixedMaxValue || Math.max(...this.data.map(({ value: e }) => e).flat());
    },
    svgChart() {
      const e = this.data.map(
        ({ value: l }) => 49.39 - (l / this.maxValue * 48.78 + Math.random() * 0.01)
      ), i = 100 / e.length, n = i / 2;
      let a = "";
      a += `L ${i / 2} ${e[0]}`;
      let r = 0;
      for (let l = 1; l < e.length; l += 1)
        l === 1 ? r = i * 1.5 : r += i, a += `C ${r - n} ${e[l - 1]} ${r - n} ${e[l]} ${r} ${e[l]}`;
      e.length <= 1 && (r += i / 2), a += `L ${r + n} ${e[e.length - 1]}`;
      const o = `
        <svg xmlns='http://www.w3.org/2000/svg' viewBox="0 0 100 50" width="100%" height="100%">
          <defs>
            <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="${this.color}" stop-opacity="1" />
            </linearGradient>
          </defs>

          <g style="transform: scaleX(${this.chartContainerWidth / (122 / 50 * 100)}); transform-origin: center;">
            <path fill="url(#linear1)" d="M0 50 L0 ${String(e[0]) + a} L100 100Z" />
            <path fill="none" stroke-width="2" stroke-linecap="round" vector-effect="non-scaling-stroke" stroke="url(#linear)" d="M0 ${String(e[0]) + a}" />
          </g>
        </svg>
      `;
      return `url("data:image/svg+xml,${encodeURIComponent(o)}")`;
    }
  },
  mounted() {
    this.chartContainerWidth = this.$refs.chart.offsetWidth, this.chartContainerHeigth = this.$refs.chart.offsetHeight, this.maxValue !== this.findMax(this.data) && (this.minValue = this.findMin(this.data));
  },
  methods: {
    findMax(e) {
      return Math.max(...e.map(({ value: i }) => i));
    },
    findMin(e) {
      return Math.min(...e.map(({ value: i }) => i));
    }
  }
};
function F1e(e, i, n, a, r, o) {
  return f(), p("div", {
    ref: "chart",
    class: "chart",
    style: Ze({ backgroundImage: o.svgChart })
  }, [
    (f(!0), p(se, null, me(n.data, ({ value: l }, c) => (f(), p("div", {
      key: c + Math.random() * 100,
      class: "group"
    }, [
      u("div", {
        style: Ze({
          transform: `translateY(-${l / (o.maxValue - r.minValue) * 122}px)`
        }),
        class: "tooltip"
      }, T(l), 5)
    ]))), 128))
  ], 4);
}
const P1e = /* @__PURE__ */ k(V1e, [["render", F1e]]);
const U1e = {
  components: {
    Lines: P1e
  },
  props: {
    condensed: Boolean,
    fixedMaxValue: Number,
    data: Array,
    title: String
  },
  data() {
    return {
      titles: [],
      colors: [
        "#3182CE",
        "#38A169",
        "#DD6B20",
        "#805AD5",
        "#E53E3E",
        "#00A49F",
        "#D69E2E",
        "#00DED2",
        "#F6AD55",
        "#570074"
      ]
    };
  },
  computed: {
    maxValue() {
      return this.fixedMaxValue || Math.max(...this.data.map(({ data: e }) => this.findMax(e)).flat());
    },
    minValue() {
      return Math.min(
        ...this.data.map(({ data: e }) => this.findMin(e)).flat()
      );
    },
    lineData() {
      return this.data[0].data.map((e) => e.title);
    }
  },
  methods: {
    value(e) {
      return this.maxValue <= 1 ? e.toFixed(1) : String(Math.ceil(e));
    },
    findMax(e) {
      return Math.max(...e.map(({ value: i }) => i));
    },
    findMin(e) {
      return Math.min(...e.map(({ value: i }) => i));
    },
    findTotals(e) {
      return e.map(({ value: n }) => n).reduce(
        (n, a) => n + a,
        0
      );
    },
    formatValue(e) {
      return ` ${new Date(e).toLocaleString("default", {
        month: "short"
      })} ${new Date(e).getDate()}`;
    }
  }
}, R1e = (e) => (hn("data-v-7f3f86d0"), e = e(), mn(), e), Y1e = {
  key: 0,
  class: "header"
}, Z1e = { class: "title unnnic-font secondary body-lg color-neutral-dark" }, W1e = { class: "main" }, Q1e = { class: "reference" }, q1e = { class: "values" }, G1e = /* @__PURE__ */ R1e(() => /* @__PURE__ */ u("div", { class: "unnnic-font secondary body-md color-neutral-cleanest" }, "   ", -1)), X1e = { class: "lines" }, J1e = { class: "groups" }, K1e = { class: "reference_values" }, $1e = { class: "labels" }, ene = {
  width: "15",
  height: "6",
  viewBox: "0 0 15 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nne = ["fill"];
function ine(e, i, n, a, r, o) {
  const l = j("Lines");
  return f(), p("div", {
    class: B(["unnnic-chart-line", { condensed: n.condensed }])
  }, [
    n.title ? (f(), p("div", Y1e, [
      u("div", Z1e, T(n.title), 1)
    ])) : N("", !0),
    u("div", W1e, [
      u("div", Q1e, [
        u("div", q1e, [
          (f(!0), p(se, null, me([o.value(o.maxValue), o.value(o.maxValue / 2), 0], (c, h) => (f(), p("div", {
            key: h + Math.random() * 100,
            class: "value unnnic-font secondary body-md color-neutral-cleanest"
          }, T(c), 1))), 128))
        ]),
        G1e
      ]),
      u("div", X1e, [
        u("div", J1e, [
          (f(!0), p(se, null, me(n.data, ({ data: c }, h) => (f(), p("div", {
            key: h + Math.random() * 100
          }, [
            Z(l, {
              data: c,
              fixedMaxValue: o.maxValue,
              fixedMinValue: o.minValue,
              color: r.colors[h]
            }, null, 8, ["data", "fixedMaxValue", "fixedMinValue", "color"])
          ]))), 128)),
          (f(), p(se, null, me(3, (c) => u("div", {
            key: c + Math.random() * 100,
            class: "horizontal-line color-neutral-cleanest",
            style: Ze({ top: `${(c - 1) * ((122 + 67) / 3) - 8}px` })
          }, null, 4)), 64))
        ])
      ])
    ]),
    u("div", K1e, [
      (f(!0), p(se, null, me(o.lineData, (c, h) => (f(), p("div", {
        key: h + Math.random() * 100,
        class: "title unnnic-font secondary body-md color-neutral-cleanest"
      }, T(o.formatValue(c)), 1))), 128))
    ]),
    u("div", $1e, [
      (f(!0), p(se, null, me(n.data, (c, h) => (f(), p("div", {
        key: h + Math.random() * 100,
        class: "label unnnic-font secondary body-lg color-neutral-dark"
      }, [
        (f(), p("svg", ene, [
          u("rect", {
            width: "15",
            height: "6",
            rx: "3",
            fill: r.colors[h]
          }, null, 8, nne)
        ])),
        p1(" " + T(c.title) + " ", 1),
        u("strong", null, T(o.findTotals(c.data)), 1)
      ]))), 128))
    ])
  ], 2);
}
const tne = /* @__PURE__ */ k(U1e, [["render", ine], ["__scopeId", "data-v-7f3f86d0"]]), ane = "Procurar", sne = "Oh não!", one = "Esse emoji não foi encontrado", rne = "Escolha um emoji...", lne = "Adicione um emoji customizado", dne = {
  activity: "Atividade",
  custom: "Customizado",
  flags: "Bandeiras",
  foods: "Comidas & Bebidas",
  frequent: "Usados recentemente",
  nature: "Animais & Natureza",
  objects: "Objetos",
  people: "Carinhas & Pessoas",
  places: "Viagens & Lugares",
  search: "Resultados encontrados",
  symbols: "Símbolos"
}, cne = {
  1: "Padrão",
  2: "Clara",
  3: "Morena-Clara",
  4: "Morena",
  5: "Morena-Escura",
  6: "Escura",
  choose: "Escolha a cor de pele padrão"
}, fne = {
  search: ane,
  search_no_results_1: sne,
  search_no_results_2: one,
  pick: rne,
  add_custom: lne,
  categories: dne,
  skins: cne
}, une = [
  {
    id: "people",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "melting_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "smiling_face_with_tear",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "face_with_open_eyes_and_hand_over_mouth",
      "face_with_peeking_eye",
      "shushing_face",
      "thinking_face",
      "saluting_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "dotted_line_face",
      "face_in_clouds",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "face_exhaling",
      "lying_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "face_with_spiral_eyes",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "disguised_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "face_with_diagonal_mouth",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "face_holding_back_tears",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "robot_face",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "rightwards_hand",
      "leftwards_hand",
      "palm_down_hand",
      "palm_up_hand",
      "ok_hand",
      "pinched_fingers",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "hand_with_index_finger_and_thumb_crossed",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "index_pointing_at_the_viewer",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "heart_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "anatomical_heart",
      "lungs",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "biting_lip",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "man_with_beard",
      "woman_with_beard",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "ninja",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "person_with_crown",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "person_in_tuxedo",
      "man_in_tuxedo",
      "woman_in_tuxedo",
      "bride_with_veil",
      "man_with_veil",
      "woman_with_veil",
      "pregnant_woman",
      "pregnant_man",
      "pregnant_person",
      "breast-feeding",
      "woman_feeding_baby",
      "man_feeding_baby",
      "person_feeding_baby",
      "angel",
      "santa",
      "mrs_claus",
      "mx_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "troll",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "men-with-bunny-ears-partying",
      "women-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "man_and_woman_holding_hands",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "people_hugging",
      "footprints",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "kiss",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart_on_fire",
      "mending_heart",
      "heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "white_heart",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "bomb",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "black_cat",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "bison",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "mammoth",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "beaver",
      "hedgehog",
      "bat",
      "bear",
      "polar_bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "dodo",
      "feather",
      "flamingo",
      "peacock",
      "parrot",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "seal",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "coral",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "ladybug",
      "cricket",
      "cockroach",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "fly",
      "worm",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "lotus",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "seedling",
      "potted_plant",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves",
      "empty_nest",
      "nest_with_eggs"
    ]
  },
  {
    id: "foods",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "blueberries",
      "kiwifruit",
      "tomato",
      "olive",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "bell_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "mushroom",
      "peanuts",
      "beans",
      "chestnut",
      "bread",
      "croissant",
      "baguette_bread",
      "flatbread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "tamale",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "fondue",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "teapot",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "pouring_liquid",
      "cup_with_straw",
      "bubble_tea",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "jar",
      "amphora"
    ]
  },
  {
    id: "activity",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "8ball",
      "crystal_ball",
      "magic_wand",
      "nazar_amulet",
      "hamsa",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "pinata",
      "mirror_ball",
      "nesting_dolls",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "sewing_needle",
      "yarn",
      "knot"
    ]
  },
  {
    id: "places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "rock",
      "wood",
      "hut",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "playground_slide",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "pickup_truck",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "roller_skate",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "wheel",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "ring_buoy",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "thong_sandal",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "military_helmet",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "accordion",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "long_drum",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "low_battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "coin",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "gun",
      "boomerang",
      "bow_and_arrow",
      "shield",
      "carpentry_saw",
      "wrench",
      "screwdriver",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "hook",
      "toolbox",
      "magnet",
      "ladder",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "crutch",
      "stethoscope",
      "x-ray",
      "door",
      "elevator",
      "mirror",
      "window",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "plunger",
      "shower",
      "bathtub",
      "mouse_trap",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "bucket",
      "soap",
      "bubbles",
      "toothbrush",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "headstone",
      "funeral_urn",
      "moyai",
      "placard",
      "identification_card"
    ]
  },
  {
    id: "symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "vibration_mode",
      "mobile_phone_off",
      "transgender_symbol",
      "heavy_multiplication_x",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "heavy_equals_sign",
      "infinity",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "currency_exchange",
      "heavy_dollar_sign",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "x",
      "negative_squared_cross_mark",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-un",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "transgender_flag",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
], hne = {
  100: {
    id: "100",
    name: "Hundred Points",
    keywords: [
      "100",
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass"
    ],
    skins: [
      {
        unified: "1f4af",
        native: "💯",
        x: 28,
        y: 6
      }
    ],
    version: 1
  },
  1234: {
    id: "1234",
    name: "Input Numbers",
    keywords: [
      "1234",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f522",
        native: "🔢",
        x: 29,
        y: 59
      }
    ],
    version: 1
  },
  grinning: {
    id: "grinning",
    name: "Grinning Face",
    emoticons: [
      ":D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    skins: [
      {
        unified: "1f600",
        native: "😀",
        x: 32,
        y: 20
      }
    ],
    version: 1
  },
  smiley: {
    id: "smiley",
    name: "Grinning Face with Big Eyes",
    emoticons: [
      ":)",
      "=)",
      "=-)"
    ],
    keywords: [
      "smiley",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    skins: [
      {
        unified: "1f603",
        native: "😃",
        x: 32,
        y: 23
      }
    ],
    version: 1
  },
  smile: {
    id: "smile",
    name: "Grinning Face with Smiling Eyes",
    emoticons: [
      ":)",
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    skins: [
      {
        unified: "1f604",
        native: "😄",
        x: 32,
        y: 24
      }
    ],
    version: 1
  },
  grin: {
    id: "grin",
    name: "Beaming Face with Smiling Eyes",
    keywords: [
      "grin",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    skins: [
      {
        unified: "1f601",
        native: "😁",
        x: 32,
        y: 21
      }
    ],
    version: 1
  },
  laughing: {
    id: "laughing",
    name: "Grinning Squinting Face",
    emoticons: [
      ":>",
      ":->"
    ],
    keywords: [
      "laughing",
      "satisfied",
      "happy",
      "joy",
      "lol",
      "haha",
      "glad",
      "XD",
      "laugh"
    ],
    skins: [
      {
        unified: "1f606",
        native: "😆",
        x: 32,
        y: 26
      }
    ],
    version: 1
  },
  sweat_smile: {
    id: "sweat_smile",
    name: "Grinning Face with Sweat",
    keywords: [
      "smile",
      "hot",
      "happy",
      "laugh",
      "relief"
    ],
    skins: [
      {
        unified: "1f605",
        native: "😅",
        x: 32,
        y: 25
      }
    ],
    version: 1
  },
  rolling_on_the_floor_laughing: {
    id: "rolling_on_the_floor_laughing",
    name: "Rolling on the Floor Laughing",
    keywords: [
      "face",
      "lol",
      "haha",
      "rofl"
    ],
    skins: [
      {
        unified: "1f923",
        native: "🤣",
        x: 40,
        y: 15
      }
    ],
    version: 3
  },
  joy: {
    id: "joy",
    name: "Face with Tears of Joy",
    keywords: [
      "cry",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    skins: [
      {
        unified: "1f602",
        native: "😂",
        x: 32,
        y: 22
      }
    ],
    version: 1
  },
  slightly_smiling_face: {
    id: "slightly_smiling_face",
    name: "Slightly Smiling Face",
    emoticons: [
      ":)",
      "(:",
      ":-)"
    ],
    keywords: [
      "smile"
    ],
    skins: [
      {
        unified: "1f642",
        native: "🙂",
        x: 33,
        y: 28
      }
    ],
    version: 1
  },
  upside_down_face: {
    id: "upside_down_face",
    name: "Upside-Down Face",
    keywords: [
      "upside",
      "down",
      "flipped",
      "silly",
      "smile"
    ],
    skins: [
      {
        unified: "1f643",
        native: "🙃",
        x: 33,
        y: 29
      }
    ],
    version: 1
  },
  melting_face: {
    id: "melting_face",
    name: "Melting Face",
    keywords: [
      "hot",
      "heat"
    ],
    skins: [
      {
        unified: "1fae0",
        native: "🫠",
        x: 55,
        y: 12
      }
    ],
    version: 14
  },
  wink: {
    id: "wink",
    name: "Winking Face",
    emoticons: [
      ";)",
      ";-)"
    ],
    keywords: [
      "wink",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    skins: [
      {
        unified: "1f609",
        native: "😉",
        x: 32,
        y: 29
      }
    ],
    version: 1
  },
  blush: {
    id: "blush",
    name: "Smiling Face with Smiling Eyes",
    emoticons: [
      ":)"
    ],
    keywords: [
      "blush",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    skins: [
      {
        unified: "1f60a",
        native: "😊",
        x: 32,
        y: 30
      }
    ],
    version: 1
  },
  innocent: {
    id: "innocent",
    name: "Smiling Face with Halo",
    keywords: [
      "innocent",
      "angel",
      "heaven"
    ],
    skins: [
      {
        unified: "1f607",
        native: "😇",
        x: 32,
        y: 27
      }
    ],
    version: 1
  },
  smiling_face_with_3_hearts: {
    id: "smiling_face_with_3_hearts",
    name: "Smiling Face with Hearts",
    keywords: [
      "3",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "adore"
    ],
    skins: [
      {
        unified: "1f970",
        native: "🥰",
        x: 43,
        y: 58
      }
    ],
    version: 11
  },
  heart_eyes: {
    id: "heart_eyes",
    name: "Smiling Face with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush"
    ],
    skins: [
      {
        unified: "1f60d",
        native: "😍",
        x: 32,
        y: 33
      }
    ],
    version: 1
  },
  "star-struck": {
    id: "star-struck",
    name: "Star-Struck",
    keywords: [
      "star",
      "struck",
      "grinning",
      "face",
      "with",
      "eyes",
      "smile",
      "starry"
    ],
    skins: [
      {
        unified: "1f929",
        native: "🤩",
        x: 40,
        y: 38
      }
    ],
    version: 5
  },
  kissing_heart: {
    id: "kissing_heart",
    name: "Face Blowing a Kiss",
    emoticons: [
      ":*",
      ":-*"
    ],
    keywords: [
      "kissing",
      "heart",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation"
    ],
    skins: [
      {
        unified: "1f618",
        native: "😘",
        x: 32,
        y: 44
      }
    ],
    version: 1
  },
  kissing: {
    id: "kissing",
    name: "Kissing Face",
    keywords: [
      "love",
      "like",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f617",
        native: "😗",
        x: 32,
        y: 43
      }
    ],
    version: 1
  },
  relaxed: {
    id: "relaxed",
    name: "Smiling Face",
    keywords: [
      "relaxed",
      "blush",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "263a-fe0f",
        native: "☺️",
        x: 57,
        y: 4
      }
    ],
    version: 1
  },
  kissing_closed_eyes: {
    id: "kissing_closed_eyes",
    name: "Kissing Face with Closed Eyes",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f61a",
        native: "😚",
        x: 32,
        y: 46
      }
    ],
    version: 1
  },
  kissing_smiling_eyes: {
    id: "kissing_smiling_eyes",
    name: "Kissing Face with Smiling Eyes",
    keywords: [
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f619",
        native: "😙",
        x: 32,
        y: 45
      }
    ],
    version: 1
  },
  smiling_face_with_tear: {
    id: "smiling_face_with_tear",
    name: "Smiling Face with Tear",
    keywords: [
      "sad",
      "cry",
      "pretend"
    ],
    skins: [
      {
        unified: "1f972",
        native: "🥲",
        x: 43,
        y: 60
      }
    ],
    version: 13
  },
  yum: {
    id: "yum",
    name: "Face Savoring Food",
    keywords: [
      "yum",
      "happy",
      "joy",
      "tongue",
      "smile",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    skins: [
      {
        unified: "1f60b",
        native: "😋",
        x: 32,
        y: 31
      }
    ],
    version: 1
  },
  stuck_out_tongue: {
    id: "stuck_out_tongue",
    name: "Face with Tongue",
    emoticons: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    keywords: [
      "stuck",
      "out",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61b",
        native: "😛",
        x: 32,
        y: 47
      }
    ],
    version: 1
  },
  stuck_out_tongue_winking_eye: {
    id: "stuck_out_tongue_winking_eye",
    name: "Winking Face with Tongue",
    emoticons: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    keywords: [
      "stuck",
      "out",
      "eye",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink"
    ],
    skins: [
      {
        unified: "1f61c",
        native: "😜",
        x: 32,
        y: 48
      }
    ],
    version: 1
  },
  zany_face: {
    id: "zany_face",
    name: "Zany Face",
    keywords: [
      "grinning",
      "with",
      "one",
      "large",
      "and",
      "small",
      "eye",
      "goofy",
      "crazy"
    ],
    skins: [
      {
        unified: "1f92a",
        native: "🤪",
        x: 40,
        y: 39
      }
    ],
    version: 5
  },
  stuck_out_tongue_closed_eyes: {
    id: "stuck_out_tongue_closed_eyes",
    name: "Squinting Face with Tongue",
    keywords: [
      "stuck",
      "out",
      "closed",
      "eyes",
      "prank",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61d",
        native: "😝",
        x: 32,
        y: 49
      }
    ],
    version: 1
  },
  money_mouth_face: {
    id: "money_mouth_face",
    name: "Money-Mouth Face",
    keywords: [
      "money",
      "mouth",
      "rich",
      "dollar"
    ],
    skins: [
      {
        unified: "1f911",
        native: "🤑",
        x: 38,
        y: 59
      }
    ],
    version: 1
  },
  hugging_face: {
    id: "hugging_face",
    name: "Hugging Face",
    keywords: [
      "smile",
      "hug"
    ],
    skins: [
      {
        unified: "1f917",
        native: "🤗",
        x: 39,
        y: 4
      }
    ],
    version: 1
  },
  face_with_hand_over_mouth: {
    id: "face_with_hand_over_mouth",
    name: "Face with Hand over Mouth",
    keywords: [
      "smiling",
      "eyes",
      "and",
      "covering",
      "whoops",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1f92d",
        native: "🤭",
        x: 40,
        y: 42
      }
    ],
    version: 5
  },
  face_with_open_eyes_and_hand_over_mouth: {
    id: "face_with_open_eyes_and_hand_over_mouth",
    name: "Face with Open Eyes and Hand over Mouth",
    keywords: [
      "silence",
      "secret",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1fae2",
        native: "🫢",
        x: 55,
        y: 14
      }
    ],
    version: 14
  },
  face_with_peeking_eye: {
    id: "face_with_peeking_eye",
    name: "Face with Peeking Eye",
    keywords: [
      "scared",
      "frightening",
      "embarrassing"
    ],
    skins: [
      {
        unified: "1fae3",
        native: "🫣",
        x: 55,
        y: 15
      }
    ],
    version: 14
  },
  shushing_face: {
    id: "shushing_face",
    name: "Shushing Face",
    keywords: [
      "with",
      "finger",
      "covering",
      "closed",
      "lips",
      "quiet",
      "shhh"
    ],
    skins: [
      {
        unified: "1f92b",
        native: "🤫",
        x: 40,
        y: 40
      }
    ],
    version: 5
  },
  thinking_face: {
    id: "thinking_face",
    name: "Thinking Face",
    keywords: [
      "hmmm",
      "think",
      "consider"
    ],
    skins: [
      {
        unified: "1f914",
        native: "🤔",
        x: 39,
        y: 1
      }
    ],
    version: 1
  },
  saluting_face: {
    id: "saluting_face",
    name: "Saluting Face",
    keywords: [
      "respect",
      "salute"
    ],
    skins: [
      {
        unified: "1fae1",
        native: "🫡",
        x: 55,
        y: 13
      }
    ],
    version: 14
  },
  zipper_mouth_face: {
    id: "zipper_mouth_face",
    name: "Zipper-Mouth Face",
    keywords: [
      "zipper",
      "mouth",
      "sealed",
      "secret"
    ],
    skins: [
      {
        unified: "1f910",
        native: "🤐",
        x: 38,
        y: 58
      }
    ],
    version: 1
  },
  face_with_raised_eyebrow: {
    id: "face_with_raised_eyebrow",
    name: "Face with Raised Eyebrow",
    keywords: [
      "one",
      "distrust",
      "scepticism",
      "disapproval",
      "disbelief",
      "surprise"
    ],
    skins: [
      {
        unified: "1f928",
        native: "🤨",
        x: 40,
        y: 37
      }
    ],
    version: 5
  },
  neutral_face: {
    id: "neutral_face",
    name: "Neutral Face",
    emoticons: [
      ":|",
      ":-|"
    ],
    keywords: [
      "indifference",
      "meh",
      ":",
      ""
    ],
    skins: [
      {
        unified: "1f610",
        native: "😐",
        x: 32,
        y: 36
      }
    ],
    version: 1
  },
  expressionless: {
    id: "expressionless",
    name: "Expressionless Face",
    emoticons: [
      "-_-"
    ],
    keywords: [
      "indifferent",
      "-",
      "",
      "meh",
      "deadpan"
    ],
    skins: [
      {
        unified: "1f611",
        native: "😑",
        x: 32,
        y: 37
      }
    ],
    version: 1
  },
  no_mouth: {
    id: "no_mouth",
    name: "Face Without Mouth",
    keywords: [
      "no",
      "hellokitty"
    ],
    skins: [
      {
        unified: "1f636",
        native: "😶",
        x: 33,
        y: 16
      }
    ],
    version: 1
  },
  dotted_line_face: {
    id: "dotted_line_face",
    name: "Dotted Line Face",
    keywords: [
      "invisible",
      "lonely",
      "isolation",
      "depression"
    ],
    skins: [
      {
        unified: "1fae5",
        native: "🫥",
        x: 55,
        y: 17
      }
    ],
    version: 14
  },
  face_in_clouds: {
    id: "face_in_clouds",
    name: "Face in Clouds",
    keywords: [
      "shower",
      "steam",
      "dream"
    ],
    skins: [
      {
        unified: "1f636-200d-1f32b-fe0f",
        native: "😶‍🌫️",
        x: 33,
        y: 15
      }
    ],
    version: 13.1
  },
  smirk: {
    id: "smirk",
    name: "Smirking Face",
    keywords: [
      "smirk",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    skins: [
      {
        unified: "1f60f",
        native: "😏",
        x: 32,
        y: 35
      }
    ],
    version: 1
  },
  unamused: {
    id: "unamused",
    name: "Unamused Face",
    emoticons: [
      ":("
    ],
    keywords: [
      "indifference",
      "bored",
      "straight",
      "serious",
      "sarcasm",
      "unimpressed",
      "skeptical",
      "dubious",
      "side",
      "eye"
    ],
    skins: [
      {
        unified: "1f612",
        native: "😒",
        x: 32,
        y: 38
      }
    ],
    version: 1
  },
  face_with_rolling_eyes: {
    id: "face_with_rolling_eyes",
    name: "Face with Rolling Eyes",
    keywords: [
      "eyeroll",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f644",
        native: "🙄",
        x: 33,
        y: 30
      }
    ],
    version: 1
  },
  grimacing: {
    id: "grimacing",
    name: "Grimacing Face",
    keywords: [
      "grimace",
      "teeth"
    ],
    skins: [
      {
        unified: "1f62c",
        native: "😬",
        x: 33,
        y: 3
      }
    ],
    version: 1
  },
  face_exhaling: {
    id: "face_exhaling",
    name: "Face Exhaling",
    keywords: [
      "relieve",
      "relief",
      "tired",
      "sigh"
    ],
    skins: [
      {
        unified: "1f62e-200d-1f4a8",
        native: "😮‍💨",
        x: 33,
        y: 5
      }
    ],
    version: 13.1
  },
  lying_face: {
    id: "lying_face",
    name: "Lying Face",
    keywords: [
      "lie",
      "pinocchio"
    ],
    skins: [
      {
        unified: "1f925",
        native: "🤥",
        x: 40,
        y: 17
      }
    ],
    version: 3
  },
  relieved: {
    id: "relieved",
    name: "Relieved Face",
    keywords: [
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "1f60c",
        native: "😌",
        x: 32,
        y: 32
      }
    ],
    version: 1
  },
  pensive: {
    id: "pensive",
    name: "Pensive Face",
    keywords: [
      "sad",
      "depressed",
      "upset"
    ],
    skins: [
      {
        unified: "1f614",
        native: "😔",
        x: 32,
        y: 40
      }
    ],
    version: 1
  },
  sleepy: {
    id: "sleepy",
    name: "Sleepy Face",
    keywords: [
      "tired",
      "rest",
      "nap"
    ],
    skins: [
      {
        unified: "1f62a",
        native: "😪",
        x: 33,
        y: 1
      }
    ],
    version: 1
  },
  drooling_face: {
    id: "drooling_face",
    name: "Drooling Face",
    keywords: [],
    skins: [
      {
        unified: "1f924",
        native: "🤤",
        x: 40,
        y: 16
      }
    ],
    version: 3
  },
  sleeping: {
    id: "sleeping",
    name: "Sleeping Face",
    keywords: [
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    skins: [
      {
        unified: "1f634",
        native: "😴",
        x: 33,
        y: 12
      }
    ],
    version: 1
  },
  mask: {
    id: "mask",
    name: "Face with Medical Mask",
    keywords: [
      "sick",
      "ill",
      "disease"
    ],
    skins: [
      {
        unified: "1f637",
        native: "😷",
        x: 33,
        y: 17
      }
    ],
    version: 1
  },
  face_with_thermometer: {
    id: "face_with_thermometer",
    name: "Face with Thermometer",
    keywords: [
      "sick",
      "temperature",
      "cold",
      "fever"
    ],
    skins: [
      {
        unified: "1f912",
        native: "🤒",
        x: 38,
        y: 60
      }
    ],
    version: 1
  },
  face_with_head_bandage: {
    id: "face_with_head_bandage",
    name: "Face with Head-Bandage",
    keywords: [
      "head",
      "bandage",
      "injured",
      "clumsy",
      "hurt"
    ],
    skins: [
      {
        unified: "1f915",
        native: "🤕",
        x: 39,
        y: 2
      }
    ],
    version: 1
  },
  nauseated_face: {
    id: "nauseated_face",
    name: "Nauseated Face",
    keywords: [
      "vomit",
      "gross",
      "green",
      "sick",
      "throw",
      "up",
      "ill"
    ],
    skins: [
      {
        unified: "1f922",
        native: "🤢",
        x: 40,
        y: 14
      }
    ],
    version: 3
  },
  face_vomiting: {
    id: "face_vomiting",
    name: "Face Vomiting",
    keywords: [
      "with",
      "open",
      "mouth",
      "sick"
    ],
    skins: [
      {
        unified: "1f92e",
        native: "🤮",
        x: 40,
        y: 43
      }
    ],
    version: 5
  },
  sneezing_face: {
    id: "sneezing_face",
    name: "Sneezing Face",
    keywords: [
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    skins: [
      {
        unified: "1f927",
        native: "🤧",
        x: 40,
        y: 36
      }
    ],
    version: 3
  },
  hot_face: {
    id: "hot_face",
    name: "Hot Face",
    keywords: [
      "feverish",
      "heat",
      "red",
      "sweating"
    ],
    skins: [
      {
        unified: "1f975",
        native: "🥵",
        x: 44,
        y: 2
      }
    ],
    version: 11
  },
  cold_face: {
    id: "cold_face",
    name: "Cold Face",
    keywords: [
      "blue",
      "freezing",
      "frozen",
      "frostbite",
      "icicles"
    ],
    skins: [
      {
        unified: "1f976",
        native: "🥶",
        x: 44,
        y: 3
      }
    ],
    version: 11
  },
  woozy_face: {
    id: "woozy_face",
    name: "Woozy Face",
    keywords: [
      "dizzy",
      "intoxicated",
      "tipsy",
      "wavy"
    ],
    skins: [
      {
        unified: "1f974",
        native: "🥴",
        x: 44,
        y: 1
      }
    ],
    version: 11
  },
  dizzy_face: {
    id: "dizzy_face",
    name: "Dizzy Face",
    keywords: [
      "spent",
      "unconscious",
      "xox"
    ],
    skins: [
      {
        unified: "1f635",
        native: "😵",
        x: 33,
        y: 14
      }
    ],
    version: 1
  },
  face_with_spiral_eyes: {
    id: "face_with_spiral_eyes",
    name: "Face with Spiral Eyes",
    keywords: [
      "sick",
      "ill",
      "confused",
      "nauseous",
      "nausea"
    ],
    skins: [
      {
        unified: "1f635-200d-1f4ab",
        native: "😵‍💫",
        x: 33,
        y: 13
      }
    ],
    version: 13.1
  },
  exploding_head: {
    id: "exploding_head",
    name: "Exploding Head",
    keywords: [
      "shocked",
      "face",
      "with",
      "mind",
      "blown"
    ],
    skins: [
      {
        unified: "1f92f",
        native: "🤯",
        x: 40,
        y: 44
      }
    ],
    version: 5
  },
  face_with_cowboy_hat: {
    id: "face_with_cowboy_hat",
    name: "Cowboy Hat Face",
    keywords: [
      "with",
      "cowgirl"
    ],
    skins: [
      {
        unified: "1f920",
        native: "🤠",
        x: 40,
        y: 12
      }
    ],
    version: 3
  },
  partying_face: {
    id: "partying_face",
    name: "Partying Face",
    keywords: [
      "celebration",
      "woohoo"
    ],
    skins: [
      {
        unified: "1f973",
        native: "🥳",
        x: 44,
        y: 0
      }
    ],
    version: 11
  },
  disguised_face: {
    id: "disguised_face",
    name: "Disguised Face",
    keywords: [
      "pretent",
      "brows",
      "glasses",
      "moustache"
    ],
    skins: [
      {
        unified: "1f978",
        native: "🥸",
        x: 44,
        y: 10
      }
    ],
    version: 13
  },
  sunglasses: {
    id: "sunglasses",
    name: "Smiling Face with Sunglasses",
    emoticons: [
      "8)"
    ],
    keywords: [
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    skins: [
      {
        unified: "1f60e",
        native: "😎",
        x: 32,
        y: 34
      }
    ],
    version: 1
  },
  nerd_face: {
    id: "nerd_face",
    name: "Nerd Face",
    keywords: [
      "nerdy",
      "geek",
      "dork"
    ],
    skins: [
      {
        unified: "1f913",
        native: "🤓",
        x: 39,
        y: 0
      }
    ],
    version: 1
  },
  face_with_monocle: {
    id: "face_with_monocle",
    name: "Face with Monocle",
    keywords: [
      "stuffy",
      "wealthy"
    ],
    skins: [
      {
        unified: "1f9d0",
        native: "🧐",
        x: 47,
        y: 11
      }
    ],
    version: 5
  },
  confused: {
    id: "confused",
    name: "Confused Face",
    emoticons: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    keywords: [
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    skins: [
      {
        unified: "1f615",
        native: "😕",
        x: 32,
        y: 41
      }
    ],
    version: 1
  },
  face_with_diagonal_mouth: {
    id: "face_with_diagonal_mouth",
    name: "Face with Diagonal Mouth",
    keywords: [
      "skeptic",
      "confuse",
      "frustrated",
      "indifferent"
    ],
    skins: [
      {
        unified: "1fae4",
        native: "🫤",
        x: 55,
        y: 16
      }
    ],
    version: 14
  },
  worried: {
    id: "worried",
    name: "Worried Face",
    keywords: [
      "concern",
      "nervous",
      ":("
    ],
    skins: [
      {
        unified: "1f61f",
        native: "😟",
        x: 32,
        y: 51
      }
    ],
    version: 1
  },
  slightly_frowning_face: {
    id: "slightly_frowning_face",
    name: "Slightly Frowning Face",
    keywords: [
      "disappointed",
      "sad",
      "upset"
    ],
    skins: [
      {
        unified: "1f641",
        native: "🙁",
        x: 33,
        y: 27
      }
    ],
    version: 1
  },
  white_frowning_face: {
    id: "white_frowning_face",
    name: "Frowning Face",
    keywords: [
      "white",
      "sad",
      "upset",
      "frown"
    ],
    skins: [
      {
        unified: "2639-fe0f",
        native: "☹️",
        x: 57,
        y: 3
      }
    ],
    version: 1
  },
  open_mouth: {
    id: "open_mouth",
    name: "Face with Open Mouth",
    emoticons: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    keywords: [
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    skins: [
      {
        unified: "1f62e",
        native: "😮",
        x: 33,
        y: 6
      }
    ],
    version: 1
  },
  hushed: {
    id: "hushed",
    name: "Hushed Face",
    keywords: [
      "woo",
      "shh"
    ],
    skins: [
      {
        unified: "1f62f",
        native: "😯",
        x: 33,
        y: 7
      }
    ],
    version: 1
  },
  astonished: {
    id: "astonished",
    name: "Astonished Face",
    keywords: [
      "xox",
      "surprised",
      "poisoned"
    ],
    skins: [
      {
        unified: "1f632",
        native: "😲",
        x: 33,
        y: 10
      }
    ],
    version: 1
  },
  flushed: {
    id: "flushed",
    name: "Flushed Face",
    keywords: [
      "blush",
      "shy",
      "flattered"
    ],
    skins: [
      {
        unified: "1f633",
        native: "😳",
        x: 33,
        y: 11
      }
    ],
    version: 1
  },
  pleading_face: {
    id: "pleading_face",
    name: "Pleading Face",
    keywords: [
      "begging",
      "mercy"
    ],
    skins: [
      {
        unified: "1f97a",
        native: "🥺",
        x: 44,
        y: 12
      }
    ],
    version: 11
  },
  face_holding_back_tears: {
    id: "face_holding_back_tears",
    name: "Face Holding Back Tears",
    keywords: [
      "touched",
      "gratitude"
    ],
    skins: [
      {
        unified: "1f979",
        native: "🥹",
        x: 44,
        y: 11
      }
    ],
    version: 14
  },
  frowning: {
    id: "frowning",
    name: "Frowning Face with Open Mouth",
    keywords: [
      "aw",
      "what"
    ],
    skins: [
      {
        unified: "1f626",
        native: "😦",
        x: 32,
        y: 58
      }
    ],
    version: 1
  },
  anguished: {
    id: "anguished",
    name: "Anguished Face",
    emoticons: [
      "D:"
    ],
    keywords: [
      "stunned",
      "nervous"
    ],
    skins: [
      {
        unified: "1f627",
        native: "😧",
        x: 32,
        y: 59
      }
    ],
    version: 1
  },
  fearful: {
    id: "fearful",
    name: "Fearful Face",
    keywords: [
      "scared",
      "terrified",
      "nervous",
      "oops",
      "huh"
    ],
    skins: [
      {
        unified: "1f628",
        native: "😨",
        x: 32,
        y: 60
      }
    ],
    version: 1
  },
  cold_sweat: {
    id: "cold_sweat",
    name: "Anxious Face with Sweat",
    keywords: [
      "cold",
      "nervous"
    ],
    skins: [
      {
        unified: "1f630",
        native: "😰",
        x: 33,
        y: 8
      }
    ],
    version: 1
  },
  disappointed_relieved: {
    id: "disappointed_relieved",
    name: "Sad but Relieved Face",
    keywords: [
      "disappointed",
      "phew",
      "sweat",
      "nervous"
    ],
    skins: [
      {
        unified: "1f625",
        native: "😥",
        x: 32,
        y: 57
      }
    ],
    version: 1
  },
  cry: {
    id: "cry",
    name: "Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "cry",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    skins: [
      {
        unified: "1f622",
        native: "😢",
        x: 32,
        y: 54
      }
    ],
    version: 1
  },
  sob: {
    id: "sob",
    name: "Loudly Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "sob",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    skins: [
      {
        unified: "1f62d",
        native: "😭",
        x: 33,
        y: 4
      }
    ],
    version: 1
  },
  scream: {
    id: "scream",
    name: "Face Screaming in Fear",
    keywords: [
      "scream",
      "munch",
      "scared",
      "omg"
    ],
    skins: [
      {
        unified: "1f631",
        native: "😱",
        x: 33,
        y: 9
      }
    ],
    version: 1
  },
  confounded: {
    id: "confounded",
    name: "Confounded Face",
    keywords: [
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    skins: [
      {
        unified: "1f616",
        native: "😖",
        x: 32,
        y: 42
      }
    ],
    version: 1
  },
  persevere: {
    id: "persevere",
    name: "Persevering Face",
    keywords: [
      "persevere",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    skins: [
      {
        unified: "1f623",
        native: "😣",
        x: 32,
        y: 55
      }
    ],
    version: 1
  },
  disappointed: {
    id: "disappointed",
    name: "Disappointed Face",
    emoticons: [
      "):",
      ":(",
      ":-("
    ],
    keywords: [
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    skins: [
      {
        unified: "1f61e",
        native: "😞",
        x: 32,
        y: 50
      }
    ],
    version: 1
  },
  sweat: {
    id: "sweat",
    name: "Face with Cold Sweat",
    keywords: [
      "downcast",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    skins: [
      {
        unified: "1f613",
        native: "😓",
        x: 32,
        y: 39
      }
    ],
    version: 1
  },
  weary: {
    id: "weary",
    name: "Weary Face",
    keywords: [
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    skins: [
      {
        unified: "1f629",
        native: "😩",
        x: 33,
        y: 0
      }
    ],
    version: 1
  },
  tired_face: {
    id: "tired_face",
    name: "Tired Face",
    keywords: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f62b",
        native: "😫",
        x: 33,
        y: 2
      }
    ],
    version: 1
  },
  yawning_face: {
    id: "yawning_face",
    name: "Yawning Face",
    keywords: [
      "tired",
      "sleepy"
    ],
    skins: [
      {
        unified: "1f971",
        native: "🥱",
        x: 43,
        y: 59
      }
    ],
    version: 12
  },
  triumph: {
    id: "triumph",
    name: "Face with Look of Triumph",
    keywords: [
      "steam",
      "from",
      "nose",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    skins: [
      {
        unified: "1f624",
        native: "😤",
        x: 32,
        y: 56
      }
    ],
    version: 1
  },
  rage: {
    id: "rage",
    name: "Pouting Face",
    keywords: [
      "rage",
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    skins: [
      {
        unified: "1f621",
        native: "😡",
        x: 32,
        y: 53
      }
    ],
    version: 1
  },
  angry: {
    id: "angry",
    name: "Angry Face",
    emoticons: [
      ">:(",
      ">:-("
    ],
    keywords: [
      "mad",
      "annoyed",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f620",
        native: "😠",
        x: 32,
        y: 52
      }
    ],
    version: 1
  },
  face_with_symbols_on_mouth: {
    id: "face_with_symbols_on_mouth",
    name: "Face with Symbols on Mouth",
    keywords: [
      "serious",
      "covering",
      "swearing",
      "cursing",
      "cussing",
      "profanity",
      "expletive"
    ],
    skins: [
      {
        unified: "1f92c",
        native: "🤬",
        x: 40,
        y: 41
      }
    ],
    version: 5
  },
  smiling_imp: {
    id: "smiling_imp",
    name: "Smiling Face with Horns",
    keywords: [
      "imp",
      "devil"
    ],
    skins: [
      {
        unified: "1f608",
        native: "😈",
        x: 32,
        y: 28
      }
    ],
    version: 1
  },
  imp: {
    id: "imp",
    name: "Imp",
    keywords: [
      "angry",
      "face",
      "with",
      "horns",
      "devil"
    ],
    skins: [
      {
        unified: "1f47f",
        native: "👿",
        x: 25,
        y: 8
      }
    ],
    version: 1
  },
  skull: {
    id: "skull",
    name: "Skull",
    keywords: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    skins: [
      {
        unified: "1f480",
        native: "💀",
        x: 25,
        y: 9
      }
    ],
    version: 1
  },
  skull_and_crossbones: {
    id: "skull_and_crossbones",
    name: "Skull and Crossbones",
    keywords: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    skins: [
      {
        unified: "2620-fe0f",
        native: "☠️",
        x: 56,
        y: 56
      }
    ],
    version: 1
  },
  hankey: {
    id: "hankey",
    name: "Pile of Poo",
    keywords: [
      "hankey",
      "poop",
      "shit",
      "shitface",
      "fail",
      "turd"
    ],
    skins: [
      {
        unified: "1f4a9",
        native: "💩",
        x: 27,
        y: 56
      }
    ],
    version: 1
  },
  clown_face: {
    id: "clown_face",
    name: "Clown Face",
    keywords: [],
    skins: [
      {
        unified: "1f921",
        native: "🤡",
        x: 40,
        y: 13
      }
    ],
    version: 3
  },
  japanese_ogre: {
    id: "japanese_ogre",
    name: "Ogre",
    keywords: [
      "japanese",
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon"
    ],
    skins: [
      {
        unified: "1f479",
        native: "👹",
        x: 24,
        y: 58
      }
    ],
    version: 1
  },
  japanese_goblin: {
    id: "japanese_goblin",
    name: "Goblin",
    keywords: [
      "japanese",
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy"
    ],
    skins: [
      {
        unified: "1f47a",
        native: "👺",
        x: 24,
        y: 59
      }
    ],
    version: 1
  },
  ghost: {
    id: "ghost",
    name: "Ghost",
    keywords: [
      "halloween",
      "spooky",
      "scary"
    ],
    skins: [
      {
        unified: "1f47b",
        native: "👻",
        x: 24,
        y: 60
      }
    ],
    version: 1
  },
  alien: {
    id: "alien",
    name: "Alien",
    keywords: [
      "UFO",
      "paul",
      "weird",
      "outer",
      "space"
    ],
    skins: [
      {
        unified: "1f47d",
        native: "👽",
        x: 25,
        y: 6
      }
    ],
    version: 1
  },
  space_invader: {
    id: "space_invader",
    name: "Alien Monster",
    keywords: [
      "space",
      "invader",
      "game",
      "arcade",
      "play"
    ],
    skins: [
      {
        unified: "1f47e",
        native: "👾",
        x: 25,
        y: 7
      }
    ],
    version: 1
  },
  robot_face: {
    id: "robot_face",
    name: "Robot",
    keywords: [
      "face",
      "computer",
      "machine",
      "bot"
    ],
    skins: [
      {
        unified: "1f916",
        native: "🤖",
        x: 39,
        y: 3
      }
    ],
    version: 1
  },
  smiley_cat: {
    id: "smiley_cat",
    name: "Grinning Cat",
    keywords: [
      "smiley",
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    skins: [
      {
        unified: "1f63a",
        native: "😺",
        x: 33,
        y: 20
      }
    ],
    version: 1
  },
  smile_cat: {
    id: "smile_cat",
    name: "Grinning Cat with Smiling Eyes",
    keywords: [
      "smile",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f638",
        native: "😸",
        x: 33,
        y: 18
      }
    ],
    version: 1
  },
  joy_cat: {
    id: "joy_cat",
    name: "Cat with Tears of Joy",
    keywords: [
      "animal",
      "cats",
      "haha",
      "happy"
    ],
    skins: [
      {
        unified: "1f639",
        native: "😹",
        x: 33,
        y: 19
      }
    ],
    version: 1
  },
  heart_eyes_cat: {
    id: "heart_eyes_cat",
    name: "Smiling Cat with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines"
    ],
    skins: [
      {
        unified: "1f63b",
        native: "😻",
        x: 33,
        y: 21
      }
    ],
    version: 1
  },
  smirk_cat: {
    id: "smirk_cat",
    name: "Cat with Wry Smile",
    keywords: [
      "smirk",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63c",
        native: "😼",
        x: 33,
        y: 22
      }
    ],
    version: 1
  },
  kissing_cat: {
    id: "kissing_cat",
    name: "Kissing Cat",
    keywords: [
      "animal",
      "cats",
      "kiss"
    ],
    skins: [
      {
        unified: "1f63d",
        native: "😽",
        x: 33,
        y: 23
      }
    ],
    version: 1
  },
  scream_cat: {
    id: "scream_cat",
    name: "Weary Cat",
    keywords: [
      "scream",
      "animal",
      "cats",
      "munch",
      "scared"
    ],
    skins: [
      {
        unified: "1f640",
        native: "🙀",
        x: 33,
        y: 26
      }
    ],
    version: 1
  },
  crying_cat_face: {
    id: "crying_cat_face",
    name: "Crying Cat",
    keywords: [
      "face",
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    skins: [
      {
        unified: "1f63f",
        native: "😿",
        x: 33,
        y: 25
      }
    ],
    version: 1
  },
  pouting_cat: {
    id: "pouting_cat",
    name: "Pouting Cat",
    keywords: [
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63e",
        native: "😾",
        x: 33,
        y: 24
      }
    ],
    version: 1
  },
  see_no_evil: {
    id: "see_no_evil",
    name: "See-No-Evil Monkey",
    keywords: [
      "see",
      "no",
      "evil",
      "animal",
      "nature",
      "haha"
    ],
    skins: [
      {
        unified: "1f648",
        native: "🙈",
        x: 34,
        y: 24
      }
    ],
    version: 1
  },
  hear_no_evil: {
    id: "hear_no_evil",
    name: "Hear-No-Evil Monkey",
    keywords: [
      "hear",
      "no",
      "evil",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f649",
        native: "🙉",
        x: 34,
        y: 25
      }
    ],
    version: 1
  },
  speak_no_evil: {
    id: "speak_no_evil",
    name: "Speak-No-Evil Monkey",
    keywords: [
      "speak",
      "no",
      "evil",
      "animal",
      "nature",
      "omg"
    ],
    skins: [
      {
        unified: "1f64a",
        native: "🙊",
        x: 34,
        y: 26
      }
    ],
    version: 1
  },
  kiss: {
    id: "kiss",
    name: "Kiss Mark",
    keywords: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48b",
        native: "💋",
        x: 26,
        y: 37
      }
    ],
    version: 1
  },
  love_letter: {
    id: "love_letter",
    name: "Love Letter",
    keywords: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48c",
        native: "💌",
        x: 26,
        y: 38
      }
    ],
    version: 1
  },
  cupid: {
    id: "cupid",
    name: "Heart with Arrow",
    keywords: [
      "cupid",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f498",
        native: "💘",
        x: 27,
        y: 39
      }
    ],
    version: 1
  },
  gift_heart: {
    id: "gift_heart",
    name: "Heart with Ribbon",
    keywords: [
      "gift",
      "love",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49d",
        native: "💝",
        x: 27,
        y: 44
      }
    ],
    version: 1
  },
  sparkling_heart: {
    id: "sparkling_heart",
    name: "Sparkling Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f496",
        native: "💖",
        x: 27,
        y: 37
      }
    ],
    version: 1
  },
  heartpulse: {
    id: "heartpulse",
    name: "Growing Heart",
    keywords: [
      "heartpulse",
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f497",
        native: "💗",
        x: 27,
        y: 38
      }
    ],
    version: 1
  },
  heartbeat: {
    id: "heartbeat",
    name: "Beating Heart",
    keywords: [
      "heartbeat",
      "love",
      "like",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f493",
        native: "💓",
        x: 27,
        y: 34
      }
    ],
    version: 1
  },
  revolving_hearts: {
    id: "revolving_hearts",
    name: "Revolving Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49e",
        native: "💞",
        x: 27,
        y: 45
      }
    ],
    version: 1
  },
  two_hearts: {
    id: "two_hearts",
    name: "Two Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    skins: [
      {
        unified: "1f495",
        native: "💕",
        x: 27,
        y: 36
      }
    ],
    version: 1
  },
  heart_decoration: {
    id: "heart_decoration",
    name: "Heart Decoration",
    keywords: [
      "purple",
      "square",
      "love",
      "like"
    ],
    skins: [
      {
        unified: "1f49f",
        native: "💟",
        x: 27,
        y: 46
      }
    ],
    version: 1
  },
  heavy_heart_exclamation_mark_ornament: {
    id: "heavy_heart_exclamation_mark_ornament",
    name: "Heart Exclamation",
    keywords: [
      "heavy",
      "mark",
      "ornament",
      "decoration",
      "love"
    ],
    skins: [
      {
        unified: "2763-fe0f",
        native: "❣️",
        x: 59,
        y: 7
      }
    ],
    version: 1
  },
  broken_heart: {
    id: "broken_heart",
    name: "Broken Heart",
    emoticons: [
      "</3"
    ],
    keywords: [
      "sad",
      "sorry",
      "break",
      "heartbreak"
    ],
    skins: [
      {
        unified: "1f494",
        native: "💔",
        x: 27,
        y: 35
      }
    ],
    version: 1
  },
  heart_on_fire: {
    id: "heart_on_fire",
    name: "Heart on Fire",
    keywords: [
      "passionate",
      "enthusiastic"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1f525",
        native: "❤️‍🔥",
        x: 59,
        y: 8
      }
    ],
    version: 13.1
  },
  mending_heart: {
    id: "mending_heart",
    name: "Mending Heart",
    keywords: [
      "broken",
      "bandage",
      "wounded"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1fa79",
        native: "❤️‍🩹",
        x: 59,
        y: 9
      }
    ],
    version: 13.1
  },
  heart: {
    id: "heart",
    name: "Red Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "valentines"
    ],
    skins: [
      {
        unified: "2764-fe0f",
        native: "❤️",
        x: 59,
        y: 10
      }
    ],
    version: 1
  },
  orange_heart: {
    id: "orange_heart",
    name: "Orange Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f9e1",
        native: "🧡",
        x: 53,
        y: 15
      }
    ],
    version: 5
  },
  yellow_heart: {
    id: "yellow_heart",
    name: "Yellow Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49b",
        native: "💛",
        x: 27,
        y: 42
      }
    ],
    version: 1
  },
  green_heart: {
    id: "green_heart",
    name: "Green Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49a",
        native: "💚",
        x: 27,
        y: 41
      }
    ],
    version: 1
  },
  blue_heart: {
    id: "blue_heart",
    name: "Blue Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f499",
        native: "💙",
        x: 27,
        y: 40
      }
    ],
    version: 1
  },
  purple_heart: {
    id: "purple_heart",
    name: "Purple Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49c",
        native: "💜",
        x: 27,
        y: 43
      }
    ],
    version: 1
  },
  brown_heart: {
    id: "brown_heart",
    name: "Brown Heart",
    keywords: [
      "coffee"
    ],
    skins: [
      {
        unified: "1f90e",
        native: "🤎",
        x: 38,
        y: 51
      }
    ],
    version: 12
  },
  black_heart: {
    id: "black_heart",
    name: "Black Heart",
    keywords: [
      "evil"
    ],
    skins: [
      {
        unified: "1f5a4",
        native: "🖤",
        x: 31,
        y: 55
      }
    ],
    version: 3
  },
  white_heart: {
    id: "white_heart",
    name: "White Heart",
    keywords: [
      "pure"
    ],
    skins: [
      {
        unified: "1f90d",
        native: "🤍",
        x: 38,
        y: 50
      }
    ],
    version: 12
  },
  anger: {
    id: "anger",
    name: "Anger Symbol",
    keywords: [
      "angry",
      "mad"
    ],
    skins: [
      {
        unified: "1f4a2",
        native: "💢",
        x: 27,
        y: 49
      }
    ],
    version: 1
  },
  boom: {
    id: "boom",
    name: "Collision",
    keywords: [
      "boom",
      "bomb",
      "explode",
      "explosion",
      "blown"
    ],
    skins: [
      {
        unified: "1f4a5",
        native: "💥",
        x: 27,
        y: 52
      }
    ],
    version: 1
  },
  dizzy: {
    id: "dizzy",
    name: "Dizzy",
    keywords: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    skins: [
      {
        unified: "1f4ab",
        native: "💫",
        x: 28,
        y: 2
      }
    ],
    version: 1
  },
  sweat_drops: {
    id: "sweat_drops",
    name: "Sweat Droplets",
    keywords: [
      "drops",
      "water",
      "drip",
      "oops"
    ],
    skins: [
      {
        unified: "1f4a6",
        native: "💦",
        x: 27,
        y: 53
      }
    ],
    version: 1
  },
  dash: {
    id: "dash",
    name: "Dash Symbol",
    keywords: [
      "dashing",
      "away",
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    skins: [
      {
        unified: "1f4a8",
        native: "💨",
        x: 27,
        y: 55
      }
    ],
    version: 1
  },
  hole: {
    id: "hole",
    name: "Hole",
    keywords: [
      "embarrassing"
    ],
    skins: [
      {
        unified: "1f573-fe0f",
        native: "🕳️",
        x: 30,
        y: 58
      }
    ],
    version: 1
  },
  bomb: {
    id: "bomb",
    name: "Bomb",
    keywords: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    skins: [
      {
        unified: "1f4a3",
        native: "💣",
        x: 27,
        y: 50
      }
    ],
    version: 1
  },
  speech_balloon: {
    id: "speech_balloon",
    name: "Speech Balloon",
    keywords: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f4ac",
        native: "💬",
        x: 28,
        y: 3
      }
    ],
    version: 1
  },
  "eye-in-speech-bubble": {
    id: "eye-in-speech-bubble",
    name: "Eye in Speech Bubble",
    keywords: [
      "in-speech-bubble",
      "info"
    ],
    skins: [
      {
        unified: "1f441-fe0f-200d-1f5e8-fe0f",
        native: "👁️‍🗨️",
        x: 11,
        y: 53
      }
    ],
    version: 2
  },
  left_speech_bubble: {
    id: "left_speech_bubble",
    name: "Left Speech Bubble",
    keywords: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f5e8-fe0f",
        native: "🗨️",
        x: 32,
        y: 11
      }
    ],
    version: 2
  },
  right_anger_bubble: {
    id: "right_anger_bubble",
    name: "Right Anger Bubble",
    keywords: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    skins: [
      {
        unified: "1f5ef-fe0f",
        native: "🗯️",
        x: 32,
        y: 12
      }
    ],
    version: 1
  },
  thought_balloon: {
    id: "thought_balloon",
    name: "Thought Balloon",
    keywords: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    skins: [
      {
        unified: "1f4ad",
        native: "💭",
        x: 28,
        y: 4
      }
    ],
    version: 1
  },
  zzz: {
    id: "zzz",
    name: "Zzz",
    keywords: [
      "sleepy",
      "tired",
      "dream"
    ],
    skins: [
      {
        unified: "1f4a4",
        native: "💤",
        x: 27,
        y: 51
      }
    ],
    version: 1
  },
  wave: {
    id: "wave",
    name: "Waving Hand",
    keywords: [
      "wave",
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    skins: [
      {
        unified: "1f44b",
        native: "👋",
        x: 12,
        y: 38
      },
      {
        unified: "1f44b-1f3fb",
        native: "👋🏻",
        x: 12,
        y: 39
      },
      {
        unified: "1f44b-1f3fc",
        native: "👋🏼",
        x: 12,
        y: 40
      },
      {
        unified: "1f44b-1f3fd",
        native: "👋🏽",
        x: 12,
        y: 41
      },
      {
        unified: "1f44b-1f3fe",
        native: "👋🏾",
        x: 12,
        y: 42
      },
      {
        unified: "1f44b-1f3ff",
        native: "👋🏿",
        x: 12,
        y: 43
      }
    ],
    version: 1
  },
  raised_back_of_hand: {
    id: "raised_back_of_hand",
    name: "Raised Back of Hand",
    keywords: [
      "fingers",
      "backhand"
    ],
    skins: [
      {
        unified: "1f91a",
        native: "🤚",
        x: 39,
        y: 17
      },
      {
        unified: "1f91a-1f3fb",
        native: "🤚🏻",
        x: 39,
        y: 18
      },
      {
        unified: "1f91a-1f3fc",
        native: "🤚🏼",
        x: 39,
        y: 19
      },
      {
        unified: "1f91a-1f3fd",
        native: "🤚🏽",
        x: 39,
        y: 20
      },
      {
        unified: "1f91a-1f3fe",
        native: "🤚🏾",
        x: 39,
        y: 21
      },
      {
        unified: "1f91a-1f3ff",
        native: "🤚🏿",
        x: 39,
        y: 22
      }
    ],
    version: 3
  },
  raised_hand_with_fingers_splayed: {
    id: "raised_hand_with_fingers_splayed",
    name: "Hand with Fingers Splayed",
    keywords: [
      "raised",
      "palm"
    ],
    skins: [
      {
        unified: "1f590-fe0f",
        native: "🖐️",
        x: 31,
        y: 37
      },
      {
        unified: "1f590-1f3fb",
        native: "🖐🏻",
        x: 31,
        y: 38
      },
      {
        unified: "1f590-1f3fc",
        native: "🖐🏼",
        x: 31,
        y: 39
      },
      {
        unified: "1f590-1f3fd",
        native: "🖐🏽",
        x: 31,
        y: 40
      },
      {
        unified: "1f590-1f3fe",
        native: "🖐🏾",
        x: 31,
        y: 41
      },
      {
        unified: "1f590-1f3ff",
        native: "🖐🏿",
        x: 31,
        y: 42
      }
    ],
    version: 1
  },
  hand: {
    id: "hand",
    name: "Raised Hand",
    keywords: [
      "fingers",
      "stop",
      "highfive",
      "high",
      "five",
      "palm",
      "ban"
    ],
    skins: [
      {
        unified: "270b",
        native: "✋",
        x: 58,
        y: 33
      },
      {
        unified: "270b-1f3fb",
        native: "✋🏻",
        x: 58,
        y: 34
      },
      {
        unified: "270b-1f3fc",
        native: "✋🏼",
        x: 58,
        y: 35
      },
      {
        unified: "270b-1f3fd",
        native: "✋🏽",
        x: 58,
        y: 36
      },
      {
        unified: "270b-1f3fe",
        native: "✋🏾",
        x: 58,
        y: 37
      },
      {
        unified: "270b-1f3ff",
        native: "✋🏿",
        x: 58,
        y: 38
      }
    ],
    version: 1
  },
  "spock-hand": {
    id: "spock-hand",
    name: "Vulcan Salute",
    keywords: [
      "spock",
      "hand",
      "fingers",
      "star",
      "trek"
    ],
    skins: [
      {
        unified: "1f596",
        native: "🖖",
        x: 31,
        y: 49
      },
      {
        unified: "1f596-1f3fb",
        native: "🖖🏻",
        x: 31,
        y: 50
      },
      {
        unified: "1f596-1f3fc",
        native: "🖖🏼",
        x: 31,
        y: 51
      },
      {
        unified: "1f596-1f3fd",
        native: "🖖🏽",
        x: 31,
        y: 52
      },
      {
        unified: "1f596-1f3fe",
        native: "🖖🏾",
        x: 31,
        y: 53
      },
      {
        unified: "1f596-1f3ff",
        native: "🖖🏿",
        x: 31,
        y: 54
      }
    ],
    version: 1
  },
  rightwards_hand: {
    id: "rightwards_hand",
    name: "Rightwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf1",
        native: "🫱",
        x: 55,
        y: 26
      },
      {
        unified: "1faf1-1f3fb",
        native: "🫱🏻",
        x: 55,
        y: 27
      },
      {
        unified: "1faf1-1f3fc",
        native: "🫱🏼",
        x: 55,
        y: 28
      },
      {
        unified: "1faf1-1f3fd",
        native: "🫱🏽",
        x: 55,
        y: 29
      },
      {
        unified: "1faf1-1f3fe",
        native: "🫱🏾",
        x: 55,
        y: 30
      },
      {
        unified: "1faf1-1f3ff",
        native: "🫱🏿",
        x: 55,
        y: 31
      }
    ],
    version: 14
  },
  leftwards_hand: {
    id: "leftwards_hand",
    name: "Leftwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf2",
        native: "🫲",
        x: 55,
        y: 32
      },
      {
        unified: "1faf2-1f3fb",
        native: "🫲🏻",
        x: 55,
        y: 33
      },
      {
        unified: "1faf2-1f3fc",
        native: "🫲🏼",
        x: 55,
        y: 34
      },
      {
        unified: "1faf2-1f3fd",
        native: "🫲🏽",
        x: 55,
        y: 35
      },
      {
        unified: "1faf2-1f3fe",
        native: "🫲🏾",
        x: 55,
        y: 36
      },
      {
        unified: "1faf2-1f3ff",
        native: "🫲🏿",
        x: 55,
        y: 37
      }
    ],
    version: 14
  },
  palm_down_hand: {
    id: "palm_down_hand",
    name: "Palm Down Hand",
    keywords: [
      "drop"
    ],
    skins: [
      {
        unified: "1faf3",
        native: "🫳",
        x: 55,
        y: 38
      },
      {
        unified: "1faf3-1f3fb",
        native: "🫳🏻",
        x: 55,
        y: 39
      },
      {
        unified: "1faf3-1f3fc",
        native: "🫳🏼",
        x: 55,
        y: 40
      },
      {
        unified: "1faf3-1f3fd",
        native: "🫳🏽",
        x: 55,
        y: 41
      },
      {
        unified: "1faf3-1f3fe",
        native: "🫳🏾",
        x: 55,
        y: 42
      },
      {
        unified: "1faf3-1f3ff",
        native: "🫳🏿",
        x: 55,
        y: 43
      }
    ],
    version: 14
  },
  palm_up_hand: {
    id: "palm_up_hand",
    name: "Palm Up Hand",
    keywords: [
      "lift",
      "offer",
      "demand"
    ],
    skins: [
      {
        unified: "1faf4",
        native: "🫴",
        x: 55,
        y: 44
      },
      {
        unified: "1faf4-1f3fb",
        native: "🫴🏻",
        x: 55,
        y: 45
      },
      {
        unified: "1faf4-1f3fc",
        native: "🫴🏼",
        x: 55,
        y: 46
      },
      {
        unified: "1faf4-1f3fd",
        native: "🫴🏽",
        x: 55,
        y: 47
      },
      {
        unified: "1faf4-1f3fe",
        native: "🫴🏾",
        x: 55,
        y: 48
      },
      {
        unified: "1faf4-1f3ff",
        native: "🫴🏿",
        x: 55,
        y: 49
      }
    ],
    version: 14
  },
  ok_hand: {
    id: "ok_hand",
    name: "Ok Hand",
    keywords: [
      "fingers",
      "limbs",
      "perfect",
      "okay"
    ],
    skins: [
      {
        unified: "1f44c",
        native: "👌",
        x: 12,
        y: 44
      },
      {
        unified: "1f44c-1f3fb",
        native: "👌🏻",
        x: 12,
        y: 45
      },
      {
        unified: "1f44c-1f3fc",
        native: "👌🏼",
        x: 12,
        y: 46
      },
      {
        unified: "1f44c-1f3fd",
        native: "👌🏽",
        x: 12,
        y: 47
      },
      {
        unified: "1f44c-1f3fe",
        native: "👌🏾",
        x: 12,
        y: 48
      },
      {
        unified: "1f44c-1f3ff",
        native: "👌🏿",
        x: 12,
        y: 49
      }
    ],
    version: 1
  },
  pinched_fingers: {
    id: "pinched_fingers",
    name: "Pinched Fingers",
    keywords: [
      "size",
      "tiny",
      "small"
    ],
    skins: [
      {
        unified: "1f90c",
        native: "🤌",
        x: 38,
        y: 44
      },
      {
        unified: "1f90c-1f3fb",
        native: "🤌🏻",
        x: 38,
        y: 45
      },
      {
        unified: "1f90c-1f3fc",
        native: "🤌🏼",
        x: 38,
        y: 46
      },
      {
        unified: "1f90c-1f3fd",
        native: "🤌🏽",
        x: 38,
        y: 47
      },
      {
        unified: "1f90c-1f3fe",
        native: "🤌🏾",
        x: 38,
        y: 48
      },
      {
        unified: "1f90c-1f3ff",
        native: "🤌🏿",
        x: 38,
        y: 49
      }
    ],
    version: 13
  },
  pinching_hand: {
    id: "pinching_hand",
    name: "Pinching Hand",
    keywords: [
      "tiny",
      "small",
      "size"
    ],
    skins: [
      {
        unified: "1f90f",
        native: "🤏",
        x: 38,
        y: 52
      },
      {
        unified: "1f90f-1f3fb",
        native: "🤏🏻",
        x: 38,
        y: 53
      },
      {
        unified: "1f90f-1f3fc",
        native: "🤏🏼",
        x: 38,
        y: 54
      },
      {
        unified: "1f90f-1f3fd",
        native: "🤏🏽",
        x: 38,
        y: 55
      },
      {
        unified: "1f90f-1f3fe",
        native: "🤏🏾",
        x: 38,
        y: 56
      },
      {
        unified: "1f90f-1f3ff",
        native: "🤏🏿",
        x: 38,
        y: 57
      }
    ],
    version: 12
  },
  v: {
    id: "v",
    name: "Victory Hand",
    keywords: [
      "v",
      "fingers",
      "ohyeah",
      "peace",
      "two"
    ],
    skins: [
      {
        unified: "270c-fe0f",
        native: "✌️",
        x: 58,
        y: 39
      },
      {
        unified: "270c-1f3fb",
        native: "✌🏻",
        x: 58,
        y: 40
      },
      {
        unified: "270c-1f3fc",
        native: "✌🏼",
        x: 58,
        y: 41
      },
      {
        unified: "270c-1f3fd",
        native: "✌🏽",
        x: 58,
        y: 42
      },
      {
        unified: "270c-1f3fe",
        native: "✌🏾",
        x: 58,
        y: 43
      },
      {
        unified: "270c-1f3ff",
        native: "✌🏿",
        x: 58,
        y: 44
      }
    ],
    version: 1
  },
  crossed_fingers: {
    id: "crossed_fingers",
    name: "Crossed Fingers",
    keywords: [
      "hand",
      "with",
      "index",
      "and",
      "middle",
      "good",
      "lucky"
    ],
    skins: [
      {
        unified: "1f91e",
        native: "🤞",
        x: 40,
        y: 0
      },
      {
        unified: "1f91e-1f3fb",
        native: "🤞🏻",
        x: 40,
        y: 1
      },
      {
        unified: "1f91e-1f3fc",
        native: "🤞🏼",
        x: 40,
        y: 2
      },
      {
        unified: "1f91e-1f3fd",
        native: "🤞🏽",
        x: 40,
        y: 3
      },
      {
        unified: "1f91e-1f3fe",
        native: "🤞🏾",
        x: 40,
        y: 4
      },
      {
        unified: "1f91e-1f3ff",
        native: "🤞🏿",
        x: 40,
        y: 5
      }
    ],
    version: 3
  },
  hand_with_index_finger_and_thumb_crossed: {
    id: "hand_with_index_finger_and_thumb_crossed",
    name: "Hand with Index Finger and Thumb Crossed",
    keywords: [
      "heart",
      "love",
      "money",
      "expensive"
    ],
    skins: [
      {
        unified: "1faf0",
        native: "🫰",
        x: 55,
        y: 20
      },
      {
        unified: "1faf0-1f3fb",
        native: "🫰🏻",
        x: 55,
        y: 21
      },
      {
        unified: "1faf0-1f3fc",
        native: "🫰🏼",
        x: 55,
        y: 22
      },
      {
        unified: "1faf0-1f3fd",
        native: "🫰🏽",
        x: 55,
        y: 23
      },
      {
        unified: "1faf0-1f3fe",
        native: "🫰🏾",
        x: 55,
        y: 24
      },
      {
        unified: "1faf0-1f3ff",
        native: "🫰🏿",
        x: 55,
        y: 25
      }
    ],
    version: 14
  },
  i_love_you_hand_sign: {
    id: "i_love_you_hand_sign",
    name: "Love-You Gesture",
    keywords: [
      "i",
      "love",
      "you",
      "hand",
      "sign",
      "fingers"
    ],
    skins: [
      {
        unified: "1f91f",
        native: "🤟",
        x: 40,
        y: 6
      },
      {
        unified: "1f91f-1f3fb",
        native: "🤟🏻",
        x: 40,
        y: 7
      },
      {
        unified: "1f91f-1f3fc",
        native: "🤟🏼",
        x: 40,
        y: 8
      },
      {
        unified: "1f91f-1f3fd",
        native: "🤟🏽",
        x: 40,
        y: 9
      },
      {
        unified: "1f91f-1f3fe",
        native: "🤟🏾",
        x: 40,
        y: 10
      },
      {
        unified: "1f91f-1f3ff",
        native: "🤟🏿",
        x: 40,
        y: 11
      }
    ],
    version: 5
  },
  the_horns: {
    id: "the_horns",
    name: "Sign of the Horns",
    keywords: [
      "hand",
      "fingers",
      "evil",
      "eye",
      "rock",
      "on"
    ],
    skins: [
      {
        unified: "1f918",
        native: "🤘",
        x: 39,
        y: 5
      },
      {
        unified: "1f918-1f3fb",
        native: "🤘🏻",
        x: 39,
        y: 6
      },
      {
        unified: "1f918-1f3fc",
        native: "🤘🏼",
        x: 39,
        y: 7
      },
      {
        unified: "1f918-1f3fd",
        native: "🤘🏽",
        x: 39,
        y: 8
      },
      {
        unified: "1f918-1f3fe",
        native: "🤘🏾",
        x: 39,
        y: 9
      },
      {
        unified: "1f918-1f3ff",
        native: "🤘🏿",
        x: 39,
        y: 10
      }
    ],
    version: 1
  },
  call_me_hand: {
    id: "call_me_hand",
    name: "Call Me Hand",
    keywords: [
      "hands",
      "gesture",
      "shaka"
    ],
    skins: [
      {
        unified: "1f919",
        native: "🤙",
        x: 39,
        y: 11
      },
      {
        unified: "1f919-1f3fb",
        native: "🤙🏻",
        x: 39,
        y: 12
      },
      {
        unified: "1f919-1f3fc",
        native: "🤙🏼",
        x: 39,
        y: 13
      },
      {
        unified: "1f919-1f3fd",
        native: "🤙🏽",
        x: 39,
        y: 14
      },
      {
        unified: "1f919-1f3fe",
        native: "🤙🏾",
        x: 39,
        y: 15
      },
      {
        unified: "1f919-1f3ff",
        native: "🤙🏿",
        x: 39,
        y: 16
      }
    ],
    version: 3
  },
  point_left: {
    id: "point_left",
    name: "Backhand Index Pointing Left",
    keywords: [
      "point",
      "direction",
      "fingers",
      "hand"
    ],
    skins: [
      {
        unified: "1f448",
        native: "👈",
        x: 12,
        y: 20
      },
      {
        unified: "1f448-1f3fb",
        native: "👈🏻",
        x: 12,
        y: 21
      },
      {
        unified: "1f448-1f3fc",
        native: "👈🏼",
        x: 12,
        y: 22
      },
      {
        unified: "1f448-1f3fd",
        native: "👈🏽",
        x: 12,
        y: 23
      },
      {
        unified: "1f448-1f3fe",
        native: "👈🏾",
        x: 12,
        y: 24
      },
      {
        unified: "1f448-1f3ff",
        native: "👈🏿",
        x: 12,
        y: 25
      }
    ],
    version: 1
  },
  point_right: {
    id: "point_right",
    name: "Backhand Index Pointing Right",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f449",
        native: "👉",
        x: 12,
        y: 26
      },
      {
        unified: "1f449-1f3fb",
        native: "👉🏻",
        x: 12,
        y: 27
      },
      {
        unified: "1f449-1f3fc",
        native: "👉🏼",
        x: 12,
        y: 28
      },
      {
        unified: "1f449-1f3fd",
        native: "👉🏽",
        x: 12,
        y: 29
      },
      {
        unified: "1f449-1f3fe",
        native: "👉🏾",
        x: 12,
        y: 30
      },
      {
        unified: "1f449-1f3ff",
        native: "👉🏿",
        x: 12,
        y: 31
      }
    ],
    version: 1
  },
  point_up_2: {
    id: "point_up_2",
    name: "Backhand Index Pointing Up",
    keywords: [
      "point",
      "2",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f446",
        native: "👆",
        x: 12,
        y: 8
      },
      {
        unified: "1f446-1f3fb",
        native: "👆🏻",
        x: 12,
        y: 9
      },
      {
        unified: "1f446-1f3fc",
        native: "👆🏼",
        x: 12,
        y: 10
      },
      {
        unified: "1f446-1f3fd",
        native: "👆🏽",
        x: 12,
        y: 11
      },
      {
        unified: "1f446-1f3fe",
        native: "👆🏾",
        x: 12,
        y: 12
      },
      {
        unified: "1f446-1f3ff",
        native: "👆🏿",
        x: 12,
        y: 13
      }
    ],
    version: 1
  },
  middle_finger: {
    id: "middle_finger",
    name: "Middle Finger",
    keywords: [
      "reversed",
      "hand",
      "with",
      "extended",
      "fingers",
      "rude",
      "flipping"
    ],
    skins: [
      {
        unified: "1f595",
        native: "🖕",
        x: 31,
        y: 43
      },
      {
        unified: "1f595-1f3fb",
        native: "🖕🏻",
        x: 31,
        y: 44
      },
      {
        unified: "1f595-1f3fc",
        native: "🖕🏼",
        x: 31,
        y: 45
      },
      {
        unified: "1f595-1f3fd",
        native: "🖕🏽",
        x: 31,
        y: 46
      },
      {
        unified: "1f595-1f3fe",
        native: "🖕🏾",
        x: 31,
        y: 47
      },
      {
        unified: "1f595-1f3ff",
        native: "🖕🏿",
        x: 31,
        y: 48
      }
    ],
    version: 1
  },
  point_down: {
    id: "point_down",
    name: "Backhand Index Pointing Down",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f447",
        native: "👇",
        x: 12,
        y: 14
      },
      {
        unified: "1f447-1f3fb",
        native: "👇🏻",
        x: 12,
        y: 15
      },
      {
        unified: "1f447-1f3fc",
        native: "👇🏼",
        x: 12,
        y: 16
      },
      {
        unified: "1f447-1f3fd",
        native: "👇🏽",
        x: 12,
        y: 17
      },
      {
        unified: "1f447-1f3fe",
        native: "👇🏾",
        x: 12,
        y: 18
      },
      {
        unified: "1f447-1f3ff",
        native: "👇🏿",
        x: 12,
        y: 19
      }
    ],
    version: 1
  },
  point_up: {
    id: "point_up",
    name: "Index Pointing Up",
    keywords: [
      "point",
      "hand",
      "fingers",
      "direction"
    ],
    skins: [
      {
        unified: "261d-fe0f",
        native: "☝️",
        x: 56,
        y: 50
      },
      {
        unified: "261d-1f3fb",
        native: "☝🏻",
        x: 56,
        y: 51
      },
      {
        unified: "261d-1f3fc",
        native: "☝🏼",
        x: 56,
        y: 52
      },
      {
        unified: "261d-1f3fd",
        native: "☝🏽",
        x: 56,
        y: 53
      },
      {
        unified: "261d-1f3fe",
        native: "☝🏾",
        x: 56,
        y: 54
      },
      {
        unified: "261d-1f3ff",
        native: "☝🏿",
        x: 56,
        y: 55
      }
    ],
    version: 1
  },
  index_pointing_at_the_viewer: {
    id: "index_pointing_at_the_viewer",
    name: "Index Pointing at the Viewer",
    keywords: [
      "you",
      "recruit"
    ],
    skins: [
      {
        unified: "1faf5",
        native: "🫵",
        x: 55,
        y: 50
      },
      {
        unified: "1faf5-1f3fb",
        native: "🫵🏻",
        x: 55,
        y: 51
      },
      {
        unified: "1faf5-1f3fc",
        native: "🫵🏼",
        x: 55,
        y: 52
      },
      {
        unified: "1faf5-1f3fd",
        native: "🫵🏽",
        x: 55,
        y: 53
      },
      {
        unified: "1faf5-1f3fe",
        native: "🫵🏾",
        x: 55,
        y: 54
      },
      {
        unified: "1faf5-1f3ff",
        native: "🫵🏿",
        x: 55,
        y: 55
      }
    ],
    version: 14
  },
  "+1": {
    id: "+1",
    name: "Thumbs Up",
    keywords: [
      "+1",
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    skins: [
      {
        unified: "1f44d",
        native: "👍",
        x: 12,
        y: 50
      },
      {
        unified: "1f44d-1f3fb",
        native: "👍🏻",
        x: 12,
        y: 51
      },
      {
        unified: "1f44d-1f3fc",
        native: "👍🏼",
        x: 12,
        y: 52
      },
      {
        unified: "1f44d-1f3fd",
        native: "👍🏽",
        x: 12,
        y: 53
      },
      {
        unified: "1f44d-1f3fe",
        native: "👍🏾",
        x: 12,
        y: 54
      },
      {
        unified: "1f44d-1f3ff",
        native: "👍🏿",
        x: 12,
        y: 55
      }
    ],
    version: 1
  },
  "-1": {
    id: "-1",
    name: "Thumbs Down",
    keywords: [
      "-1",
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    skins: [
      {
        unified: "1f44e",
        native: "👎",
        x: 12,
        y: 56
      },
      {
        unified: "1f44e-1f3fb",
        native: "👎🏻",
        x: 12,
        y: 57
      },
      {
        unified: "1f44e-1f3fc",
        native: "👎🏼",
        x: 12,
        y: 58
      },
      {
        unified: "1f44e-1f3fd",
        native: "👎🏽",
        x: 12,
        y: 59
      },
      {
        unified: "1f44e-1f3fe",
        native: "👎🏾",
        x: 12,
        y: 60
      },
      {
        unified: "1f44e-1f3ff",
        native: "👎🏿",
        x: 13,
        y: 0
      }
    ],
    version: 1
  },
  fist: {
    id: "fist",
    name: "Raised Fist",
    keywords: [
      "fingers",
      "hand",
      "grasp"
    ],
    skins: [
      {
        unified: "270a",
        native: "✊",
        x: 58,
        y: 27
      },
      {
        unified: "270a-1f3fb",
        native: "✊🏻",
        x: 58,
        y: 28
      },
      {
        unified: "270a-1f3fc",
        native: "✊🏼",
        x: 58,
        y: 29
      },
      {
        unified: "270a-1f3fd",
        native: "✊🏽",
        x: 58,
        y: 30
      },
      {
        unified: "270a-1f3fe",
        native: "✊🏾",
        x: 58,
        y: 31
      },
      {
        unified: "270a-1f3ff",
        native: "✊🏿",
        x: 58,
        y: 32
      }
    ],
    version: 1
  },
  facepunch: {
    id: "facepunch",
    name: "Oncoming Fist",
    keywords: [
      "facepunch",
      "punch",
      "angry",
      "violence",
      "hit",
      "attack",
      "hand"
    ],
    skins: [
      {
        unified: "1f44a",
        native: "👊",
        x: 12,
        y: 32
      },
      {
        unified: "1f44a-1f3fb",
        native: "👊🏻",
        x: 12,
        y: 33
      },
      {
        unified: "1f44a-1f3fc",
        native: "👊🏼",
        x: 12,
        y: 34
      },
      {
        unified: "1f44a-1f3fd",
        native: "👊🏽",
        x: 12,
        y: 35
      },
      {
        unified: "1f44a-1f3fe",
        native: "👊🏾",
        x: 12,
        y: 36
      },
      {
        unified: "1f44a-1f3ff",
        native: "👊🏿",
        x: 12,
        y: 37
      }
    ],
    version: 1
  },
  "left-facing_fist": {
    id: "left-facing_fist",
    name: "Left-Facing Fist",
    keywords: [
      "left",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91b",
        native: "🤛",
        x: 39,
        y: 23
      },
      {
        unified: "1f91b-1f3fb",
        native: "🤛🏻",
        x: 39,
        y: 24
      },
      {
        unified: "1f91b-1f3fc",
        native: "🤛🏼",
        x: 39,
        y: 25
      },
      {
        unified: "1f91b-1f3fd",
        native: "🤛🏽",
        x: 39,
        y: 26
      },
      {
        unified: "1f91b-1f3fe",
        native: "🤛🏾",
        x: 39,
        y: 27
      },
      {
        unified: "1f91b-1f3ff",
        native: "🤛🏿",
        x: 39,
        y: 28
      }
    ],
    version: 3
  },
  "right-facing_fist": {
    id: "right-facing_fist",
    name: "Right-Facing Fist",
    keywords: [
      "right",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91c",
        native: "🤜",
        x: 39,
        y: 29
      },
      {
        unified: "1f91c-1f3fb",
        native: "🤜🏻",
        x: 39,
        y: 30
      },
      {
        unified: "1f91c-1f3fc",
        native: "🤜🏼",
        x: 39,
        y: 31
      },
      {
        unified: "1f91c-1f3fd",
        native: "🤜🏽",
        x: 39,
        y: 32
      },
      {
        unified: "1f91c-1f3fe",
        native: "🤜🏾",
        x: 39,
        y: 33
      },
      {
        unified: "1f91c-1f3ff",
        native: "🤜🏿",
        x: 39,
        y: 34
      }
    ],
    version: 3
  },
  clap: {
    id: "clap",
    name: "Clapping Hands",
    keywords: [
      "clap",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    skins: [
      {
        unified: "1f44f",
        native: "👏",
        x: 13,
        y: 1
      },
      {
        unified: "1f44f-1f3fb",
        native: "👏🏻",
        x: 13,
        y: 2
      },
      {
        unified: "1f44f-1f3fc",
        native: "👏🏼",
        x: 13,
        y: 3
      },
      {
        unified: "1f44f-1f3fd",
        native: "👏🏽",
        x: 13,
        y: 4
      },
      {
        unified: "1f44f-1f3fe",
        native: "👏🏾",
        x: 13,
        y: 5
      },
      {
        unified: "1f44f-1f3ff",
        native: "👏🏿",
        x: 13,
        y: 6
      }
    ],
    version: 1
  },
  raised_hands: {
    id: "raised_hands",
    name: "Raising Hands",
    keywords: [
      "raised",
      "gesture",
      "hooray",
      "yea",
      "celebration"
    ],
    skins: [
      {
        unified: "1f64c",
        native: "🙌",
        x: 34,
        y: 45
      },
      {
        unified: "1f64c-1f3fb",
        native: "🙌🏻",
        x: 34,
        y: 46
      },
      {
        unified: "1f64c-1f3fc",
        native: "🙌🏼",
        x: 34,
        y: 47
      },
      {
        unified: "1f64c-1f3fd",
        native: "🙌🏽",
        x: 34,
        y: 48
      },
      {
        unified: "1f64c-1f3fe",
        native: "🙌🏾",
        x: 34,
        y: 49
      },
      {
        unified: "1f64c-1f3ff",
        native: "🙌🏿",
        x: 34,
        y: 50
      }
    ],
    version: 1
  },
  heart_hands: {
    id: "heart_hands",
    name: "Heart Hands",
    keywords: [
      "love",
      "appreciation",
      "support"
    ],
    skins: [
      {
        unified: "1faf6",
        native: "🫶",
        x: 55,
        y: 56
      },
      {
        unified: "1faf6-1f3fb",
        native: "🫶🏻",
        x: 55,
        y: 57
      },
      {
        unified: "1faf6-1f3fc",
        native: "🫶🏼",
        x: 55,
        y: 58
      },
      {
        unified: "1faf6-1f3fd",
        native: "🫶🏽",
        x: 55,
        y: 59
      },
      {
        unified: "1faf6-1f3fe",
        native: "🫶🏾",
        x: 55,
        y: 60
      },
      {
        unified: "1faf6-1f3ff",
        native: "🫶🏿",
        x: 56,
        y: 0
      }
    ],
    version: 14
  },
  open_hands: {
    id: "open_hands",
    name: "Open Hands",
    keywords: [
      "fingers",
      "butterfly"
    ],
    skins: [
      {
        unified: "1f450",
        native: "👐",
        x: 13,
        y: 7
      },
      {
        unified: "1f450-1f3fb",
        native: "👐🏻",
        x: 13,
        y: 8
      },
      {
        unified: "1f450-1f3fc",
        native: "👐🏼",
        x: 13,
        y: 9
      },
      {
        unified: "1f450-1f3fd",
        native: "👐🏽",
        x: 13,
        y: 10
      },
      {
        unified: "1f450-1f3fe",
        native: "👐🏾",
        x: 13,
        y: 11
      },
      {
        unified: "1f450-1f3ff",
        native: "👐🏿",
        x: 13,
        y: 12
      }
    ],
    version: 1
  },
  palms_up_together: {
    id: "palms_up_together",
    name: "Palms Up Together",
    keywords: [
      "hands",
      "gesture",
      "cupped",
      "prayer"
    ],
    skins: [
      {
        unified: "1f932",
        native: "🤲",
        x: 40,
        y: 57
      },
      {
        unified: "1f932-1f3fb",
        native: "🤲🏻",
        x: 40,
        y: 58
      },
      {
        unified: "1f932-1f3fc",
        native: "🤲🏼",
        x: 40,
        y: 59
      },
      {
        unified: "1f932-1f3fd",
        native: "🤲🏽",
        x: 40,
        y: 60
      },
      {
        unified: "1f932-1f3fe",
        native: "🤲🏾",
        x: 41,
        y: 0
      },
      {
        unified: "1f932-1f3ff",
        native: "🤲🏿",
        x: 41,
        y: 1
      }
    ],
    version: 5
  },
  handshake: {
    id: "handshake",
    name: "Handshake",
    keywords: [
      "agreement",
      "shake"
    ],
    skins: [
      {
        unified: "1f91d",
        native: "🤝",
        x: 39,
        y: 35
      },
      {
        unified: "1f91d-1f3fb",
        native: "🤝🏻",
        x: 39,
        y: 36
      },
      {
        unified: "1f91d-1f3fc",
        native: "🤝🏼",
        x: 39,
        y: 37
      },
      {
        unified: "1f91d-1f3fd",
        native: "🤝🏽",
        x: 39,
        y: 38
      },
      {
        unified: "1f91d-1f3fe",
        native: "🤝🏾",
        x: 39,
        y: 39
      },
      {
        unified: "1f91d-1f3ff",
        native: "🤝🏿",
        x: 39,
        y: 40
      }
    ],
    version: 3
  },
  pray: {
    id: "pray",
    name: "Folded Hands",
    keywords: [
      "pray",
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive",
      "high",
      "five"
    ],
    skins: [
      {
        unified: "1f64f",
        native: "🙏",
        x: 35,
        y: 26
      },
      {
        unified: "1f64f-1f3fb",
        native: "🙏🏻",
        x: 35,
        y: 27
      },
      {
        unified: "1f64f-1f3fc",
        native: "🙏🏼",
        x: 35,
        y: 28
      },
      {
        unified: "1f64f-1f3fd",
        native: "🙏🏽",
        x: 35,
        y: 29
      },
      {
        unified: "1f64f-1f3fe",
        native: "🙏🏾",
        x: 35,
        y: 30
      },
      {
        unified: "1f64f-1f3ff",
        native: "🙏🏿",
        x: 35,
        y: 31
      }
    ],
    version: 1
  },
  writing_hand: {
    id: "writing_hand",
    name: "Writing Hand",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "pen",
      "stationery",
      "write",
      "compose"
    ],
    skins: [
      {
        unified: "270d-fe0f",
        native: "✍️",
        x: 58,
        y: 45
      },
      {
        unified: "270d-1f3fb",
        native: "✍🏻",
        x: 58,
        y: 46
      },
      {
        unified: "270d-1f3fc",
        native: "✍🏼",
        x: 58,
        y: 47
      },
      {
        unified: "270d-1f3fd",
        native: "✍🏽",
        x: 58,
        y: 48
      },
      {
        unified: "270d-1f3fe",
        native: "✍🏾",
        x: 58,
        y: 49
      },
      {
        unified: "270d-1f3ff",
        native: "✍🏿",
        x: 58,
        y: 50
      }
    ],
    version: 1
  },
  nail_care: {
    id: "nail_care",
    name: "Nail Polish",
    keywords: [
      "care",
      "beauty",
      "manicure",
      "finger",
      "fashion"
    ],
    skins: [
      {
        unified: "1f485",
        native: "💅",
        x: 25,
        y: 53
      },
      {
        unified: "1f485-1f3fb",
        native: "💅🏻",
        x: 25,
        y: 54
      },
      {
        unified: "1f485-1f3fc",
        native: "💅🏼",
        x: 25,
        y: 55
      },
      {
        unified: "1f485-1f3fd",
        native: "💅🏽",
        x: 25,
        y: 56
      },
      {
        unified: "1f485-1f3fe",
        native: "💅🏾",
        x: 25,
        y: 57
      },
      {
        unified: "1f485-1f3ff",
        native: "💅🏿",
        x: 25,
        y: 58
      }
    ],
    version: 1
  },
  selfie: {
    id: "selfie",
    name: "Selfie",
    keywords: [
      "camera",
      "phone"
    ],
    skins: [
      {
        unified: "1f933",
        native: "🤳",
        x: 41,
        y: 2
      },
      {
        unified: "1f933-1f3fb",
        native: "🤳🏻",
        x: 41,
        y: 3
      },
      {
        unified: "1f933-1f3fc",
        native: "🤳🏼",
        x: 41,
        y: 4
      },
      {
        unified: "1f933-1f3fd",
        native: "🤳🏽",
        x: 41,
        y: 5
      },
      {
        unified: "1f933-1f3fe",
        native: "🤳🏾",
        x: 41,
        y: 6
      },
      {
        unified: "1f933-1f3ff",
        native: "🤳🏿",
        x: 41,
        y: 7
      }
    ],
    version: 3
  },
  muscle: {
    id: "muscle",
    name: "Flexed Biceps",
    keywords: [
      "muscle",
      "arm",
      "flex",
      "hand",
      "summer",
      "strong"
    ],
    skins: [
      {
        unified: "1f4aa",
        native: "💪",
        x: 27,
        y: 57
      },
      {
        unified: "1f4aa-1f3fb",
        native: "💪🏻",
        x: 27,
        y: 58
      },
      {
        unified: "1f4aa-1f3fc",
        native: "💪🏼",
        x: 27,
        y: 59
      },
      {
        unified: "1f4aa-1f3fd",
        native: "💪🏽",
        x: 27,
        y: 60
      },
      {
        unified: "1f4aa-1f3fe",
        native: "💪🏾",
        x: 28,
        y: 0
      },
      {
        unified: "1f4aa-1f3ff",
        native: "💪🏿",
        x: 28,
        y: 1
      }
    ],
    version: 1
  },
  mechanical_arm: {
    id: "mechanical_arm",
    name: "Mechanical Arm",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9be",
        native: "🦾",
        x: 46,
        y: 3
      }
    ],
    version: 12
  },
  mechanical_leg: {
    id: "mechanical_leg",
    name: "Mechanical Leg",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bf",
        native: "🦿",
        x: 46,
        y: 4
      }
    ],
    version: 12
  },
  leg: {
    id: "leg",
    name: "Leg",
    keywords: [
      "kick",
      "limb"
    ],
    skins: [
      {
        unified: "1f9b5",
        native: "🦵",
        x: 45,
        y: 6
      },
      {
        unified: "1f9b5-1f3fb",
        native: "🦵🏻",
        x: 45,
        y: 7
      },
      {
        unified: "1f9b5-1f3fc",
        native: "🦵🏼",
        x: 45,
        y: 8
      },
      {
        unified: "1f9b5-1f3fd",
        native: "🦵🏽",
        x: 45,
        y: 9
      },
      {
        unified: "1f9b5-1f3fe",
        native: "🦵🏾",
        x: 45,
        y: 10
      },
      {
        unified: "1f9b5-1f3ff",
        native: "🦵🏿",
        x: 45,
        y: 11
      }
    ],
    version: 11
  },
  foot: {
    id: "foot",
    name: "Foot",
    keywords: [
      "kick",
      "stomp"
    ],
    skins: [
      {
        unified: "1f9b6",
        native: "🦶",
        x: 45,
        y: 12
      },
      {
        unified: "1f9b6-1f3fb",
        native: "🦶🏻",
        x: 45,
        y: 13
      },
      {
        unified: "1f9b6-1f3fc",
        native: "🦶🏼",
        x: 45,
        y: 14
      },
      {
        unified: "1f9b6-1f3fd",
        native: "🦶🏽",
        x: 45,
        y: 15
      },
      {
        unified: "1f9b6-1f3fe",
        native: "🦶🏾",
        x: 45,
        y: 16
      },
      {
        unified: "1f9b6-1f3ff",
        native: "🦶🏿",
        x: 45,
        y: 17
      }
    ],
    version: 11
  },
  ear: {
    id: "ear",
    name: "Ear",
    keywords: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    skins: [
      {
        unified: "1f442",
        native: "👂",
        x: 11,
        y: 55
      },
      {
        unified: "1f442-1f3fb",
        native: "👂🏻",
        x: 11,
        y: 56
      },
      {
        unified: "1f442-1f3fc",
        native: "👂🏼",
        x: 11,
        y: 57
      },
      {
        unified: "1f442-1f3fd",
        native: "👂🏽",
        x: 11,
        y: 58
      },
      {
        unified: "1f442-1f3fe",
        native: "👂🏾",
        x: 11,
        y: 59
      },
      {
        unified: "1f442-1f3ff",
        native: "👂🏿",
        x: 11,
        y: 60
      }
    ],
    version: 1
  },
  ear_with_hearing_aid: {
    id: "ear_with_hearing_aid",
    name: "Ear with Hearing Aid",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bb",
        native: "🦻",
        x: 45,
        y: 56
      },
      {
        unified: "1f9bb-1f3fb",
        native: "🦻🏻",
        x: 45,
        y: 57
      },
      {
        unified: "1f9bb-1f3fc",
        native: "🦻🏼",
        x: 45,
        y: 58
      },
      {
        unified: "1f9bb-1f3fd",
        native: "🦻🏽",
        x: 45,
        y: 59
      },
      {
        unified: "1f9bb-1f3fe",
        native: "🦻🏾",
        x: 45,
        y: 60
      },
      {
        unified: "1f9bb-1f3ff",
        native: "🦻🏿",
        x: 46,
        y: 0
      }
    ],
    version: 12
  },
  nose: {
    id: "nose",
    name: "Nose",
    keywords: [
      "smell",
      "sniff"
    ],
    skins: [
      {
        unified: "1f443",
        native: "👃",
        x: 12,
        y: 0
      },
      {
        unified: "1f443-1f3fb",
        native: "👃🏻",
        x: 12,
        y: 1
      },
      {
        unified: "1f443-1f3fc",
        native: "👃🏼",
        x: 12,
        y: 2
      },
      {
        unified: "1f443-1f3fd",
        native: "👃🏽",
        x: 12,
        y: 3
      },
      {
        unified: "1f443-1f3fe",
        native: "👃🏾",
        x: 12,
        y: 4
      },
      {
        unified: "1f443-1f3ff",
        native: "👃🏿",
        x: 12,
        y: 5
      }
    ],
    version: 1
  },
  brain: {
    id: "brain",
    name: "Brain",
    keywords: [
      "smart",
      "intelligent"
    ],
    skins: [
      {
        unified: "1f9e0",
        native: "🧠",
        x: 53,
        y: 14
      }
    ],
    version: 5
  },
  anatomical_heart: {
    id: "anatomical_heart",
    name: "Anatomical Heart",
    keywords: [
      "health",
      "heartbeat"
    ],
    skins: [
      {
        unified: "1fac0",
        native: "🫀",
        x: 54,
        y: 42
      }
    ],
    version: 13
  },
  lungs: {
    id: "lungs",
    name: "Lungs",
    keywords: [
      "breathe"
    ],
    skins: [
      {
        unified: "1fac1",
        native: "🫁",
        x: 54,
        y: 43
      }
    ],
    version: 13
  },
  tooth: {
    id: "tooth",
    name: "Tooth",
    keywords: [
      "teeth",
      "dentist"
    ],
    skins: [
      {
        unified: "1f9b7",
        native: "🦷",
        x: 45,
        y: 18
      }
    ],
    version: 11
  },
  bone: {
    id: "bone",
    name: "Bone",
    keywords: [
      "skeleton"
    ],
    skins: [
      {
        unified: "1f9b4",
        native: "🦴",
        x: 45,
        y: 5
      }
    ],
    version: 11
  },
  eyes: {
    id: "eyes",
    name: "Eyes",
    keywords: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    skins: [
      {
        unified: "1f440",
        native: "👀",
        x: 11,
        y: 52
      }
    ],
    version: 1
  },
  eye: {
    id: "eye",
    name: "Eye",
    keywords: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    skins: [
      {
        unified: "1f441-fe0f",
        native: "👁️",
        x: 11,
        y: 54
      }
    ],
    version: 1
  },
  tongue: {
    id: "tongue",
    name: "Tongue",
    keywords: [
      "mouth",
      "playful"
    ],
    skins: [
      {
        unified: "1f445",
        native: "👅",
        x: 12,
        y: 7
      }
    ],
    version: 1
  },
  lips: {
    id: "lips",
    name: "Mouth",
    keywords: [
      "lips",
      "kiss"
    ],
    skins: [
      {
        unified: "1f444",
        native: "👄",
        x: 12,
        y: 6
      }
    ],
    version: 1
  },
  biting_lip: {
    id: "biting_lip",
    name: "Biting Lip",
    keywords: [
      "flirt",
      "sexy",
      "pain",
      "worry"
    ],
    skins: [
      {
        unified: "1fae6",
        native: "🫦",
        x: 55,
        y: 18
      }
    ],
    version: 14
  },
  baby: {
    id: "baby",
    name: "Baby",
    keywords: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    skins: [
      {
        unified: "1f476",
        native: "👶",
        x: 24,
        y: 28
      },
      {
        unified: "1f476-1f3fb",
        native: "👶🏻",
        x: 24,
        y: 29
      },
      {
        unified: "1f476-1f3fc",
        native: "👶🏼",
        x: 24,
        y: 30
      },
      {
        unified: "1f476-1f3fd",
        native: "👶🏽",
        x: 24,
        y: 31
      },
      {
        unified: "1f476-1f3fe",
        native: "👶🏾",
        x: 24,
        y: 32
      },
      {
        unified: "1f476-1f3ff",
        native: "👶🏿",
        x: 24,
        y: 33
      }
    ],
    version: 1
  },
  child: {
    id: "child",
    name: "Child",
    keywords: [
      "gender",
      "neutral",
      "young"
    ],
    skins: [
      {
        unified: "1f9d2",
        native: "🧒",
        x: 50,
        y: 11
      },
      {
        unified: "1f9d2-1f3fb",
        native: "🧒🏻",
        x: 50,
        y: 12
      },
      {
        unified: "1f9d2-1f3fc",
        native: "🧒🏼",
        x: 50,
        y: 13
      },
      {
        unified: "1f9d2-1f3fd",
        native: "🧒🏽",
        x: 50,
        y: 14
      },
      {
        unified: "1f9d2-1f3fe",
        native: "🧒🏾",
        x: 50,
        y: 15
      },
      {
        unified: "1f9d2-1f3ff",
        native: "🧒🏿",
        x: 50,
        y: 16
      }
    ],
    version: 5
  },
  boy: {
    id: "boy",
    name: "Boy",
    keywords: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    skins: [
      {
        unified: "1f466",
        native: "👦",
        x: 13,
        y: 34
      },
      {
        unified: "1f466-1f3fb",
        native: "👦🏻",
        x: 13,
        y: 35
      },
      {
        unified: "1f466-1f3fc",
        native: "👦🏼",
        x: 13,
        y: 36
      },
      {
        unified: "1f466-1f3fd",
        native: "👦🏽",
        x: 13,
        y: 37
      },
      {
        unified: "1f466-1f3fe",
        native: "👦🏾",
        x: 13,
        y: 38
      },
      {
        unified: "1f466-1f3ff",
        native: "👦🏿",
        x: 13,
        y: 39
      }
    ],
    version: 1
  },
  girl: {
    id: "girl",
    name: "Girl",
    keywords: [
      "female",
      "woman",
      "teenager"
    ],
    skins: [
      {
        unified: "1f467",
        native: "👧",
        x: 13,
        y: 40
      },
      {
        unified: "1f467-1f3fb",
        native: "👧🏻",
        x: 13,
        y: 41
      },
      {
        unified: "1f467-1f3fc",
        native: "👧🏼",
        x: 13,
        y: 42
      },
      {
        unified: "1f467-1f3fd",
        native: "👧🏽",
        x: 13,
        y: 43
      },
      {
        unified: "1f467-1f3fe",
        native: "👧🏾",
        x: 13,
        y: 44
      },
      {
        unified: "1f467-1f3ff",
        native: "👧🏿",
        x: 13,
        y: 45
      }
    ],
    version: 1
  },
  adult: {
    id: "adult",
    name: "Adult",
    keywords: [
      "person",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d1",
        native: "🧑",
        x: 50,
        y: 5
      },
      {
        unified: "1f9d1-1f3fb",
        native: "🧑🏻",
        x: 50,
        y: 6
      },
      {
        unified: "1f9d1-1f3fc",
        native: "🧑🏼",
        x: 50,
        y: 7
      },
      {
        unified: "1f9d1-1f3fd",
        native: "🧑🏽",
        x: 50,
        y: 8
      },
      {
        unified: "1f9d1-1f3fe",
        native: "🧑🏾",
        x: 50,
        y: 9
      },
      {
        unified: "1f9d1-1f3ff",
        native: "🧑🏿",
        x: 50,
        y: 10
      }
    ],
    version: 5
  },
  person_with_blond_hair: {
    id: "person_with_blond_hair",
    name: "Person Blond Hair",
    keywords: [
      "with",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f471",
        native: "👱",
        x: 23,
        y: 47
      },
      {
        unified: "1f471-1f3fb",
        native: "👱🏻",
        x: 23,
        y: 48
      },
      {
        unified: "1f471-1f3fc",
        native: "👱🏼",
        x: 23,
        y: 49
      },
      {
        unified: "1f471-1f3fd",
        native: "👱🏽",
        x: 23,
        y: 50
      },
      {
        unified: "1f471-1f3fe",
        native: "👱🏾",
        x: 23,
        y: 51
      },
      {
        unified: "1f471-1f3ff",
        native: "👱🏿",
        x: 23,
        y: 52
      }
    ],
    version: 1
  },
  man: {
    id: "man",
    name: "Man",
    keywords: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    skins: [
      {
        unified: "1f468",
        native: "👨",
        x: 17,
        y: 13
      },
      {
        unified: "1f468-1f3fb",
        native: "👨🏻",
        x: 17,
        y: 14
      },
      {
        unified: "1f468-1f3fc",
        native: "👨🏼",
        x: 17,
        y: 15
      },
      {
        unified: "1f468-1f3fd",
        native: "👨🏽",
        x: 17,
        y: 16
      },
      {
        unified: "1f468-1f3fe",
        native: "👨🏾",
        x: 17,
        y: 17
      },
      {
        unified: "1f468-1f3ff",
        native: "👨🏿",
        x: 17,
        y: 18
      }
    ],
    version: 1
  },
  bearded_person: {
    id: "bearded_person",
    name: "Person Beard",
    keywords: [
      "bearded",
      "man",
      "bewhiskered"
    ],
    skins: [
      {
        unified: "1f9d4",
        native: "🧔",
        x: 50,
        y: 35
      },
      {
        unified: "1f9d4-1f3fb",
        native: "🧔🏻",
        x: 50,
        y: 36
      },
      {
        unified: "1f9d4-1f3fc",
        native: "🧔🏼",
        x: 50,
        y: 37
      },
      {
        unified: "1f9d4-1f3fd",
        native: "🧔🏽",
        x: 50,
        y: 38
      },
      {
        unified: "1f9d4-1f3fe",
        native: "🧔🏾",
        x: 50,
        y: 39
      },
      {
        unified: "1f9d4-1f3ff",
        native: "🧔🏿",
        x: 50,
        y: 40
      }
    ],
    version: 5
  },
  man_with_beard: {
    id: "man_with_beard",
    name: "Man: Beard",
    keywords: [
      "man",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2642-fe0f",
        native: "🧔‍♂️",
        x: 50,
        y: 29
      },
      {
        unified: "1f9d4-1f3fb-200d-2642-fe0f",
        native: "🧔🏻‍♂️",
        x: 50,
        y: 30
      },
      {
        unified: "1f9d4-1f3fc-200d-2642-fe0f",
        native: "🧔🏼‍♂️",
        x: 50,
        y: 31
      },
      {
        unified: "1f9d4-1f3fd-200d-2642-fe0f",
        native: "🧔🏽‍♂️",
        x: 50,
        y: 32
      },
      {
        unified: "1f9d4-1f3fe-200d-2642-fe0f",
        native: "🧔🏾‍♂️",
        x: 50,
        y: 33
      },
      {
        unified: "1f9d4-1f3ff-200d-2642-fe0f",
        native: "🧔🏿‍♂️",
        x: 50,
        y: 34
      }
    ],
    version: 13.1
  },
  woman_with_beard: {
    id: "woman_with_beard",
    name: "Woman: Beard",
    keywords: [
      "woman",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2640-fe0f",
        native: "🧔‍♀️",
        x: 50,
        y: 23
      },
      {
        unified: "1f9d4-1f3fb-200d-2640-fe0f",
        native: "🧔🏻‍♀️",
        x: 50,
        y: 24
      },
      {
        unified: "1f9d4-1f3fc-200d-2640-fe0f",
        native: "🧔🏼‍♀️",
        x: 50,
        y: 25
      },
      {
        unified: "1f9d4-1f3fd-200d-2640-fe0f",
        native: "🧔🏽‍♀️",
        x: 50,
        y: 26
      },
      {
        unified: "1f9d4-1f3fe-200d-2640-fe0f",
        native: "🧔🏾‍♀️",
        x: 50,
        y: 27
      },
      {
        unified: "1f9d4-1f3ff-200d-2640-fe0f",
        native: "🧔🏿‍♀️",
        x: 50,
        y: 28
      }
    ],
    version: 13.1
  },
  red_haired_man: {
    id: "red_haired_man",
    name: "Man: Red Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b0",
        native: "👨‍🦰",
        x: 15,
        y: 29
      },
      {
        unified: "1f468-1f3fb-200d-1f9b0",
        native: "👨🏻‍🦰",
        x: 15,
        y: 30
      },
      {
        unified: "1f468-1f3fc-200d-1f9b0",
        native: "👨🏼‍🦰",
        x: 15,
        y: 31
      },
      {
        unified: "1f468-1f3fd-200d-1f9b0",
        native: "👨🏽‍🦰",
        x: 15,
        y: 32
      },
      {
        unified: "1f468-1f3fe-200d-1f9b0",
        native: "👨🏾‍🦰",
        x: 15,
        y: 33
      },
      {
        unified: "1f468-1f3ff-200d-1f9b0",
        native: "👨🏿‍🦰",
        x: 15,
        y: 34
      }
    ],
    version: 11
  },
  curly_haired_man: {
    id: "curly_haired_man",
    name: "Man: Curly Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b1",
        native: "👨‍🦱",
        x: 15,
        y: 35
      },
      {
        unified: "1f468-1f3fb-200d-1f9b1",
        native: "👨🏻‍🦱",
        x: 15,
        y: 36
      },
      {
        unified: "1f468-1f3fc-200d-1f9b1",
        native: "👨🏼‍🦱",
        x: 15,
        y: 37
      },
      {
        unified: "1f468-1f3fd-200d-1f9b1",
        native: "👨🏽‍🦱",
        x: 15,
        y: 38
      },
      {
        unified: "1f468-1f3fe-200d-1f9b1",
        native: "👨🏾‍🦱",
        x: 15,
        y: 39
      },
      {
        unified: "1f468-1f3ff-200d-1f9b1",
        native: "👨🏿‍🦱",
        x: 15,
        y: 40
      }
    ],
    version: 11
  },
  white_haired_man: {
    id: "white_haired_man",
    name: "Man: White Hair",
    keywords: [
      "haired",
      "man",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b3",
        native: "👨‍🦳",
        x: 15,
        y: 47
      },
      {
        unified: "1f468-1f3fb-200d-1f9b3",
        native: "👨🏻‍🦳",
        x: 15,
        y: 48
      },
      {
        unified: "1f468-1f3fc-200d-1f9b3",
        native: "👨🏼‍🦳",
        x: 15,
        y: 49
      },
      {
        unified: "1f468-1f3fd-200d-1f9b3",
        native: "👨🏽‍🦳",
        x: 15,
        y: 50
      },
      {
        unified: "1f468-1f3fe-200d-1f9b3",
        native: "👨🏾‍🦳",
        x: 15,
        y: 51
      },
      {
        unified: "1f468-1f3ff-200d-1f9b3",
        native: "👨🏿‍🦳",
        x: 15,
        y: 52
      }
    ],
    version: 11
  },
  bald_man: {
    id: "bald_man",
    name: "Man: Bald",
    keywords: [
      "man",
      "hairless"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b2",
        native: "👨‍🦲",
        x: 15,
        y: 41
      },
      {
        unified: "1f468-1f3fb-200d-1f9b2",
        native: "👨🏻‍🦲",
        x: 15,
        y: 42
      },
      {
        unified: "1f468-1f3fc-200d-1f9b2",
        native: "👨🏼‍🦲",
        x: 15,
        y: 43
      },
      {
        unified: "1f468-1f3fd-200d-1f9b2",
        native: "👨🏽‍🦲",
        x: 15,
        y: 44
      },
      {
        unified: "1f468-1f3fe-200d-1f9b2",
        native: "👨🏾‍🦲",
        x: 15,
        y: 45
      },
      {
        unified: "1f468-1f3ff-200d-1f9b2",
        native: "👨🏿‍🦲",
        x: 15,
        y: 46
      }
    ],
    version: 11
  },
  woman: {
    id: "woman",
    name: "Woman",
    keywords: [
      "female",
      "girls",
      "lady"
    ],
    skins: [
      {
        unified: "1f469",
        native: "👩",
        x: 21,
        y: 33
      },
      {
        unified: "1f469-1f3fb",
        native: "👩🏻",
        x: 21,
        y: 34
      },
      {
        unified: "1f469-1f3fc",
        native: "👩🏼",
        x: 21,
        y: 35
      },
      {
        unified: "1f469-1f3fd",
        native: "👩🏽",
        x: 21,
        y: 36
      },
      {
        unified: "1f469-1f3fe",
        native: "👩🏾",
        x: 21,
        y: 37
      },
      {
        unified: "1f469-1f3ff",
        native: "👩🏿",
        x: 21,
        y: 38
      }
    ],
    version: 1
  },
  red_haired_woman: {
    id: "red_haired_woman",
    name: "Woman: Red Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b0",
        native: "👩‍🦰",
        x: 18,
        y: 58
      },
      {
        unified: "1f469-1f3fb-200d-1f9b0",
        native: "👩🏻‍🦰",
        x: 18,
        y: 59
      },
      {
        unified: "1f469-1f3fc-200d-1f9b0",
        native: "👩🏼‍🦰",
        x: 18,
        y: 60
      },
      {
        unified: "1f469-1f3fd-200d-1f9b0",
        native: "👩🏽‍🦰",
        x: 19,
        y: 0
      },
      {
        unified: "1f469-1f3fe-200d-1f9b0",
        native: "👩🏾‍🦰",
        x: 19,
        y: 1
      },
      {
        unified: "1f469-1f3ff-200d-1f9b0",
        native: "👩🏿‍🦰",
        x: 19,
        y: 2
      }
    ],
    version: 11
  },
  red_haired_person: {
    id: "red_haired_person",
    name: "Person: Red Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b0",
        native: "🧑‍🦰",
        x: 49,
        y: 12
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b0",
        native: "🧑🏻‍🦰",
        x: 49,
        y: 13
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b0",
        native: "🧑🏼‍🦰",
        x: 49,
        y: 14
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b0",
        native: "🧑🏽‍🦰",
        x: 49,
        y: 15
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b0",
        native: "🧑🏾‍🦰",
        x: 49,
        y: 16
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b0",
        native: "🧑🏿‍🦰",
        x: 49,
        y: 17
      }
    ],
    version: 12.1
  },
  curly_haired_woman: {
    id: "curly_haired_woman",
    name: "Woman: Curly Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b1",
        native: "👩‍🦱",
        x: 19,
        y: 3
      },
      {
        unified: "1f469-1f3fb-200d-1f9b1",
        native: "👩🏻‍🦱",
        x: 19,
        y: 4
      },
      {
        unified: "1f469-1f3fc-200d-1f9b1",
        native: "👩🏼‍🦱",
        x: 19,
        y: 5
      },
      {
        unified: "1f469-1f3fd-200d-1f9b1",
        native: "👩🏽‍🦱",
        x: 19,
        y: 6
      },
      {
        unified: "1f469-1f3fe-200d-1f9b1",
        native: "👩🏾‍🦱",
        x: 19,
        y: 7
      },
      {
        unified: "1f469-1f3ff-200d-1f9b1",
        native: "👩🏿‍🦱",
        x: 19,
        y: 8
      }
    ],
    version: 11
  },
  curly_haired_person: {
    id: "curly_haired_person",
    name: "Person: Curly Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b1",
        native: "🧑‍🦱",
        x: 49,
        y: 18
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b1",
        native: "🧑🏻‍🦱",
        x: 49,
        y: 19
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b1",
        native: "🧑🏼‍🦱",
        x: 49,
        y: 20
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b1",
        native: "🧑🏽‍🦱",
        x: 49,
        y: 21
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b1",
        native: "🧑🏾‍🦱",
        x: 49,
        y: 22
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b1",
        native: "🧑🏿‍🦱",
        x: 49,
        y: 23
      }
    ],
    version: 12.1
  },
  white_haired_woman: {
    id: "white_haired_woman",
    name: "Woman: White Hair",
    keywords: [
      "haired",
      "woman",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b3",
        native: "👩‍🦳",
        x: 19,
        y: 15
      },
      {
        unified: "1f469-1f3fb-200d-1f9b3",
        native: "👩🏻‍🦳",
        x: 19,
        y: 16
      },
      {
        unified: "1f469-1f3fc-200d-1f9b3",
        native: "👩🏼‍🦳",
        x: 19,
        y: 17
      },
      {
        unified: "1f469-1f3fd-200d-1f9b3",
        native: "👩🏽‍🦳",
        x: 19,
        y: 18
      },
      {
        unified: "1f469-1f3fe-200d-1f9b3",
        native: "👩🏾‍🦳",
        x: 19,
        y: 19
      },
      {
        unified: "1f469-1f3ff-200d-1f9b3",
        native: "👩🏿‍🦳",
        x: 19,
        y: 20
      }
    ],
    version: 11
  },
  white_haired_person: {
    id: "white_haired_person",
    name: "Person: White Hair",
    keywords: [
      "haired",
      "person",
      "elder",
      "old"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b3",
        native: "🧑‍🦳",
        x: 49,
        y: 30
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b3",
        native: "🧑🏻‍🦳",
        x: 49,
        y: 31
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b3",
        native: "🧑🏼‍🦳",
        x: 49,
        y: 32
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b3",
        native: "🧑🏽‍🦳",
        x: 49,
        y: 33
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b3",
        native: "🧑🏾‍🦳",
        x: 49,
        y: 34
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b3",
        native: "🧑🏿‍🦳",
        x: 49,
        y: 35
      }
    ],
    version: 12.1
  },
  bald_woman: {
    id: "bald_woman",
    name: "Woman: Bald",
    keywords: [
      "woman",
      "hairless"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b2",
        native: "👩‍🦲",
        x: 19,
        y: 9
      },
      {
        unified: "1f469-1f3fb-200d-1f9b2",
        native: "👩🏻‍🦲",
        x: 19,
        y: 10
      },
      {
        unified: "1f469-1f3fc-200d-1f9b2",
        native: "👩🏼‍🦲",
        x: 19,
        y: 11
      },
      {
        unified: "1f469-1f3fd-200d-1f9b2",
        native: "👩🏽‍🦲",
        x: 19,
        y: 12
      },
      {
        unified: "1f469-1f3fe-200d-1f9b2",
        native: "👩🏾‍🦲",
        x: 19,
        y: 13
      },
      {
        unified: "1f469-1f3ff-200d-1f9b2",
        native: "👩🏿‍🦲",
        x: 19,
        y: 14
      }
    ],
    version: 11
  },
  bald_person: {
    id: "bald_person",
    name: "Person: Bald",
    keywords: [
      "person",
      "hairless"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b2",
        native: "🧑‍🦲",
        x: 49,
        y: 24
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b2",
        native: "🧑🏻‍🦲",
        x: 49,
        y: 25
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b2",
        native: "🧑🏼‍🦲",
        x: 49,
        y: 26
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b2",
        native: "🧑🏽‍🦲",
        x: 49,
        y: 27
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b2",
        native: "🧑🏾‍🦲",
        x: 49,
        y: 28
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b2",
        native: "🧑🏿‍🦲",
        x: 49,
        y: 29
      }
    ],
    version: 12.1
  },
  "blond-haired-woman": {
    id: "blond-haired-woman",
    name: "Woman: Blond Hair",
    keywords: [
      "haired-woman",
      "woman",
      "female",
      "girl",
      "blonde",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2640-fe0f",
        native: "👱‍♀️",
        x: 23,
        y: 35
      },
      {
        unified: "1f471-1f3fb-200d-2640-fe0f",
        native: "👱🏻‍♀️",
        x: 23,
        y: 36
      },
      {
        unified: "1f471-1f3fc-200d-2640-fe0f",
        native: "👱🏼‍♀️",
        x: 23,
        y: 37
      },
      {
        unified: "1f471-1f3fd-200d-2640-fe0f",
        native: "👱🏽‍♀️",
        x: 23,
        y: 38
      },
      {
        unified: "1f471-1f3fe-200d-2640-fe0f",
        native: "👱🏾‍♀️",
        x: 23,
        y: 39
      },
      {
        unified: "1f471-1f3ff-200d-2640-fe0f",
        native: "👱🏿‍♀️",
        x: 23,
        y: 40
      }
    ],
    version: 4
  },
  "blond-haired-man": {
    id: "blond-haired-man",
    name: "Man: Blond Hair",
    keywords: [
      "haired-man",
      "man",
      "male",
      "boy",
      "blonde",
      "guy",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2642-fe0f",
        native: "👱‍♂️",
        x: 23,
        y: 41
      },
      {
        unified: "1f471-1f3fb-200d-2642-fe0f",
        native: "👱🏻‍♂️",
        x: 23,
        y: 42
      },
      {
        unified: "1f471-1f3fc-200d-2642-fe0f",
        native: "👱🏼‍♂️",
        x: 23,
        y: 43
      },
      {
        unified: "1f471-1f3fd-200d-2642-fe0f",
        native: "👱🏽‍♂️",
        x: 23,
        y: 44
      },
      {
        unified: "1f471-1f3fe-200d-2642-fe0f",
        native: "👱🏾‍♂️",
        x: 23,
        y: 45
      },
      {
        unified: "1f471-1f3ff-200d-2642-fe0f",
        native: "👱🏿‍♂️",
        x: 23,
        y: 46
      }
    ],
    version: 4
  },
  older_adult: {
    id: "older_adult",
    name: "Older Adult",
    keywords: [
      "person",
      "human",
      "elder",
      "senior",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d3",
        native: "🧓",
        x: 50,
        y: 17
      },
      {
        unified: "1f9d3-1f3fb",
        native: "🧓🏻",
        x: 50,
        y: 18
      },
      {
        unified: "1f9d3-1f3fc",
        native: "🧓🏼",
        x: 50,
        y: 19
      },
      {
        unified: "1f9d3-1f3fd",
        native: "🧓🏽",
        x: 50,
        y: 20
      },
      {
        unified: "1f9d3-1f3fe",
        native: "🧓🏾",
        x: 50,
        y: 21
      },
      {
        unified: "1f9d3-1f3ff",
        native: "🧓🏿",
        x: 50,
        y: 22
      }
    ],
    version: 5
  },
  older_man: {
    id: "older_man",
    name: "Old Man",
    keywords: [
      "older",
      "human",
      "male",
      "men",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f474",
        native: "👴",
        x: 24,
        y: 16
      },
      {
        unified: "1f474-1f3fb",
        native: "👴🏻",
        x: 24,
        y: 17
      },
      {
        unified: "1f474-1f3fc",
        native: "👴🏼",
        x: 24,
        y: 18
      },
      {
        unified: "1f474-1f3fd",
        native: "👴🏽",
        x: 24,
        y: 19
      },
      {
        unified: "1f474-1f3fe",
        native: "👴🏾",
        x: 24,
        y: 20
      },
      {
        unified: "1f474-1f3ff",
        native: "👴🏿",
        x: 24,
        y: 21
      }
    ],
    version: 1
  },
  older_woman: {
    id: "older_woman",
    name: "Old Woman",
    keywords: [
      "older",
      "human",
      "female",
      "women",
      "lady",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f475",
        native: "👵",
        x: 24,
        y: 22
      },
      {
        unified: "1f475-1f3fb",
        native: "👵🏻",
        x: 24,
        y: 23
      },
      {
        unified: "1f475-1f3fc",
        native: "👵🏼",
        x: 24,
        y: 24
      },
      {
        unified: "1f475-1f3fd",
        native: "👵🏽",
        x: 24,
        y: 25
      },
      {
        unified: "1f475-1f3fe",
        native: "👵🏾",
        x: 24,
        y: 26
      },
      {
        unified: "1f475-1f3ff",
        native: "👵🏿",
        x: 24,
        y: 27
      }
    ],
    version: 1
  },
  person_frowning: {
    id: "person_frowning",
    name: "Person Frowning",
    keywords: [
      "worried"
    ],
    skins: [
      {
        unified: "1f64d",
        native: "🙍",
        x: 35,
        y: 2
      },
      {
        unified: "1f64d-1f3fb",
        native: "🙍🏻",
        x: 35,
        y: 3
      },
      {
        unified: "1f64d-1f3fc",
        native: "🙍🏼",
        x: 35,
        y: 4
      },
      {
        unified: "1f64d-1f3fd",
        native: "🙍🏽",
        x: 35,
        y: 5
      },
      {
        unified: "1f64d-1f3fe",
        native: "🙍🏾",
        x: 35,
        y: 6
      },
      {
        unified: "1f64d-1f3ff",
        native: "🙍🏿",
        x: 35,
        y: 7
      }
    ],
    version: 1
  },
  "man-frowning": {
    id: "man-frowning",
    name: "Man Frowning",
    keywords: [
      "male",
      "boy",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2642-fe0f",
        native: "🙍‍♂️",
        x: 34,
        y: 57
      },
      {
        unified: "1f64d-1f3fb-200d-2642-fe0f",
        native: "🙍🏻‍♂️",
        x: 34,
        y: 58
      },
      {
        unified: "1f64d-1f3fc-200d-2642-fe0f",
        native: "🙍🏼‍♂️",
        x: 34,
        y: 59
      },
      {
        unified: "1f64d-1f3fd-200d-2642-fe0f",
        native: "🙍🏽‍♂️",
        x: 34,
        y: 60
      },
      {
        unified: "1f64d-1f3fe-200d-2642-fe0f",
        native: "🙍🏾‍♂️",
        x: 35,
        y: 0
      },
      {
        unified: "1f64d-1f3ff-200d-2642-fe0f",
        native: "🙍🏿‍♂️",
        x: 35,
        y: 1
      }
    ],
    version: 4
  },
  "woman-frowning": {
    id: "woman-frowning",
    name: "Woman Frowning",
    keywords: [
      "female",
      "girl",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2640-fe0f",
        native: "🙍‍♀️",
        x: 34,
        y: 51
      },
      {
        unified: "1f64d-1f3fb-200d-2640-fe0f",
        native: "🙍🏻‍♀️",
        x: 34,
        y: 52
      },
      {
        unified: "1f64d-1f3fc-200d-2640-fe0f",
        native: "🙍🏼‍♀️",
        x: 34,
        y: 53
      },
      {
        unified: "1f64d-1f3fd-200d-2640-fe0f",
        native: "🙍🏽‍♀️",
        x: 34,
        y: 54
      },
      {
        unified: "1f64d-1f3fe-200d-2640-fe0f",
        native: "🙍🏾‍♀️",
        x: 34,
        y: 55
      },
      {
        unified: "1f64d-1f3ff-200d-2640-fe0f",
        native: "🙍🏿‍♀️",
        x: 34,
        y: 56
      }
    ],
    version: 4
  },
  person_with_pouting_face: {
    id: "person_with_pouting_face",
    name: "Person Pouting",
    keywords: [
      "with",
      "face",
      "upset"
    ],
    skins: [
      {
        unified: "1f64e",
        native: "🙎",
        x: 35,
        y: 20
      },
      {
        unified: "1f64e-1f3fb",
        native: "🙎🏻",
        x: 35,
        y: 21
      },
      {
        unified: "1f64e-1f3fc",
        native: "🙎🏼",
        x: 35,
        y: 22
      },
      {
        unified: "1f64e-1f3fd",
        native: "🙎🏽",
        x: 35,
        y: 23
      },
      {
        unified: "1f64e-1f3fe",
        native: "🙎🏾",
        x: 35,
        y: 24
      },
      {
        unified: "1f64e-1f3ff",
        native: "🙎🏿",
        x: 35,
        y: 25
      }
    ],
    version: 1
  },
  "man-pouting": {
    id: "man-pouting",
    name: "Man Pouting",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64e-200d-2642-fe0f",
        native: "🙎‍♂️",
        x: 35,
        y: 14
      },
      {
        unified: "1f64e-1f3fb-200d-2642-fe0f",
        native: "🙎🏻‍♂️",
        x: 35,
        y: 15
      },
      {
        unified: "1f64e-1f3fc-200d-2642-fe0f",
        native: "🙎🏼‍♂️",
        x: 35,
        y: 16
      },
      {
        unified: "1f64e-1f3fd-200d-2642-fe0f",
        native: "🙎🏽‍♂️",
        x: 35,
        y: 17
      },
      {
        unified: "1f64e-1f3fe-200d-2642-fe0f",
        native: "🙎🏾‍♂️",
        x: 35,
        y: 18
      },
      {
        unified: "1f64e-1f3ff-200d-2642-fe0f",
        native: "🙎🏿‍♂️",
        x: 35,
        y: 19
      }
    ],
    version: 4
  },
  "woman-pouting": {
    id: "woman-pouting",
    name: "Woman Pouting",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64e-200d-2640-fe0f",
        native: "🙎‍♀️",
        x: 35,
        y: 8
      },
      {
        unified: "1f64e-1f3fb-200d-2640-fe0f",
        native: "🙎🏻‍♀️",
        x: 35,
        y: 9
      },
      {
        unified: "1f64e-1f3fc-200d-2640-fe0f",
        native: "🙎🏼‍♀️",
        x: 35,
        y: 10
      },
      {
        unified: "1f64e-1f3fd-200d-2640-fe0f",
        native: "🙎🏽‍♀️",
        x: 35,
        y: 11
      },
      {
        unified: "1f64e-1f3fe-200d-2640-fe0f",
        native: "🙎🏾‍♀️",
        x: 35,
        y: 12
      },
      {
        unified: "1f64e-1f3ff-200d-2640-fe0f",
        native: "🙎🏿‍♀️",
        x: 35,
        y: 13
      }
    ],
    version: 4
  },
  no_good: {
    id: "no_good",
    name: "Person Gesturing No",
    keywords: [
      "good",
      "decline"
    ],
    skins: [
      {
        unified: "1f645",
        native: "🙅",
        x: 33,
        y: 43
      },
      {
        unified: "1f645-1f3fb",
        native: "🙅🏻",
        x: 33,
        y: 44
      },
      {
        unified: "1f645-1f3fc",
        native: "🙅🏼",
        x: 33,
        y: 45
      },
      {
        unified: "1f645-1f3fd",
        native: "🙅🏽",
        x: 33,
        y: 46
      },
      {
        unified: "1f645-1f3fe",
        native: "🙅🏾",
        x: 33,
        y: 47
      },
      {
        unified: "1f645-1f3ff",
        native: "🙅🏿",
        x: 33,
        y: 48
      }
    ],
    version: 1
  },
  "man-gesturing-no": {
    id: "man-gesturing-no",
    name: "Man Gesturing No",
    keywords: [
      "gesturing-no",
      "male",
      "boy",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2642-fe0f",
        native: "🙅‍♂️",
        x: 33,
        y: 37
      },
      {
        unified: "1f645-1f3fb-200d-2642-fe0f",
        native: "🙅🏻‍♂️",
        x: 33,
        y: 38
      },
      {
        unified: "1f645-1f3fc-200d-2642-fe0f",
        native: "🙅🏼‍♂️",
        x: 33,
        y: 39
      },
      {
        unified: "1f645-1f3fd-200d-2642-fe0f",
        native: "🙅🏽‍♂️",
        x: 33,
        y: 40
      },
      {
        unified: "1f645-1f3fe-200d-2642-fe0f",
        native: "🙅🏾‍♂️",
        x: 33,
        y: 41
      },
      {
        unified: "1f645-1f3ff-200d-2642-fe0f",
        native: "🙅🏿‍♂️",
        x: 33,
        y: 42
      }
    ],
    version: 4
  },
  "woman-gesturing-no": {
    id: "woman-gesturing-no",
    name: "Woman Gesturing No",
    keywords: [
      "gesturing-no",
      "female",
      "girl",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2640-fe0f",
        native: "🙅‍♀️",
        x: 33,
        y: 31
      },
      {
        unified: "1f645-1f3fb-200d-2640-fe0f",
        native: "🙅🏻‍♀️",
        x: 33,
        y: 32
      },
      {
        unified: "1f645-1f3fc-200d-2640-fe0f",
        native: "🙅🏼‍♀️",
        x: 33,
        y: 33
      },
      {
        unified: "1f645-1f3fd-200d-2640-fe0f",
        native: "🙅🏽‍♀️",
        x: 33,
        y: 34
      },
      {
        unified: "1f645-1f3fe-200d-2640-fe0f",
        native: "🙅🏾‍♀️",
        x: 33,
        y: 35
      },
      {
        unified: "1f645-1f3ff-200d-2640-fe0f",
        native: "🙅🏿‍♀️",
        x: 33,
        y: 36
      }
    ],
    version: 4
  },
  ok_woman: {
    id: "ok_woman",
    name: "Person Gesturing Ok",
    keywords: [
      "woman",
      "agree"
    ],
    skins: [
      {
        unified: "1f646",
        native: "🙆",
        x: 34,
        y: 0
      },
      {
        unified: "1f646-1f3fb",
        native: "🙆🏻",
        x: 34,
        y: 1
      },
      {
        unified: "1f646-1f3fc",
        native: "🙆🏼",
        x: 34,
        y: 2
      },
      {
        unified: "1f646-1f3fd",
        native: "🙆🏽",
        x: 34,
        y: 3
      },
      {
        unified: "1f646-1f3fe",
        native: "🙆🏾",
        x: 34,
        y: 4
      },
      {
        unified: "1f646-1f3ff",
        native: "🙆🏿",
        x: 34,
        y: 5
      }
    ],
    version: 1
  },
  "man-gesturing-ok": {
    id: "man-gesturing-ok",
    name: "Man Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "men",
      "boy",
      "male",
      "blue",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2642-fe0f",
        native: "🙆‍♂️",
        x: 33,
        y: 55
      },
      {
        unified: "1f646-1f3fb-200d-2642-fe0f",
        native: "🙆🏻‍♂️",
        x: 33,
        y: 56
      },
      {
        unified: "1f646-1f3fc-200d-2642-fe0f",
        native: "🙆🏼‍♂️",
        x: 33,
        y: 57
      },
      {
        unified: "1f646-1f3fd-200d-2642-fe0f",
        native: "🙆🏽‍♂️",
        x: 33,
        y: 58
      },
      {
        unified: "1f646-1f3fe-200d-2642-fe0f",
        native: "🙆🏾‍♂️",
        x: 33,
        y: 59
      },
      {
        unified: "1f646-1f3ff-200d-2642-fe0f",
        native: "🙆🏿‍♂️",
        x: 33,
        y: 60
      }
    ],
    version: 4
  },
  "woman-gesturing-ok": {
    id: "woman-gesturing-ok",
    name: "Woman Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "women",
      "girl",
      "female",
      "pink",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2640-fe0f",
        native: "🙆‍♀️",
        x: 33,
        y: 49
      },
      {
        unified: "1f646-1f3fb-200d-2640-fe0f",
        native: "🙆🏻‍♀️",
        x: 33,
        y: 50
      },
      {
        unified: "1f646-1f3fc-200d-2640-fe0f",
        native: "🙆🏼‍♀️",
        x: 33,
        y: 51
      },
      {
        unified: "1f646-1f3fd-200d-2640-fe0f",
        native: "🙆🏽‍♀️",
        x: 33,
        y: 52
      },
      {
        unified: "1f646-1f3fe-200d-2640-fe0f",
        native: "🙆🏾‍♀️",
        x: 33,
        y: 53
      },
      {
        unified: "1f646-1f3ff-200d-2640-fe0f",
        native: "🙆🏿‍♀️",
        x: 33,
        y: 54
      }
    ],
    version: 4
  },
  information_desk_person: {
    id: "information_desk_person",
    name: "Person Tipping Hand",
    keywords: [
      "information",
      "desk"
    ],
    skins: [
      {
        unified: "1f481",
        native: "💁",
        x: 25,
        y: 22
      },
      {
        unified: "1f481-1f3fb",
        native: "💁🏻",
        x: 25,
        y: 23
      },
      {
        unified: "1f481-1f3fc",
        native: "💁🏼",
        x: 25,
        y: 24
      },
      {
        unified: "1f481-1f3fd",
        native: "💁🏽",
        x: 25,
        y: 25
      },
      {
        unified: "1f481-1f3fe",
        native: "💁🏾",
        x: 25,
        y: 26
      },
      {
        unified: "1f481-1f3ff",
        native: "💁🏿",
        x: 25,
        y: 27
      }
    ],
    version: 1
  },
  "man-tipping-hand": {
    id: "man-tipping-hand",
    name: "Man Tipping Hand",
    keywords: [
      "tipping-hand",
      "male",
      "boy",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2642-fe0f",
        native: "💁‍♂️",
        x: 25,
        y: 16
      },
      {
        unified: "1f481-1f3fb-200d-2642-fe0f",
        native: "💁🏻‍♂️",
        x: 25,
        y: 17
      },
      {
        unified: "1f481-1f3fc-200d-2642-fe0f",
        native: "💁🏼‍♂️",
        x: 25,
        y: 18
      },
      {
        unified: "1f481-1f3fd-200d-2642-fe0f",
        native: "💁🏽‍♂️",
        x: 25,
        y: 19
      },
      {
        unified: "1f481-1f3fe-200d-2642-fe0f",
        native: "💁🏾‍♂️",
        x: 25,
        y: 20
      },
      {
        unified: "1f481-1f3ff-200d-2642-fe0f",
        native: "💁🏿‍♂️",
        x: 25,
        y: 21
      }
    ],
    version: 4
  },
  "woman-tipping-hand": {
    id: "woman-tipping-hand",
    name: "Woman Tipping Hand",
    keywords: [
      "tipping-hand",
      "female",
      "girl",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2640-fe0f",
        native: "💁‍♀️",
        x: 25,
        y: 10
      },
      {
        unified: "1f481-1f3fb-200d-2640-fe0f",
        native: "💁🏻‍♀️",
        x: 25,
        y: 11
      },
      {
        unified: "1f481-1f3fc-200d-2640-fe0f",
        native: "💁🏼‍♀️",
        x: 25,
        y: 12
      },
      {
        unified: "1f481-1f3fd-200d-2640-fe0f",
        native: "💁🏽‍♀️",
        x: 25,
        y: 13
      },
      {
        unified: "1f481-1f3fe-200d-2640-fe0f",
        native: "💁🏾‍♀️",
        x: 25,
        y: 14
      },
      {
        unified: "1f481-1f3ff-200d-2640-fe0f",
        native: "💁🏿‍♀️",
        x: 25,
        y: 15
      }
    ],
    version: 4
  },
  raising_hand: {
    id: "raising_hand",
    name: "Person Raising Hand",
    keywords: [
      "question"
    ],
    skins: [
      {
        unified: "1f64b",
        native: "🙋",
        x: 34,
        y: 39
      },
      {
        unified: "1f64b-1f3fb",
        native: "🙋🏻",
        x: 34,
        y: 40
      },
      {
        unified: "1f64b-1f3fc",
        native: "🙋🏼",
        x: 34,
        y: 41
      },
      {
        unified: "1f64b-1f3fd",
        native: "🙋🏽",
        x: 34,
        y: 42
      },
      {
        unified: "1f64b-1f3fe",
        native: "🙋🏾",
        x: 34,
        y: 43
      },
      {
        unified: "1f64b-1f3ff",
        native: "🙋🏿",
        x: 34,
        y: 44
      }
    ],
    version: 1
  },
  "man-raising-hand": {
    id: "man-raising-hand",
    name: "Man Raising Hand",
    keywords: [
      "raising-hand",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64b-200d-2642-fe0f",
        native: "🙋‍♂️",
        x: 34,
        y: 33
      },
      {
        unified: "1f64b-1f3fb-200d-2642-fe0f",
        native: "🙋🏻‍♂️",
        x: 34,
        y: 34
      },
      {
        unified: "1f64b-1f3fc-200d-2642-fe0f",
        native: "🙋🏼‍♂️",
        x: 34,
        y: 35
      },
      {
        unified: "1f64b-1f3fd-200d-2642-fe0f",
        native: "🙋🏽‍♂️",
        x: 34,
        y: 36
      },
      {
        unified: "1f64b-1f3fe-200d-2642-fe0f",
        native: "🙋🏾‍♂️",
        x: 34,
        y: 37
      },
      {
        unified: "1f64b-1f3ff-200d-2642-fe0f",
        native: "🙋🏿‍♂️",
        x: 34,
        y: 38
      }
    ],
    version: 4
  },
  "woman-raising-hand": {
    id: "woman-raising-hand",
    name: "Woman Raising Hand",
    keywords: [
      "raising-hand",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64b-200d-2640-fe0f",
        native: "🙋‍♀️",
        x: 34,
        y: 27
      },
      {
        unified: "1f64b-1f3fb-200d-2640-fe0f",
        native: "🙋🏻‍♀️",
        x: 34,
        y: 28
      },
      {
        unified: "1f64b-1f3fc-200d-2640-fe0f",
        native: "🙋🏼‍♀️",
        x: 34,
        y: 29
      },
      {
        unified: "1f64b-1f3fd-200d-2640-fe0f",
        native: "🙋🏽‍♀️",
        x: 34,
        y: 30
      },
      {
        unified: "1f64b-1f3fe-200d-2640-fe0f",
        native: "🙋🏾‍♀️",
        x: 34,
        y: 31
      },
      {
        unified: "1f64b-1f3ff-200d-2640-fe0f",
        native: "🙋🏿‍♀️",
        x: 34,
        y: 32
      }
    ],
    version: 4
  },
  deaf_person: {
    id: "deaf_person",
    name: "Deaf Person",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf",
        native: "🧏",
        x: 47,
        y: 5
      },
      {
        unified: "1f9cf-1f3fb",
        native: "🧏🏻",
        x: 47,
        y: 6
      },
      {
        unified: "1f9cf-1f3fc",
        native: "🧏🏼",
        x: 47,
        y: 7
      },
      {
        unified: "1f9cf-1f3fd",
        native: "🧏🏽",
        x: 47,
        y: 8
      },
      {
        unified: "1f9cf-1f3fe",
        native: "🧏🏾",
        x: 47,
        y: 9
      },
      {
        unified: "1f9cf-1f3ff",
        native: "🧏🏿",
        x: 47,
        y: 10
      }
    ],
    version: 12
  },
  deaf_man: {
    id: "deaf_man",
    name: "Deaf Man",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2642-fe0f",
        native: "🧏‍♂️",
        x: 46,
        y: 60
      },
      {
        unified: "1f9cf-1f3fb-200d-2642-fe0f",
        native: "🧏🏻‍♂️",
        x: 47,
        y: 0
      },
      {
        unified: "1f9cf-1f3fc-200d-2642-fe0f",
        native: "🧏🏼‍♂️",
        x: 47,
        y: 1
      },
      {
        unified: "1f9cf-1f3fd-200d-2642-fe0f",
        native: "🧏🏽‍♂️",
        x: 47,
        y: 2
      },
      {
        unified: "1f9cf-1f3fe-200d-2642-fe0f",
        native: "🧏🏾‍♂️",
        x: 47,
        y: 3
      },
      {
        unified: "1f9cf-1f3ff-200d-2642-fe0f",
        native: "🧏🏿‍♂️",
        x: 47,
        y: 4
      }
    ],
    version: 12
  },
  deaf_woman: {
    id: "deaf_woman",
    name: "Deaf Woman",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2640-fe0f",
        native: "🧏‍♀️",
        x: 46,
        y: 54
      },
      {
        unified: "1f9cf-1f3fb-200d-2640-fe0f",
        native: "🧏🏻‍♀️",
        x: 46,
        y: 55
      },
      {
        unified: "1f9cf-1f3fc-200d-2640-fe0f",
        native: "🧏🏼‍♀️",
        x: 46,
        y: 56
      },
      {
        unified: "1f9cf-1f3fd-200d-2640-fe0f",
        native: "🧏🏽‍♀️",
        x: 46,
        y: 57
      },
      {
        unified: "1f9cf-1f3fe-200d-2640-fe0f",
        native: "🧏🏾‍♀️",
        x: 46,
        y: 58
      },
      {
        unified: "1f9cf-1f3ff-200d-2640-fe0f",
        native: "🧏🏿‍♀️",
        x: 46,
        y: 59
      }
    ],
    version: 12
  },
  bow: {
    id: "bow",
    name: "Person Bowing",
    keywords: [
      "bow",
      "respectiful"
    ],
    skins: [
      {
        unified: "1f647",
        native: "🙇",
        x: 34,
        y: 18
      },
      {
        unified: "1f647-1f3fb",
        native: "🙇🏻",
        x: 34,
        y: 19
      },
      {
        unified: "1f647-1f3fc",
        native: "🙇🏼",
        x: 34,
        y: 20
      },
      {
        unified: "1f647-1f3fd",
        native: "🙇🏽",
        x: 34,
        y: 21
      },
      {
        unified: "1f647-1f3fe",
        native: "🙇🏾",
        x: 34,
        y: 22
      },
      {
        unified: "1f647-1f3ff",
        native: "🙇🏿",
        x: 34,
        y: 23
      }
    ],
    version: 1
  },
  "man-bowing": {
    id: "man-bowing",
    name: "Man Bowing",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f647-200d-2642-fe0f",
        native: "🙇‍♂️",
        x: 34,
        y: 12
      },
      {
        unified: "1f647-1f3fb-200d-2642-fe0f",
        native: "🙇🏻‍♂️",
        x: 34,
        y: 13
      },
      {
        unified: "1f647-1f3fc-200d-2642-fe0f",
        native: "🙇🏼‍♂️",
        x: 34,
        y: 14
      },
      {
        unified: "1f647-1f3fd-200d-2642-fe0f",
        native: "🙇🏽‍♂️",
        x: 34,
        y: 15
      },
      {
        unified: "1f647-1f3fe-200d-2642-fe0f",
        native: "🙇🏾‍♂️",
        x: 34,
        y: 16
      },
      {
        unified: "1f647-1f3ff-200d-2642-fe0f",
        native: "🙇🏿‍♂️",
        x: 34,
        y: 17
      }
    ],
    version: 4
  },
  "woman-bowing": {
    id: "woman-bowing",
    name: "Woman Bowing",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f647-200d-2640-fe0f",
        native: "🙇‍♀️",
        x: 34,
        y: 6
      },
      {
        unified: "1f647-1f3fb-200d-2640-fe0f",
        native: "🙇🏻‍♀️",
        x: 34,
        y: 7
      },
      {
        unified: "1f647-1f3fc-200d-2640-fe0f",
        native: "🙇🏼‍♀️",
        x: 34,
        y: 8
      },
      {
        unified: "1f647-1f3fd-200d-2640-fe0f",
        native: "🙇🏽‍♀️",
        x: 34,
        y: 9
      },
      {
        unified: "1f647-1f3fe-200d-2640-fe0f",
        native: "🙇🏾‍♀️",
        x: 34,
        y: 10
      },
      {
        unified: "1f647-1f3ff-200d-2640-fe0f",
        native: "🙇🏿‍♀️",
        x: 34,
        y: 11
      }
    ],
    version: 4
  },
  face_palm: {
    id: "face_palm",
    name: "Face Palm",
    keywords: [
      "person",
      "facepalming",
      "disappointed"
    ],
    skins: [
      {
        unified: "1f926",
        native: "🤦",
        x: 40,
        y: 30
      },
      {
        unified: "1f926-1f3fb",
        native: "🤦🏻",
        x: 40,
        y: 31
      },
      {
        unified: "1f926-1f3fc",
        native: "🤦🏼",
        x: 40,
        y: 32
      },
      {
        unified: "1f926-1f3fd",
        native: "🤦🏽",
        x: 40,
        y: 33
      },
      {
        unified: "1f926-1f3fe",
        native: "🤦🏾",
        x: 40,
        y: 34
      },
      {
        unified: "1f926-1f3ff",
        native: "🤦🏿",
        x: 40,
        y: 35
      }
    ],
    version: 3
  },
  "man-facepalming": {
    id: "man-facepalming",
    name: "Man Facepalming",
    keywords: [
      "male",
      "boy",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2642-fe0f",
        native: "🤦‍♂️",
        x: 40,
        y: 24
      },
      {
        unified: "1f926-1f3fb-200d-2642-fe0f",
        native: "🤦🏻‍♂️",
        x: 40,
        y: 25
      },
      {
        unified: "1f926-1f3fc-200d-2642-fe0f",
        native: "🤦🏼‍♂️",
        x: 40,
        y: 26
      },
      {
        unified: "1f926-1f3fd-200d-2642-fe0f",
        native: "🤦🏽‍♂️",
        x: 40,
        y: 27
      },
      {
        unified: "1f926-1f3fe-200d-2642-fe0f",
        native: "🤦🏾‍♂️",
        x: 40,
        y: 28
      },
      {
        unified: "1f926-1f3ff-200d-2642-fe0f",
        native: "🤦🏿‍♂️",
        x: 40,
        y: 29
      }
    ],
    version: 4
  },
  "woman-facepalming": {
    id: "woman-facepalming",
    name: "Woman Facepalming",
    keywords: [
      "female",
      "girl",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2640-fe0f",
        native: "🤦‍♀️",
        x: 40,
        y: 18
      },
      {
        unified: "1f926-1f3fb-200d-2640-fe0f",
        native: "🤦🏻‍♀️",
        x: 40,
        y: 19
      },
      {
        unified: "1f926-1f3fc-200d-2640-fe0f",
        native: "🤦🏼‍♀️",
        x: 40,
        y: 20
      },
      {
        unified: "1f926-1f3fd-200d-2640-fe0f",
        native: "🤦🏽‍♀️",
        x: 40,
        y: 21
      },
      {
        unified: "1f926-1f3fe-200d-2640-fe0f",
        native: "🤦🏾‍♀️",
        x: 40,
        y: 22
      },
      {
        unified: "1f926-1f3ff-200d-2640-fe0f",
        native: "🤦🏿‍♀️",
        x: 40,
        y: 23
      }
    ],
    version: 4
  },
  shrug: {
    id: "shrug",
    name: "Shrug",
    keywords: [
      "person",
      "shrugging",
      "regardless"
    ],
    skins: [
      {
        unified: "1f937",
        native: "🤷",
        x: 41,
        y: 50
      },
      {
        unified: "1f937-1f3fb",
        native: "🤷🏻",
        x: 41,
        y: 51
      },
      {
        unified: "1f937-1f3fc",
        native: "🤷🏼",
        x: 41,
        y: 52
      },
      {
        unified: "1f937-1f3fd",
        native: "🤷🏽",
        x: 41,
        y: 53
      },
      {
        unified: "1f937-1f3fe",
        native: "🤷🏾",
        x: 41,
        y: 54
      },
      {
        unified: "1f937-1f3ff",
        native: "🤷🏿",
        x: 41,
        y: 55
      }
    ],
    version: 3
  },
  "man-shrugging": {
    id: "man-shrugging",
    name: "Man Shrugging",
    keywords: [
      "male",
      "boy",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2642-fe0f",
        native: "🤷‍♂️",
        x: 41,
        y: 44
      },
      {
        unified: "1f937-1f3fb-200d-2642-fe0f",
        native: "🤷🏻‍♂️",
        x: 41,
        y: 45
      },
      {
        unified: "1f937-1f3fc-200d-2642-fe0f",
        native: "🤷🏼‍♂️",
        x: 41,
        y: 46
      },
      {
        unified: "1f937-1f3fd-200d-2642-fe0f",
        native: "🤷🏽‍♂️",
        x: 41,
        y: 47
      },
      {
        unified: "1f937-1f3fe-200d-2642-fe0f",
        native: "🤷🏾‍♂️",
        x: 41,
        y: 48
      },
      {
        unified: "1f937-1f3ff-200d-2642-fe0f",
        native: "🤷🏿‍♂️",
        x: 41,
        y: 49
      }
    ],
    version: 4
  },
  "woman-shrugging": {
    id: "woman-shrugging",
    name: "Woman Shrugging",
    keywords: [
      "female",
      "girl",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2640-fe0f",
        native: "🤷‍♀️",
        x: 41,
        y: 38
      },
      {
        unified: "1f937-1f3fb-200d-2640-fe0f",
        native: "🤷🏻‍♀️",
        x: 41,
        y: 39
      },
      {
        unified: "1f937-1f3fc-200d-2640-fe0f",
        native: "🤷🏼‍♀️",
        x: 41,
        y: 40
      },
      {
        unified: "1f937-1f3fd-200d-2640-fe0f",
        native: "🤷🏽‍♀️",
        x: 41,
        y: 41
      },
      {
        unified: "1f937-1f3fe-200d-2640-fe0f",
        native: "🤷🏾‍♀️",
        x: 41,
        y: 42
      },
      {
        unified: "1f937-1f3ff-200d-2640-fe0f",
        native: "🤷🏿‍♀️",
        x: 41,
        y: 43
      }
    ],
    version: 4
  },
  health_worker: {
    id: "health_worker",
    name: "Health Worker",
    keywords: [
      "hospital"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2695-fe0f",
        native: "🧑‍⚕️",
        x: 49,
        y: 48
      },
      {
        unified: "1f9d1-1f3fb-200d-2695-fe0f",
        native: "🧑🏻‍⚕️",
        x: 49,
        y: 49
      },
      {
        unified: "1f9d1-1f3fc-200d-2695-fe0f",
        native: "🧑🏼‍⚕️",
        x: 49,
        y: 50
      },
      {
        unified: "1f9d1-1f3fd-200d-2695-fe0f",
        native: "🧑🏽‍⚕️",
        x: 49,
        y: 51
      },
      {
        unified: "1f9d1-1f3fe-200d-2695-fe0f",
        native: "🧑🏾‍⚕️",
        x: 49,
        y: 52
      },
      {
        unified: "1f9d1-1f3ff-200d-2695-fe0f",
        native: "🧑🏿‍⚕️",
        x: 49,
        y: 53
      }
    ],
    version: 12.1
  },
  "male-doctor": {
    id: "male-doctor",
    name: "Man Health Worker",
    keywords: [
      "male",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2695-fe0f",
        native: "👨‍⚕️",
        x: 16,
        y: 4
      },
      {
        unified: "1f468-1f3fb-200d-2695-fe0f",
        native: "👨🏻‍⚕️",
        x: 16,
        y: 5
      },
      {
        unified: "1f468-1f3fc-200d-2695-fe0f",
        native: "👨🏼‍⚕️",
        x: 16,
        y: 6
      },
      {
        unified: "1f468-1f3fd-200d-2695-fe0f",
        native: "👨🏽‍⚕️",
        x: 16,
        y: 7
      },
      {
        unified: "1f468-1f3fe-200d-2695-fe0f",
        native: "👨🏾‍⚕️",
        x: 16,
        y: 8
      },
      {
        unified: "1f468-1f3ff-200d-2695-fe0f",
        native: "👨🏿‍⚕️",
        x: 16,
        y: 9
      }
    ],
    version: 4
  },
  "female-doctor": {
    id: "female-doctor",
    name: "Woman Health Worker",
    keywords: [
      "female",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2695-fe0f",
        native: "👩‍⚕️",
        x: 19,
        y: 33
      },
      {
        unified: "1f469-1f3fb-200d-2695-fe0f",
        native: "👩🏻‍⚕️",
        x: 19,
        y: 34
      },
      {
        unified: "1f469-1f3fc-200d-2695-fe0f",
        native: "👩🏼‍⚕️",
        x: 19,
        y: 35
      },
      {
        unified: "1f469-1f3fd-200d-2695-fe0f",
        native: "👩🏽‍⚕️",
        x: 19,
        y: 36
      },
      {
        unified: "1f469-1f3fe-200d-2695-fe0f",
        native: "👩🏾‍⚕️",
        x: 19,
        y: 37
      },
      {
        unified: "1f469-1f3ff-200d-2695-fe0f",
        native: "👩🏿‍⚕️",
        x: 19,
        y: 38
      }
    ],
    version: 4
  },
  student: {
    id: "student",
    name: "Student",
    keywords: [
      "learn"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f393",
        native: "🧑‍🎓",
        x: 47,
        y: 36
      },
      {
        unified: "1f9d1-1f3fb-200d-1f393",
        native: "🧑🏻‍🎓",
        x: 47,
        y: 37
      },
      {
        unified: "1f9d1-1f3fc-200d-1f393",
        native: "🧑🏼‍🎓",
        x: 47,
        y: 38
      },
      {
        unified: "1f9d1-1f3fd-200d-1f393",
        native: "🧑🏽‍🎓",
        x: 47,
        y: 39
      },
      {
        unified: "1f9d1-1f3fe-200d-1f393",
        native: "🧑🏾‍🎓",
        x: 47,
        y: 40
      },
      {
        unified: "1f9d1-1f3ff-200d-1f393",
        native: "🧑🏿‍🎓",
        x: 47,
        y: 41
      }
    ],
    version: 12.1
  },
  "male-student": {
    id: "male-student",
    name: "Man Student",
    keywords: [
      "male",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f393",
        native: "👨‍🎓",
        x: 14,
        y: 3
      },
      {
        unified: "1f468-1f3fb-200d-1f393",
        native: "👨🏻‍🎓",
        x: 14,
        y: 4
      },
      {
        unified: "1f468-1f3fc-200d-1f393",
        native: "👨🏼‍🎓",
        x: 14,
        y: 5
      },
      {
        unified: "1f468-1f3fd-200d-1f393",
        native: "👨🏽‍🎓",
        x: 14,
        y: 6
      },
      {
        unified: "1f468-1f3fe-200d-1f393",
        native: "👨🏾‍🎓",
        x: 14,
        y: 7
      },
      {
        unified: "1f468-1f3ff-200d-1f393",
        native: "👨🏿‍🎓",
        x: 14,
        y: 8
      }
    ],
    version: 4
  },
  "female-student": {
    id: "female-student",
    name: "Woman Student",
    keywords: [
      "female",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f393",
        native: "👩‍🎓",
        x: 17,
        y: 37
      },
      {
        unified: "1f469-1f3fb-200d-1f393",
        native: "👩🏻‍🎓",
        x: 17,
        y: 38
      },
      {
        unified: "1f469-1f3fc-200d-1f393",
        native: "👩🏼‍🎓",
        x: 17,
        y: 39
      },
      {
        unified: "1f469-1f3fd-200d-1f393",
        native: "👩🏽‍🎓",
        x: 17,
        y: 40
      },
      {
        unified: "1f469-1f3fe-200d-1f393",
        native: "👩🏾‍🎓",
        x: 17,
        y: 41
      },
      {
        unified: "1f469-1f3ff-200d-1f393",
        native: "👩🏿‍🎓",
        x: 17,
        y: 42
      }
    ],
    version: 4
  },
  teacher: {
    id: "teacher",
    name: "Teacher",
    keywords: [
      "professor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3eb",
        native: "🧑‍🏫",
        x: 47,
        y: 54
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3eb",
        native: "🧑🏻‍🏫",
        x: 47,
        y: 55
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3eb",
        native: "🧑🏼‍🏫",
        x: 47,
        y: 56
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3eb",
        native: "🧑🏽‍🏫",
        x: 47,
        y: 57
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3eb",
        native: "🧑🏾‍🏫",
        x: 47,
        y: 58
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3eb",
        native: "🧑🏿‍🏫",
        x: 47,
        y: 59
      }
    ],
    version: 12.1
  },
  "male-teacher": {
    id: "male-teacher",
    name: "Man Teacher",
    keywords: [
      "male",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3eb",
        native: "👨‍🏫",
        x: 14,
        y: 21
      },
      {
        unified: "1f468-1f3fb-200d-1f3eb",
        native: "👨🏻‍🏫",
        x: 14,
        y: 22
      },
      {
        unified: "1f468-1f3fc-200d-1f3eb",
        native: "👨🏼‍🏫",
        x: 14,
        y: 23
      },
      {
        unified: "1f468-1f3fd-200d-1f3eb",
        native: "👨🏽‍🏫",
        x: 14,
        y: 24
      },
      {
        unified: "1f468-1f3fe-200d-1f3eb",
        native: "👨🏾‍🏫",
        x: 14,
        y: 25
      },
      {
        unified: "1f468-1f3ff-200d-1f3eb",
        native: "👨🏿‍🏫",
        x: 14,
        y: 26
      }
    ],
    version: 4
  },
  "female-teacher": {
    id: "female-teacher",
    name: "Woman Teacher",
    keywords: [
      "female",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3eb",
        native: "👩‍🏫",
        x: 17,
        y: 55
      },
      {
        unified: "1f469-1f3fb-200d-1f3eb",
        native: "👩🏻‍🏫",
        x: 17,
        y: 56
      },
      {
        unified: "1f469-1f3fc-200d-1f3eb",
        native: "👩🏼‍🏫",
        x: 17,
        y: 57
      },
      {
        unified: "1f469-1f3fd-200d-1f3eb",
        native: "👩🏽‍🏫",
        x: 17,
        y: 58
      },
      {
        unified: "1f469-1f3fe-200d-1f3eb",
        native: "👩🏾‍🏫",
        x: 17,
        y: 59
      },
      {
        unified: "1f469-1f3ff-200d-1f3eb",
        native: "👩🏿‍🏫",
        x: 17,
        y: 60
      }
    ],
    version: 4
  },
  judge: {
    id: "judge",
    name: "Judge",
    keywords: [
      "law"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2696-fe0f",
        native: "🧑‍⚖️",
        x: 49,
        y: 54
      },
      {
        unified: "1f9d1-1f3fb-200d-2696-fe0f",
        native: "🧑🏻‍⚖️",
        x: 49,
        y: 55
      },
      {
        unified: "1f9d1-1f3fc-200d-2696-fe0f",
        native: "🧑🏼‍⚖️",
        x: 49,
        y: 56
      },
      {
        unified: "1f9d1-1f3fd-200d-2696-fe0f",
        native: "🧑🏽‍⚖️",
        x: 49,
        y: 57
      },
      {
        unified: "1f9d1-1f3fe-200d-2696-fe0f",
        native: "🧑🏾‍⚖️",
        x: 49,
        y: 58
      },
      {
        unified: "1f9d1-1f3ff-200d-2696-fe0f",
        native: "🧑🏿‍⚖️",
        x: 49,
        y: 59
      }
    ],
    version: 12.1
  },
  "male-judge": {
    id: "male-judge",
    name: "Man Judge",
    keywords: [
      "male",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2696-fe0f",
        native: "👨‍⚖️",
        x: 16,
        y: 10
      },
      {
        unified: "1f468-1f3fb-200d-2696-fe0f",
        native: "👨🏻‍⚖️",
        x: 16,
        y: 11
      },
      {
        unified: "1f468-1f3fc-200d-2696-fe0f",
        native: "👨🏼‍⚖️",
        x: 16,
        y: 12
      },
      {
        unified: "1f468-1f3fd-200d-2696-fe0f",
        native: "👨🏽‍⚖️",
        x: 16,
        y: 13
      },
      {
        unified: "1f468-1f3fe-200d-2696-fe0f",
        native: "👨🏾‍⚖️",
        x: 16,
        y: 14
      },
      {
        unified: "1f468-1f3ff-200d-2696-fe0f",
        native: "👨🏿‍⚖️",
        x: 16,
        y: 15
      }
    ],
    version: 4
  },
  "female-judge": {
    id: "female-judge",
    name: "Woman Judge",
    keywords: [
      "female",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2696-fe0f",
        native: "👩‍⚖️",
        x: 19,
        y: 39
      },
      {
        unified: "1f469-1f3fb-200d-2696-fe0f",
        native: "👩🏻‍⚖️",
        x: 19,
        y: 40
      },
      {
        unified: "1f469-1f3fc-200d-2696-fe0f",
        native: "👩🏼‍⚖️",
        x: 19,
        y: 41
      },
      {
        unified: "1f469-1f3fd-200d-2696-fe0f",
        native: "👩🏽‍⚖️",
        x: 19,
        y: 42
      },
      {
        unified: "1f469-1f3fe-200d-2696-fe0f",
        native: "👩🏾‍⚖️",
        x: 19,
        y: 43
      },
      {
        unified: "1f469-1f3ff-200d-2696-fe0f",
        native: "👩🏿‍⚖️",
        x: 19,
        y: 44
      }
    ],
    version: 4
  },
  farmer: {
    id: "farmer",
    name: "Farmer",
    keywords: [
      "crops"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f33e",
        native: "🧑‍🌾",
        x: 47,
        y: 12
      },
      {
        unified: "1f9d1-1f3fb-200d-1f33e",
        native: "🧑🏻‍🌾",
        x: 47,
        y: 13
      },
      {
        unified: "1f9d1-1f3fc-200d-1f33e",
        native: "🧑🏼‍🌾",
        x: 47,
        y: 14
      },
      {
        unified: "1f9d1-1f3fd-200d-1f33e",
        native: "🧑🏽‍🌾",
        x: 47,
        y: 15
      },
      {
        unified: "1f9d1-1f3fe-200d-1f33e",
        native: "🧑🏾‍🌾",
        x: 47,
        y: 16
      },
      {
        unified: "1f9d1-1f3ff-200d-1f33e",
        native: "🧑🏿‍🌾",
        x: 47,
        y: 17
      }
    ],
    version: 12.1
  },
  "male-farmer": {
    id: "male-farmer",
    name: "Man Farmer",
    keywords: [
      "male",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f33e",
        native: "👨‍🌾",
        x: 13,
        y: 46
      },
      {
        unified: "1f468-1f3fb-200d-1f33e",
        native: "👨🏻‍🌾",
        x: 13,
        y: 47
      },
      {
        unified: "1f468-1f3fc-200d-1f33e",
        native: "👨🏼‍🌾",
        x: 13,
        y: 48
      },
      {
        unified: "1f468-1f3fd-200d-1f33e",
        native: "👨🏽‍🌾",
        x: 13,
        y: 49
      },
      {
        unified: "1f468-1f3fe-200d-1f33e",
        native: "👨🏾‍🌾",
        x: 13,
        y: 50
      },
      {
        unified: "1f468-1f3ff-200d-1f33e",
        native: "👨🏿‍🌾",
        x: 13,
        y: 51
      }
    ],
    version: 4
  },
  "female-farmer": {
    id: "female-farmer",
    name: "Woman Farmer",
    keywords: [
      "female",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f33e",
        native: "👩‍🌾",
        x: 17,
        y: 19
      },
      {
        unified: "1f469-1f3fb-200d-1f33e",
        native: "👩🏻‍🌾",
        x: 17,
        y: 20
      },
      {
        unified: "1f469-1f3fc-200d-1f33e",
        native: "👩🏼‍🌾",
        x: 17,
        y: 21
      },
      {
        unified: "1f469-1f3fd-200d-1f33e",
        native: "👩🏽‍🌾",
        x: 17,
        y: 22
      },
      {
        unified: "1f469-1f3fe-200d-1f33e",
        native: "👩🏾‍🌾",
        x: 17,
        y: 23
      },
      {
        unified: "1f469-1f3ff-200d-1f33e",
        native: "👩🏿‍🌾",
        x: 17,
        y: 24
      }
    ],
    version: 4
  },
  cook: {
    id: "cook",
    name: "Cook",
    keywords: [
      "food",
      "kitchen",
      "culinary"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f373",
        native: "🧑‍🍳",
        x: 47,
        y: 18
      },
      {
        unified: "1f9d1-1f3fb-200d-1f373",
        native: "🧑🏻‍🍳",
        x: 47,
        y: 19
      },
      {
        unified: "1f9d1-1f3fc-200d-1f373",
        native: "🧑🏼‍🍳",
        x: 47,
        y: 20
      },
      {
        unified: "1f9d1-1f3fd-200d-1f373",
        native: "🧑🏽‍🍳",
        x: 47,
        y: 21
      },
      {
        unified: "1f9d1-1f3fe-200d-1f373",
        native: "🧑🏾‍🍳",
        x: 47,
        y: 22
      },
      {
        unified: "1f9d1-1f3ff-200d-1f373",
        native: "🧑🏿‍🍳",
        x: 47,
        y: 23
      }
    ],
    version: 12.1
  },
  "male-cook": {
    id: "male-cook",
    name: "Man Cook",
    keywords: [
      "male",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f373",
        native: "👨‍🍳",
        x: 13,
        y: 52
      },
      {
        unified: "1f468-1f3fb-200d-1f373",
        native: "👨🏻‍🍳",
        x: 13,
        y: 53
      },
      {
        unified: "1f468-1f3fc-200d-1f373",
        native: "👨🏼‍🍳",
        x: 13,
        y: 54
      },
      {
        unified: "1f468-1f3fd-200d-1f373",
        native: "👨🏽‍🍳",
        x: 13,
        y: 55
      },
      {
        unified: "1f468-1f3fe-200d-1f373",
        native: "👨🏾‍🍳",
        x: 13,
        y: 56
      },
      {
        unified: "1f468-1f3ff-200d-1f373",
        native: "👨🏿‍🍳",
        x: 13,
        y: 57
      }
    ],
    version: 4
  },
  "female-cook": {
    id: "female-cook",
    name: "Woman Cook",
    keywords: [
      "female",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f373",
        native: "👩‍🍳",
        x: 17,
        y: 25
      },
      {
        unified: "1f469-1f3fb-200d-1f373",
        native: "👩🏻‍🍳",
        x: 17,
        y: 26
      },
      {
        unified: "1f469-1f3fc-200d-1f373",
        native: "👩🏼‍🍳",
        x: 17,
        y: 27
      },
      {
        unified: "1f469-1f3fd-200d-1f373",
        native: "👩🏽‍🍳",
        x: 17,
        y: 28
      },
      {
        unified: "1f469-1f3fe-200d-1f373",
        native: "👩🏾‍🍳",
        x: 17,
        y: 29
      },
      {
        unified: "1f469-1f3ff-200d-1f373",
        native: "👩🏿‍🍳",
        x: 17,
        y: 30
      }
    ],
    version: 4
  },
  mechanic: {
    id: "mechanic",
    name: "Mechanic",
    keywords: [
      "worker",
      "technician"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f527",
        native: "🧑‍🔧",
        x: 48,
        y: 17
      },
      {
        unified: "1f9d1-1f3fb-200d-1f527",
        native: "🧑🏻‍🔧",
        x: 48,
        y: 18
      },
      {
        unified: "1f9d1-1f3fc-200d-1f527",
        native: "🧑🏼‍🔧",
        x: 48,
        y: 19
      },
      {
        unified: "1f9d1-1f3fd-200d-1f527",
        native: "🧑🏽‍🔧",
        x: 48,
        y: 20
      },
      {
        unified: "1f9d1-1f3fe-200d-1f527",
        native: "🧑🏾‍🔧",
        x: 48,
        y: 21
      },
      {
        unified: "1f9d1-1f3ff-200d-1f527",
        native: "🧑🏿‍🔧",
        x: 48,
        y: 22
      }
    ],
    version: 12.1
  },
  "male-mechanic": {
    id: "male-mechanic",
    name: "Man Mechanic",
    keywords: [
      "male",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f468-200d-1f527",
        native: "👨‍🔧",
        x: 14,
        y: 60
      },
      {
        unified: "1f468-1f3fb-200d-1f527",
        native: "👨🏻‍🔧",
        x: 15,
        y: 0
      },
      {
        unified: "1f468-1f3fc-200d-1f527",
        native: "👨🏼‍🔧",
        x: 15,
        y: 1
      },
      {
        unified: "1f468-1f3fd-200d-1f527",
        native: "👨🏽‍🔧",
        x: 15,
        y: 2
      },
      {
        unified: "1f468-1f3fe-200d-1f527",
        native: "👨🏾‍🔧",
        x: 15,
        y: 3
      },
      {
        unified: "1f468-1f3ff-200d-1f527",
        native: "👨🏿‍🔧",
        x: 15,
        y: 4
      }
    ],
    version: 4
  },
  "female-mechanic": {
    id: "female-mechanic",
    name: "Woman Mechanic",
    keywords: [
      "female",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f469-200d-1f527",
        native: "👩‍🔧",
        x: 18,
        y: 28
      },
      {
        unified: "1f469-1f3fb-200d-1f527",
        native: "👩🏻‍🔧",
        x: 18,
        y: 29
      },
      {
        unified: "1f469-1f3fc-200d-1f527",
        native: "👩🏼‍🔧",
        x: 18,
        y: 30
      },
      {
        unified: "1f469-1f3fd-200d-1f527",
        native: "👩🏽‍🔧",
        x: 18,
        y: 31
      },
      {
        unified: "1f469-1f3fe-200d-1f527",
        native: "👩🏾‍🔧",
        x: 18,
        y: 32
      },
      {
        unified: "1f469-1f3ff-200d-1f527",
        native: "👩🏿‍🔧",
        x: 18,
        y: 33
      }
    ],
    version: 4
  },
  factory_worker: {
    id: "factory_worker",
    name: "Factory Worker",
    keywords: [
      "labor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3ed",
        native: "🧑‍🏭",
        x: 47,
        y: 60
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3ed",
        native: "🧑🏻‍🏭",
        x: 48,
        y: 0
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3ed",
        native: "🧑🏼‍🏭",
        x: 48,
        y: 1
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3ed",
        native: "🧑🏽‍🏭",
        x: 48,
        y: 2
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3ed",
        native: "🧑🏾‍🏭",
        x: 48,
        y: 3
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3ed",
        native: "🧑🏿‍🏭",
        x: 48,
        y: 4
      }
    ],
    version: 12.1
  },
  "male-factory-worker": {
    id: "male-factory-worker",
    name: "Man Factory Worker",
    keywords: [
      "male",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3ed",
        native: "👨‍🏭",
        x: 14,
        y: 27
      },
      {
        unified: "1f468-1f3fb-200d-1f3ed",
        native: "👨🏻‍🏭",
        x: 14,
        y: 28
      },
      {
        unified: "1f468-1f3fc-200d-1f3ed",
        native: "👨🏼‍🏭",
        x: 14,
        y: 29
      },
      {
        unified: "1f468-1f3fd-200d-1f3ed",
        native: "👨🏽‍🏭",
        x: 14,
        y: 30
      },
      {
        unified: "1f468-1f3fe-200d-1f3ed",
        native: "👨🏾‍🏭",
        x: 14,
        y: 31
      },
      {
        unified: "1f468-1f3ff-200d-1f3ed",
        native: "👨🏿‍🏭",
        x: 14,
        y: 32
      }
    ],
    version: 4
  },
  "female-factory-worker": {
    id: "female-factory-worker",
    name: "Woman Factory Worker",
    keywords: [
      "female",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3ed",
        native: "👩‍🏭",
        x: 18,
        y: 0
      },
      {
        unified: "1f469-1f3fb-200d-1f3ed",
        native: "👩🏻‍🏭",
        x: 18,
        y: 1
      },
      {
        unified: "1f469-1f3fc-200d-1f3ed",
        native: "👩🏼‍🏭",
        x: 18,
        y: 2
      },
      {
        unified: "1f469-1f3fd-200d-1f3ed",
        native: "👩🏽‍🏭",
        x: 18,
        y: 3
      },
      {
        unified: "1f469-1f3fe-200d-1f3ed",
        native: "👩🏾‍🏭",
        x: 18,
        y: 4
      },
      {
        unified: "1f469-1f3ff-200d-1f3ed",
        native: "👩🏿‍🏭",
        x: 18,
        y: 5
      }
    ],
    version: 4
  },
  office_worker: {
    id: "office_worker",
    name: "Office Worker",
    keywords: [
      "business"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bc",
        native: "🧑‍💼",
        x: 48,
        y: 11
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bc",
        native: "🧑🏻‍💼",
        x: 48,
        y: 12
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bc",
        native: "🧑🏼‍💼",
        x: 48,
        y: 13
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bc",
        native: "🧑🏽‍💼",
        x: 48,
        y: 14
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bc",
        native: "🧑🏾‍💼",
        x: 48,
        y: 15
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bc",
        native: "🧑🏿‍💼",
        x: 48,
        y: 16
      }
    ],
    version: 12.1
  },
  "male-office-worker": {
    id: "male-office-worker",
    name: "Man Office Worker",
    keywords: [
      "male",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bc",
        native: "👨‍💼",
        x: 14,
        y: 54
      },
      {
        unified: "1f468-1f3fb-200d-1f4bc",
        native: "👨🏻‍💼",
        x: 14,
        y: 55
      },
      {
        unified: "1f468-1f3fc-200d-1f4bc",
        native: "👨🏼‍💼",
        x: 14,
        y: 56
      },
      {
        unified: "1f468-1f3fd-200d-1f4bc",
        native: "👨🏽‍💼",
        x: 14,
        y: 57
      },
      {
        unified: "1f468-1f3fe-200d-1f4bc",
        native: "👨🏾‍💼",
        x: 14,
        y: 58
      },
      {
        unified: "1f468-1f3ff-200d-1f4bc",
        native: "👨🏿‍💼",
        x: 14,
        y: 59
      }
    ],
    version: 4
  },
  "female-office-worker": {
    id: "female-office-worker",
    name: "Woman Office Worker",
    keywords: [
      "female",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bc",
        native: "👩‍💼",
        x: 18,
        y: 22
      },
      {
        unified: "1f469-1f3fb-200d-1f4bc",
        native: "👩🏻‍💼",
        x: 18,
        y: 23
      },
      {
        unified: "1f469-1f3fc-200d-1f4bc",
        native: "👩🏼‍💼",
        x: 18,
        y: 24
      },
      {
        unified: "1f469-1f3fd-200d-1f4bc",
        native: "👩🏽‍💼",
        x: 18,
        y: 25
      },
      {
        unified: "1f469-1f3fe-200d-1f4bc",
        native: "👩🏾‍💼",
        x: 18,
        y: 26
      },
      {
        unified: "1f469-1f3ff-200d-1f4bc",
        native: "👩🏿‍💼",
        x: 18,
        y: 27
      }
    ],
    version: 4
  },
  scientist: {
    id: "scientist",
    name: "Scientist",
    keywords: [
      "chemistry"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f52c",
        native: "🧑‍🔬",
        x: 48,
        y: 23
      },
      {
        unified: "1f9d1-1f3fb-200d-1f52c",
        native: "🧑🏻‍🔬",
        x: 48,
        y: 24
      },
      {
        unified: "1f9d1-1f3fc-200d-1f52c",
        native: "🧑🏼‍🔬",
        x: 48,
        y: 25
      },
      {
        unified: "1f9d1-1f3fd-200d-1f52c",
        native: "🧑🏽‍🔬",
        x: 48,
        y: 26
      },
      {
        unified: "1f9d1-1f3fe-200d-1f52c",
        native: "🧑🏾‍🔬",
        x: 48,
        y: 27
      },
      {
        unified: "1f9d1-1f3ff-200d-1f52c",
        native: "🧑🏿‍🔬",
        x: 48,
        y: 28
      }
    ],
    version: 12.1
  },
  "male-scientist": {
    id: "male-scientist",
    name: "Man Scientist",
    keywords: [
      "male",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f52c",
        native: "👨‍🔬",
        x: 15,
        y: 5
      },
      {
        unified: "1f468-1f3fb-200d-1f52c",
        native: "👨🏻‍🔬",
        x: 15,
        y: 6
      },
      {
        unified: "1f468-1f3fc-200d-1f52c",
        native: "👨🏼‍🔬",
        x: 15,
        y: 7
      },
      {
        unified: "1f468-1f3fd-200d-1f52c",
        native: "👨🏽‍🔬",
        x: 15,
        y: 8
      },
      {
        unified: "1f468-1f3fe-200d-1f52c",
        native: "👨🏾‍🔬",
        x: 15,
        y: 9
      },
      {
        unified: "1f468-1f3ff-200d-1f52c",
        native: "👨🏿‍🔬",
        x: 15,
        y: 10
      }
    ],
    version: 4
  },
  "female-scientist": {
    id: "female-scientist",
    name: "Woman Scientist",
    keywords: [
      "female",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f52c",
        native: "👩‍🔬",
        x: 18,
        y: 34
      },
      {
        unified: "1f469-1f3fb-200d-1f52c",
        native: "👩🏻‍🔬",
        x: 18,
        y: 35
      },
      {
        unified: "1f469-1f3fc-200d-1f52c",
        native: "👩🏼‍🔬",
        x: 18,
        y: 36
      },
      {
        unified: "1f469-1f3fd-200d-1f52c",
        native: "👩🏽‍🔬",
        x: 18,
        y: 37
      },
      {
        unified: "1f469-1f3fe-200d-1f52c",
        native: "👩🏾‍🔬",
        x: 18,
        y: 38
      },
      {
        unified: "1f469-1f3ff-200d-1f52c",
        native: "👩🏿‍🔬",
        x: 18,
        y: 39
      }
    ],
    version: 4
  },
  technologist: {
    id: "technologist",
    name: "Technologist",
    keywords: [
      "computer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bb",
        native: "🧑‍💻",
        x: 48,
        y: 5
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bb",
        native: "🧑🏻‍💻",
        x: 48,
        y: 6
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bb",
        native: "🧑🏼‍💻",
        x: 48,
        y: 7
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bb",
        native: "🧑🏽‍💻",
        x: 48,
        y: 8
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bb",
        native: "🧑🏾‍💻",
        x: 48,
        y: 9
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bb",
        native: "🧑🏿‍💻",
        x: 48,
        y: 10
      }
    ],
    version: 12.1
  },
  "male-technologist": {
    id: "male-technologist",
    name: "Man Technologist",
    keywords: [
      "male",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bb",
        native: "👨‍💻",
        x: 14,
        y: 48
      },
      {
        unified: "1f468-1f3fb-200d-1f4bb",
        native: "👨🏻‍💻",
        x: 14,
        y: 49
      },
      {
        unified: "1f468-1f3fc-200d-1f4bb",
        native: "👨🏼‍💻",
        x: 14,
        y: 50
      },
      {
        unified: "1f468-1f3fd-200d-1f4bb",
        native: "👨🏽‍💻",
        x: 14,
        y: 51
      },
      {
        unified: "1f468-1f3fe-200d-1f4bb",
        native: "👨🏾‍💻",
        x: 14,
        y: 52
      },
      {
        unified: "1f468-1f3ff-200d-1f4bb",
        native: "👨🏿‍💻",
        x: 14,
        y: 53
      }
    ],
    version: 4
  },
  "female-technologist": {
    id: "female-technologist",
    name: "Woman Technologist",
    keywords: [
      "female",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bb",
        native: "👩‍💻",
        x: 18,
        y: 16
      },
      {
        unified: "1f469-1f3fb-200d-1f4bb",
        native: "👩🏻‍💻",
        x: 18,
        y: 17
      },
      {
        unified: "1f469-1f3fc-200d-1f4bb",
        native: "👩🏼‍💻",
        x: 18,
        y: 18
      },
      {
        unified: "1f469-1f3fd-200d-1f4bb",
        native: "👩🏽‍💻",
        x: 18,
        y: 19
      },
      {
        unified: "1f469-1f3fe-200d-1f4bb",
        native: "👩🏾‍💻",
        x: 18,
        y: 20
      },
      {
        unified: "1f469-1f3ff-200d-1f4bb",
        native: "👩🏿‍💻",
        x: 18,
        y: 21
      }
    ],
    version: 4
  },
  singer: {
    id: "singer",
    name: "Singer",
    keywords: [
      "song",
      "artist",
      "performer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a4",
        native: "🧑‍🎤",
        x: 47,
        y: 42
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a4",
        native: "🧑🏻‍🎤",
        x: 47,
        y: 43
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a4",
        native: "🧑🏼‍🎤",
        x: 47,
        y: 44
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a4",
        native: "🧑🏽‍🎤",
        x: 47,
        y: 45
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a4",
        native: "🧑🏾‍🎤",
        x: 47,
        y: 46
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a4",
        native: "🧑🏿‍🎤",
        x: 47,
        y: 47
      }
    ],
    version: 12.1
  },
  "male-singer": {
    id: "male-singer",
    name: "Man Singer",
    keywords: [
      "male",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a4",
        native: "👨‍🎤",
        x: 14,
        y: 9
      },
      {
        unified: "1f468-1f3fb-200d-1f3a4",
        native: "👨🏻‍🎤",
        x: 14,
        y: 10
      },
      {
        unified: "1f468-1f3fc-200d-1f3a4",
        native: "👨🏼‍🎤",
        x: 14,
        y: 11
      },
      {
        unified: "1f468-1f3fd-200d-1f3a4",
        native: "👨🏽‍🎤",
        x: 14,
        y: 12
      },
      {
        unified: "1f468-1f3fe-200d-1f3a4",
        native: "👨🏾‍🎤",
        x: 14,
        y: 13
      },
      {
        unified: "1f468-1f3ff-200d-1f3a4",
        native: "👨🏿‍🎤",
        x: 14,
        y: 14
      }
    ],
    version: 4
  },
  "female-singer": {
    id: "female-singer",
    name: "Woman Singer",
    keywords: [
      "female",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a4",
        native: "👩‍🎤",
        x: 17,
        y: 43
      },
      {
        unified: "1f469-1f3fb-200d-1f3a4",
        native: "👩🏻‍🎤",
        x: 17,
        y: 44
      },
      {
        unified: "1f469-1f3fc-200d-1f3a4",
        native: "👩🏼‍🎤",
        x: 17,
        y: 45
      },
      {
        unified: "1f469-1f3fd-200d-1f3a4",
        native: "👩🏽‍🎤",
        x: 17,
        y: 46
      },
      {
        unified: "1f469-1f3fe-200d-1f3a4",
        native: "👩🏾‍🎤",
        x: 17,
        y: 47
      },
      {
        unified: "1f469-1f3ff-200d-1f3a4",
        native: "👩🏿‍🎤",
        x: 17,
        y: 48
      }
    ],
    version: 4
  },
  artist: {
    id: "artist",
    name: "Artist",
    keywords: [
      "painting",
      "draw",
      "creativity"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a8",
        native: "🧑‍🎨",
        x: 47,
        y: 48
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a8",
        native: "🧑🏻‍🎨",
        x: 47,
        y: 49
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a8",
        native: "🧑🏼‍🎨",
        x: 47,
        y: 50
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a8",
        native: "🧑🏽‍🎨",
        x: 47,
        y: 51
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a8",
        native: "🧑🏾‍🎨",
        x: 47,
        y: 52
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a8",
        native: "🧑🏿‍🎨",
        x: 47,
        y: 53
      }
    ],
    version: 12.1
  },
  "male-artist": {
    id: "male-artist",
    name: "Man Artist",
    keywords: [
      "male",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a8",
        native: "👨‍🎨",
        x: 14,
        y: 15
      },
      {
        unified: "1f468-1f3fb-200d-1f3a8",
        native: "👨🏻‍🎨",
        x: 14,
        y: 16
      },
      {
        unified: "1f468-1f3fc-200d-1f3a8",
        native: "👨🏼‍🎨",
        x: 14,
        y: 17
      },
      {
        unified: "1f468-1f3fd-200d-1f3a8",
        native: "👨🏽‍🎨",
        x: 14,
        y: 18
      },
      {
        unified: "1f468-1f3fe-200d-1f3a8",
        native: "👨🏾‍🎨",
        x: 14,
        y: 19
      },
      {
        unified: "1f468-1f3ff-200d-1f3a8",
        native: "👨🏿‍🎨",
        x: 14,
        y: 20
      }
    ],
    version: 4
  },
  "female-artist": {
    id: "female-artist",
    name: "Woman Artist",
    keywords: [
      "female",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a8",
        native: "👩‍🎨",
        x: 17,
        y: 49
      },
      {
        unified: "1f469-1f3fb-200d-1f3a8",
        native: "👩🏻‍🎨",
        x: 17,
        y: 50
      },
      {
        unified: "1f469-1f3fc-200d-1f3a8",
        native: "👩🏼‍🎨",
        x: 17,
        y: 51
      },
      {
        unified: "1f469-1f3fd-200d-1f3a8",
        native: "👩🏽‍🎨",
        x: 17,
        y: 52
      },
      {
        unified: "1f469-1f3fe-200d-1f3a8",
        native: "👩🏾‍🎨",
        x: 17,
        y: 53
      },
      {
        unified: "1f469-1f3ff-200d-1f3a8",
        native: "👩🏿‍🎨",
        x: 17,
        y: 54
      }
    ],
    version: 4
  },
  pilot: {
    id: "pilot",
    name: "Pilot",
    keywords: [
      "fly",
      "plane",
      "airplane"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2708-fe0f",
        native: "🧑‍✈️",
        x: 49,
        y: 60
      },
      {
        unified: "1f9d1-1f3fb-200d-2708-fe0f",
        native: "🧑🏻‍✈️",
        x: 50,
        y: 0
      },
      {
        unified: "1f9d1-1f3fc-200d-2708-fe0f",
        native: "🧑🏼‍✈️",
        x: 50,
        y: 1
      },
      {
        unified: "1f9d1-1f3fd-200d-2708-fe0f",
        native: "🧑🏽‍✈️",
        x: 50,
        y: 2
      },
      {
        unified: "1f9d1-1f3fe-200d-2708-fe0f",
        native: "🧑🏾‍✈️",
        x: 50,
        y: 3
      },
      {
        unified: "1f9d1-1f3ff-200d-2708-fe0f",
        native: "🧑🏿‍✈️",
        x: 50,
        y: 4
      }
    ],
    version: 12.1
  },
  "male-pilot": {
    id: "male-pilot",
    name: "Man Pilot",
    keywords: [
      "male",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2708-fe0f",
        native: "👨‍✈️",
        x: 16,
        y: 16
      },
      {
        unified: "1f468-1f3fb-200d-2708-fe0f",
        native: "👨🏻‍✈️",
        x: 16,
        y: 17
      },
      {
        unified: "1f468-1f3fc-200d-2708-fe0f",
        native: "👨🏼‍✈️",
        x: 16,
        y: 18
      },
      {
        unified: "1f468-1f3fd-200d-2708-fe0f",
        native: "👨🏽‍✈️",
        x: 16,
        y: 19
      },
      {
        unified: "1f468-1f3fe-200d-2708-fe0f",
        native: "👨🏾‍✈️",
        x: 16,
        y: 20
      },
      {
        unified: "1f468-1f3ff-200d-2708-fe0f",
        native: "👨🏿‍✈️",
        x: 16,
        y: 21
      }
    ],
    version: 4
  },
  "female-pilot": {
    id: "female-pilot",
    name: "Woman Pilot",
    keywords: [
      "female",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2708-fe0f",
        native: "👩‍✈️",
        x: 19,
        y: 45
      },
      {
        unified: "1f469-1f3fb-200d-2708-fe0f",
        native: "👩🏻‍✈️",
        x: 19,
        y: 46
      },
      {
        unified: "1f469-1f3fc-200d-2708-fe0f",
        native: "👩🏼‍✈️",
        x: 19,
        y: 47
      },
      {
        unified: "1f469-1f3fd-200d-2708-fe0f",
        native: "👩🏽‍✈️",
        x: 19,
        y: 48
      },
      {
        unified: "1f469-1f3fe-200d-2708-fe0f",
        native: "👩🏾‍✈️",
        x: 19,
        y: 49
      },
      {
        unified: "1f469-1f3ff-200d-2708-fe0f",
        native: "👩🏿‍✈️",
        x: 19,
        y: 50
      }
    ],
    version: 4
  },
  astronaut: {
    id: "astronaut",
    name: "Astronaut",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f680",
        native: "🧑‍🚀",
        x: 48,
        y: 29
      },
      {
        unified: "1f9d1-1f3fb-200d-1f680",
        native: "🧑🏻‍🚀",
        x: 48,
        y: 30
      },
      {
        unified: "1f9d1-1f3fc-200d-1f680",
        native: "🧑🏼‍🚀",
        x: 48,
        y: 31
      },
      {
        unified: "1f9d1-1f3fd-200d-1f680",
        native: "🧑🏽‍🚀",
        x: 48,
        y: 32
      },
      {
        unified: "1f9d1-1f3fe-200d-1f680",
        native: "🧑🏾‍🚀",
        x: 48,
        y: 33
      },
      {
        unified: "1f9d1-1f3ff-200d-1f680",
        native: "🧑🏿‍🚀",
        x: 48,
        y: 34
      }
    ],
    version: 12.1
  },
  "male-astronaut": {
    id: "male-astronaut",
    name: "Man Astronaut",
    keywords: [
      "male",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f680",
        native: "👨‍🚀",
        x: 15,
        y: 11
      },
      {
        unified: "1f468-1f3fb-200d-1f680",
        native: "👨🏻‍🚀",
        x: 15,
        y: 12
      },
      {
        unified: "1f468-1f3fc-200d-1f680",
        native: "👨🏼‍🚀",
        x: 15,
        y: 13
      },
      {
        unified: "1f468-1f3fd-200d-1f680",
        native: "👨🏽‍🚀",
        x: 15,
        y: 14
      },
      {
        unified: "1f468-1f3fe-200d-1f680",
        native: "👨🏾‍🚀",
        x: 15,
        y: 15
      },
      {
        unified: "1f468-1f3ff-200d-1f680",
        native: "👨🏿‍🚀",
        x: 15,
        y: 16
      }
    ],
    version: 4
  },
  "female-astronaut": {
    id: "female-astronaut",
    name: "Woman Astronaut",
    keywords: [
      "female",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f680",
        native: "👩‍🚀",
        x: 18,
        y: 40
      },
      {
        unified: "1f469-1f3fb-200d-1f680",
        native: "👩🏻‍🚀",
        x: 18,
        y: 41
      },
      {
        unified: "1f469-1f3fc-200d-1f680",
        native: "👩🏼‍🚀",
        x: 18,
        y: 42
      },
      {
        unified: "1f469-1f3fd-200d-1f680",
        native: "👩🏽‍🚀",
        x: 18,
        y: 43
      },
      {
        unified: "1f469-1f3fe-200d-1f680",
        native: "👩🏾‍🚀",
        x: 18,
        y: 44
      },
      {
        unified: "1f469-1f3ff-200d-1f680",
        native: "👩🏿‍🚀",
        x: 18,
        y: 45
      }
    ],
    version: 4
  },
  firefighter: {
    id: "firefighter",
    name: "Firefighter",
    keywords: [
      "fire"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f692",
        native: "🧑‍🚒",
        x: 48,
        y: 35
      },
      {
        unified: "1f9d1-1f3fb-200d-1f692",
        native: "🧑🏻‍🚒",
        x: 48,
        y: 36
      },
      {
        unified: "1f9d1-1f3fc-200d-1f692",
        native: "🧑🏼‍🚒",
        x: 48,
        y: 37
      },
      {
        unified: "1f9d1-1f3fd-200d-1f692",
        native: "🧑🏽‍🚒",
        x: 48,
        y: 38
      },
      {
        unified: "1f9d1-1f3fe-200d-1f692",
        native: "🧑🏾‍🚒",
        x: 48,
        y: 39
      },
      {
        unified: "1f9d1-1f3ff-200d-1f692",
        native: "🧑🏿‍🚒",
        x: 48,
        y: 40
      }
    ],
    version: 12.1
  },
  "male-firefighter": {
    id: "male-firefighter",
    name: "Man Firefighter",
    keywords: [
      "male",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f692",
        native: "👨‍🚒",
        x: 15,
        y: 17
      },
      {
        unified: "1f468-1f3fb-200d-1f692",
        native: "👨🏻‍🚒",
        x: 15,
        y: 18
      },
      {
        unified: "1f468-1f3fc-200d-1f692",
        native: "👨🏼‍🚒",
        x: 15,
        y: 19
      },
      {
        unified: "1f468-1f3fd-200d-1f692",
        native: "👨🏽‍🚒",
        x: 15,
        y: 20
      },
      {
        unified: "1f468-1f3fe-200d-1f692",
        native: "👨🏾‍🚒",
        x: 15,
        y: 21
      },
      {
        unified: "1f468-1f3ff-200d-1f692",
        native: "👨🏿‍🚒",
        x: 15,
        y: 22
      }
    ],
    version: 4
  },
  "female-firefighter": {
    id: "female-firefighter",
    name: "Woman Firefighter",
    keywords: [
      "female",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f692",
        native: "👩‍🚒",
        x: 18,
        y: 46
      },
      {
        unified: "1f469-1f3fb-200d-1f692",
        native: "👩🏻‍🚒",
        x: 18,
        y: 47
      },
      {
        unified: "1f469-1f3fc-200d-1f692",
        native: "👩🏼‍🚒",
        x: 18,
        y: 48
      },
      {
        unified: "1f469-1f3fd-200d-1f692",
        native: "👩🏽‍🚒",
        x: 18,
        y: 49
      },
      {
        unified: "1f469-1f3fe-200d-1f692",
        native: "👩🏾‍🚒",
        x: 18,
        y: 50
      },
      {
        unified: "1f469-1f3ff-200d-1f692",
        native: "👩🏿‍🚒",
        x: 18,
        y: 51
      }
    ],
    version: 4
  },
  cop: {
    id: "cop",
    name: "Police Officer",
    keywords: [
      "cop"
    ],
    skins: [
      {
        unified: "1f46e",
        native: "👮",
        x: 23,
        y: 8
      },
      {
        unified: "1f46e-1f3fb",
        native: "👮🏻",
        x: 23,
        y: 9
      },
      {
        unified: "1f46e-1f3fc",
        native: "👮🏼",
        x: 23,
        y: 10
      },
      {
        unified: "1f46e-1f3fd",
        native: "👮🏽",
        x: 23,
        y: 11
      },
      {
        unified: "1f46e-1f3fe",
        native: "👮🏾",
        x: 23,
        y: 12
      },
      {
        unified: "1f46e-1f3ff",
        native: "👮🏿",
        x: 23,
        y: 13
      }
    ],
    version: 1
  },
  "male-police-officer": {
    id: "male-police-officer",
    name: "Man Police Officer",
    keywords: [
      "male",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2642-fe0f",
        native: "👮‍♂️",
        x: 23,
        y: 2
      },
      {
        unified: "1f46e-1f3fb-200d-2642-fe0f",
        native: "👮🏻‍♂️",
        x: 23,
        y: 3
      },
      {
        unified: "1f46e-1f3fc-200d-2642-fe0f",
        native: "👮🏼‍♂️",
        x: 23,
        y: 4
      },
      {
        unified: "1f46e-1f3fd-200d-2642-fe0f",
        native: "👮🏽‍♂️",
        x: 23,
        y: 5
      },
      {
        unified: "1f46e-1f3fe-200d-2642-fe0f",
        native: "👮🏾‍♂️",
        x: 23,
        y: 6
      },
      {
        unified: "1f46e-1f3ff-200d-2642-fe0f",
        native: "👮🏿‍♂️",
        x: 23,
        y: 7
      }
    ],
    version: 4
  },
  "female-police-officer": {
    id: "female-police-officer",
    name: "Woman Police Officer",
    keywords: [
      "female",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2640-fe0f",
        native: "👮‍♀️",
        x: 22,
        y: 57
      },
      {
        unified: "1f46e-1f3fb-200d-2640-fe0f",
        native: "👮🏻‍♀️",
        x: 22,
        y: 58
      },
      {
        unified: "1f46e-1f3fc-200d-2640-fe0f",
        native: "👮🏼‍♀️",
        x: 22,
        y: 59
      },
      {
        unified: "1f46e-1f3fd-200d-2640-fe0f",
        native: "👮🏽‍♀️",
        x: 22,
        y: 60
      },
      {
        unified: "1f46e-1f3fe-200d-2640-fe0f",
        native: "👮🏾‍♀️",
        x: 23,
        y: 0
      },
      {
        unified: "1f46e-1f3ff-200d-2640-fe0f",
        native: "👮🏿‍♀️",
        x: 23,
        y: 1
      }
    ],
    version: 4
  },
  sleuth_or_spy: {
    id: "sleuth_or_spy",
    name: "Detective",
    keywords: [
      "sleuth",
      "or",
      "spy",
      "human"
    ],
    skins: [
      {
        unified: "1f575-fe0f",
        native: "🕵️",
        x: 31,
        y: 16
      },
      {
        unified: "1f575-1f3fb",
        native: "🕵🏻",
        x: 31,
        y: 17
      },
      {
        unified: "1f575-1f3fc",
        native: "🕵🏼",
        x: 31,
        y: 18
      },
      {
        unified: "1f575-1f3fd",
        native: "🕵🏽",
        x: 31,
        y: 19
      },
      {
        unified: "1f575-1f3fe",
        native: "🕵🏾",
        x: 31,
        y: 20
      },
      {
        unified: "1f575-1f3ff",
        native: "🕵🏿",
        x: 31,
        y: 21
      }
    ],
    version: 1
  },
  "male-detective": {
    id: "male-detective",
    name: "Man Detective",
    keywords: [
      "male",
      "crime"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2642-fe0f",
        native: "🕵️‍♂️",
        x: 31,
        y: 10
      },
      {
        unified: "1f575-1f3fb-200d-2642-fe0f",
        native: "🕵🏻‍♂️",
        x: 31,
        y: 11
      },
      {
        unified: "1f575-1f3fc-200d-2642-fe0f",
        native: "🕵🏼‍♂️",
        x: 31,
        y: 12
      },
      {
        unified: "1f575-1f3fd-200d-2642-fe0f",
        native: "🕵🏽‍♂️",
        x: 31,
        y: 13
      },
      {
        unified: "1f575-1f3fe-200d-2642-fe0f",
        native: "🕵🏾‍♂️",
        x: 31,
        y: 14
      },
      {
        unified: "1f575-1f3ff-200d-2642-fe0f",
        native: "🕵🏿‍♂️",
        x: 31,
        y: 15
      }
    ],
    version: 4
  },
  "female-detective": {
    id: "female-detective",
    name: "Woman Detective",
    keywords: [
      "female",
      "human",
      "spy"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2640-fe0f",
        native: "🕵️‍♀️",
        x: 31,
        y: 4
      },
      {
        unified: "1f575-1f3fb-200d-2640-fe0f",
        native: "🕵🏻‍♀️",
        x: 31,
        y: 5
      },
      {
        unified: "1f575-1f3fc-200d-2640-fe0f",
        native: "🕵🏼‍♀️",
        x: 31,
        y: 6
      },
      {
        unified: "1f575-1f3fd-200d-2640-fe0f",
        native: "🕵🏽‍♀️",
        x: 31,
        y: 7
      },
      {
        unified: "1f575-1f3fe-200d-2640-fe0f",
        native: "🕵🏾‍♀️",
        x: 31,
        y: 8
      },
      {
        unified: "1f575-1f3ff-200d-2640-fe0f",
        native: "🕵🏿‍♀️",
        x: 31,
        y: 9
      }
    ],
    version: 4
  },
  guardsman: {
    id: "guardsman",
    name: "Guard",
    keywords: [
      "guardsman",
      "protect"
    ],
    skins: [
      {
        unified: "1f482",
        native: "💂",
        x: 25,
        y: 40
      },
      {
        unified: "1f482-1f3fb",
        native: "💂🏻",
        x: 25,
        y: 41
      },
      {
        unified: "1f482-1f3fc",
        native: "💂🏼",
        x: 25,
        y: 42
      },
      {
        unified: "1f482-1f3fd",
        native: "💂🏽",
        x: 25,
        y: 43
      },
      {
        unified: "1f482-1f3fe",
        native: "💂🏾",
        x: 25,
        y: 44
      },
      {
        unified: "1f482-1f3ff",
        native: "💂🏿",
        x: 25,
        y: 45
      }
    ],
    version: 1
  },
  "male-guard": {
    id: "male-guard",
    name: "Man Guard",
    keywords: [
      "male",
      "uk",
      "gb",
      "british",
      "guy",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2642-fe0f",
        native: "💂‍♂️",
        x: 25,
        y: 34
      },
      {
        unified: "1f482-1f3fb-200d-2642-fe0f",
        native: "💂🏻‍♂️",
        x: 25,
        y: 35
      },
      {
        unified: "1f482-1f3fc-200d-2642-fe0f",
        native: "💂🏼‍♂️",
        x: 25,
        y: 36
      },
      {
        unified: "1f482-1f3fd-200d-2642-fe0f",
        native: "💂🏽‍♂️",
        x: 25,
        y: 37
      },
      {
        unified: "1f482-1f3fe-200d-2642-fe0f",
        native: "💂🏾‍♂️",
        x: 25,
        y: 38
      },
      {
        unified: "1f482-1f3ff-200d-2642-fe0f",
        native: "💂🏿‍♂️",
        x: 25,
        y: 39
      }
    ],
    version: 4
  },
  "female-guard": {
    id: "female-guard",
    name: "Woman Guard",
    keywords: [
      "female",
      "uk",
      "gb",
      "british",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2640-fe0f",
        native: "💂‍♀️",
        x: 25,
        y: 28
      },
      {
        unified: "1f482-1f3fb-200d-2640-fe0f",
        native: "💂🏻‍♀️",
        x: 25,
        y: 29
      },
      {
        unified: "1f482-1f3fc-200d-2640-fe0f",
        native: "💂🏼‍♀️",
        x: 25,
        y: 30
      },
      {
        unified: "1f482-1f3fd-200d-2640-fe0f",
        native: "💂🏽‍♀️",
        x: 25,
        y: 31
      },
      {
        unified: "1f482-1f3fe-200d-2640-fe0f",
        native: "💂🏾‍♀️",
        x: 25,
        y: 32
      },
      {
        unified: "1f482-1f3ff-200d-2640-fe0f",
        native: "💂🏿‍♀️",
        x: 25,
        y: 33
      }
    ],
    version: 4
  },
  ninja: {
    id: "ninja",
    name: "Ninja",
    keywords: [
      "ninjutsu",
      "skills",
      "japanese"
    ],
    skins: [
      {
        unified: "1f977",
        native: "🥷",
        x: 44,
        y: 4
      },
      {
        unified: "1f977-1f3fb",
        native: "🥷🏻",
        x: 44,
        y: 5
      },
      {
        unified: "1f977-1f3fc",
        native: "🥷🏼",
        x: 44,
        y: 6
      },
      {
        unified: "1f977-1f3fd",
        native: "🥷🏽",
        x: 44,
        y: 7
      },
      {
        unified: "1f977-1f3fe",
        native: "🥷🏾",
        x: 44,
        y: 8
      },
      {
        unified: "1f977-1f3ff",
        native: "🥷🏿",
        x: 44,
        y: 9
      }
    ],
    version: 13
  },
  construction_worker: {
    id: "construction_worker",
    name: "Construction Worker",
    keywords: [
      "labor",
      "build"
    ],
    skins: [
      {
        unified: "1f477",
        native: "👷",
        x: 24,
        y: 46
      },
      {
        unified: "1f477-1f3fb",
        native: "👷🏻",
        x: 24,
        y: 47
      },
      {
        unified: "1f477-1f3fc",
        native: "👷🏼",
        x: 24,
        y: 48
      },
      {
        unified: "1f477-1f3fd",
        native: "👷🏽",
        x: 24,
        y: 49
      },
      {
        unified: "1f477-1f3fe",
        native: "👷🏾",
        x: 24,
        y: 50
      },
      {
        unified: "1f477-1f3ff",
        native: "👷🏿",
        x: 24,
        y: 51
      }
    ],
    version: 1
  },
  "male-construction-worker": {
    id: "male-construction-worker",
    name: "Man Construction Worker",
    keywords: [
      "male",
      "construction-worker",
      "human",
      "wip",
      "guy",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2642-fe0f",
        native: "👷‍♂️",
        x: 24,
        y: 40
      },
      {
        unified: "1f477-1f3fb-200d-2642-fe0f",
        native: "👷🏻‍♂️",
        x: 24,
        y: 41
      },
      {
        unified: "1f477-1f3fc-200d-2642-fe0f",
        native: "👷🏼‍♂️",
        x: 24,
        y: 42
      },
      {
        unified: "1f477-1f3fd-200d-2642-fe0f",
        native: "👷🏽‍♂️",
        x: 24,
        y: 43
      },
      {
        unified: "1f477-1f3fe-200d-2642-fe0f",
        native: "👷🏾‍♂️",
        x: 24,
        y: 44
      },
      {
        unified: "1f477-1f3ff-200d-2642-fe0f",
        native: "👷🏿‍♂️",
        x: 24,
        y: 45
      }
    ],
    version: 4
  },
  "female-construction-worker": {
    id: "female-construction-worker",
    name: "Woman Construction Worker",
    keywords: [
      "female",
      "construction-worker",
      "human",
      "wip",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2640-fe0f",
        native: "👷‍♀️",
        x: 24,
        y: 34
      },
      {
        unified: "1f477-1f3fb-200d-2640-fe0f",
        native: "👷🏻‍♀️",
        x: 24,
        y: 35
      },
      {
        unified: "1f477-1f3fc-200d-2640-fe0f",
        native: "👷🏼‍♀️",
        x: 24,
        y: 36
      },
      {
        unified: "1f477-1f3fd-200d-2640-fe0f",
        native: "👷🏽‍♀️",
        x: 24,
        y: 37
      },
      {
        unified: "1f477-1f3fe-200d-2640-fe0f",
        native: "👷🏾‍♀️",
        x: 24,
        y: 38
      },
      {
        unified: "1f477-1f3ff-200d-2640-fe0f",
        native: "👷🏿‍♀️",
        x: 24,
        y: 39
      }
    ],
    version: 4
  },
  person_with_crown: {
    id: "person_with_crown",
    name: "Person with Crown",
    keywords: [
      "royalty",
      "power"
    ],
    skins: [
      {
        unified: "1fac5",
        native: "🫅",
        x: 54,
        y: 57
      },
      {
        unified: "1fac5-1f3fb",
        native: "🫅🏻",
        x: 54,
        y: 58
      },
      {
        unified: "1fac5-1f3fc",
        native: "🫅🏼",
        x: 54,
        y: 59
      },
      {
        unified: "1fac5-1f3fd",
        native: "🫅🏽",
        x: 54,
        y: 60
      },
      {
        unified: "1fac5-1f3fe",
        native: "🫅🏾",
        x: 55,
        y: 0
      },
      {
        unified: "1fac5-1f3ff",
        native: "🫅🏿",
        x: 55,
        y: 1
      }
    ],
    version: 14
  },
  prince: {
    id: "prince",
    name: "Prince",
    keywords: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    skins: [
      {
        unified: "1f934",
        native: "🤴",
        x: 41,
        y: 8
      },
      {
        unified: "1f934-1f3fb",
        native: "🤴🏻",
        x: 41,
        y: 9
      },
      {
        unified: "1f934-1f3fc",
        native: "🤴🏼",
        x: 41,
        y: 10
      },
      {
        unified: "1f934-1f3fd",
        native: "🤴🏽",
        x: 41,
        y: 11
      },
      {
        unified: "1f934-1f3fe",
        native: "🤴🏾",
        x: 41,
        y: 12
      },
      {
        unified: "1f934-1f3ff",
        native: "🤴🏿",
        x: 41,
        y: 13
      }
    ],
    version: 3
  },
  princess: {
    id: "princess",
    name: "Princess",
    keywords: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    skins: [
      {
        unified: "1f478",
        native: "👸",
        x: 24,
        y: 52
      },
      {
        unified: "1f478-1f3fb",
        native: "👸🏻",
        x: 24,
        y: 53
      },
      {
        unified: "1f478-1f3fc",
        native: "👸🏼",
        x: 24,
        y: 54
      },
      {
        unified: "1f478-1f3fd",
        native: "👸🏽",
        x: 24,
        y: 55
      },
      {
        unified: "1f478-1f3fe",
        native: "👸🏾",
        x: 24,
        y: 56
      },
      {
        unified: "1f478-1f3ff",
        native: "👸🏿",
        x: 24,
        y: 57
      }
    ],
    version: 1
  },
  man_with_turban: {
    id: "man_with_turban",
    name: "Man with Turban",
    keywords: [
      "person",
      "wearing",
      "headdress"
    ],
    skins: [
      {
        unified: "1f473",
        native: "👳",
        x: 24,
        y: 10
      },
      {
        unified: "1f473-1f3fb",
        native: "👳🏻",
        x: 24,
        y: 11
      },
      {
        unified: "1f473-1f3fc",
        native: "👳🏼",
        x: 24,
        y: 12
      },
      {
        unified: "1f473-1f3fd",
        native: "👳🏽",
        x: 24,
        y: 13
      },
      {
        unified: "1f473-1f3fe",
        native: "👳🏾",
        x: 24,
        y: 14
      },
      {
        unified: "1f473-1f3ff",
        native: "👳🏿",
        x: 24,
        y: 15
      }
    ],
    version: 1
  },
  "man-wearing-turban": {
    id: "man-wearing-turban",
    name: "Man Wearing Turban",
    keywords: [
      "wearing-turban",
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2642-fe0f",
        native: "👳‍♂️",
        x: 24,
        y: 4
      },
      {
        unified: "1f473-1f3fb-200d-2642-fe0f",
        native: "👳🏻‍♂️",
        x: 24,
        y: 5
      },
      {
        unified: "1f473-1f3fc-200d-2642-fe0f",
        native: "👳🏼‍♂️",
        x: 24,
        y: 6
      },
      {
        unified: "1f473-1f3fd-200d-2642-fe0f",
        native: "👳🏽‍♂️",
        x: 24,
        y: 7
      },
      {
        unified: "1f473-1f3fe-200d-2642-fe0f",
        native: "👳🏾‍♂️",
        x: 24,
        y: 8
      },
      {
        unified: "1f473-1f3ff-200d-2642-fe0f",
        native: "👳🏿‍♂️",
        x: 24,
        y: 9
      }
    ],
    version: 4
  },
  "woman-wearing-turban": {
    id: "woman-wearing-turban",
    name: "Woman Wearing Turban",
    keywords: [
      "wearing-turban",
      "female",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2640-fe0f",
        native: "👳‍♀️",
        x: 23,
        y: 59
      },
      {
        unified: "1f473-1f3fb-200d-2640-fe0f",
        native: "👳🏻‍♀️",
        x: 23,
        y: 60
      },
      {
        unified: "1f473-1f3fc-200d-2640-fe0f",
        native: "👳🏼‍♀️",
        x: 24,
        y: 0
      },
      {
        unified: "1f473-1f3fd-200d-2640-fe0f",
        native: "👳🏽‍♀️",
        x: 24,
        y: 1
      },
      {
        unified: "1f473-1f3fe-200d-2640-fe0f",
        native: "👳🏾‍♀️",
        x: 24,
        y: 2
      },
      {
        unified: "1f473-1f3ff-200d-2640-fe0f",
        native: "👳🏿‍♀️",
        x: 24,
        y: 3
      }
    ],
    version: 4
  },
  man_with_gua_pi_mao: {
    id: "man_with_gua_pi_mao",
    name: "Man with Gua Pi Mao",
    keywords: [
      "skullcap",
      "male",
      "boy",
      "chinese"
    ],
    skins: [
      {
        unified: "1f472",
        native: "👲",
        x: 23,
        y: 53
      },
      {
        unified: "1f472-1f3fb",
        native: "👲🏻",
        x: 23,
        y: 54
      },
      {
        unified: "1f472-1f3fc",
        native: "👲🏼",
        x: 23,
        y: 55
      },
      {
        unified: "1f472-1f3fd",
        native: "👲🏽",
        x: 23,
        y: 56
      },
      {
        unified: "1f472-1f3fe",
        native: "👲🏾",
        x: 23,
        y: 57
      },
      {
        unified: "1f472-1f3ff",
        native: "👲🏿",
        x: 23,
        y: 58
      }
    ],
    version: 1
  },
  person_with_headscarf: {
    id: "person_with_headscarf",
    name: "Woman with Headscarf",
    keywords: [
      "person",
      "female",
      "hijab",
      "mantilla",
      "tichel"
    ],
    skins: [
      {
        unified: "1f9d5",
        native: "🧕",
        x: 50,
        y: 41
      },
      {
        unified: "1f9d5-1f3fb",
        native: "🧕🏻",
        x: 50,
        y: 42
      },
      {
        unified: "1f9d5-1f3fc",
        native: "🧕🏼",
        x: 50,
        y: 43
      },
      {
        unified: "1f9d5-1f3fd",
        native: "🧕🏽",
        x: 50,
        y: 44
      },
      {
        unified: "1f9d5-1f3fe",
        native: "🧕🏾",
        x: 50,
        y: 45
      },
      {
        unified: "1f9d5-1f3ff",
        native: "🧕🏿",
        x: 50,
        y: 46
      }
    ],
    version: 5
  },
  person_in_tuxedo: {
    id: "person_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "person",
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    skins: [
      {
        unified: "1f935",
        native: "🤵",
        x: 41,
        y: 26
      },
      {
        unified: "1f935-1f3fb",
        native: "🤵🏻",
        x: 41,
        y: 27
      },
      {
        unified: "1f935-1f3fc",
        native: "🤵🏼",
        x: 41,
        y: 28
      },
      {
        unified: "1f935-1f3fd",
        native: "🤵🏽",
        x: 41,
        y: 29
      },
      {
        unified: "1f935-1f3fe",
        native: "🤵🏾",
        x: 41,
        y: 30
      },
      {
        unified: "1f935-1f3ff",
        native: "🤵🏿",
        x: 41,
        y: 31
      }
    ],
    version: 3
  },
  man_in_tuxedo: {
    id: "man_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2642-fe0f",
        native: "🤵‍♂️",
        x: 41,
        y: 20
      },
      {
        unified: "1f935-1f3fb-200d-2642-fe0f",
        native: "🤵🏻‍♂️",
        x: 41,
        y: 21
      },
      {
        unified: "1f935-1f3fc-200d-2642-fe0f",
        native: "🤵🏼‍♂️",
        x: 41,
        y: 22
      },
      {
        unified: "1f935-1f3fd-200d-2642-fe0f",
        native: "🤵🏽‍♂️",
        x: 41,
        y: 23
      },
      {
        unified: "1f935-1f3fe-200d-2642-fe0f",
        native: "🤵🏾‍♂️",
        x: 41,
        y: 24
      },
      {
        unified: "1f935-1f3ff-200d-2642-fe0f",
        native: "🤵🏿‍♂️",
        x: 41,
        y: 25
      }
    ],
    version: 13
  },
  woman_in_tuxedo: {
    id: "woman_in_tuxedo",
    name: "Woman in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2640-fe0f",
        native: "🤵‍♀️",
        x: 41,
        y: 14
      },
      {
        unified: "1f935-1f3fb-200d-2640-fe0f",
        native: "🤵🏻‍♀️",
        x: 41,
        y: 15
      },
      {
        unified: "1f935-1f3fc-200d-2640-fe0f",
        native: "🤵🏼‍♀️",
        x: 41,
        y: 16
      },
      {
        unified: "1f935-1f3fd-200d-2640-fe0f",
        native: "🤵🏽‍♀️",
        x: 41,
        y: 17
      },
      {
        unified: "1f935-1f3fe-200d-2640-fe0f",
        native: "🤵🏾‍♀️",
        x: 41,
        y: 18
      },
      {
        unified: "1f935-1f3ff-200d-2640-fe0f",
        native: "🤵🏿‍♀️",
        x: 41,
        y: 19
      }
    ],
    version: 13
  },
  bride_with_veil: {
    id: "bride_with_veil",
    name: "Bride with Veil",
    keywords: [
      "couple",
      "marriage",
      "wedding",
      "woman"
    ],
    skins: [
      {
        unified: "1f470",
        native: "👰",
        x: 23,
        y: 29
      },
      {
        unified: "1f470-1f3fb",
        native: "👰🏻",
        x: 23,
        y: 30
      },
      {
        unified: "1f470-1f3fc",
        native: "👰🏼",
        x: 23,
        y: 31
      },
      {
        unified: "1f470-1f3fd",
        native: "👰🏽",
        x: 23,
        y: 32
      },
      {
        unified: "1f470-1f3fe",
        native: "👰🏾",
        x: 23,
        y: 33
      },
      {
        unified: "1f470-1f3ff",
        native: "👰🏿",
        x: 23,
        y: 34
      }
    ],
    version: 1
  },
  man_with_veil: {
    id: "man_with_veil",
    name: "Man with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2642-fe0f",
        native: "👰‍♂️",
        x: 23,
        y: 23
      },
      {
        unified: "1f470-1f3fb-200d-2642-fe0f",
        native: "👰🏻‍♂️",
        x: 23,
        y: 24
      },
      {
        unified: "1f470-1f3fc-200d-2642-fe0f",
        native: "👰🏼‍♂️",
        x: 23,
        y: 25
      },
      {
        unified: "1f470-1f3fd-200d-2642-fe0f",
        native: "👰🏽‍♂️",
        x: 23,
        y: 26
      },
      {
        unified: "1f470-1f3fe-200d-2642-fe0f",
        native: "👰🏾‍♂️",
        x: 23,
        y: 27
      },
      {
        unified: "1f470-1f3ff-200d-2642-fe0f",
        native: "👰🏿‍♂️",
        x: 23,
        y: 28
      }
    ],
    version: 13
  },
  woman_with_veil: {
    id: "woman_with_veil",
    name: "Woman with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2640-fe0f",
        native: "👰‍♀️",
        x: 23,
        y: 17
      },
      {
        unified: "1f470-1f3fb-200d-2640-fe0f",
        native: "👰🏻‍♀️",
        x: 23,
        y: 18
      },
      {
        unified: "1f470-1f3fc-200d-2640-fe0f",
        native: "👰🏼‍♀️",
        x: 23,
        y: 19
      },
      {
        unified: "1f470-1f3fd-200d-2640-fe0f",
        native: "👰🏽‍♀️",
        x: 23,
        y: 20
      },
      {
        unified: "1f470-1f3fe-200d-2640-fe0f",
        native: "👰🏾‍♀️",
        x: 23,
        y: 21
      },
      {
        unified: "1f470-1f3ff-200d-2640-fe0f",
        native: "👰🏿‍♀️",
        x: 23,
        y: 22
      }
    ],
    version: 13
  },
  pregnant_woman: {
    id: "pregnant_woman",
    name: "Pregnant Woman",
    keywords: [
      "baby"
    ],
    skins: [
      {
        unified: "1f930",
        native: "🤰",
        x: 40,
        y: 45
      },
      {
        unified: "1f930-1f3fb",
        native: "🤰🏻",
        x: 40,
        y: 46
      },
      {
        unified: "1f930-1f3fc",
        native: "🤰🏼",
        x: 40,
        y: 47
      },
      {
        unified: "1f930-1f3fd",
        native: "🤰🏽",
        x: 40,
        y: 48
      },
      {
        unified: "1f930-1f3fe",
        native: "🤰🏾",
        x: 40,
        y: 49
      },
      {
        unified: "1f930-1f3ff",
        native: "🤰🏿",
        x: 40,
        y: 50
      }
    ],
    version: 3
  },
  pregnant_man: {
    id: "pregnant_man",
    name: "Pregnant Man",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac3",
        native: "🫃",
        x: 54,
        y: 45
      },
      {
        unified: "1fac3-1f3fb",
        native: "🫃🏻",
        x: 54,
        y: 46
      },
      {
        unified: "1fac3-1f3fc",
        native: "🫃🏼",
        x: 54,
        y: 47
      },
      {
        unified: "1fac3-1f3fd",
        native: "🫃🏽",
        x: 54,
        y: 48
      },
      {
        unified: "1fac3-1f3fe",
        native: "🫃🏾",
        x: 54,
        y: 49
      },
      {
        unified: "1fac3-1f3ff",
        native: "🫃🏿",
        x: 54,
        y: 50
      }
    ],
    version: 14
  },
  pregnant_person: {
    id: "pregnant_person",
    name: "Pregnant Person",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac4",
        native: "🫄",
        x: 54,
        y: 51
      },
      {
        unified: "1fac4-1f3fb",
        native: "🫄🏻",
        x: 54,
        y: 52
      },
      {
        unified: "1fac4-1f3fc",
        native: "🫄🏼",
        x: 54,
        y: 53
      },
      {
        unified: "1fac4-1f3fd",
        native: "🫄🏽",
        x: 54,
        y: 54
      },
      {
        unified: "1fac4-1f3fe",
        native: "🫄🏾",
        x: 54,
        y: 55
      },
      {
        unified: "1fac4-1f3ff",
        native: "🫄🏿",
        x: 54,
        y: 56
      }
    ],
    version: 14
  },
  "breast-feeding": {
    id: "breast-feeding",
    name: "Breast-Feeding",
    keywords: [
      "breast",
      "feeding",
      "nursing",
      "baby"
    ],
    skins: [
      {
        unified: "1f931",
        native: "🤱",
        x: 40,
        y: 51
      },
      {
        unified: "1f931-1f3fb",
        native: "🤱🏻",
        x: 40,
        y: 52
      },
      {
        unified: "1f931-1f3fc",
        native: "🤱🏼",
        x: 40,
        y: 53
      },
      {
        unified: "1f931-1f3fd",
        native: "🤱🏽",
        x: 40,
        y: 54
      },
      {
        unified: "1f931-1f3fe",
        native: "🤱🏾",
        x: 40,
        y: 55
      },
      {
        unified: "1f931-1f3ff",
        native: "🤱🏿",
        x: 40,
        y: 56
      }
    ],
    version: 5
  },
  woman_feeding_baby: {
    id: "woman_feeding_baby",
    name: "Woman Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f469-200d-1f37c",
        native: "👩‍🍼",
        x: 17,
        y: 31
      },
      {
        unified: "1f469-1f3fb-200d-1f37c",
        native: "👩🏻‍🍼",
        x: 17,
        y: 32
      },
      {
        unified: "1f469-1f3fc-200d-1f37c",
        native: "👩🏼‍🍼",
        x: 17,
        y: 33
      },
      {
        unified: "1f469-1f3fd-200d-1f37c",
        native: "👩🏽‍🍼",
        x: 17,
        y: 34
      },
      {
        unified: "1f469-1f3fe-200d-1f37c",
        native: "👩🏾‍🍼",
        x: 17,
        y: 35
      },
      {
        unified: "1f469-1f3ff-200d-1f37c",
        native: "👩🏿‍🍼",
        x: 17,
        y: 36
      }
    ],
    version: 13
  },
  man_feeding_baby: {
    id: "man_feeding_baby",
    name: "Man Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f468-200d-1f37c",
        native: "👨‍🍼",
        x: 13,
        y: 58
      },
      {
        unified: "1f468-1f3fb-200d-1f37c",
        native: "👨🏻‍🍼",
        x: 13,
        y: 59
      },
      {
        unified: "1f468-1f3fc-200d-1f37c",
        native: "👨🏼‍🍼",
        x: 13,
        y: 60
      },
      {
        unified: "1f468-1f3fd-200d-1f37c",
        native: "👨🏽‍🍼",
        x: 14,
        y: 0
      },
      {
        unified: "1f468-1f3fe-200d-1f37c",
        native: "👨🏾‍🍼",
        x: 14,
        y: 1
      },
      {
        unified: "1f468-1f3ff-200d-1f37c",
        native: "👨🏿‍🍼",
        x: 14,
        y: 2
      }
    ],
    version: 13
  },
  person_feeding_baby: {
    id: "person_feeding_baby",
    name: "Person Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f37c",
        native: "🧑‍🍼",
        x: 47,
        y: 24
      },
      {
        unified: "1f9d1-1f3fb-200d-1f37c",
        native: "🧑🏻‍🍼",
        x: 47,
        y: 25
      },
      {
        unified: "1f9d1-1f3fc-200d-1f37c",
        native: "🧑🏼‍🍼",
        x: 47,
        y: 26
      },
      {
        unified: "1f9d1-1f3fd-200d-1f37c",
        native: "🧑🏽‍🍼",
        x: 47,
        y: 27
      },
      {
        unified: "1f9d1-1f3fe-200d-1f37c",
        native: "🧑🏾‍🍼",
        x: 47,
        y: 28
      },
      {
        unified: "1f9d1-1f3ff-200d-1f37c",
        native: "🧑🏿‍🍼",
        x: 47,
        y: 29
      }
    ],
    version: 13
  },
  angel: {
    id: "angel",
    name: "Baby Angel",
    keywords: [
      "heaven",
      "wings",
      "halo"
    ],
    skins: [
      {
        unified: "1f47c",
        native: "👼",
        x: 25,
        y: 0
      },
      {
        unified: "1f47c-1f3fb",
        native: "👼🏻",
        x: 25,
        y: 1
      },
      {
        unified: "1f47c-1f3fc",
        native: "👼🏼",
        x: 25,
        y: 2
      },
      {
        unified: "1f47c-1f3fd",
        native: "👼🏽",
        x: 25,
        y: 3
      },
      {
        unified: "1f47c-1f3fe",
        native: "👼🏾",
        x: 25,
        y: 4
      },
      {
        unified: "1f47c-1f3ff",
        native: "👼🏿",
        x: 25,
        y: 5
      }
    ],
    version: 1
  },
  santa: {
    id: "santa",
    name: "Santa Claus",
    keywords: [
      "festival",
      "man",
      "male",
      "xmas",
      "father",
      "christmas"
    ],
    skins: [
      {
        unified: "1f385",
        native: "🎅",
        x: 7,
        y: 8
      },
      {
        unified: "1f385-1f3fb",
        native: "🎅🏻",
        x: 7,
        y: 9
      },
      {
        unified: "1f385-1f3fc",
        native: "🎅🏼",
        x: 7,
        y: 10
      },
      {
        unified: "1f385-1f3fd",
        native: "🎅🏽",
        x: 7,
        y: 11
      },
      {
        unified: "1f385-1f3fe",
        native: "🎅🏾",
        x: 7,
        y: 12
      },
      {
        unified: "1f385-1f3ff",
        native: "🎅🏿",
        x: 7,
        y: 13
      }
    ],
    version: 1
  },
  mrs_claus: {
    id: "mrs_claus",
    name: "Mrs. Claus",
    keywords: [
      "mrs",
      "mother",
      "christmas",
      "woman",
      "female",
      "xmas"
    ],
    skins: [
      {
        unified: "1f936",
        native: "🤶",
        x: 41,
        y: 32
      },
      {
        unified: "1f936-1f3fb",
        native: "🤶🏻",
        x: 41,
        y: 33
      },
      {
        unified: "1f936-1f3fc",
        native: "🤶🏼",
        x: 41,
        y: 34
      },
      {
        unified: "1f936-1f3fd",
        native: "🤶🏽",
        x: 41,
        y: 35
      },
      {
        unified: "1f936-1f3fe",
        native: "🤶🏾",
        x: 41,
        y: 36
      },
      {
        unified: "1f936-1f3ff",
        native: "🤶🏿",
        x: 41,
        y: 37
      }
    ],
    version: 3
  },
  mx_claus: {
    id: "mx_claus",
    name: "Mx Claus",
    keywords: [
      "christmas"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f384",
        native: "🧑‍🎄",
        x: 47,
        y: 30
      },
      {
        unified: "1f9d1-1f3fb-200d-1f384",
        native: "🧑🏻‍🎄",
        x: 47,
        y: 31
      },
      {
        unified: "1f9d1-1f3fc-200d-1f384",
        native: "🧑🏼‍🎄",
        x: 47,
        y: 32
      },
      {
        unified: "1f9d1-1f3fd-200d-1f384",
        native: "🧑🏽‍🎄",
        x: 47,
        y: 33
      },
      {
        unified: "1f9d1-1f3fe-200d-1f384",
        native: "🧑🏾‍🎄",
        x: 47,
        y: 34
      },
      {
        unified: "1f9d1-1f3ff-200d-1f384",
        native: "🧑🏿‍🎄",
        x: 47,
        y: 35
      }
    ],
    version: 13
  },
  superhero: {
    id: "superhero",
    name: "Superhero",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b8",
        native: "🦸",
        x: 45,
        y: 31
      },
      {
        unified: "1f9b8-1f3fb",
        native: "🦸🏻",
        x: 45,
        y: 32
      },
      {
        unified: "1f9b8-1f3fc",
        native: "🦸🏼",
        x: 45,
        y: 33
      },
      {
        unified: "1f9b8-1f3fd",
        native: "🦸🏽",
        x: 45,
        y: 34
      },
      {
        unified: "1f9b8-1f3fe",
        native: "🦸🏾",
        x: 45,
        y: 35
      },
      {
        unified: "1f9b8-1f3ff",
        native: "🦸🏿",
        x: 45,
        y: 36
      }
    ],
    version: 11
  },
  male_superhero: {
    id: "male_superhero",
    name: "Man Superhero",
    keywords: [
      "male",
      "good",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2642-fe0f",
        native: "🦸‍♂️",
        x: 45,
        y: 25
      },
      {
        unified: "1f9b8-1f3fb-200d-2642-fe0f",
        native: "🦸🏻‍♂️",
        x: 45,
        y: 26
      },
      {
        unified: "1f9b8-1f3fc-200d-2642-fe0f",
        native: "🦸🏼‍♂️",
        x: 45,
        y: 27
      },
      {
        unified: "1f9b8-1f3fd-200d-2642-fe0f",
        native: "🦸🏽‍♂️",
        x: 45,
        y: 28
      },
      {
        unified: "1f9b8-1f3fe-200d-2642-fe0f",
        native: "🦸🏾‍♂️",
        x: 45,
        y: 29
      },
      {
        unified: "1f9b8-1f3ff-200d-2642-fe0f",
        native: "🦸🏿‍♂️",
        x: 45,
        y: 30
      }
    ],
    version: 11
  },
  female_superhero: {
    id: "female_superhero",
    name: "Woman Superhero",
    keywords: [
      "female",
      "good",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2640-fe0f",
        native: "🦸‍♀️",
        x: 45,
        y: 19
      },
      {
        unified: "1f9b8-1f3fb-200d-2640-fe0f",
        native: "🦸🏻‍♀️",
        x: 45,
        y: 20
      },
      {
        unified: "1f9b8-1f3fc-200d-2640-fe0f",
        native: "🦸🏼‍♀️",
        x: 45,
        y: 21
      },
      {
        unified: "1f9b8-1f3fd-200d-2640-fe0f",
        native: "🦸🏽‍♀️",
        x: 45,
        y: 22
      },
      {
        unified: "1f9b8-1f3fe-200d-2640-fe0f",
        native: "🦸🏾‍♀️",
        x: 45,
        y: 23
      },
      {
        unified: "1f9b8-1f3ff-200d-2640-fe0f",
        native: "🦸🏿‍♀️",
        x: 45,
        y: 24
      }
    ],
    version: 11
  },
  supervillain: {
    id: "supervillain",
    name: "Supervillain",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b9",
        native: "🦹",
        x: 45,
        y: 49
      },
      {
        unified: "1f9b9-1f3fb",
        native: "🦹🏻",
        x: 45,
        y: 50
      },
      {
        unified: "1f9b9-1f3fc",
        native: "🦹🏼",
        x: 45,
        y: 51
      },
      {
        unified: "1f9b9-1f3fd",
        native: "🦹🏽",
        x: 45,
        y: 52
      },
      {
        unified: "1f9b9-1f3fe",
        native: "🦹🏾",
        x: 45,
        y: 53
      },
      {
        unified: "1f9b9-1f3ff",
        native: "🦹🏿",
        x: 45,
        y: 54
      }
    ],
    version: 11
  },
  male_supervillain: {
    id: "male_supervillain",
    name: "Man Supervillain",
    keywords: [
      "male",
      "evil",
      "bad",
      "criminal",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2642-fe0f",
        native: "🦹‍♂️",
        x: 45,
        y: 43
      },
      {
        unified: "1f9b9-1f3fb-200d-2642-fe0f",
        native: "🦹🏻‍♂️",
        x: 45,
        y: 44
      },
      {
        unified: "1f9b9-1f3fc-200d-2642-fe0f",
        native: "🦹🏼‍♂️",
        x: 45,
        y: 45
      },
      {
        unified: "1f9b9-1f3fd-200d-2642-fe0f",
        native: "🦹🏽‍♂️",
        x: 45,
        y: 46
      },
      {
        unified: "1f9b9-1f3fe-200d-2642-fe0f",
        native: "🦹🏾‍♂️",
        x: 45,
        y: 47
      },
      {
        unified: "1f9b9-1f3ff-200d-2642-fe0f",
        native: "🦹🏿‍♂️",
        x: 45,
        y: 48
      }
    ],
    version: 11
  },
  female_supervillain: {
    id: "female_supervillain",
    name: "Woman Supervillain",
    keywords: [
      "female",
      "evil",
      "bad",
      "criminal",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2640-fe0f",
        native: "🦹‍♀️",
        x: 45,
        y: 37
      },
      {
        unified: "1f9b9-1f3fb-200d-2640-fe0f",
        native: "🦹🏻‍♀️",
        x: 45,
        y: 38
      },
      {
        unified: "1f9b9-1f3fc-200d-2640-fe0f",
        native: "🦹🏼‍♀️",
        x: 45,
        y: 39
      },
      {
        unified: "1f9b9-1f3fd-200d-2640-fe0f",
        native: "🦹🏽‍♀️",
        x: 45,
        y: 40
      },
      {
        unified: "1f9b9-1f3fe-200d-2640-fe0f",
        native: "🦹🏾‍♀️",
        x: 45,
        y: 41
      },
      {
        unified: "1f9b9-1f3ff-200d-2640-fe0f",
        native: "🦹🏿‍♀️",
        x: 45,
        y: 42
      }
    ],
    version: 11
  },
  mage: {
    id: "mage",
    name: "Mage",
    keywords: [
      "magic"
    ],
    skins: [
      {
        unified: "1f9d9",
        native: "🧙",
        x: 51,
        y: 52
      },
      {
        unified: "1f9d9-1f3fb",
        native: "🧙🏻",
        x: 51,
        y: 53
      },
      {
        unified: "1f9d9-1f3fc",
        native: "🧙🏼",
        x: 51,
        y: 54
      },
      {
        unified: "1f9d9-1f3fd",
        native: "🧙🏽",
        x: 51,
        y: 55
      },
      {
        unified: "1f9d9-1f3fe",
        native: "🧙🏾",
        x: 51,
        y: 56
      },
      {
        unified: "1f9d9-1f3ff",
        native: "🧙🏿",
        x: 51,
        y: 57
      }
    ],
    version: 5
  },
  male_mage: {
    id: "male_mage",
    name: "Man Mage",
    keywords: [
      "male",
      "sorcerer"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2642-fe0f",
        native: "🧙‍♂️",
        x: 51,
        y: 46
      },
      {
        unified: "1f9d9-1f3fb-200d-2642-fe0f",
        native: "🧙🏻‍♂️",
        x: 51,
        y: 47
      },
      {
        unified: "1f9d9-1f3fc-200d-2642-fe0f",
        native: "🧙🏼‍♂️",
        x: 51,
        y: 48
      },
      {
        unified: "1f9d9-1f3fd-200d-2642-fe0f",
        native: "🧙🏽‍♂️",
        x: 51,
        y: 49
      },
      {
        unified: "1f9d9-1f3fe-200d-2642-fe0f",
        native: "🧙🏾‍♂️",
        x: 51,
        y: 50
      },
      {
        unified: "1f9d9-1f3ff-200d-2642-fe0f",
        native: "🧙🏿‍♂️",
        x: 51,
        y: 51
      }
    ],
    version: 5
  },
  female_mage: {
    id: "female_mage",
    name: "Woman Mage",
    keywords: [
      "female",
      "witch"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2640-fe0f",
        native: "🧙‍♀️",
        x: 51,
        y: 40
      },
      {
        unified: "1f9d9-1f3fb-200d-2640-fe0f",
        native: "🧙🏻‍♀️",
        x: 51,
        y: 41
      },
      {
        unified: "1f9d9-1f3fc-200d-2640-fe0f",
        native: "🧙🏼‍♀️",
        x: 51,
        y: 42
      },
      {
        unified: "1f9d9-1f3fd-200d-2640-fe0f",
        native: "🧙🏽‍♀️",
        x: 51,
        y: 43
      },
      {
        unified: "1f9d9-1f3fe-200d-2640-fe0f",
        native: "🧙🏾‍♀️",
        x: 51,
        y: 44
      },
      {
        unified: "1f9d9-1f3ff-200d-2640-fe0f",
        native: "🧙🏿‍♀️",
        x: 51,
        y: 45
      }
    ],
    version: 5
  },
  fairy: {
    id: "fairy",
    name: "Fairy",
    keywords: [
      "wings",
      "magical"
    ],
    skins: [
      {
        unified: "1f9da",
        native: "🧚",
        x: 52,
        y: 9
      },
      {
        unified: "1f9da-1f3fb",
        native: "🧚🏻",
        x: 52,
        y: 10
      },
      {
        unified: "1f9da-1f3fc",
        native: "🧚🏼",
        x: 52,
        y: 11
      },
      {
        unified: "1f9da-1f3fd",
        native: "🧚🏽",
        x: 52,
        y: 12
      },
      {
        unified: "1f9da-1f3fe",
        native: "🧚🏾",
        x: 52,
        y: 13
      },
      {
        unified: "1f9da-1f3ff",
        native: "🧚🏿",
        x: 52,
        y: 14
      }
    ],
    version: 5
  },
  male_fairy: {
    id: "male_fairy",
    name: "Man Fairy",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9da-200d-2642-fe0f",
        native: "🧚‍♂️",
        x: 52,
        y: 3
      },
      {
        unified: "1f9da-1f3fb-200d-2642-fe0f",
        native: "🧚🏻‍♂️",
        x: 52,
        y: 4
      },
      {
        unified: "1f9da-1f3fc-200d-2642-fe0f",
        native: "🧚🏼‍♂️",
        x: 52,
        y: 5
      },
      {
        unified: "1f9da-1f3fd-200d-2642-fe0f",
        native: "🧚🏽‍♂️",
        x: 52,
        y: 6
      },
      {
        unified: "1f9da-1f3fe-200d-2642-fe0f",
        native: "🧚🏾‍♂️",
        x: 52,
        y: 7
      },
      {
        unified: "1f9da-1f3ff-200d-2642-fe0f",
        native: "🧚🏿‍♂️",
        x: 52,
        y: 8
      }
    ],
    version: 5
  },
  female_fairy: {
    id: "female_fairy",
    name: "Woman Fairy",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9da-200d-2640-fe0f",
        native: "🧚‍♀️",
        x: 51,
        y: 58
      },
      {
        unified: "1f9da-1f3fb-200d-2640-fe0f",
        native: "🧚🏻‍♀️",
        x: 51,
        y: 59
      },
      {
        unified: "1f9da-1f3fc-200d-2640-fe0f",
        native: "🧚🏼‍♀️",
        x: 51,
        y: 60
      },
      {
        unified: "1f9da-1f3fd-200d-2640-fe0f",
        native: "🧚🏽‍♀️",
        x: 52,
        y: 0
      },
      {
        unified: "1f9da-1f3fe-200d-2640-fe0f",
        native: "🧚🏾‍♀️",
        x: 52,
        y: 1
      },
      {
        unified: "1f9da-1f3ff-200d-2640-fe0f",
        native: "🧚🏿‍♀️",
        x: 52,
        y: 2
      }
    ],
    version: 5
  },
  vampire: {
    id: "vampire",
    name: "Vampire",
    keywords: [
      "blood",
      "twilight"
    ],
    skins: [
      {
        unified: "1f9db",
        native: "🧛",
        x: 52,
        y: 27
      },
      {
        unified: "1f9db-1f3fb",
        native: "🧛🏻",
        x: 52,
        y: 28
      },
      {
        unified: "1f9db-1f3fc",
        native: "🧛🏼",
        x: 52,
        y: 29
      },
      {
        unified: "1f9db-1f3fd",
        native: "🧛🏽",
        x: 52,
        y: 30
      },
      {
        unified: "1f9db-1f3fe",
        native: "🧛🏾",
        x: 52,
        y: 31
      },
      {
        unified: "1f9db-1f3ff",
        native: "🧛🏿",
        x: 52,
        y: 32
      }
    ],
    version: 5
  },
  male_vampire: {
    id: "male_vampire",
    name: "Man Vampire",
    keywords: [
      "male",
      "dracula"
    ],
    skins: [
      {
        unified: "1f9db-200d-2642-fe0f",
        native: "🧛‍♂️",
        x: 52,
        y: 21
      },
      {
        unified: "1f9db-1f3fb-200d-2642-fe0f",
        native: "🧛🏻‍♂️",
        x: 52,
        y: 22
      },
      {
        unified: "1f9db-1f3fc-200d-2642-fe0f",
        native: "🧛🏼‍♂️",
        x: 52,
        y: 23
      },
      {
        unified: "1f9db-1f3fd-200d-2642-fe0f",
        native: "🧛🏽‍♂️",
        x: 52,
        y: 24
      },
      {
        unified: "1f9db-1f3fe-200d-2642-fe0f",
        native: "🧛🏾‍♂️",
        x: 52,
        y: 25
      },
      {
        unified: "1f9db-1f3ff-200d-2642-fe0f",
        native: "🧛🏿‍♂️",
        x: 52,
        y: 26
      }
    ],
    version: 5
  },
  female_vampire: {
    id: "female_vampire",
    name: "Woman Vampire",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9db-200d-2640-fe0f",
        native: "🧛‍♀️",
        x: 52,
        y: 15
      },
      {
        unified: "1f9db-1f3fb-200d-2640-fe0f",
        native: "🧛🏻‍♀️",
        x: 52,
        y: 16
      },
      {
        unified: "1f9db-1f3fc-200d-2640-fe0f",
        native: "🧛🏼‍♀️",
        x: 52,
        y: 17
      },
      {
        unified: "1f9db-1f3fd-200d-2640-fe0f",
        native: "🧛🏽‍♀️",
        x: 52,
        y: 18
      },
      {
        unified: "1f9db-1f3fe-200d-2640-fe0f",
        native: "🧛🏾‍♀️",
        x: 52,
        y: 19
      },
      {
        unified: "1f9db-1f3ff-200d-2640-fe0f",
        native: "🧛🏿‍♀️",
        x: 52,
        y: 20
      }
    ],
    version: 5
  },
  merperson: {
    id: "merperson",
    name: "Merperson",
    keywords: [
      "sea"
    ],
    skins: [
      {
        unified: "1f9dc",
        native: "🧜",
        x: 52,
        y: 45
      },
      {
        unified: "1f9dc-1f3fb",
        native: "🧜🏻",
        x: 52,
        y: 46
      },
      {
        unified: "1f9dc-1f3fc",
        native: "🧜🏼",
        x: 52,
        y: 47
      },
      {
        unified: "1f9dc-1f3fd",
        native: "🧜🏽",
        x: 52,
        y: 48
      },
      {
        unified: "1f9dc-1f3fe",
        native: "🧜🏾",
        x: 52,
        y: 49
      },
      {
        unified: "1f9dc-1f3ff",
        native: "🧜🏿",
        x: 52,
        y: 50
      }
    ],
    version: 5
  },
  merman: {
    id: "merman",
    name: "Merman",
    keywords: [
      "man",
      "male",
      "triton"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2642-fe0f",
        native: "🧜‍♂️",
        x: 52,
        y: 39
      },
      {
        unified: "1f9dc-1f3fb-200d-2642-fe0f",
        native: "🧜🏻‍♂️",
        x: 52,
        y: 40
      },
      {
        unified: "1f9dc-1f3fc-200d-2642-fe0f",
        native: "🧜🏼‍♂️",
        x: 52,
        y: 41
      },
      {
        unified: "1f9dc-1f3fd-200d-2642-fe0f",
        native: "🧜🏽‍♂️",
        x: 52,
        y: 42
      },
      {
        unified: "1f9dc-1f3fe-200d-2642-fe0f",
        native: "🧜🏾‍♂️",
        x: 52,
        y: 43
      },
      {
        unified: "1f9dc-1f3ff-200d-2642-fe0f",
        native: "🧜🏿‍♂️",
        x: 52,
        y: 44
      }
    ],
    version: 5
  },
  mermaid: {
    id: "mermaid",
    name: "Mermaid",
    keywords: [
      "woman",
      "female",
      "merwoman",
      "ariel"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2640-fe0f",
        native: "🧜‍♀️",
        x: 52,
        y: 33
      },
      {
        unified: "1f9dc-1f3fb-200d-2640-fe0f",
        native: "🧜🏻‍♀️",
        x: 52,
        y: 34
      },
      {
        unified: "1f9dc-1f3fc-200d-2640-fe0f",
        native: "🧜🏼‍♀️",
        x: 52,
        y: 35
      },
      {
        unified: "1f9dc-1f3fd-200d-2640-fe0f",
        native: "🧜🏽‍♀️",
        x: 52,
        y: 36
      },
      {
        unified: "1f9dc-1f3fe-200d-2640-fe0f",
        native: "🧜🏾‍♀️",
        x: 52,
        y: 37
      },
      {
        unified: "1f9dc-1f3ff-200d-2640-fe0f",
        native: "🧜🏿‍♀️",
        x: 52,
        y: 38
      }
    ],
    version: 5
  },
  elf: {
    id: "elf",
    name: "Elf",
    keywords: [
      "magical"
    ],
    skins: [
      {
        unified: "1f9dd",
        native: "🧝",
        x: 53,
        y: 2
      },
      {
        unified: "1f9dd-1f3fb",
        native: "🧝🏻",
        x: 53,
        y: 3
      },
      {
        unified: "1f9dd-1f3fc",
        native: "🧝🏼",
        x: 53,
        y: 4
      },
      {
        unified: "1f9dd-1f3fd",
        native: "🧝🏽",
        x: 53,
        y: 5
      },
      {
        unified: "1f9dd-1f3fe",
        native: "🧝🏾",
        x: 53,
        y: 6
      },
      {
        unified: "1f9dd-1f3ff",
        native: "🧝🏿",
        x: 53,
        y: 7
      }
    ],
    version: 5
  },
  male_elf: {
    id: "male_elf",
    name: "Man Elf",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2642-fe0f",
        native: "🧝‍♂️",
        x: 52,
        y: 57
      },
      {
        unified: "1f9dd-1f3fb-200d-2642-fe0f",
        native: "🧝🏻‍♂️",
        x: 52,
        y: 58
      },
      {
        unified: "1f9dd-1f3fc-200d-2642-fe0f",
        native: "🧝🏼‍♂️",
        x: 52,
        y: 59
      },
      {
        unified: "1f9dd-1f3fd-200d-2642-fe0f",
        native: "🧝🏽‍♂️",
        x: 52,
        y: 60
      },
      {
        unified: "1f9dd-1f3fe-200d-2642-fe0f",
        native: "🧝🏾‍♂️",
        x: 53,
        y: 0
      },
      {
        unified: "1f9dd-1f3ff-200d-2642-fe0f",
        native: "🧝🏿‍♂️",
        x: 53,
        y: 1
      }
    ],
    version: 5
  },
  female_elf: {
    id: "female_elf",
    name: "Woman Elf",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2640-fe0f",
        native: "🧝‍♀️",
        x: 52,
        y: 51
      },
      {
        unified: "1f9dd-1f3fb-200d-2640-fe0f",
        native: "🧝🏻‍♀️",
        x: 52,
        y: 52
      },
      {
        unified: "1f9dd-1f3fc-200d-2640-fe0f",
        native: "🧝🏼‍♀️",
        x: 52,
        y: 53
      },
      {
        unified: "1f9dd-1f3fd-200d-2640-fe0f",
        native: "🧝🏽‍♀️",
        x: 52,
        y: 54
      },
      {
        unified: "1f9dd-1f3fe-200d-2640-fe0f",
        native: "🧝🏾‍♀️",
        x: 52,
        y: 55
      },
      {
        unified: "1f9dd-1f3ff-200d-2640-fe0f",
        native: "🧝🏿‍♀️",
        x: 52,
        y: 56
      }
    ],
    version: 5
  },
  genie: {
    id: "genie",
    name: "Genie",
    keywords: [
      "magical",
      "wishes"
    ],
    skins: [
      {
        unified: "1f9de",
        native: "🧞",
        x: 53,
        y: 10
      }
    ],
    version: 5
  },
  male_genie: {
    id: "male_genie",
    name: "Man Genie",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9de-200d-2642-fe0f",
        native: "🧞‍♂️",
        x: 53,
        y: 9
      }
    ],
    version: 5
  },
  female_genie: {
    id: "female_genie",
    name: "Woman Genie",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9de-200d-2640-fe0f",
        native: "🧞‍♀️",
        x: 53,
        y: 8
      }
    ],
    version: 5
  },
  zombie: {
    id: "zombie",
    name: "Zombie",
    keywords: [
      "dead"
    ],
    skins: [
      {
        unified: "1f9df",
        native: "🧟",
        x: 53,
        y: 13
      }
    ],
    version: 5
  },
  male_zombie: {
    id: "male_zombie",
    name: "Man Zombie",
    keywords: [
      "male",
      "dracula",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2642-fe0f",
        native: "🧟‍♂️",
        x: 53,
        y: 12
      }
    ],
    version: 5
  },
  female_zombie: {
    id: "female_zombie",
    name: "Woman Zombie",
    keywords: [
      "female",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2640-fe0f",
        native: "🧟‍♀️",
        x: 53,
        y: 11
      }
    ],
    version: 5
  },
  troll: {
    id: "troll",
    name: "Troll",
    keywords: [
      "mystical",
      "monster"
    ],
    skins: [
      {
        unified: "1f9cc",
        native: "🧌",
        x: 46,
        y: 17
      }
    ],
    version: 14
  },
  massage: {
    id: "massage",
    name: "Face Massage",
    keywords: [
      "person",
      "getting",
      "relax"
    ],
    skins: [
      {
        unified: "1f486",
        native: "💆",
        x: 26,
        y: 10
      },
      {
        unified: "1f486-1f3fb",
        native: "💆🏻",
        x: 26,
        y: 11
      },
      {
        unified: "1f486-1f3fc",
        native: "💆🏼",
        x: 26,
        y: 12
      },
      {
        unified: "1f486-1f3fd",
        native: "💆🏽",
        x: 26,
        y: 13
      },
      {
        unified: "1f486-1f3fe",
        native: "💆🏾",
        x: 26,
        y: 14
      },
      {
        unified: "1f486-1f3ff",
        native: "💆🏿",
        x: 26,
        y: 15
      }
    ],
    version: 1
  },
  "man-getting-massage": {
    id: "man-getting-massage",
    name: "Man Getting Massage",
    keywords: [
      "getting-massage",
      "male",
      "boy",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2642-fe0f",
        native: "💆‍♂️",
        x: 26,
        y: 4
      },
      {
        unified: "1f486-1f3fb-200d-2642-fe0f",
        native: "💆🏻‍♂️",
        x: 26,
        y: 5
      },
      {
        unified: "1f486-1f3fc-200d-2642-fe0f",
        native: "💆🏼‍♂️",
        x: 26,
        y: 6
      },
      {
        unified: "1f486-1f3fd-200d-2642-fe0f",
        native: "💆🏽‍♂️",
        x: 26,
        y: 7
      },
      {
        unified: "1f486-1f3fe-200d-2642-fe0f",
        native: "💆🏾‍♂️",
        x: 26,
        y: 8
      },
      {
        unified: "1f486-1f3ff-200d-2642-fe0f",
        native: "💆🏿‍♂️",
        x: 26,
        y: 9
      }
    ],
    version: 4
  },
  "woman-getting-massage": {
    id: "woman-getting-massage",
    name: "Woman Getting Massage",
    keywords: [
      "getting-massage",
      "female",
      "girl",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2640-fe0f",
        native: "💆‍♀️",
        x: 25,
        y: 59
      },
      {
        unified: "1f486-1f3fb-200d-2640-fe0f",
        native: "💆🏻‍♀️",
        x: 25,
        y: 60
      },
      {
        unified: "1f486-1f3fc-200d-2640-fe0f",
        native: "💆🏼‍♀️",
        x: 26,
        y: 0
      },
      {
        unified: "1f486-1f3fd-200d-2640-fe0f",
        native: "💆🏽‍♀️",
        x: 26,
        y: 1
      },
      {
        unified: "1f486-1f3fe-200d-2640-fe0f",
        native: "💆🏾‍♀️",
        x: 26,
        y: 2
      },
      {
        unified: "1f486-1f3ff-200d-2640-fe0f",
        native: "💆🏿‍♀️",
        x: 26,
        y: 3
      }
    ],
    version: 4
  },
  haircut: {
    id: "haircut",
    name: "Haircut",
    keywords: [
      "person",
      "getting",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f487",
        native: "💇",
        x: 26,
        y: 28
      },
      {
        unified: "1f487-1f3fb",
        native: "💇🏻",
        x: 26,
        y: 29
      },
      {
        unified: "1f487-1f3fc",
        native: "💇🏼",
        x: 26,
        y: 30
      },
      {
        unified: "1f487-1f3fd",
        native: "💇🏽",
        x: 26,
        y: 31
      },
      {
        unified: "1f487-1f3fe",
        native: "💇🏾",
        x: 26,
        y: 32
      },
      {
        unified: "1f487-1f3ff",
        native: "💇🏿",
        x: 26,
        y: 33
      }
    ],
    version: 1
  },
  "man-getting-haircut": {
    id: "man-getting-haircut",
    name: "Man Getting Haircut",
    keywords: [
      "getting-haircut",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f487-200d-2642-fe0f",
        native: "💇‍♂️",
        x: 26,
        y: 22
      },
      {
        unified: "1f487-1f3fb-200d-2642-fe0f",
        native: "💇🏻‍♂️",
        x: 26,
        y: 23
      },
      {
        unified: "1f487-1f3fc-200d-2642-fe0f",
        native: "💇🏼‍♂️",
        x: 26,
        y: 24
      },
      {
        unified: "1f487-1f3fd-200d-2642-fe0f",
        native: "💇🏽‍♂️",
        x: 26,
        y: 25
      },
      {
        unified: "1f487-1f3fe-200d-2642-fe0f",
        native: "💇🏾‍♂️",
        x: 26,
        y: 26
      },
      {
        unified: "1f487-1f3ff-200d-2642-fe0f",
        native: "💇🏿‍♂️",
        x: 26,
        y: 27
      }
    ],
    version: 4
  },
  "woman-getting-haircut": {
    id: "woman-getting-haircut",
    name: "Woman Getting Haircut",
    keywords: [
      "getting-haircut",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f487-200d-2640-fe0f",
        native: "💇‍♀️",
        x: 26,
        y: 16
      },
      {
        unified: "1f487-1f3fb-200d-2640-fe0f",
        native: "💇🏻‍♀️",
        x: 26,
        y: 17
      },
      {
        unified: "1f487-1f3fc-200d-2640-fe0f",
        native: "💇🏼‍♀️",
        x: 26,
        y: 18
      },
      {
        unified: "1f487-1f3fd-200d-2640-fe0f",
        native: "💇🏽‍♀️",
        x: 26,
        y: 19
      },
      {
        unified: "1f487-1f3fe-200d-2640-fe0f",
        native: "💇🏾‍♀️",
        x: 26,
        y: 20
      },
      {
        unified: "1f487-1f3ff-200d-2640-fe0f",
        native: "💇🏿‍♀️",
        x: 26,
        y: 21
      }
    ],
    version: 4
  },
  walking: {
    id: "walking",
    name: "Pedestrian",
    keywords: [
      "walking",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f6b6",
        native: "🚶",
        x: 37,
        y: 27
      },
      {
        unified: "1f6b6-1f3fb",
        native: "🚶🏻",
        x: 37,
        y: 28
      },
      {
        unified: "1f6b6-1f3fc",
        native: "🚶🏼",
        x: 37,
        y: 29
      },
      {
        unified: "1f6b6-1f3fd",
        native: "🚶🏽",
        x: 37,
        y: 30
      },
      {
        unified: "1f6b6-1f3fe",
        native: "🚶🏾",
        x: 37,
        y: 31
      },
      {
        unified: "1f6b6-1f3ff",
        native: "🚶🏿",
        x: 37,
        y: 32
      }
    ],
    version: 1
  },
  "man-walking": {
    id: "man-walking",
    name: "Man Walking",
    keywords: [
      "human",
      "feet",
      "steps"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2642-fe0f",
        native: "🚶‍♂️",
        x: 37,
        y: 21
      },
      {
        unified: "1f6b6-1f3fb-200d-2642-fe0f",
        native: "🚶🏻‍♂️",
        x: 37,
        y: 22
      },
      {
        unified: "1f6b6-1f3fc-200d-2642-fe0f",
        native: "🚶🏼‍♂️",
        x: 37,
        y: 23
      },
      {
        unified: "1f6b6-1f3fd-200d-2642-fe0f",
        native: "🚶🏽‍♂️",
        x: 37,
        y: 24
      },
      {
        unified: "1f6b6-1f3fe-200d-2642-fe0f",
        native: "🚶🏾‍♂️",
        x: 37,
        y: 25
      },
      {
        unified: "1f6b6-1f3ff-200d-2642-fe0f",
        native: "🚶🏿‍♂️",
        x: 37,
        y: 26
      }
    ],
    version: 4
  },
  "woman-walking": {
    id: "woman-walking",
    name: "Woman Walking",
    keywords: [
      "human",
      "feet",
      "steps",
      "female"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2640-fe0f",
        native: "🚶‍♀️",
        x: 37,
        y: 15
      },
      {
        unified: "1f6b6-1f3fb-200d-2640-fe0f",
        native: "🚶🏻‍♀️",
        x: 37,
        y: 16
      },
      {
        unified: "1f6b6-1f3fc-200d-2640-fe0f",
        native: "🚶🏼‍♀️",
        x: 37,
        y: 17
      },
      {
        unified: "1f6b6-1f3fd-200d-2640-fe0f",
        native: "🚶🏽‍♀️",
        x: 37,
        y: 18
      },
      {
        unified: "1f6b6-1f3fe-200d-2640-fe0f",
        native: "🚶🏾‍♀️",
        x: 37,
        y: 19
      },
      {
        unified: "1f6b6-1f3ff-200d-2640-fe0f",
        native: "🚶🏿‍♀️",
        x: 37,
        y: 20
      }
    ],
    version: 4
  },
  standing_person: {
    id: "standing_person",
    name: "Standing Person",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd",
        native: "🧍",
        x: 46,
        y: 30
      },
      {
        unified: "1f9cd-1f3fb",
        native: "🧍🏻",
        x: 46,
        y: 31
      },
      {
        unified: "1f9cd-1f3fc",
        native: "🧍🏼",
        x: 46,
        y: 32
      },
      {
        unified: "1f9cd-1f3fd",
        native: "🧍🏽",
        x: 46,
        y: 33
      },
      {
        unified: "1f9cd-1f3fe",
        native: "🧍🏾",
        x: 46,
        y: 34
      },
      {
        unified: "1f9cd-1f3ff",
        native: "🧍🏿",
        x: 46,
        y: 35
      }
    ],
    version: 12
  },
  man_standing: {
    id: "man_standing",
    name: "Man Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2642-fe0f",
        native: "🧍‍♂️",
        x: 46,
        y: 24
      },
      {
        unified: "1f9cd-1f3fb-200d-2642-fe0f",
        native: "🧍🏻‍♂️",
        x: 46,
        y: 25
      },
      {
        unified: "1f9cd-1f3fc-200d-2642-fe0f",
        native: "🧍🏼‍♂️",
        x: 46,
        y: 26
      },
      {
        unified: "1f9cd-1f3fd-200d-2642-fe0f",
        native: "🧍🏽‍♂️",
        x: 46,
        y: 27
      },
      {
        unified: "1f9cd-1f3fe-200d-2642-fe0f",
        native: "🧍🏾‍♂️",
        x: 46,
        y: 28
      },
      {
        unified: "1f9cd-1f3ff-200d-2642-fe0f",
        native: "🧍🏿‍♂️",
        x: 46,
        y: 29
      }
    ],
    version: 12
  },
  woman_standing: {
    id: "woman_standing",
    name: "Woman Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2640-fe0f",
        native: "🧍‍♀️",
        x: 46,
        y: 18
      },
      {
        unified: "1f9cd-1f3fb-200d-2640-fe0f",
        native: "🧍🏻‍♀️",
        x: 46,
        y: 19
      },
      {
        unified: "1f9cd-1f3fc-200d-2640-fe0f",
        native: "🧍🏼‍♀️",
        x: 46,
        y: 20
      },
      {
        unified: "1f9cd-1f3fd-200d-2640-fe0f",
        native: "🧍🏽‍♀️",
        x: 46,
        y: 21
      },
      {
        unified: "1f9cd-1f3fe-200d-2640-fe0f",
        native: "🧍🏾‍♀️",
        x: 46,
        y: 22
      },
      {
        unified: "1f9cd-1f3ff-200d-2640-fe0f",
        native: "🧍🏿‍♀️",
        x: 46,
        y: 23
      }
    ],
    version: 12
  },
  kneeling_person: {
    id: "kneeling_person",
    name: "Kneeling Person",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce",
        native: "🧎",
        x: 46,
        y: 48
      },
      {
        unified: "1f9ce-1f3fb",
        native: "🧎🏻",
        x: 46,
        y: 49
      },
      {
        unified: "1f9ce-1f3fc",
        native: "🧎🏼",
        x: 46,
        y: 50
      },
      {
        unified: "1f9ce-1f3fd",
        native: "🧎🏽",
        x: 46,
        y: 51
      },
      {
        unified: "1f9ce-1f3fe",
        native: "🧎🏾",
        x: 46,
        y: 52
      },
      {
        unified: "1f9ce-1f3ff",
        native: "🧎🏿",
        x: 46,
        y: 53
      }
    ],
    version: 12
  },
  man_kneeling: {
    id: "man_kneeling",
    name: "Man Kneeling",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2642-fe0f",
        native: "🧎‍♂️",
        x: 46,
        y: 42
      },
      {
        unified: "1f9ce-1f3fb-200d-2642-fe0f",
        native: "🧎🏻‍♂️",
        x: 46,
        y: 43
      },
      {
        unified: "1f9ce-1f3fc-200d-2642-fe0f",
        native: "🧎🏼‍♂️",
        x: 46,
        y: 44
      },
      {
        unified: "1f9ce-1f3fd-200d-2642-fe0f",
        native: "🧎🏽‍♂️",
        x: 46,
        y: 45
      },
      {
        unified: "1f9ce-1f3fe-200d-2642-fe0f",
        native: "🧎🏾‍♂️",
        x: 46,
        y: 46
      },
      {
        unified: "1f9ce-1f3ff-200d-2642-fe0f",
        native: "🧎🏿‍♂️",
        x: 46,
        y: 47
      }
    ],
    version: 12
  },
  woman_kneeling: {
    id: "woman_kneeling",
    name: "Woman Kneeling",
    keywords: [
      "respectful",
      "pray"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2640-fe0f",
        native: "🧎‍♀️",
        x: 46,
        y: 36
      },
      {
        unified: "1f9ce-1f3fb-200d-2640-fe0f",
        native: "🧎🏻‍♀️",
        x: 46,
        y: 37
      },
      {
        unified: "1f9ce-1f3fc-200d-2640-fe0f",
        native: "🧎🏼‍♀️",
        x: 46,
        y: 38
      },
      {
        unified: "1f9ce-1f3fd-200d-2640-fe0f",
        native: "🧎🏽‍♀️",
        x: 46,
        y: 39
      },
      {
        unified: "1f9ce-1f3fe-200d-2640-fe0f",
        native: "🧎🏾‍♀️",
        x: 46,
        y: 40
      },
      {
        unified: "1f9ce-1f3ff-200d-2640-fe0f",
        native: "🧎🏿‍♀️",
        x: 46,
        y: 41
      }
    ],
    version: 12
  },
  person_with_probing_cane: {
    id: "person_with_probing_cane",
    name: "Person with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9af",
        native: "🧑‍🦯",
        x: 49,
        y: 6
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9af",
        native: "🧑🏻‍🦯",
        x: 49,
        y: 7
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9af",
        native: "🧑🏼‍🦯",
        x: 49,
        y: 8
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9af",
        native: "🧑🏽‍🦯",
        x: 49,
        y: 9
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9af",
        native: "🧑🏾‍🦯",
        x: 49,
        y: 10
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9af",
        native: "🧑🏿‍🦯",
        x: 49,
        y: 11
      }
    ],
    version: 12.1
  },
  man_with_probing_cane: {
    id: "man_with_probing_cane",
    name: "Man with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9af",
        native: "👨‍🦯",
        x: 15,
        y: 23
      },
      {
        unified: "1f468-1f3fb-200d-1f9af",
        native: "👨🏻‍🦯",
        x: 15,
        y: 24
      },
      {
        unified: "1f468-1f3fc-200d-1f9af",
        native: "👨🏼‍🦯",
        x: 15,
        y: 25
      },
      {
        unified: "1f468-1f3fd-200d-1f9af",
        native: "👨🏽‍🦯",
        x: 15,
        y: 26
      },
      {
        unified: "1f468-1f3fe-200d-1f9af",
        native: "👨🏾‍🦯",
        x: 15,
        y: 27
      },
      {
        unified: "1f468-1f3ff-200d-1f9af",
        native: "👨🏿‍🦯",
        x: 15,
        y: 28
      }
    ],
    version: 12
  },
  woman_with_probing_cane: {
    id: "woman_with_probing_cane",
    name: "Woman with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9af",
        native: "👩‍🦯",
        x: 18,
        y: 52
      },
      {
        unified: "1f469-1f3fb-200d-1f9af",
        native: "👩🏻‍🦯",
        x: 18,
        y: 53
      },
      {
        unified: "1f469-1f3fc-200d-1f9af",
        native: "👩🏼‍🦯",
        x: 18,
        y: 54
      },
      {
        unified: "1f469-1f3fd-200d-1f9af",
        native: "👩🏽‍🦯",
        x: 18,
        y: 55
      },
      {
        unified: "1f469-1f3fe-200d-1f9af",
        native: "👩🏾‍🦯",
        x: 18,
        y: 56
      },
      {
        unified: "1f469-1f3ff-200d-1f9af",
        native: "👩🏿‍🦯",
        x: 18,
        y: 57
      }
    ],
    version: 12
  },
  person_in_motorized_wheelchair: {
    id: "person_in_motorized_wheelchair",
    name: "Person in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bc",
        native: "🧑‍🦼",
        x: 49,
        y: 36
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bc",
        native: "🧑🏻‍🦼",
        x: 49,
        y: 37
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bc",
        native: "🧑🏼‍🦼",
        x: 49,
        y: 38
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bc",
        native: "🧑🏽‍🦼",
        x: 49,
        y: 39
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bc",
        native: "🧑🏾‍🦼",
        x: 49,
        y: 40
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bc",
        native: "🧑🏿‍🦼",
        x: 49,
        y: 41
      }
    ],
    version: 12.1
  },
  man_in_motorized_wheelchair: {
    id: "man_in_motorized_wheelchair",
    name: "Man in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bc",
        native: "👨‍🦼",
        x: 15,
        y: 53
      },
      {
        unified: "1f468-1f3fb-200d-1f9bc",
        native: "👨🏻‍🦼",
        x: 15,
        y: 54
      },
      {
        unified: "1f468-1f3fc-200d-1f9bc",
        native: "👨🏼‍🦼",
        x: 15,
        y: 55
      },
      {
        unified: "1f468-1f3fd-200d-1f9bc",
        native: "👨🏽‍🦼",
        x: 15,
        y: 56
      },
      {
        unified: "1f468-1f3fe-200d-1f9bc",
        native: "👨🏾‍🦼",
        x: 15,
        y: 57
      },
      {
        unified: "1f468-1f3ff-200d-1f9bc",
        native: "👨🏿‍🦼",
        x: 15,
        y: 58
      }
    ],
    version: 12
  },
  woman_in_motorized_wheelchair: {
    id: "woman_in_motorized_wheelchair",
    name: "Woman in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bc",
        native: "👩‍🦼",
        x: 19,
        y: 21
      },
      {
        unified: "1f469-1f3fb-200d-1f9bc",
        native: "👩🏻‍🦼",
        x: 19,
        y: 22
      },
      {
        unified: "1f469-1f3fc-200d-1f9bc",
        native: "👩🏼‍🦼",
        x: 19,
        y: 23
      },
      {
        unified: "1f469-1f3fd-200d-1f9bc",
        native: "👩🏽‍🦼",
        x: 19,
        y: 24
      },
      {
        unified: "1f469-1f3fe-200d-1f9bc",
        native: "👩🏾‍🦼",
        x: 19,
        y: 25
      },
      {
        unified: "1f469-1f3ff-200d-1f9bc",
        native: "👩🏿‍🦼",
        x: 19,
        y: 26
      }
    ],
    version: 12
  },
  person_in_manual_wheelchair: {
    id: "person_in_manual_wheelchair",
    name: "Person in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bd",
        native: "🧑‍🦽",
        x: 49,
        y: 42
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bd",
        native: "🧑🏻‍🦽",
        x: 49,
        y: 43
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bd",
        native: "🧑🏼‍🦽",
        x: 49,
        y: 44
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bd",
        native: "🧑🏽‍🦽",
        x: 49,
        y: 45
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bd",
        native: "🧑🏾‍🦽",
        x: 49,
        y: 46
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bd",
        native: "🧑🏿‍🦽",
        x: 49,
        y: 47
      }
    ],
    version: 12.1
  },
  man_in_manual_wheelchair: {
    id: "man_in_manual_wheelchair",
    name: "Man in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bd",
        native: "👨‍🦽",
        x: 15,
        y: 59
      },
      {
        unified: "1f468-1f3fb-200d-1f9bd",
        native: "👨🏻‍🦽",
        x: 15,
        y: 60
      },
      {
        unified: "1f468-1f3fc-200d-1f9bd",
        native: "👨🏼‍🦽",
        x: 16,
        y: 0
      },
      {
        unified: "1f468-1f3fd-200d-1f9bd",
        native: "👨🏽‍🦽",
        x: 16,
        y: 1
      },
      {
        unified: "1f468-1f3fe-200d-1f9bd",
        native: "👨🏾‍🦽",
        x: 16,
        y: 2
      },
      {
        unified: "1f468-1f3ff-200d-1f9bd",
        native: "👨🏿‍🦽",
        x: 16,
        y: 3
      }
    ],
    version: 12
  },
  woman_in_manual_wheelchair: {
    id: "woman_in_manual_wheelchair",
    name: "Woman in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bd",
        native: "👩‍🦽",
        x: 19,
        y: 27
      },
      {
        unified: "1f469-1f3fb-200d-1f9bd",
        native: "👩🏻‍🦽",
        x: 19,
        y: 28
      },
      {
        unified: "1f469-1f3fc-200d-1f9bd",
        native: "👩🏼‍🦽",
        x: 19,
        y: 29
      },
      {
        unified: "1f469-1f3fd-200d-1f9bd",
        native: "👩🏽‍🦽",
        x: 19,
        y: 30
      },
      {
        unified: "1f469-1f3fe-200d-1f9bd",
        native: "👩🏾‍🦽",
        x: 19,
        y: 31
      },
      {
        unified: "1f469-1f3ff-200d-1f9bd",
        native: "👩🏿‍🦽",
        x: 19,
        y: 32
      }
    ],
    version: 12
  },
  runner: {
    id: "runner",
    name: "Runner",
    keywords: [
      "running",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f3c3",
        native: "🏃",
        x: 8,
        y: 26
      },
      {
        unified: "1f3c3-1f3fb",
        native: "🏃🏻",
        x: 8,
        y: 27
      },
      {
        unified: "1f3c3-1f3fc",
        native: "🏃🏼",
        x: 8,
        y: 28
      },
      {
        unified: "1f3c3-1f3fd",
        native: "🏃🏽",
        x: 8,
        y: 29
      },
      {
        unified: "1f3c3-1f3fe",
        native: "🏃🏾",
        x: 8,
        y: 30
      },
      {
        unified: "1f3c3-1f3ff",
        native: "🏃🏿",
        x: 8,
        y: 31
      }
    ],
    version: 1
  },
  "man-running": {
    id: "man-running",
    name: "Man Running",
    keywords: [
      "walking",
      "exercise",
      "race"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2642-fe0f",
        native: "🏃‍♂️",
        x: 8,
        y: 20
      },
      {
        unified: "1f3c3-1f3fb-200d-2642-fe0f",
        native: "🏃🏻‍♂️",
        x: 8,
        y: 21
      },
      {
        unified: "1f3c3-1f3fc-200d-2642-fe0f",
        native: "🏃🏼‍♂️",
        x: 8,
        y: 22
      },
      {
        unified: "1f3c3-1f3fd-200d-2642-fe0f",
        native: "🏃🏽‍♂️",
        x: 8,
        y: 23
      },
      {
        unified: "1f3c3-1f3fe-200d-2642-fe0f",
        native: "🏃🏾‍♂️",
        x: 8,
        y: 24
      },
      {
        unified: "1f3c3-1f3ff-200d-2642-fe0f",
        native: "🏃🏿‍♂️",
        x: 8,
        y: 25
      }
    ],
    version: 4
  },
  "woman-running": {
    id: "woman-running",
    name: "Woman Running",
    keywords: [
      "walking",
      "exercise",
      "race",
      "female"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2640-fe0f",
        native: "🏃‍♀️",
        x: 8,
        y: 14
      },
      {
        unified: "1f3c3-1f3fb-200d-2640-fe0f",
        native: "🏃🏻‍♀️",
        x: 8,
        y: 15
      },
      {
        unified: "1f3c3-1f3fc-200d-2640-fe0f",
        native: "🏃🏼‍♀️",
        x: 8,
        y: 16
      },
      {
        unified: "1f3c3-1f3fd-200d-2640-fe0f",
        native: "🏃🏽‍♀️",
        x: 8,
        y: 17
      },
      {
        unified: "1f3c3-1f3fe-200d-2640-fe0f",
        native: "🏃🏾‍♀️",
        x: 8,
        y: 18
      },
      {
        unified: "1f3c3-1f3ff-200d-2640-fe0f",
        native: "🏃🏿‍♀️",
        x: 8,
        y: 19
      }
    ],
    version: 4
  },
  dancer: {
    id: "dancer",
    name: "Dancer",
    keywords: [
      "woman",
      "dancing",
      "female",
      "girl",
      "fun"
    ],
    skins: [
      {
        unified: "1f483",
        native: "💃",
        x: 25,
        y: 46
      },
      {
        unified: "1f483-1f3fb",
        native: "💃🏻",
        x: 25,
        y: 47
      },
      {
        unified: "1f483-1f3fc",
        native: "💃🏼",
        x: 25,
        y: 48
      },
      {
        unified: "1f483-1f3fd",
        native: "💃🏽",
        x: 25,
        y: 49
      },
      {
        unified: "1f483-1f3fe",
        native: "💃🏾",
        x: 25,
        y: 50
      },
      {
        unified: "1f483-1f3ff",
        native: "💃🏿",
        x: 25,
        y: 51
      }
    ],
    version: 1
  },
  man_dancing: {
    id: "man_dancing",
    name: "Man Dancing",
    keywords: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    skins: [
      {
        unified: "1f57a",
        native: "🕺",
        x: 31,
        y: 26
      },
      {
        unified: "1f57a-1f3fb",
        native: "🕺🏻",
        x: 31,
        y: 27
      },
      {
        unified: "1f57a-1f3fc",
        native: "🕺🏼",
        x: 31,
        y: 28
      },
      {
        unified: "1f57a-1f3fd",
        native: "🕺🏽",
        x: 31,
        y: 29
      },
      {
        unified: "1f57a-1f3fe",
        native: "🕺🏾",
        x: 31,
        y: 30
      },
      {
        unified: "1f57a-1f3ff",
        native: "🕺🏿",
        x: 31,
        y: 31
      }
    ],
    version: 3
  },
  man_in_business_suit_levitating: {
    id: "man_in_business_suit_levitating",
    name: "Person in Suit Levitating",
    keywords: [
      "man",
      "business",
      "levitate",
      "hover",
      "jump"
    ],
    skins: [
      {
        unified: "1f574-fe0f",
        native: "🕴️",
        x: 30,
        y: 59
      },
      {
        unified: "1f574-1f3fb",
        native: "🕴🏻",
        x: 30,
        y: 60
      },
      {
        unified: "1f574-1f3fc",
        native: "🕴🏼",
        x: 31,
        y: 0
      },
      {
        unified: "1f574-1f3fd",
        native: "🕴🏽",
        x: 31,
        y: 1
      },
      {
        unified: "1f574-1f3fe",
        native: "🕴🏾",
        x: 31,
        y: 2
      },
      {
        unified: "1f574-1f3ff",
        native: "🕴🏿",
        x: 31,
        y: 3
      }
    ],
    version: 1
  },
  dancers: {
    id: "dancers",
    name: "Woman with Bunny Ears",
    keywords: [
      "dancers",
      "people",
      "perform",
      "costume"
    ],
    skins: [
      {
        unified: "1f46f",
        native: "👯",
        x: 23,
        y: 16
      }
    ],
    version: 1
  },
  "men-with-bunny-ears-partying": {
    id: "men-with-bunny-ears-partying",
    name: "Men with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "man",
      "male",
      "boys"
    ],
    skins: [
      {
        unified: "1f46f-200d-2642-fe0f",
        native: "👯‍♂️",
        x: 23,
        y: 15
      }
    ],
    version: 4
  },
  "women-with-bunny-ears-partying": {
    id: "women-with-bunny-ears-partying",
    name: "Women with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "woman",
      "female",
      "girls"
    ],
    skins: [
      {
        unified: "1f46f-200d-2640-fe0f",
        native: "👯‍♀️",
        x: 23,
        y: 14
      }
    ],
    version: 4
  },
  person_in_steamy_room: {
    id: "person_in_steamy_room",
    name: "Person in Steamy Room",
    keywords: [
      "relax",
      "spa"
    ],
    skins: [
      {
        unified: "1f9d6",
        native: "🧖",
        x: 50,
        y: 59
      },
      {
        unified: "1f9d6-1f3fb",
        native: "🧖🏻",
        x: 50,
        y: 60
      },
      {
        unified: "1f9d6-1f3fc",
        native: "🧖🏼",
        x: 51,
        y: 0
      },
      {
        unified: "1f9d6-1f3fd",
        native: "🧖🏽",
        x: 51,
        y: 1
      },
      {
        unified: "1f9d6-1f3fe",
        native: "🧖🏾",
        x: 51,
        y: 2
      },
      {
        unified: "1f9d6-1f3ff",
        native: "🧖🏿",
        x: 51,
        y: 3
      }
    ],
    version: 5
  },
  man_in_steamy_room: {
    id: "man_in_steamy_room",
    name: "Man in Steamy Room",
    keywords: [
      "male",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2642-fe0f",
        native: "🧖‍♂️",
        x: 50,
        y: 53
      },
      {
        unified: "1f9d6-1f3fb-200d-2642-fe0f",
        native: "🧖🏻‍♂️",
        x: 50,
        y: 54
      },
      {
        unified: "1f9d6-1f3fc-200d-2642-fe0f",
        native: "🧖🏼‍♂️",
        x: 50,
        y: 55
      },
      {
        unified: "1f9d6-1f3fd-200d-2642-fe0f",
        native: "🧖🏽‍♂️",
        x: 50,
        y: 56
      },
      {
        unified: "1f9d6-1f3fe-200d-2642-fe0f",
        native: "🧖🏾‍♂️",
        x: 50,
        y: 57
      },
      {
        unified: "1f9d6-1f3ff-200d-2642-fe0f",
        native: "🧖🏿‍♂️",
        x: 50,
        y: 58
      }
    ],
    version: 5
  },
  woman_in_steamy_room: {
    id: "woman_in_steamy_room",
    name: "Woman in Steamy Room",
    keywords: [
      "female",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2640-fe0f",
        native: "🧖‍♀️",
        x: 50,
        y: 47
      },
      {
        unified: "1f9d6-1f3fb-200d-2640-fe0f",
        native: "🧖🏻‍♀️",
        x: 50,
        y: 48
      },
      {
        unified: "1f9d6-1f3fc-200d-2640-fe0f",
        native: "🧖🏼‍♀️",
        x: 50,
        y: 49
      },
      {
        unified: "1f9d6-1f3fd-200d-2640-fe0f",
        native: "🧖🏽‍♀️",
        x: 50,
        y: 50
      },
      {
        unified: "1f9d6-1f3fe-200d-2640-fe0f",
        native: "🧖🏾‍♀️",
        x: 50,
        y: 51
      },
      {
        unified: "1f9d6-1f3ff-200d-2640-fe0f",
        native: "🧖🏿‍♀️",
        x: 50,
        y: 52
      }
    ],
    version: 5
  },
  person_climbing: {
    id: "person_climbing",
    name: "Person Climbing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f9d7",
        native: "🧗",
        x: 51,
        y: 16
      },
      {
        unified: "1f9d7-1f3fb",
        native: "🧗🏻",
        x: 51,
        y: 17
      },
      {
        unified: "1f9d7-1f3fc",
        native: "🧗🏼",
        x: 51,
        y: 18
      },
      {
        unified: "1f9d7-1f3fd",
        native: "🧗🏽",
        x: 51,
        y: 19
      },
      {
        unified: "1f9d7-1f3fe",
        native: "🧗🏾",
        x: 51,
        y: 20
      },
      {
        unified: "1f9d7-1f3ff",
        native: "🧗🏿",
        x: 51,
        y: 21
      }
    ],
    version: 5
  },
  man_climbing: {
    id: "man_climbing",
    name: "Man Climbing",
    keywords: [
      "sports",
      "hobby",
      "male",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2642-fe0f",
        native: "🧗‍♂️",
        x: 51,
        y: 10
      },
      {
        unified: "1f9d7-1f3fb-200d-2642-fe0f",
        native: "🧗🏻‍♂️",
        x: 51,
        y: 11
      },
      {
        unified: "1f9d7-1f3fc-200d-2642-fe0f",
        native: "🧗🏼‍♂️",
        x: 51,
        y: 12
      },
      {
        unified: "1f9d7-1f3fd-200d-2642-fe0f",
        native: "🧗🏽‍♂️",
        x: 51,
        y: 13
      },
      {
        unified: "1f9d7-1f3fe-200d-2642-fe0f",
        native: "🧗🏾‍♂️",
        x: 51,
        y: 14
      },
      {
        unified: "1f9d7-1f3ff-200d-2642-fe0f",
        native: "🧗🏿‍♂️",
        x: 51,
        y: 15
      }
    ],
    version: 5
  },
  woman_climbing: {
    id: "woman_climbing",
    name: "Woman Climbing",
    keywords: [
      "sports",
      "hobby",
      "female",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2640-fe0f",
        native: "🧗‍♀️",
        x: 51,
        y: 4
      },
      {
        unified: "1f9d7-1f3fb-200d-2640-fe0f",
        native: "🧗🏻‍♀️",
        x: 51,
        y: 5
      },
      {
        unified: "1f9d7-1f3fc-200d-2640-fe0f",
        native: "🧗🏼‍♀️",
        x: 51,
        y: 6
      },
      {
        unified: "1f9d7-1f3fd-200d-2640-fe0f",
        native: "🧗🏽‍♀️",
        x: 51,
        y: 7
      },
      {
        unified: "1f9d7-1f3fe-200d-2640-fe0f",
        native: "🧗🏾‍♀️",
        x: 51,
        y: 8
      },
      {
        unified: "1f9d7-1f3ff-200d-2640-fe0f",
        native: "🧗🏿‍♀️",
        x: 51,
        y: 9
      }
    ],
    version: 5
  },
  fencer: {
    id: "fencer",
    name: "Fencer",
    keywords: [
      "person",
      "fencing",
      "sports",
      "sword"
    ],
    skins: [
      {
        unified: "1f93a",
        native: "🤺",
        x: 42,
        y: 31
      }
    ],
    version: 3
  },
  horse_racing: {
    id: "horse_racing",
    name: "Horse Racing",
    keywords: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    skins: [
      {
        unified: "1f3c7",
        native: "🏇",
        x: 8,
        y: 52
      },
      {
        unified: "1f3c7-1f3fb",
        native: "🏇🏻",
        x: 8,
        y: 53
      },
      {
        unified: "1f3c7-1f3fc",
        native: "🏇🏼",
        x: 8,
        y: 54
      },
      {
        unified: "1f3c7-1f3fd",
        native: "🏇🏽",
        x: 8,
        y: 55
      },
      {
        unified: "1f3c7-1f3fe",
        native: "🏇🏾",
        x: 8,
        y: 56
      },
      {
        unified: "1f3c7-1f3ff",
        native: "🏇🏿",
        x: 8,
        y: 57
      }
    ],
    version: 1
  },
  skier: {
    id: "skier",
    name: "Skier",
    keywords: [
      "sports",
      "winter",
      "snow"
    ],
    skins: [
      {
        unified: "26f7-fe0f",
        native: "⛷️",
        x: 58,
        y: 1
      }
    ],
    version: 1
  },
  snowboarder: {
    id: "snowboarder",
    name: "Snowboarder",
    keywords: [
      "sports",
      "winter"
    ],
    skins: [
      {
        unified: "1f3c2",
        native: "🏂",
        x: 8,
        y: 8
      },
      {
        unified: "1f3c2-1f3fb",
        native: "🏂🏻",
        x: 8,
        y: 9
      },
      {
        unified: "1f3c2-1f3fc",
        native: "🏂🏼",
        x: 8,
        y: 10
      },
      {
        unified: "1f3c2-1f3fd",
        native: "🏂🏽",
        x: 8,
        y: 11
      },
      {
        unified: "1f3c2-1f3fe",
        native: "🏂🏾",
        x: 8,
        y: 12
      },
      {
        unified: "1f3c2-1f3ff",
        native: "🏂🏿",
        x: 8,
        y: 13
      }
    ],
    version: 1
  },
  golfer: {
    id: "golfer",
    name: "Person Golfing",
    keywords: [
      "golfer",
      "sports",
      "business"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f",
        native: "🏌️",
        x: 9,
        y: 47
      },
      {
        unified: "1f3cc-1f3fb",
        native: "🏌🏻",
        x: 9,
        y: 48
      },
      {
        unified: "1f3cc-1f3fc",
        native: "🏌🏼",
        x: 9,
        y: 49
      },
      {
        unified: "1f3cc-1f3fd",
        native: "🏌🏽",
        x: 9,
        y: 50
      },
      {
        unified: "1f3cc-1f3fe",
        native: "🏌🏾",
        x: 9,
        y: 51
      },
      {
        unified: "1f3cc-1f3ff",
        native: "🏌🏿",
        x: 9,
        y: 52
      }
    ],
    version: 1
  },
  "man-golfing": {
    id: "man-golfing",
    name: "Man Golfing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2642-fe0f",
        native: "🏌️‍♂️",
        x: 9,
        y: 41
      },
      {
        unified: "1f3cc-1f3fb-200d-2642-fe0f",
        native: "🏌🏻‍♂️",
        x: 9,
        y: 42
      },
      {
        unified: "1f3cc-1f3fc-200d-2642-fe0f",
        native: "🏌🏼‍♂️",
        x: 9,
        y: 43
      },
      {
        unified: "1f3cc-1f3fd-200d-2642-fe0f",
        native: "🏌🏽‍♂️",
        x: 9,
        y: 44
      },
      {
        unified: "1f3cc-1f3fe-200d-2642-fe0f",
        native: "🏌🏾‍♂️",
        x: 9,
        y: 45
      },
      {
        unified: "1f3cc-1f3ff-200d-2642-fe0f",
        native: "🏌🏿‍♂️",
        x: 9,
        y: 46
      }
    ],
    version: 4
  },
  "woman-golfing": {
    id: "woman-golfing",
    name: "Woman Golfing",
    keywords: [
      "sports",
      "business",
      "female"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2640-fe0f",
        native: "🏌️‍♀️",
        x: 9,
        y: 35
      },
      {
        unified: "1f3cc-1f3fb-200d-2640-fe0f",
        native: "🏌🏻‍♀️",
        x: 9,
        y: 36
      },
      {
        unified: "1f3cc-1f3fc-200d-2640-fe0f",
        native: "🏌🏼‍♀️",
        x: 9,
        y: 37
      },
      {
        unified: "1f3cc-1f3fd-200d-2640-fe0f",
        native: "🏌🏽‍♀️",
        x: 9,
        y: 38
      },
      {
        unified: "1f3cc-1f3fe-200d-2640-fe0f",
        native: "🏌🏾‍♀️",
        x: 9,
        y: 39
      },
      {
        unified: "1f3cc-1f3ff-200d-2640-fe0f",
        native: "🏌🏿‍♀️",
        x: 9,
        y: 40
      }
    ],
    version: 4
  },
  surfer: {
    id: "surfer",
    name: "Surfer",
    keywords: [
      "person",
      "surfing",
      "sport",
      "sea"
    ],
    skins: [
      {
        unified: "1f3c4",
        native: "🏄",
        x: 8,
        y: 44
      },
      {
        unified: "1f3c4-1f3fb",
        native: "🏄🏻",
        x: 8,
        y: 45
      },
      {
        unified: "1f3c4-1f3fc",
        native: "🏄🏼",
        x: 8,
        y: 46
      },
      {
        unified: "1f3c4-1f3fd",
        native: "🏄🏽",
        x: 8,
        y: 47
      },
      {
        unified: "1f3c4-1f3fe",
        native: "🏄🏾",
        x: 8,
        y: 48
      },
      {
        unified: "1f3c4-1f3ff",
        native: "🏄🏿",
        x: 8,
        y: 49
      }
    ],
    version: 1
  },
  "man-surfing": {
    id: "man-surfing",
    name: "Man Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2642-fe0f",
        native: "🏄‍♂️",
        x: 8,
        y: 38
      },
      {
        unified: "1f3c4-1f3fb-200d-2642-fe0f",
        native: "🏄🏻‍♂️",
        x: 8,
        y: 39
      },
      {
        unified: "1f3c4-1f3fc-200d-2642-fe0f",
        native: "🏄🏼‍♂️",
        x: 8,
        y: 40
      },
      {
        unified: "1f3c4-1f3fd-200d-2642-fe0f",
        native: "🏄🏽‍♂️",
        x: 8,
        y: 41
      },
      {
        unified: "1f3c4-1f3fe-200d-2642-fe0f",
        native: "🏄🏾‍♂️",
        x: 8,
        y: 42
      },
      {
        unified: "1f3c4-1f3ff-200d-2642-fe0f",
        native: "🏄🏿‍♂️",
        x: 8,
        y: 43
      }
    ],
    version: 4
  },
  "woman-surfing": {
    id: "woman-surfing",
    name: "Woman Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach",
      "female"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2640-fe0f",
        native: "🏄‍♀️",
        x: 8,
        y: 32
      },
      {
        unified: "1f3c4-1f3fb-200d-2640-fe0f",
        native: "🏄🏻‍♀️",
        x: 8,
        y: 33
      },
      {
        unified: "1f3c4-1f3fc-200d-2640-fe0f",
        native: "🏄🏼‍♀️",
        x: 8,
        y: 34
      },
      {
        unified: "1f3c4-1f3fd-200d-2640-fe0f",
        native: "🏄🏽‍♀️",
        x: 8,
        y: 35
      },
      {
        unified: "1f3c4-1f3fe-200d-2640-fe0f",
        native: "🏄🏾‍♀️",
        x: 8,
        y: 36
      },
      {
        unified: "1f3c4-1f3ff-200d-2640-fe0f",
        native: "🏄🏿‍♀️",
        x: 8,
        y: 37
      }
    ],
    version: 4
  },
  rowboat: {
    id: "rowboat",
    name: "Rowboat",
    keywords: [
      "person",
      "rowing",
      "boat",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6a3",
        native: "🚣",
        x: 36,
        y: 18
      },
      {
        unified: "1f6a3-1f3fb",
        native: "🚣🏻",
        x: 36,
        y: 19
      },
      {
        unified: "1f6a3-1f3fc",
        native: "🚣🏼",
        x: 36,
        y: 20
      },
      {
        unified: "1f6a3-1f3fd",
        native: "🚣🏽",
        x: 36,
        y: 21
      },
      {
        unified: "1f6a3-1f3fe",
        native: "🚣🏾",
        x: 36,
        y: 22
      },
      {
        unified: "1f6a3-1f3ff",
        native: "🚣🏿",
        x: 36,
        y: 23
      }
    ],
    version: 1
  },
  "man-rowing-boat": {
    id: "man-rowing-boat",
    name: "Man Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2642-fe0f",
        native: "🚣‍♂️",
        x: 36,
        y: 12
      },
      {
        unified: "1f6a3-1f3fb-200d-2642-fe0f",
        native: "🚣🏻‍♂️",
        x: 36,
        y: 13
      },
      {
        unified: "1f6a3-1f3fc-200d-2642-fe0f",
        native: "🚣🏼‍♂️",
        x: 36,
        y: 14
      },
      {
        unified: "1f6a3-1f3fd-200d-2642-fe0f",
        native: "🚣🏽‍♂️",
        x: 36,
        y: 15
      },
      {
        unified: "1f6a3-1f3fe-200d-2642-fe0f",
        native: "🚣🏾‍♂️",
        x: 36,
        y: 16
      },
      {
        unified: "1f6a3-1f3ff-200d-2642-fe0f",
        native: "🚣🏿‍♂️",
        x: 36,
        y: 17
      }
    ],
    version: 4
  },
  "woman-rowing-boat": {
    id: "woman-rowing-boat",
    name: "Woman Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship",
      "female"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2640-fe0f",
        native: "🚣‍♀️",
        x: 36,
        y: 6
      },
      {
        unified: "1f6a3-1f3fb-200d-2640-fe0f",
        native: "🚣🏻‍♀️",
        x: 36,
        y: 7
      },
      {
        unified: "1f6a3-1f3fc-200d-2640-fe0f",
        native: "🚣🏼‍♀️",
        x: 36,
        y: 8
      },
      {
        unified: "1f6a3-1f3fd-200d-2640-fe0f",
        native: "🚣🏽‍♀️",
        x: 36,
        y: 9
      },
      {
        unified: "1f6a3-1f3fe-200d-2640-fe0f",
        native: "🚣🏾‍♀️",
        x: 36,
        y: 10
      },
      {
        unified: "1f6a3-1f3ff-200d-2640-fe0f",
        native: "🚣🏿‍♀️",
        x: 36,
        y: 11
      }
    ],
    version: 4
  },
  swimmer: {
    id: "swimmer",
    name: "Swimmer",
    keywords: [
      "person",
      "swimming",
      "sport",
      "pool"
    ],
    skins: [
      {
        unified: "1f3ca",
        native: "🏊",
        x: 9,
        y: 11
      },
      {
        unified: "1f3ca-1f3fb",
        native: "🏊🏻",
        x: 9,
        y: 12
      },
      {
        unified: "1f3ca-1f3fc",
        native: "🏊🏼",
        x: 9,
        y: 13
      },
      {
        unified: "1f3ca-1f3fd",
        native: "🏊🏽",
        x: 9,
        y: 14
      },
      {
        unified: "1f3ca-1f3fe",
        native: "🏊🏾",
        x: 9,
        y: 15
      },
      {
        unified: "1f3ca-1f3ff",
        native: "🏊🏿",
        x: 9,
        y: 16
      }
    ],
    version: 1
  },
  "man-swimming": {
    id: "man-swimming",
    name: "Man Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2642-fe0f",
        native: "🏊‍♂️",
        x: 9,
        y: 5
      },
      {
        unified: "1f3ca-1f3fb-200d-2642-fe0f",
        native: "🏊🏻‍♂️",
        x: 9,
        y: 6
      },
      {
        unified: "1f3ca-1f3fc-200d-2642-fe0f",
        native: "🏊🏼‍♂️",
        x: 9,
        y: 7
      },
      {
        unified: "1f3ca-1f3fd-200d-2642-fe0f",
        native: "🏊🏽‍♂️",
        x: 9,
        y: 8
      },
      {
        unified: "1f3ca-1f3fe-200d-2642-fe0f",
        native: "🏊🏾‍♂️",
        x: 9,
        y: 9
      },
      {
        unified: "1f3ca-1f3ff-200d-2642-fe0f",
        native: "🏊🏿‍♂️",
        x: 9,
        y: 10
      }
    ],
    version: 4
  },
  "woman-swimming": {
    id: "woman-swimming",
    name: "Woman Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer",
      "female"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2640-fe0f",
        native: "🏊‍♀️",
        x: 8,
        y: 60
      },
      {
        unified: "1f3ca-1f3fb-200d-2640-fe0f",
        native: "🏊🏻‍♀️",
        x: 9,
        y: 0
      },
      {
        unified: "1f3ca-1f3fc-200d-2640-fe0f",
        native: "🏊🏼‍♀️",
        x: 9,
        y: 1
      },
      {
        unified: "1f3ca-1f3fd-200d-2640-fe0f",
        native: "🏊🏽‍♀️",
        x: 9,
        y: 2
      },
      {
        unified: "1f3ca-1f3fe-200d-2640-fe0f",
        native: "🏊🏾‍♀️",
        x: 9,
        y: 3
      },
      {
        unified: "1f3ca-1f3ff-200d-2640-fe0f",
        native: "🏊🏿‍♀️",
        x: 9,
        y: 4
      }
    ],
    version: 4
  },
  person_with_ball: {
    id: "person_with_ball",
    name: "Person Bouncing Ball",
    keywords: [
      "with",
      "sports",
      "human"
    ],
    skins: [
      {
        unified: "26f9-fe0f",
        native: "⛹️",
        x: 58,
        y: 15
      },
      {
        unified: "26f9-1f3fb",
        native: "⛹🏻",
        x: 58,
        y: 16
      },
      {
        unified: "26f9-1f3fc",
        native: "⛹🏼",
        x: 58,
        y: 17
      },
      {
        unified: "26f9-1f3fd",
        native: "⛹🏽",
        x: 58,
        y: 18
      },
      {
        unified: "26f9-1f3fe",
        native: "⛹🏾",
        x: 58,
        y: 19
      },
      {
        unified: "26f9-1f3ff",
        native: "⛹🏿",
        x: 58,
        y: 20
      }
    ],
    version: 1
  },
  "man-bouncing-ball": {
    id: "man-bouncing-ball",
    name: "Man Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sport"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2642-fe0f",
        native: "⛹️‍♂️",
        x: 58,
        y: 9
      },
      {
        unified: "26f9-1f3fb-200d-2642-fe0f",
        native: "⛹🏻‍♂️",
        x: 58,
        y: 10
      },
      {
        unified: "26f9-1f3fc-200d-2642-fe0f",
        native: "⛹🏼‍♂️",
        x: 58,
        y: 11
      },
      {
        unified: "26f9-1f3fd-200d-2642-fe0f",
        native: "⛹🏽‍♂️",
        x: 58,
        y: 12
      },
      {
        unified: "26f9-1f3fe-200d-2642-fe0f",
        native: "⛹🏾‍♂️",
        x: 58,
        y: 13
      },
      {
        unified: "26f9-1f3ff-200d-2642-fe0f",
        native: "⛹🏿‍♂️",
        x: 58,
        y: 14
      }
    ],
    version: 4
  },
  "woman-bouncing-ball": {
    id: "woman-bouncing-ball",
    name: "Woman Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sports",
      "human",
      "female"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2640-fe0f",
        native: "⛹️‍♀️",
        x: 58,
        y: 3
      },
      {
        unified: "26f9-1f3fb-200d-2640-fe0f",
        native: "⛹🏻‍♀️",
        x: 58,
        y: 4
      },
      {
        unified: "26f9-1f3fc-200d-2640-fe0f",
        native: "⛹🏼‍♀️",
        x: 58,
        y: 5
      },
      {
        unified: "26f9-1f3fd-200d-2640-fe0f",
        native: "⛹🏽‍♀️",
        x: 58,
        y: 6
      },
      {
        unified: "26f9-1f3fe-200d-2640-fe0f",
        native: "⛹🏾‍♀️",
        x: 58,
        y: 7
      },
      {
        unified: "26f9-1f3ff-200d-2640-fe0f",
        native: "⛹🏿‍♀️",
        x: 58,
        y: 8
      }
    ],
    version: 4
  },
  weight_lifter: {
    id: "weight_lifter",
    name: "Person Lifting Weights",
    keywords: [
      "weight",
      "lifter",
      "sports",
      "training",
      "exercise"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f",
        native: "🏋️",
        x: 9,
        y: 29
      },
      {
        unified: "1f3cb-1f3fb",
        native: "🏋🏻",
        x: 9,
        y: 30
      },
      {
        unified: "1f3cb-1f3fc",
        native: "🏋🏼",
        x: 9,
        y: 31
      },
      {
        unified: "1f3cb-1f3fd",
        native: "🏋🏽",
        x: 9,
        y: 32
      },
      {
        unified: "1f3cb-1f3fe",
        native: "🏋🏾",
        x: 9,
        y: 33
      },
      {
        unified: "1f3cb-1f3ff",
        native: "🏋🏿",
        x: 9,
        y: 34
      }
    ],
    version: 1
  },
  "man-lifting-weights": {
    id: "man-lifting-weights",
    name: "Man Lifting Weights",
    keywords: [
      "lifting-weights",
      "sport"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2642-fe0f",
        native: "🏋️‍♂️",
        x: 9,
        y: 23
      },
      {
        unified: "1f3cb-1f3fb-200d-2642-fe0f",
        native: "🏋🏻‍♂️",
        x: 9,
        y: 24
      },
      {
        unified: "1f3cb-1f3fc-200d-2642-fe0f",
        native: "🏋🏼‍♂️",
        x: 9,
        y: 25
      },
      {
        unified: "1f3cb-1f3fd-200d-2642-fe0f",
        native: "🏋🏽‍♂️",
        x: 9,
        y: 26
      },
      {
        unified: "1f3cb-1f3fe-200d-2642-fe0f",
        native: "🏋🏾‍♂️",
        x: 9,
        y: 27
      },
      {
        unified: "1f3cb-1f3ff-200d-2642-fe0f",
        native: "🏋🏿‍♂️",
        x: 9,
        y: 28
      }
    ],
    version: 4
  },
  "woman-lifting-weights": {
    id: "woman-lifting-weights",
    name: "Woman Lifting Weights",
    keywords: [
      "lifting-weights",
      "sports",
      "training",
      "exercise",
      "female"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2640-fe0f",
        native: "🏋️‍♀️",
        x: 9,
        y: 17
      },
      {
        unified: "1f3cb-1f3fb-200d-2640-fe0f",
        native: "🏋🏻‍♀️",
        x: 9,
        y: 18
      },
      {
        unified: "1f3cb-1f3fc-200d-2640-fe0f",
        native: "🏋🏼‍♀️",
        x: 9,
        y: 19
      },
      {
        unified: "1f3cb-1f3fd-200d-2640-fe0f",
        native: "🏋🏽‍♀️",
        x: 9,
        y: 20
      },
      {
        unified: "1f3cb-1f3fe-200d-2640-fe0f",
        native: "🏋🏾‍♀️",
        x: 9,
        y: 21
      },
      {
        unified: "1f3cb-1f3ff-200d-2640-fe0f",
        native: "🏋🏿‍♀️",
        x: 9,
        y: 22
      }
    ],
    version: 4
  },
  bicyclist: {
    id: "bicyclist",
    name: "Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b4",
        native: "🚴",
        x: 36,
        y: 52
      },
      {
        unified: "1f6b4-1f3fb",
        native: "🚴🏻",
        x: 36,
        y: 53
      },
      {
        unified: "1f6b4-1f3fc",
        native: "🚴🏼",
        x: 36,
        y: 54
      },
      {
        unified: "1f6b4-1f3fd",
        native: "🚴🏽",
        x: 36,
        y: 55
      },
      {
        unified: "1f6b4-1f3fe",
        native: "🚴🏾",
        x: 36,
        y: 56
      },
      {
        unified: "1f6b4-1f3ff",
        native: "🚴🏿",
        x: 36,
        y: 57
      }
    ],
    version: 1
  },
  "man-biking": {
    id: "man-biking",
    name: "Man Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2642-fe0f",
        native: "🚴‍♂️",
        x: 36,
        y: 46
      },
      {
        unified: "1f6b4-1f3fb-200d-2642-fe0f",
        native: "🚴🏻‍♂️",
        x: 36,
        y: 47
      },
      {
        unified: "1f6b4-1f3fc-200d-2642-fe0f",
        native: "🚴🏼‍♂️",
        x: 36,
        y: 48
      },
      {
        unified: "1f6b4-1f3fd-200d-2642-fe0f",
        native: "🚴🏽‍♂️",
        x: 36,
        y: 49
      },
      {
        unified: "1f6b4-1f3fe-200d-2642-fe0f",
        native: "🚴🏾‍♂️",
        x: 36,
        y: 50
      },
      {
        unified: "1f6b4-1f3ff-200d-2642-fe0f",
        native: "🚴🏿‍♂️",
        x: 36,
        y: 51
      }
    ],
    version: 4
  },
  "woman-biking": {
    id: "woman-biking",
    name: "Woman Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster",
      "female"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2640-fe0f",
        native: "🚴‍♀️",
        x: 36,
        y: 40
      },
      {
        unified: "1f6b4-1f3fb-200d-2640-fe0f",
        native: "🚴🏻‍♀️",
        x: 36,
        y: 41
      },
      {
        unified: "1f6b4-1f3fc-200d-2640-fe0f",
        native: "🚴🏼‍♀️",
        x: 36,
        y: 42
      },
      {
        unified: "1f6b4-1f3fd-200d-2640-fe0f",
        native: "🚴🏽‍♀️",
        x: 36,
        y: 43
      },
      {
        unified: "1f6b4-1f3fe-200d-2640-fe0f",
        native: "🚴🏾‍♀️",
        x: 36,
        y: 44
      },
      {
        unified: "1f6b4-1f3ff-200d-2640-fe0f",
        native: "🚴🏿‍♀️",
        x: 36,
        y: 45
      }
    ],
    version: 4
  },
  mountain_bicyclist: {
    id: "mountain_bicyclist",
    name: "Mountain Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b5",
        native: "🚵",
        x: 37,
        y: 9
      },
      {
        unified: "1f6b5-1f3fb",
        native: "🚵🏻",
        x: 37,
        y: 10
      },
      {
        unified: "1f6b5-1f3fc",
        native: "🚵🏼",
        x: 37,
        y: 11
      },
      {
        unified: "1f6b5-1f3fd",
        native: "🚵🏽",
        x: 37,
        y: 12
      },
      {
        unified: "1f6b5-1f3fe",
        native: "🚵🏾",
        x: 37,
        y: 13
      },
      {
        unified: "1f6b5-1f3ff",
        native: "🚵🏿",
        x: 37,
        y: 14
      }
    ],
    version: 1
  },
  "man-mountain-biking": {
    id: "man-mountain-biking",
    name: "Man Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2642-fe0f",
        native: "🚵‍♂️",
        x: 37,
        y: 3
      },
      {
        unified: "1f6b5-1f3fb-200d-2642-fe0f",
        native: "🚵🏻‍♂️",
        x: 37,
        y: 4
      },
      {
        unified: "1f6b5-1f3fc-200d-2642-fe0f",
        native: "🚵🏼‍♂️",
        x: 37,
        y: 5
      },
      {
        unified: "1f6b5-1f3fd-200d-2642-fe0f",
        native: "🚵🏽‍♂️",
        x: 37,
        y: 6
      },
      {
        unified: "1f6b5-1f3fe-200d-2642-fe0f",
        native: "🚵🏾‍♂️",
        x: 37,
        y: 7
      },
      {
        unified: "1f6b5-1f3ff-200d-2642-fe0f",
        native: "🚵🏿‍♂️",
        x: 37,
        y: 8
      }
    ],
    version: 4
  },
  "woman-mountain-biking": {
    id: "woman-mountain-biking",
    name: "Woman Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike",
      "female"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2640-fe0f",
        native: "🚵‍♀️",
        x: 36,
        y: 58
      },
      {
        unified: "1f6b5-1f3fb-200d-2640-fe0f",
        native: "🚵🏻‍♀️",
        x: 36,
        y: 59
      },
      {
        unified: "1f6b5-1f3fc-200d-2640-fe0f",
        native: "🚵🏼‍♀️",
        x: 36,
        y: 60
      },
      {
        unified: "1f6b5-1f3fd-200d-2640-fe0f",
        native: "🚵🏽‍♀️",
        x: 37,
        y: 0
      },
      {
        unified: "1f6b5-1f3fe-200d-2640-fe0f",
        native: "🚵🏾‍♀️",
        x: 37,
        y: 1
      },
      {
        unified: "1f6b5-1f3ff-200d-2640-fe0f",
        native: "🚵🏿‍♀️",
        x: 37,
        y: 2
      }
    ],
    version: 4
  },
  person_doing_cartwheel: {
    id: "person_doing_cartwheel",
    name: "Person Cartwheeling",
    keywords: [
      "doing",
      "cartwheel",
      "sport",
      "gymnastic"
    ],
    skins: [
      {
        unified: "1f938",
        native: "🤸",
        x: 42,
        y: 7
      },
      {
        unified: "1f938-1f3fb",
        native: "🤸🏻",
        x: 42,
        y: 8
      },
      {
        unified: "1f938-1f3fc",
        native: "🤸🏼",
        x: 42,
        y: 9
      },
      {
        unified: "1f938-1f3fd",
        native: "🤸🏽",
        x: 42,
        y: 10
      },
      {
        unified: "1f938-1f3fe",
        native: "🤸🏾",
        x: 42,
        y: 11
      },
      {
        unified: "1f938-1f3ff",
        native: "🤸🏿",
        x: 42,
        y: 12
      }
    ],
    version: 3
  },
  "man-cartwheeling": {
    id: "man-cartwheeling",
    name: "Man Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2642-fe0f",
        native: "🤸‍♂️",
        x: 42,
        y: 1
      },
      {
        unified: "1f938-1f3fb-200d-2642-fe0f",
        native: "🤸🏻‍♂️",
        x: 42,
        y: 2
      },
      {
        unified: "1f938-1f3fc-200d-2642-fe0f",
        native: "🤸🏼‍♂️",
        x: 42,
        y: 3
      },
      {
        unified: "1f938-1f3fd-200d-2642-fe0f",
        native: "🤸🏽‍♂️",
        x: 42,
        y: 4
      },
      {
        unified: "1f938-1f3fe-200d-2642-fe0f",
        native: "🤸🏾‍♂️",
        x: 42,
        y: 5
      },
      {
        unified: "1f938-1f3ff-200d-2642-fe0f",
        native: "🤸🏿‍♂️",
        x: 42,
        y: 6
      }
    ],
    version: 4
  },
  "woman-cartwheeling": {
    id: "woman-cartwheeling",
    name: "Woman Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2640-fe0f",
        native: "🤸‍♀️",
        x: 41,
        y: 56
      },
      {
        unified: "1f938-1f3fb-200d-2640-fe0f",
        native: "🤸🏻‍♀️",
        x: 41,
        y: 57
      },
      {
        unified: "1f938-1f3fc-200d-2640-fe0f",
        native: "🤸🏼‍♀️",
        x: 41,
        y: 58
      },
      {
        unified: "1f938-1f3fd-200d-2640-fe0f",
        native: "🤸🏽‍♀️",
        x: 41,
        y: 59
      },
      {
        unified: "1f938-1f3fe-200d-2640-fe0f",
        native: "🤸🏾‍♀️",
        x: 41,
        y: 60
      },
      {
        unified: "1f938-1f3ff-200d-2640-fe0f",
        native: "🤸🏿‍♀️",
        x: 42,
        y: 0
      }
    ],
    version: 4
  },
  wrestlers: {
    id: "wrestlers",
    name: "Wrestlers",
    keywords: [
      "people",
      "wrestling",
      "sport"
    ],
    skins: [
      {
        unified: "1f93c",
        native: "🤼",
        x: 42,
        y: 34
      }
    ],
    version: 3
  },
  "man-wrestling": {
    id: "man-wrestling",
    name: "Men Wrestling",
    keywords: [
      "man",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2642-fe0f",
        native: "🤼‍♂️",
        x: 42,
        y: 33
      }
    ],
    version: 4
  },
  "woman-wrestling": {
    id: "woman-wrestling",
    name: "Women Wrestling",
    keywords: [
      "woman",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2640-fe0f",
        native: "🤼‍♀️",
        x: 42,
        y: 32
      }
    ],
    version: 4
  },
  water_polo: {
    id: "water_polo",
    name: "Water Polo",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93d",
        native: "🤽",
        x: 42,
        y: 47
      },
      {
        unified: "1f93d-1f3fb",
        native: "🤽🏻",
        x: 42,
        y: 48
      },
      {
        unified: "1f93d-1f3fc",
        native: "🤽🏼",
        x: 42,
        y: 49
      },
      {
        unified: "1f93d-1f3fd",
        native: "🤽🏽",
        x: 42,
        y: 50
      },
      {
        unified: "1f93d-1f3fe",
        native: "🤽🏾",
        x: 42,
        y: 51
      },
      {
        unified: "1f93d-1f3ff",
        native: "🤽🏿",
        x: 42,
        y: 52
      }
    ],
    version: 3
  },
  "man-playing-water-polo": {
    id: "man-playing-water-polo",
    name: "Man Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2642-fe0f",
        native: "🤽‍♂️",
        x: 42,
        y: 41
      },
      {
        unified: "1f93d-1f3fb-200d-2642-fe0f",
        native: "🤽🏻‍♂️",
        x: 42,
        y: 42
      },
      {
        unified: "1f93d-1f3fc-200d-2642-fe0f",
        native: "🤽🏼‍♂️",
        x: 42,
        y: 43
      },
      {
        unified: "1f93d-1f3fd-200d-2642-fe0f",
        native: "🤽🏽‍♂️",
        x: 42,
        y: 44
      },
      {
        unified: "1f93d-1f3fe-200d-2642-fe0f",
        native: "🤽🏾‍♂️",
        x: 42,
        y: 45
      },
      {
        unified: "1f93d-1f3ff-200d-2642-fe0f",
        native: "🤽🏿‍♂️",
        x: 42,
        y: 46
      }
    ],
    version: 4
  },
  "woman-playing-water-polo": {
    id: "woman-playing-water-polo",
    name: "Woman Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2640-fe0f",
        native: "🤽‍♀️",
        x: 42,
        y: 35
      },
      {
        unified: "1f93d-1f3fb-200d-2640-fe0f",
        native: "🤽🏻‍♀️",
        x: 42,
        y: 36
      },
      {
        unified: "1f93d-1f3fc-200d-2640-fe0f",
        native: "🤽🏼‍♀️",
        x: 42,
        y: 37
      },
      {
        unified: "1f93d-1f3fd-200d-2640-fe0f",
        native: "🤽🏽‍♀️",
        x: 42,
        y: 38
      },
      {
        unified: "1f93d-1f3fe-200d-2640-fe0f",
        native: "🤽🏾‍♀️",
        x: 42,
        y: 39
      },
      {
        unified: "1f93d-1f3ff-200d-2640-fe0f",
        native: "🤽🏿‍♀️",
        x: 42,
        y: 40
      }
    ],
    version: 4
  },
  handball: {
    id: "handball",
    name: "Handball",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93e",
        native: "🤾",
        x: 43,
        y: 4
      },
      {
        unified: "1f93e-1f3fb",
        native: "🤾🏻",
        x: 43,
        y: 5
      },
      {
        unified: "1f93e-1f3fc",
        native: "🤾🏼",
        x: 43,
        y: 6
      },
      {
        unified: "1f93e-1f3fd",
        native: "🤾🏽",
        x: 43,
        y: 7
      },
      {
        unified: "1f93e-1f3fe",
        native: "🤾🏾",
        x: 43,
        y: 8
      },
      {
        unified: "1f93e-1f3ff",
        native: "🤾🏿",
        x: 43,
        y: 9
      }
    ],
    version: 3
  },
  "man-playing-handball": {
    id: "man-playing-handball",
    name: "Man Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2642-fe0f",
        native: "🤾‍♂️",
        x: 42,
        y: 59
      },
      {
        unified: "1f93e-1f3fb-200d-2642-fe0f",
        native: "🤾🏻‍♂️",
        x: 42,
        y: 60
      },
      {
        unified: "1f93e-1f3fc-200d-2642-fe0f",
        native: "🤾🏼‍♂️",
        x: 43,
        y: 0
      },
      {
        unified: "1f93e-1f3fd-200d-2642-fe0f",
        native: "🤾🏽‍♂️",
        x: 43,
        y: 1
      },
      {
        unified: "1f93e-1f3fe-200d-2642-fe0f",
        native: "🤾🏾‍♂️",
        x: 43,
        y: 2
      },
      {
        unified: "1f93e-1f3ff-200d-2642-fe0f",
        native: "🤾🏿‍♂️",
        x: 43,
        y: 3
      }
    ],
    version: 4
  },
  "woman-playing-handball": {
    id: "woman-playing-handball",
    name: "Woman Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2640-fe0f",
        native: "🤾‍♀️",
        x: 42,
        y: 53
      },
      {
        unified: "1f93e-1f3fb-200d-2640-fe0f",
        native: "🤾🏻‍♀️",
        x: 42,
        y: 54
      },
      {
        unified: "1f93e-1f3fc-200d-2640-fe0f",
        native: "🤾🏼‍♀️",
        x: 42,
        y: 55
      },
      {
        unified: "1f93e-1f3fd-200d-2640-fe0f",
        native: "🤾🏽‍♀️",
        x: 42,
        y: 56
      },
      {
        unified: "1f93e-1f3fe-200d-2640-fe0f",
        native: "🤾🏾‍♀️",
        x: 42,
        y: 57
      },
      {
        unified: "1f93e-1f3ff-200d-2640-fe0f",
        native: "🤾🏿‍♀️",
        x: 42,
        y: 58
      }
    ],
    version: 4
  },
  juggling: {
    id: "juggling",
    name: "Juggling",
    keywords: [
      "person",
      "performance",
      "balance"
    ],
    skins: [
      {
        unified: "1f939",
        native: "🤹",
        x: 42,
        y: 25
      },
      {
        unified: "1f939-1f3fb",
        native: "🤹🏻",
        x: 42,
        y: 26
      },
      {
        unified: "1f939-1f3fc",
        native: "🤹🏼",
        x: 42,
        y: 27
      },
      {
        unified: "1f939-1f3fd",
        native: "🤹🏽",
        x: 42,
        y: 28
      },
      {
        unified: "1f939-1f3fe",
        native: "🤹🏾",
        x: 42,
        y: 29
      },
      {
        unified: "1f939-1f3ff",
        native: "🤹🏿",
        x: 42,
        y: 30
      }
    ],
    version: 3
  },
  "man-juggling": {
    id: "man-juggling",
    name: "Man Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2642-fe0f",
        native: "🤹‍♂️",
        x: 42,
        y: 19
      },
      {
        unified: "1f939-1f3fb-200d-2642-fe0f",
        native: "🤹🏻‍♂️",
        x: 42,
        y: 20
      },
      {
        unified: "1f939-1f3fc-200d-2642-fe0f",
        native: "🤹🏼‍♂️",
        x: 42,
        y: 21
      },
      {
        unified: "1f939-1f3fd-200d-2642-fe0f",
        native: "🤹🏽‍♂️",
        x: 42,
        y: 22
      },
      {
        unified: "1f939-1f3fe-200d-2642-fe0f",
        native: "🤹🏾‍♂️",
        x: 42,
        y: 23
      },
      {
        unified: "1f939-1f3ff-200d-2642-fe0f",
        native: "🤹🏿‍♂️",
        x: 42,
        y: 24
      }
    ],
    version: 4
  },
  "woman-juggling": {
    id: "woman-juggling",
    name: "Woman Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2640-fe0f",
        native: "🤹‍♀️",
        x: 42,
        y: 13
      },
      {
        unified: "1f939-1f3fb-200d-2640-fe0f",
        native: "🤹🏻‍♀️",
        x: 42,
        y: 14
      },
      {
        unified: "1f939-1f3fc-200d-2640-fe0f",
        native: "🤹🏼‍♀️",
        x: 42,
        y: 15
      },
      {
        unified: "1f939-1f3fd-200d-2640-fe0f",
        native: "🤹🏽‍♀️",
        x: 42,
        y: 16
      },
      {
        unified: "1f939-1f3fe-200d-2640-fe0f",
        native: "🤹🏾‍♀️",
        x: 42,
        y: 17
      },
      {
        unified: "1f939-1f3ff-200d-2640-fe0f",
        native: "🤹🏿‍♀️",
        x: 42,
        y: 18
      }
    ],
    version: 4
  },
  person_in_lotus_position: {
    id: "person_in_lotus_position",
    name: "Person in Lotus Position",
    keywords: [
      "meditate"
    ],
    skins: [
      {
        unified: "1f9d8",
        native: "🧘",
        x: 51,
        y: 34
      },
      {
        unified: "1f9d8-1f3fb",
        native: "🧘🏻",
        x: 51,
        y: 35
      },
      {
        unified: "1f9d8-1f3fc",
        native: "🧘🏼",
        x: 51,
        y: 36
      },
      {
        unified: "1f9d8-1f3fd",
        native: "🧘🏽",
        x: 51,
        y: 37
      },
      {
        unified: "1f9d8-1f3fe",
        native: "🧘🏾",
        x: 51,
        y: 38
      },
      {
        unified: "1f9d8-1f3ff",
        native: "🧘🏿",
        x: 51,
        y: 39
      }
    ],
    version: 5
  },
  man_in_lotus_position: {
    id: "man_in_lotus_position",
    name: "Man in Lotus Position",
    keywords: [
      "male",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2642-fe0f",
        native: "🧘‍♂️",
        x: 51,
        y: 28
      },
      {
        unified: "1f9d8-1f3fb-200d-2642-fe0f",
        native: "🧘🏻‍♂️",
        x: 51,
        y: 29
      },
      {
        unified: "1f9d8-1f3fc-200d-2642-fe0f",
        native: "🧘🏼‍♂️",
        x: 51,
        y: 30
      },
      {
        unified: "1f9d8-1f3fd-200d-2642-fe0f",
        native: "🧘🏽‍♂️",
        x: 51,
        y: 31
      },
      {
        unified: "1f9d8-1f3fe-200d-2642-fe0f",
        native: "🧘🏾‍♂️",
        x: 51,
        y: 32
      },
      {
        unified: "1f9d8-1f3ff-200d-2642-fe0f",
        native: "🧘🏿‍♂️",
        x: 51,
        y: 33
      }
    ],
    version: 5
  },
  woman_in_lotus_position: {
    id: "woman_in_lotus_position",
    name: "Woman in Lotus Position",
    keywords: [
      "female",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2640-fe0f",
        native: "🧘‍♀️",
        x: 51,
        y: 22
      },
      {
        unified: "1f9d8-1f3fb-200d-2640-fe0f",
        native: "🧘🏻‍♀️",
        x: 51,
        y: 23
      },
      {
        unified: "1f9d8-1f3fc-200d-2640-fe0f",
        native: "🧘🏼‍♀️",
        x: 51,
        y: 24
      },
      {
        unified: "1f9d8-1f3fd-200d-2640-fe0f",
        native: "🧘🏽‍♀️",
        x: 51,
        y: 25
      },
      {
        unified: "1f9d8-1f3fe-200d-2640-fe0f",
        native: "🧘🏾‍♀️",
        x: 51,
        y: 26
      },
      {
        unified: "1f9d8-1f3ff-200d-2640-fe0f",
        native: "🧘🏿‍♀️",
        x: 51,
        y: 27
      }
    ],
    version: 5
  },
  bath: {
    id: "bath",
    name: "Bath",
    keywords: [
      "person",
      "taking",
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c0",
        native: "🛀",
        x: 37,
        y: 42
      },
      {
        unified: "1f6c0-1f3fb",
        native: "🛀🏻",
        x: 37,
        y: 43
      },
      {
        unified: "1f6c0-1f3fc",
        native: "🛀🏼",
        x: 37,
        y: 44
      },
      {
        unified: "1f6c0-1f3fd",
        native: "🛀🏽",
        x: 37,
        y: 45
      },
      {
        unified: "1f6c0-1f3fe",
        native: "🛀🏾",
        x: 37,
        y: 46
      },
      {
        unified: "1f6c0-1f3ff",
        native: "🛀🏿",
        x: 37,
        y: 47
      }
    ],
    version: 1
  },
  sleeping_accommodation: {
    id: "sleeping_accommodation",
    name: "Person in Bed",
    keywords: [
      "sleeping",
      "accommodation",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cc",
        native: "🛌",
        x: 37,
        y: 54
      },
      {
        unified: "1f6cc-1f3fb",
        native: "🛌🏻",
        x: 37,
        y: 55
      },
      {
        unified: "1f6cc-1f3fc",
        native: "🛌🏼",
        x: 37,
        y: 56
      },
      {
        unified: "1f6cc-1f3fd",
        native: "🛌🏽",
        x: 37,
        y: 57
      },
      {
        unified: "1f6cc-1f3fe",
        native: "🛌🏾",
        x: 37,
        y: 58
      },
      {
        unified: "1f6cc-1f3ff",
        native: "🛌🏿",
        x: 37,
        y: 59
      }
    ],
    version: 1
  },
  people_holding_hands: {
    id: "people_holding_hands",
    name: "People Holding Hands",
    keywords: [
      "friendship"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f91d-200d-1f9d1",
        native: "🧑‍🤝‍🧑",
        x: 48,
        y: 41
      },
      {
        unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        native: "🧑🏻‍🤝‍🧑🏻",
        x: 48,
        y: 42
      },
      {
        unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        native: "🧑🏼‍🤝‍🧑🏼",
        x: 48,
        y: 48
      },
      {
        unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        native: "🧑🏽‍🤝‍🧑🏽",
        x: 48,
        y: 54
      },
      {
        unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        native: "🧑🏾‍🤝‍🧑🏾",
        x: 48,
        y: 60
      },
      {
        unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
        native: "🧑🏿‍🤝‍🧑🏿",
        x: 49,
        y: 5
      }
    ],
    version: 12
  },
  two_women_holding_hands: {
    id: "two_women_holding_hands",
    name: "Women Holding Hands",
    keywords: [
      "two",
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46d",
        native: "👭",
        x: 22,
        y: 31
      },
      {
        unified: "1f46d-1f3fb",
        native: "👭🏻",
        x: 22,
        y: 32
      },
      {
        unified: "1f46d-1f3fc",
        native: "👭🏼",
        x: 22,
        y: 33
      },
      {
        unified: "1f46d-1f3fd",
        native: "👭🏽",
        x: 22,
        y: 34
      },
      {
        unified: "1f46d-1f3fe",
        native: "👭🏾",
        x: 22,
        y: 35
      },
      {
        unified: "1f46d-1f3ff",
        native: "👭🏿",
        x: 22,
        y: 36
      }
    ],
    version: 1
  },
  man_and_woman_holding_hands: {
    id: "man_and_woman_holding_hands",
    name: "Man and Woman Holding Hands",
    keywords: [
      "couple",
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f46b",
        native: "👫",
        x: 21,
        y: 40
      },
      {
        unified: "1f46b-1f3fb",
        native: "👫🏻",
        x: 21,
        y: 41
      },
      {
        unified: "1f46b-1f3fc",
        native: "👫🏼",
        x: 21,
        y: 42
      },
      {
        unified: "1f46b-1f3fd",
        native: "👫🏽",
        x: 21,
        y: 43
      },
      {
        unified: "1f46b-1f3fe",
        native: "👫🏾",
        x: 21,
        y: 44
      },
      {
        unified: "1f46b-1f3ff",
        native: "👫🏿",
        x: 21,
        y: 45
      }
    ],
    version: 1
  },
  two_men_holding_hands: {
    id: "two_men_holding_hands",
    name: "Men Holding Hands",
    keywords: [
      "two",
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46c",
        native: "👬",
        x: 22,
        y: 5
      },
      {
        unified: "1f46c-1f3fb",
        native: "👬🏻",
        x: 22,
        y: 6
      },
      {
        unified: "1f46c-1f3fc",
        native: "👬🏼",
        x: 22,
        y: 7
      },
      {
        unified: "1f46c-1f3fd",
        native: "👬🏽",
        x: 22,
        y: 8
      },
      {
        unified: "1f46c-1f3fe",
        native: "👬🏾",
        x: 22,
        y: 9
      },
      {
        unified: "1f46c-1f3ff",
        native: "👬🏿",
        x: 22,
        y: 10
      }
    ],
    version: 1
  },
  couplekiss: {
    id: "couplekiss",
    name: "Kiss",
    keywords: [
      "couplekiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f48f",
        native: "💏",
        x: 26,
        y: 41
      },
      {
        unified: "1f48f-1f3fb",
        native: "💏🏻",
        x: 26,
        y: 42
      },
      {
        unified: "1f48f-1f3fc",
        native: "💏🏼",
        x: 26,
        y: 43
      },
      {
        unified: "1f48f-1f3fd",
        native: "💏🏽",
        x: 26,
        y: 44
      },
      {
        unified: "1f48f-1f3fe",
        native: "💏🏾",
        x: 26,
        y: 45
      },
      {
        unified: "1f48f-1f3ff",
        native: "💏🏿",
        x: 26,
        y: 46
      }
    ],
    version: 1
  },
  "woman-kiss-man": {
    id: "woman-kiss-man",
    name: "Kiss: Woman, Man",
    keywords: [
      "woman",
      "kiss-man",
      "kiss",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👩‍❤️‍💋‍👨",
        x: 20,
        y: 42
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍💋‍👨🏻",
        x: 20,
        y: 43
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍💋‍👨🏼",
        x: 20,
        y: 49
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍💋‍👨🏽",
        x: 20,
        y: 55
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍💋‍👨🏾",
        x: 21,
        y: 0
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍💋‍👨🏿",
        x: 21,
        y: 6
      }
    ],
    version: 2
  },
  "man-kiss-man": {
    id: "man-kiss-man",
    name: "Kiss: Man, Man",
    keywords: [
      "kiss-man",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👨‍❤️‍💋‍👨",
        x: 16,
        y: 48
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍💋‍👨🏻",
        x: 16,
        y: 49
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍💋‍👨🏼",
        x: 16,
        y: 55
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍💋‍👨🏽",
        x: 17,
        y: 0
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍💋‍👨🏾",
        x: 17,
        y: 6
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍💋‍👨🏿",
        x: 17,
        y: 12
      }
    ],
    version: 2
  },
  "woman-kiss-woman": {
    id: "woman-kiss-woman",
    name: "Kiss: Woman, Woman",
    keywords: [
      "kiss-woman",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        native: "👩‍❤️‍💋‍👩",
        x: 21,
        y: 7
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍💋‍👩🏻",
        x: 21,
        y: 8
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍💋‍👩🏼",
        x: 21,
        y: 14
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍💋‍👩🏽",
        x: 21,
        y: 20
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍💋‍👩🏾",
        x: 21,
        y: 26
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍💋‍👩🏿",
        x: 21,
        y: 32
      }
    ],
    version: 2
  },
  couple_with_heart: {
    id: "couple_with_heart",
    name: "Couple with Heart",
    keywords: [
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f491",
        native: "💑",
        x: 27,
        y: 7
      },
      {
        unified: "1f491-1f3fb",
        native: "💑🏻",
        x: 27,
        y: 8
      },
      {
        unified: "1f491-1f3fc",
        native: "💑🏼",
        x: 27,
        y: 9
      },
      {
        unified: "1f491-1f3fd",
        native: "💑🏽",
        x: 27,
        y: 10
      },
      {
        unified: "1f491-1f3fe",
        native: "💑🏾",
        x: 27,
        y: 11
      },
      {
        unified: "1f491-1f3ff",
        native: "💑🏿",
        x: 27,
        y: 12
      }
    ],
    version: 1
  },
  "woman-heart-man": {
    id: "woman-heart-man",
    name: "Couple with Heart: Woman, Man",
    keywords: [
      "woman",
      "heart-man",
      "heart",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f468",
        native: "👩‍❤️‍👨",
        x: 19,
        y: 51
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍👨🏻",
        x: 19,
        y: 52
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍👨🏼",
        x: 19,
        y: 58
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍👨🏽",
        x: 20,
        y: 3
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍👨🏾",
        x: 20,
        y: 9
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍👨🏿",
        x: 20,
        y: 15
      }
    ],
    version: 2
  },
  "man-heart-man": {
    id: "man-heart-man",
    name: "Couple with Heart: Man, Man",
    keywords: [
      "heart-man",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f468",
        native: "👨‍❤️‍👨",
        x: 16,
        y: 22
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍👨🏻",
        x: 16,
        y: 23
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍👨🏼",
        x: 16,
        y: 29
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍👨🏽",
        x: 16,
        y: 35
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍👨🏾",
        x: 16,
        y: 41
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍👨🏿",
        x: 16,
        y: 47
      }
    ],
    version: 2
  },
  "woman-heart-woman": {
    id: "woman-heart-woman",
    name: "Couple with Heart: Woman, Woman",
    keywords: [
      "heart-woman",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f469",
        native: "👩‍❤️‍👩",
        x: 20,
        y: 16
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍👩🏻",
        x: 20,
        y: 17
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍👩🏼",
        x: 20,
        y: 23
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍👩🏽",
        x: 20,
        y: 29
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍👩🏾",
        x: 20,
        y: 35
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍👩🏿",
        x: 20,
        y: 41
      }
    ],
    version: 2
  },
  family: {
    id: "family",
    name: "Family",
    keywords: [
      "home",
      "parents",
      "child",
      "mom",
      "dad",
      "father",
      "mother",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46a",
        native: "👪",
        x: 21,
        y: 39
      }
    ],
    version: 1
  },
  "man-woman-boy": {
    id: "man-woman-boy",
    name: "Family: Man, Woman, Boy",
    keywords: [
      "man",
      "woman-boy",
      "family",
      "woman",
      "love"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466",
        native: "👨‍👩‍👦",
        x: 14,
        y: 43
      }
    ],
    version: 2
  },
  "man-woman-girl": {
    id: "man-woman-girl",
    name: "Family: Man, Woman, Girl",
    keywords: [
      "man",
      "woman-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467",
        native: "👨‍👩‍👧",
        x: 14,
        y: 45
      }
    ],
    version: 2
  },
  "man-woman-girl-boy": {
    id: "man-woman-girl-boy",
    name: "Family: Man, Woman, Girl, Boy",
    keywords: [
      "man",
      "woman-girl-boy",
      "family",
      "woman",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
        native: "👨‍👩‍👧‍👦",
        x: 14,
        y: 46
      }
    ],
    version: 2
  },
  "man-woman-boy-boy": {
    id: "man-woman-boy-boy",
    name: "Family: Man, Woman, Boy, Boy",
    keywords: [
      "man",
      "woman-boy-boy",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
        native: "👨‍👩‍👦‍👦",
        x: 14,
        y: 44
      }
    ],
    version: 2
  },
  "man-woman-girl-girl": {
    id: "man-woman-girl-girl",
    name: "Family: Man, Woman, Girl, Girl",
    keywords: [
      "man",
      "woman-girl-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
        native: "👨‍👩‍👧‍👧",
        x: 14,
        y: 47
      }
    ],
    version: 2
  },
  "man-man-boy": {
    id: "man-man-boy",
    name: "Family: Man, Man, Boy",
    keywords: [
      "man",
      "man-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466",
        native: "👨‍👨‍👦",
        x: 14,
        y: 38
      }
    ],
    version: 2
  },
  "man-man-girl": {
    id: "man-man-girl",
    name: "Family: Man, Man, Girl",
    keywords: [
      "man",
      "man-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467",
        native: "👨‍👨‍👧",
        x: 14,
        y: 40
      }
    ],
    version: 2
  },
  "man-man-girl-boy": {
    id: "man-man-girl-boy",
    name: "Family: Man, Man, Girl, Boy",
    keywords: [
      "man",
      "man-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
        native: "👨‍👨‍👧‍👦",
        x: 14,
        y: 41
      }
    ],
    version: 2
  },
  "man-man-boy-boy": {
    id: "man-man-boy-boy",
    name: "Family: Man, Man, Boy, Boy",
    keywords: [
      "man",
      "man-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
        native: "👨‍👨‍👦‍👦",
        x: 14,
        y: 39
      }
    ],
    version: 2
  },
  "man-man-girl-girl": {
    id: "man-man-girl-girl",
    name: "Family: Man, Man, Girl, Girl",
    keywords: [
      "man",
      "man-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
        native: "👨‍👨‍👧‍👧",
        x: 14,
        y: 42
      }
    ],
    version: 2
  },
  "woman-woman-boy": {
    id: "woman-woman-boy",
    name: "Family: Woman, Woman, Boy",
    keywords: [
      "woman",
      "woman-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466",
        native: "👩‍👩‍👦",
        x: 18,
        y: 11
      }
    ],
    version: 2
  },
  "woman-woman-girl": {
    id: "woman-woman-girl",
    name: "Family: Woman, Woman, Girl",
    keywords: [
      "woman",
      "woman-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467",
        native: "👩‍👩‍👧",
        x: 18,
        y: 13
      }
    ],
    version: 2
  },
  "woman-woman-girl-boy": {
    id: "woman-woman-girl-boy",
    name: "Family: Woman, Woman, Girl, Boy",
    keywords: [
      "woman",
      "woman-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
        native: "👩‍👩‍👧‍👦",
        x: 18,
        y: 14
      }
    ],
    version: 2
  },
  "woman-woman-boy-boy": {
    id: "woman-woman-boy-boy",
    name: "Family: Woman, Woman, Boy, Boy",
    keywords: [
      "woman",
      "woman-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
        native: "👩‍👩‍👦‍👦",
        x: 18,
        y: 12
      }
    ],
    version: 2
  },
  "woman-woman-girl-girl": {
    id: "woman-woman-girl-girl",
    name: "Family: Woman, Woman, Girl, Girl",
    keywords: [
      "woman",
      "woman-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
        native: "👩‍👩‍👧‍👧",
        x: 18,
        y: 15
      }
    ],
    version: 2
  },
  "man-boy": {
    id: "man-boy",
    name: "Family: Man, Boy",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466",
        native: "👨‍👦",
        x: 14,
        y: 34
      }
    ],
    version: 4
  },
  "man-boy-boy": {
    id: "man-boy-boy",
    name: "Family: Man, Boy, Boy",
    keywords: [
      "man",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466-200d-1f466",
        native: "👨‍👦‍👦",
        x: 14,
        y: 33
      }
    ],
    version: 4
  },
  "man-girl": {
    id: "man-girl",
    name: "Family: Man, Girl",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467",
        native: "👨‍👧",
        x: 14,
        y: 37
      }
    ],
    version: 4
  },
  "man-girl-boy": {
    id: "man-girl-boy",
    name: "Family: Man, Girl, Boy",
    keywords: [
      "man",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f466",
        native: "👨‍👧‍👦",
        x: 14,
        y: 35
      }
    ],
    version: 4
  },
  "man-girl-girl": {
    id: "man-girl-girl",
    name: "Family: Man, Girl, Girl",
    keywords: [
      "man",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f467",
        native: "👨‍👧‍👧",
        x: 14,
        y: 36
      }
    ],
    version: 4
  },
  "woman-boy": {
    id: "woman-boy",
    name: "Family: Woman, Boy",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466",
        native: "👩‍👦",
        x: 18,
        y: 7
      }
    ],
    version: 4
  },
  "woman-boy-boy": {
    id: "woman-boy-boy",
    name: "Family: Woman, Boy, Boy",
    keywords: [
      "woman",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466-200d-1f466",
        native: "👩‍👦‍👦",
        x: 18,
        y: 6
      }
    ],
    version: 4
  },
  "woman-girl": {
    id: "woman-girl",
    name: "Family: Woman, Girl",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467",
        native: "👩‍👧",
        x: 18,
        y: 10
      }
    ],
    version: 4
  },
  "woman-girl-boy": {
    id: "woman-girl-boy",
    name: "Family: Woman, Girl, Boy",
    keywords: [
      "woman",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f466",
        native: "👩‍👧‍👦",
        x: 18,
        y: 8
      }
    ],
    version: 4
  },
  "woman-girl-girl": {
    id: "woman-girl-girl",
    name: "Family: Woman, Girl, Girl",
    keywords: [
      "woman",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f467",
        native: "👩‍👧‍👧",
        x: 18,
        y: 9
      }
    ],
    version: 4
  },
  speaking_head_in_silhouette: {
    id: "speaking_head_in_silhouette",
    name: "Speaking Head",
    keywords: [
      "in",
      "silhouette",
      "user",
      "person",
      "human",
      "sing",
      "say",
      "talk"
    ],
    skins: [
      {
        unified: "1f5e3-fe0f",
        native: "🗣️",
        x: 32,
        y: 10
      }
    ],
    version: 1
  },
  bust_in_silhouette: {
    id: "bust_in_silhouette",
    name: "Bust in Silhouette",
    keywords: [
      "user",
      "person",
      "human"
    ],
    skins: [
      {
        unified: "1f464",
        native: "👤",
        x: 13,
        y: 32
      }
    ],
    version: 1
  },
  busts_in_silhouette: {
    id: "busts_in_silhouette",
    name: "Busts in Silhouette",
    keywords: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    skins: [
      {
        unified: "1f465",
        native: "👥",
        x: 13,
        y: 33
      }
    ],
    version: 1
  },
  people_hugging: {
    id: "people_hugging",
    name: "People Hugging",
    keywords: [
      "care"
    ],
    skins: [
      {
        unified: "1fac2",
        native: "🫂",
        x: 54,
        y: 44
      }
    ],
    version: 13
  },
  footprints: {
    id: "footprints",
    name: "Footprints",
    keywords: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    skins: [
      {
        unified: "1f463",
        native: "👣",
        x: 13,
        y: 31
      }
    ],
    version: 1
  },
  monkey_face: {
    id: "monkey_face",
    name: "Monkey Face",
    emoticons: [
      ":o)"
    ],
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f435",
        native: "🐵",
        x: 11,
        y: 40
      }
    ],
    version: 1
  },
  monkey: {
    id: "monkey",
    name: "Monkey",
    keywords: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    skins: [
      {
        unified: "1f412",
        native: "🐒",
        x: 11,
        y: 4
      }
    ],
    version: 1
  },
  gorilla: {
    id: "gorilla",
    name: "Gorilla",
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f98d",
        native: "🦍",
        x: 44,
        y: 31
      }
    ],
    version: 3
  },
  orangutan: {
    id: "orangutan",
    name: "Orangutan",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a7",
        native: "🦧",
        x: 44,
        y: 57
      }
    ],
    version: 12
  },
  dog: {
    id: "dog",
    name: "Dog Face",
    keywords: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f436",
        native: "🐶",
        x: 11,
        y: 41
      }
    ],
    version: 1
  },
  dog2: {
    id: "dog2",
    name: "Dog",
    keywords: [
      "dog2",
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f415",
        native: "🐕",
        x: 11,
        y: 8
      }
    ],
    version: 1
  },
  guide_dog: {
    id: "guide_dog",
    name: "Guide Dog",
    keywords: [
      "animal",
      "blind"
    ],
    skins: [
      {
        unified: "1f9ae",
        native: "🦮",
        x: 45,
        y: 3
      }
    ],
    version: 12
  },
  service_dog: {
    id: "service_dog",
    name: "Service Dog",
    keywords: [
      "blind",
      "animal"
    ],
    skins: [
      {
        unified: "1f415-200d-1f9ba",
        native: "🐕‍🦺",
        x: 11,
        y: 7
      }
    ],
    version: 12
  },
  poodle: {
    id: "poodle",
    name: "Poodle",
    keywords: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    skins: [
      {
        unified: "1f429",
        native: "🐩",
        x: 11,
        y: 28
      }
    ],
    version: 1
  },
  wolf: {
    id: "wolf",
    name: "Wolf",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43a",
        native: "🐺",
        x: 11,
        y: 45
      }
    ],
    version: 1
  },
  fox_face: {
    id: "fox_face",
    name: "Fox",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f98a",
        native: "🦊",
        x: 44,
        y: 28
      }
    ],
    version: 3
  },
  raccoon: {
    id: "raccoon",
    name: "Raccoon",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99d",
        native: "🦝",
        x: 44,
        y: 47
      }
    ],
    version: 11
  },
  cat: {
    id: "cat",
    name: "Cat Face",
    keywords: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    skins: [
      {
        unified: "1f431",
        native: "🐱",
        x: 11,
        y: 36
      }
    ],
    version: 1
  },
  cat2: {
    id: "cat2",
    name: "Cat",
    keywords: [
      "cat2",
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    skins: [
      {
        unified: "1f408",
        native: "🐈",
        x: 10,
        y: 55
      }
    ],
    version: 1
  },
  black_cat: {
    id: "black_cat",
    name: "Black Cat",
    keywords: [
      "superstition",
      "luck"
    ],
    skins: [
      {
        unified: "1f408-200d-2b1b",
        native: "🐈‍⬛",
        x: 10,
        y: 54
      }
    ],
    version: 13
  },
  lion_face: {
    id: "lion_face",
    name: "Lion",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f981",
        native: "🦁",
        x: 44,
        y: 19
      }
    ],
    version: 1
  },
  tiger: {
    id: "tiger",
    name: "Tiger Face",
    keywords: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f42f",
        native: "🐯",
        x: 11,
        y: 34
      }
    ],
    version: 1
  },
  tiger2: {
    id: "tiger2",
    name: "Tiger",
    keywords: [
      "tiger2",
      "animal",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f405",
        native: "🐅",
        x: 10,
        y: 51
      }
    ],
    version: 1
  },
  leopard: {
    id: "leopard",
    name: "Leopard",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f406",
        native: "🐆",
        x: 10,
        y: 52
      }
    ],
    version: 1
  },
  horse: {
    id: "horse",
    name: "Horse Face",
    keywords: [
      "animal",
      "brown",
      "nature"
    ],
    skins: [
      {
        unified: "1f434",
        native: "🐴",
        x: 11,
        y: 39
      }
    ],
    version: 1
  },
  racehorse: {
    id: "racehorse",
    name: "Horse",
    keywords: [
      "racehorse",
      "animal",
      "gamble",
      "luck"
    ],
    skins: [
      {
        unified: "1f40e",
        native: "🐎",
        x: 11,
        y: 0
      }
    ],
    version: 1
  },
  unicorn_face: {
    id: "unicorn_face",
    name: "Unicorn",
    keywords: [
      "face",
      "animal",
      "nature",
      "mystical"
    ],
    skins: [
      {
        unified: "1f984",
        native: "🦄",
        x: 44,
        y: 22
      }
    ],
    version: 1
  },
  zebra_face: {
    id: "zebra_face",
    name: "Zebra",
    keywords: [
      "face",
      "animal",
      "nature",
      "stripes",
      "safari"
    ],
    skins: [
      {
        unified: "1f993",
        native: "🦓",
        x: 44,
        y: 37
      }
    ],
    version: 5
  },
  deer: {
    id: "deer",
    name: "Deer",
    keywords: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    skins: [
      {
        unified: "1f98c",
        native: "🦌",
        x: 44,
        y: 30
      }
    ],
    version: 3
  },
  bison: {
    id: "bison",
    name: "Bison",
    keywords: [
      "ox"
    ],
    skins: [
      {
        unified: "1f9ac",
        native: "🦬",
        x: 45,
        y: 1
      }
    ],
    version: 13
  },
  cow: {
    id: "cow",
    name: "Cow Face",
    keywords: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f42e",
        native: "🐮",
        x: 11,
        y: 33
      }
    ],
    version: 1
  },
  ox: {
    id: "ox",
    name: "Ox",
    keywords: [
      "animal",
      "cow",
      "beef"
    ],
    skins: [
      {
        unified: "1f402",
        native: "🐂",
        x: 10,
        y: 48
      }
    ],
    version: 1
  },
  water_buffalo: {
    id: "water_buffalo",
    name: "Water Buffalo",
    keywords: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    skins: [
      {
        unified: "1f403",
        native: "🐃",
        x: 10,
        y: 49
      }
    ],
    version: 1
  },
  cow2: {
    id: "cow2",
    name: "Cow",
    keywords: [
      "cow2",
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f404",
        native: "🐄",
        x: 10,
        y: 50
      }
    ],
    version: 1
  },
  pig: {
    id: "pig",
    name: "Pig Face",
    keywords: [
      "animal",
      "oink",
      "nature"
    ],
    skins: [
      {
        unified: "1f437",
        native: "🐷",
        x: 11,
        y: 42
      }
    ],
    version: 1
  },
  pig2: {
    id: "pig2",
    name: "Pig",
    keywords: [
      "pig2",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f416",
        native: "🐖",
        x: 11,
        y: 9
      }
    ],
    version: 1
  },
  boar: {
    id: "boar",
    name: "Boar",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f417",
        native: "🐗",
        x: 11,
        y: 10
      }
    ],
    version: 1
  },
  pig_nose: {
    id: "pig_nose",
    name: "Pig Nose",
    keywords: [
      "animal",
      "oink"
    ],
    skins: [
      {
        unified: "1f43d",
        native: "🐽",
        x: 11,
        y: 49
      }
    ],
    version: 1
  },
  ram: {
    id: "ram",
    name: "Ram",
    keywords: [
      "animal",
      "sheep",
      "nature"
    ],
    skins: [
      {
        unified: "1f40f",
        native: "🐏",
        x: 11,
        y: 1
      }
    ],
    version: 1
  },
  sheep: {
    id: "sheep",
    name: "Ewe",
    keywords: [
      "sheep",
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    skins: [
      {
        unified: "1f411",
        native: "🐑",
        x: 11,
        y: 3
      }
    ],
    version: 1
  },
  goat: {
    id: "goat",
    name: "Goat",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f410",
        native: "🐐",
        x: 11,
        y: 2
      }
    ],
    version: 1
  },
  dromedary_camel: {
    id: "dromedary_camel",
    name: "Camel",
    keywords: [
      "dromedary",
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    skins: [
      {
        unified: "1f42a",
        native: "🐪",
        x: 11,
        y: 29
      }
    ],
    version: 1
  },
  camel: {
    id: "camel",
    name: "Bactrian Camel",
    keywords: [
      "two",
      "hump",
      "animal",
      "nature",
      "hot",
      "desert"
    ],
    skins: [
      {
        unified: "1f42b",
        native: "🐫",
        x: 11,
        y: 30
      }
    ],
    version: 1
  },
  llama: {
    id: "llama",
    name: "Llama",
    keywords: [
      "animal",
      "nature",
      "alpaca"
    ],
    skins: [
      {
        unified: "1f999",
        native: "🦙",
        x: 44,
        y: 43
      }
    ],
    version: 11
  },
  giraffe_face: {
    id: "giraffe_face",
    name: "Giraffe",
    keywords: [
      "face",
      "animal",
      "nature",
      "spots",
      "safari"
    ],
    skins: [
      {
        unified: "1f992",
        native: "🦒",
        x: 44,
        y: 36
      }
    ],
    version: 5
  },
  elephant: {
    id: "elephant",
    name: "Elephant",
    keywords: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    skins: [
      {
        unified: "1f418",
        native: "🐘",
        x: 11,
        y: 11
      }
    ],
    version: 1
  },
  mammoth: {
    id: "mammoth",
    name: "Mammoth",
    keywords: [
      "elephant",
      "tusks"
    ],
    skins: [
      {
        unified: "1f9a3",
        native: "🦣",
        x: 44,
        y: 53
      }
    ],
    version: 13
  },
  rhinoceros: {
    id: "rhinoceros",
    name: "Rhinoceros",
    keywords: [
      "animal",
      "nature",
      "horn"
    ],
    skins: [
      {
        unified: "1f98f",
        native: "🦏",
        x: 44,
        y: 33
      }
    ],
    version: 3
  },
  hippopotamus: {
    id: "hippopotamus",
    name: "Hippopotamus",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99b",
        native: "🦛",
        x: 44,
        y: 45
      }
    ],
    version: 11
  },
  mouse: {
    id: "mouse",
    name: "Mouse Face",
    keywords: [
      "animal",
      "nature",
      "cheese",
      "wedge",
      "rodent"
    ],
    skins: [
      {
        unified: "1f42d",
        native: "🐭",
        x: 11,
        y: 32
      }
    ],
    version: 1
  },
  mouse2: {
    id: "mouse2",
    name: "Mouse",
    keywords: [
      "mouse2",
      "animal",
      "nature",
      "rodent"
    ],
    skins: [
      {
        unified: "1f401",
        native: "🐁",
        x: 10,
        y: 47
      }
    ],
    version: 1
  },
  rat: {
    id: "rat",
    name: "Rat",
    keywords: [
      "animal",
      "mouse",
      "rodent"
    ],
    skins: [
      {
        unified: "1f400",
        native: "🐀",
        x: 10,
        y: 46
      }
    ],
    version: 1
  },
  hamster: {
    id: "hamster",
    name: "Hamster",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f439",
        native: "🐹",
        x: 11,
        y: 44
      }
    ],
    version: 1
  },
  rabbit: {
    id: "rabbit",
    name: "Rabbit Face",
    keywords: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    skins: [
      {
        unified: "1f430",
        native: "🐰",
        x: 11,
        y: 35
      }
    ],
    version: 1
  },
  rabbit2: {
    id: "rabbit2",
    name: "Rabbit",
    keywords: [
      "rabbit2",
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    skins: [
      {
        unified: "1f407",
        native: "🐇",
        x: 10,
        y: 53
      }
    ],
    version: 1
  },
  chipmunk: {
    id: "chipmunk",
    name: "Chipmunk",
    keywords: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f43f-fe0f",
        native: "🐿️",
        x: 11,
        y: 51
      }
    ],
    version: 1
  },
  beaver: {
    id: "beaver",
    name: "Beaver",
    keywords: [
      "animal",
      "rodent"
    ],
    skins: [
      {
        unified: "1f9ab",
        native: "🦫",
        x: 45,
        y: 0
      }
    ],
    version: 13
  },
  hedgehog: {
    id: "hedgehog",
    name: "Hedgehog",
    keywords: [
      "animal",
      "nature",
      "spiny"
    ],
    skins: [
      {
        unified: "1f994",
        native: "🦔",
        x: 44,
        y: 38
      }
    ],
    version: 5
  },
  bat: {
    id: "bat",
    name: "Bat",
    keywords: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    skins: [
      {
        unified: "1f987",
        native: "🦇",
        x: 44,
        y: 25
      }
    ],
    version: 3
  },
  bear: {
    id: "bear",
    name: "Bear",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43b",
        native: "🐻",
        x: 11,
        y: 47
      }
    ],
    version: 1
  },
  polar_bear: {
    id: "polar_bear",
    name: "Polar Bear",
    keywords: [
      "animal",
      "arctic"
    ],
    skins: [
      {
        unified: "1f43b-200d-2744-fe0f",
        native: "🐻‍❄️",
        x: 11,
        y: 46
      }
    ],
    version: 13
  },
  koala: {
    id: "koala",
    name: "Koala",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f428",
        native: "🐨",
        x: 11,
        y: 27
      }
    ],
    version: 1
  },
  panda_face: {
    id: "panda_face",
    name: "Panda",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f43c",
        native: "🐼",
        x: 11,
        y: 48
      }
    ],
    version: 1
  },
  sloth: {
    id: "sloth",
    name: "Sloth",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a5",
        native: "🦥",
        x: 44,
        y: 55
      }
    ],
    version: 12
  },
  otter: {
    id: "otter",
    name: "Otter",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a6",
        native: "🦦",
        x: 44,
        y: 56
      }
    ],
    version: 12
  },
  skunk: {
    id: "skunk",
    name: "Skunk",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a8",
        native: "🦨",
        x: 44,
        y: 58
      }
    ],
    version: 12
  },
  kangaroo: {
    id: "kangaroo",
    name: "Kangaroo",
    keywords: [
      "animal",
      "nature",
      "australia",
      "joey",
      "hop",
      "marsupial"
    ],
    skins: [
      {
        unified: "1f998",
        native: "🦘",
        x: 44,
        y: 42
      }
    ],
    version: 11
  },
  badger: {
    id: "badger",
    name: "Badger",
    keywords: [
      "animal",
      "nature",
      "honey"
    ],
    skins: [
      {
        unified: "1f9a1",
        native: "🦡",
        x: 44,
        y: 51
      }
    ],
    version: 11
  },
  feet: {
    id: "feet",
    name: "Paw Prints",
    keywords: [
      "feet",
      "animal",
      "tracking",
      "footprints",
      "dog",
      "cat",
      "pet"
    ],
    skins: [
      {
        unified: "1f43e",
        native: "🐾",
        x: 11,
        y: 50
      }
    ],
    version: 1
  },
  turkey: {
    id: "turkey",
    name: "Turkey",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f983",
        native: "🦃",
        x: 44,
        y: 21
      }
    ],
    version: 1
  },
  chicken: {
    id: "chicken",
    name: "Chicken",
    keywords: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f414",
        native: "🐔",
        x: 11,
        y: 6
      }
    ],
    version: 1
  },
  rooster: {
    id: "rooster",
    name: "Rooster",
    keywords: [
      "animal",
      "nature",
      "chicken"
    ],
    skins: [
      {
        unified: "1f413",
        native: "🐓",
        x: 11,
        y: 5
      }
    ],
    version: 1
  },
  hatching_chick: {
    id: "hatching_chick",
    name: "Hatching Chick",
    keywords: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    skins: [
      {
        unified: "1f423",
        native: "🐣",
        x: 11,
        y: 22
      }
    ],
    version: 1
  },
  baby_chick: {
    id: "baby_chick",
    name: "Baby Chick",
    keywords: [
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f424",
        native: "🐤",
        x: 11,
        y: 23
      }
    ],
    version: 1
  },
  hatched_chick: {
    id: "hatched_chick",
    name: "Front-Facing Baby Chick",
    keywords: [
      "hatched",
      "front",
      "facing",
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f425",
        native: "🐥",
        x: 11,
        y: 24
      }
    ],
    version: 1
  },
  bird: {
    id: "bird",
    name: "Bird",
    keywords: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    skins: [
      {
        unified: "1f426",
        native: "🐦",
        x: 11,
        y: 25
      }
    ],
    version: 1
  },
  penguin: {
    id: "penguin",
    name: "Penguin",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f427",
        native: "🐧",
        x: 11,
        y: 26
      }
    ],
    version: 1
  },
  dove_of_peace: {
    id: "dove_of_peace",
    name: "Dove",
    keywords: [
      "of",
      "peace",
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f54a-fe0f",
        native: "🕊️",
        x: 30,
        y: 27
      }
    ],
    version: 1
  },
  eagle: {
    id: "eagle",
    name: "Eagle",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f985",
        native: "🦅",
        x: 44,
        y: 23
      }
    ],
    version: 3
  },
  duck: {
    id: "duck",
    name: "Duck",
    keywords: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    skins: [
      {
        unified: "1f986",
        native: "🦆",
        x: 44,
        y: 24
      }
    ],
    version: 3
  },
  swan: {
    id: "swan",
    name: "Swan",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a2",
        native: "🦢",
        x: 44,
        y: 52
      }
    ],
    version: 11
  },
  owl: {
    id: "owl",
    name: "Owl",
    keywords: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    skins: [
      {
        unified: "1f989",
        native: "🦉",
        x: 44,
        y: 27
      }
    ],
    version: 3
  },
  dodo: {
    id: "dodo",
    name: "Dodo",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a4",
        native: "🦤",
        x: 44,
        y: 54
      }
    ],
    version: 13
  },
  feather: {
    id: "feather",
    name: "Feather",
    keywords: [
      "bird",
      "fly"
    ],
    skins: [
      {
        unified: "1fab6",
        native: "🪶",
        x: 54,
        y: 37
      }
    ],
    version: 13
  },
  flamingo: {
    id: "flamingo",
    name: "Flamingo",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a9",
        native: "🦩",
        x: 44,
        y: 59
      }
    ],
    version: 12
  },
  peacock: {
    id: "peacock",
    name: "Peacock",
    keywords: [
      "animal",
      "nature",
      "peahen",
      "bird"
    ],
    skins: [
      {
        unified: "1f99a",
        native: "🦚",
        x: 44,
        y: 44
      }
    ],
    version: 11
  },
  parrot: {
    id: "parrot",
    name: "Parrot",
    keywords: [
      "animal",
      "nature",
      "bird",
      "pirate",
      "talk"
    ],
    skins: [
      {
        unified: "1f99c",
        native: "🦜",
        x: 44,
        y: 46
      }
    ],
    version: 11
  },
  frog: {
    id: "frog",
    name: "Frog",
    keywords: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    skins: [
      {
        unified: "1f438",
        native: "🐸",
        x: 11,
        y: 43
      }
    ],
    version: 1
  },
  crocodile: {
    id: "crocodile",
    name: "Crocodile",
    keywords: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    skins: [
      {
        unified: "1f40a",
        native: "🐊",
        x: 10,
        y: 57
      }
    ],
    version: 1
  },
  turtle: {
    id: "turtle",
    name: "Turtle",
    keywords: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    skins: [
      {
        unified: "1f422",
        native: "🐢",
        x: 11,
        y: 21
      }
    ],
    version: 1
  },
  lizard: {
    id: "lizard",
    name: "Lizard",
    keywords: [
      "animal",
      "nature",
      "reptile"
    ],
    skins: [
      {
        unified: "1f98e",
        native: "🦎",
        x: 44,
        y: 32
      }
    ],
    version: 3
  },
  snake: {
    id: "snake",
    name: "Snake",
    keywords: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    skins: [
      {
        unified: "1f40d",
        native: "🐍",
        x: 10,
        y: 60
      }
    ],
    version: 1
  },
  dragon_face: {
    id: "dragon_face",
    name: "Dragon Face",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f432",
        native: "🐲",
        x: 11,
        y: 37
      }
    ],
    version: 1
  },
  dragon: {
    id: "dragon",
    name: "Dragon",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f409",
        native: "🐉",
        x: 10,
        y: 56
      }
    ],
    version: 1
  },
  sauropod: {
    id: "sauropod",
    name: "Sauropod",
    keywords: [
      "animal",
      "nature",
      "dinosaur",
      "brachiosaurus",
      "brontosaurus",
      "diplodocus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f995",
        native: "🦕",
        x: 44,
        y: 39
      }
    ],
    version: 5
  },
  "t-rex": {
    id: "t-rex",
    name: "T-Rex",
    keywords: [
      "t",
      "rex",
      "animal",
      "nature",
      "dinosaur",
      "tyrannosaurus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f996",
        native: "🦖",
        x: 44,
        y: 40
      }
    ],
    version: 5
  },
  whale: {
    id: "whale",
    name: "Spouting Whale",
    keywords: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f433",
        native: "🐳",
        x: 11,
        y: 38
      }
    ],
    version: 1
  },
  whale2: {
    id: "whale2",
    name: "Whale",
    keywords: [
      "whale2",
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f40b",
        native: "🐋",
        x: 10,
        y: 58
      }
    ],
    version: 1
  },
  dolphin: {
    id: "dolphin",
    name: "Dolphin",
    keywords: [
      "flipper",
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f42c",
        native: "🐬",
        x: 11,
        y: 31
      }
    ],
    version: 1
  },
  seal: {
    id: "seal",
    name: "Seal",
    keywords: [
      "animal",
      "creature",
      "sea"
    ],
    skins: [
      {
        unified: "1f9ad",
        native: "🦭",
        x: 45,
        y: 2
      }
    ],
    version: 13
  },
  fish: {
    id: "fish",
    name: "Fish",
    keywords: [
      "animal",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f41f",
        native: "🐟",
        x: 11,
        y: 18
      }
    ],
    version: 1
  },
  tropical_fish: {
    id: "tropical_fish",
    name: "Tropical Fish",
    keywords: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    skins: [
      {
        unified: "1f420",
        native: "🐠",
        x: 11,
        y: 19
      }
    ],
    version: 1
  },
  blowfish: {
    id: "blowfish",
    name: "Blowfish",
    keywords: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f421",
        native: "🐡",
        x: 11,
        y: 20
      }
    ],
    version: 1
  },
  shark: {
    id: "shark",
    name: "Shark",
    keywords: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f988",
        native: "🦈",
        x: 44,
        y: 26
      }
    ],
    version: 3
  },
  octopus: {
    id: "octopus",
    name: "Octopus",
    keywords: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    skins: [
      {
        unified: "1f419",
        native: "🐙",
        x: 11,
        y: 12
      }
    ],
    version: 1
  },
  shell: {
    id: "shell",
    name: "Spiral Shell",
    keywords: [
      "nature",
      "sea",
      "beach"
    ],
    skins: [
      {
        unified: "1f41a",
        native: "🐚",
        x: 11,
        y: 13
      }
    ],
    version: 1
  },
  coral: {
    id: "coral",
    name: "Coral",
    keywords: [
      "ocean",
      "sea",
      "reef"
    ],
    skins: [
      {
        unified: "1fab8",
        native: "🪸",
        x: 54,
        y: 39
      }
    ],
    version: 14
  },
  snail: {
    id: "snail",
    name: "Snail",
    keywords: [
      "slow",
      "animal",
      "shell"
    ],
    skins: [
      {
        unified: "1f40c",
        native: "🐌",
        x: 10,
        y: 59
      }
    ],
    version: 1
  },
  butterfly: {
    id: "butterfly",
    name: "Butterfly",
    keywords: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    skins: [
      {
        unified: "1f98b",
        native: "🦋",
        x: 44,
        y: 29
      }
    ],
    version: 3
  },
  bug: {
    id: "bug",
    name: "Bug",
    keywords: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    skins: [
      {
        unified: "1f41b",
        native: "🐛",
        x: 11,
        y: 14
      }
    ],
    version: 1
  },
  ant: {
    id: "ant",
    name: "Ant",
    keywords: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    skins: [
      {
        unified: "1f41c",
        native: "🐜",
        x: 11,
        y: 15
      }
    ],
    version: 1
  },
  bee: {
    id: "bee",
    name: "Honeybee",
    keywords: [
      "bee",
      "animal",
      "insect",
      "nature",
      "bug",
      "spring",
      "honey"
    ],
    skins: [
      {
        unified: "1f41d",
        native: "🐝",
        x: 11,
        y: 16
      }
    ],
    version: 1
  },
  beetle: {
    id: "beetle",
    name: "Beetle",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab2",
        native: "🪲",
        x: 54,
        y: 33
      }
    ],
    version: 13
  },
  ladybug: {
    id: "ladybug",
    name: "Lady Beetle",
    keywords: [
      "ladybug",
      "animal",
      "insect",
      "nature"
    ],
    skins: [
      {
        unified: "1f41e",
        native: "🐞",
        x: 11,
        y: 17
      }
    ],
    version: 1
  },
  cricket: {
    id: "cricket",
    name: "Cricket",
    keywords: [
      "animal",
      "chirp"
    ],
    skins: [
      {
        unified: "1f997",
        native: "🦗",
        x: 44,
        y: 41
      }
    ],
    version: 5
  },
  cockroach: {
    id: "cockroach",
    name: "Cockroach",
    keywords: [
      "insect",
      "pests"
    ],
    skins: [
      {
        unified: "1fab3",
        native: "🪳",
        x: 54,
        y: 34
      }
    ],
    version: 13
  },
  spider: {
    id: "spider",
    name: "Spider",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f577-fe0f",
        native: "🕷️",
        x: 31,
        y: 23
      }
    ],
    version: 1
  },
  spider_web: {
    id: "spider_web",
    name: "Spider Web",
    keywords: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    skins: [
      {
        unified: "1f578-fe0f",
        native: "🕸️",
        x: 31,
        y: 24
      }
    ],
    version: 1
  },
  scorpion: {
    id: "scorpion",
    name: "Scorpion",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f982",
        native: "🦂",
        x: 44,
        y: 20
      }
    ],
    version: 1
  },
  mosquito: {
    id: "mosquito",
    name: "Mosquito",
    keywords: [
      "animal",
      "nature",
      "insect",
      "malaria"
    ],
    skins: [
      {
        unified: "1f99f",
        native: "🦟",
        x: 44,
        y: 49
      }
    ],
    version: 11
  },
  fly: {
    id: "fly",
    name: "Fly",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab0",
        native: "🪰",
        x: 54,
        y: 31
      }
    ],
    version: 13
  },
  worm: {
    id: "worm",
    name: "Worm",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1fab1",
        native: "🪱",
        x: 54,
        y: 32
      }
    ],
    version: 13
  },
  microbe: {
    id: "microbe",
    name: "Microbe",
    keywords: [
      "amoeba",
      "bacteria",
      "germs",
      "virus"
    ],
    skins: [
      {
        unified: "1f9a0",
        native: "🦠",
        x: 44,
        y: 50
      }
    ],
    version: 11
  },
  bouquet: {
    id: "bouquet",
    name: "Bouquet",
    keywords: [
      "flowers",
      "nature",
      "spring"
    ],
    skins: [
      {
        unified: "1f490",
        native: "💐",
        x: 27,
        y: 6
      }
    ],
    version: 1
  },
  cherry_blossom: {
    id: "cherry_blossom",
    name: "Cherry Blossom",
    keywords: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    skins: [
      {
        unified: "1f338",
        native: "🌸",
        x: 5,
        y: 53
      }
    ],
    version: 1
  },
  white_flower: {
    id: "white_flower",
    name: "White Flower",
    keywords: [
      "japanese",
      "spring"
    ],
    skins: [
      {
        unified: "1f4ae",
        native: "💮",
        x: 28,
        y: 5
      }
    ],
    version: 1
  },
  lotus: {
    id: "lotus",
    name: "Lotus",
    keywords: [
      "flower",
      "calm",
      "meditation"
    ],
    skins: [
      {
        unified: "1fab7",
        native: "🪷",
        x: 54,
        y: 38
      }
    ],
    version: 14
  },
  rosette: {
    id: "rosette",
    name: "Rosette",
    keywords: [
      "flower",
      "decoration",
      "military"
    ],
    skins: [
      {
        unified: "1f3f5-fe0f",
        native: "🏵️",
        x: 10,
        y: 36
      }
    ],
    version: 1
  },
  rose: {
    id: "rose",
    name: "Rose",
    keywords: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    skins: [
      {
        unified: "1f339",
        native: "🌹",
        x: 5,
        y: 54
      }
    ],
    version: 1
  },
  wilted_flower: {
    id: "wilted_flower",
    name: "Wilted Flower",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f940",
        native: "🥀",
        x: 43,
        y: 11
      }
    ],
    version: 3
  },
  hibiscus: {
    id: "hibiscus",
    name: "Hibiscus",
    keywords: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    skins: [
      {
        unified: "1f33a",
        native: "🌺",
        x: 5,
        y: 55
      }
    ],
    version: 1
  },
  sunflower: {
    id: "sunflower",
    name: "Sunflower",
    keywords: [
      "nature",
      "plant",
      "fall"
    ],
    skins: [
      {
        unified: "1f33b",
        native: "🌻",
        x: 5,
        y: 56
      }
    ],
    version: 1
  },
  blossom: {
    id: "blossom",
    name: "Blossom",
    keywords: [
      "nature",
      "flowers",
      "yellow"
    ],
    skins: [
      {
        unified: "1f33c",
        native: "🌼",
        x: 5,
        y: 57
      }
    ],
    version: 1
  },
  tulip: {
    id: "tulip",
    name: "Tulip",
    keywords: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    skins: [
      {
        unified: "1f337",
        native: "🌷",
        x: 5,
        y: 52
      }
    ],
    version: 1
  },
  seedling: {
    id: "seedling",
    name: "Seedling",
    keywords: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f331",
        native: "🌱",
        x: 5,
        y: 46
      }
    ],
    version: 1
  },
  potted_plant: {
    id: "potted_plant",
    name: "Potted Plant",
    keywords: [
      "greenery",
      "house"
    ],
    skins: [
      {
        unified: "1fab4",
        native: "🪴",
        x: 54,
        y: 35
      }
    ],
    version: 13
  },
  evergreen_tree: {
    id: "evergreen_tree",
    name: "Evergreen Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f332",
        native: "🌲",
        x: 5,
        y: 47
      }
    ],
    version: 1
  },
  deciduous_tree: {
    id: "deciduous_tree",
    name: "Deciduous Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f333",
        native: "🌳",
        x: 5,
        y: 48
      }
    ],
    version: 1
  },
  palm_tree: {
    id: "palm_tree",
    name: "Palm Tree",
    keywords: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    skins: [
      {
        unified: "1f334",
        native: "🌴",
        x: 5,
        y: 49
      }
    ],
    version: 1
  },
  cactus: {
    id: "cactus",
    name: "Cactus",
    keywords: [
      "vegetable",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f335",
        native: "🌵",
        x: 5,
        y: 50
      }
    ],
    version: 1
  },
  ear_of_rice: {
    id: "ear_of_rice",
    name: "Ear of Rice",
    keywords: [
      "sheaf",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f33e",
        native: "🌾",
        x: 5,
        y: 59
      }
    ],
    version: 1
  },
  herb: {
    id: "herb",
    name: "Herb",
    keywords: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    skins: [
      {
        unified: "1f33f",
        native: "🌿",
        x: 5,
        y: 60
      }
    ],
    version: 1
  },
  shamrock: {
    id: "shamrock",
    name: "Shamrock",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    skins: [
      {
        unified: "2618-fe0f",
        native: "☘️",
        x: 56,
        y: 49
      }
    ],
    version: 1
  },
  four_leaf_clover: {
    id: "four_leaf_clover",
    name: "Four Leaf Clover",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    skins: [
      {
        unified: "1f340",
        native: "🍀",
        x: 6,
        y: 0
      }
    ],
    version: 1
  },
  maple_leaf: {
    id: "maple_leaf",
    name: "Maple Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    skins: [
      {
        unified: "1f341",
        native: "🍁",
        x: 6,
        y: 1
      }
    ],
    version: 1
  },
  fallen_leaf: {
    id: "fallen_leaf",
    name: "Fallen Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    skins: [
      {
        unified: "1f342",
        native: "🍂",
        x: 6,
        y: 2
      }
    ],
    version: 1
  },
  leaves: {
    id: "leaves",
    name: "Leaf Fluttering in Wind",
    keywords: [
      "leaves",
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f343",
        native: "🍃",
        x: 6,
        y: 3
      }
    ],
    version: 1
  },
  empty_nest: {
    id: "empty_nest",
    name: "Empty Nest",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1fab9",
        native: "🪹",
        x: 54,
        y: 40
      }
    ],
    version: 14
  },
  nest_with_eggs: {
    id: "nest_with_eggs",
    name: "Nest with Eggs",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1faba",
        native: "🪺",
        x: 54,
        y: 41
      }
    ],
    version: 14
  },
  grapes: {
    id: "grapes",
    name: "Grapes",
    keywords: [
      "fruit",
      "food",
      "wine"
    ],
    skins: [
      {
        unified: "1f347",
        native: "🍇",
        x: 6,
        y: 7
      }
    ],
    version: 1
  },
  melon: {
    id: "melon",
    name: "Melon",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f348",
        native: "🍈",
        x: 6,
        y: 8
      }
    ],
    version: 1
  },
  watermelon: {
    id: "watermelon",
    name: "Watermelon",
    keywords: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    skins: [
      {
        unified: "1f349",
        native: "🍉",
        x: 6,
        y: 9
      }
    ],
    version: 1
  },
  tangerine: {
    id: "tangerine",
    name: "Tangerine",
    keywords: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    skins: [
      {
        unified: "1f34a",
        native: "🍊",
        x: 6,
        y: 10
      }
    ],
    version: 1
  },
  lemon: {
    id: "lemon",
    name: "Lemon",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34b",
        native: "🍋",
        x: 6,
        y: 11
      }
    ],
    version: 1
  },
  banana: {
    id: "banana",
    name: "Banana",
    keywords: [
      "fruit",
      "food",
      "monkey"
    ],
    skins: [
      {
        unified: "1f34c",
        native: "🍌",
        x: 6,
        y: 12
      }
    ],
    version: 1
  },
  pineapple: {
    id: "pineapple",
    name: "Pineapple",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f34d",
        native: "🍍",
        x: 6,
        y: 13
      }
    ],
    version: 1
  },
  mango: {
    id: "mango",
    name: "Mango",
    keywords: [
      "fruit",
      "food",
      "tropical"
    ],
    skins: [
      {
        unified: "1f96d",
        native: "🥭",
        x: 43,
        y: 55
      }
    ],
    version: 11
  },
  apple: {
    id: "apple",
    name: "Red Apple",
    keywords: [
      "fruit",
      "mac",
      "school"
    ],
    skins: [
      {
        unified: "1f34e",
        native: "🍎",
        x: 6,
        y: 14
      }
    ],
    version: 1
  },
  green_apple: {
    id: "green_apple",
    name: "Green Apple",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34f",
        native: "🍏",
        x: 6,
        y: 15
      }
    ],
    version: 1
  },
  pear: {
    id: "pear",
    name: "Pear",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f350",
        native: "🍐",
        x: 6,
        y: 16
      }
    ],
    version: 1
  },
  peach: {
    id: "peach",
    name: "Peach",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f351",
        native: "🍑",
        x: 6,
        y: 17
      }
    ],
    version: 1
  },
  cherries: {
    id: "cherries",
    name: "Cherries",
    keywords: [
      "food",
      "fruit"
    ],
    skins: [
      {
        unified: "1f352",
        native: "🍒",
        x: 6,
        y: 18
      }
    ],
    version: 1
  },
  strawberry: {
    id: "strawberry",
    name: "Strawberry",
    keywords: [
      "fruit",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f353",
        native: "🍓",
        x: 6,
        y: 19
      }
    ],
    version: 1
  },
  blueberries: {
    id: "blueberries",
    name: "Blueberries",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad0",
        native: "🫐",
        x: 55,
        y: 2
      }
    ],
    version: 13
  },
  kiwifruit: {
    id: "kiwifruit",
    name: "Kiwifruit",
    keywords: [
      "kiwi",
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f95d",
        native: "🥝",
        x: 43,
        y: 39
      }
    ],
    version: 3
  },
  tomato: {
    id: "tomato",
    name: "Tomato",
    keywords: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f345",
        native: "🍅",
        x: 6,
        y: 5
      }
    ],
    version: 1
  },
  olive: {
    id: "olive",
    name: "Olive",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad2",
        native: "🫒",
        x: 55,
        y: 4
      }
    ],
    version: 13
  },
  coconut: {
    id: "coconut",
    name: "Coconut",
    keywords: [
      "fruit",
      "nature",
      "food",
      "palm"
    ],
    skins: [
      {
        unified: "1f965",
        native: "🥥",
        x: 43,
        y: 47
      }
    ],
    version: 5
  },
  avocado: {
    id: "avocado",
    name: "Avocado",
    keywords: [
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f951",
        native: "🥑",
        x: 43,
        y: 27
      }
    ],
    version: 3
  },
  eggplant: {
    id: "eggplant",
    name: "Eggplant",
    keywords: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    skins: [
      {
        unified: "1f346",
        native: "🍆",
        x: 6,
        y: 6
      }
    ],
    version: 1
  },
  potato: {
    id: "potato",
    name: "Potato",
    keywords: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    skins: [
      {
        unified: "1f954",
        native: "🥔",
        x: 43,
        y: 30
      }
    ],
    version: 3
  },
  carrot: {
    id: "carrot",
    name: "Carrot",
    keywords: [
      "vegetable",
      "food",
      "orange"
    ],
    skins: [
      {
        unified: "1f955",
        native: "🥕",
        x: 43,
        y: 31
      }
    ],
    version: 3
  },
  corn: {
    id: "corn",
    name: "Ear of Corn",
    keywords: [
      "food",
      "vegetable",
      "plant"
    ],
    skins: [
      {
        unified: "1f33d",
        native: "🌽",
        x: 5,
        y: 58
      }
    ],
    version: 1
  },
  hot_pepper: {
    id: "hot_pepper",
    name: "Hot Pepper",
    keywords: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    skins: [
      {
        unified: "1f336-fe0f",
        native: "🌶️",
        x: 5,
        y: 51
      }
    ],
    version: 1
  },
  bell_pepper: {
    id: "bell_pepper",
    name: "Bell Pepper",
    keywords: [
      "fruit",
      "plant"
    ],
    skins: [
      {
        unified: "1fad1",
        native: "🫑",
        x: 55,
        y: 3
      }
    ],
    version: 13
  },
  cucumber: {
    id: "cucumber",
    name: "Cucumber",
    keywords: [
      "fruit",
      "food",
      "pickle"
    ],
    skins: [
      {
        unified: "1f952",
        native: "🥒",
        x: 43,
        y: 28
      }
    ],
    version: 3
  },
  leafy_green: {
    id: "leafy_green",
    name: "Leafy Green",
    keywords: [
      "food",
      "vegetable",
      "plant",
      "bok",
      "choy",
      "cabbage",
      "kale",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f96c",
        native: "🥬",
        x: 43,
        y: 54
      }
    ],
    version: 11
  },
  broccoli: {
    id: "broccoli",
    name: "Broccoli",
    keywords: [
      "fruit",
      "food",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f966",
        native: "🥦",
        x: 43,
        y: 48
      }
    ],
    version: 5
  },
  garlic: {
    id: "garlic",
    name: "Garlic",
    keywords: [
      "food",
      "spice",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c4",
        native: "🧄",
        x: 46,
        y: 9
      }
    ],
    version: 12
  },
  onion: {
    id: "onion",
    name: "Onion",
    keywords: [
      "cook",
      "food",
      "spice"
    ],
    skins: [
      {
        unified: "1f9c5",
        native: "🧅",
        x: 46,
        y: 10
      }
    ],
    version: 12
  },
  mushroom: {
    id: "mushroom",
    name: "Mushroom",
    keywords: [
      "plant",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f344",
        native: "🍄",
        x: 6,
        y: 4
      }
    ],
    version: 1
  },
  peanuts: {
    id: "peanuts",
    name: "Peanuts",
    keywords: [
      "food",
      "nut"
    ],
    skins: [
      {
        unified: "1f95c",
        native: "🥜",
        x: 43,
        y: 38
      }
    ],
    version: 3
  },
  beans: {
    id: "beans",
    name: "Beans",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1fad8",
        native: "🫘",
        x: 55,
        y: 10
      }
    ],
    version: 14
  },
  chestnut: {
    id: "chestnut",
    name: "Chestnut",
    keywords: [
      "food",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f330",
        native: "🌰",
        x: 5,
        y: 45
      }
    ],
    version: 1
  },
  bread: {
    id: "bread",
    name: "Bread",
    keywords: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    skins: [
      {
        unified: "1f35e",
        native: "🍞",
        x: 6,
        y: 30
      }
    ],
    version: 1
  },
  croissant: {
    id: "croissant",
    name: "Croissant",
    keywords: [
      "food",
      "bread",
      "french"
    ],
    skins: [
      {
        unified: "1f950",
        native: "🥐",
        x: 43,
        y: 26
      }
    ],
    version: 3
  },
  baguette_bread: {
    id: "baguette_bread",
    name: "Baguette Bread",
    keywords: [
      "food",
      "french"
    ],
    skins: [
      {
        unified: "1f956",
        native: "🥖",
        x: 43,
        y: 32
      }
    ],
    version: 3
  },
  flatbread: {
    id: "flatbread",
    name: "Flatbread",
    keywords: [
      "flour",
      "food"
    ],
    skins: [
      {
        unified: "1fad3",
        native: "🫓",
        x: 55,
        y: 5
      }
    ],
    version: 13
  },
  pretzel: {
    id: "pretzel",
    name: "Pretzel",
    keywords: [
      "food",
      "bread",
      "twisted"
    ],
    skins: [
      {
        unified: "1f968",
        native: "🥨",
        x: 43,
        y: 50
      }
    ],
    version: 5
  },
  bagel: {
    id: "bagel",
    name: "Bagel",
    keywords: [
      "food",
      "bread",
      "bakery",
      "schmear"
    ],
    skins: [
      {
        unified: "1f96f",
        native: "🥯",
        x: 43,
        y: 57
      }
    ],
    version: 11
  },
  pancakes: {
    id: "pancakes",
    name: "Pancakes",
    keywords: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes"
    ],
    skins: [
      {
        unified: "1f95e",
        native: "🥞",
        x: 43,
        y: 40
      }
    ],
    version: 3
  },
  waffle: {
    id: "waffle",
    name: "Waffle",
    keywords: [
      "food",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f9c7",
        native: "🧇",
        x: 46,
        y: 12
      }
    ],
    version: 12
  },
  cheese_wedge: {
    id: "cheese_wedge",
    name: "Cheese Wedge",
    keywords: [
      "food",
      "chadder"
    ],
    skins: [
      {
        unified: "1f9c0",
        native: "🧀",
        x: 46,
        y: 5
      }
    ],
    version: 1
  },
  meat_on_bone: {
    id: "meat_on_bone",
    name: "Meat on Bone",
    keywords: [
      "good",
      "food",
      "drumstick"
    ],
    skins: [
      {
        unified: "1f356",
        native: "🍖",
        x: 6,
        y: 22
      }
    ],
    version: 1
  },
  poultry_leg: {
    id: "poultry_leg",
    name: "Poultry Leg",
    keywords: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    skins: [
      {
        unified: "1f357",
        native: "🍗",
        x: 6,
        y: 23
      }
    ],
    version: 1
  },
  cut_of_meat: {
    id: "cut_of_meat",
    name: "Cut of Meat",
    keywords: [
      "food",
      "cow",
      "chop",
      "lambchop",
      "porkchop"
    ],
    skins: [
      {
        unified: "1f969",
        native: "🥩",
        x: 43,
        y: 51
      }
    ],
    version: 5
  },
  bacon: {
    id: "bacon",
    name: "Bacon",
    keywords: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat"
    ],
    skins: [
      {
        unified: "1f953",
        native: "🥓",
        x: 43,
        y: 29
      }
    ],
    version: 3
  },
  hamburger: {
    id: "hamburger",
    name: "Hamburger",
    keywords: [
      "meat",
      "fast",
      "food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger",
      "king"
    ],
    skins: [
      {
        unified: "1f354",
        native: "🍔",
        x: 6,
        y: 20
      }
    ],
    version: 1
  },
  fries: {
    id: "fries",
    name: "French Fries",
    keywords: [
      "chips",
      "snack",
      "fast",
      "food"
    ],
    skins: [
      {
        unified: "1f35f",
        native: "🍟",
        x: 6,
        y: 31
      }
    ],
    version: 1
  },
  pizza: {
    id: "pizza",
    name: "Pizza",
    keywords: [
      "food",
      "party"
    ],
    skins: [
      {
        unified: "1f355",
        native: "🍕",
        x: 6,
        y: 21
      }
    ],
    version: 1
  },
  hotdog: {
    id: "hotdog",
    name: "Hot Dog",
    keywords: [
      "hotdog",
      "food",
      "frankfurter"
    ],
    skins: [
      {
        unified: "1f32d",
        native: "🌭",
        x: 5,
        y: 42
      }
    ],
    version: 1
  },
  sandwich: {
    id: "sandwich",
    name: "Sandwich",
    keywords: [
      "food",
      "lunch",
      "bread"
    ],
    skins: [
      {
        unified: "1f96a",
        native: "🥪",
        x: 43,
        y: 52
      }
    ],
    version: 5
  },
  taco: {
    id: "taco",
    name: "Taco",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32e",
        native: "🌮",
        x: 5,
        y: 43
      }
    ],
    version: 1
  },
  burrito: {
    id: "burrito",
    name: "Burrito",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32f",
        native: "🌯",
        x: 5,
        y: 44
      }
    ],
    version: 1
  },
  tamale: {
    id: "tamale",
    name: "Tamale",
    keywords: [
      "food",
      "masa"
    ],
    skins: [
      {
        unified: "1fad4",
        native: "🫔",
        x: 55,
        y: 6
      }
    ],
    version: 13
  },
  stuffed_flatbread: {
    id: "stuffed_flatbread",
    name: "Stuffed Flatbread",
    keywords: [
      "food",
      "gyro"
    ],
    skins: [
      {
        unified: "1f959",
        native: "🥙",
        x: 43,
        y: 35
      }
    ],
    version: 3
  },
  falafel: {
    id: "falafel",
    name: "Falafel",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9c6",
        native: "🧆",
        x: 46,
        y: 11
      }
    ],
    version: 12
  },
  egg: {
    id: "egg",
    name: "Egg",
    keywords: [
      "food",
      "chicken",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f95a",
        native: "🥚",
        x: 43,
        y: 36
      }
    ],
    version: 3
  },
  fried_egg: {
    id: "fried_egg",
    name: "Cooking",
    keywords: [
      "fried",
      "egg",
      "food",
      "breakfast",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f373",
        native: "🍳",
        x: 6,
        y: 51
      }
    ],
    version: 1
  },
  shallow_pan_of_food: {
    id: "shallow_pan_of_food",
    name: "Shallow Pan of Food",
    keywords: [
      "cooking",
      "casserole",
      "paella"
    ],
    skins: [
      {
        unified: "1f958",
        native: "🥘",
        x: 43,
        y: 34
      }
    ],
    version: 3
  },
  stew: {
    id: "stew",
    name: "Pot of Food",
    keywords: [
      "stew",
      "meat",
      "soup"
    ],
    skins: [
      {
        unified: "1f372",
        native: "🍲",
        x: 6,
        y: 50
      }
    ],
    version: 1
  },
  fondue: {
    id: "fondue",
    name: "Fondue",
    keywords: [
      "cheese",
      "pot",
      "food"
    ],
    skins: [
      {
        unified: "1fad5",
        native: "🫕",
        x: 55,
        y: 7
      }
    ],
    version: 13
  },
  bowl_with_spoon: {
    id: "bowl_with_spoon",
    name: "Bowl with Spoon",
    keywords: [
      "food",
      "breakfast",
      "cereal",
      "oatmeal",
      "porridge"
    ],
    skins: [
      {
        unified: "1f963",
        native: "🥣",
        x: 43,
        y: 45
      }
    ],
    version: 5
  },
  green_salad: {
    id: "green_salad",
    name: "Green Salad",
    keywords: [
      "food",
      "healthy",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f957",
        native: "🥗",
        x: 43,
        y: 33
      }
    ],
    version: 3
  },
  popcorn: {
    id: "popcorn",
    name: "Popcorn",
    keywords: [
      "food",
      "movie",
      "theater",
      "films",
      "snack"
    ],
    skins: [
      {
        unified: "1f37f",
        native: "🍿",
        x: 7,
        y: 2
      }
    ],
    version: 1
  },
  butter: {
    id: "butter",
    name: "Butter",
    keywords: [
      "food",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c8",
        native: "🧈",
        x: 46,
        y: 13
      }
    ],
    version: 12
  },
  salt: {
    id: "salt",
    name: "Salt",
    keywords: [
      "condiment",
      "shaker"
    ],
    skins: [
      {
        unified: "1f9c2",
        native: "🧂",
        x: 46,
        y: 7
      }
    ],
    version: 11
  },
  canned_food: {
    id: "canned_food",
    name: "Canned Food",
    keywords: [
      "soup"
    ],
    skins: [
      {
        unified: "1f96b",
        native: "🥫",
        x: 43,
        y: 53
      }
    ],
    version: 5
  },
  bento: {
    id: "bento",
    name: "Bento Box",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f371",
        native: "🍱",
        x: 6,
        y: 49
      }
    ],
    version: 1
  },
  rice_cracker: {
    id: "rice_cracker",
    name: "Rice Cracker",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f358",
        native: "🍘",
        x: 6,
        y: 24
      }
    ],
    version: 1
  },
  rice_ball: {
    id: "rice_ball",
    name: "Rice Ball",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f359",
        native: "🍙",
        x: 6,
        y: 25
      }
    ],
    version: 1
  },
  rice: {
    id: "rice",
    name: "Cooked Rice",
    keywords: [
      "food",
      "china",
      "asian"
    ],
    skins: [
      {
        unified: "1f35a",
        native: "🍚",
        x: 6,
        y: 26
      }
    ],
    version: 1
  },
  curry: {
    id: "curry",
    name: "Curry Rice",
    keywords: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    skins: [
      {
        unified: "1f35b",
        native: "🍛",
        x: 6,
        y: 27
      }
    ],
    version: 1
  },
  ramen: {
    id: "ramen",
    name: "Steaming Bowl",
    keywords: [
      "ramen",
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    skins: [
      {
        unified: "1f35c",
        native: "🍜",
        x: 6,
        y: 28
      }
    ],
    version: 1
  },
  spaghetti: {
    id: "spaghetti",
    name: "Spaghetti",
    keywords: [
      "food",
      "italian",
      "noodle"
    ],
    skins: [
      {
        unified: "1f35d",
        native: "🍝",
        x: 6,
        y: 29
      }
    ],
    version: 1
  },
  sweet_potato: {
    id: "sweet_potato",
    name: "Roasted Sweet Potato",
    keywords: [
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f360",
        native: "🍠",
        x: 6,
        y: 32
      }
    ],
    version: 1
  },
  oden: {
    id: "oden",
    name: "Oden",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f362",
        native: "🍢",
        x: 6,
        y: 34
      }
    ],
    version: 1
  },
  sushi: {
    id: "sushi",
    name: "Sushi",
    keywords: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    skins: [
      {
        unified: "1f363",
        native: "🍣",
        x: 6,
        y: 35
      }
    ],
    version: 1
  },
  fried_shrimp: {
    id: "fried_shrimp",
    name: "Fried Shrimp",
    keywords: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    skins: [
      {
        unified: "1f364",
        native: "🍤",
        x: 6,
        y: 36
      }
    ],
    version: 1
  },
  fish_cake: {
    id: "fish_cake",
    name: "Fish Cake with Swirl",
    keywords: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    skins: [
      {
        unified: "1f365",
        native: "🍥",
        x: 6,
        y: 37
      }
    ],
    version: 1
  },
  moon_cake: {
    id: "moon_cake",
    name: "Moon Cake",
    keywords: [
      "food",
      "autumn"
    ],
    skins: [
      {
        unified: "1f96e",
        native: "🥮",
        x: 43,
        y: 56
      }
    ],
    version: 11
  },
  dango: {
    id: "dango",
    name: "Dango",
    keywords: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    skins: [
      {
        unified: "1f361",
        native: "🍡",
        x: 6,
        y: 33
      }
    ],
    version: 1
  },
  dumpling: {
    id: "dumpling",
    name: "Dumpling",
    keywords: [
      "food",
      "empanada",
      "pierogi",
      "potsticker"
    ],
    skins: [
      {
        unified: "1f95f",
        native: "🥟",
        x: 43,
        y: 41
      }
    ],
    version: 5
  },
  fortune_cookie: {
    id: "fortune_cookie",
    name: "Fortune Cookie",
    keywords: [
      "food",
      "prophecy"
    ],
    skins: [
      {
        unified: "1f960",
        native: "🥠",
        x: 43,
        y: 42
      }
    ],
    version: 5
  },
  takeout_box: {
    id: "takeout_box",
    name: "Takeout Box",
    keywords: [
      "food",
      "leftovers"
    ],
    skins: [
      {
        unified: "1f961",
        native: "🥡",
        x: 43,
        y: 43
      }
    ],
    version: 5
  },
  crab: {
    id: "crab",
    name: "Crab",
    keywords: [
      "animal",
      "crustacean"
    ],
    skins: [
      {
        unified: "1f980",
        native: "🦀",
        x: 44,
        y: 18
      }
    ],
    version: 1
  },
  lobster: {
    id: "lobster",
    name: "Lobster",
    keywords: [
      "animal",
      "nature",
      "bisque",
      "claws",
      "seafood"
    ],
    skins: [
      {
        unified: "1f99e",
        native: "🦞",
        x: 44,
        y: 48
      }
    ],
    version: 11
  },
  shrimp: {
    id: "shrimp",
    name: "Shrimp",
    keywords: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    skins: [
      {
        unified: "1f990",
        native: "🦐",
        x: 44,
        y: 34
      }
    ],
    version: 3
  },
  squid: {
    id: "squid",
    name: "Squid",
    keywords: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    skins: [
      {
        unified: "1f991",
        native: "🦑",
        x: 44,
        y: 35
      }
    ],
    version: 3
  },
  oyster: {
    id: "oyster",
    name: "Oyster",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9aa",
        native: "🦪",
        x: 44,
        y: 60
      }
    ],
    version: 12
  },
  icecream: {
    id: "icecream",
    name: "Soft Ice Cream",
    keywords: [
      "icecream",
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f366",
        native: "🍦",
        x: 6,
        y: 38
      }
    ],
    version: 1
  },
  shaved_ice: {
    id: "shaved_ice",
    name: "Shaved Ice",
    keywords: [
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f367",
        native: "🍧",
        x: 6,
        y: 39
      }
    ],
    version: 1
  },
  ice_cream: {
    id: "ice_cream",
    name: "Ice Cream",
    keywords: [
      "food",
      "hot",
      "dessert"
    ],
    skins: [
      {
        unified: "1f368",
        native: "🍨",
        x: 6,
        y: 40
      }
    ],
    version: 1
  },
  doughnut: {
    id: "doughnut",
    name: "Doughnut",
    keywords: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    skins: [
      {
        unified: "1f369",
        native: "🍩",
        x: 6,
        y: 41
      }
    ],
    version: 1
  },
  cookie: {
    id: "cookie",
    name: "Cookie",
    keywords: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    skins: [
      {
        unified: "1f36a",
        native: "🍪",
        x: 6,
        y: 42
      }
    ],
    version: 1
  },
  birthday: {
    id: "birthday",
    name: "Birthday Cake",
    keywords: [
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f382",
        native: "🎂",
        x: 7,
        y: 5
      }
    ],
    version: 1
  },
  cake: {
    id: "cake",
    name: "Shortcake",
    keywords: [
      "cake",
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f370",
        native: "🍰",
        x: 6,
        y: 48
      }
    ],
    version: 1
  },
  cupcake: {
    id: "cupcake",
    name: "Cupcake",
    keywords: [
      "food",
      "dessert",
      "bakery",
      "sweet"
    ],
    skins: [
      {
        unified: "1f9c1",
        native: "🧁",
        x: 46,
        y: 6
      }
    ],
    version: 11
  },
  pie: {
    id: "pie",
    name: "Pie",
    keywords: [
      "food",
      "dessert",
      "pastry"
    ],
    skins: [
      {
        unified: "1f967",
        native: "🥧",
        x: 43,
        y: 49
      }
    ],
    version: 5
  },
  chocolate_bar: {
    id: "chocolate_bar",
    name: "Chocolate Bar",
    keywords: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36b",
        native: "🍫",
        x: 6,
        y: 43
      }
    ],
    version: 1
  },
  candy: {
    id: "candy",
    name: "Candy",
    keywords: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    skins: [
      {
        unified: "1f36c",
        native: "🍬",
        x: 6,
        y: 44
      }
    ],
    version: 1
  },
  lollipop: {
    id: "lollipop",
    name: "Lollipop",
    keywords: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36d",
        native: "🍭",
        x: 6,
        y: 45
      }
    ],
    version: 1
  },
  custard: {
    id: "custard",
    name: "Custard",
    keywords: [
      "dessert",
      "food"
    ],
    skins: [
      {
        unified: "1f36e",
        native: "🍮",
        x: 6,
        y: 46
      }
    ],
    version: 1
  },
  honey_pot: {
    id: "honey_pot",
    name: "Honey Pot",
    keywords: [
      "bees",
      "sweet",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f36f",
        native: "🍯",
        x: 6,
        y: 47
      }
    ],
    version: 1
  },
  baby_bottle: {
    id: "baby_bottle",
    name: "Baby Bottle",
    keywords: [
      "food",
      "container",
      "milk"
    ],
    skins: [
      {
        unified: "1f37c",
        native: "🍼",
        x: 6,
        y: 60
      }
    ],
    version: 1
  },
  glass_of_milk: {
    id: "glass_of_milk",
    name: "Glass of Milk",
    keywords: [
      "beverage",
      "drink",
      "cow"
    ],
    skins: [
      {
        unified: "1f95b",
        native: "🥛",
        x: 43,
        y: 37
      }
    ],
    version: 3
  },
  coffee: {
    id: "coffee",
    name: "Hot Beverage",
    keywords: [
      "coffee",
      "caffeine",
      "latte",
      "espresso"
    ],
    skins: [
      {
        unified: "2615",
        native: "☕",
        x: 56,
        y: 48
      }
    ],
    version: 1
  },
  teapot: {
    id: "teapot",
    name: "Teapot",
    keywords: [
      "drink",
      "hot"
    ],
    skins: [
      {
        unified: "1fad6",
        native: "🫖",
        x: 55,
        y: 8
      }
    ],
    version: 13
  },
  tea: {
    id: "tea",
    name: "Teacup Without Handle",
    keywords: [
      "tea",
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    skins: [
      {
        unified: "1f375",
        native: "🍵",
        x: 6,
        y: 53
      }
    ],
    version: 1
  },
  sake: {
    id: "sake",
    name: "Sake",
    keywords: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f376",
        native: "🍶",
        x: 6,
        y: 54
      }
    ],
    version: 1
  },
  champagne: {
    id: "champagne",
    name: "Bottle with Popping Cork",
    keywords: [
      "champagne",
      "drink",
      "wine",
      "celebration"
    ],
    skins: [
      {
        unified: "1f37e",
        native: "🍾",
        x: 7,
        y: 1
      }
    ],
    version: 1
  },
  wine_glass: {
    id: "wine_glass",
    name: "Wine Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f377",
        native: "🍷",
        x: 6,
        y: 55
      }
    ],
    version: 1
  },
  cocktail: {
    id: "cocktail",
    name: "Cocktail Glass",
    keywords: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f378",
        native: "🍸",
        x: 6,
        y: 56
      }
    ],
    version: 1
  },
  tropical_drink: {
    id: "tropical_drink",
    name: "Tropical Drink",
    keywords: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f379",
        native: "🍹",
        x: 6,
        y: 57
      }
    ],
    version: 1
  },
  beer: {
    id: "beer",
    name: "Beer Mug",
    keywords: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37a",
        native: "🍺",
        x: 6,
        y: 58
      }
    ],
    version: 1
  },
  beers: {
    id: "beers",
    name: "Clinking Beer Mugs",
    keywords: [
      "beers",
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37b",
        native: "🍻",
        x: 6,
        y: 59
      }
    ],
    version: 1
  },
  clinking_glasses: {
    id: "clinking_glasses",
    name: "Clinking Glasses",
    keywords: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers",
      "wine",
      "champagne",
      "toast"
    ],
    skins: [
      {
        unified: "1f942",
        native: "🥂",
        x: 43,
        y: 13
      }
    ],
    version: 3
  },
  tumbler_glass: {
    id: "tumbler_glass",
    name: "Tumbler Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "shot"
    ],
    skins: [
      {
        unified: "1f943",
        native: "🥃",
        x: 43,
        y: 14
      }
    ],
    version: 3
  },
  pouring_liquid: {
    id: "pouring_liquid",
    name: "Pouring Liquid",
    keywords: [
      "cup",
      "water"
    ],
    skins: [
      {
        unified: "1fad7",
        native: "🫗",
        x: 55,
        y: 9
      }
    ],
    version: 14
  },
  cup_with_straw: {
    id: "cup_with_straw",
    name: "Cup with Straw",
    keywords: [
      "drink",
      "soda"
    ],
    skins: [
      {
        unified: "1f964",
        native: "🥤",
        x: 43,
        y: 46
      }
    ],
    version: 5
  },
  bubble_tea: {
    id: "bubble_tea",
    name: "Bubble Tea",
    keywords: [
      "taiwan",
      "boba",
      "milk",
      "straw"
    ],
    skins: [
      {
        unified: "1f9cb",
        native: "🧋",
        x: 46,
        y: 16
      }
    ],
    version: 13
  },
  beverage_box: {
    id: "beverage_box",
    name: "Beverage Box",
    keywords: [
      "drink"
    ],
    skins: [
      {
        unified: "1f9c3",
        native: "🧃",
        x: 46,
        y: 8
      }
    ],
    version: 12
  },
  mate_drink: {
    id: "mate_drink",
    name: "Mate",
    keywords: [
      "drink",
      "tea",
      "beverage"
    ],
    skins: [
      {
        unified: "1f9c9",
        native: "🧉",
        x: 46,
        y: 14
      }
    ],
    version: 12
  },
  ice_cube: {
    id: "ice_cube",
    name: "Ice",
    keywords: [
      "cube",
      "water",
      "cold"
    ],
    skins: [
      {
        unified: "1f9ca",
        native: "🧊",
        x: 46,
        y: 15
      }
    ],
    version: 12
  },
  chopsticks: {
    id: "chopsticks",
    name: "Chopsticks",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f962",
        native: "🥢",
        x: 43,
        y: 44
      }
    ],
    version: 5
  },
  knife_fork_plate: {
    id: "knife_fork_plate",
    name: "Fork and Knife with Plate",
    keywords: [
      "food",
      "eat",
      "meal",
      "lunch",
      "dinner",
      "restaurant"
    ],
    skins: [
      {
        unified: "1f37d-fe0f",
        native: "🍽️",
        x: 7,
        y: 0
      }
    ],
    version: 1
  },
  fork_and_knife: {
    id: "fork_and_knife",
    name: "Fork and Knife",
    keywords: [
      "cutlery",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f374",
        native: "🍴",
        x: 6,
        y: 52
      }
    ],
    version: 1
  },
  spoon: {
    id: "spoon",
    name: "Spoon",
    keywords: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    skins: [
      {
        unified: "1f944",
        native: "🥄",
        x: 43,
        y: 15
      }
    ],
    version: 3
  },
  hocho: {
    id: "hocho",
    name: "Hocho",
    keywords: [
      "knife",
      "kitchen",
      "blade",
      "cutlery",
      "weapon"
    ],
    skins: [
      {
        unified: "1f52a",
        native: "🔪",
        x: 30,
        y: 6
      }
    ],
    version: 1
  },
  jar: {
    id: "jar",
    name: "Jar",
    keywords: [
      "container",
      "sauce"
    ],
    skins: [
      {
        unified: "1fad9",
        native: "🫙",
        x: 55,
        y: 11
      }
    ],
    version: 14
  },
  amphora: {
    id: "amphora",
    name: "Amphora",
    keywords: [
      "vase",
      "jar"
    ],
    skins: [
      {
        unified: "1f3fa",
        native: "🏺",
        x: 10,
        y: 40
      }
    ],
    version: 1
  },
  earth_africa: {
    id: "earth_africa",
    name: "Earth Globe Europe-Africa",
    keywords: [
      "africa",
      "showing",
      "europe",
      "world",
      "international"
    ],
    skins: [
      {
        unified: "1f30d",
        native: "🌍",
        x: 5,
        y: 12
      }
    ],
    version: 1
  },
  earth_americas: {
    id: "earth_americas",
    name: "Earth Globe Americas",
    keywords: [
      "showing",
      "world",
      "USA",
      "international"
    ],
    skins: [
      {
        unified: "1f30e",
        native: "🌎",
        x: 5,
        y: 13
      }
    ],
    version: 1
  },
  earth_asia: {
    id: "earth_asia",
    name: "Earth Globe Asia-Australia",
    keywords: [
      "asia",
      "showing",
      "australia",
      "world",
      "east",
      "international"
    ],
    skins: [
      {
        unified: "1f30f",
        native: "🌏",
        x: 5,
        y: 14
      }
    ],
    version: 1
  },
  globe_with_meridians: {
    id: "globe_with_meridians",
    name: "Globe with Meridians",
    keywords: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    skins: [
      {
        unified: "1f310",
        native: "🌐",
        x: 5,
        y: 15
      }
    ],
    version: 1
  },
  world_map: {
    id: "world_map",
    name: "World Map",
    keywords: [
      "location",
      "direction"
    ],
    skins: [
      {
        unified: "1f5fa-fe0f",
        native: "🗺️",
        x: 32,
        y: 14
      }
    ],
    version: 1
  },
  japan: {
    id: "japan",
    name: "Map of Japan",
    keywords: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    skins: [
      {
        unified: "1f5fe",
        native: "🗾",
        x: 32,
        y: 18
      }
    ],
    version: 1
  },
  compass: {
    id: "compass",
    name: "Compass",
    keywords: [
      "magnetic",
      "navigation",
      "orienteering"
    ],
    skins: [
      {
        unified: "1f9ed",
        native: "🧭",
        x: 53,
        y: 27
      }
    ],
    version: 11
  },
  snow_capped_mountain: {
    id: "snow_capped_mountain",
    name: "Snow-Capped Mountain",
    keywords: [
      "snow",
      "capped",
      "photo",
      "nature",
      "environment",
      "winter",
      "cold"
    ],
    skins: [
      {
        unified: "1f3d4-fe0f",
        native: "🏔️",
        x: 9,
        y: 60
      }
    ],
    version: 1
  },
  mountain: {
    id: "mountain",
    name: "Mountain",
    keywords: [
      "photo",
      "nature",
      "environment"
    ],
    skins: [
      {
        unified: "26f0-fe0f",
        native: "⛰️",
        x: 57,
        y: 56
      }
    ],
    version: 1
  },
  volcano: {
    id: "volcano",
    name: "Volcano",
    keywords: [
      "photo",
      "nature",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30b",
        native: "🌋",
        x: 5,
        y: 10
      }
    ],
    version: 1
  },
  mount_fuji: {
    id: "mount_fuji",
    name: "Mount Fuji",
    keywords: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fb",
        native: "🗻",
        x: 32,
        y: 15
      }
    ],
    version: 1
  },
  camping: {
    id: "camping",
    name: "Camping",
    keywords: [
      "photo",
      "outdoors",
      "tent"
    ],
    skins: [
      {
        unified: "1f3d5-fe0f",
        native: "🏕️",
        x: 10,
        y: 0
      }
    ],
    version: 1
  },
  beach_with_umbrella: {
    id: "beach_with_umbrella",
    name: "Beach with Umbrella",
    keywords: [
      "weather",
      "summer",
      "sunny",
      "sand",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3d6-fe0f",
        native: "🏖️",
        x: 10,
        y: 1
      }
    ],
    version: 1
  },
  desert: {
    id: "desert",
    name: "Desert",
    keywords: [
      "photo",
      "warm",
      "saharah"
    ],
    skins: [
      {
        unified: "1f3dc-fe0f",
        native: "🏜️",
        x: 10,
        y: 7
      }
    ],
    version: 1
  },
  desert_island: {
    id: "desert_island",
    name: "Desert Island",
    keywords: [
      "photo",
      "tropical",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3dd-fe0f",
        native: "🏝️",
        x: 10,
        y: 8
      }
    ],
    version: 1
  },
  national_park: {
    id: "national_park",
    name: "National Park",
    keywords: [
      "photo",
      "environment",
      "nature"
    ],
    skins: [
      {
        unified: "1f3de-fe0f",
        native: "🏞️",
        x: 10,
        y: 9
      }
    ],
    version: 1
  },
  stadium: {
    id: "stadium",
    name: "Stadium",
    keywords: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    skins: [
      {
        unified: "1f3df-fe0f",
        native: "🏟️",
        x: 10,
        y: 10
      }
    ],
    version: 1
  },
  classical_building: {
    id: "classical_building",
    name: "Classical Building",
    keywords: [
      "art",
      "culture",
      "history"
    ],
    skins: [
      {
        unified: "1f3db-fe0f",
        native: "🏛️",
        x: 10,
        y: 6
      }
    ],
    version: 1
  },
  building_construction: {
    id: "building_construction",
    name: "Building Construction",
    keywords: [
      "wip",
      "working",
      "progress"
    ],
    skins: [
      {
        unified: "1f3d7-fe0f",
        native: "🏗️",
        x: 10,
        y: 2
      }
    ],
    version: 1
  },
  bricks: {
    id: "bricks",
    name: "Brick",
    keywords: [
      "bricks"
    ],
    skins: [
      {
        unified: "1f9f1",
        native: "🧱",
        x: 53,
        y: 31
      }
    ],
    version: 11
  },
  rock: {
    id: "rock",
    name: "Rock",
    keywords: [
      "stone"
    ],
    skins: [
      {
        unified: "1faa8",
        native: "🪨",
        x: 54,
        y: 26
      }
    ],
    version: 13
  },
  wood: {
    id: "wood",
    name: "Wood",
    keywords: [
      "nature",
      "timber",
      "trunk"
    ],
    skins: [
      {
        unified: "1fab5",
        native: "🪵",
        x: 54,
        y: 36
      }
    ],
    version: 13
  },
  hut: {
    id: "hut",
    name: "Hut",
    keywords: [
      "house",
      "structure"
    ],
    skins: [
      {
        unified: "1f6d6",
        native: "🛖",
        x: 38,
        y: 6
      }
    ],
    version: 13
  },
  house_buildings: {
    id: "house_buildings",
    name: "Houses",
    keywords: [
      "house",
      "buildings",
      "photo"
    ],
    skins: [
      {
        unified: "1f3d8-fe0f",
        native: "🏘️",
        x: 10,
        y: 3
      }
    ],
    version: 1
  },
  derelict_house_building: {
    id: "derelict_house_building",
    name: "Derelict House",
    keywords: [
      "building",
      "abandon",
      "evict",
      "broken"
    ],
    skins: [
      {
        unified: "1f3da-fe0f",
        native: "🏚️",
        x: 10,
        y: 5
      }
    ],
    version: 1
  },
  house: {
    id: "house",
    name: "House",
    keywords: [
      "building",
      "home"
    ],
    skins: [
      {
        unified: "1f3e0",
        native: "🏠",
        x: 10,
        y: 11
      }
    ],
    version: 1
  },
  house_with_garden: {
    id: "house_with_garden",
    name: "House with Garden",
    keywords: [
      "home",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f3e1",
        native: "🏡",
        x: 10,
        y: 12
      }
    ],
    version: 1
  },
  office: {
    id: "office",
    name: "Office Building",
    keywords: [
      "bureau",
      "work"
    ],
    skins: [
      {
        unified: "1f3e2",
        native: "🏢",
        x: 10,
        y: 13
      }
    ],
    version: 1
  },
  post_office: {
    id: "post_office",
    name: "Japanese Post Office",
    keywords: [
      "building",
      "envelope",
      "communication"
    ],
    skins: [
      {
        unified: "1f3e3",
        native: "🏣",
        x: 10,
        y: 14
      }
    ],
    version: 1
  },
  european_post_office: {
    id: "european_post_office",
    name: "Post Office",
    keywords: [
      "european",
      "building",
      "email"
    ],
    skins: [
      {
        unified: "1f3e4",
        native: "🏤",
        x: 10,
        y: 15
      }
    ],
    version: 1
  },
  hospital: {
    id: "hospital",
    name: "Hospital",
    keywords: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    skins: [
      {
        unified: "1f3e5",
        native: "🏥",
        x: 10,
        y: 16
      }
    ],
    version: 1
  },
  bank: {
    id: "bank",
    name: "Bank",
    keywords: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    skins: [
      {
        unified: "1f3e6",
        native: "🏦",
        x: 10,
        y: 17
      }
    ],
    version: 1
  },
  hotel: {
    id: "hotel",
    name: "Hotel",
    keywords: [
      "building",
      "accomodation",
      "checkin"
    ],
    skins: [
      {
        unified: "1f3e8",
        native: "🏨",
        x: 10,
        y: 19
      }
    ],
    version: 1
  },
  love_hotel: {
    id: "love_hotel",
    name: "Love Hotel",
    keywords: [
      "like",
      "affection",
      "dating"
    ],
    skins: [
      {
        unified: "1f3e9",
        native: "🏩",
        x: 10,
        y: 20
      }
    ],
    version: 1
  },
  convenience_store: {
    id: "convenience_store",
    name: "Convenience Store",
    keywords: [
      "building",
      "shopping",
      "groceries"
    ],
    skins: [
      {
        unified: "1f3ea",
        native: "🏪",
        x: 10,
        y: 21
      }
    ],
    version: 1
  },
  school: {
    id: "school",
    name: "School",
    keywords: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    skins: [
      {
        unified: "1f3eb",
        native: "🏫",
        x: 10,
        y: 22
      }
    ],
    version: 1
  },
  department_store: {
    id: "department_store",
    name: "Department Store",
    keywords: [
      "building",
      "shopping",
      "mall"
    ],
    skins: [
      {
        unified: "1f3ec",
        native: "🏬",
        x: 10,
        y: 23
      }
    ],
    version: 1
  },
  factory: {
    id: "factory",
    name: "Factory",
    keywords: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    skins: [
      {
        unified: "1f3ed",
        native: "🏭",
        x: 10,
        y: 24
      }
    ],
    version: 1
  },
  japanese_castle: {
    id: "japanese_castle",
    name: "Japanese Castle",
    keywords: [
      "photo",
      "building"
    ],
    skins: [
      {
        unified: "1f3ef",
        native: "🏯",
        x: 10,
        y: 26
      }
    ],
    version: 1
  },
  european_castle: {
    id: "european_castle",
    name: "Castle",
    keywords: [
      "european",
      "building",
      "royalty",
      "history"
    ],
    skins: [
      {
        unified: "1f3f0",
        native: "🏰",
        x: 10,
        y: 27
      }
    ],
    version: 1
  },
  wedding: {
    id: "wedding",
    name: "Wedding",
    keywords: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    skins: [
      {
        unified: "1f492",
        native: "💒",
        x: 27,
        y: 33
      }
    ],
    version: 1
  },
  tokyo_tower: {
    id: "tokyo_tower",
    name: "Tokyo Tower",
    keywords: [
      "photo",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fc",
        native: "🗼",
        x: 32,
        y: 16
      }
    ],
    version: 1
  },
  statue_of_liberty: {
    id: "statue_of_liberty",
    name: "Statue of Liberty",
    keywords: [
      "american",
      "newyork"
    ],
    skins: [
      {
        unified: "1f5fd",
        native: "🗽",
        x: 32,
        y: 17
      }
    ],
    version: 1
  },
  church: {
    id: "church",
    name: "Church",
    keywords: [
      "building",
      "religion",
      "christ"
    ],
    skins: [
      {
        unified: "26ea",
        native: "⛪",
        x: 57,
        y: 55
      }
    ],
    version: 1
  },
  mosque: {
    id: "mosque",
    name: "Mosque",
    keywords: [
      "islam",
      "worship",
      "minaret"
    ],
    skins: [
      {
        unified: "1f54c",
        native: "🕌",
        x: 30,
        y: 29
      }
    ],
    version: 1
  },
  hindu_temple: {
    id: "hindu_temple",
    name: "Hindu Temple",
    keywords: [
      "religion"
    ],
    skins: [
      {
        unified: "1f6d5",
        native: "🛕",
        x: 38,
        y: 5
      }
    ],
    version: 12
  },
  synagogue: {
    id: "synagogue",
    name: "Synagogue",
    keywords: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54d",
        native: "🕍",
        x: 30,
        y: 30
      }
    ],
    version: 1
  },
  shinto_shrine: {
    id: "shinto_shrine",
    name: "Shinto Shrine",
    keywords: [
      "temple",
      "japan",
      "kyoto"
    ],
    skins: [
      {
        unified: "26e9-fe0f",
        native: "⛩️",
        x: 57,
        y: 54
      }
    ],
    version: 1
  },
  kaaba: {
    id: "kaaba",
    name: "Kaaba",
    keywords: [
      "mecca",
      "mosque",
      "islam"
    ],
    skins: [
      {
        unified: "1f54b",
        native: "🕋",
        x: 30,
        y: 28
      }
    ],
    version: 1
  },
  fountain: {
    id: "fountain",
    name: "Fountain",
    keywords: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    skins: [
      {
        unified: "26f2",
        native: "⛲",
        x: 57,
        y: 58
      }
    ],
    version: 1
  },
  tent: {
    id: "tent",
    name: "Tent",
    keywords: [
      "photo",
      "camping",
      "outdoors"
    ],
    skins: [
      {
        unified: "26fa",
        native: "⛺",
        x: 58,
        y: 21
      }
    ],
    version: 1
  },
  foggy: {
    id: "foggy",
    name: "Foggy",
    keywords: [
      "photo",
      "mountain"
    ],
    skins: [
      {
        unified: "1f301",
        native: "🌁",
        x: 5,
        y: 0
      }
    ],
    version: 1
  },
  night_with_stars: {
    id: "night_with_stars",
    name: "Night with Stars",
    keywords: [
      "evening",
      "city",
      "downtown"
    ],
    skins: [
      {
        unified: "1f303",
        native: "🌃",
        x: 5,
        y: 2
      }
    ],
    version: 1
  },
  cityscape: {
    id: "cityscape",
    name: "Cityscape",
    keywords: [
      "photo",
      "night",
      "life",
      "urban"
    ],
    skins: [
      {
        unified: "1f3d9-fe0f",
        native: "🏙️",
        x: 10,
        y: 4
      }
    ],
    version: 1
  },
  sunrise_over_mountains: {
    id: "sunrise_over_mountains",
    name: "Sunrise over Mountains",
    keywords: [
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f304",
        native: "🌄",
        x: 5,
        y: 3
      }
    ],
    version: 1
  },
  sunrise: {
    id: "sunrise",
    name: "Sunrise",
    keywords: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f305",
        native: "🌅",
        x: 5,
        y: 4
      }
    ],
    version: 1
  },
  city_sunset: {
    id: "city_sunset",
    name: "Cityscape at Dusk",
    keywords: [
      "city",
      "sunset",
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    skins: [
      {
        unified: "1f306",
        native: "🌆",
        x: 5,
        y: 5
      }
    ],
    version: 1
  },
  city_sunrise: {
    id: "city_sunrise",
    name: "Sunset",
    keywords: [
      "city",
      "sunrise",
      "photo",
      "good",
      "morning",
      "dawn"
    ],
    skins: [
      {
        unified: "1f307",
        native: "🌇",
        x: 5,
        y: 6
      }
    ],
    version: 1
  },
  bridge_at_night: {
    id: "bridge_at_night",
    name: "Bridge at Night",
    keywords: [
      "photo",
      "sanfrancisco"
    ],
    skins: [
      {
        unified: "1f309",
        native: "🌉",
        x: 5,
        y: 8
      }
    ],
    version: 1
  },
  hotsprings: {
    id: "hotsprings",
    name: "Hot Springs",
    keywords: [
      "hotsprings",
      "bath",
      "warm",
      "relax"
    ],
    skins: [
      {
        unified: "2668-fe0f",
        native: "♨️",
        x: 57,
        y: 24
      }
    ],
    version: 1
  },
  carousel_horse: {
    id: "carousel_horse",
    name: "Carousel Horse",
    keywords: [
      "photo",
      "carnival"
    ],
    skins: [
      {
        unified: "1f3a0",
        native: "🎠",
        x: 7,
        y: 35
      }
    ],
    version: 1
  },
  playground_slide: {
    id: "playground_slide",
    name: "Playground Slide",
    keywords: [
      "fun",
      "park"
    ],
    skins: [
      {
        unified: "1f6dd",
        native: "🛝",
        x: 38,
        y: 8
      }
    ],
    version: 14
  },
  ferris_wheel: {
    id: "ferris_wheel",
    name: "Ferris Wheel",
    keywords: [
      "photo",
      "carnival",
      "londoneye"
    ],
    skins: [
      {
        unified: "1f3a1",
        native: "🎡",
        x: 7,
        y: 36
      }
    ],
    version: 1
  },
  roller_coaster: {
    id: "roller_coaster",
    name: "Roller Coaster",
    keywords: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    skins: [
      {
        unified: "1f3a2",
        native: "🎢",
        x: 7,
        y: 37
      }
    ],
    version: 1
  },
  barber: {
    id: "barber",
    name: "Barber Pole",
    keywords: [
      "hair",
      "salon",
      "style"
    ],
    skins: [
      {
        unified: "1f488",
        native: "💈",
        x: 26,
        y: 34
      }
    ],
    version: 1
  },
  circus_tent: {
    id: "circus_tent",
    name: "Circus Tent",
    keywords: [
      "festival",
      "carnival",
      "party"
    ],
    skins: [
      {
        unified: "1f3aa",
        native: "🎪",
        x: 7,
        y: 45
      }
    ],
    version: 1
  },
  steam_locomotive: {
    id: "steam_locomotive",
    name: "Locomotive",
    keywords: [
      "steam",
      "transportation",
      "vehicle",
      "train"
    ],
    skins: [
      {
        unified: "1f682",
        native: "🚂",
        x: 35,
        y: 34
      }
    ],
    version: 1
  },
  railway_car: {
    id: "railway_car",
    name: "Railway Car",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f683",
        native: "🚃",
        x: 35,
        y: 35
      }
    ],
    version: 1
  },
  bullettrain_side: {
    id: "bullettrain_side",
    name: "High-Speed Train",
    keywords: [
      "bullettrain",
      "side",
      "high",
      "speed",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f684",
        native: "🚄",
        x: 35,
        y: 36
      }
    ],
    version: 1
  },
  bullettrain_front: {
    id: "bullettrain_front",
    name: "Bullet Train",
    keywords: [
      "bullettrain",
      "front",
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f685",
        native: "🚅",
        x: 35,
        y: 37
      }
    ],
    version: 1
  },
  train2: {
    id: "train2",
    name: "Train",
    keywords: [
      "train2",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f686",
        native: "🚆",
        x: 35,
        y: 38
      }
    ],
    version: 1
  },
  metro: {
    id: "metro",
    name: "Metro",
    keywords: [
      "transportation",
      "blue",
      "square",
      "mrt",
      "underground",
      "tube"
    ],
    skins: [
      {
        unified: "1f687",
        native: "🚇",
        x: 35,
        y: 39
      }
    ],
    version: 1
  },
  light_rail: {
    id: "light_rail",
    name: "Light Rail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f688",
        native: "🚈",
        x: 35,
        y: 40
      }
    ],
    version: 1
  },
  station: {
    id: "station",
    name: "Station",
    keywords: [
      "transportation",
      "vehicle",
      "public"
    ],
    skins: [
      {
        unified: "1f689",
        native: "🚉",
        x: 35,
        y: 41
      }
    ],
    version: 1
  },
  tram: {
    id: "tram",
    name: "Tram",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68a",
        native: "🚊",
        x: 35,
        y: 42
      }
    ],
    version: 1
  },
  monorail: {
    id: "monorail",
    name: "Monorail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69d",
        native: "🚝",
        x: 36,
        y: 0
      }
    ],
    version: 1
  },
  mountain_railway: {
    id: "mountain_railway",
    name: "Mountain Railway",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69e",
        native: "🚞",
        x: 36,
        y: 1
      }
    ],
    version: 1
  },
  train: {
    id: "train",
    name: "Tram Car",
    keywords: [
      "train",
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f68b",
        native: "🚋",
        x: 35,
        y: 43
      }
    ],
    version: 1
  },
  bus: {
    id: "bus",
    name: "Bus",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68c",
        native: "🚌",
        x: 35,
        y: 44
      }
    ],
    version: 1
  },
  oncoming_bus: {
    id: "oncoming_bus",
    name: "Oncoming Bus",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68d",
        native: "🚍",
        x: 35,
        y: 45
      }
    ],
    version: 1
  },
  trolleybus: {
    id: "trolleybus",
    name: "Trolleybus",
    keywords: [
      "bart",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68e",
        native: "🚎",
        x: 35,
        y: 46
      }
    ],
    version: 1
  },
  minibus: {
    id: "minibus",
    name: "Minibus",
    keywords: [
      "vehicle",
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f690",
        native: "🚐",
        x: 35,
        y: 48
      }
    ],
    version: 1
  },
  ambulance: {
    id: "ambulance",
    name: "Ambulance",
    keywords: [
      "health",
      "911",
      "hospital"
    ],
    skins: [
      {
        unified: "1f691",
        native: "🚑",
        x: 35,
        y: 49
      }
    ],
    version: 1
  },
  fire_engine: {
    id: "fire_engine",
    name: "Fire Engine",
    keywords: [
      "transportation",
      "cars",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f692",
        native: "🚒",
        x: 35,
        y: 50
      }
    ],
    version: 1
  },
  police_car: {
    id: "police_car",
    name: "Police Car",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    skins: [
      {
        unified: "1f693",
        native: "🚓",
        x: 35,
        y: 51
      }
    ],
    version: 1
  },
  oncoming_police_car: {
    id: "oncoming_police_car",
    name: "Oncoming Police Car",
    keywords: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    skins: [
      {
        unified: "1f694",
        native: "🚔",
        x: 35,
        y: 52
      }
    ],
    version: 1
  },
  taxi: {
    id: "taxi",
    name: "Taxi",
    keywords: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f695",
        native: "🚕",
        x: 35,
        y: 53
      }
    ],
    version: 1
  },
  oncoming_taxi: {
    id: "oncoming_taxi",
    name: "Oncoming Taxi",
    keywords: [
      "vehicle",
      "cars",
      "uber"
    ],
    skins: [
      {
        unified: "1f696",
        native: "🚖",
        x: 35,
        y: 54
      }
    ],
    version: 1
  },
  car: {
    id: "car",
    name: "Automobile",
    keywords: [
      "car",
      "red",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f697",
        native: "🚗",
        x: 35,
        y: 55
      }
    ],
    version: 1
  },
  oncoming_automobile: {
    id: "oncoming_automobile",
    name: "Oncoming Automobile",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f698",
        native: "🚘",
        x: 35,
        y: 56
      }
    ],
    version: 1
  },
  blue_car: {
    id: "blue_car",
    name: "Recreational Vehicle",
    keywords: [
      "blue",
      "car",
      "sport",
      "utility",
      "transportation"
    ],
    skins: [
      {
        unified: "1f699",
        native: "🚙",
        x: 35,
        y: 57
      }
    ],
    version: 1
  },
  pickup_truck: {
    id: "pickup_truck",
    name: "Pickup Truck",
    keywords: [
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fb",
        native: "🛻",
        x: 38,
        y: 29
      }
    ],
    version: 13
  },
  truck: {
    id: "truck",
    name: "Delivery Truck",
    keywords: [
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69a",
        native: "🚚",
        x: 35,
        y: 58
      }
    ],
    version: 1
  },
  articulated_lorry: {
    id: "articulated_lorry",
    name: "Articulated Lorry",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    skins: [
      {
        unified: "1f69b",
        native: "🚛",
        x: 35,
        y: 59
      }
    ],
    version: 1
  },
  tractor: {
    id: "tractor",
    name: "Tractor",
    keywords: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    skins: [
      {
        unified: "1f69c",
        native: "🚜",
        x: 35,
        y: 60
      }
    ],
    version: 1
  },
  racing_car: {
    id: "racing_car",
    name: "Racing Car",
    keywords: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    skins: [
      {
        unified: "1f3ce-fe0f",
        native: "🏎️",
        x: 9,
        y: 54
      }
    ],
    version: 1
  },
  racing_motorcycle: {
    id: "racing_motorcycle",
    name: "Motorcycle",
    keywords: [
      "racing",
      "race",
      "sports",
      "fast"
    ],
    skins: [
      {
        unified: "1f3cd-fe0f",
        native: "🏍️",
        x: 9,
        y: 53
      }
    ],
    version: 1
  },
  motor_scooter: {
    id: "motor_scooter",
    name: "Motor Scooter",
    keywords: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    skins: [
      {
        unified: "1f6f5",
        native: "🛵",
        x: 38,
        y: 23
      }
    ],
    version: 3
  },
  manual_wheelchair: {
    id: "manual_wheelchair",
    name: "Manual Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bd",
        native: "🦽",
        x: 46,
        y: 2
      }
    ],
    version: 12
  },
  motorized_wheelchair: {
    id: "motorized_wheelchair",
    name: "Motorized Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bc",
        native: "🦼",
        x: 46,
        y: 1
      }
    ],
    version: 12
  },
  auto_rickshaw: {
    id: "auto_rickshaw",
    name: "Auto Rickshaw",
    keywords: [
      "move",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fa",
        native: "🛺",
        x: 38,
        y: 28
      }
    ],
    version: 12
  },
  bike: {
    id: "bike",
    name: "Bicycle",
    keywords: [
      "bike",
      "sports",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b2",
        native: "🚲",
        x: 36,
        y: 38
      }
    ],
    version: 1
  },
  scooter: {
    id: "scooter",
    name: "Scooter",
    keywords: [
      "kick",
      "vehicle",
      "razor"
    ],
    skins: [
      {
        unified: "1f6f4",
        native: "🛴",
        x: 38,
        y: 22
      }
    ],
    version: 3
  },
  skateboard: {
    id: "skateboard",
    name: "Skateboard",
    keywords: [
      "board"
    ],
    skins: [
      {
        unified: "1f6f9",
        native: "🛹",
        x: 38,
        y: 27
      }
    ],
    version: 11
  },
  roller_skate: {
    id: "roller_skate",
    name: "Roller Skate",
    keywords: [
      "footwear",
      "sports"
    ],
    skins: [
      {
        unified: "1f6fc",
        native: "🛼",
        x: 38,
        y: 30
      }
    ],
    version: 13
  },
  busstop: {
    id: "busstop",
    name: "Bus Stop",
    keywords: [
      "busstop",
      "transportation",
      "wait"
    ],
    skins: [
      {
        unified: "1f68f",
        native: "🚏",
        x: 35,
        y: 47
      }
    ],
    version: 1
  },
  motorway: {
    id: "motorway",
    name: "Motorway",
    keywords: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    skins: [
      {
        unified: "1f6e3-fe0f",
        native: "🛣️",
        x: 38,
        y: 14
      }
    ],
    version: 1
  },
  railway_track: {
    id: "railway_track",
    name: "Railway Track",
    keywords: [
      "train",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6e4-fe0f",
        native: "🛤️",
        x: 38,
        y: 15
      }
    ],
    version: 1
  },
  oil_drum: {
    id: "oil_drum",
    name: "Oil Drum",
    keywords: [
      "barrell"
    ],
    skins: [
      {
        unified: "1f6e2-fe0f",
        native: "🛢️",
        x: 38,
        y: 13
      }
    ],
    version: 1
  },
  fuelpump: {
    id: "fuelpump",
    name: "Fuel Pump",
    keywords: [
      "fuelpump",
      "gas",
      "station",
      "petroleum"
    ],
    skins: [
      {
        unified: "26fd",
        native: "⛽",
        x: 58,
        y: 22
      }
    ],
    version: 1
  },
  wheel: {
    id: "wheel",
    name: "Wheel",
    keywords: [
      "car",
      "transport"
    ],
    skins: [
      {
        unified: "1f6de",
        native: "🛞",
        x: 38,
        y: 9
      }
    ],
    version: 14
  },
  rotating_light: {
    id: "rotating_light",
    name: "Police Car Light",
    keywords: [
      "rotating",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "1f6a8",
        native: "🚨",
        x: 36,
        y: 28
      }
    ],
    version: 1
  },
  traffic_light: {
    id: "traffic_light",
    name: "Horizontal Traffic Light",
    keywords: [
      "transportation",
      "signal"
    ],
    skins: [
      {
        unified: "1f6a5",
        native: "🚥",
        x: 36,
        y: 25
      }
    ],
    version: 1
  },
  vertical_traffic_light: {
    id: "vertical_traffic_light",
    name: "Vertical Traffic Light",
    keywords: [
      "transportation",
      "driving"
    ],
    skins: [
      {
        unified: "1f6a6",
        native: "🚦",
        x: 36,
        y: 26
      }
    ],
    version: 1
  },
  octagonal_sign: {
    id: "octagonal_sign",
    name: "Stop Sign",
    keywords: [
      "octagonal"
    ],
    skins: [
      {
        unified: "1f6d1",
        native: "🛑",
        x: 38,
        y: 3
      }
    ],
    version: 3
  },
  construction: {
    id: "construction",
    name: "Construction",
    keywords: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    skins: [
      {
        unified: "1f6a7",
        native: "🚧",
        x: 36,
        y: 27
      }
    ],
    version: 1
  },
  anchor: {
    id: "anchor",
    name: "Anchor",
    keywords: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    skins: [
      {
        unified: "2693",
        native: "⚓",
        x: 57,
        y: 29
      }
    ],
    version: 1
  },
  ring_buoy: {
    id: "ring_buoy",
    name: "Ring Buoy",
    keywords: [
      "life",
      "saver",
      "preserver"
    ],
    skins: [
      {
        unified: "1f6df",
        native: "🛟",
        x: 38,
        y: 10
      }
    ],
    version: 14
  },
  boat: {
    id: "boat",
    name: "Sailboat",
    keywords: [
      "boat",
      "ship",
      "summer",
      "transportation",
      "water",
      "sailing"
    ],
    skins: [
      {
        unified: "26f5",
        native: "⛵",
        x: 58,
        y: 0
      }
    ],
    version: 1
  },
  canoe: {
    id: "canoe",
    name: "Canoe",
    keywords: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6f6",
        native: "🛶",
        x: 38,
        y: 24
      }
    ],
    version: 3
  },
  speedboat: {
    id: "speedboat",
    name: "Speedboat",
    keywords: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    skins: [
      {
        unified: "1f6a4",
        native: "🚤",
        x: 36,
        y: 24
      }
    ],
    version: 1
  },
  passenger_ship: {
    id: "passenger_ship",
    name: "Passenger Ship",
    keywords: [
      "yacht",
      "cruise",
      "ferry"
    ],
    skins: [
      {
        unified: "1f6f3-fe0f",
        native: "🛳️",
        x: 38,
        y: 21
      }
    ],
    version: 1
  },
  ferry: {
    id: "ferry",
    name: "Ferry",
    keywords: [
      "boat",
      "ship",
      "yacht"
    ],
    skins: [
      {
        unified: "26f4-fe0f",
        native: "⛴️",
        x: 57,
        y: 60
      }
    ],
    version: 1
  },
  motor_boat: {
    id: "motor_boat",
    name: "Motor Boat",
    keywords: [
      "ship"
    ],
    skins: [
      {
        unified: "1f6e5-fe0f",
        native: "🛥️",
        x: 38,
        y: 16
      }
    ],
    version: 1
  },
  ship: {
    id: "ship",
    name: "Ship",
    keywords: [
      "transportation",
      "titanic",
      "deploy"
    ],
    skins: [
      {
        unified: "1f6a2",
        native: "🚢",
        x: 36,
        y: 5
      }
    ],
    version: 1
  },
  airplane: {
    id: "airplane",
    name: "Airplane",
    keywords: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "2708-fe0f",
        native: "✈️",
        x: 58,
        y: 25
      }
    ],
    version: 1
  },
  small_airplane: {
    id: "small_airplane",
    name: "Small Airplane",
    keywords: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f6e9-fe0f",
        native: "🛩️",
        x: 38,
        y: 17
      }
    ],
    version: 1
  },
  airplane_departure: {
    id: "airplane_departure",
    name: "Airplane Departure",
    keywords: [
      "airport",
      "flight",
      "landing"
    ],
    skins: [
      {
        unified: "1f6eb",
        native: "🛫",
        x: 38,
        y: 18
      }
    ],
    version: 1
  },
  airplane_arriving: {
    id: "airplane_arriving",
    name: "Airplane Arrival",
    keywords: [
      "arriving",
      "airport",
      "flight",
      "boarding"
    ],
    skins: [
      {
        unified: "1f6ec",
        native: "🛬",
        x: 38,
        y: 19
      }
    ],
    version: 1
  },
  parachute: {
    id: "parachute",
    name: "Parachute",
    keywords: [
      "fly",
      "glide"
    ],
    skins: [
      {
        unified: "1fa82",
        native: "🪂",
        x: 53,
        y: 58
      }
    ],
    version: 12
  },
  seat: {
    id: "seat",
    name: "Seat",
    keywords: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "1f4ba",
        native: "💺",
        x: 28,
        y: 17
      }
    ],
    version: 1
  },
  helicopter: {
    id: "helicopter",
    name: "Helicopter",
    keywords: [
      "transportation",
      "vehicle",
      "fly"
    ],
    skins: [
      {
        unified: "1f681",
        native: "🚁",
        x: 35,
        y: 33
      }
    ],
    version: 1
  },
  suspension_railway: {
    id: "suspension_railway",
    name: "Suspension Railway",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69f",
        native: "🚟",
        x: 36,
        y: 2
      }
    ],
    version: 1
  },
  mountain_cableway: {
    id: "mountain_cableway",
    name: "Mountain Cableway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a0",
        native: "🚠",
        x: 36,
        y: 3
      }
    ],
    version: 1
  },
  aerial_tramway: {
    id: "aerial_tramway",
    name: "Aerial Tramway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a1",
        native: "🚡",
        x: 36,
        y: 4
      }
    ],
    version: 1
  },
  satellite: {
    id: "satellite",
    name: "Satellite",
    keywords: [
      "communication",
      "gps",
      "orbit",
      "spaceflight",
      "NASA",
      "ISS"
    ],
    skins: [
      {
        unified: "1f6f0-fe0f",
        native: "🛰️",
        x: 38,
        y: 20
      }
    ],
    version: 1
  },
  rocket: {
    id: "rocket",
    name: "Rocket",
    keywords: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer",
      "space",
      "fly"
    ],
    skins: [
      {
        unified: "1f680",
        native: "🚀",
        x: 35,
        y: 32
      }
    ],
    version: 1
  },
  flying_saucer: {
    id: "flying_saucer",
    name: "Flying Saucer",
    keywords: [
      "transportation",
      "vehicle",
      "ufo"
    ],
    skins: [
      {
        unified: "1f6f8",
        native: "🛸",
        x: 38,
        y: 26
      }
    ],
    version: 5
  },
  bellhop_bell: {
    id: "bellhop_bell",
    name: "Bellhop Bell",
    keywords: [
      "service"
    ],
    skins: [
      {
        unified: "1f6ce-fe0f",
        native: "🛎️",
        x: 38,
        y: 0
      }
    ],
    version: 1
  },
  luggage: {
    id: "luggage",
    name: "Luggage",
    keywords: [
      "packing",
      "travel"
    ],
    skins: [
      {
        unified: "1f9f3",
        native: "🧳",
        x: 53,
        y: 33
      }
    ],
    version: 11
  },
  hourglass: {
    id: "hourglass",
    name: "Hourglass",
    keywords: [
      "done",
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    skins: [
      {
        unified: "231b",
        native: "⌛",
        x: 56,
        y: 14
      }
    ],
    version: 1
  },
  hourglass_flowing_sand: {
    id: "hourglass_flowing_sand",
    name: "Hourglass Not Done",
    keywords: [
      "flowing",
      "sand",
      "oldschool",
      "time",
      "countdown"
    ],
    skins: [
      {
        unified: "23f3",
        native: "⏳",
        x: 56,
        y: 27
      }
    ],
    version: 1
  },
  watch: {
    id: "watch",
    name: "Watch",
    keywords: [
      "time",
      "accessories"
    ],
    skins: [
      {
        unified: "231a",
        native: "⌚",
        x: 56,
        y: 13
      }
    ],
    version: 1
  },
  alarm_clock: {
    id: "alarm_clock",
    name: "Alarm Clock",
    keywords: [
      "time",
      "wake"
    ],
    skins: [
      {
        unified: "23f0",
        native: "⏰",
        x: 56,
        y: 24
      }
    ],
    version: 1
  },
  stopwatch: {
    id: "stopwatch",
    name: "Stopwatch",
    keywords: [
      "time",
      "deadline"
    ],
    skins: [
      {
        unified: "23f1-fe0f",
        native: "⏱️",
        x: 56,
        y: 25
      }
    ],
    version: 1
  },
  timer_clock: {
    id: "timer_clock",
    name: "Timer Clock",
    keywords: [
      "alarm"
    ],
    skins: [
      {
        unified: "23f2-fe0f",
        native: "⏲️",
        x: 56,
        y: 26
      }
    ],
    version: 1
  },
  mantelpiece_clock: {
    id: "mantelpiece_clock",
    name: "Mantelpiece Clock",
    keywords: [
      "time"
    ],
    skins: [
      {
        unified: "1f570-fe0f",
        native: "🕰️",
        x: 30,
        y: 57
      }
    ],
    version: 1
  },
  clock12: {
    id: "clock12",
    name: "Twelve O’clock",
    keywords: [
      "clock12",
      "o",
      "clock",
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55b",
        native: "🕛",
        x: 30,
        y: 43
      }
    ],
    version: 1
  },
  clock1230: {
    id: "clock1230",
    name: "Twelve-Thirty",
    keywords: [
      "clock1230",
      "twelve",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f567",
        native: "🕧",
        x: 30,
        y: 55
      }
    ],
    version: 1
  },
  clock1: {
    id: "clock1",
    name: "One O’clock",
    keywords: [
      "clock1",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f550",
        native: "🕐",
        x: 30,
        y: 32
      }
    ],
    version: 1
  },
  clock130: {
    id: "clock130",
    name: "One-Thirty",
    keywords: [
      "clock130",
      "one",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55c",
        native: "🕜",
        x: 30,
        y: 44
      }
    ],
    version: 1
  },
  clock2: {
    id: "clock2",
    name: "Two O’clock",
    keywords: [
      "clock2",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f551",
        native: "🕑",
        x: 30,
        y: 33
      }
    ],
    version: 1
  },
  clock230: {
    id: "clock230",
    name: "Two-Thirty",
    keywords: [
      "clock230",
      "two",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55d",
        native: "🕝",
        x: 30,
        y: 45
      }
    ],
    version: 1
  },
  clock3: {
    id: "clock3",
    name: "Three O’clock",
    keywords: [
      "clock3",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f552",
        native: "🕒",
        x: 30,
        y: 34
      }
    ],
    version: 1
  },
  clock330: {
    id: "clock330",
    name: "Three-Thirty",
    keywords: [
      "clock330",
      "three",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55e",
        native: "🕞",
        x: 30,
        y: 46
      }
    ],
    version: 1
  },
  clock4: {
    id: "clock4",
    name: "Four O’clock",
    keywords: [
      "clock4",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f553",
        native: "🕓",
        x: 30,
        y: 35
      }
    ],
    version: 1
  },
  clock430: {
    id: "clock430",
    name: "Four-Thirty",
    keywords: [
      "clock430",
      "four",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55f",
        native: "🕟",
        x: 30,
        y: 47
      }
    ],
    version: 1
  },
  clock5: {
    id: "clock5",
    name: "Five O’clock",
    keywords: [
      "clock5",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f554",
        native: "🕔",
        x: 30,
        y: 36
      }
    ],
    version: 1
  },
  clock530: {
    id: "clock530",
    name: "Five-Thirty",
    keywords: [
      "clock530",
      "five",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f560",
        native: "🕠",
        x: 30,
        y: 48
      }
    ],
    version: 1
  },
  clock6: {
    id: "clock6",
    name: "Six O’clock",
    keywords: [
      "clock6",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    skins: [
      {
        unified: "1f555",
        native: "🕕",
        x: 30,
        y: 37
      }
    ],
    version: 1
  },
  clock630: {
    id: "clock630",
    name: "Six-Thirty",
    keywords: [
      "clock630",
      "six",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f561",
        native: "🕡",
        x: 30,
        y: 49
      }
    ],
    version: 1
  },
  clock7: {
    id: "clock7",
    name: "Seven O’clock",
    keywords: [
      "clock7",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f556",
        native: "🕖",
        x: 30,
        y: 38
      }
    ],
    version: 1
  },
  clock730: {
    id: "clock730",
    name: "Seven-Thirty",
    keywords: [
      "clock730",
      "seven",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f562",
        native: "🕢",
        x: 30,
        y: 50
      }
    ],
    version: 1
  },
  clock8: {
    id: "clock8",
    name: "Eight O’clock",
    keywords: [
      "clock8",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f557",
        native: "🕗",
        x: 30,
        y: 39
      }
    ],
    version: 1
  },
  clock830: {
    id: "clock830",
    name: "Eight-Thirty",
    keywords: [
      "clock830",
      "eight",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f563",
        native: "🕣",
        x: 30,
        y: 51
      }
    ],
    version: 1
  },
  clock9: {
    id: "clock9",
    name: "Nine O’clock",
    keywords: [
      "clock9",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f558",
        native: "🕘",
        x: 30,
        y: 40
      }
    ],
    version: 1
  },
  clock930: {
    id: "clock930",
    name: "Nine-Thirty",
    keywords: [
      "clock930",
      "nine",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f564",
        native: "🕤",
        x: 30,
        y: 52
      }
    ],
    version: 1
  },
  clock10: {
    id: "clock10",
    name: "Ten O’clock",
    keywords: [
      "clock10",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f559",
        native: "🕙",
        x: 30,
        y: 41
      }
    ],
    version: 1
  },
  clock1030: {
    id: "clock1030",
    name: "Ten-Thirty",
    keywords: [
      "clock1030",
      "ten",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f565",
        native: "🕥",
        x: 30,
        y: 53
      }
    ],
    version: 1
  },
  clock11: {
    id: "clock11",
    name: "Eleven O’clock",
    keywords: [
      "clock11",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55a",
        native: "🕚",
        x: 30,
        y: 42
      }
    ],
    version: 1
  },
  clock1130: {
    id: "clock1130",
    name: "Eleven-Thirty",
    keywords: [
      "clock1130",
      "eleven",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f566",
        native: "🕦",
        x: 30,
        y: 54
      }
    ],
    version: 1
  },
  new_moon: {
    id: "new_moon",
    name: "New Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f311",
        native: "🌑",
        x: 5,
        y: 16
      }
    ],
    version: 1
  },
  waxing_crescent_moon: {
    id: "waxing_crescent_moon",
    name: "Waxing Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f312",
        native: "🌒",
        x: 5,
        y: 17
      }
    ],
    version: 1
  },
  first_quarter_moon: {
    id: "first_quarter_moon",
    name: "First Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f313",
        native: "🌓",
        x: 5,
        y: 18
      }
    ],
    version: 1
  },
  moon: {
    id: "moon",
    name: "Waxing Gibbous Moon",
    keywords: [
      "nature",
      "night",
      "sky",
      "gray",
      "twilight",
      "planet",
      "space",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f314",
        native: "🌔",
        x: 5,
        y: 19
      }
    ],
    version: 1
  },
  full_moon: {
    id: "full_moon",
    name: "Full Moon",
    keywords: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f315",
        native: "🌕",
        x: 5,
        y: 20
      }
    ],
    version: 1
  },
  waning_gibbous_moon: {
    id: "waning_gibbous_moon",
    name: "Waning Gibbous Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing"
    ],
    skins: [
      {
        unified: "1f316",
        native: "🌖",
        x: 5,
        y: 21
      }
    ],
    version: 1
  },
  last_quarter_moon: {
    id: "last_quarter_moon",
    name: "Last Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f317",
        native: "🌗",
        x: 5,
        y: 22
      }
    ],
    version: 1
  },
  waning_crescent_moon: {
    id: "waning_crescent_moon",
    name: "Waning Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f318",
        native: "🌘",
        x: 5,
        y: 23
      }
    ],
    version: 1
  },
  crescent_moon: {
    id: "crescent_moon",
    name: "Crescent Moon",
    keywords: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    skins: [
      {
        unified: "1f319",
        native: "🌙",
        x: 5,
        y: 24
      }
    ],
    version: 1
  },
  new_moon_with_face: {
    id: "new_moon_with_face",
    name: "New Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31a",
        native: "🌚",
        x: 5,
        y: 25
      }
    ],
    version: 1
  },
  first_quarter_moon_with_face: {
    id: "first_quarter_moon_with_face",
    name: "First Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31b",
        native: "🌛",
        x: 5,
        y: 26
      }
    ],
    version: 1
  },
  last_quarter_moon_with_face: {
    id: "last_quarter_moon_with_face",
    name: "Last Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31c",
        native: "🌜",
        x: 5,
        y: 27
      }
    ],
    version: 1
  },
  thermometer: {
    id: "thermometer",
    name: "Thermometer",
    keywords: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    skins: [
      {
        unified: "1f321-fe0f",
        native: "🌡️",
        x: 5,
        y: 32
      }
    ],
    version: 1
  },
  sunny: {
    id: "sunny",
    name: "Sun",
    keywords: [
      "sunny",
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    skins: [
      {
        unified: "2600-fe0f",
        native: "☀️",
        x: 56,
        y: 40
      }
    ],
    version: 1
  },
  full_moon_with_face: {
    id: "full_moon_with_face",
    name: "Full Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31d",
        native: "🌝",
        x: 5,
        y: 28
      }
    ],
    version: 1
  },
  sun_with_face: {
    id: "sun_with_face",
    name: "Sun with Face",
    keywords: [
      "nature",
      "morning",
      "sky"
    ],
    skins: [
      {
        unified: "1f31e",
        native: "🌞",
        x: 5,
        y: 29
      }
    ],
    version: 1
  },
  ringed_planet: {
    id: "ringed_planet",
    name: "Ringed Planet",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1fa90",
        native: "🪐",
        x: 54,
        y: 2
      }
    ],
    version: 12
  },
  star: {
    id: "star",
    name: "Star",
    keywords: [
      "night",
      "yellow"
    ],
    skins: [
      {
        unified: "2b50",
        native: "⭐",
        x: 59,
        y: 24
      }
    ],
    version: 1
  },
  star2: {
    id: "star2",
    name: "Glowing Star",
    keywords: [
      "star2",
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "1f31f",
        native: "🌟",
        x: 5,
        y: 30
      }
    ],
    version: 1
  },
  stars: {
    id: "stars",
    name: "Shooting Star",
    keywords: [
      "stars",
      "night",
      "photo"
    ],
    skins: [
      {
        unified: "1f320",
        native: "🌠",
        x: 5,
        y: 31
      }
    ],
    version: 1
  },
  milky_way: {
    id: "milky_way",
    name: "Milky Way",
    keywords: [
      "photo",
      "space",
      "stars"
    ],
    skins: [
      {
        unified: "1f30c",
        native: "🌌",
        x: 5,
        y: 11
      }
    ],
    version: 1
  },
  cloud: {
    id: "cloud",
    name: "Cloud",
    keywords: [
      "weather",
      "sky"
    ],
    skins: [
      {
        unified: "2601-fe0f",
        native: "☁️",
        x: 56,
        y: 41
      }
    ],
    version: 1
  },
  partly_sunny: {
    id: "partly_sunny",
    name: "Sun Behind Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    skins: [
      {
        unified: "26c5",
        native: "⛅",
        x: 57,
        y: 47
      }
    ],
    version: 1
  },
  thunder_cloud_and_rain: {
    id: "thunder_cloud_and_rain",
    name: "Cloud with Lightning and Rain",
    keywords: [
      "thunder",
      "weather"
    ],
    skins: [
      {
        unified: "26c8-fe0f",
        native: "⛈️",
        x: 57,
        y: 48
      }
    ],
    version: 1
  },
  mostly_sunny: {
    id: "mostly_sunny",
    name: "Sun Behind Small Cloud",
    keywords: [
      "mostly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f324-fe0f",
        native: "🌤️",
        x: 5,
        y: 33
      }
    ],
    version: 1
  },
  barely_sunny: {
    id: "barely_sunny",
    name: "Sun Behind Large Cloud",
    keywords: [
      "barely",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f325-fe0f",
        native: "🌥️",
        x: 5,
        y: 34
      }
    ],
    version: 1
  },
  partly_sunny_rain: {
    id: "partly_sunny_rain",
    name: "Sun Behind Rain Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f326-fe0f",
        native: "🌦️",
        x: 5,
        y: 35
      }
    ],
    version: 1
  },
  rain_cloud: {
    id: "rain_cloud",
    name: "Cloud with Rain",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f327-fe0f",
        native: "🌧️",
        x: 5,
        y: 36
      }
    ],
    version: 1
  },
  snow_cloud: {
    id: "snow_cloud",
    name: "Cloud with Snow",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f328-fe0f",
        native: "🌨️",
        x: 5,
        y: 37
      }
    ],
    version: 1
  },
  lightning: {
    id: "lightning",
    name: "Cloud with Lightning",
    keywords: [
      "weather",
      "thunder"
    ],
    skins: [
      {
        unified: "1f329-fe0f",
        native: "🌩️",
        x: 5,
        y: 38
      }
    ],
    version: 1
  },
  tornado: {
    id: "tornado",
    name: "Tornado",
    keywords: [
      "cloud",
      "weather",
      "cyclone",
      "twister"
    ],
    skins: [
      {
        unified: "1f32a-fe0f",
        native: "🌪️",
        x: 5,
        y: 39
      }
    ],
    version: 1
  },
  fog: {
    id: "fog",
    name: "Fog",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f32b-fe0f",
        native: "🌫️",
        x: 5,
        y: 40
      }
    ],
    version: 1
  },
  wind_blowing_face: {
    id: "wind_blowing_face",
    name: "Wind Face",
    keywords: [
      "blowing",
      "gust",
      "air"
    ],
    skins: [
      {
        unified: "1f32c-fe0f",
        native: "🌬️",
        x: 5,
        y: 41
      }
    ],
    version: 1
  },
  cyclone: {
    id: "cyclone",
    name: "Cyclone",
    keywords: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    skins: [
      {
        unified: "1f300",
        native: "🌀",
        x: 4,
        y: 60
      }
    ],
    version: 1
  },
  rainbow: {
    id: "rainbow",
    name: "Rainbow",
    keywords: [
      "nature",
      "happy",
      "unicorn",
      "face",
      "photo",
      "sky",
      "spring"
    ],
    skins: [
      {
        unified: "1f308",
        native: "🌈",
        x: 5,
        y: 7
      }
    ],
    version: 1
  },
  closed_umbrella: {
    id: "closed_umbrella",
    name: "Closed Umbrella",
    keywords: [
      "weather",
      "rain",
      "drizzle"
    ],
    skins: [
      {
        unified: "1f302",
        native: "🌂",
        x: 5,
        y: 1
      }
    ],
    version: 1
  },
  umbrella: {
    id: "umbrella",
    name: "Umbrella",
    keywords: [
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2602-fe0f",
        native: "☂️",
        x: 56,
        y: 42
      }
    ],
    version: 1
  },
  umbrella_with_rain_drops: {
    id: "umbrella_with_rain_drops",
    name: "Umbrella with Rain Drops",
    keywords: [
      "rainy",
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2614",
        native: "☔",
        x: 56,
        y: 47
      }
    ],
    version: 1
  },
  umbrella_on_ground: {
    id: "umbrella_on_ground",
    name: "Umbrella on Ground",
    keywords: [
      "weather",
      "summer"
    ],
    skins: [
      {
        unified: "26f1-fe0f",
        native: "⛱️",
        x: 57,
        y: 57
      }
    ],
    version: 1
  },
  zap: {
    id: "zap",
    name: "High Voltage",
    keywords: [
      "zap",
      "thunder",
      "weather",
      "lightning",
      "bolt",
      "fast"
    ],
    skins: [
      {
        unified: "26a1",
        native: "⚡",
        x: 57,
        y: 38
      }
    ],
    version: 1
  },
  snowflake: {
    id: "snowflake",
    name: "Snowflake",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "2744-fe0f",
        native: "❄️",
        x: 58,
        y: 60
      }
    ],
    version: 1
  },
  snowman: {
    id: "snowman",
    name: "Snowman",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "2603-fe0f",
        native: "☃️",
        x: 56,
        y: 43
      }
    ],
    version: 1
  },
  snowman_without_snow: {
    id: "snowman_without_snow",
    name: "Snowman Without Snow",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "26c4",
        native: "⛄",
        x: 57,
        y: 46
      }
    ],
    version: 1
  },
  comet: {
    id: "comet",
    name: "Comet",
    keywords: [
      "space"
    ],
    skins: [
      {
        unified: "2604-fe0f",
        native: "☄️",
        x: 56,
        y: 44
      }
    ],
    version: 1
  },
  fire: {
    id: "fire",
    name: "Fire",
    keywords: [
      "hot",
      "cook",
      "flame"
    ],
    skins: [
      {
        unified: "1f525",
        native: "🔥",
        x: 30,
        y: 1
      }
    ],
    version: 1
  },
  droplet: {
    id: "droplet",
    name: "Droplet",
    keywords: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    skins: [
      {
        unified: "1f4a7",
        native: "💧",
        x: 27,
        y: 54
      }
    ],
    version: 1
  },
  ocean: {
    id: "ocean",
    name: "Water Wave",
    keywords: [
      "ocean",
      "sea",
      "nature",
      "tsunami",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30a",
        native: "🌊",
        x: 5,
        y: 9
      }
    ],
    version: 1
  },
  jack_o_lantern: {
    id: "jack_o_lantern",
    name: "Jack-O-Lantern",
    keywords: [
      "jack",
      "o",
      "lantern",
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    skins: [
      {
        unified: "1f383",
        native: "🎃",
        x: 7,
        y: 6
      }
    ],
    version: 1
  },
  christmas_tree: {
    id: "christmas_tree",
    name: "Christmas Tree",
    keywords: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    skins: [
      {
        unified: "1f384",
        native: "🎄",
        x: 7,
        y: 7
      }
    ],
    version: 1
  },
  fireworks: {
    id: "fireworks",
    name: "Fireworks",
    keywords: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    skins: [
      {
        unified: "1f386",
        native: "🎆",
        x: 7,
        y: 14
      }
    ],
    version: 1
  },
  sparkler: {
    id: "sparkler",
    name: "Sparkler",
    keywords: [
      "stars",
      "night",
      "shine"
    ],
    skins: [
      {
        unified: "1f387",
        native: "🎇",
        x: 7,
        y: 15
      }
    ],
    version: 1
  },
  firecracker: {
    id: "firecracker",
    name: "Firecracker",
    keywords: [
      "dynamite",
      "boom",
      "explode",
      "explosion",
      "explosive"
    ],
    skins: [
      {
        unified: "1f9e8",
        native: "🧨",
        x: 53,
        y: 22
      }
    ],
    version: 11
  },
  sparkles: {
    id: "sparkles",
    name: "Sparkles",
    keywords: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "2728",
        native: "✨",
        x: 58,
        y: 57
      }
    ],
    version: 1
  },
  balloon: {
    id: "balloon",
    name: "Balloon",
    keywords: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f388",
        native: "🎈",
        x: 7,
        y: 16
      }
    ],
    version: 1
  },
  tada: {
    id: "tada",
    name: "Party Popper",
    keywords: [
      "tada",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    skins: [
      {
        unified: "1f389",
        native: "🎉",
        x: 7,
        y: 17
      }
    ],
    version: 1
  },
  confetti_ball: {
    id: "confetti_ball",
    name: "Confetti Ball",
    keywords: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f38a",
        native: "🎊",
        x: 7,
        y: 18
      }
    ],
    version: 1
  },
  tanabata_tree: {
    id: "tanabata_tree",
    name: "Tanabata Tree",
    keywords: [
      "plant",
      "nature",
      "branch",
      "summer"
    ],
    skins: [
      {
        unified: "1f38b",
        native: "🎋",
        x: 7,
        y: 19
      }
    ],
    version: 1
  },
  bamboo: {
    id: "bamboo",
    name: "Pine Decoration",
    keywords: [
      "bamboo",
      "plant",
      "nature",
      "vegetable",
      "panda"
    ],
    skins: [
      {
        unified: "1f38d",
        native: "🎍",
        x: 7,
        y: 21
      }
    ],
    version: 1
  },
  dolls: {
    id: "dolls",
    name: "Japanese Dolls",
    keywords: [
      "toy",
      "kimono"
    ],
    skins: [
      {
        unified: "1f38e",
        native: "🎎",
        x: 7,
        y: 22
      }
    ],
    version: 1
  },
  flags: {
    id: "flags",
    name: "Carp Streamer",
    keywords: [
      "flags",
      "fish",
      "japanese",
      "koinobori",
      "banner"
    ],
    skins: [
      {
        unified: "1f38f",
        native: "🎏",
        x: 7,
        y: 23
      }
    ],
    version: 1
  },
  wind_chime: {
    id: "wind_chime",
    name: "Wind Chime",
    keywords: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    skins: [
      {
        unified: "1f390",
        native: "🎐",
        x: 7,
        y: 24
      }
    ],
    version: 1
  },
  rice_scene: {
    id: "rice_scene",
    name: "Moon Viewing Ceremony",
    keywords: [
      "rice",
      "scene",
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    skins: [
      {
        unified: "1f391",
        native: "🎑",
        x: 7,
        y: 25
      }
    ],
    version: 1
  },
  red_envelope: {
    id: "red_envelope",
    name: "Red Envelope",
    keywords: [
      "gift"
    ],
    skins: [
      {
        unified: "1f9e7",
        native: "🧧",
        x: 53,
        y: 21
      }
    ],
    version: 11
  },
  ribbon: {
    id: "ribbon",
    name: "Ribbon",
    keywords: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    skins: [
      {
        unified: "1f380",
        native: "🎀",
        x: 7,
        y: 3
      }
    ],
    version: 1
  },
  gift: {
    id: "gift",
    name: "Wrapped Gift",
    keywords: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "1f381",
        native: "🎁",
        x: 7,
        y: 4
      }
    ],
    version: 1
  },
  reminder_ribbon: {
    id: "reminder_ribbon",
    name: "Reminder Ribbon",
    keywords: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    skins: [
      {
        unified: "1f397-fe0f",
        native: "🎗️",
        x: 7,
        y: 29
      }
    ],
    version: 1
  },
  admission_tickets: {
    id: "admission_tickets",
    name: "Admission Tickets",
    keywords: [
      "sports",
      "concert",
      "entrance"
    ],
    skins: [
      {
        unified: "1f39f-fe0f",
        native: "🎟️",
        x: 7,
        y: 34
      }
    ],
    version: 1
  },
  ticket: {
    id: "ticket",
    name: "Ticket",
    keywords: [
      "event",
      "concert",
      "pass"
    ],
    skins: [
      {
        unified: "1f3ab",
        native: "🎫",
        x: 7,
        y: 46
      }
    ],
    version: 1
  },
  medal: {
    id: "medal",
    name: "Military Medal",
    keywords: [
      "award",
      "winning",
      "army"
    ],
    skins: [
      {
        unified: "1f396-fe0f",
        native: "🎖️",
        x: 7,
        y: 28
      }
    ],
    version: 1
  },
  trophy: {
    id: "trophy",
    name: "Trophy",
    keywords: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    skins: [
      {
        unified: "1f3c6",
        native: "🏆",
        x: 8,
        y: 51
      }
    ],
    version: 1
  },
  sports_medal: {
    id: "sports_medal",
    name: "Sports Medal",
    keywords: [
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f3c5",
        native: "🏅",
        x: 8,
        y: 50
      }
    ],
    version: 1
  },
  first_place_medal: {
    id: "first_place_medal",
    name: "1st Place Medal",
    keywords: [
      "first",
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f947",
        native: "🥇",
        x: 43,
        y: 17
      }
    ],
    version: 3
  },
  second_place_medal: {
    id: "second_place_medal",
    name: "2nd Place Medal",
    keywords: [
      "second",
      "award"
    ],
    skins: [
      {
        unified: "1f948",
        native: "🥈",
        x: 43,
        y: 18
      }
    ],
    version: 3
  },
  third_place_medal: {
    id: "third_place_medal",
    name: "3rd Place Medal",
    keywords: [
      "third",
      "award"
    ],
    skins: [
      {
        unified: "1f949",
        native: "🥉",
        x: 43,
        y: 19
      }
    ],
    version: 3
  },
  soccer: {
    id: "soccer",
    name: "Soccer Ball",
    keywords: [
      "sports",
      "football"
    ],
    skins: [
      {
        unified: "26bd",
        native: "⚽",
        x: 57,
        y: 44
      }
    ],
    version: 1
  },
  baseball: {
    id: "baseball",
    name: "Baseball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "26be",
        native: "⚾",
        x: 57,
        y: 45
      }
    ],
    version: 1
  },
  softball: {
    id: "softball",
    name: "Softball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f94e",
        native: "🥎",
        x: 43,
        y: 24
      }
    ],
    version: 11
  },
  basketball: {
    id: "basketball",
    name: "Basketball",
    keywords: [
      "sports",
      "balls",
      "NBA"
    ],
    skins: [
      {
        unified: "1f3c0",
        native: "🏀",
        x: 8,
        y: 6
      }
    ],
    version: 1
  },
  volleyball: {
    id: "volleyball",
    name: "Volleyball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f3d0",
        native: "🏐",
        x: 9,
        y: 56
      }
    ],
    version: 1
  },
  football: {
    id: "football",
    name: "American Football",
    keywords: [
      "sports",
      "balls",
      "NFL"
    ],
    skins: [
      {
        unified: "1f3c8",
        native: "🏈",
        x: 8,
        y: 58
      }
    ],
    version: 1
  },
  rugby_football: {
    id: "rugby_football",
    name: "Rugby Football",
    keywords: [
      "sports",
      "team"
    ],
    skins: [
      {
        unified: "1f3c9",
        native: "🏉",
        x: 8,
        y: 59
      }
    ],
    version: 1
  },
  tennis: {
    id: "tennis",
    name: "Tennis",
    keywords: [
      "sports",
      "balls",
      "green"
    ],
    skins: [
      {
        unified: "1f3be",
        native: "🎾",
        x: 8,
        y: 4
      }
    ],
    version: 1
  },
  flying_disc: {
    id: "flying_disc",
    name: "Flying Disc",
    keywords: [
      "sports",
      "frisbee",
      "ultimate"
    ],
    skins: [
      {
        unified: "1f94f",
        native: "🥏",
        x: 43,
        y: 25
      }
    ],
    version: 11
  },
  bowling: {
    id: "bowling",
    name: "Bowling",
    keywords: [
      "sports",
      "fun",
      "play"
    ],
    skins: [
      {
        unified: "1f3b3",
        native: "🎳",
        x: 7,
        y: 54
      }
    ],
    version: 1
  },
  cricket_bat_and_ball: {
    id: "cricket_bat_and_ball",
    name: "Cricket Game",
    keywords: [
      "bat",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3cf",
        native: "🏏",
        x: 9,
        y: 55
      }
    ],
    version: 1
  },
  field_hockey_stick_and_ball: {
    id: "field_hockey_stick_and_ball",
    name: "Field Hockey",
    keywords: [
      "stick",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d1",
        native: "🏑",
        x: 9,
        y: 57
      }
    ],
    version: 1
  },
  ice_hockey_stick_and_puck: {
    id: "ice_hockey_stick_and_puck",
    name: "Ice Hockey",
    keywords: [
      "stick",
      "and",
      "puck",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d2",
        native: "🏒",
        x: 9,
        y: 58
      }
    ],
    version: 1
  },
  lacrosse: {
    id: "lacrosse",
    name: "Lacrosse",
    keywords: [
      "sports",
      "ball",
      "stick"
    ],
    skins: [
      {
        unified: "1f94d",
        native: "🥍",
        x: 43,
        y: 23
      }
    ],
    version: 11
  },
  table_tennis_paddle_and_ball: {
    id: "table_tennis_paddle_and_ball",
    name: "Ping Pong",
    keywords: [
      "table",
      "tennis",
      "paddle",
      "and",
      "ball",
      "sports",
      "pingpong"
    ],
    skins: [
      {
        unified: "1f3d3",
        native: "🏓",
        x: 9,
        y: 59
      }
    ],
    version: 1
  },
  badminton_racquet_and_shuttlecock: {
    id: "badminton_racquet_and_shuttlecock",
    name: "Badminton",
    keywords: [
      "racquet",
      "and",
      "shuttlecock",
      "sports"
    ],
    skins: [
      {
        unified: "1f3f8",
        native: "🏸",
        x: 10,
        y: 38
      }
    ],
    version: 1
  },
  boxing_glove: {
    id: "boxing_glove",
    name: "Boxing Glove",
    keywords: [
      "sports",
      "fighting"
    ],
    skins: [
      {
        unified: "1f94a",
        native: "🥊",
        x: 43,
        y: 20
      }
    ],
    version: 3
  },
  martial_arts_uniform: {
    id: "martial_arts_uniform",
    name: "Martial Arts Uniform",
    keywords: [
      "judo",
      "karate",
      "taekwondo"
    ],
    skins: [
      {
        unified: "1f94b",
        native: "🥋",
        x: 43,
        y: 21
      }
    ],
    version: 3
  },
  goal_net: {
    id: "goal_net",
    name: "Goal Net",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f945",
        native: "🥅",
        x: 43,
        y: 16
      }
    ],
    version: 3
  },
  golf: {
    id: "golf",
    name: "Flag in Hole",
    keywords: [
      "golf",
      "sports",
      "business",
      "summer"
    ],
    skins: [
      {
        unified: "26f3",
        native: "⛳",
        x: 57,
        y: 59
      }
    ],
    version: 1
  },
  ice_skate: {
    id: "ice_skate",
    name: "Ice Skate",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "26f8-fe0f",
        native: "⛸️",
        x: 58,
        y: 2
      }
    ],
    version: 1
  },
  fishing_pole_and_fish: {
    id: "fishing_pole_and_fish",
    name: "Fishing Pole",
    keywords: [
      "and",
      "fish",
      "food",
      "hobby",
      "summer"
    ],
    skins: [
      {
        unified: "1f3a3",
        native: "🎣",
        x: 7,
        y: 38
      }
    ],
    version: 1
  },
  diving_mask: {
    id: "diving_mask",
    name: "Diving Mask",
    keywords: [
      "sport",
      "ocean"
    ],
    skins: [
      {
        unified: "1f93f",
        native: "🤿",
        x: 43,
        y: 10
      }
    ],
    version: 12
  },
  running_shirt_with_sash: {
    id: "running_shirt_with_sash",
    name: "Running Shirt",
    keywords: [
      "with",
      "sash",
      "play",
      "pageant"
    ],
    skins: [
      {
        unified: "1f3bd",
        native: "🎽",
        x: 8,
        y: 3
      }
    ],
    version: 1
  },
  ski: {
    id: "ski",
    name: "Skis",
    keywords: [
      "ski",
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    skins: [
      {
        unified: "1f3bf",
        native: "🎿",
        x: 8,
        y: 5
      }
    ],
    version: 1
  },
  sled: {
    id: "sled",
    name: "Sled",
    keywords: [
      "sleigh",
      "luge",
      "toboggan"
    ],
    skins: [
      {
        unified: "1f6f7",
        native: "🛷",
        x: 38,
        y: 25
      }
    ],
    version: 5
  },
  curling_stone: {
    id: "curling_stone",
    name: "Curling Stone",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f94c",
        native: "🥌",
        x: 43,
        y: 22
      }
    ],
    version: 5
  },
  dart: {
    id: "dart",
    name: "Bullseye",
    keywords: [
      "dart",
      "direct",
      "hit",
      "game",
      "play",
      "bar",
      "target"
    ],
    skins: [
      {
        unified: "1f3af",
        native: "🎯",
        x: 7,
        y: 50
      }
    ],
    version: 1
  },
  "yo-yo": {
    id: "yo-yo",
    name: "Yo-Yo",
    keywords: [
      "yo",
      "toy"
    ],
    skins: [
      {
        unified: "1fa80",
        native: "🪀",
        x: 53,
        y: 56
      }
    ],
    version: 12
  },
  kite: {
    id: "kite",
    name: "Kite",
    keywords: [
      "wind",
      "fly"
    ],
    skins: [
      {
        unified: "1fa81",
        native: "🪁",
        x: 53,
        y: 57
      }
    ],
    version: 12
  },
  "8ball": {
    id: "8ball",
    name: "Billiards",
    keywords: [
      "8ball",
      "pool",
      "8",
      "ball",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    skins: [
      {
        unified: "1f3b1",
        native: "🎱",
        x: 7,
        y: 52
      }
    ],
    version: 1
  },
  crystal_ball: {
    id: "crystal_ball",
    name: "Crystal Ball",
    keywords: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune",
      "teller"
    ],
    skins: [
      {
        unified: "1f52e",
        native: "🔮",
        x: 30,
        y: 10
      }
    ],
    version: 1
  },
  magic_wand: {
    id: "magic_wand",
    name: "Magic Wand",
    keywords: [
      "supernature",
      "power"
    ],
    skins: [
      {
        unified: "1fa84",
        native: "🪄",
        x: 53,
        y: 60
      }
    ],
    version: 13
  },
  nazar_amulet: {
    id: "nazar_amulet",
    name: "Nazar Amulet",
    keywords: [
      "bead",
      "charm"
    ],
    skins: [
      {
        unified: "1f9ff",
        native: "🧿",
        x: 53,
        y: 45
      }
    ],
    version: 11
  },
  hamsa: {
    id: "hamsa",
    name: "Hamsa",
    keywords: [
      "religion",
      "protection"
    ],
    skins: [
      {
        unified: "1faac",
        native: "🪬",
        x: 54,
        y: 30
      }
    ],
    version: 14
  },
  video_game: {
    id: "video_game",
    name: "Video Game",
    keywords: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    skins: [
      {
        unified: "1f3ae",
        native: "🎮",
        x: 7,
        y: 49
      }
    ],
    version: 1
  },
  joystick: {
    id: "joystick",
    name: "Joystick",
    keywords: [
      "game",
      "play"
    ],
    skins: [
      {
        unified: "1f579-fe0f",
        native: "🕹️",
        x: 31,
        y: 25
      }
    ],
    version: 1
  },
  slot_machine: {
    id: "slot_machine",
    name: "Slot Machine",
    keywords: [
      "bet",
      "gamble",
      "vegas",
      "fruit",
      "luck",
      "casino"
    ],
    skins: [
      {
        unified: "1f3b0",
        native: "🎰",
        x: 7,
        y: 51
      }
    ],
    version: 1
  },
  game_die: {
    id: "game_die",
    name: "Game Die",
    keywords: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    skins: [
      {
        unified: "1f3b2",
        native: "🎲",
        x: 7,
        y: 53
      }
    ],
    version: 1
  },
  jigsaw: {
    id: "jigsaw",
    name: "Puzzle Piece",
    keywords: [
      "jigsaw",
      "interlocking"
    ],
    skins: [
      {
        unified: "1f9e9",
        native: "🧩",
        x: 53,
        y: 23
      }
    ],
    version: 11
  },
  teddy_bear: {
    id: "teddy_bear",
    name: "Teddy Bear",
    keywords: [
      "plush",
      "stuffed"
    ],
    skins: [
      {
        unified: "1f9f8",
        native: "🧸",
        x: 53,
        y: 38
      }
    ],
    version: 11
  },
  pinata: {
    id: "pinata",
    name: "Pinata",
    keywords: [
      "mexico",
      "candy",
      "celebration"
    ],
    skins: [
      {
        unified: "1fa85",
        native: "🪅",
        x: 54,
        y: 0
      }
    ],
    version: 13
  },
  mirror_ball: {
    id: "mirror_ball",
    name: "Mirror Ball",
    keywords: [
      "disco",
      "dance",
      "party"
    ],
    skins: [
      {
        unified: "1faa9",
        native: "🪩",
        x: 54,
        y: 27
      }
    ],
    version: 14
  },
  nesting_dolls: {
    id: "nesting_dolls",
    name: "Nesting Dolls",
    keywords: [
      "matryoshka",
      "toy"
    ],
    skins: [
      {
        unified: "1fa86",
        native: "🪆",
        x: 54,
        y: 1
      }
    ],
    version: 13
  },
  spades: {
    id: "spades",
    name: "Spade Suit",
    keywords: [
      "spades",
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    skins: [
      {
        unified: "2660-fe0f",
        native: "♠️",
        x: 57,
        y: 20
      }
    ],
    version: 1
  },
  hearts: {
    id: "hearts",
    name: "Heart Suit",
    keywords: [
      "hearts",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2665-fe0f",
        native: "♥️",
        x: 57,
        y: 22
      }
    ],
    version: 1
  },
  diamonds: {
    id: "diamonds",
    name: "Diamond Suit",
    keywords: [
      "diamonds",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2666-fe0f",
        native: "♦️",
        x: 57,
        y: 23
      }
    ],
    version: 1
  },
  clubs: {
    id: "clubs",
    name: "Club Suit",
    keywords: [
      "clubs",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2663-fe0f",
        native: "♣️",
        x: 57,
        y: 21
      }
    ],
    version: 1
  },
  chess_pawn: {
    id: "chess_pawn",
    name: "Chess Pawn",
    keywords: [
      "expendable"
    ],
    skins: [
      {
        unified: "265f-fe0f",
        native: "♟️",
        x: 57,
        y: 19
      }
    ],
    version: 11
  },
  black_joker: {
    id: "black_joker",
    name: "Joker",
    keywords: [
      "black",
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    skins: [
      {
        unified: "1f0cf",
        native: "🃏",
        x: 0,
        y: 15
      }
    ],
    version: 1
  },
  mahjong: {
    id: "mahjong",
    name: "Mahjong Red Dragon",
    keywords: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    skins: [
      {
        unified: "1f004",
        native: "🀄",
        x: 0,
        y: 14
      }
    ],
    version: 1
  },
  flower_playing_cards: {
    id: "flower_playing_cards",
    name: "Flower Playing Cards",
    keywords: [
      "game",
      "sunset",
      "red"
    ],
    skins: [
      {
        unified: "1f3b4",
        native: "🎴",
        x: 7,
        y: 55
      }
    ],
    version: 1
  },
  performing_arts: {
    id: "performing_arts",
    name: "Performing Arts",
    keywords: [
      "acting",
      "theater",
      "drama"
    ],
    skins: [
      {
        unified: "1f3ad",
        native: "🎭",
        x: 7,
        y: 48
      }
    ],
    version: 1
  },
  frame_with_picture: {
    id: "frame_with_picture",
    name: "Framed Picture",
    keywords: [
      "frame",
      "with",
      "photography"
    ],
    skins: [
      {
        unified: "1f5bc-fe0f",
        native: "🖼️",
        x: 31,
        y: 60
      }
    ],
    version: 1
  },
  art: {
    id: "art",
    name: "Artist Palette",
    keywords: [
      "art",
      "design",
      "paint",
      "draw",
      "colors"
    ],
    skins: [
      {
        unified: "1f3a8",
        native: "🎨",
        x: 7,
        y: 43
      }
    ],
    version: 1
  },
  thread: {
    id: "thread",
    name: "Thread",
    keywords: [
      "needle",
      "sewing",
      "spool",
      "string"
    ],
    skins: [
      {
        unified: "1f9f5",
        native: "🧵",
        x: 53,
        y: 35
      }
    ],
    version: 11
  },
  sewing_needle: {
    id: "sewing_needle",
    name: "Sewing Needle",
    keywords: [
      "stitches"
    ],
    skins: [
      {
        unified: "1faa1",
        native: "🪡",
        x: 54,
        y: 19
      }
    ],
    version: 13
  },
  yarn: {
    id: "yarn",
    name: "Yarn",
    keywords: [
      "ball",
      "crochet",
      "knit"
    ],
    skins: [
      {
        unified: "1f9f6",
        native: "🧶",
        x: 53,
        y: 36
      }
    ],
    version: 11
  },
  knot: {
    id: "knot",
    name: "Knot",
    keywords: [
      "rope",
      "scout"
    ],
    skins: [
      {
        unified: "1faa2",
        native: "🪢",
        x: 54,
        y: 20
      }
    ],
    version: 13
  },
  eyeglasses: {
    id: "eyeglasses",
    name: "Glasses",
    keywords: [
      "eyeglasses",
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    skins: [
      {
        unified: "1f453",
        native: "👓",
        x: 13,
        y: 15
      }
    ],
    version: 1
  },
  dark_sunglasses: {
    id: "dark_sunglasses",
    name: "Sunglasses",
    keywords: [
      "dark",
      "face",
      "cool",
      "accessories"
    ],
    skins: [
      {
        unified: "1f576-fe0f",
        native: "🕶️",
        x: 31,
        y: 22
      }
    ],
    version: 1
  },
  goggles: {
    id: "goggles",
    name: "Goggles",
    keywords: [
      "eyes",
      "protection",
      "safety"
    ],
    skins: [
      {
        unified: "1f97d",
        native: "🥽",
        x: 44,
        y: 15
      }
    ],
    version: 11
  },
  lab_coat: {
    id: "lab_coat",
    name: "Lab Coat",
    keywords: [
      "doctor",
      "experiment",
      "scientist",
      "chemist"
    ],
    skins: [
      {
        unified: "1f97c",
        native: "🥼",
        x: 44,
        y: 14
      }
    ],
    version: 11
  },
  safety_vest: {
    id: "safety_vest",
    name: "Safety Vest",
    keywords: [
      "protection"
    ],
    skins: [
      {
        unified: "1f9ba",
        native: "🦺",
        x: 45,
        y: 55
      }
    ],
    version: 12
  },
  necktie: {
    id: "necktie",
    name: "Necktie",
    keywords: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    skins: [
      {
        unified: "1f454",
        native: "👔",
        x: 13,
        y: 16
      }
    ],
    version: 1
  },
  shirt: {
    id: "shirt",
    name: "T-Shirt",
    keywords: [
      "shirt",
      "tshirt",
      "t",
      "fashion",
      "cloth",
      "casual",
      "tee"
    ],
    skins: [
      {
        unified: "1f455",
        native: "👕",
        x: 13,
        y: 17
      }
    ],
    version: 1
  },
  jeans: {
    id: "jeans",
    name: "Jeans",
    keywords: [
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f456",
        native: "👖",
        x: 13,
        y: 18
      }
    ],
    version: 1
  },
  scarf: {
    id: "scarf",
    name: "Scarf",
    keywords: [
      "neck",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e3",
        native: "🧣",
        x: 53,
        y: 17
      }
    ],
    version: 5
  },
  gloves: {
    id: "gloves",
    name: "Gloves",
    keywords: [
      "hands",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e4",
        native: "🧤",
        x: 53,
        y: 18
      }
    ],
    version: 5
  },
  coat: {
    id: "coat",
    name: "Coat",
    keywords: [
      "jacket"
    ],
    skins: [
      {
        unified: "1f9e5",
        native: "🧥",
        x: 53,
        y: 19
      }
    ],
    version: 5
  },
  socks: {
    id: "socks",
    name: "Socks",
    keywords: [
      "stockings",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e6",
        native: "🧦",
        x: 53,
        y: 20
      }
    ],
    version: 5
  },
  dress: {
    id: "dress",
    name: "Dress",
    keywords: [
      "clothes",
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f457",
        native: "👗",
        x: 13,
        y: 19
      }
    ],
    version: 1
  },
  kimono: {
    id: "kimono",
    name: "Kimono",
    keywords: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    skins: [
      {
        unified: "1f458",
        native: "👘",
        x: 13,
        y: 20
      }
    ],
    version: 1
  },
  sari: {
    id: "sari",
    name: "Sari",
    keywords: [
      "dress"
    ],
    skins: [
      {
        unified: "1f97b",
        native: "🥻",
        x: 44,
        y: 13
      }
    ],
    version: 12
  },
  "one-piece_swimsuit": {
    id: "one-piece_swimsuit",
    name: "One-Piece Swimsuit",
    keywords: [
      "one",
      "piece",
      "fashion"
    ],
    skins: [
      {
        unified: "1fa71",
        native: "🩱",
        x: 53,
        y: 47
      }
    ],
    version: 12
  },
  briefs: {
    id: "briefs",
    name: "Briefs",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa72",
        native: "🩲",
        x: 53,
        y: 48
      }
    ],
    version: 12
  },
  shorts: {
    id: "shorts",
    name: "Shorts",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa73",
        native: "🩳",
        x: 53,
        y: 49
      }
    ],
    version: 12
  },
  bikini: {
    id: "bikini",
    name: "Bikini",
    keywords: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    skins: [
      {
        unified: "1f459",
        native: "👙",
        x: 13,
        y: 21
      }
    ],
    version: 1
  },
  womans_clothes: {
    id: "womans_clothes",
    name: "Womans Clothes",
    keywords: [
      "woman",
      "s",
      "fashion",
      "shopping",
      "bags",
      "female"
    ],
    skins: [
      {
        unified: "1f45a",
        native: "👚",
        x: 13,
        y: 22
      }
    ],
    version: 1
  },
  purse: {
    id: "purse",
    name: "Purse",
    keywords: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45b",
        native: "👛",
        x: 13,
        y: 23
      }
    ],
    version: 1
  },
  handbag: {
    id: "handbag",
    name: "Handbag",
    keywords: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45c",
        native: "👜",
        x: 13,
        y: 24
      }
    ],
    version: 1
  },
  pouch: {
    id: "pouch",
    name: "Pouch",
    keywords: [
      "clutch",
      "bag",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45d",
        native: "👝",
        x: 13,
        y: 25
      }
    ],
    version: 1
  },
  shopping_bags: {
    id: "shopping_bags",
    name: "Shopping Bags",
    keywords: [
      "mall",
      "buy",
      "purchase"
    ],
    skins: [
      {
        unified: "1f6cd-fe0f",
        native: "🛍️",
        x: 37,
        y: 60
      }
    ],
    version: 1
  },
  school_satchel: {
    id: "school_satchel",
    name: "Backpack",
    keywords: [
      "school",
      "satchel",
      "student",
      "education",
      "bag"
    ],
    skins: [
      {
        unified: "1f392",
        native: "🎒",
        x: 7,
        y: 26
      }
    ],
    version: 1
  },
  thong_sandal: {
    id: "thong_sandal",
    name: "Thong Sandal",
    keywords: [
      "footwear",
      "summer"
    ],
    skins: [
      {
        unified: "1fa74",
        native: "🩴",
        x: 53,
        y: 50
      }
    ],
    version: 13
  },
  mans_shoe: {
    id: "mans_shoe",
    name: "Mans Shoe",
    keywords: [
      "man",
      "s",
      "fashion",
      "male"
    ],
    skins: [
      {
        unified: "1f45e",
        native: "👞",
        x: 13,
        y: 26
      }
    ],
    version: 1
  },
  athletic_shoe: {
    id: "athletic_shoe",
    name: "Running Shoe",
    keywords: [
      "athletic",
      "shoes",
      "sports",
      "sneakers"
    ],
    skins: [
      {
        unified: "1f45f",
        native: "👟",
        x: 13,
        y: 27
      }
    ],
    version: 1
  },
  hiking_boot: {
    id: "hiking_boot",
    name: "Hiking Boot",
    keywords: [
      "backpacking",
      "camping"
    ],
    skins: [
      {
        unified: "1f97e",
        native: "🥾",
        x: 44,
        y: 16
      }
    ],
    version: 11
  },
  womans_flat_shoe: {
    id: "womans_flat_shoe",
    name: "Flat Shoe",
    keywords: [
      "womans",
      "ballet",
      "slip",
      "on",
      "slipper"
    ],
    skins: [
      {
        unified: "1f97f",
        native: "🥿",
        x: 44,
        y: 17
      }
    ],
    version: 11
  },
  high_heel: {
    id: "high_heel",
    name: "High-Heeled Shoe",
    keywords: [
      "high",
      "heel",
      "heeled",
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    skins: [
      {
        unified: "1f460",
        native: "👠",
        x: 13,
        y: 28
      }
    ],
    version: 1
  },
  sandal: {
    id: "sandal",
    name: "Womans Sandal",
    keywords: [
      "woman",
      "s",
      "shoes",
      "fashion",
      "flip",
      "flops"
    ],
    skins: [
      {
        unified: "1f461",
        native: "👡",
        x: 13,
        y: 29
      }
    ],
    version: 1
  },
  ballet_shoes: {
    id: "ballet_shoes",
    name: "Ballet Shoes",
    keywords: [
      "dance"
    ],
    skins: [
      {
        unified: "1fa70",
        native: "🩰",
        x: 53,
        y: 46
      }
    ],
    version: 12
  },
  boot: {
    id: "boot",
    name: "Womans Boots",
    keywords: [
      "boot",
      "woman",
      "s",
      "shoes",
      "fashion"
    ],
    skins: [
      {
        unified: "1f462",
        native: "👢",
        x: 13,
        y: 30
      }
    ],
    version: 1
  },
  crown: {
    id: "crown",
    name: "Crown",
    keywords: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    skins: [
      {
        unified: "1f451",
        native: "👑",
        x: 13,
        y: 13
      }
    ],
    version: 1
  },
  womans_hat: {
    id: "womans_hat",
    name: "Womans Hat",
    keywords: [
      "woman",
      "s",
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    skins: [
      {
        unified: "1f452",
        native: "👒",
        x: 13,
        y: 14
      }
    ],
    version: 1
  },
  tophat: {
    id: "tophat",
    name: "Top Hat",
    keywords: [
      "tophat",
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    skins: [
      {
        unified: "1f3a9",
        native: "🎩",
        x: 7,
        y: 44
      }
    ],
    version: 1
  },
  mortar_board: {
    id: "mortar_board",
    name: "Graduation Cap",
    keywords: [
      "mortar",
      "board",
      "school",
      "college",
      "degree",
      "university",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    skins: [
      {
        unified: "1f393",
        native: "🎓",
        x: 7,
        y: 27
      }
    ],
    version: 1
  },
  billed_cap: {
    id: "billed_cap",
    name: "Billed Cap",
    keywords: [
      "baseball"
    ],
    skins: [
      {
        unified: "1f9e2",
        native: "🧢",
        x: 53,
        y: 16
      }
    ],
    version: 5
  },
  military_helmet: {
    id: "military_helmet",
    name: "Military Helmet",
    keywords: [
      "army",
      "protection"
    ],
    skins: [
      {
        unified: "1fa96",
        native: "🪖",
        x: 54,
        y: 8
      }
    ],
    version: 13
  },
  helmet_with_white_cross: {
    id: "helmet_with_white_cross",
    name: "Rescue Worker’s Helmet",
    keywords: [
      "with",
      "white",
      "cross",
      "worker",
      "s",
      "construction",
      "build"
    ],
    skins: [
      {
        unified: "26d1-fe0f",
        native: "⛑️",
        x: 57,
        y: 51
      }
    ],
    version: 1
  },
  prayer_beads: {
    id: "prayer_beads",
    name: "Prayer Beads",
    keywords: [
      "dhikr",
      "religious"
    ],
    skins: [
      {
        unified: "1f4ff",
        native: "📿",
        x: 29,
        y: 24
      }
    ],
    version: 1
  },
  lipstick: {
    id: "lipstick",
    name: "Lipstick",
    keywords: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    skins: [
      {
        unified: "1f484",
        native: "💄",
        x: 25,
        y: 52
      }
    ],
    version: 1
  },
  ring: {
    id: "ring",
    name: "Ring",
    keywords: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    skins: [
      {
        unified: "1f48d",
        native: "💍",
        x: 26,
        y: 39
      }
    ],
    version: 1
  },
  gem: {
    id: "gem",
    name: "Gem Stone",
    keywords: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    skins: [
      {
        unified: "1f48e",
        native: "💎",
        x: 26,
        y: 40
      }
    ],
    version: 1
  },
  mute: {
    id: "mute",
    name: "Muted Speaker",
    keywords: [
      "mute",
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f507",
        native: "🔇",
        x: 29,
        y: 32
      }
    ],
    version: 1
  },
  speaker: {
    id: "speaker",
    name: "Speaker",
    keywords: [
      "low",
      "volume",
      "sound",
      "silence",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f508",
        native: "🔈",
        x: 29,
        y: 33
      }
    ],
    version: 1
  },
  sound: {
    id: "sound",
    name: "Speaker Medium Volume",
    keywords: [
      "sound",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f509",
        native: "🔉",
        x: 29,
        y: 34
      }
    ],
    version: 1
  },
  loud_sound: {
    id: "loud_sound",
    name: "Speaker High Volume",
    keywords: [
      "loud",
      "sound",
      "noise",
      "noisy",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f50a",
        native: "🔊",
        x: 29,
        y: 35
      }
    ],
    version: 1
  },
  loudspeaker: {
    id: "loudspeaker",
    name: "Loudspeaker",
    keywords: [
      "volume",
      "sound"
    ],
    skins: [
      {
        unified: "1f4e2",
        native: "📢",
        x: 28,
        y: 57
      }
    ],
    version: 1
  },
  mega: {
    id: "mega",
    name: "Megaphone",
    keywords: [
      "mega",
      "sound",
      "speaker",
      "volume"
    ],
    skins: [
      {
        unified: "1f4e3",
        native: "📣",
        x: 28,
        y: 58
      }
    ],
    version: 1
  },
  postal_horn: {
    id: "postal_horn",
    name: "Postal Horn",
    keywords: [
      "instrument",
      "music"
    ],
    skins: [
      {
        unified: "1f4ef",
        native: "📯",
        x: 29,
        y: 9
      }
    ],
    version: 1
  },
  bell: {
    id: "bell",
    name: "Bell",
    keywords: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    skins: [
      {
        unified: "1f514",
        native: "🔔",
        x: 29,
        y: 45
      }
    ],
    version: 1
  },
  no_bell: {
    id: "no_bell",
    name: "Bell with Slash",
    keywords: [
      "no",
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    skins: [
      {
        unified: "1f515",
        native: "🔕",
        x: 29,
        y: 46
      }
    ],
    version: 1
  },
  musical_score: {
    id: "musical_score",
    name: "Musical Score",
    keywords: [
      "treble",
      "clef",
      "compose"
    ],
    skins: [
      {
        unified: "1f3bc",
        native: "🎼",
        x: 8,
        y: 2
      }
    ],
    version: 1
  },
  musical_note: {
    id: "musical_note",
    name: "Musical Note",
    keywords: [
      "score",
      "tone",
      "sound"
    ],
    skins: [
      {
        unified: "1f3b5",
        native: "🎵",
        x: 7,
        y: 56
      }
    ],
    version: 1
  },
  notes: {
    id: "notes",
    name: "Musical Notes",
    keywords: [
      "music",
      "score"
    ],
    skins: [
      {
        unified: "1f3b6",
        native: "🎶",
        x: 7,
        y: 57
      }
    ],
    version: 1
  },
  studio_microphone: {
    id: "studio_microphone",
    name: "Studio Microphone",
    keywords: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f399-fe0f",
        native: "🎙️",
        x: 7,
        y: 30
      }
    ],
    version: 1
  },
  level_slider: {
    id: "level_slider",
    name: "Level Slider",
    keywords: [
      "scale"
    ],
    skins: [
      {
        unified: "1f39a-fe0f",
        native: "🎚️",
        x: 7,
        y: 31
      }
    ],
    version: 1
  },
  control_knobs: {
    id: "control_knobs",
    name: "Control Knobs",
    keywords: [
      "dial"
    ],
    skins: [
      {
        unified: "1f39b-fe0f",
        native: "🎛️",
        x: 7,
        y: 32
      }
    ],
    version: 1
  },
  microphone: {
    id: "microphone",
    name: "Microphone",
    keywords: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f3a4",
        native: "🎤",
        x: 7,
        y: 39
      }
    ],
    version: 1
  },
  headphones: {
    id: "headphones",
    name: "Headphone",
    keywords: [
      "headphones",
      "music",
      "score",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f3a7",
        native: "🎧",
        x: 7,
        y: 42
      }
    ],
    version: 1
  },
  radio: {
    id: "radio",
    name: "Radio",
    keywords: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    skins: [
      {
        unified: "1f4fb",
        native: "📻",
        x: 29,
        y: 21
      }
    ],
    version: 1
  },
  saxophone: {
    id: "saxophone",
    name: "Saxophone",
    keywords: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    skins: [
      {
        unified: "1f3b7",
        native: "🎷",
        x: 7,
        y: 58
      }
    ],
    version: 1
  },
  accordion: {
    id: "accordion",
    name: "Accordion",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa97",
        native: "🪗",
        x: 54,
        y: 9
      }
    ],
    version: 13
  },
  guitar: {
    id: "guitar",
    name: "Guitar",
    keywords: [
      "music",
      "instrument"
    ],
    skins: [
      {
        unified: "1f3b8",
        native: "🎸",
        x: 7,
        y: 59
      }
    ],
    version: 1
  },
  musical_keyboard: {
    id: "musical_keyboard",
    name: "Musical Keyboard",
    keywords: [
      "piano",
      "instrument",
      "compose"
    ],
    skins: [
      {
        unified: "1f3b9",
        native: "🎹",
        x: 7,
        y: 60
      }
    ],
    version: 1
  },
  trumpet: {
    id: "trumpet",
    name: "Trumpet",
    keywords: [
      "music",
      "brass"
    ],
    skins: [
      {
        unified: "1f3ba",
        native: "🎺",
        x: 8,
        y: 0
      }
    ],
    version: 1
  },
  violin: {
    id: "violin",
    name: "Violin",
    keywords: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    skins: [
      {
        unified: "1f3bb",
        native: "🎻",
        x: 8,
        y: 1
      }
    ],
    version: 1
  },
  banjo: {
    id: "banjo",
    name: "Banjo",
    keywords: [
      "music",
      "instructment"
    ],
    skins: [
      {
        unified: "1fa95",
        native: "🪕",
        x: 54,
        y: 7
      }
    ],
    version: 12
  },
  drum_with_drumsticks: {
    id: "drum_with_drumsticks",
    name: "Drum",
    keywords: [
      "with",
      "drumsticks",
      "music",
      "instrument",
      "snare"
    ],
    skins: [
      {
        unified: "1f941",
        native: "🥁",
        x: 43,
        y: 12
      }
    ],
    version: 3
  },
  long_drum: {
    id: "long_drum",
    name: "Long Drum",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa98",
        native: "🪘",
        x: 54,
        y: 10
      }
    ],
    version: 13
  },
  iphone: {
    id: "iphone",
    name: "Mobile Phone",
    keywords: [
      "iphone",
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    skins: [
      {
        unified: "1f4f1",
        native: "📱",
        x: 29,
        y: 11
      }
    ],
    version: 1
  },
  calling: {
    id: "calling",
    name: "Mobile Phone with Arrow",
    keywords: [
      "calling",
      "iphone",
      "incoming"
    ],
    skins: [
      {
        unified: "1f4f2",
        native: "📲",
        x: 29,
        y: 12
      }
    ],
    version: 1
  },
  phone: {
    id: "phone",
    name: "Telephone",
    keywords: [
      "phone",
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "260e-fe0f",
        native: "☎️",
        x: 56,
        y: 45
      }
    ],
    version: 1
  },
  telephone_receiver: {
    id: "telephone_receiver",
    name: "Telephone Receiver",
    keywords: [
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "1f4de",
        native: "📞",
        x: 28,
        y: 53
      }
    ],
    version: 1
  },
  pager: {
    id: "pager",
    name: "Pager",
    keywords: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    skins: [
      {
        unified: "1f4df",
        native: "📟",
        x: 28,
        y: 54
      }
    ],
    version: 1
  },
  fax: {
    id: "fax",
    name: "Fax Machine",
    keywords: [
      "communication",
      "technology"
    ],
    skins: [
      {
        unified: "1f4e0",
        native: "📠",
        x: 28,
        y: 55
      }
    ],
    version: 1
  },
  battery: {
    id: "battery",
    name: "Battery",
    keywords: [
      "power",
      "energy",
      "sustain"
    ],
    skins: [
      {
        unified: "1f50b",
        native: "🔋",
        x: 29,
        y: 36
      }
    ],
    version: 1
  },
  low_battery: {
    id: "low_battery",
    name: "Low Battery",
    keywords: [
      "drained",
      "dead"
    ],
    skins: [
      {
        unified: "1faab",
        native: "🪫",
        x: 54,
        y: 29
      }
    ],
    version: 14
  },
  electric_plug: {
    id: "electric_plug",
    name: "Electric Plug",
    keywords: [
      "charger",
      "power"
    ],
    skins: [
      {
        unified: "1f50c",
        native: "🔌",
        x: 29,
        y: 37
      }
    ],
    version: 1
  },
  computer: {
    id: "computer",
    name: "Laptop",
    keywords: [
      "computer",
      "technology",
      "screen",
      "display",
      "monitor"
    ],
    skins: [
      {
        unified: "1f4bb",
        native: "💻",
        x: 28,
        y: 18
      }
    ],
    version: 1
  },
  desktop_computer: {
    id: "desktop_computer",
    name: "Desktop Computer",
    keywords: [
      "technology",
      "computing",
      "screen"
    ],
    skins: [
      {
        unified: "1f5a5-fe0f",
        native: "🖥️",
        x: 31,
        y: 56
      }
    ],
    version: 1
  },
  printer: {
    id: "printer",
    name: "Printer",
    keywords: [
      "paper",
      "ink"
    ],
    skins: [
      {
        unified: "1f5a8-fe0f",
        native: "🖨️",
        x: 31,
        y: 57
      }
    ],
    version: 1
  },
  keyboard: {
    id: "keyboard",
    name: "Keyboard",
    keywords: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    skins: [
      {
        unified: "2328-fe0f",
        native: "⌨️",
        x: 56,
        y: 15
      }
    ],
    version: 1
  },
  three_button_mouse: {
    id: "three_button_mouse",
    name: "Computer Mouse",
    keywords: [
      "three",
      "button",
      "click"
    ],
    skins: [
      {
        unified: "1f5b1-fe0f",
        native: "🖱️",
        x: 31,
        y: 58
      }
    ],
    version: 1
  },
  trackball: {
    id: "trackball",
    name: "Trackball",
    keywords: [
      "technology",
      "trackpad"
    ],
    skins: [
      {
        unified: "1f5b2-fe0f",
        native: "🖲️",
        x: 31,
        y: 59
      }
    ],
    version: 1
  },
  minidisc: {
    id: "minidisc",
    name: "Minidisc",
    keywords: [
      "computer",
      "disk",
      "technology",
      "record",
      "data",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bd",
        native: "💽",
        x: 28,
        y: 20
      }
    ],
    version: 1
  },
  floppy_disk: {
    id: "floppy_disk",
    name: "Floppy Disk",
    keywords: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4be",
        native: "💾",
        x: 28,
        y: 21
      }
    ],
    version: 1
  },
  cd: {
    id: "cd",
    name: "Optical Disc",
    keywords: [
      "cd",
      "disk",
      "technology",
      "dvd",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bf",
        native: "💿",
        x: 28,
        y: 22
      }
    ],
    version: 1
  },
  dvd: {
    id: "dvd",
    name: "Dvd",
    keywords: [
      "cd",
      "disk",
      "disc"
    ],
    skins: [
      {
        unified: "1f4c0",
        native: "📀",
        x: 28,
        y: 23
      }
    ],
    version: 1
  },
  abacus: {
    id: "abacus",
    name: "Abacus",
    keywords: [
      "calculation"
    ],
    skins: [
      {
        unified: "1f9ee",
        native: "🧮",
        x: 53,
        y: 28
      }
    ],
    version: 11
  },
  movie_camera: {
    id: "movie_camera",
    name: "Movie Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3a5",
        native: "🎥",
        x: 7,
        y: 40
      }
    ],
    version: 1
  },
  film_frames: {
    id: "film_frames",
    name: "Film Frames",
    keywords: [
      "movie"
    ],
    skins: [
      {
        unified: "1f39e-fe0f",
        native: "🎞️",
        x: 7,
        y: 33
      }
    ],
    version: 1
  },
  film_projector: {
    id: "film_projector",
    name: "Film Projector",
    keywords: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    skins: [
      {
        unified: "1f4fd-fe0f",
        native: "📽️",
        x: 29,
        y: 23
      }
    ],
    version: 1
  },
  clapper: {
    id: "clapper",
    name: "Clapper Board",
    keywords: [
      "movie",
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3ac",
        native: "🎬",
        x: 7,
        y: 47
      }
    ],
    version: 1
  },
  tv: {
    id: "tv",
    name: "Television",
    keywords: [
      "tv",
      "technology",
      "program",
      "oldschool",
      "show"
    ],
    skins: [
      {
        unified: "1f4fa",
        native: "📺",
        x: 29,
        y: 20
      }
    ],
    version: 1
  },
  camera: {
    id: "camera",
    name: "Camera",
    keywords: [
      "gadgets",
      "photography"
    ],
    skins: [
      {
        unified: "1f4f7",
        native: "📷",
        x: 29,
        y: 17
      }
    ],
    version: 1
  },
  camera_with_flash: {
    id: "camera_with_flash",
    name: "Camera with Flash",
    keywords: [
      "photography",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f4f8",
        native: "📸",
        x: 29,
        y: 18
      }
    ],
    version: 1
  },
  video_camera: {
    id: "video_camera",
    name: "Video Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f4f9",
        native: "📹",
        x: 29,
        y: 19
      }
    ],
    version: 1
  },
  vhs: {
    id: "vhs",
    name: "Videocassette",
    keywords: [
      "vhs",
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4fc",
        native: "📼",
        x: 29,
        y: 22
      }
    ],
    version: 1
  },
  mag: {
    id: "mag",
    name: "Magnifying Glass Tilted Left",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50d",
        native: "🔍",
        x: 29,
        y: 38
      }
    ],
    version: 1
  },
  mag_right: {
    id: "mag_right",
    name: "Magnifying Glass Tilted Right",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50e",
        native: "🔎",
        x: 29,
        y: 39
      }
    ],
    version: 1
  },
  candle: {
    id: "candle",
    name: "Candle",
    keywords: [
      "fire",
      "wax"
    ],
    skins: [
      {
        unified: "1f56f-fe0f",
        native: "🕯️",
        x: 30,
        y: 56
      }
    ],
    version: 1
  },
  bulb: {
    id: "bulb",
    name: "Light Bulb",
    keywords: [
      "electricity",
      "idea"
    ],
    skins: [
      {
        unified: "1f4a1",
        native: "💡",
        x: 27,
        y: 48
      }
    ],
    version: 1
  },
  flashlight: {
    id: "flashlight",
    name: "Flashlight",
    keywords: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    skins: [
      {
        unified: "1f526",
        native: "🔦",
        x: 30,
        y: 2
      }
    ],
    version: 1
  },
  izakaya_lantern: {
    id: "izakaya_lantern",
    name: "Izakaya Lantern",
    keywords: [
      "red",
      "paper",
      "light",
      "halloween",
      "spooky"
    ],
    skins: [
      {
        unified: "1f3ee",
        native: "🏮",
        x: 10,
        y: 25
      }
    ],
    version: 1
  },
  diya_lamp: {
    id: "diya_lamp",
    name: "Diya Lamp",
    keywords: [
      "lighting"
    ],
    skins: [
      {
        unified: "1fa94",
        native: "🪔",
        x: 54,
        y: 6
      }
    ],
    version: 12
  },
  notebook_with_decorative_cover: {
    id: "notebook_with_decorative_cover",
    name: "Notebook with Decorative Cover",
    keywords: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d4",
        native: "📔",
        x: 28,
        y: 43
      }
    ],
    version: 1
  },
  closed_book: {
    id: "closed_book",
    name: "Closed Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    skins: [
      {
        unified: "1f4d5",
        native: "📕",
        x: 28,
        y: 44
      }
    ],
    version: 1
  },
  book: {
    id: "book",
    name: "Open Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "literature",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d6",
        native: "📖",
        x: 28,
        y: 45
      }
    ],
    version: 1
  },
  green_book: {
    id: "green_book",
    name: "Green Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    skins: [
      {
        unified: "1f4d7",
        native: "📗",
        x: 28,
        y: 46
      }
    ],
    version: 1
  },
  blue_book: {
    id: "blue_book",
    name: "Blue Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d8",
        native: "📘",
        x: 28,
        y: 47
      }
    ],
    version: 1
  },
  orange_book: {
    id: "orange_book",
    name: "Orange Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    skins: [
      {
        unified: "1f4d9",
        native: "📙",
        x: 28,
        y: 48
      }
    ],
    version: 1
  },
  books: {
    id: "books",
    name: "Books",
    keywords: [
      "literature",
      "library",
      "study"
    ],
    skins: [
      {
        unified: "1f4da",
        native: "📚",
        x: 28,
        y: 49
      }
    ],
    version: 1
  },
  notebook: {
    id: "notebook",
    name: "Notebook",
    keywords: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d3",
        native: "📓",
        x: 28,
        y: 42
      }
    ],
    version: 1
  },
  ledger: {
    id: "ledger",
    name: "Ledger",
    keywords: [
      "notes",
      "paper"
    ],
    skins: [
      {
        unified: "1f4d2",
        native: "📒",
        x: 28,
        y: 41
      }
    ],
    version: 1
  },
  page_with_curl: {
    id: "page_with_curl",
    name: "Page with Curl",
    keywords: [
      "documents",
      "office",
      "paper"
    ],
    skins: [
      {
        unified: "1f4c3",
        native: "📃",
        x: 28,
        y: 26
      }
    ],
    version: 1
  },
  scroll: {
    id: "scroll",
    name: "Scroll",
    keywords: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    skins: [
      {
        unified: "1f4dc",
        native: "📜",
        x: 28,
        y: 51
      }
    ],
    version: 1
  },
  page_facing_up: {
    id: "page_facing_up",
    name: "Page Facing Up",
    keywords: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    skins: [
      {
        unified: "1f4c4",
        native: "📄",
        x: 28,
        y: 27
      }
    ],
    version: 1
  },
  newspaper: {
    id: "newspaper",
    name: "Newspaper",
    keywords: [
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f4f0",
        native: "📰",
        x: 29,
        y: 10
      }
    ],
    version: 1
  },
  rolled_up_newspaper: {
    id: "rolled_up_newspaper",
    name: "Rolled-Up Newspaper",
    keywords: [
      "rolled",
      "up",
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f5de-fe0f",
        native: "🗞️",
        x: 32,
        y: 8
      }
    ],
    version: 1
  },
  bookmark_tabs: {
    id: "bookmark_tabs",
    name: "Bookmark Tabs",
    keywords: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    skins: [
      {
        unified: "1f4d1",
        native: "📑",
        x: 28,
        y: 40
      }
    ],
    version: 1
  },
  bookmark: {
    id: "bookmark",
    name: "Bookmark",
    keywords: [
      "favorite",
      "label",
      "save"
    ],
    skins: [
      {
        unified: "1f516",
        native: "🔖",
        x: 29,
        y: 47
      }
    ],
    version: 1
  },
  label: {
    id: "label",
    name: "Label",
    keywords: [
      "sale",
      "tag"
    ],
    skins: [
      {
        unified: "1f3f7-fe0f",
        native: "🏷️",
        x: 10,
        y: 37
      }
    ],
    version: 1
  },
  moneybag: {
    id: "moneybag",
    name: "Money Bag",
    keywords: [
      "moneybag",
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b0",
        native: "💰",
        x: 28,
        y: 7
      }
    ],
    version: 1
  },
  coin: {
    id: "coin",
    name: "Coin",
    keywords: [
      "money",
      "currency"
    ],
    skins: [
      {
        unified: "1fa99",
        native: "🪙",
        x: 54,
        y: 11
      }
    ],
    version: 13
  },
  yen: {
    id: "yen",
    name: "Yen Banknote",
    keywords: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b4",
        native: "💴",
        x: 28,
        y: 11
      }
    ],
    version: 1
  },
  dollar: {
    id: "dollar",
    name: "Dollar Banknote",
    keywords: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b5",
        native: "💵",
        x: 28,
        y: 12
      }
    ],
    version: 1
  },
  euro: {
    id: "euro",
    name: "Euro Banknote",
    keywords: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b6",
        native: "💶",
        x: 28,
        y: 13
      }
    ],
    version: 1
  },
  pound: {
    id: "pound",
    name: "Pound Banknote",
    keywords: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b7",
        native: "💷",
        x: 28,
        y: 14
      }
    ],
    version: 1
  },
  money_with_wings: {
    id: "money_with_wings",
    name: "Money with Wings",
    keywords: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b8",
        native: "💸",
        x: 28,
        y: 15
      }
    ],
    version: 1
  },
  credit_card: {
    id: "credit_card",
    name: "Credit Card",
    keywords: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    skins: [
      {
        unified: "1f4b3",
        native: "💳",
        x: 28,
        y: 10
      }
    ],
    version: 1
  },
  receipt: {
    id: "receipt",
    name: "Receipt",
    keywords: [
      "accounting",
      "expenses"
    ],
    skins: [
      {
        unified: "1f9fe",
        native: "🧾",
        x: 53,
        y: 44
      }
    ],
    version: 11
  },
  chart: {
    id: "chart",
    name: "Chart Increasing with Yen",
    keywords: [
      "green",
      "square",
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4b9",
        native: "💹",
        x: 28,
        y: 16
      }
    ],
    version: 1
  },
  email: {
    id: "email",
    name: "Envelope",
    keywords: [
      "email",
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "2709-fe0f",
        native: "✉️",
        x: 58,
        y: 26
      }
    ],
    version: 1
  },
  "e-mail": {
    id: "e-mail",
    name: "E-Mail",
    keywords: [
      "e",
      "mail",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e7",
        native: "📧",
        x: 29,
        y: 1
      }
    ],
    version: 1
  },
  incoming_envelope: {
    id: "incoming_envelope",
    name: "Incoming Envelope",
    keywords: [
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e8",
        native: "📨",
        x: 29,
        y: 2
      }
    ],
    version: 1
  },
  envelope_with_arrow: {
    id: "envelope_with_arrow",
    name: "Envelope with Arrow",
    keywords: [
      "email",
      "communication"
    ],
    skins: [
      {
        unified: "1f4e9",
        native: "📩",
        x: 29,
        y: 3
      }
    ],
    version: 1
  },
  outbox_tray: {
    id: "outbox_tray",
    name: "Outbox Tray",
    keywords: [
      "inbox",
      "email"
    ],
    skins: [
      {
        unified: "1f4e4",
        native: "📤",
        x: 28,
        y: 59
      }
    ],
    version: 1
  },
  inbox_tray: {
    id: "inbox_tray",
    name: "Inbox Tray",
    keywords: [
      "email",
      "documents"
    ],
    skins: [
      {
        unified: "1f4e5",
        native: "📥",
        x: 28,
        y: 60
      }
    ],
    version: 1
  },
  package: {
    id: "package",
    name: "Package",
    keywords: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    skins: [
      {
        unified: "1f4e6",
        native: "📦",
        x: 29,
        y: 0
      }
    ],
    version: 1
  },
  mailbox: {
    id: "mailbox",
    name: "Closed Mailbox with Raised Flag",
    keywords: [
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4eb",
        native: "📫",
        x: 29,
        y: 5
      }
    ],
    version: 1
  },
  mailbox_closed: {
    id: "mailbox_closed",
    name: "Closed Mailbox with Lowered Flag",
    keywords: [
      "email",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ea",
        native: "📪",
        x: 29,
        y: 4
      }
    ],
    version: 1
  },
  mailbox_with_mail: {
    id: "mailbox_with_mail",
    name: "Open Mailbox with Raised Flag",
    keywords: [
      "mail",
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4ec",
        native: "📬",
        x: 29,
        y: 6
      }
    ],
    version: 1
  },
  mailbox_with_no_mail: {
    id: "mailbox_with_no_mail",
    name: "Open Mailbox with Lowered Flag",
    keywords: [
      "no",
      "mail",
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ed",
        native: "📭",
        x: 29,
        y: 7
      }
    ],
    version: 1
  },
  postbox: {
    id: "postbox",
    name: "Postbox",
    keywords: [
      "email",
      "letter",
      "envelope"
    ],
    skins: [
      {
        unified: "1f4ee",
        native: "📮",
        x: 29,
        y: 8
      }
    ],
    version: 1
  },
  ballot_box_with_ballot: {
    id: "ballot_box_with_ballot",
    name: "Ballot Box with Ballot",
    keywords: [
      "election",
      "vote"
    ],
    skins: [
      {
        unified: "1f5f3-fe0f",
        native: "🗳️",
        x: 32,
        y: 13
      }
    ],
    version: 1
  },
  pencil2: {
    id: "pencil2",
    name: "Pencil",
    keywords: [
      "pencil2",
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    skins: [
      {
        unified: "270f-fe0f",
        native: "✏️",
        x: 58,
        y: 51
      }
    ],
    version: 1
  },
  black_nib: {
    id: "black_nib",
    name: "Black Nib",
    keywords: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "2712-fe0f",
        native: "✒️",
        x: 58,
        y: 52
      }
    ],
    version: 1
  },
  lower_left_fountain_pen: {
    id: "lower_left_fountain_pen",
    name: "Fountain Pen",
    keywords: [
      "lower",
      "left",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58b-fe0f",
        native: "🖋️",
        x: 31,
        y: 34
      }
    ],
    version: 1
  },
  lower_left_ballpoint_pen: {
    id: "lower_left_ballpoint_pen",
    name: "Pen",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58a-fe0f",
        native: "🖊️",
        x: 31,
        y: 33
      }
    ],
    version: 1
  },
  lower_left_paintbrush: {
    id: "lower_left_paintbrush",
    name: "Paintbrush",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity",
      "art"
    ],
    skins: [
      {
        unified: "1f58c-fe0f",
        native: "🖌️",
        x: 31,
        y: 35
      }
    ],
    version: 1
  },
  lower_left_crayon: {
    id: "lower_left_crayon",
    name: "Crayon",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity"
    ],
    skins: [
      {
        unified: "1f58d-fe0f",
        native: "🖍️",
        x: 31,
        y: 36
      }
    ],
    version: 1
  },
  memo: {
    id: "memo",
    name: "Memo",
    keywords: [
      "pencil",
      "write",
      "documents",
      "stationery",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    skins: [
      {
        unified: "1f4dd",
        native: "📝",
        x: 28,
        y: 52
      }
    ],
    version: 1
  },
  briefcase: {
    id: "briefcase",
    name: "Briefcase",
    keywords: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    skins: [
      {
        unified: "1f4bc",
        native: "💼",
        x: 28,
        y: 19
      }
    ],
    version: 1
  },
  file_folder: {
    id: "file_folder",
    name: "File Folder",
    keywords: [
      "documents",
      "business",
      "office"
    ],
    skins: [
      {
        unified: "1f4c1",
        native: "📁",
        x: 28,
        y: 24
      }
    ],
    version: 1
  },
  open_file_folder: {
    id: "open_file_folder",
    name: "Open File Folder",
    keywords: [
      "documents",
      "load"
    ],
    skins: [
      {
        unified: "1f4c2",
        native: "📂",
        x: 28,
        y: 25
      }
    ],
    version: 1
  },
  card_index_dividers: {
    id: "card_index_dividers",
    name: "Card Index Dividers",
    keywords: [
      "organizing",
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c2-fe0f",
        native: "🗂️",
        x: 32,
        y: 0
      }
    ],
    version: 1
  },
  date: {
    id: "date",
    name: "Calendar",
    keywords: [
      "date",
      "schedule"
    ],
    skins: [
      {
        unified: "1f4c5",
        native: "📅",
        x: 28,
        y: 28
      }
    ],
    version: 1
  },
  calendar: {
    id: "calendar",
    name: "Tear-off Calendar",
    keywords: [
      "tear",
      "off",
      "schedule",
      "date",
      "planning"
    ],
    skins: [
      {
        unified: "1f4c6",
        native: "📆",
        x: 28,
        y: 29
      }
    ],
    version: 1
  },
  spiral_note_pad: {
    id: "spiral_note_pad",
    name: "Spiral Notepad",
    keywords: [
      "note",
      "pad",
      "memo",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5d2-fe0f",
        native: "🗒️",
        x: 32,
        y: 4
      }
    ],
    version: 1
  },
  spiral_calendar_pad: {
    id: "spiral_calendar_pad",
    name: "Spiral Calendar",
    keywords: [
      "pad",
      "date",
      "schedule",
      "planning"
    ],
    skins: [
      {
        unified: "1f5d3-fe0f",
        native: "🗓️",
        x: 32,
        y: 5
      }
    ],
    version: 1
  },
  card_index: {
    id: "card_index",
    name: "Card Index",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4c7",
        native: "📇",
        x: 28,
        y: 30
      }
    ],
    version: 1
  },
  chart_with_upwards_trend: {
    id: "chart_with_upwards_trend",
    name: "Chart Increasing",
    keywords: [
      "with",
      "upwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    skins: [
      {
        unified: "1f4c8",
        native: "📈",
        x: 28,
        y: 31
      }
    ],
    version: 1
  },
  chart_with_downwards_trend: {
    id: "chart_with_downwards_trend",
    name: "Chart Decreasing",
    keywords: [
      "with",
      "downwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    skins: [
      {
        unified: "1f4c9",
        native: "📉",
        x: 28,
        y: 32
      }
    ],
    version: 1
  },
  bar_chart: {
    id: "bar_chart",
    name: "Bar Chart",
    keywords: [
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4ca",
        native: "📊",
        x: 28,
        y: 33
      }
    ],
    version: 1
  },
  clipboard: {
    id: "clipboard",
    name: "Clipboard",
    keywords: [
      "stationery",
      "documents"
    ],
    skins: [
      {
        unified: "1f4cb",
        native: "📋",
        x: 28,
        y: 34
      }
    ],
    version: 1
  },
  pushpin: {
    id: "pushpin",
    name: "Pushpin",
    keywords: [
      "stationery",
      "mark",
      "here"
    ],
    skins: [
      {
        unified: "1f4cc",
        native: "📌",
        x: 28,
        y: 35
      }
    ],
    version: 1
  },
  round_pushpin: {
    id: "round_pushpin",
    name: "Round Pushpin",
    keywords: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    skins: [
      {
        unified: "1f4cd",
        native: "📍",
        x: 28,
        y: 36
      }
    ],
    version: 1
  },
  paperclip: {
    id: "paperclip",
    name: "Paperclip",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4ce",
        native: "📎",
        x: 28,
        y: 37
      }
    ],
    version: 1
  },
  linked_paperclips: {
    id: "linked_paperclips",
    name: "Linked Paperclips",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f587-fe0f",
        native: "🖇️",
        x: 31,
        y: 32
      }
    ],
    version: 1
  },
  straight_ruler: {
    id: "straight_ruler",
    name: "Straight Ruler",
    keywords: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4cf",
        native: "📏",
        x: 28,
        y: 38
      }
    ],
    version: 1
  },
  triangular_ruler: {
    id: "triangular_ruler",
    name: "Triangular Ruler",
    keywords: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4d0",
        native: "📐",
        x: 28,
        y: 39
      }
    ],
    version: 1
  },
  scissors: {
    id: "scissors",
    name: "Scissors",
    keywords: [
      "stationery",
      "cut"
    ],
    skins: [
      {
        unified: "2702-fe0f",
        native: "✂️",
        x: 58,
        y: 23
      }
    ],
    version: 1
  },
  card_file_box: {
    id: "card_file_box",
    name: "Card File Box",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c3-fe0f",
        native: "🗃️",
        x: 32,
        y: 1
      }
    ],
    version: 1
  },
  file_cabinet: {
    id: "file_cabinet",
    name: "File Cabinet",
    keywords: [
      "filing",
      "organizing"
    ],
    skins: [
      {
        unified: "1f5c4-fe0f",
        native: "🗄️",
        x: 32,
        y: 2
      }
    ],
    version: 1
  },
  wastebasket: {
    id: "wastebasket",
    name: "Wastebasket",
    keywords: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    skins: [
      {
        unified: "1f5d1-fe0f",
        native: "🗑️",
        x: 32,
        y: 3
      }
    ],
    version: 1
  },
  lock: {
    id: "lock",
    name: "Lock",
    keywords: [
      "locked",
      "security",
      "password",
      "padlock"
    ],
    skins: [
      {
        unified: "1f512",
        native: "🔒",
        x: 29,
        y: 43
      }
    ],
    version: 1
  },
  unlock: {
    id: "unlock",
    name: "Unlocked",
    keywords: [
      "unlock",
      "privacy",
      "security"
    ],
    skins: [
      {
        unified: "1f513",
        native: "🔓",
        x: 29,
        y: 44
      }
    ],
    version: 1
  },
  lock_with_ink_pen: {
    id: "lock_with_ink_pen",
    name: "Locked with Pen",
    keywords: [
      "lock",
      "ink",
      "security",
      "secret"
    ],
    skins: [
      {
        unified: "1f50f",
        native: "🔏",
        x: 29,
        y: 40
      }
    ],
    version: 1
  },
  closed_lock_with_key: {
    id: "closed_lock_with_key",
    name: "Locked with Key",
    keywords: [
      "closed",
      "lock",
      "security",
      "privacy"
    ],
    skins: [
      {
        unified: "1f510",
        native: "🔐",
        x: 29,
        y: 41
      }
    ],
    version: 1
  },
  key: {
    id: "key",
    name: "Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f511",
        native: "🔑",
        x: 29,
        y: 42
      }
    ],
    version: 1
  },
  old_key: {
    id: "old_key",
    name: "Old Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f5dd-fe0f",
        native: "🗝️",
        x: 32,
        y: 7
      }
    ],
    version: 1
  },
  hammer: {
    id: "hammer",
    name: "Hammer",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f528",
        native: "🔨",
        x: 30,
        y: 4
      }
    ],
    version: 1
  },
  axe: {
    id: "axe",
    name: "Axe",
    keywords: [
      "tool",
      "chop",
      "cut"
    ],
    skins: [
      {
        unified: "1fa93",
        native: "🪓",
        x: 54,
        y: 5
      }
    ],
    version: 12
  },
  pick: {
    id: "pick",
    name: "Pick",
    keywords: [
      "tools",
      "dig"
    ],
    skins: [
      {
        unified: "26cf-fe0f",
        native: "⛏️",
        x: 57,
        y: 50
      }
    ],
    version: 1
  },
  hammer_and_pick: {
    id: "hammer_and_pick",
    name: "Hammer and Pick",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "2692-fe0f",
        native: "⚒️",
        x: 57,
        y: 28
      }
    ],
    version: 1
  },
  hammer_and_wrench: {
    id: "hammer_and_wrench",
    name: "Hammer and Wrench",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f6e0-fe0f",
        native: "🛠️",
        x: 38,
        y: 11
      }
    ],
    version: 1
  },
  dagger_knife: {
    id: "dagger_knife",
    name: "Dagger",
    keywords: [
      "knife",
      "weapon"
    ],
    skins: [
      {
        unified: "1f5e1-fe0f",
        native: "🗡️",
        x: 32,
        y: 9
      }
    ],
    version: 1
  },
  crossed_swords: {
    id: "crossed_swords",
    name: "Crossed Swords",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "2694-fe0f",
        native: "⚔️",
        x: 57,
        y: 30
      }
    ],
    version: 1
  },
  gun: {
    id: "gun",
    name: "Pistol",
    keywords: [
      "gun",
      "violence",
      "weapon",
      "revolver"
    ],
    skins: [
      {
        unified: "1f52b",
        native: "🔫",
        x: 30,
        y: 7
      }
    ],
    version: 1
  },
  boomerang: {
    id: "boomerang",
    name: "Boomerang",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "1fa83",
        native: "🪃",
        x: 53,
        y: 59
      }
    ],
    version: 13
  },
  bow_and_arrow: {
    id: "bow_and_arrow",
    name: "Bow and Arrow",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f3f9",
        native: "🏹",
        x: 10,
        y: 39
      }
    ],
    version: 1
  },
  shield: {
    id: "shield",
    name: "Shield",
    keywords: [
      "protection",
      "security"
    ],
    skins: [
      {
        unified: "1f6e1-fe0f",
        native: "🛡️",
        x: 38,
        y: 12
      }
    ],
    version: 1
  },
  carpentry_saw: {
    id: "carpentry_saw",
    name: "Carpentry Saw",
    keywords: [
      "cut",
      "chop"
    ],
    skins: [
      {
        unified: "1fa9a",
        native: "🪚",
        x: 54,
        y: 12
      }
    ],
    version: 13
  },
  wrench: {
    id: "wrench",
    name: "Wrench",
    keywords: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    skins: [
      {
        unified: "1f527",
        native: "🔧",
        x: 30,
        y: 3
      }
    ],
    version: 1
  },
  screwdriver: {
    id: "screwdriver",
    name: "Screwdriver",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9b",
        native: "🪛",
        x: 54,
        y: 13
      }
    ],
    version: 13
  },
  nut_and_bolt: {
    id: "nut_and_bolt",
    name: "Nut and Bolt",
    keywords: [
      "handy",
      "tools",
      "fix"
    ],
    skins: [
      {
        unified: "1f529",
        native: "🔩",
        x: 30,
        y: 5
      }
    ],
    version: 1
  },
  gear: {
    id: "gear",
    name: "Gear",
    keywords: [
      "cog"
    ],
    skins: [
      {
        unified: "2699-fe0f",
        native: "⚙️",
        x: 57,
        y: 34
      }
    ],
    version: 1
  },
  compression: {
    id: "compression",
    name: "Clamp",
    keywords: [
      "compression",
      "tool"
    ],
    skins: [
      {
        unified: "1f5dc-fe0f",
        native: "🗜️",
        x: 32,
        y: 6
      }
    ],
    version: 1
  },
  scales: {
    id: "scales",
    name: "Balance Scale",
    keywords: [
      "scales",
      "law",
      "fairness",
      "weight"
    ],
    skins: [
      {
        unified: "2696-fe0f",
        native: "⚖️",
        x: 57,
        y: 32
      }
    ],
    version: 1
  },
  probing_cane: {
    id: "probing_cane",
    name: "White Cane",
    keywords: [
      "probing",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9af",
        native: "🦯",
        x: 45,
        y: 4
      }
    ],
    version: 12
  },
  link: {
    id: "link",
    name: "Link",
    keywords: [
      "rings",
      "url"
    ],
    skins: [
      {
        unified: "1f517",
        native: "🔗",
        x: 29,
        y: 48
      }
    ],
    version: 1
  },
  chains: {
    id: "chains",
    name: "Chains",
    keywords: [
      "lock",
      "arrest"
    ],
    skins: [
      {
        unified: "26d3-fe0f",
        native: "⛓️",
        x: 57,
        y: 52
      }
    ],
    version: 1
  },
  hook: {
    id: "hook",
    name: "Hook",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9d",
        native: "🪝",
        x: 54,
        y: 15
      }
    ],
    version: 13
  },
  toolbox: {
    id: "toolbox",
    name: "Toolbox",
    keywords: [
      "tools",
      "diy",
      "fix",
      "maintainer",
      "mechanic"
    ],
    skins: [
      {
        unified: "1f9f0",
        native: "🧰",
        x: 53,
        y: 30
      }
    ],
    version: 11
  },
  magnet: {
    id: "magnet",
    name: "Magnet",
    keywords: [
      "attraction",
      "magnetic"
    ],
    skins: [
      {
        unified: "1f9f2",
        native: "🧲",
        x: 53,
        y: 32
      }
    ],
    version: 11
  },
  ladder: {
    id: "ladder",
    name: "Ladder",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9c",
        native: "🪜",
        x: 54,
        y: 14
      }
    ],
    version: 13
  },
  alembic: {
    id: "alembic",
    name: "Alembic",
    keywords: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    skins: [
      {
        unified: "2697-fe0f",
        native: "⚗️",
        x: 57,
        y: 33
      }
    ],
    version: 1
  },
  test_tube: {
    id: "test_tube",
    name: "Test Tube",
    keywords: [
      "chemistry",
      "experiment",
      "lab",
      "science"
    ],
    skins: [
      {
        unified: "1f9ea",
        native: "🧪",
        x: 53,
        y: 24
      }
    ],
    version: 11
  },
  petri_dish: {
    id: "petri_dish",
    name: "Petri Dish",
    keywords: [
      "bacteria",
      "biology",
      "culture",
      "lab"
    ],
    skins: [
      {
        unified: "1f9eb",
        native: "🧫",
        x: 53,
        y: 25
      }
    ],
    version: 11
  },
  dna: {
    id: "dna",
    name: "Dna",
    keywords: [
      "biologist",
      "genetics",
      "life"
    ],
    skins: [
      {
        unified: "1f9ec",
        native: "🧬",
        x: 53,
        y: 26
      }
    ],
    version: 11
  },
  microscope: {
    id: "microscope",
    name: "Microscope",
    keywords: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    skins: [
      {
        unified: "1f52c",
        native: "🔬",
        x: 30,
        y: 8
      }
    ],
    version: 1
  },
  telescope: {
    id: "telescope",
    name: "Telescope",
    keywords: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    skins: [
      {
        unified: "1f52d",
        native: "🔭",
        x: 30,
        y: 9
      }
    ],
    version: 1
  },
  satellite_antenna: {
    id: "satellite_antenna",
    name: "Satellite Antenna",
    keywords: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    skins: [
      {
        unified: "1f4e1",
        native: "📡",
        x: 28,
        y: 56
      }
    ],
    version: 1
  },
  syringe: {
    id: "syringe",
    name: "Syringe",
    keywords: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    skins: [
      {
        unified: "1f489",
        native: "💉",
        x: 26,
        y: 35
      }
    ],
    version: 1
  },
  drop_of_blood: {
    id: "drop_of_blood",
    name: "Drop of Blood",
    keywords: [
      "period",
      "hurt",
      "harm",
      "wound"
    ],
    skins: [
      {
        unified: "1fa78",
        native: "🩸",
        x: 53,
        y: 51
      }
    ],
    version: 12
  },
  pill: {
    id: "pill",
    name: "Pill",
    keywords: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    skins: [
      {
        unified: "1f48a",
        native: "💊",
        x: 26,
        y: 36
      }
    ],
    version: 1
  },
  adhesive_bandage: {
    id: "adhesive_bandage",
    name: "Adhesive Bandage",
    keywords: [
      "heal"
    ],
    skins: [
      {
        unified: "1fa79",
        native: "🩹",
        x: 53,
        y: 52
      }
    ],
    version: 12
  },
  crutch: {
    id: "crutch",
    name: "Crutch",
    keywords: [
      "accessibility",
      "assist"
    ],
    skins: [
      {
        unified: "1fa7c",
        native: "🩼",
        x: 53,
        y: 55
      }
    ],
    version: 14
  },
  stethoscope: {
    id: "stethoscope",
    name: "Stethoscope",
    keywords: [
      "health"
    ],
    skins: [
      {
        unified: "1fa7a",
        native: "🩺",
        x: 53,
        y: 53
      }
    ],
    version: 12
  },
  "x-ray": {
    id: "x-ray",
    name: "X-Ray",
    keywords: [
      "x",
      "ray",
      "skeleton",
      "medicine"
    ],
    skins: [
      {
        unified: "1fa7b",
        native: "🩻",
        x: 53,
        y: 54
      }
    ],
    version: 14
  },
  door: {
    id: "door",
    name: "Door",
    keywords: [
      "house",
      "entry",
      "exit"
    ],
    skins: [
      {
        unified: "1f6aa",
        native: "🚪",
        x: 36,
        y: 30
      }
    ],
    version: 1
  },
  elevator: {
    id: "elevator",
    name: "Elevator",
    keywords: [
      "lift"
    ],
    skins: [
      {
        unified: "1f6d7",
        native: "🛗",
        x: 38,
        y: 7
      }
    ],
    version: 13
  },
  mirror: {
    id: "mirror",
    name: "Mirror",
    keywords: [
      "reflection"
    ],
    skins: [
      {
        unified: "1fa9e",
        native: "🪞",
        x: 54,
        y: 16
      }
    ],
    version: 13
  },
  window: {
    id: "window",
    name: "Window",
    keywords: [
      "scenery"
    ],
    skins: [
      {
        unified: "1fa9f",
        native: "🪟",
        x: 54,
        y: 17
      }
    ],
    version: 13
  },
  bed: {
    id: "bed",
    name: "Bed",
    keywords: [
      "sleep",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cf-fe0f",
        native: "🛏️",
        x: 38,
        y: 1
      }
    ],
    version: 1
  },
  couch_and_lamp: {
    id: "couch_and_lamp",
    name: "Couch and Lamp",
    keywords: [
      "read",
      "chill"
    ],
    skins: [
      {
        unified: "1f6cb-fe0f",
        native: "🛋️",
        x: 37,
        y: 53
      }
    ],
    version: 1
  },
  chair: {
    id: "chair",
    name: "Chair",
    keywords: [
      "sit",
      "furniture"
    ],
    skins: [
      {
        unified: "1fa91",
        native: "🪑",
        x: 54,
        y: 3
      }
    ],
    version: 12
  },
  toilet: {
    id: "toilet",
    name: "Toilet",
    keywords: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    skins: [
      {
        unified: "1f6bd",
        native: "🚽",
        x: 37,
        y: 39
      }
    ],
    version: 1
  },
  plunger: {
    id: "plunger",
    name: "Plunger",
    keywords: [
      "toilet"
    ],
    skins: [
      {
        unified: "1faa0",
        native: "🪠",
        x: 54,
        y: 18
      }
    ],
    version: 13
  },
  shower: {
    id: "shower",
    name: "Shower",
    keywords: [
      "clean",
      "water",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6bf",
        native: "🚿",
        x: 37,
        y: 41
      }
    ],
    version: 1
  },
  bathtub: {
    id: "bathtub",
    name: "Bathtub",
    keywords: [
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c1",
        native: "🛁",
        x: 37,
        y: 48
      }
    ],
    version: 1
  },
  mouse_trap: {
    id: "mouse_trap",
    name: "Mouse Trap",
    keywords: [
      "cheese"
    ],
    skins: [
      {
        unified: "1faa4",
        native: "🪤",
        x: 54,
        y: 22
      }
    ],
    version: 13
  },
  razor: {
    id: "razor",
    name: "Razor",
    keywords: [
      "cut"
    ],
    skins: [
      {
        unified: "1fa92",
        native: "🪒",
        x: 54,
        y: 4
      }
    ],
    version: 12
  },
  lotion_bottle: {
    id: "lotion_bottle",
    name: "Lotion Bottle",
    keywords: [
      "moisturizer",
      "sunscreen"
    ],
    skins: [
      {
        unified: "1f9f4",
        native: "🧴",
        x: 53,
        y: 34
      }
    ],
    version: 11
  },
  safety_pin: {
    id: "safety_pin",
    name: "Safety Pin",
    keywords: [
      "diaper"
    ],
    skins: [
      {
        unified: "1f9f7",
        native: "🧷",
        x: 53,
        y: 37
      }
    ],
    version: 11
  },
  broom: {
    id: "broom",
    name: "Broom",
    keywords: [
      "cleaning",
      "sweeping",
      "witch"
    ],
    skins: [
      {
        unified: "1f9f9",
        native: "🧹",
        x: 53,
        y: 39
      }
    ],
    version: 11
  },
  basket: {
    id: "basket",
    name: "Basket",
    keywords: [
      "laundry"
    ],
    skins: [
      {
        unified: "1f9fa",
        native: "🧺",
        x: 53,
        y: 40
      }
    ],
    version: 11
  },
  roll_of_paper: {
    id: "roll_of_paper",
    name: "Roll of Paper",
    keywords: [],
    skins: [
      {
        unified: "1f9fb",
        native: "🧻",
        x: 53,
        y: 41
      }
    ],
    version: 11
  },
  bucket: {
    id: "bucket",
    name: "Bucket",
    keywords: [
      "water",
      "container"
    ],
    skins: [
      {
        unified: "1faa3",
        native: "🪣",
        x: 54,
        y: 21
      }
    ],
    version: 13
  },
  soap: {
    id: "soap",
    name: "Soap",
    keywords: [
      "bar",
      "bathing",
      "cleaning",
      "lather"
    ],
    skins: [
      {
        unified: "1f9fc",
        native: "🧼",
        x: 53,
        y: 42
      }
    ],
    version: 11
  },
  bubbles: {
    id: "bubbles",
    name: "Bubbles",
    keywords: [
      "soap",
      "fun",
      "carbonation",
      "sparkling"
    ],
    skins: [
      {
        unified: "1fae7",
        native: "🫧",
        x: 55,
        y: 19
      }
    ],
    version: 14
  },
  toothbrush: {
    id: "toothbrush",
    name: "Toothbrush",
    keywords: [
      "hygiene",
      "dental"
    ],
    skins: [
      {
        unified: "1faa5",
        native: "🪥",
        x: 54,
        y: 23
      }
    ],
    version: 13
  },
  sponge: {
    id: "sponge",
    name: "Sponge",
    keywords: [
      "absorbing",
      "cleaning",
      "porous"
    ],
    skins: [
      {
        unified: "1f9fd",
        native: "🧽",
        x: 53,
        y: 43
      }
    ],
    version: 11
  },
  fire_extinguisher: {
    id: "fire_extinguisher",
    name: "Fire Extinguisher",
    keywords: [
      "quench"
    ],
    skins: [
      {
        unified: "1f9ef",
        native: "🧯",
        x: 53,
        y: 29
      }
    ],
    version: 11
  },
  shopping_trolley: {
    id: "shopping_trolley",
    name: "Shopping Cart",
    keywords: [
      "trolley"
    ],
    skins: [
      {
        unified: "1f6d2",
        native: "🛒",
        x: 38,
        y: 4
      }
    ],
    version: 3
  },
  smoking: {
    id: "smoking",
    name: "Cigarette",
    keywords: [
      "smoking",
      "kills",
      "tobacco",
      "joint",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ac",
        native: "🚬",
        x: 36,
        y: 32
      }
    ],
    version: 1
  },
  coffin: {
    id: "coffin",
    name: "Coffin",
    keywords: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    skins: [
      {
        unified: "26b0-fe0f",
        native: "⚰️",
        x: 57,
        y: 42
      }
    ],
    version: 1
  },
  headstone: {
    id: "headstone",
    name: "Headstone",
    keywords: [
      "death",
      "rip",
      "grave"
    ],
    skins: [
      {
        unified: "1faa6",
        native: "🪦",
        x: 54,
        y: 24
      }
    ],
    version: 13
  },
  funeral_urn: {
    id: "funeral_urn",
    name: "Funeral Urn",
    keywords: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    skins: [
      {
        unified: "26b1-fe0f",
        native: "⚱️",
        x: 57,
        y: 43
      }
    ],
    version: 1
  },
  moyai: {
    id: "moyai",
    name: "Moai",
    keywords: [
      "moyai",
      "rock",
      "easter",
      "island"
    ],
    skins: [
      {
        unified: "1f5ff",
        native: "🗿",
        x: 32,
        y: 19
      }
    ],
    version: 1
  },
  placard: {
    id: "placard",
    name: "Placard",
    keywords: [
      "announcement"
    ],
    skins: [
      {
        unified: "1faa7",
        native: "🪧",
        x: 54,
        y: 25
      }
    ],
    version: 13
  },
  identification_card: {
    id: "identification_card",
    name: "Identification Card",
    keywords: [
      "document"
    ],
    skins: [
      {
        unified: "1faaa",
        native: "🪪",
        x: 54,
        y: 28
      }
    ],
    version: 14
  },
  atm: {
    id: "atm",
    name: "Atm Sign",
    keywords: [
      "money",
      "sales",
      "cash",
      "blue",
      "square",
      "payment",
      "bank"
    ],
    skins: [
      {
        unified: "1f3e7",
        native: "🏧",
        x: 10,
        y: 18
      }
    ],
    version: 1
  },
  put_litter_in_its_place: {
    id: "put_litter_in_its_place",
    name: "Litter in Bin Sign",
    keywords: [
      "put",
      "its",
      "place",
      "blue",
      "square",
      "human",
      "info"
    ],
    skins: [
      {
        unified: "1f6ae",
        native: "🚮",
        x: 36,
        y: 34
      }
    ],
    version: 1
  },
  potable_water: {
    id: "potable_water",
    name: "Potable Water",
    keywords: [
      "blue",
      "square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    skins: [
      {
        unified: "1f6b0",
        native: "🚰",
        x: 36,
        y: 36
      }
    ],
    version: 1
  },
  wheelchair: {
    id: "wheelchair",
    name: "Wheelchair Symbol",
    keywords: [
      "blue",
      "square",
      "disabled",
      "accessibility"
    ],
    skins: [
      {
        unified: "267f",
        native: "♿",
        x: 57,
        y: 27
      }
    ],
    version: 1
  },
  mens: {
    id: "mens",
    name: "Men’s Room",
    keywords: [
      "mens",
      "men",
      "s",
      "toilet",
      "restroom",
      "wc",
      "blue",
      "square",
      "gender",
      "male"
    ],
    skins: [
      {
        unified: "1f6b9",
        native: "🚹",
        x: 37,
        y: 35
      }
    ],
    version: 1
  },
  womens: {
    id: "womens",
    name: "Women’s Room",
    keywords: [
      "womens",
      "women",
      "s",
      "purple",
      "square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    skins: [
      {
        unified: "1f6ba",
        native: "🚺",
        x: 37,
        y: 36
      }
    ],
    version: 1
  },
  restroom: {
    id: "restroom",
    name: "Restroom",
    keywords: [
      "blue",
      "square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    skins: [
      {
        unified: "1f6bb",
        native: "🚻",
        x: 37,
        y: 37
      }
    ],
    version: 1
  },
  baby_symbol: {
    id: "baby_symbol",
    name: "Baby Symbol",
    keywords: [
      "orange",
      "square",
      "child"
    ],
    skins: [
      {
        unified: "1f6bc",
        native: "🚼",
        x: 37,
        y: 38
      }
    ],
    version: 1
  },
  wc: {
    id: "wc",
    name: "Water Closet",
    keywords: [
      "wc",
      "toilet",
      "restroom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6be",
        native: "🚾",
        x: 37,
        y: 40
      }
    ],
    version: 1
  },
  passport_control: {
    id: "passport_control",
    name: "Passport Control",
    keywords: [
      "custom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c2",
        native: "🛂",
        x: 37,
        y: 49
      }
    ],
    version: 1
  },
  customs: {
    id: "customs",
    name: "Customs",
    keywords: [
      "passport",
      "border",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c3",
        native: "🛃",
        x: 37,
        y: 50
      }
    ],
    version: 1
  },
  baggage_claim: {
    id: "baggage_claim",
    name: "Baggage Claim",
    keywords: [
      "blue",
      "square",
      "airport",
      "transport"
    ],
    skins: [
      {
        unified: "1f6c4",
        native: "🛄",
        x: 37,
        y: 51
      }
    ],
    version: 1
  },
  left_luggage: {
    id: "left_luggage",
    name: "Left Luggage",
    keywords: [
      "blue",
      "square",
      "travel"
    ],
    skins: [
      {
        unified: "1f6c5",
        native: "🛅",
        x: 37,
        y: 52
      }
    ],
    version: 1
  },
  warning: {
    id: "warning",
    name: "Warning",
    keywords: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    skins: [
      {
        unified: "26a0-fe0f",
        native: "⚠️",
        x: 57,
        y: 37
      }
    ],
    version: 1
  },
  children_crossing: {
    id: "children_crossing",
    name: "Children Crossing",
    keywords: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow",
      "diamond"
    ],
    skins: [
      {
        unified: "1f6b8",
        native: "🚸",
        x: 37,
        y: 34
      }
    ],
    version: 1
  },
  no_entry: {
    id: "no_entry",
    name: "No Entry",
    keywords: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    skins: [
      {
        unified: "26d4",
        native: "⛔",
        x: 57,
        y: 53
      }
    ],
    version: 1
  },
  no_entry_sign: {
    id: "no_entry_sign",
    name: "Prohibited",
    keywords: [
      "no",
      "entry",
      "sign",
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    skins: [
      {
        unified: "1f6ab",
        native: "🚫",
        x: 36,
        y: 31
      }
    ],
    version: 1
  },
  no_bicycles: {
    id: "no_bicycles",
    name: "No Bicycles",
    keywords: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b3",
        native: "🚳",
        x: 36,
        y: 39
      }
    ],
    version: 1
  },
  no_smoking: {
    id: "no_smoking",
    name: "No Smoking",
    keywords: [
      "cigarette",
      "blue",
      "square",
      "smell",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ad",
        native: "🚭",
        x: 36,
        y: 33
      }
    ],
    version: 1
  },
  do_not_litter: {
    id: "do_not_litter",
    name: "No Littering",
    keywords: [
      "do",
      "not",
      "litter",
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    skins: [
      {
        unified: "1f6af",
        native: "🚯",
        x: 36,
        y: 35
      }
    ],
    version: 1
  },
  "non-potable_water": {
    id: "non-potable_water",
    name: "Non-Potable Water",
    keywords: [
      "non",
      "potable",
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b1",
        native: "🚱",
        x: 36,
        y: 37
      }
    ],
    version: 1
  },
  no_pedestrians: {
    id: "no_pedestrians",
    name: "No Pedestrians",
    keywords: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b7",
        native: "🚷",
        x: 37,
        y: 33
      }
    ],
    version: 1
  },
  no_mobile_phones: {
    id: "no_mobile_phones",
    name: "No Mobile Phones",
    keywords: [
      "iphone",
      "mute",
      "circle"
    ],
    skins: [
      {
        unified: "1f4f5",
        native: "📵",
        x: 29,
        y: 15
      }
    ],
    version: 1
  },
  underage: {
    id: "underage",
    name: "No One Under Eighteen",
    keywords: [
      "underage",
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    skins: [
      {
        unified: "1f51e",
        native: "🔞",
        x: 29,
        y: 55
      }
    ],
    version: 1
  },
  radioactive_sign: {
    id: "radioactive_sign",
    name: "Radioactive",
    keywords: [
      "sign",
      "nuclear",
      "danger"
    ],
    skins: [
      {
        unified: "2622-fe0f",
        native: "☢️",
        x: 56,
        y: 57
      }
    ],
    version: 1
  },
  biohazard_sign: {
    id: "biohazard_sign",
    name: "Biohazard",
    keywords: [
      "sign",
      "danger"
    ],
    skins: [
      {
        unified: "2623-fe0f",
        native: "☣️",
        x: 56,
        y: 58
      }
    ],
    version: 1
  },
  arrow_up: {
    id: "arrow_up",
    name: "Up Arrow",
    keywords: [
      "blue",
      "square",
      "continue",
      "top",
      "direction"
    ],
    skins: [
      {
        unified: "2b06-fe0f",
        native: "⬆️",
        x: 59,
        y: 20
      }
    ],
    version: 1
  },
  arrow_upper_right: {
    id: "arrow_upper_right",
    name: "Up-Right Arrow",
    keywords: [
      "upper",
      "right",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    skins: [
      {
        unified: "2197-fe0f",
        native: "↗️",
        x: 56,
        y: 8
      }
    ],
    version: 1
  },
  arrow_right: {
    id: "arrow_right",
    name: "Right Arrow",
    keywords: [
      "blue",
      "square",
      "next"
    ],
    skins: [
      {
        unified: "27a1-fe0f",
        native: "➡️",
        x: 59,
        y: 14
      }
    ],
    version: 1
  },
  arrow_lower_right: {
    id: "arrow_lower_right",
    name: "South East Arrow",
    keywords: [
      "lower",
      "right",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southeast"
    ],
    skins: [
      {
        unified: "2198-fe0f",
        native: "↘️",
        x: 56,
        y: 9
      }
    ],
    version: 1
  },
  arrow_down: {
    id: "arrow_down",
    name: "Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2b07-fe0f",
        native: "⬇️",
        x: 59,
        y: 21
      }
    ],
    version: 1
  },
  arrow_lower_left: {
    id: "arrow_lower_left",
    name: "Down-Left Arrow",
    keywords: [
      "lower",
      "left",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southwest"
    ],
    skins: [
      {
        unified: "2199-fe0f",
        native: "↙️",
        x: 56,
        y: 10
      }
    ],
    version: 1
  },
  arrow_left: {
    id: "arrow_left",
    name: "Left Arrow",
    keywords: [
      "blue",
      "square",
      "previous",
      "back"
    ],
    skins: [
      {
        unified: "2b05-fe0f",
        native: "⬅️",
        x: 59,
        y: 19
      }
    ],
    version: 1
  },
  arrow_upper_left: {
    id: "arrow_upper_left",
    name: "Up-Left Arrow",
    keywords: [
      "upper",
      "left",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    skins: [
      {
        unified: "2196-fe0f",
        native: "↖️",
        x: 56,
        y: 7
      }
    ],
    version: 1
  },
  arrow_up_down: {
    id: "arrow_up_down",
    name: "Up Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "way",
      "vertical"
    ],
    skins: [
      {
        unified: "2195-fe0f",
        native: "↕️",
        x: 56,
        y: 6
      }
    ],
    version: 1
  },
  left_right_arrow: {
    id: "left_right_arrow",
    name: "Left Right Arrow",
    keywords: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    skins: [
      {
        unified: "2194-fe0f",
        native: "↔️",
        x: 56,
        y: 5
      }
    ],
    version: 1
  },
  leftwards_arrow_with_hook: {
    id: "leftwards_arrow_with_hook",
    name: "Right Arrow Curving Left",
    keywords: [
      "leftwards",
      "with",
      "hook",
      "back",
      "return",
      "blue",
      "square",
      "undo",
      "enter"
    ],
    skins: [
      {
        unified: "21a9-fe0f",
        native: "↩️",
        x: 56,
        y: 11
      }
    ],
    version: 1
  },
  arrow_right_hook: {
    id: "arrow_right_hook",
    name: "Left Arrow Curving Right",
    keywords: [
      "hook",
      "blue",
      "square",
      "return",
      "rotate",
      "direction"
    ],
    skins: [
      {
        unified: "21aa-fe0f",
        native: "↪️",
        x: 56,
        y: 12
      }
    ],
    version: 1
  },
  arrow_heading_up: {
    id: "arrow_heading_up",
    name: "Right Arrow Curving Up",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "2934-fe0f",
        native: "⤴️",
        x: 59,
        y: 17
      }
    ],
    version: 1
  },
  arrow_heading_down: {
    id: "arrow_heading_down",
    name: "Right Arrow Curving Down",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2935-fe0f",
        native: "⤵️",
        x: 59,
        y: 18
      }
    ],
    version: 1
  },
  arrows_clockwise: {
    id: "arrows_clockwise",
    name: "Clockwise Vertical Arrows",
    keywords: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    skins: [
      {
        unified: "1f503",
        native: "🔃",
        x: 29,
        y: 28
      }
    ],
    version: 1
  },
  arrows_counterclockwise: {
    id: "arrows_counterclockwise",
    name: "Counterclockwise Arrows Button",
    keywords: [
      "blue",
      "square",
      "sync",
      "cycle"
    ],
    skins: [
      {
        unified: "1f504",
        native: "🔄",
        x: 29,
        y: 29
      }
    ],
    version: 1
  },
  back: {
    id: "back",
    name: "Back Arrow",
    keywords: [
      "words",
      "return"
    ],
    skins: [
      {
        unified: "1f519",
        native: "🔙",
        x: 29,
        y: 50
      }
    ],
    version: 1
  },
  end: {
    id: "end",
    name: "End Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51a",
        native: "🔚",
        x: 29,
        y: 51
      }
    ],
    version: 1
  },
  on: {
    id: "on",
    name: "On! Arrow",
    keywords: [
      "on",
      "words"
    ],
    skins: [
      {
        unified: "1f51b",
        native: "🔛",
        x: 29,
        y: 52
      }
    ],
    version: 1
  },
  soon: {
    id: "soon",
    name: "Soon Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51c",
        native: "🔜",
        x: 29,
        y: 53
      }
    ],
    version: 1
  },
  top: {
    id: "top",
    name: "Top Arrow",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51d",
        native: "🔝",
        x: 29,
        y: 54
      }
    ],
    version: 1
  },
  place_of_worship: {
    id: "place_of_worship",
    name: "Place of Worship",
    keywords: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    skins: [
      {
        unified: "1f6d0",
        native: "🛐",
        x: 38,
        y: 2
      }
    ],
    version: 1
  },
  atom_symbol: {
    id: "atom_symbol",
    name: "Atom Symbol",
    keywords: [
      "science",
      "physics",
      "chemistry"
    ],
    skins: [
      {
        unified: "269b-fe0f",
        native: "⚛️",
        x: 57,
        y: 35
      }
    ],
    version: 1
  },
  om_symbol: {
    id: "om_symbol",
    name: "Om",
    keywords: [
      "symbol",
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "1f549-fe0f",
        native: "🕉️",
        x: 30,
        y: 26
      }
    ],
    version: 1
  },
  star_of_david: {
    id: "star_of_david",
    name: "Star of David",
    keywords: [
      "judaism"
    ],
    skins: [
      {
        unified: "2721-fe0f",
        native: "✡️",
        x: 58,
        y: 56
      }
    ],
    version: 1
  },
  wheel_of_dharma: {
    id: "wheel_of_dharma",
    name: "Wheel of Dharma",
    keywords: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "2638-fe0f",
        native: "☸️",
        x: 57,
        y: 2
      }
    ],
    version: 1
  },
  yin_yang: {
    id: "yin_yang",
    name: "Yin Yang",
    keywords: [
      "balance"
    ],
    skins: [
      {
        unified: "262f-fe0f",
        native: "☯️",
        x: 57,
        y: 1
      }
    ],
    version: 1
  },
  latin_cross: {
    id: "latin_cross",
    name: "Latin Cross",
    keywords: [
      "christianity"
    ],
    skins: [
      {
        unified: "271d-fe0f",
        native: "✝️",
        x: 58,
        y: 55
      }
    ],
    version: 1
  },
  orthodox_cross: {
    id: "orthodox_cross",
    name: "Orthodox Cross",
    keywords: [
      "suppedaneum",
      "religion"
    ],
    skins: [
      {
        unified: "2626-fe0f",
        native: "☦️",
        x: 56,
        y: 59
      }
    ],
    version: 1
  },
  star_and_crescent: {
    id: "star_and_crescent",
    name: "Star and Crescent",
    keywords: [
      "islam"
    ],
    skins: [
      {
        unified: "262a-fe0f",
        native: "☪️",
        x: 56,
        y: 60
      }
    ],
    version: 1
  },
  peace_symbol: {
    id: "peace_symbol",
    name: "Peace Symbol",
    keywords: [
      "hippie"
    ],
    skins: [
      {
        unified: "262e-fe0f",
        native: "☮️",
        x: 57,
        y: 0
      }
    ],
    version: 1
  },
  menorah_with_nine_branches: {
    id: "menorah_with_nine_branches",
    name: "Menorah",
    keywords: [
      "with",
      "nine",
      "branches",
      "hanukkah",
      "candles",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54e",
        native: "🕎",
        x: 30,
        y: 31
      }
    ],
    version: 1
  },
  six_pointed_star: {
    id: "six_pointed_star",
    name: "Dotted Six-Pointed Star",
    keywords: [
      "six",
      "pointed",
      "purple",
      "square",
      "religion",
      "jewish",
      "hexagram"
    ],
    skins: [
      {
        unified: "1f52f",
        native: "🔯",
        x: 30,
        y: 11
      }
    ],
    version: 1
  },
  aries: {
    id: "aries",
    name: "Aries",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2648",
        native: "♈",
        x: 57,
        y: 7
      }
    ],
    version: 1
  },
  taurus: {
    id: "taurus",
    name: "Taurus",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2649",
        native: "♉",
        x: 57,
        y: 8
      }
    ],
    version: 1
  },
  gemini: {
    id: "gemini",
    name: "Gemini",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264a",
        native: "♊",
        x: 57,
        y: 9
      }
    ],
    version: 1
  },
  cancer: {
    id: "cancer",
    name: "Cancer",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264b",
        native: "♋",
        x: 57,
        y: 10
      }
    ],
    version: 1
  },
  leo: {
    id: "leo",
    name: "Leo",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264c",
        native: "♌",
        x: 57,
        y: 11
      }
    ],
    version: 1
  },
  virgo: {
    id: "virgo",
    name: "Virgo",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264d",
        native: "♍",
        x: 57,
        y: 12
      }
    ],
    version: 1
  },
  libra: {
    id: "libra",
    name: "Libra",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264e",
        native: "♎",
        x: 57,
        y: 13
      }
    ],
    version: 1
  },
  scorpius: {
    id: "scorpius",
    name: "Scorpio",
    keywords: [
      "scorpius",
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264f",
        native: "♏",
        x: 57,
        y: 14
      }
    ],
    version: 1
  },
  sagittarius: {
    id: "sagittarius",
    name: "Sagittarius",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2650",
        native: "♐",
        x: 57,
        y: 15
      }
    ],
    version: 1
  },
  capricorn: {
    id: "capricorn",
    name: "Capricorn",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2651",
        native: "♑",
        x: 57,
        y: 16
      }
    ],
    version: 1
  },
  aquarius: {
    id: "aquarius",
    name: "Aquarius",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2652",
        native: "♒",
        x: 57,
        y: 17
      }
    ],
    version: 1
  },
  pisces: {
    id: "pisces",
    name: "Pisces",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2653",
        native: "♓",
        x: 57,
        y: 18
      }
    ],
    version: 1
  },
  ophiuchus: {
    id: "ophiuchus",
    name: "Ophiuchus",
    keywords: [
      "sign",
      "purple",
      "square",
      "constellation",
      "astrology"
    ],
    skins: [
      {
        unified: "26ce",
        native: "⛎",
        x: 57,
        y: 49
      }
    ],
    version: 1
  },
  twisted_rightwards_arrows: {
    id: "twisted_rightwards_arrows",
    name: "Shuffle Tracks Button",
    keywords: [
      "twisted",
      "rightwards",
      "arrows",
      "blue",
      "square",
      "music",
      "random"
    ],
    skins: [
      {
        unified: "1f500",
        native: "🔀",
        x: 29,
        y: 25
      }
    ],
    version: 1
  },
  repeat: {
    id: "repeat",
    name: "Repeat Button",
    keywords: [
      "loop",
      "record"
    ],
    skins: [
      {
        unified: "1f501",
        native: "🔁",
        x: 29,
        y: 26
      }
    ],
    version: 1
  },
  repeat_one: {
    id: "repeat_one",
    name: "Repeat Single Button",
    keywords: [
      "one",
      "blue",
      "square",
      "loop"
    ],
    skins: [
      {
        unified: "1f502",
        native: "🔂",
        x: 29,
        y: 27
      }
    ],
    version: 1
  },
  arrow_forward: {
    id: "arrow_forward",
    name: "Play Button",
    keywords: [
      "arrow",
      "forward",
      "blue",
      "square",
      "right",
      "direction"
    ],
    skins: [
      {
        unified: "25b6-fe0f",
        native: "▶️",
        x: 56,
        y: 34
      }
    ],
    version: 1
  },
  fast_forward: {
    id: "fast_forward",
    name: "Fast-Forward Button",
    keywords: [
      "fast",
      "forward",
      "blue",
      "square",
      "play",
      "speed",
      "continue"
    ],
    skins: [
      {
        unified: "23e9",
        native: "⏩",
        x: 56,
        y: 17
      }
    ],
    version: 1
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    id: "black_right_pointing_double_triangle_with_vertical_bar",
    name: "Next Track Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "forward",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ed-fe0f",
        native: "⏭️",
        x: 56,
        y: 21
      }
    ],
    version: 1
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    id: "black_right_pointing_triangle_with_double_vertical_bar",
    name: "Play or Pause Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "triangle",
      "with",
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ef-fe0f",
        native: "⏯️",
        x: 56,
        y: 23
      }
    ],
    version: 1
  },
  arrow_backward: {
    id: "arrow_backward",
    name: "Reverse Button",
    keywords: [
      "arrow",
      "backward",
      "blue",
      "square",
      "left",
      "direction"
    ],
    skins: [
      {
        unified: "25c0-fe0f",
        native: "◀️",
        x: 56,
        y: 35
      }
    ],
    version: 1
  },
  rewind: {
    id: "rewind",
    name: "Fast Reverse Button",
    keywords: [
      "rewind",
      "play",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ea",
        native: "⏪",
        x: 56,
        y: 18
      }
    ],
    version: 1
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    id: "black_left_pointing_double_triangle_with_vertical_bar",
    name: "Last Track Button",
    keywords: [
      "black",
      "left",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "backward"
    ],
    skins: [
      {
        unified: "23ee-fe0f",
        native: "⏮️",
        x: 56,
        y: 22
      }
    ],
    version: 1
  },
  arrow_up_small: {
    id: "arrow_up_small",
    name: "Upwards Button",
    keywords: [
      "arrow",
      "up",
      "small",
      "blue",
      "square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    skins: [
      {
        unified: "1f53c",
        native: "🔼",
        x: 30,
        y: 24
      }
    ],
    version: 1
  },
  arrow_double_up: {
    id: "arrow_double_up",
    name: "Fast Up Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "23eb",
        native: "⏫",
        x: 56,
        y: 19
      }
    ],
    version: 1
  },
  arrow_down_small: {
    id: "arrow_down_small",
    name: "Downwards Button",
    keywords: [
      "arrow",
      "down",
      "small",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53d",
        native: "🔽",
        x: 30,
        y: 25
      }
    ],
    version: 1
  },
  arrow_double_down: {
    id: "arrow_double_down",
    name: "Fast Down Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "23ec",
        native: "⏬",
        x: 56,
        y: 20
      }
    ],
    version: 1
  },
  double_vertical_bar: {
    id: "double_vertical_bar",
    name: "Pause Button",
    keywords: [
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23f8-fe0f",
        native: "⏸️",
        x: 56,
        y: 28
      }
    ],
    version: 1
  },
  black_square_for_stop: {
    id: "black_square_for_stop",
    name: "Stop Button",
    keywords: [
      "black",
      "square",
      "for",
      "blue"
    ],
    skins: [
      {
        unified: "23f9-fe0f",
        native: "⏹️",
        x: 56,
        y: 29
      }
    ],
    version: 1
  },
  black_circle_for_record: {
    id: "black_circle_for_record",
    name: "Record Button",
    keywords: [
      "black",
      "circle",
      "for",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23fa-fe0f",
        native: "⏺️",
        x: 56,
        y: 30
      }
    ],
    version: 1
  },
  eject: {
    id: "eject",
    name: "Eject Button",
    keywords: [
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23cf-fe0f",
        native: "⏏️",
        x: 56,
        y: 16
      }
    ],
    version: 1
  },
  cinema: {
    id: "cinema",
    name: "Cinema",
    keywords: [
      "blue",
      "square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    skins: [
      {
        unified: "1f3a6",
        native: "🎦",
        x: 7,
        y: 41
      }
    ],
    version: 1
  },
  low_brightness: {
    id: "low_brightness",
    name: "Dim Button",
    keywords: [
      "low",
      "brightness",
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    skins: [
      {
        unified: "1f505",
        native: "🔅",
        x: 29,
        y: 30
      }
    ],
    version: 1
  },
  high_brightness: {
    id: "high_brightness",
    name: "Bright Button",
    keywords: [
      "high",
      "brightness",
      "sun",
      "light"
    ],
    skins: [
      {
        unified: "1f506",
        native: "🔆",
        x: 29,
        y: 31
      }
    ],
    version: 1
  },
  signal_strength: {
    id: "signal_strength",
    name: "Antenna Bars",
    keywords: [
      "signal",
      "strength",
      "blue",
      "square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth"
    ],
    skins: [
      {
        unified: "1f4f6",
        native: "📶",
        x: 29,
        y: 16
      }
    ],
    version: 1
  },
  vibration_mode: {
    id: "vibration_mode",
    name: "Vibration Mode",
    keywords: [
      "orange",
      "square",
      "phone"
    ],
    skins: [
      {
        unified: "1f4f3",
        native: "📳",
        x: 29,
        y: 13
      }
    ],
    version: 1
  },
  mobile_phone_off: {
    id: "mobile_phone_off",
    name: "Mobile Phone off",
    keywords: [
      "mute",
      "orange",
      "square",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f4f4",
        native: "📴",
        x: 29,
        y: 14
      }
    ],
    version: 1
  },
  transgender_symbol: {
    id: "transgender_symbol",
    name: "Transgender Symbol",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "26a7-fe0f",
        native: "⚧️",
        x: 57,
        y: 39
      }
    ],
    version: 13
  },
  heavy_multiplication_x: {
    id: "heavy_multiplication_x",
    name: "Multiply",
    keywords: [
      "heavy",
      "multiplication",
      "x",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2716-fe0f",
        native: "✖️",
        x: 58,
        y: 54
      }
    ],
    version: 1
  },
  heavy_plus_sign: {
    id: "heavy_plus_sign",
    name: "Plus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    skins: [
      {
        unified: "2795",
        native: "➕",
        x: 59,
        y: 11
      }
    ],
    version: 1
  },
  heavy_minus_sign: {
    id: "heavy_minus_sign",
    name: "Minus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    skins: [
      {
        unified: "2796",
        native: "➖",
        x: 59,
        y: 12
      }
    ],
    version: 1
  },
  heavy_division_sign: {
    id: "heavy_division_sign",
    name: "Divide",
    keywords: [
      "heavy",
      "division",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2797",
        native: "➗",
        x: 59,
        y: 13
      }
    ],
    version: 1
  },
  heavy_equals_sign: {
    id: "heavy_equals_sign",
    name: "Heavy Equals Sign",
    keywords: [
      "math"
    ],
    skins: [
      {
        unified: "1f7f0",
        native: "🟰",
        x: 38,
        y: 43
      }
    ],
    version: 14
  },
  infinity: {
    id: "infinity",
    name: "Infinity",
    keywords: [
      "forever"
    ],
    skins: [
      {
        unified: "267e-fe0f",
        native: "♾️",
        x: 57,
        y: 26
      }
    ],
    version: 11
  },
  bangbang: {
    id: "bangbang",
    name: "Double Exclamation Mark",
    keywords: [
      "bangbang",
      "surprise"
    ],
    skins: [
      {
        unified: "203c-fe0f",
        native: "‼️",
        x: 56,
        y: 1
      }
    ],
    version: 1
  },
  interrobang: {
    id: "interrobang",
    name: "Exclamation Question Mark",
    keywords: [
      "interrobang",
      "wat",
      "punctuation",
      "surprise"
    ],
    skins: [
      {
        unified: "2049-fe0f",
        native: "⁉️",
        x: 56,
        y: 2
      }
    ],
    version: 1
  },
  question: {
    id: "question",
    name: "Red Question Mark",
    keywords: [
      "doubt",
      "confused"
    ],
    skins: [
      {
        unified: "2753",
        native: "❓",
        x: 59,
        y: 3
      }
    ],
    version: 1
  },
  grey_question: {
    id: "grey_question",
    name: "White Question Mark",
    keywords: [
      "grey",
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    skins: [
      {
        unified: "2754",
        native: "❔",
        x: 59,
        y: 4
      }
    ],
    version: 1
  },
  grey_exclamation: {
    id: "grey_exclamation",
    name: "White Exclamation Mark",
    keywords: [
      "grey",
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2755",
        native: "❕",
        x: 59,
        y: 5
      }
    ],
    version: 1
  },
  exclamation: {
    id: "exclamation",
    name: "Red Exclamation Mark",
    keywords: [
      "heavy",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2757",
        native: "❗",
        x: 59,
        y: 6
      }
    ],
    version: 1
  },
  wavy_dash: {
    id: "wavy_dash",
    name: "Wavy Dash",
    keywords: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    skins: [
      {
        unified: "3030-fe0f",
        native: "〰️",
        x: 59,
        y: 26
      }
    ],
    version: 1
  },
  currency_exchange: {
    id: "currency_exchange",
    name: "Currency Exchange",
    keywords: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    skins: [
      {
        unified: "1f4b1",
        native: "💱",
        x: 28,
        y: 8
      }
    ],
    version: 1
  },
  heavy_dollar_sign: {
    id: "heavy_dollar_sign",
    name: "Heavy Dollar Sign",
    keywords: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    skins: [
      {
        unified: "1f4b2",
        native: "💲",
        x: 28,
        y: 9
      }
    ],
    version: 1
  },
  recycle: {
    id: "recycle",
    name: "Recycling Symbol",
    keywords: [
      "recycle",
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    skins: [
      {
        unified: "267b-fe0f",
        native: "♻️",
        x: 57,
        y: 25
      }
    ],
    version: 1
  },
  fleur_de_lis: {
    id: "fleur_de_lis",
    name: "Fleur-De-Lis",
    keywords: [
      "fleur",
      "de",
      "lis",
      "decorative",
      "scout"
    ],
    skins: [
      {
        unified: "269c-fe0f",
        native: "⚜️",
        x: 57,
        y: 36
      }
    ],
    version: 1
  },
  trident: {
    id: "trident",
    name: "Trident Emblem",
    keywords: [
      "weapon",
      "spear"
    ],
    skins: [
      {
        unified: "1f531",
        native: "🔱",
        x: 30,
        y: 13
      }
    ],
    version: 1
  },
  name_badge: {
    id: "name_badge",
    name: "Name Badge",
    keywords: [
      "fire",
      "forbid"
    ],
    skins: [
      {
        unified: "1f4db",
        native: "📛",
        x: 28,
        y: 50
      }
    ],
    version: 1
  },
  beginner: {
    id: "beginner",
    name: "Japanese Symbol for Beginner",
    keywords: [
      "badge",
      "shield"
    ],
    skins: [
      {
        unified: "1f530",
        native: "🔰",
        x: 30,
        y: 12
      }
    ],
    version: 1
  },
  o: {
    id: "o",
    name: "Hollow Red Circle",
    keywords: [
      "o",
      "round"
    ],
    skins: [
      {
        unified: "2b55",
        native: "⭕",
        x: 59,
        y: 25
      }
    ],
    version: 1
  },
  white_check_mark: {
    id: "white_check_mark",
    name: "Check Mark Button",
    keywords: [
      "white",
      "green",
      "square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    skins: [
      {
        unified: "2705",
        native: "✅",
        x: 58,
        y: 24
      }
    ],
    version: 1
  },
  ballot_box_with_check: {
    id: "ballot_box_with_check",
    name: "Check Box with Check",
    keywords: [
      "ballot",
      "ok",
      "agree",
      "confirm",
      "black",
      "square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2611-fe0f",
        native: "☑️",
        x: 56,
        y: 46
      }
    ],
    version: 1
  },
  heavy_check_mark: {
    id: "heavy_check_mark",
    name: "Check Mark",
    keywords: [
      "heavy",
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2714-fe0f",
        native: "✔️",
        x: 58,
        y: 53
      }
    ],
    version: 1
  },
  x: {
    id: "x",
    name: "Cross Mark",
    keywords: [
      "x",
      "no",
      "delete",
      "remove",
      "cancel",
      "red"
    ],
    skins: [
      {
        unified: "274c",
        native: "❌",
        x: 59,
        y: 1
      }
    ],
    version: 1
  },
  negative_squared_cross_mark: {
    id: "negative_squared_cross_mark",
    name: "Cross Mark Button",
    keywords: [
      "negative",
      "squared",
      "x",
      "green",
      "square",
      "no",
      "deny"
    ],
    skins: [
      {
        unified: "274e",
        native: "❎",
        x: 59,
        y: 2
      }
    ],
    version: 1
  },
  curly_loop: {
    id: "curly_loop",
    name: "Curly Loop",
    keywords: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    skins: [
      {
        unified: "27b0",
        native: "➰",
        x: 59,
        y: 15
      }
    ],
    version: 1
  },
  loop: {
    id: "loop",
    name: "Double Curly Loop",
    keywords: [
      "tape",
      "cassette"
    ],
    skins: [
      {
        unified: "27bf",
        native: "➿",
        x: 59,
        y: 16
      }
    ],
    version: 1
  },
  part_alternation_mark: {
    id: "part_alternation_mark",
    name: "Part Alternation Mark",
    keywords: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    skins: [
      {
        unified: "303d-fe0f",
        native: "〽️",
        x: 59,
        y: 27
      }
    ],
    version: 1
  },
  eight_spoked_asterisk: {
    id: "eight_spoked_asterisk",
    name: "Eight Spoked Asterisk",
    keywords: [
      "star",
      "sparkle",
      "green",
      "square"
    ],
    skins: [
      {
        unified: "2733-fe0f",
        native: "✳️",
        x: 58,
        y: 58
      }
    ],
    version: 1
  },
  eight_pointed_black_star: {
    id: "eight_pointed_black_star",
    name: "Eight-Pointed Star",
    keywords: [
      "eight",
      "pointed",
      "black",
      "orange",
      "square",
      "shape",
      "polygon"
    ],
    skins: [
      {
        unified: "2734-fe0f",
        native: "✴️",
        x: 58,
        y: 59
      }
    ],
    version: 1
  },
  sparkle: {
    id: "sparkle",
    name: "Sparkle",
    keywords: [
      "stars",
      "green",
      "square",
      "awesome",
      "good",
      "fireworks"
    ],
    skins: [
      {
        unified: "2747-fe0f",
        native: "❇️",
        x: 59,
        y: 0
      }
    ],
    version: 1
  },
  copyright: {
    id: "copyright",
    name: "Copyright",
    keywords: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "00a9-fe0f",
        native: "©️",
        x: 0,
        y: 12
      }
    ],
    version: 1
  },
  registered: {
    id: "registered",
    name: "Registered",
    keywords: [
      "alphabet",
      "circle"
    ],
    skins: [
      {
        unified: "00ae-fe0f",
        native: "®️",
        x: 0,
        y: 13
      }
    ],
    version: 1
  },
  tm: {
    id: "tm",
    name: "Trade Mark",
    keywords: [
      "tm",
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "2122-fe0f",
        native: "™️",
        x: 56,
        y: 3
      }
    ],
    version: 1
  },
  hash: {
    id: "hash",
    name: "Hash Key",
    keywords: [
      "keycap",
      "",
      "symbol",
      "blue",
      "square",
      "twitter"
    ],
    skins: [
      {
        unified: "0023-fe0f-20e3",
        native: "#️⃣",
        x: 0,
        y: 0
      }
    ],
    version: 1
  },
  keycap_star: {
    id: "keycap_star",
    name: "Keycap: *",
    keywords: [
      "keycap",
      "star",
      ""
    ],
    skins: [
      {
        unified: "002a-fe0f-20e3",
        native: "*️⃣",
        x: 0,
        y: 1
      }
    ],
    version: 2
  },
  zero: {
    id: "zero",
    name: "Keycap 0",
    keywords: [
      "zero",
      "numbers",
      "blue",
      "square",
      "null"
    ],
    skins: [
      {
        unified: "0030-fe0f-20e3",
        native: "0️⃣",
        x: 0,
        y: 2
      }
    ],
    version: 1
  },
  one: {
    id: "one",
    name: "Keycap 1",
    keywords: [
      "one",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0031-fe0f-20e3",
        native: "1️⃣",
        x: 0,
        y: 3
      }
    ],
    version: 1
  },
  two: {
    id: "two",
    name: "Keycap 2",
    keywords: [
      "two",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0032-fe0f-20e3",
        native: "2️⃣",
        x: 0,
        y: 4
      }
    ],
    version: 1
  },
  three: {
    id: "three",
    name: "Keycap 3",
    keywords: [
      "three",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0033-fe0f-20e3",
        native: "3️⃣",
        x: 0,
        y: 5
      }
    ],
    version: 1
  },
  four: {
    id: "four",
    name: "Keycap 4",
    keywords: [
      "four",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0034-fe0f-20e3",
        native: "4️⃣",
        x: 0,
        y: 6
      }
    ],
    version: 1
  },
  five: {
    id: "five",
    name: "Keycap 5",
    keywords: [
      "five",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0035-fe0f-20e3",
        native: "5️⃣",
        x: 0,
        y: 7
      }
    ],
    version: 1
  },
  six: {
    id: "six",
    name: "Keycap 6",
    keywords: [
      "six",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0036-fe0f-20e3",
        native: "6️⃣",
        x: 0,
        y: 8
      }
    ],
    version: 1
  },
  seven: {
    id: "seven",
    name: "Keycap 7",
    keywords: [
      "seven",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0037-fe0f-20e3",
        native: "7️⃣",
        x: 0,
        y: 9
      }
    ],
    version: 1
  },
  eight: {
    id: "eight",
    name: "Keycap 8",
    keywords: [
      "eight",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0038-fe0f-20e3",
        native: "8️⃣",
        x: 0,
        y: 10
      }
    ],
    version: 1
  },
  nine: {
    id: "nine",
    name: "Keycap 9",
    keywords: [
      "nine",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0039-fe0f-20e3",
        native: "9️⃣",
        x: 0,
        y: 11
      }
    ],
    version: 1
  },
  keycap_ten: {
    id: "keycap_ten",
    name: "Keycap 10",
    keywords: [
      "ten",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51f",
        native: "🔟",
        x: 29,
        y: 56
      }
    ],
    version: 1
  },
  capital_abcd: {
    id: "capital_abcd",
    name: "Input Latin Uppercase",
    keywords: [
      "capital",
      "abcd",
      "alphabet",
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f520",
        native: "🔠",
        x: 29,
        y: 57
      }
    ],
    version: 1
  },
  abcd: {
    id: "abcd",
    name: "Input Latin Lowercase",
    keywords: [
      "abcd",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f521",
        native: "🔡",
        x: 29,
        y: 58
      }
    ],
    version: 1
  },
  symbols: {
    id: "symbols",
    name: "Input Symbols",
    keywords: [
      "blue",
      "square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    skins: [
      {
        unified: "1f523",
        native: "🔣",
        x: 29,
        y: 60
      }
    ],
    version: 1
  },
  abc: {
    id: "abc",
    name: "Input Latin Letters",
    keywords: [
      "abc",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f524",
        native: "🔤",
        x: 30,
        y: 0
      }
    ],
    version: 1
  },
  a: {
    id: "a",
    name: "A Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f170-fe0f",
        native: "🅰️",
        x: 0,
        y: 16
      }
    ],
    version: 1
  },
  ab: {
    id: "ab",
    name: "Negative Squared Ab",
    keywords: [
      "button",
      "red",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f18e",
        native: "🆎",
        x: 0,
        y: 20
      }
    ],
    version: 1
  },
  b: {
    id: "b",
    name: "B Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f171-fe0f",
        native: "🅱️",
        x: 0,
        y: 17
      }
    ],
    version: 1
  },
  cl: {
    id: "cl",
    name: "Cl Button",
    keywords: [
      "alphabet",
      "words",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f191",
        native: "🆑",
        x: 0,
        y: 21
      }
    ],
    version: 1
  },
  cool: {
    id: "cool",
    name: "Cool Button",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f192",
        native: "🆒",
        x: 0,
        y: 22
      }
    ],
    version: 1
  },
  free: {
    id: "free",
    name: "Free Button",
    keywords: [
      "blue",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f193",
        native: "🆓",
        x: 0,
        y: 23
      }
    ],
    version: 1
  },
  information_source: {
    id: "information_source",
    name: "Information",
    keywords: [
      "source",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "2139-fe0f",
        native: "ℹ️",
        x: 56,
        y: 4
      }
    ],
    version: 1
  },
  id: {
    id: "id",
    name: "Id Button",
    keywords: [
      "purple",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f194",
        native: "🆔",
        x: 0,
        y: 24
      }
    ],
    version: 1
  },
  m: {
    id: "m",
    name: "Circled M",
    keywords: [
      "alphabet",
      "blue",
      "circle",
      "letter"
    ],
    skins: [
      {
        unified: "24c2-fe0f",
        native: "Ⓜ️",
        x: 56,
        y: 31
      }
    ],
    version: 1
  },
  new: {
    id: "new",
    name: "New Button",
    keywords: [
      "blue",
      "square",
      "words",
      "start"
    ],
    skins: [
      {
        unified: "1f195",
        native: "🆕",
        x: 0,
        y: 25
      }
    ],
    version: 1
  },
  ng: {
    id: "ng",
    name: "Ng Button",
    keywords: [
      "blue",
      "square",
      "words",
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "1f196",
        native: "🆖",
        x: 0,
        y: 26
      }
    ],
    version: 1
  },
  o2: {
    id: "o2",
    name: "O Button (blood Type)",
    keywords: [
      "o2",
      "alphabet",
      "red",
      "square",
      "letter"
    ],
    skins: [
      {
        unified: "1f17e-fe0f",
        native: "🅾️",
        x: 0,
        y: 18
      }
    ],
    version: 1
  },
  ok: {
    id: "ok",
    name: "Ok Button",
    keywords: [
      "good",
      "agree",
      "yes",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f197",
        native: "🆗",
        x: 0,
        y: 27
      }
    ],
    version: 1
  },
  parking: {
    id: "parking",
    name: "P Button",
    keywords: [
      "parking",
      "cars",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f17f-fe0f",
        native: "🅿️",
        x: 0,
        y: 19
      }
    ],
    version: 1
  },
  sos: {
    id: "sos",
    name: "Sos Button",
    keywords: [
      "help",
      "red",
      "square",
      "words",
      "emergency",
      "911"
    ],
    skins: [
      {
        unified: "1f198",
        native: "🆘",
        x: 0,
        y: 28
      }
    ],
    version: 1
  },
  up: {
    id: "up",
    name: "Up! Button",
    keywords: [
      "up",
      "blue",
      "square",
      "above",
      "high"
    ],
    skins: [
      {
        unified: "1f199",
        native: "🆙",
        x: 0,
        y: 29
      }
    ],
    version: 1
  },
  vs: {
    id: "vs",
    name: "Vs Button",
    keywords: [
      "words",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f19a",
        native: "🆚",
        x: 0,
        y: 30
      }
    ],
    version: 1
  },
  koko: {
    id: "koko",
    name: "Squared Katakana Koko",
    keywords: [
      "japanese",
      "here",
      "button",
      "blue",
      "square",
      "destination"
    ],
    skins: [
      {
        unified: "1f201",
        native: "🈁",
        x: 4,
        y: 45
      }
    ],
    version: 1
  },
  sa: {
    id: "sa",
    name: "Squared Katakana Sa",
    keywords: [
      "japanese",
      "service",
      "charge",
      "button",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f202-fe0f",
        native: "🈂️",
        x: 4,
        y: 46
      }
    ],
    version: 1
  },
  u6708: {
    id: "u6708",
    name: "Japanese “monthly Amount” Button",
    keywords: [
      "u6708",
      "monthly",
      "amount",
      "chinese",
      "month",
      "moon",
      "orange",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f237-fe0f",
        native: "🈷️",
        x: 4,
        y: 54
      }
    ],
    version: 1
  },
  u6709: {
    id: "u6709",
    name: "Squared Cjk Unified Ideograph-6709",
    keywords: [
      "u6709",
      "japanese",
      "not",
      "free",
      "of",
      "charge",
      "button",
      "orange",
      "square",
      "chinese",
      "have",
      "kanji"
    ],
    skins: [
      {
        unified: "1f236",
        native: "🈶",
        x: 4,
        y: 53
      }
    ],
    version: 1
  },
  u6307: {
    id: "u6307",
    name: "Japanese “reserved” Button",
    keywords: [
      "u6307",
      "reserved",
      "chinese",
      "point",
      "green",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f22f",
        native: "🈯",
        x: 4,
        y: 48
      }
    ],
    version: 1
  },
  ideograph_advantage: {
    id: "ideograph_advantage",
    name: "Japanese “bargain” Button",
    keywords: [
      "ideograph",
      "advantage",
      "bargain",
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    skins: [
      {
        unified: "1f250",
        native: "🉐",
        x: 4,
        y: 58
      }
    ],
    version: 1
  },
  u5272: {
    id: "u5272",
    name: "Japanese “discount” Button",
    keywords: [
      "u5272",
      "discount",
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink",
      "square"
    ],
    skins: [
      {
        unified: "1f239",
        native: "🈹",
        x: 4,
        y: 56
      }
    ],
    version: 1
  },
  u7121: {
    id: "u7121",
    name: "Japanese “free of Charge” Button",
    keywords: [
      "u7121",
      "free",
      "charge",
      "nothing",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f21a",
        native: "🈚",
        x: 4,
        y: 47
      }
    ],
    version: 1
  },
  u7981: {
    id: "u7981",
    name: "Japanese “prohibited” Button",
    keywords: [
      "u7981",
      "prohibited",
      "kanji",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f232",
        native: "🈲",
        x: 4,
        y: 49
      }
    ],
    version: 1
  },
  accept: {
    id: "accept",
    name: "Circled Ideograph Accept",
    keywords: [
      "japanese",
      "acceptable",
      "button",
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange",
      "circle"
    ],
    skins: [
      {
        unified: "1f251",
        native: "🉑",
        x: 4,
        y: 59
      }
    ],
    version: 1
  },
  u7533: {
    id: "u7533",
    name: "Japanese “application” Button",
    keywords: [
      "u7533",
      "application",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f238",
        native: "🈸",
        x: 4,
        y: 55
      }
    ],
    version: 1
  },
  u5408: {
    id: "u5408",
    name: "Japanese “passing Grade” Button",
    keywords: [
      "u5408",
      "passing",
      "grade",
      "chinese",
      "join",
      "kanji",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f234",
        native: "🈴",
        x: 4,
        y: 51
      }
    ],
    version: 1
  },
  u7a7a: {
    id: "u7a7a",
    name: "Japanese “vacancy” Button",
    keywords: [
      "u7a7a",
      "vacancy",
      "kanji",
      "chinese",
      "empty",
      "sky",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f233",
        native: "🈳",
        x: 4,
        y: 50
      }
    ],
    version: 1
  },
  congratulations: {
    id: "congratulations",
    name: "Circled Ideograph Congratulation",
    keywords: [
      "congratulations",
      "japanese",
      "button",
      "chinese",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3297-fe0f",
        native: "㊗️",
        x: 59,
        y: 28
      }
    ],
    version: 1
  },
  secret: {
    id: "secret",
    name: "Circled Ideograph Secret",
    keywords: [
      "japanese",
      "button",
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3299-fe0f",
        native: "㊙️",
        x: 59,
        y: 29
      }
    ],
    version: 1
  },
  u55b6: {
    id: "u55b6",
    name: "Squared Cjk Unified Ideograph-55b6",
    keywords: [
      "u55b6",
      "japanese",
      "open",
      "for",
      "business",
      "button",
      "opening",
      "hours",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f23a",
        native: "🈺",
        x: 4,
        y: 57
      }
    ],
    version: 1
  },
  u6e80: {
    id: "u6e80",
    name: "Japanese “no Vacancy” Button",
    keywords: [
      "u6e80",
      "no",
      "vacancy",
      "full",
      "chinese",
      "red",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f235",
        native: "🈵",
        x: 4,
        y: 52
      }
    ],
    version: 1
  },
  red_circle: {
    id: "red_circle",
    name: "Red Circle",
    keywords: [
      "shape",
      "error",
      "danger"
    ],
    skins: [
      {
        unified: "1f534",
        native: "🔴",
        x: 30,
        y: 16
      }
    ],
    version: 1
  },
  large_orange_circle: {
    id: "large_orange_circle",
    name: "Orange Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e0",
        native: "🟠",
        x: 38,
        y: 31
      }
    ],
    version: 12
  },
  large_yellow_circle: {
    id: "large_yellow_circle",
    name: "Yellow Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e1",
        native: "🟡",
        x: 38,
        y: 32
      }
    ],
    version: 12
  },
  large_green_circle: {
    id: "large_green_circle",
    name: "Green Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e2",
        native: "🟢",
        x: 38,
        y: 33
      }
    ],
    version: 12
  },
  large_blue_circle: {
    id: "large_blue_circle",
    name: "Blue Circle",
    keywords: [
      "large",
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "1f535",
        native: "🔵",
        x: 30,
        y: 17
      }
    ],
    version: 1
  },
  large_purple_circle: {
    id: "large_purple_circle",
    name: "Purple Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e3",
        native: "🟣",
        x: 38,
        y: 34
      }
    ],
    version: 12
  },
  large_brown_circle: {
    id: "large_brown_circle",
    name: "Brown Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e4",
        native: "🟤",
        x: 38,
        y: 35
      }
    ],
    version: 12
  },
  black_circle: {
    id: "black_circle",
    name: "Black Circle",
    keywords: [
      "shape",
      "button",
      "round"
    ],
    skins: [
      {
        unified: "26ab",
        native: "⚫",
        x: 57,
        y: 41
      }
    ],
    version: 1
  },
  white_circle: {
    id: "white_circle",
    name: "White Circle",
    keywords: [
      "shape",
      "round"
    ],
    skins: [
      {
        unified: "26aa",
        native: "⚪",
        x: 57,
        y: 40
      }
    ],
    version: 1
  },
  large_red_square: {
    id: "large_red_square",
    name: "Red Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e5",
        native: "🟥",
        x: 38,
        y: 36
      }
    ],
    version: 12
  },
  large_orange_square: {
    id: "large_orange_square",
    name: "Orange Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e7",
        native: "🟧",
        x: 38,
        y: 38
      }
    ],
    version: 12
  },
  large_yellow_square: {
    id: "large_yellow_square",
    name: "Yellow Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e8",
        native: "🟨",
        x: 38,
        y: 39
      }
    ],
    version: 12
  },
  large_green_square: {
    id: "large_green_square",
    name: "Green Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e9",
        native: "🟩",
        x: 38,
        y: 40
      }
    ],
    version: 12
  },
  large_blue_square: {
    id: "large_blue_square",
    name: "Blue Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e6",
        native: "🟦",
        x: 38,
        y: 37
      }
    ],
    version: 12
  },
  large_purple_square: {
    id: "large_purple_square",
    name: "Purple Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7ea",
        native: "🟪",
        x: 38,
        y: 41
      }
    ],
    version: 12
  },
  large_brown_square: {
    id: "large_brown_square",
    name: "Brown Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7eb",
        native: "🟫",
        x: 38,
        y: 42
      }
    ],
    version: 12
  },
  black_large_square: {
    id: "black_large_square",
    name: "Black Large Square",
    keywords: [
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "2b1b",
        native: "⬛",
        x: 59,
        y: 22
      }
    ],
    version: 1
  },
  white_large_square: {
    id: "white_large_square",
    name: "White Large Square",
    keywords: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    skins: [
      {
        unified: "2b1c",
        native: "⬜",
        x: 59,
        y: 23
      }
    ],
    version: 1
  },
  black_medium_square: {
    id: "black_medium_square",
    name: "Black Medium Square",
    keywords: [
      "shape",
      "button",
      "icon"
    ],
    skins: [
      {
        unified: "25fc-fe0f",
        native: "◼️",
        x: 56,
        y: 37
      }
    ],
    version: 1
  },
  white_medium_square: {
    id: "white_medium_square",
    name: "White Medium Square",
    keywords: [
      "shape",
      "stone",
      "icon"
    ],
    skins: [
      {
        unified: "25fb-fe0f",
        native: "◻️",
        x: 56,
        y: 36
      }
    ],
    version: 1
  },
  black_medium_small_square: {
    id: "black_medium_small_square",
    name: "Black Medium Small Square",
    keywords: [
      "icon",
      "shape",
      "button"
    ],
    skins: [
      {
        unified: "25fe",
        native: "◾",
        x: 56,
        y: 39
      }
    ],
    version: 1
  },
  white_medium_small_square: {
    id: "white_medium_small_square",
    name: "White Medium Small Square",
    keywords: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "25fd",
        native: "◽",
        x: 56,
        y: 38
      }
    ],
    version: 1
  },
  black_small_square: {
    id: "black_small_square",
    name: "Black Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25aa-fe0f",
        native: "▪️",
        x: 56,
        y: 32
      }
    ],
    version: 1
  },
  white_small_square: {
    id: "white_small_square",
    name: "White Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25ab-fe0f",
        native: "▫️",
        x: 56,
        y: 33
      }
    ],
    version: 1
  },
  large_orange_diamond: {
    id: "large_orange_diamond",
    name: "Large Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f536",
        native: "🔶",
        x: 30,
        y: 18
      }
    ],
    version: 1
  },
  large_blue_diamond: {
    id: "large_blue_diamond",
    name: "Large Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f537",
        native: "🔷",
        x: 30,
        y: 19
      }
    ],
    version: 1
  },
  small_orange_diamond: {
    id: "small_orange_diamond",
    name: "Small Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f538",
        native: "🔸",
        x: 30,
        y: 20
      }
    ],
    version: 1
  },
  small_blue_diamond: {
    id: "small_blue_diamond",
    name: "Small Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f539",
        native: "🔹",
        x: 30,
        y: 21
      }
    ],
    version: 1
  },
  small_red_triangle: {
    id: "small_red_triangle",
    name: "Red Triangle Pointed Up",
    keywords: [
      "small",
      "shape",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "1f53a",
        native: "🔺",
        x: 30,
        y: 22
      }
    ],
    version: 1
  },
  small_red_triangle_down: {
    id: "small_red_triangle_down",
    name: "Red Triangle Pointed Down",
    keywords: [
      "small",
      "shape",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53b",
        native: "🔻",
        x: 30,
        y: 23
      }
    ],
    version: 1
  },
  diamond_shape_with_a_dot_inside: {
    id: "diamond_shape_with_a_dot_inside",
    name: "Diamond with a Dot",
    keywords: [
      "shape",
      "inside",
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    skins: [
      {
        unified: "1f4a0",
        native: "💠",
        x: 27,
        y: 47
      }
    ],
    version: 1
  },
  radio_button: {
    id: "radio_button",
    name: "Radio Button",
    keywords: [
      "input",
      "old",
      "music",
      "circle"
    ],
    skins: [
      {
        unified: "1f518",
        native: "🔘",
        x: 29,
        y: 49
      }
    ],
    version: 1
  },
  white_square_button: {
    id: "white_square_button",
    name: "White Square Button",
    keywords: [
      "shape",
      "input"
    ],
    skins: [
      {
        unified: "1f533",
        native: "🔳",
        x: 30,
        y: 15
      }
    ],
    version: 1
  },
  black_square_button: {
    id: "black_square_button",
    name: "Black Square Button",
    keywords: [
      "shape",
      "input",
      "frame"
    ],
    skins: [
      {
        unified: "1f532",
        native: "🔲",
        x: 30,
        y: 14
      }
    ],
    version: 1
  },
  checkered_flag: {
    id: "checkered_flag",
    name: "Chequered Flag",
    keywords: [
      "checkered",
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    skins: [
      {
        unified: "1f3c1",
        native: "🏁",
        x: 8,
        y: 7
      }
    ],
    version: 1
  },
  triangular_flag_on_post: {
    id: "triangular_flag_on_post",
    name: "Triangular Flag",
    keywords: [
      "on",
      "post",
      "mark",
      "milestone",
      "place"
    ],
    skins: [
      {
        unified: "1f6a9",
        native: "🚩",
        x: 36,
        y: 29
      }
    ],
    version: 1
  },
  crossed_flags: {
    id: "crossed_flags",
    name: "Crossed Flags",
    keywords: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    skins: [
      {
        unified: "1f38c",
        native: "🎌",
        x: 7,
        y: 20
      }
    ],
    version: 1
  },
  waving_black_flag: {
    id: "waving_black_flag",
    name: "Black Flag",
    keywords: [
      "waving",
      "pirate"
    ],
    skins: [
      {
        unified: "1f3f4",
        native: "🏴",
        x: 10,
        y: 35
      }
    ],
    version: 1
  },
  waving_white_flag: {
    id: "waving_white_flag",
    name: "White Flag",
    keywords: [
      "waving",
      "losing",
      "loser",
      "lost",
      "surrender",
      "give",
      "up",
      "fail"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f",
        native: "🏳️",
        x: 10,
        y: 30
      }
    ],
    version: 1
  },
  "rainbow-flag": {
    id: "rainbow-flag",
    name: "Rainbow Flag",
    keywords: [
      "pride",
      "gay",
      "lgbt",
      "glbt",
      "queer",
      "homosexual",
      "lesbian",
      "bisexual",
      "transgender"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-1f308",
        native: "🏳️‍🌈",
        x: 10,
        y: 28
      }
    ],
    version: 4
  },
  transgender_flag: {
    id: "transgender_flag",
    name: "Transgender Flag",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-26a7-fe0f",
        native: "🏳️‍⚧️",
        x: 10,
        y: 29
      }
    ],
    version: 13
  },
  pirate_flag: {
    id: "pirate_flag",
    name: "Pirate Flag",
    keywords: [
      "skull",
      "crossbones",
      "banner"
    ],
    skins: [
      {
        unified: "1f3f4-200d-2620-fe0f",
        native: "🏴‍☠️",
        x: 10,
        y: 31
      }
    ],
    version: 11
  },
  "flag-ac": {
    id: "flag-ac",
    name: "Ascension Island Flag",
    keywords: [
      "ac"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e8",
        native: "🇦🇨",
        x: 0,
        y: 31
      }
    ],
    version: 2
  },
  "flag-ad": {
    id: "flag-ad",
    name: "Andorra Flag",
    keywords: [
      "ad",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e9",
        native: "🇦🇩",
        x: 0,
        y: 32
      }
    ],
    version: 2
  },
  "flag-ae": {
    id: "flag-ae",
    name: "United Arab Emirates Flag",
    keywords: [
      "ae",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ea",
        native: "🇦🇪",
        x: 0,
        y: 33
      }
    ],
    version: 2
  },
  "flag-af": {
    id: "flag-af",
    name: "Afghanistan Flag",
    keywords: [
      "af",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1eb",
        native: "🇦🇫",
        x: 0,
        y: 34
      }
    ],
    version: 2
  },
  "flag-ag": {
    id: "flag-ag",
    name: "Antigua & Barbuda Flag",
    keywords: [
      "ag",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ec",
        native: "🇦🇬",
        x: 0,
        y: 35
      }
    ],
    version: 2
  },
  "flag-ai": {
    id: "flag-ai",
    name: "Anguilla Flag",
    keywords: [
      "ai",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ee",
        native: "🇦🇮",
        x: 0,
        y: 36
      }
    ],
    version: 2
  },
  "flag-al": {
    id: "flag-al",
    name: "Albania Flag",
    keywords: [
      "al",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f1",
        native: "🇦🇱",
        x: 0,
        y: 37
      }
    ],
    version: 2
  },
  "flag-am": {
    id: "flag-am",
    name: "Armenia Flag",
    keywords: [
      "am",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f2",
        native: "🇦🇲",
        x: 0,
        y: 38
      }
    ],
    version: 2
  },
  "flag-ao": {
    id: "flag-ao",
    name: "Angola Flag",
    keywords: [
      "ao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f4",
        native: "🇦🇴",
        x: 0,
        y: 39
      }
    ],
    version: 2
  },
  "flag-aq": {
    id: "flag-aq",
    name: "Antarctica Flag",
    keywords: [
      "aq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f6",
        native: "🇦🇶",
        x: 0,
        y: 40
      }
    ],
    version: 2
  },
  "flag-ar": {
    id: "flag-ar",
    name: "Argentina Flag",
    keywords: [
      "ar",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f7",
        native: "🇦🇷",
        x: 0,
        y: 41
      }
    ],
    version: 2
  },
  "flag-as": {
    id: "flag-as",
    name: "American Samoa Flag",
    keywords: [
      "as",
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f8",
        native: "🇦🇸",
        x: 0,
        y: 42
      }
    ],
    version: 2
  },
  "flag-at": {
    id: "flag-at",
    name: "Austria Flag",
    keywords: [
      "at",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f9",
        native: "🇦🇹",
        x: 0,
        y: 43
      }
    ],
    version: 2
  },
  "flag-au": {
    id: "flag-au",
    name: "Australia Flag",
    keywords: [
      "au",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fa",
        native: "🇦🇺",
        x: 0,
        y: 44
      }
    ],
    version: 2
  },
  "flag-aw": {
    id: "flag-aw",
    name: "Aruba Flag",
    keywords: [
      "aw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fc",
        native: "🇦🇼",
        x: 0,
        y: 45
      }
    ],
    version: 2
  },
  "flag-ax": {
    id: "flag-ax",
    name: "Åland Islands Flag",
    keywords: [
      "ax",
      "aland",
      "Aland",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fd",
        native: "🇦🇽",
        x: 0,
        y: 46
      }
    ],
    version: 2
  },
  "flag-az": {
    id: "flag-az",
    name: "Azerbaijan Flag",
    keywords: [
      "az",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ff",
        native: "🇦🇿",
        x: 0,
        y: 47
      }
    ],
    version: 2
  },
  "flag-ba": {
    id: "flag-ba",
    name: "Bosnia & Herzegovina Flag",
    keywords: [
      "ba",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e6",
        native: "🇧🇦",
        x: 0,
        y: 48
      }
    ],
    version: 2
  },
  "flag-bb": {
    id: "flag-bb",
    name: "Barbados Flag",
    keywords: [
      "bb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e7",
        native: "🇧🇧",
        x: 0,
        y: 49
      }
    ],
    version: 2
  },
  "flag-bd": {
    id: "flag-bd",
    name: "Bangladesh Flag",
    keywords: [
      "bd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e9",
        native: "🇧🇩",
        x: 0,
        y: 50
      }
    ],
    version: 2
  },
  "flag-be": {
    id: "flag-be",
    name: "Belgium Flag",
    keywords: [
      "be",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ea",
        native: "🇧🇪",
        x: 0,
        y: 51
      }
    ],
    version: 2
  },
  "flag-bf": {
    id: "flag-bf",
    name: "Burkina Faso Flag",
    keywords: [
      "bf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1eb",
        native: "🇧🇫",
        x: 0,
        y: 52
      }
    ],
    version: 2
  },
  "flag-bg": {
    id: "flag-bg",
    name: "Bulgaria Flag",
    keywords: [
      "bg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ec",
        native: "🇧🇬",
        x: 0,
        y: 53
      }
    ],
    version: 2
  },
  "flag-bh": {
    id: "flag-bh",
    name: "Bahrain Flag",
    keywords: [
      "bh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ed",
        native: "🇧🇭",
        x: 0,
        y: 54
      }
    ],
    version: 2
  },
  "flag-bi": {
    id: "flag-bi",
    name: "Burundi Flag",
    keywords: [
      "bi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ee",
        native: "🇧🇮",
        x: 0,
        y: 55
      }
    ],
    version: 2
  },
  "flag-bj": {
    id: "flag-bj",
    name: "Benin Flag",
    keywords: [
      "bj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ef",
        native: "🇧🇯",
        x: 0,
        y: 56
      }
    ],
    version: 2
  },
  "flag-bl": {
    id: "flag-bl",
    name: "St. Barthélemy Flag",
    keywords: [
      "bl",
      "st",
      "barthelemy",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f1",
        native: "🇧🇱",
        x: 0,
        y: 57
      }
    ],
    version: 2
  },
  "flag-bm": {
    id: "flag-bm",
    name: "Bermuda Flag",
    keywords: [
      "bm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f2",
        native: "🇧🇲",
        x: 0,
        y: 58
      }
    ],
    version: 2
  },
  "flag-bn": {
    id: "flag-bn",
    name: "Brunei Flag",
    keywords: [
      "bn",
      "darussalam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f3",
        native: "🇧🇳",
        x: 0,
        y: 59
      }
    ],
    version: 2
  },
  "flag-bo": {
    id: "flag-bo",
    name: "Bolivia Flag",
    keywords: [
      "bo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f4",
        native: "🇧🇴",
        x: 0,
        y: 60
      }
    ],
    version: 2
  },
  "flag-bq": {
    id: "flag-bq",
    name: "Caribbean Netherlands Flag",
    keywords: [
      "bq",
      "bonaire",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f6",
        native: "🇧🇶",
        x: 1,
        y: 0
      }
    ],
    version: 2
  },
  "flag-br": {
    id: "flag-br",
    name: "Brazil Flag",
    keywords: [
      "br",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f7",
        native: "🇧🇷",
        x: 1,
        y: 1
      }
    ],
    version: 2
  },
  "flag-bs": {
    id: "flag-bs",
    name: "Bahamas Flag",
    keywords: [
      "bs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f8",
        native: "🇧🇸",
        x: 1,
        y: 2
      }
    ],
    version: 2
  },
  "flag-bt": {
    id: "flag-bt",
    name: "Bhutan Flag",
    keywords: [
      "bt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f9",
        native: "🇧🇹",
        x: 1,
        y: 3
      }
    ],
    version: 2
  },
  "flag-bv": {
    id: "flag-bv",
    name: "Bouvet Island Flag",
    keywords: [
      "bv",
      "norway"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fb",
        native: "🇧🇻",
        x: 1,
        y: 4
      }
    ],
    version: 2
  },
  "flag-bw": {
    id: "flag-bw",
    name: "Botswana Flag",
    keywords: [
      "bw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fc",
        native: "🇧🇼",
        x: 1,
        y: 5
      }
    ],
    version: 2
  },
  "flag-by": {
    id: "flag-by",
    name: "Belarus Flag",
    keywords: [
      "by",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fe",
        native: "🇧🇾",
        x: 1,
        y: 6
      }
    ],
    version: 2
  },
  "flag-bz": {
    id: "flag-bz",
    name: "Belize Flag",
    keywords: [
      "bz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ff",
        native: "🇧🇿",
        x: 1,
        y: 7
      }
    ],
    version: 2
  },
  "flag-ca": {
    id: "flag-ca",
    name: "Canada Flag",
    keywords: [
      "ca",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e6",
        native: "🇨🇦",
        x: 1,
        y: 8
      }
    ],
    version: 2
  },
  "flag-cc": {
    id: "flag-cc",
    name: "Cocos (keeling) Islands Flag",
    keywords: [
      "cc",
      "keeling",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e8",
        native: "🇨🇨",
        x: 1,
        y: 9
      }
    ],
    version: 2
  },
  "flag-cd": {
    id: "flag-cd",
    name: "Congo - Kinshasa Flag",
    keywords: [
      "cd",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e9",
        native: "🇨🇩",
        x: 1,
        y: 10
      }
    ],
    version: 2
  },
  "flag-cf": {
    id: "flag-cf",
    name: "Central African Republic Flag",
    keywords: [
      "cf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1eb",
        native: "🇨🇫",
        x: 1,
        y: 11
      }
    ],
    version: 2
  },
  "flag-cg": {
    id: "flag-cg",
    name: "Congo - Brazzaville Flag",
    keywords: [
      "cg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ec",
        native: "🇨🇬",
        x: 1,
        y: 12
      }
    ],
    version: 2
  },
  "flag-ch": {
    id: "flag-ch",
    name: "Switzerland Flag",
    keywords: [
      "ch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ed",
        native: "🇨🇭",
        x: 1,
        y: 13
      }
    ],
    version: 2
  },
  "flag-ci": {
    id: "flag-ci",
    name: "Côte D’ivoire Flag",
    keywords: [
      "ci",
      "cote",
      "d",
      "ivoire",
      "ivory",
      "coast",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ee",
        native: "🇨🇮",
        x: 1,
        y: 14
      }
    ],
    version: 2
  },
  "flag-ck": {
    id: "flag-ck",
    name: "Cook Islands Flag",
    keywords: [
      "ck",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f0",
        native: "🇨🇰",
        x: 1,
        y: 15
      }
    ],
    version: 2
  },
  "flag-cl": {
    id: "flag-cl",
    name: "Chile Flag",
    keywords: [
      "cl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f1",
        native: "🇨🇱",
        x: 1,
        y: 16
      }
    ],
    version: 2
  },
  "flag-cm": {
    id: "flag-cm",
    name: "Cameroon Flag",
    keywords: [
      "cm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f2",
        native: "🇨🇲",
        x: 1,
        y: 17
      }
    ],
    version: 2
  },
  cn: {
    id: "cn",
    name: "China Flag",
    keywords: [
      "cn",
      "chinese",
      "prc",
      "country",
      "nation",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f3",
        native: "🇨🇳",
        x: 1,
        y: 18
      }
    ],
    version: 1
  },
  "flag-co": {
    id: "flag-co",
    name: "Colombia Flag",
    keywords: [
      "co",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f4",
        native: "🇨🇴",
        x: 1,
        y: 19
      }
    ],
    version: 2
  },
  "flag-cp": {
    id: "flag-cp",
    name: "Clipperton Island Flag",
    keywords: [
      "cp"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f5",
        native: "🇨🇵",
        x: 1,
        y: 20
      }
    ],
    version: 2
  },
  "flag-cr": {
    id: "flag-cr",
    name: "Costa Rica Flag",
    keywords: [
      "cr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f7",
        native: "🇨🇷",
        x: 1,
        y: 21
      }
    ],
    version: 2
  },
  "flag-cu": {
    id: "flag-cu",
    name: "Cuba Flag",
    keywords: [
      "cu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fa",
        native: "🇨🇺",
        x: 1,
        y: 22
      }
    ],
    version: 2
  },
  "flag-cv": {
    id: "flag-cv",
    name: "Cape Verde Flag",
    keywords: [
      "cv",
      "cabo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fb",
        native: "🇨🇻",
        x: 1,
        y: 23
      }
    ],
    version: 2
  },
  "flag-cw": {
    id: "flag-cw",
    name: "Curaçao Flag",
    keywords: [
      "cw",
      "curacao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fc",
        native: "🇨🇼",
        x: 1,
        y: 24
      }
    ],
    version: 2
  },
  "flag-cx": {
    id: "flag-cx",
    name: "Christmas Island Flag",
    keywords: [
      "cx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fd",
        native: "🇨🇽",
        x: 1,
        y: 25
      }
    ],
    version: 2
  },
  "flag-cy": {
    id: "flag-cy",
    name: "Cyprus Flag",
    keywords: [
      "cy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fe",
        native: "🇨🇾",
        x: 1,
        y: 26
      }
    ],
    version: 2
  },
  "flag-cz": {
    id: "flag-cz",
    name: "Czechia Flag",
    keywords: [
      "cz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ff",
        native: "🇨🇿",
        x: 1,
        y: 27
      }
    ],
    version: 2
  },
  de: {
    id: "de",
    name: "Germany Flag",
    keywords: [
      "de",
      "german",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ea",
        native: "🇩🇪",
        x: 1,
        y: 28
      }
    ],
    version: 1
  },
  "flag-dg": {
    id: "flag-dg",
    name: "Diego Garcia Flag",
    keywords: [
      "dg"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ec",
        native: "🇩🇬",
        x: 1,
        y: 29
      }
    ],
    version: 2
  },
  "flag-dj": {
    id: "flag-dj",
    name: "Djibouti Flag",
    keywords: [
      "dj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ef",
        native: "🇩🇯",
        x: 1,
        y: 30
      }
    ],
    version: 2
  },
  "flag-dk": {
    id: "flag-dk",
    name: "Denmark Flag",
    keywords: [
      "dk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f0",
        native: "🇩🇰",
        x: 1,
        y: 31
      }
    ],
    version: 2
  },
  "flag-dm": {
    id: "flag-dm",
    name: "Dominica Flag",
    keywords: [
      "dm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f2",
        native: "🇩🇲",
        x: 1,
        y: 32
      }
    ],
    version: 2
  },
  "flag-do": {
    id: "flag-do",
    name: "Dominican Republic Flag",
    keywords: [
      "do",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f4",
        native: "🇩🇴",
        x: 1,
        y: 33
      }
    ],
    version: 2
  },
  "flag-dz": {
    id: "flag-dz",
    name: "Algeria Flag",
    keywords: [
      "dz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ff",
        native: "🇩🇿",
        x: 1,
        y: 34
      }
    ],
    version: 2
  },
  "flag-ea": {
    id: "flag-ea",
    name: "Ceuta & Melilla Flag",
    keywords: [
      "ea"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e6",
        native: "🇪🇦",
        x: 1,
        y: 35
      }
    ],
    version: 2
  },
  "flag-ec": {
    id: "flag-ec",
    name: "Ecuador Flag",
    keywords: [
      "ec",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e8",
        native: "🇪🇨",
        x: 1,
        y: 36
      }
    ],
    version: 2
  },
  "flag-ee": {
    id: "flag-ee",
    name: "Estonia Flag",
    keywords: [
      "ee",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ea",
        native: "🇪🇪",
        x: 1,
        y: 37
      }
    ],
    version: 2
  },
  "flag-eg": {
    id: "flag-eg",
    name: "Egypt Flag",
    keywords: [
      "eg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ec",
        native: "🇪🇬",
        x: 1,
        y: 38
      }
    ],
    version: 2
  },
  "flag-eh": {
    id: "flag-eh",
    name: "Western Sahara Flag",
    keywords: [
      "eh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ed",
        native: "🇪🇭",
        x: 1,
        y: 39
      }
    ],
    version: 2
  },
  "flag-er": {
    id: "flag-er",
    name: "Eritrea Flag",
    keywords: [
      "er",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f7",
        native: "🇪🇷",
        x: 1,
        y: 40
      }
    ],
    version: 2
  },
  es: {
    id: "es",
    name: "Spain Flag",
    keywords: [
      "es",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f8",
        native: "🇪🇸",
        x: 1,
        y: 41
      }
    ],
    version: 1
  },
  "flag-et": {
    id: "flag-et",
    name: "Ethiopia Flag",
    keywords: [
      "et",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f9",
        native: "🇪🇹",
        x: 1,
        y: 42
      }
    ],
    version: 2
  },
  "flag-eu": {
    id: "flag-eu",
    name: "European Union Flag",
    keywords: [
      "eu",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1fa",
        native: "🇪🇺",
        x: 1,
        y: 43
      }
    ],
    version: 2
  },
  "flag-fi": {
    id: "flag-fi",
    name: "Finland Flag",
    keywords: [
      "fi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ee",
        native: "🇫🇮",
        x: 1,
        y: 44
      }
    ],
    version: 2
  },
  "flag-fj": {
    id: "flag-fj",
    name: "Fiji Flag",
    keywords: [
      "fj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ef",
        native: "🇫🇯",
        x: 1,
        y: 45
      }
    ],
    version: 2
  },
  "flag-fk": {
    id: "flag-fk",
    name: "Falkland Islands Flag",
    keywords: [
      "fk",
      "malvinas",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f0",
        native: "🇫🇰",
        x: 1,
        y: 46
      }
    ],
    version: 2
  },
  "flag-fm": {
    id: "flag-fm",
    name: "Micronesia Flag",
    keywords: [
      "fm",
      "federated",
      "states",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f2",
        native: "🇫🇲",
        x: 1,
        y: 47
      }
    ],
    version: 2
  },
  "flag-fo": {
    id: "flag-fo",
    name: "Faroe Islands Flag",
    keywords: [
      "fo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f4",
        native: "🇫🇴",
        x: 1,
        y: 48
      }
    ],
    version: 2
  },
  fr: {
    id: "fr",
    name: "France Flag",
    keywords: [
      "fr",
      "banner",
      "nation",
      "french",
      "country"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f7",
        native: "🇫🇷",
        x: 1,
        y: 49
      }
    ],
    version: 1
  },
  "flag-ga": {
    id: "flag-ga",
    name: "Gabon Flag",
    keywords: [
      "ga",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e6",
        native: "🇬🇦",
        x: 1,
        y: 50
      }
    ],
    version: 2
  },
  gb: {
    id: "gb",
    name: "United Kingdom Flag",
    keywords: [
      "gb",
      "uk",
      "great",
      "britain",
      "northern",
      "ireland",
      "nation",
      "country",
      "banner",
      "british",
      "UK",
      "english",
      "england",
      "union",
      "jack"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e7",
        native: "🇬🇧",
        x: 1,
        y: 51
      }
    ],
    version: 1
  },
  "flag-gd": {
    id: "flag-gd",
    name: "Grenada Flag",
    keywords: [
      "gd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e9",
        native: "🇬🇩",
        x: 1,
        y: 52
      }
    ],
    version: 2
  },
  "flag-ge": {
    id: "flag-ge",
    name: "Georgia Flag",
    keywords: [
      "ge",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ea",
        native: "🇬🇪",
        x: 1,
        y: 53
      }
    ],
    version: 2
  },
  "flag-gf": {
    id: "flag-gf",
    name: "French Guiana Flag",
    keywords: [
      "gf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1eb",
        native: "🇬🇫",
        x: 1,
        y: 54
      }
    ],
    version: 2
  },
  "flag-gg": {
    id: "flag-gg",
    name: "Guernsey Flag",
    keywords: [
      "gg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ec",
        native: "🇬🇬",
        x: 1,
        y: 55
      }
    ],
    version: 2
  },
  "flag-gh": {
    id: "flag-gh",
    name: "Ghana Flag",
    keywords: [
      "gh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ed",
        native: "🇬🇭",
        x: 1,
        y: 56
      }
    ],
    version: 2
  },
  "flag-gi": {
    id: "flag-gi",
    name: "Gibraltar Flag",
    keywords: [
      "gi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ee",
        native: "🇬🇮",
        x: 1,
        y: 57
      }
    ],
    version: 2
  },
  "flag-gl": {
    id: "flag-gl",
    name: "Greenland Flag",
    keywords: [
      "gl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f1",
        native: "🇬🇱",
        x: 1,
        y: 58
      }
    ],
    version: 2
  },
  "flag-gm": {
    id: "flag-gm",
    name: "Gambia Flag",
    keywords: [
      "gm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f2",
        native: "🇬🇲",
        x: 1,
        y: 59
      }
    ],
    version: 2
  },
  "flag-gn": {
    id: "flag-gn",
    name: "Guinea Flag",
    keywords: [
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f3",
        native: "🇬🇳",
        x: 1,
        y: 60
      }
    ],
    version: 2
  },
  "flag-gp": {
    id: "flag-gp",
    name: "Guadeloupe Flag",
    keywords: [
      "gp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f5",
        native: "🇬🇵",
        x: 2,
        y: 0
      }
    ],
    version: 2
  },
  "flag-gq": {
    id: "flag-gq",
    name: "Equatorial Guinea Flag",
    keywords: [
      "gq",
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f6",
        native: "🇬🇶",
        x: 2,
        y: 1
      }
    ],
    version: 2
  },
  "flag-gr": {
    id: "flag-gr",
    name: "Greece Flag",
    keywords: [
      "gr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f7",
        native: "🇬🇷",
        x: 2,
        y: 2
      }
    ],
    version: 2
  },
  "flag-gs": {
    id: "flag-gs",
    name: "South Georgia & South Sandwich Islands Flag",
    keywords: [
      "gs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f8",
        native: "🇬🇸",
        x: 2,
        y: 3
      }
    ],
    version: 2
  },
  "flag-gt": {
    id: "flag-gt",
    name: "Guatemala Flag",
    keywords: [
      "gt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f9",
        native: "🇬🇹",
        x: 2,
        y: 4
      }
    ],
    version: 2
  },
  "flag-gu": {
    id: "flag-gu",
    name: "Guam Flag",
    keywords: [
      "gu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fa",
        native: "🇬🇺",
        x: 2,
        y: 5
      }
    ],
    version: 2
  },
  "flag-gw": {
    id: "flag-gw",
    name: "Guinea-Bissau Flag",
    keywords: [
      "gw",
      "guinea",
      "bissau",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fc",
        native: "🇬🇼",
        x: 2,
        y: 6
      }
    ],
    version: 2
  },
  "flag-gy": {
    id: "flag-gy",
    name: "Guyana Flag",
    keywords: [
      "gy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fe",
        native: "🇬🇾",
        x: 2,
        y: 7
      }
    ],
    version: 2
  },
  "flag-hk": {
    id: "flag-hk",
    name: "Hong Kong Sar China Flag",
    keywords: [
      "hk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f0",
        native: "🇭🇰",
        x: 2,
        y: 8
      }
    ],
    version: 2
  },
  "flag-hm": {
    id: "flag-hm",
    name: "Heard & Mcdonald Islands Flag",
    keywords: [
      "hm"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f2",
        native: "🇭🇲",
        x: 2,
        y: 9
      }
    ],
    version: 2
  },
  "flag-hn": {
    id: "flag-hn",
    name: "Honduras Flag",
    keywords: [
      "hn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f3",
        native: "🇭🇳",
        x: 2,
        y: 10
      }
    ],
    version: 2
  },
  "flag-hr": {
    id: "flag-hr",
    name: "Croatia Flag",
    keywords: [
      "hr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f7",
        native: "🇭🇷",
        x: 2,
        y: 11
      }
    ],
    version: 2
  },
  "flag-ht": {
    id: "flag-ht",
    name: "Haiti Flag",
    keywords: [
      "ht",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f9",
        native: "🇭🇹",
        x: 2,
        y: 12
      }
    ],
    version: 2
  },
  "flag-hu": {
    id: "flag-hu",
    name: "Hungary Flag",
    keywords: [
      "hu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1fa",
        native: "🇭🇺",
        x: 2,
        y: 13
      }
    ],
    version: 2
  },
  "flag-ic": {
    id: "flag-ic",
    name: "Canary Islands Flag",
    keywords: [
      "ic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e8",
        native: "🇮🇨",
        x: 2,
        y: 14
      }
    ],
    version: 2
  },
  "flag-id": {
    id: "flag-id",
    name: "Indonesia Flag",
    keywords: [
      "id",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e9",
        native: "🇮🇩",
        x: 2,
        y: 15
      }
    ],
    version: 2
  },
  "flag-ie": {
    id: "flag-ie",
    name: "Ireland Flag",
    keywords: [
      "ie",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1ea",
        native: "🇮🇪",
        x: 2,
        y: 16
      }
    ],
    version: 2
  },
  "flag-il": {
    id: "flag-il",
    name: "Israel Flag",
    keywords: [
      "il",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f1",
        native: "🇮🇱",
        x: 2,
        y: 17
      }
    ],
    version: 2
  },
  "flag-im": {
    id: "flag-im",
    name: "Isle of Man Flag",
    keywords: [
      "im",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f2",
        native: "🇮🇲",
        x: 2,
        y: 18
      }
    ],
    version: 2
  },
  "flag-in": {
    id: "flag-in",
    name: "India Flag",
    keywords: [
      "in",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f3",
        native: "🇮🇳",
        x: 2,
        y: 19
      }
    ],
    version: 2
  },
  "flag-io": {
    id: "flag-io",
    name: "British Indian Ocean Territory Flag",
    keywords: [
      "io",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f4",
        native: "🇮🇴",
        x: 2,
        y: 20
      }
    ],
    version: 2
  },
  "flag-iq": {
    id: "flag-iq",
    name: "Iraq Flag",
    keywords: [
      "iq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f6",
        native: "🇮🇶",
        x: 2,
        y: 21
      }
    ],
    version: 2
  },
  "flag-ir": {
    id: "flag-ir",
    name: "Iran Flag",
    keywords: [
      "ir",
      "islamic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f7",
        native: "🇮🇷",
        x: 2,
        y: 22
      }
    ],
    version: 2
  },
  "flag-is": {
    id: "flag-is",
    name: "Iceland Flag",
    keywords: [
      "is",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f8",
        native: "🇮🇸",
        x: 2,
        y: 23
      }
    ],
    version: 2
  },
  it: {
    id: "it",
    name: "Italy Flag",
    keywords: [
      "it",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f9",
        native: "🇮🇹",
        x: 2,
        y: 24
      }
    ],
    version: 1
  },
  "flag-je": {
    id: "flag-je",
    name: "Jersey Flag",
    keywords: [
      "je",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1ea",
        native: "🇯🇪",
        x: 2,
        y: 25
      }
    ],
    version: 2
  },
  "flag-jm": {
    id: "flag-jm",
    name: "Jamaica Flag",
    keywords: [
      "jm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f2",
        native: "🇯🇲",
        x: 2,
        y: 26
      }
    ],
    version: 2
  },
  "flag-jo": {
    id: "flag-jo",
    name: "Jordan Flag",
    keywords: [
      "jo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f4",
        native: "🇯🇴",
        x: 2,
        y: 27
      }
    ],
    version: 2
  },
  jp: {
    id: "jp",
    name: "Japan Flag",
    keywords: [
      "jp",
      "japanese",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f5",
        native: "🇯🇵",
        x: 2,
        y: 28
      }
    ],
    version: 1
  },
  "flag-ke": {
    id: "flag-ke",
    name: "Kenya Flag",
    keywords: [
      "ke",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ea",
        native: "🇰🇪",
        x: 2,
        y: 29
      }
    ],
    version: 2
  },
  "flag-kg": {
    id: "flag-kg",
    name: "Kyrgyzstan Flag",
    keywords: [
      "kg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ec",
        native: "🇰🇬",
        x: 2,
        y: 30
      }
    ],
    version: 2
  },
  "flag-kh": {
    id: "flag-kh",
    name: "Cambodia Flag",
    keywords: [
      "kh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ed",
        native: "🇰🇭",
        x: 2,
        y: 31
      }
    ],
    version: 2
  },
  "flag-ki": {
    id: "flag-ki",
    name: "Kiribati Flag",
    keywords: [
      "ki",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ee",
        native: "🇰🇮",
        x: 2,
        y: 32
      }
    ],
    version: 2
  },
  "flag-km": {
    id: "flag-km",
    name: "Comoros Flag",
    keywords: [
      "km",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f2",
        native: "🇰🇲",
        x: 2,
        y: 33
      }
    ],
    version: 2
  },
  "flag-kn": {
    id: "flag-kn",
    name: "St. Kitts & Nevis Flag",
    keywords: [
      "kn",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f3",
        native: "🇰🇳",
        x: 2,
        y: 34
      }
    ],
    version: 2
  },
  "flag-kp": {
    id: "flag-kp",
    name: "North Korea Flag",
    keywords: [
      "kp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f5",
        native: "🇰🇵",
        x: 2,
        y: 35
      }
    ],
    version: 2
  },
  kr: {
    id: "kr",
    name: "South Korea Flag",
    keywords: [
      "kr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f7",
        native: "🇰🇷",
        x: 2,
        y: 36
      }
    ],
    version: 1
  },
  "flag-kw": {
    id: "flag-kw",
    name: "Kuwait Flag",
    keywords: [
      "kw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fc",
        native: "🇰🇼",
        x: 2,
        y: 37
      }
    ],
    version: 2
  },
  "flag-ky": {
    id: "flag-ky",
    name: "Cayman Islands Flag",
    keywords: [
      "ky",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fe",
        native: "🇰🇾",
        x: 2,
        y: 38
      }
    ],
    version: 2
  },
  "flag-kz": {
    id: "flag-kz",
    name: "Kazakhstan Flag",
    keywords: [
      "kz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ff",
        native: "🇰🇿",
        x: 2,
        y: 39
      }
    ],
    version: 2
  },
  "flag-la": {
    id: "flag-la",
    name: "Laos Flag",
    keywords: [
      "la",
      "lao",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e6",
        native: "🇱🇦",
        x: 2,
        y: 40
      }
    ],
    version: 2
  },
  "flag-lb": {
    id: "flag-lb",
    name: "Lebanon Flag",
    keywords: [
      "lb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e7",
        native: "🇱🇧",
        x: 2,
        y: 41
      }
    ],
    version: 2
  },
  "flag-lc": {
    id: "flag-lc",
    name: "St. Lucia Flag",
    keywords: [
      "lc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e8",
        native: "🇱🇨",
        x: 2,
        y: 42
      }
    ],
    version: 2
  },
  "flag-li": {
    id: "flag-li",
    name: "Liechtenstein Flag",
    keywords: [
      "li",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1ee",
        native: "🇱🇮",
        x: 2,
        y: 43
      }
    ],
    version: 2
  },
  "flag-lk": {
    id: "flag-lk",
    name: "Sri Lanka Flag",
    keywords: [
      "lk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f0",
        native: "🇱🇰",
        x: 2,
        y: 44
      }
    ],
    version: 2
  },
  "flag-lr": {
    id: "flag-lr",
    name: "Liberia Flag",
    keywords: [
      "lr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f7",
        native: "🇱🇷",
        x: 2,
        y: 45
      }
    ],
    version: 2
  },
  "flag-ls": {
    id: "flag-ls",
    name: "Lesotho Flag",
    keywords: [
      "ls",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f8",
        native: "🇱🇸",
        x: 2,
        y: 46
      }
    ],
    version: 2
  },
  "flag-lt": {
    id: "flag-lt",
    name: "Lithuania Flag",
    keywords: [
      "lt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f9",
        native: "🇱🇹",
        x: 2,
        y: 47
      }
    ],
    version: 2
  },
  "flag-lu": {
    id: "flag-lu",
    name: "Luxembourg Flag",
    keywords: [
      "lu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fa",
        native: "🇱🇺",
        x: 2,
        y: 48
      }
    ],
    version: 2
  },
  "flag-lv": {
    id: "flag-lv",
    name: "Latvia Flag",
    keywords: [
      "lv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fb",
        native: "🇱🇻",
        x: 2,
        y: 49
      }
    ],
    version: 2
  },
  "flag-ly": {
    id: "flag-ly",
    name: "Libya Flag",
    keywords: [
      "ly",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fe",
        native: "🇱🇾",
        x: 2,
        y: 50
      }
    ],
    version: 2
  },
  "flag-ma": {
    id: "flag-ma",
    name: "Morocco Flag",
    keywords: [
      "ma",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e6",
        native: "🇲🇦",
        x: 2,
        y: 51
      }
    ],
    version: 2
  },
  "flag-mc": {
    id: "flag-mc",
    name: "Monaco Flag",
    keywords: [
      "mc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e8",
        native: "🇲🇨",
        x: 2,
        y: 52
      }
    ],
    version: 2
  },
  "flag-md": {
    id: "flag-md",
    name: "Moldova Flag",
    keywords: [
      "md",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e9",
        native: "🇲🇩",
        x: 2,
        y: 53
      }
    ],
    version: 2
  },
  "flag-me": {
    id: "flag-me",
    name: "Montenegro Flag",
    keywords: [
      "me",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ea",
        native: "🇲🇪",
        x: 2,
        y: 54
      }
    ],
    version: 2
  },
  "flag-mf": {
    id: "flag-mf",
    name: "St. Martin Flag",
    keywords: [
      "mf",
      "st"
    ],
    skins: [
      {
        unified: "1f1f2-1f1eb",
        native: "🇲🇫",
        x: 2,
        y: 55
      }
    ],
    version: 2
  },
  "flag-mg": {
    id: "flag-mg",
    name: "Madagascar Flag",
    keywords: [
      "mg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ec",
        native: "🇲🇬",
        x: 2,
        y: 56
      }
    ],
    version: 2
  },
  "flag-mh": {
    id: "flag-mh",
    name: "Marshall Islands Flag",
    keywords: [
      "mh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ed",
        native: "🇲🇭",
        x: 2,
        y: 57
      }
    ],
    version: 2
  },
  "flag-mk": {
    id: "flag-mk",
    name: "North Macedonia Flag",
    keywords: [
      "mk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f0",
        native: "🇲🇰",
        x: 2,
        y: 58
      }
    ],
    version: 2
  },
  "flag-ml": {
    id: "flag-ml",
    name: "Mali Flag",
    keywords: [
      "ml",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f1",
        native: "🇲🇱",
        x: 2,
        y: 59
      }
    ],
    version: 2
  },
  "flag-mm": {
    id: "flag-mm",
    name: "Myanmar (burma) Flag",
    keywords: [
      "mm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f2",
        native: "🇲🇲",
        x: 2,
        y: 60
      }
    ],
    version: 2
  },
  "flag-mn": {
    id: "flag-mn",
    name: "Mongolia Flag",
    keywords: [
      "mn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f3",
        native: "🇲🇳",
        x: 3,
        y: 0
      }
    ],
    version: 2
  },
  "flag-mo": {
    id: "flag-mo",
    name: "Macao Sar China Flag",
    keywords: [
      "mo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f4",
        native: "🇲🇴",
        x: 3,
        y: 1
      }
    ],
    version: 2
  },
  "flag-mp": {
    id: "flag-mp",
    name: "Northern Mariana Islands Flag",
    keywords: [
      "mp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f5",
        native: "🇲🇵",
        x: 3,
        y: 2
      }
    ],
    version: 2
  },
  "flag-mq": {
    id: "flag-mq",
    name: "Martinique Flag",
    keywords: [
      "mq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f6",
        native: "🇲🇶",
        x: 3,
        y: 3
      }
    ],
    version: 2
  },
  "flag-mr": {
    id: "flag-mr",
    name: "Mauritania Flag",
    keywords: [
      "mr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f7",
        native: "🇲🇷",
        x: 3,
        y: 4
      }
    ],
    version: 2
  },
  "flag-ms": {
    id: "flag-ms",
    name: "Montserrat Flag",
    keywords: [
      "ms",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f8",
        native: "🇲🇸",
        x: 3,
        y: 5
      }
    ],
    version: 2
  },
  "flag-mt": {
    id: "flag-mt",
    name: "Malta Flag",
    keywords: [
      "mt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f9",
        native: "🇲🇹",
        x: 3,
        y: 6
      }
    ],
    version: 2
  },
  "flag-mu": {
    id: "flag-mu",
    name: "Mauritius Flag",
    keywords: [
      "mu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fa",
        native: "🇲🇺",
        x: 3,
        y: 7
      }
    ],
    version: 2
  },
  "flag-mv": {
    id: "flag-mv",
    name: "Maldives Flag",
    keywords: [
      "mv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fb",
        native: "🇲🇻",
        x: 3,
        y: 8
      }
    ],
    version: 2
  },
  "flag-mw": {
    id: "flag-mw",
    name: "Malawi Flag",
    keywords: [
      "mw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fc",
        native: "🇲🇼",
        x: 3,
        y: 9
      }
    ],
    version: 2
  },
  "flag-mx": {
    id: "flag-mx",
    name: "Mexico Flag",
    keywords: [
      "mx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fd",
        native: "🇲🇽",
        x: 3,
        y: 10
      }
    ],
    version: 2
  },
  "flag-my": {
    id: "flag-my",
    name: "Malaysia Flag",
    keywords: [
      "my",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fe",
        native: "🇲🇾",
        x: 3,
        y: 11
      }
    ],
    version: 2
  },
  "flag-mz": {
    id: "flag-mz",
    name: "Mozambique Flag",
    keywords: [
      "mz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ff",
        native: "🇲🇿",
        x: 3,
        y: 12
      }
    ],
    version: 2
  },
  "flag-na": {
    id: "flag-na",
    name: "Namibia Flag",
    keywords: [
      "na",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e6",
        native: "🇳🇦",
        x: 3,
        y: 13
      }
    ],
    version: 2
  },
  "flag-nc": {
    id: "flag-nc",
    name: "New Caledonia Flag",
    keywords: [
      "nc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e8",
        native: "🇳🇨",
        x: 3,
        y: 14
      }
    ],
    version: 2
  },
  "flag-ne": {
    id: "flag-ne",
    name: "Niger Flag",
    keywords: [
      "ne",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ea",
        native: "🇳🇪",
        x: 3,
        y: 15
      }
    ],
    version: 2
  },
  "flag-nf": {
    id: "flag-nf",
    name: "Norfolk Island Flag",
    keywords: [
      "nf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1eb",
        native: "🇳🇫",
        x: 3,
        y: 16
      }
    ],
    version: 2
  },
  "flag-ng": {
    id: "flag-ng",
    name: "Nigeria Flag",
    keywords: [
      "ng",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ec",
        native: "🇳🇬",
        x: 3,
        y: 17
      }
    ],
    version: 2
  },
  "flag-ni": {
    id: "flag-ni",
    name: "Nicaragua Flag",
    keywords: [
      "ni",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ee",
        native: "🇳🇮",
        x: 3,
        y: 18
      }
    ],
    version: 2
  },
  "flag-nl": {
    id: "flag-nl",
    name: "Netherlands Flag",
    keywords: [
      "nl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f1",
        native: "🇳🇱",
        x: 3,
        y: 19
      }
    ],
    version: 2
  },
  "flag-no": {
    id: "flag-no",
    name: "Norway Flag",
    keywords: [
      "no",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f4",
        native: "🇳🇴",
        x: 3,
        y: 20
      }
    ],
    version: 2
  },
  "flag-np": {
    id: "flag-np",
    name: "Nepal Flag",
    keywords: [
      "np",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f5",
        native: "🇳🇵",
        x: 3,
        y: 21
      }
    ],
    version: 2
  },
  "flag-nr": {
    id: "flag-nr",
    name: "Nauru Flag",
    keywords: [
      "nr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f7",
        native: "🇳🇷",
        x: 3,
        y: 22
      }
    ],
    version: 2
  },
  "flag-nu": {
    id: "flag-nu",
    name: "Niue Flag",
    keywords: [
      "nu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1fa",
        native: "🇳🇺",
        x: 3,
        y: 23
      }
    ],
    version: 2
  },
  "flag-nz": {
    id: "flag-nz",
    name: "New Zealand Flag",
    keywords: [
      "nz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ff",
        native: "🇳🇿",
        x: 3,
        y: 24
      }
    ],
    version: 2
  },
  "flag-om": {
    id: "flag-om",
    name: "Oman Flag",
    keywords: [
      "om",
      "symbol",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f4-1f1f2",
        native: "🇴🇲",
        x: 3,
        y: 25
      }
    ],
    version: 2
  },
  "flag-pa": {
    id: "flag-pa",
    name: "Panama Flag",
    keywords: [
      "pa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1e6",
        native: "🇵🇦",
        x: 3,
        y: 26
      }
    ],
    version: 2
  },
  "flag-pe": {
    id: "flag-pe",
    name: "Peru Flag",
    keywords: [
      "pe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ea",
        native: "🇵🇪",
        x: 3,
        y: 27
      }
    ],
    version: 2
  },
  "flag-pf": {
    id: "flag-pf",
    name: "French Polynesia Flag",
    keywords: [
      "pf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1eb",
        native: "🇵🇫",
        x: 3,
        y: 28
      }
    ],
    version: 2
  },
  "flag-pg": {
    id: "flag-pg",
    name: "Papua New Guinea Flag",
    keywords: [
      "pg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ec",
        native: "🇵🇬",
        x: 3,
        y: 29
      }
    ],
    version: 2
  },
  "flag-ph": {
    id: "flag-ph",
    name: "Philippines Flag",
    keywords: [
      "ph",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ed",
        native: "🇵🇭",
        x: 3,
        y: 30
      }
    ],
    version: 2
  },
  "flag-pk": {
    id: "flag-pk",
    name: "Pakistan Flag",
    keywords: [
      "pk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f0",
        native: "🇵🇰",
        x: 3,
        y: 31
      }
    ],
    version: 2
  },
  "flag-pl": {
    id: "flag-pl",
    name: "Poland Flag",
    keywords: [
      "pl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f1",
        native: "🇵🇱",
        x: 3,
        y: 32
      }
    ],
    version: 2
  },
  "flag-pm": {
    id: "flag-pm",
    name: "St. Pierre & Miquelon Flag",
    keywords: [
      "pm",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f2",
        native: "🇵🇲",
        x: 3,
        y: 33
      }
    ],
    version: 2
  },
  "flag-pn": {
    id: "flag-pn",
    name: "Pitcairn Islands Flag",
    keywords: [
      "pn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f3",
        native: "🇵🇳",
        x: 3,
        y: 34
      }
    ],
    version: 2
  },
  "flag-pr": {
    id: "flag-pr",
    name: "Puerto Rico Flag",
    keywords: [
      "pr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f7",
        native: "🇵🇷",
        x: 3,
        y: 35
      }
    ],
    version: 2
  },
  "flag-ps": {
    id: "flag-ps",
    name: "Palestinian Territories Flag",
    keywords: [
      "ps",
      "palestine",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f8",
        native: "🇵🇸",
        x: 3,
        y: 36
      }
    ],
    version: 2
  },
  "flag-pt": {
    id: "flag-pt",
    name: "Portugal Flag",
    keywords: [
      "pt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f9",
        native: "🇵🇹",
        x: 3,
        y: 37
      }
    ],
    version: 2
  },
  "flag-pw": {
    id: "flag-pw",
    name: "Palau Flag",
    keywords: [
      "pw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fc",
        native: "🇵🇼",
        x: 3,
        y: 38
      }
    ],
    version: 2
  },
  "flag-py": {
    id: "flag-py",
    name: "Paraguay Flag",
    keywords: [
      "py",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fe",
        native: "🇵🇾",
        x: 3,
        y: 39
      }
    ],
    version: 2
  },
  "flag-qa": {
    id: "flag-qa",
    name: "Qatar Flag",
    keywords: [
      "qa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f6-1f1e6",
        native: "🇶🇦",
        x: 3,
        y: 40
      }
    ],
    version: 2
  },
  "flag-re": {
    id: "flag-re",
    name: "Réunion Flag",
    keywords: [
      "re",
      "reunion",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1ea",
        native: "🇷🇪",
        x: 3,
        y: 41
      }
    ],
    version: 2
  },
  "flag-ro": {
    id: "flag-ro",
    name: "Romania Flag",
    keywords: [
      "ro",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f4",
        native: "🇷🇴",
        x: 3,
        y: 42
      }
    ],
    version: 2
  },
  "flag-rs": {
    id: "flag-rs",
    name: "Serbia Flag",
    keywords: [
      "rs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f8",
        native: "🇷🇸",
        x: 3,
        y: 43
      }
    ],
    version: 2
  },
  ru: {
    id: "ru",
    name: "Russia Flag",
    keywords: [
      "ru",
      "russian",
      "federation",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fa",
        native: "🇷🇺",
        x: 3,
        y: 44
      }
    ],
    version: 1
  },
  "flag-rw": {
    id: "flag-rw",
    name: "Rwanda Flag",
    keywords: [
      "rw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fc",
        native: "🇷🇼",
        x: 3,
        y: 45
      }
    ],
    version: 2
  },
  "flag-sa": {
    id: "flag-sa",
    name: "Saudi Arabia Flag",
    keywords: [
      "sa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e6",
        native: "🇸🇦",
        x: 3,
        y: 46
      }
    ],
    version: 2
  },
  "flag-sb": {
    id: "flag-sb",
    name: "Solomon Islands Flag",
    keywords: [
      "sb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e7",
        native: "🇸🇧",
        x: 3,
        y: 47
      }
    ],
    version: 2
  },
  "flag-sc": {
    id: "flag-sc",
    name: "Seychelles Flag",
    keywords: [
      "sc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e8",
        native: "🇸🇨",
        x: 3,
        y: 48
      }
    ],
    version: 2
  },
  "flag-sd": {
    id: "flag-sd",
    name: "Sudan Flag",
    keywords: [
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e9",
        native: "🇸🇩",
        x: 3,
        y: 49
      }
    ],
    version: 2
  },
  "flag-se": {
    id: "flag-se",
    name: "Sweden Flag",
    keywords: [
      "se",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ea",
        native: "🇸🇪",
        x: 3,
        y: 50
      }
    ],
    version: 2
  },
  "flag-sg": {
    id: "flag-sg",
    name: "Singapore Flag",
    keywords: [
      "sg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ec",
        native: "🇸🇬",
        x: 3,
        y: 51
      }
    ],
    version: 2
  },
  "flag-sh": {
    id: "flag-sh",
    name: "St. Helena Flag",
    keywords: [
      "sh",
      "st",
      "saint",
      "ascension",
      "tristan",
      "cunha",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ed",
        native: "🇸🇭",
        x: 3,
        y: 52
      }
    ],
    version: 2
  },
  "flag-si": {
    id: "flag-si",
    name: "Slovenia Flag",
    keywords: [
      "si",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ee",
        native: "🇸🇮",
        x: 3,
        y: 53
      }
    ],
    version: 2
  },
  "flag-sj": {
    id: "flag-sj",
    name: "Svalbard & Jan Mayen Flag",
    keywords: [
      "sj"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ef",
        native: "🇸🇯",
        x: 3,
        y: 54
      }
    ],
    version: 2
  },
  "flag-sk": {
    id: "flag-sk",
    name: "Slovakia Flag",
    keywords: [
      "sk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f0",
        native: "🇸🇰",
        x: 3,
        y: 55
      }
    ],
    version: 2
  },
  "flag-sl": {
    id: "flag-sl",
    name: "Sierra Leone Flag",
    keywords: [
      "sl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f1",
        native: "🇸🇱",
        x: 3,
        y: 56
      }
    ],
    version: 2
  },
  "flag-sm": {
    id: "flag-sm",
    name: "San Marino Flag",
    keywords: [
      "sm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f2",
        native: "🇸🇲",
        x: 3,
        y: 57
      }
    ],
    version: 2
  },
  "flag-sn": {
    id: "flag-sn",
    name: "Senegal Flag",
    keywords: [
      "sn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f3",
        native: "🇸🇳",
        x: 3,
        y: 58
      }
    ],
    version: 2
  },
  "flag-so": {
    id: "flag-so",
    name: "Somalia Flag",
    keywords: [
      "so",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f4",
        native: "🇸🇴",
        x: 3,
        y: 59
      }
    ],
    version: 2
  },
  "flag-sr": {
    id: "flag-sr",
    name: "Suriname Flag",
    keywords: [
      "sr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f7",
        native: "🇸🇷",
        x: 3,
        y: 60
      }
    ],
    version: 2
  },
  "flag-ss": {
    id: "flag-ss",
    name: "South Sudan Flag",
    keywords: [
      "ss",
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f8",
        native: "🇸🇸",
        x: 4,
        y: 0
      }
    ],
    version: 2
  },
  "flag-st": {
    id: "flag-st",
    name: "São Tomé & Príncipe Flag",
    keywords: [
      "st",
      "sao",
      "tome",
      "principe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f9",
        native: "🇸🇹",
        x: 4,
        y: 1
      }
    ],
    version: 2
  },
  "flag-sv": {
    id: "flag-sv",
    name: "El Salvador Flag",
    keywords: [
      "sv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fb",
        native: "🇸🇻",
        x: 4,
        y: 2
      }
    ],
    version: 2
  },
  "flag-sx": {
    id: "flag-sx",
    name: "Sint Maarten Flag",
    keywords: [
      "sx",
      "dutch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fd",
        native: "🇸🇽",
        x: 4,
        y: 3
      }
    ],
    version: 2
  },
  "flag-sy": {
    id: "flag-sy",
    name: "Syria Flag",
    keywords: [
      "sy",
      "syrian",
      "arab",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fe",
        native: "🇸🇾",
        x: 4,
        y: 4
      }
    ],
    version: 2
  },
  "flag-sz": {
    id: "flag-sz",
    name: "Eswatini Flag",
    keywords: [
      "sz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ff",
        native: "🇸🇿",
        x: 4,
        y: 5
      }
    ],
    version: 2
  },
  "flag-ta": {
    id: "flag-ta",
    name: "Tristan Da Cunha Flag",
    keywords: [
      "ta"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e6",
        native: "🇹🇦",
        x: 4,
        y: 6
      }
    ],
    version: 2
  },
  "flag-tc": {
    id: "flag-tc",
    name: "Turks & Caicos Islands Flag",
    keywords: [
      "tc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e8",
        native: "🇹🇨",
        x: 4,
        y: 7
      }
    ],
    version: 2
  },
  "flag-td": {
    id: "flag-td",
    name: "Chad Flag",
    keywords: [
      "td",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e9",
        native: "🇹🇩",
        x: 4,
        y: 8
      }
    ],
    version: 2
  },
  "flag-tf": {
    id: "flag-tf",
    name: "French Southern Territories Flag",
    keywords: [
      "tf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1eb",
        native: "🇹🇫",
        x: 4,
        y: 9
      }
    ],
    version: 2
  },
  "flag-tg": {
    id: "flag-tg",
    name: "Togo Flag",
    keywords: [
      "tg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ec",
        native: "🇹🇬",
        x: 4,
        y: 10
      }
    ],
    version: 2
  },
  "flag-th": {
    id: "flag-th",
    name: "Thailand Flag",
    keywords: [
      "th",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ed",
        native: "🇹🇭",
        x: 4,
        y: 11
      }
    ],
    version: 2
  },
  "flag-tj": {
    id: "flag-tj",
    name: "Tajikistan Flag",
    keywords: [
      "tj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ef",
        native: "🇹🇯",
        x: 4,
        y: 12
      }
    ],
    version: 2
  },
  "flag-tk": {
    id: "flag-tk",
    name: "Tokelau Flag",
    keywords: [
      "tk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f0",
        native: "🇹🇰",
        x: 4,
        y: 13
      }
    ],
    version: 2
  },
  "flag-tl": {
    id: "flag-tl",
    name: "Timor-Leste Flag",
    keywords: [
      "tl",
      "timor",
      "leste",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f1",
        native: "🇹🇱",
        x: 4,
        y: 14
      }
    ],
    version: 2
  },
  "flag-tm": {
    id: "flag-tm",
    name: "Turkmenistan Flag",
    keywords: [
      "tm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f2",
        native: "🇹🇲",
        x: 4,
        y: 15
      }
    ],
    version: 2
  },
  "flag-tn": {
    id: "flag-tn",
    name: "Tunisia Flag",
    keywords: [
      "tn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f3",
        native: "🇹🇳",
        x: 4,
        y: 16
      }
    ],
    version: 2
  },
  "flag-to": {
    id: "flag-to",
    name: "Tonga Flag",
    keywords: [
      "to",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f4",
        native: "🇹🇴",
        x: 4,
        y: 17
      }
    ],
    version: 2
  },
  "flag-tr": {
    id: "flag-tr",
    name: "Turkey Flag",
    keywords: [
      "tr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f7",
        native: "🇹🇷",
        x: 4,
        y: 18
      }
    ],
    version: 2
  },
  "flag-tt": {
    id: "flag-tt",
    name: "Trinidad & Tobago Flag",
    keywords: [
      "tt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f9",
        native: "🇹🇹",
        x: 4,
        y: 19
      }
    ],
    version: 2
  },
  "flag-tv": {
    id: "flag-tv",
    name: "Tuvalu Flag",
    keywords: [
      "tv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fb",
        native: "🇹🇻",
        x: 4,
        y: 20
      }
    ],
    version: 2
  },
  "flag-tw": {
    id: "flag-tw",
    name: "Taiwan Flag",
    keywords: [
      "tw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fc",
        native: "🇹🇼",
        x: 4,
        y: 21
      }
    ],
    version: 2
  },
  "flag-tz": {
    id: "flag-tz",
    name: "Tanzania Flag",
    keywords: [
      "tz",
      "united",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ff",
        native: "🇹🇿",
        x: 4,
        y: 22
      }
    ],
    version: 2
  },
  "flag-ua": {
    id: "flag-ua",
    name: "Ukraine Flag",
    keywords: [
      "ua",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1e6",
        native: "🇺🇦",
        x: 4,
        y: 23
      }
    ],
    version: 2
  },
  "flag-ug": {
    id: "flag-ug",
    name: "Uganda Flag",
    keywords: [
      "ug",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ec",
        native: "🇺🇬",
        x: 4,
        y: 24
      }
    ],
    version: 2
  },
  "flag-um": {
    id: "flag-um",
    name: "U.s. Outlying Islands Flag",
    keywords: [
      "um",
      "u",
      "s"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f2",
        native: "🇺🇲",
        x: 4,
        y: 25
      }
    ],
    version: 2
  },
  "flag-un": {
    id: "flag-un",
    name: "United Nations Flag",
    keywords: [
      "un",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f3",
        native: "🇺🇳",
        x: 4,
        y: 26
      }
    ],
    version: 4
  },
  us: {
    id: "us",
    name: "United States Flag",
    keywords: [
      "us",
      "america",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f8",
        native: "🇺🇸",
        x: 4,
        y: 27
      }
    ],
    version: 1
  },
  "flag-uy": {
    id: "flag-uy",
    name: "Uruguay Flag",
    keywords: [
      "uy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1fe",
        native: "🇺🇾",
        x: 4,
        y: 28
      }
    ],
    version: 2
  },
  "flag-uz": {
    id: "flag-uz",
    name: "Uzbekistan Flag",
    keywords: [
      "uz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ff",
        native: "🇺🇿",
        x: 4,
        y: 29
      }
    ],
    version: 2
  },
  "flag-va": {
    id: "flag-va",
    name: "Vatican City Flag",
    keywords: [
      "va",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e6",
        native: "🇻🇦",
        x: 4,
        y: 30
      }
    ],
    version: 2
  },
  "flag-vc": {
    id: "flag-vc",
    name: "St. Vincent & Grenadines Flag",
    keywords: [
      "vc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e8",
        native: "🇻🇨",
        x: 4,
        y: 31
      }
    ],
    version: 2
  },
  "flag-ve": {
    id: "flag-ve",
    name: "Venezuela Flag",
    keywords: [
      "ve",
      "bolivarian",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ea",
        native: "🇻🇪",
        x: 4,
        y: 32
      }
    ],
    version: 2
  },
  "flag-vg": {
    id: "flag-vg",
    name: "British Virgin Islands Flag",
    keywords: [
      "vg",
      "bvi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ec",
        native: "🇻🇬",
        x: 4,
        y: 33
      }
    ],
    version: 2
  },
  "flag-vi": {
    id: "flag-vi",
    name: "U.s. Virgin Islands Flag",
    keywords: [
      "vi",
      "u",
      "s",
      "us",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ee",
        native: "🇻🇮",
        x: 4,
        y: 34
      }
    ],
    version: 2
  },
  "flag-vn": {
    id: "flag-vn",
    name: "Vietnam Flag",
    keywords: [
      "vn",
      "viet",
      "nam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1f3",
        native: "🇻🇳",
        x: 4,
        y: 35
      }
    ],
    version: 2
  },
  "flag-vu": {
    id: "flag-vu",
    name: "Vanuatu Flag",
    keywords: [
      "vu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1fa",
        native: "🇻🇺",
        x: 4,
        y: 36
      }
    ],
    version: 2
  },
  "flag-wf": {
    id: "flag-wf",
    name: "Wallis & Futuna Flag",
    keywords: [
      "wf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1eb",
        native: "🇼🇫",
        x: 4,
        y: 37
      }
    ],
    version: 2
  },
  "flag-ws": {
    id: "flag-ws",
    name: "Samoa Flag",
    keywords: [
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1f8",
        native: "🇼🇸",
        x: 4,
        y: 38
      }
    ],
    version: 2
  },
  "flag-xk": {
    id: "flag-xk",
    name: "Kosovo Flag",
    keywords: [
      "xk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fd-1f1f0",
        native: "🇽🇰",
        x: 4,
        y: 39
      }
    ],
    version: 2
  },
  "flag-ye": {
    id: "flag-ye",
    name: "Yemen Flag",
    keywords: [
      "ye",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1ea",
        native: "🇾🇪",
        x: 4,
        y: 40
      }
    ],
    version: 2
  },
  "flag-yt": {
    id: "flag-yt",
    name: "Mayotte Flag",
    keywords: [
      "yt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1f9",
        native: "🇾🇹",
        x: 4,
        y: 41
      }
    ],
    version: 2
  },
  "flag-za": {
    id: "flag-za",
    name: "South Africa Flag",
    keywords: [
      "za",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1e6",
        native: "🇿🇦",
        x: 4,
        y: 42
      }
    ],
    version: 2
  },
  "flag-zm": {
    id: "flag-zm",
    name: "Zambia Flag",
    keywords: [
      "zm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1f2",
        native: "🇿🇲",
        x: 4,
        y: 43
      }
    ],
    version: 2
  },
  "flag-zw": {
    id: "flag-zw",
    name: "Zimbabwe Flag",
    keywords: [
      "zw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1fc",
        native: "🇿🇼",
        x: 4,
        y: 44
      }
    ],
    version: 2
  },
  "flag-england": {
    id: "flag-england",
    name: "England Flag",
    keywords: [
      "english"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
        x: 10,
        y: 32
      }
    ],
    version: 5
  },
  "flag-scotland": {
    id: "flag-scotland",
    name: "Scotland Flag",
    keywords: [
      "scottish"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        x: 10,
        y: 33
      }
    ],
    version: 5
  },
  "flag-wales": {
    id: "flag-wales",
    name: "Wales Flag",
    keywords: [
      "welsh"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
        x: 10,
        y: 34
      }
    ],
    version: 5
  }
}, mne = {
  satisfied: "laughing",
  grinning_face_with_star_eyes: "star-struck",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  shocked_face_with_exploding_head: "exploding_head",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  collision: "boom",
  raised_hand: "hand",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  mother_christmas: "mrs_claus",
  running: "runner",
  "man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
  "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
  women_holding_hands: "two_women_holding_hands",
  woman_and_man_holding_hands: "man_and_woman_holding_hands",
  couple: "man_and_woman_holding_hands",
  men_holding_hands: "two_men_holding_hands",
  paw_prints: "feet",
  flipper: "dolphin",
  honeybee: "bee",
  lady_beetle: "ladybug",
  cooking: "fried_egg",
  knife: "hocho",
  red_car: "car",
  sailboat: "boat",
  waxing_gibbous_moon: "moon",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  tshirt: "shirt",
  shoe: "mans_shoe",
  telephone: "phone",
  lantern: "izakaya_lantern",
  open_book: "book",
  envelope: "email",
  pencil: "memo",
  heavy_exclamation_mark: "exclamation",
  "flag-cn": "cn",
  "flag-de": "de",
  "flag-es": "es",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  "flag-it": "it",
  "flag-jp": "jp",
  "flag-kr": "kr",
  "flag-ru": "ru",
  "flag-us": "us"
}, pne = {
  cols: 61,
  rows: 61
}, yne = {
  categories: une,
  emojis: hne,
  aliases: mne,
  sheet: pne
};
function Vc(e) {
  return e && e.__esModule ? e.default : e;
}
function Fn(e, i, n) {
  return i in e ? Object.defineProperty(e, i, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[i] = n, e;
}
var F0, _e, Fc, F2, Pc, fl, u0 = {}, Uc = [], vne = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function et(e, i) {
  for (var n in i)
    e[n] = i[n];
  return e;
}
function Rc(e) {
  var i = e.parentNode;
  i && i.removeChild(e);
}
function H3(e, i, n) {
  var a, r, o, l = {};
  for (o in i)
    o == "key" ? a = i[o] : o == "ref" ? r = i[o] : l[o] = i[o];
  if (arguments.length > 2 && (l.children = arguments.length > 3 ? F0.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null)
    for (o in e.defaultProps)
      l[o] === void 0 && (l[o] = e.defaultProps[o]);
  return n0(e, l, a, r, null);
}
function n0(e, i, n, a, r) {
  var o = {
    type: e,
    props: i,
    key: n,
    ref: a,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: r ?? ++Fc
  };
  return r == null && _e.vnode != null && _e.vnode(o), o;
}
function bi() {
  return {
    current: null
  };
}
function r2(e) {
  return e.children;
}
function si(e, i) {
  this.props = e, this.context = i;
}
function l2(e, i) {
  if (i == null)
    return e.__ ? l2(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var n; i < e.__k.length; i++)
    if ((n = e.__k[i]) != null && n.__e != null)
      return n.__e;
  return typeof e.type == "function" ? l2(e) : null;
}
function Yc(e) {
  var i, n;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, i = 0; i < e.__k.length; i++)
      if ((n = e.__k[i]) != null && n.__e != null) {
        e.__e = e.__c.base = n.__e;
        break;
      }
    return Yc(e);
  }
}
function ul(e) {
  (!e.__d && (e.__d = !0) && F2.push(e) && !h0.__r++ || fl !== _e.debounceRendering) && ((fl = _e.debounceRendering) || Pc)(h0);
}
function h0() {
  for (var e; h0.__r = F2.length; )
    e = F2.sort(function(i, n) {
      return i.__v.__b - n.__v.__b;
    }), F2 = [], e.some(function(i) {
      var n, a, r, o, l, c;
      i.__d && (l = (o = (n = i).__v).__e, (c = n.__P) && (a = [], (r = et({}, o)).__v = o.__v + 1, So(c, o, r, n.__n, c.ownerSVGElement !== void 0, o.__h != null ? [
        l
      ] : null, a, l ?? l2(o), o.__h), qc(a, o), o.__e != l && Yc(o)));
    });
}
function Zc(e, i, n, a, r, o, l, c, h, y) {
  var v, x, C, M, z, R, U, G = a && a.__k || Uc, re = G.length;
  for (n.__k = [], v = 0; v < i.length; v++)
    if ((M = n.__k[v] = (M = i[v]) == null || typeof M == "boolean" ? null : typeof M == "string" || typeof M == "number" || typeof M == "bigint" ? n0(null, M, null, null, M) : Array.isArray(M) ? n0(r2, {
      children: M
    }, null, null, null) : M.__b > 0 ? n0(M.type, M.props, M.key, null, M.__v) : M) != null) {
      if (M.__ = n, M.__b = n.__b + 1, (C = G[v]) === null || C && M.key == C.key && M.type === C.type)
        G[v] = void 0;
      else
        for (x = 0; x < re; x++) {
          if ((C = G[x]) && M.key == C.key && M.type === C.type) {
            G[x] = void 0;
            break;
          }
          C = null;
        }
      So(e, M, C = C || u0, r, o, l, c, h, y), z = M.__e, (x = M.ref) && C.ref != x && (U || (U = []), C.ref && U.push(C.ref, null, M), U.push(x, M.__c || z, M)), z != null ? (R == null && (R = z), typeof M.type == "function" && M.__k === C.__k ? M.__d = h = Wc(M, h, e) : h = Qc(e, M, C, G, z, h), typeof n.type == "function" && (n.__d = h)) : h && C.__e == h && h.parentNode != e && (h = l2(C));
    }
  for (n.__e = R, v = re; v--; )
    G[v] != null && (typeof n.type == "function" && G[v].__e != null && G[v].__e == n.__d && (n.__d = l2(a, v + 1)), Xc(G[v], G[v]));
  if (U)
    for (v = 0; v < U.length; v++)
      Gc(U[v], U[++v], U[++v]);
}
function Wc(e, i, n) {
  for (var a, r = e.__k, o = 0; r && o < r.length; o++)
    (a = r[o]) && (a.__ = e, i = typeof a.type == "function" ? Wc(a, i, n) : Qc(n, a, a, r, a.__e, i));
  return i;
}
function m0(e, i) {
  return i = i || [], e == null || typeof e == "boolean" || (Array.isArray(e) ? e.some(function(n) {
    m0(n, i);
  }) : i.push(e)), i;
}
function Qc(e, i, n, a, r, o) {
  var l, c, h;
  if (i.__d !== void 0)
    l = i.__d, i.__d = void 0;
  else if (n == null || r != o || r.parentNode == null)
    e:
      if (o == null || o.parentNode !== e)
        e.appendChild(r), l = null;
      else {
        for (c = o, h = 0; (c = c.nextSibling) && h < a.length; h += 2)
          if (c == r)
            break e;
        e.insertBefore(r, o), l = o;
      }
  return l !== void 0 ? l : r.nextSibling;
}
function gne(e, i, n, a, r) {
  var o;
  for (o in n)
    o === "children" || o === "key" || o in i || p0(e, o, null, n[o], a);
  for (o in i)
    r && typeof i[o] != "function" || o === "children" || o === "key" || o === "value" || o === "checked" || n[o] === i[o] || p0(e, o, i[o], n[o], a);
}
function hl(e, i, n) {
  i[0] === "-" ? e.setProperty(i, n) : e[i] = n == null ? "" : typeof n != "number" || vne.test(i) ? n : n + "px";
}
function p0(e, i, n, a, r) {
  var o;
  e:
    if (i === "style")
      if (typeof n == "string")
        e.style.cssText = n;
      else {
        if (typeof a == "string" && (e.style.cssText = a = ""), a)
          for (i in a)
            n && i in n || hl(e.style, i, "");
        if (n)
          for (i in n)
            a && n[i] === a[i] || hl(e.style, i, n[i]);
      }
    else if (i[0] === "o" && i[1] === "n")
      o = i !== (i = i.replace(/Capture$/, "")), i = i.toLowerCase() in e ? i.toLowerCase().slice(2) : i.slice(2), e.l || (e.l = {}), e.l[i + o] = n, n ? a || e.addEventListener(i, o ? pl : ml, o) : e.removeEventListener(i, o ? pl : ml, o);
    else if (i !== "dangerouslySetInnerHTML") {
      if (r)
        i = i.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
      else if (i !== "href" && i !== "list" && i !== "form" && i !== "tabIndex" && i !== "download" && i in e)
        try {
          e[i] = n ?? "";
          break e;
        } catch {
        }
      typeof n == "function" || (n != null && (n !== !1 || i[0] === "a" && i[1] === "r") ? e.setAttribute(i, n) : e.removeAttribute(i));
    }
}
function ml(e) {
  this.l[e.type + !1](_e.event ? _e.event(e) : e);
}
function pl(e) {
  this.l[e.type + !0](_e.event ? _e.event(e) : e);
}
function So(e, i, n, a, r, o, l, c, h) {
  var y, v, x, C, M, z, R, U, G, re, I, V = i.type;
  if (i.constructor !== void 0)
    return null;
  n.__h != null && (h = n.__h, c = i.__e = n.__e, i.__h = null, o = [
    c
  ]), (y = _e.__b) && y(i);
  try {
    e:
      if (typeof V == "function") {
        if (U = i.props, G = (y = V.contextType) && a[y.__c], re = y ? G ? G.props.value : y.__ : a, n.__c ? R = (v = i.__c = n.__c).__ = v.__E : ("prototype" in V && V.prototype.render ? i.__c = v = new V(U, re) : (i.__c = v = new si(U, re), v.constructor = V, v.render = wne), G && G.sub(v), v.props = U, v.state || (v.state = {}), v.context = re, v.__n = a, x = v.__d = !0, v.__h = []), v.__s == null && (v.__s = v.state), V.getDerivedStateFromProps != null && (v.__s == v.state && (v.__s = et({}, v.__s)), et(v.__s, V.getDerivedStateFromProps(U, v.__s))), C = v.props, M = v.state, x)
          V.getDerivedStateFromProps == null && v.componentWillMount != null && v.componentWillMount(), v.componentDidMount != null && v.__h.push(v.componentDidMount);
        else {
          if (V.getDerivedStateFromProps == null && U !== C && v.componentWillReceiveProps != null && v.componentWillReceiveProps(U, re), !v.__e && v.shouldComponentUpdate != null && v.shouldComponentUpdate(U, v.__s, re) === !1 || i.__v === n.__v) {
            v.props = U, v.state = v.__s, i.__v !== n.__v && (v.__d = !1), v.__v = i, i.__e = n.__e, i.__k = n.__k, i.__k.forEach(function(K) {
              K && (K.__ = i);
            }), v.__h.length && l.push(v);
            break e;
          }
          v.componentWillUpdate != null && v.componentWillUpdate(U, v.__s, re), v.componentDidUpdate != null && v.__h.push(function() {
            v.componentDidUpdate(C, M, z);
          });
        }
        v.context = re, v.props = U, v.state = v.__s, (y = _e.__r) && y(i), v.__d = !1, v.__v = i, v.__P = e, y = v.render(v.props, v.state, v.context), v.state = v.__s, v.getChildContext != null && (a = et(et({}, a), v.getChildContext())), x || v.getSnapshotBeforeUpdate == null || (z = v.getSnapshotBeforeUpdate(C, M)), I = y != null && y.type === r2 && y.key == null ? y.props.children : y, Zc(e, Array.isArray(I) ? I : [
          I
        ], i, n, a, r, o, l, c, h), v.base = i.__e, i.__h = null, v.__h.length && l.push(v), R && (v.__E = v.__ = null), v.__e = !1;
      } else
        o == null && i.__v === n.__v ? (i.__k = n.__k, i.__e = n.__e) : i.__e = _ne(n.__e, i, n, a, r, o, l, h);
    (y = _e.diffed) && y(i);
  } catch (K) {
    i.__v = null, (h || o != null) && (i.__e = c, i.__h = !!h, o[o.indexOf(c)] = null), _e.__e(K, i, n);
  }
}
function qc(e, i) {
  _e.__c && _e.__c(i, e), e.some(function(n) {
    try {
      e = n.__h, n.__h = [], e.some(function(a) {
        a.call(n);
      });
    } catch (a) {
      _e.__e(a, n.__v);
    }
  });
}
function _ne(e, i, n, a, r, o, l, c) {
  var h, y, v, x = n.props, C = i.props, M = i.type, z = 0;
  if (M === "svg" && (r = !0), o != null) {
    for (; z < o.length; z++)
      if ((h = o[z]) && "setAttribute" in h == !!M && (M ? h.localName === M : h.nodeType === 3)) {
        e = h, o[z] = null;
        break;
      }
  }
  if (e == null) {
    if (M === null)
      return document.createTextNode(C);
    e = r ? document.createElementNS("http://www.w3.org/2000/svg", M) : document.createElement(M, C.is && C), o = null, c = !1;
  }
  if (M === null)
    x === C || c && e.data === C || (e.data = C);
  else {
    if (o = o && F0.call(e.childNodes), y = (x = n.props || u0).dangerouslySetInnerHTML, v = C.dangerouslySetInnerHTML, !c) {
      if (o != null)
        for (x = {}, z = 0; z < e.attributes.length; z++)
          x[e.attributes[z].name] = e.attributes[z].value;
      (v || y) && (v && (y && v.__html == y.__html || v.__html === e.innerHTML) || (e.innerHTML = v && v.__html || ""));
    }
    if (gne(e, C, x, r, c), v)
      i.__k = [];
    else if (z = i.props.children, Zc(e, Array.isArray(z) ? z : [
      z
    ], i, n, a, r && M !== "foreignObject", o, l, o ? o[0] : n.__k && l2(n, 0), c), o != null)
      for (z = o.length; z--; )
        o[z] != null && Rc(o[z]);
    c || ("value" in C && (z = C.value) !== void 0 && (z !== x.value || z !== e.value || M === "progress" && !z) && p0(e, "value", z, x.value, !1), "checked" in C && (z = C.checked) !== void 0 && z !== e.checked && p0(e, "checked", z, x.checked, !1));
  }
  return e;
}
function Gc(e, i, n) {
  try {
    typeof e == "function" ? e(i) : e.current = i;
  } catch (a) {
    _e.__e(a, n);
  }
}
function Xc(e, i, n) {
  var a, r;
  if (_e.unmount && _e.unmount(e), (a = e.ref) && (a.current && a.current !== e.__e || Gc(a, null, i)), (a = e.__c) != null) {
    if (a.componentWillUnmount)
      try {
        a.componentWillUnmount();
      } catch (o) {
        _e.__e(o, i);
      }
    a.base = a.__P = null;
  }
  if (a = e.__k)
    for (r = 0; r < a.length; r++)
      a[r] && Xc(a[r], i, typeof e.type != "function");
  n || e.__e == null || Rc(e.__e), e.__e = e.__d = void 0;
}
function wne(e, i, n) {
  return this.constructor(e, n);
}
function Jc(e, i, n) {
  var a, r, o;
  _e.__ && _e.__(e, i), r = (a = typeof n == "function") ? null : n && n.__k || i.__k, o = [], So(i, e = (!a && n || i).__k = H3(r2, null, [
    e
  ]), r || u0, u0, i.ownerSVGElement !== void 0, !a && n ? [
    n
  ] : r ? null : i.firstChild ? F0.call(i.childNodes) : null, o, !a && n ? n : r ? r.__e : i.firstChild, a), qc(o, e);
}
F0 = Uc.slice, _e = {
  __e: function(e, i) {
    for (var n, a, r; i = i.__; )
      if ((n = i.__c) && !n.__)
        try {
          if ((a = n.constructor) && a.getDerivedStateFromError != null && (n.setState(a.getDerivedStateFromError(e)), r = n.__d), n.componentDidCatch != null && (n.componentDidCatch(e), r = n.__d), r)
            return n.__E = n;
        } catch (o) {
          e = o;
        }
    throw e;
  }
}, Fc = 0, si.prototype.setState = function(e, i) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = et({}, this.state), typeof e == "function" && (e = e(et({}, n), this.props)), e && et(n, e), e != null && this.__v && (i && this.__h.push(i), ul(this));
}, si.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), ul(this));
}, si.prototype.render = r2, F2 = [], Pc = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, h0.__r = 0;
var Cne = 0;
function q(e, i, n, a, r) {
  var o, l, c = {};
  for (l in i)
    l == "ref" ? o = i[l] : c[l] = i[l];
  var h = {
    type: e,
    props: c,
    key: n,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: --Cne,
    __source: a,
    __self: r
  };
  if (typeof e == "function" && (o = e.defaultProps))
    for (l in o)
      c[l] === void 0 && (c[l] = o[l]);
  return _e.vnode && _e.vnode(h), h;
}
function kne(e, i) {
  try {
    window.localStorage[`emoji-mart.${e}`] = JSON.stringify(i);
  } catch {
  }
}
function xne(e) {
  try {
    const i = window.localStorage[`emoji-mart.${e}`];
    if (i)
      return JSON.parse(i);
  } catch {
  }
}
var it = {
  set: kne,
  get: xne
};
const u3 = /* @__PURE__ */ new Map(), bne = [
  {
    v: 14,
    emoji: "🫠"
  },
  {
    v: 13.1,
    emoji: "😶‍🌫️"
  },
  {
    v: 13,
    emoji: "🥸"
  },
  {
    v: 12.1,
    emoji: "🧑‍🦰"
  },
  {
    v: 12,
    emoji: "🥱"
  },
  {
    v: 11,
    emoji: "🥰"
  },
  {
    v: 5,
    emoji: "🤩"
  },
  {
    v: 4,
    emoji: "👱‍♀️"
  },
  {
    v: 3,
    emoji: "🤣"
  },
  {
    v: 2,
    emoji: "👋🏻"
  },
  {
    v: 1,
    emoji: "🙃"
  }
];
function Mne() {
  for (const { v: e, emoji: i } of bne)
    if (Kc(i))
      return e;
}
function Dne() {
  return !Kc("🇨🇦");
}
function Kc(e) {
  if (u3.has(e))
    return u3.get(e);
  const i = Ane(e);
  return u3.set(e, i), i;
}
const Ane = (() => {
  let e = null;
  try {
    navigator.userAgent.includes("jsdom") || (e = document.createElement("canvas").getContext("2d", {
      willReadFrequently: !0
    }));
  } catch {
  }
  if (!e)
    return () => !1;
  const i = 25, n = 20, a = Math.floor(i / 2);
  return e.font = a + "px Arial, Sans-Serif", e.textBaseline = "top", e.canvas.width = n * 2, e.canvas.height = i, (r) => {
    e.clearRect(0, 0, n * 2, i), e.fillStyle = "#FF0000", e.fillText(r, 0, 22), e.fillStyle = "#0000FF", e.fillText(r, n, 22);
    const o = e.getImageData(0, 0, n, i).data, l = o.length;
    let c = 0;
    for (; c < l && !o[c + 3]; c += 4)
      ;
    if (c >= l)
      return !1;
    const h = n + c / 4 % n, y = Math.floor(c / 4 / n), v = e.getImageData(h, y, 1, 1).data;
    return !(o[c] !== v[0] || o[c + 2] !== v[2] || e.measureText(r).width >= n);
  };
})();
var yl = {
  latestVersion: Mne,
  noCountryFlags: Dne
};
const j3 = [
  "+1",
  "grinning",
  "kissing_heart",
  "heart_eyes",
  "laughing",
  "stuck_out_tongue_winking_eye",
  "sweat_smile",
  "joy",
  "scream",
  "disappointed",
  "unamused",
  "weary",
  "sob",
  "sunglasses",
  "heart"
];
let B1 = null;
function Lne(e) {
  B1 || (B1 = it.get("frequently") || {});
  const i = e.id || e;
  i && (B1[i] || (B1[i] = 0), B1[i] += 1, it.set("last", i), it.set("frequently", B1));
}
function Tne({ maxFrequentRows: e, perLine: i }) {
  if (!e)
    return [];
  B1 || (B1 = it.get("frequently"));
  let n = [];
  if (!B1) {
    B1 = {};
    for (let o in j3.slice(0, i)) {
      const l = j3[o];
      B1[l] = i - o, n.push(l);
    }
    return n;
  }
  const a = e * i, r = it.get("last");
  for (let o in B1)
    n.push(o);
  if (n.sort((o, l) => {
    const c = B1[l], h = B1[o];
    return c == h ? o.localeCompare(l) : c - h;
  }), n.length > a) {
    const o = n.slice(a);
    n = n.slice(0, a);
    for (let l of o)
      l != r && delete B1[l];
    r && n.indexOf(r) == -1 && (delete B1[n[n.length - 1]], n.splice(-1, 1, r)), it.set("frequently", B1);
  }
  return n;
}
var $c = {
  add: Lne,
  get: Tne,
  DEFAULTS: j3
}, ef = {};
ef = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn’t be found","pick":"Pick an emoji…","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var Ai = {
  autoFocus: {
    value: !1
  },
  dynamicWidth: {
    value: !1
  },
  emojiButtonColors: {
    value: null
  },
  emojiButtonRadius: {
    value: "100%"
  },
  emojiButtonSize: {
    value: 36
  },
  emojiSize: {
    value: 24
  },
  emojiVersion: {
    value: 14,
    choices: [
      1,
      2,
      3,
      4,
      5,
      11,
      12,
      12.1,
      13,
      13.1,
      14
    ]
  },
  exceptEmojis: {
    value: []
  },
  icons: {
    value: "auto",
    choices: [
      "auto",
      "outline",
      "solid"
    ]
  },
  locale: {
    value: "en",
    choices: [
      "en",
      "ar",
      "be",
      "cs",
      "de",
      "es",
      "fa",
      "fi",
      "fr",
      "hi",
      "it",
      "ja",
      "kr",
      "nl",
      "pl",
      "pt",
      "ru",
      "sa",
      "tr",
      "uk",
      "vi",
      "zh"
    ]
  },
  maxFrequentRows: {
    value: 4
  },
  navPosition: {
    value: "top",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  noCountryFlags: {
    value: !1
  },
  noResultsEmoji: {
    value: null
  },
  perLine: {
    value: 9
  },
  previewEmoji: {
    value: null
  },
  previewPosition: {
    value: "bottom",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  searchPosition: {
    value: "sticky",
    choices: [
      "sticky",
      "static",
      "none"
    ]
  },
  set: {
    value: "native",
    choices: [
      "native",
      "apple",
      "facebook",
      "google",
      "twitter"
    ]
  },
  skin: {
    value: 1,
    choices: [
      1,
      2,
      3,
      4,
      5,
      6
    ]
  },
  skinTonePosition: {
    value: "preview",
    choices: [
      "preview",
      "search",
      "none"
    ]
  },
  theme: {
    value: "auto",
    choices: [
      "auto",
      "light",
      "dark"
    ]
  },
  // Data
  categories: null,
  categoryIcons: null,
  custom: null,
  data: null,
  i18n: null,
  // Callbacks
  getImageURL: null,
  getSpritesheetURL: null,
  onAddCustomEmoji: null,
  onClickOutside: null,
  onEmojiSelect: null,
  // Deprecated
  stickySearch: {
    deprecated: !0,
    value: !0
  }
};
let F1 = null, Oe = null;
const h3 = {};
async function vl(e) {
  if (h3[e])
    return h3[e];
  const n = await (await fetch(e)).json();
  return h3[e] = n, n;
}
let m3 = null, nf = null, tf = !1;
function P0(e, { caller: i } = {}) {
  return m3 || (m3 = new Promise((n) => {
    nf = n;
  })), e ? Sne(e) : i && !tf && console.warn(`\`${i}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`), m3;
}
async function Sne(e) {
  tf = !0;
  let { emojiVersion: i, set: n, locale: a } = e;
  if (i || (i = Ai.emojiVersion.value), n || (n = Ai.set.value), a || (a = Ai.locale.value), Oe)
    Oe.categories = Oe.categories.filter((h) => !h.name);
  else {
    Oe = (typeof e.data == "function" ? await e.data() : e.data) || await vl(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${i}/${n}.json`), Oe.emoticons = {}, Oe.natives = {}, Oe.categories.unshift({
      id: "frequent",
      emojis: []
    });
    for (const h in Oe.aliases) {
      const y = Oe.aliases[h], v = Oe.emojis[y];
      v && (v.aliases || (v.aliases = []), v.aliases.push(h));
    }
    Oe.originalCategories = Oe.categories;
  }
  if (F1 = (typeof e.i18n == "function" ? await e.i18n() : e.i18n) || (a == "en" ? /* @__PURE__ */ Vc(ef) : await vl(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${a}.json`)), e.custom)
    for (let h in e.custom) {
      h = parseInt(h);
      const y = e.custom[h], v = e.custom[h - 1];
      if (!(!y.emojis || !y.emojis.length)) {
        y.id || (y.id = `custom_${h + 1}`), y.name || (y.name = F1.categories.custom), v && !y.icon && (y.target = v.target || v), Oe.categories.push(y);
        for (const x of y.emojis)
          Oe.emojis[x.id] = x;
      }
    }
  e.categories && (Oe.categories = Oe.originalCategories.filter((h) => e.categories.indexOf(h.id) != -1).sort((h, y) => {
    const v = e.categories.indexOf(h.id), x = e.categories.indexOf(y.id);
    return v - x;
  }));
  let r = null, o = null;
  n == "native" && (r = yl.latestVersion(), o = e.noCountryFlags || yl.noCountryFlags());
  let l = Oe.categories.length, c = !1;
  for (; l--; ) {
    const h = Oe.categories[l];
    if (h.id == "frequent") {
      let { maxFrequentRows: x, perLine: C } = e;
      x = x >= 0 ? x : Ai.maxFrequentRows.value, C || (C = Ai.perLine.value), h.emojis = $c.get({
        maxFrequentRows: x,
        perLine: C
      });
    }
    if (!h.emojis || !h.emojis.length) {
      Oe.categories.splice(l, 1);
      continue;
    }
    const { categoryIcons: y } = e;
    if (y) {
      const x = y[h.id];
      x && !h.icon && (h.icon = x);
    }
    let v = h.emojis.length;
    for (; v--; ) {
      const x = h.emojis[v], C = x.id ? x : Oe.emojis[x], M = () => {
        h.emojis.splice(v, 1);
      };
      if (!C || e.exceptEmojis && e.exceptEmojis.includes(C.id)) {
        M();
        continue;
      }
      if (r && C.version > r) {
        M();
        continue;
      }
      if (o && h.id == "flags" && !Bne.includes(C.id)) {
        M();
        continue;
      }
      if (!C.search) {
        if (c = !0, C.search = "," + [
          [
            C.id,
            !1
          ],
          [
            C.name,
            !0
          ],
          [
            C.keywords,
            !1
          ],
          [
            C.emoticons,
            !1
          ]
        ].map(([R, U]) => {
          if (R)
            return (Array.isArray(R) ? R : [
              R
            ]).map((G) => (U ? G.split(/[-|_|\s]+/) : [
              G
            ]).map((re) => re.toLowerCase())).flat();
        }).flat().filter((R) => R && R.trim()).join(","), C.emoticons)
          for (const R of C.emoticons)
            Oe.emoticons[R] || (Oe.emoticons[R] = C.id);
        let z = 0;
        for (const R of C.skins) {
          if (!R)
            continue;
          z++;
          const { native: U } = R;
          U && (Oe.natives[U] = C.id, C.search += `,${U}`);
          const G = z == 1 ? "" : `:skin-tone-${z}:`;
          R.shortcodes = `:${C.id}:${G}`;
        }
      }
    }
  }
  c && t2.reset(), nf();
}
function af(e, i, n) {
  e || (e = {});
  const a = {};
  for (let r in i)
    a[r] = sf(r, e, i, n);
  return a;
}
function sf(e, i, n, a) {
  const r = n[e];
  let o = a && a.getAttribute(e) || (i[e] != null && i[e] != null ? i[e] : null);
  return r && (o != null && r.value && typeof r.value != typeof o && (typeof r.value == "boolean" ? o = o != "false" : o = r.value.constructor(o)), r.transform && o && (o = r.transform(o)), (o == null || r.choices && r.choices.indexOf(o) == -1) && (o = r.value)), o;
}
const Nne = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let V3 = null;
function Ene(e) {
  return e.id ? e : Oe.emojis[e] || Oe.emojis[Oe.aliases[e]] || Oe.emojis[Oe.natives[e]];
}
function zne() {
  V3 = null;
}
async function Ine(e, { maxResults: i, caller: n } = {}) {
  if (!e || !e.trim().length)
    return null;
  i || (i = 90), await P0(null, {
    caller: n || "SearchIndex.search"
  });
  const a = e.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((c, h, y) => c.trim() && y.indexOf(c) == h);
  if (!a.length)
    return;
  let r = V3 || (V3 = Object.values(Oe.emojis)), o, l;
  for (const c of a) {
    if (!r.length)
      break;
    o = [], l = {};
    for (const h of r) {
      if (!h.search)
        continue;
      const y = h.search.indexOf(`,${c}`);
      y != -1 && (o.push(h), l[h.id] || (l[h.id] = 0), l[h.id] += h.id == c ? 0 : y + 1);
    }
    r = o;
  }
  return o.length < 2 || (o.sort((c, h) => {
    const y = l[c.id], v = l[h.id];
    return y == v ? c.id.localeCompare(h.id) : y - v;
  }), o.length > i && (o = o.slice(0, i))), o;
}
var t2 = {
  search: Ine,
  get: Ene,
  reset: zne,
  SHORTCODES_REGEX: Nne
};
const Bne = [
  "checkered_flag",
  "crossed_flags",
  "pirate_flag",
  "rainbow-flag",
  "transgender_flag",
  "triangular_flag_on_post",
  "waving_black_flag",
  "waving_white_flag"
];
function One(e, i) {
  return Array.isArray(e) && Array.isArray(i) && e.length === i.length && e.every((n, a) => n == i[a]);
}
async function Hne(e = 1) {
  for (let i in [
    ...Array(e).keys()
  ])
    await new Promise(requestAnimationFrame);
}
function jne(e, { skinIndex: i = 0 } = {}) {
  const n = e.skins[i] || (() => (i = 0, e.skins[i]))(), a = {
    id: e.id,
    name: e.name,
    native: n.native,
    unified: n.unified,
    keywords: e.keywords,
    shortcodes: n.shortcodes || e.shortcodes
  };
  return e.skins.length > 1 && (a.skin = i + 1), n.src && (a.src = n.src), e.aliases && e.aliases.length && (a.aliases = e.aliases), e.emoticons && e.emoticons.length && (a.emoticons = e.emoticons), a;
}
const Vne = {
  activity: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ q("path", {
        d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
      })
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
      })
    })
  },
  custom: /* @__PURE__ */ q("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ q("path", {
      d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
    })
  }),
  flags: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ q("path", {
        d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
      })
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
      })
    })
  },
  foods: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ q("path", {
        d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
      })
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
      })
    })
  },
  frequent: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ q("path", {
          d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }),
        /* @__PURE__ */ q("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        })
      ]
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
      })
    })
  },
  nature: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ q("path", {
          d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }),
        /* @__PURE__ */ q("path", {
          d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        })
      ]
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ q("path", {
        d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
      })
    })
  },
  objects: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ q("path", {
          d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }),
        /* @__PURE__ */ q("path", {
          d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        })
      ]
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      children: /* @__PURE__ */ q("path", {
        d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
      })
    })
  },
  people: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ q("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }),
        /* @__PURE__ */ q("path", {
          d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        })
      ]
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
      })
    })
  },
  places: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ q("path", {
          d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }),
        /* @__PURE__ */ q("path", {
          d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        })
      ]
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
      })
    })
  },
  symbols: {
    outline: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ q("path", {
        d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
      })
    }),
    solid: /* @__PURE__ */ q("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ q("path", {
        d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
      })
    })
  }
}, Fne = {
  loupe: /* @__PURE__ */ q("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ q("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    })
  }),
  delete: /* @__PURE__ */ q("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ q("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    })
  })
};
var y0 = {
  categories: Vne,
  search: Fne
};
function F3(e) {
  let { id: i, skin: n, emoji: a } = e;
  if (e.shortcodes) {
    const c = e.shortcodes.match(t2.SHORTCODES_REGEX);
    c && (i = c[1], c[2] && (n = c[2]));
  }
  if (a || (a = t2.get(i || e.native)), !a)
    return e.fallback;
  const r = a.skins[n - 1] || a.skins[0], o = r.src || (e.set != "native" && !e.spritesheet ? typeof e.getImageURL == "function" ? e.getImageURL(e.set, r.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@14.0.0/img/${e.set}/64/${r.unified}.png` : void 0), l = typeof e.getSpritesheetURL == "function" ? e.getSpritesheetURL(e.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@14.0.0/img/${e.set}/sheets-256/64.png`;
  return /* @__PURE__ */ q("span", {
    class: "emoji-mart-emoji",
    "data-emoji-set": e.set,
    children: o ? /* @__PURE__ */ q("img", {
      style: {
        maxWidth: e.size || "1em",
        maxHeight: e.size || "1em",
        display: "inline-block"
      },
      alt: r.native || r.shortcodes,
      src: o
    }) : e.set == "native" ? /* @__PURE__ */ q("span", {
      style: {
        fontSize: e.size,
        fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
      },
      children: r.native
    }) : /* @__PURE__ */ q("span", {
      style: {
        display: "block",
        width: e.size,
        height: e.size,
        backgroundImage: `url(${l})`,
        backgroundSize: `${100 * Oe.sheet.cols}% ${100 * Oe.sheet.rows}%`,
        backgroundPosition: `${100 / (Oe.sheet.cols - 1) * r.x}% ${100 / (Oe.sheet.rows - 1) * r.y}%`
      }
    })
  });
}
const Pne = typeof window < "u" && window.HTMLElement ? window.HTMLElement : Object;
class of extends Pne {
  static get observedAttributes() {
    return Object.keys(this.Props);
  }
  update(i = {}) {
    for (let n in i)
      this.attributeChangedCallback(n, null, i[n]);
  }
  attributeChangedCallback(i, n, a) {
    if (!this.component)
      return;
    const r = sf(i, {
      [i]: a
    }, this.constructor.Props, this);
    this.component.componentWillReceiveProps ? this.component.componentWillReceiveProps({
      [i]: r
    }) : (this.component.props[i] = r, this.component.forceUpdate());
  }
  disconnectedCallback() {
    this.disconnected = !0, this.component && this.component.unregister && this.component.unregister();
  }
  constructor(i = {}) {
    if (super(), this.props = i, i.parent || i.ref) {
      let n = null;
      const a = i.parent || (n = i.ref && i.ref.current);
      n && (n.innerHTML = ""), a && a.appendChild(this);
    }
  }
}
class Une extends of {
  setShadow() {
    this.attachShadow({
      mode: "open"
    });
  }
  injectStyles(i) {
    if (!i)
      return;
    const n = document.createElement("style");
    n.textContent = i, this.shadowRoot.insertBefore(n, this.shadowRoot.firstChild);
  }
  constructor(i, { styles: n } = {}) {
    super(i), this.setShadow(), this.injectStyles(n);
  }
}
var rf = {
  fallback: "",
  id: "",
  native: "",
  shortcodes: "",
  size: {
    value: "",
    transform: (e) => /\D/.test(e) ? e : `${e}px`
  },
  // Shared
  set: Ai.set,
  skin: Ai.skin
};
class lf extends of {
  async connectedCallback() {
    const i = af(this.props, rf, this);
    i.element = this, i.ref = (n) => {
      this.component = n;
    }, await P0(), !this.disconnected && Jc(/* @__PURE__ */ q(F3, {
      ...i
    }), this);
  }
  constructor(i) {
    super(i);
  }
}
Fn(lf, "Props", rf);
typeof customElements < "u" && !customElements.get("em-emoji") && customElements.define("em-emoji", lf);
var gl, P3 = [], _l = _e.__b, wl = _e.__r, Cl = _e.diffed, kl = _e.__c, xl = _e.unmount;
function Rne() {
  var e;
  for (P3.sort(function(i, n) {
    return i.__v.__b - n.__v.__b;
  }); e = P3.pop(); )
    if (e.__P)
      try {
        e.__H.__h.forEach(i0), e.__H.__h.forEach(U3), e.__H.__h = [];
      } catch (i) {
        e.__H.__h = [], _e.__e(i, e.__v);
      }
}
_e.__b = function(e) {
  _l && _l(e);
}, _e.__r = function(e) {
  wl && wl(e);
  var i = e.__c.__H;
  i && (i.__h.forEach(i0), i.__h.forEach(U3), i.__h = []);
}, _e.diffed = function(e) {
  Cl && Cl(e);
  var i = e.__c;
  i && i.__H && i.__H.__h.length && (P3.push(i) !== 1 && gl === _e.requestAnimationFrame || ((gl = _e.requestAnimationFrame) || function(n) {
    var a, r = function() {
      clearTimeout(o), bl && cancelAnimationFrame(a), setTimeout(n);
    }, o = setTimeout(r, 100);
    bl && (a = requestAnimationFrame(r));
  })(Rne));
}, _e.__c = function(e, i) {
  i.some(function(n) {
    try {
      n.__h.forEach(i0), n.__h = n.__h.filter(function(a) {
        return !a.__ || U3(a);
      });
    } catch (a) {
      i.some(function(r) {
        r.__h && (r.__h = []);
      }), i = [], _e.__e(a, n.__v);
    }
  }), kl && kl(e, i);
}, _e.unmount = function(e) {
  xl && xl(e);
  var i, n = e.__c;
  n && n.__H && (n.__H.__.forEach(function(a) {
    try {
      i0(a);
    } catch (r) {
      i = r;
    }
  }), i && _e.__e(i, n.__v));
};
var bl = typeof requestAnimationFrame == "function";
function i0(e) {
  var i = e.__c;
  typeof i == "function" && (e.__c = void 0, i());
}
function U3(e) {
  e.__c = e.__();
}
function Yne(e, i) {
  for (var n in i)
    e[n] = i[n];
  return e;
}
function Ml(e, i) {
  for (var n in e)
    if (n !== "__source" && !(n in i))
      return !0;
  for (var a in i)
    if (a !== "__source" && e[a] !== i[a])
      return !0;
  return !1;
}
function v0(e) {
  this.props = e;
}
(v0.prototype = new si()).isPureReactComponent = !0, v0.prototype.shouldComponentUpdate = function(e, i) {
  return Ml(this.props, e) || Ml(this.state, i);
};
var Dl = _e.__b;
_e.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Dl && Dl(e);
};
var Zne = _e.__e;
_e.__e = function(e, i, n) {
  if (e.then) {
    for (var a, r = i; r = r.__; )
      if ((a = r.__c) && a.__c)
        return i.__e == null && (i.__e = n.__e, i.__k = n.__k), a.__c(e, i);
  }
  Zne(e, i, n);
};
var Al = _e.unmount;
function p3() {
  this.__u = 0, this.t = null, this.__b = null;
}
function df(e) {
  var i = e.__.__c;
  return i && i.__e && i.__e(e);
}
function Qa() {
  this.u = null, this.o = null;
}
_e.unmount = function(e) {
  var i = e.__c;
  i && i.__R && i.__R(), i && e.__h === !0 && (e.type = null), Al && Al(e);
}, (p3.prototype = new si()).__c = function(e, i) {
  var n = i.__c, a = this;
  a.t == null && (a.t = []), a.t.push(n);
  var r = df(a.__v), o = !1, l = function() {
    o || (o = !0, n.__R = null, r ? r(c) : c());
  };
  n.__R = l;
  var c = function() {
    if (!--a.__u) {
      if (a.state.__e) {
        var y = a.state.__e;
        a.__v.__k[0] = function x(C, M, z) {
          return C && (C.__v = null, C.__k = C.__k && C.__k.map(function(R) {
            return x(R, M, z);
          }), C.__c && C.__c.__P === M && (C.__e && z.insertBefore(C.__e, C.__d), C.__c.__e = !0, C.__c.__P = z)), C;
        }(y, y.__c.__P, y.__c.__O);
      }
      var v;
      for (a.setState({
        __e: a.__b = null
      }); v = a.t.pop(); )
        v.forceUpdate();
    }
  }, h = i.__h === !0;
  a.__u++ || h || a.setState({
    __e: a.__b = a.__v.__k[0]
  }), e.then(l, l);
}, p3.prototype.componentWillUnmount = function() {
  this.t = [];
}, p3.prototype.render = function(e, i) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"), a = this.__v.__k[0].__c;
      this.__v.__k[0] = function o(l, c, h) {
        return l && (l.__c && l.__c.__H && (l.__c.__H.__.forEach(function(y) {
          typeof y.__c == "function" && y.__c();
        }), l.__c.__H = null), (l = Yne({}, l)).__c != null && (l.__c.__P === h && (l.__c.__P = c), l.__c = null), l.__k = l.__k && l.__k.map(function(y) {
          return o(y, c, h);
        })), l;
      }(this.__b, n, a.__O = a.__P);
    }
    this.__b = null;
  }
  var r = i.__e && H3(r2, null, e.fallback);
  return r && (r.__h = null), [
    H3(r2, null, i.__e ? null : e.children),
    r
  ];
};
var Ll = function(e, i, n) {
  if (++n[1] === n[0] && e.o.delete(i), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.o.size))
    for (n = e.u; n; ) {
      for (; n.length > 3; )
        n.pop()();
      if (n[1] < n[0])
        break;
      e.u = n = n[2];
    }
};
(Qa.prototype = new si()).__e = function(e) {
  var i = this, n = df(i.__v), a = i.o.get(e);
  return a[0]++, function(r) {
    var o = function() {
      i.props.revealOrder ? (a.push(r), Ll(i, e, a)) : r();
    };
    n ? n(o) : o();
  };
}, Qa.prototype.render = function(e) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var i = m0(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && i.reverse();
  for (var n = i.length; n--; )
    this.o.set(i[n], this.u = [
      1,
      0,
      this.u
    ]);
  return e.children;
}, Qa.prototype.componentDidUpdate = Qa.prototype.componentDidMount = function() {
  var e = this;
  this.o.forEach(function(i, n) {
    Ll(e, n, i);
  });
};
var Wne = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Qne = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, qne = typeof document < "u", Gne = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(e);
};
si.prototype.isReactComponent = {}, [
  "componentWillMount",
  "componentWillReceiveProps",
  "componentWillUpdate"
].forEach(function(e) {
  Object.defineProperty(si.prototype, e, {
    configurable: !0,
    get: function() {
      return this["UNSAFE_" + e];
    },
    set: function(i) {
      Object.defineProperty(this, e, {
        configurable: !0,
        writable: !0,
        value: i
      });
    }
  });
});
var Tl = _e.event;
function Xne() {
}
function Jne() {
  return this.cancelBubble;
}
function Kne() {
  return this.defaultPrevented;
}
_e.event = function(e) {
  return Tl && (e = Tl(e)), e.persist = Xne, e.isPropagationStopped = Jne, e.isDefaultPrevented = Kne, e.nativeEvent = e;
};
var Sl = {
  configurable: !0,
  get: function() {
    return this.class;
  }
}, Nl = _e.vnode;
_e.vnode = function(e) {
  var i = e.type, n = e.props, a = n;
  if (typeof i == "string") {
    var r = i.indexOf("-") === -1;
    for (var o in a = {}, n) {
      var l = n[o];
      qne && o === "children" && i === "noscript" || o === "value" && "defaultValue" in n && l == null || (o === "defaultValue" && "value" in n && n.value == null ? o = "value" : o === "download" && l === !0 ? l = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + i) && !Gne(n.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o) ? o = o.toLowerCase() : r && Qne.test(o) ? o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase() : l === null && (l = void 0), a[o] = l);
    }
    i == "select" && a.multiple && Array.isArray(a.value) && (a.value = m0(n.children).forEach(function(c) {
      c.props.selected = a.value.indexOf(c.props.value) != -1;
    })), i == "select" && a.defaultValue != null && (a.value = m0(n.children).forEach(function(c) {
      c.props.selected = a.multiple ? a.defaultValue.indexOf(c.props.value) != -1 : a.defaultValue == c.props.value;
    })), e.props = a, n.class != n.className && (Sl.enumerable = "className" in n, n.className != null && (a.class = n.className), Object.defineProperty(a, "className", Sl));
  }
  e.$$typeof = Wne, Nl && Nl(e);
};
var El = _e.__r;
_e.__r = function(e) {
  El && El(e), e.__c;
};
const $ne = {
  light: "outline",
  dark: "solid"
};
class eie extends v0 {
  renderIcon(i) {
    const { icon: n } = i;
    if (n) {
      if (n.svg)
        return /* @__PURE__ */ q("span", {
          class: "flex",
          dangerouslySetInnerHTML: {
            __html: n.svg
          }
        });
      if (n.src)
        return /* @__PURE__ */ q("img", {
          src: n.src
        });
    }
    const a = y0.categories[i.id] || y0.categories.custom, r = this.props.icons == "auto" ? $ne[this.props.theme] : this.props.icons;
    return a[r] || a;
  }
  render() {
    let i = null;
    return /* @__PURE__ */ q("nav", {
      id: "nav",
      class: "padding",
      "data-position": this.props.position,
      dir: this.props.dir,
      children: /* @__PURE__ */ q("div", {
        class: "flex relative",
        children: [
          this.categories.map((n, a) => {
            const r = n.name || F1.categories[n.id], o = !this.props.unfocused && n.id == this.state.categoryId;
            return o && (i = a), /* @__PURE__ */ q("button", {
              "aria-label": r,
              "aria-selected": o || void 0,
              title: r,
              type: "button",
              class: "flex flex-grow flex-center",
              onMouseDown: (l) => l.preventDefault(),
              onClick: () => {
                this.props.onClick({
                  category: n,
                  i: a
                });
              },
              children: this.renderIcon(n)
            });
          }),
          /* @__PURE__ */ q("div", {
            class: "bar",
            style: {
              width: `${100 / this.categories.length}%`,
              opacity: i == null ? 0 : 1,
              transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${i * 100}%)` : `translateX(${i * 100}%)`
            }
          })
        ]
      })
    });
  }
  constructor() {
    super(), this.categories = Oe.categories.filter((i) => !i.target), this.state = {
      categoryId: this.categories[0].id
    };
  }
}
class nie extends v0 {
  shouldComponentUpdate(i) {
    for (let n in i)
      if (n != "children" && i[n] != this.props[n])
        return !0;
    return !1;
  }
  render() {
    return this.props.children;
  }
}
const qa = {
  rowsPerRender: 10
};
class iie extends si {
  getInitialState(i = this.props) {
    return {
      skin: it.get("skin") || i.skin,
      theme: this.initTheme(i.theme)
    };
  }
  componentWillMount() {
    this.dir = F1.rtl ? "rtl" : "ltr", this.refs = {
      menu: bi(),
      navigation: bi(),
      scroll: bi(),
      search: bi(),
      searchInput: bi(),
      skinToneButton: bi(),
      skinToneRadio: bi()
    }, this.initGrid(), this.props.stickySearch == !1 && this.props.searchPosition == "sticky" && (console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`."), this.props.searchPosition = "static");
  }
  componentDidMount() {
    if (this.register(), this.shadowRoot = this.base.parentNode, this.props.autoFocus) {
      const { searchInput: i } = this.refs;
      i.current && i.current.focus();
    }
  }
  componentWillReceiveProps(i) {
    this.nextState || (this.nextState = {});
    for (const n in i)
      this.nextState[n] = i[n];
    clearTimeout(this.nextStateTimer), this.nextStateTimer = setTimeout(() => {
      let n = !1;
      for (const r in this.nextState)
        this.props[r] = this.nextState[r], (r === "custom" || r === "categories") && (n = !0);
      delete this.nextState;
      const a = this.getInitialState();
      if (n)
        return this.reset(a);
      this.setState(a);
    });
  }
  componentWillUnmount() {
    this.unregister();
  }
  async reset(i = {}) {
    await P0(this.props), this.initGrid(), this.unobserve(), this.setState(i, () => {
      this.observeCategories(), this.observeRows();
    });
  }
  register() {
    document.addEventListener("click", this.handleClickOutside), this.observe();
  }
  unregister() {
    document.removeEventListener("click", this.handleClickOutside), this.unobserve();
  }
  observe() {
    this.observeCategories(), this.observeRows();
  }
  unobserve({ except: i = [] } = {}) {
    Array.isArray(i) || (i = [
      i
    ]);
    for (const n of this.observers)
      i.includes(n) || n.disconnect();
    this.observers = [].concat(i);
  }
  initGrid() {
    const { categories: i } = Oe;
    this.refs.categories = /* @__PURE__ */ new Map();
    const n = Oe.categories.map((r) => r.id).join(",");
    this.navKey && this.navKey != n && this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0), this.navKey = n, this.grid = [], this.grid.setsize = 0;
    const a = (r, o) => {
      const l = [];
      l.__categoryId = o.id, l.__index = r.length, this.grid.push(l);
      const c = this.grid.length - 1, h = c % qa.rowsPerRender ? {} : bi();
      return h.index = c, h.posinset = this.grid.setsize + 1, r.push(h), l;
    };
    for (let r of i) {
      const o = [];
      let l = a(o, r);
      for (let c of r.emojis)
        l.length == this.getPerLine() && (l = a(o, r)), this.grid.setsize += 1, l.push(c);
      this.refs.categories.set(r.id, {
        root: bi(),
        rows: o
      });
    }
  }
  initTheme(i) {
    if (i != "auto")
      return i;
    if (!this.darkMedia) {
      if (this.darkMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMedia.media.match(/^not/))
        return "light";
      this.darkMedia.addListener(() => {
        this.props.theme == "auto" && this.setState({
          theme: this.darkMedia.matches ? "dark" : "light"
        });
      });
    }
    return this.darkMedia.matches ? "dark" : "light";
  }
  initDynamicPerLine(i = this.props) {
    if (!i.dynamicWidth)
      return;
    const { element: n, emojiButtonSize: a } = i, r = () => {
      const { width: l } = n.getBoundingClientRect();
      return Math.floor(l / a);
    }, o = new ResizeObserver(() => {
      this.unobserve({
        except: o
      }), this.setState({
        perLine: r()
      }, () => {
        this.initGrid(), this.forceUpdate(() => {
          this.observeCategories(), this.observeRows();
        });
      });
    });
    return o.observe(n), this.observers.push(o), r();
  }
  getPerLine() {
    return this.state.perLine || this.props.perLine;
  }
  getEmojiByPos([i, n]) {
    const a = this.state.searchResults || this.grid, r = a[i] && a[i][n];
    if (r)
      return t2.get(r);
  }
  observeCategories() {
    const i = this.refs.navigation.current;
    if (!i)
      return;
    const n = /* @__PURE__ */ new Map(), a = (l) => {
      l != i.state.categoryId && i.setState({
        categoryId: l
      });
    }, r = {
      root: this.refs.scroll.current,
      threshold: [
        0,
        1
      ]
    }, o = new IntersectionObserver((l) => {
      for (const h of l) {
        const y = h.target.dataset.id;
        n.set(y, h.intersectionRatio);
      }
      const c = [
        ...n
      ];
      for (const [h, y] of c)
        if (y) {
          a(h);
          break;
        }
    }, r);
    for (const { root: l } of this.refs.categories.values())
      o.observe(l.current);
    this.observers.push(o);
  }
  observeRows() {
    const i = {
      ...this.state.visibleRows
    }, n = new IntersectionObserver((a) => {
      for (const r of a) {
        const o = parseInt(r.target.dataset.index);
        r.isIntersecting ? i[o] = !0 : delete i[o];
      }
      this.setState({
        visibleRows: i
      });
    }, {
      root: this.refs.scroll.current,
      rootMargin: `${this.props.emojiButtonSize * (qa.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * qa.rowsPerRender}px`
    });
    for (const { rows: a } of this.refs.categories.values())
      for (const r of a)
        r.current && n.observe(r.current);
    this.observers.push(n);
  }
  preventDefault(i) {
    i.preventDefault();
  }
  unfocusSearch() {
    const i = this.refs.searchInput.current;
    i && i.blur();
  }
  navigate({ e: i, input: n, left: a, right: r, up: o, down: l }) {
    const c = this.state.searchResults || this.grid;
    if (!c.length)
      return;
    let [h, y] = this.state.pos;
    const v = (() => {
      if (h == 0 && y == 0 && !i.repeat && (a || o))
        return null;
      if (h == -1)
        return !i.repeat && (r || l) && n.selectionStart == n.value.length ? [
          0,
          0
        ] : null;
      if (a || r) {
        let x = c[h];
        const C = a ? -1 : 1;
        if (y += C, !x[y]) {
          if (h += C, x = c[h], !x)
            return h = a ? 0 : c.length - 1, y = a ? 0 : c[h].length - 1, [
              h,
              y
            ];
          y = a ? x.length - 1 : 0;
        }
        return [
          h,
          y
        ];
      }
      if (o || l) {
        h += o ? -1 : 1;
        const x = c[h];
        return x ? (x[y] || (y = x.length - 1), [
          h,
          y
        ]) : (h = o ? 0 : c.length - 1, y = o ? 0 : c[h].length - 1, [
          h,
          y
        ]);
      }
    })();
    if (v)
      i.preventDefault();
    else {
      this.state.pos[0] > -1 && this.setState({
        pos: [
          -1,
          -1
        ]
      });
      return;
    }
    this.setState({
      pos: v,
      keyboard: !0
    }, () => {
      this.scrollTo({
        row: v[0]
      });
    });
  }
  scrollTo({ categoryId: i, row: n }) {
    const a = this.state.searchResults || this.grid;
    if (!a.length)
      return;
    const r = this.refs.scroll.current, o = r.getBoundingClientRect();
    let l = 0;
    if (n >= 0 && (i = a[n].__categoryId), i && (l = (this.refs[i] || this.refs.categories.get(i).root).current.getBoundingClientRect().top - (o.top - r.scrollTop) + 1), n >= 0)
      if (!n)
        l = 0;
      else {
        const c = a[n].__index, h = l + c * this.props.emojiButtonSize, y = h + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
        if (h < r.scrollTop)
          l = h;
        else if (y > r.scrollTop + o.height)
          l = y - o.height;
        else
          return;
      }
    this.ignoreMouse(), r.scrollTop = l;
  }
  ignoreMouse() {
    this.mouseIsIgnored = !0, clearTimeout(this.ignoreMouseTimer), this.ignoreMouseTimer = setTimeout(() => {
      delete this.mouseIsIgnored;
    }, 100);
  }
  handleEmojiOver(i) {
    this.mouseIsIgnored || this.state.showSkins || this.setState({
      pos: i || [
        -1,
        -1
      ],
      keyboard: !1
    });
  }
  handleEmojiClick({ e: i, emoji: n, pos: a }) {
    if (this.props.onEmojiSelect && (!n && a && (n = this.getEmojiByPos(a)), n)) {
      const r = jne(n, {
        skinIndex: this.state.skin - 1
      });
      this.props.maxFrequentRows && $c.add(r, this.props), this.props.onEmojiSelect(r, i);
    }
  }
  closeSkins() {
    this.state.showSkins && (this.setState({
      showSkins: null,
      tempSkin: null
    }), this.base.removeEventListener("click", this.handleBaseClick), this.base.removeEventListener("keydown", this.handleBaseKeydown));
  }
  handleSkinMouseOver(i) {
    this.setState({
      tempSkin: i
    });
  }
  handleSkinClick(i) {
    this.ignoreMouse(), this.closeSkins(), this.setState({
      skin: i,
      tempSkin: null
    }), it.set("skin", i);
  }
  renderNav() {
    return /* @__PURE__ */ q(eie, {
      ref: this.refs.navigation,
      icons: this.props.icons,
      theme: this.state.theme,
      dir: this.dir,
      unfocused: !!this.state.searchResults,
      position: this.props.navPosition,
      onClick: this.handleCategoryClick
    }, this.navKey);
  }
  renderPreview() {
    const i = this.getEmojiByPos(this.state.pos), n = this.state.searchResults && !this.state.searchResults.length;
    return /* @__PURE__ */ q("div", {
      id: "preview",
      class: "flex flex-middle",
      dir: this.dir,
      "data-position": this.props.previewPosition,
      children: [
        /* @__PURE__ */ q("div", {
          class: "flex flex-middle flex-grow",
          children: [
            /* @__PURE__ */ q("div", {
              class: "flex flex-auto flex-middle flex-center",
              style: {
                height: this.props.emojiButtonSize,
                fontSize: this.props.emojiButtonSize
              },
              children: /* @__PURE__ */ q(F3, {
                emoji: i,
                id: n ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                set: this.props.set,
                size: this.props.emojiButtonSize,
                skin: this.state.tempSkin || this.state.skin,
                spritesheet: !0,
                getSpritesheetURL: this.props.getSpritesheetURL
              })
            }),
            /* @__PURE__ */ q("div", {
              class: `margin-${this.dir[0]}`,
              children: i || n ? /* @__PURE__ */ q("div", {
                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                children: [
                  /* @__PURE__ */ q("div", {
                    class: "preview-title ellipsis",
                    children: i ? i.name : F1.search_no_results_1
                  }),
                  /* @__PURE__ */ q("div", {
                    class: "preview-subtitle ellipsis color-c",
                    children: i ? i.skins[0].shortcodes : F1.search_no_results_2
                  })
                ]
              }) : /* @__PURE__ */ q("div", {
                class: "preview-placeholder color-c",
                children: F1.pick
              })
            })
          ]
        }),
        !i && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
      ]
    });
  }
  renderEmojiButton(i, { pos: n, posinset: a, grid: r }) {
    const o = this.props.emojiButtonSize, l = this.state.tempSkin || this.state.skin, h = (i.skins[l - 1] || i.skins[0]).native, y = One(this.state.pos, n), v = n.concat(i.id).join("");
    return /* @__PURE__ */ q(nie, {
      selected: y,
      skin: l,
      size: o,
      children: /* @__PURE__ */ q("button", {
        "aria-label": h,
        "aria-selected": y || void 0,
        "aria-posinset": a,
        "aria-setsize": r.setsize,
        "data-keyboard": this.state.keyboard,
        title: this.props.previewPosition == "none" ? i.name : void 0,
        type: "button",
        class: "flex flex-center flex-middle",
        tabindex: "-1",
        onClick: (x) => this.handleEmojiClick({
          e: x,
          emoji: i
        }),
        onMouseEnter: () => this.handleEmojiOver(n),
        onMouseLeave: () => this.handleEmojiOver(),
        style: {
          width: this.props.emojiButtonSize,
          height: this.props.emojiButtonSize,
          fontSize: this.props.emojiSize,
          lineHeight: 0
        },
        children: [
          /* @__PURE__ */ q("div", {
            "aria-hidden": "true",
            class: "background",
            style: {
              borderRadius: this.props.emojiButtonRadius,
              backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(a - 1) % this.props.emojiButtonColors.length] : void 0
            }
          }),
          /* @__PURE__ */ q(F3, {
            emoji: i,
            set: this.props.set,
            size: this.props.emojiSize,
            skin: l,
            spritesheet: !0,
            getSpritesheetURL: this.props.getSpritesheetURL
          })
        ]
      })
    }, v);
  }
  renderSearch() {
    const i = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
    return /* @__PURE__ */ q("div", {
      children: [
        /* @__PURE__ */ q("div", {
          class: "spacer"
        }),
        /* @__PURE__ */ q("div", {
          class: "flex flex-middle",
          children: [
            /* @__PURE__ */ q("div", {
              class: "search relative flex-grow",
              children: [
                /* @__PURE__ */ q("input", {
                  type: "search",
                  ref: this.refs.searchInput,
                  placeholder: F1.search,
                  onClick: this.handleSearchClick,
                  onInput: this.handleSearchInput,
                  onKeyDown: this.handleSearchKeyDown,
                  autoComplete: "off"
                }),
                /* @__PURE__ */ q("span", {
                  class: "icon loupe flex",
                  children: y0.search.loupe
                }),
                this.state.searchResults && /* @__PURE__ */ q("button", {
                  title: "Clear",
                  "aria-label": "Clear",
                  type: "button",
                  class: "icon delete flex",
                  onClick: this.clearSearch,
                  onMouseDown: this.preventDefault,
                  children: y0.search.delete
                })
              ]
            }),
            i && this.renderSkinToneButton()
          ]
        })
      ]
    });
  }
  renderSearchResults() {
    const { searchResults: i } = this.state;
    return i ? /* @__PURE__ */ q("div", {
      class: "category",
      ref: this.refs.search,
      children: [
        /* @__PURE__ */ q("div", {
          class: `sticky padding-small align-${this.dir[0]}`,
          children: F1.categories.search
        }),
        /* @__PURE__ */ q("div", {
          children: i.length ? i.map((n, a) => /* @__PURE__ */ q("div", {
            class: "flex",
            children: n.map((r, o) => this.renderEmojiButton(r, {
              pos: [
                a,
                o
              ],
              posinset: a * this.props.perLine + o + 1,
              grid: i
            }))
          })) : /* @__PURE__ */ q("div", {
            class: `padding-small align-${this.dir[0]}`,
            children: this.props.onAddCustomEmoji && /* @__PURE__ */ q("a", {
              onClick: this.props.onAddCustomEmoji,
              children: F1.add_custom
            })
          })
        })
      ]
    }) : null;
  }
  renderCategories() {
    const { categories: i } = Oe, n = !!this.state.searchResults, a = this.getPerLine();
    return /* @__PURE__ */ q("div", {
      style: {
        visibility: n ? "hidden" : void 0,
        display: n ? "none" : void 0,
        height: "100%"
      },
      children: i.map((r) => {
        const { root: o, rows: l } = this.refs.categories.get(r.id);
        return /* @__PURE__ */ q("div", {
          "data-id": r.target ? r.target.id : r.id,
          class: "category",
          ref: o,
          children: [
            /* @__PURE__ */ q("div", {
              class: `sticky padding-small align-${this.dir[0]}`,
              children: r.name || F1.categories[r.id]
            }),
            /* @__PURE__ */ q("div", {
              class: "relative",
              style: {
                height: l.length * this.props.emojiButtonSize
              },
              children: l.map((c, h) => {
                const y = c.index - c.index % qa.rowsPerRender, v = this.state.visibleRows[y], x = "current" in c ? c : void 0;
                if (!v && !x)
                  return null;
                const C = h * a, M = C + a, z = r.emojis.slice(C, M);
                return z.length < a && z.push(...new Array(a - z.length)), /* @__PURE__ */ q("div", {
                  "data-index": c.index,
                  ref: x,
                  class: "flex row",
                  style: {
                    top: h * this.props.emojiButtonSize
                  },
                  children: v && z.map((R, U) => {
                    if (!R)
                      return /* @__PURE__ */ q("div", {
                        style: {
                          width: this.props.emojiButtonSize,
                          height: this.props.emojiButtonSize
                        }
                      });
                    const G = t2.get(R);
                    return this.renderEmojiButton(G, {
                      pos: [
                        c.index,
                        U
                      ],
                      posinset: c.posinset + U,
                      grid: this.grid
                    });
                  })
                }, c.index);
              })
            })
          ]
        });
      })
    });
  }
  renderSkinToneButton() {
    return this.props.skinTonePosition == "none" ? null : /* @__PURE__ */ q("div", {
      class: "flex flex-auto flex-center flex-middle",
      style: {
        position: "relative",
        width: this.props.emojiButtonSize,
        height: this.props.emojiButtonSize
      },
      children: /* @__PURE__ */ q("button", {
        type: "button",
        ref: this.refs.skinToneButton,
        class: "skin-tone-button flex flex-auto flex-center flex-middle",
        "aria-selected": this.state.showSkins ? "" : void 0,
        "aria-label": F1.skins.choose,
        title: F1.skins.choose,
        onClick: this.openSkins,
        style: {
          width: this.props.emojiSize,
          height: this.props.emojiSize
        },
        children: /* @__PURE__ */ q("span", {
          class: `skin-tone skin-tone-${this.state.skin}`
        })
      })
    });
  }
  renderLiveRegion() {
    const i = this.getEmojiByPos(this.state.pos), n = i ? i.name : "";
    return /* @__PURE__ */ q("div", {
      "aria-live": "polite",
      class: "sr-only",
      children: n
    });
  }
  renderSkins() {
    const n = this.refs.skinToneButton.current.getBoundingClientRect(), a = this.base.getBoundingClientRect(), r = {};
    return this.dir == "ltr" ? r.right = a.right - n.right - 3 : r.left = n.left - a.left - 3, this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview" ? r.bottom = a.bottom - n.top + 6 : (r.top = n.bottom - a.top + 3, r.bottom = "auto"), /* @__PURE__ */ q("div", {
      ref: this.refs.menu,
      role: "radiogroup",
      dir: this.dir,
      "aria-label": F1.skins.choose,
      class: "menu hidden",
      "data-position": r.top ? "top" : "bottom",
      style: r,
      children: [
        ...Array(6).keys()
      ].map((o) => {
        const l = o + 1, c = this.state.skin == l;
        return /* @__PURE__ */ q("div", {
          children: [
            /* @__PURE__ */ q("input", {
              type: "radio",
              name: "skin-tone",
              value: l,
              "aria-label": F1.skins[l],
              ref: c ? this.refs.skinToneRadio : null,
              defaultChecked: c,
              onChange: () => this.handleSkinMouseOver(l),
              onKeyDown: (h) => {
                (h.code == "Enter" || h.code == "Space" || h.code == "Tab") && (h.preventDefault(), this.handleSkinClick(l));
              }
            }),
            /* @__PURE__ */ q("button", {
              "aria-hidden": "true",
              tabindex: "-1",
              onClick: () => this.handleSkinClick(l),
              onMouseEnter: () => this.handleSkinMouseOver(l),
              onMouseLeave: () => this.handleSkinMouseOver(),
              class: "option flex flex-grow flex-middle",
              children: [
                /* @__PURE__ */ q("span", {
                  class: `skin-tone skin-tone-${l}`
                }),
                /* @__PURE__ */ q("span", {
                  class: "margin-small-lr",
                  children: F1.skins[l]
                })
              ]
            })
          ]
        });
      })
    });
  }
  render() {
    const i = this.props.perLine * this.props.emojiButtonSize;
    return /* @__PURE__ */ q("section", {
      id: "root",
      class: "flex flex-column",
      dir: this.dir,
      style: {
        width: this.props.dynamicWidth ? "100%" : `calc(${i}px + (var(--padding) + var(--sidebar-width)))`
      },
      "data-emoji-set": this.props.set,
      "data-theme": this.state.theme,
      "data-menu": this.state.showSkins ? "" : void 0,
      children: [
        this.props.previewPosition == "top" && this.renderPreview(),
        this.props.navPosition == "top" && this.renderNav(),
        this.props.searchPosition == "sticky" && /* @__PURE__ */ q("div", {
          class: "padding-lr",
          children: this.renderSearch()
        }),
        /* @__PURE__ */ q("div", {
          ref: this.refs.scroll,
          class: "scroll flex-grow padding-lr",
          children: /* @__PURE__ */ q("div", {
            style: {
              width: this.props.dynamicWidth ? "100%" : i,
              height: "100%"
            },
            children: [
              this.props.searchPosition == "static" && this.renderSearch(),
              this.renderSearchResults(),
              this.renderCategories()
            ]
          })
        }),
        this.props.navPosition == "bottom" && this.renderNav(),
        this.props.previewPosition == "bottom" && this.renderPreview(),
        this.state.showSkins && this.renderSkins(),
        this.renderLiveRegion()
      ]
    });
  }
  constructor(i) {
    super(), Fn(this, "handleClickOutside", (n) => {
      const { element: a } = this.props;
      n.target != a && (this.state.showSkins && this.closeSkins(), this.props.onClickOutside && this.props.onClickOutside(n));
    }), Fn(this, "handleBaseClick", (n) => {
      this.state.showSkins && (n.target.closest(".menu") || (n.preventDefault(), n.stopImmediatePropagation(), this.closeSkins()));
    }), Fn(this, "handleBaseKeydown", (n) => {
      this.state.showSkins && n.key == "Escape" && (n.preventDefault(), n.stopImmediatePropagation(), this.closeSkins());
    }), Fn(this, "handleSearchClick", () => {
      this.getEmojiByPos(this.state.pos) && this.setState({
        pos: [
          -1,
          -1
        ]
      });
    }), Fn(this, "handleSearchInput", async () => {
      const n = this.refs.searchInput.current;
      if (!n)
        return;
      const { value: a } = n, r = await t2.search(a), o = () => {
        this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
      };
      if (!r)
        return this.setState({
          searchResults: r,
          pos: [
            -1,
            -1
          ]
        }, o);
      const l = n.selectionStart == n.value.length ? [
        0,
        0
      ] : [
        -1,
        -1
      ], c = [];
      c.setsize = r.length;
      let h = null;
      for (let y of r)
        (!c.length || h.length == this.getPerLine()) && (h = [], h.__categoryId = "search", h.__index = c.length, c.push(h)), h.push(y);
      this.ignoreMouse(), this.setState({
        searchResults: c,
        pos: l
      }, o);
    }), Fn(this, "handleSearchKeyDown", (n) => {
      const a = n.currentTarget;
      switch (n.stopImmediatePropagation(), n.key) {
        case "ArrowLeft":
          this.navigate({
            e: n,
            input: a,
            left: !0
          });
          break;
        case "ArrowRight":
          this.navigate({
            e: n,
            input: a,
            right: !0
          });
          break;
        case "ArrowUp":
          this.navigate({
            e: n,
            input: a,
            up: !0
          });
          break;
        case "ArrowDown":
          this.navigate({
            e: n,
            input: a,
            down: !0
          });
          break;
        case "Enter":
          n.preventDefault(), this.handleEmojiClick({
            e: n,
            pos: this.state.pos
          });
          break;
        case "Escape":
          n.preventDefault(), this.state.searchResults ? this.clearSearch() : this.unfocusSearch();
          break;
      }
    }), Fn(this, "clearSearch", () => {
      const n = this.refs.searchInput.current;
      n && (n.value = "", n.focus(), this.handleSearchInput());
    }), Fn(this, "handleCategoryClick", ({ category: n, i: a }) => {
      this.scrollTo(a == 0 ? {
        row: -1
      } : {
        categoryId: n.id
      });
    }), Fn(this, "openSkins", (n) => {
      const { currentTarget: a } = n, r = a.getBoundingClientRect();
      this.setState({
        showSkins: r
      }, async () => {
        await Hne(2);
        const o = this.refs.menu.current;
        o && (o.classList.remove("hidden"), this.refs.skinToneRadio.current.focus(), this.base.addEventListener("click", this.handleBaseClick, !0), this.base.addEventListener("keydown", this.handleBaseKeydown, !0));
      });
    }), this.observers = [], this.state = {
      pos: [
        -1,
        -1
      ],
      perLine: this.initDynamicPerLine(i),
      visibleRows: {
        0: !0
      },
      ...this.getInitialState(i)
    };
  }
}
class No extends Une {
  async connectedCallback() {
    const i = af(this.props, Ai, this);
    i.element = this, i.ref = (n) => {
      this.component = n;
    }, await P0(i), !this.disconnected && Jc(/* @__PURE__ */ q(iie, {
      ...i
    }), this.shadowRoot);
  }
  constructor(i) {
    super(i, {
      styles: /* @__PURE__ */ Vc(cf)
    });
  }
}
Fn(No, "Props", Ai);
typeof customElements < "u" && !customElements.get("em-emoji-picker") && customElements.define("em-emoji-picker", No);
var cf = {};
cf = `:host {
  width: min-content;
  height: 435px;
  min-height: 230px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  --border-radius: 10px;
  --category-icon-size: 18px;
  --font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  --font-size: 15px;
  --preview-placeholder-size: 21px;
  --preview-title-size: 1.1em;
  --preview-subtitle-size: .9em;
  --shadow-color: 0deg 0% 0%;
  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);
  display: flex;
}

[data-theme="light"] {
  --em-rgb-color: var(--rgb-color, 34, 36, 39);
  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);
  --em-rgb-background: var(--rgb-background, 255, 255, 255);
  --em-rgb-input: var(--rgb-input, 255, 255, 255);
  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));
  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));
}

[data-theme="dark"] {
  --em-rgb-color: var(--rgb-color, 222, 222, 221);
  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);
  --em-rgb-background: var(--rgb-background, 21, 22, 23);
  --em-rgb-input: var(--rgb-input, 0, 0, 0);
  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));
  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));
}

#root {
  --color-a: rgb(var(--em-rgb-color));
  --color-b: rgba(var(--em-rgb-color), .65);
  --color-c: rgba(var(--em-rgb-color), .45);
  --padding: 12px;
  --padding-small: calc(var(--padding) / 2);
  --sidebar-width: 16px;
  --duration: 225ms;
  --duration-fast: 125ms;
  --duration-instant: 50ms;
  --easing: cubic-bezier(.4, 0, .2, 1);
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  background-color: rgb(var(--em-rgb-background));
  position: relative;
}

@media (prefers-reduced-motion) {
  #root {
    --duration: 0;
    --duration-fast: 0;
    --duration-instant: 0;
  }
}

#root[data-menu] button {
  cursor: auto;
}

#root[data-menu] .menu button {
  cursor: pointer;
}

:host, #root, input, button {
  color: rgb(var(--em-rgb-color));
  font-family: var(--font-family);
  font-size: var(--font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: normal;
}

*, :before, :after {
  box-sizing: border-box;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-auto {
  flex: none;
}

.flex-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.flex-grow {
  flex: auto;
}

.flex-middle {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.padding {
  padding: var(--padding);
}

.padding-t {
  padding-top: var(--padding);
}

.padding-lr {
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.padding-r {
  padding-right: var(--padding);
}

.padding-small {
  padding: var(--padding-small);
}

.padding-small-b {
  padding-bottom: var(--padding-small);
}

.padding-small-lr {
  padding-left: var(--padding-small);
  padding-right: var(--padding-small);
}

.margin {
  margin: var(--padding);
}

.margin-r {
  margin-right: var(--padding);
}

.margin-l {
  margin-left: var(--padding);
}

.margin-small-l {
  margin-left: var(--padding-small);
}

.margin-small-lr {
  margin-left: var(--padding-small);
  margin-right: var(--padding-small);
}

.align-l {
  text-align: left;
}

.align-r {
  text-align: right;
}

.color-a {
  color: var(--color-a);
}

.color-b {
  color: var(--color-b);
}

.color-c {
  color: var(--color-c);
}

.ellipsis {
  white-space: nowrap;
  max-width: 100%;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sr-only {
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
}

a {
  cursor: pointer;
  color: rgb(var(--em-rgb-accent));
}

a:hover {
  text-decoration: underline;
}

.spacer {
  height: 10px;
}

[dir="rtl"] .scroll {
  padding-left: 0;
  padding-right: var(--padding);
}

.scroll {
  padding-right: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.scroll::-webkit-scrollbar {
  width: var(--sidebar-width);
  height: var(--sidebar-width);
}

.scroll::-webkit-scrollbar-track {
  border: 0;
}

.scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.scroll::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.scroll::-webkit-scrollbar-thumb {
  min-height: 20%;
  min-height: 65px;
  border: 4px solid rgb(var(--em-rgb-background));
  border-radius: 8px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--em-color-border-over) !important;
}

.scroll:hover::-webkit-scrollbar-thumb {
  background-color: var(--em-color-border);
}

.sticky {
  z-index: 1;
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-weight: 500;
  position: sticky;
  top: -1px;
}

[dir="rtl"] .search input[type="search"] {
  padding: 10px 2.2em 10px 2em;
}

[dir="rtl"] .search .loupe {
  left: auto;
  right: .7em;
}

[dir="rtl"] .search .delete {
  left: .7em;
  right: auto;
}

.search {
  z-index: 2;
  position: relative;
}

.search input, .search button {
  font-size: calc(var(--font-size)  - 1px);
}

.search input[type="search"] {
  width: 100%;
  background-color: var(--em-color-border);
  transition-duration: var(--duration);
  transition-property: background-color, box-shadow;
  transition-timing-function: var(--easing);
  border: 0;
  border-radius: 10px;
  outline: 0;
  padding: 10px 2em 10px 2.2em;
  display: block;
}

.search input[type="search"]::-ms-input-placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"]::placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"], .search input[type="search"]::-webkit-search-decoration, .search input[type="search"]::-webkit-search-cancel-button, .search input[type="search"]::-webkit-search-results-button, .search input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
}

.search input[type="search"]:focus {
  background-color: rgb(var(--em-rgb-input));
  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);
}

.search .icon {
  z-index: 1;
  color: rgba(var(--em-rgb-color), .7);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.search .loupe {
  pointer-events: none;
  left: .7em;
}

.search .delete {
  right: .7em;
}

svg {
  fill: currentColor;
  width: 1em;
  height: 1em;
}

button {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: pointer;
  color: currentColor;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}

#nav {
  z-index: 2;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: var(--sidebar-width);
  position: relative;
}

#nav button {
  color: var(--color-b);
  transition: color var(--duration) var(--easing);
}

#nav button:hover {
  color: var(--color-a);
}

#nav svg, #nav img {
  width: var(--category-icon-size);
  height: var(--category-icon-size);
}

#nav[dir="rtl"] .bar {
  left: auto;
  right: 0;
}

#nav .bar {
  width: 100%;
  height: 3px;
  background-color: rgb(var(--em-rgb-accent));
  transition: transform var(--duration) var(--easing);
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: -12px;
  left: 0;
}

#nav button[aria-selected] {
  color: rgb(var(--em-rgb-accent));
}

#preview {
  z-index: 2;
  padding: calc(var(--padding)  + 4px) var(--padding);
  padding-right: var(--sidebar-width);
  position: relative;
}

#preview .preview-placeholder {
  font-size: var(--preview-placeholder-size);
}

#preview .preview-title {
  font-size: var(--preview-title-size);
}

#preview .preview-subtitle {
  font-size: var(--preview-subtitle-size);
}

#nav:before, #preview:before {
  content: "";
  height: 2px;
  position: absolute;
  left: 0;
  right: 0;
}

#nav[data-position="top"]:before, #preview[data-position="top"]:before {
  background: linear-gradient(to bottom, var(--em-color-border), transparent);
  top: 100%;
}

#nav[data-position="bottom"]:before, #preview[data-position="bottom"]:before {
  background: linear-gradient(to top, var(--em-color-border), transparent);
  bottom: 100%;
}

.category:last-child {
  min-height: calc(100% + 1px);
}

.category button {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  position: relative;
}

.category button > * {
  position: relative;
}

.category button .background {
  opacity: 0;
  background-color: var(--em-color-border);
  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.category button:hover .background {
  transition-duration: var(--duration-instant);
  transition-delay: 0s;
}

.category button[aria-selected] .background {
  opacity: 1;
}

.category button[data-keyboard] .background {
  transition: none;
}

.row {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.skin-tone-button {
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 100%;
}

.skin-tone-button:hover {
  border-color: var(--em-color-border);
}

.skin-tone-button:active .skin-tone {
  transform: scale(.85) !important;
}

.skin-tone-button .skin-tone {
  transition: transform var(--duration) var(--easing);
}

.skin-tone-button[aria-selected] {
  background-color: var(--em-color-border);
  border-top-color: rgba(0, 0, 0, .05);
  border-bottom-color: rgba(0, 0, 0, 0);
  border-left-width: 0;
  border-right-width: 0;
}

.skin-tone-button[aria-selected] .skin-tone {
  transform: scale(.9);
}

.menu {
  z-index: 2;
  white-space: nowrap;
  border: 1px solid var(--em-color-border);
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition-property: opacity, transform;
  transition-duration: var(--duration);
  transition-timing-function: var(--easing);
  border-radius: 10px;
  padding: 4px;
  position: absolute;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);
}

.menu.hidden {
  opacity: 0;
}

.menu[data-position="bottom"] {
  transform-origin: 100% 100%;
}

.menu[data-position="bottom"].hidden {
  transform: scale(.9)rotate(-3deg)translateY(5%);
}

.menu[data-position="top"] {
  transform-origin: 100% 0;
}

.menu[data-position="top"].hidden {
  transform: scale(.9)rotate(3deg)translateY(-5%);
}

.menu input[type="radio"] {
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  border: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.menu input[type="radio"]:checked + .option {
  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));
}

.option {
  width: 100%;
  border-radius: 6px;
  padding: 4px 6px;
}

.option:hover {
  color: #fff;
  background-color: rgb(var(--em-rgb-accent));
}

.skin-tone {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.skin-tone:after {
  content: "";
  mix-blend-mode: overlay;
  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));
  border: 1px solid rgba(0, 0, 0, .8);
  border-radius: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;
}

.skin-tone-1 {
  background-color: #ffc93a;
}

.skin-tone-2 {
  background-color: #ffdab7;
}

.skin-tone-3 {
  background-color: #e7b98f;
}

.skin-tone-4 {
  background-color: #c88c61;
}

.skin-tone-5 {
  background-color: #a46134;
}

.skin-tone-6 {
  background-color: #5d4437;
}

[data-index] {
  justify-content: space-between;
}

[data-emoji-set="twitter"] .skin-tone:after {
  box-shadow: none;
  border-color: rgba(0, 0, 0, .5);
}

[data-emoji-set="twitter"] .skin-tone-1 {
  background-color: #fade72;
}

[data-emoji-set="twitter"] .skin-tone-2 {
  background-color: #f3dfd0;
}

[data-emoji-set="twitter"] .skin-tone-3 {
  background-color: #eed3a8;
}

[data-emoji-set="twitter"] .skin-tone-4 {
  background-color: #cfad8d;
}

[data-emoji-set="twitter"] .skin-tone-5 {
  background-color: #a8805d;
}

[data-emoji-set="twitter"] .skin-tone-6 {
  background-color: #765542;
}

[data-emoji-set="google"] .skin-tone:after {
  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);
}

[data-emoji-set="google"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="google"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="google"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="google"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="google"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="google"] .skin-tone-6 {
  background-color: #61493f;
}

[data-emoji-set="facebook"] .skin-tone:after {
  border-color: rgba(0, 0, 0, .4);
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;
}

[data-emoji-set="facebook"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="facebook"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="facebook"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="facebook"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="facebook"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="facebook"] .skin-tone-6 {
  background-color: #61493f;
}

`;
const tie = {
  name: "UnnnicEmojiPicker",
  props: {
    returnName: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: "top",
      validator: (e) => ["top", "bottom"].includes(e)
    }
  },
  emits: ["close", "emojiSelected"],
  computed: {
    emojiPickerPreferences() {
      return {
        data: yne,
        set: "apple",
        theme: "light",
        previewPosition: "none",
        searchPosition: "none",
        navPosition: "bottom",
        noResultsEmoji: "cry",
        maxFrequentRows: 3
      };
    }
  },
  mounted() {
    this.initPicker();
  },
  methods: {
    initPicker() {
      new No({
        i18n: fne,
        parent: this.$refs.pickerContainer,
        onEmojiSelect: this.onEmojiSelect,
        onClickOutside: () => this.$emit("close"),
        ...this.emojiPickerPreferences
      });
    },
    onEmojiSelect(e) {
      this.$emit("emojiSelected", this.returnName ? e.id : e.native);
    }
  }
};
function aie(e, i, n, a, r, o) {
  return f(), p("div", {
    ref: "pickerContainer",
    class: B(["emoji-picker", `emoji-picker--${n.position}`]),
    onClick: i[0] || (i[0] = Qe(() => {
    }, ["stop"])),
    onKeypress: i[1] || (i[1] = d2(Qe(() => {
    }, ["stop"]), ["enter"]))
  }, null, 34);
}
const sie = /* @__PURE__ */ k(tie, [["render", aie], ["__scopeId", "data-v-f00157f7"]]);
const oie = {
  name: "UnnnicChartFunnelThreeRows",
  props: {
    rows: {
      type: Array,
      required: !0
    },
    viewBox: {
      type: String,
      required: !0
    }
  }
}, rie = ["viewBox"], lie = ["d"], die = ["y"], cie = ["y"];
function fie(e, i, n, a, r, o) {
  return f(), p("svg", {
    class: "unnnic-chart-funnel-base-rows",
    viewBox: n.viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    (f(!0), p(se, null, me(n.rows, (l, c) => (f(), p("g", {
      key: l.title + c,
      class: "unnnic-chart-funnel-base-rows__row"
    }, [
      u("path", {
        class: "row__path",
        d: l.pathD
      }, null, 8, lie),
      u("text", {
        x: "50%",
        y: l.titleY,
        class: "row__title"
      }, T(l.title), 9, die),
      u("text", {
        x: "50%",
        y: l.descriptionY,
        class: "row__description"
      }, T(l.description), 9, cie)
    ]))), 128))
  ], 8, rie);
}
const Eo = /* @__PURE__ */ k(oie, [["render", fie], ["__scopeId", "data-v-d2b9da67"]]);
const uie = {
  name: "UnnnicChartFunnelThreeRows",
  components: {
    ChartFunnelBaseRow: Eo
  },
  props: {
    data: {
      type: Array,
      required: !0
    }
  },
  computed: {
    rows() {
      const { data: e } = this;
      return [
        {
          pathD: "M362.938 0H12.025C6.30976 0 2.43799 5.81972 4.64626 11.0911L31 74H343.75L370.307 11.1122C372.535 5.83818 368.663 0 362.938 0Z",
          titleX: "50%",
          titleY: "32",
          descriptionX: "50%",
          descriptionY: "52",
          title: e[0].title,
          description: e[0].description
        },
        {
          pathD: "M344 74H31L63.4654 148H311.535L344 74Z",
          titleX: "50%",
          titleY: "106",
          descriptionX: "50%",
          descriptionY: "126",
          title: e[1].title,
          description: e[1].description
        },
        {
          pathD: "M311.5 148H63.5L93.8569 217.213C95.1325 220.122 98.0075 222 101.183 222H275.372C278.603 222 281.517 220.056 282.758 217.073L311.5 148Z",
          titleX: "50%",
          titleY: "180",
          descriptionX: "50%",
          descriptionY: "200",
          title: e[2].title,
          description: e[2].description
        }
      ];
    }
  }
};
function hie(e, i, n, a, r, o) {
  const l = j("ChartFunnelBaseRow");
  return f(), $(l, {
    class: "unnnic-chart-funnel-three-rows",
    rows: o.rows,
    viewBox: "0 0 375 222"
  }, null, 8, ["rows"]);
}
const mie = /* @__PURE__ */ k(uie, [["render", hie]]);
const pie = {
  name: "UnnnicChartFunnelFourRows",
  components: {
    ChartFunnelBaseRow: Eo
  },
  props: {
    data: {
      type: Array,
      required: !0
    }
  },
  computed: {
    rows() {
      const { data: e } = this;
      return [
        {
          pathD: "M356.374 0H8.57255C2.47804 0 -1.37827 6.54249 1.5734 11.8745L26 56H338.75L363.36 11.8984C366.336 6.56589 362.481 0 356.374 0Z",
          titleX: "50%",
          titleY: "23",
          descriptionX: "50%",
          descriptionY: "43",
          title: e[0].title,
          description: e[0].description
        },
        {
          pathD: "M339 56H26L58.4654 112H306.535L339 56Z",
          titleX: "50%",
          titleY: "78",
          descriptionX: "50%",
          descriptionY: "98",
          title: e[1].title,
          description: e[1].description
        },
        {
          pathD: "M306.5 112H58.5L90.9564 168H275.708L306.5 112Z",
          titleX: "50%",
          titleY: "136",
          descriptionX: "50%",
          descriptionY: "156",
          title: e[2].title,
          description: e[2].description
        },
        {
          pathD: "M276 168H91L120.697 219.969C122.121 222.462 124.772 224 127.643 224H239.357C242.228 224 244.879 222.462 246.303 219.969L276 168Z",
          titleX: "50%",
          titleY: "190",
          descriptionX: "50%",
          descriptionY: "210",
          title: e[3].title,
          description: e[3].description
        }
      ];
    }
  }
};
function yie(e, i, n, a, r, o) {
  const l = j("ChartFunnelBaseRow");
  return f(), $(l, {
    class: "unnnic-chart-funnel-four-rows",
    rows: o.rows,
    viewBox: "0 0 365 224"
  }, null, 8, ["rows"]);
}
const vie = /* @__PURE__ */ k(pie, [["render", yie]]);
const gie = {
  name: "UnnnicChartFunnelFiveRows",
  components: {
    ChartFunnelBaseRow: Eo
  },
  props: {
    data: {
      type: Array,
      required: !0
    }
  },
  computed: {
    rows() {
      const { data: e } = this;
      return [
        {
          pathD: "M352.506 0H8.42251C1.93921 0 -1.85142 7.30766 1.88266 12.6076L24 44H336.75L359.028 12.6324C362.79 7.33528 359.003 0 352.506 0Z",
          titleX: "50%",
          titleY: "20",
          descriptionX: "50%",
          descriptionY: "38",
          title: e[0].title,
          description: e[0].description
        },
        {
          pathD: "M337 44H24L56.4654 88H304.535L337 44Z",
          titleX: "50%",
          titleY: "62",
          descriptionX: "50%",
          descriptionY: "80",
          title: e[1].title,
          description: e[1].description
        },
        {
          pathD: "M304.5 88H56.5L88.9564 132H273.708L304.5 88Z",
          titleX: "50%",
          titleY: "106",
          descriptionX: "50%",
          descriptionY: "124",
          title: e[2].title,
          description: e[2].description
        },
        {
          pathD: "M274 132H89L121 176H242L274 132Z",
          titleX: "50%",
          titleY: "150",
          descriptionX: "50%",
          descriptionY: "168",
          title: e[3].title,
          description: e[3].description
        },
        {
          pathD: "M242 176H120.957L130.481 213.947C131.374 217.505 134.573 220 138.241 220H223.89C227.498 220 230.659 217.585 231.608 214.105L242 176Z",
          titleX: "50%",
          titleY: "194",
          descriptionX: "50%",
          descriptionY: "212",
          title: e[4].title,
          description: e[4].description
        }
      ];
    }
  }
};
function _ie(e, i, n, a, r, o) {
  const l = j("ChartFunnelBaseRow");
  return f(), $(l, {
    class: "unnnic-chart-funnel-five-rows",
    rows: o.rows,
    viewBox: "0 0 361 220"
  }, null, 8, ["rows"]);
}
const wie = /* @__PURE__ */ k(gie, [["render", _ie]]), Cie = { class: "unnnic-chart-funnel-base-container" }, kie = { class: "unnnic-chart-funnel-base-item__text__values" }, xie = { class: "unnnic-chart-funnel-base-item__text__values-title" }, bie = { class: "unnnic-chart-funnel-base-item__text__values-sub-title" }, Mie = { class: "unnnic-chart-funnel-base-item__text-description" }, Die = /* @__PURE__ */ g0({
  __name: "ChartDefaultFunnelBase",
  props: {
    data: {}
  },
  setup(e) {
    return (i, n) => (f(), p("section", Cie, [
      (f(!0), p(se, null, me(i.data, (a, r) => (f(), p("section", {
        key: r,
        class: "unnnic-chart-funnel-base-item"
      }, [
        u("section", {
          class: B([
            "overflow-hidden",
            a.widthClass,
            { "first-item": r === 0, "last-item": r === i.data.length - 1 }
          ])
        }, [
          u("section", {
            class: B([
              "unnnic-chart-funnel-base-item__card",
              { "first-item": r === 0 }
            ]),
            style: Ze({ backgroundColor: a.color })
          }, null, 6)
        ], 2),
        u("section", {
          class: B([
            "unnnic-chart-funnel-base-item__text",
            { "last-item": r === i.data.length - 1 }
          ])
        }, [
          u("section", kie, [
            u("p", xie, T(a.percentage), 1),
            u("p", bie, "   | " + T(a.value), 1)
          ]),
          u("p", Mie, T(a.description), 1)
        ], 2)
      ]))), 128))
    ]));
  }
});
const Ga = /* @__PURE__ */ k(Die, [["__scopeId", "data-v-c55591f1"]]), Aie = {
  name: "UnnnicChartFunnel",
  components: {
    ChartFunnelThreeRows: mie,
    ChartFunnelFourRows: vie,
    ChartFunnelFiveRows: wie,
    ChartDefaultFunnelBase: Ga
  },
  props: {
    data: {
      type: Array,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    }
  },
  computed: {
    chartComponent() {
      return {
        default: {
          3: Ga,
          4: Ga,
          5: Ga
        },
        basic: {
          3: "ChartFunnelThreeRows",
          4: "ChartFunnelFourRows",
          5: "ChartFunnelFiveRows"
        }
      }[this.type][this.data.length] || null;
    },
    chartData() {
      const e = ["w-60", "w-50", "w-40", "w-30", "w-20"];
      return this.type === "default" ? this.data.map((i, n) => ({
        percentage: i.title,
        value: i.value,
        description: i.description,
        widthClass: e[n],
        color: i.color
      })) : this.data;
    }
  }
};
function Lie(e, i, n, a, r, o) {
  return f(), $(oi(o.chartComponent), { data: o.chartData }, null, 8, ["data"]);
}
const Tie = /* @__PURE__ */ k(Aie, [["render", Lie]]), Sie = [
  "app-window-edit-1",
  "app-window-edit-2",
  "headphones-customer-support-2",
  "building-2-1",
  "expand-8-1",
  "flash-1-4",
  "phone-charger-1",
  "checkbox-disable",
  "headphones-customer-support-1",
  "arrow-button-down-1",
  "vip-crown-queen-2",
  "read-email-at-1",
  "flash-1-3",
  "time-clock-circle-1",
  "search-1",
  "single-neutral-2",
  "messaging-we-chat-3",
  "upload-bottom-1",
  "checkbox-select",
  "radio-default",
  "view-1-1",
  "photography-equipment-bag-1",
  "messaging-we-chat-2",
  "button-refresh-arrow-1",
  "information-circle-4",
  "science-fiction-robot-2",
  "cog-2",
  "check-square-2",
  "indicator",
  "close-1",
  "translate-2",
  "radio-selected",
  "science-fiction-robot-1",
  "cog-1",
  "check-square-1",
  "translate-1",
  "phone-3",
  "button-refresh-arrows-1",
  "chat-translate-1",
  "charger-1",
  "phone-4",
  "expand-full-1",
  "graph-stats-1",
  "check-circle-1-1",
  "messages-bubble-4",
  "hierarchy-3-3",
  "radio-disable",
  "view-off-1",
  "hierarchy-3-2",
  "single-neutral-actions-1",
  "checkbox-less",
  "arrow-right-1-1",
  "task-list-clock-1",
  "arrow-button-up-1",
  "house-1-1",
  "download-bottom-1",
  "loading-circle-1",
  "layout-dashboard-1",
  "messages-bubble-3",
  "alert-circle-1-1",
  "messages-bubble-1",
  "switch-default",
  "developer-community-github-1-1",
  "lock-2-1",
  "pencil-write-1",
  "book-address-1-2",
  "delete-1",
  "arrow-left-1-1",
  "add-1",
  "checkbox-default",
  "layout-dashboard-2",
  "download-thick-bottom-1",
  "gauge-dashboard-1",
  "logout-1-1",
  "gauge-dashboard-2",
  "switch-selected",
  "social-media-google-1",
  "social-media-facebook-1",
  "social-instagram-1",
  "alarm-bell-2",
  "check-circle-1-1-1",
  "alarm-bell-3",
  "alert-circle-1",
  "book-address-2",
  "graph-stats-ascend-2",
  "synchronize-arrow-clock-5",
  "keyboard-arrow-down-1",
  "keyboard-arrow-left-1",
  "email-action-unread-1",
  "synchronize-arrow-clock-4",
  "house-2-2",
  "copy-paste-1",
  "typing-1",
  "drag",
  "lock-unlock-1-1",
  "rating-star-1",
  "send-email-3-1",
  "switch-default-disabled",
  "switch-selected-disabled",
  "paginate-filter-text-1",
  "bin-1-1",
  "floppy-disk-1",
  "messaging-whatsapp-1",
  "export-1",
  "book-library-1",
  "book-library-2"
], Nie = [
  "background-solo",
  "background-sky",
  "background-grass",
  "background-carpet",
  "background-snow",
  "background-lightest",
  "background-white",
  "neutral-black",
  "neutral-darkest",
  "neutral-dark",
  "neutral-cloudy",
  "neutral-cleanest",
  "neutral-clean",
  "neutral-soft",
  "neutral-lightest",
  "neutral-light",
  "neutral-white",
  "neutral-snow",
  "feedback-red",
  "feedback-green",
  "feedback-yellow",
  "feedback-blue",
  "feedback-grey",
  "aux-blue",
  "aux-purple",
  "aux-orange",
  "aux-lemon",
  "aux-pink",
  "aux-baby-blue",
  "aux-baby-yellow",
  "aux-baby-red",
  "aux-baby-green",
  "aux-baby-pink",
  "aux-green-100",
  "aux-green-300",
  "aux-green-500",
  "aux-green-700",
  "aux-green-900",
  "aux-blue-100",
  "aux-blue-300",
  "aux-blue-500",
  "aux-blue-700",
  "aux-blue-900",
  "aux-purple-100",
  "aux-purple-300",
  "aux-purple-500",
  "aux-purple-700",
  "aux-purple-900",
  "aux-red-100",
  "aux-red-300",
  "aux-red-500",
  "aux-red-700",
  "aux-red-900",
  "aux-orange-100",
  "aux-orange-300",
  "aux-orange-500",
  "aux-orange-700",
  "aux-orange-900",
  "aux-yellow-100",
  "aux-yellow-300",
  "aux-yellow-500",
  "aux-yellow-700",
  "aux-yellow-900",
  "floweditor-blue",
  "floweditor-purple",
  "floweditor-wine",
  "floweditor-orange",
  "floweditor-pink",
  "floweditor-turquoise",
  "floweditor-green",
  "weni-50",
  "weni-100",
  "weni-200",
  "weni-300",
  "weni-400",
  "weni-500",
  "weni-600",
  "weni-700",
  "weni-800",
  "weni-900",
  "weni-950",
  "brand-weni",
  "brand-weni-dark",
  "brand-weni-soft",
  "brand-sec-dark",
  "brand-sec-soft",
  "brand-sec"
];
const Eie = {
  name: "UnnnicDisclaimer",
  components: { unnnicIcon: ce },
  props: {
    text: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      default: "alert-circle-1-1",
      validator(e) {
        return Sie.includes(e);
      }
    },
    iconColor: {
      type: String,
      default: "neutral-darkest",
      validator(e) {
        return Nie.includes(e);
      }
    }
  }
}, zie = { class: "unnnic-disclaimer" }, Iie = ["innerHTML"];
function Bie(e, i, n, a, r, o) {
  const l = j("UnnnicIcon");
  return f(), p("section", zie, [
    Z(l, {
      class: "unnnic-disclaimer__icon",
      size: "avatar-nano",
      icon: n.icon,
      scheme: n.iconColor,
      "data-testid": "disclaimer-icon"
    }, null, 8, ["icon", "scheme"]),
    u("p", {
      class: "unnnic-disclaimer__text",
      "data-testid": "disclaimer-text",
      innerHTML: n.text
    }, null, 8, Iie)
  ]);
}
const Oie = /* @__PURE__ */ k(Eie, [["render", Bie], ["__scopeId", "data-v-2be02645"]]);
const Hie = {
  name: "UnnnicDrawer",
  components: {
    UnnnicIcon: ce,
    UnnnicButton: Wn
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    disabledPrimaryButton: {
      type: Boolean,
      default: !1
    },
    disabledSecondaryButton: {
      type: Boolean,
      default: !1
    },
    loadingPrimaryButton: {
      type: Boolean,
      default: !1
    },
    loadingSecondaryButton: {
      type: Boolean,
      default: !1
    },
    primaryButtonText: {
      type: String,
      default: ""
    },
    primaryButtonType: {
      type: String,
      default: "primary"
    },
    secondaryButtonText: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md",
      validator(e) {
        return ["md", "lg", "xl", "gt"].includes(e);
      }
    },
    wide: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: Boolean,
      required: !0
    },
    withoutOverlay: {
      type: Boolean,
      default: !1
    },
    closeIcon: {
      type: String,
      default: "arrow_back"
    },
    distinctCloseBack: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["primaryButtonClick", "secondaryButtonClick", "close", "back"],
  data() {
    return {
      showDrawer: !0
    };
  },
  computed: {
    showFooter() {
      return !!(this.primaryButtonText || this.secondaryButtonText);
    }
  },
  methods: {
    transitionClose(e) {
      this.showDrawer = !1, setTimeout(() => {
        e == null || e(), this.showDrawer = !0;
      }, 200);
    },
    close() {
      this.transitionClose(() => this.$emit("close"));
    },
    back() {
      this.distinctCloseBack ? this.transitionClose(() => this.$emit("back")) : this.close();
    }
  }
}, jie = {
  key: 0,
  class: "unnnic-drawer",
  "data-testid": "drawer"
}, Vie = { class: "unnnic-drawer__header" }, Fie = { class: "unnnic-drawer__title-container" }, Pie = {
  class: "unnnic-drawer__title",
  "data-testid": "drawer-title"
}, Uie = {
  key: 0,
  class: "unnnic-drawer__description",
  "data-testid": "drawer-description"
}, Rie = { class: "unnnic-drawer__content" }, Yie = {
  key: 0,
  class: "unnnic-drawer__footer",
  "data-testid": "footer"
};
function Zie(e, i, n, a, r, o) {
  const l = j("UnnnicIcon"), c = j("UnnnicButton");
  return n.modelValue ? (f(), p("aside", jie, [
    n.withoutOverlay ? N("", !0) : (f(), p("section", {
      key: 0,
      class: "unnnic-drawer__overlay",
      "data-testid": "overlay",
      onClick: i[0] || (i[0] = Qe((...h) => o.close && o.close(...h), ["stop"]))
    })),
    Z(R3, {
      appear: "",
      name: "drawer"
    }, {
      default: Ee(() => [
        r.showDrawer ? (f(), p("section", {
          key: 0,
          "data-testid": "drawer-container",
          class: B([
            "unnnic-drawer__container",
            `unnnic-drawer__container--${n.size}`
          ])
        }, [
          u("header", Vie, [
            u("section", Fie, [
              e.$slots.title ? pe(e.$slots, "title", { key: 0 }, void 0, !0) : (f(), p(se, { key: 1 }, [
                u("h1", Pie, T(n.title), 1),
                n.description ? (f(), p("p", Uie, T(n.description), 1)) : N("", !0)
              ], 64))
            ]),
            Z(l, {
              class: "unnnic-drawer__close",
              "data-testid": "close-icon",
              icon: n.closeIcon,
              size: "avatar-nano",
              clickable: "",
              onClick: o.back
            }, null, 8, ["icon", "onClick"])
          ]),
          u("section", Rie, [
            pe(e.$slots, "content", {}, void 0, !0)
          ]),
          o.showFooter ? (f(), p("footer", Yie, [
            n.secondaryButtonText ? (f(), $(c, {
              key: 0,
              "data-testid": "secondary-button",
              size: "large",
              type: "tertiary",
              disabled: n.disabledSecondaryButton,
              loading: n.loadingSecondaryButton,
              text: n.secondaryButtonText,
              onClick: i[1] || (i[1] = (h) => e.$emit("secondaryButtonClick"))
            }, null, 8, ["disabled", "loading", "text"])) : N("", !0),
            n.primaryButtonText ? (f(), $(c, {
              key: 1,
              "data-testid": "primary-button",
              size: "large",
              disabled: n.disabledPrimaryButton,
              loading: n.loadingPrimaryButton,
              type: n.primaryButtonType,
              text: n.primaryButtonText,
              onClick: i[2] || (i[2] = (h) => e.$emit("primaryButtonClick"))
            }, null, 8, ["disabled", "loading", "type", "text"])) : N("", !0)
          ])) : N("", !0)
        ], 2)) : N("", !0)
      ]),
      _: 3
    })
  ])) : N("", !0);
}
const Wie = /* @__PURE__ */ k(Hie, [["render", Zie], ["__scopeId", "data-v-0871e185"]]), Qie = (e) => {
  if (typeof e.content != "string")
    throw new Error('Each item in "headers" must have "content" as a string.');
  if ("size" in e && (e.size !== "auto" && typeof e.size != "number" || e.size < 0))
    throw new Error(
      'Each item in "headers" that contains "size" must assign it as positive number or equals to "auto"'
    );
  if ("isSortable" in e && typeof e.isSortable != "boolean")
    throw new Error(
      'Each item in "headers" that contains “isSortable” must assign it as boolean'
    );
}, qie = (e) => {
  if (!Array.isArray(e))
    throw new Error("Property headers needs to be an array.");
  return e.forEach(Qie), !0;
}, Gie = (e) => {
  if (!("content" in e) || !Array.isArray(e.content))
    throw new Error('Each item in "rows" must have "content" as an array.');
  if ("link" in e && typeof e.link != "object" && typeof e.link < "u")
    throw new Error(
      'Each item in "rows" that contains “link” must assign it as object'
    );
  if (e.link && !("url" in e.link))
    throw new Error('Each item in "rows" with "link" must contain "url".');
}, Xie = (e) => {
  if (!Array.isArray(e))
    throw new Error("Property rows needs to be an array.");
  return e.forEach(Gie), !0;
};
const Jie = {
  name: "TableBodyCell",
  props: {
    cell: {
      type: [String, Object],
      default: ""
    }
  },
  methods: {
    getIsComponent(e) {
      return typeof e == "object";
    }
  }
}, Kie = { class: "unnnic-table-next__body-cell" }, $ie = {
  key: 1,
  class: "unnnic-table-next__body-cell-text",
  "data-testid": "body-cell-text"
};
function ete(e, i, n, a, r, o) {
  return f(), p("td", Kie, [
    o.getIsComponent(n.cell) ? (f(), $(oi(n.cell.component), Q1({ key: 0 }, n.cell.props, sp(n.cell.events)), null, 16)) : (f(), p("p", $ie, T(n.cell), 1))
  ]);
}
const nte = /* @__PURE__ */ k(Jie, [["render", ete], ["__scopeId", "data-v-530f93dd"]]);
const ite = {
  name: "TablePagination",
  components: {
    Pagination: Bc
  },
  mixins: [yn],
  props: {
    modelValue: {
      type: Number,
      required: !0
    },
    total: {
      type: Number,
      required: !1,
      default: 0
    },
    interval: {
      type: Number,
      required: !0
    }
  },
  emits: ["update:model-value"],
  data() {
    return {
      defaultTranslations: {
        pagination: {
          "pt-br": "{from} - {to} de {total}",
          en: "{from} - {to} of {total}",
          es: "{from} - {to} de {total}"
        }
      }
    };
  },
  computed: {
    tablePagination() {
      const { modelValue: e, interval: i, total: n } = this;
      return this.i18n("pagination", {
        from: n === 0 ? 0 : (e - 1) * i + 1,
        to: Math.min(e * i, n),
        total: n
      });
    },
    pages() {
      return Math.ceil(this.total / this.interval);
    }
  }
}, tte = { class: "table-pagination" }, ate = {
  class: "table-pagination__count",
  "data-testid": "count"
};
function ste(e, i, n, a, r, o) {
  const l = j("Pagination");
  return f(), p("section", tte, [
    u("p", ate, T(o.tablePagination), 1),
    Z(l, {
      modelValue: n.modelValue,
      max: o.pages,
      show: 5,
      "onUpdate:modelValue": i[0] || (i[0] = (c) => e.$emit("update:model-value", c))
    }, null, 8, ["modelValue", "max"])
  ]);
}
const ote = /* @__PURE__ */ k(ite, [["render", ste], ["__scopeId", "data-v-8f40f70d"]]), rte = {}, lte = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, dte = /* @__PURE__ */ u("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.52329 7.62271C6.49402 7.70173 6.47939 7.77475 6.47939 7.84175C6.47939 8.01402 6.53572 8.16813 6.64838 8.30407C6.7609 8.44001 6.92389 8.50798 7.13734 8.50798L12.8628 8.50798C13.0762 8.50798 13.2392 8.44001 13.3517 8.30407C13.4644 8.16813 13.5207 8.01402 13.5207 7.84175C13.5207 7.77475 13.5061 7.70173 13.4768 7.62271C13.4477 7.54355 13.4012 7.46936 13.3374 7.40015L10.5064 4.20619C10.4407 4.13255 10.3648 4.07978 10.2788 4.04787C10.1928 4.01596 10.0999 4 10 4C9.90023 4 9.80731 4.01596 9.72129 4.04787C9.63528 4.07978 9.55941 4.13255 9.49369 4.20619L6.66267 7.40015C6.59888 7.46936 6.55242 7.54355 6.52329 7.62271ZM13.4767 12.3773C13.506 12.2983 13.5206 12.2253 13.5206 12.1583C13.5206 11.986 13.4643 11.8319 13.3516 11.6959C13.2391 11.56 13.0761 11.492 12.8627 11.492H7.13726C6.92381 11.492 6.76082 11.56 6.6483 11.6959C6.53564 11.8319 6.47931 11.986 6.47931 12.1583C6.47931 12.2253 6.49394 12.2983 6.52321 12.3773C6.55235 12.4565 6.5988 12.5306 6.66259 12.5998L9.49362 15.7938C9.55933 15.8674 9.6352 15.9202 9.72122 15.9521C9.80723 15.984 9.90015 16 9.99997 16C10.0998 16 10.1927 15.984 10.2787 15.9521C10.3647 15.9202 10.4406 15.8674 10.5063 15.7938L13.3373 12.5999C13.4011 12.5306 13.4476 12.4565 13.4767 12.3773Z",
  fill: "#D0D3D9"
}, null, -1), cte = [
  dte
];
function fte(e, i) {
  return f(), p("svg", lte, cte);
}
const ute = /* @__PURE__ */ k(rte, [["render", fte]]), hte = "data:image/svg+xml;base64,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";
const mte = {
  name: "UnnnicTableNext",
  components: {
    TableBodyCell: nte,
    TablePagination: ote,
    Icon: ce,
    IconArrowsDefault: ute
  },
  mixins: [yn],
  props: {
    /**
     * @typedef {Array} HeaderItem
     * @property {string} content - The content of the header cell.
     * @property {number|string} size - The size of the header cell, either as a fraction (number) or 'auto'.
     * @property {boolean|undefined} isSortable - Indicates if the cell is enabled for sorting.
     */
    /**
     * Array of header items.
     * @type {HeaderItem[]}
     */
    headers: {
      type: Array,
      default: () => [],
      validator: qie
    },
    /**
     * @typedef {Array} RowItem
     * @property {Array} content - The content of the row cell.
     * @property {object|undefined} link - Link object to redirect the row cell.
     */
    /**
     * Array of row items.
     * @type {RowItem[]}
     */
    rows: {
      type: Array,
      default: () => [],
      validator: Xie
    },
    size: {
      type: String,
      default: "sm",
      validator: (e) => ["md", "sm"].includes(e)
    },
    hideHeaders: {
      type: Boolean,
      default: !1
    },
    pagination: {
      type: Number,
      default: 1
    },
    paginationTotal: {
      type: Number,
      default: 1
    },
    paginationInterval: {
      type: Number,
      default: 1
    },
    isLoading: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:pagination", "row-click", "sort"],
  data() {
    return {
      defaultTranslations: {
        without_results: {
          "pt-br": "Nenhum resultado correspondente",
          en: "No matching results",
          es: "No hay resultados coincidentes"
        }
      },
      sort: { header: "", order: "" }
    };
  },
  computed: {
    treatedPaginationTotal() {
      return this.rows.length === 0 ? 0 : this.paginationTotal;
    },
    gridTemplateColumns() {
      const e = "1fr", i = (a) => typeof a.size == "number" ? `${a.size || 1}fr` : a.size || e;
      return (this.headers.length ? this.headers.map(i) : this.rows[0].content.map(() => e)).join(" ");
    },
    shouldHideHeaders() {
      return this.hideHeaders || !this.headers.length;
    }
  },
  methods: {
    handleClickHeader(e) {
      if (!e.isSortable)
        return;
      const i = {
        asc: "desc",
        desc: "asc",
        "": "asc"
      }, n = e.content !== this.sort.header ? "asc" : i[this.sort.order];
      this.handleSort(n === "" ? "" : e.content, n);
    },
    handleSort(e, i) {
      this.sort = { header: e, order: i }, this.$emit("sort", this.sort);
    }
  }
}, pte = (e) => (hn("data-v-a19b4e95"), e = e(), mn(), e), yte = { class: "unnnic-table-next" }, vte = {
  key: 0,
  class: "unnnic-table-next__header",
  "data-testid": "header"
}, gte = ["onClick"], _te = {
  key: 0,
  class: "unnnic-table-next__body-row"
}, wte = /* @__PURE__ */ pte(() => /* @__PURE__ */ u("img", {
  class: "unnnic-table-next__body-cell--loading",
  "data-testid": "body-row-loading",
  src: hte,
  height: "40"
}, null, -1)), Cte = [
  wte
], kte = ["onClick"], xte = ["href", "target"], bte = {
  key: 2,
  class: "unnnic-table-next__body-row"
}, Mte = {
  class: "unnnic-table-next__body-cell-text",
  "data-testid": "body-cell-text"
};
function Dte(e, i, n, a, r, o) {
  const l = j("IconArrowsDefault"), c = j("Icon"), h = j("TableBodyCell"), y = j("TablePagination");
  return f(), p("table", yte, [
    o.shouldHideHeaders ? N("", !0) : (f(), p("thead", vte, [
      u("tr", {
        class: "unnnic-table-next__header-row",
        "data-testid": "header-row",
        style: Ze({ gridTemplateColumns: o.gridTemplateColumns })
      }, [
        (f(!0), p(se, null, me(n.headers, (v, x) => (f(), p("th", {
          key: v.content + x,
          class: B({
            "unnnic-table-next__header-cell": !0,
            "unnnic-table-next__header-cell--clickable": v.isSortable,
            "unnnic-table-next__header-cell--sorting": r.sort.header === v.content && r.sort.order !== ""
          }),
          "data-testid": "header-cell",
          onClick: Qe((C) => o.handleClickHeader(v), ["stop"])
        }, [
          p1(T(v.content) + " ", 1),
          v.isSortable ? (f(), p(se, { key: 0 }, [
            r.sort.header !== v.content ? (f(), $(l, {
              key: 0,
              class: "order-default-icon",
              "data-testid": "arrow-default-icon"
            })) : r.sort.order === "asc" ? (f(), $(c, {
              key: 1,
              clickable: "",
              size: "ant",
              icon: "switch_left",
              style: { transform: "rotate(-90deg)" },
              "data-testid": "arrow-asc-icon"
            })) : r.sort.order === "desc" ? (f(), $(c, {
              key: 2,
              clickable: "",
              size: "ant",
              icon: "switch_left",
              style: { transform: "rotate(90deg)" },
              "data-testid": "arrow-desc-icon"
            })) : N("", !0)
          ], 64)) : N("", !0)
        ], 10, gte))), 128))
      ], 4)
    ])),
    u("tbody", {
      class: B({
        "unnnic-table-next__body": !0,
        "unnnic-table-next__body--hide-headers": o.shouldHideHeaders
      }),
      "data-testid": "body"
    }, [
      n.isLoading ? (f(), p("tr", _te, Cte)) : n.rows.length ? (f(!0), p(se, { key: 1 }, me(n.rows, (v, x) => (f(), p("tr", {
        key: v.content + x,
        class: "unnnic-table-next__body-row",
        "data-testid": "body-row",
        style: Ze({
          gridTemplateColumns: v.link ? "auto" : o.gridTemplateColumns
        }),
        onClick: (C) => e.$emit("row-click", v)
      }, [
        v.link ? (f(), p("a", {
          key: 0,
          class: "unnnic-table-next__body-row--redirect",
          "data-testid": "body-row-redirect",
          style: Ze({ gridTemplateColumns: o.gridTemplateColumns }),
          href: v.link.url,
          target: v.link.target || "_blank"
        }, [
          (f(!0), p(se, null, me(v.content, (C) => (f(), $(h, {
            key: C + x,
            class: B([
              "unnnic-table-next__body-cell",
              `unnnic-table-next__body-cell--${n.size}`
            ]),
            "data-testid": "body-cell",
            cell: C
          }, null, 8, ["class", "cell"]))), 128))
        ], 12, xte)) : (f(!0), p(se, { key: 1 }, me(v.content, (C) => (f(), $(h, {
          key: C + x,
          class: B([
            "unnnic-table-next__body-cell",
            `unnnic-table-next__body-cell--${n.size}`
          ]),
          "data-testid": "body-cell",
          cell: C
        }, null, 8, ["class", "cell"]))), 128))
      ], 12, kte))), 128)) : (f(), p("tr", bte, [
        u("td", {
          class: B([
            "unnnic-table-next__body-cell",
            `unnnic-table-next__body-cell--${n.size}`
          ]),
          "data-testid": "body-cell"
        }, [
          u("p", Mte, T(e.i18n("without_results")), 1)
        ], 2)
      ]))
    ], 2),
    Z(y, {
      modelValue: n.pagination,
      total: o.treatedPaginationTotal,
      interval: n.paginationInterval,
      "onUpdate:modelValue": i[0] || (i[0] = (v) => e.$emit("update:pagination", v))
    }, null, 8, ["modelValue", "total", "interval"])
  ]);
}
const Ate = /* @__PURE__ */ k(mte, [["render", Dte], ["__scopeId", "data-v-a19b4e95"]]);
const Lte = {
  name: "UnnnicModalNext",
  components: {
    UnnnicIcon: ce,
    UnnnicInput: _0,
    UnnnicButton: Wn
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    url: String,
    icon: String,
    scheme: String,
    title: String,
    description: String,
    validate: String,
    validatePlaceholder: String,
    validateLabel: String,
    actionPrimaryLabel: String,
    actionPrimaryLoading: Boolean,
    actionPrimaryButtonType: {
      type: String,
      default: "primary"
    },
    actionSecondaryLabel: String,
    showCloseButton: Boolean
  },
  emits: ["close"],
  data() {
    return {
      confirmText: ""
    };
  },
  computed: {
    isPersistent() {
      var e;
      return (e = this.data) == null ? void 0 : e.persistent;
    },
    buttonType() {
      return this.disabled ? "" : this.scheme === "feedback-red" ? "danger" : this.scheme === "feedback-yellow" ? "alert" : "";
    },
    disabled() {
      return this.validate ? this.confirmText !== this.validate : !1;
    }
  },
  methods: {
    closeByDarkBackground() {
      this.$emit("close");
    },
    close() {
      var e;
      this.justClose(), (e = this.data) != null && e.onClose && this.data.onClose();
    },
    justClose() {
    }
  }
}, Tte = { class: "container" }, Ste = {
  key: 0,
  class: "header"
}, Nte = { class: "content" }, Ete = {
  key: 1,
  class: "content"
}, zte = { class: "aspect-ratio-box" }, Ite = ["src"], Bte = {
  key: 0,
  class: "header"
}, Ote = {
  key: 0,
  class: "icon"
}, Hte = {
  key: 1,
  class: "title"
}, jte = {
  key: 2,
  class: "description"
}, Vte = {
  key: 3,
  class: "confirm-text"
}, Fte = ["innerHTML"];
function Pte(e, i, n, a, r, o) {
  var y, v, x, C, M, z, R, U;
  const l = j("UnnnicIcon"), c = j("UnnnicInput"), h = j("UnnnicButton");
  return f(), p("div", {
    class: B([
      "unnnic-modal",
      `type-${n.type}`,
      {
        "show-close-button": n.showCloseButton,
        "show-actions-area": n.validate || n.actionPrimaryLabel || n.actionSecondaryLabel
      }
    ]),
    onClick: i[5] || (i[5] = Qe((...G) => o.closeByDarkBackground && o.closeByDarkBackground(...G), ["self"]))
  }, [
    u("div", Tte, [
      n.type === "default" ? (f(), p(se, { key: 0 }, [
        n.showCloseButton ? (f(), p("div", Ste, [
          Z(l, {
            icon: "close-1",
            size: "sm",
            clickable: "",
            onClick: i[0] || (i[0] = (G) => e.$emit("close"))
          })
        ])) : N("", !0),
        u("div", Nte, [
          pe(e.$slots, "default", {}, void 0, !0)
        ])
      ], 64)) : n.type === "video" ? (f(), p("div", Ete, [
        u("div", zte, [
          u("iframe", {
            class: "aspect-ratio-box-inside",
            type: "text/html",
            src: n.url,
            frameborder: "0",
            allowfullscreen: ""
          }, null, 8, Ite)
        ])
      ])) : n.type === "alert" ? (f(), p(se, { key: 2 }, [
        n.showCloseButton ? (f(), p("div", Bte, [
          Z(l, {
            icon: "close-1",
            size: "sm",
            clickable: "",
            onClick: i[1] || (i[1] = (G) => e.$emit("close"))
          })
        ])) : N("", !0),
        u("div", {
          class: B(["content", { "with-validation": n.validate }])
        }, [
          n.icon ? (f(), p("div", Ote, [
            Z(l, {
              icon: n.icon,
              scheme: n.scheme,
              size: "xl"
            }, null, 8, ["icon", "scheme"])
          ])) : N("", !0),
          (v = (y = e.$slots).title) != null && v.call(y).length || n.title ? (f(), p("div", Hte, [
            (C = (x = e.$slots).title) != null && C.call(x).length ? pe(e.$slots, "title", { key: 0 }, void 0, !0) : (f(), p(se, { key: 1 }, [
              p1(T(n.title), 1)
            ], 64))
          ])) : N("", !0),
          (z = (M = e.$slots).description) != null && z.call(M).length || n.description ? (f(), p("div", jte, [
            (U = (R = e.$slots).description) != null && U.call(R).length ? pe(e.$slots, "description", { key: 0 }, void 0, !0) : (f(), p(se, { key: 1 }, [
              p1(T(n.description), 1)
            ], 64))
          ])) : N("", !0),
          n.validate ? (f(), p("div", Vte, [
            Z(c, {
              modelValue: r.confirmText,
              "onUpdate:modelValue": i[2] || (i[2] = (G) => r.confirmText = G),
              placeholder: n.validatePlaceholder
            }, {
              label: Ee(() => [
                u("span", { innerHTML: n.validateLabel }, null, 8, Fte)
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ])) : N("", !0),
          n.validate || n.actionPrimaryLabel || n.actionSecondaryLabel ? (f(), p("div", {
            key: 4,
            class: "actions",
            style: Ze({ marginTop: n.validate ? "0" : void 0 })
          }, [
            n.validate || n.actionSecondaryLabel ? (f(), $(h, {
              key: 0,
              type: "tertiary",
              disabled: n.actionPrimaryLoading,
              onClick: i[3] || (i[3] = (G) => e.$attrs.onClickActionSecondary ? e.$emit("click-action-secondary", { close: o.justClose }) : e.$emit("close"))
            }, {
              default: Ee(() => [
                p1(T(n.actionSecondaryLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled"])) : N("", !0),
            n.validate || n.actionPrimaryLabel ? (f(), $(h, {
              key: 1,
              type: n.actionPrimaryButtonType,
              class: B(
                n.actionPrimaryButtonType === "primary" ? ["button", o.buttonType] : void 0
              ),
              disabled: o.disabled || n.actionPrimaryLoading,
              loading: n.actionPrimaryLoading,
              onClick: i[4] || (i[4] = (G) => e.$attrs.onClickActionPrimary ? e.$emit("click-action-primary", { close: o.justClose }) : null)
            }, {
              default: Ee(() => [
                p1(T(n.actionPrimaryLabel), 1)
              ]),
              _: 1
            }, 8, ["type", "class", "disabled", "loading"])) : N("", !0)
          ], 4)) : N("", !0)
        ], 2)
      ], 64)) : N("", !0)
    ])
  ], 2);
}
const Ute = /* @__PURE__ */ k(Lte, [["render", Pte], ["__scopeId", "data-v-df20e3dd"]]);
const Rte = {
  name: "UnnnicModalDialog",
  components: {
    UnnnicIcon: ce,
    UnnnicButton: Wn
  },
  mixins: [yn],
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    },
    persistent: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "",
      validate(e) {
        return ["success", "warning", "attention"].includes(e);
      }
    },
    size: {
      type: String,
      default: "md",
      validate(e) {
        return ["sm", "md", "lg"].includes(e);
      }
    },
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    iconScheme: {
      type: String,
      default: ""
    },
    showCloseIcon: {
      type: Boolean,
      default: !1
    },
    showActionsDivider: {
      type: Boolean,
      default: !1
    },
    primaryButtonProps: {
      type: Object,
      default: () => ({})
    },
    hideSecondaryButton: {
      type: Boolean,
      default: !1
    },
    secondaryButtonProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["primaryButtonClick", "secondaryButtonClick", "update:modelValue"],
  data() {
    return {
      defaultTranslations: {
        cancel: {
          "pt-br": "Cancelar",
          en: "Cancel",
          es: "Cancelar"
        }
      },
      iconsMapper: {
        success: { icon: "check_circle", scheme: "aux-green-500" },
        warning: { icon: "warning", scheme: "aux-red-500" },
        attention: { icon: "error", scheme: "aux-yellow-500" }
      },
      primaryButtonTypeMapper: {
        success: "primary",
        warning: "warning",
        attention: "attention"
      }
    };
  },
  watch: {
    modelValue(e) {
      this.updateBodyOverflow(e);
    }
  },
  methods: {
    close() {
      this.$emit("update:modelValue", !1);
    },
    updateBodyOverflow(e) {
      document.body.style.overflow = e ? "hidden" : "";
    }
  }
}, Yte = {
  key: 0,
  class: "unnnic-modal-dialog",
  "data-testid": "modal-dialog"
}, Zte = {
  key: 0,
  class: "unnnic-modal-dialog__container__left-sidebar"
}, Wte = { class: "unnnic-modal-dialog__container__body" }, Qte = {
  key: 0,
  class: "unnnic-modal-dialog__container__header"
}, qte = { class: "unnnic-modal-dialog__container__title-container" }, Gte = {
  class: "unnnic-modal-dialog__container__title-text",
  "data-testid": "title-text"
}, Xte = { class: "unnnic-modal-dialog__container__content" };
function Jte(e, i, n, a, r, o) {
  var h, y;
  const l = j("UnnnicIcon"), c = j("UnnnicButton");
  return n.modelValue ? (f(), p("section", Yte, [
    u("section", {
      class: "unnnic-modal-dialog__overlay",
      "data-testid": "modal-overlay",
      onClick: i[0] || (i[0] = Qe((v) => !n.persistent && o.close(), ["stop"]))
    }),
    u("section", {
      class: B([
        "unnnic-modal-dialog__container",
        `unnnic-modal-dialog__container--${n.size}`
      ]),
      "data-testid": "modal-container"
    }, [
      e.$slots.leftSidebar ? (f(), p("section", Zte, [
        pe(e.$slots, "leftSidebar", {}, void 0, !0)
      ])) : N("", !0),
      u("section", Wte, [
        n.title ? (f(), p("header", Qte, [
          u("section", qte, [
            n.icon || n.type ? (f(), $(l, {
              key: 0,
              "data-testid": "title-icon",
              class: "unnnic-modal-dialog__container__title-icon",
              icon: n.icon || ((h = r.iconsMapper[n.type]) == null ? void 0 : h.icon),
              scheme: n.iconScheme || ((y = r.iconsMapper[n.type]) == null ? void 0 : y.scheme),
              size: "md"
            }, null, 8, ["icon", "scheme"])) : N("", !0),
            u("h1", Gte, T(n.title), 1)
          ]),
          n.showCloseIcon ? (f(), $(l, {
            key: 0,
            "data-testid": "close-icon",
            icon: "close",
            clickable: "",
            onClick: i[1] || (i[1] = (v) => o.close())
          })) : N("", !0)
        ])) : N("", !0),
        u("section", Xte, [
          pe(e.$slots, "default", {}, void 0, !0)
        ]),
        n.primaryButtonProps.text ? (f(), p("section", {
          key: 1,
          "data-testid": "actions-section",
          class: B([
            "unnnic-modal-dialog__container__actions",
            {
              "unnnic-modal-dialog__container__actions--divider": n.showActionsDivider
            }
          ])
        }, [
          n.hideSecondaryButton ? N("", !0) : (f(), $(c, Q1({ key: 0 }, n.secondaryButtonProps, {
            "data-testid": "secondary-button",
            type: "tertiary",
            text: n.secondaryButtonProps.text || e.i18n("cancel"),
            class: "unnnic-modal-dialog__container__actions__secondary-button",
            onClick: i[2] || (i[2] = Qe((v) => n.secondaryButtonProps.text ? e.$emit("secondaryButtonClick") : o.close(), ["stop"]))
          }), null, 16, ["text"])),
          Z(c, Q1(n.primaryButtonProps, {
            "data-testid": "primary-button",
            type: n.primaryButtonProps.type || r.primaryButtonTypeMapper[n.type] || "primary",
            text: n.primaryButtonProps.text,
            class: "unnnic-modal-dialog__container__actions__primary-button",
            onClick: i[3] || (i[3] = Qe((v) => e.$emit("primaryButtonClick"), ["stop"]))
          }), null, 16, ["type", "text"])
        ], 2)) : N("", !0)
      ])
    ], 2)
  ])) : N("", !0);
}
const Kte = /* @__PURE__ */ k(Rte, [["render", Jte], ["__scopeId", "data-v-ab1febba"]]);
const $te = {
  name: "TourMask",
  props: {
    maskRect: {
      type: Object,
      required: !0
    }
  },
  computed: {
    clickBlockerRects() {
      const { maskRect: e } = this;
      return [
        {
          x: "0",
          y: "0",
          width: "100%",
          height: e.y
        },
        {
          x: "0",
          y: "0",
          width: e.x,
          height: "100%"
        },
        {
          x: "0",
          y: e.y + e.height,
          style: { height: `calc(100vh - ${e.y}px)` },
          width: "100%"
        },
        {
          x: e.x + e.width,
          y: "0",
          style: { width: `calc(100vw - ${e.x}px)` },
          height: "100%"
        }
      ];
    }
  }
}, ff = (e) => (hn("data-v-8b63dc83"), e = e(), mn(), e), e2e = { class: "unnnic-tour__mask" }, n2e = {
  class: "mask__svg",
  width: "100%",
  height: "100%"
}, i2e = {
  id: "svgTourMask",
  x: "0",
  y: "0",
  width: "100%",
  height: "100%"
}, t2e = /* @__PURE__ */ ff(() => /* @__PURE__ */ u("rect", {
  x: "0",
  y: "0",
  width: "100vw",
  height: "100vh",
  fill: "white"
}, null, -1)), a2e = ["x", "y", "width", "height"], s2e = /* @__PURE__ */ ff(() => /* @__PURE__ */ u("rect", {
  x: "0",
  y: "0",
  width: "100%",
  height: "100%",
  mask: "url(#svgTourMask)",
  class: "unnnic-tour__overlay"
}, null, -1)), o2e = ["x", "y", "width", "height"];
function r2e(e, i, n, a, r, o) {
  return f(), p("section", e2e, [
    (f(), p("svg", n2e, [
      u("defs", null, [
        u("mask", i2e, [
          t2e,
          u("rect", {
            x: n.maskRect.x,
            y: n.maskRect.y,
            width: n.maskRect.width,
            height: n.maskRect.height,
            rx: "4",
            fill: "black",
            class: "unnnic-tour__step"
          }, null, 8, a2e)
        ])
      ]),
      s2e,
      (f(!0), p(se, null, me(o.clickBlockerRects, (l, c) => (f(), p("rect", {
        key: c,
        x: l.x,
        y: l.y,
        width: l.width,
        height: l.height,
        style: Ze(l.style),
        fill: "transparent",
        "pointer-events": "auto"
      }, null, 12, o2e))), 128))
    ]))
  ]);
}
const l2e = /* @__PURE__ */ k($te, [["render", r2e], ["__scopeId", "data-v-8b63dc83"]]);
const d2e = {
  name: "UnnnicTourPopover",
  components: {
    UnnnicButton: Wn
  },
  mixins: [yn],
  props: {
    step: {
      type: Object,
      required: !0
    },
    currentStep: {
      type: Number,
      required: !0
    },
    stepsLength: {
      type: Number,
      required: !0
    },
    attachedElement: {
      type: Element,
      required: !0
    }
  },
  emits: ["end", "nextStep", "close"],
  data() {
    return {
      style: {},
      defaultTranslations: {
        close_tour: {
          "pt-br": "Fechar tour",
          en: "Close tour",
          es: "Cerrar recorrido"
        },
        understood: {
          "pt-br": "Entendi",
          en: "I understood",
          es: "Entendí"
        }
      }
    };
  },
  watch: {
    attachedElement: {
      immediate: !0,
      deep: !0,
      handler() {
        this.$nextTick(() => {
          this.updatePopoverStyle();
        });
      }
    }
  },
  methods: {
    updatePopoverStyle() {
      const { attachedElement: e, step: i } = this, n = this.$refs.popover;
      if (!e || !n)
        return;
      const {
        top: a,
        left: r,
        width: o,
        height: l
      } = e.getBoundingClientRect(), y = 12 + 2, v = n == null ? void 0 : n.offsetWidth, x = n == null ? void 0 : n.offsetHeight, C = {
        top: r - (v - o) / 2,
        bottom: r - (v - o) / 2,
        right: r + o + y,
        left: r - v - y
      }, M = {
        top: a - x - y,
        bottom: a + l + y,
        right: a - x / 2 + l / 2,
        left: a - x / 2 + l / 2
      };
      let z = {
        transform: `translate(${C[i.popoverPosition]}px, ${M[i.popoverPosition]}px)`,
        transition: "transform .3s ease"
      };
      this.style = z;
    }
  }
}, c2e = { class: "popover__header" }, f2e = { class: "header__title" }, u2e = ["innerHTML"];
function h2e(e, i, n, a, r, o) {
  const l = j("UnnnicButton");
  return f(), p("section", {
    ref: "popover",
    class: B(["unnnic-tour__popover", n.step.popoverPosition]),
    style: Ze(r.style)
  }, [
    u("header", c2e, [
      u("h1", f2e, T(n.step.title), 1),
      u("p", {
        class: "header__close-tour",
        onClick: i[0] || (i[0] = Qe((c) => e.$emit("close"), ["stop"]))
      }, T(e.i18n("close_tour")), 1)
    ]),
    u("p", {
      class: "popover__description",
      innerHTML: n.step.description
    }, null, 8, u2e),
    n.step.hiddenNextStepButton ? N("", !0) : (f(), $(l, {
      key: 0,
      type: "primary",
      onClick: i[1] || (i[1] = (c) => e.$emit("nextStep"))
    }, {
      default: Ee(() => [
        p1(T(e.i18n("understood")) + " " + T(n.currentStep) + "/" + T(n.stepsLength), 1)
      ]),
      _: 1
    }))
  ], 6);
}
const m2e = /* @__PURE__ */ k(d2e, [["render", h2e], ["__scopeId", "data-v-68f269c6"]]), p2e = (e) => {
  const { title: i, description: n, attachedElement: a, popoverPosition: r } = e;
  if (!("title" in e && "description" in e && "attachedElement" in e && "popoverPosition" in e))
    throw new Error(
      'Each item in "steps" must have "title", "description", "attachedElement" and "popoverPosition".'
    );
  if (typeof i != "string" || !i.trim())
    throw new Error('"title" must be a padded string');
  if (typeof n != "string" || !n.trim())
    throw new Error('"description" must be a padded string');
  if (!(a instanceof HTMLElement))
    throw new Error('"attachedElement" must be an HTML element.');
  if (!["top", "bottom", "left", "right"].includes(r))
    throw new Error(
      '"popoverPosition" must be one of "top", "bottom", "left", or "right".'
    );
  if ("padding" in e) {
    if (typeof e.padding != "object" || e.padding === null)
      throw new Error(
        'Each item in "steps" that contains "padding" must assign it as an object.'
      );
    if (!(e.padding.vertical || e.padding.horizontal))
      throw new Error(
        'Each item in "steps" that contains "padding" must assign it as an object with "vertical" and/or "horizontal" keys.'
      );
    if ("vertical" in e.padding && typeof e.padding.vertical != "number")
      throw new Error('"vertical" in "padding" must be a number.');
    if ("horizontal" in e.padding && typeof e.padding.horizontal != "number")
      throw new Error('"horizontal" in "padding" must be a number.');
  }
}, y2e = (e) => {
  if (!Array.isArray(e))
    throw new Error("Property steps needs to be a padded array.");
  if (!(e != null && e[0]))
    throw new Error("Steps property cannot be an empty array.");
  return e.forEach(p2e), !0;
}, v2e = {
  name: "UnnnicTour",
  components: {
    TourMask: l2e,
    TourPopover: m2e
  },
  props: {
    steps: {
      required: !0,
      type: Array,
      validator: y2e
    }
  },
  emits: ["endTour", "nextStep", "close"],
  data() {
    return {
      isTourActive: !1,
      currentStep: 1,
      maskRect: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    currentStepOptions() {
      return this.steps[this.currentStep - 1];
    },
    stepStyle() {
      const e = this.currentStepOptions.attachedElement;
      if (!this.isTourActive || !e)
        return {};
      const { top: i, left: n, width: a, height: r } = e.getBoundingClientRect();
      return {
        top: `${i}px`,
        left: `${n}px`,
        width: `${a}px`,
        height: `${r}px`
      };
    }
  },
  watch: {
    currentStep() {
      this.updateMaskRect();
    },
    isTourActive(e) {
      e && this.updateMaskRect();
    }
  },
  methods: {
    start() {
      this.isTourActive = !0, this.currentStep = 1;
    },
    end() {
      this.isTourActive = !1, this.currentStep = 1, this.$emit("endTour");
    },
    close() {
      this.$emit("close");
    },
    async handleStep(e) {
      if (this.currentStep <= this.steps.length) {
        const { beforeRender: i } = this.steps[e - 1];
        i && await i(), this.currentStep = e;
      }
    },
    nextStep() {
      const { handleStep: e, steps: i, currentStep: n, end: a } = this;
      if (n === i.length) {
        a();
        return;
      }
      e(n + 1);
    },
    updateMaskRect() {
      var l;
      const e = (l = this.currentStepOptions) == null ? void 0 : l.attachedElement, { padding: i } = this.currentStepOptions;
      if (!e)
        return;
      const { top: n, left: a, width: r, height: o } = e.getBoundingClientRect();
      this.maskRect = {
        x: a - ((i == null ? void 0 : i.horizontal) || 0) / 2,
        y: n - ((i == null ? void 0 : i.vertical) || 0) / 2,
        width: r + ((i == null ? void 0 : i.horizontal) || 0),
        height: o + ((i == null ? void 0 : i.vertical) || 0)
      };
    }
  }
};
function g2e(e, i, n, a, r, o) {
  const l = j("TourMask"), c = j("TourPopover");
  return f(), p(se, null, [
    r.isTourActive ? (f(), $(l, {
      key: 0,
      maskRect: r.maskRect
    }, null, 8, ["maskRect"])) : N("", !0),
    r.isTourActive ? (f(), $(c, {
      key: 1,
      step: o.currentStepOptions,
      stepsLength: n.steps.length,
      currentStep: r.currentStep,
      attachedElement: o.currentStepOptions.attachedElement,
      onEnd: o.end,
      onClose: o.close,
      onNextStep: o.nextStep
    }, null, 8, ["step", "stepsLength", "currentStep", "attachedElement", "onEnd", "onClose", "onNextStep"])) : N("", !0)
  ], 64);
}
const _2e = /* @__PURE__ */ k(v2e, [["render", g2e]]);
const w2e = {
  props: {
    pages: { type: Array, required: !0 },
    activePage: { type: String, required: !0 }
  },
  computed: {
    activePageIndex() {
      return this.pages.indexOf(this.activePage);
    }
  }
}, C2e = (e) => (hn("data-v-5da9ecbf"), e = e(), mn(), e), k2e = { class: "unnnic-navigator-pages" }, x2e = /* @__PURE__ */ C2e(() => /* @__PURE__ */ u("span", { class: "unnnic-navigator-pages__page-progress" }, null, -1));
function b2e(e, i, n, a, r, o) {
  return f(), p("section", k2e, [
    (f(!0), p(se, null, me(n.pages, (l, c) => (f(), p("section", {
      key: l,
      class: B([
        "unnnic-navigator-pages__page",
        {
          "unnnic-navigator-pages__page--before": o.activePageIndex > c,
          "unnnic-navigator-pages__page--current": n.activePage == l
        }
      ]),
      "data-testid": "navigator-page"
    }, [
      x2e,
      u("p", {
        class: B([
          "unnnic-navigator-pages__page-title",
          {
            "unnnic-navigator-pages__page-title--active": n.activePage === l
          }
        ]),
        "data-testid": "navigator-page-title"
      }, T(l), 3)
    ], 2))), 128))
  ]);
}
const M2e = /* @__PURE__ */ k(w2e, [["render", b2e], ["__scopeId", "data-v-5da9ecbf"]]), y3 = {
  unnnicFormElement: Ul,
  unnnicInput: _0,
  unnnicInputNext: xH,
  unnnicInputDatePicker: BY,
  unnnicButton: Wn,
  unnnicButtonIcon: jY,
  unnnicSidebar: GY,
  unnnicSidebarItem: _c,
  unnnicTable: tZ,
  unnnicTableRow: lZ,
  unnnicAvatarIcon: m2,
  unnnicIcon: ce,
  unnnicIconSvg: ce,
  unnnicIconLoading: j0,
  unnnicDropdown: Do,
  unnnicDropdownItem: bc,
  unnnicToolTip: q1,
  unnnicCard: HW,
  unnnicSimpleCard: ZW,
  unnnicCardCompany: yQ,
  unnnicCardData: AQ,
  unnnicCardImage: UQ,
  // unnnicCardFlow: cardFlow,
  unnnicCardProject: JQ,
  unnnicCardInformation: yq,
  unnnicCheckbox: V0,
  unnnicCollapse: _q,
  unnnicRadio: Mc,
  unnnicLanguageSelect: Vq,
  unnnicModal: Dc,
  unnnicModalNext: Ute,
  unnnicModalDialog: Kte,
  unnnicModalUpload: bG,
  unnnicSelectSmart: aX,
  // unnnicSelect: select,
  unnnicSelectItem: rX,
  // unnnicSelectListItem: selectListItem,
  unnnicMultiSelect: mX,
  unnnicAlert: Ec,
  unnnicCallAlert: HG,
  unnnicCallModal: jG,
  // unnnicAutocomplete: autocomplete,
  // unnnicAutocompleteSelect: autocompleteSelect,
  unnnicTag: ea,
  unnnicAccordion: _X,
  unnnicIndicator: bX,
  unnnicSkeletonLoading: NX,
  unnnicCarousel: ZX,
  unnnicLabel: GX,
  unnnicTab: tJ,
  unnnicTabsExpanded: cJ,
  unnnicBanner: TJ,
  unnnicComment: FJ,
  unnnicDatePicker: gc,
  unnnicBreadcrumb: Ic,
  unnnicSwitch: qJ,
  unnnicSlider: sK,
  unnnicDataArea: pK,
  unnnicPagination: Bc,
  unnnicDropArea: Tc,
  unnnicUploadArea: Nc,
  unnnicImportCard: Sc,
  unnnicDateFilter: kK,
  unnnicChatText: LK,
  unnnicTextArea: EK,
  unnnicCardNumber: BK,
  unnnicChartRainbow: qK,
  unnnicChartBar: h$,
  unnnicChartLine: M$,
  unnnicMoodRating: O$,
  unnnicStarRating: U$,
  unnnicAudioRecorder: oee,
  unnnicCircleProgressBar: hee,
  unnnicProgressBar: Dee,
  unnnicChatsContact: Zee,
  unnnicChatsDashboardTagLive: Xee,
  unnnicChatsHeader: s1e,
  unnnicChatsMessage: E1e,
  unnnicReplyMessage: jc,
  unnnicChatsNavbar: j1e,
  unnnicChatsUserAvatar: Lo,
  unnnicChartMultiLine: tne,
  unnnicEmojiPicker: sie,
  unnnicChartFunnel: Tie,
  unnnicDisclaimer: Oie,
  unnnicDrawer: Wie,
  unnnicTableNext: Ate,
  unnnicTour: _2e,
  unnnicNavigator: M2e
}, A2e = {
  install(e) {
    Object.keys(y3).forEach((i) => {
      e.component(i, y3[i]);
    });
  },
  ...y3
};
export {
  oe as h,
  A2e as i
};
